/*!
 * Font Awesome Pro 7.1.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2025 Fonticons, Inc.
 */
var prefix = "fass";
var fa0 = {
  prefix: 'fass',
  iconName: '0',
  icon: [320, 512, [], "30", "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160l0 128c0 88.4-71.6 160-160 160S0 408.4 0 320L0 192zM160 96c-53 0-96 43-96 96l0 128c0 53 43 96 96 96s96-43 96-96l0-128c0-53-43-96-96-96z"]
};
var fa1 = {
  prefix: 'fass',
  iconName: '1',
  icon: [256, 512, [], "31", "M32 32l-32 0 0 64 96 0 0 320-96 0 0 64 256 0 0-64-96 0 0-384-128 0z"]
};
var fa2 = {
  prefix: 'fass',
  iconName: '2',
  icon: [384, 512, [], "32", "M48 32l203 0c60.2 0 109 48.8 109 109 0 43.8-26.2 83.3-66.4 100.4l-139.1 59C119 315.4 96 350.2 96 388.7l0 27.3 256 0 0 64-320 0 0-91.3c0-64.2 38.4-122.2 97.5-147.3l139.1-59c16.6-7.1 27.4-23.4 27.4-41.4 0-24.9-20.2-45-45-45L48 96 48 32z"]
};
var fa3 = {
  prefix: 'fass',
  iconName: '3',
  icon: [320, 512, [], "33", "M192 288l-144 0 0-64 144 0c35.3 0 64-28.7 64-64s-28.7-64-64-64L0 96 0 32 192 32c70.7 0 128 57.3 128 128 0 38.2-16.8 72.5-43.3 96 26.6 23.5 43.3 57.8 43.3 96 0 70.7-57.3 128-128 128l-192 0 0-64 192 0c35.3 0 64-28.7 64-64s-28.7-64-64-64z"]
};
var fa4 = {
  prefix: 'fass',
  iconName: '4',
  icon: [384, 512, [], "34", "M64 64l0-32-64 0 0 320 256 0 0 128 64 0 0-128 64 0 0-64-64 0 0-256-64 0 0 256-192 0 0-224z"]
};
var fa5 = {
  prefix: 'fass',
  iconName: '5',
  icon: [320, 512, [], "35", "M0 32l288 0 0 64-224 0 0 112 120 0c75.1 0 136 60.9 136 136S259.1 480 184 480l-184 0 0-64 184 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L0 272 0 32z"]
};
var fa6 = {
  prefix: 'fass',
  iconName: '6',
  icon: [384, 512, [], "36", "M256 32l32 0 0 64-120 0c-48.6 0-88 39.4-88 88l0 32.2c22.9-15.3 50.4-24.2 80-24.2l48 0c79.5 0 144 64.5 144 144S287.5 480 208 480l-48 0C80.5 480 16 415.5 16 336l0-152C16 100.1 84.1 32 168 32l88 0zM80 336c0 44.2 35.8 80 80 80l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0c-44.2 0-80 35.8-80 80z"]
};
var fa7 = {
  prefix: 'fass',
  iconName: '7',
  icon: [320, 512, [], "37", "M320 32l0 39.9-3.7 7-211.7 401.1-72.4 0 202.7-384-234.9 0 0-64 320 0z"]
};
var fa8 = {
  prefix: 'fass',
  iconName: '8',
  icon: [320, 512, [], "38", "M304 160c0-70.7-57.3-128-128-128l-32 0c-70.7 0-128 57.3-128 128 0 34.6 13.7 66 36 89-31.5 23.3-52 60.8-52 103 0 70.7 57.3 128 128 128l64 0c70.7 0 128-57.3 128-128 0-42.2-20.5-79.7-52-103 22.3-23 36-54.4 36-89zM176.1 288l15.9 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l48.1 0zm0-64L144 224c-35.3 0-64-28.7-64-64 0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64 0 35.3-28.6 64-64 64z"]
};
var fa9 = {
  prefix: 'fass',
  iconName: '9',
  icon: [384, 512, [], "39", "M208 320c29.6 0 57.1-8.9 80-24.2l0 32.2c0 48.6-39.4 88-88 88l-136 0 0 64 136 0c83.9 0 152-68.1 152-152l0-152.1C351.9 96.4 287.5 32 208 32l-48 0C80.5 32 16 96.5 16 176S80.5 320 160 320l48 0zm80-144c0 44.2-35.8 80-80 80l-48 0c-44.2 0-80-35.8-80-80s35.8-80 80-80l48 0c44.2 0 80 35.8 80 80z"]
};
var faChessPawnPiece = {
  prefix: 'fass',
  iconName: 'chess-pawn-piece',
  icon: [320, 512, ["chess-pawn-alt"], "f444", "M256 128c0 24.6-9.2 47-24.4 64l24.4 0 0 48-29.3 0 13.3 144 64 80 0 48-288 0 0-48 64-80 13.3-144-29.3 0 0-48 24.4 0c-15.2-17-24.4-39.4-24.4-64 0-53 43-96 96-96s96 43 96 96z"]
};
var faChessPawnAlt = faChessPawnPiece;
var faDollarSign = {
  prefix: 'fass',
  iconName: 'dollar-sign',
  icon: [320, 512, [128178, 61781, "dollar", "usd"], "24", "M136 0l48 0 0 64 88 0 0 64-146.9 0c-24.9 0-45.1 20.2-45.1 45.1 0 22.5 16.5 41.5 38.7 44.7l91.6 13.1c53.8 7.7 93.7 53.7 93.7 108 0 60.3-48.9 109.1-109.1 109.1l-10.9 0 0 64-48 0 0-64-104 0 0-64 162.9 0c24.9 0 45.1-20.2 45.1-45.1 0-22.5-16.5-41.5-38.7-44.7l-91.6-13.1C55.9 273.5 16 227.4 16 173.1 16 112.9 64.9 64 125.1 64l10.9 0 0-64z"]
};
var faDollar = faDollarSign;
var faUsd = faDollarSign;
var faLayerPlus = {
  prefix: 'fass',
  iconName: 'layer-plus',
  icon: [576, 512, ["layer-group-plus"], "f5ff", "M488-8l0-24-48 0 0 56-56 0 0 48 56 0 0 56 48 0 0-56 56 0 0-48-56 0 0-32zM16 224L288 352 560 224 288 96 16 224zm0 160L288 512 560 384 446.4 330.5 288 405 129.6 330.5 16 384z"]
};
var faLayerGroupPlus = faLayerPlus;
var faGrid4 = {
  prefix: 'fass',
  iconName: 'grid-4',
  icon: [448, 512, [], "e198", "M0 32l80 0 0 80-80 0 0-80zM0 154.7l80 0 0 80-80 0 0-80zM0 277.3l80 0 0 80-80 0 0-80zM80 400l0 80-80 0 0-80 80 0zm122.7 0l0 80-80 0 0-80 80 0zm42.7 0l80 0 0 80-80 0 0-80zM448 400l0 80-80 0 0-80 80 0zM202.7 277.3l0 80-80 0 0-80 80 0zm42.7 0l80 0 0 80-80 0 0-80zm202.7 0l0 80-80 0 0-80 80 0zM202.7 154.7l0 80-80 0 0-80 80 0zm42.7 0l80 0 0 80-80 0 0-80zm202.7 0l0 80-80 0 0-80 80 0zM202.7 32l0 80-80 0 0-80 80 0zm42.7 0l80 0 0 80-80 0 0-80zM448 32l0 80-80 0 0-80 80 0z"]
};
var faDog = {
  prefix: 'fass',
  iconName: 'dog',
  icon: [576, 512, [128021], "f6d3", "M64 144c0 17.7 14.3 32 32 32l179.1 0 140.9 60.4 0 275.6-96 0 0-163.3C296 361 268.8 368 240 368s-56-7-80-19.3l0 163.3-96 0 0-277.6C26.7 221.2 0 185.8 0 144l0-32 64 0 0 32zM392 0l72 0 32 32 80 0 0 48c0 44.2-35.8 80-80 80l-64 0-7 28-124.7-53.4 35.7-166.6 32 0 24 32zm56 44a20 20 0 1 0 0 40 20 20 0 1 0 0-40z"]
};
var faTruckMoving = {
  prefix: 'fass',
  iconName: 'truck-moving',
  icon: [640, 512, [], "f4df", "M480 32L0 32 0 424c0 48.6 39.4 88 88 88 25.2 0 48-10.6 64-27.6 16 17 38.8 27.6 64 27.6 40.3 0 74.2-27.1 84.7-64l134.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l35.3 0 0-237.3-9.4-9.4-64-64-9.4-9.4-77.3 0 0-96zm0 160l50.7 0 45.3 45.3 0 50.7-96 0 0-96zM88 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm392 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM216 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faRotate = {
  prefix: 'fass',
  iconName: 'rotate',
  icon: [512, 512, [128260, "sync-alt"], "f2f1", "M512-8L433 71C332.7-25 173.6-23.7 75 75 25 125 0 190.5 0 256l64 0c0-49.2 18.7-98.3 56.2-135.8 73.6-73.6 192.2-75 267.5-3.9L312 192 512 192 512-8zM124.3 395.7L200 320 0 320 0 520 79 441c100.3 96 259.4 94.7 358-4 50-50 75-115.6 75-181l-64 0c0 49.2-18.7 98.3-56.2 135.8-73.6 73.6-192.2 75-267.5 3.9z"]
};
var faSyncAlt = faRotate;
var faArrowUTurnUpLeft = {
  prefix: 'fass',
  iconName: 'arrow-u-turn-up-left',
  icon: [576, 512, [], "e7ed", "M176.2-29.2l45.2 45.2-80 80 210.7 0C455 96 538.9 176.7 544 278.1l.2 9.9c0 106-86 192-192 192l-256 0 0-64 256 0c70.7 0 128-57.3 128-128l-.2-6.6C476.7 213.8 420.7 160 352.2 160l-210.7 0 80 80-45.2 45.3-157.2-157.3 157.2-157.2z"]
};
var faKeyboardBrightness = {
  prefix: 'fass',
  iconName: 'keyboard-brightness',
  icon: [640, 512, [], "e1c0", "M352 64l0 160-64 0 0-160 64 0zM112 130.7c8.2 8.2 37.1 37.1 86.6 86.6L221.3 240 176 285.3c-8.2-8.2-37.1-37.1-86.6-86.6L66.7 176 112 130.7zM573.3 176c-8.2 8.2-37.1 37.1-86.6 86.6L464 285.3 418.7 240c8.2-8.2 37.1-37.1 86.6-86.6L528 130.7 573.3 176zM0 352l128 0 0 64-128 0 0-64zm192 0l256 0 0 64-256 0 0-64zm320 64l0-64 128 0 0 64-128 0z"]
};
var faTentDoublePeak = {
  prefix: 'fass',
  iconName: 'tent-double-peak',
  icon: [576, 512, [], "e627", "M427.6 14.5C469.5 98.3 541.1 142.5 576 160l0 48-576 0 0-48c34.9-17.5 106.5-61.7 148.4-145.5 0 0 55.9 96 139.6 96s139.6-96 139.6-96zM0 512l0-256 576 0 0 256-160 0-128-192 0 192-288 0z"]
};
var faSquareMinus = {
  prefix: 'fass',
  iconName: 'square-minus',
  icon: [448, 512, [61767, "minus-square"], "f146", "M448 32l-448 0 0 448 448 0 0-448zM136 232l200 0 0 48-224 0 0-48 24 0z"]
};
var faMinusSquare = faSquareMinus;
var faWaterArrowUp = {
  prefix: 'fass',
  iconName: 'water-arrow-up',
  icon: [512, 512, ["water-rise"], "f775", "M233.6 9.4l22.6-22.6c5.5 5.5 39.7 39.7 102.6 102.6l22.6 22.6-45.3 45.3c-14.6-14.6-30.6-30.6-48-48l0 130.7-64 0 0-130.7-48 48-45.3-45.3c5.5-5.5 39.7-39.7 102.6-102.6zM136.2 286.2l8.9 3.6 111.1 44.4 111.1-44.4 8.9-3.6 8.9 3.6c83 33.2 125 50 126.3 50.5l-17.8 44.6c-2.7-1.1-41.9-16.7-117.4-46.9l-111.1 44.4-8.9 3.6-8.9-3.6-111.1-44.4c-75.5 30.2-114.7 45.9-117.4 47l-17.8-44.6 22.3-8.9 104-41.6 8.9-3.6zm0 128l8.9 3.6 111.1 44.4 111.1-44.4 8.9-3.6 8.9 3.6c83 33.2 125 50 126.3 50.5l-17.8 44.6c-2.7-1.1-41.9-16.7-117.4-46.9l-111.1 44.4-8.9 3.6-8.9-3.6-111.1-44.4c-75.5 30.2-114.7 45.9-117.4 47l-17.8-44.6 22.3-8.9 104-41.6 8.9-3.6z"]
};
var faWaterRise = faWaterArrowUp;
var faXmarkToSlot = {
  prefix: 'fass',
  iconName: 'xmark-to-slot',
  icon: [576, 512, ["times-to-slot", "vote-nay"], "f771", "M96 32l384 0 0 352-384 0 0-352zM355.9 174.1l17-17-33.9-33.9c-8.5 8.5-25.5 25.5-50.9 50.9-25.5-25.5-42.4-42.4-50.9-50.9l-33.9 33.9c8.5 8.5 25.5 25.5 50.9 50.9-25.5 25.5-42.4 42.4-50.9 50.9l33.9 33.9c8.5-8.5 25.5-25.5 50.9-50.9 25.5 25.5 42.4 42.4 50.9 50.9l33.9-33.9c-8.5-8.5-25.5-25.5-50.9-50.9l33.9-33.9zM48 312l0 120 480 0 0-144 48 0 0 192-576 0 0-192 48 0 0 24z"]
};
var faTimesToSlot = faXmarkToSlot;
var faVoteNay = faXmarkToSlot;
var faSensorCloud = {
  prefix: 'fass',
  iconName: 'sensor-cloud',
  icon: [576, 512, ["sensor-smoke"], "e02c", "M64 32l448 0 0 256.3c-16.2-10.3-35.4-16.3-56-16.3-6 0-11.9 .5-17.7 1.5-22.7-20.8-53-33.5-86.3-33.5-69.4 0-125.8 55.2-127.9 124-29.3 23.4-48.1 59.5-48.1 100l0 16-112 0 0-448zM176 96l-48 0 0 160 48 0 0-160zm96 0l-48 0 0 151.2c13.8-14.6 30-26.8 48-36L272 96zM224 464c0-33.9 21.1-62.9 50.9-74.5-1.9-6.8-2.9-14-2.9-21.5 0-44.2 35.8-80 80-80 30.8 0 57.5 17.4 70.9 42.8 9.3-6.8 20.7-10.8 33.1-10.8 34.2 0 60.9 32 55.2 65.4 36.9 7.1 64.8 39.6 64.8 78.6l0 80-352 0 0-80z"]
};
var faSensorSmoke = faSensorCloud;
var faLychee = {
  prefix: 'fass',
  iconName: 'lychee',
  icon: [512, 512, [], "e824", "M231.6-1.7c8.7 2.7 16.8 6 24.6 9.8 4.9 2.3 9.4 4.8 13.8 7.5 12.6-4.9 26.8-8.1 42.3-8 21.5 22.5 38.8 51.7 56.3 79.6 22-13.2 40-24 54.1-32.5l34.7 34.7c-8.5 14.1-19.3 32.2-32.5 54.1 27.9 17.5 57.1 34.9 79.6 56.4 .1 15.5-3.1 29.8-8 42.3 7.1 11.6 12.9 24.4 17.3 38.5-7.6 12.5-16.4 23.5-26 33.1 1.9 13.4 2.4 27.5 1.2 41.9-11.7 8.6-23.8 15.5-36 21.2-2.8 13.2-6.9 26.6-12.1 39.8-13.5 4.5-26.9 7.7-40.2 10-6.1 12-13.1 23.9-21 35.5-14 1.2-27.7 1.5-41.2 1.1-8.4 10.5-17.5 20.8-27.4 30.7-13.9-1.5-27.5-3.7-40.7-6.7-10.3 8.8-21.2 17.2-33 24.9-13.5-4.2-26.3-9.3-38.6-15.2-12.1 6.3-25.3 11.3-39.4 14.8-11.9-8.3-22.5-17.8-31.4-28-13.5 1.1-27.6 .5-42-1.8-7.7-12.4-13.7-25.2-18-38-12.8-4.3-25.7-10.3-38-18-2.3-14.4-2.9-28.6-1.8-42-10.1-8.9-19.6-19.5-28-31.4 3.5-14.1 8.5-27.3 14.8-39.4-5.9-12.2-10.9-25.1-15.2-38.6 7.7-11.7 16.1-22.7 24.9-33-3-13.1-5.2-26.8-6.7-40.7 9.9-10 20.2-19.1 30.7-27.4-.4-13.5-.1-27.2 1.1-41.2 11.6-7.9 23.5-14.9 35.5-21 2.3-13.3 5.5-26.8 10-40.2 13.2-5.2 26.6-9.3 39.8-12.1 5.7-12.2 12.6-24.4 21.2-36 14.4-1.1 28.6-.7 41.9 1.2 9.6-9.5 20.6-18.3 33.1-26zM195.5 288.5c-30.7 6.1-49.3 9.9-55.7 11.1-1.3 6.4-5 25-11.1 55.7l-4.7 23.5 47.1 9.4c3.1-15.6 6.3-31.5 9.6-47.9 16.3-3.2 32.3-6.4 47.8-9.6l-9.4-47.1-23.5 4.7zm160-32c-30.7 6.1-49.3 9.9-55.7 11.1-1.3 6.4-5 25-11.1 55.7l-4.7 23.5 47.1 9.4c3.1-15.6 6.3-31.5 9.6-47.9 16.3-3.2 32.3-6.4 47.8-9.6l-9.4-47.1-23.5 4.7zm-128-128c-30.7 6.1-49.3 9.9-55.7 11.1-1.3 6.4-5 25-11.1 55.7l-4.7 23.5 47.1 9.4c3.1-15.6 6.3-31.5 9.6-47.9 16.3-3.3 32.3-6.4 47.8-9.6l-9.4-47.1-23.5 4.7z"]
};
var faAlignJustify = {
  prefix: 'fass',
  iconName: 'align-justify',
  icon: [448, 512, [], "f039", "M448 32l-448 0 0 64 448 0 0-64zm0 256l-448 0 0 64 448 0 0-64zM0 160l0 64 448 0 0-64-448 0zM448 416l-448 0 0 64 448 0 0-64z"]
};
var faSunglasses = {
  prefix: 'fass',
  iconName: 'sunglasses',
  icon: [576, 512, [128374], "f892", "M72.4 32l103.6 0 0 64-56.4 0-49.2 160 185.6 0 0 32 64 0 0-32 185.6 0-49.2-160-56.4 0 0-64 103.6 0 7 22.6 64 208 1.4 4.6 0 212.8-256 0 0-128-64 0 0 128-256 0 0-212.8 1.4-4.6 64-208 7-22.6zM64 320l0 96 128-96-128 0zm320 0l0 96 128-96-128 0z"]
};
var faCloudCheck = {
  prefix: 'fass',
  iconName: 'cloud-check',
  icon: [576, 512, [], "e35c", "M240 32c55.4 0 103.5 31.3 127.6 77.1 14.2-8.3 30.8-13.1 48.4-13.1 53 0 96 43 96 96l0 49.1c38.3 22.1 64 63.5 64 110.9l0 128-576 0 0-144c0-62.7 40.1-116 96-135.8L96 176C96 96.5 160.5 32 240 32zM345.4 201.9L259.8 319.6c-19.3-20-33.7-34.9-43.2-44.7l-34.5 33.3c6.2 6.4 27.2 28.1 63.1 65.3l19.8 20.6 16.8-23.1 102.4-140.8 14.1-19.4-38.8-28.2-14.1 19.4z"]
};
var faMessageMinus = {
  prefix: 'fass',
  iconName: 'message-minus',
  icon: [512, 512, ["comment-alt-minus"], "f4a7", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM169.6 216l196.8 0 0 48-220.8 0 0-48 24 0z"]
};
var faCommentAltMinus = faMessageMinus;
var faFaceClouds = {
  prefix: 'fass',
  iconName: 'face-clouds',
  icon: [640, 512, [], "e47d", "M62.4 32C27.8 32.9 0 61.2 0 96l0 64 288 0 0-64c0-34.8-27.8-63.1-62.4-64-9-36.7-42.1-64-81.6-64S71.4-4.7 62.4 32zm6.1 176c-2.9 15.5-4.5 31.6-4.5 48 0 113.4 73.8 209.7 176 243.3l0-35.3c0-40.5 18.8-76.5 48.1-100 1.7-55.3 38.4-101.8 88.8-117.9-5.5-5.7-8.9-13.5-8.9-22.1 0-17.7 14.3-32 32-32s32 14.3 32 32c0 6-1.7 11.7-4.6 16.5 28.8 2.5 54.8 14.6 74.9 33 5.8-1 11.7-1.5 17.7-1.5 19.8 0 38.4 5.5 54.1 15.2 1.2-10.2 1.9-20.6 1.9-31.2 0-141.4-114.6-256-256-256-15.5 0-30.7 1.4-45.5 4 36.5 18.5 61.5 56.3 61.5 100l0 104-68.3 0c2.7 4.7 4.3 10.2 4.3 16 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16L68.5 208zM288 464l0 80 352 0 0-80c0-39-27.9-71.5-64.8-78.6 5.7-33.5-21-65.4-55.2-65.4-12.4 0-23.9 4-33.1 10.8-13.4-25.5-40.1-42.8-70.9-42.8-44.2 0-80 35.8-80 80 0 7.4 1 14.6 2.9 21.5-29.8 11.6-50.9 40.6-50.9 74.5z"]
};
var faLeftLongToLine = {
  prefix: 'fass',
  iconName: 'left-long-to-line',
  icon: [640, 512, [], "e41e", "M320 64l-192 192 192 192 0-128 320 0 0-128-320 0 0-128zM0 96l0 352 64 0 0-384-64 0 0 32z"]
};
var faPlaneLandingGear = {
  prefix: 'fass',
  iconName: 'plane-landing-gear',
  icon: [640, 512, [], "e7bc", "M240 64L401.3 240 552 240c30.9 0 56 25.1 56 56s-25.1 56-56 56l-504 0-32-176 48 0 51.2 64 103.5 0-58.7-176 80 0zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCalendarCheck = {
  prefix: 'fass',
  iconName: 'calendar-check',
  icon: [448, 512, [], "f274", "M160 64l128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0 0 64zM308.5 167l-119.4 164.2-69.1-69.1-33.9 33.9 88.9 88.9 19.8 19.9 16.5-22.7 135.9-186.9 14.1-19.4-38.8-28.3-14.1 19.4z"]
};
var faSquareRing = {
  prefix: 'fass',
  iconName: 'square-ring',
  icon: [448, 512, [], "e44f", "M448 32l-448 0 0 448 448 0 0-448zM128 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320z"]
};
var faFaceKiss = {
  prefix: 'fass',
  iconName: 'face-kiss',
  icon: [512, 512, [128535, "kiss"], "f596", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM232 288l40 0c26.5 0 48 21.5 48 48 0 12.3-4.6 23.5-12.2 32 7.6 8.5 12.2 19.7 12.2 32 0 26.5-21.5 48-48 48l-48 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32 8 0zm-88-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faKiss = faFaceKiss;
var faCircleVideo = {
  prefix: 'fass',
  iconName: 'circle-video',
  icon: [512, 512, ["video-circle"], "e12b", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm128-64l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-40 80 40 0-128-80 40 0-40c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32z"]
};
var faVideoCircle = faCircleVideo;
var faCartShoppingFast = {
  prefix: 'fass',
  iconName: 'cart-shopping-fast',
  icon: [640, 512, [], "e0dc", "M64-16l116 0c2.1 11.7 5 27.7 8.7 48l451.2 0-48 256-356.7 0 8.7 48 300 0 0 48-340 0-3.6-19.7-60.4-332.3-76 0 0-48zM224 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM0 144l0-48 112 0 0 48-112 0zm0 96l0-48 128 0 0 48-128 0zm0 96l0-48 144 0 0 48-144 0z"]
};
var faDesktopArrowDown = {
  prefix: 'fass',
  iconName: 'desktop-arrow-down',
  icon: [512, 512, [], "e155", "M280 32l0 158.1c23-23 39-39 48-48L361.9 176c-2.1 2.1-31.8 31.8-89 89l-17 17c-2.1-2.1-31.8-31.8-89-89l-17-17 33.9-33.9 48 48 0-182.1 48 0 0 24zM0 32l176 0 0 64-112 0 0 224 384 0 0-224-112 0 0-64 176 0 0 384-208 0 16 48 96 0 0 48-320 0 0-48 96 0 16-48-208 0 0-384z"]
};
var faBanjo = {
  prefix: 'fass',
  iconName: 'banjo',
  icon: [512, 512, [129685], "f8a3", "M367.1 99.7l8.9-35.7 72-64 64 64-64 72-35.7 8.9-81.1 81.1c13.9 20.6 23.4 44.3 27 70l25.7 0 0 48-25.7 0c-4.1 28.5-15.3 54.6-31.7 76.6l1.2 1.2 17 17-33.9 33.9-17-17-1.2-1.2c-22 16.5-48.1 27.7-76.6 31.7l0 25.7-48 0 0-25.7c-28.5-4.1-54.6-15.3-76.6-31.7l-1.2 1.2-17 17-33.9-33.9 17-17 1.2-1.2C41 398.6 29.8 372.5 25.7 344l-25.7 0 0-48 25.7 0c4.1-28.5 15.3-54.6 31.7-76.6l-1.2-1.2-17-17 33.9-33.9 17 17 1.2 1.2c22-16.5 48.2-27.7 76.6-31.7l0-25.7 48 0 0 25.7c25.7 3.7 49.5 13.1 70 27l81.1-81.1zM192 432a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM161 303c37.2 37.2 58.8 58.8 65 65L192 401.9c-6.1-6.1-27.8-27.8-65-65l-17-17 33.9-33.9 17 17z"]
};
var faCloudHailMixed = {
  prefix: 'fass',
  iconName: 'cloud-hail-mixed',
  icon: [512, 512, [], "f73a", "M96 320l-96 0 0-96c0-41.8 26.7-77.4 64-90.5L64 112c0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-416 0zM38.7 440l24-72 50.6 0-24 72-50.6 0zm376-72l50.6 0-48 144-50.6 0 48-144zm-120 0l50.6 0-24 72-50.6 0 24-72zm-112 0l50.6 0-48 144-50.6 0 48-144zM24 488a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm256-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSquareHalfStroke = {
  prefix: 'fass',
  iconName: 'square-half-stroke',
  icon: [448, 512, [], "e793", "M0 32l448 0 0 448-448 0 0-448zM224 416l160 0 0-320-160 0 0 320z"]
};
var faKitchenSet = {
  prefix: 'fass',
  iconName: 'kitchen-set',
  icon: [576, 512, [], "e51a", "M240 144a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288 64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112l59.6 0 0-16 200 0 0 96-200 0 0-16-59.6 0zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM424 240l0 32 120 0 0 48-288 0 0-48 120 0 0-32 48 0zM288 352l224 0 0 160-224 0 0-160zM176 320c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0 0 32-128 0 0-128 144 0zm0 64c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0 32 16 0zm48 80l0 48-224 0 0-48 224 0z"]
};
var faDna = {
  prefix: 'fass',
  iconName: 'dna',
  icon: [384, 512, [129516], "f471", "M384 0l-64 0 0 32-256 0 0-32-64 0 0 32c0 57.8 24.4 104.8 57.4 144.5 24.1 28.9 53.8 55.1 83.6 79.5-29.8 24.5-59.5 50.6-83.6 79.5-33 39.6-57.4 86.7-57.4 144.5l0 32 64 0 0-32 256 0 0 32 64 0 0-32c0-57.8-24.4-104.8-57.4-144.5-24.1-28.9-53.8-55.1-83.6-79.5 29.8-24.5 59.5-50.6 83.6-79.5 33-39.6 57.4-86.7 57.4-144.5l0-32zM79.9 96l224.2 0c-5.6 10.9-12.5 21.5-20.6 32l-182.9 0c-8.2-10.5-15.1-21.1-20.6-32zM146 176l92 0c-14.3 13-29.8 25.8-46 39-16.2-13.1-31.7-26-46-39zM304.1 416L79.9 416c5.6-10.9 12.5-21.5 20.6-32l182.9 0c8.2 10.5 15.1 21.1 20.6 32zM238 336l-92 0c14.3-13 29.8-25.8 46-39 16.2 13.1 31.7 26 46 39z"]
};
var faCircleBangladeshiTaka = {
  prefix: 'fass',
  iconName: 'circle-bangladeshi-taka',
  icon: [512, 512, [], "e701", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM136 128l27.4 0c33.5 0 60.6 27.1 60.6 60.6l0 19.4 32 0 0 32-32 0 0 83.4c0 6.9 5.6 12.6 12.6 12.6l24 0c37.2 0 67.4-30.2 67.4-67.4l0-16c0-6.9-5.6-12.6-12.6-12.6l-3.4 0-24 0 0-48 24 0 3.4 0c33.5 0 60.6 27.1 60.6 60.6l0 16C376 332.3 324.3 384 260.6 384l-24 0c-33.5 0-60.6-27.1-60.6-60.6l0-83.4-29.7 0 0-32 29.7 0 0-19.4c0-6.9-5.6-12.6-12.6-12.6l-27.4 0 0-48z"]
};
var faBoxCircleCheck = {
  prefix: 'fass',
  iconName: 'box-circle-check',
  icon: [576, 512, [], "e0c4", "M401.4 128l-290.7 0 34.3-48 222.1 0 34.3 48zM400 16l-288 0-80 112 0 352 225.4 0c-11.2-24.4-17.4-51.4-17.4-80 0-106 86-192 192-192 16.6 0 32.7 2.1 48 6l0-86-80-112zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L353.4 400 376 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z"]
};
var faTrillium = {
  prefix: 'fass',
  iconName: 'trillium',
  icon: [448, 512, [], "e588", "M233.6 413.8l0 0c16.2 9.3 33.7 15 51.3 18.4-27.2 38.9-60.1 66.6-60.6 67-.6-.5-33.5-28.2-60.6-67 17.6-3.3 35.2-9 51.3-18.4l0 0 6.2-3.8c1.1-.7 2.1-1.4 3.1-2.2 3 2.1 6.1 4.1 9.3 5.9zM224.3 0c.5 .5 96 80.2 96 160 0 14.5-3.2 28.2-8.9 40.5 13.1 1.3 26.1 5.4 38.2 12.4 69.2 39.9 90.5 162.7 90.6 163.1-1 .4-117.6 43-186.6 3.1-11.8-6.8-21.7-15.8-29.3-26.1-7.6 10.3-17.5 19.3-29.3 26.1-69.1 39.9-185.8-2.9-186.6-3.1 .1-.3 21.4-123.2 90.6-163.1 12.1-7 25.1-11.1 38.2-12.4-5.7-12.3-8.9-26-8.9-40.5 0-79.7 95.4-159.5 96-160zm0 200a40 40 0 1 0 0 80 40 40 0 1 0 0-80zM98.9 104c-6.4 17.6-10.5 36.5-10.5 56 0 4.4 .2 8.8 .7 13.1-1.1 .5-2.3 1.1-3.4 1.6l-6.5 3.5 0 0c-15.9 9.2-29.5 21.3-41.1 34.6-21.4-44.3-29.3-89.2-29.4-89.7 .9-.3 42.4-15.3 90.4-19.2zm250.9 0c48 3.8 89.6 18.9 90.4 19.2-.2 .9-8.1 45.6-29.5 89.7-9.5-10.9-20.2-20.9-32.5-29.2l-8.6-5.3 0 0-6.5-3.5c-1.1-.6-2.3-1.1-3.4-1.6 .4-4.3 .7-8.6 .7-13.1 0-19.5-4.2-38.4-10.6-56z"]
};
var faDeleteRight = {
  prefix: 'fass',
  iconName: 'delete-right',
  icon: [640, 512, [], "e154", "M64 64l0 384 400 0 176-192-176-192-400 0zM372.9 205.1c-8.5 8.5-25.5 25.5-50.9 50.9 25.5 25.5 42.4 42.4 50.9 50.9l-33.9 33.9c-8.5-8.5-25.5-25.5-50.9-50.9-25.5 25.5-42.4 42.4-50.9 50.9l-33.9-33.9c8.5-8.5 25.5-25.5 50.9-50.9l-50.9-50.9 33.9-33.9 50.9 50.9c25.5-25.5 42.4-42.4 50.9-50.9l33.9 33.9z"]
};
var faCircleColon = {
  prefix: 'fass',
  iconName: 'circle-colon',
  icon: [512, 512, [], "e6fc", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm23.2-394.9l-4.1 12.4c9.7 1.4 19 4 27.8 7.4 7.5-22.4 12.5-37.4 15-45.1l30.4 10.1c-2.2 6.7-7.9 23.6-16.9 50.6 10.3 7.5 19.4 16.5 27 26.6L320 208c-1.6-2.1-3.3-4.2-5.1-6.1L270.6 334.7c20.1-3.7 37.5-14.9 49.4-30.7l38.4 28.8c-23.3 31-60.5 51.2-102.4 51.2-.6 0-1.2 0-1.8 0-5 15-9 27.1-12.1 36.3l-30.4-10.1c3.4-10.1 6.8-20.3 10.2-30.7-9.4-2.6-18.3-6.2-26.7-10.7-9.3 27.8-15 44.9-17.2 51.5l-30.4-10.1c1.7-5 8.5-25.4 20.4-61.1-24.7-23.3-40.1-56.4-40.1-93.1 0-65.8 49.7-120 113.5-127.2l12.3-37 30.4 10.1-5.1 15.2zm8.5 65.4c-8.7-3.7-18.2-6-28.1-6.4L210.9 322c7.9 5.4 16.8 9.4 26.4 11.7l50.4-151.3zm-64.1 .4c-28 12.5-47.5 40.5-47.5 73.1 0 14.2 3.7 27.5 10.1 39l37.4-112.1z"]
};
var faChildReaching = {
  prefix: 'fass',
  iconName: 'child-reaching',
  icon: [384, 512, [], "e59d", "M192.1 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-16 384l0 128-64 0 0-273.2-8.6-10.3C40.2 152.6 6.7 112.4 3 107.9l49.2-41c5.3 6.4 35.6 42.8 90.9 109.1l99.3 0c54-66.1 83.8-102.4 89.1-109l49.5 40.5c-3.8 4.6-36.7 44.9-98.7 120.8l-9.6 11.7-.7 0 0 272-64 0 0-128-32 0z"]
};
var faFaceConfounded = {
  prefix: 'fass',
  iconName: 'face-confounded',
  icon: [512, 512, [], "e36c", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM228.5 344.4l27.5 22c21-16.8 34-27.2 38.9-31.1 3.5 2.3 20.8 13.9 52 34.7 9.1-3 20.3-6.8 33.7-11.2l12.6 37.9c-11.8 3.9-26.1 8.7-43 14.3l-9.3 3.1c-.8-.5-15.5-10.3-44-29.3-21.7 17.4-35.4 28.3-41.1 32.9-5.6-4.5-19.3-15.5-41.1-32.9-28.5 19-43.2 28.8-44 29.3-9.8-3.3-49.3-16.4-52.3-17.4l12.6-37.9c13.4 4.5 24.6 8.2 33.7 11.2 31.2-20.8 48.5-32.4 52-34.7l11.4 9.1zM135.2 177.7l95.6 48 9.2 4.6 0 20.2-10.2 4.3-95.6 40-14.7-28.3 44.2-27.6-45.3-34 16.8-27.1zm146 48l95.6-48 16.8 27.1-45.3 34 44.2 27.6-14.7 28.3-95.6-40-10.2-4.3 0-20.2 9.2-4.6z"]
};
var faSidebar = {
  prefix: 'fass',
  iconName: 'sidebar',
  icon: [512, 512, [], "e24e", "M512 448l-256 0 0-384 256 0 0 384zM0 64l208 0 0 384-208 0 0-384zm160 64l-112 0 0 48 112 0 0-48zM48 216l0 48 112 0 0-48-112 0zm112 88l-112 0 0 48 112 0 0-48z"]
};
var faPaste = {
  prefix: 'fass',
  iconName: 'paste',
  icon: [512, 512, ["file-clipboard"], "f0ea", "M352 0l-352 0 0 448 176 0 0-336-96 0 0-48 192 0 0 48 80 0 0-112zm64 160l-192 0 0 352 288 0 0-256-96-96z"]
};
var faFileClipboard = faPaste;
var faInhaler = {
  prefix: 'fass',
  iconName: 'inhaler',
  icon: [640, 512, [], "f5f9", "M224 224l144 0 24.5-91.9 174.6 155.2-55.1 192.7-288 0 0-256zm357.7 12.1L406.3 80.2 432-16 640 32 581.7 236.1zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 448a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faMeteor = {
  prefix: 'fass',
  iconName: 'meteor',
  icon: [512, 512, [9732], "f753", "M512 0L299.4 75.9 304 16 101.3 133.4C38.6 169.7 0 236.6 0 309 0 421.1 90.9 512 203 512 275.4 512 342.3 473.4 378.6 410.7L496 208 436.1 212.6 512 0zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faHoneyPot = {
  prefix: 'fass',
  iconName: 'honey-pot',
  icon: [448, 512, [127855], "e418", "M128 32l-96 0 0 64 32 0C25.1 125.2 0 171.7 0 224 0 400 128 480 128 480l192 0s128-80 128-256c0-52.3-25.1-98.8-64-128l32 0 0-64-240 0 0 128-48 0 0-128zM96.9 352C78.7 320.3 64 278.1 64 224l320 0c0 54.1-14.7 96.3-32.9 128L96.9 352z"]
};
var faLaptopSlash = {
  prefix: 'fass',
  iconName: 'laptop-slash',
  icon: [640, 512, [], "e1c7", "M81.2-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-32.1-32.1 6 0 56-56 0-40-158 0-288-288 318 0 0 240 64 0 0-304-446 0-48.9-48.9zM128 336l0-170-64-64 0 234 64 0zM442 480l-96-96-346 0 0 40 56 56 386 0z"]
};
var faGears = {
  prefix: 'fass',
  iconName: 'gears',
  icon: [640, 512, ["cogs"], "f085", "M464.7 261.9c10.4 1.4 20.4 4.2 29.9 8.1l53-35.3 49.8 49.8-35.3 53c1.9 4.7 3.7 9.6 5 14.7s2.3 10.2 3 15.2l57.1 28.2-18.2 68-63.5-4.1c-6.3 8.2-13.7 15.6-21.9 22l4.1 63.5-68 18.2-28.2-57c-10.4-1.4-20.4-4.2-30-8.1l-52.9 35.3-49.8-49.8 35.3-53c-1.9-4.7-3.6-9.6-5-14.7s-2.3-10.2-3-15.2l-57.1-28.2 18.2-68 63.5 4.1c6.3-8.2 13.6-15.6 21.9-22l-4.1-63.4 68-18.2 28.2 57zM448.1 340a44 44 0 1 0 0 88 44 44 0 1 0 0-88zM271.7-32.9l-4.1 63.4c8.3 6.4 15.6 13.8 21.9 22l63.5-4.1 18.2 68-57.1 28.2c-.7 5.1-1.6 10.2-3 15.2-1.4 5.1-3.1 10-5 14.7l35.3 53-49.8 49.8-53-35.3c-9.5 3.9-19.6 6.6-30 8.1l-28.2 57-68-18.2 4.1-63.5c-8.3-6.4-15.6-13.8-21.9-22l-63.5 4.2-18.2-68 57.1-28.3c.7-5.1 1.7-10.2 3-15.2 1.4-5.1 3.1-10 5-14.7L42.8 28.5 92.5-21.3 145.5 14c9.5-3.9 19.6-6.6 30-8.1l28.2-57 68 18.2zM192.1 84a44 44 0 1 0 .1 88 44 44 0 1 0 -.1-88z"]
};
var faCogs = faGears;
var faWaveSine = {
  prefix: 'fass',
  iconName: 'wave-sine',
  icon: [640, 512, [8767], "f899", "M58.2 148.8C77.4 97.8 126.1 64 180.6 64l4.5 0c56.1 0 106.5 34.1 127.3 86.2L387.5 338c11.1 27.8 38 46 67.9 46 30.5 0 57.8-18.9 68.5-47.4 16.8-44.8 28-74.8 33.7-89.8l59.9 22.5c-5.6 15-16.8 44.9-33.7 89.8-20.1 53.5-71.2 89-128.4 89-56.1 0-106.5-34.1-127.3-86.2L252.9 174c-11.1-27.8-38-46-67.9-46l-4.5 0c-27.8 0-52.6 17.2-62.4 43.2-18.1 48.3-29.9 79.7-35.2 94L23 242.7c5.4-14.3 17.1-45.6 35.2-94z"]
};
var faArrowTurnLeftUp = {
  prefix: 'fass',
  iconName: 'arrow-turn-left-up',
  icon: [384, 512, [], "e634", "M352 448l32 0 0 64-224 0 0-402.7c-57.4 57.4-89.4 89.4-96 96l-45.3-45.3 22.6-22.6 128-128 22.6-22.6 22.6 22.6 128 128 22.6 22.6-45.3 45.3c-6.6-6.6-38.6-38.6-96-96l0 338.7 128 0z"]
};
var faGarage = {
  prefix: 'fass',
  iconName: 'garage',
  icon: [576, 512, [], "e009", "M0 512l0-416 288-96 288 96 0 416-64 0 0-320-448 0 0 320-64 0zM464 320l-352 0 0-80 352 0 0 80zm0 192l-352 0 0-144 352 0 0 144zM224 416l0 48 128 0 0-48-128 0z"]
};
var faFlatbreadStuffed = {
  prefix: 'fass',
  iconName: 'flatbread-stuffed',
  icon: [576, 512, [129369], "e40c", "M436.1 40.2l-67.3 3.3-87-56-75.9 70.3-102.6 13-13 102.6-70.3 75.9 56 87-3.3 67.3 88.1-88.1c-10.5-14.5-16.6-32.3-16.6-51.5 0-48.6 39.4-88 88-88 19.2 0 37 6.2 51.5 16.6L436.1 40.2zM107.1 437c46.3 46.3 110.3 75 181 75 141.4 0 256-114.6 256-256 0-70.7-28.7-134.7-75-181l-362 362zm125-21a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-40-56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faUTurnDownLeft = {
  prefix: 'fass',
  iconName: 'u-turn-down-left',
  icon: [512, 512, [], "e7ef", "M512 240c0 114.9-93.1 208-208 208l-144 0 0 96-160-160 160-160 0 96 144 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-240 0 0-128 240 0c114.9 0 208 93.1 208 208z"]
};
var faFaceShakingHorizontal = {
  prefix: 'fass',
  iconName: 'face-shaking-horizontal',
  icon: [640, 512, [], "e79d", "M531.3 336L472 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l37.8 0c-44.3 76.5-127 128-221.8 128-141.4 0-256-114.6-256-256S146.6 0 288 0C407.3 0 507.5 81.6 535.9 192l16.1 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-24 0 0-48 24 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-80 0c-13.3 0-24 10.7-24 24 0 13.2 10.7 23.9 23.9 24l80.1 0c33.4 0 64-12 87.6-32-4 44.9-41.7 80-87.6 80l-20.7 0zM163.8 319.5l-39.5 27.3C153.1 388.6 201.3 416 256 416s102.9-27.4 131.8-69.2l-39.5-27.3C328 348.9 294.2 368 256 368s-72-19.1-92.2-48.5zM148 216c0-11 9-20 20-20l16 0c11 0 20 9 20 20l0 16 40 0 0-16c0-33.1-26.9-60-60-60l-16 0c-33.1 0-60 26.9-60 60l0 16 40 0 0-16zm180-20l16 0c11 0 20 9 20 20l0 16 40 0 0-16c0-33.1-26.9-60-60-60l-16 0c-33.1 0-60 26.9-60 60l0 16 40 0 0-16c0-11 9-20 20-20z"]
};
var faEyes = {
  prefix: 'fass',
  iconName: 'eyes',
  icon: [576, 512, [], "e367", "M96 224c-11.2 0-21.7 2.9-30.9 7.9 3.5-37.5 15.1-70.1 31-93.9 19.3-29 42.6-42 63.9-42s44.5 13 63.9 42c19.2 28.8 32.1 70.4 32.1 118s-12.9 89.2-32.1 118c-19.3 29-42.6 42-63.9 42s-44.5-13-63.9-42c-4.7-7-9-14.8-12.8-23.3 4.1 .8 8.4 1.3 12.7 1.3 35.3 0 64-28.7 64-64s-28.7-64-64-64zM288 120.6c-3.4-6.3-7-12.4-10.9-18.2-27-40.5-67.8-70.5-117.1-70.5S69.8 62 42.9 102.5C15.7 143.2 0 197.5 0 256S15.7 368.8 42.9 409.5C69.8 450 110.6 480 160 480s90.2-30 117.1-70.5c3.9-5.8 7.5-11.8 10.9-18.2 3.4 6.3 7 12.4 10.9 18.2 27 40.5 67.8 70.5 117.1 70.5s90.2-30 117.1-70.5C560.3 368.8 576 314.5 576 256s-15.7-112.8-42.9-153.5C506.2 62 465.4 32 416 32s-90.2 30-117.1 70.5c-3.9 5.8-7.5 11.8-10.9 18.2zm51.3 230.1c4.1 .8 8.4 1.3 12.7 1.3 35.3 0 64-28.7 64-64s-28.7-64-64-64c-11.2 0-21.7 2.9-30.9 7.9 3.5-37.5 15.1-70.1 31-93.9 19.4-29 42.6-42 63.9-42s44.5 13 63.9 42c19.2 28.8 32.1 70.4 32.1 118s-12.9 89.2-32.1 118c-19.4 29-42.6 42-63.9 42s-44.5-13-63.9-42c-4.7-7-9-14.8-12.8-23.3z"]
};
var faDash = {
  prefix: 'fass',
  iconName: 'dash',
  icon: [512, 512, ["minus-large"], "e404", "M0 224l512 0 0 64-512 0 0-64z"]
};
var faMinusLarge = faDash;
var faPhotoFilmMusic = {
  prefix: 'fass',
  iconName: 'photo-film-music',
  icon: [640, 512, [], "e228", "M192 0l416 0 0 181.3-73.5 13.4-70.5-114.6-84.7 137.7-43.3-57.7-96 128 112 0 0 64-160 0 0-352zM352 403.8c-15.3 3.8-29.7 10.5-42.1 19.7-17.1 12.8-31.9 32.2-36.5 56.4l-273.5 0 0-352 144 0 0 272 208 0 0 3.8zM320 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM104 184l-48 0 0 48 48 0 0-48zm0 96l-48 0 0 48 48 0 0-48zm0 96l-48 0 0 48 48 0 0-48zM624 255.8l0 208.1c0 23.3-18 35.4-29.1 40.5-11.9 5.4-25.4 7.5-34.9 7.5s-22.9-2.1-34.9-7.5c-11.1-5-29.1-17.2-29.1-40.5s18-35.4 29.1-40.5c11.9-5.4 25.4-7.5 34.9-7.5 4.6 0 10.1 .5 16 1.6l0-85-128 23.3 0 140.1c0 23.3-18 35.4-29.1 40.5-11.9 5.4-25.4 7.5-34.9 7.5s-22.9-2.1-34.9-7.5c-11.1-5-29.1-17.2-29.1-40.5s18-35.4 29.1-40.5c11.9-5.4 25.4-7.5 34.9-7.5 4.6 0 10.1 .5 16 1.6l0-181.8 19.7-3.6 176-32 28.3-5.1 0 28.8z"]
};
var faLocationArrowSlash = {
  prefix: 'fass',
  iconName: 'location-arrow-slash',
  icon: [576, 512, [], "e77a", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-162-162 128.8-317.1-317.1 128.8-161.7-161.7zM243.4 313.1l76.8 214.9 39.9-98.3-116.7-116.7zm-129-129L16.1 224 231.1 300.8 114.4 184.1z"]
};
var faCircleM = {
  prefix: 'fass',
  iconName: 'circle-m',
  icon: [512, 512, [], "e115", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM144 168l0-24 36.2 0 7.2 9.8 68.6 93.6 68.6-93.6 7.2-9.8 36.2 0 0 224-48 0 0-126.7c-34 46.3-55.3 75.4-64 87.3-8.7-11.8-30-40.9-64-87.3l0 126.7-48 0 0-200z"]
};
var faArrowUpToDottedLine = {
  prefix: 'fass',
  iconName: 'arrow-up-to-dotted-line',
  icon: [384, 512, [], "e0a1", "M0 0L64 0 64 64 0 64 0 0zM192 114.7l22.6 22.6 128 128 22.6 22.6-45.3 45.3c-6.6-6.6-38.6-38.6-96-96l0 274.7-64 0 0-274.7c-57.4 57.4-89.4 89.4-96 96l-45.3-45.3 22.6-22.6 128-128 22.6-22.6zM170.7 0l0 64-64 0 0-64 64 0zm42.7 0l64 0 0 64-64 0 0-64zM384 0l0 64-64 0 0-64 64 0z"]
};
var faFileCirclePlus = {
  prefix: 'fass',
  iconName: 'file-circle-plus',
  icon: [576, 512, [58606], "e494", "M272 0l-240 0 0 512 244 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3L416 144 272 0zm85.5 176L240 176 240 58.5 357.5 176zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 64 0 0 32-64 0 0 64-32 0 0-64-64 0 0-32 64 0 0-64 32 0 0 16z"]
};
var faMustache = {
  prefix: 'fass',
  iconName: 'mustache',
  icon: [640, 512, [], "e5bc", "M192 112l-8 0-6.4 4.8-83.5 62.7C51.3 155.7 20 138.3 0 127.2l0 80.1 0 0c0 106.4 86.2 192.6 192.6 192.6 46.7 0 91.7-16.9 126.9-47.7l.5-.4 .5 .4C355.6 383.1 400.7 400 447.4 400 553.8 400 640 313.8 640 207.4l0 0c0-26 0-52.7 0-80.1-20 11.1-51.3 28.5-94 52.2l-83.6-62.7-6.4-4.8-99 0c-1 1.2-13.3 15.6-37 43.1-23.6-27.6-35.9-41.9-37-43.1l-91 0z"]
};
var faWindowFrame = {
  prefix: 'fass',
  iconName: 'window-frame',
  icon: [448, 512, [129695], "e04f", "M416 448l32 0 0 64-448 0 0-64 32 0 0-448 384 0 0 448zM352 224l0-160-96 0 0 160 96 0zm-96 64l0 160 96 0 0-160-96 0zm-64-64l0-160-96 0 0 160 96 0zM96 288l0 160 96 0 0-160-96 0z"]
};
var faHouseNight = {
  prefix: 'fass',
  iconName: 'house-night',
  icon: [640, 512, [], "e010", "M88 56c0-38.1 24.2-70.5 58-82.7-10.7-3.4-22.1-5.3-34-5.3-61.9 0-112 50.1-112 112S50.1 192 112 192c40.6 0 76.1-21.6 95.8-53.9-9.9 3.8-20.6 5.9-31.8 5.9-48.6 0-88-39.4-88-88zM557.5 336l50.5 0 0-40-240-216-240 216 0 40 50.5 0 0 208 379.1 0 0-208zM522.7 74.7L480 96 522.7 117.3 544 160 565.3 117.3 608 96 565.3 74.7 544 32 522.7 74.7zM256-32L234.7 10.7 192 32 234.7 53.3 256 96 277.3 53.3 320 32 277.3 10.7 256-32zm64 320l96 0 0 96-96 0 0-96z"]
};
var faReel = {
  prefix: 'fass',
  iconName: 'reel',
  icon: [448, 512, [], "e238", "M32 0l384 0 0 64-32 0 0 32-320 0 0-32-32 0 0-64zM384 448l32 0 0 64-384 0 0-64 32 0 0-32 320 0 0 32zm0-312l0 48-320 0 0-48 320 0zm64 96l0 48-384 0 0-48 384 0zM64 328l320 0 0 48-320 0 0-48z"]
};
var faIcicles = {
  prefix: 'fass',
  iconName: 'icicles',
  icon: [512, 512, [], "f7ad", "M96 352l-96-352 512 0-96 512-80-352-48 192-48-160-48 224-48-224-48 160z"]
};
var faBinarySlash = {
  prefix: 'fass',
  iconName: 'binary-slash',
  icon: [576, 512, [], "e33e", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-.6-.6-33.3-33.3-98.1-98.1l0-126-126 0-66-66 0-222-192 0 0 30-46.8-46.8zM160.1 94l0-30 64 0 0 94-64-64zM442.3 512l-154.2-154.2 0 154.2 154.2 0zM352.1 0l-32 0 0 64 48 0 0 96-48 0 0 64 160 0 0-64-48 0 0-160-80 0zm-224 288l-32 0 0 64 48 0 0 96-48 0 0 64 160 0 0-64-48 0 0-160-80 0z"]
};
var faSquareSlidersVertical = {
  prefix: 'fass',
  iconName: 'square-sliders-vertical',
  icon: [448, 512, ["sliders-v-square"], "f3f2", "M0 32l448 0 0 448-448 0 0-448zM168 96l-48 0 0 64-56 0 0 48 56 0 0 208 48 0 0-208 56 0 0-48-56 0 0-64zm160 24l0-24-48 0 0 208-56 0 0 48 56 0 0 64 48 0 0-64 56 0 0-48-56 0 0-184z"]
};
var faSlidersVSquare = faSquareSlidersVertical;
var faArrowTrendUp = {
  prefix: 'fass',
  iconName: 'arrow-trend-up',
  icon: [640, 512, [], "e098", "M384.3 96l224 0 0 224-64 0 0-114.7-169.4 169.4-22.6 22.6c-1.3-1.3-44-44-128-128l-137.4 137.4-22.6 22.6-45.3-45.3 22.6-22.6 160-160 22.6-22.6c1.3 1.3 44 44 128 128l146.7-146.7-114.7 0 0-64z"]
};
var faTimelineArrow = {
  prefix: 'fass',
  iconName: 'timeline-arrow',
  icon: [640, 512, [], "e29d", "M208.4 16l-160 0 0 160 48 0 0 48-64 0 0 64 192 0 0 48-48 0 0 160 160 0 0-160-48 0 0-48 224 0 0 73.9c26.1-26.1 55.8-55.8 89-89l17-17c-16.3-16.3-98.1-98.1-105.9-105.9l0 73.9-96 0 0-48 48 0 0-160-160 0 0 160 48 0 0 48-192 0 0-48 48 0 0-160z"]
};
var faFort = {
  prefix: 'fass',
  iconName: 'fort',
  icon: [576, 512, [], "e486", "M64 32l-64 0 0 224 32 0 0 256 512 0 0-256 32 0 0-224-64 0 0 64-32 0 0-64-64 0 0 64-32 0 0-64-64 0 0 128-64 0 0-128-64 0 0 64-32 0 0-64-64 0 0 64-32 0 0-64zM352 320l0 144-128 0 0-144 128 0z"]
};
var faCircleV = {
  prefix: 'fass',
  iconName: 'circle-v',
  icon: [512, 512, [], "e12a", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM233.9 353.4l-89.5-209.4 52.2 0 59.4 138.9 59.4-138.9 52.2 0-89.5 209.4-2.8 6.6-38.5 0-2.8-6.6z"]
};
var faHexagonNodesBolt = {
  prefix: 'fass',
  iconName: 'hexagon-nodes-bolt',
  icon: [576, 512, [], "e69a", "M280 56c0 22.3-13.1 41.6-32 50.6l0 98.8c3.4 1.6 6.6 3.6 9.6 5.8L280 224l0 32 0 4.4 8.9 5.1c-9.3 13-16.9 27.2-22.4 42.5l-10.5-6c-2.5 1.8-5.2 3.3-8 4.7l0 98.8c5.3 2.5 10.2 5.9 14.4 9.9c4.1 14.7 10 28.6 17.6 41.5c-.4 30.6-25.3 55.2-56 55.2c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6l0-98.8c-3.4-1.6-6.6-3.6-9.6-5.8L168 288l0-32 0-4.4L88 206c-2.6 1.8-5.3 3.3-8 4.7l0 90.8c2.8 1.3 5.5 2.9 8 4.7l48-27.4 0 9.4 0 18.6 16.1 9.2 7.8 4.5-48.1 27.5c1.6 20.8-8.6 41.7-27.8 52.8C57.2 416 23 406.8 7.5 380S1.2 319 28 303.5c1.3-.8 2.6-1.5 4-2.1l0-90.8c-1.3-.6-2.7-1.3-4-2.1C1.2 193-8 158.8 7.5 132S57.2 96 84 111.5c19.3 11.1 29.4 32 27.9 52.8L192 210.1c2.5-1.8 5.2-3.3 8-4.7l0-98.8c-18.9-9-32-28.3-32-50.6c0-30.9 25.1-56 56-56s56 25.1 56 56zM432 192c-25.2 0-49.1 5.3-70.8 14.8c-.4-.3-.8-.6-1.3-.9l-48 27.4 0-9.4 0-18.6-16.1-9.2-7.8-4.5 48.1-27.5c-1.6-20.8 8.6-41.6 27.8-52.8c26.8-15.5 61-6.3 76.5 20.5c11.2 19.4 9.5 42.8-2.6 60.1c-2-.1-3.9-.1-5.9-.1zm0 32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm24 64L352 384l66.7 0L408 448l104-96-66.7 0L456 288z"]
};
var faLightEmergencyOn = {
  prefix: 'fass',
  iconName: 'light-emergency-on',
  icon: [640, 512, [], "e420", "M69.3 36l-20-13.3-26.6 39.9c8.6 5.8 31.3 20.9 68 45.3l20 13.3 26.6-39.9-68-45.3zM597.3 76l20-13.3-26.6-39.9c-8.6 5.8-31.3 20.9-68 45.3l-20 13.3 26.6 39.9c8.6-5.8 31.3-20.9 68-45.3zM24 192l-24 0 0 48 120 0 0-48-96 0zm520 0l-24 0 0 48 120 0 0-48-96 0zM320 32c-88.4 0-160 71.6-160 160l0 112 320 0 0-112c0-88.4-71.6-160-160-160zM256 200l0 8-48 0 0-8c0-66.3 53.7-120 120-120l8 0 0 48-8 0c-39.8 0-72 32.2-72 72zM544 352l-448 0 0 128 448 0 0-128z"]
};
var faQuestion = {
  prefix: 'fass',
  iconName: 'question',
  icon: [320, 512, [10067, 10068, 61736], "3f", "M320 160C320.1 71.6 248.4 0 160.1 0 71.7 0 0 71.6 0 160l0 32 64 0 0-32c0-53 43-96 96-96 53 0 96 43 96 96 0 33.2-17.3 65.4-48 83.2-50.7 29.3-77.3 44.6-80 46.2l0 94.7 64 0 0-57.7 48-27.7c51.3-29.6 80-83.4 80-138.5zM192 448l-64 0 0 64 64 0 0-64z"]
};
var faSquareLira = {
  prefix: 'fass',
  iconName: 'square-lira',
  icon: [448, 512, [], "e6e7", "M448 32l-448 0 0 448 448 0 0-448zM143.5 216c0-46.5 37.5-88 88.1-88l2.2 0c19.7 0 38.8 6.4 54.5 18.2l14.2 10.6-28.8 38.4-14.2-10.6C252 179 243 176 233.7 176l-2.2 0c-23 0-40.1 18.9-40 40l96.5 0 0 32-87.5 0c2.1 7.9 3.2 16 3.5 24l84 0 0 32-88 0c-3.2 11.3-8.3 22.1-15.1 32l135.1 0 0 48-200 0 0-42.5c1.1-1.4 9-11.6 23.7-30.5 1.7-2.2 3.3-4.6 4.7-7l-20.4 0 0-32 27.9 0c-.4-6.4-1.8-12.9-4.3-19l-1.4-3.5c-.2-.5-.4-1-.6-1.5l-21.6 0 0-32 15.5 0z"]
};
var faSquareDashedCirclePlus = {
  prefix: 'fass',
  iconName: 'square-dashed-circle-plus',
  icon: [576, 512, [], "e5c2", "M64 32l-32 0 0 112 64 0 0-48 48 0 0-64-80 0zM32 192l0 128 64 0 0-128-64 0zM96 368l-64 0 0 112 225.4 0c-9.1-19.8-14.9-41.3-16.8-64L96 416 96 368zM432 208c16.6 0 32.7 2.1 48 6l0-182-112 0 0 64 48 0 0 112.7c5.3-.4 10.6-.7 16-.7zM320 96l0-64-128 0 0 64 128 0zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 64 0 0 32-64 0 0 64-32 0 0-64-64 0 0-32 64 0 0-64 32 0 0 16z"]
};
var faChairOffice = {
  prefix: 'fass',
  iconName: 'chair-office',
  icon: [448, 512, [], "f6c1", "M352 0l0 240-256 0 0-240 256 0zM64 160l0 96-64 0 0-128 64 0 0 32zm384 0l0 96-64 0 0-128 64 0 0 32zM32 384l0-96 384 0 0 96-160 0 0 64 64 0 0 64-192 0 0-64 64 0 0-64-160 0z"]
};
var faUserMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'user-magnifying-glass',
  icon: [640, 512, [], "e5c5", "M256.4 248c21 0 40.7-5.4 57.8-14.8 10.7-12.1 23.1-22.7 36.8-31.4 15.9-20.4 25.4-46 25.4-73.8 0-66.3-53.7-120-120-120s-120 53.7-120 120 53.7 120 120 120zm-144 56l-64 208 386.3 0c-90.2-3-162.3-77-162.3-167.9 0-13.8 1.7-27.2 4.8-40.1l-164.8 0zm352 208l-.5-1.5c-5.9 .8-11.8 1.3-17.9 1.5l18.3 0zm-24-239.9a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm0 192c24.5 0 47.2-7.3 66.2-19.9 47.9 47.9 73.8 73.8 77.8 77.8l33.9-33.9c-4-4-29.9-30-77.8-77.8 12.6-19 19.9-41.7 19.9-66.2 0-66.3-53.7-120-120-120s-120 53.7-120 120 53.7 120 120 120z"]
};
var faContainerStorage = {
  prefix: 'fass',
  iconName: 'container-storage',
  icon: [576, 512, [], "f4b7", "M0 32l576 0 0 48-32 0 0 352 32 0 0 48-576 0 0-48 32 0 0-352-32 0 0-48zm120 96l0 256 48 0 0-256-48 0zm240 0l-48 0 0 256 48 0 0-256zm48 0l0 256 48 0 0-256-48 0zm-144 0l-48 0 0 256 48 0 0-256z"]
};
var faArrowLeftToBracket = {
  prefix: 'fass',
  iconName: 'arrow-left-to-bracket',
  icon: [512, 512, [], "e669", "M160 96l-96 0 0 320 128 0 0 64-192 0 0-448 192 0 0 64-32 0zm9.4 182.6l-22.6-22.6 22.6-22.6 128-128 22.6-22.6 45.3 45.3c-6.6 6.6-38.6 38.6-96 96l242.7 0 0 64-242.7 0 96 96-45.3 45.3-150.6-150.6z"]
};
var faSparkle = {
  prefix: 'fass',
  iconName: 'sparkle',
  icon: [576, 512, [], "e5d6", "M213.3 181.3L288-16 362.7 181.3 560 256 362.7 330.7 288 528 213.3 330.7 16 256 213.3 181.3z"]
};
var faCampfire = {
  prefix: 'fass',
  iconName: 'campfire',
  icon: [512, 512, [], "f6ba", "M228.5 0c-38.8 24.2-116.4 93.1-116.4 174.5 0 80.3 65.1 145.5 145.5 145.5S403 254.9 403 174.5c0-24.2-17.5-87.3-87.3-145.5L286.6 58.2 228.5 0zm87.3 218.3c0 32.1-26.1 58.2-58.2 58.2s-58.2-26-58.2-58.2c0-43.6 58.2-87.3 58.2-87.3s58.2 43.6 58.2 87.3zm154.8 80.8l-214.4 67.4-214.4-67.4-19.2 61.1 126.9 39.9-126.9 39.9 19.2 61.1 214.4-67.4 214.4 67.4 19.2-61.1-126.9-39.9 126.9-39.9-19.2-61.1z"]
};
var faHandsBound = {
  prefix: 'fass',
  iconName: 'hands-bound',
  icon: [576, 512, [], "e4f9", "M64 32l0-32-64 0 0 235.8 7.7 9 91.9 107.2-27.6 0 0 48 432 0 0-48-27.6 0 91.9-107.2 7.7-9 0-235.8-64 0 0 163.9-76.2 86.4-35.7-24.2c29.6-33.3 50-56.2 61-68.7l-47.8-42.5c-7 7.9-35.5 39.9-85.3 95.9l-8.1 9.1 0 132.2-64 0 0-132.2-8.1-9.1c-49.8-56-78.2-88-85.3-95.9l-47.8 42.5c11.1 12.5 31.4 35.4 61 68.7L140.2 250.3 64 163.9 64 32zM96 432l-24 0 0 48 56 0 0 32 128 0 0-32 64 0 0 32 128 0 0-32 56 0 0-48-408 0z"]
};
var faPanelFire = {
  prefix: 'fass',
  iconName: 'panel-fire',
  icon: [576, 512, [], "e42f", "M32 32l448 0 0 129.4-2.9-2.5-29.1 29.1-32-32 0-60-320 0 0 128 179 0c-2.9 3.4-5.8 6.8-8.6 10.3-14.2 17.8-27.9 38.6-38.6 62-1.3-.2-2.6-.3-3.9-.3-13.3 0-24 10.7-24 24 0 9.2 5.2 17.2 12.7 21.2-3 13.7-4.7 27.9-4.7 42.6 0 34.7 8.5 67.4 23.5 96.2L32 480 32 32zM152 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM384 191.9l64 64 32-32c76.8 64 96 133.3 96 160 0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192zM480 432c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faClockSevenThirty = {
  prefix: 'fass',
  iconName: 'clock-seven-thirty',
  icon: [512, 512, [], "e351", "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM232 392l0-56.7c-14.5 21.7-25.6 38.4-33.3 50l-39.9-26.6c.4-.6 26.2-39.3 77.3-116l44 13.3 0 160-48 0 0-24z"]
};
var faTugrikSign = {
  prefix: 'fass',
  iconName: 'tugrik-sign',
  icon: [384, 512, [], "e2ba", "M32 32l-32 0 0 64 160 0 0 111.3C79 227.5 37.3 237.9 34.9 238.5l11.6 46.6c4.4-1.1 42.2-10.6 113.5-28.4l0 46.5C79 323.5 37.3 333.9 34.9 334.5l11.6 46.6c4.4-1.1 42.2-10.6 113.5-28.4l0 127.3 64 0 0-143.3c81-20.2 122.7-30.7 125.1-31.3l-11.6-46.6c-4.4 1.1-42.2 10.6-113.5 28.4l0-46.5c81-20.2 122.7-30.7 125.1-31.3l-11.6-46.6c-4.4 1.1-42.2 10.6-113.5 28.4l0-95.3 160 0 0-64-352 0z"]
};
var faAudioDescriptionSlash = {
  prefix: 'fass',
  iconName: 'audio-description-slash',
  icon: [576, 512, [], "e0a8", "M32.3-33.8C33-33.2 65.6-.6 130.2 64l414 0 0 384-30 0c36.4 36.4 57.8 57.8 64.1 64.1l-33.9 33.9-17-17-512-512-17-17 33.9-33.9zM352.1 208l24 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-6 0 39.7 39.7c22.8-12.1 38.3-36.1 38.3-63.7l0-48c0-39.8-32.2-72-72-72l-72 0 0 78 48 48 0-78zm-80 133.8l106.2 106.2-346.2 0 0-346.2 100 100c-2.6 6.9-4 14.4-4 22.2l0 128 48 0 0-48 48 0 0 48 48 0 0-10.2z"]
};
var faFaceThermometer = {
  prefix: 'fass',
  iconName: 'face-thermometer',
  icon: [512, 512, [], "e39a", "M256 512c141.4 0 256-114.6 256-256 0-3.2-.1-6.4-.2-9.6l-9.6 9.2-26.9-26.9-22.6 22.6 26.5 26.5-25.8 24.9-26.1-26.1-22.6 22.6 25.6 25.6-25.8 24.9-25.2-25.2-22.6 22.6 28 28-23.1 15.9-.6 .5-.1-.1-12.7 8.8C328 371.1 294.2 352 256 352s-72 19.1-92.2 48.5l-39.5-27.3c28.8-41.8 77.1-69.2 131.8-69.2 22.1 0 43.2 4.5 62.3 12.6L457 182.4C468.2 171.5 483.9 168.1 498 172.2 463.2 72 368 0 256 0 114.6 0 0 114.6 0 256S114.6 512 256 512zM176 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faLightbulbCflOn = {
  prefix: 'fass',
  iconName: 'lightbulb-cfl-on',
  icon: [640, 512, [], "e5a7", "M294.8 69L160 96 160 32C255.8 12.8 309.1 2.2 320 0l0 64-25.2 5zM480 128l-320 64 0-64 320-64 0 64zM160 224l320-64 0 64-320 64 0-64zM416 384l0 128-192 0 0-128 32 0 0-82.6 48-9.6 0 92.2 32 0 0-99.2 144-28.8 0 64-96 19.2 0 44.8 32 0zM58.7 26.5l53.5 26.7-21.5 42.9C60.3 81 19.5 60.6 15.8 58.7L37.3 15.8 58.7 26.5zm544 42.9C579.6 81 561.8 89.9 549.3 96.2L527.8 53.3C558.2 38 599 17.7 602.7 15.8l21.5 42.9-21.5 10.7zM24 168l56 0 0 48-80 0 0-48 24 0zm560 0l56 0 0 48-80 0 0-48 24 0zM90.7 341.5C67.6 353 49.8 361.9 37.3 368.2L15.8 325.3C46.2 310 87 289.7 90.7 287.8l21.5 42.9-21.5 10.7zm458.5-53.7l74.9 37.5-21.5 42.9-74.9-37.5 21.5-42.9z"]
};
var faClockThree = {
  prefix: 'fass',
  iconName: 'clock-three',
  icon: [512, 512, [], "e356", "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 160 152 0 0-48-104 0 0-136-48 0 0 24z"]
};
var faPersonWalkingLuggage = {
  prefix: 'fass',
  iconName: 'person-walking-luggage',
  icon: [576, 512, [], "e554", "M408.5 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm-104 88l-13.3 0-9.4 9.4-80 80-9.4 9.4 0 95.6-28.7 57.4c-41.1-20.5-63.2-31.6-66.4-33.2l-79.2 158.3-7.2 14.3 14.3 7.2 80 40 14.3 7.2 7.2-14.3 38.4-76.8 .8 .4 72-144 1.4-2.7 17.2 0 0-82.7 32-32 0 69.3c0 28 12.2 54.7 33.5 72.9l80.6 69.1c11 71.6 17.4 112.9 19.1 123.9l63.3-9.7c-1.4-9-8.3-54.2-20.9-135.6l-1.8-11.7-9-7.7-52.8-45.3 0-115.2c17.6 22 28.4 35.6 32.6 40.8l111.4 0 0-64-80.6 0-54.4-68-9.6-12-95.4 0zM288.6 371L276 415.2c-44.7 44.7-71.6 71.6-80.8 80.8l45.3 45.3c8.2-8.2 37.1-37.1 86.6-86.6l5.9-5.9c.8-2.7 3.8-13.2 9-31.5l-46-39.4c-2.5-2.2-5-4.4-7.4-6.8z"]
};
var faFileArrowDown = {
  prefix: 'fass',
  iconName: 'file-arrow-down',
  icon: [384, 512, ["file-download"], "f56d", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM175 441l17 17c3.5-3.5 30.5-30.5 81-81l17-17-33.9-33.9c-10.3 10.3-23.6 23.6-40 40l0-110.1-48 0 0 110.1c-16.4-16.4-29.7-29.7-40-40L94.1 360c3.5 3.5 30.5 30.5 81 81z"]
};
var faFileDownload = faFileArrowDown;
var faPersonBooth = {
  prefix: 'fass',
  iconName: 'person-booth',
  icon: [576, 512, [], "f756", "M152 24A56 56 0 1 0 40 24 56 56 0 1 0 152 24zM64 112l-32 0 0 160c0 30.2 14.2 58.7 38.4 76.8l89.6 67.2 0 128 64 0 0-160-12.8-9.6-67.2-50.4 0-80.1c16.7 23.4 27.2 38.1 31.5 44.1l112.5 0 0-64-79.5 0-70.4-98.6-9.6-13.4-64.5 0zM32 512l0 32 64 0 0-116-54.4-40.8c-3.3-2.5-6.5-5.1-9.6-7.9L32 512zM280 0l-24 0 0 176 48 0 0-82.7 80 146.7-32 208 176 0 0 96 48 0 0-544-296 0zm24 336l-48 0 0 208 48 0 0-208z"]
};
var faLocust = {
  prefix: 'fass',
  iconName: 'locust',
  icon: [576, 512, [], "e520", "M360 32c116.6 0 211.6 92.4 215.8 208l.2 0 0 80c0 44.2-35.8 80-80 80l-12.4 0 45.7 80-55.3 0-45.7-80-80.4 0-55.4 80-58.3 0 55.4-80-53 0-59.8 80-59.9 0 64.9-86.9-41.2-15.7-81 102.6-61.2 0 270.7-342.9 25-31.7c9.7 22.5 22.1 51.6 37.4 87.2 30.2-40.4 52.2-69.8 66.1-88.4 6.7 15.6 26.1 60.8 58.2 135.7l72 0C523.7 150.9 450.1 80 360 80l-72 0 0-48 72 0zM56.3 345.2l-24.3-9.2 0-96 108.4 0-84.2 105.2zM488 296a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM249.1 240l47.2 0 2.1-2.8-16.6-38.6-32.7 41.5zm107.1 0l47.4 0-17.3-40.3-30.2 40.3z"]
};
var faWindow = {
  prefix: 'fass',
  iconName: 'window',
  icon: [512, 512, [], "f40e", "M512 64l-512 0 0 384 512 0 0-384zM128 128l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0z"]
};
var faRightLong = {
  prefix: 'fass',
  iconName: 'right-long',
  icon: [576, 512, ["long-arrow-alt-right"], "f30b", "M576 256l-192-192 0 128-384 0 0 128 384 0 0 128 192-192z"]
};
var faLongArrowAltRight = faRightLong;
var faTruckDroplet = {
  prefix: 'fass',
  iconName: 'truck-droplet',
  icon: [576, 512, [], "e58c", "M416 32L0 32 0 448 67.3 448c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l102.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l67.3 0 0-237.3-9.4-9.4-64-64-9.4-9.4-77.3 0 0-96zm96 205.3l0 50.7-96 0 0-96 50.7 0 45.3 45.3zM152 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm232 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM208 304c-39.8 0-72-32.2-72-72 0-48 72-120 72-120s72 72 72 120-32.2 72-72 72z"]
};
var faHandHoldingMedical = {
  prefix: 'fass',
  iconName: 'hand-holding-medical',
  icon: [576, 512, [], "e05c", "M240 0l96 0 0 80 80 0 0 96-80 0 0 80-96 0 0-80-80 0 0-96 80 0 0-80zM66.7 384l70.6-70.6 9.4-9.4 237.3 0 0 64-128 0 0 48 138.8 0c73.3-50.4 115.7-79.6 127.5-87.6l45.3 65.9c-6.1 4.2-59.8 41.1-161 110.7l-10.2 7-396.4 0 0-128 66.7 0z"]
};
var faHandPointLeft = {
  prefix: 'fass',
  iconName: 'hand-point-left',
  icon: [512, 512, [], "f0a5", "M0 96l0 64 240 0 0-64-240 0zM160 288l0 64 128 0 0-64-128 0zm-32-32l112 0 0-64-112 0 0 64zm64 128l0 64 128 0 0-64-128 0zM363 64l-91 0 0 192 80 0 0-112 32 0 0 144-64 0 0 64 32 0 0 96c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64z"]
};
var faCalculator = {
  prefix: 'fass',
  iconName: 'calculator',
  icon: [384, 512, [128425], "f1ec", "M384 0L0 0 0 512 384 512 384 0zM320 64l0 96-256 0 0-96 256 0zM64 208l48 0 0 48-48 0 0-48zm152 0l0 48-48 0 0-48 48 0zm56 0l48 0 0 48-48 0 0-48zM112 304l0 48-48 0 0-48 48 0zm56 0l48 0 0 48-48 0 0-48zm152 0l0 48-48 0 0-48 48 0zM64 400l160 0 0 48-160 0 0-48zm256 0l0 48-48 0 0-48 48 0z"]
};
var faOilTemperature = {
  prefix: 'fass',
  iconName: 'oil-temperature',
  icon: [640, 512, ["oil-temp"], "f614", "M592 368s48 64 48 96-21.5 48-48 48-48-21.5-48-48c0-32 48-96 48-96zM209.2 224c-10.9 18.8-17.2 40.7-17.2 64 0 70.7 57.3 128 128 128s128-57.3 128-128c0-11.9-1.7-23.4-4.7-34.4l4.7 2.4 160-32 32 32-208 224-336 0 0-69.3-96-42.7 0-144 209.2 0zM416 64l-64 0 0 32 64 0 0 64-64 0 0 54.7c28.2 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.8-61 48-73.3L288 0 416 0 416 64zM48 336.8l48 21.3 0-86.1-48 0 0 64.8z"]
};
var faOilTemp = faOilTemperature;
var faMinus = {
  prefix: 'fass',
  iconName: 'minus',
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M0 224l448 0 0 64-448 0 0-64z"]
};
var faSubtract = faMinus;
var faMessageArrowDown = {
  prefix: 'fass',
  iconName: 'message-arrow-down',
  icon: [512, 512, ["comment-alt-arrow-down"], "e1db", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM239 337c-57.2-57.2-86.8-86.8-89-89L184 214.1c9 9 25 25 48 48l0-126.1 48 0 0 126.1c23-23 39-39 48-48L361.9 248c-2.1 2.1-31.8 31.8-89 89l-17 17-17-17z"]
};
var faCommentAltArrowDown = faMessageArrowDown;
var faShoe = {
  prefix: 'fass',
  iconName: 'shoe',
  icon: [640, 512, [], "e6d8", "M0 336l0-160 192 0 32-112 48 0 74.8 67.3c-33.6 33.6-53.9 53.9-60.7 60.7L320 225.9c6.6-6.6 27.4-27.4 62.5-62.5l31.6 28.5C391 215 375 231 366.1 240L400 273.9c7.6-7.6 26.4-26.4 56.5-56.5l101.4 39c36.5 14.1 63.9 43.7 75.7 79.6L0 336zm0 48l640 0 0 64-352 0-96-32 0 32-192 0 0-64z"]
};
var faGameBoardSimple = {
  prefix: 'fass',
  iconName: 'game-board-simple',
  icon: [448, 512, ["game-board-alt"], "f868", "M0 32l448 0 0 448-448 0 0-448zM224 96l0 160 160 0 0-160-160 0zm0 160l-160 0 0 160 160 0 0-160z"]
};
var faGameBoardAlt = faGameBoardSimple;
var faArrowTurnLeft = {
  prefix: 'fass',
  iconName: 'arrow-turn-left',
  icon: [576, 512, [], "e632", "M480.3 416l0 32 64 0 0-224-402.7 0c57.4-57.4 89.4-89.4 96-96l-45.3-45.3-22.6 22.6-128 128-22.6 22.6 22.6 22.6 128 128 22.6 22.6 45.3-45.3c-6.6-6.6-38.6-38.6-96-96l338.7 0 0 128z"]
};
var faCircle4 = {
  prefix: 'fass',
  iconName: 'circle-4',
  icon: [512, 512, [], "e0f1", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM224 144l0 112 48 0 0-112 48 0 0 112 32 0 0 48-32 0 0 64-48 0 0-64-96 0 0-160 48 0z"]
};
var faHammerWar = {
  prefix: 'fass',
  iconName: 'hammer-war',
  icon: [448, 512, [], "f6e4", "M256 0l0 59.4 192-27.4 0 256-224-32-224 32 0-256 192 27.4 0-59.4 64 0zM224 304.5l32 4.6 0 234.9-64 0 0-234.9 32-4.6z"]
};
var faLightEmergency = {
  prefix: 'fass',
  iconName: 'light-emergency',
  icon: [448, 512, [], "e41f", "M64 192c0-88.4 71.6-160 160-160s160 71.6 160 160l0 112-320 0 0-112zm168-64l8 0 0-48-8 0c-66.3 0-120 53.7-120 120l0 8 48 0 0-8c0-39.8 32.2-72 72-72zM448 480l-448 0 0-128 448 0 0 128z"]
};
var faArrowUpZA = {
  prefix: 'fass',
  iconName: 'arrow-up-z-a',
  icon: [512, 512, ["sort-alpha-up-alt"], "f882", "M150.9 41.4L128.3 18.7c-5.5 5.5-39.7 39.7-102.6 102.6L3 144 48.3 189.3c14.6-14.6 30.6-30.6 48-48l0 338.7 64 0 0-338.7c17.4 17.4 33.4 33.4 48 48L253.5 144c-5.5-5.5-39.7-39.7-102.6-102.6zM448.3 32l-160 0 0 64 82.7 0-73.4 73.4-9.4 9.4 0 45.3 192 0 0-64-82.7 0 73.4-73.4 9.4-9.4 0-45.3-32 0zm-94 224l-7.9 20.5-78.3 203.5 68.6 0 12.3-32 70.5 0 12.3 32 68.6 0-78.3-203.5-7.9-20.5-60 0zm30 100.3l16.8 43.7-33.6 0 16.8-43.7z"]
};
var faSortAlphaUpAlt = faArrowUpZA;
var faMicrophoneSlash = {
  prefix: 'fass',
  iconName: 'microphone-slash',
  icon: [576, 512, [], "f131", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-153.4-153.4c34.1-34.7 55.2-82.2 55.2-134.7l0-64-48 0 0 64c0 39.2-15.7 74.8-41.2 100.8L357 290.9c16.8-17.3 27.1-40.9 27.1-66.9l0-224-192 0 0 126-142.8-142.8zM298 367.7c-3.3 .2-6.5 .3-9.8 .3-79.5 0-144-64.5-144-144l0-10.2-48-48 0 58.2c0 97.9 73.3 178.7 168 190.5l0 49.5-72 0 0 48 192 0 0-48-72 0 0-49.5c9.3-1.2 18.4-3 27.3-5.4L298 367.7z"]
};
var faSquarePen = {
  prefix: 'fass',
  iconName: 'square-pen',
  icon: [448, 512, ["pen-square", "pencil-square"], "f14b", "M448 32l-448 0 0 448 448 0 0-448zM112 288l95-95 80 80-95 95-96 16 16-96zm256-96l-47 47-80-80 47-47 80 80z"]
};
var faPenSquare = faSquarePen;
var faPencilSquare = faSquarePen;
var faBellPlus = {
  prefix: 'fass',
  iconName: 'bell-plus',
  icon: [512, 512, [], "f849", "M224 0l64 0 0 35.2C361 50 416 114.6 416 192l0 96 80 128-480 0 80-128 0-96c0-77.4 55-142 128-156.8L224 0zm32 512c-29.8 0-54.9-20.4-62-48l124 0c-7.1 27.6-32.2 48-62 48zM232 320l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faHandFist = {
  prefix: 'fass',
  iconName: 'hand-fist',
  icon: [384, 512, [9994, "fist-raised"], "f6de", "M192 0l0 144-64 0 0-144 64 0zM32 32l64 0 0 112-64 0 0-112zm192 0l64 0 0 160-64 0 0-160zm96 64l64 0 0 128-64 0 0-128zM0 253.7l0-77.7 192 0 0 80-112 0 0 32 144 0 0-64 64 0 0 32 96 0c0 52.3-25.1 98.8-64 128l0 128-224 0 0-110.4c-17.3-7.9-33.2-18.8-46.9-32.5l-2.3-2.3C16.9 336.9 0 296.2 0 253.7z"]
};
var faFistRaised = faHandFist;
var faPants = {
  prefix: 'fass',
  iconName: 'pants',
  icon: [512, 512, [], "e6d5", "M97 0l318.6 0 15 77.9 .4 2.1-78.7 0 0 48 87.9 0 70.4 365.9-188.5 36.3-65-338.1-1.4 0-65 338.1-188.5-36.3 70.4-365.9 87.9 0 0-48-78.7 0 .4-2.1 15-77.9z"]
};
var faCommentSms = {
  prefix: 'fass',
  iconName: 'comment-sms',
  icon: [512, 512, ["sms"], "f7cd", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM140.8 172.8c-23 0-41.6 18.6-41.6 41.6S117.8 256 140.8 256c5.3 0 9.6 4.3 9.6 9.6s-4.3 9.6-9.6 9.6l-41.6 0 0 32 41.6 0c23 0 41.6-18.6 41.6-41.6S163.8 224 140.8 224c-5.3 0-9.6-4.3-9.6-9.6s4.3-9.6 9.6-9.6l35.2 0 0-32-35.2 0zm188.8 41.6c0 23 18.6 41.6 41.6 41.6 5.3 0 9.6 4.3 9.6 9.6s-4.3 9.6-9.6 9.6l-41.6 0 0 32 41.6 0c23 0 41.6-18.6 41.6-41.6S394.2 224 371.2 224c-5.3 0-9.6-4.3-9.6-9.6s4.3-9.6 9.6-9.6l35.2 0 0-32-35.2 0c-23 0-41.6 18.6-41.6 41.6zm-19.2-25.6l0-16c-27 0-19.7 0-30.1 0l-4.5 8.5-20 37.8c-16.7-30.3-25.2-45.8-25.5-46.3-14.1 0-14.3 0-28.7 0l0 134.4 32 0 0-61.9c4.6 8.4 12.2 22.1 22.7 41.2 10.2-19.2 17.6-33.1 22.1-41.8l0 62.5 32 0 0-118.4z"]
};
var faSms = faCommentSms;
var faHeadSideGear = {
  prefix: 'fass',
  iconName: 'head-side-gear',
  icon: [512, 512, [], "e611", "M224 0C338.4 0 432.7 85.7 446.3 196.4l49.7 59.6 0 64-64 0 0 128-112 0 0 64-256 0 0-131.2C24.4 340.4 0 285 0 224 0 100.3 100.3 0 224 0zm32 97.2l0-33.2-64 0 0 33.2c-12.7 4.3-24.2 11-34 19.7l-28.8-16.6-32 55.4 28.8 16.6c-1.3 6.4-1.9 12.9-1.9 19.7s.7 13.3 1.9 19.7l-28.8 16.6 32 55.4 28.8-16.6c9.8 8.7 21.4 15.4 34.1 19.7l0 33.2 64 0 0-33.2c12.7-4.3 24.2-11 34.1-19.7l28.8 16.6 32-55.4-28.8-16.6c1.3-6.4 1.9-12.9 1.9-19.7s-.7-13.3-1.9-19.7l28.8-16.6-32-55.4-28.8 16.6c-9.8-8.7-21.4-15.4-34-19.7zM184 192a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faTransporter1 = {
  prefix: 'fass',
  iconName: 'transporter-1',
  icon: [640, 512, [], "e043", "M320 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-51.1 32l-16.3 0-9.6 13.2-92.9 128-18.8 25.9 51.8 37.6c9.3-12.8 28.3-39 56.9-78.4l0 65.7 160 0 0-65.7c28.6 39.4 47.6 65.6 56.9 78.4l51.8-37.6c-.2-.2-37.4-51.6-111.7-153.9l-9.6-13.2-118.5 0zM400 496l-240 0 0 48 320 0 0-48-80 0zM576 160l-16-48-16 48-48 16 48 16 16 48 16-48 48-16-48-16zM96 352l-16-48-16 48-48 16 48 16 16 48 16-48 48-16-48-16zm128 0l0 32 192 0 0-32-192 0zm0 64l0 32 192 0 0-32-192 0z"]
};
var faScannerTouchscreen = {
  prefix: 'fass',
  iconName: 'scanner-touchscreen',
  icon: [512, 512, [], "f48a", "M256-32l0 80-64 0 0-80 64 0zM416 224l-48 0 0-256 48 0 0 256zM320-32l0 80-32 0 0-80 32 0zm128 0l64 0 0 256-64 0 0-256zM64 160l0 288 192 0 0-288-192 0zM0 96l320 0 0 416-320 0 0-416z"]
};
var faFlaskRoundPotion = {
  prefix: 'fass',
  iconName: 'flask-round-potion',
  icon: [384, 512, ["flask-potion"], "f6e1", "M64 64l32 0 0 89.7C38.7 186.9 0 248.9 0 320 0 426 86 512 192 512s192-86 192-192c0-71.1-38.7-133.1-96-166.3l0-89.7 32 0 0-64-256 0 0 64zm96 109.3l0-109.3 64 0 0 130.3 19.2 8.4c45.3 19.8 76.8 64.9 76.8 117.4 0 5.4-.3 10.8-1 16l-18.7 0c-29 0-57.5-7.9-82.3-22.8l-9.6-5.8c-21.2-12.7-45.4-19.4-70.1-19.4-17.3 0-34.5 3.3-50.6 9.7l-23 9.2c4.7-46.8 34.7-86.2 76.2-104.3l19.2-8.4 0-20.9z"]
};
var faFlaskPotion = faFlaskRoundPotion;
var faCarBolt = {
  prefix: 'fass',
  iconName: 'car-bolt',
  icon: [512, 512, [], "e341", "M120 32l-22.7 0-7.5 21.4-48.5 138.6-41.3 0 0 288 96 0 0-64 320 0 0 64 96 0 0-288-41.3 0-48.5-138.6-7.5-21.4-294.7 0zM64 304a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM304 80l-24.9 112 88.9 0-160 144 24.9-112-88.9 0 160-144z"]
};
var faTableRows = {
  prefix: 'fass',
  iconName: 'table-rows',
  icon: [448, 512, ["rows"], "e292", "M0 32l448 0 0 448-448 0 0-448zM128 96l0 128 256 0 0-128-256 0zM384 288l-256 0 0 128 256 0 0-128z"]
};
var faRows = faTableRows;
var faCloudSlash = {
  prefix: 'fass',
  iconName: 'cloud-slash',
  icon: [576, 512, [], "e137", "M49.3-17l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-64-64 61.9 0 0-96c0-47.4-25.7-88.7-64-110.9l0-49.1c0-53-43-96-96-96-17.7 0-34.2 4.8-48.4 13.1-24.1-45.8-72.2-77.1-127.6-77.1-39.2 0-74.8 15.7-100.8 41.1L49.3-17zm361 497L96.5 166.2c-.2 3.3-.3 6.5-.3 9.8l0 24.2C40.2 220 .1 273.3 .1 336l0 144 410.2 0z"]
};
var faFaceHandYawn = {
  prefix: 'fass',
  iconName: 'face-hand-yawn',
  icon: [512, 512, [], "e379", "M430.9 443C480.8 396.3 512 329.8 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 73.2 30.7 139.2 80 185.9l0-137.9 81.3 0c7.6-45.4 47.1-80 94.7-80 45.3 0 83.2 31.3 93.3 73.5 26.8 26.8 72.7 72.7 86.5 86.5l-32 32c9.6 9.6 18.6 18.6 27 27zM225.7 131.7c-2.3 1.8-35.2 28.2-98.7 79l-18.7 15-30-37.5c2.3-1.8 35.2-28.2 98.7-79l18.7-15 30 37.5zm79.3 15l-18.7-15 30-37.5c2.3 1.8 35.2 28.2 98.7 79l18.7 15-30 37.5c-2.3-1.8-35.2-28.2-98.7-79zM128 352l0 122.2c0 56.2 45.6 101.8 101.8 101.8 27 0 52.9-10.7 72-29.8l82.2-82.2-32-32-48 48-16-16 80-80-32-32-80 80-16-16 64-64-32-32-96 96 0-64-48 0z"]
};
var faTickets = {
  prefix: 'fass',
  iconName: 'tickets',
  icon: [640, 512, [], "e658", "M96 32l512 0 0 128c-26.5 0-48 21.5-48 48s21.5 48 48 48l0 128-512 0 0-128c26.5 0 48-21.5 48-48s-21.5-48-48-48L96 32zM464 144l0 128-224 0 0-128 224 0zM240 96l-48 0 0 224 320 0 0-224-272 0zM48 152l0 280 464 0 0 48-512 0 0-352 48 0 0 24z"]
};
var faSimCard = {
  prefix: 'fass',
  iconName: 'sim-card',
  icon: [384, 512, [], "f7c4", "M0 0L285.3 0 294.6 9.4 384 98.7 384 512 0 512 0 0zM64 256l0 72 128 0 0-72-128 0zm0 192l80 0 0-72-80 0 0 72zm256 0l0-72-128 0 0 72 128 0zm0-192l-80 0 0 72 80 0 0-72z"]
};
var faShieldQuartered = {
  prefix: 'fass',
  iconName: 'shield-quartered',
  icon: [512, 512, [], "e575", "M256 0l11.6 4.5 207.5 80.5 19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.3-91.1 150-189.4 192.6l-12.7 5.5-12.7-5.5C144.9 463.9 86.6 389.2 53.9 313.9 21.5 239.3 13.7 162.9 16.6 113L17.8 92.5 37 85 244.5 4.5 256 0zM80.1 137c.3 24.7 3.5 54.9 11.1 87l164.8 0 0-155.3-176 68.3zM256 441.9c72.8-35.5 117.2-93.2 143.5-153.5 9.4-21.6 16.4-43.4 21.4-64.4l-164.9 0 0 217.9z"]
};
var faSquareEllipsisVertical = {
  prefix: 'fass',
  iconName: 'square-ellipsis-vertical',
  icon: [448, 512, [], "e26f", "M448 32l-448 0 0 448 448 0 0-448zM256 192l-64 0 0-64 64 0 0 64zm0 32l0 64-64 0 0-64 64 0zm0 160l-64 0 0-64 64 0 0 64z"]
};
var faOven = {
  prefix: 'fass',
  iconName: 'oven',
  icon: [448, 512, [], "e01d", "M0 0L448 0 448 512 0 512 0 0zM104 112a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm16 88l-320 0 0 224 320 0 0-224zM136 272l200 0 0 48-224 0 0-48 24 0z"]
};
var faScaleBalanced = {
  prefix: 'fass',
  iconName: 'scale-balanced',
  icon: [640, 512, [9878, "balance-scale"], "f24e", "M384 32l160 0 0 64-145.6 0c-5.2 25.8-22.9 47.1-46.4 57.3l0 294.7 192 0 0 64-448 0 0-64 192 0 0-294.7c-23.5-10.3-41.2-31.6-46.4-57.3L96 96 96 32 256 32c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zM112 128l46.5 0 6.7 12.9 88 168 2.7 5.2 0 47.8-7 7-40 40-7 7-147.9 0-7-7-40-40-7-7 0-47.8 2.7-5.2 88-168 6.7-12.9 14.5 0zM51.1 320l153.8 0-75.4-144-3 0-75.4 144zM481.5 128l61 0 6.7 12.9 88 168 2.7 5.2 0 47.8-7 7-40 40-7 7-147.9 0-7-7-40-40-7-7 0-47.8 2.7-5.2 88-168 6.7-12.9zm29 48l-75.4 144 153.8 0-75.4-144-3 0z"]
};
var faBalanceScale = faScaleBalanced;
var faCar = {
  prefix: 'fass',
  iconName: 'car',
  icon: [512, 512, [128664, "automobile"], "f1b9", "M120 32l-22.7 0-7.5 21.4-48.5 138.6-41.3 0 0 288 96 0 0-64 320 0 0 64 96 0 0-288-41.3 0-48.5-138.6-7.5-21.4-294.7 0zM402.9 192l-293.8 0 33.6-96 226.6 0 33.6 96zM64 304a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faAutomobile = faCar;
var faCircleBaht = {
  prefix: 'fass',
  iconName: 'circle-baht',
  icon: [512, 512, [], "e72d", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM240 128l0-32 32 0 0 32 4 0c42 0 76 34 76 76 0 16.2-5.1 31.3-13.8 43.7 18.1 13.9 29.8 35.8 29.8 60.3 0 42-34 76-76 76l-20 0 0 32-32 0 0-32-72 0 0-256 72 0zm-24 48l0 56 24 0 0-56-24 0zm56 0l0 56 4 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-4 0zM216 280l0 56 24 0 0-56-24 0zm56 0l0 56 20 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-20 0z"]
};
var faBadgerHoney = {
  prefix: 'fass',
  iconName: 'badger-honey',
  icon: [640, 512, [129441], "f6b4", "M160 400l20.6-48 118.1 0 21.3 128 96 0-23-137.9c27.9-29 80.6-70.8 144.1-90.8L560 288 589.5 240.8c6.1-.5 12.3-.8 18.5-.8l32-32 0-64-144-80-64 0-64 32-240 0C57.3 96 0 153.3 0 224l0 64 49.1 0c9 15.5 21.1 29 35.6 39.5l-20.7 72.5 24 80 96 0-24-80zM368 144l11.3 0 10.1-5.1 53.9-26.9 40.2 0 86.4 48-51.3 0c.9 2.5 1.4 5.2 1.4 8 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-2.8 .5-5.5 1.4-8l-41.4 0-160 96-80 0c-52.3 0-96.2-35.8-108.5-84.3 14.7-17 36.4-27.7 60.5-27.7l224 0z"]
};
var faCropSimple = {
  prefix: 'fass',
  iconName: 'crop-simple',
  icon: [512, 512, ["crop-alt"], "f565", "M128 32l0-32-64 0 0 64-64 0 0 64 64 0 0 320 272 0 0-64-208 0 0-352zM384 480l0 32 64 0 0-64 64 0 0-64-64 0 0-320-272 0 0 64 208 0 0 352z"]
};
var faCropAlt = faCropSimple;
var faTimer = {
  prefix: 'fass',
  iconName: 'timer',
  icon: [512, 512, [], "e29e", "M256 0l-32 0 0 128 64 0 0-61.3c90.8 15.2 160 94.2 160 189.3 0 106-86 192-192 192S64 362 64 256c0-53.7 22-102.3 57.6-137.1L76.8 73.1C29.5 119.6 0 184.4 0 256 0 397.4 114.6 512 256 512S512 397.4 512 256 397.4 0 256 0zM193 159l-17-17-33.9 33.9c.8 .8 33.1 33.1 97 97l17 17 33.9-33.9-17-17-80-80z"]
};
var faSquareDollar = {
  prefix: 'fass',
  iconName: 'square-dollar',
  icon: [448, 512, ["dollar-square", "usd-square"], "f2e9", "M448 32l-448 0 0 448 448 0 0-448zM248 104l0 40 40 0 0 48-85.6 0c-10.2 0-18.4 8.2-18.4 18.4 0 9.2 6.8 17 16 18.2l54.4 7.2c33 4.4 57.7 32.5 57.7 65.8 0 35.9-28.4 65.1-64 66.3l0 40-48 0 0-40-56 0 0-48 101.6 0c10.2 0 18.4-8.2 18.4-18.4 0-9.2-6.8-17-16-18.2l-54.4-7.2c-33-4.4-57.7-32.5-57.7-65.8 0-35.9 28.4-65.1 64-66.3l0-40 48 0z"]
};
var faDollarSquare = faSquareDollar;
var faUsdSquare = faSquareDollar;
var faMedal = {
  prefix: 'fass',
  iconName: 'medal',
  icon: [448, 512, [127941], "f5a2", "M80.3 192.6L0 32 128-32 224 128 320-32 448 32 367.7 192.6c30.1 33.9 48.3 78.5 48.3 127.4 0 106-86 192-192 192S32 426 32 320c0-48.9 18.3-93.5 48.3-127.4zm175.8 86.1l-32.1-61.9-32.1 61.9-71.9 9.9 52 48.2-12.3 68.1 64.3-32.1 64.3 32.1-12.3-68.1 52-48.2-71.9-9.9z"]
};
var faScroll = {
  prefix: 'fass',
  iconName: 'scroll',
  icon: [576, 512, [128220], "f70e", "M0 120C0 71.4 39.4 32 88 32l264 0c53 0 96 43 96 96l0 176-248 0 0 104c0 39.8-32.2 72-72 72l-16 0 0-272-112 0 0-88zM224 480c15.1-20.1 24-45 24-72l0-56 296 0 0 48c0 44.2-35.8 80-80 80l-240 0zM88 80c-22.1 0-40 17.9-40 40l0 40 64 0 0-80-24 0z"]
};
var faCalendars = {
  prefix: 'fass',
  iconName: 'calendars',
  icon: [512, 512, [], "e0d7", "M256 0l-64 0 0 64-96 0 0 96 416 0 0-96-96 0 0-64-64 0 0 64-96 0 0-64zM96 208l0 208 416 0 0-208-416 0zM48 184l0-24-48 0 0 352 416 0 0-48-368 0 0-280z"]
};
var faAppleCore = {
  prefix: 'fass',
  iconName: 'apple-core',
  icon: [384, 512, [], "e08f", "M176.3 96l0-16c0-44.2 35.8-80 80-80l32 0 0 32c0 44.2-35.8 80-80 80l-32 0 0-16zM14.5 155.3c17-16.9 38.9-27.3 65.8-27.3l112 32 112-32c26.9 0 48.8 10.4 65.8 27.3-49.2 31.2-81.8 86.1-81.8 148.7 0 60.4 30.5 113.8 76.9 145.5-29.9 39.1-69.4 62.5-108.9 62.5l-64-16-64 16c-39.5 0-79-23.4-108.9-62.5 46.4-31.7 76.9-85 76.9-145.5 0-62.6-32.6-117.5-81.8-148.7z"]
};
var faFileExcel = {
  prefix: 'fass',
  iconName: 'file-excel',
  icon: [384, 512, [], "f1c3", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM109.5 256l54.9 96-54.9 96 55.3 0 27.2-47.6 27.2 47.6 55.3 0-54.9-96 54.9-96-55.3 0-27.2 47.6-27.2-47.6-55.3 0z"]
};
var faDiamondHalf = {
  prefix: 'fass',
  iconName: 'diamond-half',
  icon: [576, 512, [], "e5b7", "M288-16L16 256 288 528 288-16z"]
};
var faBaguette = {
  prefix: 'fass',
  iconName: 'baguette',
  icon: [640, 512, [129366], "e3d8", "M322.5 100.5l-74.5 49.6c44.6 44.6 69.2 69.2 73.9 73.9L288 257.9c-3.5-3.5-30.4-30.4-80.7-80.7l-74.5 49.6c47.3 47.3 73 73 77.1 77.1L176 337.9c-3-3-31-31-83.9-83.9L57 277.5C-1.8 316.7-17.7 396.2 21.5 455S140.2 529.7 199 490.5l384-256c58.8-39.2 74.7-118.7 35.5-177.5S499.8-17.7 441 21.5L363.3 73.3c41.9 41.9 65.5 65.5 70.7 70.7L400 177.9c-4.1-4.1-29.9-29.9-77.5-77.5z"]
};
var faEarTriangleExclamation = {
  prefix: 'fass',
  iconName: 'ear-triangle-exclamation',
  icon: [640, 512, [], "e75c", "M447.2 84.6L203 512 96 512 96 192C96 86 182 0 288 0 354.3 0 412.7 33.6 447.2 84.6zM288 112c28.4 0 53.3 14.8 67.5 37.1l25.6-44.9C357.8 79.5 324.7 64 288 64 217.3 64 160 121.3 160 192l0 64 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 48 40 0c39.8 0 72-32.2 72-72 0-37.1-28-67.6-64-71.6l0-16.4c0-44.2 35.8-80 80-80zM240 544.1l192-336 192 336-384 0zm208-208l0-16-32 0 0 112 32 0 0-96zm0 127.7l-32 0 0 32 32 0 0-32z"]
};
var faH5 = {
  prefix: 'fass',
  iconName: 'h5',
  icon: [576, 512, [], "e412", "M96 96l0-32-64 0 0 384 64 0 0-160 96 0 0 160 64 0 0-384-64 0 0 160-96 0 0-128zM352 64l-32 0 0 208 112 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-112 0 0 64 112 0c66.3 0 120-53.7 120-120S498.3 208 432 208l-48 0 0-80 152 0 0-64-184 0z"]
};
var faPersonSkiLift = {
  prefix: 'fass',
  iconName: 'person-ski-lift',
  icon: [576, 512, ["ski-lift"], "f7c8", "M288 198.3l-32 8.5 0-206.8 32 0 0 198.3zM96 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm103.5 60.7c6 13.1 21.4 47.1 46.4 102l65.9-17.6 40.2 30.9 0 132.5 144-53.2 0-47.3 48 0 0 64c0 10-6.3 19-15.7 22.5l-344 127.1-22.5 8.3-16.6-45 22.5-8.3 120.3-44.5 0-114.5-66.7 17.8c-22.6 6-46.2-5.1-55.9-26.3-28.2-61-44.7-96.8-49.5-107.2 41.9-20.7 67-33.1 83.6-41.4zm-121.8 49L157 355.6c53.4-14.6 84-22.9 91.8-25l12.6 46.3c-4.6 1.3-41.7 11.4-111.2 30.3l-19.3 5.3-8.6-18.1-88-184-10.4-21.7 43.3-20.7 10.4 21.7z"]
};
var faSkiLift = faPersonSkiLift;
var faSquareCedi = {
  prefix: 'fass',
  iconName: 'square-cedi',
  icon: [448, 512, [], "e729", "M448 32l-448 0 0 448 448 0 0-448zM248 332.3c16.1-5.1 30.1-15.1 40-28.3l38.4 28.8c-18.7 25-46.5 42.9-78.4 48.9l0 34.2-48 0 0-34.2C140.8 370.5 96 318.5 96 256s44.8-114.5 104-125.8l0-34.2 48 0 0 34.2c31.9 6.1 59.6 24 78.4 48.9L288 208c-10-13.3-23.9-23.3-40-28.3l0 152.7zM200 179.7c-32.5 10.2-56 40.5-56 76.3s23.5 66.1 56 76.3l0-152.7z"]
};
var faFilter = {
  prefix: 'fass',
  iconName: 'filter',
  icon: [576, 512, [], "f0b0", "M224 416l128 128 0-272 208-208-544 0 208 208 0 144z"]
};
var faCalculatorSimple = {
  prefix: 'fass',
  iconName: 'calculator-simple',
  icon: [512, 512, ["calculator-alt"], "f64c", "M0 0L224 0 224 224 0 224 0 0zM288 0l224 0 0 224-224 0 0-224zM512 288l0 224-224 0 0-224 224 0zM0 288l224 0 0 224-224 0 0-224zM424 72l0-24-48 0 0 40-40 0 0 48 40 0 0 40 48 0 0-40 40 0 0-48-40 0 0-16zM72 88l-24 0 0 48 128 0 0-48-104 0zM97 351l-17-17-33.9 33.9c11.6 11.6 22.3 22.3 32 32-9.7 9.7-20.4 20.4-32 32L80 465.9c11.6-11.6 22.3-22.3 32-32 9.7 9.7 20.4 20.4 32 32L177.9 432c-11.6-11.6-22.3-22.3-32-32 9.7-9.7 20.4-20.4 32-32L144 334.1c-11.6 11.6-22.3 22.3-32 32L97 351zm263-15l-24 0 0 48 128 0 0-48-104 0zm0 80l-24 0 0 48 128 0 0-48-104 0z"]
};
var faCalculatorAlt = faCalculatorSimple;
var faCoinBlank = {
  prefix: 'fass',
  iconName: 'coin-blank',
  icon: [512, 512, [], "e3fb", "M0 208l0 96c0 29.1 19.4 55.9 52 77.3L52 295c11.7 8.7 25.1 16.6 40 23.6l0 83.7c23.5 9.8 50.5 17.5 80 22.7l0-80.9c12.9 2.5 26.3 4.5 40 5.8l0 80.2c14.3 1.2 29 1.9 44 1.9s29.7-.6 44-1.9l0-80.2c13.7-1.3 27.1-3.3 40-5.8l0 80.9c29.5-5.1 56.5-12.9 80-22.7l0-83.7c14.9-7 28.3-14.9 40-23.6l0 86.3c32.6-21.5 52-48.3 52-77.3l0-96c0-79.5-114.6-144-256-144S0 128.5 0 208zm256 96c-106 0-192-43-192-96s86-96 192-96 192 43 192 96-86 96-192 96z"]
};
var faIntersection = {
  prefix: 'fass',
  iconName: 'intersection',
  icon: [384, 512, [8898], "f668", "M64 480l0-256c0-70.7 57.3-128 128-128s128 57.3 128 128l0 256 64 0 0-256c0-106-86-192-192-192S0 118 0 224l0 256 64 0z"]
};
var faDrum = {
  prefix: 'fass',
  iconName: 'drum',
  icon: [576, 512, [129345], "f569", "M553.5 62.9c-5.4 3.5-34.7 22.8-88 57.6 48.5 17.9 78.8 46.4 78.8 87.4l0 160c0 31.3-27.4 58.8-72 78.7l0-128c-14.3 6.4-30.5 12-48 16.7l0 128c-33 8.9-71.1 14.5-112 16.1l0-128c-15.7 .6-32.3 .6-48 0l0 128c-40.9-1.6-79-7.2-112-16.1l0-128c-17.5-4.7-33.7-10.3-48-16.7l0 128c-44.6-19.9-72-47.4-72-78.7l0-160c0-80 114.6-112 256-112 41 0 79.8 2.7 114.2 8.5l104.6-68.6 20.1-13.2 26.3 40.2zm-278.4 125l64.6-42.3c-16.3-1.1-33.5-1.6-51.4-1.6-68.2 0-125.4 7.9-163.6 22.7-38.8 15.1-44.4 30.6-44.4 41.3 0 .8 2.7 17.2 46 35.9 38.9 16.8 96 28.1 162 28.1s123.1-11.3 162-28.1c43.3-18.7 46-35.1 46-35.9 0-10.6-5.6-26.2-44.4-41.3-11.5-4.5-24.7-8.3-39.4-11.5l-111.1 72.8-20.1 13.2-26.3-40.2 20.1-13.2z"]
};
var faMapPin = {
  prefix: 'fass',
  iconName: 'map-pin',
  icon: [320, 512, [128205], "f276", "M192 284.4C256.1 269.9 304 212.5 304 144 304 64.5 239.5 0 160 0S16 64.5 16 144c0 68.5 47.9 125.9 112 140.4l0 227.6 64 0 0-227.6zM168 96c-30.9 0-56 25.1-56 56l-48 0C64 94.6 110.6 48 168 48l0 48z"]
};
var faCircleHouse = {
  prefix: 'fass',
  iconName: 'circle-house',
  icon: [512, 512, [], "e6c8", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM368 256l0 128-224 0 0-128-32 0 0-32 144-128 144 128 0 32-32 0zM224 272l0 64 64 0 0-64-64 0z"]
};
var faTablePivot = {
  prefix: 'fass',
  iconName: 'table-pivot',
  icon: [576, 512, [], "e291", "M448 96l-192 0 0 64 144 0 0 64-144 0 0 144-64 0 0-144-64 0 0 192 64 0 0 64-128 0 0-448 448 0 0 128-64 0 0-64zM128 160l64 0 0-64-64 0 0 64zM448 320l-64 0 96-96 96 96-64 0 0 160-160 0 0 64-96-96 96-96 0 64 96 0 0-96z"]
};
var faBridgeSuspension = {
  prefix: 'fass',
  iconName: 'bridge-suspension',
  icon: [512, 512, [], "e4cd", "M0 120l0 52.5c27.8-10.3 52.4-27.1 72-48.6l0 132.1-72 0 0 80c37.6 9.4 64 43.2 64 82l0 94 96 0 0-64c0-53 43-96 96-96s96 43 96 96l0 64 96 0 0-94c0-38.8 26.4-72.6 64-82l0-80-72 0 0-132.1c19.6 21.5 44.2 38.3 72 48.6l0-52.5C469.2 97.1 440 52 440 0L392 0c0 75.1-60.9 136-136 136S120 75.1 120 0L72 0C72 52 42.8 97.1 0 120zm392 3.9l0 132.1-56 0 0-90.3c21.3-10.3 40.3-24.5 56-41.8zM288 181.2l0 74.8-64 0 0-74.8c10.4 1.8 21.1 2.8 32 2.8s21.6-1 32-2.8zM176 165.7l0 90.3-56 0 0-132.1c15.7 17.3 34.7 31.5 56 41.8z"]
};
var faScaleUnbalancedFlip = {
  prefix: 'fass',
  iconName: 'scale-unbalanced-flip',
  icon: [640, 512, ["balance-scale-right"], "f516", "M251.1 39.3l-113-37.7-20.2 60.7 125.9 42c7 22 23.3 39.9 44.2 49l0 294.7-192 0 0 64 256 0 0-358.7c5.1-2.2 9.9-5 14.4-8.2 107.9 36 163.1 54.4 165.9 55.3l20.2-60.7c-4.9-1.6-55.9-18.6-153-51 .3-2.9 .5-5.8 .5-8.8 0-44.2-35.8-80-80-80-29.3 0-55 15.8-68.9 39.3zM528 224l-46.5 0-6.7 12.9-88 168-2.7 5.2 0 47.8 7 7 40 40 7 7 147.9 0 7-7 40-40 7-7 0-47.8-2.7-5.2-88-168-6.7-12.9-14.5 0zm60.9 192l-153.8 0 75.4-144 3 0 75.4 144zM158.5 96l-61 0-6.7 12.9-88 168-2.7 5.2 0 47.8 7 7 40 40 7 7 147.9 0 7-7 40-40 7-7 0-47.8-2.7-5.2-88-168-6.7-12.9zm-29 48l75.4 144-153.8 0 75.4-144 3 0z"]
};
var faBalanceScaleRight = faScaleUnbalancedFlip;
var faLightSwitch = {
  prefix: 'fass',
  iconName: 'light-switch',
  icon: [384, 512, [], "e017", "M0 0L384 0 384 512 0 512 0 0zM96 96l0 136 192 0 0-136-192 0zm0 184l0 136 192 0 0-136-192 0z"]
};
var faArrowsToCircle = {
  prefix: 'fass',
  iconName: 'arrows-to-circle',
  icon: [576, 512, [], "e4bd", "M64.3-13.3l96 96 0-50.7 64 0 0 160-160 0 0-64 50.7 0-96-96 45.3-45.3zM231.7 256a56.3 56.3 0 1 1 112.5 0 56.3 56.3 0 1 1 -112.5 0zM534.9 54.6l-73.4 73.4 50.7 0 0 64-160 0 0-160 64 0 0 50.7 96-96 45.3 45.3-22.6 22.6zM512.3 525.3l-96-96 0 50.7-64 0 0-160 160 0 0 64-50.7 0 96 96-45.3 45.3zM41.6 457.4l73.4-73.4-50.7 0 0-64 160 0 0 160-64 0 0-50.7c-57.4 57.4-89.4 89.4-96 96L19 480 41.6 457.4z"]
};
var faAmpersand = {
  prefix: 'fass',
  iconName: 'ampersand',
  icon: [448, 512, [], "26", "M144.2 112.7c0 12.2 4.5 24.1 12.5 33l27.6 30.9 36.4-26.6c12.3-9 19.5-23.2 19.5-38.4 0-26.2-21.4-47.6-47.8-47.6-26.2 0-48.2 22-48.2 48.7zm114.3 88.9l-31.3 22.8 88.1 98.5c35.6-32.1 59.4-53.5 71.3-64.2l42.8 47.6c-11.9 10.7-35.7 32.1-71.4 64.3 38.2 42.7 62 69.3 71.4 79.8l-47.7 42.7c-9.5-10.6-33.2-37.1-71.3-79.7l-64.8 58.3-9.1 8.2-76.3 0c-70.2 0-128-56.9-128-127.5 0-40.7 19.4-78.9 52.3-102.9l47.9-35-23.4-26.1c-18.6-20.8-28.8-48-28.8-75.7 0-61.6 50.1-112.7 112.2-112.7 61.5 0 111.8 49.9 111.8 111.6 0 35.6-17 69.1-45.7 90.1zM160.2 416l51.7 0 55.8-50.2-92.4-103.3-53 38.7c-16.4 12-26 31-26 51.3 0 34.9 28.7 63.5 64 63.5z"]
};
var faChessClock = {
  prefix: 'fass',
  iconName: 'chess-clock',
  icon: [576, 512, [], "f43d", "M224 16l-160 0 0 48 56 0 0 32-56 0C28.7 96 0 124.7 0 160L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-16 0 0-32-160 0 0 32-168 0 0-32 56 0 0-48zM336.8 192.8A112 112 0 1 1 495.2 351.2 112 112 0 1 1 336.8 192.8zm152.7 39.6l-33.9-33.9-67.9 67.9 33.9 33.9 67.9-67.9zM160 160a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm24 128l0-96-48 0 0 96 48 0z"]
};
var faEnvelope = {
  prefix: 'fass',
  iconName: 'envelope',
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M0 64l512 0 0 72-12.8 9.6-224 168-19.2 14.4-19.2-14.4-224-168-12.8-9.6 0-72zM0 196l256 192 256-192 0 252-512 0 0-252z"]
};
var faBaby = {
  prefix: 'fass',
  iconName: 'baby',
  icon: [448, 512, [], "f77c", "M152.4 88a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM63.6 112.1c14 10.2 50.7 36.8 109.8 79.9l102 0c59.2-43 95.8-69.7 109.8-79.9l47.1 64.7c-13.7 10-51 37.1-111.9 81.4l0 29.8-192 0 0-29.8c-60.9-44.3-98.2-71.4-111.9-81.4l47.1-64.7zm65.3 216.3l60.2 52.7-23.7 27.1c10.1 11.7 24.6 28.5 43.4 50.4l-60.6 52.2c-37.4-43.4-87.9-101.9-88.8-103 11.3-12.9 34.5-39.4 69.5-79.4zm130.8 52.7l60.2-52.7c35 40 58.2 66.5 69.5 79.4-30.6 35.5-86.1 99.9-88.8 103L240 458.6c18.9-21.9 33.4-38.7 43.4-50.4l-23.7-27.1z"]
};
var faNfcLock = {
  prefix: 'fass',
  iconName: 'nfc-lock',
  icon: [576, 512, [], "e1f8", "M32 32l448 0 0 145c-5.2-.7-10.6-1-16-1-17 0-33.2 3.3-48 9.3l0-89.3-184 0 0 118.4c-14.3 8.3-24 23.8-24 41.6 0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.8-9.7-33.3-24-41.6l0-70.4 88 0 0 75.3c-19.9 22.6-32 52.2-32 84.7l-32 0 0 64-160 0 0-224 40 0 0-48-88 0 0 320 208 0 0 64-272 0 0-448zM464 272c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
var faSquareCaretDown = {
  prefix: 'fass',
  iconName: 'square-caret-down',
  icon: [448, 512, ["caret-square-down"], "f150", "M0 480l448 0 0-448-448 0 0 448zM224 360L88 192 360 192 224 360z"]
};
var faCaretSquareDown = faSquareCaretDown;
var faHyphen = {
  prefix: 'fass',
  iconName: 'hyphen',
  icon: [320, 512, [], "2d", "M0 224l320 0 0 64-320 0 0-64z"]
};
var faPlaneProp = {
  prefix: 'fass',
  iconName: 'plane-prop',
  icon: [576, 512, [], "e22b", "M231 312l9 72-48 0 0 64 56 0 8 64 64 0 8-64 28 0 0 28 40 0 0-120-40 0 0 28-20 0 9-72 175 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-175 0-9-72 20 0 0 28 40 0 0-120-40 0 0 28-28 0-8-64-64 0-8 64-56 0 0 64 48 0-9 72-71 0-33.5 5-30.5-61-40 0-22.5 75-33.5 5 0 64 33.5 5 22.5 75 40 0 30.5-61 33.5 5 71 0z"]
};
var faTent = {
  prefix: 'fass',
  iconName: 'tent',
  icon: [512, 512, [], "e57d", "M29.7 176l-29.7 304 254.9 0 0-192 129.1 192 128 0-29.7-304-227.4-144-225.1 144z"]
};
var faChimney = {
  prefix: 'fass',
  iconName: 'chimney',
  icon: [448, 512, [], "f78b", "M0 32l448 0 0 128-448 0 0-128zM32 192l96 0 0 128-96 0 0-128zm384 0l0 128-256 0 0-128 256 0zM288 352l0 128-256 0 0-128 256 0zm128 0l0 128-96 0 0-128 96 0z"]
};
var faA = {
  prefix: 'fass',
  iconName: 'a',
  icon: [384, 512, [97], "41", "M170.1 32l44.2 0 7.8 20.6C304.4 269.4 358.4 411.9 384.3 480l-68.5 0-36.4-96-174.5 0-36.4 96-68.5 0C25.9 411.9 80 269.4 162.2 52.6L170.1 32zm85 288l-63-165.8-63 165.8 125.9 0z"]
};
var faCircleSmall = {
  prefix: 'fass',
  iconName: 'circle-small',
  icon: [320, 512, [], "e122", "M0 256a160 160 0 1 1 320 0 160 160 0 1 1 -320 0z"]
};
var faParachuteBox = {
  prefix: 'fass',
  iconName: 'parachute-box',
  icon: [512, 512, [], "f4cd", "M128 224C128 152.2 144.3 88.4 169.5 43.4 195.1-2.4 226.6-24 256-24s60.9 21.6 86.5 67.4C367.7 88.4 384 152.2 384 224l-104 0 0 96 40.5 0 112-96-.5 0C432 145.6 414.3 73.4 384.4 20 378.3 9 371.5-1.4 364.2-10.9 450.7 24.9 512 104.2 512 208l0 11-8.4 7.2-151.6 130 0 155.8-192 0 0-155.8-151.6-130-8.4-7.2 0-11C0 104.2 61.3 24.9 147.8-10.9 140.5-1.4 133.7 9 127.6 20 97.7 73.4 80 145.6 80 224l-.5 0 112 96 40.5 0 0-96-104 0z"]
};
var faCartFlatbedBoxes = {
  prefix: 'fass',
  iconName: 'cart-flatbed-boxes',
  icon: [576, 512, ["dolly-flatbed-alt"], "f475", "M0 0l128 0 0 384 448 0 0 64-66.7 0c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16l-197.5 0c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16L64 448 64 64 0 64 0 0zM176 64l144 0 0 272-144 0 0-272zm336 96l0 176-144 0 0-176 144 0z"]
};
var faDollyFlatbedAlt = faCartFlatbedBoxes;
var faCartArrowDown = {
  prefix: 'fass',
  iconName: 'cart-arrow-down',
  icon: [640, 512, [], "f218", "M0-16l116 0c2.1 11.7 5 27.7 8.7 48l187.2 0 0 102.1c-23-23-39-39-48-48L230.1 120c2.1 2.1 31.8 31.8 89 89l17 17c2.1-2.1 31.8-31.8 89-89l17-17-33.9-33.9c-9 9-25 25-48 48l0-102.1 216 0-48 256-356.7 0 8.7 48 300 0 0 48-340 0-3.6-19.7-60.4-332.3-76 0 0-48zM160 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faCircle7 = {
  prefix: 'fass',
  iconName: 'circle-7',
  icon: [512, 512, [], "e0f4", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 144l156 0 0 37.7-2.5 5.1-90.6 181.3-53.7 0 9.4-18.7 78.6-157.3-97.2 0 0-48z"]
};
var faLockHashtag = {
  prefix: 'fass',
  iconName: 'lock-hashtag',
  icon: [384, 512, [], "e423", "M128 96l0 64 128 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64zM64 160l0-64C64 25.3 121.3-32 192-32S320 25.3 320 96l0 64 64 0 0 352-384 0 0-352 64 0zm96 48l-48 0 0 48-48 0 0 48 48 0 0 64-48 0 0 48 48 0 0 48 48 0 0-48 64 0 0 48 48 0 0-48 48 0 0-48-48 0 0-64 48 0 0-48-48 0 0-48-48 0 0 48-64 0 0-48zm0 96l64 0 0 64-64 0 0-64z"]
};
var faCircleSterling = {
  prefix: 'fass',
  iconName: 'circle-sterling',
  icon: [512, 512, [], "e5cf", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM160 256l0-32 18.9 0c-15.8-55.2 25.5-112 84.7-112l2.2 0c19.7 0 38.8 6.4 54.5 18.2 8.6 6.5 19.7 14.8 33.4 25l-28.8 38.4c-13.6-10.2-24.8-18.6-33.4-25-7.4-5.6-16.4-8.6-25.7-8.6l-2.2 0c-28.5 0-47.8 28.9-37 55.2l1.4 3.5c.7 1.8 1.4 3.5 2 5.3l90 0 0 32-84 0c.7 22.6-5.8 45-19.1 64l135.1 0 0 48-200 0 0-42.5c1.1-1.4 9-11.6 23.7-30.5 8.8-11.3 12.9-25.1 12.2-39L160 256z"]
};
var faBridgeCircleExclamation = {
  prefix: 'fass',
  iconName: 'bridge-circle-exclamation',
  icon: [576, 512, [], "e4ca", "M32 32l-32 0 0 64 40 0 0 64-40 0 0 112c37.6 9.4 64 43.2 64 82l0 126 96 0 0-96c0-53 43-96 96-96 6.4 0 12.7 .6 18.7 1.8 34.7-49.5 92.2-81.8 157.3-81.8 28.6 0 55.6 6.2 80 17.4l0-65.4-40 0 0-64 40 0 0-64-480 0zM424 96l0 64-80 0 0-64 80 0zM296 96l0 64-80 0 0-64 80 0zM88 96l80 0 0 64-80 0 0-64zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 112-32 0 0-112 32 0z"]
};
var faCloudArrowUp = {
  prefix: 'fass',
  iconName: 'cloud-arrow-up',
  icon: [576, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M144 480l432 0 0-128c0-47.4-25.7-88.7-64-110.9l0-49.1c0-53-43-96-96-96-17.7 0-34.2 4.8-48.4 13.1-24.1-45.8-72.2-77.1-127.6-77.1-79.5 0-144 64.5-144 144l0 24.2C40.1 220 0 273.3 0 336l0 144 144 0zM305 191c57.2 57.2 86.8 86.8 89 89L360 313.9c-9-9-25-25-48-48l0 126.1-48 0 0-126.1c-23 23-39 39-48 48L182.1 280c2.1-2.1 31.8-31.8 89-89l17-17 17 17z"]
};
var faCloudUpload = faCloudArrowUp;
var faCloudUploadAlt = faCloudArrowUp;
var faAt = {
  prefix: 'fass',
  iconName: 'at',
  icon: [512, 512, [61946], "40", "M256 64C150 64 64 150 64 256s86 192 192 192l32 0 0 64-32 0C114.6 512 0 397.4 0 256S114.6 0 256 0 512 114.6 512 256l0 128-72 0c-36 0-68.2-15.8-90.2-40.9-23.4 25.1-56.7 40.9-93.8 40.9-70.7 0-128-57.3-128-128s57.3-128 128-128c32.5 0 62.1 12.1 84.7 32l43.3 0 0 104c0 30.9 25.1 56 56 56l8 0 0-64c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faIndianRupeeSign = {
  prefix: 'fass',
  iconName: 'indian-rupee-sign',
  icon: [320, 512, ["indian-rupee", "inr"], "e1bc", "M0 32l320 0 0 48-100.7 0c17.7 19.8 30.1 44.6 34.7 72l66 0 0 48-66 0c-10.8 64.4-64.4 114.3-130.5 119.6l133.8 85.5 27 17.2-34.5 53.9-27-17.2-208-132.9-14.8-9.4c0-25 0-35.5 0-60.6l112 0c35.8 0 66.1-23.5 76.3-56L0 200 0 152 188.3 152c-10.2-32.5-40.5-56-76.3-56L0 96 0 32z"]
};
var faIndianRupee = faIndianRupeeSign;
var faInr = faIndianRupeeSign;
var faTruck = {
  prefix: 'fass',
  iconName: 'truck',
  icon: [576, 512, [128666, 9951], "f0d1", "M0 32l416 0 0 96 77.3 0 9.4 9.4 64 64 9.4 9.4 0 237.3-67.3 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-102.6 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64L0 448 0 32zM512 288l0-50.7-45.3-45.3-50.7 0 0 96 96 0zM192 424a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm232 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faGameConsoleHandheldCrank = {
  prefix: 'fass',
  iconName: 'game-console-handheld-crank',
  icon: [640, 512, [], "e5b9", "M64 32l448 0 0 448-448 0 0-448zM448 96l-320 0 0 160 320 0 0-160zM192 336l0-16-32 0 0 32-32 0 0 32 32 0 0 32 32 0 0-32 32 0 0-32-32 0 0-16zm144 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM544 144l96 0 0 80-48 0 0 96-48 0 0-176z"]
};
var faChalkboardUser = {
  prefix: 'fass',
  iconName: 'chalkboard-user',
  icon: [640, 512, ["chalkboard-teacher"], "f51c", "M128 32l480 0 0 304-96 0 0-48-128 0 0 48-120.6 0-3.9-8.8c8-16.7 12.5-35.4 12.5-55.2 0-70.7-57.3-128-128-128-5.4 0-10.8 .3-16 1l0-113zM312.4 448l-28-64 323.6 0 0 64-295.6 0zM64 272a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM232 384l56 128-288 0 56-128 176 0z"]
};
var faChalkboardTeacher = faChalkboardUser;
var faUserCheck = {
  prefix: 'fass',
  iconName: 'user-check',
  icon: [640, 512, [], "f4fc", "M464.3 512l-416 0 64-208 288 0 64 208zM638.6 114.7l-14.1 19.4-102.4 140.8-16.8 23.1c-8.8-9.1-30.9-32-66.2-68.6l-16.7-17.2 34.5-33.3c9.5 9.8 23.9 24.7 43.2 44.7l85.6-117.7 14.1-19.4 38.8 28.2zM256.3 248a120 120 0 1 1 0-240 120 120 0 1 1 0 240z"]
};
var faChartPieSimpleCircleCurrency = {
  prefix: 'fass',
  iconName: 'chart-pie-simple-circle-currency',
  icon: [640, 512, [], "e604", "M496 208C512.1 208 527.7 210 542.6 213.7 529.5 93.5 427.7 0 304 0l0 240 85.8 0c30.4-20.2 66.9-32 106.2-32zM304 400c0-41.8 13.4-80.5 36-112l-84 0 0-255.5c-125.1 8.2-224 112.3-224 239.5 0 132.5 107.5 240 240 240 21.6 0 42.5-2.9 62.4-8.2-19.3-29.9-30.4-65.6-30.4-103.8zm336 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm55.1 .5l28.2 28.2-22.6 22.6-28.2-28.2c-9.5 5.6-20.6 8.9-32.5 8.9s-23-3.2-32.5-8.9l-28.2 28.2-22.6-22.6 28.2-28.2c-5.6-9.5-8.9-20.6-8.9-32.5s3.2-23 8.9-32.5l-28.2-28.2 22.6-22.6 28.2 28.2c9.5-5.6 20.6-8.9 32.5-8.9s23 3.2 32.5 8.9l28.2-28.2 22.6 22.6-28.2 28.2c5.6 9.5 8.9 20.6 8.9 32.5s-3.2 23-8.9 32.5z"]
};
var faFaceFearful = {
  prefix: 'fass',
  iconName: 'face-fearful',
  icon: [512, 512, [], "e375", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-192c44.2 0 80 35.8 80 80l0 16-160 0 0-16c0-44.2 35.8-80 80-80zM96 224a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 116c-4.2 0-8.4 .3-12.5 .8-20.3 2.7-38.9 11.9-53.8 25.8L95 156.3 67.7 127 82.3 113.4C103 94.1 129.2 81 158.3 77.2 164.1 76.4 170 76 176 76l20 0 0 40-20 0zm172.5 .8c-4.1-.5-8.3-.8-12.5-.8l-20 0 0-40 20 0c6 0 11.9 .4 17.7 1.2 29.1 3.8 55.3 17 75.9 36.2l14.6 13.7-27.3 29.2-14.6-13.7c-14.9-13.9-33.5-23.1-53.8-25.8zM192 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faUserNinja = {
  prefix: 'fass',
  iconName: 'user-ninja',
  icon: [448, 512, [129399], "f504", "M352 128c0 70.7-57.3 128-128 128-57.9 0-106.8-38.4-122.6-91.2-16.3 19-41.4 30-70.7 28.3-2-36.7 15.6-66.7 44.1-81.3-28.5-14.5-46.1-44.5-44.1-81.3 34.9-1.9 63.7 13.9 79 39.9 21.1-41.8 64.4-70.5 114.4-70.5 70.7 0 128 57.3 128 128zM144 96l0 32 160 0 0-32-160 0zm80 288l64-64 80 0 64 192-416 0 64-192 80 0 64 64z"]
};
var faFrame = {
  prefix: 'fass',
  iconName: 'frame',
  icon: [512, 512, [], "e495", "M512 128l0-64-64 0 0-64-64 0 0 64-256 0 0-64-64 0 0 64-64 0 0 64 64 0 0 256-64 0 0 64 64 0 0 64 64 0 0-64 256 0 0 64 64 0 0-64 64 0 0-64-64 0 0-256 64 0zM128 384l0-256 256 0 0 256-256 0z"]
};
var faPlantWilt = {
  prefix: 'fass',
  iconName: 'plant-wilt',
  icon: [512, 512, [], "e5aa", "M344-32c66.3 0 120 53.7 120 120l0 6.2c29.3 12.2 48 41.3 48 76.9 0 51.3-46.9 91.9-80 124.9-33.1-33.1-80-73.7-80-124.9 0-35.6 18.7-64.7 48-76.9l0-6.2c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 456-64 0 0-328c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 38.2c29.3 12.2 48 41.3 48 76.9 0 51.3-46.9 91.9-80 124.9-33.1-33.1-80-73.7-80-124.9 0-35.6 18.7-64.7 48-76.9L48 216c0-66.3 53.7-120 120-120 20.2 0 39.3 5 56 13.8L224 88c0-66.3 53.7-120 120-120z"]
};
var faWeightScale = {
  prefix: 'fass',
  iconName: 'weight-scale',
  icon: [448, 512, ["weight"], "f496", "M116.6 192c-3-10.1-4.6-20.9-4.6-32 0-61.9 50.1-112 112-112S336 98.1 336 160c0 11.1-1.6 21.9-4.6 32l-71 0c18.6-33.5 30.7-55.2 36.3-65.3l-42-23.3c-3.4 6.2-19.9 35.8-49.2 88.6l-88.8 0zM128 32l-128 0 0 448 448 0 0-448-128 0C293.3 11.9 260 0 224 0s-69.3 11.9-96 32z"]
};
var faWeight = faWeightScale;
var faFarm = {
  prefix: 'fass',
  iconName: 'farm',
  icon: [576, 512, ["barn-silo"], "f864", "M112-32C50.1-32 0 18.1 0 80l0 2.2 196 0 27.5-12.5C218.3 12.7 170.4-32 112-32zM80 368l0-80c0-5.2 .8-10.3 2.5-15.2l47.5-142.6-130 0 0 381.8 112 0 0-144-32 0zm48-80l0 32 32 0 0 192 384 0 0-192 32 0 0-32-48-144-176-80-176 80-48 144zM416 464l-128 0 0-128 128 0 0 128zM400 176l0 96-96 0 0-96 96 0z"]
};
var faBarnSilo = faFarm;
var faCaretRight = {
  prefix: 'fass',
  iconName: 'caret-right',
  icon: [320, 512, [], "f0da", "M96 80L296 256 96 432 96 80z"]
};
var faHexagonDivide = {
  prefix: 'fass',
  iconName: 'hexagon-divide',
  icon: [576, 512, [], "e1ad", "M13.5 256.1l6.8-11.9 123.7-216.1 6.9-12.1 275.1 0 6.9 12.1 123.7 216.1 6.8 11.9-6.8 11.9-123.7 216.1-6.9 12.1-275.1 0-6.9-12.1-123.7-216.1-6.8-11.9zM320.5 128l-64 0 0 64 64 0 0-64zm-120 104l-24 0 0 48 224 0 0-48-200 0zm56 88l0 64 64 0 0-64-64 0z"]
};
var faFlorinSign = {
  prefix: 'fass',
  iconName: 'florin-sign',
  icon: [384, 512, [], "e184", "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1l-55.4 132.9-138.7 0 0 64 112 0-45.1 108.3c-5 11.9-16.6 19.7-29.5 19.7l-69.3 0 0 64 69.3 0c38.8 0 73.7-23.3 88.6-59.1l55.4-132.9 138.7 0 0-64-112 0 45.1-108.3c5-11.9 16.6-19.7 29.5-19.7l69.3 0 0-64-69.3 0z"]
};
var faLightbulbExclamationOn = {
  prefix: 'fass',
  iconName: 'lightbulb-exclamation-on',
  icon: [640, 512, [], "e1ca", "M416 528l-192 0 0-96 192 0 0 96zM320 0c106 0 192 86 192 192 0 71.1-38.6 133.1-96 166.3l0 25.7-192 0 0-25.7C166.6 325.1 128 263.1 128 192 128 86 214 0 320 0zM112.2 330.7c-9 4.5-34 17-74.9 37.5L15.8 325.3c9-4.5 34-17 74.9-37.5l21.5 42.9zm490.5-16.2l21.5 10.7-21.5 42.9c-41-20.5-65.9-33-74.9-37.5l21.5-42.9 53.4 26.7zM292 252l0 56 56 0 0-56-56 0zM80 216l-80 0 0-48 80 0 0 48zM288 72l12.8 144 38.4 0 12.8-144-64 0zM640 216l-80 0 0-48 80 0 0 48zM90.7 42.5l21.5 10.8-21.5 42.9c-41-20.5-65.9-33-74.9-37.5L37.3 15.8 90.7 42.5zM624.2 58.7c-9 4.5-34 17-74.9 37.5L527.8 53.3c9-4.5 34-17 74.9-37.5l21.5 42.9z"]
};
var faBell = {
  prefix: 'fass',
  iconName: 'bell',
  icon: [512, 512, [128276, 61602], "f0f3", "M288 0l-64 0 0 35.2C151 50 96 114.6 96 192l0 96-80 128 480 0-80-128 0-96c0-77.4-55-142-128-156.8L288 0zM194 464c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48l-124 0z"]
};
var faHandBackPointLeft = {
  prefix: 'fass',
  iconName: 'hand-back-point-left',
  icon: [512, 512, [], "e19f", "M0 208l0-80 336 0 0-32-72 0 40-48 68 0c38 0 74 16.9 98.3 46.1l4.5 5.4c24 28.8 37.1 65 37.1 102.4L512 320c0 70.7-57.3 128-128 128l-144 0 0-80-32 0 0-80-32 0 0-80-176 0z"]
};
var faLariSign = {
  prefix: 'fass',
  iconName: 'lari-sign',
  icon: [384, 512, [], "e1c8", "M168 0l0 65.5c7.9-1 15.9-1.5 24-1.5s16.1 .5 24 1.5l0-65.5 48 0 0 78c70.4 28.5 120 97.5 120 178l-64 0c0-44-22.2-82.8-56-105.8l0 105.8-48 0 0-125.8c-7.8-1.5-15.8-2.2-24-2.2s-16.2 .8-24 2.2l0 125.8-48 0 0-105.8c-33.8 23-56 61.9-56 105.8 0 70.7 57.3 128 128 128l192 0 0 64-384 0 0-64 48.9 0C18.5 350 0 305.2 0 256 0 175.4 49.6 106.4 120 78l0-78 48 0z"]
};
var faRectanglePlus = {
  prefix: 'fass',
  iconName: 'rectangle-plus',
  icon: [512, 512, [], "e6b5", "M512 64l-512 0 0 384 512 0 0-384zM232 368l0-88-88 0 0-48 88 0 0-88 48 0 0 88 88 0 0 48-88 0 0 88-48 0z"]
};
var faCucumber = {
  prefix: 'fass',
  iconName: 'cucumber',
  icon: [512, 512, [129362], "e401", "M37.5 474.5c47.8 47.8 123.9 49.9 174.2 6.4l20.4 20.4 45.3-45.3-20.1-20.1 178.7-178.7 20.1 20.1 45.3-45.3-20.4-20.4c43.5-50.3 41.4-126.4-6.4-174.2-50-50-131-50-181 0l-121.4 121.4-20.1-20.1-45.3 45.3 20.1 20.1-89.4 89.4c-50 50-50 131 0 181zM168 280l0 48-48 0 0-48 48 0zm112-32l48 0 0 48-48 0 0-48zM424 88l0 48-48 0 0-48 48 0z"]
};
var faSeal = {
  prefix: 'fass',
  iconName: 'seal',
  icon: [576, 512, [], "e241", "M131.9 99.9L21.5 145.6 67.2 256 21.5 366.4 131.9 412.1 177.6 522.5 288 476.8 398.4 522.5 444.2 412.1 554.6 366.4 508.8 256 554.6 145.6 444.2 99.9 398.4-10.5 288 35.2 177.6-10.5 131.9 99.9z"]
};
var faCircleCaretDown = {
  prefix: 'fass',
  iconName: 'circle-caret-down',
  icon: [512, 512, ["caret-circle-down"], "f32d", "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm0 360l-136-168 272 0-136 168z"]
};
var faCaretCircleDown = faCircleCaretDown;
var faMillSign = {
  prefix: 'fass',
  iconName: 'mill-sign',
  icon: [384, 512, [], "e1ed", "M319.3-13.2c-2.7 6.6-15.4 37.8-38 93.6 57.5 4.7 102.7 52.9 102.7 111.6l0 240-64 0 0-240c0-26.5-21.5-48-48-48-6.4 0-12.5 1.2-18 3.5l-30 73.8 0 210.7-64 0 0-53.2-57.8 142.2-9 22.2-44.5-18.1 9-22.2 102.2-251.7 0-59.3c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 240-64 0 0-352 64 0 0 10.8c14.5-6.9 30.8-10.8 48-10.8 31.3 0 59.7 12.9 80 33.6 9.6-9.8 20.9-17.8 33.5-23.5 32.1-78.9 48.5-119.3 49.3-121.3l44.5 18.1z"]
};
var faMugTeaSaucer = {
  prefix: 'fass',
  iconName: 'mug-tea-saucer',
  icon: [576, 512, [], "e1f5", "M168 32l0 64-40 48 0 112 128 0 0-112-40-48 0-64 232 0c70.7 0 128 57.3 128 128S518.7 288 448 288l0 96-384 0 0-352 104 0zM448 224c35.3 0 64-28.7 64-64s-28.7-64-64-64l0 128zM32 448l448 0 0 64-448 0 0-64z"]
};
var faCartCircleCheck = {
  prefix: 'fass',
  iconName: 'cart-circle-check',
  icon: [640, 512, [], "e3f1", "M24-16l-24 0 0 48 76 0 60.4 332.3 3.6 19.7 164.7 0c1.4-16.7 4.9-32.8 10.3-48l-134.9 0-8.7-48 168.7 0c34.9-48.5 91.7-80 156-80 15.8 0 31.2 1.9 46 5.5L576 32 124.8 32c-3.7-20.3-6.6-36.3-8.7-48L24-16zM208 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L417.4 400 440 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z"]
};
var faAlbum = {
  prefix: 'fass',
  iconName: 'album',
  icon: [448, 512, [128189], "f89f", "M0 32l448 0 0 448-448 0 0-448zM384 256a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faLeftToLine = {
  prefix: 'fass',
  iconName: 'left-to-line',
  icon: [512, 512, ["arrow-alt-to-left"], "f34b", "M0 448l0-384 64 0 0 384-64 0zM117 256l18.5-17.4C248.8 131.6 310.3 73.5 320 64.3l0 127.7 160 0 0 0 32 0 0 128-192 0 0 127.7c-9.7-9.2-71.2-67.3-184.5-174.2L117 256z"]
};
var faArrowAltToLeft = faLeftToLine;
var faPersonSnowboarding = {
  prefix: 'fass',
  iconName: 'person-snowboarding',
  icon: [576, 512, [127938, "snowboarding"], "f7ce", "M424.4 16a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM184.8 19.4l26.1 18.5 272 192 26.1 18.5-36.9 52.3c-6.4-4.5-45.9-32.4-118.4-83.6l-62.2 53.3c39.2 32.7 59.5 49.6 60.9 50.7l0 125.3 87 17c38.2-10.9 62.7-17.9 73.5-21l13.2 46.2c-9.9 2.8-36.3 10.4-79.1 22.6-3.6 1-7.5 1.2-11.2 .5l-368-72c-4.7-.9-9-3.2-12.4-6.6-30.5-30.5-49.5-49.5-57-57l33.9-33.9c8.3 8.3 25.6 25.6 51.8 51.8l76.2 14.9 0-123.7c0-27.7 12-54 32.8-72.2l69-60.4C193 103.6 154.9 76.7 147.8 71.7l36.9-52.3zm39.7 401.9l64 12.5 0-82.8-64-53.3 0 123.6z"]
};
var faSnowboarding = faPersonSnowboarding;
var faTty = {
  prefix: 'fass',
  iconName: 'tty',
  icon: [512, 512, ["teletype"], "f1e4", "M512.1 143.4l-36.6 109.7-128.4-17.8 .4-91.9c-59.1-21.4-123.8-21.4-182.9 0l.4 91.9-128.4 17.8-36.6-109.7 9.1-9.1C145.5-2.1 366.6-2.1 502.9 134.2l9.1 9.1zM32 320l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zM96 416l0 64-64 0 0-64 64 0zm320 0l64 0 0 64-64 0 0-64zM288 320l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zM128 416l256 0 0 64-256 0 0-64z"]
};
var faTeletype = faTty;
var faSliderCircle = {
  prefix: 'fass',
  iconName: 'slider-circle',
  icon: [576, 512, [], "e750", "M476 288c-14.2 55.2-64.3 96-124 96-70.7 0-128-57.3-128-128s57.3-128 128-128c59.6 0 109.8 40.8 124 96l100 0 0 64-100 0zM32 224l146.9 0c-1.9 10.4-2.9 21.1-2.9 32s1 21.6 2.9 32L0 288 0 224 32 224z"]
};
var faUsersRectangle = {
  prefix: 'fass',
  iconName: 'users-rectangle',
  icon: [576, 512, [], "e594", "M576 0L0 0 0 512 576 512 576 0zM224 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm-48 0c0 28.2 10.4 54 27.7 73.7-8.4 4-17.8 6.3-27.7 6.3-35.3 0-64-28.7-64-64s28.7-64 64-64c3.5 0 7 .3 10.4 .8-6.7 14.3-10.4 30.3-10.4 47.2zm224 80c-9.9 0-19.3-2.3-27.7-6.3 17.2-19.7 27.7-45.5 27.7-73.7 0-16.8-3.7-32.8-10.4-47.2 3.4-.6 6.8-.8 10.4-.8 35.3 0 64 28.7 64 64s-28.7 64-64 64zM124.7 400l-44.7 0 48-112 38.7 0-35.7 95.1-6.3 16.9zm326.5 0l-6.3-16.9-35.7-95.1 38.7 0 48 112-44.7 0zM352 272l48 128-224 0 48-128 128 0z"]
};
var faMobile = {
  prefix: 'fass',
  iconName: 'mobile',
  icon: [384, 512, [128241, "mobile-android", "mobile-phone"], "f3ce", "M368 0l-352 0 0 512 352 0 0-512zM152 416l104 0 0 48-128 0 0-48 24 0z"]
};
var faMobileAndroid = faMobile;
var faMobilePhone = faMobile;
var faArrowsTurnToDots = {
  prefix: 'fass',
  iconName: 'arrows-turn-to-dots',
  icon: [448, 512, [], "e4c1", "M265.4-6.6L288-29.3 333.3 16c-14.6 14.6-30.6 30.6-48 48l162.7 0 0 160-64 0 0-96-98.7 0c17.4 17.4 33.4 33.4 48 48L288 221.3c-5.5-5.5-39.7-39.7-102.6-102.6L162.7 96c5.5-5.5 39.7-39.7 102.6-102.6zm-82.7 272c62.9 62.9 97.1 97.1 102.6 102.6-5.5 5.5-39.7 39.7-102.6 102.6L160 493.3 114.7 448c14.6-14.6 30.6-30.6 48-48l-98.7 0 0 96-64 0 0-160 162.7 0c-17.4-17.4-33.4-33.4-48-48l45.3-45.3 22.6 22.6zM320 368a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 160a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"]
};
var faExclamation = {
  prefix: 'fass',
  iconName: 'exclamation',
  icon: [128, 512, [10069, 10071, 61738], "21", "M96 512l-64 0 0-64 64 0 0 64zm0-128L32 384 16 0 112 0 96 384z"]
};
var faLocationXmark = {
  prefix: 'fass',
  iconName: 'location-xmark',
  icon: [384, 512, ["map-marker-times", "map-marker-xmark"], "f60e", "M0 188.6C0 84.4 86 0 192 0S384 84.4 384 188.6C384 339.4 192 528 192 528S0 339.4 0 188.6zm276.9-47.5l-33.9-33.9c-8.5 8.5-25.5 25.5-50.9 50.9-25.5-25.5-42.4-42.4-50.9-50.9l-33.9 33.9c8.5 8.5 25.5 25.5 50.9 50.9-25.5 25.5-42.4 42.4-50.9 50.9l33.9 33.9c8.5-8.5 25.5-25.5 50.9-50.9 25.5 25.5 42.4 42.4 50.9 50.9l33.9-33.9c-8.5-8.5-25.5-25.5-50.9-50.9 25.5-25.5 42.4-42.4 50.9-50.9z"]
};
var faMapMarkerTimes = faLocationXmark;
var faMapMarkerXmark = faLocationXmark;
var faChurch = {
  prefix: 'fass',
  iconName: 'church',
  icon: [512, 512, [9962], "f51d", "M280-8l0-24-48 0 0 48-56 0 0 48 56 0 0 48-120 80 0 64-112 64 0 192c192 0 128 0 384 0l128 0 0-192-112-64 0-64-120-80 0-48 56 0 0-48-56 0 0-24zm40 328l0 144-128 0 0-144 128 0z"]
};
var faToggleOff = {
  prefix: 'fass',
  iconName: 'toggle-off',
  icon: [576, 512, [], "f204", "M512 128l0 256-448 0 0-256 448 0zm64-64l-576 0 0 384 576 0 0-384zM112 176l0 160 160 0 0-160-160 0z"]
};
var faFaceNauseated = {
  prefix: 'fass',
  iconName: 'face-nauseated',
  icon: [512, 512, [], "e381", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm80-320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-23.1-78.1l-81.9 40.9-17.9-35.8 99.8-49.9 17.9 35.8-17.9 8.9zm124.2-8.9l17.9-35.8c4.2 2.1 31.5 15.8 81.9 40.9l17.9 8.9-17.9 35.8c-4.2-2.1-31.5-15.8-81.9-40.9l-17.9-8.9zM160 288c26.9 0 49.9 16.5 59.3 40l73.3 0c9.5-23.5 32.5-40 59.3-40 4.8 0 9.5 .5 14 1.5-18.3 14.7-30 37.2-30 62.5s11.7 47.8 30 62.5c-4.5 1-9.2 1.5-14 1.5-26.9 0-49.9-16.5-59.3-40l-73.3 0c-9.5 23.5-32.5 40-59.3 40-4.8 0-9.5-.5-14-1.5 18.3-14.7 30-37.2 30-62.5s-11.7-47.8-30-62.5c4.5-1 9.2-1.5 14-1.5z"]
};
var faDeer = {
  prefix: 'fass',
  iconName: 'deer',
  icon: [512, 512, [129420], "f78e", "M256.3 0l0 40c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-40 32 0 0 40c0 8.6-1.9 16.7-5.4 24l69.4 0c13.3 0 24-10.7 24-24l0-40 32 0 0 40c0 21.7-12.3 40.4-30.3 49.8 .6 .5 1.1 1.1 1.7 1.6l68.6 68.6 0 64-101.3 0-26.7 80 0 208-96 0 0-144-48 0-64-27.4 0 23.3c-7.3 7.3-20.8 20.8-40.7 40.7L173.5 512 71.7 512C42.8 430.1 27.2 385.9 24.9 379.4 38.4 366 54.2 350.1 72.4 332L56.3 315.9c-3-3-5.7-6.1-8.1-9.5l-1.8 23.3-47.9-3.7C-.4 311.2 1 293.1 2.7 272 6.8 217.8 52 176 106.4 176l196.3 0 9.6-32-56 0 0-32 64-16-40 0c-30.9 0-56-25.1-56-56l0-40 32 0zm144 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faBoxOpenFull = {
  prefix: 'fass',
  iconName: 'box-open-full',
  icon: [640, 512, ["box-full"], "f49c", "M315.9 170.5c2.9-8.3 4.5-17.2 4.5-26.5 0-44.2-35.8-80-80-80-24.5 0-46.5 11-61.2 28.4l-47.1-26.9-9-5.1C149.3 23.8 192 0 240.4 0 274.1 0 305 11.6 329.6 30.9 340.8 12.4 361.1 0 384.4 0l64 0c35.1 0 63.7 28.3 64 63.4l-3.7 2.1-60.3 34.4 0-35.9-64 0 0 64-.9 0c.3 2.8 .5 5.7 .7 8.6l-63.8 36.5-4.5-2.6zM80.4 392l0-90.5c-34.6-18.5-59.7-32-75.4-40.4 3.3-6.2 27.1-50.3 71.2-132.2l15.4-28.6 28.3 15.7 200.5 111.4 200.5-111.4 25.8-14.3c5.6 8.5 27.1 40.7 64.4 96.6l17.8 26.6-53.3 35.5-15.1-22.7 0 154.3-240 136-240-136zM278.9 277.6l-161.7-89.8-25.4 47.2 165.8 88.8 21.3-46.2z"]
};
var faBoxFull = faBoxOpenFull;
var faCherries = {
  prefix: 'fass',
  iconName: 'cherries',
  icon: [576, 512, [], "e0ec", "M261.9 0L172.1 209.5c-17.4-11.1-38-17.5-60.1-17.5-61.9 0-112 50.1-112 112 0 97.2 86 176 192 176s192-78.8 192-176c0-61.9-50.1-112-112-112-15.6 0-30.5 3.2-44 9L292.8 49.8 407.3 218.5c15.7 24.7 24.7 54.1 24.7 85.5 0 70.8-34.3 131.9-86.8 172.4 12.5 2.4 25.5 3.6 38.8 3.6 106 0 192-78.8 192-176 0-61.9-50.1-112-112-112-5.4 0-10.7 .4-15.9 1.1L317 0 261.9 0z"]
};
var faVacuumRobot = {
  prefix: 'fass',
  iconName: 'vacuum-robot',
  icon: [512, 512, [], "e04e", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm95-351c-52.5-52.5-137.6-52.5-190.1 0L127 127c71.2-71.2 186.7-71.2 257.9 0s71.2 186.7 0 257.9L351 351c52.5-52.5 52.5-137.6 0-190.1zM208 206.1c3.5 3.5 30.5 30.5 81 81l17 17-33.9 33.9c-3.5-3.5-30.5-30.5-81-81l-17-17 33.9-33.9zm-64 64c3.5 3.5 30.5 30.5 81 81l17 17-33.9 33.9c-3.5-3.5-30.5-30.5-81-81l-17-17 33.9-33.9z"]
};
var faCircleEurozone = {
  prefix: 'fass',
  iconName: 'circle-eurozone',
  icon: [512, 512, [], "e745", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM136 144l96 0 0 48-72 0 0 43.2 64 0 0 48-64 0 0 36.8 73.6 0 0 48-121.6 0 0-224 24 0zm152 0l115.8 0c-1.5 3.8-25.5 62.4-72 176l68.3 0 0 48-139.7 0c1.5-3.8 25.5-62.4 72-176l-68.3 0 0-48 24 0z"]
};
var faShoePrints = {
  prefix: 'fass',
  iconName: 'shoe-prints',
  icon: [576, 512, [], "f54b", "M256 160l-32 0 0-128 160-32 192 64 0 112-192 48-128-64zM64 32l112 0 0 128-112 0 0-128zM512 336l0 112-192 64-160-32 0-128 32 0 128-64 192 48zM0 480l0-128 112 0 0 128-112 0z"]
};
var faSquirrel = {
  prefix: 'fass',
  iconName: 'squirrel',
  icon: [512, 512, [], "f71a", "M160 299.3c-19.9 22.6-32 52.2-32 84.7l0 128 352 0 0-64-48 0c10-13.4 16-30 16-48 0-26.2-12.6-49.4-32-64-13.4-10-30-16-48-16-9.4 0-18.3 1.6-26.7 4.5l-10.7-30.2c11.7-4.1 24.3-6.4 37.3-6.4 17.2 0 33.5 3.9 48 10.8l0-58.8 64 0 32-48 0-32-87.9-58.6c-2.5-1.7-5.3-3-8.1-3.9L416 64c-20.4 0-38.2 10.9-48 27.1-9.8-16.3-27.6-27.1-48-27.1l0 160-25.3 38c-2.2-.7-4.4-1.3-6.7-1.9l0-116C288 64.5 223.5 0 144 0S0 64.5 0 144 64.5 288 144 288c5.4 0 10.7-.3 16-.9l0 12.2zM416 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faCircleCedi = {
  prefix: 'fass',
  iconName: 'circle-cedi',
  icon: [512, 512, [], "e742", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-179.7c16.1-5.1 30.1-15.1 40-28.3l38.4 28.8c-18.7 25-46.5 42.9-78.4 48.9l0 34.2-48 0 0-34.2C172.8 370.5 128 318.5 128 256s44.8-114.5 104-125.8l0-34.2 48 0 0 34.2c31.9 6.1 59.6 24 78.4 48.9L320 208c-10-13.3-23.9-23.3-40-28.3l0 152.7zM232 179.7c-32.5 10.2-56 40.5-56 76.3s23.5 66.1 56 76.3l0-152.7z"]
};
var faFileCircleExclamation = {
  prefix: 'fass',
  iconName: 'file-circle-exclamation',
  icon: [576, 512, [], "e4eb", "M272 0l-240 0 0 512 244 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3L416 144 272 0zm85.5 176L240 176 240 58.5 357.5 176zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 112-32 0 0-112 32 0z"]
};
var faWallet = {
  prefix: 'fass',
  iconName: 'wallet',
  icon: [512, 512, [], "f555", "M480 32l-480 0 0 416 512 0 0-320-464 0 0-48 432 0 0-48zM416 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSquareTugrik = {
  prefix: 'fass',
  iconName: 'square-tugrik',
  icon: [448, 512, [], "e728", "M448 32l-448 0 0 448 448 0 0-448zM112 128l224 0 0 48-88 0 0 39.1c33.3-11.1 52.6-17.5 58.1-19.4l10.1 30.4c-3.8 1.3-26.6 8.9-68.2 22.7l0 30.3c33.3-11.1 52.6-17.5 58.1-19.4l10.1 30.4c-3.8 1.3-26.6 8.9-68.2 22.7l0 71.1-48 0 0-55.1c-33.3 11.1-52.6 17.5-58.1 19.4l-10.1-30.4c3.8-1.3 26.6-8.9 68.2-22.7l0-30.3c-33.3 11.1-52.6 17.5-58.1 19.4l-10.1-30.4c3.8-1.3 26.6-8.9 68.2-22.7l0-55.1-88 0 0-48z"]
};
var faMessage = {
  prefix: 'fass',
  iconName: 'message',
  icon: [512, 512, ["comment-alt"], "f27a", "M0 448l0-416 512 0 0 416-224 0-160 96 0-96-128 0z"]
};
var faCommentAlt = faMessage;
var faTrophy = {
  prefix: 'fass',
  iconName: 'trophy',
  icon: [512, 512, [127942], "f091", "M97.6 64C96.6 43.9 96 22.6 96 0L416 0c0 22.6-.6 43.9-1.6 64l97.6 0 0 24c0 56.8-12.7 101.7-33.5 136.8-20.9 35.2-49.2 59.3-78.5 75.7-18 10.1-36.5 17.4-54.1 22.5-20.2 28.6-41.2 43.7-57.9 51.8l0 73.1 96 0 0 64-256 0 0-64 96 0 0-73.1c-16-7.7-35.9-22-55.3-48.3-20.5-5.4-42.8-13.8-64.5-26.8-56.3-34.1-104.2-98-104.2-211.8l0-24 97.6 0zm3.6 48l-52.4 0c6 81.7 42.4 123.8 80.2 146.7 1.6 1 3.3 2 5 2.9-14.4-37.3-26.3-86-32.8-149.6zM379.8 256.8c22-12.9 42.3-31 57.4-56.5 13.2-22.2 23-50.9 25.9-88.4l-52.3 0c-6.2 60.9-17.4 108.2-31 144.8z"]
};
var faFaceDizzy = {
  prefix: 'fass',
  iconName: 'face-dizzy',
  icon: [512, 512, ["dizzy"], "f567", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM134.1 153.9L160 179.7c19.2-19.2 32.5-32.5 40-40L228.3 168c-7.5 7.5-20.8 20.8-40 40 19.2 19.2 32.5 32.5 40 40L200 276.3c-7.5-7.5-20.8-20.8-40-40-19.2 19.2-32.5 32.5-40 40l-28.3-28.3 40-40c-19.2-19.2-32.5-32.5-40-40l28.3-28.3 14.1 14.1zm192 0L352 179.7c19.2-19.2 32.5-32.5 40-40L420.3 168c-7.5 7.5-20.8 20.8-40 40 19.2 19.2 32.5 32.5 40 40L392 276.3c-7.5-7.5-20.8-20.8-40-40-19.2 19.2-32.5 32.5-40 40L283.7 248c7.5-7.5 20.8-20.8 40-40-19.2-19.2-32.5-32.5-40-40l28.3-28.3 14.1 14.1zM256 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faDizzy = faFaceDizzy;
var faBacteria = {
  prefix: 'fass',
  iconName: 'bacteria',
  icon: [640, 512, [], "e059", "M280-32l0 35c8.6 2.2 16.9 5.6 24.8 10.3 2.4-2.4 10.1-10.1 23.2-23.2L361.9 24c-13.1 13.1-20.8 20.8-23.2 23.2 4.6 7.8 8 16.2 10.3 24.8l35 0 0 48-35 0c-2.2 8.6-5.6 16.9-10.3 24.8 2.4 2.4 10.1 10.1 23.2 23.2L328 201.9c-13.5-13.5-20.5-20.5-21.1-21.1l-30.1 30.1c.6 .6 7.6 7.6 21.1 21.1L264 265.9c-13.5-13.5-20.5-20.5-21.1-21.1-10 10-20 20-30.1 30.1 .6 .6 7.6 7.6 21.1 21.1L200 329.9c-13.1-13.1-20.8-20.8-23.2-23.2-7.8 4.6-16.2 8-24.8 10.3l0 35-48 0 0-35c-8.6-2.2-16.9-5.6-24.8-10.3-2.4 2.4-10.1 10.1-23.2 23.2L22.1 296c13.1-13.1 20.8-20.8 23.2-23.2-4.6-7.8-8-16.2-10.3-24.8l-35 0 0-48 35 0c2.2-8.6 5.6-16.9 10.3-24.8L22.1 152 56 118.1 77.1 139.1c10-10 20-20 30.1-30.1L86.1 88 120 54.1 141.1 75.1 171.1 45.1 150.1 24 184-9.9c13.1 13.1 20.8 20.8 23.2 23.2 7.8-4.6 16.2-8 24.8-10.3l0-35 48 0zM128 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm296 40l0 11c8.6 2.2 16.9 5.6 24.8 10.3 2.4-2.4 10.1-10.1 23.2-23.2L617.9 216c-13.1 13.1-20.8 20.8-23.2 23.2 4.6 7.8 8 16.2 10.3 24.8l35 0 0 48-35 0c-2.2 8.6-5.6 16.9-10.3 24.8L617.9 360 584 393.9c-13.5-13.5-20.5-20.5-21.1-21.1l-30.1 30.1 21.1 21.1-33.9 33.9-21.1-21.1c-10 10-20 20-30.1 30.1l21.1 21.1-33.9 33.9-23.2-23.2c-7.8 4.6-16.2 8-24.8 10.3l0 35-48 0 0-35c-8.6-2.2-16.9-5.6-24.8-10.3-2.4 2.4-10.1 10.1-23.2 23.2L278.1 488c13.1-13.1 20.8-20.8 23.2-23.2-4.6-7.8-8-16.2-10.3-24.8l-35 0 0-48 35 0c2.2-8.6 5.6-16.9 10.3-24.8-2.4-2.4-10.1-10.1-23.2-23.2L312 310.1c13.5 13.5 20.5 20.5 21.1 21.1 10-10 20-20 30.1-30.1L342.1 280 376 246.1c13.5 13.5 20.5 20.5 21.1 21.1l30.1-30.1c-.6-.6-7.6-7.6-21.1-21.1L440 182.1c13.1 13.1 20.8 20.8 23.2 23.2 7.8-4.6 16.2-8 24.8-10.3l0-35 48 0 0 24zM448 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faToggleLargeOn = {
  prefix: 'fass',
  iconName: 'toggle-large-on',
  icon: [576, 512, [], "e5b1", "M576 64l-576 0 0 384 576 0 0-384zm-64 64l0 256-256 0 0-256 256 0z"]
};
var faEarDeaf = {
  prefix: 'fass',
  iconName: 'ear-deaf',
  icon: [512, 512, ["deaf", "deafness", "hard-of-hearing"], "f2a4", "M509.5 48c-33.7 33.7-58.9 58.9-69.3 69.3L395 72c33.7-33.7 58.9-58.9 69.3-69.3L509.5 48zm-304 304L70.9 486.6 48.3 509.3 3 464c.2-.2 45.1-45.1 134.6-134.6l22.6-22.6 45.3 45.3zm34.7-224c-61.9 0-112 50.1-112 112l-64 0c0-97.2 78.8-176 176-176s176 78.8 176 176c0 54.7-25 103.5-64 135.8l0 24.2c0 61.9-50.1 112-112 112l-32 0 0-64 32 0c26.5 0 48-21.5 48-48l0-57.3 14.2-9.5c30.1-20.1 49.8-54.4 49.8-93.2 0-61.9-50.1-112-112-112zm-32 112l-48 0c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faDeaf = faEarDeaf;
var faDeafness = faEarDeaf;
var faHardOfHearing = faEarDeaf;
var faPeopleArrows = {
  prefix: 'fass',
  iconName: 'people-arrows',
  icon: [512, 512, ["people-arrows-left-right"], "e068", "M32 64A64 64 0 1 1 160 64 64 64 0 1 1 32 64zM160 350.4l0 161.6-128 0 0-160-32 0 0-192 161.7 0c-48.7 44.6-83.6 76.6-104.7 96 21.4 19.6 55.8 51.1 103 94.4zM352 512l0-161.6c47.3-43.3 81.6-74.8 103-94.4-21.1-19.4-56.1-51.4-104.7-96l161.7 0 0 192-32 0 0 160-128 0zm0-448a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM224 168l0 62.4 64 0 0-62.4 96 88-96 88 0-62.4-64 0 0 62.4-96-88 96-88z"]
};
var faPeopleArrowsLeftRight = faPeopleArrows;
var faTreasureChest = {
  prefix: 'fass',
  iconName: 'treasure-chest',
  icon: [512, 512, [], "f723", "M80 41.3l0 206.7-80 0 0-88C0 106.3 33.1 60.3 80 41.3zM0 296l80 0 0 184-80 0 0-184zM128 480l0-184 96 0 0 56 64 0 0-56 96 0 0 184-256 0zm304 0l0-184 80 0 0 184-80 0zm80-232l-80 0 0-206.7c46.9 19 80 65 80 118.7l0 88zM384 32l0 216-96 0 0-56-64 0 0 56-96 0 0-216 256 0z"]
};
var faCaretLargeRight = {
  prefix: 'fass',
  iconName: 'caret-large-right',
  icon: [320, 512, [], "e82e", "M64 40L296 256 64 472 64 40z"]
};
var faHandsClapping = {
  prefix: 'fass',
  iconName: 'hands-clapping',
  icon: [576, 512, [], "e1a8", "M376.4 8l0 88-48 0 0-112 48 0 0 24zm-124 2.7c24.4 36.7 39.6 59.3 45.3 68l-39.9 26.6c-5.8-8.6-20.9-31.3-45.3-68l-13.3-20 39.9-26.6 13.3 20zm-68 91.4l17 17 151 151 0-110.1 64 0 0 185.6c0 57.1-30 110-78.9 139.4-63.9 38.4-145.8 28.3-198.5-24.4l-99.5-99.5-17-17 33.9-33.9c3.5 3.5 30.5 30.5 81 81l22.1-22.1-104-104-17-17 33.9-33.9 17 17 104 104 22.1-22.1-128-128-17-17 33.9-33.9 17 17 128 128 22.1-22.1-104-104-17-17 33.9-33.9zM465.5 484.9c-24.2 14.5-50.9 22.1-77.7 23.1 48.1-39.6 76.6-99 76.6-162.4l0-91.5 16 16 0-110.1 64 0 0 185.6c0 57.1-30 110-78.9 139.4zm.3-494.2l39.9 26.6c-5.8 8.6-20.9 31.3-45.3 68l-13.3 20-39.9-26.6c5.8-8.6 20.9-31.3 45.3-68l13.3-20z"]
};
var faCircleAmpersand = {
  prefix: 'fass',
  iconName: 'circle-ampersand',
  icon: [512, 512, [], "e0f8", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM168 128l144 0 0 59.7c0 20.4-9.7 39.6-26.2 51.6l-18 13.2 28.6 29.9c20.9-30.1 34.7-50 41.4-59.8l39.5 27.3c-5.8 8.4-21.5 31-47 67.9l60.9 63.6c.8 .8 1.5 1.7 2.2 2.6l-66.1 0-24.8-25.9c-7.8 11.3-13.8 19.9-17.9 25.9l-140.6 0 0-63.7c0-22.9 10.9-44.5 29.4-58.1l21.9-16.1-7.3-7.7c-12.8-13.4-20-31.2-20-49.8l0-60.7zm66.4 89.6l23.1-16.9c4.1-3 6.5-7.8 6.5-12.9l0-11.7-48 0 0 12.7c0 6.2 2.4 12.1 6.7 16.6l11.7 12.2zm-5.6 63.6l-27 19.8c-6.2 4.5-9.8 11.7-9.8 19.4l0 15.7 67.4 0 9.2-13.3-39.8-41.5z"]
};
var faVirusCovidSlash = {
  prefix: 'fass',
  iconName: 'virus-covid-slash',
  icon: [576, 512, [], "e4a9", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-1.6-1.6-32.3-32.3-92.1-92.1 6.6-6.6 16-16 28.2-28.2l-33.9-33.9c-12.3 12.3-21.7 21.7-28.2 28.2l-23.8-23.8c17.8-23.5 29.9-51.6 34.1-82.3l33.6 0 0 40 48 0 0-128-48 0 0 40-33.6 0c-4.2-30.7-16.3-58.8-34.1-82.3l23.8-23.8c6.6 6.6 16 16 28.3 28.3l33.9-33.9C439 44.8 434.3 40.1 423.9 29.7L390 63.7c12.3 12.3 21.7 21.7 28.3 28.3l-23.8 23.8c-23.5-17.9-51.7-29.9-82.3-34.1l0-33.6 40 0 0-48-128 0 0 48 40 0 0 33.6c-30.6 4.2-58.8 16.2-82.3 34.1l-23.8-23.8 28.2-28.2-33.9-33.9C140.1 42 130.7 51.4 124.1 58L49.3-16.9zm74.3 210.2c-4.7 12.3-8 25.2-9.9 38.7l-33.6 0 0-40-48 0 0 128 48 0 0-40 33.6 0c4.2 30.7 16.3 58.8 34.1 82.3l-23.8 23.8c-6.6-6.6-16-16-28.3-28.3L61.9 391.8c75.4 75.4 80.1 80.1 90.5 90.5l33.9-33.9c-12.3-12.3-21.7-21.7-28.3-28.3l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1l0 33.6-40 0 0 48 128 0 0-48-40 0 0-33.6c13.4-1.8 26.4-5.2 38.7-9.9L123.6 193.3z"]
};
var faChartSimpleHorizontal = {
  prefix: 'fass',
  iconName: 'chart-simple-horizontal',
  icon: [448, 512, [], "e474", "M384 128L0 128 0 0 384 0 384 128zm64 64l0 128-448 0 0-128 448 0zM256 384l0 128-256 0 0-128 256 0z"]
};
var faDownFromDottedLine = {
  prefix: 'fass',
  iconName: 'down-from-dotted-line',
  icon: [384, 512, [], "e407", "M192 522.9l-192-202.9 128 0 0-192 128 0 0 192 128 0-192 202.9zM0 64L0 0 64 0 64 64 0 64zm170.7 0l-64 0 0-64 64 0 0 64zm42.7 0l0-64 64 0 0 64-64 0zM384 64l-64 0 0-64 64 0 0 64z"]
};
var faCalendarDays = {
  prefix: 'fass',
  iconName: 'calendar-days',
  icon: [448, 512, ["calendar-alt"], "f073", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0zM64 288l64 0 0-64-64 0 0 64zm128-64l0 64 64 0 0-64-64 0zm192 64l0-64-64 0 0 64 64 0zM64 416l64 0 0-64-64 0 0 64zm192-64l-64 0 0 64 64 0 0-64zm64 64l64 0 0-64-64 0 0 64z"]
};
var faCalendarAlt = faCalendarDays;
var faLighthouse = {
  prefix: 'fass',
  iconName: 'lighthouse',
  icon: [576, 512, [], "e612", "M42.9 10.5c49.7 24.9 78.2 39.1 85.5 42.7L106.9 96.2c-7.2-3.6-35.7-17.9-85.5-42.7L0 42.7 21.5-.2 42.9 10.5zm64 202.9c-49.7 24.9-78.2 39.1-85.5 42.7L0 213.3c7.2-3.6 35.7-17.9 85.5-42.7l21.5-10.7 21.5 42.9-21.5 10.7zM160.2 64l128-64c74.7 37.3 117.3 58.7 128 64l0 48-32 0 0 48 32 0 0 64-19.2 0 44.8 224 38.4 0 0 64-384 0 0-64 38.4 0 44.8-224-19.2 0 0-64 32 0 0-48-32 0 0-48zm160 48l0-24.4-32-16-32 16 0 72.4 64 0 0-48zM554.9-.2l21.5 42.9c-7.2 3.6-35.7 17.9-85.5 42.7L469.5 96.2 448 53.3c7.2-3.6 35.7-17.9 85.5-42.7L554.9-.2zM448 202.7l21.5-42.9c7.2 3.6 35.7 17.9 85.5 42.7l21.5 10.7-21.5 42.9c-7.2-3.6-35.7-17.9-85.5-42.7L448 202.7zM320.2 368l-64 0 0 96 64 0 0-96z"]
};
var faDiamondTurnRight = {
  prefix: 'fass',
  iconName: 'diamond-turn-right',
  icon: [576, 512, ["directions"], "f5eb", "M288-16L16 256 288 528 560 256 288-16zM417 257c-57.2 57.2-86.8 86.8-89 89L294.1 312c9-9 25-25 48-48l-102.1 0 0 88-48 0 0-136 150.1 0c-23-23-39-39-48-48L328 134.1c2.1 2.1 31.8 31.8 89 89l17 17-17 17z"]
};
var faDirections = faDiamondTurnRight;
var faDrone = {
  prefix: 'fass',
  iconName: 'drone',
  icon: [512, 512, [], "f85f", "M417.7 338.5c26.8 7.7 46.3 32.3 46.3 61.5 0 35.3-28.7 64-64 64-29.2 0-53.9-19.6-61.5-46.3L320.8 400 288 400c0 61.9 50.1 112 112 112s112-50.1 112-112-50.1-112-112-112l0 32.8 17.7 17.7zM512 112C512 50.1 461.9 0 400 0S288 50.1 288 112l32.8 0 17.7-17.7c7.7-26.8 32.3-46.3 61.5-46.3 35.3 0 64 28.7 64 64 0 29.2-19.6 53.9-46.3 61.5L400 191.2 400 224c61.9 0 112-50.1 112-112zM112 0C50.1 0 0 50.1 0 112S50.1 224 112 224l0-32.8-17.7-17.7c-26.8-7.7-46.3-32.3-46.3-61.5 0-35.3 28.7-64 64-64 29.2 0 53.9 19.6 61.5 46.3l17.7 17.7 32.8 0C224 50.1 173.9 0 112 0zm0 288C50.1 288 0 338.1 0 400s50.1 112 112 112 112-50.1 112-112l-32.8 0-17.7 17.7c-7.7 26.8-32.3 46.3-61.5 46.3-35.3 0-64-28.7-64-64 0-29.2 19.6-53.9 46.3-61.5l17.7-17.7 0-32.8zM318.1 160l-124.1 0c-51.3-51.3-78.6-78.6-81.9-81.9L78.1 112c3.3 3.3 30.6 30.6 81.9 81.9l0 124.1c-51.3 51.3-78.6 78.6-81.9 81.9L112 433.9c3.3-3.3 30.6-30.6 81.9-81.9l124.1 0c51.3 51.3 78.6 78.6 81.9 81.9L433.9 400c-3.3-3.3-30.6-30.6-81.9-81.9l0-124.1c51.3-51.3 78.6-78.6 81.9-81.9L400 78.1c-3.3 3.3-30.6 30.6-81.9 81.9z"]
};
var faText = {
  prefix: 'fass',
  iconName: 'text',
  icon: [384, 512, [], "f893", "M0 32l384 0 0 128-64 0 0-64-96 0 0 320 80 0 0 64-224 0 0-64 80 0 0-320-96 0 0 64-64 0 0-128z"]
};
var faSquareGuarani = {
  prefix: 'fass',
  iconName: 'square-guarani',
  icon: [448, 512, [], "e70e", "M448 32l-448 0 0 448 448 0 0-448zM208 112l32 0 0 25.1c26.3 3.5 50 15.6 68 33.2l-33.6 34.3c-9.4-9.2-21.2-15.8-34.4-18.8l0 46.2 104 0 0 24c0 60.8-45.3 111.1-104 118.9l0 25.1-32 0 0-25.1c-58.7-7.8-104-58.1-104-118.9s45.3-111.1 104-118.9l0-25.1zM152 256c0 34.3 23.9 62.9 56 70.2l0-140.4c-32.1 7.3-56 36-56 70.2zm139.9 24l-51.9 0 0 46.2c24.2-5.5 43.8-23.2 51.9-46.2z"]
};
var faToiletPaperUnderSlash = {
  prefix: 'fass',
  iconName: 'toilet-paper-under-slash',
  icon: [576, 512, ["toilet-paper-reverse-slash"], "e2a1", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-11.3-11.3-22.7-22.7-34.1-34.1l0-254c0-106-43-192-96-192s-96 86-96 192c0 24 2.2 47 6.2 68.2l-54-54c-.2-4.7-.2-9.4-.2-14.2 0-58.9 11.8-114.5 33.2-157.2 5.8-11.7 13.1-23.7 21.9-34.8L128.1 32c-8.3 0-16.3 2.1-23.9 6L49.3-16.9zM394.3 464l-234.2 0 0 80 314.2 0-80-80zm-48-48L48.1 117.8c-10.1 30.4-16 66.9-16 106.2 0 106 43 192 96 192l218.2 0zm69.8-192c0-35.3 14.3-64 32-64s32 28.7 32 64-14.3 64-32 64-32-28.7-32-64z"]
};
var faToiletPaperReverseSlash = faToiletPaperUnderSlash;
var faHandPointUp = {
  prefix: 'fass',
  iconName: 'hand-point-up',
  icon: [384, 512, [9757], "f0a6", "M32 0l64 0 0 240-64 0 0-240zM224 160l64 0 0 128-64 0 0-128zm-32-32l0 112-64 0 0-112 64 0zm128 64l64 0 0 128-64 0 0-128zM0 363l0-91 192 0 0 80-112 0 0 32 144 0 0-64 64 0 0 32 96 0c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363z"]
};
var faPenSlash = {
  prefix: 'fass',
  iconName: 'pen-slash',
  icon: [576, 512, [], "e213", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-184.1-184.1 62-62-144-144-62 62-183.9-183.9zM165.2 234.9l-93.1 93.1-56 200 200-56 93.1-93.1-144-144zM473.1 215l87-87-144-144-87 87 144 144z"]
};
var faCommentPlus = {
  prefix: 'fass',
  iconName: 'comment-plus',
  icon: [512, 512, [], "f4b2", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM232 350.4l48 0 0-86.4 86.4 0 0-48-86.4 0 0-86.4-48 0 0 86.4-86.4 0 0 48 86.4 0 0 86.4z"]
};
var faBezierCurve = {
  prefix: 'fass',
  iconName: 'bezier-curve',
  icon: [640, 512, [], "f55b", "M344 88l0 48-48 0 0-48 48 0zM296 32l-56 0 0 52-118.4 0C111.2 62.7 89.3 48 64 48 28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36l66.9 0c-58.9 39.6-98.9 105-104 180l-52.5 0 0 160 160 0 0-160-51.3 0c5.6-63.8 44.6-118.1 99.3-145.3l0 17.3 160 0 0-17.3c54.7 27.2 93.7 81.5 99.3 145.3l-51.3 0 0 160 160 0 0-160-52.5 0c-5-75-45.1-140.4-104-180l66.9 0c10.4 21.3 32.3 36 57.6 36 35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36l-118.4 0 0-52-104 0zM136 376l0 48-48 0 0-48 48 0zm368 0l48 0 0 48-48 0 0-48z"]
};
var faClipboardListCheck = {
  prefix: 'fass',
  iconName: 'clipboard-list-check',
  icon: [384, 512, [], "f737", "M320 0l-256 0 0 32-64 0 0 480 384 0 0-480-64 0 0-32zM112 112l0-48 160 0 0 48-160 0zm58.1 101.2c-2.5 3.1-21.7 26.7-57.4 70.9l-3.2 3.9-23.5 0-3.2-4c-18.7-23.4-31-38.8-36.9-46.1l30-24c8.3 10.4 15.7 19.6 22 27.5 23.3-28.7 37.4-46.2 42.4-52.4l29.8 24.2zM192 232l128 0 0 48-128 0 0-48zM176 360l144 0 0 48-144 0 0-48zM64 352l64 0 0 64-64 0 0-64z"]
};
var faLampDesk = {
  prefix: 'fass',
  iconName: 'lamp-desk',
  icon: [512, 512, [], "e014", "M213.7 117.7L208 112c-26.5-26.5-26.5-69.5 0-96s69.5-26.5 96 0l48 48 112 0 48 48-208 208-48-48 0-105.7-92.7 98.9 45.7 182.8 175 0 0 64-199.3 0c-.5 0-.9 0-1.4 0l-183.3 0 0-64 143 0-46.1-184.2-4.2-16.9 11.9-12.7 109.1-116.4z"]
};
var faPersonHalfDress = {
  prefix: 'fass',
  iconName: 'person-half-dress',
  icon: [384, 512, [], "e548", "M248.2 24c0-30.9-25.1-56-56-56-3 0-5.9 .2-8.8 .7-26.8 4.2-47.2 27.4-47.2 55.3 0 30.9 25.1 56 56 56 3.5 0 7.3-.3 11.3-1.1 25.5-5.2 44.7-27.8 44.7-54.9zm-40 88l0 224 0 0 0 208 64 0 0-305.7c28.6 39.4 47.6 65.6 56.9 78.4l51.8-37.6c-.2-.2-37.4-51.6-111.7-153.9l-9.6-13.2-51.4 0zm-32 272l0-272-51.4 0-9.6 13.2-92.9 128-18.8 25.9 51.8 37.6c9.1-12.6 28.5-39.2 57.9-79.8l-49 147.1 48 0 0 160 64 0 0-160 0 0z"]
};
var faPeanut = {
  prefix: 'fass',
  iconName: 'peanut',
  icon: [512, 512, [], "e430", "M0 512L0 362.9C0 315.5 21.1 270.4 57.6 240l5.1-4.2c21.8-18.2 48.1-30.2 76.1-34.9l53.2-8.9 6.7-40.4c6-36.2 23.2-69.6 49.2-95.5l4.6-4.6C285.5 18.5 330.2 0 376.9 0L512 0 512 135.1c0 46.7-18.5 91.4-51.5 124.5l-4.6 4.6c-25.9 25.9-59.3 43.1-95.5 49.2l-40.4 6.7-7.6 45.4c-5.5 32.9-21.1 63.3-44.7 86.8l-12.9 12.9c-30 30-70.7 46.9-113.1 46.9L0 512zM435.2 128a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm0 64a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm-64 0a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm-224 224a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zM192 435.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0-64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4z"]
};
var faMessagePlus = {
  prefix: 'fass',
  iconName: 'message-plus',
  icon: [512, 512, ["comment-alt-plus"], "f4a8", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM232 350.4l0-86.4-86.4 0 0-48 86.4 0 0-86.4 48 0 0 86.4 86.4 0 0 48-86.4 0 0 86.4-48 0z"]
};
var faCommentAltPlus = faMessagePlus;
var faBracketCurly = {
  prefix: 'fass',
  iconName: 'bracket-curly',
  icon: [256, 512, ["bracket-curly-left"], "7b", "M96 32l-32 0 0 146.7-54.6 54.6-9.4 9.4 0 26.5 9.4 9.4 54.6 54.6 0 146.7 160 0 0-64-96 0 0-109.3c-.9-.9-17.8-17.8-50.7-50.7 32.9-32.9 49.8-49.8 50.7-50.7l0-109.3 96 0 0-64-128 0z"]
};
var faBracketCurlyLeft = faBracketCurly;
var faSquarePollHorizontal = {
  prefix: 'fass',
  iconName: 'square-poll-horizontal',
  icon: [448, 512, ["poll-h"], "f682", "M448 480l0-448-448 0 0 448 448 0zM256 176l-160 0 0-48 160 0 0 48zm96 56l0 48-256 0 0-48 256 0zM192 384l-96 0 0-48 96 0 0 48z"]
};
var faPollH = faSquarePollHorizontal;
var faNfcSignal = {
  prefix: 'fass',
  iconName: 'nfc-signal',
  icon: [576, 512, [], "e1fb", "M32 32l448 0 0 217c-22.6 5.9-44 14.6-64 25.6l0-178.6-184 0 0 118.4c-14.3 8.3-24 23.8-24 41.6 0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.8-9.7-33.3-24-41.6l0-70.4 88 0 0 164.2c-20 17.3-37.4 37.5-51.8 59.8l-172.2 0 0-224 40 0 0-48-88 0 0 320 195.5 0c-8 20.3-13.8 41.7-16.9 64L32 480 32 32zM552 288l24 0 0 48-24 0c-101.6 0-184 82.4-184 184l0 24-48 0 0-24c0-128.1 103.9-232 232-232zm-8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-96l0 48-24 0c-48.6 0-88 39.4-88 88l0 24-48 0 0-24c0-75.1 60.9-136 136-136l24 0z"]
};
var faBoxIsometric = {
  prefix: 'fass',
  iconName: 'box-isometric',
  icon: [512, 512, [], "e797", "M256 65.6L413.8 155 361.2 183.3 205.3 94.3 256 65.6zm-99.2 56.2l154.6 88.4-55.4 29.8-157.8-85 58.6-33.2zM256 536L496 400 496 128 256-8 16 128 16 400 256 536z"]
};
var faSchoolCircleXmark = {
  prefix: 'fass',
  iconName: 'school-circle-xmark',
  icon: [640, 512, [], "e56d", "M128 128l-128 0 0 384 340 0c-10.5-14.6-19-30.7-25.1-48l-90.9 0 0-128 90.9 0c26.4-74.6 97.5-128 181.1-128 28.6 0 55.6 6.2 80 17.4l0-97.4-128 0-160-128-160 128zm0 256l-64 0 0-64 64 0 0 64zM64 256l0-64 64 0 0 64-64 0zM288 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm55.3-176.7L518.6 400c25.4 25.3 40 40 44 44L540 466.6c-4-4-18.6-18.6-44-44-25.3 25.4-40 40-44 44L429.4 444c4-4 18.6-18.6 44-44-25.4-25.3-40-40-44-44L452 333.4c4 4 18.6 18.6 44 44 25.3-25.4 40-40 44-44l22.6 22.6-11.3 11.3z"]
};
var faPersonSeatWindow = {
  prefix: 'fass',
  iconName: 'person-seat-window',
  icon: [512, 512, [], "e788", "M176 128a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-16 48l-32 0 0 144c0 35.3 28.7 64 64 64l96 0 0 128 112 0 0-64-48 0 0-128-120 0 0-144-72 0zM80 160l-64 0 0 336 224 0 0-64-160 0 0-272zM480 32l-160 0 0 224 160 0 0-224z"]
};
var faGrapes = {
  prefix: 'fass',
  iconName: 'grapes',
  icon: [576, 512, [], "e306", "M400-16L423.4 7.4c31.2 31.2 31.2 81.9 0 113.1 31.2-31.2 81.9-31.2 113.1 0L560 144 536.6 167.4c-31.2 31.2-81.9 31.2-113.1 0l-46.9-46.9c-31.2-31.2-31.2-81.9 0-113.1L400-16zM224 152a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-80-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM64 312a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM32 456a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144-32a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm192-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM200 288a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm192-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faHandLizard = {
  prefix: 'fass',
  iconName: 'hand-lizard',
  icon: [512, 512, [], "f258", "M0 64l345.1 0 14.3 20.7 144 208 8.5 12.3 0 143-160 0 0-45.8-78.1-50.2-209.9 0 0-96 176 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L0 160 0 64z"]
};
var faCameraSlash = {
  prefix: 'fass',
  iconName: 'camera-slash',
  icon: [576, 512, [], "e0d9", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-11.3-11.3-22.7-22.7-34.1-34.1l0-382-128 0-32-64-192 0-31.3 62.6-111.5-111.5zM261.8 195.6c8.4-2.4 17.2-3.7 26.3-3.7 53 0 96 43 96 96 0 9.1-1.3 18-3.7 26.3L261.8 195.6zM192.1 288c0-8 1-15.9 2.9-23.3l-162.9-162.9 0 378.2 378.2 0-98.9-98.9c-7.5 1.9-15.3 2.9-23.3 2.9-53 0-96-43-96-96z"]
};
var faChalkboard = {
  prefix: 'fass',
  iconName: 'chalkboard',
  icon: [576, 512, ["blackboard"], "f51b", "M64 64l-32 0 0 320-32 0 0 64 576 0 0-64-32 0 0-320-480 0zM480 384l-64 0 0-64-192 0 0 64-128 0 0-256 384 0 0 256z"]
};
var faBlackboard = faChalkboard;
var faMemoPad = {
  prefix: 'fass',
  iconName: 'memo-pad',
  icon: [384, 512, [], "e1da", "M384 0L0 0 0 96 384 96 384 0zm0 144l-384 0 0 368 384 0 0-368zM104 192l200 0 0 48-224 0 0-48 24 0zm0 96l200 0 0 48-224 0 0-48 24 0zm0 96l120 0 0 48-144 0 0-48 24 0z"]
};
var faBluetooth = {
  prefix: 'fass',
  iconName: 'bluetooth',
  icon: [384, 512, [], "f293", "M160.3 0c21.3 16 81.1 60.8 179.2 134.4L373.7 160c-12.8 9.6-55.5 41.6-128 96 72.5 54.4 115.2 86.4 128 96-7.1 5.3-61.2 45.9-162.1 121.6l-51.2 38.4 0-192c-59.7 44.8-93.9 70.4-102.4 76.8L19.5 345.6c5.7-4.3 45.5-34.1 119.5-89.6-74-55.5-113.8-85.3-119.5-89.6l38.4-51.2c8.5 6.4 42.7 32 102.4 76.8l0-192zm64 320l0 64 42.7-32-42.7-32zm0-128l42.7-32-42.7-32 0 64z"]
};
var faObjectsAlignCenterHorizontal = {
  prefix: 'fass',
  iconName: 'objects-align-center-horizontal',
  icon: [448, 512, [], "e3bc", "M256 64l0-96-64 0 0 96-192 0 0 160 192 0 0 64-128 0 0 160 128 0 0 96 64 0 0-96 128 0 0-160-128 0 0-64 192 0 0-160-192 0z"]
};
var faDistributeSpacingVertical = {
  prefix: 'fass',
  iconName: 'distribute-spacing-vertical',
  icon: [512, 512, [], "e366", "M0 32l512 0 0 64-512 0 0-64zM96 160l320 0 0 192-320 0 0-192zM512 416l0 64-512 0 0-64 512 0z"]
};
var faUpRightFromSquare = {
  prefix: 'fass',
  iconName: 'up-right-from-square',
  icon: [512, 512, ["external-link-alt"], "f35d", "M270.1 0l241.9 0 0 241.9-98.3-98.3-167 167-22.6 22.6-45.3-45.3 22.6-22.6 167-167-98.3-98.3zM0 96l192 0 0 64-128 0 0 288 288 0 0-128 64 0 0 192-416 0 0-416z"]
};
var faExternalLinkAlt = faUpRightFromSquare;
var faSquareTurkishLira = {
  prefix: 'fass',
  iconName: 'square-turkish-lira',
  icon: [448, 512, [], "e71f", "M448 32l-448 0 0 448 448 0 0-448zM208 128l0 68.5c46.6-15.5 71.3-23.8 74.1-24.7l10.1 30.4c-1.1 .4-29.2 9.7-84.2 28.1l0 30.3c46.6-15.5 71.3-23.8 74.1-24.7l10.1 30.4c-1.1 .4-29.2 9.7-84.2 28.1l0 41.8 48 0c26.5 0 48-21.5 48-48l0-24 48 0 0 24c0 53-43 96-96 96l-96 0 0-73.8c-19.9 6.6-34 11.3-42.1 14l-10.1-30.4c6.5-2.2 23.9-8 52.2-17.4l0-30.3c-19.9 6.6-34 11.3-42.1 14l-10.1-30.4c6.5-2.2 23.9-8 52.2-17.4l0-84.5 48 0z"]
};
var faRotateExclamation = {
  prefix: 'fass',
  iconName: 'rotate-exclamation',
  icon: [512, 512, [], "e23c", "M512.2 256c0 65.5-25 131-75 181s-115.6 75-181 75c-69.9 0-137-27.8-186.5-77.3l-4.8-4.8c.3 35.3 .5 62.2 .7 80.8l-64 .5-.2-32-1.1-127-.2-32.2 176.2 0 0 64-66.7 0 5.5 5.5c37.5 37.5 88.3 58.5 141.2 58.5 49.2 0 98.3-18.8 135.8-56.2s56.2-86.6 56.2-135.8l64 0zm-228 124l-56 0 0-56 56 0 0 56zm-8.8-92l-38.4 0-12.8-160 64 0-12.8 160zM512.2 0l0 192-176 0 0-64 66.8 0-5.5-5.5C360.1 85 309.2 64 256.2 64 207.1 64 158 82.8 120.5 120.2S64.2 206.8 64.2 256l-64 0c0-65.5 25-131.1 75-181 50-50 115.5-75 181-75 70 0 137.1 27.8 186.5 77.2l5.5 5.5 0-82.8 64 0z"]
};
var faRightFromLine = {
  prefix: 'fass',
  iconName: 'right-from-line',
  icon: [576, 512, ["arrow-alt-from-left"], "f347", "M96.5 64l0 384-64 0 0-384 64 0zm459 192l-18.5 17.4c-113.3 107-174.7 165-184.5 174.2l0-127.7-192 0 0-128 192 0 0-127.7c9.7 9.2 71.2 67.3 184.5 174.2L555.4 256z"]
};
var faArrowAltFromLeft = faRightFromLine;
var faCircleQ = {
  prefix: 'fass',
  iconName: 'circle-q',
  icon: [512, 512, [], "e11e", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM184 256c0 39.8 32.2 72 72 72 11.1 0 21.6-2.5 31-7-18.7-18.7-33-33-42.8-42.8l33.9-33.9c9.8 9.8 24.1 24.1 42.8 42.8 4.5-9.4 7-19.9 7-31 0-39.8-32.2-72-72-72s-72 32.2-72 72zm192 0c0 24.5-7.3 47.2-19.9 66.2 7.9 7.9 17.8 17.8 29.8 29.8L352 385.9c-12-12-21.9-21.9-29.8-29.8-19 12.6-41.7 19.9-66.2 19.9-66.3 0-120-53.7-120-120s53.7-120 120-120 120 53.7 120 120z"]
};
var faMoonOverSun = {
  prefix: 'fass',
  iconName: 'moon-over-sun',
  icon: [576, 512, ["eclipse-alt"], "f74a", "M173.8-20.2c10.6 7.1 48.8 32.4 114.4 75.9 65.6-43.5 103.8-68.8 114.4-75.9 2.5 12.5 11.6 57.4 27.2 134.6 77.2 15.6 122.1 24.7 134.6 27.2-7.1 10.6-32.4 48.8-75.9 114.4 43.5 65.6 68.8 103.8 75.9 114.4-12.5 2.5-57.4 11.6-134.6 27.2-15.6 77.2-24.7 122.1-27.2 134.6-10.6-7.1-48.8-32.4-114.4-75.9-65.6 43.5-103.8 68.8-114.4 75.9-2.5-12.5-11.6-57.4-27.2-134.6-77.2-15.6-122.1-24.7-134.6-27.2 7.1-10.6 32.4-48.8 75.9-114.4-43.5-65.6-68.8-103.8-75.9-114.4 12.5-2.5 57.4-11.6 134.6-27.2 15.6-77.2 24.7-122.1 27.2-134.6zM432.2 256a144.2 144.2 0 1 0 -288.5 0 144.2 144.2 0 1 0 288.5 0zm-144-24c0 39.8 32.2 72 72 72 4 0 7.9-.3 11.7-.9-16.5 29.2-47.8 48.9-83.7 48.9-53 0-96-43-96-96s43-96 96-96c13.8 0 26.9 2.9 38.7 8.1-23 12-38.7 36.1-38.7 63.9z"]
};
var faEclipseAlt = faMoonOverSun;
var fa360Degrees = {
  prefix: 'fass',
  iconName: '360-degrees',
  icon: [640, 512, [], "e2dc", "M640 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 128l32 0 0-64-32 0c-53 0-96 43-96 96l0 111.8 0 .2 0 96c0 44.2 35.8 80 80 80s80-35.8 80-80l0-96c0-44.2-35.8-80-80-80-5.5 0-10.8 .6-16 1.6l0-33.6c0-17.7 14.3-32 32-32zM288 320l0-48.1c0-8.8 7.2-15.9 16-15.9 8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zM32 64l-32 0 0 64 97.3 0-57.6 67.2-7.7 9 0 51.8 48 0c26.5 0 48 21.5 48 48l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 352c0 53 43 96 96 96s96-43 96-96l0-48c0-47.6-29.8-88.3-71.7-104.5l64-74.6 7.7-9 0-51.8-160 0zm448 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm16-80c-44.2 0-80 35.8-80 80l0 224c0 44.2 35.8 80 80 80s80-35.8 80-80l0-224c0-44.2-35.8-80-80-80z"]
};
var faBracketRoundRight = {
  prefix: 'fass',
  iconName: 'bracket-round-right',
  icon: [192, 512, [], "29", "M192 256C192 140.2 120.1 62.9 81.8 37.4L46.3 90.6C71.9 107.7 128 167 128 256S71.9 404.3 46.3 421.4l35.5 53.3C120.1 449 192 371.8 192 256z"]
};
var faSquareFull = {
  prefix: 'fass',
  iconName: 'square-full',
  icon: [512, 512, [128997, 128998, 128999, 129000, 129001, 129002, 129003, 11035, 11036], "f45c", "M0 0L512 0 512 512 0 512 0 0z"]
};
var faStarSharp = {
  prefix: 'fass',
  iconName: 'star-sharp',
  icon: [576, 512, [], "e28b", "M311.3 32.7L288.4-39.2C277.2-3.8 254 69.2 218.8 179.9l-216.3 0c25.9 20.1 84.6 65.8 176.1 136.9-35.3 111-58.8 184.9-70.5 221.6 31-24.1 91.1-70.9 180.4-140.3 89.3 69.4 149.4 116.2 180.4 140.3-11.7-36.8-35.2-110.7-70.5-221.6 91.5-71.2 150.2-116.8 176.1-136.9l-216.3 0-46.8-147.1z"]
};
var faListRadio = {
  prefix: 'fass',
  iconName: 'list-radio',
  icon: [512, 512, [], "e1d0", "M64 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM224 64l-32 0 0 64 320 0 0-64-288 0zm0 160l-32 0 0 64 320 0 0-64-288 0zm0 160l-32 0 0 64 320 0 0-64-288 0zM40 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faHeadSideMedical = {
  prefix: 'fass',
  iconName: 'head-side-medical',
  icon: [512, 512, [], "f809", "M224 0C338.4 0 432.7 85.7 446.3 196.4l49.7 59.6 0 64-64 0 0 128-112 0 0 64-256 0 0-131.2C24.4 340.4 0 285 0 224 0 100.3 100.3 0 224 0zM192 192l-56 0 0 64 56 0 0 56 64 0 0-56 56 0 0-64-56 0 0-56-64 0 0 56z"]
};
var faTombstone = {
  prefix: 'fass',
  iconName: 'tombstone',
  icon: [448, 512, [], "f720", "M32 192C32 86 118 0 224 0S416 86 416 192l0 256 32 0 0 64-448 0 0-64 32 0 0-256zm216-72l0-24-48 0 0 64-72 0 0 48 72 0 0 144 48 0 0-144 72 0 0-48-72 0 0-40z"]
};
var faSquareALock = {
  prefix: 'fass',
  iconName: 'square-a-lock',
  icon: [576, 512, [], "e44d", "M480 32l-448 0 0 448 272 0 0-144-102 0-15.4 32-53.2 0 5-10.4 96-200 6.5-13.6 30.2 0 6.5 13.6 54.9 114.4 3.5 0c0-70.7 57.3-128 128-128 5.4 0 10.8 .3 16 1l0-113zM256 223.5l-31 64.5 62 0-31-64.5zM464 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faClover = {
  prefix: 'fass',
  iconName: 'clover',
  icon: [512, 512, [], "e139", "M145.6 117.7l41.9 69.8-69.8-41.9c-10.4-6.3-22.4-9.6-34.5-9.6-37.1 0-67.1 30.1-67.1 67.1l0 18.6 34.3 34.3-34.3 34.3 0 18.6c0 37.1 30.1 67.1 67.1 67.1 12.2 0 24.1-3.3 34.5-9.6l69.8-41.9-41.9 69.8c-6.3 10.4-9.6 22.4-9.6 34.5 0 37.1 30.1 67.1 67.1 67.1l18.6 0 34.3-34.3 34.3 34.3 18.6 0c37.1 0 67.1-30.1 67.1-67.1 0-12.2-3.3-24.1-9.6-34.5l-41.9-69.8 69.8 41.9c10.4 6.3 22.4 9.6 34.5 9.6 37.1 0 67.1-30.1 67.1-67.1l0-18.6-34.3-34.3 34.3-34.3 0-18.6c0-37.1-30.1-67.1-67.1-67.1-12.2 0-24.1 3.3-34.5 9.6l-69.8 41.9 41.9-69.8c6.3-10.4 9.6-22.4 9.6-34.5 0-37.1-30.1-67.1-67.1-67.1l-18.6 0-34.3 34.3-34.3-34.3-18.6 0c-37.1 0-67.1 30.1-67.1 67.1 0 12.2 3.3 24.1 9.6 34.5z"]
};
var faSignalBarsFair = {
  prefix: 'fass',
  iconName: 'signal-bars-fair',
  icon: [448, 512, ["signal-alt-2"], "f692", "M192 288l0-32-64 0 0 224 64 0 0-192zM64 416l0-32-64 0 0 96 64 0 0-64z"]
};
var faSignalAlt2 = faSignalBarsFair;
var faFolderHeart = {
  prefix: 'fass',
  iconName: 'folder-heart',
  icon: [512, 512, [], "e189", "M512 448l-512 0 0-416 224 0 64 48 224 0 0 368zM249.6 199.5c-11.1-14.8-28.5-23.5-46.9-23.5-32.4 0-58.7 26.3-58.7 58.7l0 5.3c0 64 112 128 112 128s112-64 112-128l0-5.3c0-32.4-26.3-58.7-58.7-58.7-18.5 0-35.9 8.7-46.9 23.5l-6.4 8.5-6.4-8.5z"]
};
var faCloudWord = {
  prefix: 'fass',
  iconName: 'cloud-word',
  icon: [576, 512, [], "e138", "M448 480L0 480 0 336c0-62.7 40.1-116 96-135.8L96 176c0-79.5 64.5-144 144-144 55.4 0 103.5 31.3 127.6 77.1 14.2-8.3 30.8-13.1 48.4-13.1 53 0 96 43 96 96l0 49.1c38.3 22.1 64 63.5 64 110.9l0 128-128 0zM240 336l-80 0 0 48 80 0 0-48zm120-80l-24 0 0 48 80 0 0-48-56 0zm56 80l-128 0 0 48 128 0 0-48zM184 256l-24 0 0 48 128 0 0-48-104 0z"]
};
var faScreenUsers = {
  prefix: 'fass',
  iconName: 'screen-users',
  icon: [640, 512, ["users-class"], "f63d", "M64 0l512 0 0 212.6c-10.1-3-20.9-4.6-32-4.6s-21.9 1.6-32 4.6l0-148.6-384 0 0 148.6c-10.1-3-20.9-4.6-32-4.6s-21.9 1.6-32 4.6L64 0zM32 320a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm224 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm288-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM416 512l-192 0 32-96 128 0 32 96zM32 416l128 0 32 96-192 0 32-96zm608 96l-192 0 32-96 128 0 32 96z"]
};
var faUsersClass = faScreenUsers;
var faTeethOpen = {
  prefix: 'fass',
  iconName: 'teeth-open',
  icon: [512, 512, [], "f62f", "M512 32l-512 0 0 208 512 0 0-208zm0 272l-512 0 0 176 512 0 0-176zM144 144c0-26.5 21.5-48 48-48s48 21.5 48 48l0 48-96 0 0-48zm128 0c0-26.5 21.5-48 48-48s48 21.5 48 48l0 48-96 0 0-48zM80 112c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm320 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48-64 0 0-48zM48 384l0-32 64 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32zm144 48c-26.5 0-48-21.5-48-48l0-32 96 0 0 32c0 26.5-21.5 48-48 48zm128 0c-26.5 0-48-21.5-48-48l0-32 96 0 0 32c0 26.5-21.5 48-48 48zm112-16c-17.7 0-32-14.3-32-32l0-32 64 0 0 32c0 17.7-14.3 32-32 32z"]
};
var faCircleU = {
  prefix: 'fass',
  iconName: 'circle-u',
  icon: [512, 512, [], "e127", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM208 168l0 104c0 26.5 21.5 48 48 48s48-21.5 48-48l0-128 48 0 0 128c0 53-43 96-96 96s-96-43-96-96l0-128 48 0 0 24z"]
};
var faCalendarHeart = {
  prefix: 'fass',
  iconName: 'calendar-heart',
  icon: [448, 512, [], "e0d3", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0zm57.6 215.5c-11.1-14.8-28.5-23.5-46.9-23.5-32.4 0-58.7 26.3-58.7 58.7l0 5.3c0 64 112 128 112 128s112-64 112-128l0-5.3c0-32.4-26.3-58.7-58.7-58.7-18.5 0-35.9 8.7-46.9 23.5l-6.4 8.5-6.4-8.5z"]
};
var faNarwhal = {
  prefix: 'fass',
  iconName: 'narwhal',
  icon: [640, 512, [], "f6fe", "M640 336c0-49-20.2-93.2-52.7-125.2L640 0 511.7 166.8c-15.5-4.4-31.8-6.8-48.6-6.8-50.9 0-100.7 17.5-140.2 49.6l-194.9 158.4 0-112 64-32 0-128-96 48-96-48 0 128 64 32 0 96c0 88.4 71.6 160 160 160l240 0c97.2 0 176-78.8 176-176zM496 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faBarsStaggered = {
  prefix: 'fass',
  iconName: 'bars-staggered',
  icon: [512, 512, ["reorder", "stream"], "f550", "M0 64l448 0 0 64-448 0 0-64zM64 224l448 0 0 64-448 0 0-64zM448 384l0 64-448 0 0-64 448 0z"]
};
var faReorder = faBarsStaggered;
var faStream = faBarsStaggered;
var faWarehouse = {
  prefix: 'fass',
  iconName: 'warehouse',
  icon: [576, 512, [], "f494", "M0 96l0 416 64 0 0-304 448 0 0 304 64 0 0-416-288-96-288 96zM464 320l0-64-352 0 0 64 352 0zM112 416l352 0 0-64-352 0 0 64zm352 96l0-64-352 0 0 64 352 0z"]
};
var faSwatchbook = {
  prefix: 'fass',
  iconName: 'swatchbook',
  icon: [512, 512, [], "f5c3", "M0 416c0 53 43 96 96 96s96-43 96-96L192 0 0 0 0 416zM128 64l0 64-64 0 0-64 64 0zm0 128l0 64-64 0 0-64 64 0zM72 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm109 96l331 0 0-192-139 0-192 192zM458 189.7L322.3 54 224 152.2 224 423.8 458 189.7z"]
};
var faCircleThreeQuarters = {
  prefix: 'fass',
  iconName: 'circle-three-quarters',
  icon: [512, 512, [], "e125", "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512 512 397.4 512 256l-256 0 0-256z"]
};
var faCircleChf = {
  prefix: 'fass',
  iconName: 'circle-chf',
  icon: [512, 512, [], "e72c", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM136 144c22.1 0 40 17.9 40 40l0 32-32 0 0 80 32 0 0 32c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-144c0-22.1 17.9-40 40-40zm104 24l0 64 16 0 0-88 48 0 0 224-48 0 0-88-16 0 0 88-48 0 0-224 48 0 0 24zm104-24l72 0 0 48-48 0 0 40 40 0 0 48-40 0 0 88-48 0 0-224 24 0z"]
};
var faCampground = {
  prefix: 'fass',
  iconName: 'campground',
  icon: [512, 512, [9978], "f6bb", "M344.8 52.3L365 27.5 315.5-13C305.1-.4 285.3 23.9 256 59.7 226.7 23.9 206.9-.4 196.5-13L147 27.5c9 11 31.5 38.6 67.7 82.7l-207.4 253.5-7.2 8.8 0 107.4 512 0 0-107.4-7.2-8.8-207.4-253.5 47.4-58zM256 288l112 128-224 0 112-128z"]
};
var faPersonWalkingArrowRight = {
  prefix: 'fass',
  iconName: 'person-walking-arrow-right',
  icon: [640, 512, [], "e552", "M248.4 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm-104 88l-13.3 0-9.4 9.4-80 80-9.4 9.4 0 109.3 64 0 0-82.7 32-32 0 69.3c0 28 12.2 54.7 33.5 72.9l80.7 69.1c11 71.6 17.4 112.9 19.1 123.9l63.3-9.7c-1.4-9-8.3-54.2-20.9-135.6l-1.8-11.7-9-7.7-52.8-45.3 0-115.2c17.6 22 28.4 35.6 32.6 40.8l111.4 0 0-64-80.6 0-54.4-68-9.6-12-95.4 0zM128.6 371L116 415.2C71.3 459.9 44.4 486.8 35.2 496l45.3 45.3 86.6-86.6 5.9-5.9c.8-2.7 3.8-13.2 9-31.5l-46-39.4c-2.5-2.2-5-4.4-7.4-6.8zM609.4 273l17-17c-2.1-2.1-31.8-31.8-89-89l-17-17-33.9 33.9c9 9 25 25 48 48l-126.1 0 0 48 126.1 0c-23 23-39 39-48 48l33.9 33.9c2.1-2.1 31.8-31.8 89-89z"]
};
var faSpiderBlackWidow = {
  prefix: 'fass',
  iconName: 'spider-black-widow',
  icon: [512, 512, [], "f718", "M398.5 22.8l40 96 6.2 14.8-75.5 75.4 76.4-20.8c15.4-46.1 24.5-73.6 27.5-82.6l45.5 15.2-7.6 22.8-28.1 84.2-12.4 3.4-91.2 24.8 91.2 24.9 12.4 3.4 28.1 84.2 7.6 22.8-45.5 15.2c-3-9-12.2-36.5-27.5-82.6l-76.4-20.8 75.5 75.5-6.2 14.8-40 96-9.2 22.2-44.3-18.4 9.2-22.2 33.8-81.2-35.8-35.8c-1 52.2-43.5 94.1-95.9 94.1s-95-42-96-94.1l-35.7 35.8 33.8 81.2 9.2 22.2-44.3 18.4-9.2-22.2-40-96-6.2-14.8 75.4-75.5-76.3 20.8c-15.4 46.1-24.5 73.6-27.5 82.6l-45.5-15.2 7.6-22.8 28.1-84.2 12.4-3.4 91.1-24.9-91.1-24.8-12.4-3.4-28.1-84.2-7.6-22.8 45.5-15.2c3 9 12.2 36.5 27.5 82.6l76.4 20.8-75.4-75.4 6.2-14.8 40-96 9.2-22.2 44.3 18.4-9.2 22.2-33.8 81.2 51.7 51.8c1-43.3 36.4-78.1 79.9-78.1s78.9 34.8 79.9 78.1l51.8-51.8-33.8-81.2-9.2-22.2 44.3-18.4 9.2 22.2zM216.3 288l24 40-24 40 80 0-24-40 24-40-80 0z"]
};
var faGlasses = {
  prefix: 'fass',
  iconName: 'glasses',
  icon: [576, 512, [], "f530", "M72.4 32l103.6 0 0 64-56.4 0-49.2 160 185.6 0 0 32 64 0 0-32 185.6 0-49.2-160-56.4 0 0-64 103.6 0 7 22.6 64 208 1.4 4.6 0 212.8-256 0 0-128-64 0 0 128-256 0 0-212.8 1.4-4.6 64-208 7-22.6zM64 320l0 96 128 0 0-96-128 0zm320 0l0 96 128 0 0-96-128 0z"]
};
var faCirclePause = {
  prefix: 'fass',
  iconName: 'circle-pause',
  icon: [512, 512, [62092, "pause-circle"], "f28b", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM224 192l0 160-64 0 0-192 64 0 0 32zm128 0l0 160-64 0 0-192 64 0 0 32z"]
};
var faPauseCircle = faCirclePause;
var faMemory = {
  prefix: 'fass',
  iconName: 'memory',
  icon: [512, 512, [], "f538", "M512 64L0 64 0 146.7c18.6 6.6 32 24.4 32 45.3S18.6 230.7 0 237.3l0 66.7 512 0 0-66.7c-18.6-6.6-32-24.4-32-45.3s13.4-38.7 32-45.3L512 64zm0 288l-512 0 0 96 96 0 0-48 48 0 0 48 88 0 0-48 48 0 0 48 88 0 0-48 48 0 0 48 96 0 0-96zM160 160l0 96-64 0 0-128 64 0 0 32zm128 0l0 96-64 0 0-128 64 0 0 32zm128 0l0 96-64 0 0-128 64 0 0 32z"]
};
var faGift = {
  prefix: 'fass',
  iconName: 'gift',
  icon: [512, 512, [127873], "f06b", "M321.5 68.8C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-73.3 0 34.8-59.2zm-131 0l34.8 59.2-73.3 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zm89.6-24.3l-24.1 41-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0c-48.6 0-88 39.4-88 88 0 14.4 3.5 28 9.6 40l-73.6 0 0 96 512 0 0-96-73.6 0c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4zM480 272l-200 0 0 208 200 0 0-208zm-248 0l-200 0 0 208 200 0 0-208z"]
};
var faSprinklerCeiling = {
  prefix: 'fass',
  iconName: 'sprinkler-ceiling',
  icon: [384, 512, [], "e44c", "M0 0L0 122.2c4.4 .9 47.1 9.4 128 25.6L128 82.6 64 69.8 64 0 0 0zM256 82.6l0 65.3 128-25.6 0-122.2-64 0 0 69.8-64 12.8zM160 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-48 64c0-13.3-10.7-24-24-24s-24 10.7-24 24 10.7 24 24 24 24-10.7 24-24zM24 496c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zM272 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 88c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zm-32 40c0-13.3-10.7-24-24-24s-24 10.7-24 24 10.7 24 24 24 24-10.7 24-24zm136-40c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zm-24 40c0-13.3-10.7-24-24-24s-24 10.7-24 24 10.7 24 24 24 24-10.7 24-24zm88 24c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zM224 64l0-32-64 0 0 160-96 0 0 64 256 0 0-64-96 0 0-128z"]
};
var faSquarePhoneHangup = {
  prefix: 'fass',
  iconName: 'square-phone-hangup',
  icon: [448, 512, ["phone-square-down"], "e27a", "M448 32l-448 0 0 448 448 0 0-448zM88.2 317.2l-22.6-67.9 5.7-5.7c84.4-84.3 221.1-84.3 305.5 0l5.7 5.7-22.6 67.9-79.5-11 .3-56.8c-36.6-13.2-76.6-13.2-113.1 0l.3 56.8-79.5 11z"]
};
var faPhoneSquareDown = faSquarePhoneHangup;
var faMoneyBillWheat = {
  prefix: 'fass',
  iconName: 'money-bill-wheat',
  icon: [512, 512, [], "e52a", "M176-16c44.2 0 80 35.8 80 80l0 16-16 0c-44.2 0-80-35.8-80-80l0-16 16 0zM56 0l72 0 0 48-96 0 0-48 24 0zM24 72l136 0 0 48-160 0 0-48 24 0zm8 72l96 0 0 48-96 0 0-48zM272-16l16 0c44.2 0 80 35.8 80 80l0 16-16 0c-44.2 0-80-35.8-80-80l0-16zm128 0c44.2 0 80 35.8 80 80l0 16-16 0c-44.2 0-80-35.8-80-80l0-16 16 0zm80 128l0 16c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0zm-128 0l16 0 0 16c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80zm-96 0l0 16c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0zM0 512l0-256 512 0 0 256-512 0zm48-96l0 48 48 0c0-26.5-21.5-48-48-48zM96 304l-48 0 0 48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48l48 0 0-48zM416 304c0 26.5 21.5 48 48 48l0-48-48 0zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faCircleFlorin = {
  prefix: 'fass',
  iconName: 'circle-florin',
  icon: [512, 512, [], "e6e4", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm16.4-355.3c9.5-22.3 31.4-36.7 55.7-36.7l47.9 0 0 48-47.9 0c-5 0-9.6 3-11.6 7.6l-20.7 48.4 56.2 0 0 48-76.7 0-35.7 83.3C230 377.6 208.1 392 183.9 392l-47.9 0 0-48 47.9 0c5 0 9.6-3 11.6-7.6l27.6-64.4-63 0 0-48 83.6 0 28.8-67.3z"]
};
var faDungeon = {
  prefix: 'fass',
  iconName: 'dungeon',
  icon: [512, 512, [], "f6d9", "M379.8 182.3l95-59.4c-21.5-35.2-51.2-64.8-86.5-86.2l-62.2 93.4c22.2 12.4 40.7 30.4 53.7 52.2zM279.2 113.9l65.4-98.1C317 5.6 287.2 0 256 0s-61 5.6-88.6 15.8l65.4 98.1c7.6-1.2 15.3-1.9 23.2-1.9s15.7 .6 23.2 1.9zM123.7 36.8c-35.3 21.3-65 51-86.5 86.2l95 59.4c13-21.8 31.5-39.8 53.7-52.2L123.7 36.8zm-9 191.2L16.1 166.4C5.7 194.3 0 224.5 0 256l0 48 112 0 0-48c0-9.6 .9-18.9 2.7-28zM400 256l0 48 112 0 0-48c0-31.5-5.7-61.7-16.1-89.6L397.3 228c1.8 9.1 2.7 18.4 2.7 28zM0 352l0 160 112 0 0-160-112 0zm400 0l0 160 112 0 0-160-112 0zM280 184l0-24-48 0 0 352 48 0 0-328zm-80 48l0-24-48 0 0 304 48 0 0-280zm160 0l0-24-48 0 0 304 48 0 0-280z"]
};
var faComet = {
  prefix: 'fass',
  iconName: 'comet',
  icon: [512, 512, [], "e003", "M512 0L299.4 75.9 304 16 101.3 133.4C38.6 169.7 0 236.6 0 309 0 421.1 90.9 512 203 512 275.4 512 342.3 473.4 378.6 410.7L496 208 436.1 212.6 512 0zM231.6 275.8l88.4 12.7-64 61.5 15.1 86.8-79.1-41-79.1 41 15.1-86.8-64-61.5 88.4-12.7 39.6-79 39.6 79z"]
};
var faFaceHoldingBackTears = {
  prefix: 'fass',
  iconName: 'face-holding-back-tears',
  icon: [512, 512, [129401], "e482", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm240 20.7c5.1-11.2 8-23.6 8-36.7 0-42.2-29.8-77.5-69.5-86 6.8-9.3 12-19.8 15.2-31.3 .3-1.1 2.6-9.2 7-24.4l-38.5-11c-4.3 15.2-6.7 23.3-7 24.4-6.6 23.1-26.4 40.1-50.2 43.1-6.3 .8-16.8 2.1-31.4 3.9l5 39.7 4.1-.5c-6.9 12.5-10.8 26.9-10.8 42.2 0 23.4 9.1 44.6 24 60.4l0 51.6 32 0 0-30c9.9 3.9 20.7 6 32 6 17.7 0 34.2-5.2 48-14.2l0 22.2 32 0 0-59.3zM352 328c11.3 0 22.1-2.1 32-6l0 30 32 0 0-51.6c14.9-15.8 24-37 24-60.4 0-15.3-3.9-29.7-10.8-42.2l4.1 .5 5-39.7c-14.6-1.8-25.1-3.1-31.4-3.9-23.9-3-43.6-19.9-50.2-43.1-.3-1.1-2.6-9.2-7-24.4l-38.5 11 5.5 19.2 1.5 5.2c3.3 11.5 8.5 22 15.2 31.3-39.7 8.5-69.5 43.8-69.5 86 0 48.6 39.4 88 88 88zm-96 74c-23.9 0-45.2-10.7-59.6-27.6l-36.6 31C182.9 432.6 217.4 450 256 450s73.1-17.4 96.2-44.6l-36.6-31C301.2 391.3 279.9 402 256 402zM128 232c17.7 0 32-14.3 32-32 0-5.8-1.5-11.2-4.2-15.8 1.4-.1 2.8-.2 4.2-.2 30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4 5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8 1.4-.1 2.8-.2 4.2-.2 30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4 5.7 5.2 13.3 8.4 21.6 8.4 17.7 0 32-14.3 32-32z"]
};
var faCardHeart = {
  prefix: 'fass',
  iconName: 'card-heart',
  icon: [384, 512, [], "e3eb", "M384 0L0 0 0 512 384 512 384 0zM185.6 183.5l6.4 8.5 6.4-8.5c11.1-14.8 28.5-23.5 46.9-23.5 32.4 0 58.7 26.3 58.7 58.7l0 5.3c0 64-112 128-112 128S80 288 80 224l0-5.3c0-32.4 26.3-58.7 58.7-58.7 18.5 0 35.9 8.7 46.9 23.5z"]
};
var faCarMirrors = {
  prefix: 'fass',
  iconName: 'car-mirrors',
  icon: [576, 512, [], "e343", "M152 32l-22.7 0-7.5 21.4-48.5 138.6-73.3 0 0 64 32 0 0 224 96 0 0-64 320 0 0 64 96 0 0-224 32 0 0-64-73.3 0-48.5-138.6-7.5-21.4-294.7 0zM434.9 192l-293.8 0 33.6-96 226.6 0 33.6 96zM96 304a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSuitcaseMedical = {
  prefix: 'fass',
  iconName: 'suitcase-medical',
  icon: [512, 512, ["medkit"], "f0fa", "M144 0l224 0 0 480-224 0 0-480zM416 480l0-384 96 0 0 384-96 0zM96 192l0 288-96 0 0-384 96 0 0 96zM320 48l-128 0 0 48 128 0 0-48zM228 208l0 52-52 0 0 56 52 0 0 52 56 0 0-52 52 0 0-56-52 0 0-52-56 0z"]
};
var faMedkit = faSuitcaseMedical;
var faBlockQuote = {
  prefix: 'fass',
  iconName: 'block-quote',
  icon: [448, 512, [], "e0b5", "M448 64l-448 0 0 64 448 0 0-64zm0 160l-320 0 0 64 320 0 0-64zM128 384l0 64 320 0 0-64-320 0zM64 224l-64 0 0 224 64 0 0-224z"]
};
var faHandsHoldingHeart = {
  prefix: 'fass',
  iconName: 'hands-holding-heart',
  icon: [640, 512, ["hands-heart"], "f4c3", "M311.6 23C297.5 3.5 274.9-8 250.9-8 209.5-8 176 25.5 176 66.9l0 2.4C176 154.7 320 248 320 248S464 154.7 464 69.3l0-2.4c0-41.4-33.5-74.9-74.9-74.9-24 0-46.6 11.5-60.7 31L320 34.7 311.6 23zM80 64l-80 0 0 301.3 9.4 9.4 128 128 9.4 9.4 141.3 0 0-173.3-9.4-9.4C125.1 175.9 201.5 252.2 160 210.7L114.7 256c48.8 48.8 65.1 65.1 91 91L164.1 374.8 80 290.7 80 64zm480 0l0 226.7-84.1 84.1-41.7-27.8c102.9-102.9 58.7-58.7 91-91L480 210.7c-44.2 44.2-69.7 69.7-118.6 118.6l-9.4 9.4 0 173.3 141.3 0 9.4-9.4 128-128 9.4-9.4 0-301.3-80 0z"]
};
var faHandsHeart = faHandsHoldingHeart;
var faArrowUpSmallBig = {
  prefix: 'fass',
  iconName: 'arrow-up-small-big',
  icon: [512, 512, ["sort-size-up-alt"], "f88f", "M150.6 41.4L128 18.7 25.4 121.4 2.7 144 48 189.3c14.6-14.6 30.6-30.6 48-48l0 338.7 64 0 0-338.7 48 48 45.3-45.3c-5.5-5.5-39.7-39.7-102.6-102.6zM288 32l0 160 160 0 0-160-160 0zm0 224l0 224 224 0 0-224-224 0z"]
};
var faSortSizeUpAlt = faArrowUpSmallBig;
var faSlidersSimple = {
  prefix: 'fass',
  iconName: 'sliders-simple',
  icon: [512, 512, [], "e253", "M64 384l64 0 0-64-64 0 0 64zm128 0l0 64-192 0 0-192 192 0 0 64 320 0 0 64-320 0zM32 192l-32 0 0-64 320 0 0-64 192 0 0 192-192 0 0-64-288 0zm416 0l0-64-64 0 0 64 64 0z"]
};
var faPersonCane = {
  prefix: 'fass',
  iconName: 'person-cane',
  icon: [448, 512, [], "e53c", "M232 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-59.1 32l-16.3 0-9.6 13.2-92.9 128-18.8 25.9 51.8 37.6c9.3-12.8 28.3-39 56.9-78.4l0 305.7 64 0 0-208 32 0 0 208 64 0 0-305.7c28.6 39.4 47.6 65.6 56.9 78.4l51.8-37.6c-.2-.2-37.4-51.6-111.7-153.9l-9.6-13.2-118.5 0zM392 384c4.4 0 8 3.6 8 8l0 152 48 0 0-152c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 24 48 0 0-24c0-4.4 3.6-8 8-8z"]
};
var faMessageMusic = {
  prefix: 'fass',
  iconName: 'message-music',
  icon: [512, 512, ["comment-alt-music"], "f8af", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zm336 96l0 64-48 0 0 104c0 30.9-28.7 56-64 56s-64-25.1-64-56 28.7-56 64-56c5.5 0 10.9 .6 16 1.8l0-113.8 96 0z"]
};
var faCommentAltMusic = faMessageMusic;
var faGaugeLow = {
  prefix: 'fass',
  iconName: 'gauge-low',
  icon: [512, 512, ["tachometer-alt-slow"], "f627", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64s-28.7-64-64-64c-1.7 0-3.4 .1-5.1 .2l-69.5-138.9-42.9 21.5 69.5 138.9c-10 11.3-16 26.1-16 42.3 0 35.3 28.7 64 64 64zM128 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAltSlow = faGaugeLow;
var faHexagonEquals = {
  prefix: 'fass',
  iconName: 'hexagon-equals',
  icon: [576, 512, [], "e6b2", "M13.5 256.1l6.8-11.9 123.7-216.1 6.9-12.1 275.1 0 6.9 12.1 123.7 216.1 6.8 11.9-6.8 11.9-123.7 216.1-6.9 12.1-275.1 0-6.9-12.1-123.7-216.1-6.8-11.9zm179-80.1l0 48 192 0 0-48-192 0zm0 112l0 48 192 0 0-48-192 0z"]
};
var faCapsule = {
  prefix: 'fass',
  iconName: 'capsule',
  icon: [448, 512, [], "e75a", "M189.3 189.3L290.7 290.7 363 218.5c13.5-13.5 21-31.7 21-50.7 0-39.6-32.1-71.8-71.8-71.8-19 0-37.3 7.6-50.7 21l-72.2 72.2zm219 74.5L231.8 440.2c-25.5 25.5-60 39.8-96 39.8-75 0-135.8-60.8-135.8-135.8 0-36 14.3-70.5 39.8-96L216.2 71.8c25.5-25.5 60-39.8 96-39.8 75 0 135.8 60.8 135.8 135.8 0 36-14.3 70.5-39.8 96z"]
};
var faUserSith = {
  prefix: 'fass',
  iconName: 'user-sith',
  icon: [448, 512, [], "e7b8", "M248-16l-48 0 0 16-8 0C139 0 96 43 96 96l0 64-64 128 80 0 0 16 224 0 0-16 80 0-64-128 0-64c0-53-43-96-96-96l-8 0 0-16zM176 112l32 0 0 48-64 0 0-16c0-17.7 14.3-32 32-32zm128 32l0 16-64 0 0-48 32 0c17.7 0 32 14.3 32 32zm-64 48l0 12 48 36 0 16-128 0 0-16 48-36 0-12c0-8.8 7.2-16 16-16s16 7.2 16 16zM0 512l104 0 0-64 48 0 0 64 48 0 0-64 48 0 0 64 48 0 0-64 48 0 0 64 104 0-48-160-352 0-48 160z"]
};
var faGauge = {
  prefix: 'fass',
  iconName: 'gauge',
  icon: [512, 512, ["dashboard", "gauge-med", "tachometer-alt-average"], "f624", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm320 96c0-26.9-16.5-49.9-40-59.3l0-196.7-48 0 0 196.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faDashboard = faGauge;
var faGaugeMed = faGauge;
var faTachometerAltAverage = faGauge;
var faEnvelopeOpenText = {
  prefix: 'fass',
  iconName: 'envelope-open-text',
  icon: [576, 512, [], "f658", "M288 48L416 144 522.7 144 288-32 32 160 32 480 272 480 272 308.6 102.2 187.3 288 48zm32 144l0 320 256 0 0-320-256 0zm56 64l144 0 0 48-144 0 0-48zm0 96l104 0 0 48-104 0 0-48z"]
};
var faToolbox = {
  prefix: 'fass',
  iconName: 'toolbox',
  icon: [512, 512, [129520], "f552", "M152 0l-24 0 0 96-48 0-80 80 0 96 136 0 0-40 48 0 0 40 144 0 0-40 48 0 0 40 136 0 0-96-80-80-48 0 0-96-232 0zM336 96l-160 0 0-48 160 0 0 48zM0 480l512 0 0-160-136 0 0 40-48 0 0-40-144 0 0 40-48 0 0-40-136 0 0 160z"]
};
var faWheatSlash = {
  prefix: 'fass',
  iconName: 'wheat-slash',
  icon: [576, 512, [], "e339", "M578.2 512.1L544.3 546-1.6 .1 32.3-33.8 578.2 512.1zM145.5 282.7l6.1 6.7c19.7 23.8 26.3 55 19.2 83.9 31.7-7.7 66.2 1 90.6 25.3L318.7 456 300 474.7c-37.5 37.5-98.3 37.5-135.8 0L133.8 444.3 49.1 529c-9.4 9.4-24.5 9.4-33.9 0-9.4-9.4-9.4-24.6 0-33.9l84.7-84.7-30.5-30.5c-37.5-37.5-37.5-98.3 0-135.8l18.7-18.8 57.4 57.4zm208-208l6.1 6.7c19.7 23.7 26.3 55 19.3 83.9 31.7-7.7 66.2 1 90.6 25.3L526.7 248 508 266.7c-37.5 37.5-98.3 37.5-135.8 0l-94.9-94.9c-37.5-37.5-37.5-98.3 0-135.7l18.8-18.8 57.4 57.4zM560.1 35l-.1 4.8c-2.4 47.6-40.5 85.7-88.1 88.1l-4.8 .1-51 0 0-51c0-51.4 41.6-93 93-93l51 0 0 51z"]
};
var faPowerOff = {
  prefix: 'fass',
  iconName: 'power-off',
  icon: [512, 512, [9211], "f011", "M288 0l0-32-64 0 0 320 64 0 0-288zM64 256c0-75 43-140.1 105.9-171.7L141.2 27.1C57.5 69.2 0 155.8 0 256 0 397.4 114.6 512 256 512S512 397.4 512 256c0-100.2-57.5-186.8-141.2-228.9L342.1 84.3C405 115.9 448 181 448 256 448 362 362 448 256 448S64 362 64 256z"]
};
var faSignal = {
  prefix: 'fass',
  iconName: 'signal',
  icon: [512, 512, [128246, "signal-5", "signal-perfect"], "f012", "M488 56l0-24-48 0 0 448 48 0 0-424zM384 128l-48 0 0 352 48 0 0-352zM280 248l0-24-48 0 0 256 48 0 0-232zM176 320l-48 0 0 160 48 0 0-160zM72 384l-48 0 0 96 48 0 0-96z"]
};
var faSignal5 = faSignal;
var faSignalPerfect = faSignal;
var faArrowsSpin = {
  prefix: 'fass',
  iconName: 'arrows-spin',
  icon: [512, 512, [], "e4bb", "M192 0l0 176-63.8-63.8-8 8C78.7 161.8 60.1 217.6 64.7 272L.5 272C-3.9 201.3 20.9 129.1 75 75l8-8-67-67 176 0zM391.8 391.8c41.5-41.5 60.1-97.4 55.6-151.8l64.2 0c4.4 70.7-20.4 142.9-74.5 197l-8 8 67 67-176 0 0-176 63.8 63.8 8-8zM512 192l-176 0 63.8-63.8-8-8C350.2 78.7 294.4 60.1 240 64.7L240 .5C310.7-3.9 382.9 20.9 437 75l8 8 67-67 0 176zM120.2 391.8c41.5 41.5 97.4 60.1 151.8 55.6l0 64.2c-70.7 4.4-142.9-20.4-197-74.5l-8-8-67 67 0-176 176 0-63.8 63.8 8 8z"]
};
var faJoint = {
  prefix: 'fass',
  iconName: 'joint',
  icon: [576, 512, [], "f595", "M336 0l48 0 0 43c0 40.3 16 79 44.5 107.5l21 21C469 191 480 217.4 480 245l0 43-48 0 0-43c0-14.9-5.9-29.1-16.4-39.6l-21-21C357.1 146.9 336 96 336 43l0-43zM576 288l-48 0 0-43c0-40.3-16-79-44.5-107.5l-21-21C443 97 432 70.6 432 43l0-43 48 0 0 43c0 14.9 5.9 29.1 16.4 39.6l21 21C554.9 141.1 576 192 576 245l0 43zM244.4 320l57.2 0 95.7 155.5-5.2 .8c-16.1 2.5-32.4 3.7-48.7 3.7l-47 0-96.5-156.9c14.7-2.1 29.6-3.1 44.5-3.1zM576 448l-127.2 19.6-90.6-147.2c11.4 .5 22.7 1.7 34 3.4L576 352 576 448zM149.9 333.4L240.1 480c-22.8-.3-45.4-3-67.6-8.2L0 432 0 368 149.9 333.4z"]
};
var faDownFromLine = {
  prefix: 'fass',
  iconName: 'down-from-line',
  icon: [384, 512, ["arrow-alt-from-top"], "f349", "M384 64L0 64 0 0 384 0 384 64zM192 523l-17.4-18.5C67.6 391.2 9.5 329.7 .3 320l127.7 0 0-160 0 0 0-32 128 0 0 192 127.7 0c-9.2 9.7-67.3 71.2-174.2 184.5L192 523z"]
};
var faArrowAltFromTop = faDownFromLine;
var faTabletRugged = {
  prefix: 'fass',
  iconName: 'tablet-rugged',
  icon: [448, 512, [], "f48f", "M352 64l0 384-256 0 0-384 256 0zM96 0l-64 0 0 48-32 16 0 96 32 16 0 16-32 16 0 96 32 16 0 16-32 16 0 96 32 16 0 48 384 0 0-48 32-16 0-96-32-16 0-16 32-16 0-96-32-16 0-16 32-16 0-96-32-16 0-48-320 0z"]
};
var faBraille = {
  prefix: 'fass',
  iconName: 'braille',
  icon: [384, 512, [], "f2a1", "M80 144a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 136c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0 56c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm248-80c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm56 0c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zM304 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
var faBasketShopping = {
  prefix: 'fass',
  iconName: 'basket-shopping',
  icon: [576, 512, ["shopping-basket"], "f291", "M288-10.9l17.4 18.4 144 152 .5 .5 110.1 0 0 64-23.1 0-56.9 256-384 0-56.9-256-23.1 0 0-64 110.1 0 .5-.5 144-152 17.4-18.4zm0 69.8L192.2 160 383.8 160 288 58.9zM208 264l0-24-48 0 0 160 48 0 0-136zm104-24l-48 0 0 160 48 0 0-160zm104 24l0-24-48 0 0 160 48 0 0-136z"]
};
var faShoppingBasket = faBasketShopping;
var faPartyBell = {
  prefix: 'fass',
  iconName: 'party-bell',
  icon: [512, 512, [], "e31a", "M65.6 382.4c-87.5-87.5-87.5-229.3 0-316.8s229.3-87.5 316.8 0L65.6 382.4zM480 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 480a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM376 150.1c12.8 12.8 21.2 21.2 25.2 25.2 16.7 16.7 38.6 27.2 62.1 29.8l27.4 3-5.3 47.7-27.4-3c-34.3-3.8-66.3-19.2-90.7-43.6-4-4-12.5-12.5-25.2-25.2L376 150.1zM201 359l8.3 8.2c24.4 24.4 39.8 56.4 43.6 90.7l3 27.4-47.7 5.3-3-27.4c-2.6-23.5-13.1-45.4-29.8-62.1-4-4-12.5-12.5-25.2-25.2l33.9-33.9 17 17zM469.7 503.5l-8.5-10c-12.5-14.8-19.1-33.7-18.6-53 .5-16.6-12.4-30.6-29-31.6l-30-1.8c-42.5-2.5-75.3-38.3-74.2-80.8 .2-7.6-2.4-15-7.3-20.7-4.5-5.3-12.5-14.8-24-28.3l36.6-31c11.5 13.6 19.5 23 24 28.3 12.5 14.8 19.1 33.7 18.6 53-.5 16.6 12.4 30.6 29 31.6l30 1.8c42.5 2.5 75.3 38.3 74.2 80.8-.2 7.6 2.4 15 7.3 20.7l8.5 10-36.6 31z"]
};
var faBra = {
  prefix: 'fass',
  iconName: 'bra',
  icon: [576, 512, [], "e6cf", "M143.5 52.7l4.7-23.5-47.1-9.4-4.7 23.5-36.2 180.8c-27.3 26.2-44.3 63.1-44.3 103.9 0 79.5 64.5 144 144 144 49.9 0 93.9-25.4 119.8-64l16.5 0c25.8 38.6 69.8 64 119.8 64 79.5 0 144-64.5 144-144 0-40.8-17-77.7-44.3-103.9l-36.2-180.8-4.7-23.5-47.1 9.4 4.7 23.5 37.3 186.6-101.8 40.7-45.7 64-68.6 0-45.7-64-101.8-40.7 37.3-186.6z"]
};
var faCarWash = {
  prefix: 'fass',
  iconName: 'car-wash',
  icon: [448, 512, [], "f5e6", "M224 96c-26.5 0-48-21.5-48-48 0-32 48-80 48-80s48 48 48 80-21.5 48-48 48zM89.8 144l268.4 0 7.8 20.8 46.2 123.2 35.8 0 0 224-80 0 0-64-288 0 0 64-80 0 0-224 35.8 0 54-144zm224 64l-179.6 0-30 80 239.6 0-30-80zM96 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM112 48c0 32-21.5 48-48 48S16 74.5 16 48c0-32 48-80 48-80s48 48 48 80zM384 96c-26.5 0-48-21.5-48-48 0-32 48-80 48-80s48 48 48 80-21.5 48-48 48z"]
};
var faFaceSunglasses = {
  prefix: 'fass',
  iconName: 'face-sunglasses',
  icon: [576, 512, [], "e398", "M288.3 512c141.4 0 256-114.6 256-256 0-12.9-1-25.7-2.8-38.1 12.6-56.5 22.8-102.5 30.6-137.9l-97.9 0C427.6 30.7 361.6 0 288.3 0S149.1 30.7 102.4 80L4.5 80c7.9 35.4 18.1 81.4 30.6 137.9-1.9 12.4-2.8 25.1-2.8 38.1 0 141.4 114.6 256 256 256zM511.7 130.8l-31.4 141.2-144 0-11.4-80-73.1 0-11.4 80-144 0-31.4-141.2 0 0-.6-2.8 192 0 0 16 64 0 0-16 192 0-.6 2.8zM288.3 384c38.2 0 72-19.1 92.2-48.5l39.5 27.3C391.3 404.6 343 432 288.3 432s-102.9-27.4-131.8-69.2l39.5-27.3c20.2 29.3 54 48.5 92.2 48.5z"]
};
var faBridge = {
  prefix: 'fass',
  iconName: 'bridge',
  icon: [512, 512, [], "e4c8", "M32 32l-32 0 0 64 40 0 0 64-40 0 0 112c37.6 9.4 64 43.2 64 82l0 126 96 0 0-96c0-53 43-96 96-96s96 43 96 96l0 96 96 0 0-126c0-38.8 26.4-72.6 64-82l0-112-40 0 0-64 40 0 0-64-480 0zM424 96l0 64-80 0 0-64 80 0zM296 96l0 64-80 0 0-64 80 0zM88 96l80 0 0 64-80 0 0-64z"]
};
var faArrowsFromLine = {
  prefix: 'fass',
  iconName: 'arrows-from-line',
  icon: [384, 512, [], "e0a4", "M192-32l-120 128 88 0 0 80 64 0 0-80 88 0-120-128zm0 576l120-128-88 0 0-80-64 0 0 80-88 0 120 128zM32 224l-32 0 0 64 384 0 0-64-352 0z"]
};
var faUpLongToLine = {
  prefix: 'fass',
  iconName: 'up-long-to-line',
  icon: [384, 512, [], "e6c6", "M384 256l-192-192-192 192 128 0 0 320 128 0 0-320 128 0zM320-64l-288 0 0 64 320 0 0-64-32 0z"]
};
var faUpToLine = {
  prefix: 'fass',
  iconName: 'up-to-line',
  icon: [384, 512, ["arrow-alt-to-top"], "f34d", "M32 0L384 0 384 64 0 64 0 0 32 0zM0 320l192-202.9 192 202.9-128 0 0 160 0 0 0 32-128 0 0-192-128 0z"]
};
var faArrowAltToTop = faUpToLine;
var faPlaneArrival = {
  prefix: 'fass',
  iconName: 'plane-arrival',
  icon: [576, 512, [128748], "f5af", "M386.6 193.1l-128.3-201.3-78.8-13.9 27.2 183.5-105-18.5-39.3-71.9-47.3-8.3 1 178.9 66.1 11.7 0 0 417.6 73.6c30.5 5.4 59.5-15 64.9-45.4s-15-59.5-45.4-64.9L386.6 193.1zM224 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm131.2-15.3a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 448l-32 0 0 64 576 0 0-64-544 0z"]
};
var faPotFood = {
  prefix: 'fass',
  iconName: 'pot-food',
  icon: [640, 512, [127858], "e43f", "M112 24l0-24-48 0 0 24c0 45.1 21.2 69 37.7 87.5l.4 .4C117.5 129.3 128 141.5 128 168l0 24 48 0 0-24c0-45.1-21.2-69-37.7-87.5l-.4-.4C122.5 62.7 112 50.5 112 24zm112 0l0-24-48 0 0 24c0 45.1 21.2 69 37.7 87.5l.4 .4C229.5 129.3 240 141.5 240 168l0 24 48 0 0-24c0-45.1-21.2-69-37.7-87.5l-.4-.4C234.5 62.7 224 50.5 224 24zm208 88c-50.7 0-93.6 33.7-107.4 80l214.7 0c-13.8-46.3-56.6-80-107.4-80zM576 224l-512 0 1.9 32-49.9 0 0 64 56.4 0C87.1 387.5 132.1 443.2 192 472.9l0 39.1 256 0 0-39.1c59.9-29.7 104.9-85.4 119.6-152.9l56.4 0 0-64-49.9 0 1.9-32z"]
};
var faCashRegister = {
  prefix: 'fass',
  iconName: 'cash-register',
  icon: [512, 512, [], "f788", "M320 0l-288 0 0 128 112 0 0 32-112 0-32 211.2 0 140.8 512 0 0-140.8-32-211.2-272 0 0-32 112 0 0-128zM96 48l176 0 0 32-192 0 0-32 16 0zM64 416l384 0 0 32-384 0 0-32zm72-200l0 48-48 0 0-48 48 0zm48 48l0-48 48 0 0 48-48 0zm0 32l0 48-48 0 0-48 48 0zm96-80l48 0 0 48-48 0 0-48zm-48 80l48 0 0 48-48 0 0-48zm144-80l48 0 0 48-48 0 0-48zm0 80l0 48-48 0 0-48 48 0z"]
};
var faRing = {
  prefix: 'fass',
  iconName: 'ring',
  icon: [512, 512, [], "f70b", "M64 184.3l0 51C106.8 212.1 170 192 256 192s149.2 20.1 192 43.3l0-51c-23.1-20-82.6-56.3-192-56.3S87.1 164.3 64 184.3zM512 192l0 160c-21.3 32-102.4 96-256 96S21.3 384 0 352L0 160c21.3-32 102.4-96 256-96s234.7 64 256 96l0 32zM400.1 265.6C365.8 251.5 318.4 240 256 240s-109.8 11.5-144.1 25.6C150 278.8 197.8 288 256 288s106-9.2 144.1-22.4z"]
};
var faMessageXmark = {
  prefix: 'fass',
  iconName: 'message-xmark',
  icon: [512, 512, ["comment-alt-times", "message-times"], "f4ab", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM340.9 189.1c-8.5 8.5-25.5 25.5-50.9 50.9 25.5 25.5 42.4 42.4 50.9 50.9l-33.9 33.9c-8.5-8.5-25.5-25.5-50.9-50.9-25.5 25.5-42.4 42.4-50.9 50.9l-33.9-33.9c8.5-8.5 25.5-25.5 50.9-50.9-25.5-25.5-42.4-42.4-50.9-50.9l33.9-33.9 50.9 50.9c25.5-25.5 42.4-42.4 50.9-50.9l33.9 33.9z"]
};
var faCommentAltTimes = faMessageXmark;
var faMessageTimes = faMessageXmark;
var faShareNodes = {
  prefix: 'fass',
  iconName: 'share-nodes',
  icon: [512, 512, ["share-alt"], "f1e0", "M384 192c53 0 96-43 96-96s-43-96-96-96-96 43-96 96c0 5.4 .5 10.8 1.3 16L159.6 184.1c-16.9-15-39.2-24.1-63.6-24.1-53 0-96 43-96 96s43 96 96 96c24.4 0 46.6-9.1 63.6-24.1L289.3 400c-.9 5.2-1.3 10.5-1.3 16 0 53 43 96 96 96s96-43 96-96-43-96-96-96c-24.4 0-46.6 9.1-63.6 24.1L190.7 272c.9-5.2 1.3-10.5 1.3-16s-.5-10.8-1.3-16l129.7-72.1c16.9 15 39.2 24.1 63.6 24.1z"]
};
var faShareAlt = faShareNodes;
var faOctagonDivide = {
  prefix: 'fass',
  iconName: 'octagon-divide',
  icon: [512, 512, [], "e203", "M0 160L0 352 160 512 352 512 512 352 512 160 352 0 160 0 0 160zm288-32l0 64-64 0 0-64 64 0zM168 232l200 0 0 48-224 0 0-48 24 0zm56 88l64 0 0 64-64 0 0-64z"]
};
var faFolderArrowUp = {
  prefix: 'fass',
  iconName: 'folder-arrow-up',
  icon: [512, 512, ["folder-upload"], "e054", "M512 80l0 368-512 0 0-416 224 0 64 48 224 0zM273 167l-17-17-105.9 105.9 33.9 33.9c9-9 25-25 48-48l0 126.1 48 0 0-126.1c23 23 39 39 48 48L361.9 256c-2.1-2.1-31.8-31.8-89-89z"]
};
var faFolderUpload = faFolderArrowUp;
var faArrowsMinimize = {
  prefix: 'fass',
  iconName: 'arrows-minimize',
  icon: [512, 512, ["compress-arrows"], "e0a5", "M64.3 18.8c6.6 6.6 38.6 38.6 96 96l0-66.7 64 0 0 176-176 0 0-64 66.7 0C57.6 102.6 25.6 70.6 19 64L64.3 18.8zM493.5 64c-6.6 6.6-38.6 38.6-96 96l66.7 0 0 64-176 0 0-176 64 0 0 66.7c57.4-57.4 89.4-89.4 96-96L493.5 64zM48.3 352l0-64 176 0 0 176-64 0 0-66.7c-57.4 57.4-89.4 89.4-96 96L19 448c6.6-6.6 38.6-38.6 96-96l-66.7 0zm240-64l176 0 0 64-66.7 0c57.4 57.4 89.4 89.4 96 96l-45.3 45.3-96-96 0 66.7-64 0 0-176z"]
};
var faCompressArrows = faArrowsMinimize;
var faPersonCircleExclamation = {
  prefix: 'fass',
  iconName: 'person-circle-exclamation',
  icon: [640, 512, [], "e53f", "M168 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-11.4 88l134.8 0 9.6 13.2 85.2 117.3c-17.8 12.4-33.4 27.8-46.1 45.5l-36.1-49.7 0 305.7-64 0 0-208-32 0 0 208-64 0 0-305.7c-28.6 39.4-47.6 65.6-56.9 78.4l-51.8-37.6 18.8-25.9 92.9-128 9.6-13.2zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 112 32 0 0-112z"]
};
var faBinoculars = {
  prefix: 'fass',
  iconName: 'binoculars',
  icon: [512, 512, [], "f1e5", "M192 32l0 64-96 0 0-64 96 0zm0 96l0 352-192 0 0-144 48-80 16-128 128 0zm128 0l128 0 16 128 48 80 0 144-192 0 0-352zm0-96l96 0 0 64-96 0 0-64zm-32 96l0 160-64 0 0-160 64 0z"]
};
var faGridRound5 = {
  prefix: 'fass',
  iconName: 'grid-round-5',
  icon: [448, 512, [], "e5de", "M28 32a28 28 0 1 0 0 56 28 28 0 1 0 0-56zM0 158a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zm28 70a28 28 0 1 0 0 56 28 28 0 1 0 0-56zM0 354a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zm0 98c0 15.5 12.5 28 28 28s28-12.5 28-28-12.5-28-28-28-28 12.5-28 28zm98 0c0 15.5 12.5 28 28 28s28-12.5 28-28-12.5-28-28-28-28 12.5-28 28zm126-28c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28zm70 28c0 15.5 12.5 28 28 28s28-12.5 28-28-12.5-28-28-28-28 12.5-28 28zm126-28c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28zM126 326a28 28 0 1 0 0 56 28 28 0 1 0 0-56zm70 28a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zm126-28a28 28 0 1 0 0 56 28 28 0 1 0 0-56zm70 28a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zM98 256a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zm126-28a28 28 0 1 0 0 56 28 28 0 1 0 0-56zm70 28a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zm126-28a28 28 0 1 0 0 56 28 28 0 1 0 0-56zM126 130a28 28 0 1 0 0 56 28 28 0 1 0 0-56zm70 28a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zm126-28a28 28 0 1 0 0 56 28 28 0 1 0 0-56zm70 28a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zM98 60a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zM224 32a28 28 0 1 0 0 56 28 28 0 1 0 0-56zm70 28a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zM420 32a28 28 0 1 0 0 56 28 28 0 1 0 0-56z"]
};
var faKipSign = {
  prefix: 'fass',
  iconName: 'kip-sign',
  icon: [384, 512, [], "e1c4", "M128 322.9l0 157.1-64 0 0-200-56 0 0-48 56 0 0-200 64 0 0 157.1 195.9-158 40.2 49.8-187.4 151.1 199.3 0 0 48-199.3 0 187.4 151.1-40.2 49.8-195.9-158z"]
};
var faHardDrive = {
  prefix: 'fass',
  iconName: 'hard-drive',
  icon: [448, 512, [128436, "hdd"], "f0a0", "M448 32l-448 0 0 208 448 0 0-208zm0 256l-448 0 0 192 448 0 0-192zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faHdd = faHardDrive;
var faRankingStar = {
  prefix: 'fass',
  iconName: 'ranking-star',
  icon: [576, 512, [], "e561", "M319.8 62.3l-31.8-62.3-31.8 62.3-69 11 49.4 49.5-10.9 69.1 62.3-31.7 62.3 31.7-10.9-69.1 49.4-49.5-69-11zM368 256l-160 0 0 256 160 0 0-256zM160 320l-160 0 0 192 160 0 0-192zm256 64l0 128 160 0 0-128-160 0z"]
};
var faUserTie = {
  prefix: 'fass',
  iconName: 'user-tie',
  icon: [448, 512, [], "f508", "M224 8a120 120 0 1 0 0 240 120 120 0 1 0 0-240zm48 320l0-24-96 0 0 24 31.4 36.7-31.4 115.3-40-160-56 0-64 192 416 0-64-192-56 0-40 160-.6 0-31-115.1 31.6-36.9z"]
};
var faSquareBitcoin = {
  prefix: 'fass',
  iconName: 'square-bitcoin',
  icon: [448, 512, [], "e6f2", "M0 32l448 0 0 448-448 0 0-448zM244 176c15.5 0 28 12.5 28 28s-12.5 28-28 28l-60 0 0-56 60 0zm62.2 71.7c8.7-12.4 13.8-27.4 13.8-43.7 0-37.9-27.7-69.3-64-75.1l0-32.9-32 0 0 32-16 0 0-32-32 0 0 32-40 0 0 256 40 0 0 32 32 0 0-32 16 0 0 32 32 0 0-32 4 0c42 0 76-34 76-76 0-24.6-11.7-46.4-29.8-60.3zM184 280l76 0c15.5 0 28 12.5 28 28s-12.5 28-28 28l-76 0 0-56z"]
};
var faEllipsis = {
  prefix: 'fass',
  iconName: 'ellipsis',
  icon: [448, 512, ["ellipsis-h"], "f141", "M112 200l0 112-112 0 0-112 112 0zm168 0l0 112-112 0 0-112 112 0zM448 312l-112 0 0-112 112 0 0 112z"]
};
var faEllipsisH = faEllipsis;
var faArrowTurnDownLeft = {
  prefix: 'fass',
  iconName: 'arrow-turn-down-left',
  icon: [576, 512, [], "e2e1", "M480.3 96l0-32 64 0 0 224-402.7 0c57.4 57.4 89.4 89.4 96 96l-45.3 45.3-22.6-22.6-128-128-22.6-22.6 22.6-22.6 128-128 22.6-22.6 45.3 45.3c-6.6 6.6-38.6 38.6-96 96l338.7 0 0-128z"]
};
var faOctagonCheck = {
  prefix: 'fass',
  iconName: 'octagon-check',
  icon: [512, 512, [], "e426", "M512 160L512 352 352 512 160 512 0 352 0 160 160 0 352 0 512 160zm-171.5-9l-119.4 164.2-69.1-69.1-33.9 33.9 88.9 88.9 19.8 19.9 16.5-22.7 135.9-186.9 14.1-19.4-38.8-28.3-14.1 19.4z"]
};
var faStore24 = {
  prefix: 'fass',
  iconName: 'store-24',
  icon: [640, 512, [], "e79b", "M80 32l-64 176 80 32 72-32 56 32 64-32 64 32 56-32 72 32 80-32-64-176-416 0zM64 480l240 0 0-128-176 0 0-73.7c-7.3 3.3-17.7 7.9-31 13.8-13.3-5.3-24.3-9.7-33-13.2L64 480zm284-80l40 0c0-6.6 5.4-12 12-12s12 5.4 12 12l0 1c0 4.8-1.8 9.4-4.9 13l-54 60.8-5.1 5.7 0 35.6 104 0 0-40-46.6 0 31.5-35.5c9.7-10.9 15-25 15-39.6l0-1c0-28.7-23.3-52-52-52s-52 23.3-52 52zm128 32l0 20 64 0 0 60 40 0 0-160-40 0 0 60-24 0 0-60-40 0 0 80z"]
};
var faStoreSlash = {
  prefix: 'fass',
  iconName: 'store-slash',
  icon: [576, 512, [], "e071", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-66.1-66.1 0-167.1c-8.7 3.5-19.7 7.9-33 13.2-13.3-5.9-23.7-10.5-31-13.8l0 73.7-30 0-139.3-139.3 9.3-4.7 64 32 56-32 72 32 80-32-64-176-398 0-48.9-48.9zm98.2 234.1l-98.8-98.8-32.6 89.6 80 32 51.4-22.8zM410.3 480l-128-128-154.2 0 0-73.7c-7.3 3.3-17.7 7.9-31 13.8-13.3-5.3-24.3-9.7-33-13.2l0 201.1 346.2 0z"]
};
var faPercent = {
  prefix: 'fass',
  iconName: 'percent',
  icon: [512, 512, [62101, 62785, "percentage"], "25", "M470.9 86.6l22.6-22.6-45.3-45.3-22.6 22.6-384 384-22.6 22.6 45.3 45.3 22.6-22.6 384-384zM32.3 32l0 160 160 0 0-160-160 0zm288 288l0 160 160 0 0-160-160 0z"]
};
var faPercentage = faPercent;
var faCircleN = {
  prefix: 'fass',
  iconName: 'circle-n',
  icon: [512, 512, [], "e118", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM160 144l35.4 0 7.2 8.8 101.4 124 0-132.8 48 0 0 224-35.4 0-7.2-8.8-101.4-124 0 132.8-48 0 0-224z"]
};
var faFileZipper = {
  prefix: 'fass',
  iconName: 'file-zipper',
  icon: [384, 512, ["file-archive"], "f1c6", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM64 48l0 48 96 0 0-48-96 0zm0 96l0 48 96 0 0-48-96 0zm96 96l-96 0 0 80c0 26.5 21.5 48 48 48s48-21.5 48-48l0-80zm-48 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faFileArchive = faFileZipper;
var faTrashCanXmark = {
  prefix: 'fass',
  iconName: 'trash-can-xmark',
  icon: [448, 512, [], "e2ae", "M304-16l16 48 128 0 0 64-448 0 0-64 128 0 16-48 160 0zM32 144l384 0 0 368-384 0 0-368zM308.9 269.1l-33.9-33.9c-8.5 8.5-25.5 25.5-50.9 50.9-25.5-25.5-42.4-42.4-50.9-50.9l-33.9 33.9c8.5 8.5 25.5 25.5 50.9 50.9-25.5 25.5-42.4 42.4-50.9 50.9l33.9 33.9c8.5-8.5 25.5-25.5 50.9-50.9 25.5 25.5 42.4 42.4 50.9 50.9l33.9-33.9c-8.5-8.5-25.5-25.5-50.9-50.9 25.5-25.5 42.4-42.4 50.9-50.9z"]
};
var faDisplay = {
  prefix: 'fass',
  iconName: 'display',
  icon: [512, 512, [], "e163", "M448 96l0 256-384 0 0-256 384 0zM64 32l-64 0 0 384 208 0-16 48-96 0 0 48 320 0 0-48-96 0-16-48 208 0 0-384-448 0z"]
};
var faEllipsisStroke = {
  prefix: 'fass',
  iconName: 'ellipsis-stroke',
  icon: [512, 512, ["ellipsis-h-alt"], "f39b", "M64 240l32 0 0 32-32 0 0-32zM16 272l0 48 128 0 0-128-128 0 0 80zm224-32l32 0 0 32-32 0 0-32zm-48 32l0 48 128 0 0-128-128 0 0 80zm224 0l0-32 32 0 0 32-32 0zm-48 48l128 0 0-128-128 0 0 128z"]
};
var faEllipsisHAlt = faEllipsisStroke;
var faAirConditioner = {
  prefix: 'fass',
  iconName: 'air-conditioner',
  icon: [576, 512, [], "f8f4", "M576 64l-576 0 0 256 576 0 0-256zM88 208l424 0 0 48-448 0 0-48 24 0zM208 472c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24-48 0 0 24c0 39.8 32.2 72 72 72s72-32.2 72-72l0-104-48 0 0 104zM368 368l-48 0 0 104c0 39.8 32.2 72 72 72s72-32.2 72-72l0-24-48 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104z"]
};
var faFileXls = {
  prefix: 'fass',
  iconName: 'file-xls',
  icon: [576, 512, [], "e64d", "M272 0l-240 0 0 512 176 0 0-176 208 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM292 400l0-20-40 0 0 20c0 14.4 4.3 28.4 12.2 40.4L280 464 264.2 487.6c-8 12-12.2 26-12.2 40.4l0 20 40 0 0-20c0-6.5 1.9-12.8 5.5-18.2l6.5-9.7 6.5 9.7c3.6 5.4 5.5 11.7 5.5 18.2l0 20 40 0 0-20c0-14.4-4.3-28.4-12.2-40.4L328 464 343.8 440.4c8-12 12.2-26 12.2-40.4l0-20-40 0 0 20c0 6.5-1.9 12.8-5.5 18.2l-6.5 9.7-6.5-9.7c-3.6-5.4-5.5-11.7-5.5-18.2zM400 548l52 0 0-40-32 0 0-128-40 0 0 168 20 0zm76-116c0 28.7 23.3 52 52 52 6.6 0 12 5.4 12 12s-5.4 12-12 12l-52 0 0 40 52 0c28.7 0 52-23.3 52-52s-23.3-52-52-52c-6.6 0-12-5.4-12-12s5.4-12 12-12l44 0 0-40-44 0c-28.7 0-52 23.3-52 52z"]
};
var faPinata = {
  prefix: 'fass',
  iconName: 'pinata',
  icon: [512, 512, [], "e3c3", "M256 176l256 0 0 336-128 0 0-96-160 0 0 96-128 0 0-320-96-48 0-112 192 0 0-64 64 0 0 208zM419.1 323l-34 24.4c-20-18-31.9-28.7-35.6-32-3.1 2.2-17.9 12.9-44.4 32-20-18-31.9-28.7-35.6-32-3.1 2.2-17.9 12.9-44.4 32-20-18-31.9-28.7-35.6-32l-10.5 7.5-44.4 32-13 9.4 18.7 26c5.1-3.7 20.8-15 46.9-33.8l26 23.4 9.6 8.6 10.5-7.5 34-24.5 26 23.4 9.6 8.6 10.5-7.5 34-24.5 26 23.4 9.6 8.6 10.5-7.5 34-24.5 26 23.4 11.9 10.7 21.4-23.8-11.9-10.7-35.6-32-9.6-8.6-10.5 7.5zm0-96l-34 24.4c-20-18-31.9-28.7-35.6-32-3.1 2.2-17.9 12.9-44.4 32-20-18-31.9-28.7-35.6-32-3.1 2.2-17.9 12.9-44.4 32-20-18-31.9-28.7-35.6-32l-10.5 7.5-44.4 32-13 9.4 18.7 26c5.1-3.7 20.8-15 46.9-33.8l26 23.4 9.6 8.6 10.5-7.5 34-24.5 26 23.4 9.6 8.6 10.5-7.5 34-24.5 26 23.4 9.6 8.6 10.5-7.5 34-24.5 26 23.4 11.9 10.7 21.4-23.8-11.9-10.7-35.6-32-9.6-8.6-10.5 7.5zM168 80a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faChartFft = {
  prefix: 'fass',
  iconName: 'chart-fft',
  icon: [512, 512, [], "e69e", "M64 64l0-32-64 0 0 448 512 0 0-64-448 0 0-352zm227.6 47.9L260.6 58.6c-8.2 17.8-43.2 94.3-105.1 229.4l-43.5 0 0 64 84.5 0 8.6-18.7 62.3-136c19.2 33 30.6 52.5 34.2 58.6l78.6 0c30.2 60.5 48.1 96.1 53.5 106.9l57.2-28.6c-3.9-7.8-24.7-49.4-62.3-124.6l-8.8-17.7-81.4 0-46.7-80.1z"]
};
var faCircleUserCircleExclamation = {
  prefix: 'fass',
  iconName: 'circle-user-circle-exclamation',
  icon: [640, 512, [], "e7a0", "M496 208c-77.5 0-144.3 45.9-174.6 112l-145.4 0-23.9 71.6c34.8 34.8 82.8 56.4 135.9 56.4 7.4 0 14.6-.4 21.7-1.2 5.5 21.9 14.8 42.4 27.1 60.6-15.8 3-32.1 4.6-48.8 4.6-141.4 0-256-114.6-256-256S146.6 0 288 0c126.8 0 232.1 92.2 252.4 213.2-14.3-3.4-29.1-5.2-44.4-5.2zM288 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm208-16a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 112 32 0 0-112z"]
};
var faPhoneIntercom = {
  prefix: 'fass',
  iconName: 'phone-intercom',
  icon: [512, 512, [], "e434", "M112 32l-112 0 0 448 112 0 0-448zm400 0l-352 0 0 448 352 0 0-448zM248 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm64 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm112-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 96l224 0 0 160-224 0 0-160z"]
};
var faTurnLeftUp = {
  prefix: 'fass',
  iconName: 'turn-left-up',
  icon: [384, 512, [], "e638", "M192 0l192 192-128 0 0 192 128 0 0 128-256 0 0-320-128 0 192-192z"]
};
var faScarf = {
  prefix: 'fass',
  iconName: 'scarf',
  icon: [576, 512, [129507], "f7c1", "M152.4 0l-24 0 0 225.9 7 7 136 136 17 17 17-17 111-111-113-113-17-17 33.9-33.9 17 17 111 111 0-222.1-296 0zM39.5 375l-17 17 33.9 33.9 17-17 85.1-85.1-33.9-33.9-85.1 85.1zm48 48l-17 17 33.9 33.9 17-17 85.1-85.1-33.9-33.9-85.1 85.1zm48 48l-17 17 33.9 33.9 17-17 85.1-85.1c-11.3-11.3-22.6-22.6-33.9-33.9L135.5 471zm272 33.9l17 17 33.9-33.9-17-17-85.1-85.1c-11.3 11.3-22.6 22.6-33.9 33.9L407.5 505zm48-48l17 17 33.9-33.9-17-17-85.1-85.1-33.9 33.9 85.1 85.1zm48-48l17 17 33.9-33.9-17-17-85.1-85.1-33.9 33.9 85.1 85.1z"]
};
var faMessagePen = {
  prefix: 'fass',
  iconName: 'message-pen',
  icon: [512, 512, ["comment-alt-edit", "message-edit"], "f4a4", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM160 272l144-144 64 64-144 144-80 16 16-80z"]
};
var faCommentAltEdit = faMessagePen;
var faMessageEdit = faMessagePen;
var faIcons = {
  prefix: 'fass',
  iconName: 'icons',
  icon: [576, 512, ["heart-music-camera-bolt"], "f86d", "M336 96.9l0 80.6c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48 64-21.5 64-48l0-110.1 112-33.6 0 49.2c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48 64-21.5 64-48l0-127.1c0-.6 0-1.2 0-1.8l0-55.3-30.9 9.3-160 48-17.1 5.2 0 40.9c0 .6 0 1.2 0 1.8zM128 272l-21.3 32-74.7 0 0 208 288 0 0-208-74.7 0-21.3-32-96 0zm48 88a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM152.7 26.8C140 9.9 120.2 0 99 0 62 0 32 30 32 67l0 6.1c0 73.1 128 146.3 128 146.3S288 146.3 288 73.1l0-6.1c0-37-30-67-67-67-21.1 0-41 9.9-53.6 26.8l-7.3 9.8-7.3-9.8zM528 240l-184 160 81.6 0-57.6 128 184-160-81.6 0 57.6-128z"]
};
var faHeartMusicCameraBolt = faIcons;
var faFileXml = {
  prefix: 'fass',
  iconName: 'file-xml',
  icon: [576, 512, [], "e654", "M272 0l-240 0 0 512 144 0 0-176 240 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM484 400l0-20c-33.7 0-24.7 0-37.6 0l-5.6 10.6-25.1 47.3-26.2-47.5-5.7-10.4c-17.7 0-17.9 0-35.8 0l0 168 40 0 0-77.4c5.8 10.5 15.2 27.6 28.3 51.5 12.7-24 22-41.4 27.7-52.2l0 78.1 40 0 0-148zm-224 0l0-20-40 0 0 20c0 14.4 4.3 28.4 12.2 40.4L248 464 232.2 487.6c-8 12-12.2 26-12.2 40.4l0 20 40 0 0-20c0-6.5 1.9-12.8 5.5-18.2l6.5-9.7 6.5 9.7c3.6 5.4 5.5 11.7 5.5 18.2l0 20 40 0 0-20c0-14.4-4.3-28.4-12.2-40.4L296 464 311.8 440.4c8-12 12.2-26 12.2-40.4l0-20-40 0 0 20c0 6.5-1.9 12.8-5.5 18.2l-6.5 9.7-6.5-9.7c-3.6-5.4-5.5-11.7-5.5-18.2zM508 548l72 0 0-40-32 0 0-128-40 0 0 168z"]
};
var faRulerVertical = {
  prefix: 'fass',
  iconName: 'ruler-vertical',
  icon: [256, 512, [], "f548", "M0-32l256 0 0 72-128 0 0 48 128 0 0 48-96 0 0 48 96 0 0 48-128 0 0 48 128 0 0 48-96 0 0 48 96 0 0 48-128 0 0 48 128 0 0 72-256 0 0-576z"]
};
var faMapLocationDot = {
  prefix: 'fass',
  iconName: 'map-location-dot',
  icon: [640, 512, ["map-marked-alt"], "f5a0", "M576 64l0-51.8c-19.2 9.6-73.4 36.7-162.5 81.2l-179.4-59.8-12.6-4.2-11.9 5.9-128 64-17.7 8.8 0 391.6c19.2-9.6 73.4-36.7 162.5-81.2L387 472.1c-7.1-11.9-13.8-24.3-19.8-37.1-6.1-13.2-11.6-27.4-15.8-42.2l-95.4-31.8 0-252.5 128 42.7 0 83.3c31-35.8 77-58.4 128-58.4 22.6 0 44.2 4.4 64 12.5L576 64zM512 224c-66.3 0-120 52.8-120 117.9 0 94.3 120 212.1 120 212.1S632 436.1 632 341.9C632 276.8 578.3 224 512 224zM472 344a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faMapMarkedAlt = faMapLocationDot;
var faWatermelonSlice = {
  prefix: 'fass',
  iconName: 'watermelon-slice',
  icon: [512, 512, [], "e337", "M391.7 391.4c-96.8 96.8-253.5 96.6-350.4-.3L7.4 425c115.6 115.6 302.6 116 418.3 .3S540.9 122.6 425.3 7L391.4 41c96.9 96.9 97.1 253.6 .3 350.4zM63.6 368.7c84.4 84.4 221.1 84.4 305.5 0 84.2-84.2 84.4-220.7 .3-305.1L353.8 48 48.3 353.5 63.6 368.7zM320.3 137.4c16.2 16.2 36.1 36.1 38.6 38.6l-22.6 22.6c-16.2-16.2-36.1-36.1-38.6-38.6l22.6-22.6zm-80 80c16.2 16.2 36.1 36.1 38.6 38.6l-22.6 22.6c-16.2-16.2-36.1-36.1-38.6-38.6l22.6-22.6zm88 8c16.2 16.2 36.1 36.1 38.6 38.6l-22.6 22.6c-16.2-16.2-36.1-36.1-38.6-38.6l22.6-22.6zm-168 72c16.2 16.2 36.1 36.1 38.6 38.6l-22.6 22.6c-16.2-16.2-36.1-36.1-38.6-38.6l22.6-22.6zm88 8c16.2 16.2 36.1 36.1 38.6 38.6l-22.6 22.6c-16.2-16.2-36.1-36.1-38.6-38.6l22.6-22.6z"]
};
var faJackOLantern = {
  prefix: 'fass',
  iconName: 'jack-o-lantern',
  icon: [512, 512, [127875], "f30e", "M188.5 78.1L208 0 304 0 323.5 78.1c-1.2 .6-2.4 1.2-3.5 1.8-19.3-10-40.8-15.9-64-15.9s-44.7 5.9-64 15.9c-1.2-.6-2.3-1.2-3.5-1.8zM192 470.3C173.2 486.6 151.3 496 128 496 57.3 496 0 410 0 304S57.3 112 128 112c23.3 0 45.2 9.3 64 25.7 18.8-16.3 40.7-25.7 64-25.7s45.2 9.3 64 25.7c18.8-16.3 40.7-25.7 64-25.7 70.7 0 128 86 128 192S454.7 496 384 496c-23.3 0-45.2-9.4-64-25.7-18.8 16.3-40.7 25.7-64 25.7s-45.2-9.4-64-25.7zM176 192l-38.4 64 76.8 0-38.4-64zm160 0l-38.4 64 76.8 0-38.4-64zM96 293.1c6.4 38.8 30.1 72.5 64 94.8l0-19.9 48 0 0 41.6c15.2 4.2 31.3 6.4 48 6.4s32.8-2.3 48-6.5l0-41.5 48 0 0 19.9c33.9-22.3 57.6-56.1 64-94.9-39.3 14.1-85.8 23.1-136 25.3l0 33.7-48 0 0-33.7c-50.2-2.2-96.7-11.2-136-25.2z"]
};
var faCandy = {
  prefix: 'fass',
  iconName: 'candy',
  icon: [576, 512, [127852], "e3e7", "M494.5 282.7L161.9 90.7c35-26.8 78.8-42.7 126.3-42.7 39.6 0 76.5 11 108 30.2l32.1-105.4 47 7 0 41.9 28.3-12.9 31.8 31.8-12.9 28.3 41.9 0 7 47-105.4 32.1c19.2 31.5 30.2 68.5 30.2 108 0 9-.6 18-1.7 26.7zm-12.3 48.4c-7.8 20.2-18.7 38.8-32 55.4L94.2 180.9c7.8-20.2 18.7-38.8 32.1-55.4l356 205.6zm-67.7 90.2c-35 26.8-78.8 42.7-126.3 42.7-39.6 0-76.5-11-108-30.2l-32.1 105.4-47-7 0-41.9-28.3 12.9-31.8-31.8 12.9-28.3-41.9 0-7-47 105.4-32.1c-19.2-31.5-30.2-68.5-30.2-108 0-9.1 .6-18 1.7-26.8l332.6 192z"]
};
var faHeartCrack = {
  prefix: 'fass',
  iconName: 'heart-crack',
  icon: [512, 512, [128148, "heart-broken"], "f7a9", "M288 320l-128-112 80-80-63.3-88.7C162.8 34.5 148.1 32 133.1 32 59.6 32 0 91.6 0 165.1 0 301.9 153.5 425.3 256 496 358.5 425.3 512 301.9 512 165.1 512 91.6 452.4 32 378.9 32 350.1 32 322.6 41.3 300 57.9l20 70.1-96 80 64 112z"]
};
var faHeartBroken = faHeartCrack;
var faCow = {
  prefix: 'fass',
  iconName: 'cow',
  icon: [640, 512, [128004], "f6c8", "M480 64L144 64C77.7 64 24 117.7 24 184l0 54C9.4 249.8 0 267.8 0 288l0 32 8 0c35.3 0 64-28.7 64-64l0-72c0-21.3 9.3-40.5 24-53.7l0 317.7 96 0 0-120.2c9.9 6.6 20.6 12 32 16.1l0 40.2 32 0 0-32.9c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9l0 32.9 32 0 0-40.2c11.4-4 22.1-9.4 32-16.1l0 120.2 96 0 0-192 32 32 0 64 64 96 64 0 32-160-16-22.4 0-105.6-48 0 0 38.4-96-134.4zm80 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM160 128l224 0 0 32-30.1 30.1C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9L160 160 160 128z"]
};
var faRss = {
  prefix: 'fass',
  iconName: 'rss',
  icon: [448, 512, ["feed"], "f09e", "M0 32l32 0c229.8 0 416 186.2 416 416l0 32-64 0 0-32C384 253.6 226.4 96 32 96L0 96 0 32zM0 416a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 160c159.1 0 288 128.9 288 288l0 32-64 0 0-32c0-123.7-100.3-224-224-224l-32 0 0-64 32 0z"]
};
var faFeed = faRss;
var faMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'magnifying-glass',
  icon: [576, 512, [128269, "search"], "f002", "M448.3 208c0 45.9-14.9 88.3-40 122.7L534.9 457.4 557.5 480 512.3 525.3 489.6 502.6 363 376c-34.4 25.2-76.8 40-122.7 40-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208zm-208 144a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
};
var faSearch = faMagnifyingGlass;
var faObjectsAlignLeft = {
  prefix: 'fass',
  iconName: 'objects-align-left',
  icon: [512, 512, [], "e3be", "M0 512L64 512 64 0 0 0 0 512zM128 64l0 160 384 0 0-160-384 0zm0 224l0 160 256 0 0-160-256 0z"]
};
var faCloudMoon = {
  prefix: 'fass',
  iconName: 'cloud-moon',
  icon: [640, 512, [], "f6c3", "M557.8 16.4c-65.3 16.2-113.8 75.2-113.8 145.6 0 82.8 67.2 150 150 150 13.9 0 27.3-1.9 40.1-5.4-28 37.5-69.3 64.5-117 73.8-11.1-25.3-30.2-46.3-54.1-59.8-7.6-63.4-61.6-112.6-127.1-112.6-11.2 0-22.1 1.5-32.5 4.2-4.8-4.2-9.9-8.2-15.2-11.8-.1-2.8-.2-5.6-.2-8.4 0-106 86-192 192-192 27.7 0 54 5.9 77.8 16.4zM32.1 512l0-96.1c0-47.6 34.6-87 80-94.6 0-52.8 42.6-97.3 96-97.3 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.8-14.4 45.8-14.4 44.2 0 80 35.8 80 80l0 17.6c36.5 7.4 64 39.7 64 78.4l.1 80.1-448 0z"]
};
var faAbacus = {
  prefix: 'fass',
  iconName: 'abacus',
  icon: [576, 512, [129518], "f640", "M512 96l0 112-64 0 0-32 32 0 0-48-32 0 0-32 64 0zm-96 32l-32 0 0 48 32 0 0 32-128 0 0-32 32 0 0-48-32 0 0-32 128 0 0 32zm-160 0l-32 0 0 48 32 0 0 32-96 0 0-32 32 0 0-48-32 0 0-32 96 0 0 32zm-128 0l-32 0 0 48 32 0 0 32-64 0 0-112 64 0 0 32zM64 416l0-176 64 0 0 24-32 0 0 48 32 0 0 24-32 0 0 48 32 0 0 32-64 0zm96-32l32 0 0-48-32 0 0-24 32 0 0-48-32 0 0-24 96 0 0 24-32 0 0 48 32 0 0 24-32 0 0 48 32 0 0 32-96 0 0-32zm128-72l32 0 0-48-32 0 0-24 128 0 0 96-32 0 0 48 32 0 0 32-128 0 0-32 32 0 0-48-32 0 0-24zm160 72l32 0 0-48-32 0 0-96 64 0 0 176-64 0 0-32zM64 32l-64 0 0 448 576 0 0-448-512 0z"]
};
var faBoxesStacked = {
  prefix: 'fass',
  iconName: 'boxes-stacked',
  icon: [512, 512, [62625, "boxes", "boxes-alt"], "f468", "M224 0l0 80 64 0 0-80 96 0 0 208-256 0 0-208 96 0zM512 512l-208 0 0-256 48 0 0 80 64 0 0-80 96 0 0 256zM256 256l0 256-256 0 0-256 96 0 0 80 64 0 0-80 96 0z"]
};
var faBoxes = faBoxesStacked;
var faBoxesAlt = faBoxesStacked;
var faCodeBranch = {
  prefix: 'fass',
  iconName: 'code-branch',
  icon: [448, 512, [], "f126", "M56 56l0 48 48 0 0-48-48 0zM0 0l160 0 0 160-48 0 0 64 176 0c26.5 0 48-21.5 48-48l0-16-48 0 0-160 160 0 0 160-48 0 0 16c0 61.9-50.1 112-112 112l-176 0 0 64 48 0 0 160-160 0 0-160 48 0 0-192-48 0 0-160zM392 56l-48 0 0 48 48 0 0-48zM104 456l0-48-48 0 0 48 48 0z"]
};
var faBan = {
  prefix: 'fass',
  iconName: 'ban',
  icon: [512, 512, [128683, "cancel"], "f05e", "M367.2 412.5L99.5 144.8c-22.4 31.4-35.5 69.8-35.5 111.2 0 106 86 192 192 192 41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3c22.4-31.4 35.5-69.8 35.5-111.2 0-106-86-192-192-192-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"]
};
var faCancel = faBan;
var faPersonCarryBox = {
  prefix: 'fass',
  iconName: 'person-carry-box',
  icon: [384, 512, ["person-carry"], "f4cf", "M120 24A56 56 0 1 0 8 24 56 56 0 1 0 120 24zM32 112L0 112 0 272c0 30.2 14.2 58.7 38.4 76.8l89.6 67.2 0 128 64 0 0-160-12.8-9.6-67.2-50.4 0-80.1c16.7 23.4 27.2 38.1 31.5 44.1l240.5 0 0-192-192 0 0 128-15.5 0-70.4-98.6-9.6-13.4-64.5 0zM0 512l0 32 64 0 0-116-54.4-40.8c-3.3-2.5-6.5-5.1-9.6-7.9L0 512z"]
};
var faPersonCarry = faPersonCarryBox;
var faCircleLitecoin = {
  prefix: 'fass',
  iconName: 'circle-litecoin',
  icon: [512, 512, [], "e6f4", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM240 128l0 84.5c46.6-15.5 71.3-23.8 74.1-24.7l10.1 30.4c-1.1 .4-29.2 9.7-84.2 28.1l0 89.8 112 0 0 48-160 0 0-121.8c-19.9 6.6-34 11.3-42.1 14l-10.1-30.4c6.5-2.2 23.9-8 52.2-17.4l0-100.5 48 0z"]
};
var faJugDetergent = {
  prefix: 'fass',
  iconName: 'jug-detergent',
  icon: [384, 512, [], "e519", "M96 0l128 0 0 48 32 0 0 48-192 0 0-48 32 0 0-48zM0 256c0-70.7 57.3-128 128-128l256 0 0 384-384 0 0-256zm256-32l0 160 64 0 0-160-64 0z"]
};
var faFloppyDiskPen = {
  prefix: 'fass',
  iconName: 'floppy-disk-pen',
  icon: [640, 512, [], "e182", "M96 32l-32 0 0 448 217.6 0 9.2-55.1 10.3-10.3c-4.2 .9-8.5 1.3-13 1.3-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64c0 4.4-.5 8.8-1.3 13L512 203.7 512 146.7 406.6 41.4 397.3 32 96 32zm64 64l224 0 0 128-224 0 0-128zM544 240l-52.8 52.8 80 80 52.8-52.8-80-80zM336 448l-16 96 96-16 132.6-132.6-80-80-132.6 132.6z"]
};
var faLips = {
  prefix: 'fass',
  iconName: 'lips',
  icon: [576, 512, [128068, 128482], "f600", "M114.5 118.6L0 256 92.8 367.4C135.4 418.5 198.4 448 264.9 448l46.2 0c66.5 0 129.5-29.5 172.1-80.6L576 256 461.5 118.6C432.7 84 389.9 64 344.9 64L288 102.4 231.1 64c-45.1 0-87.8 20-116.6 54.6zM96 256l96-64 96 32 96-32 80 64-67.7 38.7c-29 16.6-61.8 25.3-95.3 25.3l-31.7 0c-29.8 0-59.2-6.9-85.9-20.3L96 256z"]
};
var faOutlet = {
  prefix: 'fass',
  iconName: 'outlet',
  icon: [448, 512, [], "e01c", "M448 32l-448 0 0 448 448 0 0-448zM64 256c0-88 64-128 64-128l192 0s64 40 64 128-64 128-64 128l-192 0S64 344 64 256zm128-80l-48 0 0 80 48 0 0-80zm112 0l-48 0 0 80 48 0 0-80zM224 288c-17.7 0-32 14.3-32 32l0 16 64 0 0-16c0-17.7-14.3-32-32-32z"]
};
var faReply = {
  prefix: 'fass',
  iconName: 'reply',
  icon: [576, 512, [61714, "mail-reply"], "f3e5", "M16.5 208l239.8-215.9 0 135.9 112 0c97.2 0 176 78.8 176 176 0 128-128 176-128 176s32-32 32-80c0-61.9-50.1-112-112-112l-80 0 0 135.9-239.8-215.9z"]
};
var faMailReply = faReply;
var faSunPlantWilt = {
  prefix: 'fass',
  iconName: 'sun-plant-wilt',
  icon: [640, 512, [], "e57a", "M194.4 76.9l-34.4-76.9-34.4 76.9-78.7-30.1 30.1 78.7-76.9 34.4 76.9 34.4-30.1 78.7 78.7-30.1 34.4 76.9 34.4-76.9 78.7 30.1-30.1-78.7 76.9-34.4-76.9-34.4 30.1-78.7-78.7 30.1zM160 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm376 16l0 53.4c-14.8 7.7-24 23.1-24 44.6 0 19.5 21.5 52.9 48 78 26.5-25 48-58.7 48-78 0-21.5-9.2-37-24-44.6l0-53.4c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 22.7c-9.8-4.3-20.6-6.7-32-6.7-44.2 0-80 35.8-80 80l0 21.4c-14.8 7.6-24 23.1-24 44.6 0 19.5 21.5 52.9 48 78 26.5-25 48-58.7 48-78 0-21.5-9.2-37-24-44.6l0-21.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176-456 0 0 64 640 0 0-64-136 0 0-272c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faFaceMask = {
  prefix: 'fass',
  iconName: 'face-mask',
  icon: [512, 512, [], "e37f", "M75.9 437.9C65.3 427.5 55.7 416.1 47.1 404l67.4 0c8.9 34.5 40.2 60 77.5 60l128 0c37.3 0 68.6-25.5 77.5-60l67.4 0c-8.6 12.1-18.2 23.5-28.8 33.9-20.3 43.8-64.7 74.1-116.1 74.1l-128 0c-51.4 0-95.8-30.3-116.1-74.1zM112 364l-88.2 0C8.5 331.2 0 294.6 0 256 0 254.1 0 252.1 .1 250.2l111.9 49 0 64.8zm376.2 0l-88.2 0 0-64.8 111.9-49c0 1.9 .1 3.8 .1 5.8 0 38.6-8.5 75.2-23.8 108zM9.6 202C8.4 201.5 7.2 201.1 6 200.8 31.2 85.9 133.6 0 256 0S480.8 85.9 506 200.8c-1.2 .3-2.4 .7-3.6 1.3L379 256 133 256 9.6 202zm115.7 6l23.5-17.6c12.5-9.3 27.6-14.4 43.2-14.4l32 0 0-48-32 0c-26 0-51.2 8.4-72 24l-25.6 19.2 27.6 36.8 3.3 0zM390 208L417.6 171.2 392 152c-20.8-15.6-46-24-72-24l-32 0 0 48 32 0c15.6 0 30.7 5.1 43.2 14.4 2.5 1.9 10.3 7.7 23.5 17.6l3.3 0zM176 300l180 0 0 40-200 0 0-40 20 0zm0 80l180 0 0 40-200 0 0-40 20 0z"]
};
var faFalafel = {
  prefix: 'fass',
  iconName: 'falafel',
  icon: [576, 512, [129478], "e40a", "M174.8 113.8l-14.8 30.2 14.8 30.2 .3 .5 13.1-3.3c13 11 24.7 21 35.1 29.8 13.2 2.8 27.9 6 44.3 9.5 6.8 15.1 13.1 29.2 18.9 42.2l1.4 1.1 1.4-1.1c5.8-13 12.1-27 18.9-42.2 16.4-3.5 31.1-6.7 44.3-9.5 10.4-8.8 22.1-18.8 35.1-29.8 16.6 4.2 31.3 7.9 44.2 11.2l1.3-.3-.1-8 14.8-30.2-14.8-30.2 .6-33.8-26.2-20.6-13.8-30.8-32.3-7-25.4-21.6-32 8.1-32-8.1-25.4 21.6-32.3 7-13.8 30.8-26.2 20.6 .6 33.8zm128 224l-14.8 30.2 14.8 30.2-.6 33.8 26.2 20.6 13.8 30.8 32.3 7 25.4 21.6 32-8.1 32 8.1 25.4-21.6 32.3-7 13.8-30.8 26.2-20.6-.6-33.8 14.8-30.2-14.8-30.2 .6-33.8-26.2-20.6-13.8-30.8-32.3-7-25.4-21.6-32 8.1-32-8.1-25.4 21.6-32.3 7-13.8 30.8-26.2 20.6 .6 33.8zM254 288.3l-6.4-5.1-13.8-30.8-32.3-7-25.4-21.6-32 8.1-32-8.1-25.4 21.6-32.3 7-13.8 30.8-26.2 20.6 .6 33.8-14.8 30.2 14.8 30.2-.6 33.8 26.2 20.6 13.8 30.8 32.3 7 25.4 21.6 32-8.1 32 8.1 25.4-21.6 32.3-7 13.8-30.8 6.4-5.1c.2-10 .4-22.9 .7-38.7-6.4-13-13.1-26.7-20.1-41 7-14.3 13.7-28 20.1-41-.3-15.8-.5-28.7-.7-38.7zM128 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTombstoneBlank = {
  prefix: 'fass',
  iconName: 'tombstone-blank',
  icon: [448, 512, [129702, "tombstone-alt"], "f721", "M224 0C118 0 32 86 32 192l0 256-32 0 0 64 448 0 0-64-32 0 0-256C416 86 330 0 224 0z"]
};
var faTombstoneAlt = faTombstoneBlank;
var faCircleCaretUp = {
  prefix: 'fass',
  iconName: 'circle-caret-up',
  icon: [512, 512, ["caret-circle-up"], "f331", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-360l136 168-272 0 136-168z"]
};
var faCaretCircleUp = faCircleCaretUp;
var faLampStreet = {
  prefix: 'fass',
  iconName: 'lamp-street',
  icon: [512, 512, [], "e1c5", "M176 64C114.1 64 64 114.1 64 176l0 336-64 0 0-336C0 78.8 78.8 0 176 0 268.7 0 344.6 71.6 351.5 162.6 442.6 177.6 512 256.7 512 352l-105.5 0c-7.5 41-43.4 72-86.5 72s-79-31-86.5-72L128 352c0-94.9 68.8-173.7 159.2-189.2-6.5-55.6-53.8-98.8-111.2-98.8zM283.3 352c6.2 14.1 20.3 24 36.7 24s30.5-9.9 36.7-24l-73.3 0z"]
};
var faCircleB = {
  prefix: 'fass',
  iconName: 'circle-b',
  icon: [512, 512, [], "e0fd", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 144l92 0c37.6 0 68 30.4 68 68 0 12.7-3.5 24.7-9.6 34.8 15.6 12.5 25.6 31.6 25.6 53.2 0 37.6-30.4 68-68 68l-108 0 0-224zm112 68c0-11-9-20-20-20l-44 0 0 40 44 0c11 0 20-9 20-20zM224 320l60 0c11 0 20-9 20-20s-9-20-20-20l-60 0 0 40z"]
};
var faButterfly = {
  prefix: 'fass',
  iconName: 'butterfly',
  icon: [512, 512, [], "e811", "M55.5 32c85.1 0 160.9 53.9 188.9 134.3l11.6 33.3 11.6-33.3C295.6 85.9 371.4 32 456.5 32l55.5 0 0 220.5-3.9 2.3-113.3 68 60.1 105.2 4.2 7.3-7.6 3.8-134.3 67.2-3.9-5.9-57.3-86-57.3 86-3.9 5.9-134.3-67.2-7.6-3.8 4.2-7.3 60.1-105.2-113.3-68-3.9-2.3 0-220.5 55.5 0z"]
};
var faBacterium = {
  prefix: 'fass',
  iconName: 'bacterium',
  icon: [576, 512, [], "e05a", "M408 16l0-24-48 0 0 47.4c-13.9 5.3-26.9 13.5-38.2 24.5-11.2-11.2-22.4-22.4-33.8-33.8L254.1 64c11.3 11.3 22.6 22.6 33.8 33.8l-30.1 30.1-33.8-33.8-33.9 33.9 33.8 33.8-30.1 30.1c-11.2-11.2-22.4-22.4-33.8-33.8L126.1 192c11.3 11.3 22.6 22.6 33.8 33.8l-30.1 30.1c-11.2-11.2-22.4-22.4-33.8-33.8L62.1 256c11.3 11.3 22.6 22.6 33.8 33.8-11 11.3-19.2 24.3-24.5 38.2l-47.4 0 0 48 40.3 0c1.3 18.3 7.1 36.4 17.4 52.4-6 6-15.2 15.2-27.6 27.6L88 489.9c12.4-12.4 21.6-21.6 27.6-27.6 16 10.3 34.1 16.1 52.4 17.4l0 40.3 48 0 0-47.4c13.9-5.3 26.9-13.5 38.2-24.5 11.2 11.2 22.4 22.4 33.8 33.8L321.9 448c-11.3-11.3-22.6-22.6-33.8-33.8l30.1-30.1 33.8 33.8 33.9-33.9c-11.3-11.3-22.6-22.6-33.8-33.8l30.1-30.1 33.8 33.8 33.9-33.9c-11.3-11.3-22.6-22.6-33.8-33.8l30.1-30.1 33.8 33.8 33.9-33.9c-11.3-11.3-22.6-22.6-33.8-33.8 11-11.3 19.2-24.3 24.5-38.2l47.4 0 0-48-40.3 0c-1.3-18.3-7.1-36.4-17.4-52.4 6-6 15.2-15.2 27.6-27.6L488 22.1c-12.4 12.4-21.6 21.6-27.6 27.6-16-10.3-34.1-16.1-52.4-17.4L408 16zM160 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM272 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSquare7 = {
  prefix: 'fass',
  iconName: 'square-7',
  icon: [448, 512, [], "e25c", "M448 32l-448 0 0 448 448 0 0-448zM144 144l156 0 0 37.7-2.5 5.1-90.6 181.3-53.7 0 9.4-18.7 78.6-157.3-97.2 0 0-48z"]
};
var faMagnifyingGlassArrowsRotate = {
  prefix: 'fass',
  iconName: 'magnifying-glass-arrows-rotate',
  icon: [576, 512, [], "e65e", "M445.8 240c-5.2 33.6-18.4 64.5-37.6 90.7L534.9 457.4 557.5 480 512.3 525.3 489.6 502.6 363 376c-34.4 25.2-76.8 40-122.7 40-53.4 0-102-20.1-138.9-53.1l-45.1 45.1-24-24 0-144 144 0 24 24-53.5 53.5c25.2 21.5 57.8 34.5 93.5 34.5 68.5 0 125.9-47.9 140.4-112l65.1 0zM379.1 53.1l45.1-45.1 24 24 0 144-144 0-24-24 53.5-53.5C308.6 77 275.9 64 240.3 64 171.7 64 114.4 111.9 99.8 176l-65.1 0C50.1 76.3 136.3 0 240.3 0 293.6 0 342.3 20.1 379.1 53.1z"]
};
var faSquareI = {
  prefix: 'fass',
  iconName: 'square-i',
  icon: [448, 512, [], "e272", "M448 32l-448 0 0 448 448 0 0-448zM152 144l168 0 0 48-72 0 0 128 72 0 0 48-192 0 0-48 72 0 0-128-72 0 0-48 24 0z"]
};
var faStandardDefinition = {
  prefix: 'fass',
  iconName: 'standard-definition',
  icon: [512, 512, ["rectangle-sd"], "e28a", "M0 64l512 0 0 384-512 0 0-384zM96 216l0 8c0 30.9 25.1 56 56 56l32 0c4.4 0 8 3.6 8 8l0 8c0 4.4-3.6 8-8 8l-80 0 0 48 80 0c30.9 0 56-25.1 56-56l0-8c0-30.9-25.1-56-56-56l-32 0c-4.4 0-8-3.6-8-8l0-8c0-4.4 3.6-8 8-8l80 0 0-48-80 0c-30.9 0-56 25.1-56 56zm200-56l-24 0 0 192 72 0c39.8 0 72-32.2 72-72l0-48c0-39.8-32.2-72-72-72l-48 0zm24 144l0-96 24 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-24 0z"]
};
var faRectangleSd = faStandardDefinition;
var faAlien8bit = {
  prefix: 'fass',
  iconName: 'alien-8bit',
  icon: [576, 512, [128126, "alien-monster"], "f8f6", "M96 32l64 0 0 32 64 0 0 64 128 0 0-64 64 0 0-32 64 0 0 64-64 0 0 64 64 0 0 64 32 0 0-96 64 0 0 160-64 0 0 96-64 0 0 96-128 0 0-64 64 0 0-32-192 0 0 32 64 0 0 64-128 0 0-96-64 0 0-96-64 0 0-160 64 0 0 96 32 0 0-64 64 0 0-64-64 0 0-64zm64 288l64 0 0-96-64 0 0 96zm192 0l64 0 0-96-64 0 0 96z"]
};
var faAlienMonster = faAlien8bit;
var faVacuum = {
  prefix: 'fass',
  iconName: 'vacuum',
  icon: [640, 512, [], "e04d", "M512 64l-262.1 0-75.4 352 49.6 0 0 96-95.3 0c-.4 0-.9 0-1.3 0L0 512 0 464 48 416 109 416 192.7 25.3 198.1 0 512 0c70.7 0 128 57.3 128 128 0 42.8-21 80.7-53.3 104 13.6 26.4 21.3 56.3 21.3 88l0 192-139.3 0c26.6-23.5 43.3-57.8 43.3-96 0-70.7-57.3-128-128-128-11 0-21.8 1.4-32 4l0-164 64 0c51.2 0 97.8 20.1 132.2 52.8 16.8-11.5 27.8-30.9 27.8-52.8 0-35.3-28.7-64-64-64zM384 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBowlChopsticksNoodles = {
  prefix: 'fass',
  iconName: 'bowl-chopsticks-noodles',
  icon: [576, 512, [], "e2ea", "M32 96l0 32 96-15 0 28-96 3 0 32 96 0 0 48-104 0 3.6 61.2C32.5 368.1 82 438.2 152 472.9l0 39.1 256 0 0-39.1c70-34.6 119.5-104.8 124.4-187.7l3.6-61.2-264 0 0-208-48 0 0 208-48 0 0-192-48 0 0 46-96 18zm288 39l0 41 224 0 0-48-224 7zm0-93l0 41 224-35 0-48-224 42z"]
};
var faRecordVinyl = {
  prefix: 'fass',
  iconName: 'record-vinyl',
  icon: [512, 512, [], "f8d9", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-112a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faFloppyDisk = {
  prefix: 'fass',
  iconName: 'floppy-disk',
  icon: [448, 512, [128190, 128426, "save"], "f0c7", "M32 32l-32 0 0 448 448 0 0-333.3-105.4-105.4-9.4-9.4-301.3 0zM96 96l224 0 0 128-224 0 0-128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faSave = faFloppyDisk;
var faDownLeft = {
  prefix: 'fass',
  iconName: 'down-left',
  icon: [448, 512, [], "e16a", "M32 448L32 96 152 216 336 32 448 144 264 328 384 448 32 448z"]
};
var faToiletsPortable = {
  prefix: 'fass',
  iconName: 'toilets-portable',
  icon: [512, 512, [], "e584", "M224 0L224 80 0 80 0 0 224 0zM0 128l224 0 0 384-48 0 0-32-128 0 0 32-48 0 0-384zm128 96l0 96 48 0 0-96-48 0zM512 0l0 80-224 0 0-80 224 0zM288 128l224 0 0 384-48 0 0-32-128 0 0 32-48 0 0-384zm128 96l0 96 48 0 0-96-48 0z"]
};
var faO = {
  prefix: 'fass',
  iconName: 'o',
  icon: [448, 512, [111], "4f", "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256a224 224 0 1 1 -448 0 224 224 0 1 1 448 0z"]
};
var faPalette = {
  prefix: 'fass',
  iconName: 'palette',
  icon: [512, 512, [127912], "f53f", "M256 0C397.4 0 512 114.6 512 256l0 64-156.1 0c-37.5 0-67.9 30.4-67.9 67.9 0 18 7.2 35.3 19.9 48L320 448 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faPaintbrushFineSlash = {
  prefix: 'fass',
  iconName: 'paintbrush-fine-slash',
  icon: [576, 512, [], "e74d", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-194.9-194.9 191-191c25-25 25-65.5 0-90.5s-65.5-25-90.5 0l-191 191-226.6-226.6zM176.1 288c-61.9 0-112 50.1-112 112l0 48-64 0 0 64 176 0c61.9 0 112-50.1 112-112 0-21.6-6.1-41.8-16.7-58.9L235 304.7c-17.1-10.6-37.3-16.7-58.9-16.7z"]
};
var faBlueberries = {
  prefix: 'fass',
  iconName: 'blueberries',
  icon: [512, 512, [], "e2e8", "M512 176c0-97.2-78.8-176-176-176-80.6 0-148.6 54.2-169.4 128.2 3.1-.1 6.3-.2 9.4-.2 114.9 0 208 93.1 208 208 0 3.2-.1 6.3-.2 9.4 74-20.8 128.2-88.8 128.2-169.4zM176 512a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm16-304l0 48 48 0 0 32-48 0 0 48-32 0 0-48-48 0 0-32 48 0 0-48 32 0zM384 64l0 32 48 0 0 32-48 0 0 48-32 0 0-48-48 0 0-32 48 0 0-48 32 0 0 16z"]
};
var faFishBones = {
  prefix: 'fass',
  iconName: 'fish-bones',
  icon: [576, 512, [], "e304", "M32 96l-32 32 64 128-64 128 32 32 64-64 0-72 40 0 0 96 48 0 0-96 48 0 0 96 48 0 0-96 48 0 0 96 48 0 0-96 40 0 0 120 32 0 128-144-128-144-32 0 0 120-40 0 0-96-48 0 0 96-48 0 0-96-48 0 0 96-48 0 0-96-48 0 0 96-40 0 0-72-64-64z"]
};
var faUnlock = {
  prefix: 'fass',
  iconName: 'unlock',
  icon: [384, 512, [128275], "f09c", "M128 96c0-35.3 28.7-64 64-64 31.7 0 58 23 63.1 53.3l5.3 31.6 63.1-10.6-5.3-31.6C308.1 14.1 255.5-32 192-32 121.3-32 64 25.3 64 96l0 64-64 0 0 352 384 0 0-352-256 0 0-64z"]
};
var faFanTable = {
  prefix: 'fass',
  iconName: 'fan-table',
  icon: [448, 512, [], "e004", "M256 413.6C355.7 398.2 432 312 432 208 432 93.1 338.9 0 224 0S16 93.1 16 208c0 104 76.3 190.2 176 205.6l0 34.4-128 0 0 64 320 0 0-64-128 0 0-34.4zM178.9 53.7L224.3 166c18.5-25.3 50-39.8 83.3-35.1 48.1 6.8 81.7 51.3 74.9 99.4l-2.2 15.8-120-16.9c12.6 28.7 9.5 63.2-11.2 89.7-29.9 38.3-85.2 45.1-123.5 15.2l-12.6-9.8 74.6-95.5c-31.2-3.4-59.5-23.4-72.1-54.5-18.2-45.1 3.6-96.4 48.6-114.6l14.8-6zM224 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faEarListen = {
  prefix: 'fass',
  iconName: 'ear-listen',
  icon: [512, 512, ["assistive-listening-systems"], "f2a2", "M361.8 56.6L395.2 2c65.7 39.4 110.9 109.2 116.3 190l-64.2 0c-5.2-57.6-38.2-107.3-85.4-135.4zM160 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm54.6-86.6L173.3 448 128 493.3c-8.2-8.2-37.1-37.1-86.6-86.6L18.7 384 64 338.7 86.6 361.4zM240 128c-61.9 0-112 50.1-112 112l-64 0c0-97.2 78.8-176 176-176s176 78.8 176 176c0 54.7-25 103.5-64 135.8l0 24.2c0 61.9-50.1 112-112 112l-32 0 0-64 32 0c26.5 0 48-21.5 48-48l0-57.3 14.2-9.5c30.1-20.1 49.8-54.4 49.8-93.2 0-61.9-50.1-112-112-112zM208 240l-48 0c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faAssistiveListeningSystems = faEarListen;
var faCodePullRequest = {
  prefix: 'fass',
  iconName: 'code-pull-request',
  icon: [512, 512, [], "e13c", "M320 40l0-57.9c-65.6 65.6-96.8 96.8-97.9 97.9 17.6 17.6 84.8 84.8 97.9 97.9l0-65.9 32 0c17.7 0 32 14.3 32 32l0 208-48 0 0 160 160 0 0-160-48 0 0-208c0-53-43-96-96-96l-32 0 0-8zM72 56l48 0 0 48-48 0 0-48zM16 0l0 160 48 0 0 192-48 0 0 160 160 0 0-160-48 0 0-192 48 0 0-160-160 0zM72 408l48 0 0 48-48 0 0-48zm368 0l0 48-48 0 0-48 48 0z"]
};
var faThumbtackAngle = {
  prefix: 'fass',
  iconName: 'thumbtack-angle',
  icon: [576, 512, [], "e751", "M374.9 9.4L352.3-13.3 307 32c17 17 28.2 28.2 33.5 33.5L235.1 155.8c-60.1-11.2-124.6 6.4-171.2 53L335.5 480.3c46.5-46.5 64.2-111 53-171.2l90.4-105.4c5.3 5.3 16.4 16.4 33.5 33.5l45.3-45.3-22.6-22.6-160-160zM41.6 457.4L19 480 64.3 525.3c1.9-1.9 43.3-43.3 124.1-124.1L143.1 355.9 41.6 457.4z"]
};
var faKey = {
  prefix: 'fass',
  iconName: 'key',
  icon: [512, 512, [128273], "f084", "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0 160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7l-161.3 161.3-7 7 0 113.9 128 0 0-64 64 0 0-64 49.9 0 7-7 33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faSnake = {
  prefix: 'fass',
  iconName: 'snake',
  icon: [512, 512, [128013], "f716", "M512 80l-160-64-64 48-112 0C96.5 64 32 128.5 32 208S96.5 352 176 352l144 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0-96 48 96 48 224 0c70.7 0 128-57.3 128-128S390.7 256 320 256l-144 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l112 0 64 48 160-64 0-64zM352 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faCircleWaveformLines = {
  prefix: 'fass',
  iconName: 'circle-waveform-lines',
  icon: [512, 512, ["waveform-circle"], "e12d", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM240 152l0 232-48 0 0-256 48 0 0 24zm96 48l0 136-48 0 0-160 48 0 0 24zM144 216l0 104-48 0 0-128 48 0 0 24zm288 16l0 72-48 0 0-96 48 0 0 24z"]
};
var faWaveformCircle = faCircleWaveformLines;
var faEmptySet = {
  prefix: 'fass',
  iconName: 'empty-set',
  icon: [576, 512, [8709, 216], "f656", "M534.9 54.6L557.5 32 512.3-13.3c-11.5 11.5-33.8 33.8-67 67-43.3-33.7-97.8-53.8-157-53.8-141.4 0-256 114.6-256 256 0 59.2 20.1 113.6 53.8 157-33.2 33.2-55.6 55.6-67 67l45.3 45.3c11.5-11.5 33.8-33.8 67-67 43.3 33.7 97.8 53.8 157 53.8 141.4 0 256-114.6 256-256 0-59.2-20.1-113.6-53.8-157l44.4-44.4zM399.5 99.5L131.8 367.2c-22.4-31.4-35.5-69.8-35.5-111.2 0-106 86-192 192-192 41.5 0 79.9 13.1 111.2 35.5zM177 412.5L444.8 144.8c22.4 31.4 35.5 69.8 35.5 111.2 0 106-86 192-192 192-41.5 0-79.9-13.1-111.2-35.5z"]
};
var faCircleWon = {
  prefix: 'fass',
  iconName: 'circle-won',
  icon: [512, 512, [], "e6ec", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM232.1 144l47.7 0 4.1 18.8 20.5 93.2 18.7 0c23.8-69.4 36.4-106.2 37.9-110.5l45.4 15.6c-2.4 6.9-13.2 38.5-32.5 94.9l26.1 0 0 32-37 0-32.8 95.8-5.6 16.2-37.6 0-4.1-18.8-20.5-93.1-12.7 0c-16.4 74.5-24.6 111.8-24.6 112l-37.6 0-5.6-16.2-32.8-95.8-37 0 0-32 26.1 0c-19.3-56.4-30.2-88-32.5-94.9l45.4-15.6c1.5 4.3 14.1 41.1 37.9 110.5l18.7 0c16.4-74.5 24.6-111.8 24.6-112z"]
};
var faHockeyStick = {
  prefix: 'fass',
  iconName: 'hockey-stick',
  icon: [576, 512, [], "e7e6", "M128.1 512l-64 0 0-192 64 0 0 192zM553.7-17.8l-203.9 509.7-8.1 20.1-165.7 0 0-192 173.5 0 132.7-331.9 11.9-29.7 59.4 23.8z"]
};
var faMonkey = {
  prefix: 'fass',
  iconName: 'monkey',
  icon: [576, 512, [128018], "f6fb", "M160 416c0-80.6 49.6-149.6 120-178l0 50 167.9 0 118.2 112.9 9.9 9.5 0 101.7-64 0 0-74.3-96-91.6 0 101.9 64 0 0 64-320 0C71.6 512 0 440.4 0 352l0-352 224 0 0 192-128 0 0-64 64 0 0-64-96 0 0 288c0 53 43 96 96 96l0-32zm96-288c0-35.3 28.6-64 64-64 15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64 0 32.6-24.4 59.6-56 63.5l0 64.5-208 0 0-64.5c-31.6-3.9-56-30.9-56-63.5zM384 64c-26.5 0-48 21.5-48 48 0 23.8 17.3 43.5 40 47.3l0 48.7 80 0 0-48.7c22.7-3.8 40-23.6 40-47.3 0-26.5-21.5-48-48-48l-64 0zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faForklift = {
  prefix: 'fass',
  iconName: 'forklift',
  icon: [576, 512, [], "f47a", "M512 32l0 384 64 0 0 64-128 0 0-480 64 0 0 32zM160 96l0 64 64 96 90.4 0-68.6-160-85.8 0zM96 160l0-128 192 0 96 224 0 100.1c19.5 16.1 32 40.6 32 67.9 0 48.6-39.4 88-88 88-40.3 0-74.2-27.1-84.7-64l-70.6 0c-10.4 36.9-44.4 64-84.7 64-48.6 0-88-39.4-88-88l0-264 96 0zm32 264a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm240 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z"]
};
var faSkull = {
  prefix: 'fass',
  iconName: 'skull',
  icon: [512, 512, [128128], "f54c", "M416 427.4c58.5-44 96-111.6 96-187.4 0-132.5-114.6-240-256-240S0 107.5 0 240c0 75.8 37.5 143.4 96 187.4l0 84.6 80 0 0-64 48 0 0 64 64 0 0-64 48 0 0 64 80 0 0-84.6zM96 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faSneaker = {
  prefix: 'fass',
  iconName: 'sneaker',
  icon: [640, 512, [], "e6da", "M0 128l0 224 640 0 0-19.6c0-62.6-45.2-116-107-126.3l-83.4-13.9-65.7 65.7-33.9-33.9 57.1-57.1-37.2-22.9-66 66-33.9-33.9 57.9-57.9-87.9-54.1-48 0 0 100.7c0 32.8-26.6 59.3-59.3 59.3-22.5 0-43-12.7-53.1-32.8L48 128 0 128zM640 400l-640 0 0 48 640 0 0-48z"]
};
var faGamepadModern = {
  prefix: 'fass',
  iconName: 'gamepad-modern',
  icon: [576, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M576 128l0 352-160 0-32-96-192 0-32 96-160 0 0-352 96-96 384 0 96 96zM136 144l0 56-56 0 0 48 56 0 0 56 48 0 0-56 56 0 0-48-56 0 0-56-48 0zm264 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64-96a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faGamepadAlt = faGamepadModern;
var faSquareK = {
  prefix: 'fass',
  iconName: 'square-k',
  icon: [448, 512, [], "e274", "M448 32l-448 0 0 448 448 0 0-448zM265.7 144l68.9 0-9.6 9.3-85 82.6 4.6 7.7 66 110 8.6 14.3-56 0-58.6-97.7-28.6 27.8 0 69.9-48 0 0-224 48 0 0 87.2 89.7-87.2z"]
};
var faCommentText = {
  prefix: 'fass',
  iconName: 'comment-text',
  icon: [512, 512, [], "e14d", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM184 144l-24 0 0 48 72 0 0 144 48 0 0-144 72 0 0-48-168 0z"]
};
var faMarsStrokeUp = {
  prefix: 'fass',
  iconName: 'mars-stroke-up',
  icon: [384, 512, [9896, "mars-stroke-v"], "f22a", "M192 256a112 112 0 1 0 0 224 112 112 0 1 0 0-224zM16 368c0-86.3 62.1-158 144-173.1l0-18.9-64 0 0-64 64 0 0-61.4C140.8 65.9 123.2 80.1 107 93L67 43c7.5-6 42.5-34 105-84l20-16c3.3 2.7 36.7 29.3 100 80l25 20-40 50c-16.2-12.9-33.8-27.1-53-42.4l0 61.4 64 0 0 64-64 0 0 18.9c81.9 15 144 86.8 144 173.1 0 97.2-78.8 176-176 176S16 465.2 16 368z"]
};
var faMarsStrokeV = faMarsStrokeUp;
var faCowbell = {
  prefix: 'fass',
  iconName: 'cowbell',
  icon: [512, 512, [], "f8b3", "M160-16l192 0 0 80 48 0 88 352-464 0 88-352 48 0 0-80zM304 32l-96 0 0 32 96 0 0-32zM256 512c-32.8 0-61-19.7-73.3-48l146.7 0c-12.3 28.3-40.5 48-73.3 48z"]
};
var faFireFlameSimple = {
  prefix: 'fass',
  iconName: 'fire-flame-simple',
  icon: [384, 512, ["burn"], "f46a", "M203.1 9.7L192 0 180.9 9.7C104.2 76.8 45.7 162.2 10.9 258 3.7 277.8 0 299 0 320.2 0 425.4 86.8 512 192 512s192-86.6 192-191.8c0-21.1-3.7-42.3-10.9-62.2-34.8-95.8-93.3-181.2-170-248.3zm78.7 296.2c4.1 9.3 6.2 19.4 6.2 29.5 0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l.9-2.1c16.4-36.8 40.5-69.6 70.8-96.1l18-15.7 18 15.7c30.3 26.5 54.5 59.3 70.8 96.1l.9 2.1z"]
};
var faBurn = faFireFlameSimple;
var faTree = {
  prefix: 'fass',
  iconName: 'tree',
  icon: [512, 512, [127794], "f1bb", "M256-32l-176 208 76.3 0-108.3 128 89.8 0-121.8 144 208 0 0 96 64 0 0-96 208 0-121.8-144 89.8 0-108.3-128 76.3 0-176-208z"]
};
var faGaugeSimpleMin = {
  prefix: 'fass',
  iconName: 'gauge-simple-min',
  icon: [512, 512, ["tachometer-slowest"], "f62d", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm320 96c0-35.3-28.7-64-64-64-14.5 0-27.8 4.8-38.5 12.9l-109.1-65.5-24.7 41.2 109.1 65.5c-.5 3.2-.8 6.6-.8 9.9 0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faTachometerSlowest = faGaugeSimpleMin;
var faCommentsQuestionCheck = {
  prefix: 'fass',
  iconName: 'comments-question-check',
  icon: [576, 512, [], "e14f", "M384 144c0 97.2-86 176-192 176-22.8 0-44.7-3.6-65-10.3L0 352 35.4 245.8C13.1 217.1 0 181.9 0 144 0 46.8 86-32 192-32S384 46.8 384 144zm0 368c-94.1 0-172.4-62.1-188.8-144 34.3-.4 67.4-7.7 97.3-20.6l8.3 11.1 48 64 7.2 9.6 25.3 0 7-11.3 80-128 12.7-20.4-40.7-25.4c-.4 .6-25.1 40.1-74.2 118.7l-27-36-4.3-5.7c52.7-36.3 89.5-92.5 96-158.6 83.3 19.2 145 88.3 145 170.7 0 37.9-13.1 73.1-35.4 101.8L576 544 460.1 497.6C436.8 506.9 411 512 384 512zM160 101.2c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.2-6.8 20.5-15.8 25.6-9.4 5.3-20 6.6-30.5 8-2.3 .3-4.6 .6-6.9 .9l0 53.5 42.4 0 0-18.3c4.8-1.7 10.3-4 15.8-7.1 17.6-9.9 37.4-29.2 37.4-62.5 0-41.1-33.3-74.4-74.4-74.4s-74.4 33.3-74.4 74.4l42.4 0zM216 216l-48 0 0 48 48 0 0-48z"]
};
var faSmog = {
  prefix: 'fass',
  iconName: 'smog',
  icon: [576, 512, [], "f75f", "M436.7 288l107.3 0 0-112c0-61.9-50.1-112-112-112l-1.1 0C408.7 25.7 367.4 0 320 0 294.3 0 270.4 7.6 250.3 20.6 228.6 7.5 203.2 0 176 0 96.5 0 32 64.5 32 144l0 144 235.3 0c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32zM512 392c0-13.3-10.7-24-24-24L24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24zM88 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm176 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l288 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288 0z"]
};
var faS = {
  prefix: 'fass',
  iconName: 's',
  icon: [320, 512, [115], "53", "M0 157.5C0 88.2 56.2 32 125.5 32l178.5 0 0 64-178.5 0c-34 0-61.5 27.5-61.5 61.5 0 31 23.1 57.2 53.9 61L210.1 230C272.9 237.9 320 291.2 320 354.5 320 423.8 263.8 480 194.5 480l-178.5 0 0-64 178.5 0c34 0 61.5-27.5 61.5-61.5 0-31-23.1-57.2-53.9-61L109.9 282C47.1 274.1 0 220.8 0 157.5z"]
};
var faPhoneArrowUpRight = {
  prefix: 'fass',
  iconName: 'phone-arrow-up-right',
  icon: [512, 512, ["phone-arrow-up", "phone-outgoing"], "e224", "M128 0L0 64 0 80C0 318.6 193.4 512 432 512l16 0 64-128-128-96.8-80 80.8c-70.4-33-127-89.6-160-160L224.8 128 128 0zM335.1 143l-17 17 33.9 33.9 17-17 95-95 0 70.1 48 0 0-152-152 0 0 48 70.1 0-95 95z"]
};
var faPhoneArrowUp = faPhoneArrowUpRight;
var faPhoneOutgoing = faPhoneArrowUpRight;
var faTeddyBear = {
  prefix: 'fass',
  iconName: 'teddy-bear',
  icon: [512, 512, [], "e3cf", "M96.2 56c0 23 13.8 42.7 33.7 51.4-1.1 6.7-1.7 13.6-1.7 20.6 0 70.7 57.3 128 128 128s128-57.3 128-128c0-7-.6-13.9-1.7-20.6 19.8-8.6 33.7-28.4 33.7-51.4 0-30.9-25.1-56-56-56-22.3 0-41.6 13.1-50.6 32L202.9 32c-9-18.9-28.3-32-50.6-32-30.9 0-56 25.1-56 56zm288 312.1c63.4-33.9 111.9-92.2 132.7-162.4l-92-27.4C403.3 251 335.9 304 256.2 304S109.2 251 87.5 178.3l-92 27.4c20.9 70.1 69.3 128.5 132.7 162.4l0 47.9-32 0 0-32-96 0 0 128 512 0 0-128-96 0 0 32-32 0 0-47.9zM192.2 416c0-35.3 28.7-64 64-64s64 28.7 64 64l-128 0zm16-324a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm76 20a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zm-28 80c-17.7 0-32-10.7-32-24s14.3-24 32-24 32 10.7 32 24-14.3 24-32 24z"]
};
var faSlotMachine = {
  prefix: 'fass',
  iconName: 'slot-machine',
  icon: [640, 512, [], "e3ce", "M512 416l48 0 0-236.3c-9.8-8.8-16-21.5-16-35.7 0-26.5 21.5-48 48-48s48 21.5 48 48c0 14.2-6.2 26.9-16 35.7l0 300.3-592 0 0-448 480 0 0 384zM96 160l0 48 41 0-37.3 144 49.6 0 42-162 .8-3 0-27-96 0zm128 0l0 48 41 0-37.3 144 49.6 0 42-162 .8-3 0-27-96 0zm128 0l0 48 41 0-37.3 144 49.6 0 42-162 .8-3 0-27-96 0z"]
};
var faFaceSleeping = {
  prefix: 'fass',
  iconName: 'face-sleeping',
  icon: [640, 512, [], "e38d", "M533.8-60l0 40 44 0-39.4 37.5-6.2 5.9 0 36.6 105.6 0 0-40-44 0 39.4-37.5 6.2-5.9 0-36.6-105.6 0zM388.2 36l0 40 44 0-39.4 37.5-6.2 5.9 0 36.6 105.6 0 0-40-44 0 39.4-37.5 6.2-5.9 0-36.6-105.6 0zM336.2 .5c-5.3-.3-10.6-.5-16-.5-141.4 0-256 114.6-256 256s114.6 256 256 256 256-114.6 256-256c0-16.4-1.5-32.5-4.5-48l-235.5 0 0-207.5zM196.2 280c0 11 9 20 20 20l16 0c11 0 20-9 20-20s9-20 20-20 20 9 20 20c0 33.1-26.9 60-60 60l-16 0c-33.1 0-60-26.9-60-60 0-11 9-20 20-20s20 9 20 20zm212 20l16 0c11 0 20-9 20-20s9-20 20-20 20 9 20 20c0 33.1-26.9 60-60 60l-16 0c-33.1 0-60-26.9-60-60 0-11 9-20 20-20s20 9 20 20 9 20 20 20zm-128 116a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faJedi = {
  prefix: 'fass',
  iconName: 'jedi',
  icon: [576, 512, [], "f669", "M245.2 318.3l-25.1-50.2 50.1 25.1 9.8-293.2 16 0 9.8 293.2 50.1-25.1-25.1 50.2 53.2 17.7-53.2 17.7 25.1 50.2-47.2-23.6 2.2 65.7c59.8-10.8 105.1-63.1 105.1-126 0-38.3-16.8-72.7-43.5-96.1 45.3-28.3 75.5-78.5 75.5-135.9 0-30.5-8.5-59-23.3-83.2 64.9 37.8 112.8 101.7 129.2 177.4L512 224 559.5 224c.3 5.3 .5 10.6 .5 16 0 18.2-1.8 36-5.2 53.2L496 352 535.9 352C493.3 446.4 398.3 512 288 512S82.7 446.4 40.1 352l39.9 0-58.8-58.8c-3.4-17.2-5.2-35-5.2-53.2 0-5.4 .2-10.7 .5-16l47.5 0-41.8-41.8c16.4-75.6 64.2-139.6 129.2-177.4-14.8 24.2-23.3 52.7-23.3 83.2 0 57.3 30.2 107.6 75.5 135.9-26.7 23.5-43.5 57.8-43.5 96.1 0 62.9 45.4 115.2 105.1 126l2.2-65.7-47.2 23.6 25.1-50.2-53.2-17.7 53.2-17.7z"]
};
var faPoliceBox = {
  prefix: 'fass',
  iconName: 'police-box',
  icon: [384, 512, [], "e021", "M216 0l0 32 104 0 0 32 32 0 0 400 32 0 0 48-384 0 0-48 32 0 0-400 32 0 0-32 104 0 0-32 48 0zM96 240l0 80 80 0 0-80-80 0zm80-112l-80 0 0 80 80 0 0-80zm32 0l0 80 80 0 0-80-80 0z"]
};
var faDogLeashed = {
  prefix: 'fass',
  iconName: 'dog-leashed',
  icon: [576, 512, [129454], "f6d4", "M64 144c0 17.7 14.3 32 32 32l128 0 0 191.2c-22.9-2.1-44.5-8.5-64-18.5l0 163.3-96 0 0-277.6C26.7 221.2 0 185.8 0 144l0-32 64 0 0 32zm215.1 38.3l136.9 54.8 0 275-96 0 0-163.3c-14.9 7.6-31 13.2-48 16.3l0-185.6 7.1 2.8zM392 0l72 0 32 32 80 0 0 48c0 44.2-35.8 80-80 80l-64 0-7.2 28.8-125.4-50.1 36.6-170.7 32 0 24 32zM128.4-1.5l136 128 1.6 1.5-70 0-100.4-94.5-17.5-16.4 32.9-35 17.5 16.5zM448 44a20 20 0 1 0 0 40 20 20 0 1 0 0-40z"]
};
var faPersonHiking = {
  prefix: 'fass',
  iconName: 'person-hiking',
  icon: [448, 512, ["hiking"], "f6ec", "M192-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM128 112l93.3 0 9.4 9.4 70.6 70.6 66.7 0 0-96 48 0 0 448-48 0 0-288-93.3 0c-3.6-3.6-15.2-15.2-34.7-34.7l0 109.2 52.8 45.3 9.1 7.8 1.7 11.9c12.6 88.1 19.4 135.9 20.5 143.7l-63.4 9.1c-1.4-9.7-7.7-53.6-18.8-131.8l-80.5-69c-21.3-18.2-33.5-44.9-33.5-72.9L128 112zm47.5 310.7c-.6 1.9-1.7 5-3.1 9.3l-4 4.7-88 104-48.9-41.3 84-99.3 7.6-22.7c2.3 2.3 4.7 4.4 7.1 6.5l45.2 38.8zM0 160c0-35.3 28.7-64 64-64l32 0 0 192-96 0 0-128z"]
};
var faHiking = faPersonHiking;
var faArrowsUpToLine = {
  prefix: 'fass',
  iconName: 'arrows-up-to-line',
  icon: [512, 512, [], "e4c2", "M64.3 0l-32 0 0 64 448 0 0-64-416 0zm86.6 137.4l-22.6-22.6c-8.2 8.2-37.1 37.1-86.6 86.6L19 224 64.3 269.3c17.3-17.3 28-28 32-32l0 274.7 64 0 0-274.7c4 4 14.7 14.7 32 32L237.5 224c-8.2-8.2-37.1-37.1-86.6-86.6zm256 0l-22.6-22.6c-8.2 8.2-37.1 37.1-86.6 86.6L275 224 320.3 269.3c17.3-17.3 28-28 32-32l0 274.7 64 0 0-274.7c4 4 14.7 14.7 32 32L493.5 224c-8.2-8.2-37.1-37.1-86.6-86.6z"]
};
var faPenLine = {
  prefix: 'fass',
  iconName: 'pen-line',
  icon: [640, 512, [], "e212", "M72 328L16 528 216 472 439 249 295 105 72 328zM560 128l-144-144-87 87 144 144 87-87zM312 464l-24 0 0 48 320 0 0-48-296 0z"]
};
var faBadgePercent = {
  prefix: 'fass',
  iconName: 'badge-percent',
  icon: [512, 512, [], "f646", "M256 0C292.8 0 324.8 20.7 340.9 51.1 373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209l17-17-33.9-33.9-17 17-128 128-17 17 33.9 33.9 17-17 128-128z"]
};
var faMarsDouble = {
  prefix: 'fass',
  iconName: 'mars-double',
  icon: [640, 512, [9891], "f227", "M288 0l192 0 0 192-64 0 0-82.7-95 95c19.5 28.4 31 62.7 31 99.8 0 97.2-78.8 176-176 176S0 401.2 0 304 78.8 128 176 128c37 0 71.4 11.4 99.8 31l95-95-82.7 0 0-64zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm160 64c-6.8 0-13.4-.4-20-1.1 23.6-18.9 43.3-42.5 57.6-69.4 43.3-15.5 74.4-56.9 74.4-105.5 0-23.8-7.4-45.9-20.1-64l72.1 0c7.7 19.8 12 41.4 12 64 0 97.2-78.8 176-176 176zM528 157.3l0-157.3 112 0 0 192-64 0 0-82.7-48 48z"]
};
var faThermometer = {
  prefix: 'fass',
  iconName: 'thermometer',
  icon: [512, 512, [], "f491", "M96.4 382.1l0-112 7-7 31-31 49 49 33.9-33.9-49-49 46.1-46.1 49 49 33.9-33.9-49-49 46.1-46.1 49 49 33.9-33.9-49-49 7.8-7.8c19.4-19.4 45.6-30.2 73-30.2 57 0 103.2 46.2 103.2 103.2 0 27.4-10.9 53.6-30.2 73l-232.8 232.8-7 7-112 0-81 81-17 17-33.9-33.9c.6-.6 33.3-33.3 97.9-97.9z"]
};
var faPaintbrush = {
  prefix: 'fass',
  iconName: 'paintbrush',
  icon: [576, 512, [128396, "paint-brush"], "f1fc", "M496 0l-288 192 0 51.2c62.7 12.7 112.1 62.1 124.8 124.8L384 368 576 80 496 0zM288 400c0-61.9-50.1-112-112-112S64 338.1 64 400c0 17.2 3.9 33.4 10.8 48l-74.8 0 0 64 176 0c61.9 0 112-50.1 112-112z"]
};
var faPaintBrush = faPaintbrush;
var faSignalStream = {
  prefix: 'fass',
  iconName: 'signal-stream',
  icon: [576, 512, [], "f8dd", "M400 256c0-36.4-17.3-68.7-44.2-89.1L405.6 125c35.9 32.2 58.4 79 58.4 131s-22.6 98.8-58.4 131l-49.7-41.9C382.7 324.7 400 292.4 400 256zM84.3 52.4l49.2 41.4C90.7 134.7 64 192.2 64 256s26.7 121.4 69.5 162.1L84.3 459.6C32.2 407.5 0 335.5 0 256S32.2 104.5 84.3 52.4zM220.2 345.1L170.4 387C134.6 354.8 112 308 112 256s22.6-98.8 58.4-131l49.7 41.9C193.3 187.3 176 219.6 176 256s17.3 68.7 44.2 89.1zM491.7 459.6l-49.2-41.4C485.3 377.4 512 319.8 512 256S485.3 134.7 442.5 93.9l49.2-41.4C543.8 104.5 576 176.5 576 256s-32.2 151.5-84.3 203.6zM288 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faSquareP = {
  prefix: 'fass',
  iconName: 'square-p',
  icon: [448, 512, [], "e279", "M448 32l-448 0 0 448 448 0 0-448zM168 144l68 0c46.4 0 84 37.6 84 84s-37.6 84-84 84l-44 0 0 56-48 0 0-224 24 0zm68 120c19.9 0 36-16.1 36-36s-16.1-36-36-36l-44 0 0 72 44 0z"]
};
var faBee = {
  prefix: 'fass',
  iconName: 'bee',
  icon: [512, 512, [], "e0b2", "M330.1 448c-36.5 37.3-73.7 63.7-74.1 64-.4-.3-37.6-26.7-74.1-64l148.2 0zM256 319.9c26.9 35.8 63.5 63.7 105.9 80.1l-211.8 0c42.4-16.3 79.1-44.3 105.9-80.1zM361.9 24L326.9 59c5.8 11.1 9.1 23.6 9.1 37l0 34.7c90.8 15.2 160 94.2 160 189.3l0 48-48 0c-102.7 0-186.6-80.7-191.8-182.1L256 176c0 106-86 192-192 192l-48 0 0-48c0-95.1 69.2-174.1 160-189.3L176 96c0-13.3 3.3-25.9 9.1-37l-35-35 33.9-33.9 35 35c11.1-5.8 23.6-9.1 37-9.1 13.3 0 25.9 3.3 36.9 9.1L328-9.9 361.9 24z"]
};
var faMusicSlash = {
  prefix: 'fass',
  iconName: 'music-slash',
  icon: [576, 512, [], "f8d1", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-92.3-92.3c26-14.3 43.2-38.9 43.2-66.8l0-343.9-38.9 8.7-288 64-25.1 5.6 0 23.6-110.8-110.8zM253.3 187.2l194.8-43.3 0 116.7c-10-3-20.8-4.6-32-4.6-27.2 0-51.8 9.5-69.3 24.6l-93.5-93.5zm-93.2 42.6l0 94.7c-10-3-20.8-4.6-32-4.6-53 0-96 35.8-96 80s43 80 96 80 96-35.8 96-80l0-106.2-64-64z"]
};
var faPersonSimple = {
  prefix: 'fass',
  iconName: 'person-simple',
  icon: [192, 512, [], "e220", "M32 64A64 64 0 1 1 160 64 64 64 0 1 1 32 64zm160 96l0 192-32 0 0 160-128 0 0-160-32 0 0-192 192 0z"]
};
var faAlbumCollectionCircleUser = {
  prefix: 'fass',
  iconName: 'album-collection-circle-user',
  icon: [576, 512, [], "e48f", "M128 0l0 48 256 0 0-48-256 0zM64 192L8.7 192c1.2 8.3 14.5 101.3 39.8 278.8L54.4 512 276 512c-10.5-14.6-19-30.8-25.1-48.1-86-1.9-154.9-51.3-154.9-111.9 0-61.9 71.6-112 160-112 20.8 0 40.7 2.8 58.9 7.8 32.4-25 73-39.8 117.1-39.8 23.7 0 46.4 4.3 67.3 12.1l4-28.1-439.3 0zM241.2 378c2.2-19 7.1-37.1 14.4-54-21.9 .1-39.6 12.6-39.6 28 0 11.8 10.5 21.9 25.2 26zM104 96l-24 0 0 48 352 0 0-48-328 0zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64.5 78.9C491.2 499.4 463.1 512 432 512s-59.2-12.6-79.5-33.1l15.5-30.9 128 0 15.5 30.9zM384 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faWhale = {
  prefix: 'fass',
  iconName: 'whale',
  icon: [640, 512, [128011], "f72c", "M160 0l24 104 104 24-80 80-80.8-11.5-36.6 58.6c-6.7 10.7-8.3 23.9-4.3 35.9 5.8 17.3 22 29 40.3 29l1.1 0c10.5 0 20.7-3.8 28.6-10.6l103.8-89C329.7 160.8 418.4 128 510.1 128l129.9 0 0 352-477.6 0C72.7 480 0 407.3 0 317.6 0 278.2 15.7 240.3 43.6 212.4L92 164 80 80 160 0zM400 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowUpTriangleSquare = {
  prefix: 'fass',
  iconName: 'arrow-up-triangle-square',
  icon: [512, 512, ["sort-shapes-up"], "f88a", "M150.9 41.4L128.3 18.7 25.6 121.4 3 144 48.3 189.3c14.6-14.6 30.6-30.6 48-48l0 338.7 64 0 0-338.7c17.4 17.4 33.4 33.4 48 48L253.5 144c-5.5-5.5-39.7-39.7-102.6-102.6zM384.3 32l-112 192 224 0-112-192zm96 256l-192 0 0 192 192 0 0-192z"]
};
var faSortShapesUp = faArrowUpTriangleSquare;
var faNeuter = {
  prefix: 'fass',
  iconName: 'neuter',
  icon: [384, 512, [9906], "f22c", "M80 176a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM224 349.1c81.9-15 144-86.8 144-173.1 0-97.2-78.8-176-176-176S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1l0 194.9 64 0 0-194.9z"]
};
var faSquarePhoneFlip = {
  prefix: 'fass',
  iconName: 'square-phone-flip',
  icon: [448, 512, ["phone-square-alt"], "f87b", "M448 32l-448 0 0 448 448 0 0-448zM288 128l64 32 0 8c0 119.3-96.7 216-216 216l-8 0-32-64 64-48.4 40 40.4c35.2-16.5 63.5-44.8 80-80l-40.4-40 48.4-64z"]
};
var faPhoneSquareAlt = faSquarePhoneFlip;
var faCircleG = {
  prefix: 'fass',
  iconName: 'circle-g',
  icon: [512, 512, [], "e10f", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-328c-39.8 0-72 32.2-72 72s32.2 72 72 72c28.3 0 52.7-16.3 64.5-40l-56.5 0 0-48 112 0 0 21-.4 5c-5.1 61.6-56.7 110-119.6 110-66.3 0-120-53.7-120-120s53.7-120 120-120c30.7 0 58.8 11.6 80 30.6l-32 35.8c-12.8-11.4-29.5-18.3-48-18.3z"]
};
var faCircleDownRight = {
  prefix: 'fass',
  iconName: 'circle-down-right',
  icon: [512, 512, [], "e108", "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm72 352l-169.9 0c29.6-29.6 52.3-52.3 68-68l-84-84c24.3-24.3 54.1-54.1 57.9-57.9l84 84c15.7-15.7 38.4-38.4 68-68l0 193.9-24 0z"]
};
var faPeopleDress = {
  prefix: 'fass',
  iconName: 'people-dress',
  icon: [640, 512, [], "e217", "M248.3 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm256 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM375.4 252.7l-47.1 147.3 40 0 0 144 64 0 0-144 32 0 0 144 64 0 0-144 40 0-47.1-147.3c19.9 37.3 33.9 63.5 42 78.6l56.5-30.2-15.1-28.2-76.9-144-9-16.9-140.5 0-9 16.9-48.7 91.2-48.7-91.2-9-16.9-140.5 0-9 16.9-76.9 144-15.1 28.2 56.5 30.2c8.1-15.1 22.1-41.3 42-78.6l-47.1 147.3 40 0 0 144 64 0 0-144 32 0 0 144 64 0 0-144 40 0-47.1-147.3c20.9 39.2 32.9 61.6 35.9 67.3l38.4 0c3-5.7 15-28.1 36-67.3z"]
};
var faCircleHalf = {
  prefix: 'fass',
  iconName: 'circle-half',
  icon: [512, 512, [], "e110", "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512L256 0z"]
};
var faFaceGrinTongueSquint = {
  prefix: 'fass',
  iconName: 'face-grin-tongue-squint',
  icon: [512, 512, [128541, "grin-tongue-squint"], "f58a", "M0 256c0 104.4 62.5 194.2 152.2 234.1-5.3-13-8.2-27.2-8.2-42.1l0-61.7c-23.5-23-39.9-53.2-45.7-87 45.3 18.1 99.5 28.7 157.7 28.7s112.4-10.6 157.7-28.7c-5.8 33.8-22.2 64-45.7 87l0 61.7c0 14.9-2.9 29.1-8.2 42.1 89.7-39.8 152.2-129.6 152.2-234.1 0-141.4-114.6-256-256-256S0 114.6 0 256zm230.8-78.3l9.2 4.6 0 20.2-10.2 4.3-95.6 40-14.7-28.3 44.2-27.6-45.3-34 16.8-27.1 95.6 48zm146-48l16.8 27.1-45.3 34 44.2 27.6-14.7 28.3-95.6-40-10.2-4.3 0-20.2 9.2-4.6 95.6-48zM320 448l0-64-48 0 0 24-32 0 0-24-48 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faGrinTongueSquint = faFaceGrinTongueSquint;
var faPickaxe = {
  prefix: 'fass',
  iconName: 'pickaxe',
  icon: [576, 512, [], "e5bf", "M576 224c0 57-18.6 109.7-50.2 152.3-47.6-173.7-184.4-310.5-358.1-358.1 42.6-31.5 95.2-50.2 152.3-50.2 59.2 0 113.6 20.1 157 53.8 6.6-6.6 18.2-18.2 35-35L557.3 32c-16.8 16.8-28.5 28.5-35 35 33.7 43.3 53.8 97.8 53.8 157zM41.4 457.4L336.7 162c16.1 14 31.2 29.2 45.3 45.3L86.6 502.6 64 525.3 18.7 480 41.4 457.4z"]
};
var faCommentDollar = {
  prefix: 'fass',
  iconName: 'comment-dollar',
  icon: [512, 512, [], "f651", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM280 128l-40 0 0 24c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5l-75.5 0 0 40 44 0 0 24 40 0 0-24.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l67.5 0 0-40-28 0 0-24z"]
};
var faListTimeline = {
  prefix: 'fass',
  iconName: 'list-timeline',
  icon: [512, 512, [], "e1d1", "M240 16l208 0 0 128-214.6 0-4.7-4.7c-38.1-38.1-57.9-57.9-59.3-59.3 1.4-1.4 21.2-21.2 59.3-59.3l4.7-4.7 6.6 0zm-6.6 176l278.6 0 0 128-278.6 0-4.7-4.7c-38.1-38.1-57.9-57.9-59.3-59.3 1.4-1.4 21.2-21.2 59.3-59.3l4.7-4.7zm0 176l214.6 0 0 128-214.6 0-4.7-4.7c-38.1-38.1-57.9-57.9-59.3-59.3 1.4-1.4 21.2-21.2 59.3-59.3l4.7-4.7zM32 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM80 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faSwordsLaser = {
  prefix: 'fass',
  iconName: 'swords-laser',
  icon: [640, 512, [], "e03d", "M426.9 215.8L640-24 600-64 355.3 153.5 426.9 215.8zM182.1 297.9l-26.7 26.7 96 96 26.7-26.7-96-96zm46.6 145.4l-96-96-25.4 25.4 96 96 25.4-25.4zM0 480l96 96 84.7-84.7-96-96-84.7 84.7zM364 224L40-64 0-24 220.4 224 364 224zM595.3 508.7L640 464 531.3 355.3 486.6 400 595.3 508.7zm-22.6 22.6L464 422.6 419.3 467.3 528 576 572.7 531.3zm-176-86.6l112-112-60.7-60.7-224 0 172.7 172.7z"]
};
var faPhoneWaveform = {
  prefix: 'fass',
  iconName: 'phone-waveform',
  icon: [640, 512, [], "e6e2", "M480-8l0-24-48 0 0 256 48 0 0-232zm80 32l0-24-48 0 0 192 48 0 0-168zM400 40l0-24-48 0 0 160 48 0 0-136zM640 72l0-24-48 0 0 96 48 0 0-72zM192 0L64 64 64 80c0 238.6 193.4 432 432 432l16 0 64-128-128-96.8-80 80.8c-70.4-33-127-89.6-160-160L288.7 128 192 0z"]
};
var faHippo = {
  prefix: 'fass',
  iconName: 'hippo',
  icon: [640, 512, [129435], "f6ed", "M424.5 30.1c11.3 11.3 22.7 22.7 34.2 34.2 1.9-.1 3.9-.2 5.8-.2l32 0c11.2 0 21.9 2.3 31.6 6.5 10-10 20.9-20.9 32.4-32.4L594.4 72c-12 12-22 22-29.9 29.9 7.6 12.2 12 26.7 12 42.1l0 17.6c36.5 7.4 64 39.7 64 78.4 0 26.2-12.6 49.4-32 64l0 48-64 0 0-32-64 0 0 32-64 0 0-33.6c-11.8-2.4-22.7-7.4-32-14.4-1.5-1.1-2.9-2.3-4.3-3.5-17-14.7-27.7-36.4-27.7-60.5l0-16-32 0 0 16c0 44.7 26.2 83.2 64 101.2l0 42.8 64 0 0 96-128 0 0-108c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12l0 108-128 0 0-150.9-18.1 40.7-43.9-19.5 29.9-67.3 0-18.9c0-107.7 85.1-195.5 191.8-199.8l.2-.2 64 0 109 36.3c3.8-5.9 8.4-11.2 13.6-15.8l-3.5-3.5-17-17 33.9-33.9zm56 201.9a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-88-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faSwordLaserAlt = {
  prefix: 'fass',
  iconName: 'sword-laser-alt',
  icon: [640, 512, [], "e03c", "M600-64L276 224 419.6 224 640-24 600-64zM0 464L44.7 508.7 153.4 400 108.7 355.3 0 464zM112 576L220.7 467.3 176 422.6 67.3 531.3 112 576zm19.3-243.3l112 112 172.7-172.7-224 0-60.7 60.7z"]
};
var faFlower = {
  prefix: 'fass',
  iconName: 'flower',
  icon: [448, 512, [127804, 10047], "f7ff", "M128 480c38.2 0 72.5-16.8 96-43.3 23.5 26.6 57.8 43.3 96 43.3 70.7 0 128-57.3 128-128 0-38.2-16.8-72.5-43.3-96 26.6-23.5 43.3-57.8 43.3-96 0-70.7-57.3-128-128-128-38.2 0-72.5 16.8-96 43.3-23.5-26.6-57.8-43.3-96-43.3-70.7 0-128 57.3-128 128 0 38.2 16.8 72.5 43.3 96-26.6 23.5-43.3 57.8-43.3 96 0 70.7 57.3 128 128 128zm96-128l-96-96 96-96 96 96-96 96z"]
};
var faBowlFood = {
  prefix: 'fass',
  iconName: 'bowl-food',
  icon: [512, 512, [], "e4c6", "M0 176c0-35.3 28.7-64 64-64 .5 0 1.1 0 1.6 0 7.4-36.5 39.7-64 78.4-64 15 0 29 4.1 40.9 11.2 13.3-25.7 40.1-43.2 71.1-43.2s57.8 17.6 71.1 43.2c12-7.1 26-11.2 40.9-11.2 38.7 0 71 27.5 78.4 64 .5 0 1.1 0 1.6 0 35.3 0 64 28.7 64 64 0 11.7-3.1 22.6-8.6 32L8.6 208C3.1 198.6 0 187.7 0 176zM0 280l0-24 512 0 0 24c0 67-39.2 124.9-96 151.8l0 48.2-320 0 0-48.2C39.2 404.9 0 347 0 280z"]
};
var faGlobePointer = {
  prefix: 'fass',
  iconName: 'globe-pointer',
  icon: [640, 512, [], "e60e", "M351.9 280l95.6 0c-3.9 62.3-22.3 121.2-45.3 165.5-13 25-26.6 43.7-38.3 55.4-5.4 5.4-9.3 8.2-11.6 9.7-2.3-1.5-6.2-4.3-11.6-9.7-11.5-11.5-24.9-29.8-37.7-54.3l47.4-161.1 1.6-5.5zm14.1-48l9.1-30.9c-66.9 19.7-101.9 30-105 30.9L257 232c3.9-62.3 22.3-121.2 45.3-165.5 13-25 26.6-43.7 38.3-55.4 5.4-5.4 9.3-8.2 11.6-9.7 2.3 1.5 6.2 4.3 11.6 9.7 11.7 11.7 25.3 30.4 38.3 55.4 23 44.3 41.5 103.2 45.3 165.5l-81.4 0zM97.4 232c9.8-105.6 83.7-192.5 182.4-221.6-35.2 52.1-66 133.6-70.9 221.6L97.4 232zm509.8 48c-9.8 105.6-83.7 192.5-182.4 221.6 35.2-52.1 66-133.6 70.9-221.6l111.6 0zM424.7 10.4c98.7 29.1 172.6 116 182.4 221.6l-111.6 0c-4.9-88-35.7-169.5-70.9-221.6zM32.3 352l272-80-80 272-48-96-1.4-1.4C105.3 516.2 68.4 553.1 64.3 557.3L19 512c4.2-4.2 41.1-41.1 110.6-110.6l-1.4-1.4-96-48z"]
};
var faEggplant = {
  prefix: 'fass',
  iconName: 'eggplant',
  icon: [512, 512, [], "e16c", "M480 65.9l31.4-31.4-33.9-33.9-31.4 31.4-158.1 0 16 48 48 16 16 48 48 16 16 48 48 16 0-158.1zM257.4 92c-26.9 17.9-57.3 32.7-87.5 47.3-86.5 42-171.5 83.3-169.9 196.7 1.4 95.3 79.8 175.9 176.4 176 125.3 .1 220.1-129.1 270.3-248.5-21.1-7-38.7-12.9-52.7-17.6-4.9-14.8-10.3-30.8-16-48-17.2-5.7-33.2-11.1-48-16-4.9-14.8-10.3-30.8-16-48-17.2-5.7-33.2-11.1-48-16l-7.6-22.8-1.1-3.2z"]
};
var faFolderArrowRight = {
  prefix: 'fass',
  iconName: 'folder-arrow-right',
  icon: [512, 512, [], "e7d3", "M224 32l64 48 224 0 0 368-512 0 0-416 224 0zm6.1 160l48 48-126.1 0 0 48 126.1 0-48 48 33.9 33.9 105.9-105.9-105.9-105.9-33.9 33.9z"]
};
var faBatterySlash = {
  prefix: 'fass',
  iconName: 'battery-slash',
  icon: [640, 512, [], "f377", "M81.2-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-64.1-64.1 62 0 0-128 32 0 0-128-32 0 0-128-446 0-80.9-80.9zM226 128l318 0 0 256-62 0-256-256zM346.2 384l-250.2 0 0-250.2-64-64 0 378.2 378.2 0-64-64z"]
};
var faFilmSlash = {
  prefix: 'fass',
  iconName: 'film-slash',
  icon: [576, 512, [], "e179", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-5.9-5.9-28-28-66.1-66.1l0-414-414 0-48.9-48.9zM64.1 480l346.2 0-234.2-234.2 0 42.2-64 0 0-64 42.2 0-90.2-90.2 0 346.2zm48-128l64 0 0 64-64 0 0-64zm288-128l64 0 0 64-64 0 0-64zm64-128l0 64-64 0 0-64 64 0z"]
};
var faSquareVirus = {
  prefix: 'fass',
  iconName: 'square-virus',
  icon: [448, 512, [], "e578", "M448 32l-448 0 0 448 448 0 0-448zM308.9 137.2l33.9 33.9-17 17C309.6 204.3 321.1 232 344 232l24 0 0 48-24 0c-22.9 0-34.4 27.7-18.2 43.9l17 17-33.9 33.9-17-17C275.7 341.6 248 353.1 248 376l0 24-48 0 0-24c0-22.9-27.7-34.4-43.9-18.2l-17 17-33.9-33.9 17-17c16.2-16.2 4.7-43.9-18.2-43.9l-24 0 0-48 24 0c22.9 0 34.4-27.7 18.2-43.9l-17-17 33.9-33.9 17 17c16.2 16.2 43.9 4.7 43.9-18.2l0-24 48 0 0 24c0 22.9 27.7 34.4 43.9 18.2l17-17zM192 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faTricycleAdult = {
  prefix: 'fass',
  iconName: 'tricycle-adult',
  icon: [640, 512, [], "e5c4", "M288 64l96.8 0 9.5 13.8 125.5 181.3c7.7-2 15.8-3.1 24.2-3.1 53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-21.4 7-41.1 18.8-57.1l-18.2-26.3-83.4 83.4-142.4 0c-7.8 54.3-54.4 96-110.9 96-61.9 0-112-50.1-112-112 0-45.3 26.9-84.3 65.6-102-25-74.9-39-117-42.1-126.3L84.2 87.5c4.3 12.9 15.9 47.8 34.8 104.5l104.9 0 0 64-33.6 0c9.4 9.2 17.1 20 22.8 32l125.5 0 72.8-72.8-60.3-87.2-63.2 0 0-64zM176 336a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm368 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faCirclePhoneFlip = {
  prefix: 'fass',
  iconName: 'circle-phone-flip',
  icon: [512, 512, ["phone-circle-alt"], "e11c", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm64-384l64 32 0 8c0 119.3-96.7 216-216 216l-8 0-32-64 64-48.4 40 40.4c35.2-16.5 63.5-44.8 80-80l-40.4-40 48.4-64z"]
};
var faPhoneCircleAlt = faCirclePhoneFlip;
var faCloudSunRain = {
  prefix: 'fass',
  iconName: 'cloud-sun-rain',
  icon: [640, 512, [127782], "f743", "M335.6-3.2l-4.7-23.2c-4.7 3.1-34.8 23.1-90.5 60-55.6-36.9-85.8-56.9-90.5-60-1.1 5.5-8.3 41-21.5 106.4-65.4 13.2-100.9 20.4-106.4 21.5 3.1 4.7 23.1 34.9 60 90.5-36.9 55.6-56.9 85.8-60 90.5 5.5 1.1 41 8.3 106.4 21.5 13.2 65.4 20.4 100.9 21.5 106.4 10-6.6 29.5-19.6 58.5-38.8l0-89.1c-37.3-13.2-64-48.7-64-90.5 0-53 43-96 96-96 21.7 0 41.8 7.2 57.8 19.4 15.5-17.6 36.9-30 61.1-34l-7-1.4-16.8-83.2zM275.4 159.1c-8.8-9.3-21.2-15.1-35-15.1-26.5 0-48 21.5-48 48 0 17 8.9 32 22.2 40.5 10.2-31.4 32.1-57.4 60.7-73l.1-.4zM608.4 352l0-80c0-33.9-21.1-62.9-50.9-74.5 1.9-6.8 2.9-14 2.9-21.5 0-44.2-35.8-80-80-80-30.8 0-57.5 17.4-70.9 42.8-9.3-6.8-20.7-10.8-33.1-10.8-34.2 0-60.9 32-55.2 65.4-36.9 7.1-64.8 39.6-64.8 78.6l0 80 352 0zM255.1 512l50.6 0 37.3-112-50.6 0-37.3 112zm290.6 0l37.3-112-50.6 0-37.3 112 50.6 0zm-120 0l37.3-112-50.6 0-37.3 112 50.6 0z"]
};
var faH4 = {
  prefix: 'fass',
  iconName: 'h4',
  icon: [512, 512, [], "f86a", "M64 96l0-32-64 0 0 384 64 0 0-160 96 0 0 160 64 0 0-384-64 0 0 160-96 0 0-128zm288 0l0-32-64 0 0 224 160 0 0 160 64 0 0-384-64 0 0 160-96 0 0-128z"]
};
var faCircleCaretRight = {
  prefix: 'fass',
  iconName: 'circle-caret-right',
  icon: [512, 512, ["caret-circle-right"], "f330", "M0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zm360 0l-168 136 0-272 168 136z"]
};
var faCaretCircleRight = faCircleCaretRight;
var faKeyboardBrightnessLow = {
  prefix: 'fass',
  iconName: 'keyboard-brightness-low',
  icon: [512, 512, [], "e1c1", "M224 128l0 64 64 0 0-64-64 0zM96 178.7L50.7 224 96 269.3 141.3 224 96 178.7zM64 352l-64 0 0 64 64 0 0-64zm96 0l-32 0 0 64 256 0 0-64-224 0zm352 0l-64 0 0 64 64 0 0-64zM416 178.7L370.7 224 416 269.3 461.3 224 416 178.7z"]
};
var faArrowRightLong = {
  prefix: 'fass',
  iconName: 'arrow-right-long',
  icon: [640, 512, ["long-arrow-right"], "f178", "M598.9 278.6L621.5 256 598.9 233.4 448.3 82.7 403 128c6.6 6.6 38.6 38.6 96 96l-466.7 0 0 64 466.7 0-96 96 45.3 45.3 150.6-150.6z"]
};
var faLongArrowRight = faArrowRightLong;
var faFontCase = {
  prefix: 'fass',
  iconName: 'font-case',
  icon: [576, 512, [], "f866", "M96.4 168l0 88 96 0 0-88c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm-64 120l0-120c0-57.4 46.6-104 104-104l16 0c57.4 0 104 46.6 104 104l0 280-64 0 0-128-96 0 0 128-64 0 0-160zm392-32c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-16 0zm56-56l0-8 64 0 0 170.8c17.6 52.9 27.1 81.3 28.4 85.2l-67.5 0-6.1-18.2c-16.7 11.5-37 18.2-58.9 18.2l-16 0c-57.4 0-104-46.6-104-104l0-48c0-57.4 46.6-104 104-104l16 0c14.2 0 27.7 2.8 40 8z"]
};
var faBuildingUn = {
  prefix: 'fass',
  iconName: 'building-un',
  icon: [512, 512, [], "e4d9", "M32 0l384 0 0 336-176 0 0 16-64 0 0 112 64 0 0 48-208 0 0-512zM192 96l-64 0 0 64 64 0 0-64zm64 0l0 64 64 0 0-64-64 0zM192 224l-64 0 0 64 64 0 0-64zm64 0l0 64 64 0 0-64-64 0zM412 380l37.2 0c.7 1.7 9.6 22.7 26.8 63l0-63 40 0 0 168-38.8 0c-1-2.3-9.4-22.1-25.2-59.2l0 59.2-40 0 0-168zm-88 20l0 96c0 6.6 5.4 12 12 12s12-5.4 12-12l0-116 40 0 0 116c0 28.7-23.3 52-52 52s-52-23.3-52-52l0-116 40 0 0 20z"]
};
var faToiletPaperXmark = {
  prefix: 'fass',
  iconName: 'toilet-paper-xmark',
  icon: [512, 512, [], "e5b3", "M305.2 66.8C311 55.1 318.3 43.1 327.1 32L96 32C43 32 0 118 0 224S43 416 96 416l231.1 0c-8.8-11.1-16-23.1-21.9-34.8-21.4-42.7-33.2-98.4-33.2-157.2s11.8-114.5 33.2-157.2zM384 224c0-35.3 14.3-64 32-64s32 28.7 32 64-14.3 64-32 64-32-28.7-32-64zm128 0c0-106-43-192-96-192s-96 86-96 192 43 192 96 192 96-86 96-192zM128 464l0 80 384 0 0-137.6c-21.3 30.9-53 57.6-96 57.6l-288 0zM228.9 173.1c-8.5 8.5-25.5 25.5-50.9 50.9 25.5 25.5 42.4 42.4 50.9 50.9l-33.9 33.9c-8.5-8.5-25.5-25.5-50.9-50.9-25.5 25.5-42.4 42.4-50.9 50.9L59.1 274.9c8.5-8.5 25.5-25.5 50.9-50.9-25.5-25.5-42.4-42.4-50.9-50.9l33.9-33.9 50.9 50.9c25.5-25.5 42.4-42.4 50.9-50.9l33.9 33.9z"]
};
var faTemperatureLow = {
  prefix: 'fass',
  iconName: 'temperature-low',
  icon: [512, 512, [], "f76b", "M96 0l192 0 0 260.7c29.5 26.4 48 64.7 48 107.3 0 79.5-64.5 144-144 144S48 447.5 48 368c0-42.6 18.5-81 48-107.3L96 0zm96 432c35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3l0-52.7-48 0 0 52.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64zM464 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM352 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faH2 = {
  prefix: 'fass',
  iconName: 'h2',
  icon: [576, 512, [], "f314", "M96 96l0-32-64 0 0 384 64 0 0-160 96 0 0 160 64 0 0-384-64 0 0 160-96 0 0-128zM368 64l-32 0 0 64 113.1 0c21.5 0 38.9 17.4 38.9 38.9 0 13.9-7.5 26.8-19.6 33.8l-76.3 43.6C347.5 269.7 320 317.1 320 368.5l0 79.5 224 0 0-64-160 0 0-15.5c0-28.4 15.2-54.6 39.9-68.7l76.3-43.6C532.2 237.9 552 203.8 552 166.9 552 110.1 505.9 64 449.1 64L368 64z"]
};
var faFaceSmileHalo = {
  prefix: 'fass',
  iconName: 'face-smile-halo',
  icon: [512, 512, [], "e38f", "M512 48c0-44.2-114.6-80-256-80S0 3.8 0 48 114.6 128 256 128 512 92.2 512 48zm-64 0c0 17.7-86 32-192 32S64 65.7 64 48 150 16 256 16 448 30.3 448 48zm48 224c0-45.7-12.8-88.4-35-124.8-3.2 1.1-6.4 2.2-9.7 3.2-52.1 16.3-121.2 25.6-195.3 25.6s-143.2-9.3-195.3-25.6c-3.3-1-6.5-2.1-9.7-3.2-22.2 36.4-35 79.1-35 124.8 0 132.5 107.5 240 240 240S496 404.5 496 272zM163.8 351.5C184 380.9 217.8 400 256 400s72-19.1 92.2-48.5l39.5 27.3C358.9 420.6 310.7 448 256 448s-102.9-27.4-131.8-69.2l39.5-27.3zM148 272l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28s-28 12.5-28 28zm188-28c-15.5 0-28 12.5-28 28l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28z"]
};
var faRocketVertical = {
  prefix: 'fass',
  iconName: 'rocket-vertical',
  icon: [448, 512, [], "e7bd", "M167.4 424.6c3.2-3.2 6.6-6 10.1-8.6l92.9 0c3.5 2.5 6.9 5.4 10.1 8.6L384 528 432 352 340.6 260.6C376 107.5 285.7 25.1 224-16 162.3 25.1 72 107.5 107.4 260.6L16 352 64 528 167.4 424.6zM224 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faDoorOpen = {
  prefix: 'fass',
  iconName: 'door-open',
  icon: [448, 512, [], "f52b", "M288 64l64 0 0 448 96 0 0-64-32 0 0-448-160 0 0 0-224 0 0 448-32 0 0 64 288 0 0-448zM160 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faAlignLeft = {
  prefix: 'fass',
  iconName: 'align-left',
  icon: [448, 512, [], "f036", "M288 32l0 64-288 0 0-64 288 0zm0 256l0 64-288 0 0-64 288 0zM0 160l448 0 0 64-448 0 0-64zM448 416l0 64-448 0 0-64 448 0z"]
};
var faPencilSlash = {
  prefix: 'fass',
  iconName: 'pencil-slash',
  icon: [576, 512, [], "e215", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-184.4-184.4c18-18 38.7-38.7 62.3-62.3-15.6-15.6-52.3-52.3-110.1-110.1l-33.9-33.9c-23.6 23.6-44.3 44.3-62.3 62.3L49.3-16.9zM164.9 234.6L72.1 327.4c-31.5 112.6-50.2 179.3-56 200 20.8-5.8 87.4-24.5 200-56l92.8-92.8-144-144zM115 352.5l1.1-1 28.1 0 0 48 48 0 0 28.1-1.1 1.1-105.7 29.6 29.6-105.7zm324.2-172l33.9 33.9c53.4-53.4 60.2-60.2 87-87-15.6-15.6-52.3-52.3-110.1-110.1L416.1-16.6c-53.4 53.4-60.2 60.2-87 87 15.6 15.6 52.3 52.3 110.1 110.1z"]
};
var faCamera = {
  prefix: 'fass',
  iconName: 'camera',
  icon: [512, 512, [62258, "camera-alt"], "f030", "M160 32l-32 64-128 0 0 384 512 0 0-384-128 0-32-64-192 0zm96 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faCameraAlt = faCamera;
var faHatWinter = {
  prefix: 'fass',
  iconName: 'hat-winter',
  icon: [512, 512, [], "f7a8", "M282.5 32L256 5.5 229.5 32 192 32 192 69.5 165.5 96 192 122.5 192 139.3C128.4 163.5 87.4 223.7 62.9 292.6l65.1 32.6 117.3-58.6 10.7-5.4 128 64 65.1-32.6C424.6 223.7 383.6 163.5 320 139.3l0-16.8 26.5-26.5-26.5-26.5 0-37.5-37.5 0zM479.1 448c-1.9-34.5-7-72-16-108.7l-79.1 39.5-128-64-117.3 58.6-10.7 5.4-10.7-5.4-68.4-34.2c-9 36.7-14.1 74.2-16 108.7l-32.9 0 0 64 512 0 0-64-32.9 0z"]
};
var faHousePersonReturn = {
  prefix: 'fass',
  iconName: 'house-person-return',
  icon: [640, 512, ["house-person-arrive", "house-return"], "e011", "M472 24a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm-8 88l13.3 0 9.4 9.4 80 80 9.4 9.4 0 109.3-64 0 0-82.7-32-32 0 69.3c0 28-12.2 54.7-33.5 72.9l-80.7 69.1c-11 71.6-17.4 112.9-19.1 123.9l-63.3-9.7c1.4-9 8.3-54.2 20.9-135.6l1.8-11.7 9-7.7 52.8-45.3 0-115.2c-17.6 22-28.4 35.6-32.6 40.8l-111.4 0 0-64 80.6 0 54.4-68 9.6-12 95.4 0zm15.9 259l12.6 44.2c44.7 44.7 71.6 71.6 80.8 80.8l-45.3 45.3-86.6-86.6-5.9-5.9c-.8-2.7-3.8-13.2-9-31.5l46-39.4c2.5-2.2 5-4.4 7.4-6.8zM308.9 109.8l-27.4 34.2-105.6 0 0 160 144 0 0 4.3c-27.6 23.6-44.6 38.2-50.9 43.7L48 352 48 192 16 192 16 161.2 192 8 308.9 109.8z"]
};
var faHousePersonArrive = faHousePersonReturn;
var faHouseReturn = faHousePersonReturn;
var faKnife = {
  prefix: 'fass',
  iconName: 'knife',
  icon: [576, 512, ["utensil-knife"], "f2e4", "M480 16l-464 464 48 48 192-192 64 64 181.5-181.5c50-50 50-131 0-181L480 16z"]
};
var faUtensilKnife = faKnife;
var faMessageExclamation = {
  prefix: 'fass',
  iconName: 'message-exclamation',
  icon: [512, 512, ["comment-alt-exclamation"], "f4a5", "M512 448l-224 0-160 96 0-96-128 0 0-416 512 0 0 416zM228 308l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0z"]
};
var faCommentAltExclamation = faMessageExclamation;
var faRightToLine = {
  prefix: 'fass',
  iconName: 'right-to-line',
  icon: [512, 512, ["arrow-alt-to-right"], "f34c", "M512 64l0 384-64 0 0-384 64 0zM395 256l-18.5 17.4c-113.3 107-174.7 165-184.5 174.2l0-127.7-192 0 0-128 192 0 0-127.7c9.7 9.2 71.2 67.3 184.5 174.2L395 256z"]
};
var faArrowAltToRight = faRightToLine;
var faMailbox = {
  prefix: 'fass',
  iconName: 'mailbox',
  icon: [576, 512, [128234], "f813", "M240 208c0-53-43-96-96-96s-96 43-96 96l0 224 192 0 0-224zM0 208C0 128.5 64.5 64 144 64l272 0c88.4 0 160 71.6 160 160l0 256-576 0 0-272zm80 0l128 0 0 48-128 0 0-48zm264 0l-24 0 0 48 80 0 0 64 80 0 0-112-136 0z"]
};
var faMessageHeart = {
  prefix: 'fass',
  iconName: 'message-heart',
  icon: [512, 512, [], "e5c9", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM249.6 183.5l6.4 8.5 6.4-8.5c11.1-14.8 28.5-23.5 46.9-23.5 32.4 0 58.7 26.3 58.7 58.7l0 5.3c0 64-112 128-112 128S144 288 144 224l0-5.3c0-32.4 26.3-58.7 58.7-58.7 18.5 0 35.9 8.7 46.9 23.5z"]
};
var faMessageMiddleTop = {
  prefix: 'fass',
  iconName: 'message-middle-top',
  icon: [512, 512, ["comment-middle-top-alt"], "e1e2", "M176 64l80-96 80 96 176 0 0 416-512 0 0-416 176 0z"]
};
var faCommentMiddleTopAlt = faMessageMiddleTop;
var faUsersRays = {
  prefix: 'fass',
  iconName: 'users-rays',
  icon: [640, 512, [], "e593", "M48.4-49.9L14.5-16c4.8 4.8 29.1 29.1 73 73l17 17 33.9-33.9c-4.8-4.8-29.1-29.1-73-73l-17-17zm544 0c-4.8 4.8-29.1 29.1-73 73l-17 17 33.9 33.9c4.8-4.8 29.1-29.1 73-73l17-17-33.9-33.9zM65.4 545c43.8-43.8 68.2-68.2 73-73l-33.9-33.9c-4.8 4.8-29.1 29.1-73 73l-17 17 33.9 33.9 17-17zm527 17l33.9-33.9-73-73-17-17-33.9 33.9c4.8 4.8 29.1 29.1 73 73l17 17zM320.4 208a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm112 176l-48-144-128 0-48 144 224 0zm104-224a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm-96.1 96l37.6 112.8 5.1 15.2 93.4 0-48-128-88.1 0zm-239.9 0l-88.1 0-48 128 93.4 0 5.1-15.2 37.6-112.8zm15.9-96a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
};
var faCirclesOverlap = {
  prefix: 'fass',
  iconName: 'circles-overlap',
  icon: [576, 512, [], "e600", "M160 304c0 14.1 1.4 27.9 4.1 41.2-58-18.6-100.1-73-100.1-137.2 0-79.5 64.5-144 144-144 39 0 74.4 15.5 100.3 40.7-85.8 25.7-148.3 105.2-148.3 199.3zM383.7 96.6C346.8 38.5 281.9 0 208 0 93.1 0 0 93.1 0 208 0 317.6 84.8 407.4 192.3 415.4 229.2 473.5 294.1 512 368 512 482.9 512 576 418.9 576 304 576 194.4 491.2 104.6 383.7 96.6zm28.2 70.2c58 18.6 100.1 73 100.1 137.2 0 79.5-64.5 144-144 144-39 0-74.4-15.5-100.3-40.7 85.8-25.7 148.3-105.2 148.3-199.3 0-14.1-1.4-27.9-4.1-41.2z"]
};
var faRainbow = {
  prefix: 'fass',
  iconName: 'rainbow',
  icon: [640, 512, [127752], "f75b", "M320 96C178.6 96 64 210.6 64 352l0 96-64 0 0-96C0 175.3 143.3 32 320 32S640 175.3 640 352l0 96-64 0 0-96C576 210.6 461.4 96 320 96zm0 112c-79.5 0-144 64.5-144 144l0 96-64 0 0-96c0-114.9 93.1-208 208-208s208 93.1 208 208l0 96-64 0 0-96c0-79.5-64.5-144-144-144zM288 352l0 96-64 0 0-96c0-53 43-96 96-96s96 43 96 96l0 96-64 0 0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faBoxArrowDownArrowUp = {
  prefix: 'fass',
  iconName: 'box-arrow-down-arrow-up',
  icon: [448, 512, [], "e795", "M448 128l0 352-448 0 0-352 80-112 288 0 80 112zM120 344l-56 0 80 96 80-96-56 0 0-152-48 0 0 152zm104-64l56 0 0 152 48 0 0-152 56 0-80-96-80 96zM78.7 128l290.7 0-34.3-48-222.1 0-34.3 48z"]
};
var faLeftFromDottedLine = {
  prefix: 'fass',
  iconName: 'left-from-dotted-line',
  icon: [576, 512, [], "e6c2", "M21.5 256l202.9 192 0-128 192 0 0-128-32 0 0 0-160 0 0-128-202.9 192zM480.4 448l64 0 0-64-64 0 0 64zm0-170.7l0 64 64 0 0-64-64 0zm0-42.7l64 0 0-64-64 0 0 64zm0-170.7l0 64 64 0 0-64-64 0z"]
};
var faSitemap = {
  prefix: 'fass',
  iconName: 'sitemap',
  icon: [512, 512, [], "f0e8", "M192 32l128 0 0 128-40 0 0 64 192 0 0 128 40 0 0 128-128 0 0-128 40 0 0-80-144 0 0 80 40 0 0 128-128 0 0-128 40 0 0-80-144 0 0 80 40 0 0 128-128 0 0-128 40 0 0-128 192 0 0-64-40 0 0-128z"]
};
var faCaravanSimple = {
  prefix: 'fass',
  iconName: 'caravan-simple',
  icon: [640, 512, ["caravan-alt"], "e000", "M544 32l-512 0 0 384 104.4 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8l328.4 0 0-64-96 0 0-320zM128 128l128 0 0 128-128 0 0-128zm320 0l0 128-128 0 0-128 128 0zM184 424a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faCaravanAlt = faCaravanSimple;
var faFaceGrinStars = {
  prefix: 'fass',
  iconName: 'face-grin-stars',
  icon: [576, 512, [129321, "grin-stars"], "f587", "M288.2 512c141.4 0 256-114.6 256-256 0-17.8-1.8-35.1-5.3-51.9l30.9-19.6-13.9-87.1-74.2-18.7-39.7-70.3-66.9 6.7c-27.1-9.8-56.4-15.1-86.9-15.1-30.6 0-60 5.4-87.2 15.3L134 9 96.1 78.5 20.5 97.4 6.5 184.6 37.4 204.1c-3.4 16.8-5.3 34.1-5.3 51.9 0 141.4 114.6 256 256 256zM418.9 324.9c11.9-3.7 23.9 6.3 19.6 18.1-22.4 61.3-81.3 105.1-150.3 105.1S160.2 404.2 137.8 342.9c-4.3-11.8 7.7-21.8 19.6-18.1 39.2 12.2 83.7 19.1 130.7 19.1s91.5-6.9 130.7-19.1zM400.2 67.8l33.8 68.5 75.6 11-54.7 53.3 12.9 75.3-67.6-35.5-67.6 35.5 12.9-75.3-54.7-53.3 75.6-11 33.8-68.5zM210 136.2l75.6 11-54.7 53.3 12.9 75.3-67.6-35.5-67.6 35.5 12.9-75.3-54.7-53.3 75.6-11 33.8-68.5 33.8 68.5z"]
};
var faGrinStars = faFaceGrinStars;
var faMessageSms = {
  prefix: 'fass',
  iconName: 'message-sms',
  icon: [512, 512, [], "e1e5", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM140.8 172.8l35.2 0 0 32-35.2 0c-5.3 0-9.6 4.3-9.6 9.6s4.3 9.6 9.6 9.6c23 0 41.6 18.6 41.6 41.6s-18.6 41.6-41.6 41.6l-41.6 0 0-32 41.6 0c5.3 0 9.6-4.3 9.6-9.6s-4.3-9.6-9.6-9.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6zm188.8 41.6c0-23 18.6-41.6 41.6-41.6l35.2 0 0 32-35.2 0c-5.3 0-9.6 4.3-9.6 9.6s4.3 9.6 9.6 9.6c23 0 41.6 18.6 41.6 41.6s-18.6 41.6-41.6 41.6l-41.6 0 0-32 41.6 0c5.3 0 9.6-4.3 9.6-9.6s-4.3-9.6-9.6-9.6c-23 0-41.6-18.6-41.6-41.6zm-19.2-25.6l0 118.4-32 0 0-62.5c-4.6 8.6-12 22.5-22.1 41.8-10.5-19.1-18.1-32.8-22.7-41.2l0 61.9-32 0 0-134.4 16 0 12.7 0c.3 .6 8.8 16 25.5 46.3l20-37.8 4.5-8.5c14.2 0 16.5 0 30.1 0l0 16z"]
};
var faCommentsQuestion = {
  prefix: 'fass',
  iconName: 'comments-question',
  icon: [576, 512, [], "e14e", "M192 320c106 0 192-78.8 192-176S298-32 192-32 0 46.8 0 144c0 37.9 13.1 73.1 35.4 101.8L0 352 127 309.7c20.3 6.7 42.2 10.3 65 10.3zm3.2 48c16.4 81.9 94.7 144 188.8 144 27 0 52.8-5.1 76.1-14.4L576 544 540.6 437.8c22.3-28.7 35.4-63.9 35.4-101.8 0-82.4-61.7-151.5-145-170.7-11.5 115.8-115.8 201.2-235.8 202.7zM192 69.2c-17.7 0-32 14.3-32 32l-42.4 0c0-41.1 33.3-74.4 74.4-74.4s74.4 33.3 74.4 74.4c0 33.3-19.8 52.7-37.4 62.5-5.5 3.1-11 5.4-15.8 7.1l0 18.3-42.4 0 0-53.5c2.3-.3 4.6-.6 6.9-.9 10.5-1.3 21.1-2.7 30.5-8 9-5.1 15.8-12.4 15.8-25.6 0-17.7-14.3-32-32-32zM168 216l48 0 0 48-48 0 0-48z"]
};
var faSortUp = {
  prefix: 'fass',
  iconName: 'sort-up',
  icon: [448, 512, ["sort-asc"], "f0de", "M8 224L224-8 440 224 8 224z"]
};
var faSortAsc = faSortUp;
var faBillboard = {
  prefix: 'fass',
  iconName: 'billboard',
  icon: [576, 512, [], "e5cd", "M168 64l-136 0 0 288-32 0 0 64 256 0 0 96 64 0 0-96 256 0 0-64-32 0 0-288-136 0 0 80 40 0 0 48-128 0 0-48 40 0 0-80-144 0 0 80 40 0 0 48-128 0 0-48 40 0 0-80z"]
};
var faEye = {
  prefix: 'fass',
  iconName: 'eye',
  icon: [576, 512, [128065], "f06e", "M288 32C129.6 32 30 181.3 0 256 30 330.7 129.6 480 288 480S546 330.7 576 256C546 181.3 446.4 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 96c53 0 96-43 96-96s-43-96-96-96l0 96-96 0c0 53 43 96 96 96z"]
};
var faArrowDownSmallBig = {
  prefix: 'fass',
  iconName: 'arrow-down-small-big',
  icon: [512, 512, ["sort-size-down-alt"], "f88d", "M288 32l160 0 0 160-160 0 0-160zm0 224l224 0 0 224-224 0 0-224zM150.6 470.6L128 493.3c-5.5-5.5-39.7-39.7-102.6-102.6L2.7 368 48 322.7c14.6 14.6 30.6 30.6 48 48l0-338.7 64 0 0 338.7c17.4-17.4 33.4-33.4 48-48L253.3 368c-5.5 5.5-39.7 39.7-102.6 102.6z"]
};
var faSortSizeDownAlt = faArrowDownSmallBig;
var faAxe = {
  prefix: 'fass',
  iconName: 'axe',
  icon: [640, 512, [129683], "f6b2", "M473.9 105.9l54.1 54.1 112 0 0 32c0 123.7-100.3 224-224 224l-32 0 0-112-176-176 144-144 54.1 54.1c1-1 15-15 41.9-41.9L515.9 64c-27 27-40.9 40.9-41.9 41.9zM228.1 216L296 283.9 105.9 473.9 72 507.9 4.1 440 38.1 406.1 228.1 216z"]
};
var faCaretLeft = {
  prefix: 'fass',
  iconName: 'caret-left',
  icon: [320, 512, [], "f0d9", "M224 80L24 256 224 432 224 80z"]
};
var faAppleWhole = {
  prefix: 'fass',
  iconName: 'apple-whole',
  icon: [448, 512, [127822, 127823, "apple-alt"], "f5d1", "M208 96l0-16c0-44.2 35.8-80 80-80l32 0 0 32c0 44.2-35.8 80-80 80l-32 0 0-16zM0 288c0-76.3 35.7-160 112-160l112 32 112-32c76.3 0 112 83.7 112 160 0 128-80 224-160 224l-64-16-64 16C80 512 0 416 0 288z"]
};
var faAppleAlt = faAppleWhole;
var faScrollTorah = {
  prefix: 'fass',
  iconName: 'scroll-torah',
  icon: [576, 512, ["torah"], "f6a0", "M0 0l96 0 0 32 384 0 0-32 96 0 0 512-96 0 0-32-384 0 0 32-96 0 0-512zM176 320l77.9 0 34.1 56 34.1-56 77.9 0-39-64 39-64-77.9 0-34.1-56-34.1 56-77.9 0 39 64-39 64z"]
};
var faTorah = faScrollTorah;
var faHouseLock = {
  prefix: 'fass',
  iconName: 'house-lock',
  icon: [640, 512, [], "e510", "M368 512l0-208 32 0c0-60 41.2-110.3 96.9-124.2L288-16 32 224 32 272 80 272 80 512 368 512zM224 464l0-144 96 0 0 144-96 0zM528 272c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faSquareLitecoin = {
  prefix: 'fass',
  iconName: 'square-litecoin',
  icon: [448, 512, [], "e6f7", "M448 32l-448 0 0 448 448 0 0-448zM208 128l0 84.5c46.6-15.5 71.3-23.8 74.1-24.7l10.1 30.4c-1.1 .4-29.2 9.7-84.2 28.1l0 89.8 112 0 0 48-160 0 0-121.8c-19.9 6.6-34 11.3-42.1 14l-10.1-30.4c6.5-2.2 23.9-8 52.2-17.4l0-100.5 48 0z"]
};
var faArrowsLeftRightToLine = {
  prefix: 'fass',
  iconName: 'arrows-left-right-to-line',
  icon: [576, 512, [], "e4ba", "M64 96l-64 0 0 320 64 0 0-320zM454.6 278.6L477.3 256c-8.2-8.2-37.1-37.1-86.6-86.6L368 146.7 322.7 192c17.3 17.3 28 28 32 32l-133.5 0c4-4 14.7-14.7 32-32L208 146.7c-8.2 8.2-37.1 37.1-86.6 86.6L98.7 256 185.4 342.6 208 365.3 253.3 320c-17.3-17.3-28-28-32-32l133.5 0-32 32 45.3 45.3 86.6-86.6zM576 128l0-32-64 0 0 320 64 0 0-288z"]
};
var faTrash = {
  prefix: 'fass',
  iconName: 'trash',
  icon: [448, 512, [], "f1f8", "M144-16l-16 48-128 0 0 64 448 0 0-64-128 0-16-48-160 0zM416 144l-384 0 24 368 336 0 24-368z"]
};
var faFaceSadTear = {
  prefix: 'fass',
  iconName: 'face-sad-tear',
  icon: [512, 512, [128546, "sad-tear"], "f5b4", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm271 98c5.5-1.3 11.2-2 17-2 27.6 0 51.6 15.5 63.7 38.4l42.4-22.5c-20.1-37.9-60.1-63.9-106.1-63.9-12.5 0-24.6 1.9-35.9 5.5 9.8 12.7 16.5 27.9 18.9 44.6zM176 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM135.2 338.6c-4.2 8.4-7.2 17.7-7.2 27 0 28.7 20.7 50.4 48 50.4s48-21.7 48-50.4c0-9.3-3.1-18.6-7.2-27-9.7-19.7-24.8-36.2-40.8-50.6-16 14.4-31.1 30.9-40.8 50.6z"]
};
var faSadTear = faFaceSadTear;
var faTireFlat = {
  prefix: 'fass',
  iconName: 'tire-flat',
  icon: [512, 512, [], "f632", "M400 288c0-39.2-15.7-74.7-41.1-100.7L330.1 227c13.7 16.6 21.9 37.8 21.9 61 0 2-.1 4-.2 6l46.6 15.2c1-6.9 1.5-14 1.5-21.2zm-63.1 51.6c-12.9 20.2-33.2 35.2-57 41.3l0 35 42.1 0c26.3-13.6 47.8-35 61.5-61.2l-46.6-15.2zM232 416l0-35c-23.8-6.1-44-21.2-56.9-41.3l-46.6 15.2C142.2 381 163.7 402.4 190 416l42 0zM36.1 419.1C13.2 380.8 0 335.9 0 288 0 146.6 114.6 32 256 32S512 146.6 512 288c0 47.9-13.2 92.8-36.1 131.1l36.1 28.9 0 64-512 0 0-64 36.1-28.9zM112 288c0 7.2 .5 14.3 1.5 21.2L160.2 294c-.1-2-.2-4-.2-6 0-23.2 8.2-44.4 21.9-61l-28.8-39.7C127.7 213.3 112 248.8 112 288zm144-96c12.5 0 24.4 2.4 35.4 6.7L320.2 159c-19.3-9.6-41.1-15-64.2-15s-44.8 5.4-64.1 15l28.8 39.7c10.9-4.3 22.9-6.7 35.4-6.7zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faMelon = {
  prefix: 'fass',
  iconName: 'melon',
  icon: [512, 512, [], "e310", "M512 256c0 141.4-114.6 256-256 256-50.8 0-98.1-14.8-137.9-40.3 65 .4 164.5-16.1 251-102.6s103-186 102.6-251C497.2 157.9 512 205.2 512 256zM142.9 142.9C68.2 217.5 50.9 334.5 47.6 404.8 17.7 362.8 0 311.5 0 256 0 114.6 114.6 0 256 0 309.1 0 358.5 16.2 399.4 43.9 332 44.8 224.8 61 142.9 142.9zM95.1 422.7c.3-18.9 1.7-43.3 5.7-70.2 9.1-62.3 30.6-130.3 76.1-175.7 54.3-54.3 122.9-75.3 180.7-82.1 25.3-3 47.8-3.2 65-2.4 1.4 15.5 2 35.5-.1 58.3-5.1 54.1-25.4 122.9-87.2 184.7s-130.6 82.1-184.7 87.2c-21.4 2-40.4 1.6-55.4 .4z"]
};
var faFax = {
  prefix: 'fass',
  iconName: 'fax',
  icon: [512, 512, [128224, 128439], "f1ac", "M160 0l0 144 64 0 0-80 146.7 0 45.3 45.3 0 34.7 64 0 0-61.3-73.4-73.4-9.4-9.4-237.3 0zM112 128l-112 0 0 352 112 0 0-352zm400 64l-352 0 0 288 352 0 0-288zM224 288a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm0 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM336 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM312 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM424 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM400 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faArrowLeftLongToLine = {
  prefix: 'fass',
  iconName: 'arrow-left-long-to-line',
  icon: [640, 512, [], "e3d4", "M265.4 105.4L288 82.7 333.3 128c-6.6 6.6-38.6 38.6-96 96l402.7 0 0 64-402.7 0c57.4 57.4 89.4 89.4 96 96l-45.3 45.3-150.6-150.6-22.6-22.6 22.6-22.6 128-128zM0 128l0-32 64 0 0 320-64 0 0-288z"]
};
var faUserMusic = {
  prefix: 'fass',
  iconName: 'user-music',
  icon: [640, 512, [], "f8eb", "M256 248a120 120 0 1 0 0-240 120 120 0 1 0 0 240zm16 247.9c0-31.8 17.3-56.8 37.9-72.3 12.3-9.3 26.7-15.9 42.1-19.7l0-99.8-240 0-64 208 225.5 0c-1-5.1-1.5-10.5-1.5-16.1zm352-240l0-28.8-28.3 5.1-176 32-19.7 3.6 0 181.8c-5.9-1.1-11.4-1.6-16-1.6-9.5 0-22.9 2.1-34.9 7.5-11.1 5-29.1 17.2-29.1 40.5s18 35.4 29.1 40.5c11.9 5.4 25.4 7.5 34.9 7.5s22.9-2.1 34.9-7.5c11.1-5 29.1-17.2 29.1-40.5l0-140.1 128-23.3 0 85c-5.9-1.1-11.4-1.6-16-1.6-9.5 0-22.9 2.1-34.9 7.5-11.1 5-29.1 17.2-29.1 40.5s18 35.4 29.1 40.5c11.9 5.4 25.4 7.5 34.9 7.5s22.9-2.1 34.9-7.5c11.1-5 29.1-17.2 29.1-40.5l0-208.1z"]
};
var faPersonCirclePlus = {
  prefix: 'fass',
  iconName: 'person-circle-plus',
  icon: [640, 512, [], "e541", "M168 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-11.4 88l134.8 0 9.6 13.2 85.2 117.3c-17.8 12.4-33.4 27.8-46.1 45.5l-36.1-49.7 0 305.7-64 0 0-208-32 0 0 208-64 0 0-305.7c-28.6 39.4-47.6 65.6-56.9 78.4l-51.8-37.6 18.8-25.9 92.9-128 9.6-13.2zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 64-64 0 0 32 64 0 0 64 32 0 0-64 64 0 0-32-64 0 0-48z"]
};
var faHamsa = {
  prefix: 'fass',
  iconName: 'hamsa',
  icon: [512, 512, [], "f665", "M256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM0 288l96 0 0-256 80 0 0 192 40 0 0-224 80 0 0 224 40 0 0-192 80 0 0 256 96 0 0 48-95.4 105c-41.1 45.2-99.4 71-160.6 71S136.6 486.2 95.4 441L0 336 0 288zm256 0c-48 0-96 64-96 64s48 64 96 64 96-64 96-64-48-64-96-64z"]
};
var faHouseBuilding = {
  prefix: 'fass',
  iconName: 'house-building',
  icon: [640, 512, [], "e1b1", "M320 0l0 124.6 144 116.3 0 110.9-32 0 0 160.2 208 0 0-512-320 0zM440.2 160l-56.2-45.4 0-18.6 64 0 0 64-7.8 0zM576 96l0 64-64 0 0-64 64 0zM528 224l48 0 0 64-48 0 0-64zm48 128l0 64-64 0 0-64 64 0zM384 304l32 0 0-40-208-168-208 168 0 40 32 0 0 208 352 0 0-208zM256 272l0 96-96 0 0-96 96 0z"]
};
var faPersonCircleQuestion = {
  prefix: 'fass',
  iconName: 'person-circle-question',
  icon: [640, 512, [], "e542", "M168 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-11.4 88l134.8 0 9.6 13.2 85.2 117.3c-17.8 12.4-33.4 27.8-46.1 45.5l-36.1-49.7 0 305.7-64 0 0-208-32 0 0 208-64 0 0-305.7c-28.6 39.4-47.6 65.6-56.9 78.4l-51.8-37.6 18.8-25.9 92.9-128 9.6-13.2zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-56c13.3 0 24 10.7 24 24 0 7.2-4.2 13.7-10.8 16.6-14.8 6.6-24.6 10.9-29.2 13l0 26.4 32 0 0-5.6 10.2-4.5c18.1-8.1 29.8-26 29.8-45.9 0-30.9-25.1-56-56-56s-56 25.1-56 56l32 0c0-13.3 10.7-24 24-24zM480 480l32 0 0-32-32 0 0 32z"]
};
var faCrateEmpty = {
  prefix: 'fass',
  iconName: 'crate-empty',
  icon: [512, 512, [], "e151", "M512 224l-512 0 0 128 512 0 0-128zm0 160l-512 0 0 128 512 0 0-128zM64 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM48 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faSunHaze = {
  prefix: 'fass',
  iconName: 'sun-haze',
  icon: [576, 512, [], "f765", "M173.6-20.2c10.6 7.1 48.8 32.4 114.4 75.9 65.6-43.5 103.8-68.8 114.4-75.9 2.5 12.5 11.6 57.4 27.2 134.6 77.2 15.6 122.1 24.7 134.6 27.2-7.1 10.6-32.4 48.8-75.9 114.4l42.5 64-131.9 0c10.9-18.8 17.1-40.7 17.1-64 0-70.7-57.3-128-128-128S160 185.3 160 256c0 23.3 6.2 45.2 17.1 64l-131.9 0 42.5-64C44.1 190.4 18.8 152.2 11.8 141.6 24.3 139 69.2 130 146.4 114.3 162 37.1 171-7.7 173.6-20.2zM368 256c0 26.2-12.6 49.4-32 64l-96 0c-19.4-14.6-32-37.8-32-64 0-44.2 35.8-80 80-80s80 35.8 80 80zM512 368l0 48-512 0 0-48 512 0zM64 464l128 0 0 48-128 0 0-48zm176 0l336 0 0 48-336 0 0-48z"]
};
var faCircle3 = {
  prefix: 'fass',
  iconName: 'circle-3',
  icon: [512, 512, [], "e0f0", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm28-280c11 0 20-9 20-20s-9-20-20-20l-108 0 0-48 108 0c37.6 0 68 30.4 68 68 0 16.8-6.1 32.1-16.2 44 10.1 11.9 16.2 27.2 16.2 44 0 37.6-30.4 68-68 68l-108 0 0-48 108 0c11 0 20-9 20-20s-9-20-20-20l-76 0 0-48 76 0z"]
};
var faClipboardCheck = {
  prefix: 'fass',
  iconName: 'clipboard-check',
  icon: [384, 512, [], "f46c", "M320 32l64 0 0 480-384 0 0-480 64 0 0-32 256 0 0 32zM249.4 217.9L163.8 335.6c-19.3-20-33.7-34.9-43.2-44.7L86.1 324.2c6.2 6.4 27.2 28.1 63.1 65.3l19.8 20.6 16.8-23.1 102.4-140.8 14.1-19.4-38.8-28.2-14.1 19.4zM112 112l160 0 0-48-160 0 0 48z"]
};
var faShareFromSquare = {
  prefix: 'fass',
  iconName: 'share-from-square',
  icon: [576, 512, [61509, "share-square"], "f14d", "M384 336l192-176-192-176 0 112-64 0c-79.5 0-144 64.5-144 144 0 104.7 128 144 128 144s-32-26.2-32-65.5c0-52.2 42.3-94.5 94.5-94.5l17.5 0 0 112zM64 96l-32 0 0 416 416 0 0-128-64 0 0 64-288 0 0-288 48 0 0-64-80 0z"]
};
var faShareSquare = faShareFromSquare;
var faForkKnife = {
  prefix: 'fass',
  iconName: 'fork-knife',
  icon: [576, 512, ["utensils-alt"], "f2e6", "M456 24L440 8 316.6 78.5c-27.6 15.8-44.6 45.1-44.6 76.8 0 19.4 6.4 38.1 18 53.4L57.4 441.4 34.7 464 80 509.3 102.6 486.6 335.2 254c15.3 11.6 34 18 53.4 18 31.8 0 61.1-17 76.8-44.6l70.5-123.4-16-16-104 104-16-16 96-112-16-16-112 96-16-16 104-104zM96 16L74.5 37.5c-50 50-50 131 0 181l68.9 68.9 87-87c-4.2-13.9-6.5-28.5-6.5-43.3 0-4.2 .2-8.4 .5-12.6L96 16zM512 528l48-48-160.5-160.5c-4.2 .4-8.4 .5-12.6 .5-14.8 0-29.4-2.2-43.3-6.5l-23 23 191.4 191.4z"]
};
var faUtensilsAlt = faForkKnife;
var faReceipt = {
  prefix: 'fass',
  iconName: 'receipt',
  icon: [384, 512, [129534], "f543", "M0 0l0 512 64-48 64 48 64-48 64 48 64-48 64 48 0-512-64 48-64-48-64 48-64-48-64 48-64-48zM104 136l200 0 0 48-224 0 0-48 24 0zM80 328l224 0 0 48-224 0 0-48zm24-96l200 0 0 48-224 0 0-48 24 0z"]
};
var faEquals = {
  prefix: 'fass',
  iconName: 'equals',
  icon: [448, 512, [62764], "3d", "M32 128l-32 0 0 64 448 0 0-64-416 0zm0 192l-32 0 0 64 448 0 0-64-416 0z"]
};
var faDiagramLeanCanvas = {
  prefix: 'fass',
  iconName: 'diagram-lean-canvas',
  icon: [576, 512, [], "e156", "M464 96l0 176 48 0 0-176-48 0zm-48 0l-48 0 0 64 48 0 0-64zm-96 0l-64 0 0 176 64 0 0-176zM208 96l-48 0 0 64 48 0 0-64zm-96 0l-48 0 0 176 48 0 0-176zM64 320l0 96 200 0 0-96-200 0zm248 96l200 0 0-96-200 0 0 96zM0 32l576 0 0 448-576 0 0-448zM208 272l0-64-48 0 0 64 48 0zm208-64l-48 0 0 64 48 0 0-64z"]
};
var faBoxArrowUp = {
  prefix: 'fass',
  iconName: 'box-arrow-up',
  icon: [448, 512, [], "e827", "M448 128l0 352-448 0 0-352 80-112 288 0 80 112zM118.1 296l33.9 33.9 48-48 0 126.1 48 0 0-126.1 48 48 33.9-33.9-105.9-105.9-105.9 105.9zM78.7 128l290.7 0-34.3-48-222.1 0-34.3 48z"]
};
var faChevronUp = {
  prefix: 'fass',
  iconName: 'chevron-up',
  icon: [512, 512, [], "f077", "M256.3 82.7l22.6 22.6 214.6 214.6-45.3 45.3-22.6-22.6-169.4-169.4-169.4 169.4-22.6 22.6-45.3-45.3 22.6-22.6 192-192 22.6-22.6z"]
};
var faVirusSlash = {
  prefix: 'fass',
  iconName: 'virus-slash',
  icon: [576, 512, [], "e075", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-1.6-1.6-32.3-32.3-92.1-92.1l11.3-11.3-28.4-28.4c-31-31.2-8.9-84.3 35.1-84.3l40 0 0-80-40 0c-44 0-66.1-53.2-35.1-84.4l28.4-28.4-56.6-56.6-28.3 28.3c-31.2 31.2-84.4 9.1-84.4-35l0-40-80 0 0 40c0 44.1-53.3 66.1-84.4 35L135.4 46.7 124.1 58 49.3-16.9zM72.1 216l-40 0 0 80 40 0c44.1 0 66.1 53.3 35 84.5l-28.3 28.3 56.6 56.6 28.6-28.6c31.2-30.7 84.1-8.6 84.1 35.3l0 40 80 0 0-40.1c0-21.4 12.6-37.6 29.1-45l-240-240C109.8 203.4 93.5 216 72.1 216z"]
};
var faGlobeStand = {
  prefix: 'fass',
  iconName: 'globe-stand',
  icon: [448, 512, [], "f5f6", "M23.5 359l-17 17 33.9 33.9c12.4-12.4 21.6-21.6 27.5-27.5 34.3 27.7 74.9 43.8 116.5 48.3l0 33.3-120 0 0 48 288 0 0-48-120 0 0-33.3c49.1-5.3 96.8-26.7 134.4-64.3 81.7-81.7 87.1-211 16.1-298.9 5.9-5.9 15.1-15.1 27.5-27.5L376.4 6.1C352.6 29.9 318 64.5 315.9 66.6l17 17c68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0l-17-17c-9.7 9.7-24.2 24.2-43.5 43.5zm185-7a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
};
var faRingDiamond = {
  prefix: 'fass',
  iconName: 'ring-diamond',
  icon: [384, 512, [], "e5ab", "M128 0l-32 72 35.8 65.6C55.2 162.9 0 235 0 320 0 426 86 512 192 512s192-86 192-192c0-85-55.2-157.1-131.8-182.4L288 72 256 0 128 0zM320 320a128 128 0 1 1 -256 0 128 128 0 1 1 256 0z"]
};
var faPhoneRotary = {
  prefix: 'fass',
  iconName: 'phone-rotary',
  icon: [512, 512, [9742], "f8d3", "M0 224l0-96s96-96 256-96 256 96 256 96l0 96-64.3 0c-43.4-70.5-66.4-107.8-68.9-112l-245.6 0c-2.6 4.2-25.6 41.5-68.9 112L0 224zM32 480l0-112 128-208 192 0 128 208 0 112-448 0zM328 312a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z"]
};
var faSlash = {
  prefix: 'fass',
  iconName: 'slash',
  icon: [576, 512, [], "f715", "M32.3-33.9l17 17 512 512 17 17-33.9 33.9-17-17-512-512-17-17 33.9-33.9z"]
};
var faArrowDownToDottedLine = {
  prefix: 'fass',
  iconName: 'arrow-down-to-dotted-line',
  icon: [384, 512, [], "e095", "M0 512l64 0 0-64-64 0 0 64zM192 397.3l22.6-22.6 128-128 22.6-22.6-45.3-45.3c-6.6 6.6-38.6 38.6-96 96l0-274.7-64 0 0 274.7c-57.4-57.4-89.4-89.4-96-96l-45.3 45.3 22.6 22.6 128 128 22.6 22.6zM170.7 512l0-64-64 0 0 64 64 0zm42.7 0l64 0 0-64-64 0 0 64zM384 512l0-64-64 0 0 64 64 0z"]
};
var faSaxophoneFire = {
  prefix: 'fass',
  iconName: 'saxophone-fire',
  icon: [640, 512, ["sax-hot"], "f8db", "M0 153.6c0 2.1 .1 4.3 .2 6.4L87 160c14.9-25.1 41-44.7 41-44.7s26.1 19.5 41 44.7l86.9 0c.1-2.1 .2-4.3 .2-6.4 0-21.3-15.4-76.8-76.8-128L153.6 51.2 102.4 0C68.3 21.3 0 81.9 0 153.6zM168 344l50.9-88 37.1 0 0-48-256 0 0 48 16.9 0-12.6 53.4C1.5 321.8 0 334.4 0 347.1l0 3.1c0 89.3 72.4 161.8 161.8 161.8 49.4 0 96.1-22.6 126.8-61.4l255.4-322.6 96 0 0-32-48-32-80 0-63 63c-3.8-3.8-12.2-12.2-25-25L390.1 136c12.8 12.8 21.1 21.1 25 25L401 175c-3.8-3.8-12.2-12.2-25-25L342.1 184c12.8 12.8 21.1 21.1 25 25L353 223c-3.8-3.8-12.2-12.2-25-25L294.1 232c12.8 12.8 21.1 21.1 25 25l-119 119-32-32zm-24-64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM88 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSaxHot = faSaxophoneFire;
var faWindowFrameOpen = {
  prefix: 'fass',
  iconName: 'window-frame-open',
  icon: [448, 512, [], "e050", "M416 64l0 224-384 0 0-288 384 0 0 64zM256 64l0 160 96 0 0-160-96 0zm-64 0l-96 0 0 160 96 0 0-160zM96 448l256 0 0-112 64 0 0 112 32 0 0 64-448 0 0-64 32 0 0-112 64 0 0 112z"]
};
var faCircleD = {
  prefix: 'fass',
  iconName: 'circle-d',
  icon: [512, 512, [], "e104", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM184 144l72 0c61.9 0 112 50.1 112 112S317.9 368 256 368l-96 0 0-224 24 0zm72 176c35.3 0 64-28.7 64-64s-28.7-64-64-64l-48 0 0 128 48 0z"]
};
var faExpand = {
  prefix: 'fass',
  iconName: 'expand',
  icon: [448, 512, [], "f065", "M32 32l-32 0 0 160 64 0 0-96 96 0 0-64-128 0zM64 352l0-32-64 0 0 160 160 0 0-64-96 0 0-64zM320 32l-32 0 0 64 96 0 0 96 64 0 0-160-128 0zM448 352l0-32-64 0 0 96-96 0 0 64 160 0 0-128z"]
};
var faScooter = {
  prefix: 'fass',
  iconName: 'scooter',
  icon: [512, 512, [], "e7c3", "M256 32l121 0 6.1 24.2 64 256 2.4 9.7c35.8 8 62.5 39.9 62.5 78.1 0 44.2-35.8 80-80 80-32.8 0-61-19.7-73.3-48l-205.3 0c-12.3 28.3-40.5 48-73.3 48-44.2 0-80-35.8-80-80s35.8-80 80-80c32.8 0 61 19.7 73.3 48l205.3 0c6-13.7 15.7-25.4 27.9-33.8l-1.6-6.4-57.9-231.8-71 0 0-64zM112 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faFileMp4 = {
  prefix: 'fass',
  iconName: 'file-mp4',
  icon: [576, 512, [], "e649", "M272 0l-240 0 0 512 112 0 0-176 272 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM324 400l0-20-20 0c-2.7 0-8.5 0-17.6 0-.5 1-10.8 20.3-30.7 57.9-20.8-37.9-31.5-57.2-31.8-57.9-17.7 0-17.9 0-35.8 0l0 168 40 0 0-77.4c5.8 10.5 15.2 27.6 28.3 51.5 12.7-24 22-41.4 27.7-52.2l0 78.1 40 0 0-148zm44-20l-20 0 0 168 40 0 0-48 12 0c33.1 0 60-26.9 60-60s-26.9-60-60-60l-32 0zm32 80l-12 0 0-40 12 0c11 0 20 9 20 20s-9 20-20 20zm76 24l64 0 0 60 40 0 0-160-40 0 0 60-24 0 0-60-40 0 0 100z"]
};
var faNoteSticky = {
  prefix: 'fass',
  iconName: 'note-sticky',
  icon: [448, 512, [62026, "sticky-note"], "f249", "M304 480l-304 0 0-448 448 0 0 304-144 144zm85.5-176L272 304 272 421.5 389.5 304z"]
};
var faStickyNote = faNoteSticky;
var faDolphin = {
  prefix: 'fass',
  iconName: 'dolphin',
  icon: [512, 512, [], "e168", "M176 0l30.5 0c46.1 0 89.7 10.2 128.9 28.6L464 0 480 16 427.4 94.8c52.4 55 84.6 129.4 84.6 211.3 0 94.2-79.2 169.5-173.3 164.3l-72.5-4-18.3 45.7-88 0 32-80-32-80 88 0 21.5 53.7 60-3c30.5-1.5 54.5-26.7 54.5-57.3 0-31.7-25.7-57.4-57.4-57.4l-6.6 0 0 64-32 0-80-64-208 0 0-66.1c8.5-5.1 22.5-13.5 42-25.2-6.4-16.3-10-34.1-10-52.7 0-79.5 64.5-144 144-144zm0 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBorderBottom = {
  prefix: 'fass',
  iconName: 'border-bottom',
  icon: [448, 512, [], "f84d", "M448 480l-448 0 0-64 448 0 0 64zM64 352l-64 0 0-64 64 0 0 64zM384 96l0-64 64 0 0 64-64 0zm64 128l-64 0 0-64 64 0 0 64zM384 352l0-64 64 0 0 64-64 0zM64 224l-64 0 0-64 64 0 0 64zM0 96l0-64 64 0 0 64-64 0zm192 0l-64 0 0-64 64 0 0 64zm64 0l0-64 64 0 0 64-64 0z"]
};
var faUserMessage = {
  prefix: 'fass',
  iconName: 'user-message',
  icon: [576, 512, [], "e7b1", "M320 0l0 192 64 0 0 80 80-80 112 0 0-192-256 0zM224 8C157.7 8 104 61.7 104 128s53.7 120 120 120c17.1 0 33.3-3.6 48-10l0-220c-14.7-6.4-30.9-10-48-10zM432 512l-64-208-288 0-64 208 416 0z"]
};
var faSignalWeak = {
  prefix: 'fass',
  iconName: 'signal-weak',
  icon: [512, 512, ["signal-1"], "f68c", "M72 480l-48 0 0-96 48 0 0 96z"]
};
var faSignal1 = faSignalWeak;
var faTableColumns = {
  prefix: 'fass',
  iconName: 'table-columns',
  icon: [448, 512, ["columns"], "f0db", "M0 32l448 0 0 448-448 0 0-448zM64 160l0 256 128 0 0-256-128 0zm320 0l-128 0 0 256 128 0 0-256z"]
};
var faColumns = faTableColumns;
var faPersonShelter = {
  prefix: 'fass',
  iconName: 'person-shelter',
  icon: [512, 512, [], "e54f", "M64 181.4l0 330.6-64 0 0-368 256-144 256 144 0 368-64 0 0-330.6-192-108-192 108zM256 128a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-48 96l110.3 0 6.8 12.6 56 104 11.4 21.1-42.3 22.8c-5-9.3-17.8-33-38.2-71l0 198.5-48 0 0-112-16 0 0 112-48 0 0-198.5c-20.5 38.1-33.2 61.7-38.2 71l-42.3-22.8 11.4-21.1 56-104 6.8-12.6 14.3 0z"]
};
var faCameraSecurity = {
  prefix: 'fass',
  iconName: 'camera-security',
  icon: [448, 512, ["camera-home"], "f8fe", "M448 0l-448 0 0 416 200 0 0 48-104 0 0 48 256 0 0-48-104 0 0-48 200 0 0-416zM224 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"]
};
var faCameraHome = faCameraSecurity;
var faCircleNotch = {
  prefix: 'fass',
  iconName: 'circle-notch',
  icon: [512, 512, [], "f1ce", "M214.8 68.4C128.6 87.3 64 164.1 64 256 64 362 150 448 256 448s192-86 192-192c0-91.9-64.6-168.7-150.8-187.6L310.8 5.9C425.9 31 512 133.4 512 256 512 397.4 397.4 512 256 512S0 397.4 0 256C0 133.4 86.1 31 201.2 5.9l13.7 62.5z"]
};
var faWater = {
  prefix: 'fass',
  iconName: 'water',
  icon: [512, 512, [], "f773", "M136.2 62.2l8.9 3.6 111.1 44.4 111.1-44.4 8.9-3.6 8.9 3.6c83 33.2 125 50 126.3 50.5l-17.8 44.6c-2.7-1.1-41.9-16.7-117.4-46.9l-111.1 44.4-8.9 3.6-8.9-3.6-111.1-44.4c-75.5 30.2-114.7 45.9-117.4 47L1 116.2c1.2-.5 43.3-17.3 126.3-50.5l8.9-3.6zm0 144l8.9 3.6 111.1 44.4 111.1-44.4 8.9-3.6 8.9 3.6c83 33.2 125 50 126.3 50.5l-17.8 44.6c-2.7-1.1-41.9-16.7-117.4-46.9l-111.1 44.4-8.9 3.6-8.9-3.6-111.1-44.4c-75.5 30.2-114.7 45.9-117.4 47L1 260.2c1.2-.5 43.3-17.3 126.3-50.5l8.9-3.6zm8.9 147.6l111.1 44.4 111.1-44.4 8.9-3.6 8.9 3.6c82.9 33.2 125 50 126.3 50.5l-17.8 44.6c-2.7-1.1-41.8-16.7-117.4-46.9l-111.1 44.4-8.9 3.6-8.9-3.6-111.1-44.4c-75.5 30.2-114.7 45.9-117.4 47L1 404.2c1.2-.5 43.3-17.3 126.3-50.5l8.9-3.6 8.9 3.6z"]
};
var faDeleteLeft = {
  prefix: 'fass',
  iconName: 'delete-left',
  icon: [640, 512, [9003, "backspace"], "f55a", "M576 64l0 384-400 0-176-192 176-192 400 0zM267.1 205.1L318.1 256c-25.5 25.5-42.4 42.4-50.9 50.9l33.9 33.9c8.5-8.5 25.5-25.5 50.9-50.9 25.5 25.5 42.4 42.4 50.9 50.9l33.9-33.9c-8.5-8.5-25.5-25.5-50.9-50.9 25.5-25.5 42.4-42.4 50.9-50.9l-33.9-33.9c-8.5 8.5-25.5 25.5-50.9 50.9l-50.9-50.9-33.9 33.9z"]
};
var faBackspace = faDeleteLeft;
var faCircleRupee = {
  prefix: 'fass',
  iconName: 'circle-rupee',
  icon: [512, 512, [], "e714", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM152 144l48 0c39.8 0 72 32.2 72 72 0 26.9-14.7 50.3-36.5 62.6 14.8 44.3 23.7 71.2 26.8 80.5l-45.5 15.2C214 366 204.4 337.2 188 288l-12 0 0 80-48 0 0-224 24 0zm48 96c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0 48 24 0zm80 .1c0-31 25.1-56.1 56.1-56.1l63.9 0 0 48-63.9 0c-4.5 0-8.1 3.6-8.1 8.1 0 3.6 2.3 6.7 5.8 7.8L368 258.1c23.7 7.1 40 29 40 53.7 0 31-25.1 56.1-56.1 56.1l-63.9 0 0-48 63.9 0c4.5 0 8.1-3.6 8.1-8.1 0-3.6-2.3-6.7-5.8-7.8L320 293.9c-23.7-7.1-40-29-40-53.7z"]
};
var faArrowDownToSquare = {
  prefix: 'fass',
  iconName: 'arrow-down-to-square',
  icon: [448, 512, [], "e096", "M256 0l0-32-64 0 0 274.7c-4-4-14.7-14.7-32-32L114.7 256c8.2 8.2 37.1 37.1 86.6 86.6L224 365.3 333.3 256 288 210.7 256 242.7 256 0zM32 96l-32 0 0 416 448 0 0-416-128 0 0 64 64 0 0 288-320 0 0-288 64 0 0-64-96 0z"]
};
var faSquareB = {
  prefix: 'fass',
  iconName: 'square-b',
  icon: [448, 512, [], "e264", "M448 32l-448 0 0 448 448 0 0-448zM144 144l92 0c37.6 0 68 30.4 68 68 0 12.7-3.5 24.7-9.6 34.8 15.6 12.5 25.6 31.6 25.6 53.2 0 37.6-30.4 68-68 68l-108 0 0-224zm112 68c0-11-9-20-20-20l-44 0 0 40 44 0c11 0 20-9 20-20zM192 320l60 0c11 0 20-9 20-20s-9-20-20-20l-60 0 0 40z"]
};
var faBroomBall = {
  prefix: 'fass',
  iconName: 'broom-ball',
  icon: [576, 512, ["quidditch", "quidditch-broom-ball"], "f458", "M496 544a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM106.8 277.2c30.6-30.6 73.1-45.9 115.8-42.2L341 353.3c3.7 42.8-11.6 85.2-42.2 115.9-27.4 27.4-64.6 42.8-103.3 42.8l-195.5 0 0-32 160-144-96 48 0-3.5c0-38.8 15.4-75.9 42.8-103.3zM576 48l-200 200 40 40 0 32-51.7 0-108.3-108.3 0-51.7 32 0 40 40 200-200 48 48z"]
};
var faQuidditch = faBroomBall;
var faQuidditchBroomBall = faBroomBall;
var faH6 = {
  prefix: 'fass',
  iconName: 'h6',
  icon: [512, 512, [], "e413", "M64 64l0 160 96 0 0-160 64 0 0 384-64 0 0-160-96 0 0 160-64 0 0-384 64 0zm320 64c-17.7 0-32 14.3-32 32l0 53.5c10-3.5 20.8-5.5 32-5.5l32 0c53 0 96 43 96 96l0 48c0 53-43 96-96 96l-32 0c-53 0-96-43-96-96l0-192c0-53 43-96 96-96l96 0 0 64-96 0zM352 304l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32z"]
};
var faJ = {
  prefix: 'fass',
  iconName: 'j',
  icon: [320, 512, [106], "4a", "M320 32l0 288c0 88.4-71.6 160-160 160S0 408.4 0 320l0-64 64 0 0 64c0 53 43 96 96 96s96-43 96-96l0-288 64 0z"]
};
var faShuttleSpace = {
  prefix: 'fass',
  iconName: 'shuttle-space',
  icon: [576, 512, ["space-shuttle"], "f197", "M0 368l0 112 160 0 186.7-112-93.3 0-106.7 64-2.7 0 0-80 32-16 190.2 0c71.1 0 135.1-23.1 177.8-80-42.7-56.9-106.7-80-177.8-80l-190.2 0-32-16 0-80 2.7 0 106.7 64 93.3 0-186.7-112-160 0 0 336zm96 0l0 64-48 0 0-64 48 0zM96 80l0 64-48 0 0-64 48 0zM432 224l0 64-32 0 0-64 32 0z"]
};
var faSpaceShuttle = faShuttleSpace;
var faYinYang = {
  prefix: 'fass',
  iconName: 'yin-yang',
  icon: [512, 512, [9775], "f6ad", "M216 160l40-40 40 40-40 40-40-40zm40 352a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-448c53 0 96 43 96 96s-43 96-96 96-96 43-96 96 43 96 96 96C150 448 64 362 64 256S150 64 256 64zM216 352l40-40 40 40-40 40-40-40z"]
};
var faSignalGood = {
  prefix: 'fass',
  iconName: 'signal-good',
  icon: [512, 512, ["signal-3"], "f68e", "M280 248l0-24-48 0 0 256 48 0 0-232zM176 320l-48 0 0 160 48 0 0-160zM72 384l-48 0 0 96 48 0 0-96z"]
};
var faSignal3 = faSignalGood;
var faImageStack = {
  prefix: 'fass',
  iconName: 'image-stack',
  icon: [512, 512, [], "e771", "M120-32l-24 0 0 48 320 0 0-48-296 0zM72 64l-24 0 0 48 416 0 0-48-392 0zm440 96l-512 0 0 320 512 0 0-320zM96 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 416l-320 0 84-112 33.7 44.9 74.3-92.9 128 160z"]
};
var faStop = {
  prefix: 'fass',
  iconName: 'stop',
  icon: [448, 512, [9209], "f04d", "M0 32l448 0 0 448-448 0z"]
};
var faTrowel = {
  prefix: 'fass',
  iconName: 'trowel',
  icon: [640, 512, [], "e589", "M464 208l-25.4-25.4-136 136 81.4 81.4-48 48-272 64 64-272 48-48 81.4 81.4 136-136-25.4-25.4 160-160 96 96-160 160z"]
};
var faCircle2 = {
  prefix: 'fass',
  iconName: 'circle-2',
  icon: [512, 512, [], "e0ef", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM208 145.3l62 0c36.5 0 66 29.6 66 66 0 27.1-16.6 51.5-41.9 61.4l-44.7 17.6c-12.9 5.1-22.1 16.3-24.6 29.6l103.3 0 0 48-152 0 0-40.4c0-36.2 22.1-68.7 55.8-81.9l44.7-17.6c6.9-2.7 11.4-9.4 11.4-16.8 0-10-8.1-18-18-18l-86 0 0-48 24 0z"]
};
var faDrumstick = {
  prefix: 'fass',
  iconName: 'drumstick',
  icon: [512, 512, [127831], "f6d6", "M160 278.5L160 176C160 78.8 238.8 0 336 0s176 78.8 176 176-78.8 176-176 176l-102.5 0-58.4 58.3c10.4 10.8 16.8 25.5 16.8 41.7 0 33.1-26.9 60-60 60s-60-26.9-60-60l0-12-12 0c-33.1 0-60-26.9-60-60s26.9-60 60-60c16.2 0 30.9 6.4 41.6 16.8L160 278.5z"]
};
var faSquareX = {
  prefix: 'fass',
  iconName: 'square-x',
  icon: [448, 512, [], "e286", "M448 32l-448 0 0 448 448 0 0-448zM119.7 144l57.9 0 46.4 69 46.4-69 57.8 0-10.4 15.4-65 96.6 65 96.6 10.4 15.4-57.8 0-46.4-69-46.4 69-57.9 0 10.4-15.4 65-96.6-65-96.6-10.4-15.4z"]
};
var faPeapod = {
  prefix: 'fass',
  iconName: 'peapod',
  icon: [512, 512, [], "e31c", "M512 0L416 0C186.2 0 0 186.2 0 416l0 96 96 0c229.8 0 416-186.2 416-416l0-96zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faMessageText = {
  prefix: 'fass',
  iconName: 'message-text',
  icon: [512, 512, ["comment-alt-text"], "e1e6", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM184 144l168 0 0 48-72 0 0 144-48 0 0-144-72 0 0-48 24 0z"]
};
var faCommentAltText = faMessageText;
var faHandBackFist = {
  prefix: 'fass',
  iconName: 'hand-back-fist',
  icon: [384, 512, ["hand-rock"], "f255", "M0 240l0-96 64 0 0-144 96 0 0 16 96 0 0 16 64 0 0 32 64 0 0 160-64 128-256 0-64-112zM32 400l320 0 0 112-320 0 0-112z"]
};
var faHandRock = faHandBackFist;
var faSnowmanHead = {
  prefix: 'fass',
  iconName: 'snowman-head',
  icon: [448, 512, ["frosty-head"], "f79b", "M64 0l320 0 0 160-320 0 0-160zM330.2 192l117.8 0 0 64-57.7 0c16.3 28.2 25.7 61 25.7 96 0 66.8-34.1 125.6-85.8 160l-212.3 0c-51.7-34.4-85.8-93.2-85.8-160 0-35 9.3-67.8 25.7-96l-57.7 0 0-64 330.2 0zM152 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 448l27.8-48.7c2.7-4.8 4.2-10.2 4.2-15.7 0-17.5-14.2-31.6-31.6-31.6l-.8 0c-17.5 0-31.6 14.2-31.6 31.6 0 5.5 1.4 10.9 4.2 15.7L224 448z"]
};
var faFrostyHead = faSnowmanHead;
var faBlanket = {
  prefix: 'fass',
  iconName: 'blanket',
  icon: [448, 512, [], "f498", "M0 32l448 0 0 352-352 0 0-48 304 0 0-48-352 0 0 144 400 0 0 48-448 0 0-448z"]
};
var faCommentXmark = {
  prefix: 'fass',
  iconName: 'comment-xmark',
  icon: [512, 512, ["comment-times"], "f4b5", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM340.9 189.1l-33.9-33.9c-8.5 8.5-25.5 25.5-50.9 50.9l-50.9-50.9-33.9 33.9c8.5 8.5 25.5 25.5 50.9 50.9-25.5 25.5-42.4 42.4-50.9 50.9l33.9 33.9c8.5-8.5 25.5-25.5 50.9-50.9 25.5 25.5 42.4 42.4 50.9 50.9l33.9-33.9c-8.5-8.5-25.5-25.5-50.9-50.9 25.5-25.5 42.4-42.4 50.9-50.9z"]
};
var faCommentTimes = faCommentXmark;
var faPersonDollyEmpty = {
  prefix: 'fass',
  iconName: 'person-dolly-empty',
  icon: [512, 512, [], "f4d1", "M120 24A56 56 0 1 0 8 24 56 56 0 1 0 120 24zM32 112L0 112 0 272c0 30.2 14.2 58.7 38.4 76.8l89.6 67.2 0 128 64 0 0-160-12.8-9.6-67.2-50.4 0-80.1c16.7 23.4 27.2 38.1 31.5 44.1l112.5 0 0 162.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48 20.9 0 38.7-13.4 45.3-32l194.7 0 0-48-208 0 0-304-48 0 0 64-79.5 0-70.4-98.6-9.6-13.4-64.5 0zM0 512l0 32 64 0 0-116-54.4-40.8c-3.3-2.5-6.5-5.1-9.6-7.9L0 512z"]
};
var faSignalSlash = {
  prefix: 'fass',
  iconName: 'signal-slash',
  icon: [576, 512, [], "f695", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-7.3-7.3-26.7-26.7-58.1-58.1l0-422-48 0 0 374-56-56 0-222-48 0 0 174-318.8-318.8zM312.1 381.8l-48-48 0 146.2 48 0 0-98.2zM208.1 320l-48 0 0 160 48 0 0-160zm-104 64l-48 0 0 96 48 0 0-96z"]
};
var faHexagonPlus = {
  prefix: 'fass',
  iconName: 'hexagon-plus',
  icon: [576, 512, ["plus-hexagon"], "f300", "M13.5 256.1l6.8-11.9 123.7-216.1 6.9-12.1 275.1 0 6.9 12.1 123.7 216.1 6.8 11.9-6.8 11.9-123.7 216.1-6.9 12.1-275.1 0-6.9-12.1-123.7-216.1-6.8-11.9zM264.5 368l48 0 0-88 88 0 0-48-88 0 0-88-48 0 0 88-88 0 0 48 88 0 0 88z"]
};
var faPlusHexagon = faHexagonPlus;
var faTemperatureHigh = {
  prefix: 'fass',
  iconName: 'temperature-high',
  icon: [512, 512, [], "f769", "M96 0l192 0 0 260.7c29.5 26.4 48 64.7 48 107.3 0 79.5-64.5 144-144 144S48 447.5 48 368c0-42.6 18.5-81 48-107.3L96 0zm96 432c35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3l0-236.7-48 0 0 236.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64zM464 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM352 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faGreaterThan = {
  prefix: 'fass',
  iconName: 'greater-than',
  icon: [512, 512, [62769], "3e", "M32 14L493.4 227 512 235.5 512 276.5 493.4 285.1 32 498 32 427.5 403.6 256 32 84.5 32 14z"]
};
var faToothbrush = {
  prefix: 'fass',
  iconName: 'toothbrush',
  icon: [576, 512, [129701], "f635", "M0 160c0-35.3 28.7-64 64-64l224 0c37.7 0 40-33.2 40-64 57.4 0 120 31.6 120 96 0 53-43 96-96 96L0 224 0 160zm80 96l0 160 32 0 0-160 48 0 0 160 32 0 0-160 48 0 0 160 32 0 0-160 48 0 0 160 32 0 0-160 48 0 0 160 176 0 0 64-576 0 0-64 32 0 0-160 48 0z"]
};
var faFlute = {
  prefix: 'fass',
  iconName: 'flute',
  icon: [576, 512, [], "f8b9", "M498.3 6.1l-33.9-33.9-33.9 33.9-267 267 107.9 107.9 267-267 33.9-33.9C550.6 58.4 526 33.7 498.3 6.1zm-261 408.9L129.5 307c-70.2 70.2-111.9 111.9-125 125 49.9 49.9 95 95 107.9 107.9 13.1-13.1 54.8-54.8 125-125zm51-182.9a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-168 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232-232a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faLobster = {
  prefix: 'fass',
  iconName: 'lobster',
  icon: [512, 512, [129438], "e421", "M80 2l0 94 42.9-57.2c3.3 7.7 5.1 16.2 5.1 25.2l0 64c0 14.9-5.1 28.6-13.6 39.4l36.9 24.6 46.5 0c2.7-7.3 6.2-14 10.2-20.2l0-118.2c-26.2-4.4-43-7.2-50.4-8.4l5.3-31.6 63.8 10.6 13.4 2.2 0 111.6c5.9-4.4 11.4-7.7 16-10 4.6 2.3 10.1 5.6 16 10l0-111.6c3.1-.5 23.6-3.9 61.4-10.2l15.8-2.6 5.3 31.6c-7.4 1.2-24.2 4-50.4 8.4l0 118.2c4 6.2 7.5 13 10.2 20.2l46.5 0 36.9-24.6C389.1 156.6 384 142.9 384 128l0-64c0-8.9 1.8-17.4 5.1-25.2L432 96 432 2c5.1-1.3 10.5-2 16-2 35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-.7 0-66 44-6 4-55.3 0 0 16 60.2 0c34.8-17.4 54.4-27.2 58.9-29.5l14.3 28.6c-3.9 2-24.7 12.3-62.3 31.2l-3.4 1.7-67.8 0 0 16 77.4 0c35.4-11.8 55.7-18.6 60.7-20.2l10.1 30.4c-4.6 1.5-25.7 8.6-63.2 21.1l-2.5 .8-82.6 0 0 16 35.8 0 35.4 17.7 14.3 7.2-14.3 28.6-42.9-21.5-28.2 0-21.6 64.8c30.4 5 53.6 31.4 53.6 63.2l-192 0c0-31.8 23.2-58.2 53.6-63.2L192 384 163.8 384c-21.5 10.7-35.8 17.9-42.9 21.5l-14.3-28.6c6.6-3.3 22-11 46.3-23.2l3.4-1.7 35.8 0 0-16-82.6 0-2.5-.8c-37.5-12.5-58.5-19.5-63.2-21.1l10.1-30.4c5.1 1.7 25.3 8.4 60.7 20.2l77.4 0 0-16-67.8 0-3.4-1.7c-37.6-18.8-58.4-29.2-62.3-31.2l14.3-28.6 58.9 29.5 60.2 0 0-16-55.3 0-6-4-66-44-.7 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0 69.5 0 74.9 .7 80 2z"]
};
var faCalendarCircleExclamation = {
  prefix: 'fass',
  iconName: 'calendar-circle-exclamation',
  icon: [576, 512, [], "e46e", "M192 32l0-32-64 0 0 64-96 0 0 112 448 0 0-112-96 0 0-64-64 0 0 64-128 0 0-32zM32 480l225.4 0c-11.2-24.4-17.4-51.4-17.4-80 0-78.7 47.4-146.4 115.1-176L32 224 32 480zm400 64a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 112-32 0 0-112 32 0z"]
};
var faMobileRotate = {
  prefix: 'fass',
  iconName: 'mobile-rotate',
  icon: [640, 512, [], "e813", "M602.5 320L384 538.5 37.5 192 256-26.5 602.5 320zM176 416l-55.5 0c4 36 34.5 64 71.5 64 18.3 0 35-6.9 47.8-18.2l34.1 34c-21.4 20-50.2 32.2-81.8 32.2-63.6 0-115.6-49.5-119.7-112l-56.3 0 80-80 80 80zm198-24L408 425.9 489.9 344 456 310.1 374 392zM448-16c63.6 0 115.6 49.5 119.7 112l56.3 0-80 80-80-80 55.5 0c-4-36-34.5-64-71.5-64-18.3 0-35 6.9-47.8 18.2l-34.1-34C387.6-3.7 416.4-16 448-16z"]
};
var faCrutch = {
  prefix: 'fass',
  iconName: 'crutch',
  icon: [576, 512, [], "f7f7", "M352.3-13.3l22.6 22.6 160 160 22.6 22.6-45.3 45.3-24-24-177.4 177.4-9.4 9.4-112 0C5.1 584.4 107.4 482.1 64.3 525.3L19 480c24.4-24.4 56.2-56.2 125.3-125.3l0-112 9.4-9.4 177.4-177.4-1.4-1.4-22.6-22.6 45.3-45.3zm24 114.5l-82.7 82.7 66.7 66.7 82.7-82.7-66.7-66.7zm-128 128l-40 40 0 66.7 66.7 0 40-40-66.7-66.7z"]
};
var faCommand = {
  prefix: 'fass',
  iconName: 'command',
  icon: [512, 512, [], "e142", "M32 208l112 0 0 96-144 0 0 208 208 0 0-144 96 0 0 144 208 0 0-208-144 0 0-96 144 0 0-208-208 0 0 144-96 0 0-144-208 0 0 208 32 0zm224 96l-48 0 0-96 96 0 0 96-48 0zM64 144l0-80 80 0 0 80-80 0zm80 304l-80 0 0-80 80 0 0 80zM368 144l0-80 80 0 0 80-80 0zm80 224l0 80-80 0 0-80 80 0z"]
};
var faTvRetro = {
  prefix: 'fass',
  iconName: 'tv-retro',
  icon: [512, 512, [128250], "f401", "M160-13.3c6.6 6.6 38.6 38.6 96 96 57.4-57.4 89.4-89.4 96-96L397.3 32c-12 12-33.3 33.3-64 64l178.7 0 0 384-512 0 0-384 178.7 0c-30.7-30.7-52-52-64-64L160-13.3zM384 160l-320 0 0 256 320 0 0-256zm88 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM448 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPawClaws = {
  prefix: 'fass',
  iconName: 'paw-claws',
  icon: [512, 512, [], "f702", "M256 224c64 0 192 80 192 256L256 432 64 480c0-176 128-256 192-256zM48 160.4c19.3 2.3 39.6 16.2 52.4 38.2 18.9 32.4 14.3 70.1-10.2 84.2s-59.7-.9-78.5-33.3C3.7 235.8 0 221.3 .1 208l-.1-96 48 0 0 48.4zM511.9 208c.1 13.3-3.7 27.8-11.6 41.4-18.9 32.4-54 47.3-78.5 33.3s-29.1-51.7-10.2-84.2c12.8-22 33-35.8 52.4-38.2l0-48.4 48 0-.1 96zM160 32.3c29.8-3 61.6 22 74.5 60.5 14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5c-4-11.9-5.7-23.9-5.4-35.2l-.1-112 48 0 0 48.3zM399.9 96c.2 11.3-1.4 23.2-5.4 35.2-14.3 42.9-52.1 69.1-84.4 58.5s-46.9-53.9-32.6-96.8c12.9-38.6 44.7-63.6 74.5-60.5l0-48.3 48 0-.1 112z"]
};
var faSeptagon = {
  prefix: 'fass',
  iconName: 'septagon',
  icon: [576, 512, ["heptagon"], "e820", "M516.1 67.7L572.4 314.3 414.7 512.1 161.7 512.1 4 314.3 60.3 67.7 288.2-42.1 516.1 67.7z"]
};
var faHeptagon = faSeptagon;
var faFaceSmileUpsideDown = {
  prefix: 'fass',
  iconName: 'face-smile-upside-down',
  icon: [512, 512, [], "e395", "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm0 144c-38.2 0-72 19.1-92.2 48.5l-39.5-27.3C153.1 123.4 201.3 96 256 96s102.9 27.4 131.8 69.2l-39.5 27.3C328 163.1 294.2 144 256 144zM368 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM176 336a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faGlassEmpty = {
  prefix: 'fass',
  iconName: 'glass-empty',
  icon: [384, 512, [], "e191", "M99.2 448l185.6 0 30-384-245.6 0 30 384zM344 512L40 512 0 0 384 0 379 64 344 512z"]
};
var faEar = {
  prefix: 'fass',
  iconName: 'ear',
  icon: [384, 512, [128066], "f5f0", "M384 192c0 76.8-45.1 143-110.2 173.7L208 512 0 512 0 192C0 86 86 0 192 0S384 86 384 192zm-272 0c0-44.2 35.8-80 80-80s80 35.8 80 80l0 32 48 0 0-32c0-70.7-57.3-128-128-128S64 121.3 64 192l0 64 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 48 40 0c39.8 0 72-32.2 72-72 0-37.1-28-67.6-64-71.6l0-16.4z"]
};
var faStreetView = {
  prefix: 'fass',
  iconName: 'street-view',
  icon: [512, 512, [], "f21d", "M256 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 160l64 0c35.3 0 64 28.7 64 64l0 80-33.8 0-14.2 128-96 0-14.2-128-33.8 0 0-80c0-35.3 28.7-64 64-64zM412.4 400.2c-16.1-4.2-34.8-7.6-55.4-10.2l5.3-47.7c22.7 2.9 43.7 6.7 62.1 11.5 22.4 5.8 42.6 13.3 57.8 23.3 14.7 9.6 29.8 24.9 29.8 47s-15.1 37.4-29.8 47c-15.2 9.9-35.5 17.5-57.8 23.3-45.1 11.7-105.3 17.8-168.4 17.8s-123.3-6.1-168.4-17.8C65.2 488.4 45 480.9 29.8 471 15.1 461.4 0 446.1 0 424s15.1-37.4 29.8-47c15.2-9.9 35.5-17.5 57.8-23.3 18.5-4.8 39.5-8.6 62.1-11.5L155 390c-20.6 2.6-39.3 6.1-55.4 10.2-56.6 14.6-56.6 32.9 0 47.5 39.9 10.3 95.8 16.2 156.4 16.2s116.5-5.9 156.4-16.2c56.6-14.6 56.6-32.9 0-47.5z"]
};
var faBriefs = {
  prefix: 'fass',
  iconName: 'briefs',
  icon: [512, 512, [], "e6d0", "M512 64l-512 0 0 48 512 0 0-48zM336 160l-160 0 0 37.9c0 42.6-12.6 84.3-36.3 119.8l-17.8 26.7C145.7 372.3 160 408.5 160 448l192 0c0-39.5 14.3-75.7 38.1-103.6l-17.8-26.7C348.6 282.2 336 240.5 336 197.9l0-37.9zm48 0l0 37.9c0 33.2 9.8 65.6 28.2 93.2l14.4 21.6C451.3 297 480.6 288 512 288l0-128-128 0zM0 160L0 288c31.4 0 60.7 9 85.4 24.7l14.4-21.6c18.4-27.6 28.2-60 28.2-93.2l0-37.9-128 0z"]
};
var faSpeakers = {
  prefix: 'fass',
  iconName: 'speakers',
  icon: [448, 512, [], "f8e0", "M448-32l-352 0 0 480 352 0 0-480zM272 184a104 104 0 1 1 0 208 104 104 0 1 1 0-208zm56 104a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM240 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120l0-24-48 0 0 448 352 0 0-48-304 0 0-376z"]
};
var faWaveSquare = {
  prefix: 'fass',
  iconName: 'wave-square',
  icon: [512, 512, [], "f83e", "M64 64l224 0 0 320 96 0 0-160 128 0 0 64-64 0 0 160-224 0 0-320-96 0 0 160-128 0 0-64 64 0 0-160z"]
};
var faAngleLeft = {
  prefix: 'fass',
  iconName: 'angle-left',
  icon: [320, 512, [8249], "f104", "M19 256l22.6 22.6 160 160 22.6 22.6 45.3-45.3-160-160 137.4-137.4 22.6-22.6-45.3-45.3-22.6 22.6-160 160-22.6 22.6z"]
};
var faTurtle = {
  prefix: 'fass',
  iconName: 'turtle',
  icon: [576, 512, [128034], "f726", "M384 288l-352 0 0-80c0-97.2 78.8-176 176-176s176 78.8 176 176l0 80zm192 0l-96 0 0 96-128 0 0 96-128 0 0-96-32 0 0 96-128 0 0-96-64 0 0-64 416 0 0-208 64 0c53 0 96 43 96 96l0 80zm-80-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faArrowRightToLine = {
  prefix: 'fass',
  iconName: 'arrow-right-to-line',
  icon: [512, 512, [8677, "arrow-to-right"], "f340", "M512 96l0-32-64 0 0 384 64 0 0-352zM374.6 278.6l22.6-22.6-22.6-22.6-128-128-22.6-22.6-45.3 45.3c6.6 6.6 38.6 38.6 96 96L0 224 0 288 274.7 288c-57.4 57.4-89.4 89.4-96 96l45.3 45.3 22.6-22.6 128-128z"]
};
var faArrowToRight = faArrowRightToLine;
var faPantsStraight = {
  prefix: 'fass',
  iconName: 'pants-straight',
  icon: [448, 512, [], "e6d6", "M448 0l-448 0 4 64 124 0 0 48-121 0 25 400 168 0 0-320 48 0 0 320 168 0 25-400-121 0 0-48 124 0 4-64z"]
};
var faScrewdriver = {
  prefix: 'fass',
  iconName: 'screwdriver',
  icon: [576, 512, [129691], "f54a", "M352 146.7l0-66.7 144-96 64 64-96 144-66.7 0-109.3 109.3 0 82.7-160 160-128-128 160-160 82.7 0 109.3-109.3z"]
};
var faTrafficLightStop = {
  prefix: 'fass',
  iconName: 'traffic-light-stop',
  icon: [320, 512, [], "f63a", "M320-32l-320 0 0 576 320 0 0-576zM160 360c30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56 25.1-56 56-56zm56-104a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 152a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm24 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM160 440c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24z"]
};
var faSquareEuro = {
  prefix: 'fass',
  iconName: 'square-euro',
  icon: [448, 512, [], "e732", "M448 32l-448 0 0 448 448 0 0-448zM128.2 240l-24.2 0 0-32 32.1 0c19.6-51.5 69.5-88 127.8-88l57 0 0 48-57 0c-31 0-58.3 15.9-74.2 40l66.3 0 0 32-79.3 0c-1 5.4-1.6 11-1.6 16.8 0 5.2 .4 10.3 1.3 15.2l79.5 0 0 32-67.2 0c15.7 24.9 43.5 41.5 75.2 41.5l57 0 0 48-57 0c-58.9 0-109.1-37.3-128.4-89.5l-31.5 0 0-32 24 0c-.6-5-.8-10.1-.8-15.2 0-5.7 .3-11.3 1-16.8z"]
};
var faTractor = {
  prefix: 'fass',
  iconName: 'tractor',
  icon: [576, 512, [128668], "f722", "M235.8 96l57.6 96-133.4 0 0-96 75.8 0zm64.7 288l101.2 0c-6.1 12-9.6 25.6-9.6 40 0 48.6 39.4 88 88 88s88-39.4 88-88c0-32.7-17.8-61.2-44.3-76.4l52.3-43.6 0-112-96 0 0-96-48 0 0 96-64 0-96-160-176 0 0 191c-1.9 .9-3.7 1.9-5.6 2.9l-15.3-15.3-56.6 56.6 15.3 15.3c-5.1 9.3-9.3 19.2-12.3 29.6l-21.6 0 0 80 21.6 0c3 10.4 7.1 20.3 12.3 29.6l-15.3 15.3 56.6 56.6 15.3-15.3c9.3 5.1 19.2 9.3 29.6 12.3l0 21.6 80 0 0-21.6c10.4-3 20.3-7.1 29.6-12.3l15.3 15.3 56.6-56.6-15.3-15.3c6.4-11.6 11.3-24.2 14.3-37.6zM160 416a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm360 8a40 40 0 1 1 -80 0 40 40 0 1 1 80 0z"]
};
var faBridgeCircleXmark = {
  prefix: 'fass',
  iconName: 'bridge-circle-xmark',
  icon: [576, 512, [], "e4cb", "M32 32l-32 0 0 64 40 0 0 64-40 0 0 112c37.6 9.4 64 43.2 64 82l0 126 96 0 0-96c0-53 43-96 96-96 6.4 0 12.7 .6 18.7 1.8 34.7-49.5 92.2-81.8 157.3-81.8 28.6 0 55.6 6.2 80 17.4l0-65.4-40 0 0-64 40 0 0-64-480 0zM424 96l0 64-80 0 0-64 80 0zM296 96l0 64-80 0 0-64 80 0zM88 96l80 0 0 64-80 0 0-64zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm55.3-176.7L454.6 400c25.4 25.3 40 40 44 44L476 466.6c-4-4-18.6-18.6-44-44-25.3 25.4-40 40-44 44L365.4 444c4-4 18.6-18.6 44-44-25.4-25.3-40-40-44-44L388 333.4c4 4 18.6 18.6 44 44 25.3-25.4 40-40 44-44l22.6 22.6-11.3 11.3z"]
};
var faVials = {
  prefix: 'fass',
  iconName: 'vials',
  icon: [512, 512, [], "f493", "M32 0L0 0 0 64 32 64 32 416c0 53 43 96 96 96s96-43 96-96l0-352 64 0 0 352c0 53 43 96 96 96s96-43 96-96l0-352 32 0 0-64-480 0zM160 64l0 128-64 0 0-128 64 0zm256 0l0 128-64 0 0-128 64 0z"]
};
var faStarfighterTwinIonEngineAdvanced = {
  prefix: 'fass',
  iconName: 'starfighter-twin-ion-engine-advanced',
  icon: [576, 512, ["starfighter-alt-advanced"], "e28e", "M424.5 53.7l-21.7-23.5 47-43.4c2.1 2.3 41.3 44.8 117.7 127.5l8.5 9.2 0 247.7-7 8.8c-76.7 95.8-115.3 144.2-116 145l-50-40c1.8-2.3 38.2-47.7 109-136.2l0-48-75.6 15.1C412.7 374.6 355.2 416 288 416S163.3 374.6 139.6 315.9L64 300.8 64 356.2C134.1 438 170.5 480.4 173.1 483.5l-48.6 41.6c-1.4-1.6-40.3-47-116.8-136.3l-7.7-9 0-247.7 7.7-9C84.2 33.9 123.2-11.5 124.5-13.1l48.6 41.7c-2.6 3.1-39 45.5-109.1 127.3l0 55.4 75.6-15.1C163.3 137.4 220.8 96 288 96s124.7 41.4 148.4 100.1l75.6 15.1 0-62.7-87.5-94.8zM288 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-152a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
var faStethoscope = {
  prefix: 'fass',
  iconName: 'stethoscope',
  icon: [576, 512, [129658], "f0f1", "M32 0l128 0 0 64-64 0 0 128c0 53 43 96 96 96s96-43 96-96l0-128-64 0 0-64 128 0 0 192c0 77.4-55 142-128 156.8l0 19.2c0 61.9 50.1 112 112 112s112-50.1 112-112l0-85.5c-37.3-13.2-64-48.7-64-90.5 0-53 43-96 96-96s96 43 96 96c0 41.8-26.7 77.4-64 90.5l0 85.5c0 97.2-78.8 176-176 176S160 465.2 160 368l0-19.2C87 334 32 269.4 32 192L32 0zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faPodcast = {
  prefix: 'fass',
  iconName: 'podcast',
  icon: [448, 512, [], "f2ce", "M334 361.4c40.2-32.3 66-81.8 66-137.4 0-97.2-78.8-176-176-176S48 126.8 48 224c0 55.6 25.8 105.1 66 137.4l8.9 62.6C50 387 0 311.4 0 224 0 100.3 100.3 0 224 0S448 100.3 448 224c0 87.4-50 163-122.9 200l8.9-62.6zm-13.4-53.4l-27.1-33.9-3.6-4.6c8.9-12.9 14.2-28.6 14.2-45.5 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 16.9 5.2 32.6 14.2 45.5l-3.6 4.6-27.1 33.9C107.8 285.5 96 256.1 96 224 96 153.3 153.3 96 224 96s128 57.3 128 128c0 32.1-11.8 61.5-31.4 83.9zM160 344l32-40 64 0 32 40-24 168-80 0-24-168zm64-160a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faArrowUpRightDots = {
  prefix: 'fass',
  iconName: 'arrow-up-right-dots',
  icon: [576, 512, [], "e4b7", "M128.3 32l-32 0 0 64 50.7 0C63 180 20.3 222.7 19 224l45.3 45.3c1.3-1.3 44-44 128-128l0 50.7 64 0 0-160-128 0zM436.1 70.1a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zM311.9 194.2a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zm162.2-38.1a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zM188.4 317.8a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zM350 279.7a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zm86.1 38.1a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zM102.3 403.8a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zm86.1 38.1a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zM350 403.8a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zm86.1 38.1a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0z"]
};
var faChessQueen = {
  prefix: 'fass',
  iconName: 'chess-queen',
  icon: [512, 512, [9819], "f445", "M256 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM96 160l-96-32 0 48 128 208-64 80 0 48 384 0 0-48-64-80 128-208 0-48-96 32-80-64-80 64-80-64-80 64z"]
};
var faAnchorCircleExclamation = {
  prefix: 'fass',
  iconName: 'anchor-circle-exclamation',
  icon: [640, 512, [], "e4ab", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-53 0-96 43-96 96 0 41.8 26.7 77.4 64 90.5l0 261.5-112 0 0-140.1c10.5 9.2 21.9 19.2 34.3 30l31.6-36.1c-4.4-3.8-31.7-27.8-82.1-71.8L112 216.1c-2.5 2.2-29.1 25.5-79.8 69.8l-18.1 15.8 31.6 36.1c12.4-10.8 23.8-20.8 34.3-30l0 204.1 260 0c-22.7-31.5-36-70.2-36-112 0-27.3 5.7-53.3 16-76.9l0-136.6c37.3-13.2 64-48.7 64-90.5 0-53-43-96-96-96zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 112-32 0 0-112 32 0z"]
};
var faEllipsisVertical = {
  prefix: 'fass',
  iconName: 'ellipsis-vertical',
  icon: [128, 512, ["ellipsis-v"], "f142", "M120 32l-112 0 0 112 112 0 0-112zM8 200l0 112 112 0 0-112-112 0zM8 368l0 112 112 0 0-112-112 0z"]
};
var faEllipsisV = faEllipsisVertical;
var faAcorn = {
  prefix: 'fass',
  iconName: 'acorn',
  icon: [448, 512, [], "f6ae", "M399.6 240C395.4 320.1 358.7 435.1 224 480 89.3 435.1 52.6 320.1 48.4 240l351.1 0zM273.4 28.7L259.7 48.4c-3.3 4.8-6 10.1-7.9 15.6L352 64c53 0 96 43 96 96l0 32-448 0 0-32c0-53 43-96 96-96l106.2 0c3-15.3 9.2-29.9 18.1-42.9l13.7-19.8 39.5 27.3z"]
};
var faBanParking = {
  prefix: 'fass',
  iconName: 'ban-parking',
  icon: [512, 512, ["parking-circle-slash"], "f616", "M412.5 367.2L342.3 297c20.6-17.6 33.7-43.8 33.7-73 0-53-43-96-96-96l-106.7 0-28.5-28.5c31.4-22.4 69.8-35.5 111.2-35.5 106 0 192 86 192 192 0 41.5-13.1 79.9-35.5 111.2zm-45.3 45.3c-31.4 22.4-69.8 35.5-111.2 35.5-106 0-192-86-192-192 0-41.5 13.1-79.9 35.5-111.2l68.5 68.5 0 170.7 64 0 0-64 42.7 0 92.5 92.5zM296.6 251.4L237.3 192 280 192c17.7 0 32 14.3 32 32 0 11.6-6.2 21.7-15.4 27.4zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z"]
};
var faParkingCircleSlash = faBanParking;
var faSquareDong = {
  prefix: 'fass',
  iconName: 'square-dong',
  icon: [448, 512, [], "e70f", "M448 32l-448 0 0 448 448 0 0-448zM240 112l48 0 0 32 32 0 0 32-32 0 0 176-48 0 0-6.7c-9.8 4.3-20.6 6.7-32 6.7-44.2 0-80-35.8-80-80s35.8-80 80-80c11.4 0 22.2 2.4 32 6.7l0-22.7-48 0 0-32 48 0 0-32zM208 240a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM112 376l224 0 0 32-224 0 0-32z"]
};
var faListDropdown = {
  prefix: 'fass',
  iconName: 'list-dropdown',
  icon: [448, 512, [], "e1cf", "M448 32l0 144-448 0 0-144 448 0zM0 480l0-256 448 0 0 256-448 0zM120 280l-24 0 0 48 256 0 0-48-232 0zm0 96l-24 0 0 48 256 0 0-48-232 0zM312 80l-38.6 0c44.2 44.2 60.1 60.1 62.6 62.6 12.2-12.2 52.1-52.1 62.6-62.6L312 80z"]
};
var faCameraCircleEllipsis = {
  prefix: 'fass',
  iconName: 'camera-circle-ellipsis',
  icon: [640, 512, [], "e766", "M224 32l-32 64-128 0 0 384 257.4 0c-11.2-24.4-17.4-51.4-17.4-80 0-5.8 .3-11.5 .8-17.2-45.8-7.3-80.8-47-80.8-94.8 0-53 43-96 96-96 33 0 62.1 16.7 79.4 42 28.4-16.6 61.4-26 96.6-26 28.6 0 55.6 6.2 80 17.4l0-129.4-128 0-32-64-192 0zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM479.3 384l32 0 0 32-32 0 0-32zM448 384l0 32-32 0 0-32 32 0zm96 0l32 0 0 32-32 0 0-32z"]
};
var faFamilyDress = {
  prefix: 'fass',
  iconName: 'family-dress',
  icon: [512, 512, [], "e301", "M128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM64 512l96 0 0-64-32 0 0-240 37.5 0c-3.5-10-5.5-20.8-5.5-32 0-5.5 .5-10.8 1.3-16l-97.3 0-64 224 64 0 0 128zm384 0l0-128 64 0-64-224-97.3 0c.9 5.2 1.3 10.5 1.3 16 0 11.2-1.9 22-5.5 32l37.5 0 0 240-32 0 0 64 96 0zM384 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80 176l0-144-160 0 0 144 32 0 0 112 96 0 0-112 32 0z"]
};
var faPodium = {
  prefix: 'fass',
  iconName: 'podium',
  icon: [448, 512, [], "f680", "M176 0L288 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-112 0 0-24-48 0 0 72 304 0 0 48-416 0 0-48 64 0 0-120 96 0 0-24zM80 512l-23.7-272 335.3 0-23.7 272-288 0z"]
};
var faRobotAstromech = {
  prefix: 'fass',
  iconName: 'robot-astromech',
  icon: [512, 512, [], "e2d2", "M128 128l0 32 256 0 0-32C384 57.3 326.7 0 256 0S128 57.3 128 128zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM0 512l128 0 0-128 64 64 128 0 64-64 0 128 128 0 0-32-48-64 0-224-416 0 0 224-48 64 0 32zM208 256l112 0 0 32-128 0 0-32 16 0zm0 64l112 0 0 32-128 0 0-32 16 0z"]
};
var faHeartCircleExclamation = {
  prefix: 'fass',
  iconName: 'heart-circle-exclamation',
  icon: [576, 512, [], "e4fe", "M133.1 32C175.8 32 216 52.5 241 87.1l15 20.7 15-20.7c25-34.6 65.2-55.1 107.9-55.1 73.5 0 133.1 59.6 133.1 133.1 0 19.2-3 38.1-8.5 56.6-22.1-8.9-46.2-13.8-71.5-13.8-106 0-192 86-192 192 0 33 8.3 64 23 91.2-2.4 1.6-4.7 3.3-7 4.8-102.5-70.7-256-194.1-256-330.9 0-73.5 59.6-133.1 133.1-133.1zM432 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 112 32 0 0-112z"]
};
var faBuildingCircleExclamation = {
  prefix: 'fass',
  iconName: 'building-circle-exclamation',
  icon: [576, 512, [], "e4d3", "M416 0l-384 0 0 512 244 0c-10.5-14.6-19-30.7-25.1-48l-74.9 0 0-112 70 0c6-23.3 16.3-45 30-64l-20 0 0-64 64 0 0 20c27.5-19.8 60.3-32.4 96-35.4L416 0zM128 96l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM128 224l64 0 0 64-64 0 0-64zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-240l0 112-32 0 0-112 32 0zm0 176l-32 0 0-32 32 0 0 32z"]
};
var faPersonArrowUpFromLine = {
  prefix: 'fass',
  iconName: 'person-arrow-up-from-line',
  icon: [640, 512, [], "e539", "M621.5 80C616 74.5 581.8 40.3 518.9-22.6L496.3-45.3c-5.5 5.5-39.7 39.7-102.6 102.6L371 80 416.3 125.3c14.6-14.6 30.6-30.6 48-48l0 178.7 64 0 0-178.7c17.4 17.4 33.4 33.4 48 48L621.5 80zM224.2 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-51.1 32l-16.3 0-9.6 13.2-92.9 128-18.8 25.9 51.8 37.6c9.3-12.8 28.3-39 56.9-78.4l0 241.7-112 0 0 64 576 0 0-64-304 0 0-241.7c28.6 39.4 47.6 65.6 56.9 78.4l51.8-37.6-18.8-25.9-92.9-128-9.6-13.2-118.5 0zm67.1 368l-32 0 0-144 32 0 0 144z"]
};
var faCircleArrowDownLeft = {
  prefix: 'fass',
  iconName: 'circle-arrow-down-left',
  icon: [512, 512, [], "e0f9", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm40-208l-54.1 0 103-103 17-17-33.9-33.9-17 17-103 103 0-78.1-48 0 0 160 160 0 0-48-24 0z"]
};
var faNotEqual = {
  prefix: 'fass',
  iconName: 'not-equal',
  icon: [448, 512, [], "f53e", "M100.2 384l-62.8 94.2-1.2 1.8 76.9 0 64-96 270.9 0 0-64-228.2 0 85.3-128 142.9 0 0-64-100.2 0 62.8-94.2 1.2-1.8-76.9 0-64 96-270.9 0 0 64 228.2 0-85.3 128-142.9 0 0 64 100.2 0z"]
};
var faBinaryCircleCheck = {
  prefix: 'fass',
  iconName: 'binary-circle-check',
  icon: [576, 512, [], "e33c", "M288 0l112 0 0 160 48 0 0 48.7c-5.3-.4-10.6-.7-16-.7-27.3 0-53.3 5.7-76.9 16l-67.1 0 0-64 48 0 0-96-48 0 0-64zM64 288l112 0 0 160 48 0 0 64-160 0 0-64 48 0 0-96-48 0 0-64zM96 0l160 0 0 224-192 0 0-224 32 0zm32 160l64 0 0-96-64 0 0 96zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.4-51.5l-25.9-18.8-9.4 12.9-53 72.9C393.7 395 381 382.3 376 377.4L353.4 400c2.8 2.8 19.9 19.9 51.3 51.3l13.2 13.2 11-15.1 64-88 9.4-12.9z"]
};
var faTrainTram = {
  prefix: 'fass',
  iconName: 'train-tram',
  icon: [384, 512, [128650], "e5b4", "M24-16l-24 0 0 80 48 0 0-32 120 0 0 64-136 0 0 352 34.1 0C26.7 497.2 6.2 522.8 4.5 525l61.5 0 61.6-77 129 0 61.6 77 61.5 0c-1.7-2.2-22.3-27.8-61.6-77l34 0 0-352-136 0 0-64 120 0 0 32 48 0 0-80-360 0zM288 160l0 96-192 0 0-96 192 0zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPlaneDeparture = {
  prefix: 'fass',
  iconName: 'plane-departure',
  icon: [640, 512, [128747], "f5b0", "M404 143.1l-211.8-110.2-75.2 27.4 115.3 145.3-100.2 36.5-70-42.6-45.1 16.4 90.3 154.4 63.1-23 0 0 398.4-145c29.1-10.6 44-42.7 33.5-71.8s-42.7-44-71.8-33.5L404 143.1zM64.3 448l-32 0 0 64 576 0 0-64-544 0z"]
};
var faMicrophoneStand = {
  prefix: 'fass',
  iconName: 'microphone-stand',
  icon: [512, 512, [127908], "f8cb", "M290.2 52.3c46.9-46.9 122.8-46.9 169.7 0s46.9 122.8 0 169.7l-4.6 4.6-169.7-169.7 4.6-4.6zM257.3 85.3L427 255 420.3 261.6c-21.6 21.6-49.8 32.5-78.1 32.8L217.8 170.1c.3-28.3 11.2-56.5 32.8-78.1l6.7-6.7zM7.5 414.2l184.5-202.1 108.1 108.1-19.8 18.1 0 205.7-48 0 0-161.8-134.4 122.7-90.4-90.6z"]
};
var faShop24 = {
  prefix: 'fass',
  iconName: 'shop-24',
  icon: [640, 512, [], "e79a", "M16 256l0-64 80-160 384 0 80 160 0 64-48 0 0 48-64 0 0-48-96 0 0 48-64 0 0-48-160 0 0 128 176 0 0 96-240 0 0-224-48 0zM348 400c0-28.7 23.3-52 52-52s52 23.3 52 52l0 1c0 14.6-5.4 28.7-15 39.6l-31.5 35.5 46.6 0 0 40-104 0 0-35.6 5.1-5.7 54-60.8c3.2-3.6 4.9-8.2 4.9-13l0-1c0-6.6-5.4-12-12-12s-12 5.4-12 12l-40 0zm128 32l0-80 40 0 0 60 24 0 0-60 40 0 0 160-40 0 0-60-64 0 0-20z"]
};
var faBrightness = {
  prefix: 'fass',
  iconName: 'brightness',
  icon: [512, 512, [], "e0c9", "M288 32l0-32-64 0 0 112 64 0 0-80zM118.6 73.4L96 50.7 50.7 96c32.4 32.4 72.2 72.2 77.3 77.3L173.3 128c-13.5-13.5-31.7-31.7-54.6-54.6zm320 45.3L461.3 96 416 50.7c-32.4 32.4-72.2 72.2-77.3 77.3l45.3 45.3 54.6-54.6zM32 224l-32 0 0 64 112 0 0-64-80 0zm448 0l-80 0 0 64 112 0 0-64-32 0zM150.6 406.6L173.3 384 128 338.7C95.6 371.1 55.8 410.9 50.7 416L96 461.3c13.5-13.5 31.7-31.7 54.6-54.6zm256-45.3l-22.6-22.6-45.3 45.3 77.3 77.3 45.3-45.3-54.6-54.6zM288 480l0-80-64 0 0 112 64 0 0-32zM256 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faRightToBracket = {
  prefix: 'fass',
  iconName: 'right-to-bracket',
  icon: [512, 512, ["sign-in-alt"], "f2f6", "M344.5 273.4L363 256 344.5 238.6C231.2 131.6 169.7 73.5 160 64.3l0 127.7-160 0 0 128 160 0 0 127.7c9.7-9.2 71.2-67.3 184.5-174.2zM352 416l-32 0 0 64 192 0 0-448-192 0 0 64 128 0 0 320-96 0z"]
};
var faSignInAlt = faRightToBracket;
var faSdCard = {
  prefix: 'fass',
  iconName: 'sd-card',
  icon: [384, 512, [], "f7c2", "M384 0l-285.3 0-9.4 9.4-80 80-9.4 9.4 0 413.3 384 0 0-512zM160 88l0 72-48 0 0-96 48 0 0 24zm88 0l0 72-48 0 0-96 48 0 0 24zm88 0l0 72-48 0 0-96 48 0 0 24z"]
};
var faDot = {
  prefix: 'fass',
  iconName: 'dot',
  icon: [128, 512, [], "e7d1", "M128 320l-128 0 0-128 128 0 0 128z"]
};
var faHouseCircleExclamation = {
  prefix: 'fass',
  iconName: 'house-circle-exclamation',
  icon: [640, 512, [], "e50a", "M496 208c11.7 0 23.1 1 34.2 3l-242.2-227-256 240 0 48 48 0 0 240 260 0c-10.5-14.6-19-30.7-25.1-48l-90.9 0 0-144 97.4 0c30.3-66.1 97.1-112 174.6-112zm0 336a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-240l0 112-32 0 0-112 32 0zm0 176l-32 0 0-32 32 0 0 32z"]
};
var faShekelSign = {
  prefix: 'fass',
  iconName: 'shekel-sign',
  icon: [448, 512, [8362, "ils", "shekel", "sheqel", "sheqel-sign"], "f20b", "M32 32l-32 0 0 448 64 0 0-384 128 0c35.3 0 64 28.7 64 64l0 192 64 0 0-192c0-70.7-57.3-128-128-128L32 32zM320 480c70.7 0 128-57.3 128-128l0-320-64 0 0 320c0 35.3-28.7 64-64 64l-128 0 0-256-64 0 0 320 192 0z"]
};
var faIls = faShekelSign;
var faShekel = faShekelSign;
var faSheqel = faShekelSign;
var faSheqelSign = faShekelSign;
var faSquareU = {
  prefix: 'fass',
  iconName: 'square-u',
  icon: [448, 512, [], "e281", "M448 32l-448 0 0 448 448 0 0-448zM176 168l0 104c0 26.5 21.5 48 48 48s48-21.5 48-48l0-128 48 0 0 128c0 53-43 96-96 96s-96-43-96-96l0-128 48 0 0 24z"]
};
var faTruckContainerEmpty = {
  prefix: 'fass',
  iconName: 'truck-container-empty',
  icon: [640, 512, [], "e2b5", "M448 128l-32 0 0 208-416 0 0 88c0 48.6 39.4 88 88 88 25.2 0 48-10.6 64-27.6 16 17 38.8 27.6 64 27.6 40.3 0 74.2-27.1 84.7-64l118.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l51.3 0 0-237.3-9.4-9.4-64-64-9.4-9.4-109.3 0zM576 288l-96 0 0-96 50.7 0 45.3 45.3 0 50.7zM88 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm376 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM216 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faUserPilotTie = {
  prefix: 'fass',
  iconName: 'user-pilot-tie',
  icon: [448, 512, [], "e2c1", "M48 48l0-32 176-48 176 48 0 32-32 19.2 0 44.8s-5.8 2.8-16 6.7l0 25.3c0 70.7-57.3 128-128 128S96 214.7 96 144l0-25.3c-10.2-3.9-16-6.7-16-6.7L80 67.2 48 48zm176 96c-29.1 0-56.8-4.6-80-10.3l0 10.3c0 44.2 35.8 80 80 80s80-35.8 80-80l0-10.3c-23.2 5.7-50.9 10.3-80 10.3zm48 184l-31.6 36.9 31 115.1 .6 0 40-160 56 0 64 192-416 0 64-192 56 0 40 160 31.4-115.3-31.4-36.7 0-24 96 0 0 24zM168.8 26.5L154.5 55.2c3.9 2 24.7 12.3 62.3 31.2l7.2 3.6 7.2-3.6c37.6-18.8 58.4-29.2 62.3-31.2L279.2 26.5c-5.1 2.6-23.5 11.8-55.2 27.6-31.6-15.8-50-25-55.2-27.6zM336 416l-16 0 0 32 48 0 0-32-32 0z"]
};
var faRadio = {
  prefix: 'fass',
  iconName: 'radio',
  icon: [512, 512, [128251], "f8d7", "M494.3 15.2l23.2-6-12-46.5-23.2 6-464 120-18 4.7 0 386.6 512 0 0-384-330.3 0 312.3-80.8zM368.2 208a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm-304 16l160 0 0 48-160 0 0-48zm0 96l160 0 0 48-160 0 0-48z"]
};
var faHandDots = {
  prefix: 'fass',
  iconName: 'hand-dots',
  icon: [512, 512, ["allergies"], "f461", "M288.2 32l0-32-64 0 0 256-32 0 0-224-64 0 0 304c0 1.5 0 3.1 .1 4.6-31.5-30-55.7-53-72.6-69.1L.5 329.4c8.2 7.8 49.7 47.4 124.5 118.6 43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-240-64 0 0 160-32 0 0-224-64 0 0 224-32 0 0-224zm-88 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-88 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faAllergies = faHandDots;
var faPencilLine = {
  prefix: 'fass',
  iconName: 'pencil-line',
  icon: [640, 512, [], "e74f", "M70.1 512.3L16 527.4c5.8-20.7 24.5-87.4 56-200L261.1 138.3 295 104.4c15.6 15.6 52.3 52.3 110.1 110.1L439 248.4 405.1 282.3 216 471.4 70.1 512.3zm45.8-160.9l-1.1 1-29.6 105.7 105.7-29.6 1.1-1 0-28.1-48 0 0-48-28.1 0zM473 214.5c-15.6-15.6-52.3-52.3-110.1-110.1L329 70.5c53.4-53.4 60.2-60.2 87-87 15.6 15.6 52.3 52.3 110.1 110.1L560 127.4c-53.4 53.4-60.2 60.2-87 87zM312 464l296 0 0 48-320 0 0-48 24 0z"]
};
var faHandShaka = {
  prefix: 'fass',
  iconName: 'hand-shaka',
  icon: [576, 512, [], "e831", "M102.8 45.5l24 88 1.4 5.2 0 18.8-42.5 42.5 68 68-16 16 90.5 90.5 16-16 68 68 47.8-47.8 .1 .1 168.1-168 45.3 45.2-201.4 201.4c-35 35-82.4 54.6-131.9 54.6s-96.9-19.7-131.9-54.6l-2.8-2.8c-36.7-36.7-57.4-86.6-57.4-138.5l0-166.7C31.2 86.8 20.1 46.3 15.1 27.9L92.3 6.9 102.8 45.5zM421.5 272L312.3 381.3 267 336 376.3 226.8 421.5 272zm-64-72L228.3 329.3 183 284 312.3 154.8 357.5 200zm-72-64L176.3 245.2 131 200 240.3 90.8 285.5 136z"]
};
var faFlaskGear = {
  prefix: 'fass',
  iconName: 'flask-gear',
  icon: [576, 512, [], "e5f1", "M0 448l128-224 0-160-32 0 0-64 256 0 0 64-32 0 0 153.5-36.5-21.1-23.8 42.5-2.4 4.3-1.3-2.2 0-177-64 0 0 177c-.9 1.6-16 27.9-45.1 79l67.5 0-.2 .4-22.4 40 37.7 23.5-37.7 23.4c12.6 22.6 32.1 57.5 58.5 104.8L0 512 0 448zM368.2 223.9l96 0 0 41.4c11.1 4.5 21.4 10.5 30.7 17.8l35.9-20.7 45.3 81.5-33.4 20.9c.9 6.3 1.4 12.7 1.4 19.2 0 6.5-.5 12.9-1.4 19.1l33.4 20.8-45.3 81.7-35.9-20.7c-9.3 7.3-19.6 13.3-30.7 17.8l0 41.4-96 0 0-41.2c-11.2-4.5-21.5-10.5-30.9-17.8l-35.7 20.6-45.6-81.7 33.4-20.7c-.9-6.3-1.4-12.7-1.4-19.2 0-6.5 .5-13 1.4-19.3l-33.4-20.8 45.6-81.5 35.7 20.6c9.3-7.3 19.7-13.3 30.9-17.8l0-41.2zm99.9 160.2a52 52 0 1 0 -104 0 52 52 0 1 0 104 0z"]
};
var faBookSkull = {
  prefix: 'fass',
  iconName: 'book-skull',
  icon: [448, 512, ["book-dead"], "f6b7", "M0 0l448 0 0 384-32 0 0 64 32 0 0 64-448 0 0-512zM64 416l0 32 288 0 0-64-256 0c-17.7 0-32 14.3-32 32zM272 163.2c19.4-11.7 32-30.3 32-51.2 0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2l0 28.8 96 0 0-28.8zM176 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm65.9 109.5c-1.9 .9-34.5 15.7-97.9 44.5-63.4-28.8-96-43.7-97.9-44.5l-16.6 36.4c7.2 3.3 29.2 13.3 66.2 30.1-36.9 16.8-59 26.8-66.2 30.1l16.6 36.4c1.9-.9 34.5-15.7 97.9-44.5 63.4 28.8 96 43.7 97.9 44.5l16.6-36.4c-7.2-3.3-29.2-13.3-66.2-30.1 36.9-16.8 59-26.8 66.2-30.1l-16.6-36.4z"]
};
var faBookDead = faBookSkull;
var faUnlockKeyhole = {
  prefix: 'fass',
  iconName: 'unlock-keyhole',
  icon: [384, 512, ["unlock-alt"], "f13e", "M192 32c-35.3 0-64 28.7-64 64l0 64 256 0 0 352-384 0 0-352 64 0 0-64c0-70.7 57.3-128 128-128 63.5 0 116.1 46.1 126.2 106.7l5.3 31.6-63.1 10.6-5.3-31.6C250 55.1 223.7 32 192 32zm40 328l24 0 0-48-128 0 0 48 104 0z"]
};
var faUnlockAlt = faUnlockKeyhole;
var faTruckRamp = {
  prefix: 'fass',
  iconName: 'truck-ramp',
  icon: [576, 512, [], "f4e0", "M320.3 32l256 0 0 392c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8l-43.7 0-315.5 94.6-30.7 9.2-18.4-61.3 30.7-9.2 297.2-89.2 0-328.2zm208 391.9c-.1-22-17.9-39.9-40-39.9-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40l0-.1z"]
};
var faEnvelopeDot = {
  prefix: 'fass',
  iconName: 'envelope-dot',
  icon: [576, 512, ["envelope-badge"], "e16f", "M496 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM368 80c0 56.9 37.1 105 88.3 121.7l-149.1 111.9-19.2 14.4-19.2-14.4-224-168-12.8-9.6 0-72 337 0c-.7 5.2-1 10.6-1 16zM336 352L536.9 201.3c2.4-.8 4.8-1.7 7.1-2.6l0 249.3-512 0 0-252 256 192 48-36z"]
};
var faEnvelopeBadge = faEnvelopeDot;
var faHouseHeart = {
  prefix: 'fass',
  iconName: 'house-heart',
  icon: [512, 512, ["home-heart"], "f4c9", "M512 272l-48 0 0 240-416 0 0-240-48 0 0-48 256-240 256 240 0 48zM249.6 247.5c-11.1-14.8-28.5-23.5-46.9-23.5-32.4 0-58.7 26.3-58.7 58.7l0 5.3c0 64 112 128 112 128s112-64 112-128l0-5.3c0-32.4-26.3-58.7-58.7-58.7-18.5 0-35.9 8.7-46.9 23.5l-6.4 8.5-6.4-8.5z"]
};
var faHomeHeart = faHouseHeart;
var faFileArrowUp = {
  prefix: 'fass',
  iconName: 'file-arrow-up',
  icon: [384, 512, ["file-upload"], "f574", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM209 263l-17-17c-3.5 3.5-30.5 30.5-81 81l-17 17 33.9 33.9c10.3-10.3 23.6-23.6 40-40l0 110.1 48 0 0-110.1c16.4 16.4 29.7 29.7 40 40L289.9 344c-3.5-3.5-30.5-30.5-81-81z"]
};
var faFileUpload = faFileArrowUp;
var faGameConsoleHandheld = {
  prefix: 'fass',
  iconName: 'game-console-handheld',
  icon: [384, 512, [], "f8bb", "M0 0L384 0 384 512 0 512 0 0zM96 64l0 160 192 0 0-160-192 0zM232 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 288l0 32-32 0 0 32 32 0 0 32 32 0 0-32 32 0 0-32-32 0 0-32-32 0z"]
};
var faFaceGrinTears = {
  prefix: 'fass',
  iconName: 'face-grin-tears',
  icon: [640, 512, [128514, "grin-tears"], "f588", "M543.8 380.3C500.1 458.9 416.3 512 320 512S139.9 458.9 96.2 380.3c24.1-13.5 41.6-37.8 45.7-66.8 6.8-47.8 12.6-88 17.2-120.7-37.8 5.4-67.8 9.7-90.2 12.9 23.4-117.3 126.9-205.7 251.1-205.7S547.7 88.4 571.1 205.7c-22.4-3.2-52.5-7.5-90.2-12.9 4.7 32.7 10.4 72.9 17.2 120.7 4.1 29 21.6 53.2 45.8 66.8zm-66.2-81C432.4 317.4 378.2 328 320 328s-112.4-10.6-157.7-28.7C175.3 374.7 240.9 432 320 432s144.7-57.3 157.7-132.7zM212 208c0-15.5 12.5-28 28-28s28 12.5 28 28l0 28 40 0 0-28c0-37.6-30.4-68-68-68s-68 30.4-68 68l0 28 40 0 0-28zm188-28c15.5 0 28 12.5 28 28l0 28 40 0 0-28c0-37.6-30.4-68-68-68s-68 30.4-68 68l0 28 40 0 0-28c0-15.5 12.5-28 28-28zM640 300.6c0 28.4-23 51.4-51.4 51.4-25.6 0-47.3-18.8-50.9-44.1l-9.7-67.9 67.9 9.7c25.3 3.6 44.1 25.3 44.1 50.9zm-640 0c0-25.6 18.8-47.3 44.1-50.9l67.9-9.7-9.7 67.9C98.7 333.2 77 352 51.4 352 23 352 0 329 0 300.6z"]
};
var faGrinTears = faFaceGrinTears;
var faPenToSquare = {
  prefix: 'fass',
  iconName: 'pen-to-square',
  icon: [576, 512, ["edit"], "f044", "M176 272l-16 112 112-16 191-191-96-96-191 191zM560 80l-96-96-63 63 96 96 63-63zM64 64l-32 0 0 448 448 0 0-224-64 0 0 160-320 0 0-320 160 0 0-64-192 0z"]
};
var faEdit = faPenToSquare;
var faEarthEurope = {
  prefix: 'fass',
  iconName: 'earth-europe',
  icon: [512, 512, ["globe-europe"], "f7a2", "M454 320l-22 0-48-48 0-80 32 0 0-32-64 0 0 48-96 0 0 32-64 0 0-32 80-80 0-16-48 0 0-32 32-32c114.9 0 208 93.1 208 208 0 22.3-3.5 43.8-10 64zm-13.4 32C408.2 414.1 345.4 457.8 272 463.4l0-31.4-64 0-48-48 0-112 144 0 48 48 32 0 32 32 24.6 0zM256 512l26.2-1.3c-8.6 .9-17.3 1.3-26.2 1.3zm26.2-1.3C411.3 497.6 512 388.6 512 256 512 114.6 397.4 0 256 0l0 0C114.6 0 0 114.6 0 256 0 383.5 93.2 489.3 215.3 508.8 228.5 510.9 242.1 512 256 512zM187.3 123.3c-24.8 24.8-39.2 39.2-43.3 43.3L121.4 144c4.1-4.1 18.5-18.5 43.3-43.3l11.3-11.3 22.6 22.6-11.3 11.3z"]
};
var faGlobeEurope = faEarthEurope;
var faTablePicnic = {
  prefix: 'fass',
  iconName: 'table-picnic',
  icon: [512, 512, [], "e32d", "M125.7 347.9l-40.1 100.1-68.9 0 44.8-112 68.9 0-4.8 11.9zm352 56.2l17.6 43.9-68.9 0-8.1-20.1-36.7-91.9 68.9 0 27.3 68.1zM448 128l-80.7 0 38.4 96 106.3 0 0 64-512 0 0-64 106.3 0 38.4-96-80.8 0 0-64 384 0 0 64zM175.2 224l161.5 0-38.4-96-84.7 0-38.4 96z"]
};
var faFaceGrinBeamSweat = {
  prefix: 'fass',
  iconName: 'face-grin-beam-sweat',
  icon: [576, 512, [128517, "grin-beam-sweat"], "f583", "M497.7-21.6c4.6-4.5 9.4-8.7 14.3-12.9 4.9 4.2 9.7 8.4 14.3 12.9 10.8 10.5 28.8 29.7 40 51.3 5.6 10.7 9.6 22.5 9.6 34.3 0 36.4-27.6 64-64 64s-64-27.6-64-64c0-11.8 4.1-23.6 9.6-34.3 11.2-21.6 29.2-40.8 40-51.3zM288 0c42.5 0 82.6 10.4 117.8 28.7-3.6 10.9-5.8 22.7-5.8 35.3 0 62.9 49.1 112 112 112 6.4 0 12.7-.5 18.8-1.5 8.6 25.6 13.2 53 13.2 81.5 0 141.4-114.6 256-256 256S32 397.4 32 256 146.6 0 288 0zm0 328c-58.2 0-112.4-10.6-157.7-28.7 13 75.4 78.6 132.7 157.7 132.7s144.7-57.3 157.7-132.7C400.4 317.4 346.2 328 288 328zM208 180c15.5 0 28 12.5 28 28l0 28 40 0 0-28c0-37.6-30.4-68-68-68s-68 30.4-68 68l0 28 40 0 0-28c0-15.5 12.5-28 28-28zm132 28c0-15.5 12.5-28 28-28s28 12.5 28 28l0 28 40 0 0-28c0-37.6-30.4-68-68-68s-68 30.4-68 68l0 28 40 0 0-28z"]
};
var faGrinBeamSweat = faFaceGrinBeamSweat;
var faCircleHalfStroke = {
  prefix: 'fass',
  iconName: 'circle-half-stroke',
  icon: [512, 512, [9680, "adjust"], "f042", "M448 256c0-106-86-192-192-192l0 384c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"]
};
var faAdjust = faCircleHalfStroke;
var faRulerTriangle = {
  prefix: 'fass',
  iconName: 'ruler-triangle',
  icon: [576, 512, [128208], "f61c", "M64.3-29.3l0 509.3 509.3 0-77.7-77.7c-9.4 9.4-19.9 19.9-31.6 31.6L430.3 400c11.7-11.7 22.2-22.2 31.6-31.6l-46.1-46.1c-29.4 29.4-47.9 47.9-55.6 55.6L326.3 344c7.7-7.7 26.2-26.2 55.6-55.6l-46.1-46.1c-9.4 9.4-19.9 19.9-31.6 31.6L270.3 240c11.7-11.7 22.2-22.2 31.6-31.6l-46.1-46.1c-29.4 29.4-47.9 47.9-55.6 55.6L166.3 184c7.7-7.7 26.2-26.2 55.6-55.6L175.9 82.3c-9.4 9.4-19.9 19.9-31.6 31.6L110.3 80 141.9 48.4 64.3-29.3zm128 293l88.2 88.2-88.2 0 0-88.2z"]
};
var faOctagonPlus = {
  prefix: 'fass',
  iconName: 'octagon-plus',
  icon: [512, 512, ["plus-octagon"], "f301", "M0 160L0 352 160 512 352 512 512 352 512 160 352 0 160 0 0 160zM232 368l0-88-88 0 0-48 88 0 0-88 48 0 0 88 88 0 0 48-88 0 0 88-48 0z"]
};
var faPlusOctagon = faOctagonPlus;
var faUserCowboy = {
  prefix: 'fass',
  iconName: 'user-cowboy',
  icon: [448, 512, [], "f8ea", "M106.9 80.4c-37.7-10.4-71.8-25.7-100.9-44.7 12.6 39.5 45.8 73.5 91 95.9-.4 4.1-.6 8.2-.6 12.4 0 70.7 57.3 128 128 128s128-57.3 128-128c0-4.2-.2-8.3-.6-12.4 45.2-22.4 78.4-56.3 91-95.9-29.1 19-63.3 34.3-100.9 44.7l-37.5-112.4-80 32-80-32-37.5 112.4zM224.4 224c-42.3 0-77-32.9-79.8-74.5 24.8 6.8 51.7 10.5 79.8 10.5s55-3.7 79.8-10.5c-2.8 41.6-37.5 74.5-79.8 74.5zm208 288l-64-192-288 0-64 192 416 0z"]
};
var faBookmarkPlus = {
  prefix: 'fass',
  iconName: 'bookmark-plus',
  icon: [384, 512, [], "e755", "M0 0L0 528 192 416 384 528 384 0 0 0zM168 320l0-72-72 0 0-48 72 0 0-72 48 0 0 72 72 0 0 48-72 0 0 72-48 0z"]
};
var faPersonMilitaryToPerson = {
  prefix: 'fass',
  iconName: 'person-military-to-person',
  icon: [512, 512, [], "e54c", "M200 0l-144 14.1 0 32 144 0 0-46.1zM189.5 78.1l-122.9 0c-1.6 5.7-2.5 11.7-2.5 17.9 0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM192 192L83.8 192 217.8 295 192 192zM32 320L197.8 320 58.7 213.1 32 320zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96 160l-32-128-128 0-32 128 192 0zM272 432l96 80 16 0 0-56c82.7 0 125.3 0 128 0l0-48c-2.7 0-45.3 0-128 0l0-56-16 0-96 80zM128 352l0 56c-82.7 0-125.3 0-128 0l0 48c2.7 0 45.3 0 128 0l0 56 16 0 96-80-96-80-16 0z"]
};
var faImageMusic = {
  prefix: 'fass',
  iconName: 'image-music',
  icon: [640, 512, [], "e770", "M512 32l-448 0 0 448 209.5 0c4.6-24.3 19.4-43.6 36.5-56.4 3.7-2.8 7.5-5.3 11.5-7.6l-209.5 0 96-144 46.1 69.1 81.9-133.1 16 26 0-6.2 160-29.1 0-166.7zM192 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM624 255.8l0-28.8-28.3 5.1-176 32-19.7 3.6 0 181.8c-5.9-1.1-11.4-1.6-16-1.6-9.5 0-22.9 2.1-34.9 7.5-11.1 5-29.1 17.2-29.1 40.5s18 35.4 29.1 40.5c11.9 5.4 25.4 7.5 34.9 7.5s22.9-2.1 34.9-7.5c11.1-5 29.1-17.2 29.1-40.5l0-140.1 128-23.3 0 85c-5.9-1.1-11.4-1.6-16-1.6-9.5 0-22.9 2.1-34.9 7.5-11.1 5-29.1 17.2-29.1 40.5s18 35.4 29.1 40.5c11.9 5.4 25.4 7.5 34.9 7.5s22.9-2.1 34.9-7.5c11.1-5 29.1-17.2 29.1-40.5l0-208.1z"]
};
var faPersonPinball = {
  prefix: 'fass',
  iconName: 'person-pinball',
  icon: [512, 512, [], "e21d", "M512 544l-64 0 0-160-224 0 0 160-64 0 0-245-48-61.7 0 306.8-64 0 0-178.7-48-48 0-205.3 95.7 0 9.6 12.3 94.3 121.2 231.5-51.4-45.3-136-1.7-4.9 0-85.2 128 0 0 576zM248 288a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM64 80A56 56 0 1 1 64-32 56 56 0 1 1 64 80z"]
};
var faMouseField = {
  prefix: 'fass',
  iconName: 'mouse-field',
  icon: [512, 512, [], "e5a8", "M396.2 113.6c2.5-8.1 3.8-16.7 3.8-25.6 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 29.8 14.8 56.1 37.4 72l-5.4 0c-88.4 0-160 71.6-160 160l0 48-24 0c-39.8 0-72 32.2-72 72s32.2 72 72 72l408 0 0-48-408 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l344 0 0-56.8c-4.8-1.8-26.8-9.7-65.7-23.9l23.8-63.5c2 .1 4 .2 6 .2l131.9 0 0-23.1c0-43-19.8-81.4-50.8-106.5 11.8-15 18.8-33.9 18.8-54.4 0-46.4-35.9-84.4-81.4-87.8 20.6 20.3 33.4 48.5 33.4 79.8 0 14.5-2.8 28.4-7.8 41.1-8.9-3.4-18.3-6-28-7.5zM400 196a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM312 48c22.1 0 40 17.9 40 40l0 40-40 0c-22.1 0-40-17.9-40-40s17.9-40 40-40z"]
};
var faTableCellsColumnLock = {
  prefix: 'fass',
  iconName: 'table-cells-column-lock',
  icon: [640, 512, [], "e678", "M256 224l0 192 64 0 0-192-64 0zm256-79c-46.7 5.8-85.6 36.8-102.7 79l-25.3 0 0 48-16 0 0 208-304 0 0-448 448 0 0 113zM128 224l0 192 64 0 0-192-64 0zm400 16c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
var faTruckFieldUn = {
  prefix: 'fass',
  iconName: 'truck-field-un',
  icon: [640, 512, [], "e58e", "M384 32l-352 0 0 96-32 0 0 160 32 0 0 96 32.4 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8l144.7 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8l48.4 0 0-160-72.7 0-1.7-4.2-56-136-8.2-19.8-85.4 0 0-32zm0 192l0-96 42.6 0 39.5 96-82.1 0zM152 352a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm280 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM132 144l0 64c0 6.6 5.4 12 12 12s12-5.4 12-12l0-84 40 0 0 84c0 28.7-23.3 52-52 52s-52-23.3-52-52l0-84 40 0 0 20zm108-20l20.4 0c1.6 3.2 9.5 18.9 23.6 47.3l0-47.3 40 0 0 136-40.4 0c-1.6-3.2-9.5-18.9-23.6-47.3l0 47.3-40 0 0-136 20 0z"]
};
var faClock = {
  prefix: 'fass',
  iconName: 'clock',
  icon: [512, 512, [128339, "clock-four"], "f017", "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 148.8 10.7 7.1 96 64 20 13.3 26.6-39.9c-2.4-1.6-37.5-25-105.3-70.2l0-147.2-48 0 0 24z"]
};
var faClockFour = faClock;
var faLayerMinus = {
  prefix: 'fass',
  iconName: 'layer-minus',
  icon: [576, 512, ["layer-group-minus"], "f5fe", "M408 24l136 0 0 48-160 0 0-48 24 0zM288 352L16 224 288 96 560 224 288 352zM129.6 330.5L288 405 446.4 330.5 560 384 288 512 16 384 129.6 330.5z"]
};
var faLayerGroupMinus = faLayerMinus;
var faCircleEuro = {
  prefix: 'fass',
  iconName: 'circle-euro',
  icon: [512, 512, [], "e5ce", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM144.2 240l-24.2 0 0-32 32.1 0c19.6-51.5 69.5-88 127.8-88l57 0 0 48-57 0c-31 0-58.3 15.9-74.2 40l66.3 0 0 32-79.3 0c-1 5.4-1.6 11-1.6 16.8 0 5.2 .4 10.3 1.3 15.2l79.5 0 0 32-67.2 0c15.7 24.9 43.5 41.5 75.2 41.5l57 0 0 48-57 0c-58.9 0-109.1-37.3-128.4-89.5l-31.5 0 0-32 24 0c-.6-5-.8-10.1-.8-15.2 0-5.7 .3-11.3 1-16.8z"]
};
var faBook = {
  prefix: 'fass',
  iconName: 'book',
  icon: [448, 512, [128212], "f02d", "M384 0l-384 0 0 512 448 0 0-64-32 0 0-64 32 0 0-384-64 0zM96 384l256 0 0 64-288 0 0-32c0-17.7 14.3-32 32-32zm32-256l224 0 0 48-224 0 0-48zm224 96l0 48-224 0 0-48 224 0z"]
};
var faFaceLaughWink = {
  prefix: 'fass',
  iconName: 'face-laugh-wink',
  icon: [512, 512, ["laugh-wink"], "f59c", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-80c-83 0-151.2-63.1-159.2-144l318.4 0c-8 80.9-76.2 144-159.2 144zM144 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm164 8l0 16-40 0 0-16c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60l0 16-40 0 0-16c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20z"]
};
var faLaughWink = faFaceLaughWink;
var faTransducer = {
  prefix: 'fass',
  iconName: 'transducer',
  icon: [384, 512, [], "e826", "M80 544l-80 0 0-144 80 0 0 144zm176 0l-128 0 0-144 128 0 0 144zm128 0l-80 0 0-144 80 0 0 144zM160 64l64 0 0-96 48 0 0 96 48 0 0 288-256 0 0-288 48 0 0-96 48 0 0 96z"]
};
var faUserDoctorHairLong = {
  prefix: 'fass',
  iconName: 'user-doctor-hair-long',
  icon: [448, 512, [], "e459", "M304 128c0-18-6-34.6-16-48l0 0-64 48-80 0 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zm48 0l0 48 48 96-352 0 48-96 0-48C96 57.3 153.3 0 224 0S352 57.3 352 128zM284 367.4c-23.3 8.2-40 30.5-40 56.6l0 52 40 0 0-52c0-11 9-20 20-20s20 9 20 20l0 52 40 0 0-52c0-26.1-16.7-48.3-40-56.6l0-47.4 44 0 64 192-416 0 64-192 44 0 0 68.4c-16.5 7.6-28 24.3-28 43.6 0 26.5 21.5 48 48 48s48-21.5 48-48c0-19.4-11.5-36.1-28-43.6l0-68.4 120 0 0 47.4z"]
};
var faCloudMeatball = {
  prefix: 'fass',
  iconName: 'cloud-meatball',
  icon: [512, 512, [], "f73b", "M0 320l109.7 0 62.6-62.6 26.8 5.4 15.2-22.7 83.4 0 15.2 22.7 26.8-5.4 62.6 62.6 109.7 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80-24.3 0-46.1 10.9-60.8 28-18.7-35.7-56.1-60-99.2-60-61.9 0-112 50.1-112 112l0 21.5C26.7 146.6 0 182.2 0 224l0 96zM172.1 434.7l-6.6 33.1 22.6 22.6 33.1-6.6 18.7 28.1 32 0 18.7-28.1 33.1 6.6 22.6-22.6-6.6-33.1 28.1-18.7 0-32-28.1-18.7 6.6-33.1-22.6-22.6-33.1 6.6-18.7-28.1-32 0-18.7 28.1-33.1-6.6-22.6 22.6 6.6 33.1-28.1 18.7 0 32 28.1 18.7zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faCloudXmark = {
  prefix: 'fass',
  iconName: 'cloud-xmark',
  icon: [576, 512, [], "e35f", "M144 480l432 0 0-128c0-47.4-25.7-88.7-64-110.9l0-49.1c0-53-43-96-96-96-17.7 0-34.2 4.8-48.4 13.1-24.1-45.8-72.2-77.1-127.6-77.1-79.5 0-144 64.5-144 144l0 24.2C40.1 220 0 273.3 0 336l0 144 144 0zM372.9 237.1c-8.5 8.5-25.5 25.5-50.9 50.9 25.5 25.5 42.4 42.4 50.9 50.9l-33.9 33.9c-8.5-8.5-25.5-25.5-50.9-50.9-25.5 25.5-42.4 42.4-50.9 50.9l-33.9-33.9c8.5-8.5 25.5-25.5 50.9-50.9-25.5-25.5-42.4-42.4-50.9-50.9l33.9-33.9c8.5 8.5 25.5 25.5 50.9 50.9 25.5-25.5 42.4-42.4 50.9-50.9l33.9 33.9z"]
};
var faChartArea = {
  prefix: 'fass',
  iconName: 'chart-area',
  icon: [512, 512, ["area-chart"], "f1fe", "M64 64l0-32-64 0 0 448 512 0 0-64-448 0 0-352zM328.8 189.3l-88.8-96.8-112 122.2 0 137.3 352 0 0-137.9-88-88-63.2 63.2z"]
};
var faAreaChart = faChartArea;
var faUtilityPoleDouble = {
  prefix: 'fass',
  iconName: 'utility-pole-double',
  icon: [512, 512, [], "e2c4", "M288 0l0 64 96 0 0-32 48 0 0 32 32 0 0-32 48 0 0 96-68.7 0-155.3 103.5 0 24.5 96 0 0-32 48 0 0 32 32 0 0-32 48 0 0 96-68.7 0-155.3 103.5 0 88.5-64 0 0-88.5-155.3-103.5-68.7 0 0-96 48 0 0 32 32 0 0-32 48 0 0 32 96 0 0-24.5-155.3-103.5-68.7 0 0-96 48 0 0 32 32 0 0-32 48 0 0 32 96 0 0-64 64 0zM155.3 128l68.7 45.8 0-45.8-68.7 0zM288 173.8l68.7-45.8-68.7 0 0 45.8zM155.3 320l68.7 45.8 0-45.8-68.7 0zM288 365.8l68.7-45.8-68.7 0 0 45.8z"]
};
var faRupiahSign = {
  prefix: 'fass',
  iconName: 'rupiah-sign',
  icon: [512, 512, [], "e23d", "M0 32l112 0c79.5 0 144 64.5 144 144 0 54.3-30 101.5-74.4 126.1 32.7 108.8 49.4 164.6 50.2 167.4l-61.3 18.4c-.8-2.6-17.6-58.7-50.4-168.1-2.7 .1-5.4 .2-8.1 .2l-48 0 0 160-64 0 0-448zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0 0 160zm224-32l112 0c61.9 0 112 50.1 112 112S461.9 448 400 448l-48 0 0 96-64 0 0-320zm64 160l48 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-48 0 0 96z"]
};
var faDiagramNested = {
  prefix: 'fass',
  iconName: 'diagram-nested',
  icon: [448, 512, [], "e157", "M0 32l192 0 0 192-64 0 0 128 128 0 0-64 192 0 0 192-192 0 0-64-192 0 0-192-64 0 0-192z"]
};
var faSquareQuarters = {
  prefix: 'fass',
  iconName: 'square-quarters',
  icon: [448, 512, [], "e44e", "M0 32l448 0 0 448-448 0 0-448zM64 96L224 256 384 96 64 96zm0 320l320 0-160-160-160 160z"]
};
var faPrintSlash = {
  prefix: 'fass',
  iconName: 'print-slash',
  icon: [576, 512, [], "f686", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-.6-.6-33.3-33.3-98.1-98.1l0-30 64 0 0-192-286 0-48-48 270 0 0-64-80-80-304 0 0 30-46.8-46.8zM378.2 448l-218 0 0-96 122 0-160-160-90 0 0 192 64 0 0 128 346 0-64-64zm62-176a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faShieldKeyhole = {
  prefix: 'fass',
  iconName: 'shield-keyhole',
  icon: [512, 512, [], "e248", "M256 0l11.6 4.5 207.5 80.5 19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.3-91.1 150-189.4 192.6l-12.7 5.5-12.7-5.5C144.9 463.9 86.6 389.2 53.9 313.9 21.5 239.3 13.7 162.9 16.6 113L17.8 92.5 37 85 244.5 4.5 256 0zm56 208c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 93.4 48 0 0-93.4c18.9-9 32-28.3 32-50.6z"]
};
var faSquareLeft = {
  prefix: 'fass',
  iconName: 'square-left',
  icon: [448, 512, [11013, "arrow-alt-square-left"], "f351", "M0 32l0 448 448 0 0-448-448 0zM224 384l-8 0-128-128 128-128 8 0 0 80 128 0 0 96-128 0 0 80z"]
};
var faArrowAltSquareLeft = faSquareLeft;
var faTextWidth = {
  prefix: 'fass',
  iconName: 'text-width',
  icon: [512, 512, [], "f035", "M64.3 0l-32 0 0 128 64 0 0-64 128 0 0 160-64 0 0 64 192 0 0-64-64 0 0-160 128 0 0 64 64 0 0-128-416 0zm86.6 406.6l22.6-22.6-45.3-45.3c-8.2 8.2-37.1 37.1-86.6 86.6L19 448c8.2 8.2 37.1 37.1 86.6 86.6l22.6 22.6 45.3-45.3-32-32 229.5 0-32 32 45.3 45.3 109.3-109.3-109.3-109.3-45.3 45.3 32 32-229.5 0 9.4-9.4z"]
};
var faCircleCurrency = {
  prefix: 'fass',
  iconName: 'circle-currency',
  icon: [512, 512, [], "e6ee", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM168 134.1c10.4 10.4 23.5 23.5 39.2 39.2 14.3-8.4 31-13.3 48.8-13.3s34.5 4.8 48.8 13.3c15.7-15.7 28.8-28.8 39.2-39.2L377.9 168c-10.4 10.4-23.5 23.5-39.2 39.2 8.4 14.3 13.3 31 13.3 48.8s-4.8 34.5-13.3 48.8c15.7 15.7 28.8 28.8 39.2 39.2L344 377.9c-10.4-10.4-23.5-23.5-39.2-39.2-14.3 8.4-31 13.3-48.8 13.3s-34.5-4.8-48.8-13.3c-15.7 15.7-28.8 28.8-39.2 39.2L134.1 344c10.4-10.4 23.5-23.5 39.2-39.2-8.4-14.3-13.3-31-13.3-48.8s4.8-34.5 13.3-48.8c-15.7-15.7-28.8-28.8-39.2-39.2L168 134.1zm54.2 87.9l-.2 .2c-8.6 8.7-13.9 20.6-13.9 33.8s5.3 25.2 13.9 33.8c0-67.7 0-67.6 .2 .2 8.7 8.6 20.6 13.9 33.8 13.9s25.2-5.3 33.8-13.9l.2-.2c8.6-8.7 13.9-20.6 13.9-33.8s-5.3-25.2-13.9-33.8l-.2-.2c-8.7-8.6-20.6-13.9-33.8-13.9s-25.2 5.3-33.8 13.9z"]
};
var faSignatureLock = {
  prefix: 'fass',
  iconName: 'signature-lock',
  icon: [576, 512, [], "e3ca", "M160 96c-17.7 0-32 14.3-32 32l0 64-64 0 0-64c0-53 43-96 96-96s96 43 96 96l0 7.8c0 18.2-.9 36.4-2.7 54.6 40.1-13.5 73-24.6 98.7-33.3l0 53c-10.2 18.4-16 39.5-16 62l-48 0 0-25.8-46.8 15.8-1.2 5.3c-11.8 53.3-31.6 104.5-58.7 151.9-19.8 34.6-31.3 54.8-34.8 60.8l-114.6 0 0-215 21.8-7.3 132-44.5c4.2-25.6 6.3-51.4 6.3-77.3l0-7.8c0-17.7-14.3-32-32-32zM304 368l0 48-84.5 0c8.2-15.7 15.6-31.7 22.3-48l62.1 0zM169 286.3l-73 24.6 0 105 13.4 0 16.3-28.6c18.3-32 32.8-65.9 43.3-101.1zm327-14.2c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 47.9 64 0 0-47.9zM352 320l32 0 0-47.9c0-44.2 35.8-80 80-80s80 35.8 80 80l0 47.9 32 0 0 192-224 0 0-192z"]
};
var faSatellite = {
  prefix: 'fass',
  iconName: 'satellite',
  icon: [576, 512, [128752], "f7bf", "M248.4-9.9l17 17 89.4 89.4c42.1-42.1 68-68 77.7-77.7 10.9 10.9 34.4 34.4 70.6 70.6L525.7 112c-9.7 9.7-35.6 35.6-77.7 77.7l89.4 89.4 17 17-17 17-96 96-17 17-106.3-106.3-15.5 15.5c11.4 24.6 17.8 52 17.8 80.9 0 38.7-11.4 74.7-31.1 104.9L179.1 410.6c-46.2 46.2-73.8 73.8-82.6 82.6L51.2 448c8.9-8.9 36.4-36.4 82.6-82.6L23.6 255.1c30.1-19.7 66.2-31.1 104.9-31.1 28.9 0 56.3 6.4 80.9 17.8l15.5-15.5-89.4-89.4-17-17 17-17 96-96 17-17zm0 67.9l-62.1 62.1 72.4 72.4 62.1-62.1-72.4-72.4zm176 300.1l62.1-62.1-72.4-72.4-62.1 62.1 72.4 72.4z"]
};
var faBallPile = {
  prefix: 'fass',
  iconName: 'ball-pile',
  icon: [576, 512, [], "f77e", "M288 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM176 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM160 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm128 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm288-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM400 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
var faSeats = {
  prefix: 'fass',
  iconName: 'seats',
  icon: [512, 512, [], "e765", "M224 0l0 240-192 0 0-240 192 0zM480 0l0 240-192 0 0-240 192 0zm32 384l-32 0 0 128-64 0 0-128-128 0 0 128-64 0 0-128-128 0 0 128-64 0 0-128-32 0 0-96 512 0 0 96z"]
};
var faFileEps = {
  prefix: 'fass',
  iconName: 'file-eps',
  icon: [576, 512, [], "e644", "M272 0l-240 0 0 512 144 0 0-176 240 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM240 380l-20 0 0 168 104 0 0-40-64 0 0-24 48 0 0-40-48 0 0-24 64 0 0-40-84 0zm128 0l-20 0 0 168 40 0 0-48 12 0c33.1 0 60-26.9 60-60s-26.9-60-60-60l-32 0zm32 80l-12 0 0-40 12 0c11 0 20 9 20 20s-9 20-20 20zm76-28c0 28.7 23.3 52 52 52 6.6 0 12 5.4 12 12s-5.4 12-12 12l-52 0 0 40 52 0c28.7 0 52-23.3 52-52s-23.3-52-52-52c-6.6 0-12-5.4-12-12s5.4-12 12-12l44 0 0-40-44 0c-28.7 0-52 23.3-52 52z"]
};
var faMagnifyingGlassMinus = {
  prefix: 'fass',
  iconName: 'magnifying-glass-minus',
  icon: [576, 512, ["search-minus"], "f010", "M448.3 208c0 45.9-14.9 88.3-40 122.7L534.9 457.4 557.5 480 512.3 525.3 489.6 502.6 363 376c-34.4 25.2-76.8 40-122.7 40-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208zm-128 24l24 0 0-48-208 0 0 48 184 0z"]
};
var faSearchMinus = faMagnifyingGlassMinus;
var faVentDamper = {
  prefix: 'fass',
  iconName: 'vent-damper',
  icon: [640, 512, [], "e465", "M64 64l512 0 0 96 64 0 0 192-64 0 0 96-512 0 0-96-64 0 0-192 64 0 0-96zm120 64l-24 0 0 48 320 0 0-48-296 0zm0 104l-24 0 0 48 320 0 0-48-296 0zm0 104l-24 0 0 48 320 0 0-48-296 0z"]
};
var faPeopleGroup = {
  prefix: 'fass',
  iconName: 'people-group',
  icon: [512, 512, [], "e533", "M256 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm64 384l0-128 32 0 0-112c0-53-43-96-96-96s-96 43-96 96l0 112 32 0 0 128 128 0zM96 144a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM32 480l112.1 0c-.1-1.3-.1-2.7-.1-4l0-44-32 0 0-160c0-26.7 7.3-51.6 19.9-73.1-11.1-4.5-23.2-6.9-35.9-6.9-53 0-96 43-96 96l0 96 32 0 0 96zm448 0l0-96 32 0 0-96c0-53-43-96-96-96-12.7 0-24.8 2.5-35.9 6.9 12.6 21.4 19.9 46.4 19.9 73.1l0 160-32 0 0 44c0 1.3 0 2.7-.1 4L480 480zM416 144a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faSquareQuote = {
  prefix: 'fass',
  iconName: 'square-quote',
  icon: [448, 512, [], "e329", "M0 32l448 0 0 448-448 0 0-448zM208 160l-112 0 0 112 64 0 0 8c0 13.3-10.7 24-24 24l-24 0 0 48 24 0c39.8 0 72-32.2 72-72l0-120zm32 0l0 112 64 0 0 8c0 13.3-10.7 24-24 24l-24 0 0 48 24 0c39.8 0 72-32.2 72-72l0-120-112 0z"]
};
var faSquareBinary = {
  prefix: 'fass',
  iconName: 'square-binary',
  icon: [448, 512, [], "e69b", "M0 32l448 0 0 448-448 0 0-448zm120 68l-20 0 0 136 120 0 0-136-100 0zm20 96l0-56 40 0 0 56-40 0zm140-96l-20 0 0 40 16 0 0 96 40 0 0-136-36 0zM132 276l0 40 16 0 0 96 40 0 0-136-56 0zm96 0l0 136 120 0 0-136-120 0zm40 40l40 0 0 56-40 0 0-56z"]
};
var faMasksTheater = {
  prefix: 'fass',
  iconName: 'masks-theater',
  icon: [640, 512, [127917, "theater-masks"], "f630", "M23 97l50 283.6 119.1 40.1 0-96.2-57.8 10.2c-.3-38.6 22.7-73.6 57.8-88.8l0-56.8-83.9 14.8c-4.6-26.1 12.8-51 38.9-55.6 17.4-3.1 34.2 3.6 44.9 16.2l0-52.5 9.6-12.8C222.6 71.3 272.5 35.6 349.1 21.8 318.6 5.5 262.8-10.3 185.2 3.4 84.4 21.2 35.1 73.2 23 97zm217.1 31l0 288 176 96 176-96 0-288c-16-21.3-73.6-64-176-64s-160 42.7-176 64zm176 288c-61.1 0-110.8-48.9-112-109.7 28.9 28.3 68.4 45.7 112 45.7s83.1-17.4 112-45.7c-1.2 60.8-50.9 109.7-112 109.7zm-112-176c0-26.5 21.5-48 48-48s48 21.5 48 48l-96 0zm224 0l-96 0c0-26.5 21.5-48 48-48s48 21.5 48 48z"]
};
var faTheaterMasks = faMasksTheater;
var faHouseTurret = {
  prefix: 'fass',
  iconName: 'house-turret',
  icon: [576, 512, [], "e1b4", "M448 0l-64 0 0 64-64 0 0-64-64 0 0 72.9 208 168 0 110.9-32 0 0 160.2 144 0 0-512-64 0 0 64-64 0 0-64zM384 304l32 0 0-40-208-168-208 168 0 40 32 0 0 208 352 0 0-208zM256 272l0 96-96 0 0-96 96 0z"]
};
var faCartPlus = {
  prefix: 'fass',
  iconName: 'cart-plus',
  icon: [640, 512, [], "f217", "M0-16l116 0c2.1 11.7 5 27.7 8.7 48l451.2 0-48 256-356.7 0 8.7 48 300 0 0 48-340 0-3.6-19.7-60.4-332.3-76 0 0-48zM160 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM312 241.6l48 0 0-57.6 57.6 0 0-48-57.6 0 0-57.6-48 0 0 57.6-57.6 0 0 48 57.6 0 0 57.6z"]
};
var faHandsAslInterpreting = {
  prefix: 'fass',
  iconName: 'hands-asl-interpreting',
  icon: [640, 512, ["american-sign-language-interpreting", "asl-interpreting", "hands-american-sign-language-interpreting"], "f2a3", "M260.5 69.9l24.6-20.5-41-49.2c-6.2 5.1-43 35.8-110.5 92.1l29.3-58.6-57.2-28.6-14.3 28.6-77.9 155.7C4.6 207.2 0 226.8 0 246.7L0 256c0 70.7 57.3 128 128 128l80 0 0-.3c46.2-3.5 83.8-37.1 93.6-81.3l-62.5-13.8c-4 17.9-20 31.3-39.1 31.3-22.1 0-40-17.9-40-40s17.9-40 40-40c19.1 0 35.1 13.4 39.1 31.3l62.5-13.8c-8-36.3-34.9-65.5-69.9-76.6 48.8-13.3 80.7-22 95.6-26.1L310.5 93.1c-11.6 3.2-50.1 13.7-115.6 31.5l65.6-54.7zM378.8 442.3l-24.6 20.5 41 49.2c6.2-5.1 43-35.8 110.5-92.1l-29.3 58.6 57.2 28.6 14.3-28.6 77.9-155.7c8.9-17.8 13.5-37.4 13.5-57.2l0-9.3c0-70.7-57.3-128-128-128l-80 0 0 .3c-46.2 3.5-83.8 37.1-93.6 81.2l62.5 13.8c4-17.9 20-31.3 39.1-31.3 22.1 0 40 17.9 40 40s-17.9 40-40 40c-19.1 0-35.1-13.4-39.1-31.3l-62.5 13.8c8 36.3 34.9 65.5 69.9 76.6-48.8 13.3-80.7 22-95.6 26.1l16.8 61.7c11.6-3.2 50.1-13.7 115.6-31.5l-65.6 54.7z"]
};
var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faAslInterpreting = faHandsAslInterpreting;
var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faFaceAnxiousSweat = {
  prefix: 'fass',
  iconName: 'face-anxious-sweat',
  icon: [640, 512, [], "e36a", "M320 512c141.4 0 256-114.6 256-256S461.4 0 320 0c-131 0-239.1 98.5-254.2 225.4 6.1 4.8 25.8 20.5 34.6 28l.3 .3c14.4 12.5 32.3 29.7 46.8 50.2 14.3 20.1 28.4 47.7 28.4 80.1 0 25.4-8 48.6-21.7 67.2 44.7 38 102.5 60.8 165.7 60.8zm0-192c44.2 0 80 35.8 80 80l0 16-160 0 0-16c0-44.2 35.8-80 80-80zm112-48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM240 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm36.3-80c-10.6 10.6-17.7 17.7-21.5 21.5-24.2 24.2-55.3 40.2-89 45.8l-2.5 .4-19.7 3.3-6.6-39.5 19.7-3.3 2.5-.4c25.5-4.2 49-16.4 67.3-34.6 3.8-3.8 11-11 21.5-21.5L276.3 160zm101.6 14.1L363.7 160 392 131.7c10.6 10.6 17.7 17.7 21.5 21.5 18.3 18.3 41.8 30.4 67.3 34.6l2.5 .4 19.7 3.3-6.6 39.5-19.7-3.3-2.5-.4c-33.7-5.6-64.8-21.6-89-45.8l-7.4-7.4zM49.7 298.4c-10.8 10.5-28.8 29.7-40 51.3-5.6 10.7-9.6 22.5-9.6 34.3 0 36.4 27.6 64 64 64s64-27.6 64-64c0-11.8-4.1-23.6-9.6-34.3-11.2-21.6-29.2-40.8-40-51.3-4.6-4.5-9.4-8.7-14.3-12.9-4.9 4.2-9.7 8.4-14.3 12.9z"]
};
var faMessageSmile = {
  prefix: 'fass',
  iconName: 'message-smile',
  icon: [512, 512, ["comment-alt-smile"], "f4aa", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM192 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM166.6 280c22 24.6 53.9 40 89.4 40s67.4-15.4 89.4-40l35.8 32c-30.7 34.3-75.5 56-125.2 56s-94.5-21.7-125.2-56l35.8-32z"]
};
var faCommentAltSmile = faMessageSmile;
var faLocationExclamation = {
  prefix: 'fass',
  iconName: 'location-exclamation',
  icon: [384, 512, ["map-marker-exclamation"], "f608", "M192 0C298 0 384 84.4 384 188.6 384 339.4 192 528 192 528S0 339.4 0 188.6C0 84.4 86 0 192 0zM164 292l0 56 56 0 0-56-56 0zM160 96l12.8 160 38.4 0 12.8-160-64 0z"]
};
var faMapMarkerExclamation = faLocationExclamation;
var faSquareNaira = {
  prefix: 'fass',
  iconName: 'square-naira',
  icon: [448, 512, [], "e708", "M0 32l448 0 0 448-448 0 0-448zm152 96l-24 0 0 128-32 0 0 32 32 0 0 96 48 0 0-96 39.5 0 52 84.6 7 11.4 45.4 0 0-96 32 0 0-32-32 0 0-128-48 0 0 128-19.8 0-71.7-116.6-7-11.4-21.4 0zm43.8 128l-19.8 0 0-32.2 19.8 32.2z"]
};
var faTableCellsRowUnlock = {
  prefix: 'fass',
  iconName: 'table-cells-row-unlock',
  icon: [640, 512, [], "e691", "M256 224l0 192 64 0 0-192-64 0zm256-79c-46.7 5.8-85.6 36.8-102.7 79l-25.3 0 0 48-16 0 0 208-304 0 0-448 448 0 0 113zM128 224l0 192 64 0 0-192-64 0zm400 16c-17.7 0-32 14.3-32 32l0 48 144 0 0 192-224 0 0-192 32 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32z"]
};
var faDiamonds4 = {
  prefix: 'fass',
  iconName: 'diamonds-4',
  icon: [576, 512, [], "e68b", "M169 409l119-119 119 119-119 119-119-119zM135 375L16 256 135 137 254.1 256 135 375zM169 103l119-119 119 119-119 119-119-119zM441 137l119 119-119 119-119-119 119-119z"]
};
var faRocket = {
  prefix: 'fass',
  iconName: 'rocket',
  icon: [576, 512, [], "f135", "M0 320l160 0 64 64 0 160 160-96 0-122.1c141.4-83.5 135.5-212 120.6-286.5-74.5-14.9-203-20.8-286.5 120.6L96 160 0 320zM384 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faFileCircleInfo = {
  prefix: 'fass',
  iconName: 'file-circle-info',
  icon: [576, 512, [58604], "e493", "M272 0l-240 0 0 512 244 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3L416 144 272 0zm85.5 176L240 176 240 58.5 357.5 176zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm15.3-224l0 32-32 0 0-32 32 0zm1.2 64l0 64 15.5 0 0 32-15.5 0-.5 0c-24 0-40 0-48 0l0-32 16 0 .5 0 0-32-.5 0-16 0 0-32c23.9 0 40.8 0 48.5 0z"]
};
var faCloudFog = {
  prefix: 'fass',
  iconName: 'cloud-fog',
  icon: [576, 512, [127787, "fog"], "f74e", "M128 320l-96 0 0-96c0-41.8 26.7-77.4 64-90.5L96 112c0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-416 0zm384 48l0 48-512 0 0-48 512 0zM64 464l128 0 0 48-128 0 0-48zm176 0l336 0 0 48-336 0 0-48z"]
};
var faFog = faCloudFog;
var faOption = {
  prefix: 'fass',
  iconName: 'option',
  icon: [640, 512, [], "e318", "M448 448l-15.4 0-9.6-12-246.4-308-176.6 0 0-64 207.4 0 9.6 12 246.4 308 176.6 0 0 64-192 0zm0-320l-32 0 0-64 224 0 0 64-192 0z"]
};
var faUtilityPole = {
  prefix: 'fass',
  iconName: 'utility-pole',
  icon: [512, 512, [], "e2c3", "M288 0l0 64 96 0 0-32 48 0 0 32 32 0 0-32 48 0 0 96-64.9 0-159.1 132.6 0 251.4-64 0 0-251.4-159.1-132.6-64.9 0 0-96 48 0 0 32 32 0 0-32 48 0 0 32 96 0 0-64 64 0zM139.9 128l84.1 70.1 0-70.1-84.1 0zM288 198.1l84.1-70.1-84.1 0 0 70.1z"]
};
var faShrimp = {
  prefix: 'fass',
  iconName: 'shrimp',
  icon: [512, 512, [129424], "e448", "M24 32l-24 0 0 144 66.4 0C77.7 257.3 147.5 320 232 320l56 0 0-192-240 0 0-48 432 0 0-48-456 0zM320 320l18.3 0c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128l-16 0 0 192zm62.8 35.1c.8 3.4 1.2 7 1.2 10.6 0 4.6-.7 9-1.9 13.1L472.6 415c24.6-30.3 39.4-68.9 39.4-111 0-12.3-1.3-24.3-3.7-35.9L382.8 355.1zm-21.2 50c-3 1.8-6.2 3.2-9.6 4.3l0 69.9c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6zM320 407.8c-48.1-16.8-80.1-28-96-33.6l0 105.8 96 0 0-72.2zM168 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faAlien = {
  prefix: 'fass',
  iconName: 'alien',
  icon: [448, 512, [128125], "f8f5", "M224 0C100.3 0 0 100.3 0 224 0 400 224 512 224 512S448 400 448 224C448 100.3 347.7 0 224 0zm32 304c0-44.2 35.8-80 80-80l48 0 0 16c0 44.2-35.8 80-80 80l-48 0 0-16zM112 224c44.2 0 80 35.8 80 80l0 16-48 0c-44.2 0-80-35.8-80-80l0-16 48 0z"]
};
var faSkeleton = {
  prefix: 'fass',
  iconName: 'skeleton',
  icon: [512, 512, [], "f620", "M288 0l0 64 160 0 0 64-160 0 0 48 224 0 0 64-224 0 0 48 128 0 0 64-128 0 0 48 80 0c44.2 0 80 35.8 80 80l0 32-64 0 0-32c0-8.8-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16l0 32-64 0 0-32c0-44.2 35.8-80 80-80l80 0 0-48-128 0 0-64 128 0 0-48-224 0 0-64 224 0 0-48-160 0 0-64 160 0 0-64 64 0z"]
};
var faTirePressureWarning = {
  prefix: 'fass',
  iconName: 'tire-pressure-warning',
  icon: [512, 512, [], "f633", "M384 32l0-32 64 0 0 46.5c0 24.1 3.9 48 11.5 70.8l2.5 7.4c4.8 14.4 11.5 28.6 19.3 44.4 17.5 35.6 33.4 82.6 27.5 136.2-5.3 48.6-28.1 99-76.8 148.7l0 58-64 0 0-32-32 0 0 32-64 0 0-32-32 0 0 32-64 0 0-32-32 0 0 32-64 0 0-58c-48.7-49.7-71.4-100.1-76.8-148.7-5.9-53.6 9.9-100.6 27.5-136.2 7.8-15.8 14.5-30 19.3-44.4l2.5-7.4C60.1 94.5 64 70.5 64 46.5l0-46.5 64 0 0 46.5c0 31-5 61.7-14.8 91.1l-2.5 7.4c-6.3 19-14.8 36.6-22.6 52.5-14.7 29.7-25.3 64-21.3 100.9 3.7 34 20.4 74.1 65.7 117.7l246.8 0c45.3-43.6 62-83.7 65.7-117.7 4.1-36.9-6.6-71.1-21.3-100.9-7.8-15.8-16.3-33.5-22.6-52.5l-2.5-7.4C389 108.2 384 77.4 384 46.5L384 32zM280 136l0 120-48 0 0-144 48 0 0 24zm0 160l0 48-48 0 0-48 48 0z"]
};
var faNose = {
  prefix: 'fass',
  iconName: 'nose',
  icon: [448, 512, [], "e5bd", "M448 512L448 368 176 0 64 0 64 249.6c17.5-6.2 36.4-9.6 56-9.6l40 0 0 48-40 0C53.7 288 0 341.7 0 408l0 104 96 0c0-44.2 35.8-80 80-80s80 35.8 80 80l192 0z"]
};
var faSignPostsWrench = {
  prefix: 'fass',
  iconName: 'sign-posts-wrench',
  icon: [640, 512, [], "e626", "M96 64l0-48 64 0 0 48 256 0 0-48 64 0 0 48 64 0 0 114.9c-10.4-1.9-21.1-2.9-32-2.9-97.2 0-176 78.8-176 176 0 35.4 10.5 68.4 28.5 96l-204.5 0 0 64-64 0 0-64-64 0 0-384 64 0zM464 233.3l0 118.7 48 32 48-32 0-118.7c46.9 19 80 65 80 118.7 0 47.4-25.7 88.7-64 110.9l0 81.1-128 0 0-81.1c-38.3-22.1-64-63.5-64-110.9 0-53.7 33.1-99.7 80-118.7z"]
};
var faTengeSign = {
  prefix: 'fass',
  iconName: 'tenge-sign',
  icon: [384, 512, [8376, "tenge"], "f7d7", "M0 32l384 0 0 48-384 0 0-48zm0 96l384 0 0 64-160 0 0 288-64 0 0-288-160 0 0-64z"]
};
var faTenge = faTengeSign;
var faFaceScream = {
  prefix: 'fass',
  iconName: 'face-scream',
  icon: [576, 512, [], "e38b", "M539.5 304c3-15.5 4.5-31.6 4.5-48 0-141.4-114.6-256-256-256S32 114.6 32 256c0 16.4 1.5 32.5 4.5 48l98.9 0c1.7 8.6 13.7 68.6 36 179.9 35 17.9 74.6 28.1 116.7 28.1s81.7-10.1 116.7-28.1c22.3-111.4 34.3-171.3 36-179.9l98.9 0zM288 320c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zm-46.6-77c-22.5 36.9-62.8 54.7-90.1 39.8s-31.1-56.8-8.7-93.7 62.8-54.7 90.1-39.8 31.1 56.9 8.7 93.7zm183.3 39.8c-27.3 14.9-67.6-2.9-90.1-39.8s-18.6-78.8 8.7-93.7 67.6 2.9 90.1 39.8 18.6 78.8-8.7 93.7zM0 352l0 160 128 0-32-160-96 0zm576 0l-96 0-32 160 128 0 0-160z"]
};
var faHouseChimneyMedical = {
  prefix: 'fass',
  iconName: 'house-chimney-medical',
  icon: [512, 512, ["clinic-medical"], "f7f2", "M464 272l48 0 0-48-48-45 0-131-96 0 0 41-112-105-256 240 0 48 48 0 0 240 416 0 0-240zM224 288l0-56 64 0 0 56 56 0 0 64-56 0 0 56-64 0 0-56-56 0 0-64 56 0z"]
};
var faClinicMedical = faHouseChimneyMedical;
var faSquareArrowLeft = {
  prefix: 'fass',
  iconName: 'square-arrow-left',
  icon: [448, 512, ["arrow-square-left"], "f33a", "M448 32l-448 0 0 448 448 0 0-448zM103 239c63.8-63.8 96.2-96.2 97-97L233.9 176c-7.6 7.6-26.3 26.3-56 56l150.1 0 24 0 0 48-174.1 0c29.7 29.7 48.4 48.4 56 56l-33.9 33.9-17-17c-63.8-63.8-96.2-96.2-97-97l17-17z"]
};
var faArrowSquareLeft = faSquareArrowLeft;
var faCircleLocationArrow = {
  prefix: 'fass',
  iconName: 'circle-location-arrow',
  icon: [512, 512, ["location-circle"], "f602", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM233.4 278.6L86.3 244.7 369.1 142.9 267.3 425.7 233.4 278.6z"]
};
var faLocationCircle = faCircleLocationArrow;
var faUsersSlash = {
  prefix: 'fass',
  iconName: 'users-slash',
  icon: [640, 512, [], "e073", "M81.2-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-271.1-271.1c56.5-1.1 102-47.2 102-104 0-57.4-46.6-104-104-104-56.8 0-102.9 45.5-104 102L81.2-16.9zM485 288l-31.2 0 181.2 181.2c1.2 1.2 2.3 2.4 3.3 3.7L592 288 485 288zM59.9 97.7c-21.5 12.5-35.9 35.7-35.9 62.3 0 39.8 32.2 72 72 72 26.6 0 49.8-14.4 62.3-35.9L59.9 97.7zM234.2 272l-26.2 0-48 208 282.2 0-208-208zM110.7 480l2.5-10.8 41.8-181.2-107 0-48 192 110.7 0zM616 160a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z"]
};
var faTrafficCone = {
  prefix: 'fass',
  iconName: 'traffic-cone',
  icon: [512, 512, [], "f636", "M173.7 128l50.3-128 64 0 50.3 128-164.6 0zm-25.1 64l214.9 0 37.7 96-290.3 0 37.7-96zM48 448l37.7-96 340.6 0 37.7 96 48 0 0 64-512 0 0-64 48 0z"]
};
var faStarSharpHalfStroke = {
  prefix: 'fass',
  iconName: 'star-sharp-half-stroke',
  icon: [576, 512, ["star-sharp-half-alt"], "e28d", "M288.4-39.1l69.7 219 216.3 0-176.1 136.9 70.5 221.6-180.4-140.3-180.4 140.3 70.5-221.6-176.1-136.9 216.3 0 69.7-219zm0 366.3l72.3 56.2-27.6-86.8 78.1-60.7-94 0-28.7-90.3 0 181.6z"]
};
var faStarSharpHalfAlt = faStarSharpHalfStroke;
var faH1 = {
  prefix: 'fass',
  iconName: 'h1',
  icon: [512, 512, [], "f313", "M401.7 67.4c-48.6 24.3-79.4 39.7-92.6 46.3l28.6 57.2c20.9-10.5 36.3-18.2 46.3-23.2l0 236.2-64 0 0 64 192 0 0-64-64 0 0-320-39.6 0-6.8 3.4zM64 96l0-32-64 0 0 384 64 0 0-160 128 0 0 160 64 0 0-384-64 0 0 160-128 0 0-128z"]
};
var faTamale = {
  prefix: 'fass',
  iconName: 'tamale',
  icon: [320, 512, [129748], "e451", "M0 16S48-32 160-32 320 16 320 16l-23.5 176-68.4 0 15.7-125.5 2.5-19.8-39.7-5-2.5 19.8-16.3 130.5-55.7 0-16.3-130.5-2.5-19.8-39.7 5 2.5 19.8 15.7 125.5-68.4 0-23.5-176zM277.9 348.6l-14.3-28.6 33 0 23.5 176S272 544 160 544 0 496 0 496l23.5-176 33 0-14.3 28.6 43.4 21.7c-7.4 59.3-11.4 91-11.9 95l39.7 5c.8-6.3 4.2-33.3 10.1-81l33.1 16.6 3.4-6.8 3.4 6.8 33.1-16.6c6 47.7 9.3 74.7 10.1 81l39.7-5c-.5-4-4.5-35.7-11.9-95l43.4-21.7zM8 232l304 0 0 48-113.2 0 25.4 50.7-42.9 21.5c-7.2-14.4-14.3-28.6-21.3-42.5-7 14-14.1 28.2-21.3 42.5L95.8 330.7c6.5-13 15-29.9 25.4-50.7L8 280 8 232z"]
};
var faRouteHighway = {
  prefix: 'fass',
  iconName: 'route-highway',
  icon: [448, 512, [], "f61a", "M240.7 12.6L224.3 2.7c-12.9 7.8-20 12-21.1 12.7-37.5 22.5-84 24.3-123.1 4.7l-1.4-.7-27.1-13.5c-7.2 12.6-22.9 40-47 82.3L-4 103c3.3 6.7 12 23.9 25.9 51.7 6.8 13.7 10.4 28.8 10.4 44.1 0 12.5-2.4 25-7.1 36.6L9.4 275c-6 15.1-9.1 31.2-9.1 47.5 0 50 29.1 95.4 74.6 116.3l136.1 62.4 13.3 6.1 13.3-6.1 136.1-62.4c45.5-20.8 74.6-66.3 74.6-116.3 0-16.3-3.1-32.4-9.1-47.5l-15.8-39.5c-4.7-11.7-7.1-24.1-7.1-36.6 0-15.3 3.6-30.4 10.4-44.1 13.9-27.8 22.5-45 25.9-51.7-1.7-3.1-15.2-26.7-40.5-70.9l-15-26.3-27.1 13.5-1.4 .7C329.4 39.7 283 37.9 245.4 15.4l-4.7-2.8zM96.1 192l256.3 0c-.1 2.3-.1 4.6-.1 6.8 0 20.7 3.9 41.2 11.6 60.4l15.8 39.5c3 7.5 4.6 15.6 4.6 23.7 0 25-14.6 47.7-37.3 58.1l-122.7 56.3-122.7-56.3c-22.7-10.4-37.3-33.1-37.3-58.1 0-8.1 1.6-16.2 4.6-23.7l15.8-39.5c7.7-19.2 11.6-39.7 11.6-60.4 0-2.3 0-4.6-.1-6.8z"]
};
var faPaperPlane = {
  prefix: 'fass',
  iconName: 'paper-plane',
  icon: [640, 512, [61913], "f1d8", "M0 192L608-32 384 576 286.9 329.2 416 160 247.2 289.3 0 192z"]
};
var faObjectIntersect = {
  prefix: 'fass',
  iconName: 'object-intersect',
  icon: [512, 512, [], "e49d", "M288 64l0 96-128 0 0 128-96 0 0-224 224 0zM64 352l96 0 0 160 352 0 0-352-160 0 0-160-352 0 0 352 64 0zM448 224l0 224-224 0 0-96 128 0 0-128 96 0z"]
};
var faBookAtlas = {
  prefix: 'fass',
  iconName: 'book-atlas',
  icon: [448, 512, ["atlas"], "f558", "M0 0l448 0 0 384-32 0 0 64 32 0 0 64-448 0 0-512zM64 416l0 32 288 0 0-64-256 0c-17.7 0-32 14.3-32 32zM302.4 216c-4.5 22.3-18.4 41.3-37.3 52.7 5.4-15 9.1-33 10.4-52.7l26.9 0zm-156.8 0l26.9 0c1.3 19.7 5 37.7 10.4 52.7-18.9-11.4-32.8-30.3-37.3-52.7zm70.7 49.7c-5.6-12.1-10.1-29.3-11.6-49.7l38.8 0c-1.6 20.4-6 37.6-11.6 49.7-3.2 6.9-5.9 10.6-7.7 12.6-1.8-1.9-4.5-5.6-7.7-12.6zm0-131.4c3.2-6.9 5.9-10.6 7.7-12.6 1.8 1.9 4.5 5.6 7.7 12.6 5.6 12.1 10.1 29.3 11.6 49.7l-38.8 0c1.6-20.4 6-37.6 11.6-49.7zM302.4 184l-26.9 0c-1.3-19.7-5-37.7-10.4-52.7 18.9 11.4 32.8 30.3 37.3 52.7zm-129.9 0l-26.9 0c4.5-22.3 18.4-41.3 37.3-52.7-5.4 15-9.1 33-10.4 52.7zM344 200a120 120 0 1 0 -240 0 120 120 0 1 0 240 0z"]
};
var faAtlas = faBookAtlas;
var faTable = {
  prefix: 'fass',
  iconName: 'table',
  icon: [448, 512, [], "f0ce", "M256 160l0 96 128 0 0-96-128 0zm-64 0l-128 0 0 96 128 0 0-96zM0 320l0-288 448 0 0 448-448 0 0-160zm384 0l-128 0 0 96 128 0 0-96zM192 416l0-96-128 0 0 96 128 0z"]
};
var faCircleSort = {
  prefix: 'fass',
  iconName: 'circle-sort',
  icon: [512, 512, ["sort-circle"], "e030", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm136-32l240 0-120-128-120 128zM256 416l120-128-240 0 120 128z"]
};
var faSortCircle = faCircleSort;
var faHeart = {
  prefix: 'fass',
  iconName: 'heart',
  icon: [512, 512, [128153, 128154, 128155, 128156, 128420, 129293, 129294, 129505, 9829, 10084, 61578], "f004", "M133.1 32C175.8 32 216 52.5 241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1 512 301.9 358.5 425.3 256 496 153.5 425.3 0 301.9 0 165.1 0 91.6 59.6 32 133.1 32z"]
};
var faScythe = {
  prefix: 'fass',
  iconName: 'scythe',
  icon: [640, 512, [], "f710", "M384.4 0l117 0-3.3 15.2-37.9 176.8-427.9 0s80-192 352-192zM488.9 288l62.5-288 65.5 0-70.9 326.7 0 .1-34.3 159.9-6.7 31.3-62.6-13.4c1.3-5.9 12.2-56.7 32.7-152.6l-122.7 0 0-64 136.5 0z"]
};
var faCircleChevronUp = {
  prefix: 'fass',
  iconName: 'circle-chevron-up',
  icon: [512, 512, ["chevron-circle-up"], "f139", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm17-345l104 104 17 17-33.9 33.9-17-17-87-87-87 87-17 17-33.9-33.9 17-17 104-104 17-17 17 17z"]
};
var faChevronCircleUp = faCircleChevronUp;
var faApostrophe = {
  prefix: 'fass',
  iconName: 'apostrophe',
  icon: [192, 512, [], "27", "M72 352c66.3 0 120-53.7 120-120l0-200-192 0 0 192 128 0 0 8c0 30.9-25.1 56-56 56l-40 0 0 64 40 0z"]
};
var faBatteryHalf = {
  prefix: 'fass',
  iconName: 'battery-half',
  icon: [640, 512, ["battery-3"], "f242", "M544 128l0 256-448 0 0-256 448 0zM96 64l-64 0 0 384 576 0 0-128 32 0 0-128-32 0 0-128-512 0zM336 176l-192 0 0 160 192 0 0-160z"]
};
var faBattery3 = faBatteryHalf;
var faFontAwesome = {
  prefix: 'fass',
  iconName: 'font-awesome',
  icon: [512, 512, [62501, 62694, "font-awesome-flag", "font-awesome-logo-full"], "f2b4", "M91.7 96C106.3 86.8 116 70.5 116 52 116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 419 64 0 0-64 400 0 0-32-64-144 64-144 0-32-404.3 0z"]
};
var faFontAwesomeFlag = faFontAwesome;
var faFontAwesomeLogoFull = faFontAwesome;
var faHandcuffs = {
  prefix: 'fass',
  iconName: 'handcuffs',
  icon: [576, 512, [], "e4f8", "M320-64l-64 0 0 64 64 0 0-64zM224 0l-64 0 0 64 64 0 0-64zm32 96l-128 0 0 42.9C53.4 165.3 0 236.4 0 320 0 426 86 512 192 512s192-86 192-192c0-83.6-53.4-154.7-128-181.1L256 96zM64 320a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm448 0c0 66.9-51.3 121.8-116.6 127.5-14.3 22.8-32.4 43.1-53.4 59.9 13.5 3 27.6 4.6 42 4.6 106 0 192-86 192-192 0-83.6-53.4-154.7-128-181.1l0-42.9-128 0 0 20.9c30.4 19.2 56.2 45.1 75.4 75.6 65.4 5.8 116.6 60.6 116.6 127.5zM352 0l0 64 64 0 0-64-64 0z"]
};
var faSquareBangladeshiTaka = {
  prefix: 'fass',
  iconName: 'square-bangladeshi-taka',
  icon: [448, 512, [], "e744", "M448 32l-448 0 0 448 448 0 0-448zM104 128l27.4 0c33.5 0 60.6 27.1 60.6 60.6l0 19.4 32 0 0 32-32 0 0 83.4c0 6.9 5.6 12.6 12.6 12.6l24 0c37.2 0 67.4-30.2 67.4-67.4l0-16c0-6.9-5.6-12.6-12.6-12.6l-3.4 0-24 0 0-48 24 0 3.4 0c33.5 0 60.6 27.1 60.6 60.6l0 16C344 332.3 292.3 384 228.6 384l-24 0c-33.5 0-60.6-27.1-60.6-60.6l0-83.4-29.7 0 0-32 29.7 0 0-19.4c0-6.9-5.6-12.6-12.6-12.6l-27.4 0 0-48z"]
};
var faHatCowboySide = {
  prefix: 'fass',
  iconName: 'hat-cowboy-side',
  icon: [640, 512, [], "f8c1", "M640 400l0 43.6-53.4-35.6-292.7-195.1c-36.1-24.1-78.6-36.9-122-36.9l-3.9 0c-2.7 0-5.4 0-8 .1l32-144.1 64 0 64 48 64-48 64 0 43.1 194.1C575.4 239.1 640 312 640 400zM171.9 224c33.9 0 67.1 10 95.4 28.9L560 448 0 448 0 395.9C0 301 77 224 171.9 224z"]
};
var faSausage = {
  prefix: 'fass',
  iconName: 'sausage',
  icon: [512, 512, [], "f820", "M320 160c0-42.1 27.1-77.8 64.7-90.8L360 0 472 0 447.3 69.2c37.7 13 64.7 48.7 64.7 90.8 0 194.4-157.6 352-352 352-42.1 0-77.8-27.1-90.8-64.7L0 472 0 360 69.2 384.7c13-37.7 48.7-64.7 90.8-64.7 88.4 0 160-71.6 160-160zM168 412c134.8 0 244-109.2 244-244l-40 0c0 112.7-91.3 204-204 204l0 40z"]
};
var faChevronsDown = {
  prefix: 'fass',
  iconName: 'chevrons-down',
  icon: [512, 512, ["chevron-double-down"], "f322", "M278.9 278.6l-22.6 22.6-22.6-22.6-192-192-22.6-22.6 45.3-45.3 22.6 22.6 169.4 169.4 169.4-169.4 22.6-22.6 45.3 45.3-22.6 22.6-192 192zm0 192l-22.6 22.6-22.6-22.6-192-192-22.6-22.6 45.3-45.3 22.6 22.6 169.4 169.4 169.4-169.4 22.6-22.6 45.3 45.3-22.6 22.6-192 192z"]
};
var faChevronDoubleDown = faChevronsDown;
var faIndustry = {
  prefix: 'fass',
  iconName: 'industry',
  icon: [512, 512, [], "f275", "M128 32l-128 0 0 448 512 0 0-352-192 96 0-96-192 96 0-192z"]
};
var faPeopleDressSimple = {
  prefix: 'fass',
  iconName: 'people-dress-simple',
  icon: [512, 512, [], "e218", "M128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM256 384l-64-224-128 0-64 224 64 0 0 128 128 0 0-128 64 0zm0 0l64 0 0 128 128 0 0-128 64 0-64-224-128 0-64 224zM384 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faLinesLeaning = {
  prefix: 'fass',
  iconName: 'lines-leaning',
  icon: [384, 512, [], "e51e", "M190.6 73.5l9.5-30.5-61.1-19.1-9.5 30.5-120 384-9.5 30.5 61.1 19.1 9.5-30.5 120-384zM292.9 37.7l-63.1-10.5-5.3 31.6-64 384-5.3 31.6 63.1 10.5 5.3-31.6 64-384 5.3-31.6zM384.1 32l-64 0 0 448 64 0 0-448z"]
};
var faPassport = {
  prefix: 'fass',
  iconName: 'passport',
  icon: [384, 512, [], "f5ab", "M0 0L384 0 384 512 0 512 0 0zM96 384l0 48 192 0 0-48-192 0zM278.6 208c-4.8 26.4-21.5 48.7-44.2 61.2 6.7-17 11.2-38 12.6-61.2l31.6 0zm-173.1 0l31.6 0c1.4 23.1 6 44.2 12.6 61.2-22.7-12.5-39.4-34.8-44.2-61.2zm76.4 55c-6.2-13.4-11.1-32.5-12.7-55l45.8 0c-1.6 22.5-6.5 41.6-12.7 55-4.5 9.6-8.2 13.8-10.2 15.5-2-1.7-5.7-5.8-10.2-15.5zm0-142c4.5-9.6 8.2-13.8 10.2-15.5 2 1.7 5.7 5.8 10.2 15.5 6.2 13.4 11.1 32.5 12.7 55l-45.8 0c1.6-22.5 6.5-41.6 12.7-55zm96.7 55L247 176c-1.4-23.1-6-44.2-12.6-61.2 22.7 12.5 39.4 34.8 44.2 61.2zM137 176l-31.6 0c4.8-26.4 21.5-48.7 44.2-61.2-6.7 17-11.2 38-12.6 61.2zm183 16a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]
};
var faInfinity = {
  prefix: 'fass',
  iconName: 'infinity',
  icon: [640, 512, [8734, 9854], "f534", "M0 96l240 0 9.6 12.8 70.4 93.9 70.4-93.9 9.6-12.8 240 0 0 320-240 0-9.6-12.8-70.4-93.9-70.4 93.9-9.6 12.8-240 0 0-320zM280 256l-72-96-144 0 0 192 144 0 72-96zm80 0l72 96 144 0 0-192-144 0-72 96z"]
};
var faHandHeart = {
  prefix: 'fass',
  iconName: 'hand-heart',
  icon: [640, 512, [], "f4bc", "M549.1 304c41.4 0 74.9 33.5 74.9 74.9l0 2.5c0 85-143 178-144 178.7 0 0-144-93.3-144-178.7l0-2.5c0-41.4 33.5-74.9 74.9-74.9 24 0 46.6 11.5 60.7 31l8.4 11.7 8.4-11.7c14.1-19.5 36.6-31 60.7-31zM352 224l32 0 0-192 64 0 0 192 32 0 0-128 64 0 0 160.2c-23.1 1-45.3 8.3-64 21.1-20.1-13.7-44.1-21.3-69.1-21.3-67.9 0-122.9 55-122.9 122.9l0 2.5c0 34.4 14.2 65.5 30.3 90.1 9.4 14.5 20.4 28.1 31.7 40.6l-1.2 0c-59.6 0-116.9-22.9-160-64-74.8-71.2-116.2-110.7-124.5-118.6l55.2-57.9c16.8 16 41 39.1 72.6 69.1 0-1.5-.1-3.1-.1-4.6l0-304 64 0 0 192 32 0 0-224 64 0 0 224z"]
};
var faClone = {
  prefix: 'fass',
  iconName: 'clone',
  icon: [512, 512, [], "f24d", "M288 448l-224 0 0-224 48 0 0-64-112 0 0 352 352 0 0-112-64 0 0 48zm224-96l0-352-352 0 0 352 352 0z"]
};
var faForward = {
  prefix: 'fass',
  iconName: 'forward',
  icon: [640, 512, [9193], "f04e", "M336 296l0 200 288-240-288-240 0 200-240-200 0 480 240-200z"]
};
var faSquareR = {
  prefix: 'fass',
  iconName: 'square-r',
  icon: [448, 512, [], "e27c", "M448 32l-448 0 0 448 448 0 0-448zM144 144l104 0c39.8 0 72 32.2 72 72 0 29.5-17.7 54.8-43.1 66l40.2 74.7 6.1 11.4-54.5 0-43.1-80-33.7 0 0 80-48 0 0-224zM286 400l1.2 0-.9 .5-.3-.5zM192 240l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0 48z"]
};
var faPeriod = {
  prefix: 'fass',
  iconName: 'period',
  icon: [128, 512, [], "2e", "M0 352l128 0 0 128-128 0 0-128z"]
};
var faM = {
  prefix: 'fass',
  iconName: 'm',
  icon: [448, 512, [109], "4d", "M0 32l0 448 64 0 0-310.3 133.4 200.1 26.6 39.9 26.6-39.9 133.4-200.1 0 310.3 64 0 0-448-49.1 0-9.5 14.2-165.4 248.1-165.4-248.1-9.5-14.2-49.1 0z"]
};
var faMoneyCheckPen = {
  prefix: 'fass',
  iconName: 'money-check-pen',
  icon: [640, 512, ["money-check-edit"], "f872", "M32 64l512 0 0 108.6-.5-.5-252.8 252.8-3.8 23.1-254.9 0 0-384zm96 224l0 48 192 0 0-48-192 0zM448 176l-320 0 0 48 320 0 0-48zm96 63.9l80 80-52.8 52.8-80-80 52.8-52.8zm-208 208l132.6-132.6 80 80-132.6 132.6-96 16 16-96z"]
};
var faMoneyCheckEdit = faMoneyCheckPen;
var faRoadSpikes = {
  prefix: 'fass',
  iconName: 'road-spikes',
  icon: [640, 512, [], "e568", "M32 96l0 256 576 0-160-256-32 0 0 153.6-96-153.6-32 0 0 153.6-96-153.6-32 0 0 153.6-96-153.6-32 0zM0 384l0 64 640 0 0-64-640 0z"]
};
var faFishCooked = {
  prefix: 'fass',
  iconName: 'fish-cooked',
  icon: [576, 512, [], "f7fe", "M320 64c176 0 256 192 256 192S496 448 320 448c-80.3 0-167.8-57.4-216.9-114.5L0 416 0 368 32 256 0 144 0 96 108.7 172.1C158.7 117.2 242.7 64 320 64zm17.9 96L304 126.1c-3.5 3.5-30.5 30.5-81 81l-17 17 33.9 33.9c3.5-3.5 30.5-30.5 81-81l17-17zm112 16l-33.9-33.9-17 17-160 160-17 17 33.9 33.9 17-17 160-160 17-17zm16 112L432 254.1c-3.5 3.5-30.5 30.5-81 81l-17 17 33.9 33.9 97.9-97.9z"]
};
var faPersonSeatReclined = {
  prefix: 'fass',
  iconName: 'person-seat-reclined',
  icon: [576, 512, [], "e21f", "M168.5 72a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm17 88l105.3 0 5.1 25.7 26.9 134.3 115.9 0 7.8 20.8 37.2 99.1c10.6-3.5 26.9-9 49.1-16.4L553 484.2c-42.8 14.3-105.1 35-107.6 35.9-2.3-6.2-19.3-51.6-51-136.1l-97.2 0c-.4 0-.8 0-1.3 0l-13.1 0c-30.5 0-56.8-21.5-62.8-51.4-21.1-105.5-32.6-163-34.5-172.6zm-57.8 24.7l58.2 247.3 166.7 0 0 64-217.3 0-5.8-24.7-64-272-7.3-31.1 62.3-14.7 7.3 31.1z"]
};
var faMountain = {
  prefix: 'fass',
  iconName: 'mountain',
  icon: [576, 512, [127956], "f6fc", "M560 480L16 480 288-16 560 480zM210.5 258.5l29.5 29.5 64-64 42.6 0-58.6-106.9-77.5 141.3z"]
};
var faCircleW = {
  prefix: 'fass',
  iconName: 'circle-w',
  icon: [512, 512, [], "e12c", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176.6 349.5l-48.6-205.5 49.3 0 26 110.1 29.7-93.4 5.3-16.7 35.1 0 5.3 16.7 29.7 93.4 26-110.1 49.3 0-48.6 205.5-4.4 18.5-36.5 0-5.3-16.7-33.1-104.1-33.1 104.1-5.3 16.7-36.5 0-4.4-18.5z"]
};
var faChess = {
  prefix: 'fass',
  iconName: 'chess',
  icon: [512, 512, [], "f439", "M128 56l40 0 0 40-104 0 0 32 36 72-20 0 0 48 29.6 0-13.6 136-64 80 0 48 320 0 0-48-64-80-13.6-136 29.6 0 0-48-20 0 36-72 0-32-104 0 0-40 40 0 0-48-40 0 0-40-48 0 0 40-40 0 0 48zM512 512l0-48-32-48 0-64 32-32 0-160-64 0 0 48-32 0 0-48-58.3 0-5.7 11.3 0 124.7-24.6 0 6.9 69.1 55.2 68.9 10.5 13.2 0 64.8 112 0z"]
};
var faTemperatureThreeQuarters = {
  prefix: 'fass',
  iconName: 'temperature-three-quarters',
  icon: [320, 512, ["temperature-3", "thermometer-3", "thermometer-three-quarters"], "f2c8", "M256 0L64 0 64 260.7C34.5 287 16 325.4 16 368 16 447.5 80.5 512 160 512s144-64.5 144-144c0-42.6-18.5-81-48-107.3L256 0zM224 368c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-180.7 48 0 0 180.7c23.5 9.5 40 32.5 40 59.3z"]
};
var faTemperature3 = faTemperatureThreeQuarters;
var faThermometer3 = faTemperatureThreeQuarters;
var faThermometerThreeQuarters = faTemperatureThreeQuarters;
var faB = {
  prefix: 'fass',
  iconName: 'b',
  icon: [320, 512, [98], "42", "M32 32l-32 0 0 448 192 0c70.7 0 128-57.3 128-128 0-46.5-24.8-87.3-62-109.7 18.7-22.3 30-51 30-82.3 0-70.7-57.3-128-128-128L32 32zM160 224l-96 0 0-128 96 0c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288l128 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-128 0 0-128z"]
};
var faShieldVirus = {
  prefix: 'fass',
  iconName: 'shield-virus',
  icon: [512, 512, [], "e06c", "M256 0l11.6 4.5 207.5 80.5 19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.3-91.1 150-189.4 192.6l-12.7 5.5-12.7-5.5C144.9 463.9 86.6 389.2 53.9 313.9 21.5 239.3 13.7 162.9 16.6 113L17.8 92.5 37 85 244.5 4.5 256 0zm84.9 137.2l-17 17C307.7 170.4 280 158.9 280 136l0-24-48 0 0 24c0 22.9-27.7 34.4-43.9 18.2l-17-17-33.9 33.9 17 17c16.2 16.2 4.7 43.9-18.2 43.9l-24 0 0 48 24 0c22.9 0 34.4 27.7 18.2 43.9l-17 17 33.9 33.9 17-17c16.2-16.2 43.9-4.7 43.9 18.2l0 24 48 0 0-24c0-22.9 27.7-34.4 43.9-18.2l17 17 33.9-33.9-17-17C341.7 307.7 353.1 280 376 280l24 0 0-48-24 0c-22.9 0-34.4-27.7-18.2-43.9l17-17-33.9-33.9zM224 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faTriangle = {
  prefix: 'fass',
  iconName: 'triangle',
  icon: [576, 512, [9650], "f2ec", "M16 480L288-16 560 480 16 480z"]
};
var faLitecoinSign = {
  prefix: 'fass',
  iconName: 'litecoin-sign',
  icon: [384, 512, [], "e1d3", "M128 64l0-32-64 0 0 189.9c-28.3 8.1-48.9 14-61.7 17.6l13.2 46.2c15-4.3 31.2-8.9 48.5-13.9l0 208.2 320 0 0-64-256 0 0-162.5 134.6-38.5 23.1-6.6-13.2-46.2-23.1 6.6-121.4 34.7 0-139.6z"]
};
var faDiceD6 = {
  prefix: 'fass',
  iconName: 'dice-d6',
  icon: [512, 512, [], "f6d1", "M496 128L496 400 256 536 16 400 16 128 256-8 496 128zM256 248.8l-158.2-93.5-17.8 10.1 0 25.9 156 92.2 0 167.7 20 11.4 20-11.3 0-167.7 156-92.2 0-25.9-17.8-10.1-158.2 93.5z"]
};
var faGripLinesVertical = {
  prefix: 'fass',
  iconName: 'grip-lines-vertical',
  icon: [192, 512, [], "f7a5", "M64 32l-64 0 0 448 64 0 0-448zm128 0l-64 0 0 448 64 0 0-448z"]
};
var faToggleLargeOff = {
  prefix: 'fass',
  iconName: 'toggle-large-off',
  icon: [576, 512, [], "e5b0", "M320 128l-256 0 0 256 256 0 0-256zm64 320l-384 0 0-384 576 0 0 384-192 0zm0-320l0 256 128 0 0-256-128 0z"]
};
var faGolfBallTee = {
  prefix: 'fass',
  iconName: 'golf-ball-tee',
  icon: [384, 512, ["golf-ball"], "f450", "M320 432l-104 0 0 112-48 0 0-112-104 0 0-48 256 0 0 48zM192 0c106 0 192 86 192 192 0 57.4-25.2 108.8-65.1 144L65.1 336C25.2 300.8 0 249.4 0 192 0 86 86 0 192 0zm16 256c0 8.8-7.2 16-16 16l-16 0 0 32 16 0c26.5 0 48-21.5 48-48l0-16-32 0 0 16zm64-64c0 8.8-7.2 16-16 16l-16 0 0 32 16 0c26.5 0 48-21.5 48-48l0-16-32 0 0 16zm-80-16c0 8.8-7.2 16-16 16l-16 0 0 32 16 0c26.5 0 48-21.5 48-48l0-16-32 0 0 16z"]
};
var faGolfBall = faGolfBallTee;
var faHexagon = {
  prefix: 'fass',
  iconName: 'hexagon',
  icon: [576, 512, [11043], "f312", "M20.3 244.1l-6.8 11.9 6.8 11.9 123.7 216.1 6.9 12.1 275.1 0 6.9-12.1 123.7-216.1 6.8-11.9-6.8-11.9-123.7-216.1-6.9-12.1-275.1 0-6.9 12.1-123.7 216.1z"]
};
var faKite = {
  prefix: 'fass',
  iconName: 'kite',
  icon: [640, 512, [129665], "f6f4", "M608 320l-343.3 57.2-134.8 134.8-57.9 0 0-222-72 30 0-96 72 30 0-78-72 0 0-48 120 0 0 126 72-30 0 96-72-30 0 164.1 110.8-110.8 57.2-343.3 320 0 0 320zM339.7 80l14.1 14.2 65.8 65.8-113.8 113.8-14.1 14.2 28.3 28.3 14.2-14.1 113.8-113.8 65.8 65.8 14.2 14.1 28.3-28.3-14.1-14.2-65.8-65.8 49.8-49.8 14.1-14.2-28.3-28.3-14.2 14.1-49.8 49.8-65.8-65.8-14.2-14.1-28.3 28.3z"]
};
var faShareAll = {
  prefix: 'fass',
  iconName: 'share-all',
  icon: [640, 512, [], "f367", "M256.3 432l224-224-224-224 0 144-48 0c-97.2 0-176 78.8-176 176 0 128 128 176 128 176s-32-32-32-80c0-61.9 50.1-112 112-112l16 0 0 144zm119-400.4l176.4 176.4-176.4 176.4 33.9 33.9 193.4-193.4 17-17-17-17-193.4-193.4-33.9 33.9z"]
};
var faChemex = {
  prefix: 'fass',
  iconName: 'chemex',
  icon: [384, 512, [], "e830", "M384 318.2l0 1.8-58.2 0 15.3 21.1c27.8 38.3 46.8 86.1 29.3 130l-4.7 10.8c-3.3 7.1-7.1 13.9-11.3 20.4L348 512 36 512c-6.8-9.4-12.7-19.5-17.8-30.1l-4.7-10.8c-16.4-41.2-.8-85.8 24.1-122.8l5.1-7.3 15.3-21.1-58.2 0 0-1.6 54.1-74.4 94.3 0c7.6 16.5 24.2 28 43.6 28s36-11.5 43.6-28l94.3 0 54.1 74.2zM94.6 378.7c-23.9 32.9-26.6 56.2-21.6 68.7 .1 .2 .2 .4 .2 .6l237.4 0c.1-.2 .2-.4 .2-.6 5-12.5 2.4-35.8-21.6-68.7l-42.7-58.7-109.4 0-42.7 58.7zM384 48l-58.2 80 58.2 0 0 1.6-54.2 74.4-94.2 0c-7.6-16.5-24.2-28-43.6-28s-36 11.5-43.6 28L54.1 204 0 129.6 0 128 58.2 128 0 48 0 0 384 0 384 48zM137.3 128l109.4 0 46.5-64-202.4 0 46.5 64z"]
};
var faFolderOpen = {
  prefix: 'fass',
  iconName: 'folder-open',
  icon: [576, 512, [128194, 128449, 61717], "f07c", "M32 292.2l0-260.2 224 0 64 48 192 0 0 80-437.2 0C71.2 171.2 56.9 215.2 32 292.2zM498.3 448L32 448 109.7 208 576 208 498.3 448z"]
};
var faTick = {
  prefix: 'fass',
  iconName: 'tick',
  icon: [128, 512, [], "e32f", "M32 288L0 32 128 32 96 288 32 288z"]
};
var faFaceDrooling = {
  prefix: 'fass',
  iconName: 'face-drooling',
  icon: [512, 512, [], "e372", "M256 512c27.9 0 54.8-4.5 80-12.7l0-104.7c-10 5.8-20.7 10.5-32 14.1l0 55.3-48 0 0-48c-54.7 0-102.9-27.4-131.8-69.2l39.5-27.3C184 348.9 217.8 368 256 368s72-19.1 92.2-48.5l39.5 27.3c-1.2 1.8-2.5 3.5-3.8 5.2l0 125.7C460.5 433.5 512 350.8 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256 114.6 512 256 512zM96 216c0-48.6 39.4-88 88-88l24 0 0 48-24 0c-22.1 0-40 17.9-40 40l0 24-48 0 0-24zm232-88c48.6 0 88 39.4 88 88l0 24-48 0 0-24c0-22.1-17.9-40-40-40l-24 0 0-48 24 0z"]
};
var faBullseyeArrow = {
  prefix: 'fass',
  iconName: 'bullseye-arrow',
  icon: [576, 512, [127919], "f648", "M384 48L464-32 496 48 576 80 496 160 429.1 148.8 297 281 263 247 395.2 114.9 384 48zM288 0c23.3 0 45.8 3.1 67.2 8.9-1.4 1.4-8.9 8.9-22.6 22.6 3 17.8 5.2 30.9 6.6 39.4-16.3-4.5-33.4-6.9-51.2-6.9-106 0-192 86-192 192s86 192 192 192 192-86 192-192c0-17.7-2.4-34.9-6.9-51.2 8.4 1.4 21.6 3.6 39.4 6.6 13.7-13.7 21.2-21.2 22.6-22.6 5.8 21.4 8.9 43.9 8.9 67.2 0 141.4-114.6 256-256 256S32 397.4 32 256 146.6 0 288 0zm0 112c12.9 0 25.4 1.7 37.3 4.9l-63.5 63.5c-31.3 10.9-53.8 40.6-53.8 75.6 0 44.2 35.8 80 80 80 35 0 64.7-22.5 75.6-53.8l63.5-63.5c3.2 11.9 4.9 24.4 4.9 37.3 0 79.5-64.5 144-144 144s-144-64.5-144-144 64.5-144 144-144z"]
};
var faKaaba = {
  prefix: 'fass',
  iconName: 'kaaba',
  icon: [512, 512, [128331], "f66b", "M256 174.3L419.2 112.4 256 51.3 92.8 112.4 256 174.3zM256 0L512 96 512 165.2 256 262.3 0 165.2 0 96 256 0zM0 269.2l0-52.7 247.5 93.9 8.5 3.2 8.5-3.2 247.5-93.9 0 52.7-128 48.6 0 51.3 128-48.6 0 95.4-256 96-256-96 0-95.4 128 48.6 0-51.3-128-48.6zM247.5 414.4l8.5 3.2 8.5-3.2 71.5-27.1 0-51.3-80 30.3-80-30.3 0 51.3 71.5 27.1z"]
};
var faHandBackPointRight = {
  prefix: 'fass',
  iconName: 'hand-back-point-right',
  icon: [512, 512, [], "e1a1", "M512 208l0-80-336 0 0-32 72 0-40-48-68 0c-38 0-74 16.9-98.3 46.1l-4.5 5.4C13.1 128.3 0 164.5 0 201.9L0 320c0 70.7 57.3 128 128 128l144 0 0-80 32 0 0-80 32 0 0-80 176 0z"]
};
var faStarfighterTwinIonEngine = {
  prefix: 'fass',
  iconName: 'starfighter-twin-ion-engine',
  icon: [512, 512, ["starfighter-alt"], "e038", "M64 64l0-32-64 0 0 448 64 0 0-181.3 42.4 14.1C129.3 373.1 187.6 416 256 416s126.7-42.9 149.6-103.2l42.4-14.1 0 181.3 64 0 0-448-64 0 0 181.3-42.4-14.1C382.7 138.9 324.4 96 256 96S129.3 138.9 106.4 199.2L64 213.3 64 64zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 152a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faStarfighterAlt = faStarfighterTwinIonEngine;
var faHandHolding = {
  prefix: 'fass',
  iconName: 'hand-holding',
  icon: [576, 512, [], "f4bd", "M66.7 384l70.6-70.6 9.4-9.4 237.3 0 0 64-128 0 0 48 138.8 0c73.3-50.4 115.7-79.6 127.5-87.6l45.3 65.9c-6.1 4.2-59.8 41.1-161 110.7l-10.2 7-396.4 0 0-128 66.7 0z"]
};
var faBadgeSheriff = {
  prefix: 'fass',
  iconName: 'badge-sheriff',
  icon: [512, 512, [], "f8a2", "M304.4 16c0 15.1-7 28.6-17.9 37.4l41.9 74.6 88.5 0c2.3-13.6 10.4-26.1 23.3-33.6 23-13.3 52.3-5.4 65.6 17.6s5.4 52.3-17.6 65.6c-13 7.5-27.9 8.2-40.9 3.4l-46.9 75.1 46.9 75.1c13-4.9 28-4.1 40.9 3.4 23 13.3 30.8 42.6 17.6 65.6s-42.6 30.8-65.6 17.6c-12.9-7.4-21-20-23.3-33.6l-88.5 0-41.9 74.6c10.9 8.8 17.9 22.3 17.9 37.4 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-15.1 7-28.6 17.9-37.4l-41.9-74.6-88.5 0c-2.3 13.6-10.4 26.1-23.3 33.6-23 13.3-52.3 5.4-65.6-17.6s-5.4-52.3 17.6-65.6c13-7.5 27.9-8.2 40.9-3.4l46.9-75.1-46.9-75.1c-13 4.9-28 4.1-40.9-3.4-23-13.3-30.8-42.6-17.6-65.6S49.5 81.2 72.5 94.4c12.9 7.4 21 20 23.3 33.6l88.5 0 41.9-74.6c-10.9-8.8-17.9-22.3-17.9-37.4 0-26.5 21.5-48 48-48s48 21.5 48 48zm-112 240l64 64 64-64-64-64-64 64z"]
};
var faRainbowHalf = {
  prefix: 'fass',
  iconName: 'rainbow-half',
  icon: [512, 512, [], "e7ca", "M480 64C250.2 64 64 250.2 64 480L0 480C0 214.9 214.9 0 480 0l0 64zm0 128c-159.1 0-288 128.9-288 288l-64 0c0-194.4 157.6-352 352-352l0 64zM320 480l-64 0c0-123.7 100.3-224 224-224l0 64c-88.4 0-160 71.6-160 160z"]
};
var faCommentLines = {
  prefix: 'fass',
  iconName: 'comment-lines',
  icon: [512, 512, [], "f4b0", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM152 176l-24 0 0 48 256 0 0-48-232 0zm0 96l-24 0 0 48 160 0 0-48-136 0z"]
};
var faSingleQuoteRight = {
  prefix: 'fass',
  iconName: 'single-quote-right',
  icon: [192, 512, [], "e81c", "M32 352l40 0c30.9 0 56-25.1 56-56l0-8-128 0 0-192 192 0 0 200c0 66.3-53.7 120-120 120l-40 0 0-64z"]
};
var faBottleDroplet = {
  prefix: 'fass',
  iconName: 'bottle-droplet',
  icon: [320, 512, [], "e4c4", "M80-32l160 0 0 64-32 0 0 103.3c64.9 20.4 112 81 112 152.7l0 256-320 0 0-256c0-71.6 47.1-132.3 112-152.7l0-103.3-32 0 0-64zm80 448c35.3 0 64-32.4 64-64s-64-112-64-112-64 80.4-64 112 28.7 64 64 64z"]
};
var faFaceExplode = {
  prefix: 'fass',
  iconName: 'face-explode',
  icon: [512, 512, ["exploding-head"], "e2fe", "M.9 235l63.1 21 96-32 96 32 96-32 96 32 63.1-21c.6 6.9 .9 14 .9 21 0 141.4-114.6 256-256 256S0 397.4 0 256c0-7.1 .3-14.1 .9-21zM208 336a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 448l128 0c0-35.3-28.7-64-64-64s-64 28.7-64 64zM384 128l-64 0 0 64-64 16-64-16 0-64-128 0 0-64c0-35.3 28.7-64 64-64 5.5 0 10.9 .7 16 2 0-.7 0-1.3 0-2 0-35.3 28.7-64 64-64 19.1 0 36.3 8.4 48 21.7 11.7-13.3 28.9-21.7 48-21.7 35.3 0 64 28.7 64 64 0 .7 0 1.4 0 2 5.1-1.3 10.5-2 16-2 35.3 0 64 28.7 64 64l0 64-64 0z"]
};
var faExplodingHead = faFaceExplode;
var faWindowMinimize = {
  prefix: 'fass',
  iconName: 'window-minimize',
  icon: [512, 512, [128469], "f2d1", "M0 384l512 0 0 64-512 0 0-64z"]
};
var faStadium = {
  prefix: 'fass',
  iconName: 'stadium',
  icon: [640, 512, [], "e6cc", "M432 32l-96 51.2 0 21c53 1.1 102.4 7.8 144 18.7l0-138.8 24 0 120 64-96 51.2 0 39.5c19.9 8.3 37.4 18.2 50.9 29.8 16.3 14 29.1 32.7 29.1 55.6l0 181.2c0 23.1-12.3 42.3-28.7 57.1s-38.6 26.9-64.1 36.7c-36.2 13.8-81.3 23.6-131.3 28.2l0-143.2-128 0 0 143.2c-49.9-4.6-95.1-14.4-131.2-28.2-25.5-9.7-47.8-21.9-64.1-36.7S32 428.3 32 405.2L32 224c0-22.9 12.8-41.6 29.1-55.6 9.7-8.4 21.6-15.9 34.9-22.5l0-161.9 24 0 120 64-96 51.2 0 28.1c40.6-12.3 90.2-20.3 144-22.6l0-136.7 24 0 120 64zM169.5 169.9c-10 2.7-19.3 5.6-27.9 8.7-22.4 8.1-38.8 17.2-49.1 26.2-10.4 9-12.4 15.5-12.4 19.2s2 10.2 12.4 19.2c10.4 8.9 26.8 18 49.1 26.2 11.5 4.2 24.2 8 38 11.3 7.3-12.1 25.4-22.6 50.3-30.2l-57.1-76.1-3.3-4.5zm297.7 4.5l-57.1 76.1c24.9 7.5 43 18.1 50.3 30.2 13.8-3.3 26.6-7.1 38.1-11.3 22.4-8.1 38.8-17.2 49.1-26.2 10.4-9 12.4-15.5 12.4-19.2s-2-10.2-12.4-19.2c-10.4-8.9-26.8-18-49.1-26.2-8.6-3.1-18-6.1-28-8.7l-3.3 4.5zM320 152c-35.2 0-68.6 2.6-98.6 7.2l61 81.3c12-1.2 24.6-1.9 37.7-1.9 13 0 25.6 .7 37.6 1.9l61-81.3c-30.1-4.6-63.4-7.2-98.6-7.2z"]
};
var faMegaphone = {
  prefix: 'fass',
  iconName: 'megaphone',
  icon: [512, 512, [128227], "f675", "M512 32l-64 0 0 41.1-384 109.7 0-22.9-64 0 0 192 64 0 0-22.9 70.5 20.1c-4.2 10.8-6.5 22.5-6.5 34.7 0 53 43 96 96 96 46.9 0 86-33.7 94.3-78.2l129.7 37 0 41.1 64 0 0-448zM271.8 388.5c-2.3 24.4-22.8 43.5-47.8 43.5-26.5 0-48-21.5-48-48 0-7.7 1.8-15 5-21.4l90.8 25.9z"]
};
var faBurgerGlass = {
  prefix: 'fass',
  iconName: 'burger-glass',
  icon: [576, 512, [], "e0ce", "M108.7 160l-7.5-96 245.6 0-7.5 96-230.6 0zM72 512l136 0 0-199.8c9.6-28.1 25-53.1 46-74.2 30.4-30.5 78.2-58.5 148.2-61.9 6.5-82.8 11.1-141.5 13.8-176.1L32 0 72 512zm184 31.8l320 0 0-64-320 0 0 64zM576 320s-32-96.1-160-96.2C288 224 256 320 256 320l0 47.8 320 0 0-47.8zm0 127.8l0-48-320 0 0 48 320 0zM400 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faPenPaintbrush = {
  prefix: 'fass',
  iconName: 'pen-paintbrush',
  icon: [576, 512, ["pencil-paintbrush"], "f618", "M72 328L16 528 216 472 439 249 295 105 72 328zM560 128l-144-144-87 87 144 144 87-87zM109.3 18.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5l102.1 102.1 90.5-90.5-102.1-102.1zM400 512l176 0 0-64-64 0 0-48c0-42.3-23.4-79.1-58-98.1L301.9 454c19.1 34.6 55.9 58 98.1 58z"]
};
var faPencilPaintbrush = faPenPaintbrush;
var faLightbulbSlash = {
  prefix: 'fass',
  iconName: 'lightbulb-slash',
  icon: [576, 512, [], "f673", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-153.2-153.2c43.9-35.2 72-89.3 72-149.9 0-106-86-192-192-192-60.7 0-114.7 28.1-149.9 72L49.3-16.9zM181.6 115.5C203.3 84.4 239.3 64 280.1 64l8 0 0 48-8 0c-27.6 0-51.6 15.5-63.7 38.3l-34.9-34.9zM97.7 167.4c-1 8.1-1.6 16.3-1.6 24.6 0 71.1 38.6 133.1 96 166.3l0 25.7 122.2 0-216.6-216.6zM384.1 453.8l-21.8-21.8-170.2 0 0 96 192 0 0-74.2z"]
};
var faCircleAustralianDollar = {
  prefix: 'fass',
  iconName: 'circle-australian-dollar',
  icon: [512, 512, [], "e730", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm64-376l32 0 0 24 32 0 0 48-52.8 0c-6.2 0-11.2 5-11.2 11.2 0 5.3 3.8 9.9 9 11l23.5 4.7c27.7 5.5 47.6 29.8 47.6 58 0 28.9-20.7 52.9-48 58.1l0 25.1-32 0 0-24-40 0 0-48 60.8 0c6.2 0 11.2-5 11.2-11.2 0-5.3-3.8-9.9-9-11l-23.5-4.7c-27.7-5.5-47.6-29.8-47.6-58 0-28.9 20.7-52.9 48-58.1l0-25.1zm-150.5 8l44.9 0 4.7 18 53.4 206-49.6 0-6.2-24-49.4 0-6.2 24-49.6 0 53.4-206 4.7-18zM192 248.7l-12.3 47.3 24.5 0-12.3-47.3z"]
};
var faShuttleSpaceVertical = {
  prefix: 'fass',
  iconName: 'shuttle-space-vertical',
  icon: [448, 512, [], "e7bf", "M336 544l112 0 0-160-112-186.7 0 93.3 64 106.7 0 2.7-80 0-16-32 0-190.2c0-71.1-23.1-135.1-80-177.8-56.9 42.7-80 106.7-80 177.8l0 190.2-16 32-80 0 0-2.7 64-106.7 0-93.3-112 186.7 0 160 336 0zm0-96l64 0 0 48-64 0 0-48zM48 448l64 0 0 48-64 0 0-48zM192 112l64 0 0 32-64 0 0-32z"]
};
var faPersonToDoor = {
  prefix: 'fass',
  iconName: 'person-to-door',
  icon: [640, 512, [58704], "e433", "M344 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM128 112l-21.7 0c-1.4 3.4-14.7 36.8-40 100.1l-11.9 29.7 59.4 23.8c5.9-14.8 17.9-44.7 35.8-89.6l41.4 0-22.7 90.6c-8.3 33.2 11 67 43.7 76.8L308 372.2c-38.9 87.5-59.6 134.1-62.2 140l58.5 26 13-29.2c50.9-114.5 77.1-173.5 78.8-177.2-13.5-4.1-56.1-16.8-127.6-38.3l20.7-70.4c14.5 24.8 24 41.1 28.5 48.8l130.4 0 0-64-93.6 0-28.2-48.4C309 130.1 277.4 112 243.3 112L128 112zm4.8 284.9C62.7 454.8 24.7 486.1 19 490.8l40.7 49.4c4.6-3.8 44.8-36.9 120.7-99.5l6.8-5.6c.3-.9 5.6-15.7 15.8-44.3l-4.7-1.4c-20.4-6.1-37.9-17.6-51.2-32.4l-14.3 40zM448 48l0 112 48 0 0 160-48 0 0 144c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L496 0c-26.5 0-48 21.5-48 48z"]
};
var faFaceViewfinder = {
  prefix: 'fass',
  iconName: 'face-viewfinder',
  icon: [512, 512, [], "e2ff", "M24 0l136 0 0 48-112 0 0 112-48 0 0-160 24 0zM376 0l136 0 0 160-48 0 0-112-112 0 0-48 24 0zM48 376l0 88 112 0 0 48-160 0 0-160 48 0 0 24zm464 0l0 136-160 0 0-48 112 0 0-112 48 0 0 24zM96 256a160 160 0 1 1 320 0 160 160 0 1 1 -320 0zm136-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-98.9 50.6l-27.7 16c15.7 27.1 45 45.4 78.6 45.4s62.9-18.3 78.6-45.4l-27.7-16C296.7 308.2 277.7 320 256 320s-40.7-11.8-50.9-29.4z"]
};
var faRectangleVideoOnDemand = {
  prefix: 'fass',
  iconName: 'rectangle-video-on-demand',
  icon: [576, 512, [], "e774", "M576 64l-576 0 0 384 576 0 0-384zM112 184l0 59.8c0 16.5 5.7 32.5 16 45.3 10.3-12.8 16-28.7 16-45.3l0-83.8 48 0 0 83.8c0 31.8-12.6 62.3-35.1 84.9-7.1 7.1-16.7 16.7-28.9 28.9-12.2-12.2-21.8-21.8-28.9-28.9-22.5-22.5-35.1-53-35.1-84.9l0-83.8 48 0 0 24zm168 24c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0zm-56 8c0-30.9 25.1-56 56-56l16 0c30.9 0 56 25.1 56 56l0 80c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-80zm184-56l40 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0 0-192 24 0zm24 144l16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96z"]
};
var faTennisBall = {
  prefix: 'fass',
  iconName: 'tennis-ball',
  icon: [512, 512, [127934], "f45e", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM51.9 216c41.7-1 83.1-17.3 114.9-49.2S215 93.6 216 51.9c13-2.5 26.3-3.9 40-3.9 2.7 0 5.3 .1 8 .2 0 55.2-21.1 110.4-63.3 152.6S103.4 264 48.2 264c-.1-2.7-.2-5.3-.2-8 0-13.7 1.3-27.1 3.9-40zM460.2 296c-41.7 1-83.1 17.3-114.9 49.2S297 418.4 296 460.2c-13 2.5-26.3 3.8-40 3.8-2.7 0-5.3-.1-8-.2 0-55.2 21.1-110.4 63.3-152.6S408.6 248 463.8 248c.1 2.7 .2 5.3 .2 8 0 13.7-1.3 27.1-3.8 40z"]
};
var faChevronRight = {
  prefix: 'fass',
  iconName: 'chevron-right',
  icon: [320, 512, [9002], "f054", "M317.5 256L294.9 278.6 102.9 470.6 80.3 493.3 35 448 57.6 425.4 227 256 57.6 86.6 35 64 80.3 18.7 102.9 41.4 294.9 233.4 317.5 256z"]
};
var faEgg = {
  prefix: 'fass',
  iconName: 'egg',
  icon: [384, 512, [129370], "f7fb", "M192 496C86 496 0 394 0 288 0 176 64 16 192 16S384 176 384 288c0 106-86 208-192 208zM96 288c0-24.5 5-54.4 15.1-82.8 10.1-28.5 25-54.1 43.7-71.2l-21.6-23.6C109.3 132.2 92.1 163 80.9 194.5 69.7 226.1 64 259.7 64 288l0 16 32 0 0-16z"]
};
var faConveyorBeltArm = {
  prefix: 'fass',
  iconName: 'conveyor-belt-arm',
  icon: [640, 512, [], "e5f8", "M192 160l0-96-96 0 0-64 96 0 0 0 64 0 0 0 96 0 0 64-96 0 0 64 96 0 0 0 128 0 0 96-48 0 0-32-208 0-32 0 0-32zm224 96l96 0 0 64 32 0c53 0 96 43 96 96s-43 96-96 96L96 512c-53 0-96-43-96-96s43-96 96-96l0-64 96 0 0 64 64 0 0-64 96 0 0 64 64 0 0-64zM128 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLandmarkDome = {
  prefix: 'fass',
  iconName: 'landmark-dome',
  icon: [512, 512, ["landmark-alt"], "f752", "M224 0l64 0 0 34.7C368.4 48.1 431.9 111.6 445.3 192l34.7 0 0 64-32 0 0 160 64 48 0 48-512 0 0-48 64-48 0-160-32 0 0-64 34.7 0C80.1 111.6 143.6 48.1 224 34.7L224 0zM112 416l64 0 0-160-64 0 0 160zm112 0l64 0 0-160-64 0 0 160zm112 0l64 0 0-160-64 0 0 160z"]
};
var faLandmarkAlt = faLandmarkDome;
var faGrate = {
  prefix: 'fass',
  iconName: 'grate',
  icon: [448, 512, [], "e193", "M32 32l-32 0 0 448 448 0 0-448-416 0zM64 232l0-136 40 0 0 136-40 0zm0 48l40 0 0 136-40 0 0-136zm88 136l0-136 48 0 0 136-48 0zm96 0l0-136 48 0 0 136-48 0zm96 0l0-136 40 0 0 136-40 0zm40-184l-40 0 0-136 40 0 0 136zM296 96l0 136-48 0 0-136 48 0zm-96 0l0 136-48 0 0-136 48 0z"]
};
var faWorm = {
  prefix: 'fass',
  iconName: 'worm',
  icon: [448, 512, [], "e599", "M224 96c0-53 43-96 96-96l128 0 0 376c0 75.1-60.9 136-136 136S176 451.1 176 376l0-80c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 216-96 0 0-216c0-75.1 60.9-136 136-136s136 60.9 136 136l0 80c0 22.1 17.9 40 40 40s40-17.9 40-40l0-184-32 0c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSack = {
  prefix: 'fass',
  iconName: 'sack',
  icon: [512, 512, [], "f81c", "M384 0l-256 0 56 112 144 0 56-112zM342.4 160l-172.8 0-47.1 39.2C55 255.5 16 338.8 16 426.6l0 85.4 480 0 0-85.4c0-87.8-39-171.2-106.5-227.4L342.4 160z"]
};
var faUserInjured = {
  prefix: 'fass',
  iconName: 'user-injured',
  icon: [448, 512, [], "f728", "M242.7 80L334 80c-10.7-24.6-29.5-44.9-52.9-57.6L242.7 80zm-.9-70.7C236 8.4 230 8 224 8 174.8 8 132.5 37.6 114 80l80.6 0 47.1-70.7zM224 248c66.3 0 120-53.7 120-120l-240 0c0 66.3 53.7 120 120 120zM432 512l-64-192-226.5 0 45 80 165.5 0 0 112 80 0zM86.5 320l-6.5 0-64 192 178.5 0-108-192zM249.5 512l54.5 0 0-64-90.5 0 36 64z"]
};
var faMidi = {
  prefix: 'fass',
  iconName: 'midi',
  icon: [512, 512, [], "e806", "M320 8.1C430.4 36.5 512 136.7 512 256 512 397.4 397.4 512 256 512S0 397.4 0 256C0 136.7 81.6 36.5 192 8.1l0 87.9 128 0 0-87.9zM256 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-90.5-37.5a32 32 0 1 0 -45.2 45.2 32 32 0 1 0 45.2-45.2zm226.3 0a32 32 0 1 0 -45.3 45.2 32 32 0 1 0 45.3-45.2zM96 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm320 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faMoonStar = {
  prefix: 'fass',
  iconName: 'moon-star',
  icon: [512, 512, [], "e7c9", "M208 216C208 122.2 272.6 43.5 359.7 21.9 328 7.8 292.9 0 256 0 114.6 0 0 114.6 0 256S114.6 512 256 512c84.1 0 158.8-40.6 205.4-103.2-17 4.7-34.9 7.2-53.4 7.2-110.5 0-200-89.5-200-200zm163.2 20.8L400 320 428.8 236.8 512 208 428.8 179.2 400 96 371.2 179.2 288 208 371.2 236.8z"]
};
var faStrikethrough = {
  prefix: 'fass',
  iconName: 'strikethrough',
  icon: [512, 512, [], "f0cc", "M96 157.5C96 88.2 152.2 32 221.5 32l178.5 0 0 64-178.5 0c-34 0-61.5 27.5-61.5 61.5 0 31 23.1 57.2 53.9 61l44.1 5.5 254 0 0 64-512 0 0-64 115.1 0C103 204.6 96 181.8 96 157.5zM349.2 336l65.5 0c.9 6.1 1.4 12.2 1.4 18.5 0 69.3-56.2 125.5-125.5 125.5l-178.5 0 0-64 178.5 0c34 0 61.5-27.5 61.5-61.5 0-6.4-1-12.7-2.8-18.5z"]
};
var faCalendarCircleMinus = {
  prefix: 'fass',
  iconName: 'calendar-circle-minus',
  icon: [576, 512, [], "e46f", "M192 32l0 32 128 0 0-64 64 0 0 64 96 0 0 112-448 0 0-112 96 0 0-64 64 0 0 32zM32 480l0-256 323.1 0c-67.8 29.6-115.1 97.3-115.1 176 0 28.6 6.2 55.6 17.4 80L32 480zm256-80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16l0-32-160 0 0 32 160 0z"]
};
var faBlog = {
  prefix: 'fass',
  iconName: 'blog',
  icon: [512, 512, [], "f781", "M224 0l24 0C393.8 0 512 118.2 512 264l0 24-48 0 0-24c0-119.3-96.7-216-216-216l-24 0 0-48zM128 96l0 272c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48l-16 0 0-96 16 0c79.5 0 144 64.5 144 144S255.5 512 176 512 32 447.5 32 368l0-272 96 0zm120 0c92.8 0 168 75.2 168 168l0 24-48 0 0-24c0-66.3-53.7-120-120-120l-24 0 0-48 24 0z"]
};
var faStopwatch20 = {
  prefix: 'fass',
  iconName: 'stopwatch-20',
  icon: [512, 512, [], "e06f", "M336.3 0l-160 0 0 48 56 0 0 25.3c-108 11.9-192 103.5-192 214.7 0 119.3 96.7 216 216 216s216-96.7 216-216c0-39.8-10.8-77.1-29.6-109.2 19.7-19.7 36.7-36.7 50.8-50.8L448.3 82.7c-15 15-30.3 30.3-46 46-32.9-30.2-75.2-50.3-122-55.5l0-25.3 56 0 0-48zm-196 240c0-28.7 23.3-52 52-52s52 23.3 52 52l0 3.8c0 11.7-3.2 23.1-9.3 33l-43.8 71.2 53.1 0 0 40-104 0 0-33.7 3-4.8 57.6-93.6c2.2-3.6 3.4-7.8 3.4-12.1l0-3.8c0-6.6-5.4-12-12-12s-12 5.4-12 12l-40 0zm180-52c28.7 0 52 23.3 52 52l0 96c0 28.7-23.3 52-52 52s-52-23.3-52-52l0-96c0-28.7 23.3-52 52-52zm-12 52l0 96c0 6.6 5.4 12 12 12s12-5.4 12-12l0-96c0-6.6-5.4-12-12-12s-12 5.4-12 12z"]
};
var faSquareFlorin = {
  prefix: 'fass',
  iconName: 'square-florin',
  icon: [448, 512, [], "e717", "M448 32l-448 0 0 448 448 0 0-448zM240.4 156.7c9.5-22.3 31.4-36.7 55.7-36.7l47.9 0 0 48-47.9 0c-5 0-9.6 3-11.6 7.6l-20.7 48.4 56.2 0 0 48-76.7 0-35.7 83.3C198 377.6 176.1 392 151.9 392l-47.9 0 0-48 47.9 0c5 0 9.6-3 11.6-7.6l27.6-64.4-63 0 0-48 83.6 0 28.8-67.3z"]
};
var faBinary = {
  prefix: 'fass',
  iconName: 'binary',
  icon: [384, 512, [], "e33b", "M256 0l80 0 0 160 48 0 0 64-160 0 0-64 48 0 0-96-48 0 0-64 32 0zM32 288l80 0 0 160 48 0 0 64-160 0 0-64 48 0 0-96-48 0 0-64 32 0zM0 0L192 0 192 224 0 224 0 0zM64 64l0 96 64 0 0-96-64 0zM224 288l160 0 0 224-192 0 0-224 32 0zm32 160l64 0 0-96-64 0 0 96z"]
};
var faShieldCheck = {
  prefix: 'fass',
  iconName: 'shield-check',
  icon: [512, 512, [], "f2f7", "M267.6 4.5l207.5 80.5 19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.2-91.1 150-189.4 192.6l-12.7 5.5-12.7-5.5C144.9 463.9 86.6 389.2 53.9 313.9 21.5 239.3 13.7 162.9 16.6 113L17.8 92.5 37 85 244.5 4.5 256 0 267.6 4.5zm45.8 165.3L227.8 287.6c-19.3-20-33.7-34.9-43.2-44.7l-34.5 33.3c6.2 6.4 27.2 28.1 63.1 65.2l19.8 20.6 16.8-23.1 102.4-140.8 14.1-19.4-38.8-28.2-14.1 19.4z"]
};
var faSquareCruzeiro = {
  prefix: 'fass',
  iconName: 'square-cruzeiro',
  icon: [448, 512, [], "e6ed", "M448 32l-448 0 0 448 448 0 0-448zM131 256c0 44.5 31.2 81.7 73 90.8l0-118.8 40 0 0 17.1c10.7-5.8 23-9.1 36-9.1l8 0 0 40-8 0c-19.9 0-36 16.1-36 36l0 34.8c22.1-4.8 41.2-17.5 54.4-35l38.4 28.8C311.1 374.8 270.1 397 224 397 146.1 397 83 333.9 83 256s63.1-141 141-141c46.1 0 87.1 22.2 112.8 56.4l-38.4 28.8c-17-22.6-44-37.2-74.4-37.2-51.4 0-93 41.6-93 93z"]
};
var faTruckPickup = {
  prefix: 'fass',
  iconName: 'truck-pickup',
  icon: [640, 512, [128763], "f63c", "M288 96l0 96 133.4 0-57.6-96-75.8 0zm-64 96l0-160 176 0 96 160 112 0 0 128 32 0 0 64-64.4 0c.2 2.6 .4 5.3 .4 8 0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8l-160.7 0c.2 2.6 .4 5.3 .4 8 0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8l-64.4 0 0-64 32 0 0-128 192 0zM192 392a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm296 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faSeedling = {
  prefix: 'fass',
  iconName: 'seedling',
  icon: [512, 512, [127793, "sprout"], "f4d8", "M512 0l0 32C512 140.1 435.4 230.3 333.6 251.4 325.7 193.3 299.6 141 261.1 100.5 301.2 40 369.9 0 448 0l64 0zM0 64l64 0c123.7 0 224 100.3 224 224l0 224-64 0 0-192C100.3 320 0 219.7 0 96L0 64z"]
};
var faSprout = faSeedling;
var faCircleDivide = {
  prefix: 'fass',
  iconName: 'circle-divide',
  icon: [512, 512, [], "e106", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm32-320l-64 0 0-64 64 0 0 64zM168 232l200 0 0 48-224 0 0-48 24 0zm56 152l0-64 64 0 0 64-64 0z"]
};
var faCircleKip = {
  prefix: 'fass',
  iconName: 'circle-kip',
  icon: [512, 512, [], "e6fd", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm97.8-348.5c-2.9 2.3-34.4 27.9-94.6 76.7l92.7 0 0 32-92.5 0c60 48.4 91.5 73.8 94.4 76.2l-30.1 37.4c-2.1-1.7-35.3-28.5-99.6-80.4l0 78.6-48 0 0-111.8-31.8 0 0-32 31.8 0 0-112.2 48 0 0 78.9c64.3-52.1 97.5-79 99.5-80.7l30.2 37.3z"]
};
var faTransgender = {
  prefix: 'fass',
  iconName: 'transgender',
  icon: [576, 512, [9895, "transgender-alt"], "f225", "M128-32l32 0 0 64-62.1 0 38.1 38.1 32-32 33.9 33.9c-11.6 11.6-22.3 22.3-32 32l14.2 14.2c27.9-23.8 64.2-38.2 103.8-38.2 36.7 0 70.6 12.4 97.6 33.2l81.2-81.2-50.7 0 0-64 160 0 0 160-64 0 0-50.7-84.4 84.4c13 23.1 20.4 49.9 20.4 78.3 0 77.4-55 142-128 156.8l0 35.2 64 0 0 64-64 0 0 48-64 0 0-48-64 0 0-64 64 0 0-35.2c-73-14.8-128-79.4-128-156.8 0-31.4 9-60.7 24.7-85.4L136 137.9c-9.7 9.7-20.4 20.4-32 32l-33.9-33.9 32-32-38.1-38.1 0 62.1-64 0 0-160 128 0zM288 336a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faTransgenderAlt = faTransgender;
var faArrowDownToBracket = {
  prefix: 'fass',
  iconName: 'arrow-down-to-bracket',
  icon: [448, 512, [], "e094", "M246.6 342.6l-22.6 22.6-22.6-22.6-128-128-22.6-22.6 45.3-45.3c6.6 6.6 38.6 38.6 96 96l0-242.7 64 0 0 242.7c57.4-57.4 89.4-89.4 96-96l45.3 45.3-22.6 22.6-128 128zM64 352l0 96 320 0 0-128 64 0 0 192-448 0 0-192 64 0 0 32z"]
};
var faUnicorn = {
  prefix: 'fass',
  iconName: 'unicorn',
  icon: [640, 512, [129412], "f727", "M448 160l0 80 0 0c-.5 30-12.8 56.4-32 75.7l0 196.3-96 0 0-165.3c-4.1-.7-8.2-1.6-12.3-2.8L224 320 224 355.9c-7.2 7.2-20.9 20.9-41.1 41.1l38.3 115-101.2 0c-29.8-89.3-45.4-136.3-47-141 13.1-13.1 28.9-28.9 47.6-47.6L78.2 259.9c-7.3-11-11.9-23.4-13.6-36.4-10.1 7.3-16.7 19.1-16.7 32.5l0 80-48 0 0-80c0-44.6 33.2-81.5 76.3-87.2 14.9-24.4 41.8-40.8 72.5-40.8L320 128C320 57.3 377.3 0 448 0l112 0 0 32-32 0 16 16 96 0 0 16-80 26.7 0 101.3-80 32-32-64zm64-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faLeftFromBracket = {
  prefix: 'fass',
  iconName: 'left-from-bracket',
  icon: [576, 512, [], "e66c", "M40 238.6L21.5 256 40 273.4c113.3 107 174.7 165 184.5 174.2l0-127.7 160 0 0-128-160 0 0-127.7c-9.7 9.2-71.2 67.3-184.5 174.2zM384.5 416l-32 0 0 64 192 0 0-448-192 0 0 64 128 0 0 320-96 0z"]
};
var faRampLoading = {
  prefix: 'fass',
  iconName: 'ramp-loading',
  icon: [384, 512, [], "f4d4", "M0 0l384 0 0 404.7-53.1-106.1-10.9-21.9 0-212.7-256 0 0 212.7c-.3 .5-21.6 43.2-64 128L0 0zM320 384l64 128-384 0 96-192 192 0 32 64z"]
};
var faHandHoldingBox = {
  prefix: 'fass',
  iconName: 'hand-holding-box',
  icon: [576, 512, [], "f47b", "M224 128l0-128-96 0 0 256 320 0 0-256-96 0 0 128-64-32-64 32zM137.4 313.4l-70.6 70.6-66.7 0 0 128 396.4 0 10.2-7c101.2-69.6 154.8-106.4 161-110.7l-45.3-65.9c-11.7 8.1-54.2 37.3-127.5 87.6l-138.8 0 0-48 128 0 0-64-237.3 0-9.4 9.4z"]
};
var faStarHalf = {
  prefix: 'fass',
  iconName: 'star-half',
  icon: [576, 512, [61731], "f089", "M304.2-52.8l0 0-108.6 181.4-201.1 32 143.9 144.1-31.7 201.2 197.5-100.5 0-458.1z"]
};
var faArrowDownToLine = {
  prefix: 'fass',
  iconName: 'arrow-down-to-line',
  icon: [384, 512, ["arrow-to-bottom"], "f33d", "M32 512l-32 0 0-64 384 0 0 64-352 0zM214.6 374.6l-22.6 22.6-22.6-22.6-128-128-22.6-22.6 45.3-45.3c6.6 6.6 38.6 38.6 96 96l0-274.7 64 0 0 274.7c57.4-57.4 89.4-89.4 96-96l45.3 45.3-22.6 22.6-128 128z"]
};
var faArrowToBottom = faArrowDownToLine;
var faPhotoFilm = {
  prefix: 'fass',
  iconName: 'photo-film',
  icon: [640, 512, ["photo-video"], "f87c", "M192 0l448 0 0 352-448 0 0-352zM320 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM240 288l352 0-128-208-84.7 137.7-43.3-57.7-96 128zM0 128l144 0 0 272 304 0 0 80-448 0 0-352zm104 56l-48 0 0 48 48 0 0-48zm0 96l-48 0 0 48 48 0 0-48zm0 96l-48 0 0 48 48 0 0-48z"]
};
var faPhotoVideo = faPhotoFilm;
var faPi = {
  prefix: 'fass',
  iconName: 'pi',
  icon: [512, 512, [], "f67e", "M64.4 32l-32 0 0 64 96 0 0 280.4C107 419.4 92.7 448 85.5 462.3l57.2 28.6c6.6-13.2 22-44.1 46.3-92.6l3.4-6.8 0-295.6 128 0 0 384 131.8 0c11.2-22.3 34.9-69.9 39.2-78.3l-57.2-28.6c-10.7 21.5-17.9 35.8-21.5 42.9l-28.2 0 0-320 96 0 0-64-416 0z"]
};
var faPictureInPicture = {
  prefix: 'fass',
  iconName: 'picture-in-picture',
  icon: [512, 512, [], "e80b", "M512 208l-64 0 0-112-384 0 0 320 144 0 0 64-208 0 0-448 512 0 0 176zm0 272l-256 0 0-224 256 0 0 224z"]
};
var faTableCellsLock = {
  prefix: 'fass',
  iconName: 'table-cells-lock',
  icon: [640, 512, [], "e679", "M448 96l0 64-64 0 0-64 64 0zM384 224l25.3 0c17.1-42.2 56-73.2 102.7-79l0-113-448 0 0 448 304 0 0-208 16 0 0-48zm-64 64l-64 0 0-64 64 0 0 64zm-64 64l64 0 0 64-64 0 0-64zm-64-64l-64 0 0-64 64 0 0 64zm-64 64l64 0 0 64-64 0 0-64zm0-192l0-64 64 0 0 64-64 0zm128 0l0-64 64 0 0 64-64 0zm272 80c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faPumpMedical = {
  prefix: 'fass',
  iconName: 'pump-medical',
  icon: [320, 512, [], "e06a", "M96-32l0 112 128 0 0-24 96 0 0-48-96 0 0-40-128 0zM320 128l-320 0 0 384 320 0 0-384zM128 232l64 0 0 56 56 0 0 64-56 0 0 56-64 0 0-56-56 0 0-64 56 0 0-56z"]
};
var faFire = {
  prefix: 'fass',
  iconName: 'fire',
  icon: [448, 512, [128293], "f06d", "M285.9 58.2c-4.2 5-9 11-14.2 17.9-15.7-25.9-31.8-47.6-45.3-64.2-15.5-19-31.8-35.4-49.5-52.1-14.6 12.3-28.4 24.2-41.8 38-14.9 15.3-34.7 37.5-54.6 65.1-39.4 55-80.5 133.9-80.5 225 0 123.7 100.3 224 224 224S448 411.7 448 288c0-70.3-28.4-132.7-55.6-176.6-13.7-22.1-27.4-40-37.7-52.4-10.5-12.6-22-24.1-33.6-35.7l0 0-1.1-1.1c-.6 .6-1.2 1.2-1.9 1.9-11.2 11.2-22.1 22-32.3 34.3zM225.7 416c-63.2 0-113.7-40.6-113.7-109.2 0-65.6 63.2-114.8 63.2-114.8 5.6 7 87.1 110.6 87.1 110.6l50.6-58.8c4.2 5.6 7 11.2 9.8 16.8 25.3 46.2 14 105-28.1 134.4-21.1 14-43.5 21-68.8 21z"]
};
var faFaceSmilePlus = {
  prefix: 'fass',
  iconName: 'face-smile-plus',
  icon: [640, 512, ["smile-plus"], "f5b9", "M568-64l0 72 72 0 0 48-72 0 0 72-48 0 0-72-72 0 0-48 72 0 0-72 48 0zM0 272a240 240 0 1 1 480 0 240 240 0 1 1 -480 0zm147.8 63.5l-39.5 27.3C137.1 404.6 185.3 432 240 432s102.9-27.4 131.8-69.2l-39.5-27.3C312 364.9 278.2 384 240 384s-72-19.1-92.2-48.5zM160 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faSmilePlus = faFaceSmilePlus;
var faMagnifyingGlassPlus = {
  prefix: 'fass',
  iconName: 'magnifying-glass-plus',
  icon: [576, 512, ["search-plus"], "f00e", "M448.3 208c0 45.9-14.9 88.3-40 122.7L534.9 457.4 557.5 480 512.3 525.3 489.6 502.6 363 376c-34.4 25.2-76.8 40-122.7 40-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208zm-232 96l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faSearchPlus = faMagnifyingGlassPlus;
var faSwap = {
  prefix: 'fass',
  iconName: 'swap',
  icon: [640, 512, [], "e609", "M128 32l-112 128 80 0 0 320 256 0 0-384 128 0 0 288-80 0 112 128 112-128-80 0 0-352-256 0 0 384-128 0 0-256 80 0-112-128z"]
};
var faCommentHeart = {
  prefix: 'fass',
  iconName: 'comment-heart',
  icon: [512, 512, [], "e5c8", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM249.6 183.5c-11.1-14.8-28.5-23.5-46.9-23.5-32.4 0-58.7 26.3-58.7 58.7l0 5.3c0 64 112 128 112 128s112-64 112-128l0-5.3c0-32.4-26.3-58.7-58.7-58.7-18.5 0-35.9 8.7-46.9 23.5l-6.4 8.5-6.4-8.5z"]
};
var faFaceSmileTear = {
  prefix: 'fass',
  iconName: 'face-smile-tear',
  icon: [512, 512, [], "e393", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM240 366.9c-31.6-4.5-58.9-22.2-76.3-47.3l-39.5 27.3c28.3 40.9 75.2 68.1 128.6 69.2-8.2-14.1-12.8-30.5-12.8-48l0-1.1zM176 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM295.2 338.6c-4.2 8.4-7.2 17.7-7.2 27 0 28.7 20.7 50.4 48 50.4s48-21.7 48-50.4c0-9.3-3.1-18.6-7.2-27-9.7-19.7-24.8-36.2-40.8-50.6-16 14.4-31.1 30.9-40.8 50.6z"]
};
var faWheat = {
  prefix: 'fass',
  iconName: 'wheat',
  icon: [576, 512, [], "f72d", "M145.8 282.7l6.1 6.7c19.7 23.8 26.3 55 19.3 83.9 31.7-7.7 66.2 1 90.6 25.3l57.4 57.4-18.7 18.7c-37.5 37.5-98.3 37.5-135.8 0L134.1 444.3 49.4 529c-9.4 9.4-24.5 9.4-33.9 0-9.4-9.4-9.4-24.6 0-33.9l84.7-84.7-30.5-30.5c-37.5-37.5-37.5-98.3 0-135.8l18.7-18.8 57.4 57.4zm104-104l6.1 6.7c19.7 23.8 26.3 55 19.3 83.9 31.7-7.7 66.2 1 90.6 25.3l57.4 57.4-18.7 18.7c-37.5 37.5-98.3 37.5-135.8 0l-94.9-94.9c-37.5-37.5-37.5-98.3 0-135.8l18.7-18.8 57.4 57.4zm104-104l6.1 6.7c19.7 23.8 26.3 55 19.3 83.9 31.7-7.7 66.2 1 90.6 25.3l57.4 57.4-18.7 18.7c-37.5 37.5-98.3 37.5-135.8 0l-94.9-94.9c-37.5-37.5-37.5-98.3 0-135.7l18.8-18.8 57.4 57.4zM560.5 35l-.1 4.8c-2.4 47.6-40.5 85.7-88.1 88.1l-4.8 .1-51 0 0-51c0-51.4 41.6-93 93-93l51 0 0 51z"]
};
var faBarcodeScan = {
  prefix: 'fass',
  iconName: 'barcode-scan',
  icon: [576, 512, [], "f465", "M128 32l-64 0 0 192-64 0 0 48 576 0 0-48-64 0 0-192-48 0 0 192-48 0 0-192-48 0 0 192-48 0 0-192-64 0 0 192-48 0 0-192-48 0 0 192-32 0 0-192zM64 480l64 0 0-160-64 0 0 160zm96 0l48 0 0-160-48 0 0 160zm96 0l64 0 0-160-64 0 0 160zm112 0l48 0 0-160-48 0 0 160zm96 0l48 0 0-160-48 0 0 160z"]
};
var faEarCircleCheckmark = {
  prefix: 'fass',
  iconName: 'ear-circle-checkmark',
  icon: [576, 512, [], "e75b", "M447.3 208.6c.5-5.5 .7-11 .7-16.6 0-106-86-192-192-192S64 86 64 192l0 320 208 0 1.6-3.5c-21.2-30.9-33.6-68.2-33.6-108.5 0-57.3 25.1-108.8 65-144l0 0c22.3-19.7 49.3-34.3 79-42l0 0c15.3-3.9 31.4-6 48-6 5.1 0 10.2 .2 15.3 .6zM256 64c61.6 0 113 43.5 125.2 101.4-16 3.4-31.4 8.5-46.1 15-5.6-38.7-38.9-68.3-79.2-68.3-44.2 0-80 35.8-80 80l0 16.4c36 4 64 34.5 64 71.6 0 39.8-32.2 72-72 72l-40 0 0-48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-64c0-70.7 57.3-128 128-128zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm60.9-182.6l-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L353.4 400 376 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8-9.4 12.9z"]
};
var faGalaxy = {
  prefix: 'fass',
  iconName: 'galaxy',
  icon: [512, 512, [], "e008", "M336 0l32 0-12.6 7.8c-51.5 31.7-84.8 85.7-90.5 145.2 16.5-5.8 34.8-9 55.1-9 2.9 0 5.8 .1 8.7 .2 .9-.1 1.9-.2 2.8-.2 1.9 0 3.7 .3 5.5 .7 98.1 8.6 175.1 90.9 175.1 191.3l0 32-7.8-12.6c-31.7-51.5-85.7-84.8-145.2-90.5 5.8 16.5 9 34.8 9 55.1 0 2.9-.1 5.8-.2 8.7 .1 .9 .2 1.9 .2 2.8 0 1.9-.3 3.7-.7 5.5-8.6 98.1-90.9 175.1-191.3 175.1l-32 0 12.6-7.8c51.5-31.7 84.8-85.7 90.5-145.2-16.5 5.8-34.8 9-55.1 9-2.9 0-5.8-.1-8.7-.2-.9 .1-1.9 .2-2.8 .2-1.9 0-3.7-.3-5.5-.7-98.1-8.6-175.1-90.9-175.1-191.3l0-32 7.8 12.6c31.7 51.5 85.7 84.8 145.2 90.5-5.8-16.5-9-34.8-9-55.1 0-2.9 .1-5.8 .2-8.7-.1-.9-.2-1.9-.2-2.8 0-1.9 .3-3.7 .7-5.5 8.6-98.1 90.9-175.1 191.3-175.1zM256 296l40-40-40-40-40 40 40 40z"]
};
var faFlask = {
  prefix: 'fass',
  iconName: 'flask',
  icon: [448, 512, [], "f0c3", "M128 224l-128 224 0 64 448 0 0-64-128-224 0-160 32 0 0-64-256 0 0 64 32 0 0 160zM192 64l64 0 0 177c.9 1.6 16 27.9 45.1 79l-154.3 0c29.2-51.1 44.2-77.4 45.1-79l0-177z"]
};
var faCarKey = {
  prefix: 'fass',
  iconName: 'car-key',
  icon: [576, 512, [], "e7c0", "M152 32l-22.7 0-7.5 21.4-48.5 138.6-41.3 0 0 288 96 0 0-64 240 0 0-48c-38.8-29.2-64-75.6-64-128 0-16.7 2.6-32.8 7.3-48l-170.2 0 33.6-96 219.5 0c21-10.2 44.5-15.9 69.3-16-6.5-18.6-12.1-34.6-16.8-48L152 32zM96 304a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm480-64c0-61.9-50.1-112-112-112S352 178.1 352 240c0 44.7 26.2 83.2 64 101.2l0 122.8 48 48 64-64-32-32 32-32-29.8-37.3C543.3 332.3 576 289.9 576 240zM432 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faFireplace = {
  prefix: 'fass',
  iconName: 'fireplace',
  icon: [576, 512, [], "f79a", "M0 32l576 0 0 96-32 0 0 384-64 0 0-160c0-106-86-192-192-192S96 246 96 352l0 160-64 0 0-384-32 0 0-96zM261.8 224l52.4 52.4 26.2-26.2c62.8 52.4 78.5 109.1 78.5 130.9 0 72.3-58.6 130.9-130.9 130.9S157.1 453.4 157.1 381.1c0-73.3 69.8-135.3 104.7-157.1zm78.5 196.5c0-39.3-52.4-78.5-52.4-78.5s-52.4 39.3-52.4 78.5c0 28.9 23.4 52.4 52.4 52.4s52.4-23.4 52.4-52.4z"]
};
var faFlowerTulip = {
  prefix: 'fass',
  iconName: 'flower-tulip',
  icon: [448, 512, [127799], "f801", "M64 0l80 64 80-96 80 96 80-64 0 128c0 70.7-57.3 128-128 128l0 128c29.2-38.9 75.7-64 128-64l64 0 0 32c0 88.4-71.6 160-160 160l-128 0C71.6 512 0 440.4 0 352l0-32 64 0c52.3 0 98.8 25.1 128 64l0-128c-70.7 0-128-57.3-128-128L64 0z"]
};
var faInboxes = {
  prefix: 'fass',
  iconName: 'inboxes',
  icon: [512, 512, [], "e1bb", "M427.5 64l19.2 96-78.7 0-32 64-160 0-32-64-78.7 0 19.2-96 343.1 0zM32 0L0 160 0 320 512 320 512 160 480 0 32 0zM0 368l0 144 512 0 0-144-144 0-32 48-160 0-32-48-144 0z"]
};
var faRectangleVertical = {
  prefix: 'fass',
  iconName: 'rectangle-vertical',
  icon: [384, 512, ["rectangle-portrait"], "f2fb", "M384 0L384 512 0 512 0 0 384 0z"]
};
var faRectanglePortrait = faRectangleVertical;
var faAlignRight = {
  prefix: 'fass',
  iconName: 'align-right',
  icon: [448, 512, [], "f038", "M448 32l0 64-288 0 0-64 288 0zm0 256l0 64-288 0 0-64 288 0zM0 160l448 0 0 64-448 0 0-64zM448 416l0 64-448 0 0-64 448 0z"]
};
var faTransporter6 = {
  prefix: 'fass',
  iconName: 'transporter-6',
  icon: [640, 512, [], "e2a7", "M272-32l-16 0 0 32 128 0 0-32-112 0zM176 224l-16 0 0 32 320 0 0-32-304 0zM480 496l-320 0 0 48 320 0 0-48zM144 48l-48-16-16-48-16 48-48 16 48 16 16 48 16-48 48-16zM576 384l-16-48-16 48-48 16 48 16 16 48 16-48 48-16-48-16z"]
};
var faCableCar = {
  prefix: 'fass',
  iconName: 'cable-car',
  icon: [512, 512, [128673, 57551, "tram"], "f7da", "M288.2-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 56a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32.2 224l200 0 0-96.2-193.4 55.3-23.1 6.6-13.2-46.2 23.1-6.6c373.3-106.7 186.7-53.3 448-128l23.1-6.6 13.2 46.2-23.1 6.6-206.6 59 0 109.9 200 0 0 288-448 0 0-288zm264 64l-80 0 0 96 80 0 0-96zm48 0l0 96 72 0 0-96-72 0zm-248 0l0 96 72 0 0-96-72 0z"]
};
var faTram = faCableCar;
var faKitMedical = {
  prefix: 'fass',
  iconName: 'kit-medical',
  icon: [512, 512, ["first-aid"], "f479", "M0 64l0 384 80 0 0-384-80 0zm128 0l0 384 256 0 0-384-256 0zM512 448l0-384-80 0 0 384 80 0zM224 168l64 0 0 56 56 0 0 64-56 0 0 56-64 0 0-56-56 0 0-64 56 0 0-56z"]
};
var faFirstAid = faKitMedical;
var faGripLines = {
  prefix: 'fass',
  iconName: 'grip-lines',
  icon: [448, 512, [], "f7a4", "M0 288l0 64 448 0 0-64-448 0zM0 160l0 64 448 0 0-64-448 0z"]
};
var faBurger = {
  prefix: 'fass',
  iconName: 'burger',
  icon: [512, 512, ["hamburger"], "f805", "M32 384l0 96 448 0 0-96-448 0zM480 224l0-48S432 32 256 32 32 176 32 176l0 48 448 0zm32 48l-512 0 0 64 512 0 0-64zM256 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM120 128a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm248-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHamburger = faBurger;
var faRaindrops = {
  prefix: 'fass',
  iconName: 'raindrops',
  icon: [448, 512, [], "f75c", "M103 101.2c-4.6 8.9-7 18.7-7 28.7 0 34.3 27.8 62.1 62.1 62.1l3.8 0c34.3 0 62.1-27.8 62.1-62.1 0-10-2.4-19.9-7-28.7L160-8 103 101.2zM7 325.2C2.4 334 0 343.9 0 353.9 0 388.2 27.8 416 62.1 416l3.8 0c34.3 0 62.1-27.8 62.1-62.1 0-10-2.4-19.9-7-28.7L64 216 7 325.2zM320 152L210.6 325.9c-12.2 19.4-18.6 41.8-18.6 64.6 0 67.1 54.4 121.4 121.4 121.4l13.1 0c67.1 0 121.4-54.4 121.4-121.4 0-22.9-6.5-45.3-18.6-64.6L320 152z"]
};
var faSnowman = {
  prefix: 'fass',
  iconName: 'snowman',
  icon: [640, 512, [9731, 9924], "f7d0", "M403 211.7c32.2-24.9 53-63.9 53-107.7 0-75.1-60.9-136-136-136S184 28.9 184 104c0 43.9 20.8 82.9 53 107.7-32.2 16.3-59 41.8-76.8 73.1l-48.1-20.6 0-64.2-48 0 0 43.6c-15.1-6.5-30-12.8-44.6-19.1L.5 268.6c20.5 8.8 118.6 50.8 141.5 60.6-3.9 14.9-6 30.6-6 46.7 0 74.8 44.7 139.3 108.8 168l150.3 0c64.2-28.7 108.8-93.2 108.8-168 0-16.2-2.1-31.8-6-46.7 103.3-44.3 139.3-59.7 141.5-60.6l-18.9-44.1c-14.6 6.3-29.5 12.6-44.6 19.1l0-43.6-48 0 0 64.2-48.2 20.6c-17.9-31.3-44.6-56.8-76.8-73.1zM296 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM292.2 159.3c-2.7-4.8-4.2-10.2-4.2-15.7 0-17.5 14.2-31.6 31.6-31.6l.8 0c17.5 0 31.6 14.2 31.6 31.6 0 5.5-1.4 10.9-4.2 15.7L320 208 292.2 159.3z"]
};
var faHotel = {
  prefix: 'fass',
  iconName: 'hotel',
  icon: [512, 512, [127976], "f594", "M16 0l480 0 0 48-32 0 0 416 32 0 0 48-480 0 0-48 32 0 0-416-32 0 0-48zM288 384l62.7 0c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80l62.7 0 0 80 64 0 0-80zM112 96l0 64 64 0 0-64-64 0zm176 0l-64 0 0 64 64 0 0-64zm48 0l0 64 64 0 0-64-64 0zM176 192l-64 0 0 64 64 0 0-64zm48 0l0 64 64 0 0-64-64 0zm176 0l-64 0 0 64 64 0 0-64z"]
};
var faPrint = {
  prefix: 'fass',
  iconName: 'print',
  icon: [512, 512, [128424, 128438, 9113], "f02f", "M64 0l304 0 80 80 0 64-384 0 0-144zM0 192l512 0 0 192-64 0 0 128-384 0 0-128-64 0 0-192zM128 416l0 32 256 0 0-96-256 0 0 64zM456 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faDialMin = {
  prefix: 'fass',
  iconName: 'dial-min',
  icon: [576, 512, [], "e161", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64-64 0 0-64zM400.9 401c-56.7 56.7-145.4 62-208 15.7l111.9-111.9 17-17-33.9-33.9-17 17-111.9 111.9c-46.2-62.6-41-151.3 15.7-208 62.5-62.5 163.8-62.5 226.3 0s62.5 163.8 0 226.3z"]
};
var faCirclePolishZloty = {
  prefix: 'fass',
  iconName: 'circle-polish-zloty',
  icon: [512, 512, [], "e700", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm95.4-360l0 77.4c6.4-2.6 14.9-5.9 25.5-10.2l11.9 29.7c-8.6 3.5-21.1 8.4-37.4 14.9l0 120.1-48 0 0-100.9c-5.4 2.2-13.5 5.4-24.3 9.7l-11.9-29.7c8.8-3.5 20.9-8.4 36.2-14.5l0-120.6 48 0 0 24zM136 192l131.1 0c-3.4 8.7-22.1 56.7-56 144l60.9 0 0 48-131.1 0c3.4-8.7 22.1-56.7 56-144l-60.9 0 0-48z"]
};
var faFamily = {
  prefix: 'fass',
  iconName: 'family',
  icon: [512, 512, [], "e300", "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM64 512l0-160-32 0 0-192 129.3 0c-.9 5.2-1.3 10.5-1.3 16 0 11.2 1.9 22 5.5 32l-37.5 0 0 240 32 0 0 64-96 0zm384 0l-96 0 0-64 32 0 0-240-37.5 0c3.5-10 5.5-20.8 5.5-32 0-5.5-.5-10.8-1.3-16l97.3 0 64 224-64 0 0 128zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm80 272l-32 0 0 112-96 0 0-112-32 0 0-144 160 0 0 144z"]
};
var faStarfighter = {
  prefix: 'fass',
  iconName: 'starfighter',
  icon: [640, 512, [], "e037", "M352 0l32 256 0 224-128 0 0-224 32-256 64 0zM288 256l0 64 64 0 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zM72 72l0 48 24 0 0 48-24 0 0 184 56 0 0-64 96 0 0 224-64 0 0-44.8-88-35.2 0 40-48 0 0-304-24 0 0-48 24 0 0-48 48 0zm544 0l0 48 24 0 0 48-24 0 0 304-48 0 0-40-88 35.2 0 44.8-64 0 0-224 96 0 0 64 56 0 0-184-24 0 0-48 24 0 0-48 48 0z"]
};
var faCartCircleArrowDown = {
  prefix: 'fass',
  iconName: 'cart-circle-arrow-down',
  icon: [640, 512, [], "e3ef", "M24-16l-24 0 0 48 76 0 60.4 332.3 3.6 19.7 164.7 0c1.4-16.7 4.9-32.8 10.3-48l-134.9 0-8.7-48 168.7 0c34.9-48.5 91.7-80 156-80 15.8 0 31.2 1.9 46 5.5L576 32 124.8 32c-3.7-20.3-6.6-36.3-8.7-48L24-16zM208 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm288 32a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-136l-11.3 11.3-56 56-11.3 11.3-11.3-11.3-56-56-11.3-11.3 22.6-22.6c4.6 4.6 18 18 40 40l0-105.4 32 0 0 105.4c22-22 35.4-35.4 40-40L574.6 408z"]
};
var faMessageMedical = {
  prefix: 'fass',
  iconName: 'message-medical',
  icon: [512, 512, ["comment-alt-medical"], "f7f4", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM217.6 134.4l76.8 0 0 67.2 67.2 0 0 76.8-67.2 0 0 67.2-76.8 0 0-67.2-67.2 0 0-76.8 67.2 0 0-67.2z"]
};
var faCommentAltMedical = faMessageMedical;
var faCircleArrowDownRight = {
  prefix: 'fass',
  iconName: 'circle-arrow-down-right',
  icon: [512, 512, [], "e0fa", "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM216 304l54.1 0-103-103-17-17 33.9-33.9 17 17 103 103 0-78.1 48 0 0 160-160 0 0-48 24 0z"]
};
var faVolleyball = {
  prefix: 'fass',
  iconName: 'volleyball',
  icon: [512, 512, [127952, "volleyball-ball"], "f45f", "M0 256c0 45.2 11.7 87.6 32.2 124.5l15.7-95.8 1-5.9 3.6-4.8 111.2-145.6-82.8-59.2C31.1 115.9 0 182.3 0 256zM135.4 481.9l10.9-111.5 .6-6.6 3.9-5.3 77.6-105.5-36.2-82.7-97.9 128.2-22.2 135.7c18.4 19 39.7 35.2 63.3 47.8zm46.4 19.2c23.5 7.1 48.4 10.9 74.3 10.9 93.3 0 174.9-49.9 219.6-124.4l-90.7 34.3-5.6 2.1-6-.8-181.7-23.5-9.9 101.4zM502.3 326.2c6.3-22.3 9.7-45.9 9.7-70.2 0-2.8 0-5.6-.1-8.4l-101.9 46.3-6 2.7-6.6-.7-130.2-14.5-53.5 72.8 159.9 20.7 128.7-48.7zM362.2 243.7L300.2 94.8 193.7 7.6c-26.1 6.5-50.7 17.1-72.9 31l91.1 65.2 5.4 3.8 2.6 6 52.6 120 89.8 10zm143.2-45.9C479.3 85.7 379.7 1.9 260.2 0l75 61.4 4.6 3.8 2.3 5.5 70.5 169.1 92.7-42.1z"]
};
var faVolleyballBall = faVolleyball;
var faArrowTurnDownRight = {
  prefix: 'fass',
  iconName: 'arrow-turn-down-right',
  icon: [576, 512, [], "e3d6", "M96.3 96l0-32-64 0 0 224 402.7 0-96 96 45.3 45.3 173.3-173.3-22.6-22.6-128-128-22.6-22.6-45.3 45.3c6.6 6.6 38.6 38.6 96 96l-338.7 0 0-128z"]
};
var faTrafficLight = {
  prefix: 'fass',
  iconName: 'traffic-light',
  icon: [320, 512, [128678], "f637", "M320-32l-320 0 0 576 320 0 0-576zM160 360c30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56 25.1-56 56-56zm56-104a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 152a56 56 0 1 1 0-112 56 56 0 1 1 0 112z"]
};
var faPlaneCircleCheck = {
  prefix: 'fass',
  iconName: 'plane-circle-check',
  icon: [640, 512, [], "e555", "M232 24c0-30.9 25.1-56 56-56s56 25.1 56 56l0 127.3 78 71.5c-69.3 29-118 97.4-118 177.2 0 49.3 18.6 94.3 49.1 128.3l-65.1-16.3-128 32 0-48 72-57.6 0-99.7-184 61.3 0-80 184-168.7 0-127.3zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.4-51.5l-25.9-18.8-9.4 12.9-53 72.9C457.7 395 445 382.3 440 377.4L417.4 400c2.8 2.8 19.9 19.9 51.3 51.3l13.2 13.2 11-15.1 64-88 9.4-12.9z"]
};
var faSquarePeso = {
  prefix: 'fass',
  iconName: 'square-peso',
  icon: [448, 512, [], "e71a", "M448 32l-448 0 0 448 448 0 0-448zM136 120l88 0c43.3 0 80.4 26.4 96 64l32 0 0 32-24.3 0c.4 5.3 .4 10.7 0 16l24.3 0 0 32-32 0c-15.7 37.6-52.8 64-96 64l-40 0 0 64-48 0 0-128-24 0 0-32 24 0 0-16-24 0 0-32 24 0 0-64zm88 48l-40 0 0 16 79.2 0c-10.1-9.9-23.9-16-39.2-16zm-40 64l95.4 0c.4-2.6 .6-5.3 .6-8s-.2-5.4-.6-8l-95.4 0 0 16zm0 32l0 16 40 0c15.3 0 29.1-6.1 39.2-16L184 264z"]
};
var faHouseWater = {
  prefix: 'fass',
  iconName: 'house-water',
  icon: [640, 512, ["house-flood"], "f74f", "M560.4 272l-50.5 0 0 118.4c-31.2-12.5-54.4-21.8-69.5-27.8-6.7 2.7-46.7 18.7-120 48-73.3-29.3-113.3-45.3-120-48-15.1 6.1-38.3 15.3-69.5 27.8l0-118.4-50.5 0 0-40 240-216 240 216 0 40zM209.3 417.7l111.1 44.4 111.1-44.4 8.9-3.6 8.9 3.6 111.8 44.7c29.3-9.7 50.1-16.7 62.4-20.8l15.2 45.5c-11 3.7-34.6 11.5-70.8 23.6l-8.3 2.8-8.2-3.3-111.1-44.4-111.1 44.4-8.9 3.6-8.9-3.6-111.1-44.4-111.1 44.4-8.2 3.3-8.3-2.8C36.6 498.7 13 490.8 2 487.2l15.2-45.5c12.4 4.1 33.2 11.1 62.4 20.8l111.8-44.7 8.9-3.6 8.9 3.6zM368.4 224l-96 0 0 96 96 0 0-96z"]
};
var faHouseFlood = faHouseWater;
var faUsers = {
  prefix: 'fass',
  iconName: 'users',
  icon: [640, 512, [], "f0c0", "M320 16a104 104 0 1 1 0 208 104 104 0 1 1 0-208zM96 88a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm14.7 392l-110.7 0 48-192 107 0-41.8 181.2-2.5 10.8zm418.5 0l-2.5-10.8-41.8-181.2 107 0 48 192-110.7 0zM472 160a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM208 272l224 0 48 208-320 0 48-208z"]
};
var faCertificate = {
  prefix: 'fass',
  iconName: 'certificate',
  icon: [576, 512, [], "f0a3", "M241.2-.5L211.3-31.2c-6 23.8-15.1 59.4-27.1 107-47.2-13.3-82.6-23.3-106.2-30 6.7 23.6 16.7 59 30 106.2-47.6 12.1-83.2 21.1-107 27.1 17.6 17.1 43.9 42.8 79.1 77-35.2 34.2-61.5 59.9-79.1 77 23.8 6 59.4 15.1 107 27.1-13.3 47.2-23.3 82.6-30 106.2 23.6-6.7 59-16.7 106.2-30 12.1 47.6 21.1 83.2 27.1 107 17.1-17.6 42.8-43.9 77-79.1 34.2 35.2 59.9 61.5 77 79.1 6-23.8 15.1-59.4 27.1-107 47.2 13.3 82.6 23.3 106.2 30-6.7-23.6-16.7-59-30-106.2 47.6-12.1 83.2-21.1 107-27.1-17.6-17.1-43.9-42.8-79.1-77 35.2-34.2 61.5-59.9 79.1-77-23.8-6-59.4-15.1-107-27.1 13.3-47.2 23.3-82.6 30-106.2-23.6 6.7-59 16.7-106.2 30-12.1-47.6-21.1-83.2-27.1-107-17.1 17.6-42.8 43.9-77 79.1L241.2-.5z"]
};
var faAlarmClock = {
  prefix: 'fass',
  iconName: 'alarm-clock',
  icon: [512, 512, [9200], "f34e", "M492.3 153.2c-32.2-56.4-84-100.1-146.1-121.9 17.4-19.2 42.6-31.3 70.6-31.3 52.6 0 95.2 42.6 95.2 95.2 0 21.8-7.3 41.9-19.7 58zm-472.6 0C7.3 137.2 0 117.1 0 95.2 0 42.6 42.6 0 95.2 0 123.2 0 148.4 12.1 165.8 31.3 103.7 53.1 51.9 96.9 19.7 153.2zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6C96.3 493 77 512.3 64 525.3L18.7 480C31.7 467 51 447.7 76.6 422.2 48.6 384.8 32 338.3 32 288 32 164.3 132.3 64 256 64S480 164.3 480 288c0 50.3-16.6 96.8-44.6 134.2l57.8 57.8-45.3 45.3-57.8-57.8zM232 160l0 137.9 7 7 72 72 33.9-33.9-65-65 0-118.1-48 0z"]
};
var faHelicopterSymbol = {
  prefix: 'fass',
  iconName: 'helicopter-symbol',
  icon: [512, 512, [], "e502", "M445.4 224l64.7 0C495.6 108.2 403.8 16.4 288 2l0 64.7C368.4 80.1 431.9 143.6 445.4 224zM510 288l-64.7 0C431.9 368.4 368.4 431.9 288 445.3l0 64.7c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510l0-64.7C143.6 431.9 80.2 368.4 66.7 288L2 288zm0-64l64.7 0C80.2 143.6 143.6 80.1 224 66.7L224 2C108.2 16.4 16.4 108.2 2 224zm206-64l0-32-64 0 0 256 64 0 0-96 96 0 0 96 64 0 0-256-64 0 0 96-96 0 0-64z"]
};
var faHouseChimneyCrack = {
  prefix: 'fass',
  iconName: 'house-chimney-crack',
  icon: [512, 512, ["house-damage"], "f6f1", "M464 272l48 0 0-48-48-45 0-131-96 0 0 41-112-105-256 240 0 48 48 0 0 240 150.4 0-38.4-64 96-80-64-112 160 112-96 80 38.4 64 169.6 0 0-240z"]
};
var faHouseDamage = faHouseChimneyCrack;
var faDryerHeat = {
  prefix: 'fass',
  iconName: 'dryer-heat',
  icon: [448, 512, ["dryer-alt"], "f862", "M448 0L0 0 0 512 448 512 448 0zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM72 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM192 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM171.3 204.7l-22.6 22.6 28.7 28.7c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l28.7 28.7 22.6-22.6-28.7-28.7c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-28.7-28.7zM280 233.4l-28.7-28.7-22.6 22.6 28.7 28.7c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l28.7 28.7 22.6-22.6-28.7-28.7c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6z"]
};
var faDryerAlt = faDryerHeat;
var faBringForward = {
  prefix: 'fass',
  iconName: 'bring-forward',
  icon: [512, 512, [], "f856", "M224 448l224 0 0-224-48 0 0-64 112 0 0 352-352 0 0-112 64 0 0 48zM0 352L0 0 352 0 352 352 0 352z"]
};
var faDialLow = {
  prefix: 'fass',
  iconName: 'dial-low',
  icon: [576, 512, [], "e15d", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64-64 0 0-64zM287.6 447.6c-80.2 0-146.6-59-158.2-136l182.2 0 0-48-182.2 0c11.6-77 78-136 158.2-136 88.4 0 160 71.6 160 160s-71.6 160-160 160z"]
};
var faCircleWifiCircleWifi = {
  prefix: 'fass',
  iconName: 'circle-wifi-circle-wifi',
  icon: [640, 512, ["circle-wifi-group"], "e67e", "M288 512c16.7 0 33-1.6 48.8-4.6-20.7-30.6-32.8-67.6-32.8-107.4 0-1.4 0-2.9 0-4.3-4.7 2.7-10.2 4.3-16 4.3-17.7 0-32-14.3-32-32s14.3-32 32-32c9.3 0 17.7 4 23.6 10.4 4.8-16.5 11.8-32.2 20.6-46.5-13-7.5-28.1-11.9-44.1-11.9-30.4 0-57.3 15.4-73.1 38.9l-34.4-34.4c24.9-32 63.7-52.6 107.4-52.6 27.5 0 53 8.1 74.4 22.1 12.5-12.1 26.6-22.5 42-30.9-32.3-24.6-72.6-39.2-116.3-39.2-57.1 0-108.4 24.9-143.5 64.5l-34-34c43.9-48.2 107.2-78.5 177.5-78.5 65.2 0 124.4 26 167.6 68.2 13-2.8 26.5-4.2 40.4-4.2 15.3 0 30.2 1.8 44.4 5.2-20.4-121-125.6-213.2-252.4-213.2-141.4 0-256 114.6-256 256S146.6 512 288 512zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-31.5-20.4l-25.6 19.2C564.3 370.6 532.3 352 496 352s-68.3 18.6-86.9 46.8l-25.6-19.2c24.5-36 65.7-59.6 112.5-59.6s88.1 23.6 112.5 59.6zM496 384c26.2 0 49.4 12.6 64 32l-25.6 19.2C525.6 423.5 511.7 416 496 416s-29.6 7.5-38.4 19.2L432 416c14.6-19.4 37.8-32 64-32zm0 60a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"]
};
var faCircleWifiGroup = faCircleWifiCircleWifi;
var faDisplayMedical = {
  prefix: 'fass',
  iconName: 'display-medical',
  icon: [512, 512, ["desktop-medical"], "e166", "M64 96l0 256 384 0 0-256-384 0zM0 32l512 0 0 384-208 0 16 48 96 0 0 48-320 0 0-48 96 0 16-48-208 0 0-384zM224 136l64 0 0 56 56 0 0 64-56 0 0 56-64 0 0-56-56 0 0-64 56 0 0-56z"]
};
var faDesktopMedical = faDisplayMedical;
var faPersonMilitaryPointing = {
  prefix: 'fass',
  iconName: 'person-military-pointing',
  icon: [576, 512, [], "e54a", "M416.3 1.4l-192 16 0 48 192 0 0-64zm-176 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16l-156.8 0c-1 5.2-1.6 10.5-1.6 16zm-168 112l-40 0 0 80 192 0 0 89.4 169.4-169.4-321.4 0zM429 235.3l-182.1 182.1 169.4 0 0-46.3c41.2 69.8 65.9 111.5 73.9 125.1l68.9-40.7-20.4-34.4-104-176-5.7-9.7zM224.3 449.4l0 64 192 0 0-64-192 0z"]
};
var faDatabase = {
  prefix: 'fass',
  iconName: 'database',
  icon: [448, 512, [], "f1c0", "M0 80l128-80 192 0 128 80 0 48-128 80-192 0-128-80 0 0 0-48zM333.8 256l114.2-71.4 0 103.4-128 80-192 0-128-80 0 0 0-103.4 114.2 71.4 219.5 0zM0 344.6l114.2 71.4 219.5 0 114.2-71.4 0 87.4-128 80-192 0-128-80 0-87.4z"]
};
var faNewspaper = {
  prefix: 'fass',
  iconName: 'newspaper',
  icon: [512, 512, [128240], "f1ea", "M0 480l0-384 48 0 0 336 16 0c17.7 0 32-14.3 32-32l0-368 416 0 0 448-512 0zM160 96l0 128 128 0 0-128-128 0zM448 368l-288 0 0 48 288 0 0-48zM160 272l0 48 288 0 0-48-288 0zm288-96l-112 0 0 48 112 0 0-48z"]
};
var faCloudRain = {
  prefix: 'fass',
  iconName: 'cloud-rain',
  icon: [512, 512, [127783, 9926], "f73d", "M96 320l-96 0 0-96c0-41.8 26.7-77.4 64-90.5L64 112c0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-416 0zm8 64l35.9 71.8c2.7 5.4 4.1 11.3 4.1 17.4 0 21.4-17.4 38.8-38.8 38.8l-2.3 0c-21.4 0-38.8-17.4-38.8-38.8 0-6 1.4-12 4.1-17.4L104 384zm116.1 71.8L256 384 291.9 455.8c2.7 5.4 4.1 11.3 4.1 17.4 0 21.4-17.4 38.8-38.8 38.8l-2.3 0c-21.4 0-38.8-17.4-38.8-38.8 0-6 1.4-12 4.1-17.4zM408 384l35.9 71.8c2.7 5.4 4.1 11.3 4.1 17.4 0 21.4-17.4 38.8-38.8 38.8l-2.3 0c-21.4 0-38.8-17.4-38.8-38.8 0-6 1.4-12 4.1-17.4L408 384z"]
};
var faSignalStrong = {
  prefix: 'fass',
  iconName: 'signal-strong',
  icon: [512, 512, ["signal-4"], "f68f", "M384 152l0-24-48 0 0 352 48 0 0-328zM280 224l-48 0 0 256 48 0 0-256zM176 344l0-24-48 0 0 160 48 0 0-136zM72 408l0-24-48 0 0 96 48 0 0-72z"]
};
var faSignal4 = faSignalStrong;
var faMaximize = {
  prefix: 'fass',
  iconName: 'maximize',
  icon: [448, 512, ["expand-arrows-alt"], "f31e", "M0 32l0 200 72-72 96 96-96 96-72-72 0 200 200 0-72-72 96-96 96 96-72 72 200 0 0-200-72 72-96-96 96-96 72 72 0-200-200 0 72 72-96 96-96-96 72-72-200 0z"]
};
var faExpandArrowsAlt = faMaximize;
var faLocationArrow = {
  prefix: 'fass',
  iconName: 'location-arrow',
  icon: [576, 512, [], "f124", "M16 224L528 16 320 528 240 304 16 224z"]
};
var faCity = {
  prefix: 'fass',
  iconName: 'city',
  icon: [576, 512, [127961], "f64f", "M448 0l-192 0 0 96-48 0 0-96-48 0 0 96-64 0 0-96-48 0 0 96-48 0 0 416 576 0 0-320-128 0 0-192zM384 96l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zm64 0l64 0 0 64-64 0 0-64zm-192 0l0 64-64 0 0-64 64 0zm-64-96l64 0 0 64-64 0 0-64zM64 288l64 0 0 64-64 0 0-64zm0-32l0-64 64 0 0 64-64 0z"]
};
var faRectangleCode = {
  prefix: 'fass',
  iconName: 'rectangle-code',
  icon: [512, 512, [], "e322", "M0 64l512 0 0 384-512 0 0-384zM278.1 176c3.6 3.6 30.3 30.3 80 80-49.7 49.7-76.4 76.4-80 80l33.9 33.9 17-17 80-80 17-17-17-17c-63.8-63.8-96.2-96.2-97-97L278.1 176zM217 193l17-17-33.9-33.9c-.8 .8-33.1 33.1-97 97l-17 17c.8 .8 33.1 33.1 97 97l17 17 33.9-33.9c-3.6-3.6-30.3-30.3-80-80l63-63z"]
};
var faToiletPaperCheck = {
  prefix: 'fass',
  iconName: 'toilet-paper-check',
  icon: [512, 512, [], "e5b2", "M327.1 32c-8.8 11.1-16 23.1-21.9 34.8-21.4 42.7-33.2 98.4-33.2 157.2l0 320-272 0 0-320C0 118 43 32 96 32l231.1 0zM416 32c53 0 96 86 96 192s-43 192-96 192-96-86-96-192 43-192 96-192zM172.7 159.9l-59.3 81.6c-10.6-11-21.5-22.3-32.8-33.9L46.1 241c7.9 8.2 25.5 26.3 52.6 54.4L118.6 316c1.3-1.8 32.3-44.4 92.9-127.8l14.1-19.4-38.8-28.3-14.1 19.4zM416 160c-17.7 0-32 28.7-32 64s14.3 64 32 64 32-28.7 32-64-14.3-64-32-64z"]
};
var faSealQuestion = {
  prefix: 'fass',
  iconName: 'seal-question',
  icon: [512, 512, [], "e243", "M256 0l64 64 128 0 0 128 64 64-64 64 0 128-128 0-64 64-64-64-128 0 0-128-64-64 64-64 0-128 128 0 64-64zm0 181.2c17.7 0 32 14.3 32 32 0 26.9-28.8 31-49.9 34l-3.3 .5 0 53.5 42.4 0 0-18.3c30.4-10.6 53.2-36.1 53.2-69.6 0-41.1-33.3-74.4-74.4-74.4s-74.4 33.3-74.4 74.4l42.4 0c0-17.7 14.3-32 32-32zM232 328l0 48 48 0 0-48-48 0z"]
};
var faXRay = {
  prefix: 'fass',
  iconName: 'x-ray',
  icon: [512, 512, [], "f497", "M0 32l512 0 0 64-32 0 0 320 32 0 0 64-512 0 0-64 32 0 0-320-32 0 0-64zm280 88l0-24-48 0 0 40-88 0 0 48 88 0 0 48-104 0 0 48 104 0 0 48-88 0 0 48 88 0 0 40 48 0 0-40 88 0 0-48-88 0 0-48 104 0 0-48-104 0 0-48 88 0 0-48-88 0 0-16z"]
};
var faUmbrellaBeach = {
  prefix: 'fass',
  iconName: 'umbrella-beach',
  icon: [512, 512, [127958], "f5ca", "M512 256c0 41.2-9.7 80.1-27 114.5l-206.8-103.4-1.6 3.2-88.8 177.7 324.2 0 0 64-512 0 0-64 116.2 0 103.2-206.3 1.6-3.2-194-97C69 57.6 155.8 0 256 0 397.4 0 512 114.6 512 256z"]
};
var faArrowRightToBracket = {
  prefix: 'fass',
  iconName: 'arrow-right-to-bracket',
  icon: [512, 512, ["sign-in"], "f090", "M352 96l96 0 0 320-128 0 0 64 192 0 0-448-192 0 0 64 32 0zm-9.4 182.6l22.6-22.6-22.6-22.6-128-128-22.6-22.6-45.3 45.3 96 96-242.7 0 0 64 242.7 0c-57.4 57.4-89.4 89.4-96 96L192 429.3 342.6 278.6z"]
};
var faSignIn = faArrowRightToBracket;
var faHeadset = {
  prefix: 'fass',
  iconName: 'headset',
  icon: [448, 512, [], "f590", "M224 64C135.6 64 64 135.6 64 224l96 0 0 160-64 0c-53 0-96-43-96-96l0-64C0 100.3 100.3 0 224 0S448 100.3 448 224l0 288.1-24 0c-140-.1-228-.1-264-.1l0-48c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 0 112 .1 0-92.9c-14.1 8.2-30.5 12.8-48 12.8l-64 0 0-160 96 0c0-88.4-71.6-160-160-160z"]
};
var faThumbtackAngleSlash = {
  prefix: 'fass',
  iconName: 'thumbtack-angle-slash',
  icon: [576, 512, [], "e752", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-179-179 96.3-112.4c5.3 5.3 16.4 16.4 33.5 33.5L557.4 192 374.8 9.4 352.1-13.3 306.9 32c17 17 28.2 28.2 33.5 33.5L228 161.8 49.3-16.9zm57.5 193.3c-15.4 8.5-29.9 19.3-42.9 32.4L335.3 480.3c13.1-13.1 23.9-27.5 32.4-42.9L106.7 176.4zM41.5 457.4L18.9 480 64.1 525.3c1.9-1.9 43.3-43.3 124.1-124.1L143 355.9 41.5 457.4z"]
};
var faCameraPolaroid = {
  prefix: 'fass',
  iconName: 'camera-polaroid',
  icon: [576, 512, [], "f8aa", "M64 32l448 0 0 214.3 58.6 87.9 5.4 8.1 0 137.7-576 0 0-137.7 5.4-8.1 58.6-87.9 0-214.3zM288 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM384 96l0 64 64 0 0-64-64 0zM120 352l-24 0 0 48 384 0 0-48-360 0z"]
};
var faFaceSaluting = {
  prefix: 'fass',
  iconName: 'face-saluting',
  icon: [640, 512, [129761], "e484", "M253.4-16l-22.6 22.6-128.5 128.5 26.2 27.3c30.5-30.5 51.7-51.7 63.7-63.7L237.4 144c-9.8 9.8-35.4 35.4-76.7 76.7-31.2 31.2-81.9 31.2-113.1 0l-4.1-4.1c-31.2-31.2-31.2-81.9 0-113.1L185.5-38.6 208.1-61.3 253.4-16zm98.7 528c-129.2 0-236-95.7-253.5-220 34.6 1.5 69.6-11 96-37.4l45.5-45.5c.6 17.2 14.7 30.9 32 30.9 17.7 0 32-14.3 32-32 0-17.3-13.7-31.4-30.9-32l32-32c-21.9-21.9-45.9-45.9-72-72 51.7-51.7 60.8-60.8 66.7-66.7 16.8-3.5 34.3-5.3 52.2-5.3 141.4 0 256 114.6 256 256s-114.6 256-256 256zm0-144c-38.2 0-72-19.1-92.2-48.5l-39.5 27.3c28.8 41.8 77.1 69.2 131.7 69.2S455 388.6 483.9 346.8l-39.5-27.3c-20.2 29.3-54 48.5-92.2 48.5zm80-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faHandHorns = {
  prefix: 'fass',
  iconName: 'hand-horns',
  icon: [384, 512, [], "e1a9", "M32 0l64 0 0 240-64 0 0-240zM224 160l64 0 0 128-64 0 0-128zm-32-32l0 112-64 0 0-112 64 0zM320 64l64 0 0 288c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363l0-91 192 0 0 80-112 0 0 32 144 0 0-64 96 0 0-256z"]
};
var faFileExclamation = {
  prefix: 'fass',
  iconName: 'file-exclamation',
  icon: [384, 512, [], "f31a", "M384 144L384 512 0 512 0 0 240 0 384 144zM164 404l0 56 56 0 0-56-56 0zm-4-180l12.8 144 38.4 0 12.8-144-64 0zm48-48L325.5 176 208 58.5 208 176z"]
};
var faHeadSideCircuit = {
  prefix: 'fass',
  iconName: 'head-side-circuit',
  icon: [512, 512, [], "e75e", "M67.5 63.8C25.8 104.4 0 161.2 0 224 0 285 24.4 340.4 64 380.8l0 131.2 256 0 0-64 112 0 0-128 64 0 0-64-49.7-59.6c-6.4-51.7-30.4-98-65.8-132.6l-40.5 40.5 0 53.1c12 6.9 20 19.8 20 34.6 0 22.1-17.9 40-40 40s-40-17.9-40-40c0-14.8 8-27.7 20-34.6l0-69.6 5.9-5.9 43.5-43.5C318.8 17.6 282.8 4.3 244 .9l0 92.5c12 6.9 20 19.8 20 34.6 0 22.1-17.9 40-40 40s-40-17.9-40-40c0-14.8 8-27.7 20-34.6L204 .9C165.2 4.3 129.2 17.6 98.6 38.3l43.5 43.5 5.9 5.9 0 69.6c12 6.9 20 19.8 20 34.6 0 22.1-17.9 40-40 40s-40-17.9-40-40c0-14.8 8-27.7 20-34.6l0-53.1-40.5-40.5zM184 256a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faPipeCircleCheck = {
  prefix: 'fass',
  iconName: 'pipe-circle-check',
  icon: [576, 512, [], "e436", "M96 96l0 32 384 0 0-32 64 0 0 148c-31.5-22.7-70.2-36-112-36-100.6 0-183.2 77.4-191.3 176l-144.7 0 0 32-64 0 0-320 64 0zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.4-51.5l-25.9-18.8-9.4 12.9-53 72.9C393.7 395 381 382.3 376 377.4L353.4 400c2.8 2.8 19.9 19.9 51.3 51.3l13.2 13.2 11-15.1 64-88 9.4-12.9z"]
};
var faSplotch = {
  prefix: 'fass',
  iconName: 'splotch',
  icon: [512, 512, [], "f5bc", "M256 0l80 0 30.9 103c10.8 35.9 37.7 64.7 72.8 77.9l72.3 27.1 0 64-73.2 54.9c-34 25.5-52 67-47.3 109.3l8.4 75.9-96 0-73.3-58.6c-4.5-3.6-9.3-6.7-14.5-9.2-15.8-7.9-33.7-10.4-51-7.3L16 464 16 376 40.3 346.9c14.6-17.4 22.6-39.4 22.6-62.1 0-18.8-5.5-37.2-15.8-53L0 160 0 80 101.1 97.2c44 7.5 88.5-10.1 115.5-45.5L256 0z"]
};
var faSquareShekel = {
  prefix: 'fass',
  iconName: 'square-shekel',
  icon: [448, 512, [], "e735", "M448 32l-448 0 0 448 448 0 0-448zM352 160l0 144c0 39.8-32.2 72-72 72l-112 0c0-2.7 0-45.3 0-128l0-24 48 0c0 6.7 0 41.3 0 104l64 0c13.3 0 24-10.7 24-24l0-168 48 0 0 24zM120 136l88 0c39.8 0 72 32.2 72 72l0 80-48 0 0-80c0-13.3-10.7-24-24-24l-64 0 0 192-48 0 0-240 24 0z"]
};
var faUpLong = {
  prefix: 'fass',
  iconName: 'up-long',
  icon: [384, 512, ["long-arrow-alt-up"], "f30c", "M192-32l-192 192 128 0 0 384 128 0 0-384 128 0-192-192z"]
};
var faLongArrowAltUp = faUpLong;
var faFaceUnamused = {
  prefix: 'fass',
  iconName: 'face-unamused',
  icon: [512, 512, [], "e39f", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-63.7-89.6l-42.4-22.5C170 361.9 210 336 256 336s86 25.9 106.1 63.9l-42.4 22.5C307.6 399.5 283.6 384 256 384s-51.6 15.5-63.7 38.4zM120 192l64 0c22.1 0 40 17.9 40 40s-17.9 40-40 40c-19.4 0-35.5-13.7-39.2-32l-48.8 0 0-48 24 0zm168 0l88 0c22.1 0 40 17.9 40 40s-17.9 40-40 40c-19.4 0-35.5-13.7-39.2-32l-48.8 0 0-48z"]
};
var faCircleIndianRupee = {
  prefix: 'fass',
  iconName: 'circle-indian-rupee',
  icon: [512, 512, [], "e734", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM184 120l168 0 0 32-60.1 0c9.3 11.3 15.9 25 18.7 40l41.4 0 0 32-41.4 0c-6.1 33-30.5 59.5-62.3 68.6 55.9 44.7 85.7 68.6 89.5 71.6l-30 37.5-18.7-15-112-89.6-9-7.2 0-41.9 56 0c16.4 0 30.5-9.9 36.7-24l-100.7 0 0-32 100.7 0c-6.2-14.1-20.3-24-36.7-24l-64 0 0-48 24 0z"]
};
var faSpinnerScale = {
  prefix: 'fass',
  iconName: 'spinner-scale',
  icon: [448, 512, [], "e62a", "M276 12l0 52c0 28.7-23.3 52-52 52s-52-23.3-52-52l0-52 104 0zM224 416c17.7 0 32 14.3 32 32l0 32-64 0 0-32c0-17.7 14.3-32 32-32zM448 288l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0 64zM64 256c0 17.7-14.3 32-32 32l-32 0 0-64 32 0c17.7 0 32 14.3 32 32zM359.8 41l79.2 79.2-39.6 39.6c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2L359.8 41zM110.9 369.1c12.5 12.5 12.5 32.8 0 45.3L88.2 437 43 391.8 65.6 369.1c12.5-12.5 32.8-12.5 45.3 0zM359.8 437l-22.6-22.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L405 391.8 359.8 437zM122.2 154.2c-18.7 18.7-49.1 18.7-67.9 0l-33.9-33.9 67.9-67.9 33.9 33.9c18.7 18.7 18.7 49.1 0 67.9z"]
};
var faHexagonNodes = {
  prefix: 'fass',
  iconName: 'hexagon-nodes',
  icon: [448, 512, [], "e699", "M280 56c0 22.3-13.1 41.6-32 50.6l0 98.8c3.4 1.6 6.6 3.6 9.6 5.8L280 224l0 32 0 4.4 80 45.7c2.6-1.8 5.2-3.3 8-4.6l0-90.8c-2.8-1.3-5.5-2.9-8-4.7l-48 27.4 0-9.4 0-18.6-16.1-9.2-7.8-4.5 48.1-27.5c-1.6-20.8 8.6-41.6 27.8-52.8c26.8-15.5 61-6.3 76.5 20.5s6.3 61-20.5 76.5c-1.3 .8-2.7 1.5-4 2.1l0 90.8c1.4 .6 2.7 1.3 4 2.1c26.8 15.5 36 49.7 20.5 76.5s-49.7 36-76.5 20.5c-19.3-11.1-29.4-32-27.8-52.8L256 301.9c-2.5 1.8-5.2 3.3-8 4.7l0 98.8c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6l0-98.8c-3.4-1.6-6.6-3.6-9.6-5.8L168 288l0-32 0-4.4L88 206c-2.6 1.8-5.3 3.3-8 4.7l0 90.8c2.8 1.3 5.5 2.9 8 4.7l48-27.4 0 9.4 0 18.6 16.1 9.2 7.8 4.5-48.1 27.5c1.6 20.8-8.6 41.7-27.8 52.8C57.2 416 23 406.8 7.5 380S1.2 319 28 303.5c1.3-.8 2.6-1.5 4-2.1l0-90.8c-1.3-.6-2.7-1.3-4-2.1C1.2 193-8 158.8 7.5 132S57.2 96 84 111.5c19.3 11.1 29.4 32 27.9 52.8L192 210.1c2.5-1.8 5.2-3.3 8-4.7l0-98.8c-18.9-9-32-28.3-32-50.6c0-30.9 25.1-56 56-56s56 25.1 56 56z"]
};
var faHospital = {
  prefix: 'fass',
  iconName: 'hospital',
  icon: [576, 512, [127973, 62589, "hospital-alt", "hospital-wide"], "f0f8", "M128 0l320 0 0 128 128 0 0 384-576 0 0-384 128 0 0-128zM336 352l-96 0 0 112 96 0 0-112zM128 384l0-64-64 0 0 64 64 0zM64 256l64 0 0-64-64 0 0 64zM512 384l0-64-64 0 0 64 64 0zM448 256l64 0 0-64-64 0 0 64zM264 96l0 48-48 0 0 48 48 0 0 48 48 0 0-48 48 0 0-48-48 0 0-48-48 0z"]
};
var faHospitalAlt = faHospital;
var faHospitalWide = faHospital;
var faFaceRelieved = {
  prefix: 'fass',
  iconName: 'face-relieved',
  icon: [512, 512, [], "e389", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm68-248c0 11 9 20 20 20l16 0c11 0 20-9 20-20l0-16 40 0 0 16c0 33.1-26.9 60-60 60l-16 0c-33.1 0-60-26.9-60-60l0-16 40 0 0 16zM152 284l16 0c11 0 20-9 20-20l0-16 40 0 0 16c0 33.1-26.9 60-60 60l-16 0c-33.1 0-60-26.9-60-60l0-16 40 0 0 16c0 11 9 20 20 20zm40.3 77.6C204.4 384.5 228.4 400 256 400s51.6-15.5 63.7-38.4l42.4 22.5C342 422.1 302 448 256 448s-86-25.9-106.1-63.9l42.4-22.5zm6-230.7l-6.3 2.1c-22.8 7.6-42.4 22.6-55.7 42.6l-7.6 11.5-33.3-22.2 7.6-11.5c18.3-27.4 45.1-47.9 76.3-58.3l6.3-2.1 12.6 37.9zM320 133.1l-6.3-2.1 12.6-37.9 6.3 2.1c31.2 10.4 58.1 30.9 76.3 58.3l7.6 11.5-33.3 22.2-7.6-11.5c-13.3-20-32.9-35-55.7-42.6z"]
};
var faSquarePeruvianSoles = {
  prefix: 'fass',
  iconName: 'square-peruvian-soles',
  icon: [448, 512, [], "e716", "M448 480l-448 0 0-448 448 0 0 448zM315.6 128l-70.7 247.4-2.5 8.6 49.9 0 70.7-247.4 2.5-8.6-49.9 0zM159.6 152c-35.1 0-63.6 28.5-63.6 63.6 0 30.3 21.4 56.4 51.1 62.3l16.4 3.3c7.3 1.5 12.5 7.8 12.5 15.3 0 8.6-7 15.6-15.6 15.6l-56.4 0 0 48 56.4 0c35.1 0 63.6-28.5 63.6-63.6 0-30.3-21.4-56.4-51.1-62.3l-16.4-3.3c-7.3-1.5-12.5-7.8-12.5-15.2 0-8.6 7-15.6 15.6-15.6l48.4 0 0-48-48.4 0z"]
};
var faCommentSmile = {
  prefix: 'fass',
  iconName: 'comment-smile',
  icon: [512, 512, [], "f4b4", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM166.6 280l-35.8 32c30.7 34.3 75.5 56 125.2 56s94.5-21.7 125.2-56l-35.8-32c-22 24.6-53.9 40-89.4 40s-67.4-15.4-89.4-40z"]
};
var faFolderCheck = {
  prefix: 'fass',
  iconName: 'folder-check',
  icon: [512, 512, [], "e64e", "M224 32l64 48 224 0 0 368-512 0 0-416 224 0zm89.4 161.9L227.8 311.6c-19.3-20-33.7-34.9-43.2-44.7l-34.5 33.3c6.2 6.4 27.2 28.1 63.1 65.3l19.8 20.6 16.8-23.1 102.4-140.8 14.1-19.4-38.8-28.2-14.1 19.4z"]
};
var faCurrencySign = {
  prefix: 'fass',
  iconName: 'currency-sign',
  icon: [448, 512, [], "e72b", "M49.4 47L32.4 30.1-1.5 64c4.6 4.6 29.4 29.4 74.3 74.3-25.3 32.5-40.3 73.4-40.3 117.7s15 85.2 40.3 117.7C27.8 418.7 3.1 443.4-1.5 448l33.9 33.9c4.6-4.6 29.4-29.4 74.3-74.3 32.5 25.3 73.4 40.3 117.7 40.3s85.2-15 117.7-40.3c44.9 44.9 69.7 69.7 74.3 74.3L450.4 448c-4.6-4.6-29.4-29.4-74.3-74.3 25.3-32.5 40.3-73.4 40.3-117.7s-15-85.2-40.3-117.7C421 93.3 445.8 68.6 450.4 64L416.4 30.1c-4.6 4.6-29.4 29.4-74.3 74.3-32.5-25.3-73.4-40.3-117.7-40.3s-85.2 15-117.7 40.3L49.4 47zM95.6 256a128.4 128.4 0 1 1 256.9 0 128.4 128.4 0 1 1 -256.9 0z"]
};
var faChartUser = {
  prefix: 'fass',
  iconName: 'chart-user',
  icon: [640, 512, ["user-chart"], "f6a3", "M128 32l480 0 0 416-295.6 0-52.9-120.8c8-16.7 12.5-35.4 12.5-55.2 0-70.7-57.3-128-128-128-5.4 0-10.8 .3-16 1l0-113zM446.1 160L368 238.1c-23-23-39-39-48-48L286.1 224c6.1 6.1 27.8 27.8 65 65l17 17 17-17 95-95 0 54.1 48 0 0-136-136 0 0 48 54.1 0zM64 272a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM56 384l176 0 56 128-288 0 56-128z"]
};
var faUserChart = faChartUser;
var faPersonHarassing = {
  prefix: 'fass',
  iconName: 'person-harassing',
  icon: [576, 512, [], "e549", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5l28.6-47.5 0 255.1 64 0 0-160 16 0 0 160 64 0 0-276.4 60.1 72.8 49.3-40.8-105.7-128-9.6-11.6-135.3 0-9.3 15.5-76.9 128 54.9 33zM480 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm18.7 48l-34.7 34.7 0 80-41.4-41.4-49.8 5.7c-37.2 59.5-58.8 94.1-65 103.9l54.3 33.9c9.7-15.5 24.2-38.8 43.6-69.8l57.6 57.6c12.4 12.4 29.1 19.3 46.6 19.3 36.4 0 65.9-29.5 65.9-65.9l0-158.1-77.3 0zM288 32l0 32 88 0 0-32-88 0zm-.8 65.7l-14.3-7.2-14.3 28.6c3.9 2 24.7 12.4 62.3 31.2l14.3 7.2 14.3-28.6c-3.9-2-24.7-12.4-62.3-31.2z"]
};
var faFlatbread = {
  prefix: 'fass',
  iconName: 'flatbread',
  icon: [512, 512, [129747], "e40b", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM177 369L143 335 335 143 369 177 177 369zm64-224L145 241 111 207 207 111 241 145zm64 256L271 367 367 271 401 305 305 401z"]
};
var faCircleMicrophoneLines = {
  prefix: 'fass',
  iconName: 'circle-microphone-lines',
  icon: [512, 512, ["microphone-circle-alt"], "e117", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM208 240l0-128 96 0 0 32-48 0 0 32 48 0 0 32-48 0 0 32 48 0c0 26.5-21.5 48-48 48s-48-21.5-48-48zm-48-32l0 32c0 53 43 96 96 96s96-43 96-96l0-32 48 0 0 32c0 71.4-51.9 130.6-120 142l0 42-48 0 0-42c-68.1-11.4-120-70.7-120-142l0-32 48 0z"]
};
var faMicrophoneCircleAlt = faCircleMicrophoneLines;
var faMoneyBillTrendUp = {
  prefix: 'fass',
  iconName: 'money-bill-trend-up',
  icon: [512, 512, [], "e529", "M480 8l0 125.8-48 0 0-67.9-127 127-15.7 15.7-16.9-14.5-96.4-82.6-96.4 82.6-18.2 15.6-31.2-36.4 18.2-15.6 112-96 15.6-13.4 15.6 13.4 95.1 81.5 111.3-111.3-67.9 0 0-48 149.8 0 0 24zM0 256l512 0 0 256-512 0 0-256zM48 416l0 48 48 0c0-26.5-21.5-48-48-48zM96 304l-48 0 0 48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48l48 0 0-48zM416 304c0 26.5 21.5 48 48 48l0-48-48 0zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faPenRuler = {
  prefix: 'fass',
  iconName: 'pen-ruler',
  icon: [576, 512, ["pencil-ruler"], "f5ae", "M254.4 77.8L222.5 45.9c-44.6 44.6-68 68-70.4 70.4L123.8 88c2.4-2.4 25.9-25.9 70.4-70.4-.2-.2-11.6-11.6-34.1-34.1-8.9 8.9-47.7 47.7-116.3 116.3L15.5 128c12.6 12.6 44 44 94.3 94.3L254.4 77.8zm67.3 356.4c50.3 50.3 81.8 81.8 94.3 94.3l144.6-144.6-28.3-28.3-5.9-5.9c-44.6 44.5-68 68-70.4 70.4L427.8 392c2.4-2.4 25.9-25.9 70.4-70.4l-31.9-31.9-144.6 144.6zM72.1 328l-56 200 200-56 223-223-144-144-223 223zm488-200l-144-144-87 87 144 144 87-87z"]
};
var faPencilRuler = faPenRuler;
var faBracketsSquare = {
  prefix: 'fass',
  iconName: 'brackets-square',
  icon: [448, 512, ["brackets"], "f7e9", "M416 32l32 0 0 448-160 0 0-64 96 0 0-320-96 0 0-64 128 0zM32 32l128 0 0 64-96 0 0 320 96 0 0 64-160 0 0-448 32 0z"]
};
var faBrackets = faBracketsSquare;
var faPersonDressSimple = {
  prefix: 'fass',
  iconName: 'person-dress-simple',
  icon: [256, 512, [], "e21c", "M64 64A64 64 0 1 1 192 64 64 64 0 1 1 64 64zm128 96l64 224-64 0 0 128-128 0 0-128-64 0 64-224 128 0z"]
};
var faTrainSubwayTunnel = {
  prefix: 'fass',
  iconName: 'train-subway-tunnel',
  icon: [512, 512, ["subway-tunnel"], "e2a3", "M256 0C114.6 0 0 114.6 0 256l0 256 94.1 0 64-64-46.1 0 0-320 288 0 0 320-46.1 0 64 64 94.1 0 0-256C512 114.6 397.4 0 256 0zm94.1 512l-64-64-60.1 0-64 64 188.1 0zM280 320l72 0 0-128-72 0 0 128zM232 192l-72 0 0 128 72 0 0-128zM184 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSubwayTunnel = faTrainSubwayTunnel;
var faRepeat = {
  prefix: 'fass',
  iconName: 'repeat',
  icon: [512, 512, [128257], "f363", "M352 208l0-80-288 0 0 160-64 0 0-224 352 0 0-80 24 0 112 112-112 112-24 0zM160 448l0 80-24 0-112-112 112-112 24 0 0 80 288 0 0-160 64 0 0 224-352 0z"]
};
var faBottleBaby = {
  prefix: 'fass',
  iconName: 'bottle-baby',
  icon: [320, 512, [], "e673", "M96 64l0-32 32-16 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 32 16 0 32 32 0 0 48-192 0 0-48 32 0zM16 224l48-64 192 0 48 64 0 320-288 0 0-96 112 0 0-48-112 0 0-64 112 0 0-48-112 0 0-64z"]
};
var faBone = {
  prefix: 'fass',
  iconName: 'bone',
  icon: [640, 512, [129460], "f5d7", "M190.7 160c-7.6-45.4-47.1-80-94.7-80-53 0-96 43-96 96 0 33.4 17 62.8 42.9 80-25.9 17.2-42.9 46.6-42.9 80 0 53 43 96 96 96 47.6 0 87.1-34.6 94.7-80l258.7 0c7.6 45.4 47.1 80 94.7 80 53 0 96-43 96-96 0-33.4-17-62.8-42.9-80 25.9-17.2 42.9-46.6 42.9-80 0-53-43-96-96-96-47.6 0-87.1 34.6-94.7 80l-258.7 0z"]
};
var faRightLeftLarge = {
  prefix: 'fass',
  iconName: 'right-left-large',
  icon: [640, 512, [], "e5e1", "M256.3 176l0-71.9c-17.8 16.1-89 80.1-213.4 192.1L16.5 320 42.9 343.8c124.4 112 195.6 176 213.4 192.1l0-119.9 64 0 0-64-128 0 0 40.1-80.2-72.1 80.2-72.1 0 40.1 192 0 0 119.9c17.8-16.1 89-80.1 213.4-192.1l26.4-23.8-26.4-23.8C473.3 56.2 402.2-7.8 384.3-23.9l0 119.9-64 0 0 64 128 0 0-40.1 80.2 72.1-80.2 72.1 0-40.1-192 0 0-48z"]
};
var faStrawberry = {
  prefix: 'fass',
  iconName: 'strawberry',
  icon: [576, 512, [], "e32b", "M408-24L431.4-.6c31.2 31.2 31.2 81.9 0 113.1 31.2-31.2 81.9-31.2 113.1 0L568 136 544.6 159.4c-31.2 31.2-81.9 31.2-113.1 0-15.6-15.6-31.2-31.2-46.9-46.9-31.2-31.2-31.2-81.9 0-113.1L408-24zM32 336c0-176 96.2-272 192.2-272 32.7 .1 65.3 12.6 90.3 37.5l128 128c25 25 37.5 57.8 37.5 90.5 0 96-96 192-272 192l-176 0 0-176zM214.4 137.6c2.8 28.8-16 47.6-44.8 44.8-2.8-28.8 16-47.6 44.8-44.8zm-32 96c2.8 28.8-16 47.6-44.8 44.8-2.8-28.8 16-47.6 44.8-44.8zm64 64c2.8 28.8-16 47.6-44.8 44.8-2.8-28.8 16-47.6 44.8-44.8zm64 64c2.8 28.8-16 47.6-44.8 44.8-2.8-28.8 16-47.6 44.8-44.8zm-160-32c2.8 28.8-16 47.6-44.8 44.8-2.8-28.8 16-47.6 44.8-44.8zm64 64c2.8 28.8-16 47.6-44.8 44.8-2.8-28.8 16-47.6 44.8-44.8zm64-192c2.8 28.8-16 47.6-44.8 44.8-2.8-28.8 16-47.6 44.8-44.8zm64 64c2.8 28.8-16 47.6-44.8 44.8-2.8-28.8 16-47.6 44.8-44.8zm64 64c2.8 28.8-16 47.6-44.8 44.8-2.8-28.8 16-47.6 44.8-44.8z"]
};
var faSquareBolt = {
  prefix: 'fass',
  iconName: 'square-bolt',
  icon: [448, 512, [], "e265", "M448 32l-448 0 0 448 448 0 0-448zM88 272l200-168-32.4 136 104.4 0-200 168 32.4-136-104.4 0z"]
};
var faFireFlameCurved = {
  prefix: 'fass',
  iconName: 'fire-flame-curved',
  icon: [384, 512, ["fire-alt"], "f7e4", "M168.3 31.8L208 0 208 43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7 384 434 306 512 209.7 512l-29.9 0C80.5 512 0 431.5 0 332.2 0 274.6 28.8 220.8 76.7 188.9L96 176 96 288c0 35.3 28.7 64 64 64s64-28.7 64-64l0-3.9c0-18-7.2-35.3-19.9-48l-44.7-44.7c-20.1-20.1-31.4-47.4-31.4-75.9 0-32.6 14.8-63.4 40.3-83.8z"]
};
var faFireAlt = faFireFlameCurved;
var faSignatureSlash = {
  prefix: 'fass',
  iconName: 'signature-slash',
  icon: [640, 512, [], "e3cb", "M81.2-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-1-1-33-33-96.1-96.1l126 0 0-48-174 0-48-48 158 0 0-64-115.6 0c11.7-35.2 24.2-72.6 37.5-112.4-28.8 8.6-89.3 26.8-181.4 54.4 2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96-26 0-49.6 10.3-66.9 27.1l-76-76zM202.4 104.4c5.7-5.2 13.3-8.4 21.6-8.4 17.7 0 32 14.3 32 32l0 7.8c0 7.2-.2 14.5-.5 21.7l-53.1-53.1zM352.2 254.2l46-13.8-12.5 37.5-2.4 7.3-31-31zm26 161.8l-48-48-7.1 0c-6.5 16.3-13.7 32.3-21.6 48l76.7 0zM196.3 234.1c-60.8 18.2-94.2 28.3-100.3 30.1l0 103.8-96 0 0 48 96 0 0 64 114.6 0c3.4-6 15-26.3 34.8-60.8 17.1-29.9 31.2-61.2 42.3-93.7l-91.4-91.4zm35.6 56.2c-10.4 33.8-24.5 66.4-42.1 97.2l-16.3 28.6-13.4 0 0-104.2 71.8-21.5z"]
};
var faBusSimple = {
  prefix: 'fass',
  iconName: 'bus-simple',
  icon: [448, 512, ["bus-alt"], "f55e", "M448 0l-448 0 0 448 32 0 0 64 96 0 0-64 192 0 0 64 96 0 0-64 32 0 0-448zM64 96l320 0 0 160-320 0 0-160zM96 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBusAlt = faBusSimple;
var faSquarePeseta = {
  prefix: 'fass',
  iconName: 'square-peseta',
  icon: [448, 512, [], "e6ea", "M448 32l-448 0 0 448 448 0 0-448zM144 120l88 0c52 0 95.1 38.2 102.8 88l25.2 0 0 32-25.2 0c-7.7 49.8-50.8 88-102.8 88l-40 0 0 64-48 0 0-152-24 0 0-32 24 0 0-88zm88 48l-40 0 0 40 93.7 0c-6.9-23.1-28.3-40-53.7-40zM192 280l40 0c25.4 0 46.8-16.9 53.7-40l-93.7 0 0 40z"]
};
var faTankWater = {
  prefix: 'fass',
  iconName: 'tank-water',
  icon: [448, 512, [], "e452", "M224 0l60.2 93.7c7.7 12 11.8 25.9 11.8 40.1l0 2.2c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-2.2c0-14.2 4.1-28.2 11.8-40.1L224 0zM64 32l82.4 0-23 35.7C117.7 76.6 113.2 86.1 110 96l-46 0 0 174.2c24.4-9.8 37.8-15.1 40-16l8.9 3.6 111.1 44.4 111.1-44.4 8.9-3.6c2.2 .9 15.6 6.2 40 16l0-174.1-46 0c-3.2-9.9-7.7-19.4-13.4-28.3l-23-35.7 146.4 0 0 448-448 0 0-448 64 0z"]
};
var faUserShakespeare = {
  prefix: 'fass',
  iconName: 'user-shakespeare',
  icon: [448, 512, [], "e2c2", "M304 144c0 38.7-27.5 71-64 78.4l0-22.4-32 0 0 22.4c-36.5-7.4-64-39.7-64-78.4l0-16c0-44.2 35.8-80 80-80s80 35.8 80 80l0 16zM224 0C153.3 0 96 57.3 96 128l0 24-32 56 0 48 98 0c18.4 10.2 39.5 16 62 16s43.6-5.8 62-16l98 0 0-48-32-56 0-24C352 57.3 294.7 0 224 0zm7.2 137.7l-7.2-3.6c-.6 .3-13.7 6.8-39.2 19.6l-14.3 7.2 14.3 28.6c7.8-3.9 20.8-10.4 39.2-19.6 18.3 9.2 31.4 15.7 39.2 19.6l14.3-28.6-46.3-23.2zM64 320l-64 192 200 0 0-128 48 0 0 128 200 0-64-192-32 0 0-16-54.6 0c-22.3 10.3-47.2 16-73.4 16s-51.1-5.7-73.4-16l-54.6 0 0 16-32 0z"]
};
var faVenusMars = {
  prefix: 'fass',
  iconName: 'venus-mars',
  icon: [640, 512, [9892], "f228", "M480-64l-32 0 0 64 82.7 0-56.7 56.7c-26.3-15.7-57.1-24.7-90-24.7-35.4 0-68.4 10.5-96 28.5-27.6-18-60.6-28.5-96-28.5-97.2 0-176 78.8-176 176 0 86.3 62.1 158.1 144 173.1l0 34.9-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-34.9c23.3-4.3 44.9-13.1 64-25.6 27.6 18 60.6 28.5 96 28.5 97.2 0 176-78.8 176-176 0-41.1-14.1-79-37.8-109l53.8-53.8 0 82.7 64 0 0-192-160 0zM336 309.2c20.2-28.6 32-63.5 32-101.2s-11.8-72.6-32-101.2c14.6-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112S445.9 320 384 320c-17.2 0-33.5-3.9-48-10.8zM288 150.3c10.2 16.9 16 36.6 16 57.7s-5.8 40.9-16 57.7c-10.2-16.9-16-36.6-16-57.7s5.8-40.9 16-57.7zm-48-43.5c-20.2 28.6-32 63.5-32 101.2s11.8 72.6 32 101.2c-14.5 6.9-30.8 10.8-48 10.8-61.9 0-112-50.1-112-112S130.1 96 192 96c17.2 0 33.5 3.9 48 10.8z"]
};
var faKazoo = {
  prefix: 'fass',
  iconName: 'kazoo',
  icon: [640, 512, [], "f8c7", "M448.2-45.3l22.6 22.6 128 128 22.6 22.6c-2.8 2.8-42.5 42.5-119 119-9.9 65.6-61.7 117.4-127.3 127.3l-48.3 48.3-2.8 2.8-3.4 2-160 96-21.4 12.9c-4.1-4.1-31.3-31.3-81.7-81.7l-17.7-17.7 12.9-21.4 96-160 2-3.4 2.8-2.8 48.4-48.4c9.9-65.5 61.7-117.3 127.3-127.3 76.5-76.5 116.2-116.2 119-119zM352.3 328a104 104 0 1 0 0-208 104 104 0 1 0 0 208zm20-149.2l0 25.3 45.3 0 0 40-45.3 0 0 45.3-40 0 0-45.3-45.3 0 0-40 45.3 0 0-45.3 40 0 0 20z"]
};
var faDiagramSubtask = {
  prefix: 'fass',
  iconName: 'diagram-subtask',
  icon: [448, 512, [], "e479", "M0 32l448 0 0 192-320 0 0 128 64 0 0-64 256 0 0 192-256 0 0-64-128 0 0-192-64 0 0-192z"]
};
var faArrowsFromDottedLine = {
  prefix: 'fass',
  iconName: 'arrows-from-dotted-line',
  icon: [384, 512, [], "e0a3", "M80 96l112-128 112 128-80 0 0 80-64 0 0-80-80 0zm0 320l80 0 0-80 64 0 0 80 80 0-112 128-112-128zM0 224l64 0 0 64-64 0 0-64zm170.7 0l0 64-64 0 0-64 64 0zm42.7 0l64 0 0 64-64 0 0-64zM384 224l0 64-64 0 0-64 64 0z"]
};
var faGripDots = {
  prefix: 'fass',
  iconName: 'grip-dots',
  icon: [512, 512, [], "e410", "M64 224a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM256 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm192 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM256 416a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM64 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faBlender = {
  prefix: 'fass',
  iconName: 'blender',
  icon: [512, 512, [], "f517", "M0 0l480 0-22.9 80-137.1 0 0 48 123.4 0-18.3 64-105.1 0 0 48 91.4 0-27.4 96-256 0-9.1-96-118.9 0 0-240zM114.3 192l-13.7-144-52.6 0 0 144 66.3 0zM416 384l0 128-320 0 0-128 320 0zM256 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faU = {
  prefix: 'fass',
  iconName: 'u',
  icon: [384, 512, [117], "55", "M64 32l0 256c0 70.7 57.3 128 128 128s128-57.3 128-128l0-256 64 0 0 256c0 106-86 192-192 192S0 394 0 288L0 32 64 32z"]
};
var faBoxHeart = {
  prefix: 'fass',
  iconName: 'box-heart',
  icon: [448, 512, [], "f49d", "M369.4 128l-121.4 0 0-48 87.1 0 34.3 48zM200 128l-121.4 0 34.3-48 87.1 0 0 48zM368 16l-288 0-80 112 0 352 448 0 0-352-80-112zM217.6 231.5l6.4 8.5 6.4-8.5c11.1-14.8 28.5-23.5 46.9-23.5 32.4 0 58.7 26.3 58.7 58.7l0 5.3c0 64-112 128-112 128S112 336 112 272l0-5.3c0-32.4 26.3-58.7 58.7-58.7 18.5 0 35.9 8.7 46.9 23.5z"]
};
var faLightbulbCfl = {
  prefix: 'fass',
  iconName: 'lightbulb-cfl',
  icon: [320, 512, [], "e5a6", "M160 64l0-64C149.1 2.2 95.8 12.8 0 32L0 96 134.8 69 160 64zm160 0l-320 64 0 64 320-64 0-64zM0 288l320-64 0-64-320 64 0 64zM256 512l0-128-32 0 0-44.8 96-19.2 0-64-144 28.8 0 99.2-32 0 0-92.2-48 9.6 0 82.6-32 0 0 128 192 0z"]
};
var faShare = {
  prefix: 'fass',
  iconName: 'share',
  icon: [576, 512, ["mail-forward"], "f064", "M560.2 208l-239.8-215.9 0 135.9-112 0c-97.2 0-176 78.8-176 176 0 128 128 176 128 176s-32-32-32-80c0-61.9 50.1-112 112-112l80 0 0 135.9 239.8-215.9z"]
};
var faMailForward = faShare;
var faCassetteVhs = {
  prefix: 'fass',
  iconName: 'cassette-vhs',
  icon: [512, 512, [128252, "vhs"], "f8ec", "M0 64l512 0 0 80-512 0 0-80zM0 192l512 0 0 256-512 0 0-256zm88.4 64C73.2 273 64 295.4 64 320s9.2 47 24.4 64l71.6 0 0-24c-22.1 0-40-17.9-40-40s17.9-40 40-40l0-24-71.6 0zm192 128l23.6 0 0-128-96 0 0 128 72.4 0zm143.1 0c15.2-17 24.4-39.4 24.4-64s-9.2-47-24.4-64l-71.6 0 0 24c22.1 0 40 17.9 40 40s-17.9 40-40 40l0 24 71.6 0z"]
};
var faVhs = faCassetteVhs;
var faPhoneFlip = {
  prefix: 'fass',
  iconName: 'phone-flip',
  icon: [512, 512, [128381, "phone-alt"], "f879", "M512.1 64l-128-64-96.8 128 80.8 80c-33 70.4-89.6 127-160 160l-80-80.8-128 96.8 64 128 16 0c238.6 0 432-193.4 432-432l0-16z"]
};
var faPhoneAlt = faPhoneFlip;
var faFaceSwear = {
  prefix: 'fass',
  iconName: 'face-swear',
  icon: [640, 512, [], "e399", "M320-32C456-32 567.2 74.1 575.5 208l-511 0C72.8 74.1 184-32 320-32zM240 176c17.7 0 32-14.3 32-32l0-.3c4.9 1.6 14.5 4.8 28.6 9.6l12.6-37.9-19-6.3-96-32-19-6.3-12.6 37.9c11 3.7 27 9 47.8 15.9-4.1 5.4-6.6 12.1-6.6 19.4 0 17.7 14.3 32 32 32zm192-32c0-7.3-2.4-14-6.6-19.4 20.9-7 36.8-12.3 47.8-15.9l-12.6-37.9-19 6.3-96 32-19 6.3 12.6 37.9c14.2-4.7 23.7-7.9 28.6-9.6l0 .3c0 17.7 14.3 32 32 32s32-14.3 32-32zM0 256l640 0 0 256-640 0 0-256zM416 368l0-32-32 0 0-32-32 0 0 32-32 0 0-32-32 0 0 32-32 0 0 32 32 0 0 32-32 0 0 32 32 0 0 32 32 0 0-32 32 0 0 32 32 0 0-32 32 0 0-32-32 0 0-32 32 0zm-64 0l0 32-32 0 0-32 32 0zm220.1-29.6l10.4-12.1-24.3-20.8-10.4 12.1-96 112-10.4 12.1 24.3 20.8 10.4-12.1 96-112zM224 304l-32 0 0 96 32 0 0-96zM96 320.5c-18.2 3.1-32 18.9-32 37.9 0 17.7 12 33 29.1 37.3l30 7.5c2.9 .7 4.9 3.3 4.9 6.3 0 3.6-2.9 6.5-6.5 6.5l-57.5 0 0 32 32 0 0 16 32 0 0-16.5c18.2-3.1 32-18.9 32-37.9 0-17.7-12-33-29.1-37.3l-30-7.5c-2.9-.7-4.9-3.3-4.9-6.3 0-3.6 2.9-6.5 6.5-6.5l49.5 0 0-32-24 0 0-16-32 0 0 16.5zM488 312l-40 0 0 40 40 0 0-40zm48 104l0 40 40 0 0-40-40 0zM192 432l0 32 32 0 0-32-32 0z"]
};
var faToiletPortable = {
  prefix: 'fass',
  iconName: 'toilet-portable',
  icon: [320, 512, [], "e583", "M0 0L0 80 320 80 320 0 0 0zM24 128l-24 0 0 384 48 0 0-32 224 0 0 32 48 0 0-384-296 0zm248 96l0 96-48 0 0-96 48 0z"]
};
var faCircleRupiah = {
  prefix: 'fass',
  iconName: 'circle-rupiah',
  icon: [512, 512, [], "e706", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM152 144l48 0c39.8 0 72 32.2 72 72 0 26.9-14.7 50.3-36.5 62.6 14.8 44.3 23.7 71.2 26.8 80.5l-45.5 15.2C214 366 204.4 337.2 188 288l-12 0 0 80-48 0 0-224 24 0zm48 96c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0 48 24 0zm88-16l64 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-16 0 0 56-48 0 0-184zm48 80l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0 32z"]
};
var faMobileVibrateSlash = {
  prefix: 'fass',
  iconName: 'mobile-vibrate-slash',
  icon: [640, 512, [], "e817", "M160.4 62l0-62 320 0 0 382 130.1 130.1-33.9 33.9-545.9-545.9 33.9-33.9 95.8 95.8zM474.6 512l-314.2 0 0-314.2 314.2 314.2zM256.4 464l102.3 0-48-48-54.3 0 0 48zM122.5 159.9l-40.1 40.1 38.1 38.1 0 35.9-38.1 38.1 48 48-33.9 33.9-81.9-81.9 56-56-56-56 74.1-74.1 33.9 33.9zM626.4 200l-56 56 56 56-73.9 73.9-33.9-33.9 40-40-38.1-38.1 0-35.9 38.1-38.1-48-48 33.9-33.9 81.9 81.9z"]
};
var faTableCellsColumnUnlock = {
  prefix: 'fass',
  iconName: 'table-cells-column-unlock',
  icon: [640, 512, [], "e690", "M256 288l0-64 153.3 0c17.1-42.2 56-73.2 102.7-79l0-113-448 0 0 448 304 0 0-64-112 0 0-64 112 0 0-64-112 0zm0-192l192 0 0 64-192 0 0-64zM528 240c17.7 0 32 14.3 32 32l48 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48-32 0 0 192 224 0 0-192-144 0 0-48c0-17.7 14.3-32 32-32z"]
};
var faPersonPregnant = {
  prefix: 'fass',
  iconName: 'person-pregnant',
  icon: [384, 512, [], "e31e", "M192.4-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm16 448l-32 0 0 128-64 0 0-128-49.8 0c4-14.7 17.8-66 41.4-153.8-21.2 31.8-36.8 55.2-46.8 70.2l-53.3-35.5 17.8-26.6 96-144 9.5-14.2 129.1 0 0 85.9 30.4 18.2c30.8 18.5 49.6 51.7 49.6 87.6 0 29.8-13 58.2-35.7 77.6l-28.3 24.3 0 138.4-64 0 0-128z"]
};
var faLessThan = {
  prefix: 'fass',
  iconName: 'less-than',
  icon: [512, 512, [62774], "3c", "M480 14L18.6 227 0 235.5 0 276.5 18.6 285.1 480 498 480 427.5 108.4 256 480 84.5 480 14z"]
};
var faImageCircleArrowDown = {
  prefix: 'fass',
  iconName: 'image-circle-arrow-down',
  icon: [640, 512, [], "e76c", "M512 32l-448 0 0 448 276 0c-13.7-19-24-40.7-30-64l-198 0 96-144 46.1 69.1 81.9-133.1 18.6 30.2c35.1-38.2 85.5-62.2 141.4-62.2 5.4 0 10.7 .2 16 .7L512 32zM192 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-136l-11.3 11.3-56 56-11.3 11.3-11.3-11.3-56-56-11.3-11.3 22.6-22.6c4.6 4.6 18 18 40 40l0-105.4 32 0 0 105.4c22-22 35.4-35.4 40-40L574.6 376z"]
};
var faSquareFragile = {
  prefix: 'fass',
  iconName: 'square-fragile',
  icon: [448, 512, ["box-fragile", "square-wine-glass-crack"], "f49b", "M448 32l-448 0 0 448 448 0 0-448zM128 96l48 0 32 64-32 32 80 64-32-64 48-32-32-64 80 0 0 112c0 46.2-32.6 84.7-76 93.9l0 74.1 60 0 0 40-160 0 0-40 60 0 0-74.1c-43.4-9.2-76-47.8-76-93.9l0-112z"]
};
var faBoxFragile = faSquareFragile;
var faSquareWineGlassCrack = faSquareFragile;
var faInboxFull = {
  prefix: 'fass',
  iconName: 'inbox-full',
  icon: [512, 512, [], "e1ba", "M423.5 96l24 192-79.5 0-32 64-160 0-32-64-79.5 0 24-192 335 0zM32 32l-32 256 0 192 512 0 0-192-32-256-448 0zm120 96l-24 0 0 48 256 0 0-48-232 0zm0 80l-24 0 0 48 256 0 0-48-232 0z"]
};
var faFilmCanister = {
  prefix: 'fass',
  iconName: 'film-canister',
  icon: [576, 512, ["film-cannister"], "f8b7", "M96 0l160 0 0 32 96 0 0 64-32 0 0 352 32 0 0 64-352 0 0-64 32 0 0-352-32 0 0-64 96 0 0-32zM576 112l0 208-64 0 0 112-144 0 0-48 48 0 0-64-48 0 0-96 48 0 0-64-48 0 0-48 208 0zM96 112l0 320 48 0 0-320-48 0zm432 48l-64 0 0 64 64 0 0-64z"]
};
var faFilmCannister = faFilmCanister;
var faHammerBrush = {
  prefix: 'fass',
  iconName: 'hammer-brush',
  icon: [640, 512, [], "e620", "M0 137.7C0 91.7 23 48.7 61.3 23.1 83.9 8 110.5 0 137.7 0l86.3 0 48 32 16 0 0-32 64 0 0 160-64 0 0-32-16 0-48 32-96 0-48-32-80 32 0-22.3zM224 208l0 304-96 0 0-304 96 0zM448 448l-32 64-96 0 0-176 288 0 0 176-128 0-32-64zM320 256l96-64 0-192 96 0 0 192 96 64 0 32-288 0 0-32z"]
};
var faSuperscript = {
  prefix: 'fass',
  iconName: 'superscript',
  icon: [576, 512, [], "f12b", "M448 0l96 0 0 160 32 0 0 64-128 0 0-64 32 0 0-96-32 0 0-64zM64 64l80.7 0 9.6 13.6 85.8 122.5 85.8-122.5 9.6-13.6 80.7 0 0 64-47.3 0-89.6 128 89.6 128 47.3 0 0 64-80.7 0-9.6-13.6-85.8-122.6-85.8 122.6-9.6 13.6-80.7 0 0-64 47.3 0 89.6-128-89.6-128-47.3 0 0-64z"]
};
var faUniformMartialArts = {
  prefix: 'fass',
  iconName: 'uniform-martial-arts',
  icon: [640, 512, [], "e3d1", "M180 0l57.7 0 69.9 144.7-54.6 143.3-109 0 0-154.9-48 87.3 0 195.7-96 0 0-220.3 5.9-10.8 88-160 13.7-24.9 72.4 0zM144 352l0-32 352 0 0 32-146.1 0 42.1 63.2 8.9 13.3-26.6 17.8-8.9-13.3-45.4-68.1-45.4 68.1-8.9 13.3-26.6-17.8c.4-.6 17.4-26.1 51-76.5L144 352zm77.3 45.5l-26.6 39.9 79.9 53.3c19.1-28.6 34.2-51.3 45.4-68.1 11.2 16.8 26.4 39.5 45.4 68.1l79.9-53.3c-20.7-31-32.6-48.8-35.6-53.4l86.3 0 0 128-352 0 0-128 86.3 0-9 13.5zM496 133.1l0 154.9-208.8 0c34.4-90.3 71-186.3 109.7-288l135.4 0 13.7 24.9 88 160 5.9 10.8 0 220.3-96 0 0-195.7-48-87.3z"]
};
var faCircleUserCircleUser = {
  prefix: 'fass',
  iconName: 'circle-user-circle-user',
  icon: [640, 512, [], "e7a5", "M496 208c-77.5 0-144.3 45.9-174.6 112l-145.4 0-23.9 71.6c34.8 34.8 82.8 56.4 135.9 56.4 7.4 0 14.6-.4 21.7-1.2 5.5 21.9 14.8 42.4 27.1 60.6-15.8 3-32.1 4.6-48.8 4.6-141.4 0-256-114.6-256-256S146.6 0 288 0c126.8 0 232.1 92.2 252.4 213.2-14.3-3.4-29.1-5.2-44.4-5.2zM288 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm64 128a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm223.5 78.9l-15.5-30.9-128 0-15.5 30.9C436.8 499.4 464.9 512 496 512s59.2-12.6 79.5-33.1zM544 368a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faCircleStop = {
  prefix: 'fass',
  iconName: 'circle-stop',
  icon: [512, 512, [62094, "stop-circle"], "f28d", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm96-352l0 192-192 0 0-192 192 0z"]
};
var faStopCircle = faCircleStop;
var faArrowsUpDown = {
  prefix: 'fass',
  iconName: 'arrows-up-down',
  icon: [320, 512, ["arrows-v"], "f07d", "M137.6 534.6l22.6 22.6 118.6-118.6 22.6-22.6-45.3-45.3c-12 12-33.3 33.3-64 64l0-357.5c30.7 30.7 52 52 64 64L301.5 96c-2.9-2.9-42.4-42.4-118.6-118.6L160.3-45.3C157.4-42.4 117.8-2.9 41.6 73.4L19 96 64.3 141.2c12-12 33.3-33.3 64-64l0 357.5c-30.7-30.7-52-52-64-64L19 416c2.9 2.9 42.4 42.4 118.6 118.6z"]
};
var faArrowsV = faArrowsUpDown;
var faMeterDroplet = {
  prefix: 'fass',
  iconName: 'meter-droplet',
  icon: [640, 512, [], "e1ea", "M566.5 201.8C568 203.6 569.7 205.4 571.4 207.4 548.7 89.2 444.8 0 320 0 178.6 0 64 114.6 64 256S178.6 512 320 512c15.6 0 30.9-1.4 45.8-4.1-13.8-24.1-21.8-51.9-21.8-81.8 0-33.2 10.4-65.4 23.2-93.1 13-28.1 29.9-54.4 46-76.6 16.2-22.3 32.3-41.3 44.4-54.7L512 146.7c3.4 3.3 6.8 6.7 10.2 10 15.1 14.7 30.1 29.4 44.2 45.1zM344 128l0 96-48 0 0-96 48 0zm-96 24l0 72-48 0 0-96 48 0 0 24zM632 426.1C632 331.9 512 214 512 214S392 331.9 392 426.1C392 491.2 445.7 544 512 544s120-52.8 120-117.9z"]
};
var faOrnament = {
  prefix: 'fass',
  iconName: 'ornament',
  icon: [448, 512, [], "f7b8", "M208 64.6L208 32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32.6c-10.5-.7-21.5-.7-32 0zm-48 8.7C98.8 91.5 48.6 135.2 21.6 192l404.9 0C399.4 135.2 349.2 91.5 288 73.3L288 32c0-35.3-28.7-64-64-64S160-3.3 160 32l0 41.3zM0 288c0 16.5 1.8 32.5 5.2 48l437.7 0c3.4-15.5 5.2-31.5 5.2-48s-1.8-32.5-5.2-48L5.2 240C1.8 255.5 0 271.5 0 288zm21.6 96c36 75.7 113.1 128 202.4 128s166.5-52.3 202.4-128L21.6 384z"]
};
var faDisplaySlash = {
  prefix: 'fass',
  iconName: 'display-slash',
  icon: [640, 512, ["desktop-slash"], "e2fa", "M73.4-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-1-1-33-33-96.1-96.1l70 0 0-384-454 0-48.9-48.9zM186.3 96l326 0 0 256-70 0-256-256zm128 256l-186 0 0-186-64-64 0 314 208 0-16 48-96 0 0 48 314 0-48-48-42 0-16-48 10 0-64-64z"]
};
var faDesktopSlash = faDisplaySlash;
var faPageCaretUp = {
  prefix: 'fass',
  iconName: 'page-caret-up',
  icon: [384, 512, ["file-caret-up"], "e42a", "M240 0L0 0 0 512 384 512 384 144 240 0zM96 336l0-24 96-104 96 104 0 24-192 0z"]
};
var faFileCaretUp = faPageCaretUp;
var faPooStorm = {
  prefix: 'fass',
  iconName: 'poo-storm',
  icon: [512, 512, ["poo-bolt"], "f75a", "M352 64c0-53-48-96-112-96 0 0 64 112-48 112l-40 0c-48.6 0-88 39.4-88 88l0 43.3C27.1 221.8 0 255.7 0 296l0 88 67.5 0 219-184 78.3 0-32.4 136 91.6 0 0 48 88 0 0-88c0-40.3-27.1-74.2-64-84.7l0-43.3c0-48.6-39.4-88-88-88l-9.4 0c.9-5 1.4-10.4 1.4-16zM104 416l104.4 0-32.4 136 200-168-104.4 0 32.4-136-200 168z"]
};
var faPooBolt = faPooStorm;
var faVideoSlash = {
  prefix: 'fass',
  iconName: 'video-slash',
  icon: [576, 512, [], "f4e2", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-145.2-145.2 0-286-286 0-80.9-80.9zM32.1 448l346.2 0-346.2-346.2 0 346.2zm544-32l0-320-112 74.7 0 170.7 112 74.7z"]
};
var faSquareXmark = {
  prefix: 'fass',
  iconName: 'square-xmark',
  icon: [448, 512, [10062, "times-square", "xmark-square"], "f2d3", "M448 32l-448 0 0 448 448 0 0-448zM140.1 305.9L190.1 256c-38.8-38.8-61.1-61.1-66.9-66.9l33.9-33.9 66.9 66.9c38.8-38.8 61.1-61.1 66.9-66.9l33.9 33.9c-5.8 5.8-28.1 28.1-66.9 66.9 38.8 38.8 61.1 61.1 66.9 66.9l-33.9 33.9c-5.8-5.8-28.1-28.1-66.9-66.9-38.8 38.8-61.1 61.1-66.9 66.9l-33.9-33.9 17-17z"]
};
var faTimesSquare = faSquareXmark;
var faXmarkSquare = faSquareXmark;
var faMessageDots = {
  prefix: 'fass',
  iconName: 'message-dots',
  icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCommentAltDots = faMessageDots;
var faMessaging = faMessageDots;
var faDropletDegree = {
  prefix: 'fass',
  iconName: 'droplet-degree',
  icon: [576, 512, ["dewpoint"], "f748", "M256 512C150 512 64 426 64 320S256-32 256-32 448 214 448 320 362 512 256 512zM528 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faDewpoint = faDropletDegree;
var faTowerControl = {
  prefix: 'fass',
  iconName: 'tower-control',
  icon: [512, 512, [], "e2a2", "M176.1 0l160 0 0 48-56 0 0 48 208.6 0c-.5 2.1-18.4 76.8-53.8 224l29.2 0 0 64-48 0 0 128-320 0 0-128-48 0 0-64 29.2 0C41.9 172.8 24 98.1 23.5 96l208.6 0 0-48-56 0 0-48zM407.5 160l-71.4 0 0 160 33 0 38.4-160zm-119.4 0l-64 0 0 160 64 0 0-160zm-112 0l-71.4 0 38.4 160 33 0 0-160z"]
};
var faCircleDong = {
  prefix: 'fass',
  iconName: 'circle-dong',
  icon: [512, 512, [], "e723", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm16-400l48 0 0 32 32 0 0 32-32 0 0 176-48 0 0-6.7c-9.8 4.3-20.6 6.7-32 6.7-44.2 0-80-35.8-80-80s35.8-80 80-80c11.4 0 22.2 2.4 32 6.7l0-22.7-48 0 0-32 48 0 0-32zM240 240a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM144 408l0-32 224 0 0 32-224 0z"]
};
var faBurgerCheese = {
  prefix: 'fass',
  iconName: 'burger-cheese',
  icon: [512, 512, [127828, "cheeseburger"], "f7f1", "M32 480l0-80 448 0 0 80-448 0zM480 176l0 48-448 0 0-48S80 32 256 32 480 176 480 176zM248 272l72 48 72-48 120 0 0 80-512 0 0-80 248 0zM280 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM144 152a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCheeseburger = faBurgerCheese;
var faHandHoldingDroplet = {
  prefix: 'fass',
  iconName: 'hand-holding-droplet',
  icon: [576, 512, ["hand-holding-water"], "f4c1", "M288 0L211.2 102.4c-12.5 16.6-19.2 36.8-19.2 57.6 0 53 43 96 96 96s96-43 96-96c0-20.8-6.7-41-19.2-57.6L288 0zM137.4 313.4l-70.6 70.6-66.7 0 0 128 396.4 0 10.2-7c101.2-69.6 154.8-106.4 161-110.7l-45.3-65.9c-11.7 8.1-54.2 37.3-127.5 87.6l-138.8 0 0-48 128 0 0-64-237.3 0-9.4 9.4z"]
};
var faHandHoldingWater = faHandHoldingDroplet;
var faWonSign = {
  prefix: 'fass',
  iconName: 'won-sign',
  icon: [576, 512, [8361, "krw", "won"], "f159", "M94.6 54.5l-9.5-30.5-61.1 19.1 9.5 30.5 52 166.5-45.5 0 0 48 60.5 0 53 169.5 7 22.5 65.5 0 5.3-25.5 34.7-166.5 44 0 34.7 166.5 5.3 25.5 65.5 0 7-22.5 53-169.5 60.5 0 0-48-45.5 0 52-166.5 9.5-30.5-61.1-19.1-9.5 30.5-58 185.5-58.1 0-38-182.5-5.3-25.5-68 0-5.3 25.5-38 182.5-58.1 0-58-185.5zm73 233.5l33.1 0-13.2 63.6-19.9-63.6zm108.5-48l12-57.5 12 57.5-24 0zm99.3 48l33.1 0-19.9 63.6-13.2-63.6z"]
};
var faKrw = faWonSign;
var faWon = faWonSign;
var faObjectUngroup = {
  prefix: 'fass',
  iconName: 'object-ungroup',
  icon: [640, 512, [], "f248", "M128 0l-128 0 0 128 32 0 0 96-32 0 0 128 128 0 0-32 192 0 0 32 128 0 0-128-32 0 0-96 32 0 0-128-128 0 0 32-192 0 0-32zM352 224l0 32-256 0 0-160 256 0 0 128zM320 512l0-32 192 0 0 32 128 0 0-128-32 0 0-96 32 0 0-128-128 0 0 32-16 0 0 64 48 0 0 160-272 0 0-48-48 0 0 16-32 0 0 128 128 0z"]
};
var faChartWaterfall = {
  prefix: 'fass',
  iconName: 'chart-waterfall',
  icon: [512, 512, [], "e0eb", "M64 32l0 384 448 0 0 64-512 0 0-448 64 0zM176 224l0 128-64 0 0-128 64 0zm112-64l0 96-64 0 0-128 64 0 0 32zM400 64l0 128-64 0 0-128 64 0zM512 96l0 256-64 0 0-288 64 0 0 32z"]
};
var faComment = {
  prefix: 'fass',
  iconName: 'comment',
  icon: [512, 512, [128489, 61669], "f075", "M256 480c141.4 0 256-107.5 256-240S397.4 0 256 0 0 107.5 0 240c0 56.5 20.8 108.5 55.7 149.5L0 512 148.7 457.9c32.6 14.2 69 22.1 107.3 22.1z"]
};
var faSpaceStationMoon = {
  prefix: 'fass',
  iconName: 'space-station-moon',
  icon: [512, 512, [], "e033", "M512 256c0 10.8-.7 21.4-2 31.9-72.4 25.2-159.6 40.1-254 40.1S74.4 313.1 2 287.9C.7 277.4 0 266.8 0 256 0 114.6 114.6 0 256 0S512 114.6 512 256zM256 376c87 0 169.2-12 241-33.5-35.5 98.8-130 169.5-241 169.5S50.5 441.3 15 342.5C86.8 364 169 376 256 376zM160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faUpFromBracket = {
  prefix: 'fass',
  iconName: 'up-from-bracket',
  icon: [448, 512, [], "e590", "M241.4 7.5L224-11 206.6 7.5C99.6 120.8 41.5 182.3 32.3 192l127.7 0 0 160 128 0 0-160 127.7 0c-9.2-9.7-67.3-71.2-174.2-184.5zM64 352l0-32-64 0 0 192 448 0 0-192-64 0 0 128-320 0 0-96z"]
};
var faCalendarCirclePlus = {
  prefix: 'fass',
  iconName: 'calendar-circle-plus',
  icon: [576, 512, [], "e470", "M192 32l0-32-64 0 0 64-96 0 0 112 448 0 0-112-96 0 0-64-64 0 0 64-128 0 0-32zM32 480l225.4 0c-11.2-24.4-17.4-51.4-17.4-80 0-78.7 47.4-146.4 115.1-176L32 224 32 480zm400 64a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 64 0 0 32-64 0 0 64-32 0 0-64-64 0 0-32 64 0 0-64 32 0 0 16z"]
};
var faTabletScreen = {
  prefix: 'fass',
  iconName: 'tablet-screen',
  icon: [448, 512, ["tablet-android-alt"], "f3fc", "M0 0L448 0 448 512 0 512 0 0zM160 416l0 48 128 0 0-48-128 0zM384 64l-320 0 0 304 320 0 0-304z"]
};
var faTabletAndroidAlt = faTabletScreen;
var faSaltShaker = {
  prefix: 'fass',
  iconName: 'salt-shaker',
  icon: [384, 512, [129474], "e446", "M384 512l-8-64-40.1-321C326.8 54.5 265.1 0 192 0S57.2 54.5 48.1 127L8 448 0 512 384 512zm-72.5-64l-239 0 32-256 175 0 32 256zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM240 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faFileCheck = {
  prefix: 'fass',
  iconName: 'file-check',
  icon: [384, 512, [], "f316", "M384 144L384 512 0 512 0 0 240 0 384 144zM249.4 265.9L163.8 383.6c-19.3-20-33.7-34.9-43.2-44.7L86.1 372.2c6.2 6.4 27.2 28.1 63.1 65.3l19.8 20.6 16.8-23.1 102.4-140.8 14.1-19.4-38.8-28.3-14.1 19.4zM208 176L325.5 176 208 58.5 208 176z"]
};
var faHillAvalanche = {
  prefix: 'fass',
  iconName: 'hill-avalanche',
  icon: [576, 512, [], "e507", "M.4 512l480 0-480-480 0 480zM551.5 391.1c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6-40.9 15.6-56.6 0l-81.7-81.7c22.3-14.2 37.1-39.1 37.1-67.5 0-33.9-21.1-62.9-50.9-74.5 1.9-6.8 2.9-14 2.9-21.5 0-44.2-35.8-80-80-80-27.3 0-51.5 13.7-65.9 34.6-5.8-20-24.2-34.6-46.1-34.6-26.5 0-48 21.5-48 48 0 4 .5 7.9 1.4 11.6L440.1 401.9c34.2 23.1 81.1 19.5 111.4-10.8zM448.4 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faArrowsToEye = {
  prefix: 'fass',
  iconName: 'arrows-to-eye',
  icon: [640, 512, [], "e4bf", "M176.4 32l-48 0 0 62.1-80-80-33.9 33.9c3.6 3.6 30.3 30.3 80 80l-62.1 0 0 48 144 0 0-144zm144 88c-80.7 0-139.9 67.5-170.2 136 30.3 68.5 89.6 136 170.2 136s139.9-67.5 170.2-136c-30.3-68.5-89.6-136-170.2-136zm-.9 72a64 64 0 1 1 .9 128 64 64 0 1 1 -.9-128zM176.4 456l0-120-144 0 0 48 62.1 0c-49.7 49.7-76.4 76.4-80 80l33.9 33.9c3.6-3.6 30.3-30.3 80-80l0 62.1 48 0 0-24zm288 0l0 24 48 0 0-62.1c49.7 49.7 76.4 76.4 80 80L626.4 464c-3.6-3.6-30.3-30.3-80-80l62.1 0 0-48-144 0 0 120zm0-424l0 144 144 0 0-48-62.1 0c49.7-49.7 76.4-76.4 80-80L592.4 14.1c-3.6 3.6-30.3 30.3-80 80l0-62.1-48 0z"]
};
var faSnowplow = {
  prefix: 'fass',
  iconName: 'snowplow',
  icon: [640, 512, [], "f7d2", "M128 160l0-160 208 0 112 224 0 72 80 0 0-80c0-48.6 39.4-88 88-88l24 0 0 48-24 0c-22.1 0-40 17.9-40 40l0 208c0 22.1 17.9 40 40 40l24 0 0 48-24 0c-48.6 0-88-39.4-88-88l0-80-63 0c9.5 16.5 15 35.6 15 56 0 61.9-50.1 112-112 112l-224 0c-61.9 0-112-50.1-112-112 0-30.5 12.2-58.2 32-78.4l0-161.6 64 0zm91.7 34.9l43.6 29.1 113.2 0-80-160-104.4 0 0 108.8 27.7 22.1zM416 400c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l224 0c26.5 0 48-21.5 48-48zm-280 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM232 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faShieldExclamation = {
  prefix: 'fass',
  iconName: 'shield-exclamation',
  icon: [512, 512, [], "e247", "M267.6 4.5l207.5 80.5 19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.2-91.1 150-189.4 192.6l-12.7 5.5-12.7-5.5C144.9 463.9 86.6 389.2 53.9 313.9 21.5 239.3 13.7 162.9 16.6 113L17.8 92.5 37 85 244.5 4.5 256 0 267.6 4.5zM228 308l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0z"]
};
var faSquareW = {
  prefix: 'fass',
  iconName: 'square-w',
  icon: [448, 512, [], "e285", "M448 32l-448 0 0 448 448 0 0-448zM144.6 349.5l-48.6-205.5 49.3 0 26 110.1 29.7-93.4 5.3-16.7 35.1 0 5.3 16.7 29.7 93.4 26-110.1 49.3 0-48.6 205.5-4.4 18.5-36.5 0-5.3-16.7-33.1-104.1-33.1 104.1-5.3 16.7-36.5 0-4.4-18.5z"]
};
var faChartGantt = {
  prefix: 'fass',
  iconName: 'chart-gantt',
  icon: [512, 512, [], "e0e4", "M64 64l0-32-64 0 0 448 512 0 0-64-448 0 0-352zm96 0l-32 0 0 64 160 0 0-64-128 0zm64 112l-32 0 0 64 192 0 0-64-160 0zM384 288l-32 0 0 64 128 0 0-64-96 0z"]
};
var faCreditCardBlank = {
  prefix: 'fass',
  iconName: 'credit-card-blank',
  icon: [512, 512, [], "f389", "M512 64l-512 0 0 384 512 0 0-384zM88 336l72 0 0 48-96 0 0-48 24 0zm144 0l72 0 0 48-96 0 0-48 24 0zm144 0l72 0 0 48-96 0 0-48 24 0z"]
};
var faHandsHoldingDollar = {
  prefix: 'fass',
  iconName: 'hands-holding-dollar',
  icon: [640, 512, ["hands-usd"], "f4c5", "M344-16l-48 0 0 36-1.8 0c-36.6 0-66.2 29.7-66.2 66.2 0 33.4 24.9 61.6 58 65.7l61 7.6c5.1 .6 9 5 9 10.2 0 5.7-4.6 10.2-10.2 10.2l-101.8 0 0 56 52 0 0 36 48 0 0-36 1.8 0c36.6 0 66.2-29.7 66.2-66.2 0-33.4-24.9-61.6-58-65.7l-61-7.6c-5.1-.6-9-5-9-10.2 0-5.7 4.6-10.2 10.2-10.2l93.8 0 0-56-44 0 0-36zM80 64l-80 0 0 301.3 9.4 9.4 128 128 9.4 9.4 141.3 0 0-173.3-9.4-9.4C125.1 175.9 201.5 252.2 160 210.7L114.7 256c48.8 48.8 65.1 65.1 91 91L164.1 374.8 80 290.7 80 64zm480 0l0 226.7-84.1 84.1-41.7-27.8c102.9-102.9 58.7-58.7 91-91L480 210.7c-44.2 44.2-69.7 69.7-118.6 118.6l-9.4 9.4 0 173.3 141.3 0 9.4-9.4 128-128 9.4-9.4 0-301.3-80 0z"]
};
var faHandsUsd = faHandsHoldingDollar;
var faBuildingMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'building-magnifying-glass',
  icon: [576, 512, [], "e61c", "M32.4 0l384 0 0 180.9c-12.8-3.1-26.2-4.8-40-4.8-92.8 0-168 75.2-168 168 0 2.6 .1 5.3 .2 7.9l-32.2 0 0 112 82.3 0c29.1 28.5 68.4 46.6 112 48l-338.3 0 0-512zM382.1 512c11.8-.4 23.3-2 34.3-4.7l0 4.7-34.3 0zM192.4 96l-64 0 0 64 64 0 0-64zm64 0l0 64 64 0 0-64-64 0zm-64 128l-64 0 0 64 64 0 0-64zm184 192.1a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 48c-66.3 0-120-53.7-120-120s53.7-120 120-120 120 53.7 120 120c0 24.5-7.3 47.2-19.9 66.2 47.9 47.9 73.8 73.8 77.8 77.8L520.4 522c-4-4-29.9-29.9-77.8-77.8-19 12.6-41.7 19.9-66.2 19.9z"]
};
var faSquareA = {
  prefix: 'fass',
  iconName: 'square-a',
  icon: [448, 512, [], "e25f", "M448 32l-448 0 0 448 448 0 0-448zM208.9 144l30.2 0 6.5 13.6 96 200 5 10.4-53.2 0-15.4-32-108 0-15.4 32-53.2 0 5-10.4 96-200 6.5-13.6zM224 223.5l-31 64.5 62 0-31-64.5z"]
};
var faVideo = {
  prefix: 'fass',
  iconName: 'video',
  icon: [576, 512, ["video-camera"], "f03d", "M416 64l-384 0 0 384 384 0 0-384zM576 416l0-320-112 74.7 0 170.7 112 74.7z"]
};
var faVideoCamera = faVideo;
var faFacePouting = {
  prefix: 'fass',
  iconName: 'face-pouting',
  icon: [512, 512, [], "e387", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm208-16l0-.3c4.9 1.6 14.5 4.8 28.6 9.6l12.6-37.9-19-6.3-96-32-19-6.3-12.6 37.9c11 3.7 26.9 9 47.8 15.9-4.1 5.4-6.6 12.1-6.6 19.4 0 17.7 14.3 32 32 32s32-14.3 32-32zm128 32c17.7 0 32-14.3 32-32 0-7.3-2.4-14-6.6-19.4 20.9-7 36.8-12.3 47.8-15.9l-12.6-37.9-19 6.3-96 32-19 6.3 12.6 37.9c14.2-4.7 23.7-7.9 28.6-9.6l0 .3c0 17.7 14.3 32 32 32zM152 414.6c29.1-19.3 64.9-30.6 103.6-30.6s74.5 11.4 103.6 30.6c-4.7-53-49.3-94.6-103.6-94.6S156.7 361.6 152 414.6z"]
};
var faChessPawn = {
  prefix: 'fass',
  iconName: 'chess-pawn',
  icon: [384, 512, [9823], "f443", "M192-32c66.3 0 120 53.7 120 120 0 27-8.9 51.9-24 72l32 0 0 64-42.7 0 26.7 160 64 80 0 48-352 0 0-48 64-80 26.7-160-42.7 0 0-64 32 0c-15.1-20.1-24-45-24-72 0-66.3 53.7-120 120-120z"]
};
var faUserHeadset = {
  prefix: 'fass',
  iconName: 'user-headset',
  icon: [448, 512, [], "f82d", "M80 160C80 80.5 144.5 16 224 16S368 80.5 368 160l0 112-80 0c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 48 256 0 0-160C416 54 330-32 224-32S32 54 32 160l0 24 48 0 0-24zm256 0c0-61.9-50.1-112-112-112S112 98.1 112 160c0 24.5 7.9 47.2 21.2 65.6 15.5-25 43.2-41.6 74.8-41.6l32 0c30.9 0 58.1 15.9 73.8 40l2.2 0c12.7-18.1 20.1-40.2 20.1-64zM0 512l448 0-64-160-320 0-64 160z"]
};
var faSynagogue = {
  prefix: 'fass',
  iconName: 'synagogue',
  icon: [576, 512, [128333], "f69b", "M16 80c0-35.3 28.7-64 64-64s64 28.7 64 64l0 32-128 0 0-32zm0 432l0-352 128 0 144-96 144 96 128 0 0 352-544 0zM560 112l-128 0 0-32c0-35.3 28.7-64 64-64s64 28.7 64 64l0 32zM352 320l-128 0 0 144 128 0 0-144zm-64-88a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faMug = {
  prefix: 'fass',
  iconName: 'mug',
  icon: [576, 512, [], "f874", "M384 64l-320 0 0 384 384 0 0-128c70.7 0 128-57.3 128-128S518.7 64 448 64l-64 0zm64 64c35.3 0 64 28.7 64 64s-28.7 64-64 64l0-128z"]
};
var faShirtJersey = {
  prefix: 'fass',
  iconName: 'shirt-jersey',
  icon: [640, 512, [], "e6d7", "M400 32c0 44.2-35.8 80-80 80s-80-35.8-80-80l-80 0-96 96 96 96 0 288 320 0 0-288 96-96-96-96-80 0zM604.3 156.3l-96 96 35.7 35.7 96-96-35.7-35.7zM0 192l96 96 35.7-35.7-96-96-35.7 35.7zm296 88l48 0 0-80-48 0 0 80zM256 160l128 0 0 160-128 0 0-160z"]
};
var faBuildingCircleCheck = {
  prefix: 'fass',
  iconName: 'building-circle-check',
  icon: [576, 512, [], "e4d2", "M416 0l-384 0 0 512 244 0c-10.5-14.6-19-30.7-25.1-48l-74.9 0 0-112 70 0c6-23.3 16.3-45 30-64l-20 0 0-64 64 0 0 20c27.5-19.8 60.3-32.4 96-35.4L416 0zM128 96l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM128 224l64 0 0 64-64 0 0-64zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L353.4 400 376 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z"]
};
var faCalendarPlus = {
  prefix: 'fass',
  iconName: 'calendar-plus',
  icon: [448, 512, [], "f271", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0zm40 384l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faWheelchairMove = {
  prefix: 'fass',
  iconName: 'wheelchair-move',
  icon: [448, 512, ["wheelchair-alt"], "e2ce", "M312 56a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM189.8 29l22.4 18.2c102.3 83.1 153.7 124.9 154.3 125.3-10.1 11.1-35.4 39-75.9 83.5L447 256c-1 5.2-14.3 71.3-39.7 198.3l-6.3 31.4-62.8-12.6c1.2-5.9 11.4-56.9 30.6-153.1l-52.2 0c2.1 10.3 3.2 21 3.2 32 0 88.4-71.6 160-160 160S0 440.4 0 352 71.6 192 160 192c6 0 11.9 .3 17.8 1l50.4-50.4-33.9-27.6c-32.6 32.6-54.6 54.6-66.2 66.2L82.7 136c8.2-8.2 37.1-37.1 86.6-86.6L189.8 29zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faWheelchairAlt = faWheelchairMove;
var faUserKey = {
  prefix: 'fass',
  iconName: 'user-key',
  icon: [576, 512, [], "e7b0", "M224 248a120 120 0 1 0 0-240 120 120 0 1 0 0 240zM368 432c-38.8-29.2-64-75.6-64-128l-224 0-64 208 352 0 0-80zM576 304c0-61.9-50.1-112-112-112S352 242.1 352 304c0 44.7 26.2 83.2 64 101.2l0 122.8 48 48 64-64-32-32 32-32-29.8-37.3C543.3 396.3 576 353.9 576 304zM432 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faUserShield = {
  prefix: 'fass',
  iconName: 'user-shield',
  icon: [576, 512, [], "f505", "M224 248a120 120 0 1 0 0-240 120 120 0 1 0 0 240zm16 107.2l0-51.2-160 0-64 208 282.3 0C261.4 469.2 240 413.9 240 355.2zM462 530.8c69.3-30.8 114-99.6 114-175.5l0-51.2-144-48-144 48 0 51.2c0 75.9 44.7 144.6 114 175.5l30 13.3 30-13.3zm-30-39.2l0-184.9 96 32 0 16.6c0 56.9-33.5 108.5-85.5 131.6L432 491.6z"]
};
var faTally4 = {
  prefix: 'fass',
  iconName: 'tally-4',
  icon: [448, 512, [], "e297", "M64 64l0-32-64 0 0 448 64 0 0-416zm128 0l0-32-64 0 0 448 64 0 0-416zM320 32l-64 0 0 448 64 0 0-448zM448 64l0-32-64 0 0 448 64 0 0-416z"]
};
var faBreadLoaf = {
  prefix: 'fass',
  iconName: 'bread-loaf',
  icon: [576, 512, [127838], "f7eb", "M32 256l-32 0 0-64C0 121.3 57.3 64 128 64l96 0c70.7 0 128 57.3 128 128l0 64-32 0 0 224-288 0 0-224zM344.8 64L448 64c70.7 0 128 57.3 128 128l0 64-176 0 0-64c0-50.4-21.2-95.9-55.2-128zM368 480l0-176 176 0 0 176-176 0z"]
};
var faCircle0 = {
  prefix: 'fass',
  iconName: 'circle-0',
  icon: [512, 512, [], "e0ed", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-368c53 0 96 43 96 96l0 32c0 53-43 96-96 96s-96-43-96-96l0-32c0-53 43-96 96-96zm-48 96l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faBold = {
  prefix: 'fass',
  iconName: 'bold',
  icon: [384, 512, [], "f032", "M32 32l-32 0 0 64 64 0 0 320-64 0 0 64 256 0c70.7 0 128-57.3 128-128 0-46.5-24.8-87.3-62-109.7 18.7-22.3 30-51 30-82.3 0-70.7-57.3-128-128-128L32 32zm96 384l0-128 128 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-128 0zm0-320l96 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-96 0 0-128z"]
};
var faHeartPulse = {
  prefix: 'fass',
  iconName: 'heart-pulse',
  icon: [512, 512, ["heartbeat"], "f21e", "M241 87.1C216 52.5 175.9 32 133.1 32 59.6 32 0 91.6 0 165.1l0 2.6c0 23.7 6.3 48.1 16.9 72.3l112.3 0c24.4-48.9 42.3-84.6 53.6-107.2 9.7 17.2 34.7 61.6 75 133.3 31.9-47.9 52.7-79 62.3-93.4 12.5 18.7 27.4 41.2 44.8 67.3l130.3 0c10.6-24.2 16.9-48.6 16.9-72.3l0-2.6C512 91.6 452.4 32 378.9 32 336.2 32 296 52.5 271 87.1l-15 20.7-15-20.7zM468.8 288l-129.6 0c-3.9-5.9-10.3-15.5-19.2-28.7-33.1 49.6-55 82.5-65.7 98.6-7.7-13.7-30.7-54.6-69-122.7-15.4 30.8-24.2 48.4-26.4 52.8L43.2 288C116.2 399.6 256 496 256 496s139.8-96.4 212.8-208z"]
};
var faHeartbeat = faHeartPulse;
var faSquareRootVariable = {
  prefix: 'fass',
  iconName: 'square-root-variable',
  icon: [576, 512, ["square-root-alt"], "f698", "M296 32l280 0 0 64-232 0-105.3 361-6.7 23-42.4 0-9.3-15.9-102.7-176.1-77.6 0 0-64 114.4 0 9.3 15.9 74.5 127.7 91.2-312.5 6.7-23zM528 226.7l45.3 45.3-48 48 48 48-45.3 45.3-48-48-48 48-45.3-45.3 48-48-48-48 45.3-45.3c14.6 14.6 30.6 30.6 48 48 17.4-17.4 33.4-33.4 48-48z"]
};
var faSquareRootAlt = faSquareRootVariable;
var faMessageCheck = {
  prefix: 'fass',
  iconName: 'message-check',
  icon: [512, 512, ["comment-alt-check"], "f4a2", "M512 448l-224 0-160 96 0-96-128 0 0-416 512 0 0 416zM340.5 135l-119.4 164.2-69.1-69.1-33.9 33.9 88.9 88.9 19.8 19.9 16.5-22.7 135.9-186.9 14.1-19.4-38.8-28.3-14.1 19.4z"]
};
var faCommentAltCheck = faMessageCheck;
var faHandsBubbles = {
  prefix: 'fass',
  iconName: 'hands-bubbles',
  icon: [512, 512, ["hands-wash"], "e05e", "M384 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM0 128c0 14.6 0 49.4 .1 104.6 .1 52.2 23.9 101 63.9 133 .8-80.9 42.8-155.8 111.5-198.8 33.1-20.7 60.1-37.6 80.8-50.5 30.5-52.8 47.5-82.3 51-88.3l-41.6-24-12 20.8-84 145.5-20.8-12 63.2-109.5 12-20.8-41.6-24-12 20.8-63.2 109.5 0 0-43.3 75c0-35.8-.1-62.9-.1-81.3L0 128zm284.1-11.8l28.8 46.1c22-38 35.5-61.6 40.7-70.6l-41.6-24c-7.3 12.7-16.7 28.9-28 48.5zm43.2 69.1l16.7 26.7 23.4 0c15.2-26.4 26.1-45.2 32.7-56.6l-41.6-24c-6.8 11.8-17.2 29.8-31.1 53.9zm-61.1-37.4c-12.6 7.9-41.7 26.1-87.3 54.6-51.6 32.2-82.9 88.7-82.9 149.5l0 8c0 8.9 .8 17.6 2.2 26.1 35.4 8.2 61.8 40 61.8 77.9 0 6.3-.7 12.5-2.1 18.4 25.2 18.6 56.4 29.6 90.1 29.6l200 0 0-48-128 0 0-24 160 0 0-48-160 0 0-24 192 0 0-48-192 0 0-24 160 0 0-48-160 0 0 0-93.2 0c34-21.2 58.4-36.5 73.3-45.8l-33.9-54.3zM512 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faHandsWash = faHandsBubbles;
var faGuitars = {
  prefix: 'fass',
  iconName: 'guitars',
  icon: [576, 512, [], "f8bf", "M120 0l72 0 0 85.7-2.5 5.1-21.5 42.9 0 44.4c50.3 8.6 88 43.8 88 86 0 14-4.2 27.3-11.6 39.1-8.2 13-7.5 31.9 2.9 43.4 9.8 10.9 17.1 23.3 21.1 36.8-7.3 16.1-12.4 34.7-12.4 54.9 0 6.2 .5 12.2 1.3 18.2-21.4 33.1-64.1 55.6-113.3 55.6-70.7 0-128-46.6-128-104 0-23 9.2-44.3 24.8-61.5 10.3-11.4 11.1-30.4 2.9-43.4-7.5-11.8-11.6-25.1-11.6-39.1 0-42.1 37.7-77.3 88-86l0-44.4-21.5-42.9-2.5-5.1 0-85.7 24 0zm24 344a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM408 148.6L376 112 400 0 432 0c22.1 0 40 17.9 40 40l0 4.4c0 12.4-6.4 23.3-16 29.7l0 164.7c48-7.2 48-46.9 48-46.9l32 0 0 37.5c0 12.9-4.3 25.4-8.5 37.8-1.4 4-2.7 7.9-3.9 11.8-2.1 6.8-3.6 15.1-3.6 24.8 0 33.5 17 70.9 28.8 92.9 6.9 12.7 11.2 26.9 11.2 41.3 0 40.8-33 73.8-73.8 73.8l-108.4 0c-40.8 0-73.8-33-73.8-73.8 0-14.5 4.3-28.6 11.2-41.3 11.8-22 28.8-59.3 28.8-92.9 0-9.8-1.5-18-3.6-24.8-1.2-3.9-2.6-7.9-3.9-11.8-4.2-12.4-8.5-25-8.5-37.8l0-53.5 32 0s0 52.8 48 62.5l0-89.9zM392 288l0 48 88 0 0-48-88 0zm0 80l0 48 88 0 0-48-88 0z"]
};
var faMarker = {
  prefix: 'fass',
  iconName: 'marker',
  icon: [512, 512, [], "f5a1", "M263 9l-17-17-17 17-126.1 126.1-17 17 33.9 33.9 17-17 109.1-109.1 31 31-92.1 92.1 144 144 153.2-153.2c19.1-19.1 29.8-45 29.8-72 0-56.2-45.6-101.8-101.8-101.8-27 0-52.9 10.7-72 29.8L311 57 263 9zM40 328L0 512 184 472 295 361 151 217 40 328z"]
};
var faUserHairLong = {
  prefix: 'fass',
  iconName: 'user-hair-long',
  icon: [448, 512, [], "e45b", "M304 128c0-18-6-34.6-16-48l0 0-64 48-80 0 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zm48 0l0 48 48 96-352 0 48-96 0-48C96 57.3 153.3 0 224 0S352 57.3 352 128zm80 384l-416 0 64-192 288 0 64 192z"]
};
var faTrafficLightGo = {
  prefix: 'fass',
  iconName: 'traffic-light-go',
  icon: [320, 512, [], "f638", "M104 416c0 30.9 25.1 56 56 56s56-25.1 56-56-25.1-56-56-56-56 25.1-56 56zm56-216a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM104 96a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zM0-32l320 0 0 576-320 0 0-576zM136 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHousePersonLeave = {
  prefix: 'fass',
  iconName: 'house-person-leave',
  icon: [640, 512, ["house-leave", "house-person-depart"], "e00f", "M440 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM336 112l-13.3 0-9.4 9.4-80 80-9.4 9.4 0 109.3 64 0 0-82.7 32-32 0 69.3c0 28 12.2 54.7 33.5 72.9l80.7 69.1c11 71.6 17.4 112.9 19.1 123.9l63.3-9.7c-1.4-9-8.3-54.2-20.9-135.6l-1.8-11.7-9-7.7-52.8-45.3 0-115.2c17.6 22 28.4 35.6 32.6 40.8l111.4 0 0-64-80.6 0-54.4-68-9.6-12-95.4 0zM320.1 371l-12.6 44.2c-44.7 44.7-71.6 71.6-80.8 80.8L272 541.3c8.2-8.2 37.1-37.1 86.6-86.6l5.9-5.9c.8-2.7 3.8-13.2 9-31.5l-46-39.4c-2.5-2.2-5-4.4-7.4-6.8zM192 8l-176 153.2 0 30.8 32 0 0 160 128 0 0-161.1c6.2-6.2 40.7-40.7 103.4-103.4L281.2 85.7 192 8z"]
};
var faHouseLeave = faHousePersonLeave;
var faHousePersonDepart = faHousePersonLeave;
var faDownUp = {
  prefix: 'fass',
  iconName: 'down-up',
  icon: [576, 512, [], "e6c1", "M16 352l112 0 0-352 64 0 0 352 112 0-144 160-144-160zM448 160l0 352-64 0 0-352-112 0 144-160 144 160-112 0z"]
};
var faClipboard = {
  prefix: 'fass',
  iconName: 'clipboard',
  icon: [384, 512, [128203], "f328", "M64 0l256 0 0 32 64 0 0 480-384 0 0-480 64 0 0-32zm48 64l0 48 160 0 0-48-160 0z"]
};
var faPlaceOfWorship = {
  prefix: 'fass',
  iconName: 'place-of-worship',
  icon: [512, 512, [], "f67f", "M96 208l64-48 0-96 96-80 96 80 0 96 64 48 0 64 96 48 0 192c-682.7 0-277.3 0-512 0l0-192 96-48 0-64zM320 464l0-144-128 0 0 144 128 0z"]
};
var faCannabis = {
  prefix: 'fass',
  iconName: 'cannabis',
  icon: [512, 512, [], "f55f", "M330.3 199.3c11.2-8.5 23-16.1 34.8-22.8 41-23.3 84.4-36.9 112.2-42.5l23.5-4.7-4.7 23.5c-5.6 27.7-19.3 70.9-42.7 111.7-9.3 16.2-20.4 32.4-33.3 47.2 24.8 6.7 46.3 16.9 60.1 24.6l25.2 14-25.2 14c-14.8 8.2-38.4 19.4-65.5 26-18.9 4.6-40.1 7.2-61.5 4.7 5.5 22 11.1 44.2 16.8 66.8-16.2-8-46.1-22.9-89.6-44.6l0 94.8-48 0 0-94.8c-43.5 21.7-73.4 36.5-89.6 44.6 5.7-22.6 11.3-44.9 16.8-66.8-21.4 2.5-42.6-.1-61.4-4.7-20.3-5-38.7-12.5-52.8-19.4l-12.7-6.6-25.2-14 25.2-14c13.8-7.7 35.2-17.9 60-24.6-12.9-14.8-23.9-30.9-33.2-47.2-23.4-40.8-37.1-84-42.7-111.7l-4.7-23.5 23.5 4.7c27.9 5.5 71.2 19.2 112.2 42.5 11.8 6.7 23.6 14.3 34.8 22.8-3-115.5 73.9-199.3 73.9-199.3s76.9 83.9 73.9 199.3z"]
};
var faFaceZipper = {
  prefix: 'fass',
  iconName: 'face-zipper',
  icon: [576, 512, [], "e3a5", "M527.3 347.3c10.8-28.4 16.8-59.2 16.8-91.3 0-141.4-114.6-256-256-256s-256 114.6-256 256 114.6 256 256 256c32.2 0 63-5.9 91.3-16.8-18.7-18.7-39.8-39.8-63.2-63.2l33.9-33.9 6.1-6.1-28.1 0 0-80 48 0 0 60.1c39.4-39.4 68.7-68.7 88-88 23.4 23.4 44.5 44.5 63.2 63.2zM176.1 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-72 136l0 80-48 0 0-80 48 0zm-80 0l0 80-48 0 0-80 48 0zm320 112l-72-72-80 80 72 72c22.1 22.1 57.9 22.1 80 0s22.1-57.9 0-80zm-56 40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faPeopleRoof = {
  prefix: 'fass',
  iconName: 'people-roof',
  icon: [640, 512, [], "e537", "M334.7-12.6l-14.3-7.2-14.3 7.2-256 128-28.6 14.3 28.6 57.2 28.6-14.3 241.7-120.8 241.7 120.8 28.6 14.3 28.6-57.2-28.6-14.3-256-128zM320.4 272a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0 48c-53 0-96 43-96 96l0 64 192 0 0-64c0-53-43-96-96-96zm-128-64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64.4 416l0 64 112 0 0-80c0-18.4 3.5-36 9.8-52.2-12.2-7.5-26.5-11.8-41.8-11.8-44.2 0-80 35.8-80 80zm400 64l112 0 0-64c0-44.2-35.8-80-80-80-15.3 0-29.6 4.3-41.8 11.8 6.3 16.2 9.8 33.8 9.8 52.2l0 80zm80-224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faPump = {
  prefix: 'fass',
  iconName: 'pump',
  icon: [640, 512, [], "e442", "M128 0l224 0 0 64-32 0 0 320-256 0 0 32-64 0 0-224 64 0 0 32 96 0 0-160-32 0 0-64zM640 96l0 416-272 0 0-416 272 0zM432 192l0 48 144 0 0-48-144 0zm0 88l0 48 144 0 0-48-144 0zm0 88l0 48 144 0 0-48-144 0z"]
};
var faSquareAmpersand = {
  prefix: 'fass',
  iconName: 'square-ampersand',
  icon: [448, 512, [], "e260", "M448 32l-448 0 0 448 448 0 0-448zM136 128l144 0 0 59.7c0 20.4-9.7 39.6-26.2 51.6l-18 13.2 28.6 29.9c20.9-30.1 34.7-50 41.4-59.8l39.5 27.3c-5.8 8.4-21.5 31-47 67.9l60.9 63.6c.8 .8 1.5 1.7 2.2 2.6l-66.1 0-24.8-25.9c-7.8 11.3-13.8 19.9-17.9 25.9l-140.6 0 0-63.7c0-22.9 10.9-44.5 29.4-58.1l21.9-16.1-7.3-7.7c-12.8-13.4-20-31.2-20-49.8l0-60.7zm66.4 89.6l23.1-16.9c4.1-3 6.5-7.8 6.5-12.9l0-11.7-48 0 0 12.7c0 6.2 2.4 12.1 6.7 16.6l11.7 12.2zm-5.6 63.6l-27 19.8c-6.2 4.5-9.8 11.7-9.8 19.4l0 15.7 67.4 0 9.2-13.3-39.8-41.5z"]
};
var faDisease = {
  prefix: 'fass',
  iconName: 'disease',
  icon: [512, 512, [], "f7fa", "M236.5 29.4L224 48c-20 30-53.6 48-89.7 48L68 96c-37.5 0-67.9 30.4-67.9 67.9 0 18 7.2 35.2 19.9 47.9l27 27c11 11 17.2 25.9 17.2 41.5 0 15.8-6.4 30.9-17.7 42L33.4 335.1c-11.1 10.8-17.3 25.7-17.3 41.2 0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6 32.8 0 64.2 14.6 85.2 39.8l30.5 36.6c10.4 12.4 25.7 19.6 41.9 19.6 30.1 0 54.5-24.4 54.5-54.5l0-51.2c0-41.4 25.4-78.5 64-93.5l22.2-8.6c25.2-9.8 41.8-34.1 41.8-61.1 0-26.4-15.9-50.3-40.3-60.5L429 164.8c-33.2-13.9-57.6-43-65.5-78.1l-7.9-35.2c-6.8-30.1-33.5-51.5-64.3-51.5-22 0-42.6 11-54.8 29.4zM192 256l-64 0 0-64 64 0 0 64zm64 32l64 0 0 64-64 0 0-64zm64-64l-64 0 0-64 64 0 0 64z"]
};
var faBookBible = {
  prefix: 'fass',
  iconName: 'book-bible',
  icon: [448, 512, ["bible"], "f647", "M384 0l-384 0 0 512 448 0 0-64-32 0 0-64 32 0 0-384-64 0zM96 384l256 0 0 64-288 0 0-32c0-17.7 14.3-32 32-32zM192 64l64 0 0 64 64 0 0 64-64 0 0 128-64 0 0-128-64 0 0-64 64 0 0-64z"]
};
var faBible = faBookBible;
var faChessBoard = {
  prefix: 'fass',
  iconName: 'chess-board',
  icon: [448, 512, [], "f43c", "M448 32l-448 0 0 448 448 0 0-448zM128 96l0 64 64 0 0-64 64 0 0 64 64 0 0-64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64 64 0 0-64-64 0 0-64 64 0 0-64-64 0 0-64 64 0zm64 128l64 0 0-64-64 0 0 64zm0 64l0-64-64 0 0 64 64 0zm64 0l-64 0 0 64 64 0 0-64zm0 0l64 0 0-64-64 0 0 64z"]
};
var faSprinkler = {
  prefix: 'fass',
  iconName: 'sprinkler',
  icon: [512, 512, [], "e035", "M24 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM0 128a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM0 232a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm360 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM488 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM448 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-40-32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM288 64l0 192 128 0 0 40-96 88 0 128-128 0 0-128-96-88 0-40 128 0 0-192 64 0z"]
};
var faGunSquirt = {
  prefix: 'fass',
  iconName: 'gun-squirt',
  icon: [576, 512, [], "e19d", "M128 32l0 32 416 0 0 64 32 0 0 64-32 0 0 64-296 0-18 72 42 0 0-40 48 0 0 128-48 0 0-40-54 0-26 104-160 0 56.1-224.3C38.8 251.7 0 210.4 0 160 0 112.4 34.6 72.9 80 65.3l0-33.3 48 0zm352 96l-416 0 0 64 416 0 0-64z"]
};
var faMugMarshmallows = {
  prefix: 'fass',
  iconName: 'mug-marshmallows',
  icon: [576, 512, [], "f7b7", "M416 0l0 80-320 0 0-48 160 0 0-32 160 0zM64 128l80 0 0 128 48 0 0-128 256 0c70.7 0 128 57.3 128 128S518.7 384 448 384l0 96-384 0 0-352zM448 320c35.3 0 64-28.7 64-64s-28.7-64-64-64l0 128z"]
};
var faCircleHeart = {
  prefix: 'fass',
  iconName: 'circle-heart',
  icon: [512, 512, ["heart-circle"], "f4c7", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-6.4-312.5l6.4 8.5 6.4-8.5c11.1-14.8 28.5-23.5 46.9-23.5 32.4 0 58.7 26.3 58.7 58.7l0 5.3c0 64-112 128-112 128S144 304 144 240l0-5.3c0-32.4 26.3-58.7 58.7-58.7 18.5 0 35.9 8.7 46.9 23.5z"]
};
var faHeartCircle = faCircleHeart;
var faUserHatTieMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'user-hat-tie-magnifying-glass',
  icon: [576, 512, [], "e7af", "M96 80l48-112 32 0 48 32 48-32 32 0 48 112 48 0 0 48-48 0 0 14.8c0 26.5-8.1 51.2-21.9 71.6-33.1 9.4-62 28.6-83.4 54.4-7.4 1.3-15 2-22.7 2-70.7 0-128-57.3-128-128l0-14.8-48 0 0-48 48 0zM208 376.1c0 55.9 27.3 105.4 69.2 135.9l-261.2 0 64-192 56 0 40 160 31.4-115.3-31.4-36.7 0-24 48.2 0c-10.4 21.8-16.2 46.3-16.2 72.1zM144 142.8c0 44.2 35.8 80 80 80s80-35.8 80-80l0-14.8-160 0 0 14.8zM376 448.1a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 48c-66.3 0-120-53.7-120-120s53.7-120 120-120 120 53.7 120 120c0 24.5-7.3 47.2-19.9 66.2 47.9 47.9 73.8 73.8 77.8 77.8L520 554c-4-4-29.9-29.9-77.8-77.8-19 12.6-41.7 19.9-66.2 19.9z"]
};
var faDiagramSankey = {
  prefix: 'fass',
  iconName: 'diagram-sankey',
  icon: [576, 512, [], "e158", "M308.4 64l235.6 0 0 64-212.4 0-87.1 72.6-8.9 7.4-235.6 0 0-64 212.4 0 87.1-72.6 8.9-7.4zM144 320l-144 0 0-64 544 0 0 64-320 0 48 64 272 0 0 64-304 0-9.6-12.8-86.4-115.2z"]
};
var faSunset = {
  prefix: 'fass',
  iconName: 'sunset',
  icon: [576, 512, [127751], "f767", "M305.2 185c50.5-50.5 77.5-77.5 81-81L352.2 70.1c-10.3 10.3-23.6 23.6-40 40l0-126.1-48 0 0 126.1-40-40-33.9 33.9c3.5 3.5 30.5 30.5 81 81l17 17 17-17zM203.5 207.5l-29.7-19.7c-2.5 12.5-11.6 57.4-27.2 134.6-77.2 15.6-122.1 24.7-134.6 27.2 12.4 18.6 27.1 40.8 44.1 66.4l113.5 0c19-46.9 65-80 118.7-80s99.7 33.1 118.7 80l113.5 0c17-25.6 31.7-47.8 44.1-66.4-12.5-2.5-57.4-11.6-134.6-27.2-15.6-77.2-24.7-122.1-27.2-134.6-10.6 7.1-48.8 32.4-114.4 75.9l-84.7-56.2zM32.2 464l0 48 512 0 0-48-512 0z"]
};
var faCircleEquals = {
  prefix: 'fass',
  iconName: 'circle-equals',
  icon: [512, 512, [], "e6b1", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM160 176l192 0 0 48-192 0 0-48zm0 112l192 0 0 48-192 0 0-48z"]
};
var faMars = {
  prefix: 'fass',
  iconName: 'mars',
  icon: [512, 512, [9794], "f222", "M320 0l192 0 0 192-64 0 0-82.7-95 95c19.5 28.4 31 62.7 31 99.8 0 97.2-78.8 176-176 176S32 401.2 32 304 110.8 128 208 128c37 0 71.4 11.4 99.8 31l95-95-82.7 0 0-64zM208 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
var faUserVneckHairMullet = {
  prefix: 'fass',
  iconName: 'user-vneck-hair-mullet',
  icon: [448, 512, [], "e7ba", "M144 144l0-32 64 0 16-48 16 48 64 0 0 32c0 44.2-35.8 80-80 80s-80-35.8-80-80zm208 0l0-32 16 0 0-48-26.8 0C323.2 26.2 284.7 0 240 0L208 0c-44.7 0-83.2 26.2-101.2 64l-26.8 0 0 48 16 0 0 32c0 25.1 7.3 48.6 19.8 68.4L80 272 368 272 332.2 212.4C344.7 192.6 352 169.1 352 144zM224 384l-64-64-80 0-64 192 416 0-64-192-80 0-64 64z"]
};
var faLaptop = {
  prefix: 'fass',
  iconName: 'laptop',
  icon: [640, 512, [128187], "f109", "M96 32l-32 0 0 304 64 0 0-240 384 0 0 240 64 0 0-304-480 0zM0 384l0 40 56 56 528 0 56-56 0-40-640 0z"]
};
var faUserXmark = {
  prefix: 'fass',
  iconName: 'user-xmark',
  icon: [640, 512, ["user-times"], "f235", "M104.4 128a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zm264 176l64 208-416 0 64-208 288 0zM629.2 141.1c-8.5 8.5-25.5 25.5-50.9 50.9 25.5 25.5 42.4 42.4 50.9 50.9l-33.9 33.9-50.9-50.9c-25.5 25.5-42.4 42.4-50.9 50.9l-33.9-33.9c8.5-8.5 25.5-25.5 50.9-50.9-25.5-25.5-42.4-42.4-50.9-50.9l33.9-33.9c8.5 8.5 25.5 25.5 50.9 50.9 25.5-25.5 42.4-42.4 50.9-50.9l33.9 33.9z"]
};
var faUserTimes = faUserXmark;
var faFlagUsa = {
  prefix: 'fass',
  iconName: 'flag-usa',
  icon: [448, 512, [], "f74d", "M64 0l0 48 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5 46.3 23.2 100.8 23.2 147.1 0l54.4-27.2 0 86.2-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9l0 32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4l33.7-12.3 0 62-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3l-63.5 13.6 0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4l33.7-12.3 0 61.9-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3l-63.5 13.6 0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4l33.7-12.3 0 55.7-55.5 20.8c-46.2 17.3-97.6 14.6-141.7-7.4-37.9-19-81.4-23.7-122.5-13.4L64 400 64 512 0 512 0 0 64 0zm48 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faHandMiddleFinger = {
  prefix: 'fass',
  iconName: 'hand-middle-finger',
  icon: [448, 512, [128405], "f806", "M272 0l-80 0 0 192-80 0 0 144-32 0 0-72-48 40 0 57.5c0 44.7 19.8 87 54.1 115.6 27 22.5 61.1 34.9 96.3 34.9L304 512c70.7 0 128-57.3 128-128l0-144-80 0 0-32-80 0 0-208z"]
};
var faAlt = {
  prefix: 'fass',
  iconName: 'alt',
  icon: [640, 512, [], "e08a", "M448 64l-15.4 0-9.6 12-246.4 308-176.6 0 0 64 207.4 0 9.6-12 246.4-308 176.6 0 0-64-192 0zm0 320l-32 0 0 64 224 0 0-64-192 0z"]
};
var faMortarPestle = {
  prefix: 'fass',
  iconName: 'mortar-pestle',
  icon: [512, 512, [], "f5a7", "M469.5 0L252.3 160 397.3 160 510.1 47.2 469.5 0zM32 192l-32 0 0 64 32 0c0 82.5 43.4 147.7 123.9 176.2-17.4 21.9-27.9 49.6-27.9 79.8l256 0c0-30.2-10.4-57.9-27.9-79.8 80.5-28.6 123.9-93.7 123.9-176.2l32 0 0-64-480 0z"]
};
var faBanana = {
  prefix: 'fass',
  iconName: 'banana',
  icon: [640, 512, [], "e2e5", "M385.6 10.4c58.2 52.7 94.8 128.9 94.8 213.6 0 12.3-.8 24.4-2.3 36.3l-115.9 24.4-50.8-30.1c16.1-33.5 25-71 25-110.6 0-31.4-5.6-61.3-15.9-89l65.1-44.6zm-29 308.2c204.4-43 125.1-26.3 155.6-32.8l9.2 9.2 80 80 17 17-33.9 33.9-87.8-87.8-43.9 9.3C406.5 444.7 307.3 512 192.4 512l-160 0 0-112 48 0c72.9 0 138.7-30.5 185.4-79.4l-22.1-13.1c-63.3 33-97.1 50.6-101.4 52.9l-22.2-42.6c2.4-1.2 40.2-21 113.3-59.1l11.8-6.2c4.4 2.6 83 49.2 111.5 66z"]
};
var faUmbrellaSimple = {
  prefix: 'fass',
  iconName: 'umbrella-simple',
  icon: [512, 512, ["umbrella-alt"], "e2bc", "M288-32l0 34C414.3 17.7 512 125.5 512 256L0 256C0 125.5 97.7 17.7 224 2l0-34 64 0zm0 459.9c0 46.5-37.7 84.1-84.1 84.1-28.1 0-54.4-14.1-70-37.5l-.5-.8-17.8-26.6 53.3-35.5 17.8 26.6 .5 .8c3.7 5.6 10 9 16.7 9 11.1 0 20.1-9 20.1-20.1l0-123.9 64 0 0 123.9z"]
};
var faUmbrellaAlt = faUmbrellaSimple;
var faJoystick = {
  prefix: 'fass',
  iconName: 'joystick',
  icon: [448, 512, [128377], "f8c5", "M448 512l-448 0 0-160 448 0 0 160zM224 0c61.9 0 112 50.1 112 112 0 50.7-33.7 93.5-80 107.3l0 84.7-64 0 0-84.7c-46.3-13.8-80-56.6-80-107.3 0-61.9 50.1-112 112-112zM200 48a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faHeadSideCough = {
  prefix: 'fass',
  iconName: 'head-side-cough',
  icon: [512, 512, [], "e061", "M0 512l256 0 0-192 64 0 0-64-49.7-59.6C256.7 85.7 162.4 0 48 0 31.5 0 15.5 1.8 0 5.2L0 512zM112 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 232l0-40 96-24 0 72-96-8zM480 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm128 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM480 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faPlaneLock = {
  prefix: 'fass',
  iconName: 'plane-lock',
  icon: [640, 512, [], "e558", "M288-32c-30.9 0-56 25.1-56 56l0 127.3-184 168.7 0 80 184-61.3 0 99.7-72 57.6 0 48 128-32 80 20 0-228 32 0c0-29.1 9.7-55.9 26.1-77.4L344 151.3 344 24c0-30.9-25.1-56-56-56zM496 304c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48-64 0 0-48zm-48 48l-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48z"]
};
var faBatteryThreeQuarters = {
  prefix: 'fass',
  iconName: 'battery-three-quarters',
  icon: [640, 512, ["battery-4"], "f241", "M544 128l0 256-448 0 0-256 448 0zM96 64l-64 0 0 384 576 0 0-128 32 0 0-128-32 0 0-128-512 0zM416 176l-272 0 0 160 272 0 0-160z"]
};
var faBattery4 = faBatteryThreeQuarters;
var faFrancSign = {
  prefix: 'fass',
  iconName: 'franc-sign',
  icon: [320, 512, [], "e18f", "M320 32l-272 0 0 288-48 0 0 48 48 0 0 112 64 0 0-112 112 0 0-48-112 0 0-64 176 0 0-64-176 0 0-96 208 0 0-64z"]
};
var faTripleChevronsRight = {
  prefix: 'fass',
  iconName: 'triple-chevrons-right',
  icon: [640, 512, [], "e7f9", "M237.5 256L64.3 429.3 19 384 147 256 19 128 64.3 82.8 237.5 256zm192 0L256.3 429.3 211 384 339 256 211 128 256.3 82.8 429.5 256zm192 0L448.3 429.3 403 384 531 256 403 128 448.3 82.8 621.5 256z"]
};
var faFilterCircleDollar = {
  prefix: 'fass',
  iconName: 'filter-circle-dollar',
  icon: [640, 512, ["funnel-dollar"], "f662", "M224 416l66.7 66.6c-12-25-18.7-53.1-18.7-82.6 0-86.4 57.1-159.5 135.6-183.6L560 64 16 64 224 272 224 416zm384-16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM480 328l32 0 0 32-61.8 0c-5.6 0-10.2 4.6-10.2 10.2 0 4.9 3.5 9.1 8.3 10l45 8.2c20 3.6 34.6 21.1 34.6 41.5 0 23.3-18.9 42.2-42.2 42.2l-5.8 0 0 24-32 0 0-24-32 0 0-32 69.8 0c5.6 0 10.2-4.6 10.2-10.2 0-4.9-3.5-9.1-8.3-10l-45-8.2c-20-3.6-34.6-21.1-34.6-41.5 0-22.6 17.7-41 40-42.1l0-24.1 32 0 0 24z"]
};
var faFunnelDollar = faFilterCircleDollar;
var faCheese = {
  prefix: 'fass',
  iconName: 'cheese',
  icon: [512, 512, [], "f7ef", "M0 256L288 32c123.7 0 224 100.3 224 224L0 256zm512 48l0 176-512 0 0-176 512 0z"]
};
var faCircleH = {
  prefix: 'fass',
  iconName: 'circle-h',
  icon: [512, 512, [9405, "hospital-symbol"], "f47e", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm96-344l0 200-48 0 0-88-96 0 0 88-48 0 0-224 48 0 0 88 96 0 0-88 48 0 0 24z"]
};
var faHospitalSymbol = faCircleH;
var faBoxBallot = {
  prefix: 'fass',
  iconName: 'box-ballot',
  icon: [512, 512, [128499], "f735", "M238.6 256L270.6 256 424 102.6 273.4-48 104 121.4 238.6 256zM416 256l0 48-320 0 0-48 74.7 0c-79.3-79.3-122-122-128-128l-42.7 0 0 224 512 0 0-224-45.5 0-8.5 8.5-119.5 119.5 77.5 0zM0 512l512 0 0-112-512 0 0 112z"]
};
var faLocationCheck = {
  prefix: 'fass',
  iconName: 'location-check',
  icon: [384, 512, ["map-marker-check"], "f606", "M192 0C298 0 384 84.4 384 188.6 384 339.4 192 528 192 528S0 339.4 0 188.6C0 84.4 86 0 192 0zm57.4 137.9L163.8 255.6c-19.3-20-33.7-34.9-43.2-44.7L86.1 244.2c6.2 6.4 27.2 28.1 63.1 65.2l19.8 20.6 16.8-23.1 102.4-140.8 14.1-19.4-38.8-28.2-14.1 19.4z"]
};
var faMapMarkerCheck = faLocationCheck;
var faTilde = {
  prefix: 'fass',
  iconName: 'tilde',
  icon: [512, 512, [63135], "7e", "M0 128l173.3 0 9.4 9.4 182.6 182.6 82.7 0 0-160 64 0 0 224-173.3 0-9.4-9.4-182.6-182.6-82.7 0 0 160-64 0 0-224z"]
};
var faCommentMiddle = {
  prefix: 'fass',
  iconName: 'comment-middle',
  icon: [512, 512, [], "e149", "M191.5 440.8L256 544 320.5 440.8C430.6 415.8 512 328.2 512 224 512 100.3 397.4 0 256 0S0 100.3 0 224C0 328.2 81.4 415.8 191.5 440.8z"]
};
var faArrowLeftFromDottedLine = {
  prefix: 'fass',
  iconName: 'arrow-left-from-dotted-line',
  icon: [576, 512, [], "e6b9", "M19 256l22.6 22.6 128 128 22.6 22.6 45.3-45.3-96-96 274.7 0 0-64-274.7 0c57.4-57.4 89.4-89.4 96-96l-45.3-45.3-22.6 22.6-128 128-22.6 22.6zM480.3 64l0 64 64 0 0-64-64 0zm0 170.7l64 0 0-64-64 0 0 64zm0 42.7l0 64 64 0 0-64-64 0zm0 170.7l64 0 0-64-64 0 0 64z"]
};
var faUTurnLeftDown = {
  prefix: 'fass',
  iconName: 'u-turn-left-down',
  icon: [576, 512, ["u-turn"], "e7f1", "M304 0C189.1 0 96 93.1 96 208l0 144-96 0 160 160 160-160-96 0 0-144c0-44.2 35.8-80 80-80s80 35.8 80 80l0 240 128 0 0-240C512 93.1 418.9 0 304 0z"]
};
var faUTurn = faUTurnLeftDown;
var faArrowDownFromBracket = {
  prefix: 'fass',
  iconName: 'arrow-down-from-bracket',
  icon: [448, 512, [], "e667", "M246.6 486.6l-22.6 22.6-22.6-22.6-128-128-22.6-22.6 45.3-45.3c6.6 6.6 38.6 38.6 96 96l0-226.7 64 0 0 226.7 96-96 45.3 45.3-150.6 150.6zM64 160l0 32-64 0 0-192 448 0 0 192-64 0 0-128-320 0 0 96z"]
};
var faSchool = {
  prefix: 'fass',
  iconName: 'school',
  icon: [576, 512, [127979], "f549", "M0 128l128 0 160-128 160 128 128 0 0 384-576 0 0-384zM352 336l-128 0 0 128 128 0 0-128zM64 384l64 0 0-64-64 0 0 64zm64-128l0-64-64 0 0 64 64 0zM448 384l64 0 0-64-64 0 0 64zm64-128l0-64-64 0 0 64 64 0zm-224 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faEarMuffs = {
  prefix: 'fass',
  iconName: 'ear-muffs',
  icon: [512, 512, [], "f795", "M256 64c-70.7 0-128 57.3-128 128l0 32 32 0 0 64c0 11.6-3.1 22.6-8.6 32 5.4 9.4 8.6 20.4 8.6 32s-3.1 22.6-8.6 32c5.4 9.4 8.6 20.4 8.6 32l0 64-80 0c-35.3 0-64-28.7-64-64 0-6.5 1-12.8 2.8-18.7-11.6-11.6-18.8-27.6-18.8-45.3s7.2-33.7 18.8-45.3c-1.8-5.9-2.8-12.2-2.8-18.7 0-29.8 20.4-54.9 48-62l0-34C64 86 150 0 256 0S448 86 448 192l0 34c27.6 7.1 48 32.2 48 62 0 6.5-1 12.8-2.8 18.7 11.6 11.6 18.8 27.6 18.8 45.3s-7.2 33.7-18.8 45.3c1.8 5.9 2.8 12.2 2.8 18.7 0 35.3-28.7 64-64 64l-80 0 0-64c0-11.6 3.1-22.6 8.6-32-5.4-9.4-8.6-20.4-8.6-32s3.1-22.6 8.6-32c-5.4-9.4-8.6-20.4-8.6-32l0-64 32 0 0-32c0-70.7-57.3-128-128-128z"]
};
var faClockSeven = {
  prefix: 'fass',
  iconName: 'clock-seven',
  icon: [512, 512, [], "e350", "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 128.7c-47.7 71.6-72.2 108.3-73.3 109.9l39.9 26.6c.4-.6 26.2-39.3 77.3-116l4-6 0-167.3-48 0 0 24z"]
};
var faDiceFive = {
  prefix: 'fass',
  iconName: 'dice-five',
  icon: [448, 512, [9860], "f523", "M448 32l-448 0 0 448 448 0 0-448zM128 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faTornado = {
  prefix: 'fass',
  iconName: 'tornado',
  icon: [448, 512, [127786], "f76f", "M0 0L0 45.6C0 62.7 1.7 79.6 5 96l352.8 0c3.2-6.9 7.5-13.3 13-18.8L416 32 416 0 0 0zM355.7 144l-336 0c12.4 29.7 30.2 56.8 52.7 80l339.6 0-47.2-62.9c-3.9-5.2-7-11-9.2-17.1zM242.6 334.7c8.2 4.8 15.8 10.7 22.5 17.3l178.6 0c2.8-11 4.3-22.5 4.3-34.1 0-15.7-2.7-31.2-7.9-45.9L136 272 242.6 334.7zM294.3 400c5.3 17 6.5 35.2 3.6 53l-9.8 59 108.4-86.7c9.3-7.4 17.5-16 24.4-25.3l-126.5 0z"]
};
var faArrowLeftToLine = {
  prefix: 'fass',
  iconName: 'arrow-left-to-line',
  icon: [512, 512, [8676, "arrow-to-left"], "f33e", "M0 416l0 32 64 0 0-384-64 0 0 352zM137.4 233.4l-22.6 22.6 22.6 22.6 128 128 22.6 22.6 45.3-45.3c-6.6-6.6-38.6-38.6-96-96l274.7 0 0-64-274.7 0c57.4-57.4 89.4-89.4 96-96l-45.3-45.3-22.6 22.6-128 128z"]
};
var faArrowToLeft = faArrowLeftToLine;
var faJetFighter = {
  prefix: 'fass',
  iconName: 'jet-fighter',
  icon: [576, 512, ["fighter-jet"], "f0fb", "M480 200l-118 0-114-152 72 0 0-48-192 0 0 48 32 0 0 152-54.4 0-57.6-72-48 0 0 104 64 0 0 48-64 0 0 104 48 0 57.6-72 54.4 0 0 152-32 0 0 48 192 0 0-48-72 0 114-152 118 0 96-40 0-32-96-40z"]
};
var faFighterJet = faJetFighter;
var faPersonBikingMountain = {
  prefix: 'fass',
  iconName: 'person-biking-mountain',
  icon: [640, 512, [128693, "biking-mountain"], "f84b", "M400 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM336 88l91.2 72 84.8 0 0 64-107.2 0-49.5-39.6-60.3 48.5 57 38 0 177.1-64 0 0-142.9-60.5-38.4c-32.8-20.8-35-67.9-4.3-91.6L336 88zM536 274.6c13.1 2.9 25.4 8 36.4 15.1l13.1-13.1 33.9 33.9-13.1 13.1c7 11 12.2 23.3 15.1 36.4l18.6 0 0 48-18.6 0c-2.9 13.1-8 25.4-15.1 36.4l13.1 13.1-33.9 33.9-13.1-13.1c-11 7-23.3 12.2-36.4 15.1l0 18.6-48 0 0-18.6c-13.1-2.9-25.4-8-36.4-15.1l-13.1 13.1-33.9-33.9 13.1-13.1c-7-11-12.2-23.3-15.1-36.4l-18.6 0 0-48 18.6 0c2.9-13.1 8-25.4 15.1-36.4l-13.1-13.1 33.9-33.9 13.1 13.1c11-7 23.3-12.2 36.4-15.1l0-18.6 48 0 0 18.6zM512 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM152 256l0 18.6c13.1 2.9 25.4 8 36.4 15.1l13.1-13.1 33.9 33.9-13.1 13.1c7 11 12.2 23.3 15.1 36.4l18.6 0 0 48-18.6 0c-2.9 13.1-8 25.4-15.1 36.4l13.1 13.1-33.9 33.9-13.1-13.1c-11 7-23.3 12.2-36.4 15.1l0 18.6-48 0 0-18.6c-13.1-2.9-25.4-8-36.4-15.1l-13.1 13.1-33.9-33.9 13.1-13.1c-7-11-12.2-23.3-15.1-36.4l-18.6 0 0-48 18.6 0c2.9-13.1 8-25.4 15.1-36.4l-13.1-13.1 33.9-33.9 13.1 13.1c11-7 23.3-12.2 36.4-15.1l0-18.6 48 0zm40 128a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faBikingMountain = faPersonBikingMountain;
var faThumbsDown = {
  prefix: 'fass',
  iconName: 'thumbs-down',
  icon: [512, 512, [128078, 61576], "f165", "M432 32l0 64 32 0 0 64 16 0 0 80 16 0 0 112-208 0 48 96-96 48-80-144 0-256 96-64 176 0zM112 96l0 320-112 0 0-320 112 0z"]
};
var faFunction = {
  prefix: 'fass',
  iconName: 'function',
  icon: [640, 512, [], "f661", "M64 0l160 0 0 64-96 0 0 128 64 0 0 64-64 0 0 224-128 0 0-64 64 0 0-160-64 0 0-64 64 0 0-192zM288 320c0 52.7 15.7 101.6 42.7 142.3l-53.4 35.3C243.6 446.7 224 385.6 224 320s19.6-126.7 53.3-177.7l53.4 35.3C303.7 218.4 288 267.3 288 320zm288 0c0-52.7-15.7-101.6-42.7-142.3l53.4-35.3C620.4 193.3 640 254.4 640 320s-19.6 126.7-53.3 177.7l-53.4-35.3c27-40.7 42.7-89.6 42.7-142.3zM398.6 241.4L432 274.7c24-24 42.7-42.7 56-56l45.3 45.3-56 56 56 56-45.3 45.3-56-56-56 56-45.3-45.3 56-56-56-56 45.3-45.3 22.6 22.6z"]
};
var faBroom = {
  prefix: 'fass',
  iconName: 'broom',
  icon: [576, 512, [129529], "f51a", "M416 288l-40-40 200-200-48-48-200 200-40-40-32 0 0 51.7 108.3 108.3 51.7 0 0-32zm-74.9 65.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3-27.4 27.4-42.8 64.6-42.8 103.4l0 3.5 96-48-160 144 0 32 195.5 0c38.8 0 75.9-15.4 103.4-42.8 30.6-30.6 45.9-73.1 42.3-115.8z"]
};
var faDiscDrive = {
  prefix: 'fass',
  iconName: 'disc-drive',
  icon: [512, 512, [], "f8b5", "M32 32l448 0 0 384 32 0 0 64-512 0 0-64 32 0 0-384zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192 0a160 160 0 1 0 -320 0 160 160 0 1 0 320 0z"]
};
var faGrill = {
  prefix: 'fass',
  iconName: 'grill',
  icon: [448, 512, [], "e5a3", "M0 32l448 0 0 64c0 89.8-52.9 167.3-129.2 203l55.2 128.9c1.8 4.1 6.2 14.6 13.5 31.4l-44.1 18.9c-14.5-33.8-15.2-35.4-26.6-62.2L160 416c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L129.2 299C52.9 263.3 0 185.8 0 96L0 32zM151.8 368l144.4 0-22.9-53.4c-15.9 3.6-32.3 5.4-49.3 5.4s-33.4-1.9-49.3-5.4L151.8 368zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFileImport = {
  prefix: 'fass',
  iconName: 'file-import',
  icon: [384, 512, ["arrow-right-to-file"], "f56f", "M240 0L0 0 0 304 182.1 304c-23-23-39-39-48-48L168 222.1c2.1 2.1 31.8 31.8 89 89l17 17c-2.1 2.1-31.8 31.8-89 89l-17 17-33.9-33.9c9-9 25-25 48-48L0 352 0 512 384 512 384 144 240 0zm85.5 176L208 176 208 58.5 325.5 176z"]
};
var faArrowRightToFile = faFileImport;
var faJug = {
  prefix: 'fass',
  iconName: 'jug',
  icon: [448, 512, [], "f8c6", "M160-16l160 0 0 64-192 0 0-64 32 0zM359 151l-3.7 3.7 31.7 36.2 5.9-5.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zm67.9 67.9l-10.9 10.9 0 282.2-384 0 0-288 112-128 160 0 19.7 22.5 1.4-1.4c28.1-28.1 73.7-28.1 101.8 0s28.1 73.7 0 101.8zM352 288l-256 0 0 128 256 0 0-128z"]
};
var faUtensils = {
  prefix: 'fass',
  iconName: 'utensils',
  icon: [512, 512, [127860, 61685, "cutlery"], "f2e7", "M32.1-1.5L17.9 149.8c-1.2 5.9-1.9 12-1.9 18.1 0 45.9 35.1 83.6 80 87.7l0 256.4 64 0 0-256.4c44.9-4.1 80-41.8 80-87.7 0-6.1-.6-12.1-1.9-18.1l-14.2-151.3-31.9 0-14.7 161.4-20.1 0-13.3-161.3-31.9 0-13.3 161.3-20.1 0-14.7-161.4-31.9 0zM480 0C432 0 320 32 320 176l0 176 96 0 0 160 64 0 0-512z"]
};
var faCutlery = faUtensils;
var faIdBadge = {
  prefix: 'fass',
  iconName: 'id-badge',
  icon: [384, 512, [], "f2c1", "M384 0L0 0 0 512 384 512 384 0zM272 352l32 96-224 0 32-96 160 0zM136 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM152 64l104 0 0 48-128 0 0-48 24 0z"]
};
var faSpider = {
  prefix: 'fass',
  iconName: 'spider',
  icon: [512, 512, [128375], "f717", "M398.5 22.8l40 96 6.2 14.8-75.5 75.4 76.4-20.8c15.4-46.1 24.5-73.6 27.5-82.6l45.5 15.2-7.6 22.8-28.1 84.2-12.4 3.4-91.2 24.8 91.2 24.9 12.4 3.4 28.1 84.2 7.6 22.8-45.5 15.2c-3-9-12.2-36.5-27.5-82.6l-76.4-20.8 75.5 75.5-6.2 14.8-40 96-9.2 22.2-44.3-18.4 9.2-22.2 33.8-81.2-35.8-35.8c-1 52.2-43.5 94.1-95.9 94.1s-95-42-96-94.1l-35.7 35.8 33.8 81.2 9.2 22.2-44.3 18.4-9.2-22.2-40-96-6.2-14.8 75.4-75.5-76.3 20.8c-15.4 46.1-24.5 73.6-27.5 82.6l-45.5-15.2 7.6-22.8 28.1-84.2 12.4-3.4 91.1-24.9-91.1-24.8-12.4-3.4-28.1-84.2-7.6-22.8 45.5-15.2c3 9 12.2 36.5 27.5 82.6l76.4 20.8-75.4-75.4 6.2-14.8 40-96 9.2-22.2 44.3 18.4-9.2 22.2-33.8 81.2 51.7 51.8c1-43.3 36.4-78.1 79.9-78.1s78.9 34.8 79.9 78.1l51.8-51.8-33.8-81.2-9.2-22.2 44.3-18.4 9.2 22.2z"]
};
var faUserQuestion = {
  prefix: 'fass',
  iconName: 'user-question',
  icon: [576, 512, [], "e7b7", "M104.4 128a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zm264 176l64 208-416 0 64-208 288 0zm128-186.8c-17.7 0-32 14.3-32 32l-42.4 0c0-41.1 33.3-74.4 74.4-74.4s74.4 33.3 74.4 74.4c0 33.5-22.8 59-53.2 69.6l0 18.3-42.4 0 0-53.5 3.3-.5c21.1-3 49.9-7.1 49.9-34 0-17.7-14.3-32-32-32zM472.4 264l48 0 0 48-48 0 0-48z"]
};
var faPersonFairy = {
  prefix: 'fass',
  iconName: 'person-fairy',
  icon: [576, 512, [], "e608", "M288 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm96 352l-32 0 0 160-128 0 0-160-32 0 0-192 192 0 0 192zM0 56l64 0c52.9 0 100.8 21.4 135.5 56l-55.5 0 0 288 32 0 0 30.7c-14.8 6-31 9.3-48 9.3l-64 0 0-48c0-39.5 17.9-74.8 46-98.3-65-30.7-110-97-110-173.7L0 56zM448 440c-17 0-33.2-3.3-48-9.3l0-30.7 32 0 0-288-55.5 0C411.2 77.4 459.1 56 512 56l64 0 0 64c0 76.7-45 142.9-110 173.7 28.1 23.5 46 58.8 46 98.3l0 48-64 0z"]
};
var faMobileRetro = {
  prefix: 'fass',
  iconName: 'mobile-retro',
  icon: [384, 512, [], "e527", "M16 0l352 0 0 512-352 0 0-512zM96 128l0 128 192 0 0-128-192 0zM216 304l-48 0 0 48 48 0 0-48zm-48 96l0 48 48 0 0-48-48 0zm136 0l-48 0 0 48 48 0 0-48zM80 400l0 48 48 0 0-48-48 0zm224-96l-48 0 0 48 48 0 0-48zM80 304l0 48 48 0 0-48-48 0zM168 40l-24 0 0 48 96 0 0-48-72 0z"]
};
var faSignsPost = {
  prefix: 'fass',
  iconName: 'signs-post',
  icon: [512, 512, ["map-signs"], "f277", "M288 0l-64 0 0 64-192 0 0 128 192 0 0 64-160 0-64 64 64 64 160 0 0 128 64 0 0-128 192 0 0-128-192 0 0-64 160 0 64-64-64-64-160 0 0-64z"]
};
var faMapSigns = faSignsPost;
var faGroupArrowsRotate = {
  prefix: 'fass',
  iconName: 'group-arrows-rotate',
  icon: [512, 512, [], "e4f6", "M37.6 122.3c-11.5 18.7-20.6 39-27 60.5l61.3 18.3C90.4 139.2 139.2 90.4 201.1 71.9L182.9 10.6C161.4 17 141.1 26.1 122.3 37.6 112.3 15.4 89.9 0 64 0 28.7 0 0 28.7 0 64 0 89.9 15.4 112.3 37.6 122.3zm436.7 0c22.2-10 37.6-32.4 37.6-58.3 0-35.3-28.7-64-64-64-25.9 0-48.3 15.4-58.3 37.6-18.7-11.5-39-20.6-60.5-27L310.9 71.9c61.9 18.4 110.8 67.3 129.2 129.2l61.3-18.3c-6.4-21.5-15.5-41.8-27-60.5zM512 448c0-25.9-15.4-48.3-37.6-58.3 11.5-18.7 20.6-39 27-60.5l-61.3-18.3c-18.4 61.9-67.3 110.8-129.2 129.2l18.3 61.3c21.5-6.4 41.8-15.5 60.5-27 10 22.2 32.4 37.6 58.3 37.6 35.3 0 64-28.7 64-64zM37.6 389.7c-22.2 10-37.6 32.4-37.6 58.3 0 35.3 28.7 64 64 64 25.9 0 48.3-15.4 58.3-37.6 18.7 11.5 39 20.6 60.5 27l18.3-61.3C139.2 421.6 90.4 372.8 71.9 310.9L10.6 329.1c6.4 21.5 15.5 41.8 27 60.5zM360 144l-28.9 28.9c-19.8-17.9-46.2-28.9-75.1-28.9-43.6 0-81.3 24.9-99.8 61.1L199 226.9c10.6-20.8 32.2-34.9 57-34.9 15.6 0 30 5.6 41.1 14.9l-33.1 33.1 96 0 0-96zM314.6 285.1c-10.6 20.8-32.2 34.9-57 34.9-15.7 0-30-5.6-41.1-14.9l33.1-33.1-96 0 0 96 28.9-28.9c19.8 17.9 46.2 28.9 75.1 28.9 43.6 0 81.3-24.9 99.8-61.1l-42.7-21.8z"]
};
var faDiagramVenn = {
  prefix: 'fass',
  iconName: 'diagram-venn',
  icon: [640, 512, [], "e15a", "M224 416c-88.4 0-160-71.6-160-160S135.6 96 224 96c11 0 21.7 1.1 32 3.2-39.6 40.4-64 95.7-64 156.8s24.4 116.4 64 156.8c-10.3 2.1-21.1 3.2-32 3.2zm0 64c34.4 0 66.9-7.7 96-21.6 29.1 13.8 61.6 21.6 96 21.6 123.7 0 224-100.3 224-224S539.7 32 416 32C381.6 32 349.1 39.7 320 53.6 290.9 39.7 258.4 32 224 32 100.3 32 0 132.3 0 256S100.3 480 224 480zM416 96c88.4 0 160 71.6 160 160S504.4 416 416 416c-11 0-21.7-1.1-32-3.2 39.6-40.4 64-95.7 64-156.8S423.6 139.6 384 99.2C394.3 97.1 405 96 416 96z"]
};
var faArrowsSplitUpAndLeft = {
  prefix: 'fass',
  iconName: 'arrows-split-up-and-left',
  icon: [576, 512, [], "e4bc", "M374.9-22.6L352.3-45.3c-2.9 2.9-42.4 42.4-118.6 118.6L211 96 256.3 141.3c12-12 33.3-33.3 64-64l0 178.7-178.7 0c30.7-30.7 52-52 64-64l-45.3-45.3c-2.9 2.9-42.4 42.4-118.6 118.6L19 288c2.9 2.9 42.4 42.4 118.6 118.6l22.6 22.6 45.3-45.3-64-64 178.7 0 0 192 192 0 0-64-128 0 0-370.7 64 64 45.3-45.3c-2.9-2.9-42.4-42.4-118.6-118.6z"]
};
var faImagePolaroidUser = {
  prefix: 'fass',
  iconName: 'image-polaroid-user',
  icon: [448, 512, [], "e1b6", "M448 32l-448 0 0 448 448 0 0-448zM384 96l0 256-58.7 0-21.3-64-160 0-21.3 64-58.7 0 0-256 320 0zM224 248a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faArrowUpLeft = {
  prefix: 'fass',
  iconName: 'arrow-up-left',
  icon: [448, 512, [], "e09d", "M64.3 64l-32 0 0 288 64 0 0-178.7 265.4 265.4 22.6 22.6 45.3-45.3-22.6-22.6-265.4-265.4 178.7 0 0-64-256 0z"]
};
var faSquareAustralianDollar = {
  prefix: 'fass',
  iconName: 'square-australian-dollar',
  icon: [448, 512, [], "e718", "M448 32l-448 0 0 448 448 0 0-448zM288 136l32 0 0 24 32 0 0 48-52.8 0c-6.2 0-11.2 5-11.2 11.2 0 5.3 3.8 9.9 9 11l23.5 4.7c27.7 5.5 47.6 29.8 47.6 58 0 28.9-20.7 52.9-48 58.1l0 25.1-32 0 0-24-40 0 0-48 60.8 0c6.2 0 11.2-5 11.2-11.2 0-5.3-3.8-9.9-9-11l-23.5-4.7c-27.7-5.5-47.6-29.8-47.6-58 0-28.9 20.7-52.9 48-58.1l0-25.1zm-150.5 8l44.9 0 4.7 18 53.4 206-49.6 0-6.2-24-49.4 0-6.2 24-49.6 0 53.4-206 4.7-18zM160 248.7l-12.3 47.3 24.5 0-12.3-47.3z"]
};
var faCarGarage = {
  prefix: 'fass',
  iconName: 'car-garage',
  icon: [640, 512, [], "f5e2", "M333-13.3l256 112 29.3 12.8-25.7 58.6-29.3-12.8-243.2-106.4-243.2 106.4-29.3 12.8-25.7-58.6 29.3-12.8 256-112 12.8-5.6 12.8 5.6zM186 144l268.4 0 7.8 20.8 46.2 123.2 35.8 0 0 224-80 0 0-64-288 0 0 64-80 0 0-224 35.8 0 46.2-123.2 7.8-20.8zm224 64l-179.6 0-30 80 239.6 0-30-80zM192.1 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faPersonFromPortal = {
  prefix: 'fass',
  iconName: 'person-from-portal',
  icon: [576, 512, ["portal-exit"], "e023", "M180.3 117.9C164 28.6 132.3-32 96-32 43-32 0 96.9 0 256S43 544 96 544c19.6 0 37.9-17.7 53.1-48l-69.1 0 0-160 108.2 0c1.2-12.7 2.2-25.7 2.8-39l-71-28.4c19.7-49.2 39.8-99.4 60.3-150.6zM416 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM256 112l-21.7 0c-1.4 3.4-14.7 36.8-40 100.1l-11.9 29.7 59.4 23.8c5.9-14.8 17.9-44.7 35.8-89.6l41.4 0-22.7 90.6c-8.3 33.2 11 67 43.7 76.8L436 372.2c-38.9 87.5-59.6 134.1-62.2 140l58.5 26 13-29.2c50.9-114.5 77.1-173.5 78.8-177.2-13.5-4.1-56.1-16.8-127.6-38.3l20.7-70.4c14.5 24.8 24 41.1 28.5 48.8l130.4 0 0-64-93.6 0-28.2-48.4C437 130.1 405.4 112 371.2 112L256 112zm19.1 245l-9.7 27-137.4 0 0 64 182.6 0c4.2-11.7 11-30.8 20.4-57.2l-4.7-1.4c-20.4-6.1-37.9-17.6-51.2-32.4z"]
};
var faPortalExit = faPersonFromPortal;
var faFillDrip = {
  prefix: 'fass',
  iconName: 'fill-drip',
  icon: [576, 512, [], "f576", "M334.6 1.4L312-21.3c-4 4-41.3 41.3-112 112-37.4-37.4-61.4-61.4-72-72L82.7 64c10.6 10.6 34.6 34.6 72 72l-121.4 121.4-22.6 22.6 22.6 22.6 208 208 22.6 22.6 22.6-22.6 256-256 22.6-22.6-22.6-22.6-208-208zM233.4 214.6L256 237.3 301.3 192c-13.3-13.3-32-32-56-56l66.7-66.7 162.7 162.7-56 56-309.5 0-8-8 98.7-98.7 33.4 33.4zM512 352l-55.7 97.4c-5.5 9.5-8.3 20.4-8.3 31.4 0 34.9 28.3 63.2 63.2 63.2l1.6 0c34.9 0 63.2-28.3 63.2-63.2 0-11-2.9-21.8-8.3-31.4L512 352z"]
};
var faShieldHeart = {
  prefix: 'fass',
  iconName: 'shield-heart',
  icon: [512, 512, [], "e574", "M256 0l11.6 4.5 207.5 80.5 19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.3-91.1 150-189.4 192.6l-12.7 5.5-12.7-5.5C144.9 463.9 86.6 389.2 53.9 313.9 21.5 239.3 13.7 162.9 16.6 113L17.8 92.5 37 85 244.5 4.5 256 0zm-6.4 183.4c-11.1-14.8-28.5-23.5-46.9-23.5-32.4 0-58.7 26.3-58.7 58.7l0 5.3c0 64 112 128 112 128s112-64 112-128l0-5.3c0-32.4-26.3-58.7-58.7-58.7-18.5 0-35.9 8.7-46.9 23.5l-6.4 8.5-6.4-8.5z"]
};
var faTrashCanUndo = {
  prefix: 'fass',
  iconName: 'trash-can-undo',
  icon: [448, 512, ["trash-can-arrow-turn-left", "trash-undo-alt"], "f896", "M304-16l16 48 128 0 0 64-448 0 0-64 128 0 16-48 160 0zM32 144l384 0 0 368-384 0 0-368zM209 257l17-17-33.9-33.9c-3.5 3.5-30.5 30.5-81 81l-17 17c3.5 3.5 30.5 30.5 81 81l17 17 33.9-33.9c-10.3-10.3-23.6-23.6-40-40l54.1 0c22.1 0 40 17.9 40 40l0 64 48 0 0-64c0-48.6-39.4-88-88-88l-54.1 0 23-23z"]
};
var faTrashCanArrowTurnLeft = faTrashCanUndo;
var faTrashUndoAlt = faTrashCanUndo;
var faChampagneGlass = {
  prefix: 'fass',
  iconName: 'champagne-glass',
  icon: [256, 512, ["glass-champagne"], "f79e", "M41.4-32l173.4 0 7.5 21.4c19.3 55.1 39.9 139.6 36.6 212-1.7 36.1-9.4 73.3-30.1 102.2-16.4 22.9-39.5 38.6-68.7 45l0 131.4 64 0 0 64-192 0 0-64 64 0 0-131.4C67 342.2 43.9 326.6 27.5 303.6 6.8 274.8-1 237.6-2.6 201.5-6 129 14.6 44.6 33.9-10.6L41.4-32zm24 160l125.3 0C186 94.5 177.8 60.8 169 32L87.3 32c-8.9 28.8-17 62.5-21.8 96z"]
};
var faGlassChampagne = faChampagneGlass;
var faPersonSkiingNordic = {
  prefix: 'fass',
  iconName: 'person-skiing-nordic',
  icon: [640, 512, ["skiing-nordic"], "f7ca", "M457.1 16a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM571.2 238.3l-26.9 13.5 0 180.2-32 0 0-164.2c-24.1 12.1-43.2 21.6-57.3 28.6-7.5-9.7-24.7-32.1-51.7-67.3L363.8 298c38 19 63.6 31.8 76.8 38.4-2.3 5.8-18.6 48.4-49.1 127.6L553 464c11.6-7.8 24.3-16.2 37.9-25.3l26.6 39.9c-12.6 8.4-27.3 18.2-44 29.3l-6 4-215.8 0c-.5 0-1 0-1.5 0l-318 0 0-48 98.7 0c6.5-6.5 38.8-38.8 96.8-96.8L238 331.4c11.3 18.3 27.7 33.8 48.4 44.2l4.8 2.4c-3.1 11-5.3 18.6-6.5 22.8l-5.9 5.9-57.4 57.4 101.3 0 37.1-96.4-55.6-27.8C262.7 319 247.5 267 271.5 227.1l37.7-62.7-44.3-12.3c-6.7 33.3-11.8 59.2-15.5 77.6l-26.5-5.3-129.8 207.6-37.7 0 134-214.3-2.8-.6c2.6-12.8 10-49.9 22.3-111.4l6.8-33.8c13.9 3.9 52.4 14.6 115.5 32.1 46.7 13 88 40.8 117.6 79.3l24.9 32.3c28.9-14.5 51.9-26 69-34.5l28.6 57.2z"]
};
var faSkiingNordic = faPersonSkiingNordic;
var faDiagramCells = {
  prefix: 'fass',
  iconName: 'diagram-cells',
  icon: [448, 512, [], "e475", "M448 32l0 192-448 0 0-192 448 0zM384 416l0-64-320 0 0 64 320 0zm64 64l-448 0 0-192 448 0 0 192z"]
};
var faSquare6 = {
  prefix: 'fass',
  iconName: 'square-6',
  icon: [448, 512, [], "e25b", "M448 32l-448 0 0 448 448 0 0-448zM280 144l0 48-72 0c-13.3 0-24 10.7-24 24l0 12.1c7.5-2.7 15.6-4.1 24-4.1l32 0c39.8 0 72 32.2 72 72s-32.2 72-72 72l-32 0c-39.8 0-72-32.2-72-72l0-80c0-39.8 32.2-72 72-72l72 0zM208 320l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
var faSquare2 = {
  prefix: 'fass',
  iconName: 'square-2',
  icon: [448, 512, [], "e257", "M448 32l-448 0 0 448 448 0 0-448zM176 145.3l62 0c36.5 0 66 29.6 66 66 0 27.1-16.6 51.5-41.9 61.4l-44.7 17.6c-12.9 5.1-22.1 16.3-24.6 29.6l103.3 0 0 48-152 0 0-40.4c0-36.2 22.1-68.7 55.8-81.9l44.7-17.6c6.9-2.7 11.4-9.4 11.4-16.8 0-10-8.1-18-18-18l-86 0 0-48 24 0z"]
};
var faArrowsToDottedLine = {
  prefix: 'fass',
  iconName: 'arrows-to-dotted-line',
  icon: [384, 512, [], "e0a6", "M80 48l112 128 112-128-80 0 0-80-64 0 0 80-80 0zm0 416l80 0 0 80 64 0 0-80 80 0-112-128-112 128zM0 224l0 64 64 0 0-64-64 0zm170.7 0l-64 0 0 64 64 0 0-64zm42.7 0l0 64 64 0 0-64-64 0zM384 224l-64 0 0 64 64 0 0-64z"]
};
var faHatBeach = {
  prefix: 'fass',
  iconName: 'hat-beach',
  icon: [640, 512, [], "e606", "M320 32c-88.4 0-160 71.6-160 160l161.1 0c-.8-5.2-1.1-10.6-1.1-16 0-56.9 42.4-103.8 97.3-111-27-20.7-60.7-33-97.3-33zm1.1 224l-161.1 0-160 128 0 64 640 0 0-64-36.5-29.2c-19.9 18.2-46.4 29.2-75.5 29.2-17.2 0-33.5-3.9-48-10.8-14.5 6.9-30.8 10.8-48 10.8-61.9 0-112-50.1-112-112 0-5.4 .4-10.8 1.1-16zM480 314.3c11.7 13.3 28.9 21.7 48 21.7 35.3 0 64-28.7 64-64 0-19.1-8.4-36.3-21.7-48 13.3-11.7 21.7-28.9 21.7-48 0-35.3-28.7-64-64-64-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7-35.3 0-64 28.7-64 64 0 19.1 8.4 36.3 21.7 48-13.3 11.7-21.7 28.9-21.7 48 0 35.3 28.7 64 64 64 19.1 0 36.3-8.4 48-21.7zM440 224l40-40 40 40-40 40-40-40z"]
};
var faRouter = {
  prefix: 'fass',
  iconName: 'router',
  icon: [576, 512, [], "f8da", "M352.1 0c79.5 0 151.5 32.2 203.6 84.4l-33.9 33.9C478.4 74.9 418.4 48 352.1 48S225.9 74.9 182.4 118.3L148.5 84.4C200.6 32.2 272.6 0 352.1 0zm0 112c48.6 0 92.6 19.7 124.5 51.5l-33.9 33.9c-23.2-23.2-55.2-37.5-90.5-37.5s-67.3 14.3-90.5 37.5l-33.9-33.9c31.8-31.8 75.8-51.5 124.5-51.5zm24 112l0 96 168 0 0 160-512 0 0-160 296 0 0-96 48 0zm-256 152a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"]
};
var faSensor = {
  prefix: 'fass',
  iconName: 'sensor',
  icon: [448, 512, [], "e028", "M448 32l-448 0 0 448 448 0 0-448zM112 120l0 136-48 0 0-160 48 0 0 24zm96 0l0 136-48 0 0-160 48 0 0 24z"]
};
var faSquareCheck = {
  prefix: 'fass',
  iconName: 'square-check',
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M448 480l-448 0 0-448 448 0 0 448zM308.5 151l-119.4 164.2-69.1-69.1-33.9 33.9 88.9 88.9 19.8 19.9 16.5-22.7 135.9-186.9 14.1-19.4-38.8-28.3-14.1 19.4z"]
};
var faCheckSquare = faSquareCheck;
var faPaintbrushFine = {
  prefix: 'fass',
  iconName: 'paintbrush-fine',
  icon: [576, 512, ["paint-brush-alt", "paint-brush-fine", "paintbrush-alt"], "f5a9", "M525.3 141.3L570.5 96 480 5.5c-4.3 4.3-86.2 86.2-245.5 245.5 41.3 16.2 74.3 49.2 90.5 90.5L525.3 141.3zM176 512c61.9 0 112-50.1 112-112S237.9 288 176 288 64 338.1 64 400l0 48-64 0 0 64 176 0z"]
};
var faPaintBrushAlt = faPaintbrushFine;
var faPaintBrushFine = faPaintbrushFine;
var faPaintbrushAlt = faPaintbrushFine;
var faBath = {
  prefix: 'fass',
  iconName: 'bath',
  icon: [512, 512, [128705, "bathtub"], "f2cd", "M64 0l-32 0 0 256-32 0 0 64 32 0 0 48c0 28.4 12.4 54 32 71.6l0 72.4 64 0 0-48 256 0 0 48 64 0 0-72.4c19.6-17.6 32-43.1 32-71.6l0-48 32 0 0-64-416 0 0-192 18.7 0 18.8 18.8c-3.6 9.1-5.5 18.9-5.5 29.2 0 19.6 7 37.5 18.7 51.4l-12.6 12.6 33.9 33.9 17-17 104-104 17-17-33.9-33.9-12.6 12.6C245.5 39 227.6 32 208 32 197.7 32 187.8 34 178.8 37.5 156.9 15.6 144.4 3.1 141.3 0L64 0z"]
};
var faBathtub = faBath;
var faChessBishop = {
  prefix: 'fass',
  iconName: 'chess-bishop',
  icon: [320, 512, [9821], "f43a", "M64 384L48.3 368.3C17.4 337.4 0 295.4 0 251.7 0 213.1 13.5 175.8 38.2 146.1l68.4-82.1-42.7 0 0-64 192 0 0 64-42.7 0 47.6 57.1-102.9 102.9 33.9 33.9 99.3-99.3c18.7 27.3 28.7 59.7 28.7 93 0 43.7-17.4 85.7-48.3 116.6l-15.7 15.7 64 80 0 48-320 0 0-48 64-80z"]
};
var faFence = {
  prefix: 'fass',
  iconName: 'fence',
  icon: [512, 512, [], "e303", "M80 32l-64 80 0 368 128 0 0-62.6 48 0 0 62.6 128 0 0-62.6 48 0 0 62.6 128 0 0-368-64-80-64 80 0 49.4-48 0 0-49.4-64-80-64 80 0 49.4-48 0 0-49.4-64-80zM368 225.4l0 128-48 0 0-128 48 0zm-176 0l0 128-48 0 0-128 48 0z"]
};
var faMicrowave = {
  prefix: 'fass',
  iconName: 'microwave',
  icon: [576, 512, [], "e01b", "M0 64l576 0 0 384-64 0 0 32-64 0 0-32-320 0 0 32-64 0 0-32-64 0 0-384zm96 96l0 192 288 0 0-192-288 0zm416 0l-48 0 0 192 48 0 0-192z"]
};
var faAlarmExclamation = {
  prefix: 'fass',
  iconName: 'alarm-exclamation',
  icon: [512, 512, [], "f843", "M256 64c123.7 0 224 100.3 224 224 0 50.3-16.6 96.8-44.6 134.2l57.8 57.8-45.3 45.3-57.8-57.8C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.2-44.6L64 525.3 18.8 480 76.6 422.2C48.6 384.8 32 338.3 32 288 32 164.3 132.3 64 256 64zM228 356l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0zM95.2 0C123.2 0 148.4 12.1 165.8 31.3 103.7 53.1 51.9 96.9 19.7 153.2 7.3 137.2 0 117.1 0 95.2 0 42.6 42.6 0 95.2 0zM416.7 0c52.6 0 95.3 42.6 95.3 95.2 0 21.8-7.3 41.9-19.7 58-32.2-56.4-84-100.1-146.2-121.9 17.4-19.2 42.6-31.3 70.6-31.3z"]
};
var faTomato = {
  prefix: 'fass',
  iconName: 'tomato',
  icon: [512, 512, [], "e330", "M280-32l0 86.9C294.4 40.7 314.2 32 336 32l48 0 0 16c0 31.7-18.4 59-45.1 72 26.7 13 45.1 40.3 45.1 72l0 16-64 0c-26.2 0-49.4-12.6-64-32-14.6 19.4-37.8 32-64 32l-64 0 0-16c0-31.7 18.4-59 45.1-72-26.7-13-45.1-40.3-45.1-72l0-16 48 0c21.8 0 41.6 8.7 56 22.9l0-86.9 48 0zM256 112c0-2.7 .1-5.4 .4-8l-.8 0c.3 2.6 .4 5.3 .4 8zM432 256l0-64c0-18.7-4-36.4-11.2-52.4 55.8 35.5 91.2 91.7 91.2 164.4 0 130.9-114.6 208-256 208S0 434.9 0 304C0 231.2 35.4 175.1 91.2 139.6 84 155.6 80 173.3 80 192l0 64 112 0c23.3 0 45.2-6.2 64-17.1 18.8 10.9 40.7 17.1 64 17.1l112 0z"]
};
var faPrescriptionBottleMedical = {
  prefix: 'fass',
  iconName: 'prescription-bottle-medical',
  icon: [384, 512, ["prescription-bottle-alt"], "f486", "M0 0L384 0 384 96 0 96 0 0zM32 144l320 0 0 368-320 0 0-368zm128 88l0 56-56 0 0 64 56 0 0 56 64 0 0-56 56 0 0-64-56 0 0-56-64 0z"]
};
var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
var faWatchCalculator = {
  prefix: 'fass',
  iconName: 'watch-calculator',
  icon: [384, 512, [], "f8f0", "M80-32l224 0 10.7 96 69.3 0 0 384-69.3 0-10.7 96-224 0-10.7-96-69.3 0 0-384 69.3 0 10.7-96zM320 128l-256 0 0 256 256 0 0-256zm-32 32l0 64-192 0 0-64 192 0zM96 248l48 0 0 48-48 0 0-48zm120 0l0 48-48 0 0-48 48 0zm24 0l48 0 0 48-48 0 0-48zm-96 64l0 48-48 0 0-48 48 0zm24 0l48 0 0 48-48 0 0-48zm120 0l0 48-48 0 0-48 48 0z"]
};
var faDrawPolygon = {
  prefix: 'fass',
  iconName: 'draw-polygon',
  icon: [512, 512, [58055, "vector-polygon"], "f5ee", "M512 0l-128 0 0 32-256 0 0-32-128 0 0 128 32 0 0 256-32 0 0 128 128 0 0-32 256 0 0 32 128 0 0-128-60.1 0-2-2.7-65.9-91.3 0-67.9 65.9-91.3 2-2.7 60.1 0 0-128zM384 112.7l-57.3 79.3-70.7 0 0 128 70.7 0 2 2.7 55.3 76.5 0 16.7-256 0 0-32-32 0 0-256 32 0 0-32 256 0 0 16.7z"]
};
var faVectorPolygon = faDrawPolygon;
var faCircleGuarani = {
  prefix: 'fass',
  iconName: 'circle-guarani',
  icon: [512, 512, [], "e73b", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM240 137.1l0-25.1 32 0 0 25.1c26.3 3.5 50 15.6 68 33.2l-33.6 34.3c-9.4-9.2-21.2-15.8-34.4-18.8l0 46.2 104 0 0 24c0 60.8-45.3 111.1-104 118.9l0 25.1-32 0 0-25.1c-58.7-7.8-104-58.1-104-118.9s45.3-111.1 104-118.9zM184 256c0 34.3 23.9 62.9 56 70.2l0-140.4c-32.1 7.3-56 36-56 70.2zm139.9 24l-51.9 0 0 46.2c24.2-5.5 43.8-23.2 51.9-46.2z"]
};
var faSlider = {
  prefix: 'fass',
  iconName: 'slider',
  icon: [576, 512, [], "e252", "M288 96l160 0 0 128 128 0 0 64-128 0 0 128-160 0 0-320zM0 288l0-64 240 0 0 64-240 0z"]
};
var faICursor = {
  prefix: 'fass',
  iconName: 'i-cursor',
  icon: [256, 512, [], "f246", "M32 0C70.2 0 104.5 16.8 128 43.3 151.5 16.8 185.8 0 224 0l32 0 0 64-32 0c-35.3 0-64 28.7-64 64l0 96 64 0 0 64-64 0 0 96c0 35.3 28.7 64 64 64l32 0 0 64-32 0c-38.2 0-72.5-16.8-96-43.3-23.5 26.6-57.8 43.3-96 43.3l-32 0 0-64 32 0c35.3 0 64-28.7 64-64l0-96-64 0 0-64 64 0 0-96c0-35.3-28.7-64-64-64L0 64 0 0 32 0z"]
};
var faCloudRainbow = {
  prefix: 'fass',
  iconName: 'cloud-rainbow',
  icon: [576, 512, [], "f73e", "M552 240c-23.5 0-45.3 7.2-63.4 19.6-8.5-5-17.5-9.1-27-12.3-1.5-7.8-3.8-15.4-6.6-22.6 26.9-20.5 60.5-32.8 97-32.8l24 0 0 48-24 0zm0-96c-46 0-88.5 14.9-122.9 40.2-11.5-12.2-25.3-22.1-40.8-29 44.4-36.9 101.4-59.2 163.7-59.2l24 0 0 48-24 0zm0-96c-87.5 0-166.4 37-221.8 96.1-16.1 .7-31.4 4.4-45.4 10.5-4.9-4.5-10-8.7-15.4-12.6 64.2-86.2 166.9-142.1 282.6-142.1l24 0 0 48-24 0zM96 480l-96 0 0-96c0-41.8 26.7-77.4 64-90.5L64 272c0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-416 0z"]
};
var faHeartCirclePlus = {
  prefix: 'fass',
  iconName: 'heart-circle-plus',
  icon: [576, 512, [], "e500", "M133.1 32C175.8 32 216 52.5 241 87.1l15 20.7 15-20.7c25-34.6 65.2-55.1 107.9-55.1 73.5 0 133.1 59.6 133.1 133.1 0 19.2-3 38.1-8.5 56.6-22.1-8.9-46.2-13.8-71.5-13.8-106 0-192 86-192 192 0 33 8.3 64 23 91.2-2.4 1.6-4.7 3.3-7 4.8-102.5-70.7-256-194.1-256-330.9 0-73.5 59.6-133.1 133.1-133.1zM432 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 64-64 0 0 32 64 0 0 64 32 0 0-64 64 0 0-32-64 0 0-48z"]
};
var faShieldDog = {
  prefix: 'fass',
  iconName: 'shield-dog',
  icon: [512, 512, [], "e573", "M256 0l11.6 4.5 207.5 80.5 19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.3-91.1 150-189.4 192.6l-12.7 5.5-12.7-5.5C144.9 463.9 86.6 389.2 53.9 313.9 21.5 239.3 13.7 162.9 16.6 113L17.8 92.5 37 85 244.5 4.5 256 0zM160.9 286.2l-16.9 33.8 128 64 0-64 48 0c44.2 0 80-35.8 80-80l0-48-80 0-16-32-64 0 0 64c0 35.3-28.7 64-64 64-5.2 0-10.3-.6-15.1-1.8zM144 160l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64-64 0zm112 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faFileSlash = {
  prefix: 'fass',
  iconName: 'file-slash',
  icon: [576, 512, [], "e3a7", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-.6-.6-33.3-33.3-98.1-98.1l0-270-144-144-240 0 0 30-46.8-46.8zM96.1 512l346.2 0-346.2-346.2 0 346.2zM421.6 176l-117.5 0 0-117.5 117.5 117.5z"]
};
var faChessRookPiece = {
  prefix: 'fass',
  iconName: 'chess-rook-piece',
  icon: [320, 512, ["chess-rook-alt"], "f448", "M16 32l0 160 48 64 0 128-64 80 0 48 320 0 0-48-64-80 0-128 48-64 0-160-64 0 0 48-48 0 0-48-64 0 0 48-48 0 0-48-64 0z"]
};
var faChessRookAlt = faChessRookPiece;
var faGreaterThanEqual = {
  prefix: 'fass',
  iconName: 'greater-than-equal',
  icon: [448, 512, [], "f532", "M426.1 161.6L0 19.6 0 87.1 314.8 192 0 296.9 0 364.4 426.1 222.4 448 215.1 448 168.9 426.1 161.6zM416 416l-416 0 0 64 448 0 0-64-32 0z"]
};
var faEnvelopeOpen = {
  prefix: 'fass',
  iconName: 'envelope-open',
  icon: [512, 512, [62135], "f2b6", "M441.8 187.3L256 48 70.2 187.3 256 320 441.8 187.3zM0 160l256-192 256 192 0 320-512 0 0-320z"]
};
var faMound = {
  prefix: 'fass',
  iconName: 'mound',
  icon: [576, 512, [], "e52d", "M142.6 178.3C173.3 127.2 228.4 96 288 96s114.7 31.2 145.4 82.3L576 416 0 416 142.6 178.3z"]
};
var faRingsWedding = {
  prefix: 'fass',
  iconName: 'rings-wedding',
  icon: [512, 512, [], "f81b", "M128.7 102.4L96 48 128 0 224 0 256 48 223.3 102.4C297.5 123.1 352 191.2 352 272 352 318.3 334.1 360.5 304.8 391.9 285.2 381 272 360 272 336l0-6.3c10.2-16.9 16-36.6 16-57.7 0-12-1.9-23.6-5.4-34.5-34.9 19-58.6 56-58.6 98.5 0 61.9 50.1 112 112 112s112-50.1 112-112c0-38.9-19.8-73.1-49.9-93.2-3.7-28.4-12.7-55.1-26-79.1 79.9 16.7 139.9 87.5 139.9 172.3 0 97.2-78.8 176-176 176-55.3 0-104.7-25.5-137-65.5-7.5 1-15.2 1.5-23 1.5-97.2 0-176-78.8-176-176 0-80.8 54.5-148.9 128.7-169.6zM176 160c-61.9 0-112 50.1-112 112 0 58.7 45.1 106.8 102.5 111.6-4.2-15.1-6.5-31.1-6.5-47.6 0-64.4 34.5-120.7 86.1-151.3-19.2-15.4-43.6-24.7-70.1-24.7z"]
};
var faGrillFire = {
  prefix: 'fass',
  iconName: 'grill-fire',
  icon: [640, 512, [], "e5a4", "M64 32l448 0 0 64c0 27.4-4.9 53.7-14 78l-43.1-43.1-32.4 20.2c-25.4 15.9-61.7 45-92.1 83.2-18.8 23.6-36.9 52.6-47.8 85.6-15-.4-29.7-2.2-43.9-5.4l-22.9 53.4 56.8 0c-.4 5.2-.7 10.5-.7 15.8 0 10.9 .8 21.7 2.5 32.2L224 416c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L193.2 299C116.9 263.3 64 185.8 64 96l0-64zm96 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM448 192l64 64 32-32c76.8 64 96 133.3 96 160 0 88.4-71.6 160-160 160S320 472.4 320 384c0-89.6 85.3-165.3 128-192zm96 240.2c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faDistributeSpacingHorizontal = {
  prefix: 'fass',
  iconName: 'distribute-spacing-horizontal',
  icon: [448, 512, [], "e365", "M0 0L64 0 64 512 0 512 0 0zM128 96l192 0 0 320-192 0 0-320zM448 0l0 512-64 0 0-512 64 0z"]
};
var faBowlSoftServe = {
  prefix: 'fass',
  iconName: 'bowl-soft-serve',
  icon: [448, 512, [], "e46b", "M224 0l32 0c70.7 0 128 57.3 128 128 0 11.7-3.1 22.6-8.6 32l8.6 0c35.3 0 64 28.7 64 64l0 64-448 0 0-64c0-35.3 28.7-64 64-64l8.6 0c-5.4-9.4-8.6-20.3-8.6-32 0-35.3 28.7-64 64-64l81.3 0c17 0 30.7-13.7 30.7-30.7 0-6.1-1.8-12-5.2-17L224 0zM32 336l384 0 0 8c0 57.4-46.6 104-104 104l-16 0 24 64-192 0 24-64-16 0C78.6 448 32 401.4 32 344l0-8z"]
};
var faVoicemail = {
  prefix: 'fass',
  iconName: 'voicemail',
  icon: [640, 512, [], "f897", "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80 0-79.5-64.5-144-144-144S0 160.5 0 240 64.5 384 144 384l352 0c79.5 0 144-64.5 144-144S575.5 96 496 96 352 160.5 352 240c0 29.6 8.9 57.1 24.2 80l-112.5 0zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faVest = {
  prefix: 'fass',
  iconName: 'vest',
  icon: [448, 512, [], "e085", "M200 512l0-224-55.6-222.6C162.2 77.3 188.4 88 224 88s61.8-10.7 79.6-22.6l-55.6 222.6 0 224 200 0 0-256-64-96 0-160-84.4 0-6.9 11.1-.3 .4c-.4 .6-1.2 1.5-2.3 2.8-2.3 2.6-6.1 6.3-11.4 10.1-10.6 7.4-28.1 15.6-54.7 15.6s-44.1-8.2-54.7-15.6c-5.4-3.8-9.2-7.5-11.5-10.1-1.1-1.3-1.9-2.3-2.3-2.8l-.3-.4-6.9-11.1-84.4 0 0 160-64 96 0 256 200 0z"]
};
var faAudioDescription = {
  prefix: 'fass',
  iconName: 'audio-description',
  icon: [512, 512, [], "f29e", "M0 64l512 0 0 384-512 0 0-384zM96 224l0 128 48 0 0-48 48 0 0 48 48 0 0-128c0-35.3-28.7-64-64-64l-16 0c-35.3 0-64 28.7-64 64zm48 32l0-32c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 32-48 0zm152-96l-24 0 0 192 72 0c39.8 0 72-32.2 72-72l0-48c0-39.8-32.2-72-72-72l-48 0zm48 144l-24 0 0-96 24 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24z"]
};
var faW = {
  prefix: 'fass',
  iconName: 'w',
  icon: [576, 512, [119], "57", "M507.2 32l67.6 0-144.1 426.2-7.4 21.8-47 0-6.7-23-81.3-278.7-81.3 278.7-6.7 23-47 0-7.4-21.8-144.1-426.2 67.6 0 104.6 309.4 83.5-286.4 6.7-23 48 0 6.7 23 83.5 286.4 104.6-309.4z"]
};
var faCartCircleXmark = {
  prefix: 'fass',
  iconName: 'cart-circle-xmark',
  icon: [640, 512, [], "e3f4", "M24-16l-24 0 0 48 76 0 60.4 332.3 3.6 19.7 164.7 0c1.4-16.7 4.9-32.8 10.3-48l-134.9 0-8.7-48 168.7 0c34.9-48.5 91.7-80 156-80 15.8 0 31.2 1.9 46 5.5L576 32 124.8 32c-3.7-20.3-6.6-36.3-8.7-48L24-16zM208 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm288 32a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm55.3-176.7L518.6 400c25.4 25.3 40 40 44 44L540 466.6c-4-4-18.6-18.6-44-44-25.3 25.4-40 40-44 44L429.4 444c4-4 18.6-18.6 44-44-25.4-25.3-40-40-44-44L452 333.4c4 4 18.6 18.6 44 44 25.3-25.4 40-40 44-44l22.6 22.6-11.3 11.3z"]
};
var faCloudsSun = {
  prefix: 'fass',
  iconName: 'clouds-sun',
  icon: [576, 512, [], "f746", "M330.5-26.4c1.1 5.5 8.3 41 21.5 106.4 65.4 13.2 100.9 20.4 106.4 21.5-8.1 12.2-18.2 27.4-30.2 45.6-9.1-2-18.5-3.1-28.2-3.1-25.1 0-48.5 7.2-68.2 19.7-12.1-39.2-48.6-67.7-91.8-67.7-53 0-96 43-96 96 0 13.6 2.8 26.5 7.9 38.2-23.8 16.2-41.8 40.3-50.4 68.4-43.4-8.8-70-14.2-80-16.2 3.1-4.7 23.1-34.9 60-90.5-36.9-55.6-56.9-85.8-60-90.5 5.5-1.1 41-8.3 106.4-21.5 13.2-65.4 20.4-100.9 21.5-106.4 4.7 3.1 34.9 23.1 90.5 60 55.6-36.9 85.8-56.9 90.5-60zM273.7 218c-15.3-6.4-32-10-49.7-10-9.6 0-19 1.1-28.1 3.1-2.5-5.8-3.9-12.3-3.9-19.1 0-26.5 21.5-48 48-48s48 21.5 48 48c0 8.1-2 15.8-5.6 22.5-3 1.1-5.9 2.2-8.8 3.5zm213 166c-11.2-27.6-31.7-50.4-57.6-64.5-11-45.6-52.1-79.5-101.1-79.5l-1.3 0c12.3-28.3 40.5-48 73.3-48 35 0 64.8 22.5 75.6 53.8 8.7-3.7 18.3-5.8 28.4-5.8 39.8 0 72 32.2 72 72l0 72-89.3 0zM96 432c0-33.9 21.1-62.9 50.9-74.6-1.9-6.8-2.9-14-2.9-21.5 0-44.2 35.8-80 80-80 30.8 0 57.5 17.4 70.9 42.8 9.3-6.8 20.7-10.8 33.1-10.8 34.2 0 60.9 32 55.2 65.4 36.9 7.1 64.8 39.6 64.8 78.6l0 80-352 0 0-80z"]
};
var faEyeDropper = {
  prefix: 'fass',
  iconName: 'eye-dropper',
  icon: [512, 512, ["eye-dropper-empty", "eyedropper"], "f1fb", "M341.6 29.2L240.1 130.8C236 126.7 225.3 116 208 98.7l-45.3 45.3 22.6 22.6 160 160 22.6 22.6 45.3-45.3c-17.3-17.3-28-28-32.1-32.1L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM32 344l0 88-3.7 5.5C10.1 464.9 .6 479.1 0 480l32 32 8-5.3 34.5-23 5.5-3.7 88 0 131.4-131.4-45.3-45.3-112.7 112.7-45.5 0 0-45.5 112.7-112.7-45.3-45.3-131.4 131.4z"]
};
var faEyeDropperEmpty = faEyeDropper;
var faEyedropper = faEyeDropper;
var faCircleXmark = {
  prefix: 'fass',
  iconName: 'circle-xmark',
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM172.1 305.9L222.1 256c-38.8-38.8-61.1-61.1-66.9-66.9l33.9-33.9 66.9 66.9c38.8-38.8 61.1-61.1 66.9-66.9l33.9 33.9c-5.8 5.8-28.1 28.1-66.9 66.9 38.8 38.8 61.1 61.1 66.9 66.9l-33.9 33.9c-5.8-5.8-28.1-28.1-66.9-66.9-38.8 38.8-61.1 61.1-66.9 66.9l-33.9-33.9 17-17z"]
};
var faTimesCircle = faCircleXmark;
var faXmarkCircle = faCircleXmark;
var faTrailer = {
  prefix: 'fass',
  iconName: 'trailer',
  icon: [640, 512, [], "e041", "M32 32l512 0 0 320 96 0 0 64-328.4 0c.2 2.6 .4 5.3 .4 8 0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8L32 416 32 32zm432 80l-48 0 0 208 48 0 0-208zm-352 0l0 208 48 0 0-208-48 0zm200 0l-48 0 0 208 48 0 0-208zM264 424a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z"]
};
var faTurkishLiraSign = {
  prefix: 'fass',
  iconName: 'turkish-lira-sign',
  icon: [448, 512, ["try", "turkish-lira"], "e2bb", "M192 32l0 75.6 121.4-34.7 23.1-6.6 13.2 46.2-23.1 6.6-134.6 38.5 0 46.1 121.4-34.7 23.1-6.6 13.2 46.2-23.1 6.6-134.6 38.5 0 162.5 72 0c53 0 96-43 96-96l64 0c0 88.4-71.6 160-160 160l-136 0 0-208.2c-17.3 4.9-33.5 9.6-48.5 13.9L66.3 239.5c12.8-3.7 33.4-9.5 61.7-17.6l0-46.1c-17.3 5-33.5 9.6-48.5 13.9L66.3 143.5c12.8-3.7 33.4-9.5 61.7-17.6l0-93.9 64 0z"]
};
var faTry = faTurkishLiraSign;
var faTurkishLira = faTurkishLiraSign;
var faGaugeCircleMinus = {
  prefix: 'fass',
  iconName: 'gauge-circle-minus',
  icon: [640, 512, [], "e497", "M288 0c126.8 0 232.1 92.2 252.4 213.2-14.3-3.4-29.1-5.2-44.4-5.2-70.9 0-132.8 38.4-166.1 95.6-5.3-4.6-11.3-8.3-17.9-11l0-196.7-48 0 0 196.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64 5.7 0 11.2-.7 16.5-2.1 2.5 34.5 14 66.4 32.3 93.5-15.8 3-32.1 4.6-48.8 4.6-141.4 0-256-114.6-256-256S146.6 0 288 0zM176 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM432 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16l0-32-160 0 0 32 160 0z"]
};
var faDrawSquare = {
  prefix: 'fass',
  iconName: 'draw-square',
  icon: [512, 512, [62923, "vector-square"], "f5ef", "M384 0l128 0 0 128-32 0 0 256 32 0 0 128-128 0 0-32-256 0 0 32-128 0 0-128 32 0 0-256-32 0 0-128 128 0 0 32 256 0 0-32zM96 128l0 256 32 0 0 32 256 0 0-32 32 0 0-256-32 0 0-32-256 0 0 32-32 0z"]
};
var faVectorSquare = faDrawSquare;
var faMountains = {
  prefix: 'fass',
  iconName: 'mountains',
  icon: [640, 512, [9968], "f6fd", "M637 480L565.9 480 553 456.7 381.4 145.3 416 83.2 637 480zm-126-.2L1 479.8 256 17.3 511 479.8zM186.7 275.5l24.3 24.2 60-59.7 34.7 0-49.7-90.1-69.3 125.7z"]
};
var faTruckTow = {
  prefix: 'fass',
  iconName: 'truck-tow',
  icon: [640, 512, [], "e2b8", "M120-32l-24 0 0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-48 0 0 32c0 35.3 28.7 64 64 64s64-28.7 64-64l0-64 48 192-160 0 0 192 67.3 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l102.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l67.3 0 0-192-64-160-192 0 0 156.8-204.7-275.1-7.2-9.7-20.1 0zM500.7 160l38.4 96-123.1 0 0-96 84.7 0zM144 424a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm312-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faLocationMinus = {
  prefix: 'fass',
  iconName: 'location-minus',
  icon: [384, 512, ["map-marker-minus"], "f609", "M0 188.6C0 84.4 86 0 192 0S384 84.4 384 188.6C384 339.4 192 528 192 528S0 339.4 0 188.6zM120 168l-24 0 0 48 192 0 0-48-168 0z"]
};
var faMapMarkerMinus = faLocationMinus;
var faShieldXmark = {
  prefix: 'fass',
  iconName: 'shield-xmark',
  icon: [512, 512, ["shield-times"], "e24c", "M256 0l11.6 4.5 207.5 80.5 19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.3-91.1 150-189.4 192.6l-12.7 5.5-12.7-5.5C144.9 463.9 86.6 389.2 53.9 313.9 21.5 239.3 13.7 162.9 16.6 113L17.8 92.5 37 85 244.5 4.5 256 0zm84.8 189.1l-33.9-33.9c-8.5 8.5-25.5 25.5-50.9 50.9-25.5-25.5-42.4-42.4-50.9-50.9l-33.9 33.9c8.5 8.5 25.5 25.5 50.9 50.9-25.5 25.5-42.4 42.4-50.9 50.9l33.9 33.9c8.5-8.5 25.5-25.5 50.9-50.9 25.5 25.5 42.4 42.4 50.9 50.9l33.9-33.9c-8.5-8.5-25.5-25.5-50.9-50.9 25.5-25.5 42.4-42.4 50.9-50.9z"]
};
var faShieldTimes = faShieldXmark;
var faFaceShush = {
  prefix: 'fass',
  iconName: 'face-shush',
  icon: [512, 512, [], "e38c", "M512 256c0 88-44.4 165.6-112 211.7l0-131.7-64 0 0-5.4c20.6-11.9 38.3-28.3 51.8-47.8l-39.5-27.3c-3.7 5.3-7.8 10.3-12.2 14.8l0-46.4-144 0 0 59.9c-11-7.7-20.6-17.3-28.2-28.4l-39.5 27.3c16.8 24.4 40.3 43.9 67.8 55.9l0 21.3c-29.1 21.9-48 56.7-48 96l0 16C144 477 144.3 481.9 144.9 486.7 59.2 445.3 0 357.6 0 256 0 114.6 114.6 0 256 0S512 114.6 512 256zM208 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM264 432c-13.3 0-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24l88 0 0 48-88 0c-39.8 0-72-32.2-72-72l0-16c0-31.4 20-58 48-67.9l0-116.1 48 0 0 112 64 0 0 80-48 0 0-32-40 0z"]
};
var faSquareEurozone = {
  prefix: 'fass',
  iconName: 'square-eurozone',
  icon: [448, 512, [], "e727", "M448 32l-448 0 0 448 448 0 0-448zM104 144l96 0 0 48-72 0 0 43.2 64 0 0 48-64 0 0 36.8 73.6 0 0 48-121.6 0 0-224 24 0zm152 0l115.8 0c-1.5 3.8-25.5 62.4-72 176l68.3 0 0 48-139.7 0c1.5-3.8 25.5-62.4 72-176l-68.3 0 0-48 24 0z"]
};
var faHeadSideSpeak = {
  prefix: 'fass',
  iconName: 'head-side-speak',
  icon: [640, 512, [], "e75f", "M64.4 512l256 0 0-192 64 0 0-64-49.7-59.6C321.1 85.7 226.8 0 112.4 0 96 0 79.9 1.8 64.4 5.2l0 506.8zm112-320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 232l0-40 96-24 0 72-96-8zm357-216l-33.9 33.9 17 17c71.9 71.9 71.9 188.4 0 260.2l-17 17 33.9 33.9 17-17c90.6-90.6 90.6-237.5 0-328.1l-17-17zm-67.9 67.9l-33.9 33.9 17 17c34.4 34.4 34.4 90.1 0 124.5l-17 17 33.9 33.9 17-17c53.1-53.1 53.1-139.2 0-192.3l-17-17z"]
};
var faHouseDay = {
  prefix: 'fass',
  iconName: 'house-day',
  icon: [640, 512, [], "e00e", "M192 16c8.2 0 16.3 .9 24 2.6l0-74.6-48 0 0 74.6c7.7-1.7 15.8-2.6 24-2.6zm60.4 17.7c13.6 8.7 25.2 20.3 33.9 33.9 27-27 44.6-44.6 52.7-52.7L305.1-19.1c-8.2 8.2-25.8 25.8-52.7 52.7zM170.6 193.1l88.7-79.9c-7.7-28.4-33.7-49.3-64.5-49.3-36.9 0-66.8 29.9-66.8 66.8 0 28.4 17.7 52.6 42.6 62.3zm-39 29.2c-13.6-8.7-25.2-20.3-33.9-33.9l-52.7 52.7 33.9 33.9c8.2-8.2 25.8-25.8 52.7-52.7zM80 128c0-8.2 .9-16.3 2.6-24l-74.6 0 0 48 74.6 0c-1.7-7.7-2.6-15.8-2.6-24zM97.7 67.6c8.7-13.6 20.3-25.2 33.9-33.9-27-27-44.6-44.6-52.7-52.7L44.9 14.9 97.7 67.6zM557.5 336l50.5 0 0-40-240-216-240 216 0 40 50.5 0 0 208 379.1 0 0-208zM320 288l96 0 0 96-96 0 0-96z"]
};
var faVolcano = {
  prefix: 'fass',
  iconName: 'volcano',
  icon: [512, 512, [127755], "f770", "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15 11.2-18.6 31.6-31 54.8-31s43.6 12.4 54.8 31c11.1-9.4 25.5-15 41.2-15 35.3 0 64 28.7 64 64s-28.7 64-64 64l-48 0-32 48-32 0-32-48-48 0zM298.4 272l-84.9 0-66.2 74.5 92.6-26.5 80 64 54-27-75.6-85zM192 224l128 0 192 216 0 72-512 0 0-72 192-216z"]
};
var faWandSparkles = {
  prefix: 'fass',
  iconName: 'wand-sparkles',
  icon: [512, 512, [], "f72b", "M0 432l80 80 288-320 48 0 0-53.3 96-106.7-32-32-284.4 256-67.6 0 0 60.8-128 115.2zm432 16l24-56 56-24-56-24-24-56-24 56-56 24 56 24 24 56zM56 168l24 56 24-56 56-24-56-24-24-56-24 56-56 24 56 24zM208 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32z"]
};
var faFireFlame = {
  prefix: 'fass',
  iconName: 'fire-flame',
  icon: [384, 512, ["flame"], "f6df", "M203.1 9.7L192 0 180.9 9.7C104.2 76.8 45.7 162.2 10.9 258 3.7 277.8 0 299 0 320.2 0 425.4 86.8 512 192 512s192-86.6 192-191.8c0-21.1-3.7-42.3-10.9-62.2-34.8-95.8-93.3-181.2-170-248.3zM208 144l0 15.9c0 12.9 5.2 25.2 14.3 34.2l47.1 46.4c22.1 21.8 34.6 51.5 34.6 82.5 0 60.2-48.8 109-109 109l-3 0c-61.9 0-112-50.6-112-112.4 0-25.5 12-49.6 32.4-64.9l15.6-11.7 0 55c0 24.3 19.8 44 44.1 44 24.2 0 43.9-19.6 43.9-43.8 0-11.6-4.6-22.8-12.8-31l-16.8-16.8c-11.7-11.7-18.3-27.7-18.3-44.3 0-19 8.6-37 23.5-48.9L208 144z"]
};
var faFlame = faFireFlame;
var faBowlingBallPin = {
  prefix: 'fass',
  iconName: 'bowling-ball-pin',
  icon: [640, 512, [], "e0c3", "M240 512a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM632 384l-64 128-112 0-21.1-42.2c38-44.7 61.1-102.6 61.1-165.8 0-34-6.7-66.3-18.7-96l91.8 0 62.8 176zM228 232a28 28 0 1 0 0 56 28 28 0 1 0 0-56zm-72-40a28 28 0 1 0 0 56 28 28 0 1 0 0-56zm72-48a28 28 0 1 0 0 56 28 28 0 1 0 0-56zM512 0c35.3 0 64 28.7 64 64l0 5.8c0 6.8-1 13.6-2.9 20.1l-21.1 70.2-80 0-21-70.2c-2-6.5-3-13.3-3-20.1l0-5.8c0-35.3 28.7-64 64-64z"]
};
var faMicrophone = {
  prefix: 'fass',
  iconName: 'microphone',
  icon: [384, 512, [], "f130", "M288 0L96 0 96 224c0 53 43 96 96 96s96-43 96-96L288 0zM48 184l0-24-48 0 0 64c0 97.9 73.3 178.7 168 190.5l0 49.5-72 0 0 48 192 0 0-48-72 0 0-49.5c94.7-11.8 168-92.6 168-190.5l0-64-48 0 0 64c0 79.5-64.5 144-144 144S48 303.5 48 224l0-40z"]
};
var faCrown = {
  prefix: 'fass',
  iconName: 'crown',
  icon: [576, 512, [128081], "f521", "M307 91.2c12.5-6.8 21-20 21-35.2 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 15.2 8.5 28.4 21 35.2L176 224 88.9 158.7c4.5-6.4 7.1-14.3 7.1-22.7 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 21.8 17.5 39.6 39.2 40l40.8 272 384 0 40.8-272c21.7-.4 39.2-18.2 39.2-40 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 8.4 2.6 16.3 7.1 22.7L400 224 307 91.2z"]
};
var faTentArrowTurnLeft = {
  prefix: 'fass',
  iconName: 'tent-arrow-turn-left',
  icon: [576, 512, [], "e580", "M31.5 113c57.2 57.2 86.8 86.8 89 89l33.9-33.9-48-48 54.1 0 0 0 336 0 0 88 48 0 0-136-312 0 0 0-126.1 0c23-23 39-39 48-48l-33.9-33.9-89 89-17 17 17 17zM94.2 277.3l-29.7 234.7 222.9 0 0-160 97.1 160 128 0-29.7-234.7-195.4-117.3-193.1 117.3z"]
};
var faTruckFast = {
  prefix: 'fass',
  iconName: 'truck-fast',
  icon: [640, 512, ["shipping-fast"], "f48b", "M64 32l416 0 0 96 77.3 0 9.4 9.4 64 64 9.4 9.4 0 237.3-67.3 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-102.6 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-67.3 0 0-112-64 0 0-48 160 0 0-48-160 0 0-48 224 0 0-48-224 0 0-48 64 0 0-64zM576 288l0-50.7-45.3-45.3-50.7 0 0 96 96 0zM256 424a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm232 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faShippingFast = faTruckFast;
var faUserPen = {
  prefix: 'fass',
  iconName: 'user-pen',
  icon: [640, 512, ["user-edit"], "f4ff", "M256 8a120 120 0 1 1 0 240 120 120 0 1 1 0-240zm34.7 416.9l-14.5 87.1-228.2 0 64-208 288 0 2.7 8.9-112 112zM544 239.9l80 80-52.8 52.8-80-80 52.8-52.8zm-208 208l132.6-132.6 80 80-132.6 132.6-96 16 16-96z"]
};
var faUserEdit = faUserPen;
var faSquareNorwegianKrone = {
  prefix: 'fass',
  iconName: 'square-norwegian-krone',
  icon: [448, 512, [], "e707", "M448 32l-448 0 0 448 448 0 0-448zM144 128l0 126.1c43-43 67-67 72-72L249.9 216c-7.8 7.8-26.1 26.1-54.7 54.7l53.3 99-42.3 22.8c-3.6-6.7-19.1-35.5-46.5-86.3l-15.8 15.8 0 62.1-48 0 0-256 48 0zm160 78.2c9.6-4.1 20-6.2 30.6-6.2l33.4 0 0 48-33.4 0c-8.1 0-15.9 3.2-21.7 9s-9 13.5-9 21.7l0 105.4-48 0 0-192 48 0 0 14.2z"]
};
var faPersonSnowmobiling = {
  prefix: 'fass',
  iconName: 'person-snowmobiling',
  icon: [512, 512, ["snowmobile"], "f7d1", "M192 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM309.5 85.3l-10.7-21.5-42.9 21.5c3.6 7.2 17.9 35.7 42.7 85.5l0 .1-23.2 29-99.4-71.8-80 0 0 96-64 0 0 112c-19.4 14.6-32 37.8-32 64 0 44.2 35.8 80 80 80l160 0c44.2 0 80-35.8 80-80 0-18-6-34.6-16-48l53.6 0 4.6 10.1 32.3 69.9-43.5 0 0 48 161 0 0-80-48 0 0 32-16.6 0-36.9-80C466.7 350.7 512 304.6 512 248l0-8-166.9-83.4-3.6-7.3-32-64zM80 368l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 432c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faSnowmobile = faPersonSnowmobiling;
var faBurgerSoda = {
  prefix: 'fass',
  iconName: 'burger-soda',
  icon: [576, 512, [], "f858", "M240-16l-18.4 0-4.8 17.8-25.1 94.2-151.7 0 0 48 24 0 32 368 112 0 0-199.8c9.6-28.1 25-53.1 46-74.2 27.3-27.3 68.4-52.7 127-60.1l3-34 24 0 0-48-166.6 0 17.1-64 61.6 0 0-48-80 0zm16 559.8l320 0 0-64-320 0 0 64zM576 320s-32-96.1-160-96.2C288 224 256 320 256 320l0 47.8 320 0 0-47.8zm0 127.8l0-48-320 0 0 48 320 0zM400 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faRabbitRunning = {
  prefix: 'fass',
  iconName: 'rabbit-running',
  icon: [640, 512, ["rabbit-fast"], "f709", "M480 32l-24 0-4.7 16.5c-3.2 11.2-5 22.5-5.6 33.8 23.5 20.8 41.5 47.4 51.9 77.7l-25.6 0c-18-44.5-55.4-79-102.1-93l-9.8-3-32 16 7.1 19.7c13.5 37.5 39.5 68.4 72.9 88.2l0 26.8-104.3-59.6c-30.9-17.7-65.9-26.9-101.5-26.9-32.3 0-62.2 16.8-78.9 44.4-10.3-12.5-25.8-20.4-43.2-20.4-30.9 0-56 25.1-56 56s25.1 56 56 56c11.3 0 21.8-3.3 30.6-9.1 4.9 17.2 14.5 33.1 28.4 45.9l151.4 138.8 9.2 8.4 172.4 0 0-64-128 0 0-43.5c0-42.9-28.4-80.5-69.6-92.3l-30.8-8.8 8.8-30.8 30.8 8.8c55 15.7 92.8 65.9 92.8 123.1l0 15.7 56-32.4 6.4-3.7 161.6 0 0-88.9-71-57.9c8-48.9-7.6-99.1-42.8-135L480 32zM184.1 408.4l-26.8 17.5 35 53.6c17.6-11.5 36-23.5 55-35.9l-48.7-44.6-14.5 9.5zM504 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faRabbitFast = faRabbitRunning;
var faDialMax = {
  prefix: 'fass',
  iconName: 'dial-max',
  icon: [576, 512, [], "e15e", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64-64 0 0-64zm401.4-81.3c56.7 56.7 62 145.4 15.7 208l-111.9-111.9-17-17-33.9 33.9 17 17 111.9 111.9c-62.6 46.2-151.3 41-208-15.7-62.5-62.5-62.5-163.8 0-226.3s163.8-62.5 226.3 0z"]
};
var faFaceHushed = {
  prefix: 'fass',
  iconName: 'face-hushed',
  icon: [512, 512, [], "e37b", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-48 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM192 164c-4.2 0-8.4 .3-12.5 .8-20.3 2.7-38.9 11.9-53.8 25.8L111 204.3 83.7 175 98.3 161.4c20.6-19.3 46.8-32.4 75.9-36.2 5.8-.8 11.7-1.2 17.7-1.2l20 0 0 40-20 0zm140.5 .8c-4.1-.5-8.3-.8-12.5-.8l-20 0 0-40 20 0c6 0 11.9 .4 17.7 1.2 29.1 3.8 55.3 17 75.9 36.2l14.6 13.7-27.3 29.2-14.6-13.7c-14.9-13.9-33.5-23.1-53.8-25.8z"]
};
var faStocking = {
  prefix: 'fass',
  iconName: 'stocking',
  icon: [384, 512, [], "f7d5", "M384 0l-320 0 0 96 320 0 0-96zM96 144l0 112-40.3 26.9C20.9 306.1 0 345.1 0 386.9l0 2.2c0 67.8 55 122.8 122.8 122.8 24.2 0 48-7.2 68.1-20.6L352 384 352 144 96 144z"]
};
var faCircleDanishKrone = {
  prefix: 'fass',
  iconName: 'circle-danish-krone',
  icon: [512, 512, [], "e746", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM176 152l0-24-48 0 0 256 48 0 0-62.1 15.8-15.8c27.4 50.8 42.9 79.6 46.5 86.3l42.3-22.8-53.3-99c28.6-28.7 46.9-46.9 54.7-54.7L248 182.1c-5 5-29 29-72 72L176 152zm160 40l-48 0 0 192 48 0 0-105.4c0-8.1 3.2-15.9 9-21.7s13.5-9 21.7-9l33.4 0 0-48-33.4 0c-10.6 0-21 2.2-30.6 6.2l0-14.2zm40 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faUserClock = {
  prefix: 'fass',
  iconName: 'user-clock',
  icon: [576, 512, [], "f4fd", "M224 8a120 120 0 1 1 0 240 120 120 0 1 1 0-240zm16 392c0 41.8 13.4 80.5 36 112l-260 0 64-208 185.7 0c-16.3 28.2-25.7 61-25.7 96zm48 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 96 80 0 0-32-48 0 0-64z"]
};
var faFaceDowncastSweat = {
  prefix: 'fass',
  iconName: 'face-downcast-sweat',
  icon: [512, 512, [], "e371", "M49.7 10.4C38.9 20.9 20.9 40.1 9.6 61.7 4.1 72.4 0 84.2 0 96 0 132.4 27.6 160 64 160s64-27.6 64-64c0-11.8-4.1-23.6-9.6-34.3-11.2-21.6-29.2-40.8-40-51.3-4.6-4.5-9.4-8.7-14.3-12.9-4.9 4.2-9.7 8.4-14.3 12.9zM256 512c141.4 0 256-114.6 256-256S397.4 0 256 0c-37.4 0-72.9 8-104.9 22.4 12.5 18.8 25 44.2 25 73.6 0 62.9-49.1 112-112 112-20.7 0-39.9-5.3-56.3-14.6-5 20-7.7 41-7.7 62.6 0 141.4 114.6 256 256 256zm-63.7-89.6l-42.4-22.5C170 361.9 210 336 256 336s86 25.9 106.1 63.9l-42.4 22.5C307.6 399.5 283.6 384 256 384s-51.6 15.5-63.7 38.4zM120 240l104 0 0 48-128 0 0-48 24 0zm168 0l128 0 0 48-128 0 0-48z"]
};
var faShieldPlus = {
  prefix: 'fass',
  iconName: 'shield-plus',
  icon: [512, 512, [], "e24a", "M256 0l11.6 4.5 207.5 80.5 19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.3-91.1 150-189.4 192.6l-12.7 5.5-12.7-5.5C144.9 463.9 86.6 389.2 53.9 313.9 21.5 239.3 13.7 162.9 16.6 113L17.8 92.5 37 85 244.5 4.5 256 0zM232 336l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faAccentGrave = {
  prefix: 'fass',
  iconName: 'accent-grave',
  icon: [192, 512, [], "60", "M144 0l32 224-64 0-80-224 112 0z"]
};
var faHeadphonesSlash = {
  prefix: 'fass',
  iconName: 'headphones-slash',
  icon: [576, 512, [], "e77c", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-3.7-3.7-30.2-30.2-79.4-79.4 8.4-14.3 13.3-30.9 13.3-48.7l0-160c0-123.7-100.3-224-224-224-61.3 0-116.9 24.7-157.4 64.6L49.3-16.9zM176 109.8c28.9-28.4 68.4-45.8 112.1-45.8 88.4 0 160 71.6 160 160l0 32-96 0 0 30-176.1-176.1zM186.3 256l-58.2 0 0-32c0-8.3 .6-16.4 1.8-24.3L77.6 147.3c-8.7 23.9-13.5 49.8-13.5 76.7l0 160c0 53 43 96 96 96l64 0 0-186.2-37.8-37.8z"]
};
var faHoodCloak = {
  prefix: 'fass',
  iconName: 'hood-cloak',
  icon: [512, 512, [], "f6ef", "M0 464l0 48 512 0 0-48-64-96 0-149.9c0-37.9-11.2-75-32.2-106.5L384 64 448 32 448 0 288 0C164.3 0 64 100.3 64 224l0 144-64 96zm352-16l-192 0 0-160c0-53 43-96 96-96s96 43 96 96l0 160z"]
};
var faFileOdf = {
  prefix: 'fass',
  iconName: 'file-odf',
  icon: [576, 512, [], "e7fc", "M280 380c24.3 0 44 19.7 44 44l0 80c0 24.3-19.7 44-44 44l-16 0c-24.3 0-44-19.7-44-44l0-80c0-24.3 19.7-44 44-44l16 0zm120 0c28.7 0 52 23.3 52 52l0 64c0 28.7-23.3 52-52 52l-52 0 0-168 52 0zm164 40l-48 0 0 24 48 0 0 40-48 0 0 64-40 0 0-168 88 0 0 40zM416 144l0 192-240 0 0 176-144 0 0-512 240 0 144 144zM264 420c-2.2 0-4 1.8-4 4l0 80c0 2.2 1.8 4 4 4l16 0c2.2 0 4-1.8 4-4l0-80c0-2.2-1.8-4-4-4l-16 0zm124 88l12 0c6.6 0 12-5.4 12-12l0-64c0-6.6-5.4-12-12-12l-12 0 0 88zM240 176L357.5 176 240 58.5 240 176z"]
};
var faSquareArrowUp = {
  prefix: 'fass',
  iconName: 'square-arrow-up',
  icon: [448, 512, ["arrow-square-up"], "f33c", "M448 32l-448 0 0 448 448 0 0-448zM241 135l80 80 17 17-33.9 33.9c-7.6-7.6-26.3-26.3-56-56l0 174.1-48 0 0-174.1c-29.7 29.7-48.4 48.4-56 56l-33.9-33.9 97-97 17-17 17 17z"]
};
var faArrowSquareUp = faSquareArrowUp;
var faClockTenThirty = {
  prefix: 'fass',
  iconName: 'clock-ten-thirty',
  icon: [512, 512, [], "e355", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm24-120l0-148.8-10.7-7.1c-76.7-51.1-115.3-76.9-116-77.3l-26.6 39.9c2.4 1.6 37.5 25 105.3 70.2l0 147.2 48 0 0-24z"]
};
var faSquare4 = {
  prefix: 'fass',
  iconName: 'square-4',
  icon: [448, 512, [], "e259", "M448 32l-448 0 0 448 448 0 0-448zM192 144l0 112 48 0 0-112 48 0 0 112 32 0 0 48-32 0 0 64-48 0 0-64-96 0 0-160 48 0z"]
};
var faShower = {
  prefix: 'fass',
  iconName: 'shower',
  icon: [512, 512, [128703], "f2cc", "M32 32l-32 0 0 448 64 0 0-384 50.7 0 26.7 26.7c-21 38.9-17.4 87.5 10.9 123l-1.3 1.3-17 17 33.9 33.9 17-17 160-160 17-17-33.9-33.9-17 17-1.3 1.3c-35.5-28.3-84.1-31.9-123-10.9-28.5-28.5-43.7-43.7-45.5-45.5L32 32zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faSquareSterling = {
  prefix: 'fass',
  iconName: 'square-sterling',
  icon: [448, 512, [], "e713", "M0 32l448 0 0 448-448 0 0-448zM202.3 256c-1.3-7.2-3.4-14.4-6.3-21.3l-1.4-3.5c-10.8-26.3 8.5-55.2 37-55.2l2.2 0c9.3 0 18.3 3 25.7 8.6l14.2 10.6 28.8-38.4-14.2-10.6c-15.7-11.8-34.9-18.2-54.5-18.2l-2.2 0c-62.6 0-105.2 63.6-81.4 121.5l1.4 3.5c.4 1 .8 2 1.1 3l-24.8 0 0 32 26.6 0c-1.9 8.2-5.5 16.1-10.8 23-14.7 18.9-22.6 29.1-23.7 30.5l0 42.5 200 0 0-48-135.1 0c10.1-14.5 16.3-31 18.3-48l84.8 0 0-32-85.7 0z"]
};
var faFishingRod = {
  prefix: 'fass',
  iconName: 'fishing-rod',
  icon: [448, 512, [], "e3a8", "M284.6 0l91.4 0 0 160-48 0 0-112-36.6 0-203.4 58.1 0 181.9 40 0 0 224-128 0 0-224 40 0 0-218.1 17.4-5 224-64 3.2-.9zM256 344c0-76.8 64-136 96-152 32 16 96 75.2 96 152 0 32-16 80-64 112l32 40 0 16-128 0 0-16 32-40c-48-32-64-80-64-112zm128-32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSquareCaretUp = {
  prefix: 'fass',
  iconName: 'square-caret-up',
  icon: [448, 512, ["caret-square-up"], "f151", "M448 32l-448 0 0 448 448 0 0-448zM224 152l136 168-272 0 136-168z"]
};
var faCaretSquareUp = faSquareCaretUp;
var faCircleArrowUpLeft = {
  prefix: 'fass',
  iconName: 'circle-arrow-up-left',
  icon: [512, 512, [], "e0fb", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm40-304l-54.1 0 103 103 17 17-33.9 33.9-17-17-103-103 0 78.1-48 0 0-160 160 0 0 48-24 0z"]
};
var faBoxDollar = {
  prefix: 'fass',
  iconName: 'box-dollar',
  icon: [448, 512, ["box-usd"], "f4a0", "M369.4 128l-121.4 0 0-48 87.1 0 34.3 48zM200 128l-121.4 0 34.3-48 87.1 0 0 48zM368 16l-288 0-80 112 0 352 448 0 0-352-80-112zM248 192l0 24 28 0 0 40-67.5 0c-6.9 0-12.5 5.6-12.5 12.5 0 6.1 4.4 11.3 10.4 12.3l41.7 7c25.3 4.2 43.9 26.1 43.9 51.8 0 26.1-19 47.7-44 51.8l0 24.7-40 0 0-24-44 0 0-40 75.5 0c6.9 0 12.5-5.6 12.5-12.5 0-6.1-4.4-11.3-10.4-12.3l-41.7-7c-25.3-4.2-43.9-26.1-43.9-51.8 0-28.8 23.2-52.2 52-52.5l0-24 40 0z"]
};
var faBoxUsd = faBoxDollar;
var faTheta = {
  prefix: 'fass',
  iconName: 'theta',
  icon: [384, 512, [], "f69e", "M64 256C64 200 80.2 150.7 104.9 116.2 129.6 81.6 160.8 64 192 64s62.4 17.6 87.1 52.2C303.8 150.7 320 200 320 256s-16.2 105.3-40.9 139.8C254.4 430.4 223.2 448 192 448s-62.4-17.6-87.1-52.2C80.2 361.3 64 312 64 256zM192 0C134.8 0 86 32.5 52.8 79 19.6 125.6 0 188.2 0 256S19.6 386.4 52.8 433c33.2 46.5 82 79 139.2 79s106-32.5 139.2-79C364.4 386.4 384 323.8 384 256S364.4 125.6 331.2 79C298 32.5 249.2 0 192 0zM144 224l-32 0 0 64 160 0 0-64-128 0z"]
};
var faFaceSmileTongue = {
  prefix: 'fass',
  iconName: 'face-smile-tongue',
  icon: [512, 512, [], "e394", "M478.9 382.1C500 344.9 512 301.8 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256 114.6 512 256 512c26.5 0 52-4 76-11.5-4.2-3-8.2-6.4-12-10.2l-58.4-58.4c-1.9 .1-3.7 .1-5.6 .1-87.9 0-161.4-61.6-179.6-144l49.6 0c17.1 55.6 68.8 96 130 96s112.9-40.4 130-96l49.6 0c-2.4 10.8-5.8 21.3-10 31.3L458.3 352c8.9 8.9 15.8 19.2 20.5 30.1zm-160.2 39l35.3 35.3c19.5 19.5 51 19.5 70.4 0s19.5-51 0-70.4L400.4 362c-21 26.6-49.3 47.3-81.8 59.1zM176 180c-15.5 0-28 12.5-28 28l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28zm132 28l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28s-28 12.5-28 28z"]
};
var faFileVector = {
  prefix: 'fass',
  iconName: 'file-vector',
  icon: [384, 512, [], "e64c", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM152 232l-64 0 0 64 24 0 0 80-24 0 0 64 64 0 0-24 80 0 0 24 64 0 0-64-24 0 0-80 24 0 0-64-64 0 0 24-80 0 0-24zm80 64l0 80-80 0 0-80 80 0z"]
};
var faVideoArrowUpRight = {
  prefix: 'fass',
  iconName: 'video-arrow-up-right',
  icon: [576, 512, [], "e2c9", "M32 64l384 0 0 384-384 0 0-384zM464 341.3l0-170.7 112-74.7 0 320-112-74.7zM184 208l54.1 0-103 103-17 17 33.9 33.9 17-17 103-103 0 78.1 48 0 0-160-160 0 0 48 24 0z"]
};
var faMapLocation = {
  prefix: 'fass',
  iconName: 'map-location',
  icon: [640, 512, ["map-marked"], "f59f", "M576 64l0-51.8c-19.2 9.6-73.4 36.7-162.5 81.2l-179.4-59.8-12.6-4.2-11.9 5.9-128 64-17.7 8.8 0 391.6c19.2-9.6 73.4-36.7 162.5-81.2L387 472.1c-7.1-11.9-13.8-24.3-19.8-37.1-6.1-13.2-11.6-27.4-15.8-42.2l-95.4-31.8 0-252.5 128 42.7 0 83.3c31-35.8 77-58.4 128-58.4 22.6 0 44.2 4.4 64 12.5L576 64zM392 341.9C392 436.1 512 554 512 554S632 436.1 632 341.9C632 276.8 578.3 224 512 224S392 276.8 392 341.9z"]
};
var faMapMarked = faMapLocation;
var faTableCellsHeaderLock = {
  prefix: 'fass',
  iconName: 'table-cells-header-lock',
  icon: [640, 512, [], "e6ae", "M384 224l0 48-16 0 0 208-304 0 0-448 448 0 0 113c-46.7 5.8-85.6 36.8-102.7 79L384 224zm-64 0l-64 0 0 64 64 0 0-64zm-128 0l-64 0 0 64 64 0 0-64zm64 128l0 64 64 0 0-64-64 0zm-128 0l0 64 64 0 0-64-64 0zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
var faFaceIcicles = {
  prefix: 'fass',
  iconName: 'face-icicles',
  icon: [512, 512, [], "e37c", "M320 503.9c-20.5 5.3-41.9 8.1-64 8.1-85.7 0-161.5-42.1-208-106.7l0 74.7-48 0 0-224C0 114.6 114.6 0 256 0S512 114.6 512 256l0 224-48 0 0-74.7c-24.7 34.3-57.7 62.3-96 81l0 57.7-48 0 0-40.1zm36-104.1c24.6-2 44-22.7 44-47.8s-19.4-45.8-44-47.8l0 95.7zM316 304l-40 0 0 96 40 0 0-96zm-80 96l0-96-40 0 0 96 40 0zM112 352c0 25.2 19.4 45.8 44 47.8l0-95.7c-24.6 2-44 22.7-44 47.8zm64-112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faPenFancy = {
  prefix: 'fass',
  iconName: 'pen-fancy',
  icon: [576, 512, [128395, 10002], "f5ac", "M128.2 387.5c-.1-1.2-.2-2.3-.2-3.5 0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32c-1.2 0-2.4-.1-3.5-.2L71.6 500.7 256 448 290.4 356.3 187.7 253.6 96 288 43.3 472.4 128.2 387.5zm185.1-76.2L560 80 464-16 232.7 230.7 313.3 311.3z"]
};
var faUserChef = {
  prefix: 'fass',
  iconName: 'user-chef',
  icon: [448, 512, [], "e3d2", "M64 32c0 20.9 13.4 38.7 32 45.3L96 144c0 70.7 57.3 128 128 128s128-57.3 128-128l0-66.7c18.6-6.6 32-24.4 32-45.3 0-26.5-21.5-48-48-48-14.3 0-27.2 6.3-36 16.3-8.8-10-21.7-16.3-36-16.3-16.7 0-31.4 8.5-40 21.5-8.6-12.9-23.3-21.5-40-21.5-14.3 0-27.2 6.3-36 16.3-8.8-10-21.7-16.3-36-16.3-26.5 0-48 21.5-48 48zM304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16 160 0 0 16zM275.8 320l-147.8 73.9 0 118.1 304 0-64-192-92.2 0zm-71.6 0l-124.2 0-64 192 80 0 0-137.9 8.8-4.4 99.4-49.7zM280 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faDropletPlus = {
  prefix: 'fass',
  iconName: 'droplet-plus',
  icon: [384, 512, [], "e800", "M192-32S384 214 384 320 298 512 192 512 0 426 0 320 192-32 192-32zM168 224l0 72-72 0 0 48 72 0 0 72 48 0 0-72 72 0 0-48-72 0 0-72-48 0z"]
};
var faEuroSign = {
  prefix: 'fass',
  iconName: 'euro-sign',
  icon: [448, 512, [8364, "eur", "euro"], "f153", "M73.3 192C100.8 99.5 186.5 32 288 32l96 0 0 64-96 0c-65.6 0-122 39.5-146.7 96l154.7 0 0 48-167.2 0c-.5 5.3-.8 10.6-.8 16s.3 10.7 .8 16l167.2 0 0 48-154.7 0c24.7 56.5 81.1 96 146.7 96l96 0 0 64-96 0c-101.5 0-187.2-67.5-214.7-160l-57.3 0 0-48 48.6 0c-.7-10.5-.7-21.5 0-32l-48.6 0 0-48 57.3 0z"]
};
var faEur = faEuroSign;
var faEuro = faEuroSign;
var faHouseCircleXmark = {
  prefix: 'fass',
  iconName: 'house-circle-xmark',
  icon: [640, 512, [], "e50b", "M496 208c11.7 0 23.1 1 34.2 3l-242.2-227-256 240 0 48 48 0 0 240 260 0c-10.5-14.6-19-30.7-25.1-48l-90.9 0 0-144 97.4 0c30.3-66.1 97.1-112 174.6-112zm0 336a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm55.3-176.7L518.6 400c25.4 25.3 40 40 44 44L540 466.6c-4-4-18.6-18.6-44-44-25.3 25.4-40 40-44 44L429.4 444c4-4 18.6-18.6 44-44-25.4-25.3-40-40-44-44L452 333.4c4 4 18.6 18.6 44 44 25.3-25.4 40-40 44-44l22.6 22.6-11.3 11.3z"]
};
var faLiraSign = {
  prefix: 'fass',
  iconName: 'lira-sign',
  icon: [320, 512, [8356], "f195", "M52.4 256l-52.4 0 0-48 35.6 0C20.7 124.7 84.3 42 175.1 42l8.2 0c33.6 0 66.2 11.3 92.5 32.2 9.2 7.3 22.9 18.2 41.2 32.6L277.2 157c-18.2-14.4-32-25.3-41.2-32.6-15-11.9-33.6-18.4-52.8-18.4l-8.2 0c-53.8 0-90.1 52.9-73.5 102l186.4 0 0 48-169.1 0c2.3 10.6 3.6 21.3 3.9 32l165.2 0 0 48-170.5 0c-4.8 18.6-12.6 36.5-23.6 52.9l-18.1 27.1 244.2 0 0 64-320 0 0-65.7 5.4-8.1 35.2-52.8c3.7-5.6 6.9-11.4 9.4-17.4l-50 0 0-48 58.8 0c-.5-10.8-2.6-21.6-6.4-32z"]
};
var faCirclePeso = {
  prefix: 'fass',
  iconName: 'circle-peso',
  icon: [512, 512, [], "e6ff", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM168 120l88 0c43.3 0 80.4 26.4 96 64l32 0 0 32-24.3 0c.4 5.3 .4 10.7 0 16l24.3 0 0 32-32 0c-15.7 37.6-52.8 64-96 64l-40 0 0 64-48 0 0-128-24 0 0-32 24 0 0-16-24 0 0-32 24 0 0-64zm88 48l-40 0 0 16 79.2 0c-10.1-9.9-23.9-16-39.2-16zm-40 64l95.4 0c.4-2.6 .6-5.3 .6-8s-.2-5.4-.6-8l-95.4 0 0 16zm0 32l0 16 40 0c15.3 0 29.1-6.1 39.2-16L216 264z"]
};
var faYenSign = {
  prefix: 'fass',
  iconName: 'yen-sign',
  icon: [384, 512, [165, "cny", "jpy", "rmb", "yen"], "f157", "M85.6 62.7l-17.3-26.9-53.8 34.6 17.3 26.9 112.3 174.7-79.7 0 0 48 96 0 0 32-96 0 0 48 96 0 0 80 64 0 0-80 96 0 0-48-96 0 0-32 96 0 0-48-79.7 0 112.3-174.7 17.3-26.9-53.8-34.6-17.3 26.9-106.8 166.1-106.8-166.1z"]
};
var faCny = faYenSign;
var faJpy = faYenSign;
var faRmb = faYenSign;
var faYen = faYenSign;
var faBoxOpen = {
  prefix: 'fass',
  iconName: 'box-open',
  icon: [640, 512, [], "f49e", "M80.4 301.4l0 90.5 240 136 240-136 0-154.3 15.1 22.7 53.3-35.5C622 214.7 600 181.8 563 126.2l-4.3-6.5-6.8-3.8-216-120-15.5-8.6-15.5 8.6-216 120-8.2 4.6-4.4 8.3c-44.1 82-67.8 126-71.2 132.2 15.7 8.4 40.8 21.9 75.4 40.4zm240-74.1L170.2 144 320.4 60.6 470.5 144 320.4 227.4zm-41.5 50.2l-21.3 46.2-165.8-88.8 25.4-47.2 161.7 89.8z"]
};
var faGolfFlagHole = {
  prefix: 'fass',
  iconName: 'golf-flag-hole',
  icon: [512, 512, [], "e3ac", "M128-32L416 96 175.5 202.9c.4 1.6 .5 3.3 .5 5.1l0 85.6c25.2-3.6 52.1-5.6 80-5.6 141.4 0 256 50.1 256 112S397.4 512 256 512 0 461.9 0 400c0-41.5 51.5-77.7 128-97l0-335zm96 448c35.3 0 64-14.3 64-32s-28.7-32-64-32-64 14.3-64 32 28.7 32 64 32z"]
};
var faTruckField = {
  prefix: 'fass',
  iconName: 'truck-field',
  icon: [640, 512, [], "e58d", "M32 32l352 0 0 32 85.4 0 8.2 19.8 56 136 1.7 4.2 72.7 0 0 160-48.4 0c.2 2.6 .4 5.3 .4 8 0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8l-144.7 0c.2 2.6 .4 5.3 .4 8 0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8l-32.4 0 0-96-32 0 0-160 32 0 0-96zm352 96l0 96 82.1 0-39.5-96-42.6 0zM192 392a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm280 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faUTurnLeftUp = {
  prefix: 'fass',
  iconName: 'u-turn-left-up',
  icon: [576, 512, [], "e7f2", "M304 512C189.1 512 96 418.9 96 304l0-144-96 0 160-160 160 160-96 0 0 144c0 44.2 35.8 80 80 80s80-35.8 80-80l0-240 128 0 0 240c0 114.9-93.1 208-208 208z"]
};
var faCircleMill = {
  prefix: 'fass',
  iconName: 'circle-mill',
  icon: [512, 512, [], "e702", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm85.1-408.1c-2.3 5.1-10.7 24.1-25.4 57.1 34.2 5.6 60.2 35.3 60.2 71l0 120-48 0 0-120c0-13.3-10.7-24-24-24-3.6 0-7.1 .8-10.2 2.2L280 241.4c0 68.2 0 105.1 0 110.6l-48 0 0-2.6c-20.1 45.2-30.7 69.1-31.9 71.7l-29.2-13 6.5-14.6 54.6-122.9 0-38.6 0-.4c-.2-13.1-10.9-23.6-24-23.6-13.3 0-24 10.7-24 24 0 76 0 116 0 120l-48 0c0-10.7 0-37.3 0-80l0 0c0-9.3 0-38.7 0-88l0-24 48 0 0 4.1c7.5-2.7 15.6-4.1 24-4.1 18.4 0 35.3 6.9 48 18.3 6.7-6 14.6-10.8 23.2-13.9 20.7-46.6 31.6-71.1 32.7-73.5l29.2 13z"]
};
var faWhistle = {
  prefix: 'fass',
  iconName: 'whistle',
  icon: [640, 512, [], "f460", "M416 112l64 0 0-48 160 0 0 128-226.2 50.2c1.4 9.7 2.2 19.6 2.2 29.8 0 114.9-93.1 208-208 208S0 386.9 0 272 93.1 64 208 64l208 0 0 48zM208 192a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"]
};
var faKerning = {
  prefix: 'fass',
  iconName: 'kerning',
  icon: [576, 512, [], "f86f", "M30.8 22.4l-11.3-22.4 71.7 0 77.2 153 77.2-153 71.7 0-11.3 22.4-109 216-8.9 17.6-39.4 0-8.9-17.6-109-216zm349-4.8l8.9-17.6 39.4 0 8.9 17.6 109 216 11.3 22.4-71.7 0-24.2-48-105.9 0-24.2 48-71.7 0 11.3-22.4 109-216zM387.7 144l41.3 0-20.7-41-20.7 41zM237.6 352c-17.3 17.3-28 28-32 32l165.5 0-32-32 45.3-45.3 109.3 109.3-109.3 109.3-45.3-45.3 32-32-165.5 0c4 4 14.7 14.7 32 32l-45.3 45.3c-8.2-8.2-37.1-37.1-86.6-86.6l-22.6-22.6 86.6-86.6 22.6-22.6 45.3 45.3z"]
};
var faLocationPinLock = {
  prefix: 'fass',
  iconName: 'location-pin-lock',
  icon: [512, 512, [], "e51f", "M0 188.6C0 84.4 86 0 192 0 294.1 0 377.6 78.3 383.6 177 320.7 185.1 272 238.8 272 304l-32 0 0 171.6c-27.6 32.3-48 52.4-48 52.4S0 339.4 0 188.6zM192 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm208 16c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
var faWavesSine = {
  prefix: 'fass',
  iconName: 'waves-sine',
  icon: [576, 512, [], "e65d", "M0 448l32 0c39.4 0 75.8-18.3 99.4-48.2l-31.7-79.2-9.6 24.1C80.6 368.4 57.6 384 32 384l-32 0 0 64zM160 169.8l-10.5-26.3C130.3 95.5 83.7 64 32 64l-32 0 0 64 32 0c25.6 0 48.6 15.6 58.1 39.3l80.5 201.2c19.2 48 65.7 79.5 117.5 79.5 39.4 0 75.8-18.3 99.4-48.3l-31.7-79.2-9.7 24.2C336.6 368.4 313.6 384 288 384s-48.6-15.6-58.1-39.3L194.5 256 230 167.3c9.5-23.7 32.5-39.3 58.1-39.3s48.6 15.6 58.1 39.3l80.5 201.2c19.2 48 65.7 79.5 117.5 79.5l32 0 0-64-32 0c-25.6 0-48.6-15.6-58.1-39.3l-35.5-88.7 35.5-88.7c9.5-23.7 32.5-39.3 58.1-39.3l32 0 0-64-32 0c-51.7 0-98.3 31.5-117.5 79.5l-10.5 26.3-10.5-26.3C386.3 95.5 339.7 64 288 64s-98.3 31.5-117.5 79.5L160 169.8z"]
};
var faPersonPraying = {
  prefix: 'fass',
  iconName: 'person-praying',
  icon: [384, 512, [128720, "pray"], "f683", "M192.4 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm-72.1 80l92.5 0c3.5 4.8 20.5 28.2 51.1 70.2 27.6-22.6 51.1-41.8 70.3-57.5l50.7 61.9C371.1 229.9 336.7 258 281.8 303L249 329.8c-16.9-23.3-32.9-45.2-47.8-65.8l-45 90 116.1 85.8-23.8 72.2-248 0 0-80 126.6 0-53.2-39.3C38.8 366.8 28 319.4 48.2 280.9L109 165.4 120.3 144z"]
};
var faPray = faPersonPraying;
var faLocationPlus = {
  prefix: 'fass',
  iconName: 'location-plus',
  icon: [384, 512, ["map-marker-plus"], "f60a", "M0 188.6C0 84.4 86 0 192 0S384 84.4 384 188.6C384 339.4 192 528 192 528S0 339.4 0 188.6zM168 288l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faMapMarkerPlus = faLocationPlus;
var faDiamondHalfStroke = {
  prefix: 'fass',
  iconName: 'diamond-half-stroke',
  icon: [576, 512, [], "e5b8", "M16 256c7.5 7.5 83.1 83.1 226.7 226.7L288 528 560 256c-7.5-7.5-83.1-83.1-226.7-226.7L288-16c-7.5 7.5-83.1 83.1-226.7 226.7L16 256zM288 437.5L288 74.5 469.5 256 288 437.5z"]
};
var faClipboardList = {
  prefix: 'fass',
  iconName: 'clipboard-list',
  icon: [384, 512, [], "f46d", "M320 0l-256 0 0 32-64 0 0 480 384 0 0-480-64 0 0-32zM112 112l0-48 160 0 0 48-160 0zM64 224l64 0 0 64-64 0 0-64zm112 8l144 0 0 48-144 0 0-48zm0 128l144 0 0 48-144 0 0-48zm-48-8l0 64-64 0 0-64 64 0z"]
};
var faObjectsAlignCenterVertical = {
  prefix: 'fass',
  iconName: 'objects-align-center-vertical',
  icon: [576, 512, [], "e3bd", "M96 32l160 0 0 192 64 0 0-128 160 0 0 128 96 0 0 64-96 0 0 128-160 0 0-128-64 0 0 192-160 0 0-192-96 0 0-64 96 0 0-192z"]
};
var faCandyBar = {
  prefix: 'fass',
  iconName: 'candy-bar',
  icon: [640, 512, [127851, "chocolate-bar"], "e3e8", "M192 416l128 0 0-136-128 0 0 136zm176 0l272 0 0-320-272 0 0 320zM320 96l-128 0 0 136 128 0 0-136zM144 96L94.9 96c-7 49.1-45.8 87.8-94.9 94.9l0 41.1 144 0 0-136zM0 280l0 136 144 0 0-136-144 0z"]
};
var faChocolateBar = faCandyBar;
var faBoothCurtain = {
  prefix: 'fass',
  iconName: 'booth-curtain',
  icon: [448, 512, [], "f734", "M32 0l-32 0 0 512 64 0 0-448 32 0 0 336c0 26.5 21.5 48 48 48s48-21.5 48-48c0 26.5 21.5 48 48 48s48-21.5 48-48c0 26.5 21.5 48 48 48s48-21.5 48-48l0 112 64 0 0-512-416 0z"]
};
var faSackDollar = {
  prefix: 'fass',
  iconName: 'sack-dollar',
  icon: [512, 512, [128176], "f81d", "M128 0l256 0-56 112-144 0-56-112zm41.6 160l172.8 0 47.1 39.2C457 255.5 496 338.8 496 426.6l0 85.4-480 0 0-85.4c0-87.8 39-171.2 106.5-227.4L169.6 160zM280 224l-40 0 0 24c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5l-75.5 0 0 40 44 0 0 24 40 0 0-24.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l67.5 0 0-40-28 0 0-24z"]
};
var faMountainSun = {
  prefix: 'fass',
  iconName: 'mountain-sun',
  icon: [576, 512, [], "e52f", "M560.5 480l-544 0 272-496 272 496zM210.9 258.5l29.5 29.5 64-64 42.6 0-58.6-106.9-77.5 141.3zM496.5 160a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
};
var faHockeyMask = {
  prefix: 'fass',
  iconName: 'hockey-mask',
  icon: [448, 512, [], "f6ee", "M0 240C0 432 48 512 224 512s224-80 224-272L448 0 0 0 0 240zM160 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM176 296a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM272 296a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM264 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm8 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 272c-35.3 0-64-28.7-64-64l0-32 128 0 0 32c0 35.3-28.7 64-64 64zm256-64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-32 128 0 0 32z"]
};
var faLocationSmile = {
  prefix: 'fass',
  iconName: 'location-smile',
  icon: [384, 512, ["map-marker-smile"], "f60d", "M0 188.6C0 84.4 86 0 192 0S384 84.4 384 188.6C384 339.4 192 528 192 528S0 339.4 0 188.6zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM95.4 267.1C106.9 284.4 140.9 316 192 316s85.1-31.6 96.6-48.9l-33.3-22.2c-6.2 9.4-29.1 31.1-63.4 31.1s-57.1-21.7-63.4-31.1L95.4 267.1z"]
};
var faMapMarkerSmile = faLocationSmile;
var faTally3 = {
  prefix: 'fass',
  iconName: 'tally-3',
  icon: [448, 512, [], "e296", "M64 32l0 448-64 0 0-448 64 0zm128 0l0 448-64 0 0-448 64 0zM320 64l0 416-64 0 0-448 64 0 0 32z"]
};
var faArrowDownFromLine = {
  prefix: 'fass',
  iconName: 'arrow-down-from-line',
  icon: [384, 512, [8615, "arrow-from-top"], "f345", "M32 64L0 64 0 0 384 0 384 64 32 64zM214.6 502.6l-22.6 22.6-22.6-22.6-128-128-22.6-22.6 45.3-45.3c6.6 6.6 38.6 38.6 96 96l0-274.7 64 0 0 274.7 96-96 45.3 45.3-150.6 150.6z"]
};
var faArrowFromTop = faArrowDownFromLine;
var faChartPyramid = {
  prefix: 'fass',
  iconName: 'chart-pyramid',
  icon: [576, 512, [], "e0e6", "M103.7 320l368.5 0-61.4-112-245.7 0-61.4 112zM77.4 368l-61.4 112 544 0-61.4-112-421.2 0zM288-16l-96.5 176 193 0-96.5-176z"]
};
var faGoalNet = {
  prefix: 'fass',
  iconName: 'goal-net',
  icon: [576, 512, [], "e3ab", "M576 480l-64 0 0-384-448 0 0 384-64 0 0-448 576 0 0 448zM192 176l72 0 0-48 48 0 0 48 72 0 0-48 48 0 0 48 48 0 0 48-48 0 0 48 48 0 0 48-48 0 0 48 48 0 0 48-48 0 0 64-48 0 0-64-72 0 0 64-48 0 0-64-72 0 0 64-48 0 0-64-48 0 0-48 48 0 0-48-48 0 0-48 48 0 0-48-48 0 0-48 48 0 0-48 48 0 0 48zm0 192l72 0 0-48-72 0 0 48zm120 0l72 0 0-48-72 0 0 48zM192 272l72 0 0-48-72 0 0 48zm120 0l72 0 0-48-72 0 0 48z"]
};
var faLinkHorizontalSlash = {
  prefix: 'fass',
  iconName: 'link-horizontal-slash',
  icon: [576, 512, ["chain-horizontal-slash"], "e1cc", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-6.1-6.1-27.8-27.8-65-65 38.2-29.2 62.8-75.3 62.8-127.1 0-59.3-32.3-111.1-80.3-138.8 .2 3.6 .3 7.1 .3 10.8 0 21.9-3.4 42.9-9.6 62.7 15.9 17.1 25.6 40.1 25.6 65.3 0 34.2-17.9 64.2-44.8 81.2l-82.1-82.1c38.2-29.2 62.8-75.3 62.8-127.1 0-88.4-71.6-160-160-160l-128 0c-18.6 0-36.4 3.2-53 9L49.3-16.9zM162.2 96l126 0c53 0 96 43 96 96 0 34.2-17.9 64.2-44.8 81.2l-49.2-49.2 30 0 0-64-32 0c-18.6 0-36.4 3.2-53 9l-73-73zM410.3 480l-64-64-58.2 0c-53 0-96-43-96-96 0-16.8 4.3-32.6 11.9-46.3l-46.3-46.3c-18.6 26.1-29.5 58.1-29.5 92.6 0 88.4 71.6 160 160 160l122.2 0zM29.7 99.4c-18.6 26.1-29.5 58.1-29.5 92.6 0 59.3 32.3 111.1 80.3 138.8-.2-3.6-.3-7.1-.3-10.8 0-21.9 3.4-42.9 9.6-62.7-15.9-17.1-25.6-40.1-25.6-65.3 0-16.8 4.3-32.6 11.9-46.3L29.7 99.4z"]
};
var faChainHorizontalSlash = faLinkHorizontalSlash;
var faCarpool = {
  prefix: 'fass',
  iconName: 'carpool',
  icon: [512, 512, ["car-people"], "e69c", "M96 16l-18.9 0-4.4 18.4-45.5 189.6-27.2 0 0 256 96 0 0-64 320 0 0 64 96 0 0-256-27.2 0-45.5-189.6-4.4-18.4-338.9 0zM435.5 224l-35.5 0-16-32-96 0-16 32-32 0-16-32-96 0-16 32-35.5 0 38.4-160 282.2 0 38.4 160zM176 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-8-192a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z"]
};
var faCarPeople = faCarpool;
var faArrowUpWideShort = {
  prefix: 'fass',
  iconName: 'arrow-up-wide-short',
  icon: [576, 512, ["sort-amount-up"], "f161", "M150.9 41.4L128.3 18.7c-4.2 4.2-41.1 41.1-110.6 110.6L-5 152 40.3 197.3c13.3-13.3 32-32 56-56l0 338.7 64 0 0-338.7c24 24 42.7 42.7 56 56L261.5 152c-4.2-4.2-41.1-41.1-110.6-110.6zM320.3 480l64 0 0-64-96 0 0 64 32 0zm0-128l128 0 0-64-160 0 0 64 32 0zm0-128l192 0 0-64-224 0 0 64 32 0zm0-128l256 0 0-64-288 0 0 64 32 0z"]
};
var faSortAmountUp = faArrowUpWideShort;
var faArrowUpFromDottedLine = {
  prefix: 'fass',
  iconName: 'arrow-up-from-dotted-line',
  icon: [384, 512, [], "e09b", "M192-13.3l22.6 22.6 128 128 22.6 22.6-45.3 45.3c-6.6-6.6-38.6-38.6-96-96l0 274.7-64 0 0-274.7c-57.4 57.4-89.4 89.4-96 96L18.7 160 41.4 137.4 169.4 9.4 192-13.3zM0 448l64 0 0 64-64 0 0-64zm170.7 0l0 64-64 0 0-64 64 0zm42.7 0l64 0 0 64-64 0 0-64zM384 448l0 64-64 0 0-64 64 0z"]
};
var faUTurnRightUp = {
  prefix: 'fass',
  iconName: 'u-turn-right-up',
  icon: [576, 512, [], "e7f4", "M272 512c114.9 0 208-93.1 208-208l0-144 96 0-160-160-160 160 96 0 0 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-240-128 0 0 240c0 114.9 93.1 208 208 208z"]
};
var faHexagonImage = {
  prefix: 'fass',
  iconName: 'hexagon-image',
  icon: [576, 512, [], "e504", "M13.5 256.1l6.8-11.9 123.7-216.1 6.9-12.1 275.1 0 6.9 12.1 123.7 216.1 6.8 11.9-6.8 11.9-90.9 158.8 0 0-3 5.2 0 0c-23.7 41.4-35.9 62.7-36.7 64.1l-275.1 0-6.9-12.1-123.7-216.1-6.8-11.9zM341.8 224l-76.7 125.6-65.5-93.6-61.8 88.3 50.2 87.8 134.8 0-.1-.1 66.2 0 38.7-67.5-85.8-140.5zm-69.3-64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faUsersLine = {
  prefix: 'fass',
  iconName: 'users-line',
  icon: [576, 512, [], "e592", "M224 128a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm128 96l48 144-224 0 48-144 128 0zm40-80a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm15.9 96l88.1 0 48 128-93.4 0-5.1-15.2-37.6-112.8zm-239.9 0l-37.6 112.8-5.1 15.2-93.4 0 48-128 88.1 0zM72 144a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM0 416l576 0 0 48-576 0 0-48z"]
};
var faArrowUpRightAndArrowDownLeftFromCenter = {
  prefix: 'fass',
  iconName: 'arrow-up-right-and-arrow-down-left-from-center',
  icon: [512, 512, [], "e0a0", "M352 0l-32 0 0 64 82.7 0c-84 84-126.7 126.7-128 128L320 237.3c1.3-1.3 44-44 128-128l0 82.7 64 0 0-192-160 0zM214.6 342.6L237.3 320 192 274.7c-1.3 1.3-44 44-128 128l0-82.7-64 0 0 192 192 0 0-64-82.7 0 105.4-105.4z"]
};
var faCameraViewfinder = {
  prefix: 'fass',
  iconName: 'camera-viewfinder',
  icon: [512, 512, ["screenshot"], "e0da", "M0 0l0 160 48 0 0-112 112 0 0-48-160 0zM192 96l-12 32-84 0 0 256 320 0 0-256-84 0-12-32-128 0zm64 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM488 0l-136 0 0 48 112 0 0 112 48 0 0-160-24 0zM0 512l160 0 0-48-112 0 0-112-48 0 0 160zm488 0l24 0 0-160-48 0 0 112-112 0 0 48 136 0z"]
};
var faScreenshot = faCameraViewfinder;
var faStarOfDavid = {
  prefix: 'fass',
  iconName: 'star-of-david',
  icon: [512, 512, [10017], "f69a", "M0 416l156.3 0 74.1 128 51.2 0 74.1-128 156.3 0 0-49.9-3.5-6.1-60.2-104 60.2-104 3.5-6.1 0-49.9-156.3 0-74.1-128-51.2 0-74.1 128-156.3 0 0 49.9 3.5 6.1 60.2 104-60.2 104-3.5 6.1 0 49.9zM96.1 311.9l27.8 48.1-55.7 0 27.8-48.1zM188.6 360l-60.2-104 60.2-104 134.8 0 60.2 104-60.2 104-134.8 0zM221 416l70 0-35 60.4-35-60.4zm167.1-56l27.8-48.1 27.8 48.1-55.7 0zm27.8-159.9l-27.8-48.1 55.7 0-27.8 48.1zM291 96l-70 0 35-60.4 35 60.4zM123.9 152l-27.8 48.1-27.8-48.1 55.7 0z"]
};
var faNotesMedical = {
  prefix: 'fass',
  iconName: 'notes-medical',
  icon: [512, 512, [], "f481", "M96 416l272 0 144-144 0-272-416 0 0 416zM336 112l0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64 64 0zM48 120l0-24-48 0 0 416 352 0 0-48-304 0 0-344z"]
};
var faAustralSign = {
  prefix: 'fass',
  iconName: 'austral-sign',
  icon: [448, 512, [], "e0a9", "M195.9 32l56.1 0 8.2 19.8 77.9 188.2 101.9 0 0 48-82 0 19.9 48 62.2 0 0 48-42.3 0 39.7 96-69.3 0-39.7-96-208.8 0-39.7 96-69.3 0 39.7-96-42.3 0 0-48 62.2 0 19.9-48-82 0 0-48 101.9 0 77.9-188.2 8.2-19.8zM159.3 288l-19.9 48 169.1 0-19.9-48-129.4 0zm109.5-48L224 131.6 179.2 240 268.8 240z"]
};
var faFileChartPie = {
  prefix: 'fass',
  iconName: 'file-chart-pie',
  icon: [384, 512, [], "f65a", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM80 336c0 61.9 50.1 112 112 112 53.6 0 98.4-37.7 109.4-88l-133.4 0 0-133.4c-50.3 11-88 55.8-88 109.4zm136-24l85.4 0c-9.3-42.6-42.8-76.1-85.4-85.4l0 85.4z"]
};
var faFaceSadSweat = {
  prefix: 'fass',
  iconName: 'face-sad-sweat',
  icon: [640, 512, [], "e38a", "M320 512c141.4 0 256-114.6 256-256S461.4 0 320 0c-131 0-239.1 98.5-254.2 225.4 6.1 4.8 25.8 20.5 34.6 28l.3 .3c14.4 12.5 32.3 29.7 46.8 50.2 14.3 20.1 28.4 47.7 28.4 80.1 0 25.4-8 48.6-21.7 67.2 44.7 38 102.5 60.8 165.7 60.8zm-63.7-89.6l-42.4-22.5C234 361.9 274 336 320 336s86 25.9 106.1 63.9l-42.4 22.5C371.6 399.5 347.6 384 320 384s-51.6 15.5-63.7 38.4zM432 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM240 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm36.3-80c-10.6 10.6-17.7 17.7-21.5 21.5-24.2 24.2-55.3 40.2-89 45.8l-2.5 .4-19.7 3.3-6.6-39.5 19.7-3.3 2.5-.4c25.5-4.2 49-16.4 67.3-34.6 3.8-3.8 11-11 21.5-21.5L276.3 160zm101.6 14.1L363.7 160 392 131.7c10.6 10.6 17.7 17.7 21.5 21.5 18.3 18.3 41.8 30.4 67.3 34.6l2.5 .4 19.7 3.3-6.6 39.5-19.7-3.3-2.5-.4c-33.7-5.6-64.8-21.6-89-45.8l-7.4-7.4zM49.7 298.4c-10.8 10.5-28.8 29.7-40 51.3-5.6 10.7-9.6 22.5-9.6 34.3 0 36.4 27.6 64 64 64s64-27.6 64-64c0-11.8-4.1-23.6-9.6-34.3-11.2-21.6-29.2-40.8-40-51.3-4.6-4.5-9.4-8.7-14.3-12.9-4.9 4.2-9.7 8.4-14.3 12.9z"]
};
var faClipboardUser = {
  prefix: 'fass',
  iconName: 'clipboard-user',
  icon: [384, 512, [], "f7f3", "M320 0l-256 0 0 32-64 0 0 480 384 0 0-480-64 0 0-32zM112 112l0-48 160 0 0 48-160 0zm80 120a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM293.3 448l-202.7 0 21.3-64 160 0 21.3 64z"]
};
var faCommentArrowDown = {
  prefix: 'fass',
  iconName: 'comment-arrow-down',
  icon: [512, 512, [], "e143", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM239 337l17 17c2.1-2.1 31.8-31.8 89-89l17-17-33.9-33.9c-9 9-25 25-48 48l0-126.1-48 0 0 126.1c-23-23-39-39-48-48L150.1 248c2.1 2.1 31.8 31.8 89 89z"]
};
var faFileImage = {
  prefix: 'fass',
  iconName: 'file-image',
  icon: [384, 512, [128443], "f1c5", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM128 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 448l0-48-128-112-128 112 0 48 256 0z"]
};
var faFileMov = {
  prefix: 'fass',
  iconName: 'file-mov',
  icon: [576, 512, [], "e647", "M272 0l-240 0 0 512 112 0 0-176 272 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM324 400l0-20-20 0c-2.7 0-8.5 0-17.6 0-.5 1-10.8 20.3-30.7 57.9-20.8-37.9-31.5-57.2-31.8-57.9-17.7 0-17.9 0-35.8 0l0 168 40 0 0-77.4c5.8 10.5 15.2 27.6 28.3 51.5 12.7-24 22-41.4 27.7-52.2l0 78.1 40 0 0-148zm68-20c-24.3 0-44 19.7-44 44l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-80c0-24.3-19.7-44-44-44l-16 0zm-4 44c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 80c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80zm128-44l-40 0 0 55c0 21.6 3.9 43 11.5 63.2 10.7 28.5 16.9 45.1 18.7 49.8l43.7 0c1.8-4.7 8-21.3 18.7-49.8 7.6-20.2 11.5-41.6 11.5-63.2l0-55-40 0 0 55c0 16.8-3 33.4-8.9 49.2l-3.1 8.2-3.1-8.2C519 468.4 516 451.8 516 435l0-55z"]
};
var faPie = {
  prefix: 'fass',
  iconName: 'pie',
  icon: [576, 512, [129383], "f705", "M544 240l-12.7 0C497.7 137.8 401.4 64 288 64S78.3 137.8 44.7 240l-44.7 0 0 64 41.2 0 63.9-30.4 6-2.9 6.3 2.3 82.5 30 82.5-30 5.5-2 5.5 2 82.5 30 82.5-30 6.3-2.3 6.1 2.9 63.9 30.4 41.2 0 0-64-32 0zM96 448l384 0 38.7-116.2-55.6-26.5-81.7 29.7-5.5 2-5.5-2-82.5-30-82.5 30-5.5 2-5.5-2-81.7-29.7-55.6 26.5 38.7 116.2zM206.3 151.2c-12.1 24.3-19.9 39.7-23.2 46.3l-28.6-14.3c3.3-6.6 11-22 23.2-46.3l7.2-14.3 28.6 14.3-7.2 14.3zm192-14.3c12.1 24.3 19.9 39.7 23.2 46.3l-28.6 14.3c-3.3-6.6-11-22-23.2-46.3l-7.2-14.3 28.6-14.3 7.2 14.3zM304 144l0 48-32 0 0-64 32 0 0 16z"]
};
var faUserPoliceHairLong = {
  prefix: 'fass',
  iconName: 'user-police-hair-long',
  icon: [448, 512, [], "e7b5", "M48 16l0 32 32 19.2 0 44.8s5.8 2.8 16 6.7l0 57.3-48 96 352 0-48-96 0-57.3c10.2-3.9 16-6.7 16-6.7l0-44.8 32-19.2 0-32-176-48-176 48zm96 117.7c23.2 5.7 50.9 10.3 80 10.3s56.8-4.6 80-10.3l0 10.3c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-10.3zM160 320l-80 0-64 192 416 0-64-192-80 0-64 64-64-64zM224 24l40 40-40 40-40-40 40-40zm80 376a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBagel = {
  prefix: 'fass',
  iconName: 'bagel',
  icon: [640, 512, [129391], "e3d7", "M640 208c0 112.8-89.7 204.6-201.7 207.9 7.5-15.3 13.4-31.5 17.7-48.4l22.7-15.6 56.7-1.6 19-53.4 44.9-34.6-16-54.4 16-54.4-44.9-34.6-19-53.4-56.7-1.6-46.8-32-46.8 32-56.7 1.6-3.7 10.5C312.4 69.7 299.3 64.3 285.8 60 323.4 22.9 375 0 432 0 546.9 0 640 93.1 640 208zM410.7 147.6c6.7-2.3 13.8-3.6 21.3-3.6 35.3 0 64 28.7 64 64 0 24.9-14.2 46.5-34.9 57-6.7-43.8-24.4-83.9-50.3-117.4zM0 304a208 208 0 1 1 416 0 208 208 0 1 1 -416 0zm256 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM120 208l24 24 24-24-24-24-24 24zM80 296l24-24-24-24-24 24 24 24zm32 128l24-24-24-24-24 24 24 24zM304 264l24-24-24-24-24 24 24 24zM216 432l24 24 24-24-24-24-24 24zm88-8l24-24-24-24-24 24 24 24z"]
};
var faCartXmark = {
  prefix: 'fass',
  iconName: 'cart-xmark',
  icon: [640, 512, [], "e0dd", "M0-16l116 0c2.1 11.7 5 27.7 8.7 48l451.2 0-48 256-356.7 0 8.7 48 300 0 0 48-340 0-3.6-19.7-60.4-332.3-76 0 0-48zM160 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm31.8-349.8L381.8 80.2c-9.3 9.3-24.6 24.6-45.8 45.8-21.2-21.2-36.5-36.5-45.8-45.8l-33.9 33.9c9.3 9.3 24.6 24.6 45.8 45.8-21.2 21.2-36.5 36.5-45.8 45.8l33.9 33.9c9.3-9.3 24.6-24.6 45.8-45.8 21.2 21.2 36.5 36.5 45.8 45.8l33.9-33.9c-9.3-9.3-24.6-24.6-45.8-45.8 21.2-21.2 36.5-36.5 45.8-45.8z"]
};
var faSquareCaretRight = {
  prefix: 'fass',
  iconName: 'square-caret-right',
  icon: [448, 512, ["caret-square-right"], "f152", "M448 480l0-448-448 0 0 448 448 0zM328 256l-168 136 0-272 168 136z"]
};
var faCaretSquareRight = faSquareCaretRight;
var faUtensilsSlash = {
  prefix: 'fass',
  iconName: 'utensils-slash',
  icon: [576, 512, [], "e464", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-295.2-295.2c3.9-9.9 6-20.7 6-32 0-6.1-.6-12.1-1.9-18.1l-14.2-151.3-31.9 0-13.3 146.2-24.8-24.8-10-121.2-31.9 0-6.1 73.3-38.9-38.9-3.1-34.5-31.4 0-15.4-15.4zM512.1 378.2L512.1 0c-48 0-160 32-160 176l0 42.2 160 160zM52.6 122.3L50 149.8c-1.2 5.9-1.9 12-1.9 18.1 0 45.9 35.1 83.6 80 87.7l0 256.4 64 0 0-250.2-139.5-139.5z"]
};
var faVial = {
  prefix: 'fass',
  iconName: 'vial',
  icon: [512, 512, [129514], "f492", "M356.1 22.8L333.4 .2 288.2 45.4 306.7 64 28.1 342.6C10.1 360.6 0 385 0 410.5L0 416c0 53 43 96 96 96l5.5 0c25.5 0 49.9-10.1 67.9-28.1l278.6-278.6 18.6 18.6 45.3-45.3c-22.4-22.4-62-62-137.2-137.2l0 0-18.6-18.6zM205.3 256l146.7-146.7 50.7 50.7-96 96-101.5 0z"]
};
var faHelicopter = {
  prefix: 'fass',
  iconName: 'helicopter',
  icon: [640, 512, [128641], "f533", "M208.3 32l-24 0 0 48 176 0 0 48-220.8 0c-26.1-31.4-39.5-47.4-40-48L17.5 80C24 92.9 45.8 136.5 82.9 210.7l6.6 13.3 122.6 0 120.8 166.1 7.2 9.9 116.2 0c75.1 0 136-60.9 136-136s-60.9-136-136-136l-48 0 0-48 176 0 0-48-376 0zm200 160l48 0c39.8 0 72 32.2 72 72s-32.2 72-72 72l-48 0 0-144zm200 224l-48 0 0 32-304 0 0 48 352 0 0-80z"]
};
var faMitten = {
  prefix: 'fass',
  iconName: 'mitten',
  icon: [448, 512, [], "f7b5", "M352 384L64 384 5.4 178.9C1.8 166.4 0 153.4 0 140.3 0 62.8 62.8 0 140.3 0l3.4 0c66 0 123.5 44.9 139.5 108.9l33.6 134.3 51.2-51.2 80 80-96 112zM32 432l352 0 0 80-352 0 0-80z"]
};
var faFileMusic = {
  prefix: 'fass',
  iconName: 'file-music',
  icon: [384, 512, [], "f8b6", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM272 240l-96 0 0 113.8c-5.1-1.2-10.5-1.8-16-1.8-35.3 0-64 25.1-64 56s28.7 56 64 56 64-25.1 64-56l0-104 48 0 0-64z"]
};
var faGasPump = {
  prefix: 'fass',
  iconName: 'gas-pump',
  icon: [512, 512, [9981], "f52f", "M320 0l-288 0 0 464-16 0 0 48 320 0 0-48-16 0 0-160 48 0 0 144 144 0 0-313.3-6.2-6.9c-64-70.4-96-105.6-96.1-105.8L374.1 54.4c9.2 10.1 23.1 25.4 41.9 46.1l0 91.5 48 0 0 208-48 0 0-144-96 0 0-256zM256 64l0 128-160 0 0-128 160 0z"]
};
var faHelmetBattle = {
  prefix: 'fass',
  iconName: 'helmet-battle',
  icon: [576, 512, [], "f6eb", "M96 192l0 240 160 80 0-256-96-32 0-32 256 0 0 32-96 32 0 256 160-80 0-240c0-40.3-19-78.2-51.2-102.4L288-16 147.2 89.6C115 113.8 96 151.7 96 192zM64 256L64 0 32 0 0 256 64 256zM512 0l0 256 64 0-32-256-32 0z"]
};
var faMeat = {
  prefix: 'fass',
  iconName: 'meat',
  icon: [512, 512, [127830], "f814", "M243.6 19.6C283.7-20.4 371.9 2.8 440.5 71.5s91.9 156.8 51.8 196.9l-115.5 115.6-175.4 0-26.4 26.4c10.4 10.8 16.8 25.5 16.8 41.6 0 33.1-26.9 60-60 60s-60-26.9-60-60l0-12-12 0c-33.1 0-60-26.9-60-60s26.9-60 60-60c16.2 0 30.9 6.4 41.7 16.8l26.3-26.4 0-175.2 115.6-115.6zm64 184.8c49.6 49.6 113.3 66.4 142.2 37.4s12.2-92.6-37.4-142.2-113.3-66.4-142.2-37.4-12.2 92.6 37.4 142.2zm36.3-36.3c-15.3-15.3-20.4-34.9-11.5-43.8s28.5-3.7 43.8 11.5 20.4 34.9 11.5 43.8-28.5 3.7-43.8-11.5z"]
};
var faTrumpet = {
  prefix: 'fass',
  iconName: 'trumpet',
  icon: [640, 512, [127930], "f8e3", "M512 285.5c38.4 25.4 71.5 63.4 96 98.5l32 0 0-320-32 0c-41.7 59.7-108.4 128-184 128l-24 0 0-64-48 0 0 64-40 0 0-64-48 0 0 64-40 0 0-64-48 0 0 64-128 0 0-16-48 0 0 96 48 0 0-16 33.1 0c-10.9 18.8-17.1 40.7-17.1 64 0 70.7 57.3 128 128 128l192 0c62.4 0 114.4-44.7 125.7-103.8-3.5-3.1-7-6-10.6-8.8-17.7-13.8-34.8-23.2-51.1-27.8l0 12.5c0 29.8-20.4 54.9-48 62l0-126 24 0c8.1 0 16.1 .8 24 2.3 1.3 .2 2.6 .5 3.9 .8 21.1 4.6 41.2 14 60.1 26.5zM352 384l-40 0 0-128 40 0 0 128zM176 258l0 124c-27.6-7.1-48-32.2-48-62s20.4-54.9 48-62zm48-2l40 0 0 128-40 0 0-128z"]
};
var faBrowsers = {
  prefix: 'fass',
  iconName: 'browsers',
  icon: [576, 512, [], "e0cb", "M496 32l80 0 0 352-480 0 0-352 400 0zM48 128l0 304 432 0 0 48-480 0 0-352 48 0zM256 88l0 48 256 0 0-48-256 0zm-32-8l-64 0 0 64 64 0 0-64z"]
};
var faArrowDownLeft = {
  prefix: 'fass',
  iconName: 'arrow-down-left',
  icon: [448, 512, [], "e091", "M64.3 448l-32 0 0-288 64 0 0 178.7 265.4-265.4 22.6-22.6 45.3 45.3-22.6 22.6-265.4 265.4 178.7 0 0 64-256 0z"]
};
var faSquare1 = {
  prefix: 'fass',
  iconName: 'square-1',
  icon: [448, 512, [], "e256", "M448 32l-448 0 0 448 448 0 0-448zM184 144l64 0 0 176 56 0 0 48-160 0 0-48 56 0 0-128-40 0 0-48 24 0z"]
};
var faUserNurseHairLong = {
  prefix: 'fass',
  iconName: 'user-nurse-hair-long',
  icon: [448, 512, [], "e45e", "M96 24l128-56 128 56 0 152 48 96-352 0 48-96 0-152zM304 144l0-16-160 0 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80zM224 384l64-64 80 0 64 192-416 0 64-192 80 0 64 64zM208 8l0 24-24 0 0 32 24 0 0 24 32 0 0-24 24 0 0-32-24 0 0-24-32 0z"]
};
var faTemperatureSun = {
  prefix: 'fass',
  iconName: 'temperature-sun',
  icon: [576, 512, ["temperature-hot"], "f76a", "M256.4 28.4l0 89.1c-10-3.5-20.8-5.5-32-5.5-53 0-96 43-96 96 0 51.3 40.3 93.3 91 95.9-7.1 20.1-11 41.6-11 64.1 0 3 .1 5.9 .2 8.9-42.5 28.2-67.4 44.7-74.7 49.5-1.1-5.5-8.3-41-21.5-106.4-65.4-13.2-100.9-20.4-106.4-21.5 3.1-4.7 23.1-34.8 60-90.5-36.9-55.6-56.9-85.8-60-90.5 5.5-1.1 41-8.3 106.4-21.5 13.2-65.4 20.4-100.9 21.5-106.4 4.7 3.1 34.8 23.1 90.5 60l32-21.2zm0 143.9l0 68.8c-2.2 2.5-4.3 5-6.3 7.6-7.4 4.7-16.2 7.4-25.7 7.4-26.5 0-48-21.5-48-48s21.5-48 48-48c12.3 0 23.5 4.6 32 12.2zM304.4 0l192 0 0 260.7c29.5 26.4 48 64.7 48 107.3 0 79.5-64.5 144-144 144s-144-64.5-144-144c0-42.6 18.5-81 48-107.3L304.4 0zm96 432c35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3l0-236.7-48 0 0 236.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64z"]
};
var faTemperatureHot = faTemperatureSun;
var faGasPumpSlash = {
  prefix: 'fass',
  iconName: 'gas-pump-slash',
  icon: [576, 512, [], "f5f4", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-6.3-6.3-27.7-27.7-64.1-64.1l30 0 0-313.3-6.2-6.9c-64-70.4-96-105.6-96.1-105.8L406.2 54.4c9.2 10.1 23.1 25.4 41.9 46.1l0 91.5 48 0 0 208-30 0-114-114 0-286-286 0-16.9-16.9zM130.2 64l158 0 0 128-30 0-128-128zm-66 69.8l0 330.2-16 0 0 48 320 0 0-48-16 0 0-42.2-288-288z"]
};
var faEnvelopeCircleCheck = {
  prefix: 'fass',
  iconName: 'envelope-circle-check',
  icon: [640, 512, [], "e4e8", "M96 64l-32 0 0 72 12.8 9.6 224 168 9.1 6.9c21.2-83 96.4-144.5 186.1-144.5 28.6 0 55.6 6.2 80 17.4L576 64 96 64zM272 352l-208-156 0 252 257.4 0c-10.1-22-16.2-46.3-17.2-71.9L272 352zm368 16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L417.4 368 440 345.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z"]
};
var faFileGif = {
  prefix: 'fass',
  iconName: 'file-gif',
  icon: [576, 512, [], "e645", "M272 0l-240 0 0 512 208 0 0-176 176 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM328 380c-24.3 0-44 19.7-44 44l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-44-48 0 0 40 8 0 0 4c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 8 40 0 0-8c0-24.3-19.7-44-44-44l-16 0zm124 20l0-20-40 0 0 168 40 0 0-148zm24-20l0 168 40 0 0-64 48 0 0-40-48 0 0-24 48 0 0-40-88 0z"]
};
var faPersonSkating = {
  prefix: 'fass',
  iconName: 'person-skating',
  icon: [512, 512, ["skating"], "f7c5", "M368.1 56a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-240 40l211.8 0c11.8 23.7 34.3 68.6 35.2 70.3-1.4 1.4-31.2 31.2-89.2 89.2 62.9 28 95.6 42.5 98.3 43.7l0 148.8-64 0 0-107.2-82.4-36.6c-41-18.2-51-72-19.3-103.7l40.4-40.4-130.7 0 0-64zM89.5 361.4l75.9-75.9c7.7 19.7 21.6 37.3 41 49.6-55.9 55.9-87.3 87.3-94.2 94.2L66.9 384 89.5 361.4zm331 83.2l31 7.8c-1.9 7.6-5.9 23.4-11.9 47.5l-3 12.1-148.5 0 0-32 123.5 0c3.5-14 6.4-25.8 8.8-35.4zM143.3 486.3c-24.9 12.5-39.1 19.5-42.3 21.2l-8.2-8.2-80-80-11.3-11.3 22.6-22.6 11.3 11.3 71.8 71.8c15.7-7.8 27.7-13.8 36-18l14.3 28.6-14.3 7.2z"]
};
var faSkating = faPersonSkating;
var faFaceAngryHorns = {
  prefix: 'fass',
  iconName: 'face-angry-horns',
  icon: [640, 512, [], "e368", "M320 0C264.6 0 213.2 17.6 171.3 47.6 57.1 42.8 0 0 0 0 0 80.1 55.6 160.1 74.1 184.5 67.5 207.2 64 231.2 64 256 64 397.4 178.6 512 320 512S576 397.4 576 256c0-24.8-3.5-48.8-10.1-71.5 18.5-24.4 74.1-104.4 74.1-184.5 0 0-57.1 42.8-171.3 47.6-41.9-30-93.2-47.6-148.7-47.6zm0 384c-27.6 0-51.6 15.5-63.7 38.4l-42.4-22.5C234 361.9 274 336 320 336s86 25.9 106.1 63.9l-42.4 22.5C371.6 399.5 347.6 384 320 384zm-80-80c-17.7 0-32-14.3-32-32 0-7.3 2.4-14 6.6-19.4-20.9-7-36.8-12.3-47.8-15.9l12.6-37.9 19 6.3 96 32 19 6.3-12.6 37.9c-14.2-4.7-23.7-7.9-28.7-9.6l0 .3c0 17.7-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-.3c-4.9 1.6-14.5 4.8-28.7 9.6l-12.6-37.9 19-6.3 96-32 19-6.3 12.6 37.9c-11 3.7-27 9-47.8 15.9 4.1 5.4 6.6 12.1 6.6 19.4z"]
};
var faSun = {
  prefix: 'fass',
  iconName: 'sun',
  icon: [576, 512, [9728], "f185", "M173.8-20.2c10.6 7.1 48.8 32.4 114.4 75.9 65.6-43.5 103.8-68.8 114.4-75.9 2.5 12.5 11.6 57.4 27.2 134.6 77.2 15.6 122.1 24.7 134.6 27.2-7.1 10.6-32.4 48.8-75.9 114.4 43.5 65.6 68.8 103.8 75.9 114.4-12.5 2.5-57.4 11.6-134.6 27.2-15.6 77.2-24.7 122.1-27.2 134.6-10.6-7.1-48.8-32.4-114.4-75.9-65.6 43.5-103.8 68.8-114.4 75.9-2.5-12.5-11.6-57.4-27.2-134.6-77.2-15.6-122.1-24.7-134.6-27.2 7.1-10.6 32.4-48.8 75.9-114.4-43.5-65.6-68.8-103.8-75.9-114.4 12.5-2.5 57.4-11.6 134.6-27.2 15.6-77.2 24.7-122.1 27.2-134.6zm34 276.2a80.2 80.2 0 1 1 160.5 0 80.2 80.2 0 1 1 -160.5 0zm208.5 0a128.2 128.2 0 1 0 -256.5 0 128.2 128.2 0 1 0 256.5 0z"]
};
var faDiploma = {
  prefix: 'fass',
  iconName: 'diploma',
  icon: [640, 512, ["scroll-ribbon"], "f5ea", "M80 64C35.8 64 0 135.6 0 224l0 160 163.2 0c-12.3-24-19.2-51.2-19.2-80 0-97.2 78.8-176 176-176s176 78.8 176 176c0 28.8-6.9 56-19.2 80l163.2 0 0-160c0-88.4-35.8-160-80-160L80 64zM448 304c0-70.7-57.3-128-128-128S192 233.3 192 304c0 32.5 12.1 62.1 32 84.7l0 131.3 96-40 96 40 0-131.3c19.9-22.6 32-52.2 32-84.7zM320 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faScrollRibbon = faDiploma;
var faBaseball = {
  prefix: 'fass',
  iconName: 'baseball',
  icon: [512, 512, [129358, 9918, "baseball-ball"], "f433", "M232.4 1.1c-122.2 11.4-219.5 108.7-230.9 230.9 22.3-.1 43.9-3.4 64.3-9.3l13.5 46.1c-24.7 7.2-50.8 11.2-77.8 11.3 11.4 122.2 108.7 219.5 230.9 230.9 .1-27 4-53.1 11.3-77.8l46.1 13.5c-6 20.4-9.2 41.9-9.3 64.3 122.2-11.4 219.5-108.7 230.9-230.9-22.3 .1-43.9 3.4-64.3 9.3l-13.5-46.1c24.7-7.2 50.8-11.2 77.8-11.3-11.4-122.2-108.7-219.5-230.9-230.9-.1 27-4 53.1-11.3 77.8L223.1 65.4c6-20.4 9.2-41.9 9.3-64.3zM134.6 245.8l-23-42.1c39-21.3 71.2-53.5 92.5-92.5l42.1 23c-25.7 47-64.5 85.8-111.6 111.6zm132 132c25.7-47 64.5-85.8 111.6-111.6l23 42.1c-39 21.3-71.2 53.5-92.5 92.5l-42.1-23z"]
};
var faBaseballBall = faBaseball;
var faImage = {
  prefix: 'fass',
  iconName: 'image',
  icon: [448, 512, [], "f03e", "M448 32l-448 0 0 448 448 0 0-448zM128 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm16 160l46.1 69.1 81.9-133.1 128 208-352 0 96-144z"]
};
var faBoot = {
  prefix: 'fass',
  iconName: 'boot',
  icon: [448, 512, [129406], "f782", "M0 0l320 0 0 112-128 0 0 48 96 0 0 48-96 0 0 48 128 0c70.7 0 128 57.3 128 128L0 384 0 0zM0 432l448 0 0 48-28 32-56 0-28-32-28 32-56 0-28-32-28 32-56 0-28-32-28 32-56 0-28-32 0-48z"]
};
var faCarBump = {
  prefix: 'fass',
  iconName: 'car-bump',
  icon: [576, 512, [], "f5e0", "M252.2 4.5l-19.2 11.1-194 112-19.2 11.1 3.6 21.9 21.6 129.8-31 17.9c77.3 133.9 90.7 157 112 194l69.3-40-32-55.4 249.4-144 32 55.4 69.3-40c-45.3-78.5-82.7-143.2-112-194l-31 17.9-101.6-83.6-17.1-14.1zM90.2 171.9l155.6-89.8 66 54.3-207.5 119.8-14-84.3zm252.6 1.9a32 32 0 1 1 32 55.4 32 32 0 1 1 -32-55.4zm-178 139.7a32 32 0 1 1 -55.4 32 32 32 0 1 1 55.4-32zM464 400c-61.9 0-112 50.1-112 112l224 0c0-61.9-50.1-112-112-112z"]
};
var faMoneyBillSimple = {
  prefix: 'fass',
  iconName: 'money-bill-simple',
  icon: [512, 512, [], "e1f1", "M512 64l-512 0 0 384 512 0 0-384zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faSquareArrowDown = {
  prefix: 'fass',
  iconName: 'square-arrow-down',
  icon: [448, 512, ["arrow-square-down"], "f339", "M448 32l-448 0 0 448 448 0 0-448zM241 377l-17 17-17-17c-63.8-63.8-96.2-96.2-97-97L144 246.1c7.6 7.6 26.3 26.3 56 56l0-174.1 48 0 0 174.1c29.7-29.7 48.4-48.4 56-56l33.9 33.9-17 17-80 80z"]
};
var faArrowSquareDown = faSquareArrowDown;
var faNotdef = {
  prefix: 'fass',
  iconName: 'notdef',
  icon: [384, 512, [], "e1fe", "M0 0L384 0 384 512 0 512 0 0zM64 390.3L153.5 256 64 121.7 64 390.3zM102.5 448L281.5 448 192 313.7 102.5 448zm128-192L320 390.3 320 121.7 230.5 256zM281.5 64L102.5 64 192 198.3 281.5 64z"]
};
var faCommentQuestion = {
  prefix: 'fass',
  iconName: 'comment-question',
  icon: [512, 512, [], "e14b", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM256 165.2c17.7 0 32 14.3 32 32 0 13.2-6.8 20.5-15.8 25.6-9.4 5.3-20 6.6-30.5 8-2.3 .3-4.6 .6-6.9 .9l0 53.5 42.4 0 0-18.3c4.8-1.7 10.3-4 15.8-7.1 17.6-9.9 37.4-29.2 37.4-62.5 0-41.1-33.3-74.4-74.4-74.4s-74.4 33.3-74.4 74.4l42.4 0c0-17.7 14.3-32 32-32zM232 312l0 48 48 0 0-48-48 0z"]
};
var faUserRobot = {
  prefix: 'fass',
  iconName: 'user-robot',
  icon: [448, 512, [], "e04b", "M248 24l0-24-48 0 0 64-120 0 0 104-48 0 0 48 48 0 0 88 288 0 0-88 48 0 0-48-48 0 0-104-120 0 0-40zM0 352l0 160 104 0 0-64 48 0 0 64 48 0 0-64 48 0 0 64 48 0 0-64 48 0 0 64 104 0 0-160-448 0zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBasketball = {
  prefix: 'fass',
  iconName: 'basketball',
  icon: [512, 512, [127936, "basketball-ball"], "f434", "M92.7 58.8l78.4 78.4c18.2-25 28.9-55.9 28.9-89.2 0-14.1-1.9-27.7-5.5-40.6-38 9.4-72.6 27.2-101.8 51.4zM58.8 92.7c-24.2 29.2-42 63.8-51.4 101.8 12.9 3.6 26.5 5.5 40.6 5.5 33.3 0 64.1-10.7 89.2-28.9L58.8 92.7zM256 0c-4.6 0-9.2 .1-13.7 .4 3.7 15.3 5.7 31.2 5.7 47.6 0 46.6-15.9 89.4-42.6 123.4L256 222.1 419.3 58.8C374.9 22.1 318.1 0 256 0zM48 248c-16.4 0-32.4-2-47.6-5.7-.2 4.5-.4 9.1-.4 13.7 0 62.1 22.1 118.9 58.8 163.3L222.1 256 171.4 205.4C137.4 232.1 94.6 248 48 248zm463.6 21.7c.2-4.5 .4-9.1 .4-13.7 0-62.1-22.1-118.9-58.8-163.3L289.9 256 340.6 306.6c34-26.7 76.9-42.6 123.4-42.6 16.4 0 32.4 2 47.6 5.7zm-7.1 47.8c-12.9-3.6-26.5-5.5-40.6-5.5-33.3 0-64.1 10.7-89.2 28.9l78.4 78.4c24.2-29.2 42-63.8 51.4-101.8zM340.9 374.8c-18.2 25-28.9 55.9-28.9 89.2 0 14.1 1.9 27.7 5.5 40.6 38-9.4 72.6-27.2 101.8-51.4l-78.4-78.4zm-34.3-34.3L256 289.9 92.7 453.2c44.3 36.7 101.2 58.8 163.3 58.8 4.6 0 9.2-.1 13.7-.4-3.7-15.3-5.7-31.2-5.7-47.6 0-46.6 15.9-89.4 42.6-123.4z"]
};
var faBasketballBall = faBasketball;
var faPencil = {
  prefix: 'fass',
  iconName: 'pencil',
  icon: [576, 512, [9999, 61504, "pencil-alt"], "f303", "M16 527.4c20.7-5.8 87.4-24.5 200-56L405.1 282.3 439 248.4c-15.6-15.6-52.3-52.3-110.1-110.1L295 104.4 261.1 138.3 72 327.4C40.5 440 21.8 506.7 16 527.4zm98.4-173.6l75.1 75.1-104.3 29.2 29.2-104.3zM439 180.5L473 214.5c53.4-53.4 60.2-60.2 87-87-15.6-15.6-52.3-52.3-110.1-110.1L416-16.6c-53.4 53.4-60.2 60.2-87 87 15.6 15.6 52.3 52.3 110.1 110.1z"]
};
var faPencilAlt = faPencil;
var faPersonWalkingArrowLoopLeft = {
  prefix: 'fass',
  iconName: 'person-walking-arrow-loop-left',
  icon: [640, 512, [], "e551", "M160-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM98.7 112l108.6 0 9.6 12 54.4 68 80.6 0 0 64-111.4 0c-4.2-5.2-15-18.8-32.6-40.8l0 115.2 52.8 45.3 9 7.7 1.8 11.7c12.5 81.4 19.5 126.6 20.9 135.6l-63.3 9.7c-1.7-11-8-52.3-19.1-123.9l-80.7-69.1C108.2 329.2 96 302.6 96 274.6l0-69.3-32 32 0 82.7-64 0 0-109.3 9.4-9.4 80-80 9.4-9.4zM83.5 415.2L96.1 371c2.4 2.3 4.8 4.6 7.4 6.8l46 39.4c-5.2 18.3-8.2 28.8-9 31.5L134.6 454.6 48 541.3 2.7 496c9.2-9.2 36.1-36.1 80.8-80.8zM342.1 352c2.1-2.1 31.8-31.8 89-89l17-17 33.9 33.9c-9 9-25 25-48 48l158.1 0 0-120-176 0 0-48 224 0 0 216-206.1 0c23 23 39 39 48 48L448 457.9c-2.1-2.1-31.8-31.8-89-89l-17-17z"]
};
var faBootHeeled = {
  prefix: 'fass',
  iconName: 'boot-heeled',
  icon: [448, 512, [], "e33f", "M96 0l-96 0 32 288-32 128 0 96 128 0 0-32 128 32 192 0 0-96-192-128 32-288-144 0 0 224-48 0 0-224z"]
};
var faDiceSix = {
  prefix: 'fass',
  iconName: 'dice-six',
  icon: [448, 512, [9861], "f526", "M0 32l448 0 0 448-448 0 0-448zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCircleEllipsis = {
  prefix: 'fass',
  iconName: 'circle-ellipsis',
  icon: [512, 512, [], "e10a", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM192 224l0 64-64 0 0-64 64 0zm192 0l0 64-64 0 0-64 64 0zm-160 0l64 0 0 64-64 0 0-64z"]
};
var faSwedishKronaSign = {
  prefix: 'fass',
  iconName: 'swedish-krona-sign',
  icon: [512, 512, [], "e73e", "M112 48l0-32-64 0 0 464 64 0 0-113.8 29.1-26.5c70.8 101.2 106.5 152.1 107 152.9l52.4-36.7-18.4-26.2-93.4-133.4c69.9-63.6 107.4-97.6 112.3-102.1l-43-47.4-23.7 21.5-122.5 111.3 0-231.7zM448 224l48 0 0-64-48 0c-22.8 0-44.8 6.1-64 17.1l0-17.1-64 0 0 320 64 0 0-192c0-13.8 4.5-27.3 12.8-38.4 12.1-16.1 31.1-25.6 51.2-25.6z"]
};
var faArrowUpSquareTriangle = {
  prefix: 'fass',
  iconName: 'arrow-up-square-triangle',
  icon: [512, 512, ["sort-shapes-up-alt"], "f88b", "M150.9 41.4l-22.6-22.6-102.6 102.6-22.6 22.6 45.3 45.3 48-48 0 338.7 64 0 0-338.7 48 48 45.3-45.3c-5.5-5.5-39.7-39.7-102.6-102.6zM288.3 32l0 192 192 0 0-192-192 0zm96 256l-112 192 224 0-112-192z"]
};
var faSortShapesUpAlt = faArrowUpSquareTriangle;
var faAnglesDown = {
  prefix: 'fass',
  iconName: 'angles-down',
  icon: [448, 512, ["angle-double-down"], "f103", "M246.9 470.6l-22.6 22.6-22.6-22.6-160-160-22.6-22.6 45.3-45.3 22.6 22.6 137.4 137.4 137.4-137.4 22.6-22.6 45.3 45.3-182.6 182.6zm0-192l-22.6 22.6-22.6-22.6-160-160-22.6-22.6 45.3-45.3 22.6 22.6 137.4 137.4 160-160 45.3 45.3-22.6 22.6-160 160z"]
};
var faAngleDoubleDown = faAnglesDown;
var faVan = {
  prefix: 'fass',
  iconName: 'van',
  icon: [576, 512, [], "e7c8", "M0 64l464 0 9.6 12.8 96 128 6.4 8.5 0 186.7-64.4 0c-4 44.9-41.7 80-87.6 80s-83.6-35.1-87.6-80l-96.7 0c-4 44.9-41.7 80-87.6 80s-83.6-35.1-87.6-80L0 400 0 64zM384 224l120 0-72-96-48 0 0 96zm80 168a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM152 432a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faBatteryLow = {
  prefix: 'fass',
  iconName: 'battery-low',
  icon: [640, 512, ["battery-1"], "e0b1", "M544 128l0 256-448 0 0-256 448 0zM96 64l-64 0 0 384 576 0 0-128 32 0 0-128-32 0 0-128-512 0zm96 112l-48 0 0 160 48 0 0-160z"]
};
var faBattery1 = faBatteryLow;
var faLacrosseStickBall = {
  prefix: 'fass',
  iconName: 'lacrosse-stick-ball',
  icon: [576, 512, [], "e3b6", "M496.5 544a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm-96-576c97.2 0 176 78.8 176 176 0 57.8-35.9 109-89.3 129.2l-10.9 3.6-11.5 3.3c-8.6 2.5-16.8 6.2-24.2 11l-7.2 5.2-34.9 27.9c-22.5 18-50.4 27.8-79.2 27.8-23.4 0-45.3-6.4-64.1-17.4L48.5 541.2 3.2 496 209.9 289.3c-11-18.8-17.4-40.7-17.4-64.1 0-28.8 9.8-56.7 27.8-79.2l27.9-34.9 5.2-7.2c4.9-7.5 8.6-15.6 11-24.2l3.3-11.5 3.6-10.9C291.5 3.9 342.7-32 400.5-32zm0 64c-31 0-58.5 19.3-69.3 47.9l-1.9 5.8-3.3 11.5c-4.9 17.2-12.8 33.3-23.2 47.8l-4.6 6.1-27.9 34.9c-8.9 11.1-13.7 25-13.8 39.2 0 34.7 28.1 62.7 62.7 62.7 14.2 0 28.1-4.8 39.2-13.7l34.9-27.9 6.1-4.6c14.4-10.4 30.6-18.3 47.8-23.2l11.5-3.3 5.8-1.9c28.6-10.8 47.9-38.3 47.9-69.3 0-61.9-50.1-112-112-112z"]
};
var faSeatAirlineWindow = {
  prefix: 'fass',
  iconName: 'seat-airline-window',
  icon: [384, 512, [], "e7be", "M64 0l0 154.8 55.1 165.2 264.9 0 0 64-311.1 0-7.3-21.9-64-192-1.6-4.9 0-165.2 64 0zM32 448l352 0 0 64-352 0 0-64zM352 0l0 224-160 0 0-224 160 0z"]
};
var faAlarmSnooze = {
  prefix: 'fass',
  iconName: 'alarm-snooze',
  icon: [512, 512, [], "f845", "M492.3 153.2c-32.2-56.4-84-100.1-146.1-121.9 17.4-19.2 42.6-31.3 70.6-31.3 52.6 0 95.2 42.6 95.2 95.2 0 21.8-7.3 41.9-19.7 58zm-472.6 0C7.3 137.2 0 117.1 0 95.2 0 42.6 42.6 0 95.2 0 123.2 0 148.4 12.1 165.8 31.3 103.7 53.1 51.9 96.9 19.7 153.2zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6C96.3 493 77 512.3 64 525.3L18.7 480C31.7 467 51 447.7 76.6 422.2 48.6 384.8 32 338.3 32 288 32 164.3 132.3 64 256 64S480 164.3 480 288c0 50.3-16.6 96.8-44.6 134.2l57.8 57.8-45.3 45.3-57.8-57.8zM200 192l-24 0 0 48 79.2 0c-46.9 84.4-73.5 132.3-80 144l160.8 0 0-48-79.2 0c46.9-84.4 73.5-132.3 80-144L200 192z"]
};
var faSyringe = {
  prefix: 'fass',
  iconName: 'syringe',
  icon: [576, 512, [128137], "f48e", "M497.4-17l-17-17-33.9 33.9c11.6 11.6 22.3 22.3 32 32L432.4 78.1c-49.7-49.7-76.4-76.4-80-80L318.5 32c13 13 21 21 24 24l-78.1 78.1c31.3 31.3 50.6 50.6 57.9 57.9l-33.9 33.9c-7.3-7.3-26.6-26.6-57.9-57.9l-46.1 46.1 57.9 57.9-33.9 33.9c-7.3-7.3-26.6-26.6-57.9-57.9l-47 47-7 7 0 112C51.8 458.7 27.2 483.4 22.5 488l33.9 33.9c4.6-4.6 29.3-29.3 73.9-73.9l112 0 7-7 239-239c3 3 11 11 24 24L546.4 192c-3.6-3.6-30.3-30.3-80-80l46.1-46.1c9.7 9.7 20.4 20.4 32 32L578.4 64c-20.5-20.4-70-70-81-81z"]
};
var faShowerDown = {
  prefix: 'fass',
  iconName: 'shower-down',
  icon: [384, 512, ["shower-alt"], "e24d", "M224 0l0 35.2C297 50 352 114.6 352 192l32 0 0 64-384 0 0-64 32 0C32 114.6 87 50 160 35.2L160 0 224 0zm32 416l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7L256 416zm36.2-79.3L320 288 347.8 336.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7zM128 416l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7L128 416zm36.2-79.3L192 288 219.8 336.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7zM64 288l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7L64 288z"]
};
var faShowerAlt = faShowerDown;
var faWheatAwn = {
  prefix: 'fass',
  iconName: 'wheat-awn',
  icon: [576, 512, ["wheat-alt"], "e2cd", "M145.8 282.7l6.1 6.7c19.7 23.8 26.3 55 19.3 83.9 31.7-7.7 66.2 1 90.6 25.3l57.4 57.4-18.8 18.7c-37.5 37.5-98.3 37.5-135.7 0L134.1 444.3 49.4 529c-9.4 9.4-24.5 9.4-33.9 0-9.4-9.4-9.4-24.6 0-33.9l84.7-84.7-30.5-30.5c-37.5-37.5-37.5-98.3 0-135.8l18.8-18.7 57.4 57.4zm104-104l6.1 6.7c19.7 23.7 26.3 55 19.3 83.9 31.7-7.7 66.2 1 90.6 25.3l57.4 57.4-18.8 18.7c-37.5 37.5-98.3 37.5-135.7 0l-94.9-94.9c-37.5-37.5-37.5-98.3 0-135.8l18.8-18.7 57.4 57.4zM546.1 32l-17 17-114.5 114.4c7.7 1 15.2 3 22.5 5.9l58.3-58.3 17-17 33.9 34-17 16.9-52.7 52.7 50.3 50.3-18.8 18.7c-37.5 37.5-98.3 37.5-135.7 0l-94.9-94.9c-37.5-37.5-37.5-98.3 0-135.8l18.8-18.7 50.3 50.3 52.7-52.7 17-17 33.9 34-17 16.9-58.3 58.3c2.8 7.1 4.7 14.5 5.8 22l114.3-114.2 17-17 33.9 34z"]
};
var faWheatAlt = faWheatAwn;
var faPlaneUp = {
  prefix: 'fass',
  iconName: 'plane-up',
  icon: [512, 512, [], "e22d", "M200 24c0-30.9 25.1-56 56-56s56 25.1 56 56l0 127.3 184 168.7 0 80-184-61.3 0 99.7 72 57.6 0 48-128-32-128 32 0-48 72-57.6 0-99.7-184 61.3 0-80 184-168.7 0-127.3z"]
};
var faCircleUserCircleCheck = {
  prefix: 'fass',
  iconName: 'circle-user-circle-check',
  icon: [640, 512, [], "e79f", "M496 208c-77.5 0-144.3 45.9-174.6 112l-145.4 0-23.9 71.6c34.8 34.8 82.8 56.4 135.9 56.4 7.4 0 14.6-.4 21.7-1.2 5.5 21.9 14.8 42.4 27.1 60.6-15.8 3-32.1 4.6-48.8 4.6-141.4 0-256-114.6-256-256S146.6 0 288 0c126.8 0 232.1 92.2 252.4 213.2-14.3-3.4-29.1-5.2-44.4-5.2zM288 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm64 128a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.4-51.5l-25.9-18.8-9.4 12.9-53 72.9C457.7 395 445 382.3 440 377.4L417.4 400c2.8 2.8 19.9 19.9 51.3 51.3l13.2 13.2 11-15.1 64-88 9.4-12.9z"]
};
var faBat = {
  prefix: 'fass',
  iconName: 'bat',
  icon: [576, 512, [], "f6b5", "M224 48L288 80 352 48 379.9 159.7 480 112c61.9 72.3 96 164.3 96 259.5l0 28.5-96-48-48 80-64-64-80 112-80-112-64 64-48-80-96 48 0-28.5C0 276.3 34.1 184.3 96 112L196.1 159.7 224 48z"]
};
var faAlignCenter = {
  prefix: 'fass',
  iconName: 'align-center',
  icon: [448, 512, [], "f037", "M352 32l-256 0 0 64 256 0 0-64zm96 128l-448 0 0 64 448 0 0-64zM0 416l0 64 448 0 0-64-448 0zM352 288l-256 0 0 64 256 0 0-64z"]
};
var faHockeyPuck = {
  prefix: 'fass',
  iconName: 'hockey-puck',
  icon: [512, 512, [], "f453", "M512 352c0 53-114.6 96-256 96S0 405 0 352L0 242.6c16.9 12.3 36.9 22.3 58.1 30.2 53 19.9 123 31.2 197.9 31.2s144.9-11.3 197.9-31.2c21.2-7.9 41.2-17.9 58.1-30.2L512 352zM256 64c141.4 0 256 43 256 96S397.4 256 256 256 0 213 0 160 114.6 64 256 64z"]
};
var faCircleArrowLeft = {
  prefix: 'fass',
  iconName: 'circle-arrow-left',
  icon: [512, 512, ["arrow-circle-left"], "f0a8", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM135 273l-17-17c.8-.8 33.1-33.1 97-97l17-17 33.9 33.9c-7.6 7.6-26.3 26.3-56 56l174.1 0 0 48-174.1 0c29.7 29.7 48.4 48.4 56 56l-33.9 33.9-17-17-80-80z"]
};
var faArrowCircleLeft = faCircleArrowLeft;
var faChartRadar = {
  prefix: 'fass',
  iconName: 'chart-radar',
  icon: [576, 512, [], "e0e7", "M13.5 256.1l6.8-11.9 123.7-216.1 6.9-12.1 275.1 0 6.9 12.1 123.7 216.1 6.8 11.9-6.8 11.9-123.7 216.1-6.9 12.1-275.1 0-6.9-12.1-123.7-216.1-6.8-11.9zm323-96.1c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 6.7 1.4 13.1 3.9 18.9l-46.1 61.5c-1.9-.2-3.8-.3-5.7-.3-26.5 0-48 21.5-48 48s21.5 48 48 48c14.4 0 27.3-6.3 36.1-16.3L307 335.4c6.4 19 24.4 32.6 45.5 32.6 26.5 0 48-21.5 48-48 0-24.2-17.9-44.2-41.2-47.5l-33.1-82.8c6.4-8.2 10.3-18.5 10.3-29.7zM313.7 287.8l-75.8-15.2c-.4-1.2-.8-2.3-1.3-3.5l45.4-60.6 31.7 79.2z"]
};
var faArrowProgress = {
  prefix: 'fass',
  iconName: 'arrow-progress',
  icon: [512, 512, [], "e5df", "M254.4 52.8l-38.4-28.8 0 40-216 0 0 224 448 0 0 96-8.6 0c-11.1-19.1-31.7-32-55.4-32-35.3 0-64 28.7-64 64s28.7 64 64 64c23.7 0 44.4-12.9 55.4-32l72.6 0 0-224-448 0 0-96 152 0 0 40c60.8-45.6 83.2-62.4 96-72L254.4 52.8zM416 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM151.4 448l32.6 0 0 40c60.8-45.6 83.2-62.4 96-72-35.2-26.4-76.8-57.6-96-72l0 40-32.6 0c-11.1-19.1-31.7-32-55.4-32-35.3 0-64 28.7-64 64s28.7 64 64 64c23.7 0 44.4-12.9 55.4-32z"]
};
var faWarehouseFull = {
  prefix: 'fass',
  iconName: 'warehouse-full',
  icon: [576, 512, ["warehouse-alt"], "f495", "M0 512l0-416 288-96 288 96 0 416-64 0 0-320-448 0 0 320-64 0zM320 256l0 128 128 0 0 128-320 0 0-256 192 0z"]
};
var faWarehouseAlt = faWarehouseFull;
var faPenSwirl = {
  prefix: 'fass',
  iconName: 'pen-swirl',
  icon: [576, 512, [], "e214", "M208 240l159-159 96 96-159 159-112 16 16-112zM560 80l-63 63-96-96 63-63 96 96zM288 0c27.8 0 54.5 4.4 79.5 12.6L314.3 65.8C305.7 64.6 296.9 64 288 64 182 64 96 150 96 256s86 192 192 192l32 0 0 64-32 0C146.6 512 32 397.4 32 256S146.6 0 288 0zM480 256c0-8.9-.6-17.7-1.8-26.3l53.2-53.2c8.2 25 12.6 51.8 12.6 79.5 0 88.4-71.6 160-160 160l-32 0 0-64 32 0c53 0 96-43 96-96z"]
};
var faTruckLadder = {
  prefix: 'fass',
  iconName: 'truck-ladder',
  icon: [640, 512, [], "e657", "M352 32l0 48-32 0 0 80 32 0 0 48-352 0 0-48 32 0 0-80-32 0 0-48 352 0zM272 80l-32 0 0 80 32 0 0-80zm-80 0l-32 0 0 80 32 0 0-80zm-80 0l-32 0 0 80 32 0 0-80zM608 320l0 96-67.3 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-102.6 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-67.3 0 0-160 352 0 0-160 144 0 80 160 0 64zM488.4 160l-40.4 0 0 96 88.4 0-48-96zM224 392a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm232 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faCommentImage = {
  prefix: 'fass',
  iconName: 'comment-image',
  icon: [512, 512, [], "e148", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM192 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 336l0-48-128-112-128 112 0 48 256 0z"]
};
var faPlugCircleBolt = {
  prefix: 'fass',
  iconName: 'plug-circle-bolt',
  icon: [640, 512, [], "e55b", "M224-32l0 128 128 0 0-128 64 0 0 128 96 0 0 64-32 0 0 48.7c-98.6 8.1-176 90.7-176 191.3 0 27.3 5.7 53.3 16 76.9l0 35.1-64 0 0-98.7C165.2 398.1 96 319.1 96 224l0-64-32 0 0-64 96 0 0-128 64 0zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM400 416l70.9 0-22.9 80 144-112-70.9 0 22.9-80-144 112z"]
};
var faJeans = {
  prefix: 'fass',
  iconName: 'jeans',
  icon: [512, 512, [], "e6d2", "M97 0L86.2 56 426.3 56 415.6 0 97 0zM78.5 96l-10 52 11.8 0c30.4 0 55.6-22.6 59.5-52L78.5 96zM180 96c-4.1 51.5-47.1 92-99.7 92l-19.5 0-58.8 305.9 188.5 36.3 45.7-237.8 0-196.3-56.3 0zm96.3 0l0 196.3 45.7 237.8 188.5-36.3-58.8-305.9-19.5 0c-52.5 0-95.6-40.5-99.7-92l-56.3 0zm96.5 0c3.9 29.4 29 52 59.5 52l11.8 0-10-52-61.2 0z"]
};
var faGrid5 = {
  prefix: 'fass',
  iconName: 'grid-5',
  icon: [448, 512, [], "e199", "M56 32l-56 0 0 56 56 0 0-56zM0 130l0 56 56 0 0-56-56 0zm56 98l-56 0 0 56 56 0 0-56zM0 326l0 56 56 0 0-56-56 0zm0 98l0 56 56 0 0-56-56 0zm98 0l0 56 56 0 0-56-56 0zm154 0l-56 0 0 56 56 0 0-56zm42 0l0 56 56 0 0-56-56 0zm154 0l-56 0 0 56 56 0 0-56zM154 326l-56 0 0 56 56 0 0-56zm42 0l0 56 56 0 0-56-56 0zm154 0l-56 0 0 56 56 0 0-56zm42 0l0 56 56 0 0-56-56 0zM98 228l0 56 56 0 0-56-56 0zm154 0l-56 0 0 56 56 0 0-56zm42 0l0 56 56 0 0-56-56 0zm154 0l-56 0 0 56 56 0 0-56zM154 130l-56 0 0 56 56 0 0-56zm42 0l0 56 56 0 0-56-56 0zm154 0l-56 0 0 56 56 0 0-56zm42 0l0 56 56 0 0-56-56 0zM98 32l0 56 56 0 0-56-56 0zm154 0l-56 0 0 56 56 0 0-56zm42 0l0 56 56 0 0-56-56 0zm154 0l-56 0 0 56 56 0 0-56z"]
};
var faPipeSection = {
  prefix: 'fass',
  iconName: 'pipe-section',
  icon: [640, 512, [], "e438", "M64 96l0 32 512 0 0-32 64 0 0 320-64 0 0-32-512 0 0 32-64 0 0-320 64 0z"]
};
var faRestroom = {
  prefix: 'fass',
  iconName: 'restroom',
  icon: [640, 512, [], "f7bd", "M80 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM53.4 128l149.2 0 7 22.5 44.9 144-54.5 17 0 200.5-64 0 0-160-16 0 0 160-64 0 0-200.5-54.5-17 44.9-144 7-22.5zM344 0l0 512-48 0 0-512 48 0zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-26.6 80l149.2 0 7 22.5 44.9 144-40.2 12.5 25.7 77-40 0 0 128-64 0 0-128-16 0 0 128-64 0 0-128-40 0 25.7-77-40.2-12.5 44.9-144 7-22.5z"]
};
var faReflectBoth = {
  prefix: 'fass',
  iconName: 'reflect-both',
  icon: [448, 512, [], "e66f", "M87 73l120 120 17 17 17-17c93.2-93.2 146.8-146.8 161-161L46.1 32 87 73zM41 119L0 78.1 0 433.9c14.1-14.1 67.8-67.8 161-161l17-17-17-17-120-120zM87 439l-41 41 355.9 0-177.9-177.9-17 17-120 120zm361-361c-14.1 14.1-67.8 67.8-161 161l-17 17 17 17c93.2 93.2 146.8 146.8 161 161l0-355.9z"]
};
var faGearCode = {
  prefix: 'fass',
  iconName: 'gear-code',
  icon: [512, 512, [], "e5e8", "M200.1-16l112 0 19.7 95.5c14.1 6 27.3 13.7 39.3 22.8l92.6-30.7 56 97-72.9 64.8c.9 7.4 1.3 15 1.3 22.7s-.5 15.3-1.3 22.7l72.9 64.8-56 97-92.6-30.7c-12.1 9.1-25.3 16.7-39.3 22.8l-19.7 95.5-112 0-19.7-95.5c-14.1-6-27.2-13.7-39.3-22.8l-92.6 30.7-56-97 72.9-64.8c-.9-7.4-1.3-15-1.3-22.7s.5-15.3 1.3-22.7l-72.9-64.8 56-97 92.6 30.7c12.1-9.1 25.3-16.7 39.3-22.8L200.1-16zm99.5 172.5l4.5-19.5-39-9-4.5 19.5-48 208-4.5 19.5 39 9 4.5-19.5 48-208zM182.2 238.1l14.1-14.1-28.3-28.3c-6.5 6.5-21.8 21.8-46.1 46.1L107.8 256c6.5 6.5 21.8 21.8 46.1 46.1l14.1 14.1 28.3-28.3c-8.8-8.8-19.5-19.5-32-32l17.9-17.9zm176-28.3l-14.1-14.1-28.3 28.3c8.8 8.8 19.5 19.5 32 32-12.5 12.5-23.2 23.2-32 32l28.3 28.3c6.5-6.5 21.8-21.8 46.1-46.1L404.3 256c-6.5-6.5-21.8-21.8-46.1-46.1z"]
};
var faCurlingStone = {
  prefix: 'fass',
  iconName: 'curling-stone',
  icon: [512, 512, [129356, "curling"], "f44a", "M160 32l-32 0 0 128-64 0 0 64-64 0 0 104 512 0 0-104-64 0 0-64-256 0 0-64 192 0 0-64-224 0zM512 376l-512 0 0 104 512 0 0-104z"]
};
var faCurling = faCurlingStone;
var faAnchorLock = {
  prefix: 'fass',
  iconName: 'anchor-lock',
  icon: [640, 512, [], "e4ad", "M288 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 96c0-53 43-96 96-96s96 43 96 96c0 41.8-26.7 77.4-64 90.5l0 261.5 48 0 0 64-288 0 0-204.1c-10.5 9.2-21.9 19.2-34.3 30L14.1 301.7c4.4-3.8 31.7-27.8 82.1-71.8L112 216.1c2.5 2.2 29.1 25.5 79.8 69.8l18.1 15.8-31.6 36.1c-12.4-10.8-23.8-20.8-34.3-30l0 140.1 112 0 0-261.5c-37.3-13.2-64-48.7-64-90.5zM528 272c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
var faTimeline = {
  prefix: 'fass',
  iconName: 'timeline',
  icon: [576, 512, [], "e29c", "M48 16l160 0 0 160-48 0 0 48 256 0 0-48-48 0 0-160 160 0 0 160-48 0 0 48 96 0 0 64-256 0 0 48 48 0 0 160-160 0 0-160 48 0 0-48-256 0 0-64 96 0 0-48-48 0 0-160z"]
};
var faBriefcaseBlank = {
  prefix: 'fass',
  iconName: 'briefcase-blank',
  icon: [512, 512, [], "e0c8", "M168 0l-24 0 0 96-144 0 0 384 512 0 0-384-144 0 0-96-200 0zM320 96l-128 0 0-48 128 0 0 48z"]
};
var faCoinFront = {
  prefix: 'fass',
  iconName: 'coin-front',
  icon: [512, 512, [], "e3fc", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM256 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 336a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm24-240l0-24-48 0 0 144 48 0 0-120z"]
};
var faCalendarStar = {
  prefix: 'fass',
  iconName: 'calendar-star',
  icon: [448, 512, [], "f736", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0zM261.6 244.2l-37.6-76.2-37.6 76.2-84.1 12.2 60.9 59.3-14.4 83.8 75.2-39.6 75.2 39.6-14.4-83.8 60.9-59.3-84.1-12.2z"]
};
var faPenCircle = {
  prefix: 'fass',
  iconName: 'pen-circle',
  icon: [512, 512, [], "e20e", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM144 288l95-95 80 80-95 95-96 16 16-96zm256-96l-47 47-80-80 47-47 80 80z"]
};
var faLightbulb = {
  prefix: 'fass',
  iconName: 'lightbulb',
  icon: [384, 512, [128161], "f0eb", "M288 358.3c57.4-33.2 96-95.2 96-166.3 0-106-86-192-192-192S0 86 0 192c0 71.1 38.6 133.1 96 166.3l0 25.7 192 0 0-25.7zm0 73.7l-192 0 0 96 192 0 0-96zM184 112c-39.8 0-72 32.2-72 72l0 8-48 0 0-8c0-66.3 53.7-120 120-120l8 0 0 48-8 0z"]
};
var faPageCaretDown = {
  prefix: 'fass',
  iconName: 'page-caret-down',
  icon: [384, 512, ["file-caret-down"], "e429", "M240 0L0 0 0 512 384 512 384 144 240 0zM96 224l192 0 0 24-96 104-96-104 0-24z"]
};
var faFileCaretDown = faPageCaretDown;
var faBookBlank = {
  prefix: 'fass',
  iconName: 'book-blank',
  icon: [448, 512, [128213, 128215, 128216, 128217, "book-alt"], "f5d9", "M384 0l-384 0 0 512 448 0 0-64-32 0 0-64 32 0 0-384-64 0zM96 384l256 0 0 64-288 0 0-32c0-17.7 14.3-32 32-32z"]
};
var faBookAlt = faBookBlank;
var faTrashUndo = {
  prefix: 'fass',
  iconName: 'trash-undo',
  icon: [448, 512, ["trash-arrow-turn-left"], "f895", "M304-16l16 48 128 0 0 64-448 0 0-64 128 0 16-48 160 0zM32 144l384 0-24 368-336 0-24-368zM209 257l17-17-33.9-33.9c-3.5 3.5-30.5 30.5-81 81l-17 17c3.5 3.5 30.5 30.5 81 81l17 17 33.9-33.9c-10.3-10.3-23.6-23.6-40-40l54.1 0c22.1 0 40 17.9 40 40l0 64 48 0 0-64c0-48.6-39.4-88-88-88l-54.1 0 23-23z"]
};
var faTrashArrowTurnLeft = faTrashUndo;
var faSubtitles = {
  prefix: 'fass',
  iconName: 'subtitles',
  icon: [512, 512, [], "e60f", "M512 64l-512 0 0 384 512 0 0-384zM88 240l200 0 0 48-224 0 0-48 24 0zm272 0l88 0 0 48-112 0 0-48 24 0zM88 336l88 0 0 48-112 0 0-48 24 0zm160 0l200 0 0 48-224 0 0-48 24 0z"]
};
var faWaveTriangle = {
  prefix: 'fass',
  iconName: 'wave-triangle',
  icon: [576, 512, [], "f89a", "M196.2 40.1l23.7 39.5 168.3 280.5 99.2-124.1 20-25 50 40-20 25C435.6 403.3 383.3 468.6 380.7 471.9l-23.7-39.5-168.3-280.5-99.3 124.1-20 25-50-40 20-25C141.4 108.7 193.6 43.4 196.2 40.1z"]
};
var faFootWing = {
  prefix: 'fass',
  iconName: 'foot-wing',
  icon: [576, 512, [], "e834", "M246.4-32c94.6 0 171.2 76.7 171.3 171.2 0 39.6-13.8 78.1-38.9 108.7l-3.9 4.7 73.7 147.3 43.9 5.5c48 6 84.1 46.8 84.1 95.2l0 43.3-224 0-240.7-144.4C67.5 373 52.2 316.2 77 271l25.6-46.6c-23-15.9-38.1-42.4-38.1-72.4l0-27.4C27.6 114.1 .5 80.3 .5 40l0-72 245.9 0zM48.5 40c0 22.1 17.9 40 40 40l168 0 0 48-144 0 0 24c0 22.1 17.9 40 40 40l85.1 0 0 48-85.1 0c-1.2 0-2.4-.1-3.5-.2l-18.7 34 110.6 66.3 100.8-122.7c18.1-22.1 28-49.7 28-78.3 0-68.1-55.2-123.2-123.3-123.2l-197.9 0 0 24z"]
};
var faGaugeCirclePlus = {
  prefix: 'fass',
  iconName: 'gauge-circle-plus',
  icon: [640, 512, [], "e498", "M288 0c126.8 0 232.1 92.2 252.4 213.2-14.3-3.4-29.1-5.2-44.4-5.2-70.9 0-132.8 38.4-166.1 95.6-5.3-4.6-11.3-8.3-17.9-11l0-196.7-48 0 0 196.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64 5.7 0 11.2-.7 16.5-2.1 2.5 34.5 14 66.4 32.3 93.5-15.8 3-32.1 4.6-48.8 4.6-141.4 0-256-114.6-256-256S146.6 0 288 0zM176 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM432 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 64-64 0 0 32 64 0 0 64 32 0 0-64 64 0 0-32-64 0 0-48z"]
};
var faFilmMusic = {
  prefix: 'fass',
  iconName: 'film-music',
  icon: [640, 512, [], "e769", "M64 32l448 0 0 166.7-160 29.1 0 176c-15.3 3.8-29.7 10.5-42.1 19.7-17.1 12.8-31.9 32.2-36.5 56.4L64 480 64 32zm48 320l0 64 64 0 0-64-64 0zm0-128l0 64 64 0 0-64-64 0zm0-128l0 64 64 0 0-64-64 0zm352 0l-64 0 0 64 64 0 0-64zM624 255.8l0 208.1c0 23.3-18 35.4-29.1 40.5-11.9 5.4-25.4 7.5-34.9 7.5s-22.9-2.1-34.9-7.5c-11.1-5-29.1-17.2-29.1-40.5s18-35.4 29.1-40.5c11.9-5.4 25.4-7.5 34.9-7.5 4.6 0 10.1 .5 16 1.6l0-85-128 23.3 0 140.1c0 23.3-18 35.4-29.1 40.5-11.9 5.4-25.4 7.5-34.9 7.5s-22.9-2.1-34.9-7.5c-11.1-5-29.1-17.2-29.1-40.5s18-35.4 29.1-40.5c11.9-5.4 25.4-7.5 34.9-7.5 4.6 0 10.1 .5 16 1.6l0-181.8 19.7-3.6 176-32 28.3-5.1 0 28.8z"]
};
var faHeadSide = {
  prefix: 'fass',
  iconName: 'head-side',
  icon: [512, 512, [], "f6e9", "M224 0C338.4 0 432.7 85.7 446.3 196.4l49.7 59.6 0 64-64 0 0 128-112 0 0 64-256 0 0-131.2C24.4 340.4 0 285 0 224 0 100.3 100.3 0 224 0zm96 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faOctagonEquals = {
  prefix: 'fass',
  iconName: 'octagon-equals',
  icon: [512, 512, [], "e6b3", "M0 160L0 352 160 512 352 512 512 352 512 160 352 0 160 0 0 160zm160 16l192 0 0 48-192 0 0-48zm0 112l192 0 0 48-192 0 0-48z"]
};
var faChevronsLeft = {
  prefix: 'fass',
  iconName: 'chevrons-left',
  icon: [512, 512, ["chevron-double-left"], "f323", "M41.6 233.4l-22.6 22.6 22.6 22.6 192 192 22.6 22.6 45.3-45.3-22.6-22.6-169.4-169.4 169.4-169.4 22.6-22.6-45.3-45.3-22.6 22.6-192 192zm192 0l-22.6 22.6 22.6 22.6 192 192 22.6 22.6 45.3-45.3-22.6-22.6-169.4-169.4 169.4-169.4 22.6-22.6-45.3-45.3-22.6 22.6-192 192z"]
};
var faChevronDoubleLeft = faChevronsLeft;
var faCircleArrowRight = {
  prefix: 'fass',
  iconName: 'circle-arrow-right',
  icon: [512, 512, ["arrow-circle-right"], "f0a9", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM377 273l-80 80-17 17-33.9-33.9c7.6-7.6 26.3-26.3 56-56l-174.1 0 0-48 174.1 0c-29.7-29.7-48.4-48.4-56-56L280 142.1c.8 .8 33.1 33.1 97 97l17 17-17 17z"]
};
var faArrowCircleRight = faCircleArrowRight;
var faGameBoard = {
  prefix: 'fass',
  iconName: 'game-board',
  icon: [448, 512, [], "f867", "M0 32l448 0 0 448-448 0 0-448zM144 96l0 80 80 0 0-80-80 0zm0 160l0-80-80 0 0 80 80 0zm80 0l-80 0 0 80-80 0 0 80 80 0 0-80 80 0 0 80 80 0 0-80 80 0 0-80-80 0 0-80 80 0 0-80-80 0 0 80-80 0 0 80zm0 0l80 0 0 80-80 0 0-80z"]
};
var faFileChartColumn = {
  prefix: 'fass',
  iconName: 'file-chart-column',
  icon: [384, 512, ["file-chart-line"], "f659", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM208 280l0-24-48 0 0 192 48 0 0-168zm96 32l0-24-48 0 0 160 48 0 0-136zM112 344l0-24-48 0 0 128 48 0 0-104z"]
};
var faFileChartLine = faFileChartColumn;
var faCustard = {
  prefix: 'fass',
  iconName: 'custard',
  icon: [512, 512, [127854], "e403", "M416 64l27.7 124.7-69.1-19.7-6.6-1.9-6.6 1.9-105.4 30.1-105.4-30.1-6.6-1.9-6.6 1.9-69.1 19.7 27.7-124.7 320 0zM32.3 350.9l24.2-108.9 87.6-25 105.4 30.1 6.6 1.9 6.6-1.9 105.4-30.1 87.5 25 24.5 110-447.7-1.1zM24 400l488 0 0 48-512 0 0-48 24 0z"]
};
var faBlockQuestion = {
  prefix: 'fass',
  iconName: 'block-question',
  icon: [448, 512, [], "e3dd", "M448 480l-448 0 0-448 448 0 0 448zM72 384a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm304 0a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM200 352l0 48 48 0 0-48-48 0zm-8-208c-30.9 0-56 25.1-56 56l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.8 0c8.4 0 15.2 6.8 15.2 15.2 0 4.4-2.7 10.5-14.3 19.6-15.6 12.1-33.4 21.4-49.7 32.7l0 52.5 48 0 0-26.9c8.4-5.1 20.2-12 31.1-20.5 14.7-11.5 32.9-30 32.9-57.5 0-34.9-28.3-63.2-63.2-63.2L192 144zM72 80a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm304 0a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faMarsAndVenus = {
  prefix: 'fass',
  iconName: 'mars-and-venus',
  icon: [512, 512, [9893], "f224", "M336-64l176 0 0 176-64 0 0-66.7-63 63c19.5 28.4 31 62.7 31 99.8 0 86.3-62.1 158.1-144 173.1l0 34.9 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-34.9c-81.9-15-144-86.8-144-173.1 0-97.2 78.8-176 176-176 37 0 71.4 11.4 99.8 31l63-63-66.7 0 0-64zm16 272a112 112 0 1 0 -224 0 112 112 0 1 0 224 0z"]
};
var faNetworkWired = {
  prefix: 'fass',
  iconName: 'network-wired',
  icon: [576, 512, [], "f6ff", "M328 88l0 48-80 0 0-48 80 0zM248 32l-56 0 0 160 64 0 0 32-256 0 0 64 128 0 0 32-64 0 0 160 192 0 0-160-64 0 0-32 192 0 0 32-64 0 0 160 192 0 0-160-64 0 0-32 128 0 0-64-256 0 0-32 64 0 0-160-136 0zM120 376l80 0 0 48-80 0 0-48zm336 0l0 48-80 0 0-48 80 0z"]
};
var faFaceConfused = {
  prefix: 'fass',
  iconName: 'face-confused',
  icon: [512, 512, [], "e36d", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM203.2 385.6l-32 24-28.8-38.4c13.9-10.4 24.5-18.4 32-24 37.4-28 82.9-43.2 129.6-43.2l64 0 0 48-64 0c-36.3 0-71.7 11.8-100.8 33.6zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBuildingShield = {
  prefix: 'fass',
  iconName: 'building-shield',
  icon: [576, 512, [], "e4d8", "M416 0l-384 0 0 512 266.3 0c-12.6-14.6-23.5-30.8-32.2-48l-90.1 0 0-112 64 0 0-82.6 16-5.3 0-40.1 64 0 0 18.7 96-32 0-210.7zM128 96l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM128 224l64 0 0 64-64 0 0-64zM462 530.8c69.3-30.8 114-99.6 114-175.5l0-51.2-144-48-144 48 0 51.2c0 75.9 44.7 144.6 114 175.5l30 13.3 30-13.3zm-30-39.2l0-184.9 96 32 0 16.6c0 56.9-33.5 108.5-85.5 131.6L432 491.6z"]
};
var faBedEmpty = {
  prefix: 'fass',
  iconName: 'bed-empty',
  icon: [576, 512, [128719], "f8f9", "M64 64l0-32-64 0 0 448 64 0 0-96 448 0 0 96 64 0 0-288-512 0 0-128z"]
};
var faGrillHot = {
  prefix: 'fass',
  iconName: 'grill-hot',
  icon: [448, 512, [], "e5a5", "M128-64l0 24c0 9 3.6 17.6 9.9 24L168 14.1c15.4 15.4 24 36.2 24 57.9l0 24-48 0 0-24c0-9-3.6-17.6-9.9-24L104 17.9C88.6 2.6 80-18.3 80-40l0-24 48 0zM0 144l448 0c0 86.2-52.4 160.2-127.2 191.7l53.2 124.2c1.8 4.1 6.2 14.6 13.5 31.4l-44.1 18.9c-14.5-33.8-15.2-35.4-26.6-62.2L160 448c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c3.4 0 6.8 .3 10.1 .8l21-49.1C52.4 304.2 0 230.2 0 144zM151.8 400l144.4 0-21.8-50.8C263.2 351 251.7 352 240 352l-32 0c-11.7 0-23.2-1-34.4-2.8L151.8 400zM96 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM240-40c0 9 3.6 17.6 9.9 24L280 14.1c15.4 15.4 24 36.2 24 57.9l0 24-48 0 0-24c0-9-3.6-17.6-9.9-24L216 17.9C200.6 2.6 192-18.3 192-40l0-24 48 0 0 24z"]
};
var faEarWaveform = {
  prefix: 'fass',
  iconName: 'ear-waveform',
  icon: [640, 512, [], "e75d", "M474 240c3.9-15.3 6-31.4 6-48 0-106-86-192-192-192S96 86 96 192l0 320 208 0 0-224 80 0 0-48 90 0zM288 112c-44.2 0-80 35.8-80 80l0 16.4c36 4 64 34.5 64 71.6 0 39.8-32.2 72-72 72l-40 0 0-48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-64c0-70.7 57.3-128 128-128s128 57.3 128 128l-48 0c0-44.2-35.8-80-80-80zM480 288l-48 0 0 256 48 0 0-256zm80 32l-48 0 0 192 48 0 0-192zM400 336l-48 0 0 160 48 0 0-160zm240 32l-48 0 0 96 48 0 0-96z"]
};
var faCode = {
  prefix: 'fass',
  iconName: 'code',
  icon: [640, 512, [], "f121", "M362.3-7.6l-8.8 30.8-128 448-8.8 30.8 61.5 17.6 8.8-30.8 128-448 8.8-30.8-61.5-17.6zM435 160c6.6 6.6 38.6 38.6 96 96-57.4 57.4-89.4 89.4-96 96l45.3 45.3 118.6-118.6 22.6-22.6c-2.9-2.9-42.4-42.4-118.6-118.6L480.3 114.7 435 160zM160.3 114.7c-2.9 2.9-42.4 42.4-118.6 118.6L19 256c2.9 2.9 42.4 42.4 118.6 118.6l22.6 22.6 45.3-45.3c-6.6-6.6-38.6-38.6-96-96 57.4-57.4 89.4-89.4 96-96l-45.3-45.3z"]
};
var faFeatherPointed = {
  prefix: 'fass',
  iconName: 'feather-pointed',
  icon: [512, 512, ["feather-alt"], "f56b", "M512 0c-4.4 53.7-19.9 155.2-54.5 245.1l-89.5 26.9 0 16 71.1 0c-8.2 16.9-17.2 32.9-27.1 47.6l-108 32.4 0 16 66.3 0c-65 57.7-174.7 91.5-248.8 38.4L32 512 0 480c44.2-44.3 134.9-134.9 272-272L240 176 68.9 347.1C48.3 273.6 85.1 183.9 137.4 131.6 228.5 40.5 428.3 6.9 512 0z"]
};
var faFeatherAlt = faFeatherPointed;
var faBoxIsometricTape = {
  prefix: 'fass',
  iconName: 'box-isometric-tape',
  icon: [512, 512, [], "e798", "M496 391L256 526 16 391 16 120 105.5 69.3 352 208 352 333 432 288 432 160 187.8 22.6 256-16 496 120 496 391z"]
};
var faFileCircleQuestion = {
  prefix: 'fass',
  iconName: 'file-circle-question',
  icon: [576, 512, [], "e4ef", "M272 0l-240 0 0 512 244 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3L416 144 272 0zm85.5 176L240 176 240 58.5 357.5 176zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 344c-13.3 0-24 10.7-24 24l-32 0c0-30.9 25.1-56 56-56s56 25.1 56 56c0 19.8-11.7 37.8-29.8 45.9l-10.2 4.5 0 5.6-32 0 0-26.4c4.6-2.1 14.4-6.4 29.2-13 6.6-2.9 10.8-9.4 10.8-16.6 0-13.3-10.7-24-24-24zM416 480l0-32 32 0 0 32-32 0z"]
};
var faFaceNoseSteam = {
  prefix: 'fass',
  iconName: 'face-nose-steam',
  icon: [512, 512, [], "e382", "M498.3 339.8c9.1-26.2 14-54.4 14-83.8 0-141.4-114.6-256-256-256S.3 114.6 .3 256c0 29.6 5 58.1 14.3 84.6 31.8-22.5 75.1-21.5 105.8 3.1 33.3-19.3 57.3-33.3 71.9-41.8 34.9 34.9 31.5 31.5 51.5 51.5-8.5 14.6-22.4 38.6-41.8 71.9 19.2 24 24.1 55.7 14.5 83.6 13 2 26.2 3.1 39.7 3.1 14 0 27.7-1.1 41.1-3.3-9.5-27.8-4.6-59.4 14.6-83.3-19.3-33.3-33.3-57.3-41.8-71.9 34.9-34.9 31.5-31.5 51.5-51.5 14.6 8.5 38.6 22.4 71.9 41.8 30.3-24.3 73-25.6 104.6-3.9zM96.3 224l128 0 0 48-128 0 0-48zm192 0l128 0 0 48-128 0 0-48zm88.9-62.1c-50.3 25.2-77.6 38.8-81.9 40.9l-17.9-35.8c4.2-2.1 31.5-15.8 81.9-40.9l17.9-8.9 17.9 35.8-17.9 8.9zm-259.8-8.9l17.9-35.8 81.9 40.9 17.9 8.9-17.9 35.8-81.9-40.9-17.9-8.9zM414.7 378.5c-5.5 5.5-9.4 12-11.7 19l-82.7-45.5 45.5 82.7c-6.9 2.3-13.5 6.2-19 11.7-18.7 18.7-18.7 49.1 0 67.9 14.8 14.8 36.8 17.9 54.7 9.4 .6 .7 1.2 1.3 1.9 2 25 25 65.5 25 90.5 0s25-65.5 0-90.5c-.6-.6-1.3-1.3-2-1.9 8.6-17.8 5.4-39.9-9.4-54.7-18.7-18.7-49.1-18.7-67.9 0zM22.2 433.2c-.7 .6-1.3 1.2-2 1.9-25 25-25 65.5 0 90.5s65.5 25 90.5 0c.6-.6 1.3-1.3 1.9-2 17.9 8.6 39.9 5.4 54.7-9.4 18.7-18.7 18.7-49.1 0-67.9-5.7-5.7-12.4-9.6-19.5-11.9L192.3 352 111 397.2c-2.3-6.8-6.1-13.2-11.6-18.7-18.7-18.7-49.1-18.7-67.9 0-14.8 14.8-17.9 36.8-9.4 54.7z"]
};
var faSignature = {
  prefix: 'fass',
  iconName: 'signature',
  icon: [640, 512, [], "f5b7", "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 7.8c0 27.7-2.4 55.3-7.1 82.5l-130 39-22.8 6.8 0 103.8-96 0 0 48 96 0 0 64 114.6 0c3.4-6 15-26.3 34.8-60.8 26.8-47 46.5-97.7 58.4-150.5l94.4-28.3c-8.1 24.2-16.9 50.8-26.5 79.6l204.4 0 0-64-115.6 0c11.7-35.2 24.2-72.6 37.5-112.4-28.8 8.6-89.3 26.8-181.4 54.4 2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96s-96 43-96 96l0 64 64 0 0-64zM160 311.8l71.8-21.5c-10.4 33.8-24.5 66.4-42.1 97.2l-16.3 28.6-13.4 0 0-104.2zM616 416l24 0 0-48-316.9 0c-6.5 16.3-13.7 32.3-21.6 48L616 416z"]
};
var faEarthAmericas = {
  prefix: 'fass',
  iconName: 'earth-americas',
  icon: [512, 512, [127758, "earth", "earth-america", "globe-americas"], "f57d", "M55.7 199.7l40.3 40.3 48 0 48 48 0 64 32 32 0 64 64 0 0-48 64-64 0-80-128 0-32-32 0-32 80 0 0-32-32-32 0-16 32-32 0-31.4c-5.3-.4-10.6-.6-16-.6-95.4 0-175.7 64.2-200.3 151.7zM464 256c0-36.9-9.6-71.5-26.4-101.6l-37.6 37.6 0 80 63.4 0c.4-5.3 .6-10.6 .6-16zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"]
};
var faEarth = faEarthAmericas;
var faEarthAmerica = faEarthAmericas;
var faGlobeAmericas = faEarthAmericas;
var faCarrot = {
  prefix: 'fass',
  iconName: 'carrot',
  icon: [640, 512, [129365], "f787", "M464-48L440.6-24.6c-31.2 31.2-31.2 81.9 0 113.1 15.6 15.6 31.2 31.2 46.9 46.9 31.2 31.2 81.9 31.2 113.1 0L624 112 600.6 88.6c-31.2-31.2-81.9-31.2-113.1 0 31.2-31.2 31.2-81.9 0-113.1L464-48zM332.3 96c-45.5 0-87.6 20.8-115.2 55.2 43.7 43.7 68 68 72.8 72.8L256 257.9c-6.4-6.4-27.5-27.5-63.4-63.4-86.5 201.8-133.7 311.9-141.6 330.3 40.9-17.5 106.2-45.5 195.9-84-30.5-30.5-49.5-49.5-57-57L224 350.1c5.2 5.2 28.7 28.7 70.5 70.5l95.9-41.1C444.8 356.2 480 302.8 480 243.7 480 162.1 413.9 96 332.3 96z"]
};
var faSparkles = {
  prefix: 'fass',
  iconName: 'sparkles',
  icon: [640, 512, [10024], "f890", "M480 32l32-72 32 72 72 32-72 32-32 72-32-72-72-32 72-32zM160 192l64-144 64 144 144 64-144 64-64 144-64-144-144-64 144-64zM480 344l32 72 72 32-72 32-32 72-32-72-72-32 72-32 32-72z"]
};
var faSquareL = {
  prefix: 'fass',
  iconName: 'square-l',
  icon: [448, 512, [], "e275", "M448 32l-448 0 0 448 448 0 0-448zM192 168l0 152 112 0 0 48-160 0 0-224 48 0 0 24z"]
};
var faCauldron = {
  prefix: 'fass',
  iconName: 'cauldron',
  icon: [448, 512, [], "f6bf", "M160 32c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm128 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM35.1 224C16.5 257 0 297.1 0 334.4 0 371.8 11.9 403.8 32 429.9l0 82.1 48 0 0-39c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39l0 39 48 0 0-82.1c20.1-26.1 32-58.1 32-95.5 0-37.3-16.5-77.4-35.1-110.4l35.1 0 0-64-448 0 0 64 35.1 0z"]
};
var faTemperatureFull = {
  prefix: 'fass',
  iconName: 'temperature-full',
  icon: [320, 512, ["temperature-4", "thermometer-4", "thermometer-full"], "f2c7", "M256 0L64 0 64 260.7C34.5 287 16 325.4 16 368 16 447.5 80.5 512 160 512s144-64.5 144-144c0-42.6-18.5-81-48-107.3L256 0zM224 368c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-236.7 48 0 0 236.7c23.5 9.5 40 32.5 40 59.3z"]
};
var faTemperature4 = faTemperatureFull;
var faThermometer4 = faTemperatureFull;
var faThermometerFull = faTemperatureFull;
var faTableCellsRowLock = {
  prefix: 'fass',
  iconName: 'table-cells-row-lock',
  icon: [640, 512, [], "e67a", "M256 288l0-64 153.3 0c17.1-42.2 56-73.2 102.7-79l0-113-448 0 0 448 304 0 0-64-112 0 0-64 112 0 0-64-112 0zm0-192l192 0 0 64-192 0 0-64zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faCircleUserCirclePlus = {
  prefix: 'fass',
  iconName: 'circle-user-circle-plus',
  icon: [640, 512, [], "e7a3", "M496 208c-77.5 0-144.3 45.9-174.6 112l-145.4 0-23.9 71.6c34.8 34.8 82.8 56.4 135.9 56.4 7.4 0 14.6-.4 21.7-1.2 5.5 21.9 14.8 42.4 27.1 60.6-15.8 3-32.1 4.6-48.8 4.6-141.4 0-256-114.6-256-256S146.6 0 288 0c126.8 0 232.1 92.2 252.4 213.2-14.3-3.4-29.1-5.2-44.4-5.2zM288 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm208-16a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 64-64 0 0 32 64 0 0 64 32 0 0-64 64 0 0-32-64 0 0-48z"]
};
var faBoltLightning = {
  prefix: 'fass',
  iconName: 'bolt-lightning',
  icon: [384, 512, [], "e0b7", "M0 288l32-288 224 0-48 160 176 0 0 48-256 304 48-224-176 0z"]
};
var faCloudShowersWater = {
  prefix: 'fass',
  iconName: 'cloud-showers-water',
  icon: [512, 512, [], "e4e4", "M279.4 55.7c-15.2-32.9-48.5-55.7-87.2-55.7-53 0-96 43-96 96-35.3 0-64 28.7-64 64l0 64 448 0 0-64c0-35.3-28.7-64-64-64l-1.6 0c-7.4-36.5-39.7-64-78.4-64-22.2 0-42.3 9.1-56.8 23.7zM22.9 384l50.6 0 37.3-112-50.6 0-37.3 112zm402.6 0l37.3-112-50.6 0-37.3 112 50.6 0zm-120 0l37.3-112-50.6 0-37.3 112 50.6 0zm-112 0l37.3-112-50.6 0-37.3 112 50.6 0zm-48.4 33.7l-8.9-3.6-8.9 3.6C44.3 450.9 2.2 467.7 1 468.2l17.8 44.6c2.7-1.1 41.9-16.7 117.4-47l111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4c75.5 30.2 114.6 45.9 117.4 46.9l17.8-44.6c-1.2-.5-43.3-17.3-126.3-50.5l-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4z"]
};
var faArrowUpLong = {
  prefix: 'fass',
  iconName: 'arrow-up-long',
  icon: [384, 512, ["long-arrow-up"], "f176", "M214.9-22.6l-22.6-22.6-22.6 22.6-128 128-22.6 22.6 45.3 45.3c6.6-6.6 38.6-38.6 96-96l0 466.7 64 0 0-466.7 96 96 45.3-45.3-22.6-22.6-128-128z"]
};
var faLongArrowUp = faArrowUpLong;
var faFluxCapacitor = {
  prefix: 'fass',
  iconName: 'flux-capacitor',
  icon: [448, 512, [], "f8ba", "M0 32l448 0 0 448-448 0 0-448zM384 152c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 6.6 1.1 12.9 3.2 18.8l-51.2 51.2-51.2-51.2c2.1-5.9 3.2-12.2 3.2-18.8 0-30.9-25.1-56-56-56s-56 25.1-56 56 25.1 56 56 56c6.6 0 12.9-1.1 18.8-3.2l61.2 61.2 0 43.4c-18.9 9-32 28.3-32 50.6 0 30.9 25.1 56 56 56s56-25.1 56-56c0-22.3-13.1-41.6-32-50.6l0-43.4 61.2-61.2c5.9 2.1 12.2 3.2 18.8 3.2 30.9 0 56-25.1 56-56z"]
};
var faAddressCard = {
  prefix: 'fass',
  iconName: 'address-card',
  icon: [576, 512, [62140, "contact-card", "vcard"], "f2bb", "M576 32l-576 0 0 448 576 0 0-448zM256 288l32 96-224 0 32-96 160 0zM120 192a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm240-48l136 0 0 48-160 0 0-48 24 0zm0 96l136 0 0 48-160 0 0-48 24 0z"]
};
var faContactCard = faAddressCard;
var faVcard = faAddressCard;
var faStaff = {
  prefix: 'fass',
  iconName: 'staff',
  icon: [512, 512, [], "f71b", "M306.3 0L512 0 512 244.2c-23.4 6.7-46.2 13.2-68.3 19.5l-30.1 53.3-52.6-29.7-96 27.4C138.1 441.8 73.8 506.1 72 507.9L4.1 440c18.6-18.6 49.3-49.3 91.9-91.9l0-60.1 60.1 0 49.9-49.9 8.8-8.8 12-3.4 189.2-54.1 0-75.8-50.3 0-2.7 5.5-21.5 42.9-85.9-42.9c34.5-69 43.2-86.4 50.7-101.5z"]
};
var faBasketShoppingMinus = {
  prefix: 'fass',
  iconName: 'basket-shopping-minus',
  icon: [576, 512, [], "e652", "M288-10.9l17.4 18.4 144 152 .5 .5 110.1 0 0 64-23.1 0-56.9 256-384 0-56.9-256-23.1 0 0-64 110.1 0 .5-.5 144-152 17.4-18.4zm0 69.8L192.2 160 383.8 160 288 58.9zM216 296l-24 0 0 48 192 0 0-48-168 0z"]
};
var faAngleRight = {
  prefix: 'fass',
  iconName: 'angle-right',
  icon: [320, 512, [8250], "f105", "M301.5 256L278.9 278.6 118.9 438.6 96.3 461.3 51 416 73.6 393.4 211 256 73.6 118.6 51 96 96.3 50.7 118.9 73.4 278.9 233.4 301.5 256z"]
};
var faToiletPaperUnder = {
  prefix: 'fass',
  iconName: 'toilet-paper-under',
  icon: [512, 512, [58015, "toilet-paper-blank-under", "toilet-paper-reverse", "toilet-paper-reverse-alt"], "e2a0", "M327.1 32c-8.8 11.1-16 23.1-21.9 34.8-21.4 42.7-33.2 98.4-33.2 157.2s11.8 114.5 33.2 157.2c5.9 11.7 13.1 23.7 21.9 34.8L96 416C43 416 0 330 0 224S43 32 96 32l231.1 0zM416 288c17.7 0 32-28.7 32-64s-14.3-64-32-64-32 28.7-32 64 14.3 64 32 64zm0 128c-53 0-96-86-96-192s43-192 96-192 96 86 96 192-43 192-96 192zM128 520l0-56 288 0c43 0 74.7-26.7 96-57.6l0 137.6-384 0 0-24z"]
};
var faToiletPaperBlankUnder = faToiletPaperUnder;
var faToiletPaperReverse = faToiletPaperUnder;
var faToiletPaperReverseAlt = faToiletPaperUnder;
var faStomach = {
  prefix: 'fass',
  iconName: 'stomach',
  icon: [512, 512, [], "f623", "M192 32l0-32-64 0 0 224 128 0 0 64c0 35.3-28.7 64-64 64l-192 0 0 160 64 0 0-80 48 0c24.6 0 36 9.5 58.2 28.2l0 0c1.7 1.4 3.4 2.9 5.3 4.4 12.6 10.5 28.4 22.9 49.6 32.2 21.4 9.5 46.9 15.2 78.9 15.2 114.9 0 208-93.1 208-208l0-80c0-70.7-57.3-128-128-128-47.4 0-88.7 25.7-110.9 64l-81.1 0 0-128zM352 256l-32 0 0-32c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80c0 5.4-.3 10.7-.9 16l-39.1 0-43.2-57.6-4.8-6.4-8 0z"]
};
var faFaceCowboyHat = {
  prefix: 'fass',
  iconName: 'face-cowboy-hat',
  icon: [512, 512, [], "e36e", "M0 15C33.9 37.2 73.8 55 117.7 67.2L161.5-64 254.8-26.7 348.1-64 391.8 67.2c43.9-12.1 83.8-30 117.7-52.2-26.5 83-130.5 145-254.8 145S26.5 98 0 15zM32 288c0-46 13.9-88.8 37.7-124.4 47.8 24.5 109.7 41.8 186.3 41.8s138.5-17.3 186.3-41.8C466.1 199.2 480 242 480 288 480 411.7 379.7 512 256 512S32 411.7 32 288zm224 79c-50.9 0-98.3-9.2-138-25.1 11.3 65.9 68.8 116.1 138 116.1s126.6-50.2 138-116.1c-39.6 15.9-87 25.1-138 25.1zm-48-95a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faFaceMeh = {
  prefix: 'fass',
  iconName: 'face-meh',
  icon: [512, 512, [128528, "meh"], "f11a", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM176 320l184 0 0 48-208 0 0-48 24 0z"]
};
var faMeh = faFaceMeh;
var faArrowUpFromGroundWater = {
  prefix: 'fass',
  iconName: 'arrow-up-from-ground-water',
  icon: [640, 512, [], "e4b5", "M320.4-9.9l17 17 88 88 17 17-33.9 33.9c-6.3-6.3-27.6-27.6-64-64l0 302.1-48 0 0-302.1c-36.4 36.4-57.7 57.7-64 64l-33.9-33.9 17-17 88-88 17-17zM240.4 192l0 186.6c-6.6-2.6-19.9-8-40-16-6.4 2.5-47.1 18.8-122.3 48.9l-13.8-4.6 0-214.9 176 0zm336 0l0 214.9-13.7 4.6c-75.1-30.1-115.9-46.4-122.3-48.9-20.1 8-33.4 13.4-40 16l0-186.6 176 0zM209.3 417.7l111.1 44.4 111.1-44.4 8.9-3.6 8.9 3.6 111.8 44.7c29.2-9.7 50.1-16.7 62.4-20.8l15.2 45.5c-11 3.7-34.6 11.5-70.8 23.6l-8.3 2.8-8.2-3.3-111.1-44.4-111.1 44.4-8.9 3.6-8.9-3.6-111.1-44.4-111.1 44.4-8.2 3.3-8.3-2.8C36.6 498.7 13 490.8 2 487.2l15.2-45.5c12.4 4.1 33.2 11.1 62.4 20.8l111.8-44.7 8.9-3.6 8.9 3.6z"]
};
var faFacePleading = {
  prefix: 'fass',
  iconName: 'face-pleading',
  icon: [512, 512, [], "e386", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm160 72c48.6 0 88-39.4 88-88 0-42.2-29.8-77.5-69.5-86 6.8-9.3 12-19.8 15.2-31.3 .3-1.1 2.6-9.2 7-24.4l-38.5-11c-4.3 15.2-6.7 23.3-7 24.4-6.6 23.1-26.4 40.1-50.2 43.1-6.3 .8-16.8 2.1-31.4 3.9l5 39.7 4.1-.5c-6.9 12.5-10.8 26.9-10.8 42.2 0 48.6 39.4 88 88 88zm192 0c48.6 0 88-39.4 88-88 0-15.3-3.9-29.7-10.8-42.2l4.1 .5 5-39.7c-14.6-1.8-25.1-3.1-31.4-3.9-23.9-3-43.6-19.9-50.2-43.1-.3-1.1-2.6-9.2-7-24.4l-38.5 11 5.5 19.2 1.5 5.2c3.3 11.5 8.5 22 15.2 31.3-39.7 8.5-69.5 43.8-69.5 86 0 48.6 39.4 88 88 88zM224 384l-24 0 0 48 112 0 0-48-88 0zM128 232c17.7 0 32-14.3 32-32 0-5.8-1.5-11.2-4.2-15.8 1.4-.1 2.8-.2 4.2-.2 30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4 5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8 1.4-.1 2.8-.2 4.2-.2 30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4 5.7 5.2 13.3 8.4 21.6 8.4 17.7 0 32-14.3 32-32z"]
};
var faEnvelopeCircleUser = {
  prefix: 'fass',
  iconName: 'envelope-circle-user',
  icon: [640, 512, [], "e6de", "M96 64l-32 0 0 72 12.8 9.6 224 168 9.1 6.9c21.2-83 96.4-144.5 186.1-144.5 28.6 0 55.6 6.2 80 17.4L576 64 96 64zM272 352l-208-156 0 252 257.4 0c-10.1-22-16.2-46.3-17.2-71.9L272 352zm368 16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64.5 78.9C555.2 467.4 527.1 480 496 480s-59.2-12.6-79.5-33.1l15.5-30.9 128 0 15.5 30.9zM448 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faBarn = {
  prefix: 'fass',
  iconName: 'barn',
  icon: [576, 512, [], "e6c7", "M80 80l208-80 208 80 56 208-40 0 0 224-448 0 0-224-40 0 56-208zm256 32l-96 0 0 96 96 0 0-96zM192 464L348.5 464 192 320.6 192 464zm35.5-176L384 431.4 384 288 227.5 288z"]
};
var faMap = {
  prefix: 'fass',
  iconName: 'map',
  icon: [512, 512, [128506, 62072], "f279", "M512 64l0-51.8c-19.2 9.6-73.4 36.7-162.5 81.2l-179.4-59.8-12.6-4.2-11.9 5.9-128 64-17.7 8.8 0 391.6c19.2-9.6 73.4-36.7 162.5-81.2l179.4 59.8 12.6 4.2 11.9-5.9 128-64 17.7-8.8 0-339.8zM192 360.9l0-252.5 128 42.7 0 252.5-128-42.7z"]
};
var faUserPlus = {
  prefix: 'fass',
  iconName: 'user-plus',
  icon: [640, 512, [], "f234", "M136 128a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zM400 304l64 208-416 0 64-208 288 0zm120-16l0-72-72 0 0-48 72 0 0-72 48 0 0 72 72 0 0 48-72 0 0 72-48 0z"]
};
var faTurnDownLeft = {
  prefix: 'fass',
  iconName: 'turn-down-left',
  icon: [512, 512, [], "e331", "M0 256l192-192 0 128 192 0 0-128 128 0 0 256-320 0 0 128-192-192z"]
};
var faPlaneEngines = {
  prefix: 'fass',
  iconName: 'plane-engines',
  icon: [576, 512, [9992, "plane-alt"], "f3de", "M520 200c30.9 0 56 25.1 56 56s-25.1 56-56 56l-127.3 0-66 72 25.3 0 0 64-84 0-44 48-80 0 61.3-184-99.7 0-57.6 72-48 0 32-128-32-128 48 0 57.6 72 99.7 0-61.3-184 80 0 44 48 84 0 0 64-25.3 0 66 72 127.3 0z"]
};
var faPlaneAlt = faPlaneEngines;
var faVenus = {
  prefix: 'fass',
  iconName: 'venus',
  icon: [384, 512, [9792], "f221", "M80 176a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM224 349.1c81.9-15 144-86.8 144-173.1 0-97.2-78.8-176-176-176S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1l0 66.9-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-66.9z"]
};
var faUserDoctorMessage = {
  prefix: 'fass',
  iconName: 'user-doctor-message',
  icon: [576, 512, ["user-md-chat"], "f82e", "M320 0l0 192 64 0 0 80 80-80 112 0 0-192-256 0zM224 8C157.7 8 104 61.7 104 128s53.7 120 120 120c17.1 0 33.3-3.6 48-10l0-220c-14.7-6.4-30.9-10-48-10zm60 359.4l0-47.4-120 0 0 68.4c16.5 7.6 28 24.3 28 43.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-19.4 11.5-36.1 28-43.6l0-68.4-44 0-64 192 416 0-64-192-44 0 0 47.4c23.3 8.2 40 30.5 40 56.6l0 52-40 0 0-52c0-11-9-20-20-20s-20 9-20 20l0 52-40 0 0-52c0-26.1 16.7-48.3 40-56.6z"]
};
var faUserMdChat = faUserDoctorMessage;
var faBarsSort = {
  prefix: 'fass',
  iconName: 'bars-sort',
  icon: [448, 512, [], "e0ae", "M0 64l448 0 0 64-448 0 0-64zM0 224l320 0 0 64-320 0 0-64zM192 384l0 64-192 0 0-64 192 0z"]
};
var faHighDefinition = {
  prefix: 'fass',
  iconName: 'high-definition',
  icon: [512, 512, ["rectangle-hd"], "e1ae", "M0 64l512 0 0 384-512 0 0-384zm144 96l-48 0 0 192 48 0 0-72 48 0 0 72 48 0 0-192-48 0 0 72-48 0 0-72zm152 0l-24 0 0 192 72 0c39.8 0 72-32.2 72-72l0-48c0-39.8-32.2-72-72-72l-48 0zm48 144l-24 0 0-96 24 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24z"]
};
var faRectangleHd = faHighDefinition;
var faCirclePeseta = {
  prefix: 'fass',
  iconName: 'circle-peseta',
  icon: [576, 512, [], "e741", "M296 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM208 120l88 0c52 0 95.1 38.2 102.8 88l25.2 0 0 32-25.2 0c-7.7 49.8-50.8 88-102.8 88l-40 0 0 64-48 0 0-152-24 0 0-32 24 0 0-88zm88 48l-40 0 0 40 93.7 0c-6.9-23.1-28.3-40-53.7-40zM256 280l40 0c25.4 0 46.8-16.9 53.7-40l-93.7 0 0 40z"]
};
var faDitto = {
  prefix: 'fass',
  iconName: 'ditto',
  icon: [320, 512, [], "22", "M0 32l32 256 64 0 32-256-128 0zm192 0l32 256 64 0 32-256-128 0z"]
};
var faSquareArrowDownRight = {
  prefix: 'fass',
  iconName: 'square-arrow-down-right',
  icon: [448, 512, [], "e262", "M0 480l448 0 0-448-448 0 0 448zM184 304l54.1 0-103-103-17-17 33.9-33.9 17 17 103 103 0-78.1 48 0 0 160-160 0 0-48 24 0z"]
};
var faPipeValve = {
  prefix: 'fass',
  iconName: 'pipe-valve',
  icon: [512, 512, [], "e439", "M288 32l0 32 96 0 0 64-96 0 0 64 160 0 0-32 64 0 0 320-64 0 0-32-384 0 0 32-64 0 0-320 64 0 0 32 160 0 0-64-96 0 0-64 96 0 0-32 64 0z"]
};
var faSquareS = {
  prefix: 'fass',
  iconName: 'square-s',
  icon: [448, 512, [], "e27d", "M448 32l-448 0 0 448 448 0 0-448zM202.5 144l93.5 0 0 48-93.5 0c-10.2 0-18.5 8.3-18.5 18.5 0 9.3 6.9 17.2 16.2 18.3l53.6 6.7c33.3 4.2 58.2 32.4 58.2 66 0 36.7-29.8 66.5-66.5 66.5l-101.5 0 0-48 101.5 0c10.2 0 18.5-8.3 18.5-18.5 0-9.3-6.9-17.2-16.2-18.3l-53.6-6.7c-33.3-4.2-58.2-32.4-58.2-66 0-36.7 29.8-66.5 66.5-66.5z"]
};
var faDiagramSuccessor = {
  prefix: 'fass',
  iconName: 'diagram-successor',
  icon: [512, 512, [], "e47a", "M305.5 128l70.6 0 0-48-120 0 0 144-224 0 0-192 392 0 0 96 70.6 0c-13.4 13.4-41.2 41.2-83.3 83.3l-11.3 11.3-11.3-11.3c-42.1-42.1-69.9-69.9-83.3-83.3zM480.1 480l-448 0 0-192 448 0 0 192zm-288-320l0-64-96 0 0 64 96 0z"]
};
var faHeadSideCoughSlash = {
  prefix: 'fass',
  iconName: 'head-side-cough-slash',
  icon: [576, 512, [], "e062", "M527-16.9l17-17 33.9 33.9-17 17-512 512-17 17-33.9-33.9C9.3 500.8 20.7 489.4 32.1 478l0-472.8C47.6 1.8 63.7 0 80.1 0 194.5 0 288.8 85.7 302.4 196.4l5.1 6.2 219.4-219.4zM134 512l154.2-154.2 0 154.2-154.2 0zm74.2-320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm280 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm128 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faArrowsMaximize = {
  prefix: 'fass',
  iconName: 'arrows-maximize',
  icon: [448, 512, ["expand-arrows"], "f31d", "M288 32l-32 0 0 64 82.7 0-114.7 114.7-114.7-114.7 82.7 0 0-64-192 0 0 192 64 0 0-82.7 114.7 114.7-114.7 114.7 0-82.7-64 0 0 192 192 0 0-64-82.7 0 114.7-114.7 114.7 114.7-82.7 0 0 64 192 0 0-192-64 0 0 82.7-114.7-114.7 114.7-114.7 0 82.7 64 0 0-192-160 0z"]
};
var faExpandArrows = faArrowsMaximize;
var faPlusLarge = {
  prefix: 'fass',
  iconName: 'plus-large',
  icon: [512, 512, [], "e59e", "M288 32l0-32-64 0 0 224-224 0 0 64 224 0 0 224 64 0 0-224 224 0 0-64-224 0 0-192z"]
};
var faMugTea = {
  prefix: 'fass',
  iconName: 'mug-tea',
  icon: [576, 512, [], "f875", "M168 64l0 64-40 48 0 112 128 0 0-112-40-48 0-64 232 0c70.7 0 128 57.3 128 128S518.7 320 448 320l0 128-384 0 0-384 104 0zM512 192c0-35.3-28.7-64-64-64l0 128c35.3 0 64-28.7 64-64z"]
};
var faDiagramProject = {
  prefix: 'fass',
  iconName: 'diagram-project',
  icon: [512, 512, ["project-diagram"], "f542", "M0 32l192 0 0 64 128 0 0-64 192 0 0 192-192 0 0-64-128 0 0 42.7 64 85.3 128 0 0 192-192 0 0-170.7-64-85.3-128 0 0-192z"]
};
var faProjectDiagram = faDiagramProject;
var faTerminal = {
  prefix: 'fass',
  iconName: 'terminal',
  icon: [576, 512, [], "f120", "M41.6 118.6L19 96 64.3 50.7 86.9 73.4 246.9 233.4 269.5 256 246.9 278.6 86.9 438.6 64.3 461.3 19 416 41.6 393.4 179 256 41.6 118.6zM256.3 384l288 0 0 64-320 0 0-64 32 0z"]
};
var faEclipse = {
  prefix: 'fass',
  iconName: 'eclipse',
  icon: [640, 512, [], "f749", "M165.6-20.2c10.6 7.1 48.8 32.4 114.4 75.9 65.6-43.5 103.8-68.8 114.4-75.9 4.4 21.6 9.8 48.3 16.2 80.1-39.4 13.9-73.4 39.4-97.8 72.4-10.5-2.8-21.5-4.2-32.8-4.2-70.7 0-128 57.3-128 128s57.3 128 128 128c11.3 0 22.3-1.5 32.8-4.2 24.4 33 58.4 58.5 97.8 72.4-6.4 31.8-11.8 58.5-16.2 80.1-10.6-7.1-48.8-32.4-114.4-75.9-65.6 43.5-103.8 68.8-114.4 75.9-2.5-12.5-11.6-57.4-27.2-134.6-77.2-15.6-122.1-24.7-134.6-27.2 7.1-10.6 32.4-48.8 75.9-114.4-43.5-65.6-68.8-103.8-75.9-114.4 12.5-2.5 57.4-11.6 134.6-27.2 15.6-77.2 24.7-122.1 27.2-134.6zM280 176c2.6 0 5.2 .1 7.8 .4-10.2 24.5-15.8 51.4-15.8 79.6s5.6 55.1 15.8 79.6c-2.6 .2-5.2 .4-7.8 .4-44.2 0-80-35.8-80-80s35.8-80 80-80zM480 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z"]
};
var faHouseFire = {
  prefix: 'fass',
  iconName: 'house-fire',
  icon: [640, 512, [], "e50c", "M288 464c7.2 17.3 16.7 33.4 28.2 48l-236.2 0 0-240-48 0 0-48 256-240 160.8 150.7-26.2 16.4c-25.4 15.9-61.7 45-92.1 83.2-18.8 23.6-36.9 52.6-47.9 85.7l-58.6 0 0 144 64 0zM448 192l64 64 32-32c76.8 64 96 133.3 96 160 0 88.4-71.6 160-160 160S320 472.4 320 384c0-89.6 85.3-165.3 128-192zm96 240.2c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faMask = {
  prefix: 'fass',
  iconName: 'mask',
  icon: [576, 512, [], "f6fa", "M288 64C64 64 0 160 0 272S80 448 176 448l48 0 32-96 64 0 32 96 48 0c96 0 176-64 176-176S512 64 288 64zM96 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faHurricane = {
  prefix: 'fass',
  iconName: 'hurricane',
  icon: [384, 512, [], "f751", "M0 208C0 98.5 84.6 8.8 192 .6L192 96c107.4 8.2 192 97.9 192 207.4S299.4 502.6 192 510.8l0-95.4C84.6 407.2 0 317.5 0 208zm288 48a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faEarthAfrica = {
  prefix: 'fass',
  iconName: 'earth-africa',
  icon: [512, 512, [127757, "globe-africa"], "f57c", "M454 192c-27-83.6-105.4-144-198-144-22.3 0-43.8 3.5-64 10l0 102 32 0 32-32 96 0-64 64-88 0-40 40 0 88 96 0 0 96 48 0 48-48 0-48 32 0 0-64-32-32 0-32 102 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"]
};
var faGlobeAfrica = faEarthAfrica;
var faThumbtack = {
  prefix: 'fass',
  iconName: 'thumbtack',
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M64 0l-32 0 0 64 61.5 0-10 129.5C33.1 228.1 0 286.2 0 352l384 0c0-65.8-33.1-123.9-83.6-158.5L290.5 64 352 64 352 0 64 0zm96 400l0 144 64 0 0-144-64 0z"]
};
var faThumbTack = faThumbtack;
var faSquareUp = {
  prefix: 'fass',
  iconName: 'square-up',
  icon: [448, 512, [11014, "arrow-alt-square-up"], "f353", "M448 32l-448 0 0 448 448 0 0-448zM96 256l0-8 128-128 128 128 0 8-80 0 0 128-96 0 0-128-80 0z"]
};
var faArrowAltSquareUp = faSquareUp;
var faFaceTongueMoney = {
  prefix: 'fass',
  iconName: 'face-tongue-money',
  icon: [512, 512, [], "e39d", "M336-16l-48 0 0 18c-22.2-2.8-41.7-2.2-56-.9l0-17.1-136 0 0 36.4c-31 17.1-52 50.1-52 88 0 1.3 0 2.6 .1 3.9-27.8 41-44.1 90.4-44.1 143.7 0 88 44.4 165.6 112 211.7l0-115.7-32 0 0-48 352 0 0 48-32 0 0 115.7c67.6-46.1 112-123.7 112-211.7 0-62.7-22.6-120.2-60-164.7l0-83.3-28 0 0-24-88 0zM184 32l0 24 28 0 0 40-67.5 0c-6.9 0-12.5 5.6-12.5 12.5 0 6.1 4.4 11.3 10.4 12.3l41.7 7c25.3 4.2 43.9 26.1 43.9 51.8 0 26.1-19 47.7-44 51.8l0 24.7-40 0 0-24-44 0 0-40 75.5 0c6.9 0 12.5-5.6 12.5-12.5 0-6.1-4.4-11.3-10.4-12.3l-41.7-7C110.5 156 92 134.1 92 108.5 92 79.7 115.2 56.3 144 56l0-24 40 0zm152 0l40 0 0 24 28 0 0 40-67.5 0c-6.9 0-12.5 5.6-12.5 12.5 0 6.1 4.4 11.3 10.4 12.3l41.7 7c25.3 4.2 43.9 26.1 43.9 51.8 0 26.1-19 47.7-44 51.8l0 24.7-40 0 0-24-44 0 0-40 75.5 0c6.9 0 12.5-5.6 12.5-12.5 0-6.1-4.4-11.3-10.4-12.3l-41.7-7c-25.3-4.2-43.9-26.1-43.9-51.8 0-28.8 23.2-52.2 52-52.5l0-24zm16 320l-192 0 0 128c0 53 43 96 96 96s96-43 96-96l0-128zm-80 48l24 0 0 32-49.5 0c-3.6 0-6.5 2.9-6.5 6.5 0 3 2 5.6 4.9 6.3l30 7.5c17.1 4.3 29.1 19.7 29.1 37.3 0 19-13.8 34.8-32 37.9l0 16.5-32 0 0-16-24 0 0-32 49.5 0c3.6 0 6.5-2.9 6.5-6.5 0-3-2-5.6-4.9-6.3l-30-7.5c-17.1-4.3-29.1-19.7-29.1-37.3 0-19 13.8-34.8 32-37.9l0-16.5 32 0 0 16z"]
};
var faHandPointDown = {
  prefix: 'fass',
  iconName: 'hand-point-down',
  icon: [384, 512, [], "f0a7", "M32 512l64 0 0-240-64 0 0 240zM224 352l64 0 0-128-64 0 0 128zm-32 32l0-112-64 0 0 112 64 0zm128-64l64 0 0-128-64 0 0 128zM0 149l0 91 192 0 0-80-112 0 0-32 144 0 0 64 64 0 0-32 96 0C384 71.6 312.4 0 224 0L162.3 0C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149z"]
};
var faFaceMehBlank = {
  prefix: 'fass',
  iconName: 'face-meh-blank',
  icon: [512, 512, [128566, "meh-blank"], "f5a4", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm208-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faMehBlank = faFaceMehBlank;
var faBowlHot = {
  prefix: 'fass',
  iconName: 'bowl-hot',
  icon: [512, 512, ["soup"], "f823", "M176 8c0 26.5 10.5 38.7 25.9 56.1l.4 .4C218.8 83 240 106.9 240 152l0 24-48 0 0-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C149.2 77 128 53.1 128 8l0-24 48 0 0 24zM304 8c0 26.5 10.5 38.7 25.9 56.1l.4 .4C346.8 83 368 106.9 368 152l0 24-48 0 0-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C277.2 77 256 53.1 256 8l0-24 48 0 0 24zM3.6 285.2l-3.6-61.2 512 0-3.6 61.2C503.5 368.1 454 438.2 384 472.9l0 39.1-256 0 0-39.1C58 438.2 8.5 368.1 3.6 285.2z"]
};
var faSoup = faBowlHot;
var faPartyHorn = {
  prefix: 'fass',
  iconName: 'party-horn',
  icon: [512, 512, [], "e31b", "M32 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM150.1 136c12.8-12.8 21.2-21.2 25.2-25.2 16.7-16.7 27.2-38.6 29.8-62.1l3-27.4 47.7 5.3-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L184 169.9 150.1 136zM359 311l8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3 5.3 47.7-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8-4 4-12.5 12.5-25.2 25.2l-33.9-33.9 17-17zM503.5 42.3l-10 8.5c-14.8 12.5-33.7 19.1-53 18.6-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2-7.6-.2-15 2.4-20.7 7.3-5.3 4.5-14.8 12.5-28.3 24l-31-36.6c13.6-11.5 23-19.5 28.3-24 14.8-12.5 33.7-19.1 53-18.6 16.6 .4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2 7.6 .2 15-2.4 20.7-7.3l10-8.5 31 36.6zM32 512L0 480 38.5 381.1 130.9 473.5 32 512zm131.5-51.1l-112.4-112.4 23.2-59.6 148.8 148.8-59.6 23.2zM255.7 425L87 256.3 112 192 320 400 255.7 425z"]
};
var faBells = {
  prefix: 'fass',
  iconName: 'bells',
  icon: [640, 512, [], "f77f", "M0 256l229.9 63.4-8.3-31.6c-26.6-101.2 33.7-205.6 134.6-233.1 2.7-.7 5.3-1.4 8-2-16.9-37.7-49.9-67.9-92.6-79.6-75.3-20.6-152.5 23.9-172.3 99.5L76.7 158.4 0 256zm128.2 85.6c2.9 32.7 30.3 58.3 63.8 58.3 18 0 34.2-7.4 45.8-19.3l1.7-8.6-111.3-30.4zM265.2 487.3L640 384 563.3 286.4 540.7 200.5C520.9 125 443.8 80.4 368.4 101S248.1 199.6 267.9 275.1l22.6 85.9-25.3 126.3zm94.9 23.8c10.9 19.6 31.9 32.9 55.9 32.9 35.3 0 64-28.7 64-64 0-.6 0-1.1 0-1.7L360.1 511.1z"]
};
var faTemperatureEmpty = {
  prefix: 'fass',
  iconName: 'temperature-empty',
  icon: [320, 512, ["temperature-0", "thermometer-0", "thermometer-empty"], "f2cb", "M64 0l192 0 0 260.7c29.5 26.4 48 64.7 48 107.3 0 79.5-64.5 144-144 144S16 447.5 16 368c0-42.6 18.5-81 48-107.3L64 0zm96 432c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"]
};
var faTemperature0 = faTemperatureEmpty;
var faThermometer0 = faTemperatureEmpty;
var faThermometerEmpty = faTemperatureEmpty;
var faPopcorn = {
  prefix: 'fass',
  iconName: 'popcorn',
  icon: [384, 512, [127871], "f819", "M2.7 160c-1.8-5-2.7-10.4-2.7-16 0-26.5 21.5-48 48-48 3.9 0 7.6 .5 11.2 1.3-2.1-5.4-3.2-11.2-3.2-17.3 0-26.5 21.5-48 48-48 12.8 0 24.4 5 33 13.2 5-25.8 27.7-45.2 55-45.2s49.9 19.4 55 45.2c8.6-8.2 20.2-13.2 33-13.2 26.5 0 48 21.5 48 48 0 6.1-1.1 11.9-3.2 17.3 3.6-.9 7.4-1.3 11.2-1.3 26.5 0 48 21.5 48 48 0 5.6-1 11-2.7 16L2.7 160zm259.7 48l-27.6 304-85.6 0-27.6-304 140.9 0zM0 208l73.4 0 27.6 304-69 0-32-304zM283 512l27.6-304 73.4 0-32 304-69 0z"]
};
var faBorderLeft = {
  prefix: 'fass',
  iconName: 'border-left',
  icon: [448, 512, [], "f84f", "M0 480l0-448 64 0 0 448-64 0zm128 0l0-64 64 0 0 64-64 0zm0-448l64 0 0 64-64 0 0-64zM256 480l0-64 64 0 0 64-64 0zm0-448l64 0 0 64-64 0 0-64zM384 480l0-64 64 0 0 64-64 0zm0-448l64 0 0 64-64 0 0-64zm0 320l0-64 64 0 0 64-64 0zm0-192l64 0 0 64-64 0 0-64z"]
};
var faBorderNone = {
  prefix: 'fass',
  iconName: 'border-none',
  icon: [448, 512, [], "f850", "M0 416l0 64 64 0 0-64-64 0zM128 32l0 64 64 0 0-64-64 0zM256 416l0 64 64 0 0-64-64 0zM128 480l64 0 0-64-64 0 0 64zM256 32l0 64 64 0 0-64-64 0zM384 480l64 0 0-64-64 0 0 64zm0-384l64 0 0-64-64 0 0 64zM0 32l0 64 64 0 0-64-64 0zM384 352l64 0 0-64-64 0 0 64zM0 160l0 64 64 0 0-64-64 0zM0 352l64 0 0-64-64 0 0 64zM384 160l0 64 64 0 0-64-64 0z"]
};
var faHighlighter = {
  prefix: 'fass',
  iconName: 'highlighter',
  icon: [576, 512, [], "f591", "M314.3 314.3l146.1-203.4-27.1-27.1-203.4 146.1 84.5 84.5zM128 320l0-96 312-224 104 104-224 312-96 0-48 48-96-96 48-48 0 0zM4.7 468.7l54.1-54.1 70.6 70.6-22.1 22.1-4.7 4.7-102.6 0 0-38.6 4.7-4.7z"]
};
var faPalletBox = {
  prefix: 'fass',
  iconName: 'pallet-box',
  icon: [576, 512, [], "e208", "M448 0l0 256-320 0 0-256 320 0zM0 320l576 0 0 64-64 0 0 64 64 0 0 64-576 0 0-64 64 0 0-64-64 0 0-64zM128 448l128 0 0-64-128 0 0 64zm192 0l128 0 0-64-128 0 0 64z"]
};
var faStarExclamation = {
  prefix: 'fass',
  iconName: 'star-exclamation',
  icon: [576, 512, [], "f2f3", "M380.8 128.6l201.1 32-143.9 144.1 31.7 201.2-181.5-92.3-181.5 92.3 31.7-201.2-143.9-144.1 201.1-32 92.6-181.4 92.6 181.4zM260.2 308l0 56 56 0 0-56-56 0zm-4-180l12.8 144 38.4 0 12.8-144-64 0z"]
};
var faSickle = {
  prefix: 'fass',
  iconName: 'sickle',
  icon: [512, 512, [], "f822", "M224 352l-43-43c-33.9-33.9-53-80-53-128 0-100 81-181 181-181l11 0C426 0 512 86 512 192l-22.7-31.2C463.3 125.1 421.9 104 377.8 104 301.7 104 240 165.7 240 241.8l0 9.8c0 18.8 3.6 37.4 10.6 54.8l5.4 13.6-32 32zM0 448l88-88-24-24 48-48 112 112-48 48-24-24-88 88-64-64z"]
};
var faMoneyBillWave = {
  prefix: 'fass',
  iconName: 'money-bill-wave',
  icon: [512, 512, [], "f53a", "M0 451.7L0 60.3c113.2 50.4 185.6 26.3 258.4 2 71.2-23.7 142.9-47.6 253.6-2l0 391.5c-113.2-50.4-185.6-26.3-258.4-2-71.2 23.7-142.9 47.6-253.6 2zM336 256c0-53-35.8-96-80-96s-80 43-80 96 35.8 96 80 96 80-43 80-96zM64 406c23.3 6.1 44.2 8.2 64 7.4-1.3-34.2-29.5-61.5-64-61.5l0 54zm320.8-47.9c19.8 0 40.9 1.8 63.2 6.1l0-60.3c-32 0-58.5 23.5-63.2 54.2zM448 106c-23.3-6.1-44.2-8.2-64-7.4 1.3 34.2 29.5 61.5 64 61.5l0-54zM64 208c32 0 58.5-23.5 63.2-54.2-19.8 0-40.9-1.8-63.2-6.1L64 208z"]
};
var faPlaneTail = {
  prefix: 'fass',
  iconName: 'plane-tail',
  icon: [512, 512, [], "e22c", "M56 0l144 0 235.8 256 76.2 0 0 256-41.8 0c-154.4 0-303.9-53.8-422.9-152.1-4-3.3-9.1-7.5-15.3-12.6L32 256 130.1 256 56 0zM248 336l-24 0 0 48 224 0 0-48-200 0z"]
};
var faToiletPaperSlash = {
  prefix: 'fass',
  iconName: 'toilet-paper-slash',
  icon: [576, 512, [], "e072", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-86.6-86.6c40.1-23.1 69.4-96.9 69.4-184.5 0-106-43-192-96-192s-96 86-96 192c0 24 2.2 47 6.2 68.2l-54.2-54.2 0-14c0-58.9 11.8-114.5 33.2-157.2 5.8-11.7 13.1-23.7 21.9-34.8L128.1 32c-8.3 0-16.3 2.1-23.9 6L49.3-16.9zM32.1 224l0 320 272 0 0-170.2-256-256c-10.1 30.4-16 66.9-16 106.2zm416 64c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64z"]
};
var faSirenOn = {
  prefix: 'fass',
  iconName: 'siren-on',
  icon: [640, 512, [], "e02e", "M69.3 36l-20-13.3-26.6 39.9c8.6 5.8 31.3 20.9 68 45.3l20 13.3 26.6-39.9-68-45.3zM597.3 76l20-13.3-26.6-39.9c-8.6 5.8-31.3 20.9-68 45.3l-20 13.3 26.6 39.9c8.6-5.8 31.3-20.9 68-45.3zM24 192l-24 0 0 48 112 0 0-48-88 0zm528 0l-24 0 0 48 112 0 0-48-88 0zM176 32l-32 272 68.3 0 19.6-176 48.3 0-.3 2.7-19.3 173.3 235.4 0-32-272-288 0zM544 352l-448 0 0 128 448 0 0-128z"]
};
var faFileShield = {
  prefix: 'fass',
  iconName: 'file-shield',
  icon: [576, 512, [], "e4f0", "M272 0l-240 0 0 512 266.3 0C261.4 469.2 240 413.9 240 355.2l0-85.8c3.5-1.2 62.2-20.7 176-58.7L416 144 272 0zm85.5 176L240 176 240 58.5 357.5 176zM462 530.8c69.3-30.8 114-99.6 114-175.4l0-51.2-144-48-144 48 0 51.2c0 75.9 44.7 144.6 114 175.4l30 13.3 30-13.3zm-30-39.2l0-184.9 96 32 0 16.6c0 56.9-33.5 108.5-85.5 131.6L432 491.6z"]
};
var faWhiskeyGlassIce = {
  prefix: 'fass',
  iconName: 'whiskey-glass-ice',
  icon: [448, 512, ["glass-whiskey-rocks"], "f7a1", "M32 32L0 32 0 352c0 70.7 57.3 128 128 128l192 0c70.7 0 128-57.3 128-128l0-320-416 0zM64 256l0-160 320 0 0 160-48.3 0 25.5 95.2-216.4 58-41-153.2-39.8 0zm239.5 61.3l-33.1-123.6-123.6 33.1 33.1 123.6 123.6-33.1z"]
};
var faGlassWhiskeyRocks = faWhiskeyGlassIce;
var faSquid = {
  prefix: 'fass',
  iconName: 'squid',
  icon: [512, 512, [129425], "e450", "M396.3 26c33.9-10 72.3-18.8 115.7-26-7.1 42.7-15.7 80.7-25.5 114.2l18.2 115.3 3.5 22.1c-9.9-1.8-34.2-6-72.9-12.9-47.1 81.4-102.8 111.2-147.7 115.8l37.2 37.2c6.2 6.2 16.4 6.2 22.6 0l56.1-56.1c19-19 49.9-18.7 68.6 .7 21.3 22.2 33.6 35 37 38.5l-8.3 10.9-2.5 3.3c-28.3 37-81 40.1-113.6 10.9L370 414.4c-18.7 18.7-49.1 18.7-67.9 0l-45.3-45.3-33.9 33.9 32.6 32.6c19.5 19.5 18.6 51.5-2.1 69.8l-2.8 2.5-21.2-23.9 2.8-2.5c6.9-6.1 7.2-16.8 .7-23.3l-56-56c-1.7 6.5-4.7 12.7-8.8 18.4l-20.1 27.3c-2.5 3.5-3.9 7.6-3.9 11.9 0 11.1 9 20.1 20.1 20.1l27.9 0 0 32-27.9 0c-28.8 0-52.1-23.3-52.1-52.1 0-11.1 3.6-21.9 10.1-30.9l20.1-27.3c6.8-9.2 5.8-22-2.3-30.1-8.2-8.2-21.2-9.1-30.4-2.1l-26.2 20C74.3 396.3 63.2 400 51.9 400 23.2 400 0 376.8 0 348.1l0-28.1 32 0 0 28.1c0 11 8.9 19.9 19.9 19.9 4.4 0 8.6-1.4 12-4.1l26.2-20c5.8-4.4 12.3-7.6 19.1-9.4L53.8 279.2c-6.4-6.4-16.7-6.2-22.9 .3l-3.3 3.5-23.2-22 3.3-3.5c18.6-19.6 49.7-20 68.7-.9l33.4 33.4 33.9-33.9-45.3-45.3c-18.7-18.7-18.7-49.1 0-67.9L113 128.4c-29.4-32.7-26.5-85.5 10.4-114.1 1.2-1 6.1-4.8 14.7-11.4 3.5 3.4 16.5 16.1 39 38.1 19.1 18.7 19.3 49.4 .4 68.3l-56.3 56.3c-6.2 6.2-6.2 16.4 0 22.6l36.3 36.3c4.7-45 34.7-100.8 116.4-147.9-6.7-37.8-10.9-61.7-12.7-71.8L283.4 8.2 396.3 26zM200.9 280a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faTextHeight = {
  prefix: 'fass',
  iconName: 'text-height',
  icon: [640, 512, [], "f034", "M470.9 361.4l-22.6-22.6-45.3 45.3 109.3 109.3 109.3-109.3-45.3-45.3-32 32 0-229.5 32 32 45.3-45.3c-8.2-8.2-37.1-37.1-86.6-86.6L512.3 18.7c-8.2 8.2-37.1 37.1-86.6 86.6l-22.6 22.6 45.3 45.3 32-32 0 229.5-9.4-9.4zM64.3 32l-32 0 0 128 64 0 0-64 64 0 0 320-64 0 0 64 192 0 0-64-64 0 0-320 64 0 0 64 64 0 0-128-288 0z"]
};
var faMoneyCheckDollarPen = {
  prefix: 'fass',
  iconName: 'money-check-dollar-pen',
  icon: [640, 512, ["money-check-edit-alt"], "f873", "M544 64l-512 0 0 384 254.9 0 3.8-23.1 88.9-88.9-75.7 0 0-48 123.7 0 115.9-115.9 .5 .5 0-108.6zM304 176l176 0 0 48-176 0 0-48zM200 144l0 24 28 0 0 40-67.5 0c-6.9 0-12.5 5.6-12.5 12.5 0 6.1 4.4 11.3 10.4 12.3l41.7 7c25.3 4.2 43.9 26.1 43.9 51.8 0 26.1-19 47.7-44 51.8l0 24.7-40 0 0-24-44 0 0-40 75.5 0c6.9 0 12.5-5.6 12.5-12.5 0-6.1-4.4-11.3-10.4-12.3l-41.7-7c-25.3-4.2-43.9-26.1-43.9-51.8 0-28.8 23.2-52.2 52-52.5l0-24 40 0zm344 95.9l-52.8 52.8 80 80 52.8-52.8-80-80zm-208 208l-16 96 96-16 132.6-132.6-80-80-132.6 132.6z"]
};
var faMoneyCheckEditAlt = faMoneyCheckDollarPen;
var faHandWave = {
  prefix: 'fass',
  iconName: 'hand-wave',
  icon: [576, 512, [], "e1a7", "M392 72l0-8c0-22.1-17.9-40-40-40l-32 0 0-48 32 0c48.6 0 88 39.4 88 88l0 32-48 0 0-24zM217.4 70.6l-22.6-22.6 45.3-45.3 22.6 22.6 192 192c3.3 3.3 6.4 6.7 9.4 10.2l0-131.5 80 0 0 216.3c0 60.2-27.9 116.9-75.5 153.7-50.8 39.2-115.5 49.7-173.6 32.7-28.4-7.1-55.3-21.8-77.6-44.1l-4.9-4.9C-20 217.3 106.6 343.8 50.7 288L96 242.7c45.6 45.6 68.4 68.4 110.6 110.6l18.7-18.7-136-136-22.6-22.6 45.3-45.3 22.6 22.6 136 136 18.7-18.7-174.6-174.6 45.3-45.3 22.6 22.6 152 152 18.7-18.7-136-136zM56 352l0 32c0 22.1 17.9 40 40 40l32 0 0 48-32 0c-48.6 0-88-39.4-88-88l0-32 48 0z"]
};
var faChartCandlestick = {
  prefix: 'fass',
  iconName: 'chart-candlestick',
  icon: [512, 512, [], "e0e2", "M64 32l0 384 448 0 0 64-512 0 0-448 64 0zM344 96l24 0 0 160-24 0 0 64-48 0 0-64-24 0 0-160 24 0 0-64 48 0 0 64zm96 88l0-56 48 0 0 56 24 0 0 128-24 0 0 56-48 0 0-56-24 0 0-128 24 0zM200 120l24 0 0 192-24 0 0 56-48 0 0-56-24 0 0-192 24 0 0-56 48 0 0 56z"]
};
var faTransporter4 = {
  prefix: 'fass',
  iconName: 'transporter-4',
  icon: [640, 512, [], "e2a5", "M272-32l-16 0 0 32 128 0 0-32-112 0zm0 64l-16 0 0 32 128 0 0-32-112 0zM240 96l-16 0 0 32 192 0 0-32-176 0zm-32 64l-16 0 0 32 256 0 0-32-240 0zm-32 64l-16 0 0 32 320 0 0-32-304 0zm-16 64l-16 0 0 32 352 0 0-32-336 0zm80 64l-16 0 0 32 192 0 0-32-176 0zm0 64l-16 0 0 32 192 0 0-32-176 0zm240 80l-320 0 0 48 320 0 0-48zM144 400l-48-16-16-48-16 48-48 16 48 16 16 48 16-48 48-16zM576 160l-16-48-16 48-48 16 48 16 16 48 16-48 48-16-48-16z"]
};
var faPanFood = {
  prefix: 'fass',
  iconName: 'pan-food',
  icon: [640, 512, [129368], "e42b", "M320 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-448c39.8 0 72 32.2 72 72l0 8-144 0 0-8c0-39.8 32.2-72 72-72zM244.3 200c-6.5 6.5-21.8 21.8-46.1 46.1l-14.1 14.1-28.3-28.3 46.1-46.1 14.1-14.1 28.3 28.3zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM416 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM238.6 296l-8 8 16 16 33.4 0c30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56l0-33.4-16-16-8 8-22.6-22.6c32.2-32.2 28.1-28.1 38.6-38.6L238.6 296zM464 176l11 11c13.4 13.4 21 31.6 21 50.6l0 4.8c0 18.7-8.5 36.4-23.1 48.1-10.9 8.7-24.5 13.5-38.5 13.5l-4.1 0c-19.4 0-38-7.7-51.8-21.4L368 272 464 176zM48 160l-48 0 0 192 48 0 0-192zm592 24l0-24-48 0 0 192 48 0 0-168z"]
};
var faEurozoneSign = {
  prefix: 'fass',
  iconName: 'eurozone-sign',
  icon: [576, 512, [], "e740", "M32.4 64l224 0 0 64-160 0 0 96 144 0 0 64-144 0 0 96 160 0 0 64-224 0 0-384zm272 0l252.9 0-24.6 46.9-143.4 273.1 147.1 0 0 64-252.9 0 24.6-46.9 143.4-273.1-147.1 0 0-64z"]
};
var faFaceGrinTongue = {
  prefix: 'fass',
  iconName: 'face-grin-tongue',
  icon: [512, 512, [128539, "grin-tongue"], "f589", "M0 256c0 104.4 62.5 194.2 152.2 234.1-5.3-13-8.2-27.2-8.2-42.1l0-61.7c-23.5-23-39.9-53.2-45.7-87 45.3 18.1 99.5 28.7 157.7 28.7s112.4-10.6 157.7-28.7c-5.8 33.8-22.2 64-45.7 87l0 61.7c0 14.9-2.9 29.1-8.2 42.1 89.7-39.8 152.2-129.6 152.2-234.1 0-141.4-114.6-256-256-256S0 114.6 0 256zm176-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm16 240l0-64-48 0 0 24-32 0 0-24-48 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faGrinTongue = faFaceGrinTongue;
var faPotato = {
  prefix: 'fass',
  iconName: 'potato',
  icon: [512, 512, [129364], "e440", "M43.1 260.9l52.9-52.9 48-80 80-48 36.9-36.9c27.6-27.6 65-43.1 104-43.1 81.2 0 147.1 65.8 147.1 147.1 0 39-15.5 76.4-43.1 104l-4.9 4.9-80 144-112 48-20.9 20.9c-27.6 27.6-65 43.1-104 43.1-81.2 0-147.1-65.8-147.1-147.1 0-39 15.5-76.4 43.1-104zM408 168l-48 0 0 48 48 0 0-48zM216 200l-48 0 0 48 48 0 0-48zM136 392l0 48 48 0 0-48-48 0z"]
};
var faFileSignature = {
  prefix: 'fass',
  iconName: 'file-signature',
  icon: [640, 512, [], "f573", "M64 0l240 0 144 144 0 123.7-132.3 132.3-28.8 0-33.4-66.7-6.6-13.3-42.2 0-7.2 8.8-72 88 37.2 30.4 58.5-71.5c23.5 47 35.5 71 36.1 72.3l29.7 0-10.7 64-212.2 0 0-512zM272 58.5L272 176 389.5 176 272 58.5zM544 239.9l80 80-52.8 52.8-80-80 52.8-52.8zm-208 208l132.6-132.6 80 80-132.6 132.6-96 16 16-96z"]
};
var faSquareDashed = {
  prefix: 'fass',
  iconName: 'square-dashed',
  icon: [448, 512, [], "e269", "M32 32l80 0 0 64-48 0 0 48-64 0 0-112 32 0zM0 192l64 0 0 128-64 0 0-128zm384 0l64 0 0 128-64 0 0-128zm64-48l-64 0 0-48-48 0 0-64 112 0 0 112zm0 224l0 112-112 0 0-64 48 0 0-48 64 0zM64 368l0 48 48 0 0 64-112 0 0-112 64 0zM288 480l-128 0 0-64 128 0 0 64zM160 96l0-64 128 0 0 64-128 0z"]
};
var faSteak = {
  prefix: 'fass',
  iconName: 'steak',
  icon: [576, 512, [129385], "f824", "M352 384l-256 0 0-95.9 145.2 0 85.7-158.4c11.3-20.8 33-33.8 56.7-33.8 35.6 0 64.4 28.8 64.4 64.4L448 288c0 53-43 96-96 96zm64-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-232 .1L242.5 84.1C270.5 32.3 324.7 0 383.6 0 472.2 0 544 71.8 544 160.4L544 288c0 106-86 192-192 192l-352 0 0-287.9 184 0zM352 416c70.7 0 128-57.3 128-128l0-127.6c0-53.3-43.2-96.4-96.4-96.4-35.4 0-67.9 19.4-84.8 50.5l-76.7 141.6-158.1 0 0 159.9 288 0z"]
};
var faAxeBattle = {
  prefix: 'fass',
  iconName: 'axe-battle',
  icon: [512, 512, [], "f6b3", "M176 106.6C134.4 82.6 104.7 40.4 97.6-9.1 38.2 37.7 0 110.4 0 192S38.2 346.3 97.6 393.1c7.1-49.5 36.8-91.7 78.4-115.7l0-170.8zM336 277.4c41.6 24 71.3 66.2 78.4 115.7 49.4-39 84.1-95.7 94.4-160.6L448 192 508.8 151.5c-10.3-64.9-45-121.6-94.4-160.6-7.1 49.5-36.8 91.7-78.4 115.7l0 170.8zM288 32l0-32-64 0 0 544 64 0 0-512z"]
};
var faCircleQuarterStroke = {
  prefix: 'fass',
  iconName: 'circle-quarter-stroke',
  icon: [512, 512, [], "e5d3", "M64 256l192 0 0-192c106 0 192 86 192 192S362 448 256 448 64 362 64 256zM0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0z"]
};
var faPhoneHangup = {
  prefix: 'fass',
  iconName: 'phone-hangup',
  icon: [640, 512, [], "e225", "M591.9 378.5l45.2-135.8-11.3-11.3C457.1 62.7 183.6 62.7 14.9 231.4l-11.3 11.3 45.3 135.8 158.9-22.1-.5-113.7c73.1-26.5 153.2-26.5 226.3 0l-.5 113.7 158.9 22.1z"]
};
var faSquareHeart = {
  prefix: 'fass',
  iconName: 'square-heart',
  icon: [448, 512, [128159, "heart-square"], "f4c8", "M448 32l-448 0 0 448 448 0 0-448zM217.6 199.5l6.4 8.5 6.4-8.5c11.1-14.8 28.5-23.5 46.9-23.5 32.4 0 58.7 26.3 58.7 58.7l0 5.3c0 64-112 128-112 128S112 304 112 240l0-5.3c0-32.4 26.3-58.7 58.7-58.7 18.5 0 35.9 8.7 46.9 23.5z"]
};
var faHeartSquare = faSquareHeart;
var faConveyorBelt = {
  prefix: 'fass',
  iconName: 'conveyor-belt',
  icon: [640, 512, [], "f46e", "M480 0l0 256-320 0 0-256 320 0zM0 416c0-53 43-96 96-96l448 0c53 0 96 43 96 96s-43 96-96 96L96 512c-53 0-96-43-96-96zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faBoxCheck = {
  prefix: 'fass',
  iconName: 'box-check',
  icon: [448, 512, [], "f467", "M448 128l0 352-448 0 0-352 80-112 288 0 80 112zM281.4 217.9L195.8 335.6c-19.3-20-33.7-34.9-43.2-44.7l-34.5 33.3c6.2 6.4 27.2 28.1 63.1 65.3l19.8 20.6 16.8-23.1 102.4-140.8 14.1-19.4-38.8-28.2-14.1 19.4zM78.7 128l290.7 0-34.3-48-222.1 0-34.3 48z"]
};
var faBlanketFire = {
  prefix: 'fass',
  iconName: 'blanket-fire',
  icon: [640, 512, [], "e3da", "M120 32l-24 0 0 448 199.5 0c-7.8-15-13.9-31.1-17.9-48l-133.6 0 0-144 151.9 0c10-20 22.1-38 34.6-53.7 30.4-38.2 66.7-67.3 92.1-83.2l32.4-20.2 55.1 55.1 34-34 0-120-424 0zM272 384l0-.2c0-16.6 2.2-32.6 6-47.8l-86 0 0 48 80 0zM448 192c-42.7 26.7-128 102.4-128 192 0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-32 32-64-64zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96z"]
};
var faSquare9 = {
  prefix: 'fass',
  iconName: 'square-9',
  icon: [448, 512, [], "e25e", "M448 32l-448 0 0 448 448 0 0-448zM168 368l0-48 72 0c13.3 0 24-10.7 24-24l0-12.1c-7.5 2.7-15.6 4.1-24 4.1l-32 0c-39.8 0-72-32.2-72-72s32.2-72 72-72l32 0c39.8 0 72 32.2 72 72l0 80c0 39.8-32.2 72-72 72l-72 0zm72-176l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
var faBuildingWheat = {
  prefix: 'fass',
  iconName: 'building-wheat',
  icon: [640, 512, [], "e4db", "M416 0l-384 0 0 512 313.3 0c-6-14.8-9.3-31-9.3-48l0-64 9.3 0c-6-14.8-9.3-31-9.3-48l0-64 9.3 0c-6-14.8-9.3-31-9.3-48l0-64 32 0 0-120 48 0 0-56zM272 352l0 112-96 0 0-112 96 0zM128 96l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM128 224l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zm320 0l-32 0c-44.2 0-80 35.8-80 80l0 16 32 0c44.2 0 80-35.8 80-80l0-16zm0 128l0-16-32 0c-44.2 0-80 35.8-80 80l0 16 32 0c44.2 0 80-35.8 80-80zm0 112l0-16-32 0c-44.2 0-80 35.8-80 80l0 16 32 0c44.2 0 80-35.8 80-80zM496 528c0-44.2-35.8-80-80-80l-32 0 0 16c0 44.2 35.8 80 80 80l32 0 0-16zm0-96l0-16c0-44.2-35.8-80-80-80l-32 0 0 16c0 44.2 35.8 80 80 80l32 0zm0-128c0-44.2-35.8-80-80-80l-32 0 0 16c0 44.2 35.8 80 80 80l32 0 0-16zM536 64l-48 0 0 152 48 0 0-152zm72 64l0-24-48 0 0 80 48 0 0-56zM464 104l-48 0 0 80 48 0 0-80z"]
};
var faPlugCircleMinus = {
  prefix: 'fass',
  iconName: 'plug-circle-minus',
  icon: [640, 512, [], "e55e", "M224-32l0 128 128 0 0-128 64 0 0 128 96 0 0 64-32 0 0 48.7c-98.6 8.1-176 90.7-176 191.3 0 27.3 5.7 53.3 16 76.9l0 35.1-64 0 0-98.7C165.2 398.1 96 319.1 96 224l0-64-32 0 0-64 96 0 0-128 64 0zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16l0-32-160 0 0 32 160 0z"]
};
var faBookSpine = {
  prefix: 'fass',
  iconName: 'book-spine',
  icon: [448, 512, [], "e754", "M0 0l448 0 0 384-32 0 0 64 32 0 0 64-448 0 0-512zM64 416l0 32 288 0 0-64-256 0c-17.7 0-32 14.3-32 32zM64 64l0 261.5c10-3.5 20.8-5.5 32-5.5l64 0 0-256-96 0z"]
};
var faHockeySticks = {
  prefix: 'fass',
  iconName: 'hockey-sticks',
  icon: [640, 512, [], "f454", "M528 512l-132.4 0-8.6-18.5-40.6-86.9 40.5-86.7 141.1 0 0 192zm112 0l-64 0 0-192 64 0 0 192zM64 512l-64 0 0-192 64 0 0 192zM490.5-15.5l-13.5 29-224 480-8.6 18.5-132.4 0 0-192 151.3 0 155.7-333.5 13.5-29 58 27.1zM221-13.5l72.5 155.3-35.3 75.7-95.2-203.9-13.5-29 58-27.1 13.5 29z"]
};
var faDownLongToLine = {
  prefix: 'fass',
  iconName: 'down-long-to-line',
  icon: [384, 512, [], "e6c0", "M0 256l192 192 192-192-128 0 0-320-128 0 0 320-128 0zM64 576l288 0 0-64-320 0 0 64 32 0z"]
};
var faColon = {
  prefix: 'fass',
  iconName: 'colon',
  icon: [128, 512, [], "3a", "M128 64l-128 0 0 128 128 0 0-128zm0 256l-128 0 0 128 128 0 0-128z"]
};
var faFutbol = {
  prefix: 'fass',
  iconName: 'futbol',
  icon: [512, 512, [9917, "futbol-ball", "soccer-ball"], "f1e3", "M406.2 136.4l-28.5 80.1 70.1 48c-1.6 35.9-13 69.2-31.6 97.4l-85-2.3-24 81.5c-16.3 4.5-33.5 6.9-51.2 6.9s-34.9-2.4-51.2-6.9l-24-81.5-85 2.3c-18.6-28.1-30.1-61.5-31.6-97.4l70.1-48-28.5-80.1c21.5-26.9 50-47.9 82.8-60.2L256 128 323.4 76.2c32.8 12.3 61.3 33.3 82.8 60.2zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-336l-76.1 55.3 29.1 89.4 94 0 29.1-89.4-76.1-55.3z"]
};
var faFutbolBall = faFutbol;
var faSoccerBall = faFutbol;
var faFaceHandOverMouth = {
  prefix: 'fass',
  iconName: 'face-hand-over-mouth',
  icon: [512, 512, [129762], "e378", "M88 442.2C88 444.6 88.1 447 88.2 449.3 34.2 402.4 0 333.2 0 256 0 114.6 114.6 0 256 0S512 114.6 512 256c0 79-35.8 149.7-92.1 196.6L440.6 432c-20.3-20.3-36.3-36.3-48-48l3.7-3.7 28.3-28.3c-41.8-41.8-76.9-76.9-88.6-88.6l-16 16c-11.7-11.7-27.7-27.7-48-48-20.2 20.2-36.4 36.4-48.6 48.6L88 280 88 442.2zM208 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 320l48 0 0 64 96-96 32 32-64 64 16 16 80-80 32 32-80 80 16 16 48-48 32 32-82.2 82.2c-19.1 19.1-45 29.8-72 29.8-56.2 0-101.8-45.6-101.8-101.8L128 320z"]
};
var faCirclePlus = {
  prefix: 'fass',
  iconName: 'circle-plus',
  icon: [512, 512, ["plus-circle"], "f055", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM232 368l0-88-88 0 0-48 88 0 0-88 48 0 0 88 88 0 0 48-88 0 0 88-48 0z"]
};
var faPlusCircle = faCirclePlus;
var faCoffeePot = {
  prefix: 'fass',
  iconName: 'coffee-pot',
  icon: [512, 512, [], "e002", "M32 32l-32 0 0 192 64 0 0-128 53.3 0 27.8 83.3C96 214 64 271.3 64 336l0 8c0 80 72 136 72 136l304 0s72-56 72-136l0-8c0-64.7-32-122-81.1-156.7L480 32 32 32zM194 224l188 0c34.9 19.4 59.8 54.6 65 96l-318 0c5.2-41.4 30.1-76.6 65-96z"]
};
var faSquareQuestion = {
  prefix: 'fass',
  iconName: 'square-question',
  icon: [448, 512, ["question-square"], "f2fd", "M448 32l-448 0 0 448 448 0 0-448zM224 176c-17.7 0-32 14.3-32 32l-48 0c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.1-20.5 57.5-38.2 70-6.3 4.4-12.5 7.8-17.8 10.4l0 21.9-48 0 0-56.7c1.4-.4 2.7-.7 4.1-1.1 12.2-3.2 23.3-6.1 34.1-13.7 10.4-7.3 17.8-16.9 17.8-30.8 0-17.7-14.3-32-32-32zM200 344l48 0 0 48-48 0 0-48z"]
};
var faQuestionSquare = faSquareQuestion;
var faListTree = {
  prefix: 'fass',
  iconName: 'list-tree',
  icon: [512, 512, [], "e1d2", "M96 48l-96 0 0 96 24 0 0 296 104 0 0 24 96 0 0-96-96 0 0 24-56 0 0-112 56 0 0 24 96 0 0-96-96 0 0 24-56 0 0-88 24 0 0-96zm64 16l0 64 352 0 0-64-352 0zM288 224l0 64 224 0 0-64-224 0zm0 160l0 64 224 0 0-64-224 0z"]
};
var faBrazilianRealSign = {
  prefix: 'fass',
  iconName: 'brazilian-real-sign',
  icon: [512, 512, [], "e46c", "M432 16l0 48 48 0 0 64-80.9 0c-26 0-47.1 21.1-47.1 47.1 0 22.5 15.9 41.8 37.9 46.2l32.8 6.6c51.9 10.4 89.3 56 89.3 109 0 50.6-33.8 93.3-80 106.7l0 52.4-64 0 0-48-64 0 0-64 96.9 0c26 0 47.1-21.1 47.1-47.1 0-22.5-15.9-41.8-37.9-46.2l-32.8-6.6c-51.9-10.4-89.3-56-89.3-109 0-50.6 33.8-93.2 80-106.7l0-52.4 64 0zM0 32l112 0c79.5 0 144 64.5 144 144 0 54.3-30 101.5-74.4 126.1 32.7 108.8 49.4 164.6 50.2 167.4l-61.3 18.4c-.8-2.6-17.6-58.7-50.4-168.1-2.7 .1-5.4 .2-8.1 .2l-48 0 0 160-64 0 0-448zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0 0 160z"]
};
var faBookOpenLines = {
  prefix: 'fass',
  iconName: 'book-open-lines',
  icon: [512, 512, [], "e753", "M256 141.3c16.3-6.8 32.9-13.7 49.7-20.7 39-16.2 80.8-24.6 123.1-24.6l19.2 0 0 320-19.2 0c-59.1 0-117.7 11.7-172.3 34.5l-.5 .2 0-309.3zM512 32l-83.2 0c-50.7 0-100.9 10-147.7 29.5L256 72 230.9 61.5C184.1 42 133.9 32 83.2 32L0 32 0 480 83.2 480c50.7 0 100.9 10 147.7 29.5L256 520 281.1 509.5c46.8-19.5 97-29.5 147.7-29.5l83.2 0 0-448zM304 399.6l21.2-9.4c21-9.3 43.8-14.2 66.8-14.2l24 0 0-48-24 0c-29.7 0-59.1 6.2-86.3 18.3l-1.7 .8 0 52.5zm0-96l21.2-9.4c21-9.3 43.8-14.2 66.8-14.2l24 0 0-48-24 0c-29.7 0-59.1 6.2-86.3 18.3l-1.7 .8 0 52.5zm0-96l21.2-9.4c21-9.3 43.8-14.2 66.8-14.2l24 0 0-48-24 0c-29.7 0-59.1 6.2-86.3 18.3l-1.7 .8 0 52.5zM64 136l24 0c35.4 0 70.5 5.6 104 16.7l0 51-4-1.5c-32-12-65.9-18.1-100-18.1l-24 0 0-48zM192 395.6l-4-1.5c-32-12-65.9-18.1-100-18.1l-24 0 0-48 24 0c35.4 0 70.5 5.6 104 16.7l0 51zm0-96l-4-1.5c-32-12-65.9-18.1-100-18.1l-24 0 0-48 24 0c35.4 0 70.5 5.6 104 16.7l0 51z"]
};
var faEllipsisStrokeVertical = {
  prefix: 'fass',
  iconName: 'ellipsis-stroke-vertical',
  icon: [128, 512, ["ellipsis-v-alt"], "f39c", "M80 64l0 32-32 0 0-32 32 0zM48 16l-48 0 0 128 128 0 0-128-80 0zM80 240l0 32-32 0 0-32 32 0zM48 192l-48 0 0 128 128 0 0-128-80 0zm0 224l32 0 0 32-32 0 0-32zM0 368l0 128 128 0 0-128-128 0z"]
};
var faEllipsisVAlt = faEllipsisStrokeVertical;
var faStarAndCrescent = {
  prefix: 'fass',
  iconName: 'star-and-crescent',
  icon: [576, 512, [9770], "f699", "M360.5 48c44.1 0 85 13.7 118.6 37.1-46.9-52.2-114.9-85.1-190.6-85.1-141.4 0-256 114.6-256 256s114.6 256 256 256c75.7 0 143.8-32.9 190.6-85.1-33.6 23.4-74.5 37.1-118.6 37.1-114.9 0-208-93.1-208-208s93.1-208 208-208zm98.3 157.8l-42.3-85.8-42.3 85.8-94.6 13.8 68.5 66.7-16.2 94.2 84.6-44.5 84.6 44.5-16.2-94.2 68.5-66.7-94.6-13.8z"]
};
var faTextSize = {
  prefix: 'fass',
  iconName: 'text-size',
  icon: [576, 512, [], "f894", "M32 32l-32 0 0 128 64 0 0-64 64 0 0 320-64 0 0 64 192 0 0-64-64 0 0-320 64 0 0 64 64 0 0-128-288 0zM288 224l-32 0 0 128 64 0 0-64 64 0 0 128-64 0 0 64 192 0 0-64-64 0 0-128 64 0 0 64 64 0 0-128-288 0z"]
};
var faFaceSurprise = {
  prefix: 'fass',
  iconName: 'face-surprise',
  icon: [512, 512, [128558, "surprise"], "f5c2", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-48 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faSurprise = faFaceSurprise;
var faHospitalUser = {
  prefix: 'fass',
  iconName: 'hospital-user',
  icon: [640, 512, [], "f80d", "M64 0l384 0 0 185.3c-46.9 19-80 65-80 118.7 0 19.8 4.5 38.5 12.5 55.2L313.6 512 64 512 64 0zM208 352l0 112 74.2 0 21.8-49.8 0-62.2-96 0zM280 88l-48 0 0 48-48 0 0 48 48 0 0 48 48 0 0-48 48 0 0-48-48 0 0-48zM416 304a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM584 416l56 128-288 0 56-128 176 0z"]
};
var faArrowDownUpLock = {
  prefix: 'fass',
  iconName: 'arrow-down-up-lock',
  icon: [576, 512, [], "e4b0", "M160 525.3c5.5-5.5 39.7-39.7 102.6-102.6L285.3 400 240 354.7c-14.6 14.6-30.6 30.6-48 48l0-114.7 145 0c4.2-33.9 21.7-63.6 47-83.9l0-94.8c17.4 17.4 33.4 33.4 48 48L477.3 112c-5.5-5.5-39.7-39.7-102.6-102.6L352-13.3c-5.5 5.5-39.7 39.7-102.6 102.6L226.7 112 272 157.3c14.6-14.6 30.6-30.6 48-48l0 114.7-288 0 0 64 96 0 0 114.7c-17.4-17.4-33.4-33.4-48-48L34.7 400c5.5 5.5 39.7 39.7 102.6 102.6L160 525.3zM128 32l0 144 64 0 0-176-64 0 0 32zM464 272c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faFolder = {
  prefix: 'fass',
  iconName: 'folder',
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", "M0 448l512 0 0-368-224 0-64-48-224 0 0 416z"]
};
var faFolderBlank = faFolder;
var faHollyBerry = {
  prefix: 'fass',
  iconName: 'holly-berry',
  icon: [512, 512, [], "f7aa", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm160 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 343.1l-96 10.7 33.8 69.3-17.8 88.9 81.8-39.1 75.5 15.7-13.3-95.7 94.7-9-30.7-73.3 16-86.6-80 36.8-78.6-11.7 14.6 94zm222.7 49.8l-13.3 95.7 75.5-15.7 81.8 39.1-17.8-88.9 33.8-69.3-96-10.7 14.6-94-78.6 11.7-48.8-22.5-12.7 68.7c21.2 50.6 32.8 78.4 34.9 83.3l26.6 2.5z"]
};
var faMessageImage = {
  prefix: 'fass',
  iconName: 'message-image',
  icon: [512, 512, ["comment-alt-image"], "e1e0", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM128 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 336l-256 0 0-48 128-112 128 112 0 48z"]
};
var faCommentAltImage = faMessageImage;
var faCommentQuote = {
  prefix: 'fass',
  iconName: 'comment-quote',
  icon: [512, 512, [], "e14c", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM224 160l-112 0 0 112 64 0 0 8c0 13.3-10.7 24-24 24l-24 0 0 48 24 0c39.8 0 72-32.2 72-72l0-120zM384 272l0-112-112 0 0 112 64 0 0 8c0 13.3-10.7 24-24 24l-24 0 0 48 24 0c39.8 0 72-32.2 72-72l0-8z"]
};
var faVenusDouble = {
  prefix: 'fass',
  iconName: 'venus-double',
  icon: [640, 512, [9890], "f226", "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1l0 66.9 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-66.9C78.1 334.1 16 262.3 16 176 16 78.8 94.8 0 192 0S368 78.8 368 176zM357.5 327c14.4-15.8 26.6-33.7 36.1-53.1 16.1 9 34.7 14.1 54.5 14.1 61.9 0 112-50.1 112-112S509.9 64 448 64c-19.8 0-38.3 5.1-54.5 14.1-9.5-19.4-21.6-37.3-36.1-53.1 26.4-15.9 57.4-25 90.5-25 97.2 0 176 78.8 176 176 0 86.3-62.1 158-144 173.1l0 66.9 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-66.9c-21.1-3.9-40.8-11.5-58.5-22.1z"]
};
var faElephant = {
  prefix: 'fass',
  iconName: 'elephant',
  icon: [640, 512, [128024], "f6da", "M122.3 72.6c11.7-9.1 24.5-16.9 38.1-23.2l0 62.6c0 79.5 64.5 144 144 144l16 0 0-32-16 0c-61.9 0-112-50.1-112-112l0-112 112 0c30.5 0 58.2 12.2 78.4 32l1.6 0c88.4 0 160 71.6 160 160l0 119.4c-9.4 5.4-20.3 8.6-32 8.6-20.9 0-39.5-10-51.2-25.6l-25.6 19.2c6.6 8.7 14.6 16.3 23.7 22.4l0 0c6.5 4.3 13.6 7.9 21.1 10.5l0 0c10 3.5 20.8 5.5 32 5.5s22-1.9 32-5.5l0 0c13.9-4.9 26.4-13 36.6-23.4l11.2-11.4 22.9 22.4-11.2 11.4c-16.1 16.4-36.5 28.5-59.4 34.4l0 21.5c0 8 6.5 14.5 14.5 14.5 6.2 0 11.8-4 13.7-9.9l5.4-16.2 60.7 20.2-5.4 16.2c-10.7 32.1-40.7 53.7-74.5 53.7-43.4 0-78.5-35.1-78.5-78.5l0-21.5c-25.2-6.5-47.3-20.4-64-39.3l0 171.3-128 0 0-102c-15.3 3.9-31.4 6-48 6s-32.7-2.1-48-6l0 102-128 0 0-174.9-18.1 40.7-43.9-19.5 29.9-67.3 0-42.9c0-72.2 35.4-136.2 89.9-175.4zM464.4 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faClipboardQuestion = {
  prefix: 'fass',
  iconName: 'clipboard-question',
  icon: [384, 512, [], "e4e3", "M320 0l-256 0 0 32-64 0 0 480 384 0 0-480-64 0 0-32zM112 112l0-48 160 0 0 48-160 0zm80 133.2c-17.7 0-32 14.3-32 32l-42.4 0c0-41.1 33.3-74.4 74.4-74.4s74.4 33.3 74.4 74.4c0 33.5-22.8 59-53.2 69.6l0 18.3-42.4 0 0-53.5 3.3-.5c21.1-3 49.9-7.1 49.9-34 0-17.7-14.3-32-32-32zM168 392l48 0 0 48-48 0 0-48z"]
};
var faHotdog = {
  prefix: 'fass',
  iconName: 'hotdog',
  icon: [576, 512, [127789], "f80f", "M218.5 506.5l37.5 37.5 320-320-37.5-37.5-320 320zM0 288L37.5 325.5 357.5 5.5 320-32 0 288zM488.6 168.6c31.2-31.2 31.2-81.9 0-113.1s-81.9-31.2-113.1 0l-288 288c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0l288-288z"]
};
var faArrowUpFromBracket = {
  prefix: 'fass',
  iconName: 'arrow-up-from-bracket',
  icon: [448, 512, [], "e09a", "M246.6 9.4L224-13.3 201.4 9.4 73.4 137.4 50.7 160 96 205.3c6.6-6.6 38.6-38.6 96-96l0 242.7 64 0 0-242.7c57.4 57.4 89.4 89.4 96 96l45.3-45.3-22.6-22.6-128-128zM64 352l0-32-64 0 0 192 448 0 0-192-64 0 0 128-320 0 0-96z"]
};
var faReplyClock = {
  prefix: 'fass',
  iconName: 'reply-clock',
  icon: [640, 512, ["reply-time"], "e239", "M320.3 112a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 96 80 0 0-32-48 0 0-64zm-16 272c26.1 0 51-5.2 73.7-14.7 4.1 14.9 6.3 30.5 6.3 46.7 0 128-128 176-128 176s32-32 32-80c0-61.9-50.1-112-112-112l-80 0 0 135.9-239.8-215.9 239.8-215.9 0 135.9 22 0c21.3 82.8 96.5 144 186 144z"]
};
var faReplyTime = faReplyClock;
var faChartLineUp = {
  prefix: 'fass',
  iconName: 'chart-line-up',
  icon: [512, 512, [], "e0e5", "M64 32l0 384 448 0 0 64-512 0 0-448 64 0zM304 349.3c-6.6-6.6-38.6-38.6-96-96-30.7 30.7-52 52-64 64L98.7 272c8.2-8.2 37.1-37.1 86.6-86.6L208 162.7c6.6 6.6 38.6 38.6 96 96l65.4-65.4-65.4-65.4 176 0 0 176-65.4-65.4C345.1 308.2 308.2 345.1 304 349.3z"]
};
var faMicroscope = {
  prefix: 'fass',
  iconName: 'microscope',
  icon: [512, 512, [128300], "f610", "M288 0l-160 0 0 304 160 0 0-112 32 0c70.7 0 128 57.3 128 128S390.7 448 320 448l-320 0 0 64 512 0 0-64-48.9 0c30.4-34 48.9-78.8 48.9-128 0-106-86-192-192-192l-32 0 0-128zM120 352l-24 0 0 48 224 0 0-48-200 0z"]
};
var faCatSpace = {
  prefix: 'fass',
  iconName: 'cat-space',
  icon: [576, 512, [], "e001", "M400-32c97.2 0 176 78.8 176 176 0 80.6-54.1 148.4-128 169.3l0 198.7-64 0 0-172.8-136 108.8 88 0 0 64-272 0 0-320c0-17.7-14.3-32-32-32l-32 0 0-64 32 0c53 0 96 43 96 96l0 85.8c24.6-37 61.6-64.9 105.2-77.8-5.9-17.6-9.2-36.4-9.2-56 0-97.2 78.8-176 176-176zm96 176c0 53-43 96-96 96s-96-43-96-96l0-84.7c-19.9 22.6-32 52.2-32 84.7 0 70.7 57.3 128 128 128s128-57.3 128-128c0-32.5-12.1-62.1-32-84.7l0 84.7zM368 124a20 20 0 1 0 0 40 20 20 0 1 0 0-40zm64 0a20 20 0 1 0 0 40 20 20 0 1 0 0-40zM147.4 12.5L200 32 147.4 51.4 128 104 108.6 51.4 56 32 108.6 12.5 128-40 147.4 12.5zM400 16c-26.7 0-51.6 8.2-72.1 22.2l44.7 37.2 54.9 0 44.6-37.2C451.5 24.2 426.7 16 400 16z"]
};
var faCircleExclamationCheck = {
  prefix: 'fass',
  iconName: 'circle-exclamation-check',
  icon: [640, 512, [], "e10d", "M320.3 0c123.7 0 226.9 87.7 250.8 204.3-11.5 15.9-36.9 50.8-76.2 104.8l-29.1-30-103.5 100.1c35.3 36.5 64.8 67.1 88.7 91.7l3.3 3.3c-39 24-84.8 37.8-133.9 37.8-141.4 0-256-114.6-256-256S178.9 0 320.3 0zM638.6 274.7l-14.1 19.4-102.4 140.8-16.8 23.1c-10.1-10.5-29.6-30.6-58.5-60.5l-16.7-17.3 34.5-33.3c10.8 11.1 22.6 23.4 35.4 36.6l85.6-117.7 14.1-19.4 38.8 28.3zM292.3 380l56 0 0-56-56 0 0 56zm8.8-92l38.4 0 12.8-160-64 0 12.8 160z"]
};
var faCards = {
  prefix: 'fass',
  iconName: 'cards',
  icon: [576, 512, [], "e3ed", "M544 512l-320 0 0-6.4 271.3-72.7-98.8-368.9 147.5 0 0 448zM436.6 399L127.5 481.8 11.5 49.1 320.6-33.8 436.6 399zM203.3 318l10.3 38.6 92.4-24.7-10.3-38.7-92.4 24.8zM132.1 216.2c-15.4 26.8-6.3 61 20.5 76.5l4.8 2.5c24.2 11.1 53 3.4 68.6-18.2l9-15 15.3 8.5c25.9 11.6 56.9 2.1 71.4-23.1l2.5-4.8c11.1-24.2 3.4-53-18.1-68.6l-112-65-61.9 107.2z"]
};
var faCloud = {
  prefix: 'fass',
  iconName: 'cloud',
  icon: [576, 512, [9729], "f0c2", "M448 480L0 480 0 336c0-62.7 40.1-116 96-135.8L96 176c0-79.5 64.5-144 144-144 55.4 0 103.5 31.3 127.6 77.1 14.2-8.3 30.8-13.1 48.4-13.1 53 0 96 43 96 96l0 49.1c38.3 22.1 64 63.5 64 110.9l0 128-128 0z"]
};
var faAlbumCirclePlus = {
  prefix: 'fass',
  iconName: 'album-circle-plus',
  icon: [576, 512, [], "e48c", "M32 32l448 0 0 182c-15.3-3.9-31.4-6-48-6-7.8 0-15.4 .5-22.9 1.4-20-65.6-81-113.4-153.1-113.4-88.4 0-160 71.6-160 160 0 83.2 63.5 151.5 144.6 159.3 1.8 23 7.6 44.8 16.8 64.7L32 480 32 32zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm176 32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 64-64 0 0 32 64 0 0 64 32 0 0-64 64 0 0-32-64 0 0-48z"]
};
var faBaseballBatBall = {
  prefix: 'fass',
  iconName: 'baseball-bat-ball',
  icon: [640, 512, [], "f432", "M624 80l-240 240-160 80-103 103 17 17-33.9 33.9-81.9-81.9 33.9-33.9 17 17 103-103 80-160 240-240 128 128zM496 544a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
};
var faCarRear = {
  prefix: 'fass',
  iconName: 'car-rear',
  icon: [512, 512, ["car-alt"], "f5de", "M97.3 32l317.4 0 7.5 21.4 48.5 138.6 41.3 0 0 224-32 0 0 64-96 0 0-64-256 0 0 64-96 0 0-64-32 0 0-224 41.3 0 48.5-138.6 7.5-21.4zm272 64l-226.6 0-33.6 96 293.8 0-33.6-96zM320 288l-128 0 0 64 128 0 0-64zM48 256l0 48 80 0 0-48-80 0zm416 0l-80 0 0 48 80 0 0-48z"]
};
var faCarAlt = faCarRear;
var faWindsock = {
  prefix: 'fass',
  iconName: 'windsock',
  icon: [512, 512, [], "f777", "M64 32l0-32-64 0 0 512 64 0 0-192 64 0 0 48 80-16.7 0-286.7-80-16.7 0 48-64 0 0-64zm64 112l0 128-64 0 0-128 64 0zM256 74.7l0 266.7 112-23.3 0-220-112-23.3zM512 288l0-160-96-20 0 200 96-20z"]
};
var faFaceWorried = {
  prefix: 'fass',
  iconName: 'face-worried',
  icon: [512, 512, [], "e3a3", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-.4-112c-38.7 0-74.5 11.4-103.6 30.6 4.7-53 49.3-94.6 103.6-94.6s98.8 41.6 103.6 94.6C330.1 411.4 294.3 400 255.6 400zM144 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 164c-4.2 0-8.4 .3-12.5 .8-20.3 2.7-38.9 11.9-53.8 25.8L111 204.3 83.7 175 98.3 161.4c20.6-19.3 46.8-32.4 75.9-36.2 5.8-.8 11.7-1.2 17.7-1.2l20 0 0 40-20 0zm140.5 .8c-4.1-.5-8.3-.8-12.5-.8l-20 0 0-40 20 0c6 0 11.9 .4 17.7 1.2 29.1 3.8 55.3 17 75.9 36.2l14.6 13.7-27.3 29.2-14.6-13.7c-14.9-13.9-33.5-23.1-53.8-25.8z"]
};
var faMicrophoneCircleXmark = {
  prefix: 'fass',
  iconName: 'microphone-circle-xmark',
  icon: [576, 512, [], "e77e", "M320 0l0 148c-48.5 34.9-80 91.7-80 156 0 4.9 .2 9.8 .5 14.6-5.4 .9-10.9 1.4-16.5 1.4-53 0-96-43-96-96L128 0 320 0zM224 368c8.9 0 17.6-.8 26.1-2.4 5.4 15.8 12.7 30.7 21.8 44.3-7.8 2-15.7 3.5-23.9 4.5l0 49.5 72 0 0 48-192 0 0-48 72 0 0-49.5C105.3 402.7 32 321.9 32 224l0-64 48 0 0 64c0 79.5 64.5 144 144 144zM432 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm55.3 111.3L498.6 260 476 237.4c-4 4-18.7 18.7-44 44-25.4-25.4-40-40-44-44L365.4 260c4 4 18.6 18.7 44 44-25.4 25.4-40 40-44 44L388 370.6c4-4 18.7-18.6 44-44 25.4 25.4 40 40 44 44L498.6 348c-4-4-18.6-18.7-44-44l32.7-32.7z"]
};
var faMessageLines = {
  prefix: 'fass',
  iconName: 'message-lines',
  icon: [512, 512, ["comment-alt-lines"], "f4a6", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM152 176l232 0 0 48-256 0 0-48 24 0zm0 96l136 0 0 48-160 0 0-48 24 0z"]
};
var faCommentAltLines = faMessageLines;
var faThumbtackSlash = {
  prefix: 'fass',
  iconName: 'thumbtack-slash',
  icon: [576, 512, ["thumb-tack-slash"], "e68f", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-143.1-143.1 62 0c0-65.8-33.1-123.9-83.6-158.5l-10-129.5 61.5 0 0-64-314.2 0 56.3 56.3-4.8 62.9-136.1-136.1zM282.3 352L149.5 219.2c-33 34.5-53.4 81.3-53.4 132.8l186.2 0zM256.1 512l0 32 64 0 0-144-64 0 0 112z"]
};
var faThumbTackSlash = faThumbtackSlash;
var faBoxArrowDown = {
  prefix: 'fass',
  iconName: 'box-arrow-down',
  icon: [448, 512, [], "e794", "M335.1 80l-222.1 0-34.3 48 290.7 0-34.3-48zM80 16l288 0 80 112 0 352-448 0 0-352 80-112zM207 401l17 17c2.1-2.1 31.8-31.8 89-89l17-17-33.9-33.9c-9 9-25 25-48 48l0-126.1-48 0 0 126.1c-23-23-39-39-48-48L118.1 312c2.1 2.1 31.8 31.8 89 89z"]
};
var faPlusMinus = {
  prefix: 'fass',
  iconName: 'plus-minus',
  icon: [384, 512, [], "e43c", "M224 32l0-32-64 0 0 160-160 0 0 64 160 0 0 160 64 0 0-160 160 0 0-64-160 0 0-128zM0 448l0 64 384 0 0-64-384 0z"]
};
var faHouseCircleCheck = {
  prefix: 'fass',
  iconName: 'house-circle-check',
  icon: [640, 512, [], "e509", "M496 208c11.7 0 23.1 1 34.2 3l-242.2-227-256 240 0 48 48 0 0 240 260 0c-10.5-14.6-19-30.7-25.1-48l-90.9 0 0-144 97.4 0c30.3-66.1 97.1-112 174.6-112zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L417.4 400 440 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z"]
};
var faFaceWoozy = {
  prefix: 'fass',
  iconName: 'face-woozy',
  icon: [512, 512, [], "e3a2", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm384-48c0-35.3-21.5-64-48-64s-48 28.7-48 64 21.5 64 48 64 48-28.7 48-64zM213.8 263.3l23.3-5.8-11.6-46.6-87.3 21.8-23.3 5.8 11.6 46.6c8.7-2.2 37.8-9.5 87.3-21.8zm27.5-144.6L214.7 78.7c-.6 .4-39.3 26.2-116 77.3l-20 13.3 26.6 39.9c.6-.4 39.3-26.2 116-77.3l20-13.3zM161 335l-17-17-33.9 33.9c13.3 13.3 20.6 20.6 21.7 21.7 23.6 23.6 59.6 29.4 89.4 14.5 10-5 21.9-3.9 30.8 2.8L280 412c10.4 7.8 23.1 12 36.1 12 19.8 0 38.4-9.8 49.6-26.2 16.2-23.6 28.1-41 35.7-52.1l-39.6-27.1c-7.6 11.1-19.5 28.5-35.7 52.1-2.3 3.3-6 5.3-10 5.3-2.6 0-5.2-.9-7.3-2.4l-27.9-21c-23.5-17.6-54.9-20.4-81.1-7.3-11.3 5.7-25 3.4-34-5.5L161 335z"]
};
var faCrateApple = {
  prefix: 'fass',
  iconName: 'crate-apple',
  icon: [512, 512, ["apple-crate"], "f6b1", "M160 54.9C160 24.6 184.6 0 214.9 0l9.1 0 0 9.1C224 39.4 199.4 64 169.1 64l-9.1 0 0-9.1zm192 0C352 24.6 376.6 0 406.9 0l9.1 0 0 9.1C416 39.4 391.4 64 361.1 64l-9.1 0 0-9.1zM96 80c27.4 0 64 18.3 64 18.3S196.6 80 224 80c43.6 0 64 47.8 64 91.4 0 7-.4 13.9-1.2 20.6L33.2 192c-.8-6.7-1.2-13.5-1.2-20.6 0-43.6 20.4-91.4 64-91.4zm384 91.4c0 7-.4 13.9-1.2 20.6L319 192c.7-6.7 1-13.6 1-20.6 0-26.1-6-55.1-20.3-78.6-2.7-4.4-5.7-8.7-9-12.7 27.1 1.1 61.3 18.2 61.3 18.2S388.6 80 416 80c43.6 0 64 47.8 64 91.4zM0 224l512 0 0 128-512 0 0-128zM0 384l512 0 0 128-512 0 0-128zm80-96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM464 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faAppleCrate = faCrateApple;
var faCalendarDay = {
  prefix: 'fass',
  iconName: 'calendar-day',
  icon: [448, 512, [], "f783", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0zm64 384l0-128-128 0 0 128 128 0z"]
};
var faCircle = {
  prefix: 'fass',
  iconName: 'circle',
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"]
};
var faNotebook = {
  prefix: 'fass',
  iconName: 'notebook',
  icon: [512, 512, [], "e201", "M64 0l0 104-64 0 0 48 64 0 0 80-64 0 0 48 64 0 0 80-64 0 0 48 64 0 0 104 112 0 0-512-112 0zM480 0l-256 0 0 512 256 0 0-512z"]
};
var faOctagonXmark = {
  prefix: 'fass',
  iconName: 'octagon-xmark',
  icon: [512, 512, ["times-octagon", "xmark-octagon"], "f2f0", "M0 160L0 352 160 512 352 512 512 352 512 160 352 0 160 0 0 160zM172.1 305.9L222.1 256c-38.8-38.8-61.1-61.1-66.9-66.9l33.9-33.9 66.9 66.9c38.8-38.8 61.1-61.1 66.9-66.9l33.9 33.9c-5.8 5.8-28.1 28.1-66.9 66.9 38.8 38.8 61.1 61.1 66.9 66.9l-33.9 33.9c-5.8-5.8-28.1-28.1-66.9-66.9-38.8 38.8-61.1 61.1-66.9 66.9l-33.9-33.9 17-17z"]
};
var faTimesOctagon = faOctagonXmark;
var faXmarkOctagon = faOctagonXmark;
var faRacquet = {
  prefix: 'fass',
  iconName: 'racquet',
  icon: [576, 512, [], "f45a", "M405.2-15.8c40 1.7 78.8 16.6 108.5 46.3l5.8 6.1c27.7 30.9 40.7 70.3 40.7 110.5l-.3 10.2c-2.7 51-25.8 103-66.7 143.8-54.4 54.4-131.8 78.6-198.2 61.6-29.4-7.5-62.9-5.5-84.3 16l-37.4 37.3 16 16-109.2 109.3-77.2-77.3 109.2-109.3 16 16 37.6-37.6c21.4-21.4 23.5-54.7 16-83.9-3-11.8-4.8-24-5.3-36.2l-.2-8c0-54.2 23.4-110.5 66.9-154S343-16 397.2-16l8 .2zm-8 63.8c-36 0-76.4 15.8-108.8 48.2S240.2 168.9 240.2 205l.4 10.4c2.1 23.9 11.4 45 27.3 60.9 40.4 40.4 120.7 39 180.1-20.5 30.4-30.4 46.2-67.7 48-102l.2-6.8c0-28.2-9.6-53.2-27.7-71.3-15.9-15.9-37-25.2-60.9-27.3L397.2 48z"]
};
var faMobileVibrate = {
  prefix: 'fass',
  iconName: 'mobile-vibrate',
  icon: [640, 512, [], "e816", "M480.4 512l-320 0 0-512 320 0 0 512zm-224-48l128 0 0-48-128 0 0 48zM130.4 152l-48 48 38.1 38.1 0 35.9-38.1 38.1 48 48-33.9 33.9-81.9-81.9 56-56-56-56 81.9-81.9 33.9 33.9zm496 48l-56 56 56 56-81.9 81.9-33.9-33.9 48-48-38.1-38.1 0-35.9 38.1-38.1-48-48 33.9-33.9 81.9 81.9z"]
};
var faFaceGrinSquint = {
  prefix: 'fass',
  iconName: 'face-grin-squint',
  icon: [512, 512, [128518, "grin-squint"], "f585", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-184c58.2 0 112.4-10.6 157.7-28.7-13 75.4-78.6 132.7-157.7 132.7S111.3 374.7 98.3 299.3C143.6 317.4 197.8 328 256 328zM127.2 129.7l95.6 48 9.2 4.6 0 20.2-10.2 4.3-95.6 40-14.7-28.3 44.2-27.6-45.3-34 16.8-27.1zm162 48l95.6-48 16.8 27.1-45.3 34 44.2 27.6-14.7 28.3-95.6-40-10.2-4.3 0-20.2 9.2-4.6z"]
};
var faGrinSquint = faFaceGrinSquint;
var faTreeDeciduous = {
  prefix: 'fass',
  iconName: 'tree-deciduous',
  icon: [512, 512, [127795, "tree-alt"], "f400", "M256 0c47.6 0 87 34.6 94.7 80L368 80c53 0 96 43 96 96l0 36.1c29 20.2 48 53.8 48 91.9l0 80-224 28 0 132-64 0 0-132-224-28 0-80c0-38.1 19-71.7 48-91.9L48 176c0-53 43-96 96-96l17.3 0C169 34.6 208.4 0 256 0z"]
};
var faTreeAlt = faTreeDeciduous;
var faUsersBetweenLines = {
  prefix: 'fass',
  iconName: 'users-between-lines',
  icon: [576, 512, [], "e591", "M24 16l552 0 0 48-576 0 0-48 24 0zm0 448l552 0 0 48-576 0 0-48 24 0zM392 192a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm15.9 96l88.1 0 48 128-93.4 0-5.1-15.2-37.6-112.8zm-239.9 0l-37.6 112.8-5.1 15.2-93.4 0 48-128 88.1 0zM72 192a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm152-16a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm128 96l48 144-224 0 48-144 128 0z"]
};
var faMango = {
  prefix: 'fass',
  iconName: 'mango',
  icon: [512, 512, [], "e30f", "M480 0c0 44.2-35.8 80-80 80l-64 0 0 18.5c99.5 15.6 176 101.7 176 205.5 0 114.9-93.1 208-208 208L0 512 0 384 130.2 188.6c35.7-53.5 94.1-87.3 157.8-92L288 48c0-44.2 35.8-80 80-80l112 0 0 32zM384 296c0 48.6-39.4 88-88 88l0 48c75.1 0 136-60.9 136-136l-48 0z"]
};
var faCrosshairsSimple = {
  prefix: 'fass',
  iconName: 'crosshairs-simple',
  icon: [512, 512, [], "e59f", "M445.3 224l-93.3 0 0 64 93.3 0C431.9 368.4 368.4 431.9 288 445.3l0-93.3-64 0 0 93.3C143.6 431.9 80.1 368.4 66.7 288l93.3 0 0-64-93.3 0C80.1 143.6 143.6 80.1 224 66.7l0 7.3c0 39.7 0 68.4 0 86.1l64 0c0-17.7 0-46.3 0-86.1l0-7.3C368.4 80.1 431.9 143.6 445.3 224zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z"]
};
var faPipeSmoking = {
  prefix: 'fass',
  iconName: 'pipe-smoking',
  icon: [640, 512, [], "e3c4", "M0 224L0 346.4c0 91.5 74.1 165.6 165.6 165.6 56.3 0 108.8-28.6 139.3-76l136.3-212-117.9 0-67.2 96 0-96-256 0zm356.8-48l115.2 0 72-112 96 0 0-64-160 0-123.2 176z"]
};
var faCoconut = {
  prefix: 'fass',
  iconName: 'coconut',
  icon: [512, 512, [], "e2f6", "M141.6 141.1c-43.7 43.7-73 91.8-85.8 133.3-13.2 42.7-7.4 71.9 7.5 86.7s44 20.6 86.7 7.5c41.5-12.8 89.6-42.1 133.3-85.8s73-91.8 85.8-133.3c13.2-42.7 7.4-71.9-7.5-86.7s-44-20.6-86.7-7.5c-41.5 12.8-89.6 42.1-133.3 85.8zM260.8 9.4C310-5.8 362-4.8 395.6 28.8l41 40.9c48.6 48.6 75.9 114.5 75.9 183.2 0 143.1-116 259-259 259-68.7 0-134.6-27.3-183.2-75.9l-41-41c-33.6-33.6-34.6-85.6-19.4-134.8 15.6-50.4 49.7-105 97.8-153.1S210.4 25 260.8 9.4zm63.5 88.2c25 25-5.4 95.9-67.9 158.4S123 348.9 98 323.9 103.4 228 165.9 165.5 299.3 72.6 324.3 97.6zm95.4 107.1l-11.3-11.3-22.6 22.6c4.1 4.1 18.5 18.5 43.3 43.3l11.3 11.3 22.6-22.6c-4.1-4.1-18.5-18.5-43.3-43.3zm-56 136l-11.3-11.3-22.6 22.6c4.1 4.1 18.5 18.5 43.3 43.3l11.3 11.3 22.6-22.6c-4.1-4.1-18.5-18.5-43.3-43.3zm-136 56l-11.3-11.3-22.6 22.6c4.1 4.1 18.5 18.5 43.3 43.3l11.3 11.3 22.6-22.6c-4.1-4.1-18.5-18.5-43.3-43.3z"]
};
var faFaceDiagonalMouth = {
  prefix: 'fass',
  iconName: 'face-diagonal-mouth',
  icon: [512, 512, [129764], "e47e", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM358.1 335.2l-184 48-23.2 6.1-12.1-46.4 23.2-6.1 184-48 23.2-6.1 12.1 46.4-23.2 6.1zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faStarSharpHalf = {
  prefix: 'fass',
  iconName: 'star-sharp-half',
  icon: [576, 512, [], "e28c", "M304.4-32l-85.7 211.9-216.3 0 176.1 136.9-70.5 221.6 196.4-152.7 0-417.7z"]
};
var faMessageWaveform = {
  prefix: 'fass',
  iconName: 'message-waveform',
  icon: [640, 512, [], "e6e0", "M64 448l0-416 512 0 0 240-48 0 0-32-144 0 0 48-80 0 0 188.8-112 67.2 0-96-128 0zM480 312l0 232-48 0 0-256 48 0 0 24zm80 32l0 168-48 0 0-192 48 0 0 24zM400 360l0 136-48 0 0-160 48 0 0 24zm240 32l0 72-48 0 0-96 48 0 0 24z"]
};
var faMusicMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'music-magnifying-glass',
  icon: [640, 512, [], "e662", "M448 208c0 62.7-40.1 116-96 135.8l0 66.6c27.4-6.5 52.7-18.4 74.7-34.5L553.4 502.6 576 525.3 621.3 480 598.6 457.4 472 330.7C497.1 296.3 512 253.9 512 208 512 93.1 418.9 0 304 0 197.3 0 109.3 80.4 97.4 183.9l67.2-12.2C180.7 109.7 237 64 304 64 383.5 64 448 128.5 448 208zM304 223.9l0-28.8-28.3 5.1-176 32-19.7 3.6 0 181.8c-5.9-1.1-11.4-1.6-16-1.6-9.5 0-22.9 2.1-34.9 7.5-11.1 5-29.1 17.2-29.1 40.5s18 35.4 29.1 40.5C41.1 509.9 54.5 512 64 512s22.9-2.1 34.9-7.5c11.1-5 29.1-17.2 29.1-40.5l0-140.1 128-23.3 0 85c-5.9-1.1-11.4-1.6-16-1.6-9.5 0-22.9 2.1-34.9 7.5-11.1 5-29.1 17.2-29.1 40.5s18 35.4 29.1 40.5c11.9 5.4 25.4 7.5 34.9 7.5s22.9-2.1 34.9-7.5c11.1-5 29.1-17.2 29.1-40.5l0-208.1z"]
};
var faHouseMedicalCircleXmark = {
  prefix: 'fass',
  iconName: 'house-medical-circle-xmark',
  icon: [640, 512, [], "e513", "M80 512l260 0c-21.2-29.5-34.3-65.3-35.9-104l-48.2 0 0-56-56 0 0-64 56 0 0-56 64 0 0 56 20 0c34.9-48.5 91.7-80 156-80 11.7 0 23.1 1 34.2 3L288-16 32 224 32 272 80 272 80 512zm416 32a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm55.3-176.7L518.6 400c25.4 25.3 40 40 44 44L540 466.6c-4-4-18.6-18.6-44-44-25.3 25.4-40 40-44 44L429.4 444c4-4 18.6-18.6 44-44-25.4-25.3-40-40-44-44L452 333.4c4 4 18.6 18.6 44 44 25.3-25.4 40-40 44-44l22.6 22.6-11.3 11.3z"]
};
var faClub = {
  prefix: 'fass',
  iconName: 'club',
  icon: [512, 512, [9827], "f327", "M380 160.1c2.6-10.2 4-21 4-32.1 0-70.7-57.3-128-128-128S128 57.3 128 128c0 11.1 1.4 21.8 4 32.1-1.3 0-2.7-.1-4-.1-70.7 0-128 57.3-128 128S57.3 416 128 416c38.2 0 72.5-16.8 96-43.3l0 75.3-64 0 0 64 192 0 0-64-64 0 0-75.3c23.5 26.6 57.8 43.3 96 43.3 70.7 0 128-57.3 128-128S454.7 160 384 160c-1.4 0-2.7 0-4 .1z"]
};
var faFireSmoke = {
  prefix: 'fass',
  iconName: 'fire-smoke',
  icon: [512, 512, [], "f74b", "M96 192c0 16.8 2.6 33 7.4 48.2 2.8-.2 5.7-.2 8.6-.2 12.7 0 25.1 1.5 36.9 4.3 14.1-10.8 30-19.6 47-25.8 14-39.8 60-74.4 60-74.4s46.1 34.6 60 74.4c17.1 6.2 32.9 14.9 47 25.8 11.9-2.8 24.3-4.3 36.9-4.3 2.9 0 5.8 .1 8.6 .2 4.8-15.2 7.4-31.4 7.4-48.2 0-26.7-19.2-96-96-160L288 64 224 0C181.3 26.7 96 102.4 96 192zM256 512l256 0 0-112c0-61.9-50.1-112-112-112-17.3 0-33.7 3.9-48.3 10.9-23.4-26.3-57.6-42.9-95.7-42.9s-72.2 16.6-95.7 42.9c-14.6-7-31-10.9-48.3-10.9-61.9 0-112 50.1-112 112l0 112 256 0z"]
};
var faTableList = {
  prefix: 'fass',
  iconName: 'table-list',
  icon: [448, 512, ["th-list"], "f00b", "M0 32l448 0 0 448-448 0 0-448zM64 96l0 64 64 0 0-64-64 0zm320 0l-192 0 0 64 192 0 0-64zM64 224l0 64 64 0 0-64-64 0zm320 0l-192 0 0 64 192 0 0-64zM64 352l0 64 64 0 0-64-64 0zm320 0l-192 0 0 64 192 0 0-64z"]
};
var faThList = faTableList;
var faFlaskVial = {
  prefix: 'fass',
  iconName: 'flask-vial',
  icon: [640, 512, [], "e4f3", "M179.9 429.1l-2.2 5c-14.5 8.8-31.5 13.9-49.7 13.9-53 0-96-43-96-96l0-288-32 0 0-64 256 0 0 64-32 0 0 262.1-44.1 102.9zM96 64l0 128 64 0 0-128-64 0zM378.8 249.2l-30.3 70.8 135 0-30.3-70.8-5.2-12.1 0-173.1-64 0 0 173.1-5.2 12.1zM224 512l0-64 96-224 0-160-32 0 0-64 256 0 0 64-32 0 0 160 96 224 0 64-384 0z"]
};
var faLuchadorMask = {
  prefix: 'fass',
  iconName: 'luchador-mask',
  icon: [448, 512, ["luchador", "mask-luchador"], "f455", "M224-16C109.1-16 16 77.1 16 192l0 336 416 0 0-336C432 77.1 338.9-16 224-16zM192 144l32 56 32-56 128 0 0 144-120 0 16 32 72 0 0 128-256 0 0-128 72 0 16-32-120 0 0-144 128 0zM104 248l96 0-40-64-56 0 0 64zm240-64l-56 0-40 64 96 0 0-64zM312 360l-176 0 0 48 176 0 0-48z"]
};
var faLuchador = faLuchadorMask;
var faMaskLuchador = faLuchadorMask;
var faCircleExclamation = {
  prefix: 'fass',
  iconName: 'circle-exclamation',
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM228 324l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0z"]
};
var faExclamationCircle = faCircleExclamation;
var faBlockBrick = {
  prefix: 'fass',
  iconName: 'block-brick',
  icon: [448, 512, ["wall-brick"], "e3db", "M96 32l0 80 256 0 0-80-256 0zM64 112l0-80-64 0 0 80 64 0zM0 144l0 96 208 0 0-96-208 0zM0 368l64 0 0-96-64 0 0 96zm0 32l0 80 208 0 0-80-208 0zm240 0l0 80 208 0 0-80-208 0zm208-32l0-96-64 0 0 96 64 0zm-96 0l0-96-256 0 0 96 256 0zm96-224l-208 0 0 96 208 0 0-96zm0-32l0-80-64 0 0 80 64 0z"]
};
var faWallBrick = faBlockBrick;
var faArrowUTurnRightUp = {
  prefix: 'fass',
  iconName: 'arrow-u-turn-right-up',
  icon: [576, 512, [], "e7ec", "M573.5 144l-45.3 45.2-80-80 0 210.7c0 102.7-80.7 186.6-182.1 191.8l-9.9 .2c-106 0-192-86-192-192l0-256 64 0 0 256c0 70.7 57.3 128 128 128l6.6-.2c67.6-3.4 121.4-59.4 121.4-127.8l0-210.7-80 80-45.2-45.2 157.2-157.2 157.3 157.2z"]
};
var faTaxi = {
  prefix: 'fass',
  iconName: 'taxi',
  icon: [512, 512, [128662, "cab"], "f1ba", "M352 0l-192 0 0 64-81 0c-.7 2.9-11.4 45.6-32 128l-47 0 0 288 96 0 0-64 320 0 0 64 96 0 0-288-47 0c-20.6-82.4-31.3-125.1-32-128l-81 0 0-64zm31 128l16 64-286 0 16-64 254 0zM96 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCab = faTaxi;
var faTextSlash = {
  prefix: 'fass',
  iconName: 'text-slash',
  icon: [576, 512, ["remove-format"], "f87d", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-255.3-255.3 45.4-160.7 102.8 0c-3.4 13.6-8.7 34.9-16 64l66 0c2.4-9.5 9.7-39 22.1-88.2l9.9-39.8-418 0c-4.8 19.3-7.3 29.2-7.4 29.6L49.3-16.9zM180.5 114.4l4.6-18.4 116.7 0-30.8 108.9-90.5-90.5zM293 362.7l-51.9-51.9-29.7 105.2-83.3 0 0 64 224 0 0-58.2-5.8-5.8-68.4 0 15.1-53.3z"]
};
var faRemoveFormat = faTextSlash;
var faPeoplePulling = {
  prefix: 'fass',
  iconName: 'people-pulling',
  icon: [576, 512, [], "e535", "M128 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm10.8 304l29.8 134.1 3.9 23.2 .5 2.7 64.9 0c-1.2-7.1-3.2-19.5-6.2-37.3-.1-.6-.2-1.1-.3-1.7L174.3 216.8c90.7 44.5 140.5 68.9 149.4 73.3 7.1-23.6 14.7-48.5 22.7-74.8 16.6-7.4 28.7-12.7 36.2-16.1l-17 63.6c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4c16.9 62 27 99.1 30.4 111.4l61.7-16.8-32.4-118.9-2-7.5-5.2-5.7-52.3-57 18.4-62.4c10.6 21.2 16.8 33.6 18.5 36.9l9.5 4.8 48 24 28.6-57.2-38.5-19.2-35.2-70.5-7-14-15.3-3.1-80-16-10-2c-146.8 65.3-75.8 33.7-94.7 42.1l-4.1 13.6-5.7 17-138.7-68-6.7-3.3-138.5 0 0 224 58.2 0 26.2 157.3 .5 2.7 64.9 0-2.2-13.3-24.5-146.7 15.7 0zM464 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4c-32.4 32.4-54.4 54.4-66 66l45.3 45.3 75.3-75.3 2.4-6.1 15.7-39.3-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"]
};
var faBackward = {
  prefix: 'fass',
  iconName: 'backward',
  icon: [640, 512, [9194], "f04a", "M304 296l0 200-288-240 288-240 0 200 240-200 0 480-240-200z"]
};
var faSpade = {
  prefix: 'fass',
  iconName: 'spade',
  icon: [512, 512, [9824], "f2f4", "M347 69.5L256.5-21c-54.1 54.1-126.9 126.9-218.5 218.5-50 50-50 131 0 181s131 50 181 0l5.5-5.5 0 75-64 0 0 64 192 0 0-64-64 0 0-75 5.5 5.5c50 50 131 50 181 0s50-131 0-181L347 69.5z"]
};
var faDreidel = {
  prefix: 'fass',
  iconName: 'dreidel',
  icon: [576, 512, [], "f792", "M557.5 32l-22.6 22.6-136 136 97.4 97.4-71 71-240-240 71-71 97.4 97.4 136-136 22.6-22.6 45.3 45.3zM151.3 153l240 240-87 87-240 0 0-240 87-87z"]
};
var faCarBurst = {
  prefix: 'fass',
  iconName: 'car-burst',
  icon: [640, 512, ["car-crash"], "f5e1", "M232 8.1l0 24-48 0 0-88 48 0 0 64zM32 168.1l-24 0 0-48 88 0 0 48-64 0zM304.2 81.9L270.2 47.9c23.6-23.6 61.3-61.3 62.2-62.2l33.9 33.9c-23.6 23.6-61.3 61.3-62.2 62.2zM100.5 285.5l-17 17-33.9-33.9c23.6-23.6 61.3-61.3 62.2-62.2l33.9 33.9c-9.4 9.4-24.5 24.5-45.3 45.3zM49.6 19.6L83.5-14.3C107.1 9.3 144.8 47 145.8 47.9L111.8 81.9C88.3 58.3 50.6 20.6 49.6 19.6zM315.9 99.3l21.4 5.7 216.4 58 21.4 5.7 2.1 22.1 12.7 131 34.6 9.3c-40 149.4-46.9 175.2-58 216.4l-77.3-20.7 16.6-61.8-278.2-74.5-16.6 61.8-77.3-20.7c23.5-87.6 42.8-159.7 58-216.4l34.6 9.3 76.5-107.1 12.9-18zM515.8 219.1l-173.5-46.5-49.7 69.5 231.5 62-8.3-85zM255.7 348.1a32 32 0 1 0 16.6-61.8 32 32 0 1 0 -16.6 61.8zm286.5 43.6a32 32 0 1 0 -61.8-16.6 32 32 0 1 0 61.8 16.6z"]
};
var faCarCrash = faCarBurst;
var faCommentMinus = {
  prefix: 'fass',
  iconName: 'comment-minus',
  icon: [512, 512, [], "f4b1", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM169.6 216l-24 0 0 48 220.8 0 0-48-196.8 0z"]
};
var faSquareF = {
  prefix: 'fass',
  iconName: 'square-f',
  icon: [448, 512, [], "e270", "M448 32l-448 0 0 448 448 0 0-448zM168 144l136 0 0 48-112 0 0 48 96 0 0 48-96 0 0 80-48 0 0-224 24 0z"]
};
var faChessQueenPiece = {
  prefix: 'fass',
  iconName: 'chess-queen-piece',
  icon: [320, 512, ["chess-queen-alt"], "f446", "M160 22c14.9 0 27-12.1 27-27s-12.1-27-27-27-27 12.1-27 27 12.1 27 27 27zM64 64l-64-16 0 32 72.7 120-24.7 0 0 48 29.6 0-13.6 136-64 80 0 48 320 0 0-48-64-80-13.6-136 29.6 0 0-48-24.7 0 72.7-120 0-32-64 16-48-32-48 32-48-32-48 32z"]
};
var faChessQueenAlt = faChessQueenPiece;
var faTurnLeftDown = {
  prefix: 'fass',
  iconName: 'turn-left-down',
  icon: [384, 512, [], "e637", "M192 512l192-192-128 0 0-192 128 0 0-128-256 0 0 320-128 0 192 192z"]
};
var faLink = {
  prefix: 'fass',
  iconName: 'link',
  icon: [576, 512, [128279, "chain"], "f0c1", "M372.7 108.7c14.1-8.3 30.2-12.7 46.8-12.7 51.1 0 92.5 41.4 92.5 92.5 0 24.5-9.7 48-27.1 65.4l-71.1 71.1c-17.3 17.3-40.9 27.1-65.4 27.1-54.6 0-92.7-45.4-92.4-103.9l.1-24.1-64 0-.1 23.9c-.4 84.9 57.9 168.1 156.4 168.1 41.5 0 81.3-16.5 110.6-45.8l71.1-71.1c29.3-29.3 45.8-69.1 45.8-110.6 0-86.4-70-156.5-156.5-156.5-37.3 0-73.1 13.3-101.3 37.2 20.3 10.1 38.7 23.5 54.5 39.5zM162.2 187.1c17.3-17.3 40.9-27.1 65.4-27.1 54.4 0 92.6 45.5 92.4 103.9l-.1 24.1 64 0 .1-23.9c.3-84.7-58.2-168.1-156.4-168.1-41.5 0-81.3 16.5-110.6 45.8L45.8 212.9c-29.3 29.3-45.8 69.1-45.8 110.6 0 86.4 70 156.5 156.5 156.5 37.2 0 73.1-13.3 101.3-37.2-20.3-10.1-38.8-23.5-54.6-39.5-14 8.2-30.1 12.6-46.7 12.6-51.1 0-92.5-41.4-92.5-92.5 0-24.5 9.7-48 27.1-65.4l71.1-71.1z"]
};
var faChain = faLink;
var faChartLineDown = {
  prefix: 'fass',
  iconName: 'chart-line-down',
  icon: [512, 512, [128201], "f64d", "M64 32l0 384 448 0 0 64-512 0 0-448 64 0zM414.6 209.4l65.4-65.4 0 176-176 0 65.4-65.4-65.4-65.4c-57.4 57.4-89.4 89.4-96 96-8.2-8.2-37.1-37.1-86.6-86.6L98.7 176 144 130.7c12 12 33.3 33.3 64 64 57.4-57.4 89.4-89.4 96-96 4.2 4.2 41.1 41.1 110.6 110.6z"]
};
var faBackwardStep = {
  prefix: 'fass',
  iconName: 'backward-step',
  icon: [384, 512, ["step-backward"], "f048", "M64 296l0 184-64 0 0-448 64 0 0 184 320-200 0 480-320-200z"]
};
var faStepBackward = faBackwardStep;
var faClockOne = {
  prefix: 'fass',
  iconName: 'clock-one',
  icon: [512, 512, [], "e34e", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392l0 56.7c14.5-21.7 25.6-38.4 33.3-50l39.9 26.6-13.3 20-64 96-44-13.3 0-160 48 0 0 24z"]
};
var faDiceD4 = {
  prefix: 'fass',
  iconName: 'dice-d4',
  icon: [576, 512, [], "f6d0", "M576 320L288 544 0 320 288-32 576 320zM268 93.5l0 353.8 20 15.6 20-15.6 0-353.8-20-24.4-20 24.4z"]
};
var faX = {
  prefix: 'fass',
  iconName: 'x',
  icon: [384, 512, [120], "58", "M306.3 32l77.5 0-1.4 2-151.5 222 151.5 222 1.4 2-77.5 0-114.2-167.2-114.2 167.2-77.5 0 1.4-2 151.5-222-151.5-222-1.4-2 77.5 0 114.2 167.2 114.2-167.2z"]
};
var faCircleUser = {
  prefix: 'fass',
  iconName: 'circle-user',
  icon: [512, 512, [62142, "user-circle"], "f2bd", "M391.9 391.6l-23.9-71.6-224 0-23.9 71.6C154.9 426.5 202.9 448 256 448s101.1-21.5 135.9-56.4zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
};
var faUserCircle = faCircleUser;
var faRectangleList = {
  prefix: 'fass',
  iconName: 'rectangle-list',
  icon: [512, 512, ["list-alt"], "f022", "M512 64l-512 0 0 384 512 0 0-384zM160 320a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm120-56l168 0 0 48-192 0 0-48 24 0zm0 128l168 0 0 48-192 0 0-48 24 0z"]
};
var faListAlt = faRectangleList;
var faCircleWifi = {
  prefix: 'fass',
  iconName: 'circle-wifi',
  icon: [512, 512, [], "e67d", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM399.5 256.5C364.4 216.9 313.1 192 256 192s-108.4 24.9-143.5 64.5l-34-34C122.4 174.3 185.7 144 256 144s133.6 30.3 177.5 78.5l-34 34zm-36.1 36.1l-34.4 34.4C313.3 303.4 286.4 288 256 288s-57.3 15.4-73.1 38.9l-34.4-34.4c24.9-32 63.7-52.6 107.4-52.6s82.5 20.6 107.4 52.6zM224 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faHand = {
  prefix: 'fass',
  iconName: 'hand',
  icon: [512, 512, [129306, 9995, "hand-paper"], "f256", "M288.2 32l0-32-64 0 0 256-32 0 0-224-64 0 0 304c0 1.5 0 3.1 .1 4.6-31.5-30-55.7-53-72.6-69.1L.5 329.4c8.2 7.8 49.7 47.4 124.5 118.6 43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-240-64 0 0 160-32 0 0-224-64 0 0 224-32 0 0-224z"]
};
var faHandPaper = faHand;
var faLassoSparkles = {
  prefix: 'fass',
  iconName: 'lasso-sparkles',
  icon: [640, 512, [], "e1c9", "M368-40L341.3 21.3 280 48 341.3 74.7 368 136 394.7 74.7 456 48 394.7 21.3 368-40zM184.3 58.7c-16.5 7.1-31.7 15.4-45.3 24.8-46.4 31.9-75 75.9-75 124.5s28.6 92.6 75 124.4c5.5 3.8 11.2 7.4 17.1 10.8l49.1 30.7c11.7 7.3 18.8 20.2 18.8 34 0 22.1-17.9 40.1-40.1 40.1l-5.6 0c-7.1 0-14.1-1.7-20.4-4.8-34.9-17.5-60.3-30.2-76.2-38.1L53.1 462.3c15.9 8 41.3 20.7 76.2 38.1 15.2 7.6 32 11.6 49 11.6l5.6 0c57.5 0 104.1-46.6 104.1-104.1 0-8.7-1.1-17.3-3.2-25.6 11.5 1.1 23.2 1.7 35.2 1.7 141.3 0 256.1-78.9 256-176 0-48.5-28.6-92.6-75-124.5-.8-.6-1.7-1.1-2.5-1.7-12.2 5.3-34.6 15-67.4 29.3l-2.5 5.7c13.4 5.7 25.5 12.2 36.1 19.5 34.6 23.8 47.2 50.2 47.2 71.7s-12.7 47.9-47.2 71.7c-34.4 23.6-85.4 40.3-144.8 40.3-52 0-97.5-12.7-131.1-31.8l-14.2-8.9c-34.2-23.7-46.7-49.9-46.7-71.3 0-21.5 12.7-47.9 47.2-71.7 25.7-17.7 60.8-31.5 101.7-37.3-.6-.3-31.5-13.7-92.6-40.3zm317 378.6L440 464 501.3 490.7 528 552 554.7 490.7 616 464 554.7 437.3 528 376 501.3 437.3z"]
};
var faArrowUpFromSquare = {
  prefix: 'fass',
  iconName: 'arrow-up-from-square',
  icon: [448, 512, [], "e09c", "M256 288l0-210.7 32 32 45.3-45.3c-8.2-8.2-37.1-37.1-86.6-86.6L224-45.3c-8.2 8.2-37.1 37.1-86.6 86.6L114.7 64 160 109.3c17.3-17.3 28-28 32-32l0 242.7 64 0 0-32zM32 128l-32 0 0 384 448 0 0-384-128 0 0 64 64 0 0 256-320 0 0-256 64 0 0-64-96 0z"]
};
var faCircleR = {
  prefix: 'fass',
  iconName: 'circle-r',
  icon: [512, 512, [], "e120", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 144l104 0c39.8 0 72 32.2 72 72 0 29.5-17.7 54.8-43.1 66l40.2 74.7 6.1 11.4-54.5 0-43.1-80-33.7 0 0 80-48 0 0-224zM318 400l1.2 0-.9 .5-.3-.5zM224 240l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0 48z"]
};
var faPolishZlotySign = {
  prefix: 'fass',
  iconName: 'polish-zloty-sign',
  icon: [448, 512, [], "e70b", "M384.1 32l0 162.4c15.9-6 31.2-11.7 46-17.3L447 222c-12 4.5-33 12.4-62.9 23.6l0 234.4-64 0 0-210.4c-15.9 6-31.2 11.7-46 17.3L257.2 242c12-4.5 33-12.4 62.9-23.6l0-186.4 64 0zM32.1 192l199.1 0c-6 10.5-48.7 85.2-128 224l120.9 0 0 64-231.1 0c6-10.5 48.7-85.2 128-224l-120.9 0 0-64 32 0z"]
};
var faPhoneConnection = {
  prefix: 'fass',
  iconName: 'phone-connection',
  icon: [640, 512, [], "e6e1", "M591.5 81l-96-96 33.9-33.9 96 96-33.9 33.9zM64.4 64l128-64 96.8 128-80.8 80c33 70.4 89.6 127 160 160l80-80.8 128 96.8-64 128-16 0c-238.6 0-432-193.4-432-432l0-16zm303.1 49l33.9-33.9 96 96-33.9 33.9-96-96zm93-33a36 36 0 1 1 72 0 36 36 0 1 1 -72 0zm-92 92a36 36 0 1 1 0 72 36 36 0 1 1 0-72z"]
};
var faSnooze = {
  prefix: 'fass',
  iconName: 'snooze',
  icon: [448, 512, [128164, "zzz"], "f880", "M192 0l-32 0 0 64 65.3 0-57.6 67.2-7.7 9 0 51.8 160 0 0-64-65.3 0 57.6-67.2 7.7-9 0-51.8-128 0zM320 224l-32 0 0 64 65.3 0-57.6 67.2-7.7 9 0 51.8 160 0 0-64-65.3 0 57.6-67.2 7.7-9 0-51.8-128 0zM32 256l-32 0 0 64 130.7 0-121.4 121.4-9.4 9.4 0 61.3 224 0 0-64-130.7 0 121.4-121.4 9.4-9.4 0-61.3-192 0z"]
};
var faZzz = faSnooze;
var faUserDoctorHairMullet = {
  prefix: 'fass',
  iconName: 'user-doctor-hair-mullet',
  icon: [448, 512, [], "e7ad", "M144 144l0-32 64 0 16-48 16 48 64 0 0 32c0 44.2-35.8 80-80 80s-80-35.8-80-80zm208 0l0-32 16 0 0-48-26.8 0C323.2 26.2 284.7 0 240 0L208 0c-44.7 0-83.2 26.2-101.2 64l-26.8 0 0 48 16 0 0 32c0 25.1 7.3 48.6 19.8 68.4L80 272 368 272 332.2 212.4C344.7 192.6 352 169.1 352 144zM284 367.4l0-47.4-120 0 0 68.4c16.5 7.6 28 24.3 28 43.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-19.4 11.5-36.1 28-43.6l0-68.4-44 0-64 192 416 0-64-192-44 0 0 47.4c23.3 8.2 40 30.5 40 56.6l0 52-40 0 0-52c0-11-9-20-20-20s-20 9-20 20l0 52-40 0 0-52c0-26.1 16.7-48.3 40-56.6z"]
};
var faPanFrying = {
  prefix: 'fass',
  iconName: 'pan-frying',
  icon: [576, 512, [127859], "e42c", "M448 224c0 33.4-7.3 65.1-20.4 93.6L567.9 408.2 487.2 512 364.8 398.3C326.3 429.4 277.3 448 224 448 100.3 448 0 347.7 0 224S100.3 0 224 0 448 100.3 448 224zM319.9 154c-21.2-5.4-50.6-22.6-65.8-38.4-24.5-25.5-65-26.3-90.5-1.8-11.6 11.2-18.1 25.6-19.4 40.5-2.2 24.7-9.2 56.2-21.5 77.6-22.1 38.3-9 87.2 29.3 109.3s87.2 9 109.3-29.3c9.4-16.3 33-30 51.6-32.6 10.2-1.4 20.3-5.4 29.2-12 28.4-21.1 34.3-61.1 13.3-89.5-9.1-12.3-21.8-20.4-35.5-23.9zM504 424a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faVanShuttle = {
  prefix: 'fass',
  iconName: 'van-shuttle',
  icon: [576, 512, [128656, "shuttle-van"], "f5b6", "M32 64l-32 0 0 336 64.4 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l104.7 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l56.4 0 0-186.7-6.4-8.5-96-128-9.6-12.8-432 0zM504 224l-120 0 0-96 48 0 72 96zM64 224l0-96 96 0 0 96-96 0zm160 0l0-96 96 0 0 96-96 0zM392 392a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM152 352a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faShuttleVan = faVanShuttle;
var faStairs = {
  prefix: 'fass',
  iconName: 'stairs',
  icon: [576, 512, [], "e289", "M384 32l192 0 0 64-128 0 0 128-128 0 0 128-128 0 0 128-192 0 0-64 128 0 0-128 128 0 0-128 128 0 0-128z"]
};
var faShuttlecock = {
  prefix: 'fass',
  iconName: 'shuttlecock',
  icon: [512, 512, [], "f45b", "M262.9 424.3l-33.2 29.2C181.7 495.4 109.5 493 64.5 448S17.1 330.8 59 282.8l29.1-33.3 174.8 174.8zM288.5 64l-64 160 112-144 80 16 16 80-144 112 160-64 64 32 0 32-207.4 110.6-191.2-191.2 110.7-207.4 32 0 32 64z"]
};
var faCoinVertical = {
  prefix: 'fass',
  iconName: 'coin-vertical',
  icon: [384, 512, [], "e3fd", "M240 512l-96 0C64.5 512 0 397.4 0 256S64.5 0 144 0l96 0c29.1 0 55.9 19.4 77.3 52L231 52c8.7 11.7 16.6 25.1 23.6 40l83.7 0c9.8 23.5 17.5 50.5 22.7 80l-80.9 0c2.5 12.9 4.5 26.3 5.8 40l80.2 0c1.2 14.3 1.9 29 1.9 44s-.6 29.7-1.9 44l-80.2 0c-1.3 13.7-3.3 27.1-5.8 40l80.9 0c-5.1 29.5-12.9 56.5-22.7 80l-83.7 0c-7 14.9-14.9 28.3-23.6 40l86.3 0c-21.5 32.6-48.3 52-77.3 52zm-96-64c53 0 96-86 96-192s-43-192-96-192-96 86-96 192 43 192 96 192zm0-48c-35.3 0-64-64.5-64-144s28.7-144 64-144 64 64.5 64 144-28.7 144-64 144z"]
};
var faCircleTurkishLira = {
  prefix: 'fass',
  iconName: 'circle-turkish-lira',
  icon: [512, 512, [], "e739", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM240 128l0 68.5c46.6-15.5 71.3-23.8 74.1-24.7l10.1 30.4c-1.1 .4-29.2 9.7-84.2 28.1l0 30.3c46.6-15.5 71.3-23.8 74.1-24.7l10.1 30.4c-1.1 .4-29.2 9.7-84.2 28.1l0 41.8 48 0c26.5 0 48-21.5 48-48l0-24 48 0 0 24c0 53-43 96-96 96l-96 0 0-73.8c-19.9 6.6-34 11.3-42.1 14l-10.1-30.4c6.5-2.2 23.9-8 52.2-17.4l0-30.3c-19.9 6.6-34 11.3-42.1 14l-10.1-30.4c6.5-2.2 23.9-8 52.2-17.4l0-84.5 48 0z"]
};
var faSheep = {
  prefix: 'fass',
  iconName: 'sheep',
  icon: [640, 512, [128017], "f711", "M576 135.8c8.4 3.6 20.6 8.8 36.6 15.7l18.9-44.1c-9.2-3.9-34.9-15-77.2-33.1L512 32 448 32 405.7 74.3c-42.3 18.1-68 29.2-77.2 33.1l18.9 44.1c16-6.8 28.2-12.1 36.6-15.7l0 152.2 192 0 0-152.2zM464 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM286.5 90.6l15.8-6.8c-11.7-12.2-28.1-19.8-46.3-19.8-19.2 0-36.5 8.5-48.2 21.9-10.9-8.7-24.8-13.9-39.8-13.9-30.1 0-55.3 20.8-62.2 48.8-3.2-.5-6.5-.8-9.8-.8-35.3 0-64 28.7-64 64 0 5.3 .7 10.5 1.9 15.5-20.2 10.8-33.9 32-33.9 56.5s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64 .5 0 1 0 1.5 0l22.5 120 88 0 0-85.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7l0 85.7 88 0 22.5-120c.5 0 1 0 1.5 0 35.3 0 64-28.7 64-64 0-2.7-.2-5.4-.5-8l-127.5 0 0-135.6-21.4 9.2-44.1-102.9z"]
};
var faHorseHead = {
  prefix: 'fass',
  iconName: 'horse-head',
  icon: [512, 512, [], "f7ab", "M0 512L0 319.2c0-109.5 69.7-207 173.4-242.3l178.6-60.9 32 48-48 32 104 64 72 192-64 64-80 0-58.6-70.4c-11.6 4.1-24.1 6.4-37.1 6.4l-.2 0c-6.3 0-12.5-.5-18.6-1.5-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2l-8-13.8-27.7 16 8 13.8c24 41.5 68.3 70 119.3 71.9L352 512 0 512zM328 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleCalendar = {
  prefix: 'fass',
  iconName: 'circle-calendar',
  icon: [512, 512, ["calendar-circle"], "e102", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM224 112l0 32 64 0 0-32 40 0 0 32 56 0 0 64-256 0 0-64 56 0 0-32 40 0zM128 384l0-128 256 0 0 128-256 0z"]
};
var faCalendarCircle = faCircleCalendar;
var faVault = {
  prefix: 'fass',
  iconName: 'vault',
  icon: [512, 512, [], "e2c5", "M512 32l-512 0 0 448 64 0 0 32 64 0 0-32 256 0 0 32 64 0 0-32 64 0 0-448zM192 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM424 249.6l0 102.4-48 0 0-102.4c-14.3-8.3-24-23.8-24-41.6 0-26.5 21.5-48 48-48s48 21.5 48 48c0 17.8-9.7 33.3-24 41.6z"]
};
var faClosedCaptioningSlash = {
  prefix: 'fass',
  iconName: 'closed-captioning-slash',
  icon: [576, 512, [], "e135", "M32.3-33.8C33-33.2 65.6-.6 130.2 64l414 0 0 384-30 0c36.4 36.4 57.8 57.8 64.1 64.1l-33.9 33.9-17-17-512-512-17-17 33.9-33.9zM352.1 286l0-70c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 24 48 0 0-24c0-30.9-25.1-56-56-56l-32 0c-30.9 0-56 25.1-56 56l0 22 48 48zm61.7 61.7c20.2-8.5 34.3-28.4 34.3-51.6l0-24-48 0 0 24c0 4.4-3.6 8-8 8l-22 0 43.6 43.6zM378.3 448l-346.2 0 0-346.2 98.3 98.3c-1.5 5-2.3 10.4-2.3 15.9l0 80c0 30.9 25.1 56 56 56l32 0c18.1 0 34.1-8.5 44.4-21.8L378.3 448zM176.1 245.8l48 48 0 2.2c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-50.2z"]
};
var faDrumSteelpan = {
  prefix: 'fass',
  iconName: 'drum-steelpan',
  icon: [576, 512, [], "f56a", "M473 209.8c-22.2 9.4-49.7 17-81 22.2L353.9 176 411.2 91.7c23.4 4.9 44.2 11.2 61.7 18.6 47.1 19.9 55 39.9 55 49.8s-8 29.9-55 49.8zM340.7 238.1c-16.9 1.3-34.5 1.9-52.7 1.9s-35.8-.7-52.7-1.9l14.6-46.1 76.2 0 14.6 46.1zm-156.6-6.1c-31.4-5.2-58.8-12.8-81-22.2-47.1-19.9-55-39.9-55-49.8s8-29.9 55-49.8c17.5-7.4 38.3-13.7 61.7-18.6l57.4 84.3-38 55.9zM225.5 82.8C245.3 81 266.2 80 288 80s42.7 1 62.5 2.8l-24.4 77.2-76.2 0-24.4-77.2zM576 160C576 80 447.1 32 288 32S0 80 0 160L0 352c0 80 128.9 128 288 128s288-48 288-128l0-192z"]
};
var faThumbsUp = {
  prefix: 'fass',
  iconName: 'thumbs-up',
  icon: [512, 512, [128077, 61575], "f164", "M160 160l80-144 96 48-48 96 208 0 0 112-16 0 0 80-16 0 0 64-32 0 0 64-176 0-96-64 0-256zm-48 0l0 320-112 0 0-320 112 0z"]
};
var faEngine = {
  prefix: 'fass',
  iconName: 'engine',
  icon: [576, 512, [], "e16e", "M376 80l24 0 0-48-224 0 0 48 88 0 0 48-168 0 0 104-32 0 0-104-48 0 0 256 48 0 0-104 32 0 0 104 85.3 0 42.7 64 224 0 0-320-136 0 0-48 64 0zm120 80l0 256 48 0 0-256-48 0zM328 240l-136 0 0-48 160 0 0 48-24 0z"]
};
var faUserAlien = {
  prefix: 'fass',
  iconName: 'user-alien',
  icon: [448, 512, [], "e04a", "M64 167C64 74.8 135.6 0 224 0S384 74.8 384 167l0 89-160 128-160-128 0-89zm80 9l-32 0 0 16c0 35.3 28.7 64 64 64l32 0 0-16c0-35.3-28.7-64-64-64zm96 64l0 16 32 0c35.3 0 64-28.7 64-64l0-16-32 0c-35.3 0-64 28.7-64 64zM80 352l27.2 0c67.4 53.9 106.3 85.1 116.8 93.5 10.5-8.4 49.5-39.6 116.8-93.5l27.2 0 64 160-416 0 64-160z"]
};
var faRectangleHistory = {
  prefix: 'fass',
  iconName: 'rectangle-history',
  icon: [512, 512, [], "e4a2", "M512 480l0-272-512 0 0 272 512 0zM464 104l-416 0 0 48 416 0 0-48zM416 0l-320 0 0 48 320 0 0-48z"]
};
var faRectangleMinus = {
  prefix: 'fass',
  iconName: 'rectangle-minus',
  icon: [512, 512, [], "e6b4", "M512 64l-512 0 0 384 512 0 0-384zM168 232l200 0 0 48-224 0 0-48 24 0z"]
};
var faStamp = {
  prefix: 'fass',
  iconName: 'stamp',
  icon: [512, 512, [], "f5bf", "M320 167.6c19.6-17.6 32-43.1 32-71.6 0-53-43-96-96-96s-96 43-96 96c0 28.4 12.4 54 32 71.6l0 88.4-80 0C50.1 256 0 306.1 0 368l0 48 512 0 0-48c0-61.9-50.1-112-112-112l-80 0 0-88.4zM56 464l-24 0 0 48 448 0 0-48-424 0z"]
};
var faTripleChevronsUp = {
  prefix: 'fass',
  iconName: 'triple-chevrons-up',
  icon: [384, 512, [], "e7fa", "M365.5 512l-45.3 45.3-128-128-128 128-45.3-45.3 173.2-173.2 173.3 173.2zm0-192l-45.3 45.3-128-128-128 128-45.3-45.3 173.2-173.2 173.3 173.2zm0-192l-45.3 45.3-128-128-128 128-45.3-45.3 173.2-173.2 173.3 173.2z"]
};
var faMenorah = {
  prefix: 'fass',
  iconName: 'menorah',
  icon: [640, 512, [], "f676", "M32 0L59.8 48.7C62.6 53.5 64 58.9 64 64.4 64 81.8 49.8 96 32.4 96l-.8 0C14.2 96 0 81.8 0 64.4 0 58.9 1.4 53.5 4.2 48.7L32 0zm96 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7L128 0zm68.2 48.7L224 0 251.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7zM320 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7L320 0zm68.2 48.7L416 0 443.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7zM512 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7L512 0zm68.2 48.7L608 0 635.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7 0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6 0-5.5 1.4-10.9 4.2-15.7zM64 128l0 192 224 0 0-192 64 0 0 192 224 0 0-192 64 0 0 256-288 0 0 64 160 0 0 64-384 0 0-64 160 0 0-64-288 0 0-256 64 0zm96 0l0 160-64 0 0-160 64 0zm96 0l0 160-64 0 0-160 64 0zm192 0l0 160-64 0 0-160 64 0zm96 0l0 160-64 0 0-160 64 0z"]
};
var faTurnLeft = {
  prefix: 'fass',
  iconName: 'turn-left',
  icon: [512, 512, [], "e636", "M0 256l192 192 0-128 192 0 0 128 128 0 0-256-320 0 0-128-192 192z"]
};
var faSquareWon = {
  prefix: 'fass',
  iconName: 'square-won',
  icon: [448, 512, [], "e709", "M448 32l-448 0 0 448 448 0 0-448zM200.1 128l47.7 0 4.1 18.8 20.5 93.2 18.7 0c23.8-69.4 36.4-106.2 37.9-110.5l45.4 15.6c-2.4 6.9-13.2 38.5-32.5 94.9l26.1 0 0 32-37 0-32.8 95.8-5.6 16.2-37.6 0-4.1-18.8-20.5-93.1-12.7 0c-16.4 74.5-24.6 111.8-24.6 112l-37.6 0-5.6-16.2-32.8-95.8-37 0 0-32 26.1 0c-19.3-56.4-30.2-88-32.5-94.9l45.4-15.6c1.5 4.3 14.1 41.1 37.9 110.5l18.7 0c16.4-74.5 24.6-111.8 24.6-112z"]
};
var faMalaysianRinggitSign = {
  prefix: 'fass',
  iconName: 'malaysian-ringgit-sign',
  icon: [576, 512, [], "e6fa", "M288 96l0-32 49.6 0 9.4 14.8 85 133.6 85-133.6 9.4-14.8 49.6 0 0 384-64 0 0-242.1c-39.7 62.3-66.3 104.2-80 125.7-13.7-21.5-40.3-63.4-80-125.7l0 242.1-64 0 0-352zM0 64l128 0c70.7 0 128 57.3 128 128 0 50.2-28.8 93.6-70.9 114.6 28.8 76.8 44.8 119.6 48.1 128.2l-59.9 22.5c-2.7-7.1-19.8-52.8-51.4-137.2L64 320 64 448 0 448 0 64zM64 256l64 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-64 0 0 128z"]
};
var faPresentationScreen = {
  prefix: 'fass',
  iconName: 'presentation-screen',
  icon: [512, 512, ["presentation"], "f685", "M24 32l488 0 0 48-512 0 0-48 24 0zM232 384l-200 0 0-256 448 0 0 256-200 0 0 35.5c54.9 38.4 84.7 59.3 89.4 62.6l-27.5 39.3c-5.3-3.7-34-23.8-85.9-60.1-51.9 36.3-80.6 56.4-85.9 60.1l-27.5-39.3c4.8-3.3 34.6-24.2 89.4-62.6l0-35.5z"]
};
var faPresentation = faPresentationScreen;
var faCameraMovie = {
  prefix: 'fass',
  iconName: 'camera-movie',
  icon: [576, 512, [127909, 127910], "f8a9", "M128 240C57.3 240 0 182.7 0 112S57.3-16 128-16c48.2 0 90.2 26.6 112 66 21.8-39.4 63.8-66 112-66 70.7 0 128 57.3 128 128S422.7 240 352 240l-224 0zm224-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM176 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 437.3l0-170.7 112-74.7 0 320-112-74.7zM64 288l352 0 0 208-352 0 0-208z"]
};
var faSquareCurrency = {
  prefix: 'fass',
  iconName: 'square-currency',
  icon: [448, 512, [], "e70c", "M448 32l-448 0 0 448 448 0 0-448zM136 134.1c10.4 10.4 23.5 23.5 39.2 39.2 14.3-8.4 31-13.3 48.8-13.3s34.5 4.8 48.8 13.3c15.7-15.7 28.8-28.8 39.2-39.2L345.9 168c-10.4 10.4-23.5 23.5-39.2 39.2 8.4 14.3 13.3 31 13.3 48.8s-4.8 34.5-13.3 48.8c15.7 15.7 28.8 28.8 39.2 39.2L312 377.9c-10.4-10.4-23.5-23.5-39.2-39.2-14.3 8.4-31 13.3-48.8 13.3s-34.5-4.8-48.8-13.3c-15.7 15.7-28.8 28.8-39.2 39.2L102.1 344c10.4-10.4 23.5-23.5 39.2-39.2-8.4-14.3-13.3-31-13.3-48.8s4.8-34.5 13.3-48.8c-15.7-15.7-28.8-28.8-39.2-39.2L136 134.1zm54.2 87.9l-.2 .2c-8.6 8.7-13.9 20.6-13.9 33.8s5.3 25.2 13.9 33.8c0-67.7 0-67.6 .2 .2 8.7 8.6 20.6 13.9 33.8 13.9s25.2-5.3 33.8-13.9l.2-.2c8.6-8.7 13.9-20.6 13.9-33.8s-5.3-25.2-13.9-33.8l-.2-.2c-8.7-8.6-20.6-13.9-33.8-13.9s-25.2 5.3-33.8 13.9z"]
};
var faHatChef = {
  prefix: 'fass',
  iconName: 'hat-chef',
  icon: [512, 512, [], "f86b", "M448 384l-384 0 0 128 384 0 0-128zm0-48l0-90.8c37.8-18 64-56.5 64-101.2 0-61.9-50.1-112-112-112-17.3 0-33.7 3.9-48.3 10.9-23.4-26.3-57.6-42.9-95.7-42.9s-72.2 16.6-95.7 42.9C145.7 35.9 129.3 32 112 32 50.1 32 0 82.1 0 144 0 188.7 26.2 227.2 64 245.2l0 90.8 64 0 0-144 48 0 0 144 56 0 0-144 48 0 0 144 56 0 0-144 48 0 0 144 64 0z"]
};
var faChildren = {
  prefix: 'fass',
  iconName: 'children',
  icon: [640, 512, [], "e4e1", "M160.2 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-41.5 32l-16.2 0-9.6 13.1C37.4 248.8 7.5 289.4 3.5 294.9l51.6 37.9c13.6-18.5 24.3-33.1 32.3-44l-31.1 111.2 32 0 0 112 64 0 0-112 16 0 0 112 64 0 0-112 32 0-31.1-111.2c8 10.9 18.7 25.5 32.3 44L317 294.9c-4-5.5-33.9-46.1-89.4-121.8l-9.6-13.1-99.2 0zm361.5-32a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-41.5 32l-16.2 0-9.6 13.1c-55.6 75.7-85.4 116.3-89.4 121.8l51.6 37.9c13.4-18.3 24.5-33.3 33.2-45.1l0 224.4 64 0 0-128 16 0 0 128 64 0 0-224.4c8.7 11.8 19.7 26.9 33.1 45.1L637 294.9c-4-5.5-33.9-46.1-89.4-121.8l-9.6-13.1-99.2 0z"]
};
var faSnowBlowing = {
  prefix: 'fass',
  iconName: 'snow-blowing',
  icon: [640, 512, [], "f761", "M512 48l32 0c53 0 96 43 96 96s-43 96-96 96l-160 0 0-64 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64 32 0zM200 64l0 49.4c8.7-8.7 16.7-16.7 24-24L246.6 112c-3.5 3.5-19.1 19.1-46.6 46.6l0 55.8 48.3-27.9c10.1-37.6 15.8-58.9 17.1-63.7l30.9 8.3c-2.7 10-5.6 20.9-8.8 32.8 9.1-5.2 21-12.1 35.8-20.7l24 41.6c-14.8 8.6-26.8 15.4-35.8 20.7 11.9 3.2 22.8 6.1 32.8 8.8L336 245.2c-4.8-1.3-26.1-7-63.7-17.1L224 256 272.3 283.9c37.6-10.1 58.9-15.8 63.7-17.1l8.3 30.9c-10 2.7-20.9 5.6-32.8 8.8 9.1 5.2 21 12.1 35.8 20.7l-24 41.6c-14.8-8.6-26.8-15.4-35.8-20.7 3.2 11.9 6.1 22.8 8.8 32.8l-30.9 8.3c-1.3-4.8-7-26.1-17.1-63.7l-48.3-27.9 0 55.8c27.5 27.5 43.1 43.1 46.6 46.6L224 422.6c-7.3-7.3-15.3-15.3-24-24l0 49.4-48 0 0-49.4c-8.7 8.7-16.7 16.7-24 24L105.4 400c3.5-3.5 19.1-19.1 46.6-46.6l0-55.8-48.3 27.9c-10.1 37.6-15.8 58.9-17.1 63.7l-30.9-8.3c2.7-10 5.6-20.9 8.8-32.8-9.1 5.2-21 12.1-35.8 20.7l-24-41.6c14.8-8.6 26.8-15.4 35.8-20.7-11.9-3.2-22.8-6.1-32.8-8.8L16 266.8c4.8 1.3 26.1 7 63.7 17.1L128 256 79.7 228.1C42 238.2 20.8 243.9 16 245.2L7.7 214.3c10-2.7 20.9-5.6 32.8-8.8-9.1-5.2-21-12.1-35.8-20.7l24-41.6c14.8 8.6 26.8 15.4 35.8 20.7-3.2-11.9-6.1-22.8-8.8-32.8l30.9-8.3c1.3 4.8 7 26.1 17.1 63.7l48.3 27.9 0-55.8c-27.5-27.5-43.1-43.1-46.6-46.6L128 89.4c7.3 7.3 15.3 15.3 24 24l0-49.4 48 0zM480 464l0-64 56 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-152 0 0-64 152 0c53 0 96 43 96 96s-43 96-96 96l-56 0z"]
};
var faAlbumCollection = {
  prefix: 'fass',
  iconName: 'album-collection',
  icon: [512, 512, [], "f8a0", "M128.3 0l0 48 256 0 0-48-256 0zm-64 192L9 192c1.2 8.3 14.5 101.3 39.8 278.8l5.9 41.2 403.3 0 5.9-41.2c25.4-177.6 38.6-270.5 39.8-278.8L64.3 192zm352 160c0 61.9-71.6 112-160 112s-160-50.1-160-112 71.6-112 160-112 160 50.1 160 112zm-160 28c22.1 0 40-12.5 40-28s-17.9-28-40-28-40 12.5-40 28 17.9 28 40 28zM104.3 96l-24 0 0 48 352 0 0-48-328 0z"]
};
var faChartLine = {
  prefix: 'fass',
  iconName: 'chart-line',
  icon: [512, 512, ["line-chart"], "f201", "M64 64l0-32-64 0 0 448 512 0 0-64-448 0 0-352zm406.6 86.6L493.3 128 448 82.7c-1.3 1.3-44 44-128 128-44-44-70.7-70.7-80-80-2.9 2.9-42.4 42.4-118.6 118.6L98.7 272 144 317.3c6.6-6.6 38.6-38.6 96-96 44 44 70.7 70.7 80 80l22.6-22.6 128-128z"]
};
var faLineChart = faChartLine;
var faCircleUpLeft = {
  prefix: 'fass',
  iconName: 'circle-up-left',
  icon: [512, 512, [], "e128", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM184 160l169.9 0c-29.6 29.6-52.3 52.3-68 68 53 53 81 81 84 84-24.3 24.3-54.1 54.1-57.9 57.9-3-3-31-31-84-84-15.7 15.7-38.4 38.4-68 68l0-193.9 24 0z"]
};
var faEnvelopeRibbon = {
  prefix: 'fass',
  iconName: 'envelope-ribbon',
  icon: [640, 512, ["envelope-certificate"], "e829", "M512 160c70.7 0 128 57.3 128 128 0 40.4-18.8 76.4-48 99.9l0 132.1-80-40-80 40 0-132.1c-29.2-23.5-48-59.5-48-99.9 0-70.7 57.3-128 128-128zM320 388l32.9-24.7c8 16.8 18.5 32.1 31.1 45.4l0 39.3-320 0 0-252 256 192zM512 240a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm64-115.9c-19.8-7.8-41.4-12.1-64-12.1-97.2 0-176 78.8-176 176 0 9 .7 17.8 2 26.5l-18 13.5-19.2-14.4-224-168-12.8-9.6 0-72 512 0 0 60.1z"]
};
var faEnvelopeCertificate = faEnvelopeRibbon;
var faTire = {
  prefix: 'fass',
  iconName: 'tire',
  icon: [512, 512, [], "f631", "M400 256c0-39.2-15.7-74.7-41.1-100.7L330.1 195c13.7 16.6 21.9 37.8 21.9 61 0 2-.1 4-.2 6l46.6 15.2c1-6.9 1.5-14 1.5-21.2zm-63.1 51.6c-12.9 20.2-33.2 35.2-57 41.3l0 49c45.1-7.6 83.1-36.1 103.6-75.2l-46.6-15.2zM232 349c-23.8-6.1-44-21.2-56.9-41.3l-46.6 15.2c20.5 39.1 58.5 67.6 103.6 75.2l0-49zM112 256c0 7.2 .5 14.3 1.5 21.2L160.2 262c-.1-2-.2-4-.2-6 0-23.2 8.2-44.4 21.9-61l-28.8-39.7C127.7 181.3 112 216.8 112 256zm144-96c12.5 0 24.4 2.4 35.4 6.7L320.2 127c-19.3-9.6-41.1-15-64.2-15s-44.8 5.4-64.1 15l28.8 39.7c10.9-4.3 22.9-6.7 35.4-6.7zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faAustralianDollarSign = {
  prefix: 'fass',
  iconName: 'australian-dollar-sign',
  icon: [576, 512, [], "e6fe", "M400.2 16l0 52.4c-46.2 13.5-80 56.1-80 106.7 0 53 37.4 98.6 89.3 109l32.8 6.6c22 4.4 37.9 23.8 37.9 46.2 0 26-21.1 47.1-47.1 47.1l-96.9 0 0 64 64 0 0 48 64 0 0-52.4c46.2-13.5 80-56.1 80-106.7 0-53-37.4-98.6-89.3-109l-32.8-6.6c-22-4.4-37.9-23.7-37.9-46.2 0-26 21.1-47.1 47.1-47.1l80.9 0 0-64-48 0 0-48-64 0zm-248 32l-25.2 0-5.9 24.5-98.1 407.5 65.8 0 23.1-96 96.5 0 23.1 96 65.8 0-98.1-407.5-5.9-24.5-41.2 0zm40.9 272l-65.7 0 32.9-136.5 32.9 136.5z"]
};
var faSquareEnvelope = {
  prefix: 'fass',
  iconName: 'square-envelope',
  icon: [448, 512, ["envelope-square"], "f199", "M448 32l-448 0 0 448 448 0 0-448zM96 160l256 0 0 41.3-128 74-128-74 0-41.3zM232 307.6l120-69.3 0 113.8-256 0 0-113.8 120 69.3 8 4.6 8-4.6z"]
};
var faEnvelopeSquare = faSquareEnvelope;
var faObjectExclude = {
  prefix: 'fass',
  iconName: 'object-exclude',
  icon: [512, 512, [], "e49c", "M0 0l352 0 0 160 160 0 0 352-352 0 0-160-160 0 0-352zM320 192l-128 0 0 128 128 0 0-128z"]
};
var faUserGroupCrown = {
  prefix: 'fass',
  iconName: 'user-group-crown',
  icon: [576, 512, ["users-crown"], "f6a5", "M64 53.7L64 128c0 61.9 50.1 112 112 112s112-50.1 112-112l0-128-64 32-48-48-48 48-64-32 0 53.7zM240 128c0 35.3-28.7 64-64 64s-64-28.7-64-64l128 0zM432 256a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm80 48l-169.5 0 55.7 194.8 3.8 13.2 174.1 0-64-208zM64 288l-64 224 352 0-64-224-224 0z"]
};
var faUsersCrown = faUserGroupCrown;
var faBanSmoking = {
  prefix: 'fass',
  iconName: 'ban-smoking',
  icon: [512, 512, [128685, "smoking-ban"], "f54d", "M99.5 144.8c113.9 113.9 228.2 228.2 267.8 267.8-31.4 22.4-69.8 35.5-111.2 35.5-106 0-192-86-192-192 0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32 82.7 0 0 32-50.7 0zm32 32l50.7 0 0-96-146.7 0-124.5-124.5c31.4-22.4 69.8-35.5 111.2-35.5 106 0 192 86 192 192 0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM288 96l-32 0 0 16c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16l0 16 32 0 0-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16l0-16zM229.5 320l-96-96-37.5 0 0 96 133.5 0z"]
};
var faSmokingBan = faBanSmoking;
var faUserVisor = {
  prefix: 'fass',
  iconName: 'user-visor',
  icon: [448, 512, [], "e04c", "M334 176c-18.5 42.4-60.8 72-110 72s-91.5-29.6-110-72l-34 0 0-128 54.6 0c22-24.6 53.9-40 89.4-40s67.5 15.4 89.4 40l54.6 0 0 128-34 0zm34 128l64 208-416 0 64-208 288 0zM272 472l48-28 48 28-48-96-48 96zM152 92l-20 0 0 40 184 0 0-40-164 0z"]
};
var faBarProgressHalf = {
  prefix: 'fass',
  iconName: 'bar-progress-half',
  icon: [512, 512, [], "e6a7", "M256 160l0 192 192 0 0-192-192 0zM0 96l512 0 0 320-512 0 0-320z"]
};
var faTruckFront = {
  prefix: 'fass',
  iconName: 'truck-front',
  icon: [512, 512, [], "e2b7", "M0 32l512 0 0 416-32 0 0 64-96 0 0-64-256 0 0 64-96 0 0-64-32 0 0-416zM128 160l0 96 256 0 0-96-256 0zm0 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBlindsOpen = {
  prefix: 'fass',
  iconName: 'blinds-open',
  icon: [448, 512, [], "f8fc", "M448 32l-448 0 0 64 112 0 0 256 48 0 0-256 288 0 0-64zm0 192l0-64-240 0 0 64 240 0zM64 160l-64 0 0 64 64 0 0-64zm0 144l0-16-64 0 0 64 64 0 0-48zm144-16l0 64 240 0 0-64-240 0zM0 480l448 0 0-64-448 0 0 64z"]
};
var faBuilding = {
  prefix: 'fass',
  iconName: 'building',
  icon: [384, 512, [127970, 61687], "f1ad", "M384 0L0 0 0 512 384 512 384 0zM240 352l0 112-96 0 0-112 96 0zM96 96l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM96 224l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0z"]
};
var faBullseye = {
  prefix: 'fass',
  iconName: 'bullseye',
  icon: [512, 512, [], "f140", "M448 256a192 192 0 1 0 -384 0 192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faAlbumCircleUser = {
  prefix: 'fass',
  iconName: 'album-circle-user',
  icon: [576, 512, [], "e48d", "M32 32l448 0 0 182c-15.3-3.9-31.4-6-48-6-7.8 0-15.4 .5-22.9 1.4-20-65.6-81-113.4-153.1-113.4-88.4 0-160 71.6-160 160 0 83.2 63.5 151.5 144.6 159.3 1.8 23 7.6 44.8 16.8 64.7L32 480 32 32zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32 176a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm223.5 78.9l-15.5-30.9-128 0-15.5 30.9C372.8 499.4 400.9 512 432 512s59.2-12.6 79.5-33.1zM480 368a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faArrowLeftLong = {
  prefix: 'fass',
  iconName: 'arrow-left-long',
  icon: [640, 512, ["long-arrow-left"], "f177", "M41.6 233.4l-22.6 22.6 22.6 22.6 128 128 22.6 22.6 45.3-45.3-96-96 466.7 0 0-64-466.7 0c57.4-57.4 89.4-89.4 96-96l-45.3-45.3-22.6 22.6-128 128z"]
};
var faLongArrowLeft = faArrowLeftLong;
var faSwapArrows = {
  prefix: 'fass',
  iconName: 'swap-arrows',
  icon: [640, 512, [], "e60a", "M19 128c8.2-8.2 37.1-37.1 86.6-86.6l22.6-22.6c8.2 8.2 37.1 37.1 86.6 86.6l22.6 22.6-45.3 45.3c-17.3-17.3-28-28-32-32l0 274.7 128 0 0-384 256 0 0 338.7 32-32 45.3 45.3-109.3 109.3-109.3-109.3 45.3-45.3 32 32 0-274.7-128 0 0 384-256 0 0-338.7c-4 4-14.7 14.7-32 32L19 128z"]
};
var faChessRook = {
  prefix: 'fass',
  iconName: 'chess-rook',
  icon: [384, 512, [9820], "f447", "M0 0l0 160 64 64 0 160-64 80 0 48 384 0 0-48-64-80 0-160 64-64 0-160-96 0 0 64-48 0 0-64-96 0 0 64-48 0 0-64-96 0z"]
};
var faBlenderPhone = {
  prefix: 'fass',
  iconName: 'blender-phone',
  icon: [576, 512, [], "f6b6", "M76.6-1.4l75.4 25.1-12.3 88.3-50.6-.3c-14.7 40.6-14.7 85.1 0 125.7l50.6-.3 12.3 88.3-75.4 25.1-6.3-6.3c-93.7-93.7-93.7-245.7 0-339.4l6.3-6.3zM224 336l-32-336 384 0-22.9 80-137.1 0 0 48 123.4 0-18.3 64-105.1 0 0 48 91.4 0-27.4 96-256 0zm288 48l0 128-320 0 0-128 320 0zM352 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowTurnUp = {
  prefix: 'fass',
  iconName: 'arrow-turn-up',
  icon: [384, 512, ["level-up"], "f148", "M32 448l-32 0 0 64 224 0 0-402.7c57.4 57.4 89.4 89.4 96 96l45.3-45.3-22.6-22.6-128-128-22.6-22.6-22.6 22.6-128 128-22.6 22.6 45.3 45.3c6.6-6.6 38.6-38.6 96-96l0 338.7-128 0z"]
};
var faLevelUp = faArrowTurnUp;
var faShelvesEmpty = {
  prefix: 'fass',
  iconName: 'shelves-empty',
  icon: [512, 512, [], "e246", "M64 32l0-32-64 0 0 512 64 0 0-32 384 0 0 32 64 0 0-512-64 0 0 160-384 0 0-128zm0 192l384 0 0 192-384 0 0-192z"]
};
var faNote = {
  prefix: 'fass',
  iconName: 'note',
  icon: [448, 512, [], "e1ff", "M0 480l304 0 144-144 0-304-448 0 0 448zm272-58.5L272 304 389.5 304 272 421.5zM112 112l0 48-48 0 0-48 48 0zM64 232l48 0 0 48-48 0 0-48zm48 120l0 48-48 0 0-48 48 0z"]
};
var faPenField = {
  prefix: 'fass',
  iconName: 'pen-field',
  icon: [640, 512, [], "e211", "M288 320l16-112 164.7-164.7 96 96-164.7 164.7-112 16zM587.3 116.7l-96-96 52.7-52.7 96 96-52.7 52.7zM64 96l224 0 0 64-160 0 0 256 384 0 0-160 64 0 0 224-512 0 0-384zM256 256l0 64-64 0 0-64 64 0z"]
};
var faCorn = {
  prefix: 'fass',
  iconName: 'corn',
  icon: [512, 512, [127805], "f6c7", "M512 40c0 15-8.3 28.1-20.5 34.9 7.7 7.3 12.5 17.6 12.5 29.1 0 18-11.8 33.2-28.2 38.2 2.7 5.4 4.2 11.4 4.2 17.8 0 18-11.8 33.2-28.2 38.2 2.7 5.4 4.2 11.4 4.2 17.8 0 22.1-17.9 40-40 40-1.1 0-2.3 0-3.4-.1 2.2 4.9 3.4 10.4 3.4 16.1 0 13.6-6.8 25.7-17.3 32.9-47.7-29.7-103.6-41.1-157.5-34.2 6.9-53.9-4.5-109.8-34.2-157.5 7.2-10.4 19.3-17.3 32.9-17.3 5.7 0 11.2 1.2 16.1 3.4-.1-1.1-.1-2.2-.1-3.4 0-22.1 17.9-40 40-40 6.4 0 12.4 1.5 17.8 4.2 5-16.3 20.2-28.2 38.2-28.2 6.4 0 12.4 1.5 17.8 4.2 5-16.3 20.2-28.2 38.2-28.2 11.4 0 21.8 4.8 29.1 12.5 6.8-12.2 19.9-20.5 34.9-20.5 22.1 0 40 17.9 40 40zM139.9 82.5l10.4 10.4c50.2 50.2 69.4 119.6 57.5 184.6-38.7 10.7-75.2 31.2-105.5 61.6L28.7 412.7 0 384 0 320 112 208 139.9 82.5zM51.3 435.3l73.6-73.6c28.6-28.6 63.5-47.1 100.1-55.6 67.6-15.6 141.4 3 194 55.6l10.4 10.4-125.5 27.9-112 112-64 0-76.7-76.7z"]
};
var faPianoKeyboard = {
  prefix: 'fass',
  iconName: 'piano-keyboard',
  icon: [576, 512, [127929], "f8d5", "M576 64l-576 0 0 384 576 0 0-384zM512 224l0 160-76 0 0-64 12 0 0-96 64 0zM396 384l-88 0 0-64 12 0 0-96 64 0 0 96 12 0 0 64zm-128 0l-88 0 0-64 12 0 0-96 64 0 0 96 12 0 0 64zm-128 0l-76 0 0-160 64 0 0 96 12 0 0 64z"]
};
var faFaceTongueSweat = {
  prefix: 'fass',
  iconName: 'face-tongue-sweat',
  icon: [640, 512, [], "e39e", "M429.5 487.4c86.6-41 146.5-129.3 146.5-231.4 0-141.4-114.6-256-256-256-131 0-239.1 98.5-254.2 225.4 6.1 4.8 25.8 20.5 34.6 28l.3 .3c14.4 12.5 32.3 29.7 46.8 50.2 14.3 20.1 28.4 47.7 28.4 80.1 0 25.4-8 48.6-21.7 67.2 17 14.4 35.8 26.7 56.1 36.3-1.6-7.6-2.5-15.4-2.5-23.4l0-44.9c-10.2-8-16-17.3-16-27.1 0-30.9 57.3-56 128-56s128 25.1 128 56c0 9.8-5.8 19.1-16 27.1l0 44.9c0 8-.8 15.9-2.5 23.4zM400 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM272 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-9.9-97.9l-7.4 7.4c-24.2 24.2-55.3 40.2-89 45.8l-2.5 .4-19.7 3.3-6.6-39.5 19.7-3.3 2.5-.4c25.5-4.2 49-16.4 67.3-34.6 3.8-3.8 11-11 21.5-21.5l28.3 28.3-14.1 14.1zM363.7 144L392 115.7c10.6 10.6 17.7 17.7 21.5 21.5 18.3 18.3 41.8 30.4 67.3 34.6l2.5 .4 19.7 3.3-6.6 39.5-19.7-3.3-2.5-.4c-33.7-5.6-64.8-21.6-89-45.8-3.8-3.8-11-11-21.5-21.5zM64 285.5c-4.9 4.2-9.7 8.4-14.3 12.9-10.8 10.5-28.8 29.7-40 51.3-5.6 10.7-9.6 22.5-9.6 34.3 0 36.4 27.6 64 64 64s64-27.6 64-64c0-11.8-4.1-23.6-9.6-34.3-11.2-21.6-29.2-40.8-40-51.3-4.6-4.5-9.4-8.7-14.3-12.9zM384 448l0-64-48 0 0 24-32 0 0-24-48 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faBicycle = {
  prefix: 'fass',
  iconName: 'bicycle',
  icon: [640, 512, [128690], "f206", "M313.6 32l166.4 0 0 48-89.6 0 72.2 148.4c10.7-2.9 21.9-4.4 33.4-4.4 70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128c0-42 20.2-79.2 51.4-102.6l-20.4-41.9-73.6 147.2-6.6 13.3-47.8 0c-7.9 63.1-61.7 112-127 112-70.7 0-128-57.3-128-128S73.3 224 144 224c10.8 0 21.2 1.3 31.2 3.8l28.5-56.9-11.5-26.9-64.2 0 0-48 95.8 0c2.8 6.5 9.7 22.5 20.6 48l123.7 0c-28.6-58.8-46.8-96.2-54.5-112zM228.5 228.7l-45.6 91.3 84.8 0-39.1-91.3zM305.7 287l47.5-95-88.2 0 40.7 95zm168.7 75.5l-29.7-61c-12.8 13-20.7 30.8-20.7 50.5 0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72c-2.7 0-5.5 .2-8.1 .5 23 47.3 36.4 74.8 40.2 82.6l-43.2 21-10.5-21.6zM144 368l-38.8 0c10-20.1 24.7-49.4 43.9-87.8-1.7-.1-3.4-.2-5.1-.2-39.8 0-72 32.2-72 72s32.2 72 72 72c34.3 0 62.9-23.9 70.2-56L144 368z"]
};
var faMoneySimpleFromBracket = {
  prefix: 'fass',
  iconName: 'money-simple-from-bracket',
  icon: [576, 512, [], "e313", "M24 0l552 0 0 192-48 0 0-144-480 0 0 144-48 0 0-192 24 0zM480 96l0 416-384 0 0-416 384 0zM288 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faUserTieHairLong = {
  prefix: 'fass',
  iconName: 'user-tie-hair-long',
  icon: [448, 512, [], "e460", "M304 128c0-18-6-34.6-16-48l0 0-64 48-80 0 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zm48 0l0 48 48 96-352 0 48-96 0-48C96 57.3 153.3 0 224 0S352 57.3 352 128zM272 328l-31.6 36.9 31 115.1 .6 0 40-160 56 0 64 192-416 0 64-192 56 0 40 160 31.4-115.3-31.4-36.7 0-24 96 0 0 24z"]
};
var faBadge = {
  prefix: 'fass',
  iconName: 'badge',
  icon: [512, 512, [], "f335", "M340.9 51.1C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256s20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9z"]
};
var faTruckUtensils = {
  prefix: 'fass',
  iconName: 'truck-utensils',
  icon: [576, 512, [], "e628", "M416 32L0 32 0 448 67.3 448c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l102.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l67.3 0 0-237.3-9.4-9.4-64-64-9.4-9.4-77.3 0 0-96zm96 205.3l0 50.7-96 0 0-96 50.7 0 45.3 45.3zM152 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm232 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM208 192c0 23.8-17.3 43.5-40 47.3l0 96.7-48 0 0-96.7c-22.7-3.8-40-23.6-40-47.3l0-96 32 0 0 80 16 0 0-80 32 0 0 80 16 0 0-80 32 0 0 96zM320 96l0 240-48 0 0-80-32 0 0-80c0-44.2 35.8-80 80-80z"]
};
var faFileBracketsCurly = {
  prefix: 'fass',
  iconName: 'file-brackets-curly',
  icon: [384, 512, [], "e804", "M384 144L384 512 0 512 0 0 240 0 384 144zM84 292.4c-20.5 23-33.4 37.6-38.8 43.6 5.4 6 18.3 20.5 38.8 43.6l0 64.4 72 0 0-40-32 0 0-39.6c-.8-1-9.3-10.4-25.3-28.4 16-18 24.4-27.5 25.3-28.4l0-39.6 32 0 0-40-72 0 0 64.4zM228 268l32 0 0 39.6c.8 1 9.3 10.4 25.3 28.4-16 18-24.4 27.5-25.3 28.4l0 39.6-32 0 0 40 72 0 0-64.4c20.5-23 33.4-37.5 38.7-43.6-5.4-6-18.3-20.5-38.7-43.6l0-64.4-72 0 0 40zm-20-92L325.5 176 208 58.5 208 176z"]
};
var faCircleArrowDown = {
  prefix: 'fass',
  iconName: 'circle-arrow-down',
  icon: [512, 512, ["arrow-circle-down"], "f0ab", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM239 377c-63.8-63.8-96.2-96.2-97-97L176 246.1c7.6 7.6 26.3 26.3 56 56l0-150.1 0-24 48 0 0 174.1c29.7-29.7 48.4-48.4 56-56l33.9 33.9-17 17-80 80-17 17-17-17z"]
};
var faArrowCircleDown = faCircleArrowDown;
var faPeruvianSolesSign = {
  prefix: 'fass',
  iconName: 'peruvian-soles-sign',
  icon: [512, 512, [], "e705", "M516.5 11.5l-121.2 500.5-65.8 0 2.8-11.5 121.2-500.5 65.8 0-2.8 11.5zM272.4 128l-146.9 0c-24.9 0-45.1 20.2-45.1 45.1 0 22.4 16.5 41.5 38.8 44.7l91.6 13.1c53.8 7.7 93.7 53.7 93.7 108 0 60.3-48.9 109.1-109.1 109.1l-162.9 0 0-64 162.9 0c24.9 0 45.1-20.2 45.1-45.1 0-22.4-16.5-41.5-38.8-44.7l-91.6-13.1c-53.8-7.7-93.7-53.7-93.7-108 0-60.3 48.9-109.1 109.1-109.1l146.9 0 0 64z"]
};
var faTripleChevronsLeft = {
  prefix: 'fass',
  iconName: 'triple-chevrons-left',
  icon: [640, 512, [], "e7f8", "M237.5 128L109.5 256 237.5 384 192.3 429.3 19 256 192.3 82.8 237.5 128zm192 0L301.5 256 429.5 384 384.3 429.3 211 256 384.3 82.8 429.5 128zm192 0L493.5 256 621.5 384 576.3 429.3 403 256 576.3 82.8 621.5 128z"]
};
var faGear = {
  prefix: 'fass',
  iconName: 'gear',
  icon: [512, 512, [9881, "cog"], "f013", "M200.1-16l112 0 19.7 95.5c14.1 6 27.3 13.7 39.3 22.8l92.6-30.7 56 97-72.9 64.8c.9 7.4 1.3 15 1.3 22.7s-.5 15.3-1.3 22.7l72.9 64.8-56 97-92.6-30.7c-12.1 9.1-25.3 16.7-39.3 22.8l-19.7 95.5-112 0-19.7-95.5c-14.1-6-27.2-13.7-39.3-22.8l-92.6 30.7-56-97 72.9-64.8c-.9-7.4-1.3-15-1.3-22.7s.5-15.3 1.3-22.7l-72.9-64.8 56-97 92.6 30.7c12.1-9.1 25.3-16.7 39.3-22.8L200.1-16zm56 352a80 80 0 1 0 -.1-160 80 80 0 1 0 .1 160z"]
};
var faCog = faGear;
var faFilms = {
  prefix: 'fass',
  iconName: 'films',
  icon: [576, 512, [], "e17a", "M96 32l448 0 0 384-448 0 0-384zM48 128l0 336 400 0 0 48-448 0 0-384 48 0zm96-48l0 64 64 0 0-64-64 0zm0 112l0 64 64 0 0-64-64 0zm64 112l-64 0 0 64 64 0 0-64zM432 80l0 64 64 0 0-64-64 0zm64 112l-64 0 0 64 64 0 0-64zM432 304l0 64 64 0 0-64-64 0z"]
};
var faWalker = {
  prefix: 'fass',
  iconName: 'walker',
  icon: [448, 512, [], "f831", "M119.3 0l297 0 0 392.6c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64s-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4l0-168.6-223 0-65.9 263.8-7.8 31-62.1-15.5 7.8-31 112-448 6.1-24.2zm26 160l207 0 0-96-183 0-24 96z"]
};
var faSquareArrowRight = {
  prefix: 'fass',
  iconName: 'square-arrow-right',
  icon: [448, 512, ["arrow-square-right"], "f33b", "M448 32l-448 0 0 448 448 0 0-448zM345 273l-80 80-17 17-33.9-33.9c7.6-7.6 26.3-26.3 56-56l-174.1 0 0-48 174.1 0c-29.7-29.7-48.4-48.4-56-56L248 142.1c.8 .8 33.1 33.1 97 97l17 17-17 17z"]
};
var faArrowSquareRight = faSquareArrowRight;
var faFaceParty = {
  prefix: 'fass',
  iconName: 'face-party',
  icon: [640, 512, [], "e383", "M38.1 73.1c25.7-39.5 59.5-73.3 99-99L203.5-7.5c-65.4 29-118 81.6-147 147L38.1 73.1zM257.8 7.6C277.7 2.6 298.5 0 320 0 433.4 0 529.7 73.8 563.3 176l-110.5 0c-11-12.3-27-20-44.7-20l-16 0c-33.1 0-60 26.9-60 60l0 16 40 0 0-16c0-11 9-20 20-20l16 0c11 0 20 9 20 20l0 16 36 0 0 64-69.5 0c-7.6-5.1-16.7-8-26.5-8l-48 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 48 0c9.8 0 18.9-2.9 26.5-8L498 440c-46.1 44.6-108.8 72-178 72-141.4 0-256-114.6-256-256 0-21.5 2.6-42.3 7.6-62.2 22.8-91.4 94.8-163.4 186.2-186.2zM27 33.3L0-64 97.3-37C70.8-16.8 47.2 6.8 27 33.3zM232 196l16 0c11 0 20 9 20 20l0 16 40 0 0-16c0-33.1-26.9-60-60-60l-16 0c-33.1 0-60 26.9-60 60l0 16 40 0 0-16c0-11 9-20 20-20zm280 28l128 0 0 168-216 0 0-48 168 0 0-72-32 0 0 32-48 0 0-80z"]
};
var faMarsAndVenusBurst = {
  prefix: 'fass',
  iconName: 'mars-and-venus-burst',
  icon: [640, 512, [], "e523", "M496-64l-32 0 0 64 66.7 0-63 63c-28.4-19.5-62.7-31-99.8-31-97.2 0-176 78.8-176 176 0 86.3 62.1 158.1 144 173.1l0 34.9-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-34.9c81.9-15 144-86.8 144-173.1 0-37-11.4-71.4-31-99.8l63-63 0 66.7 64 0 0-176-144 0zM368 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM176-32l-42.2 88.5-95.4-22.2 42.9 88.1-76.9 60.8 95.6 21.4-.4 98 50.8-40.9c-4.2-17.2-6.5-35.2-6.5-53.7 0-63.7 26.6-121.1 69.2-161.9L176-32z"]
};
var faColumns3 = {
  prefix: 'fass',
  iconName: 'columns-3',
  icon: [448, 512, [], "e361", "M320 96l0 320 64 0 0-320-64 0zm-64 0l-64 0 0 320 64 0 0-320zM128 416l0-320-64 0 0 320 64 0zM0 32l448 0 0 448-448 0 0-448z"]
};
var faOtter = {
  prefix: 'fass',
  iconName: 'otter',
  icon: [640, 512, [129446], "f700", "M188.8 193.6l19.2 14.4 48 0 0-64c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64l0 64 48 0c14.7-11 23.7-17.8 27.1-20.3-5.7-3.8-9.4-6.3-11.1-7.4l0-36.3 64 0 0 36.3c-1.7 1.1-5.4 3.6-11.1 7.4l7.9 5.9zM256 320l0 64 128 0 0-64 64-64 0-64 64 0 0 128 32 0 0-115.7c0-48.2-30.8-91-76.6-106.3l-8.5-2.8 8.2-30.9 19.9 4C576 86.1 640 164.2 640 254.9l0 1.1 0 0c0 123.7-100.3 224-224 224l-160.6 0C132 480 32 380 32 256.6l0-.6-16 0 0-112-16 0 0-48 26.8 0C44.8 58.2 83.3 32 128 32l64 0c44.7 0 83.2 26.2 101.2 64l26.8 0 0 48-16 0 0 16 80 0 0 64-64 0 0 32 80 0-48 48 0 16-32 0c-41.8 0-77.4-26.7-90.5-64l-37.5 0-32-24-32 24-32 0c0 35.3 28.7 64 64 64l96 0zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faArrowUTurnRightDown = {
  prefix: 'fass',
  iconName: 'arrow-u-turn-right-down',
  icon: [576, 512, [], "e7eb", "M573.5 368l-45.3-45.3-80 80 0-210.7C448.3 89.3 367.6 5.4 266.1 .2L256.3 0c-106 0-192 86-192 192l0 256 64 0 0-256c0-70.7 57.3-128 128-128l6.6 .2c67.6 3.4 121.4 59.4 121.4 127.8l0 210.7-80-80-45.2 45.3 157.2 157.2 157.3-157.2z"]
};
var faCircle9 = {
  prefix: 'fass',
  iconName: 'circle-9',
  icon: [512, 512, [], "e0f6", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM200 368l0-48 72 0c13.3 0 24-10.7 24-24l0-12.1c-7.5 2.7-15.6 4.1-24 4.1l-32 0c-39.8 0-72-32.2-72-72s32.2-72 72-72l32 0c39.8 0 72 32.2 72 72l0 80c0 39.8-32.2 72-72 72l-72 0zm72-176l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
var faSneakerRunning = {
  prefix: 'fass',
  iconName: 'sneaker-running',
  icon: [640, 512, [], "e819", "M240 480l-208 0 0-48 208 0 0 48zm203.9-49.1l196.1 0 0 49.1-224 0-352-208 26.9-44.9 353 203.8zM128 400l-96 0 0-48 96 0 0 48zM256 82.8c0 25 20.3 45.2 45.2 45.2 12 0 23.5-4.8 32-13.2l50.7-50.8 48 0 24.6 64-72.6 0 0 48 91.1 0 18.5 48-77.5 0 0 48 96 0c64.9 0 118.4 48.3 126.8 110.9l-182 0-341.2-197 92.4-153.9 48 0 0 50.8z"]
};
var faCircleChevronLeft = {
  prefix: 'fass',
  iconName: 'circle-chevron-left',
  icon: [512, 512, ["chevron-circle-left"], "f137", "M512 256a256 256 0 1 0 -512 0 256 256 0 1 0 512 0zM167 239l104-104 17-17 33.9 33.9-17 17-87 87 87 87 17 17-33.9 33.9-17-17-104-104-17-17 17-17z"]
};
var faChevronCircleLeft = faCircleChevronLeft;
var faCircleQuestion = {
  prefix: 'fass',
  iconName: 'circle-question',
  icon: [512, 512, [62108, "question-circle"], "f059", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-336c-17.7 0-32 14.3-32 32l-48 0c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.1-20.5 57.5-38.2 70-6.3 4.4-12.5 7.8-17.8 10.4l0 21.9-48 0 0-56.7c1.4-.4 2.7-.7 4.1-1.1 12.2-3.2 23.3-6.1 34.1-13.7 10.4-7.3 17.8-16.9 17.8-30.8 0-17.7-14.3-32-32-32zM232 344l48 0 0 48-48 0 0-48z"]
};
var faQuestionCircle = faCircleQuestion;
var faArrowRotateRight10 = {
  prefix: 'fass',
  iconName: 'arrow-rotate-right-10',
  icon: [512, 512, [], "e837", "M512 192l-59.2 16.9-32-51.4-.1-.2-.1-.2C386.9 101.2 325.8 64 256 64 150 64 64 150 64 256s86 192 192 192c75 0 140-43 171.7-105.8 19 9.6 38.1 19.2 57.2 28.7-42.1 83.6-128.7 141.1-228.8 141.1-141.4 0-256-114.6-256-256S114.6 0 256 0c76.5 0 145.1 33.6 192 86.7l0-86.7 64 0 0 192zM208 352l-48 0 0-129.2-18.7 9.4-21.5-42.9c11.7-5.9 31.2-15.6 58.5-29.3l29.7 0 0 192zM312 160c30.9 0 56 25.1 56 56l0 80c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-80c0-30.9 25.1-56 56-56l16 0zm-16 48c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0z"]
};
var faWalkieTalkie = {
  prefix: 'fass',
  iconName: 'walkie-talkie',
  icon: [384, 512, [], "f8ef", "M112-32l0 96 48 0 0-32 64 0 0 32 32 0 0-32 64 0 0 32 64 0 0 224-32 64 0 160-320 0 0-160-32-64 0-224 64 0 0-96 48 0zm8 176l-24 0 0 48 192 0 0-48-168 0zm0 96l-24 0 0 48 192 0 0-48-168 0z"]
};
var faUserGroup = {
  prefix: 'fass',
  iconName: 'user-group',
  icon: [576, 512, [128101, "user-friends"], "f500", "M64 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM288 288l64 224-352 0 64-224 224 0zM432 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm80 240l64 208-174.1 0-3.8-13.2-55.7-194.8 169.5 0z"]
};
var faUserFriends = faUserGroup;
var faBedFront = {
  prefix: 'fass',
  iconName: 'bed-front',
  icon: [512, 512, ["bed-alt"], "f8f7", "M480 32l-448 0 0 144 48 0 0-48 152 0 0 48 48 0 0-48 152 0 0 48 48 0 0-144zM32 224l-32 0 0 256 64 0 0-64 384 0 0 64 64 0 0-256-480 0z"]
};
var faBedAlt = faBedFront;
var faHouseChimney = {
  prefix: 'fass',
  iconName: 'house-chimney',
  icon: [512, 512, [63499, "home-lg"], "e3af", "M464 272l48 0 0-48-48-45 0-131-96 0 0 41-112-105-256 240 0 48 48 0 0 240 416 0 0-240zM320 464l-128 0 0-144 128 0 0 144z"]
};
var faHomeLg = faHouseChimney;
var faRightFromBracket = {
  prefix: 'fass',
  iconName: 'right-from-bracket',
  icon: [576, 512, ["sign-out-alt"], "f2f5", "M536.9 273.4l18.5-17.4-18.5-17.4c-113.3-107-174.7-165-184.5-174.2l0 127.7-160 0 0 128 160 0 0 127.7c9.7-9.2 71.2-67.3 184.5-174.2zM192.5 96l32 0 0-64-192 0 0 448 192 0 0-64-128 0 0-320 96 0z"]
};
var faSignOutAlt = faRightFromBracket;
var faPeanuts = {
  prefix: 'fass',
  iconName: 'peanuts',
  icon: [576, 512, [129372], "e431", "M32 362.9l0 149.1 141.7 0c42.4 0 83.1-16.9 113.1-46.9l12.9-12.9c23.6-23.6 39.2-53.9 44.7-86.8l7.6-45.4 40.4-6.7c36.2-6 69.6-23.2 95.5-49.2l4.6-4.6c33-33 51.5-77.8 51.5-124.5L544 0 408.9 0c-46.7 0-91.4 18.5-124.5 51.5l-4.6 4.6c-25.9 25.9-43.1 59.3-49.2 95.5l-6.7 40.4-53.2 8.9c-28 4.7-54.3 16.7-76.1 34.9L89.6 240C53.1 270.4 32 315.5 32 362.9zM448 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm0 64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm-64 0a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm-224 224a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM204.8 416a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm0-64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM576 218.3c-11.2 27.9-27.9 53.5-49.6 75.2l-4.6 4.6c-33 33-75.5 54.9-121.6 62.6l-6.5 1.1-1.9 11.6c-7.1 42.8-27.4 82.2-58.1 112.9l-12.9 12.9c-19.4 19.4-42.2 34.6-67.1 44.9l44.6 0c31.8 0 62.3-12.6 84.9-35.1l9.7-9.7c17.7-17.7 29.4-40.5 33.5-65.1l5.7-34.1 30.3-5c27.1-4.5 52.2-17.4 71.6-36.9l3.4-3.4c24.8-24.8 38.7-58.3 38.7-93.3l0-41.3c0-.6 0-1.1 0-1.7z"]
};
var faTriangleInstrument = {
  prefix: 'fass',
  iconName: 'triangle-instrument',
  icon: [576, 512, ["triangle-music"], "f8e2", "M320 42.4l0-74.4-64 0 0 74.4-4.5 8.2-200.4 365.4-35.1 64 544 0c-14.7-26.7-55.5-101.3-122.6-223.6l-47.1 47.1 61.7 112.4-327.8 0 163.9-298.9 54.2 98.8-35.4 35.4c-5.9-2.1-12.2-3.2-18.8-3.2-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8L537 89 553.9 72 520 38.1 503 55 389.3 168.7 324.5 50.6 320 42.4z"]
};
var faTriangleMusic = faTriangleInstrument;
var faBowlSpoon = {
  prefix: 'fass',
  iconName: 'bowl-spoon',
  icon: [512, 512, [129379], "e3e0", "M0 80C0 27 50.1-16 112-16l112 0 0 64 288 0 0 64-288 0 0 64-112 0C50.1 176 0 133 0 80zM0 224l512 0-3.6 61.2C503.5 368.1 454 438.2 384 472.9l0 39.1-256 0 0-39.1C58 438.2 8.5 368.1 3.6 285.2L0 224z"]
};
var faFile = {
  prefix: 'fass',
  iconName: 'file',
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M240 0L0 0 0 512 384 512 384 144 240 0zm85.5 176L208 176 208 58.5 325.5 176z"]
};
var faPlaneSlash = {
  prefix: 'fass',
  iconName: 'plane-slash',
  icon: [576, 512, [], "e069", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-175.5-175.5 7-7.6 127.3 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-127.3 0-168.7-184-80 0 31 92.9-125.8-125.8zm81 216.9l-24.6 0-57.6-72-48 0 32 128-32 128 48 0 57.6-72 99.7 0-61.3 184 80 0 96.7-105.5-190.5-190.5z"]
};
var faIndustryWindows = {
  prefix: 'fass',
  iconName: 'industry-windows',
  icon: [512, 512, [127981, "industry-alt"], "f3b3", "M0 32l128 0 0 192 192-96 0 96 192-96 0 352-512 0 0-448zM288 320l-64 0 0 64 64 0 0-64zm-128 0l-64 0 0 64 64 0 0-64zm256 0l-64 0 0 64 64 0 0-64z"]
};
var faIndustryAlt = faIndustryWindows;
var faCloudShowersHeavy = {
  prefix: 'fass',
  iconName: 'cloud-showers-heavy',
  icon: [512, 512, [], "f740", "M96 320l-96 0 0-96c0-41.8 26.7-77.4 64-90.5L64 112c0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-416 0zM62.7 368l50.6 0-48 144-50.6 0 48-144zm402.6 0l-48 144-50.6 0 48-144 50.6 0zm-120 0l-48 144-50.6 0 48-144 50.6 0zm-112 0l-48 144-50.6 0 48-144 50.6 0z"]
};
var faBedBunk = {
  prefix: 'fass',
  iconName: 'bed-bunk',
  icon: [512, 512, [], "f8f8", "M64 32l0-32-64 0 0 512 64 0 0-64 384 0 0 64 64 0 0-512-288 0 0 128-160 0 0-96zM224 288l0 96-160 0 0-192 384 0 0 64-224 0 0 32zm-32 16a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faPersonFalling = {
  prefix: 'fass',
  iconName: 'person-falling',
  icon: [512, 512, [], "e546", "M320.3 32l0-32-64 0c0 13.7 0 50.3 0 109.9L189.5 150c-57.8 34.7-93.2 97.2-93.2 164.6 0 52.5 0 86.3 0 101.4l64 0c0-15.1 0-48.9 0-101.4 0-16.7 3.3-33 9.4-48l189.8 233.6 20.2 24.8 49.7-40.4-20.2-24.8-113.6-139.8 104.8 0c28.8 38.4 48 64 57.6 76.8l51.2-38.4c-8-10.7-30.4-40.5-67.2-89.6l-9.6-12.8-113 0-60.7-72.8c35.9-21.5 56.5-33.9 61.7-37l0-114.1zm-216 112a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faSquareChevronDown = {
  prefix: 'fass',
  iconName: 'square-chevron-down',
  icon: [448, 512, ["chevron-square-down"], "f329", "M0 480l448 0 0-448-448 0 0 448zM207 345l-104-104-17-17 33.9-33.9 17 17 87 87 87-87 17-17 33.9 33.9-17 17-104 104-17 17-17-17z"]
};
var faChevronSquareDown = faSquareChevronDown;
var faButter = {
  prefix: 'fass',
  iconName: 'butter',
  icon: [640, 512, [129480], "e3e4", "M448 128l64 0 0 144 64 0 0-208-512 0 0 208 384 0 0-144zM64 320l-32 0 0 64 32 0 0 64 512 0 0-64 40 0 0-64-552 0z"]
};
var faTurnDown = {
  prefix: 'fass',
  iconName: 'turn-down',
  icon: [384, 512, [10549, "level-down-alt"], "f3be", "M192 512l-192-192 128 0 0-192-128 0 0-128 256 0 0 320 128 0-192 192z"]
};
var faLevelDownAlt = faTurnDown;
var faVolumeSlash = {
  prefix: 'fass',
  iconName: 'volume-slash',
  icon: [576, 512, [128263], "f2e2", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-241.2-241.2 0-246-137.3 108.7-133.6-133.6zM90.3 160l-58.2 0 0 192 96 0 192 152 0-114.2-229.8-229.8zM373 211.1l9.4 7.6c10.9 8.8 17.7 22.2 17.7 37.3 0 6.4-1.2 12.4-3.5 18L432 309.3c10.2-15.2 16.2-33.6 16.2-53.3 0-30.1-13.9-56.9-35.5-74.5l-10.9-8.8-28.8 38.4zM544.1 256c0-60.1-27.7-113.8-70.9-149l-13.7-11.2-28.8 38.4 12.3 10c32.5 26.4 53.2 66.7 53.2 111.8 0 33-11.1 63.4-29.8 87.7l34.2 34.2c27.2-33.1 43.6-75.6 43.6-121.9z"]
};
var faUpRightAndDownLeftFromCenter = {
  prefix: 'fass',
  iconName: 'up-right-and-down-left-from-center',
  icon: [512, 512, ["expand-alt"], "f424", "M512 0l0 208-71-71-96 96-17 17c-8.8-8.8-25.1-25.1-49-49l-17-17 17-17 96-96-71-71 208 0zM0 512l0-208 71 71 96-96 17-17c8.8 8.8 25.1 25.1 49 49l17 17-17 17-96 96 71 71-208 0z"]
};
var faExpandAlt = faUpRightAndDownLeftFromCenter;
var faUserTag = {
  prefix: 'fass',
  iconName: 'user-tag',
  icon: [640, 512, [], "f507", "M256 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM364.1 512l-60.1-60.1 0-147.9-192 0-64 208 316.1 0zM352 288.1l0 144 144 144 144-144-144-144-144 0zM432 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSquare0 = {
  prefix: 'fass',
  iconName: 'square-0',
  icon: [448, 512, [], "e255", "M448 32l-448 0 0 448 448 0 0-448zM224 144c53 0 96 43 96 96l0 32c0 53-43 96-96 96s-96-43-96-96l0-32c0-53 43-96 96-96zm-48 96l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faInboxIn = {
  prefix: 'fass',
  iconName: 'inbox-in',
  icon: [512, 512, [128229, "inbox-arrow-down"], "f310", "M423.5 96l24 192-79.5 0-32 64-160 0-32-64-79.5 0 24-192 335 0zM32 32l-32 256 0 192 512 0 0-192-32-256-448 0zM273 313c50.5-50.5 77.5-77.5 81-81L320 198.1c-10.3 10.3-23.6 23.6-40 40l0-110.1-48 0 0 110.1c-16.4-16.4-29.7-29.7-40-40L158.1 232c3.5 3.5 30.5 30.5 81 81l17 17 17-17z"]
};
var faInboxArrowDown = faInboxIn;
var faKettlebell = {
  prefix: 'fass',
  iconName: 'kettlebell',
  icon: [384, 512, [], "e832", "M352 168.9l-4.6 7.6-34.9 58.1c43.6 35.2 71.5 89 71.5 149.4 0 49.2-18.5 94-48.9 128L48.9 512C18.5 478 0 433.2 0 384 0 323.6 27.9 269.8 71.4 234.6L36.6 176.5 32 168.9 32 0 352 0 352 168.9zM96 151.1l31.2 52.1c20.2-7.2 42-11.2 64.8-11.2 22.7 0 44.5 4 64.7 11.2l31.3-52.1 0-87.1-192 0 0 87.1z"]
};
var faGlobeSnow = {
  prefix: 'fass',
  iconName: 'globe-snow',
  icon: [448, 512, [], "f7a3", "M448 224c0 54.8-19.7 105.1-52.4 144l-65.6 0-60-64 66 0-112-112-112 112 66 0-60 64-65.6 0C19.7 329.1 0 278.8 0 224 0 100.3 100.3 0 224 0S448 100.3 448 224zM240 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-232 8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM16 480l57.6-64 300.8 0 57.6 64 0 32-416 0 0-32z"]
};
var faHandSparkles = {
  prefix: 'fass',
  iconName: 'hand-sparkles',
  icon: [640, 512, [], "e05d", "M352 0l0 256 32 0 0-224 64 0 0 224 32 0 0-160 64 0 0 171.5-44.6 104-57.7 24.7-9.7 4.2 0 63.3c3.4 1.5 16 6.8 37.6 16.1-28.7 20.3-63.7 32.2-101.6 32.2l-19.2 0c-59.6 0-116.9-22.9-160-64-74.8-71.2-116.3-110.7-124.5-118.6l55.2-57.9c16.9 16.1 41.1 39.1 72.6 69.1 0-1.5-.1-3.1-.1-4.6l0-304 64 0 0 224 32 0 0-256 64 0zM256 368l32 16 16 32 16-32 32-16-32-16-16-32-16 32-32 16zM56 120l24-56 24 56 56 24-56 24-24 56-24-56-56-24 56-24zM560 352l24 56 56 24-56 24-24 56-24-56-56-24 56-24 24-56z"]
};
var faFilePpt = {
  prefix: 'fass',
  iconName: 'file-ppt',
  icon: [576, 512, [], "e64a", "M272 0l-240 0 0 512 144 0 0-176 240 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM240 380l-20 0 0 168 40 0 0-48 12 0c33.1 0 60-26.9 60-60s-26.9-60-60-60l-32 0zm32 80l-12 0 0-40 12 0c11 0 20 9 20 20s-9 20-20 20zm96-80l-20 0 0 168 40 0 0-48 12 0c33.1 0 60-26.9 60-60s-26.9-60-60-60l-32 0zm32 80l-12 0 0-40 12 0c11 0 20 9 20 20s-9 20-20 20zm76-80l0 40 32 0 0 128 40 0 0-128 32 0 0-40-104 0z"]
};
var faArrowsToDot = {
  prefix: 'fass',
  iconName: 'arrows-to-dot',
  icon: [512, 512, [], "e4be", "M376 64l-88 0 0-64-64 0 0 64-88 0 120 128 120-128zM64 224l-64 0 0 64 64 0 0 88 128-120-128-120 0 88zm224 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160-32l0-88-128 120 128 120 0-88 64 0 0-64-64 0zM376 448l-120-128-120 128 88 0 0 64 64 0 0-64 88 0z"]
};
var faFaceSadCry = {
  prefix: 'fass',
  iconName: 'face-sad-cry',
  icon: [512, 512, [128557, "sad-cry"], "f5b3", "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6l0-221.4-48 0 0 195.7C44.4 421.6 0 344 0 256 0 114.6 114.6 0 256 0S512 114.6 512 256c0 88-44.4 165.6-112 211.7l0-195.7-48 0 0 221.4zM208 336l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48zM132 216c0-11 9-20 20-20l16 0c11 0 20 9 20 20l0 16 40 0 0-16c0-33.1-26.9-60-60-60l-16 0c-33.1 0-60 26.9-60 60l0 16 40 0 0-16zm212-20l16 0c11 0 20 9 20 20l0 16 40 0 0-16c0-33.1-26.9-60-60-60l-16 0c-33.1 0-60 26.9-60 60l0 16 40 0 0-16c0-11 9-20 20-20z"]
};
var faSadCry = faFaceSadCry;
var faImageSlash = {
  prefix: 'fass',
  iconName: 'image-slash',
  icon: [576, 512, [], "e1b7", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-5.9-5.9-28-28-66.1-66.1l0-414-414 0-48.9-48.9zM179.8 113.6c3.9-1 8.1-1.6 12.4-1.6 26.5 0 48 21.5 48 48 0 4.3-.6 8.4-1.6 12.4l-58.8-58.8zM312.5 246.4l23.6-38.4 99.1 161.1-122.7-122.7zM410.3 480l-64-64-234.2 0 93.7-140.5-141.7-141.7 0 346.2 346.2 0z"]
};
var faTrophyStar = {
  prefix: 'fass',
  iconName: 'trophy-star',
  icon: [512, 512, ["trophy-alt"], "f2eb", "M96 0c0 22.6 .6 43.9 1.6 64L0 64 0 88c0 113.7 47.9 177.7 104.2 211.8 21.6 13.1 44 21.5 64.5 26.8 19.4 26.3 39.4 40.6 55.3 48.3l0 73.1-96 0 0 64 256 0 0-64-96 0 0-73.1c16.6-8 37.7-23.2 57.9-51.8 17.6-5.2 36.1-12.4 54.1-22.5 29.3-16.4 57.6-40.6 78.5-75.7 20.9-35.2 33.5-80.1 33.5-136.8l0-24-97.6 0c1-20.1 1.6-41.4 1.6-64L96 0zM48.8 112l52.4 0c6.5 63.6 18.3 112.3 32.8 149.6-1.7-.9-3.3-1.9-5-2.9-37.9-22.9-74.3-65-80.2-146.7zm388.3 88.4c-15.1 25.5-35.4 43.6-57.4 56.5 13.6-36.7 24.8-83.9 31-144.8l52.3 0c-2.9 37.4-12.7 66.1-25.9 88.4zm-154.8-71l58.9 8.6-42.6 41.5 10.1 58.6-52.7-27.7-52.7 27.7 10.1-58.6-42.6-41.5 58.9-8.6 26.3-53.4 26.3 53.4z"]
};
var faTrophyAlt = faTrophyStar;
var faDongSign = {
  prefix: 'fass',
  iconName: 'dong-sign',
  icon: [384, 512, [], "e169", "M320-16l-64 0 0 64-128 0 0 48 128 0 0 72.2c-22.9-15.3-50.4-24.2-80-24.2-79.5 0-144 64.5-144 144S96.5 432 176 432c29.6 0 57.1-8.9 80-24.2l0 24.2 64 0 0-336 64 0 0-48-64 0 0-64zM96 288a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM384 464l-384 0 0 48 384 0 0-48z"]
};
var faSquareCent = {
  prefix: 'fass',
  iconName: 'square-cent',
  icon: [448, 512, [], "e6f0", "M448 32l-448 0 0 448 448 0 0-448zM200 96l48 0 0 34.2c31.9 6.1 59.6 24 78.4 48.9L288 208c-14.6-19.5-37.9-32-64-32-44.2 0-80 35.8-80 80s35.8 80 80 80c26.2 0 49.4-12.5 64-32l38.4 28.8c-18.7 25-46.5 42.9-78.4 48.9l0 34.2-48 0 0-34.2C140.8 370.5 96 318.5 96 256s44.8-114.5 104-125.8L200 96z"]
};
var faPeopleLine = {
  prefix: 'fass',
  iconName: 'people-line',
  icon: [576, 512, [], "e534", "M288 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm64 384l0 32-128 0 0-32-32 0 0-112c0-53 43-96 96-96s96 43 96 96l0 112-32 0zm-208 0l0 32-80 0 0-32-32 0 0-96c0-53 43-96 96-96 12.7 0 24.8 2.5 35.9 6.9-12.6 21.4-19.9 46.4-19.9 73.1l0 112zm288 32l0-144c0-26.7-7.3-51.6-19.9-73.1 11.1-4.5 23.2-6.9 35.9-6.9 53 0 96 43 96 96l0 96-32 0 0 32-80 0zM128 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm320 0a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM24 464l552 0 0 48-576 0 0-48 24 0z"]
};
var faSquareRss = {
  prefix: 'fass',
  iconName: 'square-rss',
  icon: [448, 512, ["rss-square"], "f143", "M448 32l-448 0 0 448 448 0 0-448zM96 112c150.2 0 272 121.8 272 272l-48 0c0-123.7-100.3-224-224-224l0-48zm0 96c97.2 0 176 78.8 176 176l-48 0c0-70.7-57.3-128-128-128l0-48zm0 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faRssSquare = faSquareRss;
var faIslandTropical = {
  prefix: 'fass',
  iconName: 'island-tropical',
  icon: [512, 512, [127965, "island-tree-palm"], "f811", "M112 96L62.2 96c0-36 38.4-96 128-96 58.4 0 95 25.5 113.5 53.2 19.9-12.6 46.5-21.2 80.3-21.2 89.6 0 128 60 128 96l-64 0-32-32-32 32-82.5 0c28 79.9 21.2 170.2 9.9 226.1 59.5 11 104.6 63.2 104.6 125.9l0 32-384 0 0-32c0-70.7 57.3-128 128-128l64 0c29.7-79.3 29.4-150.9 22.8-194l-98.9 98.9c-25.5-25.5-40.7-95 22.6-158.4 1.3-1.3 2.7-2.7 4.1-3.9L144 64 112 96z"]
};
var faIslandTreePalm = faIslandTropical;
var faClockTwelve = {
  prefix: 'fass',
  iconName: 'clock-twelve',
  icon: [512, 512, [], "e358", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392l0 160-48 0 0-184 48 0 0 24z"]
};
var faCalendarMinus = {
  prefix: 'fass',
  iconName: 'calendar-minus',
  icon: [448, 512, [], "f272", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0zm-8 264l-24 0 0 48 192 0 0-48-168 0z"]
};
var faChartDiagram = {
  prefix: 'fass',
  iconName: 'chart-diagram',
  icon: [512, 512, [], "e695", "M480 32l-448 0 0 96 200 0 0 40-48 48-144 0 0 136-40 0 0 128 128 0 0-128-40 0 0-88 96 0 48 48 0 40-40 0 0 128 128 0 0-128-40 0 0-40 48-48 96 0 0 88-40 0 0 128 128 0 0-128-40 0 0-136-144 0-48-48 0-40 200 0 0-96z"]
};
var faBallotCheck = {
  prefix: 'fass',
  iconName: 'ballot-check',
  icon: [384, 512, [], "f733", "M384 0L0 0 0 512 384 512 384 0zM128 96l0 64-64 0 0-64 64 0zm0 256l0 64-64 0 0-64 64 0zm48 8l144 0 0 48-144 0 0-48zm24-256l120 0 0 48-144 0 0-48 24 0zm8 128l112 0 0 48-112 0 0-48zm-37.1-27.8c-1.6 2.1-21.4 28.6-59.5 79.4l-3.4 4.5-24 0-3.4-4.5c-18.1-24.1-29.9-39.9-35.5-47.4L75.8 213.1 96 240c25.3-33.7 40-53.3 44.2-58.9l30.7 23z"]
};
var faChfSign = {
  prefix: 'fass',
  iconName: 'chf-sign',
  icon: [640, 512, [], "e602", "M80 128c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 64 0 0 16c0 44.2-35.8 80-80 80S0 412.2 0 368L0 144C0 99.8 35.8 64 80 64s80 35.8 80 80l0 16-64 0 0-16c0-8.8-7.2-16-16-16zM256 64l0 160 96 0 0-160 64 0 0 384-64 0 0-160-96 0 0 160-64 0 0-384 64 0zm192 0l192 0 0 64-128 0 0 96 96 0 0 64-96 0 0 160-64 0 0-384z"]
};
var faCalendarImage = {
  prefix: 'fass',
  iconName: 'calendar-image',
  icon: [448, 512, [], "e0d4", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0zm0 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM352 384l0-48-128-112-128 112 0 48 256 0z"]
};
var faDownRight = {
  prefix: 'fass',
  iconName: 'down-right',
  icon: [448, 512, [], "e16b", "M416 448L416 96 296 216 112 32 0 144 184 328 64 448 416 448z"]
};
var faCalendarCircleUser = {
  prefix: 'fass',
  iconName: 'calendar-circle-user',
  icon: [576, 512, [], "e471", "M192 32l0 32 128 0 0-64 64 0 0 64 96 0 0 112-448 0 0-112 96 0 0-64 64 0 0 32zM32 480l0-256 323.1 0c-67.8 29.6-115.1 97.3-115.1 176 0 28.6 6.2 55.6 17.4 80L32 480zm256-80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm223.5 78.9l-15.5-30.9-128 0-15.5 30.9C372.8 499.4 400.9 512 432 512s59.2-12.6 79.5-33.1zM480 368a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faCircleShareNodes = {
  prefix: 'fass',
  iconName: 'circle-share-nodes',
  icon: [512, 512, [], "e6db", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM400 160c0 35.3-28.7 64-64 64-15.4 0-29.5-5.4-40.6-14.5l-85.3 46.5 85.3 46.5c11-9.1 25.2-14.5 40.6-14.5 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L190.5 300c-11.7 12.3-28.2 20-46.5 20-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3 0-35.3 28.7-64 64-64s64 28.7 64 64z"]
};
var faFaceTired = {
  prefix: 'fass',
  iconName: 'face-tired',
  icon: [512, 512, [128555, "tired"], "f5c8", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-128c-48.9 0-93.5 16.8-127.4 44.3-.4-4.1-.6-8.2-.6-12.3 0-70.7 57.3-128 128-128s128 57.3 128 128c0 4.2-.2 8.3-.6 12.3-33.9-27.6-78.5-44.3-127.4-44.3zM135.2 145.7l95.6 48 9.2 4.6 0 20.2-10.2 4.3-95.6 40-14.7-28.3 44.2-27.6-45.3-34 16.8-27.1zm146 48l95.6-48 16.8 27.1-45.3 34 44.2 27.6-14.7 28.3-95.6-40-10.2-4.3 0-20.2 9.2-4.6z"]
};
var faTired = faFaceTired;
var faDiagramPrevious = {
  prefix: 'fass',
  iconName: 'diagram-previous',
  icon: [448, 512, [], "e478", "M448 224l0-192-448 0 0 192 61.5 0c48.3-48.3 77.5-77.5 117.3-117.3 3.8-3.8 18.9-18.9 45.3-45.3 51 51 50.8 50.8 101.3 101.3 17.1 17.1 37.5 37.5 61.3 61.3l61.5 0zM0 288l0 192 448 0 0-192-192 0 0-64 62.6 0c-13.4-13.4-41.2-41.2-83.3-83.3l-11.3-11.3-11.3 11.3c-42.1 42.1-69.9 69.9-83.3 83.3l62.6 0 0 64-192 0z"]
};
var faFaceAstonished = {
  prefix: 'fass',
  iconName: 'face-astonished',
  icon: [512, 512, [], "e36b", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-208c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zM144 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 132c-4.2 0-8.4 .3-12.5 .8-20.3 2.7-38.9 11.9-53.8 25.8L111 172.3 83.7 143 98.3 129.4C119 110.1 145.2 97 174.3 93.2 180.1 92.4 186 92 192 92l20 0 0 40-20 0zm140.5 .8c-4.1-.5-8.3-.8-12.5-.8l-20 0 0-40 20 0c6 0 11.9 .4 17.7 1.2 29.1 3.8 55.3 17 75.9 36.2l14.6 13.7-27.3 29.2-14.6-13.7c-14.9-13.9-33.5-23.1-53.8-25.8z"]
};
var faIceSkate = {
  prefix: 'fass',
  iconName: 'ice-skate',
  icon: [576, 512, [9976], "f7ac", "M320 96l-80 0 0 48 80 0 0 32-80 0 0 48 80 0 160 48 0 144-48 0 0 48 56 0c22.1 0 40-17.9 40-40l0-8 48 0 0 8c0 48.6-39.4 88-88 88l-488 0 0-48 96 0 0-48-32 0 0-352 192-32 0-32 64 0 0 96zM144 464l240 0 0-48-240 0 0 48z"]
};
var faArrowUTurnLeftUp = {
  prefix: 'fass',
  iconName: 'arrow-u-turn-left-up',
  icon: [576, 512, [], "e7ea", "M3 144l45.2 45.2 80-80 0 210.8c0 102.7 80.7 186.6 182.1 191.7l9.9 .3c106 0 192-86 192-192l0-256-64 0 0 256c0 70.7-57.3 128-128 128l-6.6-.2C246 444.4 192.3 388.5 192.2 320l0-210.8 80 80 45.3-45.2-157.3-157.2-157.2 157.2z"]
};
var faLaptopArrowDown = {
  prefix: 'fass',
  iconName: 'laptop-arrow-down',
  icon: [640, 512, [], "e1c6", "M352 32l0-32-64 0 0 210.7c-17.4-17.4-33.4-33.4-48-48L194.7 208c5.5 5.5 39.7 39.7 102.6 102.6L320 333.3c5.5-5.5 39.7-39.7 102.6-102.6L445.3 208 400 162.7c-14.6 14.6-30.6 30.6-48 48L352 32zM96 32l-32 0 0 304 64 0 0-240 112 0 0-64-144 0zM512 96l0 240 64 0 0-304-176 0 0 64 112 0zM0 384l0 40 56 56 528 0 56-56 0-40-640 0z"]
};
var faUserCirclePlus = {
  prefix: 'fass',
  iconName: 'user-circle-plus',
  icon: [576, 512, [], "e7ab", "M224 248a120 120 0 1 0 0-240 120 120 0 1 0 0 240zm16 152c0-35 9.3-67.8 25.7-96L80 304 16 512 276 512c-22.7-31.5-36-70.2-36-112zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 64 0 0 32-64 0 0 64-32 0 0-64-64 0 0-32 64 0 0-64 32 0 0 16z"]
};
var faRaygun = {
  prefix: 'fass',
  iconName: 'raygun',
  icon: [576, 512, [], "e025", "M192 64l96 0 0-32 48 0 0 288-48 0 0-32-112 224-128-64 80-160-16 0C50.1 288 0 237.9 0 176 0 131.3 26.2 92.8 64 74.8L64 0 192 64zm224 0l0 80 64 0 96-48 0 160-96-48-64 0 0 80-48 0 0-224 48 0zM136 176a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHandPointRight = {
  prefix: 'fass',
  iconName: 'hand-point-right',
  icon: [512, 512, [], "f0a4", "M512 96l0 64-240 0 0-64 240 0zM352 288l0 64-128 0 0-64 128 0zm32-32l-112 0 0-64 112 0 0 64zM320 384l0 64-128 0 0-64 128 0zM149 64l91 0 0 192-80 0 0-112-32 0 0 144 64 0 0 64-32 0 0 96C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64z"]
};
var faConveyorBeltEmpty = {
  prefix: 'fass',
  iconName: 'conveyor-belt-empty',
  icon: [640, 512, [], "e150", "M96 320c-53 0-96 43-96 96s43 96 96 96l448 0c53 0 96-43 96-96s-43-96-96-96L96 320zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faArrowRightFromArc = {
  prefix: 'fass',
  iconName: 'arrow-right-from-arc',
  icon: [576, 512, [], "e4b1", "M96.3 256c0-106 86-192 192-192l32 0 0-64-32 0c-141.4 0-256 114.6-256 256s114.6 256 256 256l32 0 0-64-32 0c-106 0-192-86-192-192zM422.9 121.4L400.3 98.7 355 144c9.3 9.3 36 36 80 80l-242.7 0 0 64 242.7 0-80 80 45.3 45.3 157.3-157.3c-.2-.2-45.1-45.1-134.6-134.6z"]
};
var faSignalStreamSlash = {
  prefix: 'fass',
  iconName: 'signal-stream-slash',
  icon: [576, 512, [], "e250", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-5.3-5.3-28.7-28.7-70.2-70.2 42.4-50.2 68-115.1 68-185.9 0-79.5-32.2-151.5-84.3-203.6L442.7 93.9c42.8 40.8 69.5 98.4 69.5 162.1 0 53.2-18.5 102-49.5 140.5l-34.2-34.2c22.4-29.5 35.7-66.3 35.7-106.3 0-52-22.6-98.8-58.4-131L356 166.9c26.8 20.5 44.2 52.8 44.2 89.1 0 22.2-6.5 42.9-17.6 60.3l-48-48c1-3.9 1.6-8.1 1.6-12.4 0-26.5-21.5-48-48-48-4.3 0-8.4 .6-12.4 1.6L49.3-16.9zm74.3 210.2c-7.4 19.5-11.5 40.6-11.5 62.7 0 52 22.6 98.8 58.4 131l49.7-41.9c-26.8-20.5-44.2-52.8-44.2-89.1 0-3.3 .1-6.5 .4-9.8l-52.9-52.9zM40 109.7C14.7 152.6 .1 202.6 .1 256 .1 335.5 32.3 407.5 84.4 459.6l49.2-41.4c-42.8-40.8-69.5-98.4-69.5-162.1 0-35.6 8.3-69.2 23.1-99.1L40 109.7z"]
};
var faCourtSport = {
  prefix: 'fass',
  iconName: 'court-sport',
  icon: [640, 512, [], "e643", "M640 480l-296 0 0-114.6c50.3-11 88-55.8 88-109.4s-37.7-98.4-88-109.4l0-114.6 296 0 0 96-128 0 0 256 128 0 0 96zM296 146.6c-50.3 11-88 55.8-88 109.4s37.7 98.4 88 109.4l0 114.6-296 0 0-96 128 0 0-256-128 0 0-96 296 0 0 114.6zm0 168.8c-23.5-9.5-40-32.5-40-59.3s16.5-49.9 40-59.3l0 118.7zm48 0l0-118.7c23.5 9.5 40 32.5 40 59.3s-16.5 49.9-40 59.3zM560 176l80 0 0 160-80 0 0-160zM80 336l-80 0 0-160 80 0 0 160z"]
};
var faTrainTrack = {
  prefix: 'fass',
  iconName: 'train-track',
  icon: [512, 512, [], "e453", "M119 96l16-64 66 0c-.3 1.1-5.6 22.4-16 64l142 0c-10.4-41.6-15.7-62.9-16-64l66 0 16 64 55 0 0 64-39 0 16 64 55 0 0 64-39 0 16 64 55 0 0 64-39 0c10.4 41.6 15.7 62.9 16 64l-66 0-16-64-302 0-16 64-66 0c.3-1.1 5.6-22.4 16-64l-39 0 0-64 55 0 16-64-39 0 0-64 55 0 16-64-39 0 0-64 55 0zm50 64l-16 64 206 0-16-64-174 0zM375 288l-238 0-16 64 270 0-16-64z"]
};
var faUserMicrophone = {
  prefix: 'fass',
  iconName: 'user-microphone',
  icon: [576, 512, [], "e7b2", "M224 8a120 120 0 1 1 0 240 120 120 0 1 1 0-240zm48 360.2c0 59.4 29.4 111.9 74.5 143.8l-330.5 0 64-208 192 0 0 64.2zM400 224l96 0 0 144c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-144zM368 336l0 32c0 44.2 35.8 80 80 80s80-35.8 80-80l0-32 48 0 0 32c0 62.5-44.8 114.5-104 125.8l0 50.2-48 0 0-50.2C364.8 482.5 320 430.5 320 368l0-32 48 0z"]
};
var faCars = {
  prefix: 'fass',
  iconName: 'cars',
  icon: [576, 512, [], "f85b", "M96.1-.1l192 .5 24.1 .1c1.3 4.5 12 41.7 32 111.7l-66.6-.2-13.7-47.6-143.8-.4-18.3 64 121.2 0-32 112.1-47.1 0 0 63.9-80 0 0 48-64 0 0-224 35.3 0C59.1 44.5 71.3 1.8 71.9-.2L96.1-.1zM128 223.5a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm135.9-63.7l24.2 .1 192 .5 24.1 .1c.5 1.9 12.7 44.4 36.6 127.6l35.3 0 0 224-64 0 0-48-256 0 0 48-64 0 0-224 35.3 0c23.9-83.5 36.1-126.2 36.6-128.2zm192 64.5l-143.8-.4-18.3 64 180.3 0-18.3-63.7zM288 415.5a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faNfcPen = {
  prefix: 'fass',
  iconName: 'nfc-pen',
  icon: [640, 512, [], "e1fa", "M64 32l448 0 0 171.7-64 64 0-171.7-184 0 0 118.4c-14.3 8.3-24 23.8-24 41.6 0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.8-9.7-33.3-24-41.6l0-70.4 88 0 0 171.7-52.3 52.3-171.7 0 0-224 40 0 0-48-88 0 0 320 171.7 0-8.9 8.9-9.2 55.1-217.6 0 0-448zM544 239.9l80 80-52.8 52.8-80-80 52.8-52.8zm-208 208l132.6-132.6 80 80-132.6 132.6-96 16 16-96z"]
};
var faArrowUp = {
  prefix: 'fass',
  iconName: 'arrow-up',
  icon: [448, 512, [8593], "f062", "M246.9 17.4l-22.6-22.6-22.6 22.6-160 160-22.6 22.6 45.3 45.3c1.3-1.3 44-44 128-128l0 402.7 64 0 0-402.7c84 84 126.7 126.7 128 128l45.3-45.3-22.6-22.6-160-160z"]
};
var faXmarkLarge = {
  prefix: 'fass',
  iconName: 'xmark-large',
  icon: [576, 512, [], "e59b", "M534.9 54.6L557.5 32 512.3-13.3 489.6 9.4 288.3 210.7 86.9 9.4 64.3-13.3 19 32 41.6 54.6 243 256 41.6 457.4 19 480 64.3 525.3 86.9 502.6 288.3 301.3 489.6 502.6 512.3 525.3 557.5 480 333.5 256 534.9 54.6z"]
};
var faCubesStacked = {
  prefix: 'fass',
  iconName: 'cubes-stacked',
  icon: [512, 512, [], "e4e6", "M192 0l128 0 0 128-128 0 0-128zM320 384l0 128-128 0 0-128 128 0zm192 0l0 128-128 0 0-128 128 0zM416 192l0 128-128 0 0-128 128 0zM160 165.5L250.5 256 160 346.5 69.5 256 160 165.5zM128 384l0 128-128 0 0-128 128 0z"]
};
var faChildCombatant = {
  prefix: 'fass',
  iconName: 'child-combatant',
  icon: [576, 512, ["child-rifle"], "e4e0", "M160 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-43.1 32l-16 0-9.6 12.8C34.4 248.5 4 289 0 294.4l51.2 38.4c14.4-19.2 24-32 28.8-38.4l0 217.6 64 0 0-128 32 0 0 128 64 0 0-217.6c4.8 6.4 14.4 19.2 28.8 38.4l51.2-38.4-91.3-121.6-9.6-12.8-102.1 0zM464 0l-64 0 0 32 16 0 0 96-16 0 0 64-32 0 0 208 48 0 0 112 96 0-28-112 60 0 0-48-64 0 0-26.7 64-21.3 0-112-48 0 0 72-16 5.3 0-141.3-16 0 0-128z"]
};
var faChildRifle = faChildCombatant;
var faSquareG = {
  prefix: 'fass',
  iconName: 'square-g',
  icon: [448, 512, [], "e271", "M448 32l-448 0 0 448 448 0 0-448zM224 184c-39.8 0-72 32.2-72 72s32.2 72 72 72c28.3 0 52.7-16.3 64.5-40l-56.5 0 0-48 112 0 0 21-.4 5c-5.1 61.6-56.7 110-119.6 110-66.3 0-120-53.7-120-120s53.7-120 120-120c30.7 0 58.8 11.6 80 30.6l-32 35.8c-12.8-11.4-29.5-18.3-48-18.3z"]
};
var faVestPatches = {
  prefix: 'fass',
  iconName: 'vest-patches',
  icon: [448, 512, [], "e086", "M200 288l0 224-200 0 0-256 64-96 0-160 84.4 0 6.9 11.1 .3 .4c.4 .6 1.2 1.5 2.3 2.8 2.3 2.6 6.1 6.3 11.5 10.1 10.6 7.4 28.1 15.6 54.7 15.6s44.1-8.2 54.7-15.6c5.4-3.8 9.2-7.5 11.4-10.1 1.1-1.3 1.9-2.3 2.3-2.8l.3-.4 6.9-11.1 84.4 0 0 160 64 96 0 256-200 0 0-224 55.6-222.6C285.8 77.3 259.6 88 224 88s-61.8-10.7-79.6-22.6L200 288zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM72 247L55 264c4.5 4.5 12.5 12.5 24 24-11.5 11.5-19.5 19.5-24 24l17 17c4.5-4.5 12.5-12.5 24-24 11.5 11.5 19.5 19.5 24 24l17-17c-4.5-4.5-12.5-12.5-24-24 11.5-11.5 19.5-19.5 24-24l-17-17c-4.5 4.5-12.5 12.5-24 24-11.5-11.5-19.5-19.5-24-24zm232 33l0 56 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faImageCirclePlus = {
  prefix: 'fass',
  iconName: 'image-circle-plus',
  icon: [640, 512, [], "e76e", "M512 32l-448 0 0 448 276 0c-13.7-19-24-40.7-30-64l-198 0 96-144 46.1 69.1 81.9-133.1 18.6 30.2c35.1-38.2 85.5-62.2 141.4-62.2 5.4 0 10.7 .2 16 .7L512 32zM192 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 64 0 0 32-64 0 0 64-32 0 0-64-64 0 0-32 64 0 0-64 32 0 0 16z"]
};
var faMartiniGlassEmpty = {
  prefix: 'fass',
  iconName: 'martini-glass-empty',
  icon: [512, 512, ["glass-martini"], "f000", "M0 80l16 16 194.7 194.7 13.3 13.3 0 144-96 0 0 64 256 0 0-64-96 0 0-144 224-224 0-48-512 0 0 48zM106.5 96L405.5 96 256 245.5 106.5 96z"]
};
var faGlassMartini = faMartiniGlassEmpty;
var faCircleLari = {
  prefix: 'fass',
  iconName: 'circle-lari',
  icon: [512, 512, [], "e71d", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-375.9c1.3 0 2.7-.1 4-.1 4 0 8.1 .2 12 .6l0-24.6 32 0 0 32c39.3 14.9 69 49.2 77.5 91.2l4.2 20.8-49 0-2.3-11.2C330.6 225.6 319.4 209 304 198l0 42-32 0 0-55.1c-3.9-.6-7.9-.9-12-.9-1.3 0-2.7 0-4 .1l0 55.9-32 0 0-46.9c-23.8 12.8-40 38-40 66.9 0 42 34 76 76 76l108 0 0 48-224 0 0-48 18 0c-16.3-21-26-47.4-26-76 0-56 37.1-103.3 88-118.7l0-29.3 32 0 0 24.1z"]
};
var faKidneys = {
  prefix: 'fass',
  iconName: 'kidneys',
  icon: [640, 512, [], "f5fb", "M265.7 34.5C231.8-6.2 171.3-11.7 130.5 22.3l-10 8.3C44.2 94.2 0 188.5 0 288 0 341 43 384 96 384s96-43 96-96c0-5.9 .4-11.8 1.1-17.7l30.9 30.9 0 210.7 64 0 0-237.3-9.4-9.4-60.2-60.2c7.1-10 15.5-19.1 25.1-27.1l10-8.3c40.7-33.9 46.2-94.5 12.3-135.2zM446.9 270.3c.7 5.8 1.1 11.7 1.1 17.7 0 53 43 96 96 96s96-43 96-96c0-99.5-44.2-193.8-120.6-257.4l-10-8.3C468.7-11.7 408.2-6.2 374.2 34.5s-28.4 101.3 12.3 135.2l10 8.3c9.6 8 18 17.1 25.1 27.1l-60.2 60.2-9.4 9.4 0 237.3 64 0 0-210.7 30.9-30.9z"]
};
var faBracketsCurly = {
  prefix: 'fass',
  iconName: 'brackets-curly',
  icon: [576, 512, [], "f7ea", "M64 32l160 0 0 64-96 0 0 109.3c-.9 .9-17.8 17.8-50.7 50.7 32.9 32.9 49.8 49.8 50.7 50.7l0 109.3 96 0 0 64-160 0 0-146.7-54.6-54.6-9.4-9.4 0-26.5 9.4-9.4 54.6-54.6 0-146.7zm448 0l0 146.7 54.6 54.6 9.4 9.4 0 26.5-64 64 0 146.7-160 0 0-64 96 0 0-109.3 50.7-50.7c-32.9-32.9-49.8-49.8-50.7-50.7l0-109.3-96 0 0-64 160 0z"]
};
var faPersonSoccer = {
  prefix: 'fass',
  iconName: 'person-soccer',
  icon: [576, 512, [], "e789", "M344 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM128 112l-21.7 0c-1.4 3.4-14.7 36.8-40 100.1l-11.9 29.7 59.4 23.8c5.9-14.8 17.9-44.7 35.8-89.6l41.4 0-22.7 90.6c-8.3 33.2 11 67 43.7 76.8L308 372.2c-38.9 87.5-59.6 134.1-62.2 140l58.5 26 13-29.2c50.9-114.5 77.1-173.5 78.8-177.2-13.5-4.1-56.1-16.8-127.6-38.3l20.7-70.4c14.5 24.8 24 41.1 28.5 48.8l130.4 0 0-64-93.6 0-28.2-48.4C309 130.1 277.4 112 243.3 112L128 112zm4.8 284.9C62.7 454.8 24.7 486.1 19 490.8l40.7 49.4c4.6-3.8 44.8-36.9 120.7-99.5l6.8-5.6c.3-.9 5.6-15.7 15.8-44.3l-4.7-1.4c-20.4-6.1-37.9-17.6-51.2-32.4l-14.3 40zM480 544a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faDiamondExclamation = {
  prefix: 'fass',
  iconName: 'diamond-exclamation',
  icon: [576, 512, [], "e405", "M560 256L288 528 16 256 288-16 560 256zM260 324l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0z"]
};
var faMagnet = {
  prefix: 'fass',
  iconName: 'magnet',
  icon: [448, 512, [129522], "f076", "M0 176L0 288C0 411.7 100.3 512 224 512S448 411.7 448 288l0-112-128 0 0 112c0 53-43 96-96 96s-96-43-96-96l0-112-128 0zm0-48l128 0 0-96-128 0 0 96zm320 0l128 0 0-96-128 0 0 96z"]
};
var faRoadBarrier = {
  prefix: 'fass',
  iconName: 'road-barrier',
  icon: [640, 512, [], "e562", "M64 64l0-32-64 0 0 448 64 0 0-213.7 85.2-170.3-85.2 0 0-32zm576 0l0-32-64 0 0 85.7-85.2 170.3 85.2 0 0 192 64 0 0-416zM330.8 96l-5.4 10.7-90.6 181.3 74.3 0 5.4-10.7 90.6-181.3-74.3 0zM437.2 288l5.4-10.7 90.6-181.3-74.3 0-5.4 10.7-90.6 181.3 74.3 0zM277.2 96l-74.3 0-5.4 10.7-90.6 181.3 74.3 0 5.4-10.7 90.6-181.3z"]
};
var faCompassDrafting = {
  prefix: 'fass',
  iconName: 'compass-drafting',
  icon: [512, 512, ["drafting-compass"], "f568", "M352 96c0 14.1-3.1 27.6-8.6 39.7l45.3 75.9c-23.3 26.7-54.3 46.2-89.5 55.1L256 192 188 309.5c21.5 6.8 44.3 10.5 68 10.5 82.9 0 155.3-45 194.1-112l55.4 32c-49.7 86-142.8 144-249.4 144-35.4 0-69.4-6.4-100.7-18.1L91.4 476.2 0 512 0 417.8 64 310.7C41.3 290.4 21.9 266.5 6.6 240l55.4-32c9.8 17 21.9 32.6 35.7 46.4l70.9-118.7c-5.5-12.1-8.5-25.5-8.5-39.7 0-53 43-96 96-96s96 43 96 96zm29 311.9c33.7-13.5 64.7-32.3 92-55.4l39 65.3 0 94.2-91.4-35.8-39.5-68.2zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faDraftingCompass = faCompassDrafting;
var faRectangle = {
  prefix: 'fass',
  iconName: 'rectangle',
  icon: [512, 512, [9644, "rectangle-landscape"], "f2fa", "M0 64l512 0 0 384-512 0 0-384z"]
};
var faRectangleLandscape = faRectangle;
var faHandHoldingSkull = {
  prefix: 'fass',
  iconName: 'hand-holding-skull',
  icon: [576, 512, [], "e1a4", "M432 104c0-66.3-64.5-120-144-120S144 37.7 144 104c0 35.5 18.5 67.5 48 89.4l0 62.6 192 0 0-62.6c29.5-22 48-53.9 48-89.4zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM137.4 313.4l-70.6 70.6-66.7 0 0 128 396.4 0 10.2-7c101.2-69.6 154.8-106.4 161-110.7l-45.3-65.9c-11.7 8.1-54.2 37.3-127.5 87.6l-138.8 0 0-48 128 0 0-64-237.3 0-9.4 9.4z"]
};
var faSquarePersonConfined = {
  prefix: 'fass',
  iconName: 'square-person-confined',
  icon: [448, 512, [], "e577", "M0 32l448 0 0 448-448 0 0-448zM256 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm18.7 48c-5.1 5.1-13.6 13.6-25.4 25.4l-9.4 9.4 0 13.3 0 66.7-41.4-41.4-51.2 8.3C63.2 442 93.5 381.4 76.2 416l71.6 0c35.5-71 34.6-69.2 37-74l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3 36.4 0 65.9-29.5 65.9-65.9l0-158.1-77.3 0z"]
};
var faGrid = {
  prefix: 'fass',
  iconName: 'grid',
  icon: [448, 512, ["grid-3"], "e195", "M0 32l112 0 0 112-112 0 0-112zM0 200l112 0 0 112-112 0 0-112zM112 368l0 112-112 0 0-112 112 0zM168 32l112 0 0 112-112 0 0-112zM280 200l0 112-112 0 0-112 112 0zM168 368l112 0 0 112-112 0 0-112zM448 32l0 112-112 0 0-112 112 0zM336 200l112 0 0 112-112 0 0-112zM448 368l0 112-112 0 0-112 112 0z"]
};
var faGrid3 = faGrid;
var faCabinetFiling = {
  prefix: 'fass',
  iconName: 'cabinet-filing',
  icon: [384, 512, [128452], "f64b", "M0 0L0 224 384 224 384 0 0 0zM0 272l0 240 384 0 0-240-384 0zM96 80l192 0 0 80-48 0 0-32-96 0 0 32-48 0 0-80zm0 272l192 0 0 80-48 0 0-32-96 0 0 32-48 0 0-80z"]
};
var faPlateWheat = {
  prefix: 'fass',
  iconName: 'plate-wheat',
  icon: [512, 512, [], "e55a", "M400 32c44.2 0 80 35.8 80 80l0 32-16 0c-44.2 0-80-35.8-80-80l0-32 16 0zM56 64l72 0 0 48-96 0 0-48 24 0zM24 136l136 0 0 48-160 0 0-48 24 0zm8 72l96 0 0 48-96 0 0-48zM272 32l16 0c44.2 0 80 35.8 80 80l0 32-16 0c-44.2 0-80-35.8-80-80l0-32zm-96 0c44.2 0 80 35.8 80 80l0 32-16 0c-44.2 0-80-35.8-80-80l0-32 16 0zM480 176l0 32c0 44.2-35.8 80-80 80l-16 0 0-32c0-44.2 35.8-80 80-80l16 0zm-128 0l16 0 0 32c0 44.2-35.8 80-80 80l-16 0 0-32c0-44.2 35.8-80 80-80zm-96 0l0 32c0 44.2-35.8 80-80 80l-16 0 0-32c0-44.2 35.8-80 80-80l16 0zM96 444C40.8 429.8 0 379.6 0 320l512 0c0 59.6-40.8 109.8-96 124l0 36-320 0 0-36z"]
};
var faRectangleVerticalHistory = {
  prefix: 'fass',
  iconName: 'rectangle-vertical-history',
  icon: [512, 512, [], "e237", "M480 0l-272 0 0 512 272 0 0-512zM104 48l0 416 48 0 0-416-48 0zM0 96l0 320 48 0 0-320-48 0z"]
};
var faSignHanging = {
  prefix: 'fass',
  iconName: 'sign-hanging',
  icon: [512, 512, ["sign"], "f4d9", "M128 0l0 64 384 0 0 64-384 0 0 384-64 0 0-384-64 0 0-64 64 0 0-64 64 0zM480 176l0 208-304 0 0-208 304 0z"]
};
var faSign = faSignHanging;
var faCircle8 = {
  prefix: 'fass',
  iconName: 'circle-8',
  icon: [512, 512, [], "e0f5", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 212c0-37.6 30.4-68 68-68l24 0c37.6 0 68 30.4 68 68 0 14.7-4.6 28.2-12.5 39.3 12.7 12.3 20.5 29.6 20.5 48.7 0 37.6-30.4 68-68 68l-40 0c-37.6 0-68-30.4-68-68 0-19.1 7.9-36.3 20.5-48.7-7.9-11.1-12.5-24.7-12.5-39.3zm112 0c0-11-9-20-20-20l-24 0c-11 0-20 9-20 20s9 20 20 20l24 0c11 0 20-9 20-20zm-52 68c-11 0-20 9-20 20s9 20 20 20l40 0c11 0 20-9 20-20s-9-20-20-20l-40 0z"]
};
var faCarBattery = {
  prefix: 'fass',
  iconName: 'car-battery',
  icon: [512, 512, ["battery-car"], "f5df", "M80 32l128 0 0 32 96 0 0-32 128 0 0 32 80 0 0 384-512 0 0-384 80 0 0-32zM392 184l0-24-48 0 0 56-56 0 0 48 56 0 0 56 48 0 0-56 56 0 0-48-56 0 0-32zM64 216l0 48 160 0 0-48-160 0z"]
};
var faBatteryCar = faCarBattery;
var faShirt = {
  prefix: 'fass',
  iconName: 'shirt',
  icon: [640, 512, [128085, "t-shirt", "tshirt"], "f553", "M320 112c44.2 0 80-35.8 80-80l80 0 160 160-96 96-64-64 0 288-320 0 0-288-64 64-96-96 160-160 80 0c0 44.2 35.8 80 80 80z"]
};
var faTShirt = faShirt;
var faTshirt = faShirt;
var faParagraph = {
  prefix: 'fass',
  iconName: 'paragraph',
  icon: [448, 512, [182], "f1dd", "M160 0l288 0 0 64-64 0 0 448-64 0 0-448-48 0 0 448-64 0 0-192-48 0C71.6 320 0 248.4 0 160S71.6 0 160 0z"]
};
var faEnvelopesBulk = {
  prefix: 'fass',
  iconName: 'envelopes-bulk',
  icon: [576, 512, ["mail-bulk"], "f674", "M448 0l0 80-304 0 0 128-80 0 0-208 384 0zM192 160l0-32 384 0 0 288-208 0 0-208-176 0 0-48zm320 32l-96 0 0 96 96 0 0-96zM320 256l0 58.3-160 84-160-84 0-58.3 320 0zm0 112.6l0 143.4-320 0 0-143.4 148.8 78.2 11.2 5.9 11.2-5.9 148.8-78.2z"]
};
var faMailBulk = faEnvelopesBulk;
var faFileDoc = {
  prefix: 'fass',
  iconName: 'file-doc',
  icon: [576, 512, [], "e5ed", "M272 0l-240 0 0 512 144 0 0-176 240 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM240 380l-20 0 0 168 52 0c28.7 0 52-23.3 52-52l0-64c0-28.7-23.3-52-52-52l-32 0zm20 128l0-88 12 0c6.6 0 12 5.4 12 12l0 64c0 6.6-5.4 12-12 12l-12 0zM392 380c-24.3 0-44 19.7-44 44l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-80c0-24.3-19.7-44-44-44l-16 0zm-4 44c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 80c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80zm88 0l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-16-40 0 0 16c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 16 40 0 0-16c0-24.3-19.7-44-44-44l-16 0c-24.3 0-44 19.7-44 44z"]
};
var faGuitar = {
  prefix: 'fass',
  iconName: 'guitar',
  icon: [512, 512, [], "f7a6", "M376 64l-8.9 35.7-82.5 82.5c-45.1-29.4-99.3-30.2-131 1.6-11 11-18 24.6-21.4 39.6-3.7 16.6-19.1 30.7-36.1 31.6-25.6 1.3-49.3 10.7-67.3 28.6-44.8 44.8-36.4 125.8 18.7 180.9S183.6 528 228.4 483.2c17.9-17.9 27.4-41.7 28.6-67.3 .9-17 15-32.3 31.6-36.1 15-3.4 28.6-10.5 39.6-21.4 31.8-31.8 31-85.9 1.6-131l82.5-82.5 35.7-8.9 64-72-64-64-72 64zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faFlyingDisc = {
  prefix: 'fass',
  iconName: 'flying-disc',
  icon: [448, 512, [], "e3a9", "M23.7 456.3c-20.7-20.7-27.3-52.3-21.9-89.7 2 3 4.2 5.9 6.7 8.7l3.5 3.7 3.7 3.5c18.9 16.7 42.3 21.9 62.7 21.7 21.6-.2 43.6-6.1 64.2-14.5 41.4-17 86.2-48.3 126.4-88.6s71.5-85 88.6-126.4c8.5-20.6 14.4-42.6 14.5-64.2 .2-21.8-5.7-46.9-25.2-66.4-3.9-3.9-8.1-7.3-12.4-10.2 37.4-5.5 69.1 1.2 89.7 21.9 55.3 55.3 10.5 189.8-100.2 300.5S79 511.6 23.7 456.3zM235.1 267.1C161.4 340.9 76.7 375.8 45.9 345s4.1-115.4 77.9-189.2 158.4-108.6 189.2-77.9-4.1 115.4-77.9 189.2z"]
};
var faSuitcase = {
  prefix: 'fass',
  iconName: 'suitcase',
  icon: [512, 512, [129523], "f0f2", "M168 0l-24 0 0 480 224 0 0-480-200 0zM416 96l0 384 96 0 0-384-96 0zM0 96l0 384 96 0 0-384-96 0zm320 0l-128 0 0-48 128 0 0 48z"]
};
var faCircleUp = {
  prefix: 'fass',
  iconName: 'circle-up',
  icon: [512, 512, [61467, "arrow-alt-circle-up"], "f35b", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM128 256l0-8 128-128 128 128 0 8-80 0 0 128-96 0 0-128-80 0z"]
};
var faArrowAltCircleUp = faCircleUp;
var faF = {
  prefix: 'fass',
  iconName: 'f',
  icon: [320, 512, [102], "46", "M32 32l-32 0 0 448 64 0 0-192 192 0 0-64-192 0 0-128 256 0 0-64-288 0z"]
};
var faXmarksLines = {
  prefix: 'fass',
  iconName: 'xmarks-lines',
  icon: [640, 512, [], "e59a", "M32 32l-32 0 0 64 640 0 0-64-608 0zm0 384l-32 0 0 64 640 0 0-64-608 0zM57 183L40 166.1 6.1 200c7.6 7.6 26.3 26.3 56 56-29.7 29.7-48.4 48.4-56 56L40 345.9c7.6-7.6 26.3-26.3 56-56 29.7 29.7 48.4 48.4 56 56L185.9 312c-7.6-7.6-26.3-26.3-56-56l56-56-33.9-33.9c-7.6 7.6-26.3 26.3-56 56L57 183zm224 0l-17-17-33.9 33.9 56 56c-29.7 29.7-48.4 48.4-56 56L264 345.9c7.6-7.6 26.3-26.3 56-56 29.7 29.7 48.4 48.4 56 56L409.9 312c-7.6-7.6-26.3-26.3-56-56 29.7-29.7 48.4-48.4 56-56L376 166.1c-7.6 7.6-26.3 26.3-56 56l-39-39zm224 0l-17-17-33.9 33.9c7.6 7.6 26.3 26.3 56 56-29.7 29.7-48.4 48.4-56 56L488 345.9c7.6-7.6 26.3-26.3 56-56 29.7 29.7 48.4 48.4 56 56L633.9 312c-7.6-7.6-26.3-26.3-56-56 29.7-29.7 48.4-48.4 56-56L600 166.1c-7.6 7.6-26.3 26.3-56 56l-39-39z"]
};
var faHashtagLock = {
  prefix: 'fass',
  iconName: 'hashtag-lock',
  icon: [640, 512, [], "e415", "M186.7 128l27.4-128 65.5 0-27.4 128 126.5 0 27.4-128 65.5 0-27.4 128 99.9 0-10.3 48.1c-1.9-.1-3.8-.1-5.8-.1-22.5 0-43.6 5.8-62 16l-35.6 0-8.7 40.6C408 253 400 277.6 400 304l-32 0 0 179.4-6.1 28.6-65.5 0 27.4-128-126.5 0-27.4 128-65.5 0 27.4-128-99.9 0 13.7-64 99.9 0 27.4-128-99.9 0 13.7-64 99.9 0zm51.7 64l-27.4 128 126.5 0 27.4-128-126.5 0zM528 272c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
var faGarageOpen = {
  prefix: 'fass',
  iconName: 'garage-open',
  icon: [576, 512, [], "e00b", "M0 512l0-416 288-96 288 96 0 416-64 0 0-320-448 0 0 320-64 0zM207.1 240l175.7 0 0 0 81.2 0 0 48-352 0 0-48 81.2 0 0 0 13.9 0zm230.8 96c5.2 9.1 8.6 15 10.1 17.6l0 158.4-64 0 0-48-192 0 0 48-64 0 0-158.4c1.5-2.6 4.9-8.5 10.1-17.6l299.8 0zM208 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faGasPumpLeft = {
  prefix: 'fass',
  iconName: 'gas-pump-left',
  icon: [640, 512, [], "e778", "M192 0l288 0 0 256 80 0 0 112 32 0 0-176-48 0 0-91.5c-18.8-20.7-32.7-36-41.9-46.1l35.5-32.3 16.1 17.8 80 88 6.2 6.9 0 281.3-128 0 0-112-32 0 0 208-288 0 0-512zm64 64l0 128 160 0 0-128-160 0zM0 256l128-96 0 192-128-96z"]
};
var faPumpImpeller = {
  prefix: 'fass',
  iconName: 'pump-impeller',
  icon: [512, 512, [], "e835", "M374.2 356l5.3 53.5 1.1 11.1-6 9.3c-29.9 46.5-48.7 75.9-56.5 88.1l-53.9-34.6c8.9-13.8 25.7-40.1 50.5-78.8-2.9-30.1-5.3-54.8-7.3-74.3l63.7-6.2 3.1 31.8zm-85 29.5c-11.2 13.7-29.4 35.8-54.4 66.3l-7.1 8.6-10.8 2.3c-54 11.8-88.1 19.2-102.3 22.3l-13.7-62.5c16-3.5 46.5-10.2 91.4-20 19.2-23.3 35-42.5 47.4-57.7l49.4 40.6zM410.3 243.2l41.6 34.1 8.6 7.1 2.3 10.8c11.8 54 19.2 88.1 22.3 102.3l-62.5 13.7c-3.5-16-10.2-46.5-20-91.4-23.3-19.2-42.5-35-57.7-47.4l40.6-49.4 24.7 20.3zM55.5 281.3l51.8 33.3c30.1-2.9 54.8-5.3 74.3-7.3l6.2 63.7c-17.6 1.7-46.1 4.5-85.4 8.4l-11.1 1.1-9.3-6-61.2-39.3-26.9-17.2 34.6-53.9 26.9 17.3zM255.9 296a40 40 0 1 1 .1-80 40 40 0 1 1 -.1 80zM96.3 132.1l13.2 60.2c23.3 19.2 42.5 35 57.7 47.4l-40.6 49.4c-13.7-11.2-35.8-29.4-66.3-54.4l-8.6-7.1-2.3-10.8c-11.8-54-19.2-88.1-22.3-102.3l62.5-13.7 6.8 31.3zM430 137.6c46.5 29.9 75.9 48.7 88.1 56.5L483.6 248c-13.8-8.9-40.1-25.7-78.8-50.5-30.1 2.9-54.8 5.3-74.3 7.2L324.3 141c17.6-1.7 46.1-4.5 85.4-8.4l11.1-1.1 9.3 6zM248 28.5c-8.9 13.8-25.7 40.1-50.5 78.8 2.9 30.1 5.3 54.8 7.2 74.3l-63.7 6.2c-1.7-17.6-4.5-46.1-8.4-85.4l-1.1-11.1 6-9.3c29.9-46.5 48.7-75.9 56.5-88.1L248 28.5zM411.3 89.4c-16 3.5-46.5 10.2-91.4 20-19.2 23.3-35 42.5-47.4 57.7L223 126.5c11.2-13.7 29.4-35.8 54.4-66.3l7.1-8.6 10.8-2.3c54-11.8 88.1-19.2 102.3-22.3l13.7 62.5z"]
};
var faBasketShoppingPlus = {
  prefix: 'fass',
  iconName: 'basket-shopping-plus',
  icon: [576, 512, [], "e653", "M288-10.9l17.4 18.4 144 152 .5 .5 110.1 0 0 64-23.1 0-56.9 256-384 0-56.9-256-23.1 0 0-64 110.1 0 .5-.5 144-152 17.4-18.4zm0 69.8L192.2 160 383.8 160 288 58.9zM264 416l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faHandFingersCrossed = {
  prefix: 'fass',
  iconName: 'hand-fingers-crossed',
  icon: [384, 512, [], "e1a3", "M101 35.6l-13.5-29-58 27.1C35.4 46.4 50.6 78.9 75 131.3l35.3-75.7-9.4-20.1zM165.6 240l26.4 0 0-9.4-11-23.7-15.4 33zM288 320l-64 0 0 64-144 0 0-32 112 0 0-80-192 0 0 91c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c30 30 70.7 46.9 113.1 46.9l61.7 0c88.4 0 160-71.6 160-160l-96 0 0-32zM212.9 63l13.5-29-58-27.1-13.5 29-95.2 204.1 70.6 0 82.6-177zM224 160l0 128 64 0 0-128-64 0zm96 32l0 128 64 0 0-128-64 0z"]
};
var faBrainArrowCurvedRight = {
  prefix: 'fass',
  iconName: 'brain-arrow-curved-right',
  icon: [640, 512, ["mind-share"], "f677", "M184 56c0-30.9 25.1-56 56-56l56 0 0 365.9c-5.2 15.8-8 32.6-8 50.1 0 17.3 3.1 33 8 46.9l0 49.1-64 0c-29.8 0-54.9-20.4-62-48-.7 0-1.3 0-2 0-44.2 0-80-35.8-80-80 0-18 6-34.6 16-48-19.4-14.6-32-37.8-32-64 0-30.9 17.6-57.8 43.2-71.1-7.1-12-11.2-26-11.2-40.9 0-44.2 35.8-80 80-80l0-24zM464 192l0 64-16 0c-39.7 0-76 14.5-104 38.4L344 0 400 0c30.9 0 56 25.1 56 56l0 24c44.2 0 80 35.8 80 80 0 11.4-2.4 22.2-6.7 32L464 192zm64 48l112 112-112 112-16 0 0-64-48 0c-35.3 0-64 28.7-64 64l0 48s-64-32-64-96c0-61.9 50.1-112 112-112l64 0 0-64 16 0z"]
};
var faMindShare = faBrainArrowCurvedRight;
var faPersonSign = {
  prefix: 'fass',
  iconName: 'person-sign',
  icon: [640, 512, [], "f757", "M152.3 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm40 312l0 208-64 0 0-305.5c-35.6 46.5-57.6 75.3-66 86.3l-50.8-38.9 19.4-25.4 104-136 9.6-12.6 127.2 0 9.6 12 59.6 74.5 57.7 28.9 4.8 2.4 18.6-51-82.3-29.9 54.7-150.4 82.3 29.9c2.5-6.8 6.7-18.5 12.8-35.2L534.7 9.7c-6.1 16.7-10.3 28.4-12.8 35.2l83.1 30.2-54.7 150.4-83.1-30.2-44.6 122.6-8.2 22.6-45.1-16.4c6.2-16.9 10.3-28.2 12.3-33.7l-11.4-5.7-64-32-6.3-3.1c-2.5-3.1-6.3-7.9-11.4-14.3l0 308.8-64 0 0-208-32 0z"]
};
var faCircleTrash = {
  prefix: 'fass',
  iconName: 'circle-trash',
  icon: [512, 512, ["trash-circle"], "e126", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM224 112l80.2 0c3.9 9.8 8.2 20.4 12.8 32l67 0 0 48-256 0 0-48 67 0c4.6-11.6 8.9-22.2 12.8-32l16.2 0zM176 384l-16-144 192 0-16 144-160 0z"]
};
var faTrashCircle = faCircleTrash;
var faEarthOceania = {
  prefix: 'fass',
  iconName: 'earth-oceania',
  icon: [512, 512, ["globe-oceania"], "e47b", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM411.3 379.3c-24.8 24.8-39.2 39.2-43.3 43.3L345.4 400c4.1-4.1 18.5-18.5 43.3-43.3l11.3-11.3 22.6 22.6-11.3 11.3zM288 416l0 32-64 0 0-32 64 0zM448 256l0 64-32 0 0-64 32 0zM192 160l0-32 96 0 0 64-64 0-32-32zM96 352l0-64 64-64 32 0 0 32 32 0 0-32 32 0 64 64 0 96-96 0-32-32-96 0z"]
};
var faGlobeOceania = faEarthOceania;
var faUTurnUpLeft = {
  prefix: 'fass',
  iconName: 'u-turn-up-left',
  icon: [512, 512, [], "e7f5", "M512 272c0-114.9-93.1-208-208-208l-144 0 0-96-160 160 160 160 0-96 144 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-240 0 0 128 240 0c114.9 0 208-93.1 208-208z"]
};
var faCommentSlash = {
  prefix: 'fass',
  iconName: 'comment-slash',
  icon: [576, 512, [], "f4b3", "M49.3-17l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-88.7-88.7c44.3-43.1 71.5-101.8 71.5-166.4 0-132.5-114.6-240-256-240-63 0-120.7 21.3-165.3 56.7L49.3-17zM32.1 239.9c0 56.5 20.8 108.5 55.7 149.5L32.1 511.9 180.8 457.8c32.6 14.2 69 22.1 107.3 22.1 36.4 0 70.9-7.1 102.3-19.9L60.5 130.1C42.4 163 32.1 200.3 32.1 239.9z"]
};
var faPlay = {
  prefix: 'fass',
  iconName: 'play',
  icon: [512, 512, [9654], "f04b", "M64 16L64 496 496 256 64 16z"]
};
var faUserDashed = {
  prefix: 'fass',
  iconName: 'user-dashed',
  icon: [448, 512, [], "e7ac", "M224 256c-14.7 0-28.9-2.5-42.1-7.1l33.2-57.5c2.9 .4 5.9 .6 8.9 .6s6-.2 8.9-.6l33.2 57.5c-13.2 4.6-27.4 7.1-42.1 7.1zm-83.7-31.1c-21.4-18.5-36.6-44-42.1-72.9l66.4 0c2.2 5.6 5.3 10.7 8.9 15.4l-33.2 57.5zM283.3 104c-2.2-5.6-5.3-10.7-8.9-15.4l33.2-57.5c21.4 18.5 36.6 44 42.1 72.9l-66.4 0zM232.9 64.6c-2.9-.4-5.9-.6-8.9-.6s-6 .2-8.9 .6L181.9 7.1C195.1 2.5 209.3 0 224 0s28.9 2.5 42.1 7.1L232.9 64.6zM98.2 104c5.5-28.9 20.7-54.4 42.1-72.9l33.2 57.5c-3.6 4.7-6.6 9.8-8.9 15.4l-66.4 0zM307.7 224.9l-33.2-57.5c3.6-4.7 6.6-9.8 8.9-15.4l66.4 0c-5.5 28.9-20.7 54.4-42.1 72.9zM144 304l0 64-14.1 0-53.3-64 67.4 0zm48 64l0-64 64 0 0 64-64 0zm112-64l67.4 0-53.3 64-14.1 0 0-64zm93.5 43.7l21 68.3-66.5 0 0 1.6-3.4-11.2 5.9-7.1 43-51.6zM433.2 464l14.8 48-67 0-14.8-48 67 0zM99.4 406.4l-3.4 11.2 0-1.6-66.5 0 21-68.3 43 51.6 5.9 7.1zM81.7 464l-14.8 48-67 0 14.8-48 67 0z"]
};
var faHouseWindow = {
  prefix: 'fass',
  iconName: 'house-window',
  icon: [512, 512, [], "e3b3", "M512 272l-48 0 0 240-416 0 0-240-48 0 0-48 256-240 256 240 0 48zM320 352l0-128-128 0 0 128 128 0z"]
};
var faVialCircleCheck = {
  prefix: 'fass',
  iconName: 'vial-circle-check',
  icon: [512, 512, [], "e596", "M32 0l288 0 0 64-32 0 0 161.4c-66.1 30.3-112 97.1-112 174.6 0 39.7 12 76.6 32.7 107.2-10.3 3.1-21.3 4.8-32.7 4.8-61.9 0-112-50.1-112-112l0-336-32 0 0-64zm96 64l0 128 96 0 0-128-96 0zm96 336a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.4-51.5l-25.9-18.8-9.4 12.9-53 72.9C329.7 395 317 382.3 312 377.4L289.4 400c2.8 2.8 19.9 19.9 51.3 51.3l13.2 13.2 11-15.1 64-88 9.4-12.9z"]
};
var faBridgeCircleCheck = {
  prefix: 'fass',
  iconName: 'bridge-circle-check',
  icon: [576, 512, [], "e4c9", "M32 32l-32 0 0 64 40 0 0 64-40 0 0 112c37.6 9.4 64 43.2 64 82l0 126 96 0 0-96c0-53 43-96 96-96 6.4 0 12.7 .6 18.7 1.8 34.7-49.5 92.2-81.8 157.3-81.8 28.6 0 55.6 6.2 80 17.4l0-65.4-40 0 0-64 40 0 0-64-480 0zM424 96l0 64-80 0 0-64 80 0zM296 96l0 64-80 0 0-64 80 0zM88 96l80 0 0 64-80 0 0-64zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L353.4 400 376 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z"]
};
var faCediSign = {
  prefix: 'fass',
  iconName: 'cedi-sign',
  icon: [384, 512, [], "e0df", "M232.5 32l0-24-48 0 0 50.5C89.2 73.9 16.5 156.4 16.5 256s72.8 182.1 168 197.5l0 50.5 48 0 0-48.6c58.9-4.7 110.5-34.8 144-79.3l-51.2-38.4c-21.8 29.1-55 49-92.8 53.5l0-270.1c37.9 4.4 71 24.4 92.8 53.5L376.5 136c-33.4-44.5-85.1-74.7-144-79.3l0-24.6zm-48 91.8l0 264.4c-59.7-14.4-104-68.1-104-132.2s44.3-117.8 104-132.2z"]
};
var faHatSanta = {
  prefix: 'fass',
  iconName: 'hat-santa',
  icon: [576, 512, [], "f7a7", "M464 336l-352 0 112-336 192 0-48 48 96 288zm64 144l-480 0 0-96 480 0 0 96zM519.3 23.8l33.3-.4-.4 33.3 23.8 23.3-23.8 23.3 .4 33.3-33.3-.4-23.3 23.8-23.3-23.8-33.3 .4 .4-33.3-23.8-23.3 23.8-23.3-.4-33.3 33.3 .4 23.3-23.8 23.3 23.8z"]
};
var faPuzzlePiece = {
  prefix: 'fass',
  iconName: 'puzzle-piece',
  icon: [512, 512, [129513], "f12e", "M192 89.6c-19.1-8.3-32-23.8-32-41.6 0-26.5 28.7-48 64-48s64 21.5 64 48c0 17.8-12.9 33.3-32 41.6l0 38.4 128 0 0 128 38.4 0c8.3-19.1 23.8-32 41.6-32 26.5 0 48 28.7 48 64s-21.5 64-48 64c-17.8 0-33.3-12.9-41.6-32l-38.4 0 0 192-128 0 0-38.4c19.1-8.3 32-23.8 32-41.6 0-26.5-28.7-48-64-48s-64 21.5-64 48c0 17.8 12.9 33.3 32 41.6l0 38.4-192 0 0-192 38.4 0c8.3 19.1 23.8 32 41.6 32 26.5 0 48-28.7 48-64s-21.5-64-48-64c-17.8 0-33.3 12.9-41.6 32l-38.4 0 0-128 192 0 0-38.4z"]
};
var faHelmetUn = {
  prefix: 'fass',
  iconName: 'helmet-un',
  icon: [512, 512, [], "e503", "M479.5 224C471.2 98.9 367.2 0 240 0 107.5 0 0 107.5 0 240l0 144 214.9 0 128.6 121.4c4.5 4.2 10.4 6.6 16.5 6.6l120 0 0-48-110.5 0-1.5-1.5 0-174.5 144 0 0-64-32.5 0zM320 417.2l-78-73.7 32.4-55.5 45.6 0 0 129.2zM160 112l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 32 0 0 80c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-80 32 0 0 16zM272 96l17.9 0 4.4 8.8 25.7 51.4 0-60.2 32 0 0 128-33.9 0-4.4-8.8-25.7-51.4 0 60.2-32 0 0-128 16 0z"]
};
var faGlassWater = {
  prefix: 'fass',
  iconName: 'glass-water',
  icon: [384, 512, [], "e4f4", "M76.6 158.3l-7.4-94.3 245.6 0-7.4 94.3-20.6 10.3c-19.4 9.7-42.2 9.7-61.6 0-20.9-10.4-45.5-10.4-66.4 0-19.4 9.7-42.2 9.7-61.6 0L76.6 158.3zM40 512l304 0 35-448 5-64-384 0 40 512z"]
};
var faPenFancySlash = {
  prefix: 'fass',
  iconName: 'pen-fancy-slash',
  icon: [576, 512, [], "e210", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-214.8-214.8 213.7-200.3-96-96-200.3 213.7-214.5-214.5zM96.1 288l-52.7 184.4 84.9-84.9c-.1-1.2-.2-2.3-.2-3.5 0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32c-1.2 0-2.4-.1-3.5-.2L71.7 500.7 256.1 448 289.4 359.1 185 254.7 96.1 288z"]
};
var faHeartCircleBolt = {
  prefix: 'fass',
  iconName: 'heart-circle-bolt',
  icon: [576, 512, [], "e4fc", "M133.1 32C175.8 32 216 52.5 241 87.1l15 20.7 15-20.7c25-34.6 65.2-55.1 107.9-55.1 73.5 0 133.1 59.6 133.1 133.1 0 19.2-3 38.1-8.5 56.6-22.1-8.9-46.2-13.8-71.5-13.8-106 0-192 86-192 192 0 33 8.3 64 23 91.2-2.4 1.6-4.7 3.3-7 4.8-102.5-70.7-256-194.1-256-330.9 0-73.5 59.6-133.1 133.1-133.1zM432 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM336 416l70.9 0-22.9 80 144-112-70.9 0 22.9-80-144 112z"]
};
var faFireHydrant = {
  prefix: 'fass',
  iconName: 'fire-hydrant',
  icon: [384, 512, [], "e17f", "M224 32l0 4c45 11.6 80.4 47 92 92l36 0 0 48-320 0 0-48 36 0c11.6-45 47-80.4 92-92l0-36 64 0 0 32zM32 464l32 0 0-64-48 0 0-128 48 0 0-64 256 0 0 64 48 0 0 128-48 0 0 64 32 0 0 48-320 0 0-48zm160-64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faMemoCircleCheck = {
  prefix: 'fass',
  iconName: 'memo-circle-check',
  icon: [576, 512, [], "e1d9", "M416 0l-384 0 0 512 244 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3L416 0zM128 128l192 0 0 48-192 0 0-48zm0 96l112 0 0 48-112 0 0-48zm0 96l80 0 0 48-80 0 0-48zm448 80a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L353.4 400 376 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z"]
};
var faPumpSoap = {
  prefix: 'fass',
  iconName: 'pump-soap',
  icon: [320, 512, [], "e06b", "M96-32l0 112 128 0 0-24 96 0 0-48-96 0 0-40-128 0zM320 128l-320 0 0 384 320 0 0-384zM224 344c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-40.8 36-84 64-112 28 28 64 71.2 64 112z"]
};
var faHandScissors = {
  prefix: 'fass',
  iconName: 'hand-scissors',
  icon: [512, 512, [], "f257", "M40 208l-40 0 0 80 208 0 0 80 32 0 0 80 144 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3-22.8-22.8-53.6-35.6-85.8-35.6l-93.7 0 0 32.3 76.9 24.5 15.2 4.9-9.7 30.5c-1.5-.5-29-9.2-82.4-26.2l0 .1C144.3 84.8 71.6 62 69.8 61.4l-24 76.3c.9 .3 75.5 23.7 223.7 70.3L40 208z"]
};
var faSandwich = {
  prefix: 'fass',
  iconName: 'sandwich',
  icon: [512, 512, [129386], "f81f", "M0 64l512 0 0 112-512 0 0-112zM320 384l96-48 96 0 0 112-512 0 0-112 224 0 96 48zM144.2 209.1l111.8 29.8 111.8-29.8 8-2.1 8 2c74.8 18.7 117.2 29.3 127 31.8l-15.5 62.1c-11.2-2.8-50.9-12.7-119-29.8l-112 29.9-8.2 2.2-8.2-2.2-112-29.9c-68.1 17-107.8 27-119 29.8L1.2 240.7c9.9-2.5 52.2-13.1 127-31.8l8-2 8 2.1z"]
};
var faDolly = {
  prefix: 'fass',
  iconName: 'dolly',
  icon: [640, 512, ["dolly-box"], "f472", "M64.5 0l-32 0 0 64 104.9 0 92.1 276.2c-22.5 17.6-37 45-37 75.8 0 53 43 96 96 96 52.4 0 95.1-42 96-94.3l202.1-67.4 30.4-10.1-20.2-60.7-30.4 10.1-202.1 67.4c-17.2-22.1-43.9-36.5-74-37L190.8 21.9 183.5 0 64.5 0zm176 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm26.9-311.9l55.9 172.1c20.5 5.1 39.2 14.5 55.1 27.3l171.2-55.6-69.2-213-213 69.2z"]
};
var faDollyBox = faDolly;
var faPaperclip = {
  prefix: 'fass',
  iconName: 'paperclip',
  icon: [512, 512, [128206], "f0c6", "M224.6 12.8c56.2-56.2 147.4-56.2 203.6 0s56.2 147.4 0 203.6l-164 164c-34.4 34.4-90.1 34.4-124.5 0s-34.4-90.1 0-124.5l152.7-152.7 22.6-22.6 45.3 45.3-22.6 22.6-152.7 152.7c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l164-164c31.2-31.2 31.2-81.9 0-113.1s-81.9-31.2-113.1 0l-164 164c-53.1 53.1-53.1 139.2 0 192.3s139.2 53.1 192.3 0l130.1-130.1 22.6-22.6 45.3 45.3-22.6 22.6-130.1 130.1c-78.1 78.1-204.7 78.1-282.8 0s-78.1-204.7 0-282.8l164-164z"]
};
var faMeterFire = {
  prefix: 'fass',
  iconName: 'meter-fire',
  icon: [640, 512, [], "e1eb", "M272 383.8C272 432.2 288.5 476.7 316.1 512 176.5 509.9 64 396.1 64 256 64 114.6 178.6 0 320 0 434.2 0 530.9 74.7 563.9 177.9l-22.8-19-29.1 29.1-57.1-57.1-32.4 20.2c-25.4 15.9-61.7 45-92.1 83.2-30.2 37.9-58.5 89.6-58.5 149.5zm72-236l0-19.8-48 0 0 69.7c15.4-18.8 31.9-35.6 48-49.9zM248 128l-48 0 0 96 48 0 0-96zm200 64l64 64 32-32c76.8 64 96 133.3 96 160 0 88.4-71.6 160-160 160S320 472.4 320 384c0-89.6 85.3-165.3 128-192zm96 240.2c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faDemocrat = {
  prefix: 'fass',
  iconName: 'democrat',
  icon: [640, 512, [], "f747", "M64 32C64 12.1 80 0 80 0L128 45.7 176 0s16 12.1 16 32c0 26.5-21.9 42-29.5 46.6L248 160c412.3 0 263.7 0 310.3 0l9.5 10.6 72 80-47.6 42.8-49.4-54.9 1.2 1.5 0 80-352 0-48-112-72 48-72-72 87.6-109.4C78.1 67.4 64 53.2 64 32zM544 352l0 160-96 0 0-96-160 0 0 96-96 0 0-160 352 0zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM368 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSquareArrowUpRight = {
  prefix: 'fass',
  iconName: 'square-arrow-up-right',
  icon: [448, 512, ["external-link-square"], "f14c", "M0 32l448 0 0 448-448 0 0-448zM184 208l54.1 0-103 103-17 17 33.9 33.9 17-17 103-103 0 78.1 48 0 0-160-160 0 0 48 24 0z"]
};
var faExternalLinkSquare = faSquareArrowUpRight;
var faSquareExclamation = {
  prefix: 'fass',
  iconName: 'square-exclamation',
  icon: [448, 512, ["exclamation-square"], "f321", "M448 480l-448 0 0-448 448 0 0 448zM196 324l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0z"]
};
var faExclamationSquare = faSquareExclamation;
var faWave = {
  prefix: 'fass',
  iconName: 'wave',
  icon: [512, 512, [], "e65b", "M334 271c-21.9 8.8-45.8-7.4-45.8-31 0-44.2 35.8-80 80-80 21.5 0 41 8.5 55.4 22.3l38.6-27.1C429.8 82.7 356.9 32 272.2 32 157.3 32 64.2 125.1 64.2 240l0 43C33.8 295.1 12.8 303.5 1 308.2l17.8 44.6c25-10 114.7-45.9 117.4-47l111.1 44.4 8.9 3.6 8.9-3.6 86.7-34.7 0 0 24.4-9.7c75.5 30.2 114.6 45.9 117.4 46.9l17.8-44.6-22.3-8.9-104-41.6-8.9-3.6c-1.9 .8-15.9 6.4-42.2 16.9l0 0zM136.2 382.2l-8.9 3.6C44.3 418.9 2.2 435.7 1 436.2l17.8 44.6c2.7-1.1 41.8-16.7 117.4-47l111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4c75.5 30.2 114.6 45.9 117.4 46.9l17.8-44.6c-1.2-.5-43.3-17.3-126.3-50.5l-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4-8.9-3.6z"]
};
var faFerry = {
  prefix: 'fass',
  iconName: 'ferry',
  icon: [640, 512, [], "e4ea", "M224.4 0l192 0 0 64 128 0 0 256-37.7 69.1c-28.5-11.4-50.6-20.2-66.3-26.5l-26.7 10.7-93.3 37.3-93.2-37.3-26.8-10.7c-15.7 6.3-37.8 15.1-66.3 26.5l-37.7-69.1 0-256 128 0 0-64zm-64 256l320 0 0-128-320 0 0 128zm48.9 161.7l111.1 44.4 111.1-44.4 8.9-3.6 8.9 3.6 111.8 44.7c29.3-9.7 50.1-16.7 62.4-20.8l15.2 45.5c-11 3.7-34.6 11.5-70.8 23.6l-8.3 2.8-8.2-3.3-111.1-44.4-111.1 44.4-8.9 3.6-8.9-3.6-111.1-44.4-111.1 44.4-8.2 3.3-8.3-2.8C36.6 498.7 13 490.8 2 487.2l15.2-45.5c12.4 4.1 33.2 11.1 62.4 20.8l111.8-44.7 8.9-3.6 8.9 3.6z"]
};
var faMosquito = {
  prefix: 'fass',
  iconName: 'mosquito',
  icon: [576, 512, [], "e52b", "M127.3 487.3c4.6-7.4 21-33.6 49-78.5l0-41 0-8.3 4.9-6.6 39.3-52.2-66.2 59.5c-17 15.3-39 23.7-61.9 23.8l-8.1 0c-46.6 0-84.4-37.8-84.4-84.4 0-43 32.4-79.2 75.1-83.9l130.5-14.5c-35.4-30.3-54.1-46.3-56.2-48.2l3.8-14.9 13.3-53.4c-19.4-29-32.5-48.7-39.3-59l39-27.5c5.8 8.7 20.9 31.4 45.3 68.1l6.1 9.1-2.7 10.7-12.3 49.2 53.3 45.7 0-60.8 16 0 0-72.2 32 0 0 72.2 16 0 0 60.9 53.4-45.7-12.3-49.2-2.7-10.7 6.1-9.1c24.4-36.7 39.5-59.3 45.3-68.1l39 27.5c-6.8 10.3-19.9 29.9-39.3 59l13.3 53.4 3.8 14.9-11.5 9.9-44.7 38.3 130.4 14.5c42.8 4.8 75.1 40.9 75.1 83.9 0 46.6-37.8 84.4-84.4 84.4l-8.1 0c-22.8 0-44.9-8.5-61.9-23.8l-66.1-59.5 39.2 52.2 5 6.6 0 49.3 36.2 58 12.8 20.5-39.8 26.3-12.8-20.5-40-64-3.8-6 0-47-32.4-43.1 0 106.7-64 0 0-106.6-32.3 43 0 47-3.8 6-40 64-12.8 20.5-39.8-26.3z"]
};
var faHexagonMinus = {
  prefix: 'fass',
  iconName: 'hexagon-minus',
  icon: [576, 512, ["minus-hexagon"], "f307", "M13.5 256.1l6.8-11.9 123.7-216.1 6.9-12.1 275.1 0 6.9 12.1 123.7 216.1 6.8 11.9-6.8 11.9-123.7 216.1-6.9 12.1-275.1 0-6.9-12.1-123.7-216.1-6.8-11.9zm187-24.1l-24 0 0 48 224 0 0-48-200 0z"]
};
var faMinusHexagon = faHexagonMinus;
var faBuildingCircleArrowRight = {
  prefix: 'fass',
  iconName: 'building-circle-arrow-right',
  icon: [576, 512, [], "e4d1", "M32 0l384 0 0 208.7c-35.7 2.9-68.5 15.6-96 35.4l0-20-64 0 0 64 20 0c-13.7 19-24 40.7-30 64l-70 0 0 112 74.9 0c6.1 17.3 14.6 33.4 25.1 48L32 512 32 0zM192 96l-64 0 0 64 64 0 0-64zm64 0l0 64 64 0 0-64-64 0zM192 224l-64 0 0 64 64 0 0-64zm96 176a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-78.6L417.4 344c4.6 4.6 18 18 40 40l-105.4 0 0 32 105.4 0c-22 22-35.4 35.4-40 40l22.6 22.6 11.3-11.3 56-56 11.3-11.3-11.3-11.3-56-56-11.3-11.3z"]
};
var faFaceHandPeeking = {
  prefix: 'fass',
  iconName: 'face-hand-peeking',
  icon: [640, 512, [129763], "e481", "M430.4 487c-33.4 16-70.9 25-110.4 25-91.4 0-171.6-47.9-216.9-120 37.2-.3 72.7-15.2 99-41.5 63.8-63.8 100.6-100.6 110.5-110.5-20.3-20.3-36.3-36.3-48-48l3.7-3.7 28.3-28.3c-41.8-41.8-76.9-76.9-88.6-88.6l-16 16C177.5 73 167 62.4 160.4 55.8 204.2 20.9 259.6 0 320 0 453.3 0 562.8 101.9 574.9 232l-30.3 0-69.1-67.3-.1-.1c-32.8-32.8-86-32.8-118.8 0s-32.8 86 0 118.8c1.2 1.2 2.5 2.4 3.8 3.6l-17 17 32 32-22.7 22.7c-9.6-4.3-20.8-6.7-32.7-6.7-35.3 0-64 21.5-64 48s28.7 48 64 48c21.2 0 40.1-7.8 51.7-19.7L430.4 487zM416.4 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM0 250.2l0-122.2 48 0 0 64 96-96 32 32-64 64 16 16 80-80 32 32-80 80 16 16 48-48 32 32-82.2 82.2C154.7 341.3 128.8 352 101.8 352 45.6 352 0 306.4 0 250.2zM640 272l0 122.2c0 56.2-45.6 101.8-101.8 101.8-27 0-52.9-10.7-72-29.8l-82.2-82.2 32-32 48 48 16-16-80-80 32-32 80 80 16-16-64-64 32-32 96 96 0-64 48 0z"]
};
var faArrowLeftFromLine = {
  prefix: 'fass',
  iconName: 'arrow-left-from-line',
  icon: [576, 512, [8612, "arrow-from-right"], "f344", "M480.3 416l0 32 64 0 0-384-64 0 0 352zM41.6 233.4l-22.6 22.6 22.6 22.6 128 128 22.6 22.6 45.3-45.3c-6.6-6.6-38.6-38.6-96-96l274.7 0 0-64-274.7 0c57.4-57.4 89.4-89.4 96-96l-45.3-45.3-22.6 22.6-128 128z"]
};
var faArrowFromRight = faArrowLeftFromLine;
var faLeftRight = {
  prefix: 'fass',
  iconName: 'left-right',
  icon: [512, 512, [8596, "arrows-alt-h"], "f337", "M0 128l160-144 0 112 352 0 0 64-352 0 0 112-160-144zM352 528l0-112-352 0 0-64 352 0 0-112 160 144-160 144z"]
};
var faArrowsAltH = faLeftRight;
var faSignalBarsWeak = {
  prefix: 'fass',
  iconName: 'signal-bars-weak',
  icon: [448, 512, ["signal-alt-1"], "f691", "M64 384l0 96-64 0 0-96 64 0z"]
};
var faSignalAlt1 = faSignalBarsWeak;
var faAirplayAudio = {
  prefix: 'fass',
  iconName: 'airplay-audio',
  icon: [512, 512, [], "e77b", "M48 256c0 53.1 19.9 101.5 52.6 138.3l-29.2 29.2-4.8 4.8C25.2 382.8 0 322.3 0 256 0 114.6 114.6 0 256 0S512 114.6 512 256c0 66.3-25.2 126.8-66.6 172.2l-4.8-4.8-29.2-29.2C444.1 357.5 464 309.1 464 256 464 141.1 370.9 48 256 48S48 141.1 48 256zm368 0c0 39.8-14.5 76.2-38.6 104.2l-34.1-34.1c15.4-19.2 24.7-43.6 24.7-70.2 0-61.9-50.1-112-112-112S144 194.1 144 256c0 26.6 9.2 51 24.7 70.2l-34.1 34.1C110.5 332.2 96 295.8 96 256 96 167.6 167.6 96 256 96s160 71.6 160 160zM256 238.9l-53 53c-6.9-10.2-11-22.6-11-35.9 0-35.3 28.7-64 64-64s64 28.7 64 64c0 13.3-4.1 25.6-11 35.9l-53-53zM50.7 512c24.2-24.2 85.1-85.1 182.6-182.6L256 306.7 461.3 512 50.7 512z"]
};
var faLightbulbGear = {
  prefix: 'fass',
  iconName: 'lightbulb-gear',
  icon: [576, 512, [], "e5fd", "M229.4 383.8l-.3 .2-101.1 0 0-25.7C70.6 325.1 32 263.1 32 192 32 86 118 0 224 0 324.6 0 407.1 77.4 415.3 175.9l-95.2 0 0 41.7-36.7-21.2c-12.2 21.8-35.3 63.1-69.3 123.9l-22.4 40 37.7 23.5zM128 432l77.6 0 8.5 15.2 45.1 80.8-131.2 0 0-96zm88-320l8 0 0-48-8 0C149.7 64 96 117.7 96 184l0 8 48 0 0-8c0-39.8 32.2-72 72-72zM368.2 223.9l96 0 0 41.4c11.1 4.5 21.4 10.5 30.7 17.8l35.9-20.7 45.3 81.5-33.4 20.9c.9 6.3 1.4 12.7 1.4 19.2 0 6.5-.5 12.9-1.4 19.1l33.4 20.8-45.3 81.7-35.9-20.7c-9.3 7.3-19.6 13.3-30.7 17.8l0 41.4-96 0 0-41.2c-11.2-4.5-21.5-10.5-30.9-17.8l-35.7 20.6-45.6-81.7 33.4-20.7c-.9-6.3-1.4-12.7-1.4-19.2 0-6.5 .5-13 1.4-19.3l-33.4-20.8 45.6-81.5 35.7 20.6c9.3-7.3 19.7-13.3 30.9-17.8l0-41.2zm99.9 160.2a52 52 0 1 0 -104 0 52 52 0 1 0 104 0z"]
};
var faGrid2Minus = {
  prefix: 'fass',
  iconName: 'grid-2-minus',
  icon: [448, 512, [], "e6aa", "M192 32l-192 0 0 192 192 0 0-192zm0 256l-192 0 0 192 192 0 0-192zM256 32l0 192 192 0 0-192-192 0zm24 328l-24 0 0 48 192 0 0-48-168 0z"]
};
var faRectangleTerminal = {
  prefix: 'fass',
  iconName: 'rectangle-terminal',
  icon: [512, 512, [], "e236", "M0 64l512 0 0 384-512 0 0-384zM86.1 176l80 80c-49.7 49.7-76.4 76.4-80 80l33.9 33.9 17-17c63.8-63.8 96.2-96.2 97-97-.8-.8-33.1-33.1-97-97l-17-17-33.9 33.9zM248 336l-24 0 0 48 192 0 0-48-168 0z"]
};
var faSquareDownLeft = {
  prefix: 'fass',
  iconName: 'square-down-left',
  icon: [448, 512, [], "e26b", "M448 480l-448 0 0-448 448 0 0 448zM152 352l169.9 0c-29.6-29.6-52.3-52.3-68-68 53-53 81-81 84-84-24.3-24.3-54.1-54.1-57.9-57.9-3 3-31 31-84 84-15.7-15.7-38.4-38.4-68-68l0 193.9 24 0z"]
};
var faMailboxOpenLetter = {
  prefix: 'fass',
  iconName: 'mailbox-open-letter',
  icon: [640, 512, [], "e823", "M164.8 414.7l11.2 5.8 11.2-5.8 100.8-53 0 118.2-288 0 0-151.9 164.8 86.6zM576 96c38.9 29.2 64 75.7 64 128l0 256-304 0 0-272c0-53-43-96-96-96-41.8 0-77.2 26.7-90.4 64l-49.9 0C114.2 111.9 171.5 64 240 64l128 0 0-16 208 0 0 48zM288 307.5l-112 58.8-176-92.5 0-49.9 288 0 0 83.5zM416 256l48 0 0-80 64 0 0-80-112 0 0 160z"]
};
var faPepper = {
  prefix: 'fass',
  iconName: 'pepper',
  icon: [512, 512, [129745], "e432", "M320 24c-22.1 0-40 17.9-40 40l0 3c13.8-3.6 28.7-4.1 43.6-1 8.3 1.7 16.2 4.5 23.5 8.2 21.6-10.4 47-13.3 71.9-6.6 55.5 14.9 88.3 72 73.4 127.5l-56 208c-14.9 55.5-72 88.3-127.5 73.4-4.8-1.3-9.4-2.9-13.8-4.8-6 2.7-12.4 4.8-19.1 6.2-22.2 4.8-44.3 1.4-63.2-8.1-6.8 3.2-14 5.8-21.6 7.5-56 12.9-111.8-22-124.7-78l-48-208c-12.9-56 22-111.8 78-124.7 23.9-5.5 47.8-2.3 68.3 7.5 7.1-3.6 14.8-6.3 23-8.1 15.1-3.2 30.1-2.7 44.1 .9l0-3c0-48.6 39.4-88 88-88l24 0 0 48-24 0z"]
};
var faMoonStars = {
  prefix: 'fass',
  iconName: 'moon-stars',
  icon: [512, 512, [], "f755", "M448-32l16 48 48 16-48 16-16 48-16-48-48-16 48-16 16-48zM314.7 83.1c-76.2 18.9-132.7 87.8-132.7 169.9 0 96.6 78.3 175 175 175 16.2 0 31.9-2.2 46.8-6.3-40.8 54.8-106.1 90.3-179.8 90.3-123.7 0-224-100.3-224-224S100.3 64 224 64c32.3 0 63 6.8 90.7 19.1zM384 352L355.2 268.8 272 240 355.2 211.2 384 128 412.8 211.2 496 240 412.8 268.8 384 352z"]
};
var faClockFive = {
  prefix: 'fass',
  iconName: 'clock-five',
  icon: [512, 512, [], "e349", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392l0 128.7 60 90 13.3 20-39.9 26.6-13.3-20-64-96-4-6 0-167.3 48 0 0 24z"]
};
var faCorner = {
  prefix: 'fass',
  iconName: 'corner',
  icon: [512, 512, [], "e3fe", "M0 160l512 0 0 224-64 0 0-160-448 0 0-64z"]
};
var faVirus = {
  prefix: 'fass',
  iconName: 'virus',
  icon: [512, 512, [], "e074", "M296 0l0 40c0 44.1 53.3 66.1 84.5 35l28.3-28.3 56.6 56.6-28.4 28.4c-31 31.2-9 84.4 35.1 84.4l40 0 0 80-40 0c-44 0-66.1 53.2-35.1 84.3l28.4 28.4-56.6 56.6-28.3-28.3c-31.2-31.1-84.4-9.1-84.5 34.9l0 40.1-80 0 0-40c0-43.9-52.9-66-84.1-35.3l-28.6 28.6-56.6-56.6 28.3-28.3c31.2-31.2 9.1-84.5-35-84.5l-40 0 0-80 40 0c44 0 66-53 35.2-84.2L46.7 103.3 103.3 46.7 131.5 75c31.2 31.2 84.5 9.1 84.5-35l0-40 80 0zM224 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faNorwegianKroneSign = {
  prefix: 'fass',
  iconName: 'norwegian-krone-sign',
  icon: [512, 512, [], "e6e8", "M112 48l0-32-64 0 0 464 64 0 0-113.8 29.1-26.5c70.8 101.2 106.5 152.1 107 152.9l52.4-36.7-18.4-26.2-93.4-133.4c69.9-63.6 107.4-97.6 112.3-102.1l-43-47.4-23.7 21.5-122.5 111.3 0-231.7zM448 224l48 0 0-64-48 0c-22.8 0-44.8 6.1-64 17.1l0-17.1-64 0 0 320 64 0 0-192c0-13.8 4.5-27.3 12.8-38.4 12.1-16.1 31.1-25.6 51.2-25.6z"]
};
var faGem = {
  prefix: 'fass',
  iconName: 'gem',
  icon: [512, 512, [128142], "f3a5", "M0 208L256 480 512 208 400 32 112 32 0 208zM376 64L299.6 189 464 208 256 232 48 208 212.4 189 136 64 256 177.7 376 64z"]
};
var faToilet = {
  prefix: 'fass',
  iconName: 'toilet',
  icon: [448, 512, [128701], "f7d8", "M24 0L0 0 0 48 32 48 32 196.9c-1.9 1.4-3.8 2.9-5.6 4.4-15.5 13.2-26.4 31.6-26.4 54.6 0 46.9 14.3 84.1 37 112.5 15.1 18.9 33.3 33.1 51.9 43.9L64 512 384 512 359.1 412.4c18.6-10.8 36.8-25 51.9-43.9 22.7-28.4 37-65.5 37-112.5 0-23.1-10.9-41.5-26.4-54.6-1.8-1.5-3.7-3-5.6-4.4l0-148.9 32 0 0-48-424 0zM96 64l64 0 0 32-64 0 0-32zM224 288c-88.4 0-160-14.3-160-32s71.6-32 160-32 160 14.3 160 32-71.6 32-160 32z"]
};
var faBurgerFries = {
  prefix: 'fass',
  iconName: 'burger-fries',
  icon: [576, 512, [], "e0cd", "M208-16l0 239.1c-17.4-1.9-33.7-6.6-48-13.3L160-32 208-16zM128 32l0 128-48 0 0-144 48 16zm240 0l0 128-48 0 0-144 48 16zM288 16l0 192.5-.5 .2c-16 7.4-32.6 12.1-47.5 14.2L240 32 288 16zM32.8 222.2l42.8-20.1c29 40.9 87 69.9 148.4 69.9 1 0 2 0 3 0-7.8 12.5-14.2 26-19 40.2l0 167.8-106.4 0-4.8-17.8-64-240zM256 543.8l0-64 320 0 0 64-320 0zM576 320l0 47.8-320 0 0-47.8s32-96 160-96.2c128 .1 160 96.2 160 96.2zm0 127.8l-320 0 0-48 320 0 0 48zM432 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-96 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faPaperclipVertical = {
  prefix: 'fass',
  iconName: 'paperclip-vertical',
  icon: [448, 512, [], "e3c2", "M32 112C32 32.5 96.5-32 176-32S320 32.5 320 112l0 232c0 48.6-39.4 88-88 88s-88-39.4-88-88l0-248 64 0 0 248c0 13.3 10.7 24 24 24s24-10.7 24-24l0-232c0-44.2-35.8-80-80-80S96 67.8 96 112l0 232c0 75.1 60.9 136 136 136s136-60.9 136-136l0-216 64 0 0 216c0 110.5-89.5 200-200 200S32 454.5 32 344l0-232z"]
};
var faShirtLongSleeve = {
  prefix: 'fass',
  iconName: 'shirt-long-sleeve',
  icon: [576, 512, [], "e3c7", "M288 112c44.2 0 80-35.8 80-80l103 0 12.7 28.3 72 160 4.2 9.4 0 218.3-64 0 0-192-48 0 0 256-320 0 0-256-48 0 0 192-64 0 0-218.3 4.2-9.4 72-160 12.7-28.3 103 0c0 44.2 35.8 80 80 80z"]
};
var faTrashCanCheck = {
  prefix: 'fass',
  iconName: 'trash-can-check',
  icon: [448, 512, [], "e2a9", "M416 512l-384 0 0-368 384 0 0 368zM281.4 233.9L195.8 351.6c-19.3-20-33.7-34.9-43.2-44.7l-34.5 33.3c6.2 6.4 27.2 28.1 63.1 65.3l19.8 20.6 16.8-23.1 102.4-140.8 14.1-19.4-38.8-28.2-14.1 19.4zM320 32l128 0 0 64-448 0 0-64 128 0 16-48 160 0 16 48z"]
};
var faSingleQuoteLeft = {
  prefix: 'fass',
  iconName: 'single-quote-left',
  icon: [192, 512, [], "e81b", "M160 160l-40 0c-30.9 0-56 25.1-56 56l0 8 128 0 0 192-192 0 0-200C0 149.7 53.7 96 120 96l40 0 0 64z"]
};
var faArrowUTurnDownRight = {
  prefix: 'fass',
  iconName: 'arrow-u-turn-down-right',
  icon: [576, 512, [], "e7e8", "M400.2 541.3l-45.3-45.3 80-80-210.7 0C121.5 416 37.6 335.3 32.5 233.9l-.2-9.9c0-106 86-192 192-192l256 0 0 64-256 0c-70.7 0-128 57.3-128 128l.2 6.6C99.8 298.2 155.8 352 224.2 352l210.7 0-80-80 45.3-45.2 157.2 157.2-157.2 157.3z"]
};
var faMoneyBills = {
  prefix: 'fass',
  iconName: 'money-bills',
  icon: [576, 512, [], "e1f3", "M576 32l-480 0 0 352 480 0 0-352zM336 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM160 160l0-64 64 0c0 35.3-28.7 64-64 64zm0 96c35.3 0 64 28.7 64 64l-64 0 0-64zM448 96l64 0 0 64c-35.3 0-64-28.7-64-64zm64 160l0 64-64 0c0-35.3 28.7-64 64-64zM48 152l0-24-48 0 0 352 480 0 0-48-432 0 0-280z"]
};
var faCarCircleBolt = {
  prefix: 'fass',
  iconName: 'car-circle-bolt',
  icon: [640, 512, [], "e342", "M129.3 32l317.4 0 7.5 21.4 42.9 122.6-1.1 0c-16.9 0-33.3 2.2-48.9 6.3-9.5 2.5-18.9 5.7-28 9.7-18.4 8-35.3 18.9-50.1 32-39.9 35.2-65 86.7-65 144 0 16.6 2.1 32.7 6 48l-182 0 0 64-96 0 0-288 41.3 0 48.5-138.6 7.5-21.4zM332.8 192c24-22.3 52.7-39.7 84.3-50.7l-15.8-45.3-226.6 0-33.6 96 191.7 0zM128 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224 32a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm192-96l-144 112 70.9 0-22.9 80 144-112-70.9 0 22.9-80z"]
};
var faTabletButton = {
  prefix: 'fass',
  iconName: 'tablet-button',
  icon: [448, 512, [], "f10a", "M448 0L0 0 0 512 448 512 448 0zM224 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faRectangleHighDynamicRange = {
  prefix: 'fass',
  iconName: 'rectangle-high-dynamic-range',
  icon: [576, 512, ["rectangle-hdr"], "e773", "M576 64l-576 0 0 384 576 0 0-384zM112 184l0 48 32 0 0-72 48 0 0 192-48 0 0-72-32 0 0 72-48 0 0-192 48 0 0 24zm112-24l64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0 0-192zm48 144l16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96zM384 160l60 0c37.6 0 68 30.4 68 68 0 17.4-6.5 33.2-17.2 45.3 10.8 12.6 17.2 28.9 17.2 46.7l0 32-48 0 0-32c0-13.3-10.7-24-24-24l-8 0 0 56-48 0 0-192zm60 88c11 0 20-9 20-20s-9-20-20-20l-12 0 0 40 12 0z"]
};
var faRectangleHdr = faRectangleHighDynamicRange;
var faSquareYen = {
  prefix: 'fass',
  iconName: 'square-yen',
  icon: [448, 512, [], "e724", "M448 32l-448 0 0 448 448 0 0-448zM165.3 127.2c2.3 4 21.9 37.5 58.7 100.5 36.8-63 56.4-96.5 58.7-100.5l41.4 24.2c-1.9 3.3-22.3 38.2-61.1 104.6l41 0 0 32-56 0 0 32 56 0 0 32-56 0 0 48-48 0 0-48-56 0 0-32 56 0 0-32-56 0 0-32 41 0c-38.8-66.5-59.2-101.3-61.1-104.6l41.4-24.2z"]
};
var faSquareArrowDownLeft = {
  prefix: 'fass',
  iconName: 'square-arrow-down-left',
  icon: [448, 512, [], "e261", "M448 480l-448 0 0-448 448 0 0 448zM264 304l-54.1 0 103-103 17-17-33.9-33.9-17 17-103 103 0-78.1-48 0 0 160 160 0 0-48-24 0z"]
};
var faBulldozer = {
  prefix: 'fass',
  iconName: 'bulldozer',
  icon: [640, 512, [], "e655", "M64 32l179.8 0 8.8 17.7 71.2 142.3 28.2 0 0-96 48 0 0 96 48 0 0 104 80 0 0-80c0-48.6 39.4-88 88-88l24 0 0 48-24 0c-22.1 0-40 17.9-40 40l0 208c0 22.1 17.9 40 40 40l24 0 0 48-24 0c-48.6 0-88-39.4-88-88l0-80-63 0c9.5 16.5 15 35.6 15 56 0 61.9-50.1 112-112 112l-224 0c-61.9 0-112-50.1-112-112 0-30.5 12.2-58.2 32-78.4L64 32zm80 320c-26.5 0-48 21.5-48 48s21.5 48 48 48l224 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-224 0zM204.2 96l-76.2 0 0 96 124.2 0-48-96zM328 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM136 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCalendarPen = {
  prefix: 'fass',
  iconName: 'calendar-pen',
  icon: [448, 512, ["calendar-edit"], "f333", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0zM128 320l-16 80 80-16 144-144-64-64-144 144z"]
};
var faCalendarEdit = faCalendarPen;
var faBellOn = {
  prefix: 'fass',
  iconName: 'bell-on',
  icon: [640, 512, [128365], "f8fa", "M615.5 36.6L596.6-7.5c-9 3.9-35.1 15-78.1 33.5l-22.1 9.5 18.9 44.1c9-3.9 35.1-15 78.1-33.5l22.1-9.5zM352 0l-64 0 0 35.2C215 50 160 114.6 160 192l0 96-80 128 480 0-80-128 0-96c0-77.4-55-142-128-156.8L352 0zM258 464c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48l-124 0zM0 160l0 48 112 0 0-48-112 0zm552 0l-24 0 0 48 112 0 0-48-88 0zM46.5 46.1c43 18.4 69 29.6 78.1 33.5l18.9-44.1-78.1-33.5-22.1-9.5-18.9 44.1 22.1 9.5z"]
};
var faExcavator = {
  prefix: 'fass',
  iconName: 'excavator',
  icon: [640, 512, [], "e656", "M416 384c0-26.3-10.6-50.2-27.8-67.5l187.8-156.5 0 144-128 128 0 48 112 0c44.2 0 80-35.8 80-80l0-368-64 0-192 160-96-160-160 0 0 160-96 0 0 120.4C12.4 330 0 355.6 0 384 0 437 43 480 96 480l224 0c53 0 96-43 96-96zM309.4 192l-117.4 0 0-96 59.8 0 57.6 96zM64 384c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 416c-17.7 0-32-14.3-32-32z"]
};
var faRectangleXmark = {
  prefix: 'fass',
  iconName: 'rectangle-xmark',
  icon: [512, 512, [62164, "rectangle-times", "times-rectangle", "window-close"], "f410", "M512 64l-512 0 0 384 512 0 0-384zM172.1 305.9L222.1 256c-38.8-38.8-61.1-61.1-66.9-66.9l33.9-33.9 66.9 66.9c38.8-38.8 61.1-61.1 66.9-66.9l33.9 33.9c-5.8 5.8-28.1 28.1-66.9 66.9 38.8 38.8 61.1 61.1 66.9 66.9l-33.9 33.9c-5.8-5.8-28.1-28.1-66.9-66.9-38.8 38.8-61.1 61.1-66.9 66.9l-33.9-33.9 17-17z"]
};
var faRectangleTimes = faRectangleXmark;
var faTimesRectangle = faRectangleXmark;
var faWindowClose = faRectangleXmark;
var faWrench = {
  prefix: 'fass',
  iconName: 'wrench',
  icon: [576, 512, [128295], "f0ad", "M416.3 192L524.9 83.5c12.4 22.7 19.5 48.8 19.5 76.5 0 88.4-71.6 160-160 160-17.5 0-34.4-2.8-50.2-8-134 134-207.9 207.9-221.8 221.8L10.5 432c13.9-13.9 87.9-87.9 221.8-221.8-5.2-15.8-8-32.6-8-50.2 0-88.4 71.6-160 160-160 27.7 0 53.8 7.1 76.5 19.5l-108.5 108.5 0 64 64 0z"]
};
var faMessageSlash = {
  prefix: 'fass',
  iconName: 'message-slash',
  icon: [576, 512, ["comment-alt-slash"], "f4a9", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-6.3-6.3-27.7-27.7-64.1-64.1l30 0 0-416-446 0-48.9-48.9zM32.1 101.8l0 346.2 128 0 0 96 160-96 58.2 0-346.2-346.2z"]
};
var faCommentAltSlash = faMessageSlash;
var faMace = {
  prefix: 'fass',
  iconName: 'mace',
  icon: [640, 512, [], "f6f8", "M384-64L338.4 38.6c-51.7 15.3-92.5 56.1-107.8 107.8L128 192 230.6 237.6c15.3 51.7 56.1 92.5 107.8 107.8L384 448 429.6 345.4c51.7-15.3 92.5-56.1 107.8-107.8L640 192 537.4 146.4C522.1 94.7 481.3 53.9 429.6 38.6L384-64zM261.3 360C244 347.3 228.7 332 216 314.7L73.4 457.4 50.7 480 96 525.3 118.6 502.6 261.3 360zM384 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faWatch = {
  prefix: 'fass',
  iconName: 'watch',
  icon: [448, 512, [8986], "f2e1", "M155-32L293-32c24.5 0 45 18.4 47.7 42.7l10.1 90.6C395.5 138 424 193.7 424 256s-28.5 118-73.2 154.7l-10.1 90.6C338 525.6 317.5 544 293 544L155 544c-24.5 0-45-18.4-47.7-42.7L97.2 410.7C52.5 374 24 318.3 24 256S52.5 138 97.2 101.3l10.1-90.6C110-13.6 130.5-32 155-32zm93 184l0 94.1c31.3 31.3 50.6 50.6 57.9 57.9L272 337.9c-6.1-6.1-27.8-27.8-65-65l-7-7 0-113.9 48 0zM360 256a136 136 0 1 0 -272 0 136 136 0 1 0 272 0z"]
};
var faTally1 = {
  prefix: 'fass',
  iconName: 'tally-1',
  icon: [448, 512, [], "e294", "M64 32l0 448-64 0 0-448 64 0z"]
};
var faTrashCan = {
  prefix: 'fass',
  iconName: 'trash-can',
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M144-16l160 0 16 48 128 0 0 64-448 0 0-64 128 0 16-48zM32 144l384 0 0 368-384 0 0-368zm112 64l-48 0 0 240 48 0 0-240zm104 0l-48 0 0 240 48 0 0-240zm104 0l-48 0 0 240 48 0 0-240z"]
};
var faTrashAlt = faTrashCan;
var faPuzzle = {
  prefix: 'fass',
  iconName: 'puzzle',
  icon: [512, 512, [], "e443", "M304 0l208 0 0 208-80 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16-64 0 0-64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-80zM0 272l0-208 208 0 0 64 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 80-64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-80 0zM0 512l0-208 208 0 0 64-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 80-208 0zM240 304l64 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 80 0 0 208-208 0 0-208z"]
};
var faTableCells = {
  prefix: 'fass',
  iconName: 'table-cells',
  icon: [448, 512, ["th"], "f00a", "M384 96l0 64-64 0 0-64 64 0zm0 128l0 64-64 0 0-64 64 0zm0 128l0 64-64 0 0-64 64 0zM256 288l-64 0 0-64 64 0 0 64zm-64 64l64 0 0 64-64 0 0-64zm-64-64l-64 0 0-64 64 0 0 64zM64 352l64 0 0 64-64 0 0-64zm0-192l0-64 64 0 0 64-64 0zm128 0l0-64 64 0 0 64-64 0zM64 32l-64 0 0 448 448 0 0-448-384 0z"]
};
var faTh = faTableCells;
var faTrashCanList = {
  prefix: 'fass',
  iconName: 'trash-can-list',
  icon: [640, 512, [], "e2ab", "M336-16l16 48 96 0 0 64-416 0 0-64 96 0 16-48 192 0zM480 128l160 0 0 64-160 0 0-64zm0 128l128 0 0 64-128 0 0-64zm96 128l0 64-96 0 0-64 96 0zM64 144l352 0 0 368-352 0 0-368zm144 64l-48 0 0 240 48 0 0-240zm112 0l-48 0 0 240 48 0 0-240z"]
};
var faRibbon = {
  prefix: 'fass',
  iconName: 'ribbon',
  icon: [384, 512, [127895], "f4d6", "M95 0L289 0 293.7 7.7c15.8 25.9 45.2 73.9 88 144l5.9 9.6-7 8.8-102.2 127.7 86.2 108.3 9.9 12.5-12.5 10-80 64-12.5 10-10-12.5-256-320-7-8.8 5.9-9.6C101.9-11.3 92.3 4.5 95 0zm97 189.2l48.6-61.2-97.3 0 48.6 61.2zM75 336.2L161.3 444c-29 36.2-44.6 55.7-46.8 58.5l-12.5-10-80-64-12.5-10 9.9-12.5 55.5-69.8z"]
};
var faLandmarkFlag = {
  prefix: 'fass',
  iconName: 'landmark-flag',
  icon: [512, 512, [], "e51c", "M368-32l-144 0 0 160-208 0 0 64 48 0 0 224-64 48 0 48 512 0 0-48-64-48 0-224 48 0 0-64-224 0 0-64 96 0 0-96zm32 224l0 224-64 0 0-224 64 0zm-112 0l0 224-64 0 0-224 64 0zm-112 0l0 224-64 0 0-224 64 0z"]
};
var faBadminton = {
  prefix: 'fass',
  iconName: 'badminton',
  icon: [576, 512, [], "e33a", "M480.2 380c28.2 0 52.4 20.1 57.6 47.8l18.1 96.5 3.7 19.7-.2 0-40.5 0c-.8-4.3-3.8-20.3-9-48l-9.7 0 0 48-40 0 0-48-9.7 0c-5.2 27.7-8.2 43.7-9 48l-40.5 0-.2 0 3.7-19.7 18.1-96.5 1.2-5.1c7-25 30-42.7 56.4-42.7zm-75-395.8c40 1.7 78.8 16.6 108.5 46.3l5.8 6.1c27.7 30.9 40.7 70.3 40.7 110.5l-.3 10.2c-2.7 51-25.8 103-66.7 143.8-54.4 54.4-131.8 78.6-198.2 61.6-29.4-7.5-62.9-5.5-84.3 16l-37.4 37.3 16 16-109.2 109.3-77.2-77.3 109.2-109.3 16 16 37.6-37.6c21.4-21.4 23.5-54.7 16-83.9-3-11.8-4.8-24-5.3-36.2l-.2-8c0-54.2 23.4-110.5 66.9-154S343-16 397.2-16l8 .2zm-8 63.8c-36 0-76.4 15.8-108.8 48.2S240.2 168.9 240.2 205l.4 10.4c2.1 23.9 11.4 45 27.3 60.9 40.4 40.4 120.7 39 180.1-20.5 30.4-30.4 46.2-67.7 48-102l.2-6.8c0-28.2-9.6-53.2-27.7-71.3-15.9-15.9-37-25.2-60.9-27.3L397.2 48z"]
};
var faUpToBracket = {
  prefix: 'fass',
  iconName: 'up-to-bracket',
  icon: [448, 512, [], "e66e", "M206.6 167.5L224 149 241.4 167.5c107 113.3 165 174.7 174.2 184.5l-127.7 0 0 160-128 0 0-160-127.7 0c9.2-9.7 67.3-71.2 174.2-184.5zM64 160l0 32-64 0 0-192 448 0 0 192-64 0 0-128-320 0 0 96z"]
};
var faChartLineUpDown = {
  prefix: 'fass',
  iconName: 'chart-line-up-down',
  icon: [512, 512, [], "e5d7", "M64 32l0 384 448 0 0 64-512 0 0-448 64 0zM97.4 209.4c89.6-89.6 134.4-134.4 134.6-134.6 9.3 9.3 36 36 80 80l77.4-77.4-45.4-45.4 136 0 0 136-45.4-45.4c-79.6 79.6-120.4 120.4-122.6 122.6-9.3-9.3-36-36-80-80l-89.4 89.4-45.3-45.3zM480 352l-136 0 45.4-45.4-35.4-35.4 45.3-45.3 35.4 35.4 45.4-45.4 0 136z"]
};
var faUpDownLeftRight = {
  prefix: 'fass',
  iconName: 'up-down-left-right',
  icon: [576, 512, ["arrows-alt"], "f0b2", "M265.6 502.6l22.6 22.6C312.6 500.9 392.4 421.1 413.5 400l-93.3 0 0-112 112 0 0 93.3c88.4-88.4 120.2-120.2 125.3-125.3-24.4-24.4-104.2-104.2-125.3-125.3l0 93.3-112 0 0-112 93.3 0C325.1 23.6 293.3-8.2 288.3-13.3 263.9 11.1 184.1 90.9 163 112l93.3 0 0 112-112 0 0-93.3C55.9 219.1 24.1 250.9 19 256 43.4 280.4 123.2 360.2 144.3 381.3l0-93.3 112 0 0 112-93.3 0c37.5 37.5 71.7 71.7 102.6 102.6z"]
};
var faArrowsAlt = faUpDownLeftRight;
var faGarageEmpty = {
  prefix: 'fass',
  iconName: 'garage-empty',
  icon: [576, 512, [], "e6c9", "M0 96l0 416 64 0 0-320 448 0 0 320 64 0 0-416-288-96-288 96z"]
};
var faCarSide = {
  prefix: 'fass',
  iconName: 'car-side',
  icon: [640, 512, [128663], "f5e4", "M128 32l-22.7 0-7.5 21.4-48.5 138.6-49.3 0 0 208 64.4 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l144.7 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l80.4 0 0-208-120 0-110.4-147.2-9.6-12.8-272 0zM440 192l-152 0 0-96 80 0 72 96zM240 96l0 96-122.9 0 33.6-96 89.3 0zM152 352a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm280 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faTrashArrowUp = {
  prefix: 'fass',
  iconName: 'trash-arrow-up',
  icon: [448, 512, ["trash-restore"], "f829", "M304-16l16 48 128 0 0 64-448 0 0-64 128 0 16-48 160 0zM32 144l384 0-24 368-336 0-24-368zm209 79l-17-17c-2.1 2.1-31.8 31.8-89 89l-17 17 33.9 33.9c9-9 25-25 48-48l0 126.1 48 0 0-126.1c23 23 39 39 48 48L329.9 312c-2.1-2.1-31.8-31.8-89-89z"]
};
var faTrashRestore = faTrashArrowUp;
var faLifeRing = {
  prefix: 'fass',
  iconName: 'life-ring',
  icon: [512, 512, [], "f1cd", "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm91 .5c33.7-43.3 53.8-97.8 53.8-157S491.9 142.4 458.2 99l19-19-45.3-45.3-19 19C369.6 20.1 315.2 0 256 0S142.4 20.1 99 53.8l-19-19-45.3 45.3 19 19C20.1 142.4 0 196.8 0 256S20.1 369.6 53.8 413l-19 19 45.3 45.3 19-19c43.3 33.7 97.8 53.8 157 53.8s113.6-20.1 157-53.8l19 19 45.3-45.3-19-19zm-45.7-45.7l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faBarProgressThreeQuarters = {
  prefix: 'fass',
  iconName: 'bar-progress-three-quarters',
  icon: [512, 512, [], "e6a9", "M352 160l0 192 96 0 0-192-96 0zM0 96l512 0 0 320-512 0 0-320z"]
};
var faCopyright = {
  prefix: 'fass',
  iconName: 'copyright',
  icon: [512, 512, [169], "f1f9", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM205.1 306.9c28.1 28.1 73.7 28.1 101.8 0l33.9 33.9c-46.9 46.9-122.8 46.9-169.7 0s-46.9-122.8 0-169.7 122.8-46.9 169.7 0l-33.9 33.9c-28.1-28.1-73.7-28.1-101.8 0s-28.1 73.7 0 101.8z"]
};
var faLeafyGreen = {
  prefix: 'fass',
  iconName: 'leafy-green',
  icon: [576, 512, [129388], "e41d", "M216.5 26.2c-34.9-34.9-91.5-34.9-126.4 0-15.4 15.4-24 35.1-25.8 55.3-15.3 2.5-30.1 9.6-41.9 21.4-28.3 28.3-29.8 73.3-4.5 103.4l0 72.6 54.2 54.2 0 80.4 23.9-23.9 0-98.7 48-48 0-96 66.1-66.1c2.8-15.4 8.4-29.8 16.2-42.7-2.9-4.1-6.2-8-9.9-11.7zM549.9 183.9C566.2 164.4 576 139.4 576 112 576 50.1 525.9 0 464 0 436.6 0 411.6 9.8 392.1 26.1 376.3 14.7 357 8 336 8 285.8 8 244.6 46.5 240.4 95.6l-64.4 64.4 0 96-48 48 0 98.7C99.6 431.2 79.2 451.6 66.7 464L112 509.3c12.4-12.4 32.8-32.8 61.3-61.3l98.7 0 48-48 96 0 64.4-64.4c49.1-4.2 87.6-45.4 87.6-95.6 0-21-6.7-40.3-18.1-56.1zM486.6 112l-11.3 11.3-84.7 84.7 73.4 0 0 32-105.4 0c-41.4 41.4-77.2 77.2-107.3 107.3L240 358.6 217.4 336c2.2-2.2 20.4-20.4 54.6-54.6l0-105.4 32 0 0 73.4c11.9-11.9 61.5-61.5 148.7-148.7L464 89.4 486.6 112z"]
};
var faHighlighterLine = {
  prefix: 'fass',
  iconName: 'highlighter-line',
  icon: [576, 512, [], "e1af", "M229.7 229.7l203.4-146.1 27.1 27.1-146.1 203.4-84.5-84.5zM128 224l0 96 0 0-48 48 96 96 48-48 96 0 224-312-104-104-312 224zM58.7 414.6l-54.1 54.1-4.7 4.7 0 38.6 102.6 0 4.7-4.7 22.1-22.1-70.6-70.6zM280 464l-24 0 0 48 320 0 0-48-296 0z"]
};
var faRectangleHistoryCircleUser = {
  prefix: 'fass',
  iconName: 'rectangle-history-circle-user',
  icon: [576, 512, [], "e4a4", "M257.4 480c-11.2-24.4-17.4-51.4-17.4-80 0-106 86-192 192-192l-432 0 0 272 257.4 0zM464 160l0-48-416 0 0 48 416 0zM416 64l0-48-320 0 0 48 320 0zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64.5 78.9C491.2 499.4 463.1 512 432 512s-59.2-12.6-79.5-33.1l15.5-30.9 128 0 15.5 30.9zM384 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faFerrisWheel = {
  prefix: 'fass',
  iconName: 'ferris-wheel',
  icon: [512, 512, [], "e174", "M304 0l-96 0 0 37.2c-24.2 5.3-46.9 14.5-67.4 26.8L64 64 64 140.6C51.6 161.1 42.4 183.8 37.2 208l-37.2 0 0 96 37.2 0c5.3 24.2 14.5 46.9 26.8 67.4l0 76.6 57.2 0 24.5-76.1c-25.1-23.9-42.5-56-47.9-91.9l65.2 0c-2-7.7-3-15.7-3-24s1-16.3 3-24l-65.2 0c4-26.3 14.3-50.4 29.4-70.9l46.1 46.1c8.3-14 20-25.7 33.9-33.9l-46.1-46.1c20.5-15.1 44.6-25.4 70.9-29.4l0 65.2c7.7-2 15.7-3 24-3s16.3 1 24 3l0-65.2c26.3 4 50.4 14.3 70.9 29.4l-46.1 46.1c14 8.3 25.7 20 33.9 33.9l46.1-46.1c15.1 20.5 25.4 44.6 29.4 70.9L349 232c2 7.7 3 15.7 3 24s-1.1 16.3-3 24l65.2 0c-5.4 35.9-22.8 68-47.9 91.9l24.5 76.1 57.2 0 0-76.6c12.4-20.6 21.6-43.3 26.8-67.4l37.2 0 0-96-37.2 0c-5.3-24.2-14.5-46.9-26.8-67.4l0-76.6-76.6 0C350.9 51.6 328.2 42.4 304 37.2L304 0zM166.5 464c-2.8 8.7-7.9 24.7-15.4 48l209.8 0c-21-65.3-24.7-76.7-59.2-184.3l-12.1-37.5c8.9-8.7 14.4-20.8 14.4-34.2 0-24-17.6-43.9-40.6-47.4-2.4-.4-4.9-.6-7.4-.6s-5 .2-7.4 .6c-23 3.6-40.6 23.4-40.6 47.4 0 13.4 5.5 25.5 14.4 34.2-3.5 11-20.6 64-51.1 159.1L166.5 464z"]
};
var faArrowUpFromArc = {
  prefix: 'fass',
  iconName: 'arrow-up-from-arc',
  icon: [512, 512, [], "e4b4", "M256 448C150 448 64 362 64 256l0-32-64 0 0 32C0 397.4 114.6 512 256 512S512 397.4 512 256l0-32-64 0 0 32c0 106-86 192-192 192zM121.4 121.4L98.7 144 144 189.3c9.3-9.3 36-36 80-80l0 242.7 64 0 0-242.7 80 80 45.3-45.3c-.2-.2-45.1-45.1-134.6-134.6L256-13.3c-.2 .2-45.1 45.1-134.6 134.6z"]
};
var faGridDividers = {
  prefix: 'fass',
  iconName: 'grid-dividers',
  icon: [448, 512, [], "e3ad", "M0 16l448 0 0 48-448 0 0-48zm112 96l0 112-112 0 0-112 112 0zm0 256l0 112-112 0 0-112 112 0zm56 0l112 0 0 112-112 0 0-112zM280 112l0 112-112 0 0-112 112 0zm56 256l112 0 0 112-112 0 0-112zM448 112l0 112-112 0 0-112 112 0zM24 272l424 0 0 48-448 0 0-48 24 0z"]
};
var faLightbulbDollar = {
  prefix: 'fass',
  iconName: 'lightbulb-dollar',
  icon: [384, 512, [], "f670", "M288 358.3c57.4-33.2 96-95.2 96-166.3 0-106-86-192-192-192S0 86 0 192c0 71.1 38.6 133.1 96 166.3l0 25.7 192 0 0-25.7zM96 528l192 0 0-96-192 0 0 96zM216 80l0 24 28 0 0 40-67.5 0c-6.9 0-12.5 5.6-12.5 12.5 0 6.1 4.4 11.3 10.4 12.3l41.7 7c25.3 4.2 43.9 26.1 43.9 51.8 0 26.1-19 47.7-44 51.8l0 24.7-40 0 0-24-44 0 0-40 75.5 0c6.9 0 12.5-5.6 12.5-12.5 0-6.1-4.4-11.3-10.4-12.3l-41.7-7c-25.3-4.2-43.9-26.1-43.9-51.8 0-28.8 23.2-52.2 52-52.5l0-24 40 0z"]
};
var faCoffin = {
  prefix: 'fass',
  iconName: 'coffin',
  icon: [384, 512, [9904], "f6c6", "M0 144L104 512 280 512 384 144 272 0 112 0 0 144z"]
};
var faFilePrescription = {
  prefix: 'fass',
  iconName: 'file-prescription',
  icon: [384, 512, [], "f572", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM88 208l-24 0 0 176 48 0 0-48 32 0c2.4 0 4.8-.1 7.2-.4L193 374.9c-18.4 17.4-32.7 30.9-43 40.6l33 34.9c9.9-9.4 24.9-23.6 45.1-42.6 20 18.7 35 32.8 45 42.2l32.8-35c-10.4-9.7-24.7-23.1-42.9-40.2 18.3-17.3 32.6-30.8 42.9-40.6l-33-34.9c-9.9 9.4-24.9 23.6-45 42.5l-33.1-31c8.2-10.8 13.1-24.2 13.1-38.8 0-35.3-28.7-64-64-64l-56 0zm32 80l-8 0 0-32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0z"]
};
var faEraser = {
  prefix: 'fass',
  iconName: 'eraser',
  icon: [640, 512, [], "f12d", "M218.5 416l107 0 69.3-69.3-165.5-165.5-122.7 122.7 112 112zM256 480l-64 0C90.6 378.6 31.9 319.9 16 304L61.3 258.7 290.7 29.3 336-16c10.1 10.1 80.4 80.4 210.7 210.7l45.3 45.3-176 176 160 0 0 64-320 0z"]
};
var faFlaskRoundPoison = {
  prefix: 'fass',
  iconName: 'flask-round-poison',
  icon: [384, 512, ["flask-poison"], "f6e0", "M64 0l256 0 0 64-32 0 0 89.7c57.3 33.2 96 95.2 96 166.3 0 106-86 192-192 192S0 426 0 320c0-71.1 38.7-133.1 96-166.3L96 64 64 64 64 0zM304 312c0-48.6-50.1-88-112-88S80 263.4 80 312c0 29.9 19 56.3 48 72.2l0 47.8 128 0 0-47.8c29-15.9 48-42.3 48-72.2zM152 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faFlaskPoison = faFlaskRoundPoison;
var faCameraClock = {
  prefix: 'fass',
  iconName: 'camera-clock',
  icon: [640, 512, [], "e767", "M224 32l-32 64-128 0 0 384 257.4 0c-11.2-24.4-17.4-51.4-17.4-80 0-5.8 .3-11.5 .8-17.2-45.8-7.3-80.8-47-80.8-94.8 0-53 43-96 96-96 33 0 62.1 16.7 79.4 42 28.4-16.6 61.4-26 96.6-26 28.6 0 55.6 6.2 80 17.4l0-129.4-128 0-32-64-192 0zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 320l0 64 48 0 0 32-80 0 0-96 32 0z"]
};
var faCircleHalfHorizontal = {
  prefix: 'fass',
  iconName: 'circle-half-horizontal',
  icon: [512, 512, [], "e80c", "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256l512 0z"]
};
var faSquareT = {
  prefix: 'fass',
  iconName: 'square-t',
  icon: [448, 512, [], "e280", "M448 32l-448 0 0 448 448 0 0-448zM136 144l200 0 0 48-88 0 0 176-48 0 0-176-88 0 0-48 24 0z"]
};
var faCircleShekel = {
  prefix: 'fass',
  iconName: 'circle-shekel',
  icon: [512, 512, [], "e703", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM384 160l0 144c0 39.8-32.2 72-72 72l-112 0c0-2.7 0-45.3 0-128l0-24 48 0c0 6.7 0 41.3 0 104l64 0c13.3 0 24-10.7 24-24l0-168 48 0 0 24zM152 136l88 0c39.8 0 72 32.2 72 72l0 80-48 0 0-80c0-13.3-10.7-24-24-24l-64 0 0 192-48 0 0-240 24 0z"]
};
var faSpaceStationMoonConstruction = {
  prefix: 'fass',
  iconName: 'space-station-moon-construction',
  icon: [512, 512, ["space-station-moon-alt"], "e034", "M510 287.9c1.3-10.5 2-21.1 2-31.9 0-10.8-.7-21.5-2-32l-62 0 0-64-96 0 0-64 64 0 0-39.9C372.2 21 316.5 0 256 0 114.6 0 0 114.6 0 256 0 266.8 .7 277.4 2 287.9 74.4 313.1 161.6 328 256 328s181.6-14.9 254-40.1zM384 367c-40.9 5.9-83.9 9-128 9-87 0-169.2-12-241-33.5 35.5 98.8 130 169.5 241 169.5 76.5 0 145.1-33.5 192-86.7l0-25.3-64 0 0-33zM192 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
var faCircleMoon = {
  prefix: 'fass',
  iconName: 'circle-moon',
  icon: [512, 512, [], "e7e0", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-448C150 64 64 150 64 256s86 192 192 192c63.1 0 119.1-30.5 154.1-77.5-12.8 3.5-26.2 5.5-40.1 5.5-82.8 0-150-67.2-150-150 0-70.3 48.4-129.3 113.7-145.6-23.8-10.5-50-16.4-77.7-16.4z"]
};
var faBasketballHoop = {
  prefix: 'fass',
  iconName: 'basketball-hoop',
  icon: [576, 512, [], "f435", "M464 288l-14.1 0-30.1 210.8-1.9 13.2-30.6 0-2.6-3.1-42.4-50.2-38.5 49.5-2.9 3.7-25.7 0-2.9-3.7-38.5-49.5-42.4 50.2-2.6 3.1-30.6 0-1.9-13.2-30.1-210.8-14.1 0 0-48 352 0 0 48zM260.1 427.6l27.9 35.8 27.9-35.8-27.9-33-27.9 33zm-70.6 21.5l19.1-22.6-27.3-35.1 8.3 57.7zm177.9-22.6l19.1 22.6 8.3-57.7-27.3 35.1zM201.2 351.8l33.8 43.5 26.8-31.7-36.8-43.6-23.8 31.7zm113 11.8l26.8 31.7 33.8-43.5-23.8-31.7-36.8 43.6zM288 0C496 0 576 176 576 176l0 176-76.4 33.9 12.4-65.9 0-128-96 0 0-80-256 0 0 80-96 0 0 128 12.3 65.9-76.3-33.9 0-176S80 0 288 0zm0 332.7l37.8-44.7-75.6 0 37.8 44.7zm-116.3-8.3l27.3-36.4-32.5 0 5.2 36.4zm232.6 0l5.2-36.4-32.5 0 27.3 36.4zM368 192l-160 0 0-32 160 0 0 32z"]
};
var faCodeSimple = {
  prefix: 'fass',
  iconName: 'code-simple',
  icon: [640, 512, [], "e13d", "M246.9 118.6l22.6-22.6-45.3-45.3-22.6 22.6-160 160-22.6 22.6 22.6 22.6 160 160 22.6 22.6 45.3-45.3-22.6-22.6-137.4-137.4 137.4-137.4zm146.7 0l137.4 137.4-160 160 45.3 45.3 205.3-205.3-22.6-22.6-160-160-22.6-22.6-45.3 45.3 22.6 22.6z"]
};
var faLeftToDottedLine = {
  prefix: 'fass',
  iconName: 'left-to-dotted-line',
  icon: [512, 512, [], "e6c3", "M0 64l64 0 0 64-64 0 0-64zM117.1 256l202.9-192 0 128 192 0 0 128-192 0 0 128-202.9-192zM0 234.7l0-64 64 0 0 64-64 0zm0 42.7l64 0 0 64-64 0 0-64zM0 448l0-64 64 0 0 64-64 0z"]
};
var faHockeyStickPuck = {
  prefix: 'fass',
  iconName: 'hockey-stick-puck',
  icon: [640, 512, [], "e3ae", "M128 512l-64 0 0-192 64 0 0 192zM553.6-17.8l-203.9 509.7-8.1 20.1-165.7 0 0-192 173.5 0 132.7-331.9 11.9-29.7 59.4 23.8zM640 512l-192 0 0-96 192 0 0 96z"]
};
var faHourglassStart = {
  prefix: 'fass',
  iconName: 'hourglass-start',
  icon: [384, 512, ["hourglass-1"], "f251", "M0 0l384 0 0 64-32 0 0 77.3-9.4 9.4-105.4 105.4 114.7 114.7 0 77.3 32 0 0 64-384 0 0-64 32 0 0-77.3 9.4-9.4 105.4-105.4-105.4-105.4-9.4-9.4 0-77.3-32 0 0-64zM96 397.3l0 50.7 192 0 0-50.7-96-96-96 96z"]
};
var faHourglass1 = faHourglassStart;
var faCircleLeft = {
  prefix: 'fass',
  iconName: 'circle-left',
  icon: [512, 512, [61840, "arrow-alt-circle-left"], "f359", "M512 256a256 256 0 1 0 -512 0 256 256 0 1 0 512 0zM256 384l-8 0-128-128 128-128 8 0 0 80 128 0 0 96-128 0 0 80z"]
};
var faArrowAltCircleLeft = faCircleLeft;
var faRestroomSimple = {
  prefix: 'fass',
  iconName: 'restroom-simple',
  icon: [640, 512, [], "e23a", "M192 64A64 64 0 1 0 64 64 64 64 0 1 0 192 64zm32 96l-192 0 0 192 32 0 0 160 128 0 0-160 32 0 0-192zM344 0l-48 0 0 512 48 0 0-512zM512 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM640 384l-64-224-128 0-64 224 64 0 0 128 128 0 0-128 64 0z"]
};
var faCruzeiroSign = {
  prefix: 'fass',
  iconName: 'cruzeiro-sign',
  icon: [448, 512, [], "e152", "M240.5 96c-88.4 0-160 71.6-160 160 0 71.6 47.1 132.3 112 152.7l0-176.7 48 0 0 22.7C256 245.2 274 240 292.7 240l35.8 0 0 48-35.8 0c-18.8 0-36.1 10-45.4 26.3-4.5 7.9-6.9 16.8-6.9 25.9l0 75.8c52.3 0 98.8-25.1 128-64l51.2 38.4c-40.8 54.3-105.9 89.6-179.2 89.6-123.7 0-224-100.3-224-224S116.8 32 240.5 32c73.3 0 138.4 35.2 179.2 89.6L368.5 160c-29.2-38.9-75.7-64-128-64z"]
};
var faSmoking = {
  prefix: 'fass',
  iconName: 'smoking',
  icon: [576, 512, [128684], "f48d", "M336 0l48 0 0 43c0 40.3 16 79 44.5 107.5l21 21C469 191 480 217.4 480 245l0 43-48 0 0-43c0-14.9-5.9-29.1-16.4-39.6l-21-21C357.1 146.9 336 96 336 43l0-43zM576 288l-48 0 0-43c0-40.3-16-79-44.5-107.5l-21-21C443 97 432 70.6 432 43l0-43 48 0 0 43c0 14.9 5.9 29.1 16.4 39.6l21 21C554.9 141.1 576 192 576 245l0 43zM320 448l96 0 0-32-96 0 0 32zM0 352l480 0 0 160-480 0 0-160zm576 24l0 136-48 0 0-160 48 0 0 24z"]
};
var faChartPieSimpleCircleDollar = {
  prefix: 'fass',
  iconName: 'chart-pie-simple-circle-dollar',
  icon: [640, 512, [], "e605", "M496 208C512.1 208 527.7 210 542.6 213.7 529.5 93.5 427.7 0 304 0l0 240 85.8 0c30.4-20.2 66.9-32 106.2-32zM304 400c0-41.8 13.4-80.5 36-112l-84 0 0-255.5c-125.1 8.2-224 112.3-224 239.5 0 132.5 107.5 240 240 240 21.6 0 42.5-2.9 62.4-8.2-19.3-29.9-30.4-65.6-30.4-103.8zm336 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 328l32 0 0 32-61.8 0c-5.6 0-10.2 4.6-10.2 10.2 0 4.9 3.5 9.1 8.3 10l45 8.2c20 3.6 34.6 21.1 34.6 41.5 0 23.3-18.9 42.2-42.2 42.2l-5.8 0 0 24-32 0 0-24-32 0 0-32 69.8 0c5.6 0 10.2-4.6 10.2-10.2 0-4.9-3.5-9.1-8.3-10l-45-8.2c-20-3.6-34.6-21.1-34.6-41.5 0-22.6 17.7-41 40-42.1l0-24.1 32 0 0 24z"]
};
var faUserVneckHair = {
  prefix: 'fass',
  iconName: 'user-vneck-hair',
  icon: [448, 512, [], "e462", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16 48 0c20.8 0 41-6.7 57.6-19.2L288 80 288 80c10 13.4 16 30 16 48l0 16zM224 0C153.3 0 96 57.3 96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16C352 57.3 294.7 0 224 0zm64 320l-64 64-64-64-80 0-64 192 416 0-64-192-80 0z"]
};
var faSquarePollVertical = {
  prefix: 'fass',
  iconName: 'square-poll-vertical',
  icon: [448, 512, ["poll"], "f681", "M448 32l-448 0 0 448 448 0 0-448zM144 224l0 160-48 0 0-160 48 0zm56-96l48 0 0 256-48 0 0-256zM352 288l0 96-48 0 0-96 48 0z"]
};
var faPoll = faSquarePollVertical;
var faPersonCircleMinus = {
  prefix: 'fass',
  iconName: 'person-circle-minus',
  icon: [640, 512, [], "e540", "M168 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-11.4 88l134.8 0 9.6 13.2 85.2 117.3c-17.8 12.4-33.4 27.8-46.1 45.5l-36.1-49.7 0 305.7-64 0 0-208-32 0 0 208-64 0 0-305.7c-28.6 39.4-47.6 65.6-56.9 78.4l-51.8-37.6 18.8-25.9 92.9-128 9.6-13.2zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16l0-32-160 0 0 32 160 0z"]
};
var faEnvelopeOpenDollar = {
  prefix: 'fass',
  iconName: 'envelope-open-dollar',
  icon: [576, 512, [], "f657", "M473.8 187.3L288 48 102.2 187.3 288 320 473.8 187.3zM32 160l256-192 256 192 0 96-96 0 0 36.5c-31 17.1-52 50.1-52 88 0 13.9 2.8 27.2 8 39.3l0 60.2-372 0 0-320zM536 304l0 24 28 0 0 40-67.5 0c-6.9 0-12.5 5.6-12.5 12.5 0 6.1 4.4 11.3 10.4 12.3l41.7 7c25.3 4.2 43.9 26.1 43.9 51.8 0 26.1-19 47.7-44 51.8l0 24.7-40 0 0-24-44 0 0-40 75.5 0c6.9 0 12.5-5.6 12.5-12.5 0-6.1-4.4-11.3-10.4-12.3l-41.7-7c-25.3-4.2-43.9-26.1-43.9-51.8 0-28.8 23.2-52.2 52-52.5l0-24 40 0z"]
};
var faBiohazard = {
  prefix: 'fass',
  iconName: 'biohazard',
  icon: [576, 512, [9763], "f780", "M260-3.3c-68.7 13.3-120.6 74.1-120.6 147 0 25.1 6.1 48.7 17 69.5-21 1.8-42 8.2-61.5 19.5-62.8 36.5-89.2 112-66.4 178.4l22.7-13.2c-1.1-6.1-1.7-12.7-1.7-19.6 0-123.5 184.4-123.5 184.4 0 0 92.6-103.5 115.8-155.4 69.6L57 460.5c45.8 53.1 124.1 67.9 186.9 31.4 17.9-10.4 32.8-23.9 44.5-39.4 11.7 15.6 26.6 29.1 44.5 39.4 62.8 36.5 141.1 21.7 186.9-31.5l-21.6-12.5c-51.9 46.2-155.5 23-155.5-69.6 0-123.5 184.4-123.5 184.4 0 0 6.9-.6 13.5-1.7 19.6l22.7 13.2c22.9-66.4-3.5-142-66.4-178.4-19.5-11.3-40.4-17.7-61.5-19.5 10.9-20.8 17-44.4 17-69.5 0-72.9-51.9-133.7-120.6-147l0 25.9c93.7 26.1 84.2 181.6-28.4 181.6S166.3 48.7 260 22.6l0-25.9zM248.4 288a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM435 317.7c-16.2 0-31.4 5.5-42.1 15-10.1 9.1-18.1 23.4-18.1 45.6 0 21.1 7.2 35 16.5 44.1 32.2-24.6 55.5-60.5 63.9-101.8-6.3-1.9-13.2-3-20.2-3zM202 378.3c0-22.3-8-36.6-18.1-45.6-10.7-9.6-25.9-15-42.1-15-7 0-13.9 1-20.2 3 8.4 41.3 31.6 77.2 63.9 101.8 9.4-9.1 16.5-23.1 16.5-44.2zm41.2-224.3c9 10.2 23.2 18.2 45.2 18.2s36.2-8 45.2-18.2c6.7-7.6 11.5-17.5 13.6-28.4-18.3-6.8-38.2-10.5-58.8-10.5s-40.5 3.7-58.8 10.5c2.2 10.9 6.9 20.8 13.6 28.5z"]
};
var faObjectsAlignBottom = {
  prefix: 'fass',
  iconName: 'objects-align-bottom',
  icon: [512, 512, [], "e3bb", "M512 512l0-64-512 0 0 64 512 0zM64 384l160 0 0-384-160 0 0 384zm224 0l160 0 0-256-160 0 0 256z"]
};
var faScrollOld = {
  prefix: 'fass',
  iconName: 'scroll-old',
  icon: [576, 512, [], "f70f", "M88 32C39.4 32 0 71.4 0 120l0 88 112 0 0 48 48 32-48 32 0 160 16 0c39.8 0 72-32.2 72-72l0-104 248 0 0-112-48-32 48-32c0-53-43-96-96-96L88 32zM448 480l16 0c44.2 0 80-35.8 80-80l0-48-160 0-32 48-32-48-72 0 0 56c0 27-8.9 51.9-24 72l224 0zM112 80l0 80-64 0 0-40c0-22.1 17.9-40 40-40l24 0z"]
};
var faBellConcierge = {
  prefix: 'fass',
  iconName: 'bell-concierge',
  icon: [512, 512, [128718, "concierge-bell"], "f562", "M216 64l-24 0 0 48 40 0 0 33.3C124.8 156.7 40.2 243.7 32.6 352l446.9 0C471.8 243.7 387.2 156.7 280 145.3l0-33.3 40 0 0-48-104 0zM24 400l-24 0 0 48 512 0 0-48-488 0z"]
};
var faConciergeBell = faBellConcierge;
var faRulerHorizontal = {
  prefix: 'fass',
  iconName: 'ruler-horizontal',
  icon: [576, 512, [], "f547", "M0 384l0-256 72 0 0 128 48 0 0-128 48 0 0 96 48 0 0-96 48 0 0 128 48 0 0-128 48 0 0 96 48 0 0-96 48 0 0 128 48 0 0-128 72 0 0 256-576 0z"]
};
var faHorse = {
  prefix: 'fass',
  iconName: 'horse',
  icon: [576, 512, [128014], "f6f0", "M448 238.1l0-78.1 16 0 32 64 80-32 0-128-32-32 32 0 0-32-128 0C377.3 0 320 57.3 320 128l-171.2 0C118.1 128 91.2 144.3 76.3 168.8 33.2 174.5 0 211.4 0 256l0 80 48 0 0-80c0-13.4 6.6-25.2 16.7-32.5 1.6 13 6.3 25.4 13.6 36.4l42.4 63.6c-18.7 18.6-34.5 34.5-47.6 47.6 1.5 4.6 17.2 51.6 47 141l101.2 0-38.3-115c20.2-20.2 33.9-33.9 41.1-41.1l0-35.9 83.7 23.9c4.1 1.2 8.2 2.1 12.3 2.8l0 165.3 96 0 0-196.3c19.2-19.2 31.5-45.7 32-75.7l0 0 0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faAngle90 = {
  prefix: 'fass',
  iconName: 'angle-90',
  icon: [448, 512, [], "e08d", "M64 64l0-32-64 0 0 448 448 0 0-64-384 0 0-352zM178 169l25.6-41c-28.5-13.8-59.3-23.6-91.7-28.4l0 48.6c23.2 4.1 45.3 11.2 66 20.8zM331.8 368l48.6 0c-4.9-32.4-14.6-63.2-28.4-91.7L311 302c9.6 20.7 16.6 42.9 20.8 66zm-4-133.2c-22.3-32.4-50.3-60.4-82.7-82.7l-25.5 40.8c26.2 18.3 49.1 41.2 67.4 67.4l40.8-25.5z"]
};
var faDownToBracket = {
  prefix: 'fass',
  iconName: 'down-to-bracket',
  icon: [448, 512, [], "e4e7", "M206.6 344.5L224 363 241.4 344.5c107-113.3 165-174.7 174.2-184.5l-127.7 0 0-160-128 0 0 160-127.7 0c9.2 9.7 67.3 71.2 174.2 184.5zM64 352l0-32-64 0 0 192 448 0 0-192-64 0 0 128-320 0 0-96z"]
};
var faBookCopy = {
  prefix: 'fass',
  iconName: 'book-copy',
  icon: [576, 512, [], "e0be", "M224 384l352 0 0-64-32 0 0-64 32 0 0-256-352 0 0 384zm64-80c0-26.5 21.5-48 48-48l144 0 0 64-192 0 0-16zM0 128l0 384 352 0 0-64-288 0 0-16c0-26.5 21.5-48 48-48l64 0 0-256-176 0z"]
};
var faCalendar = {
  prefix: 'fass',
  iconName: 'calendar',
  icon: [448, 512, [128197, 128198], "f133", "M160 0l-64 0 0 64-96 0 0 112 448 0 0-112-96 0 0-64-64 0 0 64-128 0 0-64zM0 224l0 256 448 0 0-256-448 0z"]
};
var faHandsHoldingChild = {
  prefix: 'fass',
  iconName: 'hands-holding-child',
  icon: [640, 512, [], "e4fa", "M320 48a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM290.5 64l-8.8 0-6.7 5.7c-39 33-61.9 52.4-68.8 58.2l31 36.7c12-10.1 24.7-20.9 38.1-32.2-8.8 70-13.4 107.5-14.1 112.6l47.6 6c1.8-14 4.2-33.6 7.3-58.8l7.6 0c3.1 25.2 5.6 44.8 7.3 58.8l47.6-6c-.6-5-5.3-42.6-14.1-112.6 13.4 11.4 26.1 22.1 38.1 32.2l31-36.7C427 122 404 102.6 365 69.7l-6.7-5.7-67.9 0zM80 64l-80 0 0 301.3 9.4 9.4 128 128 9.4 9.4 141.3 0 0-173.3-9.4-9.4C125.1 175.9 201.5 252.2 160 210.7L114.7 256c48.8 48.8 65.1 65.1 91 91L164.1 374.8 80 290.7 80 64zm480 0l0 226.7-84.1 84.1-41.7-27.8c102.9-102.9 58.7-58.7 91-91L480 210.7c-44.2 44.2-69.7 69.7-118.6 118.6l-9.4 9.4 0 173.3 141.3 0 146.7-146.7 0-301.3-80 0z"]
};
var faPollPeople = {
  prefix: 'fass',
  iconName: 'poll-people',
  icon: [512, 512, [], "f759", "M80 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 256a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm384-48l0 64-144 0 0-64 144 0zM272 288l-48 0 0 160 288 0 0-160-240 0zM384 112l80 0 0 64-80 0 0-64zM224 64l0 160 288 0 0-160-288 0zM0 480l160 0-24-64-112 0-24 64zM24 160l-24 64 160 0-24-64-112 0z"]
};
var faBracketRound = {
  prefix: 'fass',
  iconName: 'bracket-round',
  icon: [192, 512, ["parenthesis"], "28", "M0 256C0 140.2 71.9 62.9 110.2 37.4l35.5 53.3C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4l-35.5 53.3C71.9 449.1 0 371.8 0 256z"]
};
var faParenthesis = faBracketRound;
var faTruckContainer = {
  prefix: 'fass',
  iconName: 'truck-container',
  icon: [640, 512, [], "f4dc", "M0 32l352 0 0 256-352 0 0-256zM104 80l-48 0 0 160 48 0 0-160zm96 0l-48 0 0 160 48 0 0-160zm96 0l-48 0 0 160 48 0 0-160zm120 48l141.3 0 9.4 9.4 64 64 9.4 9.4 0 237.3-51.3 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-118.6 0c-10.4 36.9-44.4 64-84.7 64-25.2 0-48-10.6-64-27.6-16 17-38.8 27.6-64 27.6-48.6 0-88-39.4-88-88l0-88 416 0 0-208zM576 237.3l-45.3-45.3-50.7 0 0 96 96 0 0-50.7zM128 424a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm376 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM256 424a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z"]
};
var faEyeEvil = {
  prefix: 'fass',
  iconName: 'eye-evil',
  icon: [640, 512, [], "f6db", "M258.1 111.4L320 0 381.9 111.4c11 2.7 21.7 6.2 31.8 10.3l136.3-39-59 94.5c7.1 8.9 13 18.4 17.7 28.3L640 256 508.7 306.5c-4.6 10-10.6 19.4-17.7 28.3l59 94.5-136.3-39c-10.1 4.1-20.7 7.5-31.8 10.3L320 512 258.1 400.6c-11-2.7-21.7-6.2-31.8-10.2l-136.3 39 59-94.5c-7.1-8.9-13-18.4-17.7-28.3L0 256 131.3 205.5c4.6-10 10.6-19.4 17.7-28.3l-59-94.5 136.3 39c10.1-4.1 20.7-7.5 31.8-10.3zM320 352c53 0 96-43 96-96 0-19.7-6-38.1-16.2-53.3-16.9 9.7-35.7 16.5-55.8 19.5 4.6 9.3 7.9 20.7 7.9 33.8 0 40.4-32 64-32 64s-32-23.6-32-64c0-13.1 3.4-24.5 7.9-33.8-20.1-3-38.9-9.8-55.8-19.5-10.2 15.3-16.2 33.6-16.2 53.3 0 53 43 96 96 96z"]
};
var faPlayFlip = {
  prefix: 'fass',
  iconName: 'play-flip',
  icon: [512, 512, [], "e780", "M448 16L448 496 16 256 448 16z"]
};
var faBorderInner = {
  prefix: 'fass',
  iconName: 'border-inner',
  icon: [448, 512, [], "f84e", "M252 64l0-28-56 0 0 192-192 0 0 56 192 0 0 192 56 0 0-192 192 0 0-56-192 0 0-164zM8 40l0 48 48 0 0-48-48 0zM8 424l0 48 48 0 0-48-48 0zM56 184l0-48-48 0 0 48 48 0zm336 0l48 0 0-48-48 0 0 48zM56 328l-48 0 0 48 48 0 0-48zm336 0l0 48 48 0 0-48-48 0zM152 424l-48 0 0 48 48 0 0-48zM104 40l0 48 48 0 0-48-48 0zM344 424l-48 0 0 48 48 0 0-48zM296 40l0 48 48 0 0-48-48 0zM440 424l-48 0 0 48 48 0 0-48zM392 40l0 48 48 0 0-48-48 0z"]
};
var faItalic = {
  prefix: 'fass',
  iconName: 'italic',
  icon: [384, 512, [], "f033", "M128 32l256 0 0 64-90.7 0-133.3 320 96 0 0 64-256 0 0-64 90.7 0 133.3-320-96 0 0-64z"]
};
var faMicrophoneCirclePlus = {
  prefix: 'fass',
  iconName: 'microphone-circle-plus',
  icon: [576, 512, [], "e77d", "M320 0l0 148c-48.5 34.9-80 91.7-80 156 0 4.9 .2 9.8 .5 14.6-5.4 .9-10.9 1.4-16.5 1.4-53 0-96-43-96-96L128 0 320 0zM224 368c8.9 0 17.6-.8 26.1-2.4 5.4 15.8 12.7 30.7 21.8 44.3-7.8 2-15.7 3.5-23.9 4.5l0 49.5 72 0 0 48-192 0 0-48 72 0 0-49.5C105.3 402.7 32 321.9 32 224l0-64 48 0 0 64c0 79.5 64.5 144 144 144zM432 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 64-64 0 0 32 64 0 0 64 32 0 0-64 64 0 0-32-64 0 0-48z"]
};
var faDownToLine = {
  prefix: 'fass',
  iconName: 'down-to-line',
  icon: [384, 512, ["arrow-alt-to-bottom"], "f34a", "M128 32l0-32 128 0 0 192 127.7 0c-9.2 9.7-67.3 71.2-174.2 184.5L192 395 174.6 376.5C67.6 263.2 9.5 201.7 .3 192l127.7 0 0-160 0 0zM384 512l-384 0 0-64 384 0 0 64z"]
};
var faArrowAltToBottom = faDownToLine;
var faCircleCruzeiro = {
  prefix: 'fass',
  iconName: 'circle-cruzeiro',
  icon: [512, 512, [], "e722", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM163 256c0 44.5 31.2 81.7 73 90.8l0-118.8 40 0 0 17.1c10.7-5.8 23-9.1 36-9.1l8 0 0 40-8 0c-19.9 0-36 16.1-36 36l0 34.8c22.1-4.8 41.2-17.5 54.4-35l38.4 28.8c-25.7 34.2-66.6 56.4-112.8 56.4-77.9 0-141-63.1-141-141s63.1-141 141-141c46.1 0 87.1 22.2 112.8 56.4l-38.4 28.8c-17-22.6-44-37.2-74.4-37.2-51.4 0-93 41.6-93 93z"]
};
var faCloudBinary = {
  prefix: 'fass',
  iconName: 'cloud-binary',
  icon: [576, 512, [], "e601", "M144 480l432 0 0-128c0-47.4-25.7-88.7-64-110.9l0-49.1c0-53-43-96-96-96-17.7 0-34.2 4.8-48.4 13.1-24.1-45.8-72.2-77.1-127.6-77.1-79.5 0-144 64.5-144 144l0 24.2C40.1 220 0 273.3 0 336l0 144 144 0zm64-320l80 0 0 112-96 0 0-112 16 0zm16 80l32 0 0-48-32 0 0 48zm112-80l32 0 0 112-32 0 0-80-16 0 0-32 16 0zM224 304l32 0 0 112-32 0 0-80-16 0 0-32 16 0zm96 0l80 0 0 112-96 0 0-112 16 0zm16 80l32 0 0-48-32 0 0 48z"]
};
var faCardClub = {
  prefix: 'fass',
  iconName: 'card-club',
  icon: [384, 512, [], "e3e9", "M384 512L0 512 0 0 384 0 384 512zM136 352l0 48 112 0 0-48-112 0zm56-240c-35.3 0-64 28.7-64 64 0 5.6 .8 11.1 2.2 16.3-32.6 3-58.2 30.3-58.2 63.7 0 35.3 28.7 64 64 64 24.1 0 45.1-13.4 56-33.1 10.9 19.7 31.9 33.1 56 33.1 35.3 0 64-28.7 64-64 0-33.4-25.6-60.8-58.2-63.7 1.4-5.2 2.2-10.6 2.2-16.3 0-35.3-28.7-64-64-64z"]
};
var faLightSwitchOn = {
  prefix: 'fass',
  iconName: 'light-switch-on',
  icon: [384, 512, [], "e019", "M0 0L384 0 384 512 0 512 0 0zM144 256l0-112 96 0 0 112-96 0zm0 160l144 0 0-320-192 0 0 320 48 0z"]
};
var faTruckSuv = {
  prefix: 'fass',
  iconName: 'truck-suv',
  icon: [576, 512, [], "e7c6", "M96 32l-20.3 0-8.6 18.4-64 136-2.6 5.6-.4 0 0 192 48.4 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8l128.7 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8l48.4 0 0-192-85.1 0-78.9-143.4-9.1-16.6-306.9 0zM417.9 192l-161.9 0 0-96 109.1 0 52.8 96zM192 192l-120.9 0 45.2-96 75.7 0 0 96zM96 392a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm344-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faKhanda = {
  prefix: 'fass',
  iconName: 'khanda',
  icon: [512, 512, [9772], "f66d", "M192 48l64-48 64 48s-6.6 10.6-14.5 27.5C342.5 93.8 368 131.9 368 176s-25.5 82.2-62.5 100.5C313.4 293.4 320 304 320 304l-48 36 0 22.6 34.5-23.7 .1-.1c57.2-39.3 109.4-82.8 109.4-158.2 0-47.6-14.7-106.7-32-132.6 0 0 128 54.5 128 176 0 96-112 192-112 192l-83.4-45.3-32.4 22.3 46.1 31.7c1.8-.4 3.7-.7 5.7-.7 13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21l-40.2-27.6 0 28.9c9.6 5.5 16 15.9 16 27.7 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7l0-28.9-40.2 27.6c-1.5 11.8-11.6 21-23.8 21-13.3 0-24-10.7-24-24s10.7-24 24-24c2 0 3.9 .2 5.7 .7L227.8 393 195.4 370.7 112 416S0 320 0 224c0-121.5 128-176 128-176-17.3 25.9-32 85.1-32 132.6 0 75.4 52.2 118.9 109.4 158.2l.1 .1 34.5 23.7 0-22.6-48-36s6.6-10.6 14.5-27.5C169.5 258.2 144 220.1 144 176s25.5-82.2 62.5-100.5C198.6 58.6 192 48 192 48zm0 128c0 23.5 12.7 44.1 31.6 55.2 4.9-17.3 8.4-36.2 8.4-55.2s-3.5-37.9-8.4-55.2C204.7 131.9 192 152.5 192 176zm88 0c0 18.9 3.5 37.9 8.4 55.2 18.9-11.1 31.6-31.7 31.6-55.2s-12.7-44.1-31.6-55.2c-4.9 17.3-8.4 36.2-8.4 55.2z"]
};
var faFaceFrownOpen = {
  prefix: 'fass',
  iconName: 'face-frown-open',
  icon: [512, 512, [128550, "frown-open"], "f57a", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM255.6 368c-38.7 0-74.5 11.4-103.6 30.6 4.7-53 49.3-94.6 103.6-94.6s98.8 41.6 103.6 94.6C330.1 379.4 294.3 368 255.6 368z"]
};
var faFrownOpen = faFaceFrownOpen;
var faCheck = {
  prefix: 'fass',
  iconName: 'check',
  icon: [512, 512, [10003, 10004], "f00c", "M493 88.9l-18.8 25.9-256 352-22 30.3c-.7-.7-52.2-52.2-154.5-154.5L19 320 64.3 274.7c1.9 1.9 43.3 43.3 124.1 124.1l234-321.7 18.8-25.9 51.8 37.6z"]
};
var faBowArrow = {
  prefix: 'fass',
  iconName: 'bow-arrow',
  icon: [640, 512, [127993], "f6b9", "M576 115.9l-6.9 27.4-51-51-307.1 307.1 12.7 50.8 3.3 13.2-9.6 9.6-94 94c-6.5-25.9-14.1-56.3-22.8-91.2l-91.1-22.8 94-94 9.6-9.6 13.2 3.3 50.8 12.7 307.1-307.1-51-51 27.4-6.9 153.9-38.5-38.5 153.9zM497 181.2c51.7 94.5 39.4 214.8-37.2 297l17.8 17.8-45.3 45.3-147.7-147.7 45.3-45.3 84.7 84.7c51.5-56.7 63-136.8 34.6-203.9L497 181.2zM98.2 116.5C180.4 40 300.7 27.6 395.3 79.4l-47.8 47.8c-67.2-28.5-147.3-16.9-204 34.6l84.7 84.7-45.2 45.3-147.7-147.7 45.2-45.2 17.8 17.8z"]
};
var faBanBug = {
  prefix: 'fass',
  iconName: 'ban-bug',
  icon: [512, 512, ["debug"], "f7f9", "M256 448c-106 0-192-86-192-192 0-41.5 13.1-79.9 35.5-111.2L367.2 412.5C335.9 434.9 297.5 448 256 448zm98.4-138.8c11.2 1.6 25.2 3.6 42 6l6.8-47.5c-12.6-1.8-34.9-5-67.2-9.6l0-4.1c32.2-4.6 54.6-7.8 67.2-9.6l-6.8-47.5c-13.7 2-33.8 4.8-60.4 8.6l0-10.6c18.7-9.3 34.8-17.4 48.2-24.1l-21.5-42.9c-13.1 6.6-29.8 14.9-50 25l-24.8-24.8-64 0-25.4 25.4-53.9-53.9c31.4-22.4 69.8-35.5 111.2-35.5 106 0 192 86 192 192 0 41.5-13.1 79.9-35.5 111.2l-58.1-58.1zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM132.6 264.2l-23.8 3.4 6.8 47.5c13.7-2 33.8-4.8 60.4-8.6l0 10.6c-18.7 9.3-34.8 17.4-48.2 24.1l21.5 42.9c13.1-6.6 29.8-14.9 50-25l24.8 24.8 46.9 0-122.1-122.1-16.2 2.3z"]
};
var faDebug = faBanBug;
var faArrowDownFromDottedLine = {
  prefix: 'fass',
  iconName: 'arrow-down-from-dotted-line',
  icon: [384, 512, [], "e090", "M192 525.3l173.3-173.3-45.3-45.3-96 96 0-274.7-64 0 0 274.7c-57.4-57.4-89.4-89.4-96-96l-45.3 45.3 22.6 22.6 128 128 22.6 22.6zM0 64L64 64 64 0 0 0 0 64zm170.7 0l0-64-64 0 0 64 64 0zm42.7 0l64 0 0-64-64 0 0 64zM384 64l0-64-64 0 0 64 64 0z"]
};
var faFingerprint = {
  prefix: 'fass',
  iconName: 'fingerprint',
  icon: [512, 512, [], "f577", "M48 256c0-114.9 93.1-208 208-208 63.1 0 119.6 28.1 157.8 72.5l15.6 18.2 36.4-31.3-15.6-18.2C403.3 34.6 333.7 0 256 0 114.6 0 0 114.6 0 256l0 64 48 0 0-64zm458.5-52.9l-4.9-23.5-47 9.9 4.9 23.5c2.9 13.9 4.5 28.3 4.5 43.1l0 64 48 0 0-64c0-18.1-1.9-35.8-5.5-52.9zM256 80c-34.2 0-66 9.7-93 26.6l31.7 37c18.2-9.9 39.1-15.6 61.3-15.6 70.7 0 128 57.3 128 128l0 24.9c0 34.6-2.8 69.1-8.4 103.1l48.6 0c5.2-34 7.8-68.5 7.8-103.1l0-24.9c0-97.2-78.8-176-176-176zM126.1 137.3C97.5 168.6 80 210.3 80 256l0 24.9c0 35-5.5 69.8-16.2 103.1l50.1 0c9.3-33.5 14.1-68.2 14.1-103.1l0-24.9c0-31.1 11.1-59.7 29.6-81.9l-31.6-36.8zM256 160c-53 0-96 43-96 96l0 24.9c0 46-7.6 91.6-22.5 135.1l46.3 0c13.4-43.7 20.3-89.2 20.3-135.1l0-24.9c0-28.7 23.3-52 52-52s52 23.3 52 52l0 24.9c0 45.6-5.5 91-16.4 135.1l45.2 0c10.1-44.2 15.2-89.5 15.2-135.1l0-24.9c0-53-43-96-96-96zm24 96l-48 0 0 24.9c0 59.9-11 119.3-32.5 175.2-4.3 11.3-7.4 19.3-9.2 23.9l51.4 0 2.6-6.7C267.9 411.9 280 346.7 280 280.9l0-24.9z"]
};
var faBowlScoop = {
  prefix: 'fass',
  iconName: 'bowl-scoop',
  icon: [448, 512, [127847, "bowl-shaved-ice"], "e3de", "M416 192c0 5.4-.2 10.7-.7 16L32.7 208c-.4-5.3-.7-10.6-.7-16 0-106 86-192 192-192S416 86 416 192zM0 288l0-32 448 0 0 32c0 70.7-57.3 128-128 128l-36.6 0 68.6 96-256 0 68.6-96-36.6 0C57.3 416 0 358.7 0 288z"]
};
var faBowlShavedIce = faBowlScoop;
var faChargingStation = {
  prefix: 'fass',
  iconName: 'charging-station',
  icon: [576, 512, [], "f5e7", "M64 0l288 0 0 288 80 0 0 112 40 0 0-147.7c-32.5-10.2-56-40.5-56-76.3l0-48 32 0 0-64 32 0 0 64 32 0 0-64 32 0 0 64 32 0 0 48c0 35.8-23.5 66.1-56 76.3l0 195.7-136 0 0-112-32 0 0 128 16 0 0 48-320 0 0-48 16 0 0-464zM249.1 66.3l-137.1 123.4 76.2 0-21.3 96 137.1-123.4-76.2 0 21.3-96z"]
};
var faPlaneUpSlash = {
  prefix: 'fass',
  iconName: 'plane-up-slash',
  icon: [576, 512, [], "e22e", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-126.1-126.1 92.9 31 0-80-184-168.7 0-127.3c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 127.3-7.6 7-175.2-175.2zM153.6 223.3l-105.5 96.7 0 80 184-61.3 0 99.7-72 57.6 0 48 128-32 128 32 0-48-72-57.6 0-24.6-190.5-190.5z"]
};
var faUserLock = {
  prefix: 'fass',
  iconName: 'user-lock',
  icon: [576, 512, [], "f502", "M224 248a120 120 0 1 0 0-240 120 120 0 1 0 0 240zm80 104l0-48-224 0-64 208 288 0 0-160zm160-80c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faMobileScreenButton = {
  prefix: 'fass',
  iconName: 'mobile-screen-button',
  icon: [384, 512, ["mobile-alt"], "f3cd", "M16 0l352 0 0 512-352 0 0-512zM80 64l0 304 224 0 0-304-224 0zM192 472c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"]
};
var faMobileAlt = faMobileScreenButton;
var faOlive = {
  prefix: 'fass',
  iconName: 'olive',
  icon: [448, 512, [], "e316", "M0 320c0 88.4 71.6 160 160 160 192 0 288-181.9 288-280 0-76.5-91.5-168-168-168-98.1 0-280 96-280 288zM265.1 105.1c71.3-10.4 120.1 38.4 109.7 109.7-71.3 10.4-120.1-38.4-109.7-109.7z"]
};
var faAnchorCircleCheck = {
  prefix: 'fass',
  iconName: 'anchor-circle-check',
  icon: [640, 512, [], "e4aa", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-53 0-96 43-96 96 0 41.8 26.7 77.4 64 90.5l0 261.5-112 0 0-140.1c10.5 9.2 21.9 19.2 34.3 30l31.6-36.1c-4.4-3.8-31.7-27.8-82.1-71.8L112 216.1c-2.5 2.2-29.1 25.5-79.8 69.8l-18.1 15.8 31.6 36.1c12.4-10.8 23.8-20.8 34.3-30l0 204.1 260 0c-22.7-31.5-36-70.2-36-112 0-27.3 5.7-53.3 16-76.9l0-136.6c37.3-13.2 64-48.7 64-90.5 0-53-43-96-96-96zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.7-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L417.4 400 440 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z"]
};
var faRectangle4k = {
  prefix: 'fass',
  iconName: 'rectangle-4k',
  icon: [512, 512, [], "e772", "M0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm144 32l-48 0 0 72c0 30.9 25.1 56 56 56l40 0 0 64 48 0 0-192-48 0 0 80-40 0c-4.4 0-8-3.6-8-8l0-72zm176 0l-48 0 0 192 48 0 0-72c26.5 0 48 21.5 48 48l0 24 48 0 0-24c0-28.7-12.6-54.4-32.5-72 19.9-17.6 32.5-43.3 32.5-72l0-24-48 0 0 24c0 26.5-21.5 48-48 48l0-72z"]
};
var faScalpel = {
  prefix: 'fass',
  iconName: 'scalpel',
  icon: [640, 512, [], "f61d", "M111.6 368L0 480 192 480 304 368 111.6 368zm47.8-48L416 320 580.7 155.3c17.2-17.2 26.8-40.7 26.8-64.9 0-49.8-40.1-90.8-89.9-91.2-24.4-.2-47.8 9.4-65 26.7L159.4 320z"]
};
var faPersonWalkingWithCane = {
  prefix: 'fass',
  iconName: 'person-walking-with-cane',
  icon: [576, 512, ["blind"], "f29d", "M224.1-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm-64 237.3l-32 32 0 82.7-64 0 0-109.3 9.4-9.4 80-80 9.4-9.4 107.9 0 9.6 11 104 120 12 13.8-7.4 5.5-38.4 28.8-5.6 4.2-9-10.4-63.8-73.6 0 119.1 52.8 45.3 9 7.7 1.8 11.7c12.5 81.4 19.5 126.6 20.9 135.6l-63.3 9.7c-1.7-11-8-52.3-19.1-123.9l-80.7-69.1c-21.3-18.2-33.5-44.9-33.5-72.9l0-69.3zm.1 165.8c2.4 2.3 4.8 4.6 7.4 6.8l46 39.4c-5.2 18.3-8.2 28.8-9 31.5l-5.9 5.9-86.6 86.6-45.3-45.3c9.2-9.2 36.1-36.1 80.8-80.8L160.2 371zm252.9-76.6l14.3 19.3 136 184 14.3 19.3-38.6 28.5-14.3-19.3-136-184-14.3-19.3 38.6-28.5z"]
};
var faBlind = faPersonWalkingWithCane;
var faCandleHolder = {
  prefix: 'fass',
  iconName: 'candle-holder',
  icon: [512, 512, [128367], "f6bc", "M224 192c44.2 0 80-35.8 80-80 0-48-80-112-80-112s-80 64-80 112c0 44.2 35.8 80 80 80zM128 464l-64 0 0 48 376 0c39.8 0 72-32.2 72-72s-32.2-72-72-72-72 32.2-72 72l0 24-48 0 0-224-192 0 0 224zm288-24c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24l-24 0 0-24z"]
};
var faFileWaveform = {
  prefix: 'fass',
  iconName: 'file-waveform',
  icon: [384, 512, ["file-medical-alt"], "f478", "M0 0l240 0 144 144 0 368-384 0 0-160 67.2 0 40.9 61.3 7.1 10.7 28.1 0 6.5-13.8 42.9-91.2c7.1 14.3 12.6 25.3 16.5 33l110.8 0 0-48-81.2 0c-20-40.1-30.7-61.4-32-64l-30.1 0-6.5 13.8-45.9 97.5c-19.2-28.7-29.7-44.5-31.5-47.3L0 304 0 0zM208 58.5L208 176 325.5 176 208 58.5z"]
};
var faFileMedicalAlt = faFileWaveform;
var faRenminbiSign = {
  prefix: 'fass',
  iconName: 'renminbi-sign',
  icon: [384, 512, [], "e73c", "M85.6 62.7l-17.3-26.9-53.8 34.6 17.3 26.9 112.3 174.7-79.7 0 0 48 96 0 0 32-96 0 0 48 96 0 0 80 64 0 0-80 96 0 0-48-96 0 0-32 96 0 0-48-79.7 0 112.3-174.7 17.3-26.9-53.8-34.6-17.3 26.9-106.8 166.1-106.8-166.1z"]
};
var faFaceSpiralEyes = {
  prefix: 'fass',
  iconName: 'face-spiral-eyes',
  icon: [512, 512, [], "e485", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm36.9-95.4L256 392c-28.9 19.3-44.9 29.9-48 32-2.9-1.9-19.3-12.9-49.4-33-15 7.5-28.2 14.1-39.5 19.8l-17.9-35.8c9.6-4.8 26.2-13.1 49.9-24.9l10.4-5.2c1.9 1.3 17.4 11.6 46.6 31 28.9-19.3 44.9-29.9 48-32 3.1 2.1 19.1 12.7 48 32 29.1-19.4 44.7-29.8 46.6-31l60.3 30.1-17.9 35.8-39.5-19.8c-30.1 20.1-46.6 31.1-49.4 33l-11.1-7.4zM173.7 140c-21.8 0-42.6 8.4-57.9 23.4-15.3 14.9-23.8 35.1-23.8 56.1 0 14.9 6.1 29.3 17 39.9 10.9 10.6 25.8 16.7 41.3 16.7s30.4-6 41.3-16.7c10.9-10.6 17-25 17-39.9 0-8.8-3.6-17.4-10.1-23.7-6.5-6.4-15.4-10-24.8-10s-18.2 3.6-24.8 10c-6.5 6.3-10.1 14.9-10.1 23.7 0 2.8 1.1 5.5 3.2 7.6 2.1 2.1 5.1 3.3 8.2 3.3s6.1-1.2 8.2-3.3c2.1-2.1 3.2-4.8 3.2-7.6l24 0c0 9.3-3.8 18.2-10.5 24.8-6.7 6.5-15.6 10.1-24.9 10.1s-18.3-3.6-24.9-10.1c-6.7-6.5-10.5-15.4-10.5-24.8 0-15.4 6.3-30.1 17.3-40.9 11.1-10.8 26-16.8 41.5-16.8s30.5 6 41.5 16.8c11.1 10.8 17.3 25.5 17.3 40.9 0 21.5-8.7 42-24.2 57.1-15.5 15.1-36.4 23.5-58.1 23.5s-42.6-8.4-58.1-23.5c-15.5-15.1-24.2-35.6-24.2-57.1 0-27.5 11.2-53.9 31.1-73.2 19.8-19.4 46.7-30.2 74.7-30.2l0 24zM396.2 252.6c15.3-14.9 23.8-35.1 23.8-56.1 0-14.9-6.1-29.3-17-39.9-10.9-10.6-25.8-16.7-41.3-16.7s-30.4 6-41.3 16.7c-10.9 10.6-17 25-17 39.9 0 8.8 3.6 17.4 10.1 23.7 6.5 6.4 15.4 10 24.8 10s18.2-3.6 24.8-10c6.5-6.3 10.1-14.9 10.1-23.7 0-2.8-1.1-5.5-3.2-7.6-2.1-2.1-5.1-3.3-8.2-3.3s-6.1 1.2-8.2 3.3c-2.1 2.1-3.2 4.8-3.2 7.6l-24 0c0-9.3 3.8-18.2 10.5-24.8 6.7-6.5 15.6-10.1 24.9-10.1s18.3 3.6 24.9 10.1c6.7 6.5 10.5 15.4 10.5 24.8 0 15.4-6.3 30.1-17.3 40.9-11.1 10.8-26 16.8-41.5 16.8s-30.5-6-41.5-16.8c-11.1-10.8-17.3-25.5-17.3-40.9 0-21.5 8.7-42 24.2-57.1 15.5-15.1 36.4-23.5 58.1-23.5s42.6 8.4 58.1 23.5c15.5 15.1 24.2 35.6 24.2 57.1 0 27.5-11.2 53.9-31.1 73.2-19.8 19.4-46.7 30.2-74.7 30.2l0-24c21.8 0 42.6-8.4 57.9-23.4z"]
};
var faCalendarArrowUp = {
  prefix: 'fass',
  iconName: 'calendar-arrow-up',
  icon: [448, 512, ["calendar-upload"], "e0d1", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0zm81 191l-17-17c-2.1 2.1-31.8 31.8-89 89l-17 17 33.9 33.9c9-9 25-25 48-48l0 126.1 48 0 0-126.1c23 23 39 39 48 48L329.9 280c-2.1-2.1-31.8-31.8-89-89z"]
};
var faCalendarUpload = faCalendarArrowUp;
var faPersonArmsRaised = {
  prefix: 'fass',
  iconName: 'person-arms-raised',
  icon: [384, 512, [], "e783", "M80 0l0-32-64 0 0 224 96 0 0 352 64 0 0-192 32 0 0 192 64 0 0-352 96 0 0-224-64 0 0 160-224 0 0-128zM192 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faPersonDressFairy = {
  prefix: 'fass',
  iconName: 'person-dress-fairy',
  icon: [576, 512, [], "e607", "M288 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 384l-64-224-128 0-64 224 64 0 0 128 128 0 0-128 64 0zM192 104.9C158 74.5 113.2 56 64 56L0 56 0 120c0 76.7 45 142.9 110 173.7-28.1 23.5-46 58.8-46 98.3l0 48 27.5 0 100.5-335.1zM484.5 440l27.5 0 0-48c0-39.5-17.9-74.8-46-98.3 65-30.7 110-97 110-173.7l0-64-64 0c-49.2 0-94 18.5-128 48.9L484.5 440z"]
};
var faBarProgress = {
  prefix: 'fass',
  iconName: 'bar-progress',
  icon: [512, 512, [], "e6a4", "M320 160l0 192 128 0 0-192-128 0zM0 96l512 0 0 320-512 0 0-320z"]
};
var faChartKanban = {
  prefix: 'fass',
  iconName: 'chart-kanban',
  icon: [512, 512, [], "e64f", "M384 448l128 0 0-384-128 0 0 384zM320 320l0-256-128 0 0 256 128 0zM128 416l0-352-128 0 0 352 128 0z"]
};
var faCloudMusic = {
  prefix: 'fass',
  iconName: 'cloud-music',
  icon: [576, 512, [], "f8ae", "M144 480l432 0 0-128c0-47.4-25.7-88.7-64-110.9l0-49.1c0-53-43-96-96-96-17.7 0-34.2 4.8-48.4 13.1-24.1-45.8-72.2-77.1-127.6-77.1-79.5 0-144 64.5-144 144l0 24.2C40.1 220 0 273.3 0 336l0 144 144 0zM368 192l0 64-48 0 0 104c0 30.9-28.7 56-64 56s-64-25.1-64-56 28.7-56 64-56c5.5 0 10.9 .6 16 1.8l0-113.8 96 0z"]
};
var faWatchSmart = {
  prefix: 'fass',
  iconName: 'watch-smart',
  icon: [384, 512, [], "e2cc", "M123-32L261-32c24.5 0 45 18.4 47.7 42.7l6 54C353.8 70 384 103.5 384 144l0 224c0 40.5-30.2 74-69.3 79.3l-6 54C306 525.6 285.5 544 261 544L123 544c-24.5 0-45-18.4-47.7-42.7l-6-54C30.2 442 0 408.5 0 368L0 144c0-40.5 30.2-74 69.3-79.3l6-54C78-13.6 98.5-32 123-32zM304 128L80 128c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm-88 56l0 62.1c31.3 31.3 50.6 50.6 57.9 57.9L240 337.9c-6.1-6.1-27.8-27.8-65-65l-7-7 0-105.9 48 0 0 24z"]
};
var faLeftToBracket = {
  prefix: 'fass',
  iconName: 'left-to-bracket',
  icon: [512, 512, [], "e66d", "M167.5 273.4L149 256 167.5 238.6C280.8 131.6 342.3 73.5 352 64.3l0 127.7 160 0 0 128-160 0 0 127.7c-9.7-9.2-71.2-67.3-184.5-174.2zM160 416l32 0 0 64-192 0 0-448 192 0 0 64-128 0 0 320 96 0z"]
};
var faGrateDroplet = {
  prefix: 'fass',
  iconName: 'grate-droplet',
  icon: [640, 512, [], "e194", "M128 32l-32 0 0 448 257.1 0c-5.9-16.9-9.1-35-9.1-54 0-3.3 .1-6.7 .3-10l-.3 0 0-136 48 0 0 7.6c15.8-25.1 33.1-47.8 48-65.6l0-125.9 40 0 0 90c20.3-9.4 43.7-9.4 64 0l0-154-416 0zm32 200l0-136 40 0 0 136-40 0zm0 48l40 0 0 136-40 0 0-136zm88 136l0-136 48 0 0 136-48 0zM392 96l0 136-48 0 0-136 48 0zm-96 0l0 136-48 0 0-136 48 0zM632 426.1C632 331.9 512 214 512 214S392 331.9 392 426.1C392 491.2 445.7 544 512 544s120-52.8 120-117.9z"]
};
var faHouseCrack = {
  prefix: 'fass',
  iconName: 'house-crack',
  icon: [512, 512, [], "e3b1", "M512 272l-48 0 0 240-169.6 0-38.4-64 96-80-160-112 64 112-96 80 38.4 64-150.4 0 0-240-48 0 0-48 256-240 256 240 0 48z"]
};
var faWifiSlash = {
  prefix: 'fass',
  iconName: 'wifi-slash',
  icon: [576, 512, [], "f6ac", "M32.5-33.8C33.1-33.2 65.8-.5 130.6 64.3 179 43.5 232.3 32 288.3 32 404.7 32 509.5 81.7 582.6 161.1l-45.8 44.7c-61.5-67.4-150-109.8-248.4-109.8-37.8 0-74.2 6.3-108.2 17.8l94.6 94.6c4.5-.3 9-.4 13.6-.4 31.8 0 62 6.6 89.3 18.5l0 0c30.4 13.2 57.2 33 78.8 57.5l-45.9 44.8-7.8 7.6 158.7 158.7 17 17-33.9 33.9-17-17-512-512-17-17 33.9-33.9zM218.5 288c-20.2 9.8-38.1 23.8-52.4 40.8L120.1 284c14.8-16.8 32.1-31.4 51.3-43.1L218.5 288zM45 114.5l45.7 45.7c-18.5 13.4-35.5 28.7-50.8 45.6L-6 161.1c15.6-16.9 32.7-32.5 51-46.6zM240.3 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faHatWizard = {
  prefix: 'fass',
  iconName: 'hat-wizard',
  icon: [512, 512, [], "f6e8", "M64 400l112-272 240-128-48 192 80 208-217.1 0 17.1-40 56-24-56-24-24-56-24 56-56 24 56 24 17.1 40-153.1 0zM256 192l16 32 16-32 32-16-32-16-16-32-16 32-32 16 32 16zM32 448l480 0 0 64-512 0 0-64 32 0z"]
};
var faFootballHelmet = {
  prefix: 'fass',
  iconName: 'football-helmet',
  icon: [512, 512, [], "f44f", "M256 0C386.6 0 494.3 97.8 510 224.2l-159.2 18.7 28.2 93.1 133 0 0 176-129.8 0-5.2-17-33.6-111-55.4 0 0 80-64 0-188.9-78.7C12.8 347.3 0 303.2 0 256 0 114.6 114.6 0 256 0zM417.8 464l46.2 0 0-80-70.4 0 24.2 80zM160 288a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm80-32l30 80 58.8 0-26.5-87.4-62.4 7.4z"]
};
var faUserDoctor = {
  prefix: 'fass',
  iconName: 'user-doctor',
  icon: [448, 512, ["user-md"], "f0f0", "M224 8a120 120 0 1 0 0 240 120 120 0 1 0 0-240zm60 359.4l0-47.4-120 0 0 68.4c16.5 7.6 28 24.3 28 43.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-19.4 11.5-36.1 28-43.6l0-68.4-44 0-64 192 416 0-64-192-44 0 0 47.4c23.3 8.2 40 30.5 40 56.6l0 52-40 0 0-52c0-11-9-20-20-20s-20 9-20 20l0 52-40 0 0-52c0-26.1 16.7-48.3 40-56.6z"]
};
var faUserMd = faUserDoctor;
var faGlassesRound = {
  prefix: 'fass',
  iconName: 'glasses-round',
  icon: [576, 512, [128083, "glasses-alt"], "f5f5", "M71 32l137 0 0 64-87 0-29.9 119.6c14.1-4.9 29.2-7.6 44.9-7.6 55.1 0 102.6 32.8 124 80l56.1 0c21.3-47.2 68.8-80 124-80 15.7 0 30.9 2.7 44.9 7.6l-29.9-119.6-87 0 0-64 137 0 6.1 24.2 58.3 233.1c4.4 17.8 6.7 36 6.7 54.3l0 .4c0 75.1-60.9 136-136 136-72.4 0-131.6-56.6-135.8-128l-32.5 0C267.6 423.4 208.4 480 136 480 60.9 480 0 419.1 0 344l0-.4c0-18.3 2.2-36.6 6.7-54.3L65 56.2 71 32zM64 344a72 72 0 1 0 144 0 72 72 0 1 0 -144 0zm376 72a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
};
var faGlassesAlt = faGlassesRound;
var faRocketLaunch = {
  prefix: 'fass',
  iconName: 'rocket-launch',
  icon: [512, 512, [128640], "e027", "M160 288l-160 0 96-160 122.1 0C301.6-13.4 430.1-7.5 504.6 7.4 519.5 81.9 525.4 210.4 384 293.9l0 122.1-160 96 0-160-64-64zM432 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM152.4 473.6c-45.3 45.3-152 38-152 38s-7.3-106.7 38-152c31.5-31.5 82.5-31.5 114 0s31.5 82.5 0 114zm-40.6-32c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-16.5 16.5-13.8 55.2-13.8 55.2s38.7 2.7 55.2-13.8z"]
};
var faHandHoldingCircleDollar = {
  prefix: 'fass',
  iconName: 'hand-holding-circle-dollar',
  icon: [576, 512, [], "e621", "M416 112a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM288 40l32 0 0 32-61.8 0c-5.6 0-10.2 4.6-10.2 10.2 0 4.9 3.5 9.1 8.3 10l45 8.2c20 3.6 34.6 21.1 34.6 41.5 0 23.3-18.9 42.2-42.2 42.2l-5.8 0 0 24-32 0 0-24-32 0 0-32 69.8 0c5.6 0 10.2-4.6 10.2-10.2 0-4.9-3.5-9.1-8.3-10l-45-8.2c-20-3.6-34.6-21.1-34.6-41.5 0-22.6 17.7-41 40-42.1l0-24.1 32 0 0 24zM137.4 313.4l-70.6 70.6-66.7 0 0 128 396.4 0 10.2-7c101.2-69.6 154.8-106.4 161-110.7l-45.3-65.9c-11.7 8.1-54.2 37.3-127.5 87.6l-138.8 0 0-48 128 0 0-64-237.3 0-9.4 9.4z"]
};
var faChartBar = {
  prefix: 'fass',
  iconName: 'chart-bar',
  icon: [512, 512, ["bar-chart"], "f080", "M64 32l0 384 448 0 0 64-512 0 0-448 64 0zm320 96l-256 0 0-64 256 0 0 64zM160 176l160 0 0 64-192 0 0-64 32 0zm0 112l288 0 0 64-320 0 0-64 32 0z"]
};
var faBarChart = faChartBar;
var faMessageDollar = {
  prefix: 'fass',
  iconName: 'message-dollar',
  icon: [512, 512, ["comment-alt-dollar"], "f650", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zm280 96l0 24 28 0 0 40-67.5 0c-6.9 0-12.5 5.6-12.5 12.5 0 6.1 4.4 11.3 10.4 12.3l41.7 7c25.3 4.2 43.9 26.1 43.9 51.8 0 26.1-19 47.7-44 51.8l0 24.7-40 0 0-24-44 0 0-40 75.5 0c6.9 0 12.5-5.6 12.5-12.5 0-6.1-4.4-11.3-10.4-12.3l-41.7-7c-25.3-4.2-43.9-26.1-43.9-51.8 0-28.8 23.2-52.2 52-52.5l0-24 40 0z"]
};
var faCommentAltDollar = faMessageDollar;
var faVideoDownToLine = {
  prefix: 'fass',
  iconName: 'video-down-to-line',
  icon: [448, 512, [], "e776", "M24 496l424 0 0 48-448 0 0-48 24 0zM384 0l0 320-103.2 0 55.2 96-224 0 55.2-96-103.2 0 0-320 320 0z"]
};
var faSprayCanSparkles = {
  prefix: 'fass',
  iconName: 'spray-can-sparkles',
  icon: [576, 512, ["air-freshener"], "f5d0", "M160 0l0 112 128 0 0-112-128 0zm0 160c-53 0-96 43-96 96l0 256 320 0 0-256c0-53-43-96-96-96l-128 0zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 32l-32 16 32 16 16 32 16-32 32-16-32-16-16-32-16 32zm32 112l32 16 16 32 16-32 32-16-32-16-16-32-16 32-32 16zM528 0l-16 32-32 16 32 16 16 32 16-32 32-16-32-16-16-32zM512 224l-32 16 32 16 16 32 16-32 32-16-32-16-16-32-16 32z"]
};
var faAirFreshener = faSprayCanSparkles;
var faBahtSign = {
  prefix: 'fass',
  iconName: 'baht-sign',
  icon: [320, 512, [], "e0ac", "M160 0l-48 0 0 64-112 0 0 384 112 0 0 64 48 0 0-64 48 0c61.9 0 112-50.1 112-112 0-40.1-21.1-75.3-52.7-95.1 13.1-18.3 20.7-40.7 20.7-64.9 0-61.9-50.1-112-112-112l-16 0 0-64zM112 128l0 96-48 0 0-96 48 0zm48 96l0-96 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0zm-48 64l0 96-48 0 0-96 48 0zm48 96l0-96 48 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-48 0z"]
};
var faFaceBeamHandOverMouth = {
  prefix: 'fass',
  iconName: 'face-beam-hand-over-mouth',
  icon: [512, 512, [129325], "e47c", "M88 436C88 440.6 88.2 445.2 88.6 449.7 34.3 402.8 0 333.4 0 256 0 114.6 114.6 0 256 0S512 114.6 512 256c0 68.5-26.9 130.7-70.7 176.7-4.9-4.9-21.1-21.1-48.7-48.7l3.7-3.7 28.3-28.3c-41.8-41.8-76.9-76.9-88.6-88.6l-16 16c-11.7-11.7-27.7-27.7-48-48-20.2 20.2-36.4 36.4-48.6 48.6L88 280 88 436zm88-272c15.5 0 28 12.5 28 28l0 28 40 0 0-28c0-37.6-30.4-68-68-68s-68 30.4-68 68l0 28 40 0 0-28c0-15.5 12.5-28 28-28zm132 28c0-15.5 12.5-28 28-28s28 12.5 28 28l0 28 40 0 0-28c0-37.6-30.4-68-68-68s-68 30.4-68 68l0 28 40 0 0-28zM128 320l48 0 0 64 96-96 32 32-64 64 16 16 80-80 32 32-80 80 16 16 48-48 32 32-82.2 82.2c-19.1 19.1-45 29.8-72 29.8-56.2 0-101.8-45.6-101.8-101.8L128 320z"]
};
var faTemperatureArrowUp = {
  prefix: 'fass',
  iconName: 'temperature-arrow-up',
  icon: [576, 512, ["temperature-up"], "e040", "M470.9 9.4c49.6 49.6 78.4 78.4 86.6 86.6l-45.3 45.3-32-32 0 210.7-64 0 0-210.7-32 32-45.3-45.3c8.2-8.2 37.1-37.1 86.6-86.6l22.6-22.6 22.6 22.6zM96.3 0l192 0 0 260.7c29.5 26.4 48 64.7 48 107.3 0 79.5-64.5 144-144 144s-144-64.5-144-144c0-42.6 18.5-81 48-107.3L96.3 0zm96 432c35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3l0-236.7-48 0 0 236.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64z"]
};
var faTemperatureUp = faTemperatureArrowUp;
var faWebAwesome = {
  prefix: 'fass',
  iconName: 'web-awesome',
  icon: [640, 512, [], "e682", "M372.2 52c0 20.9-12.4 39-30.2 47.2L448 192 552.4 171.1c-5.3-7.7-8.4-17.1-8.4-27.1 0-26.5 21.5-48 48-48s48 21.5 48 48c0 26-20.6 47.1-46.4 48L464 480 176 480 46.4 192C20.6 191.1 0 170 0 144 0 117.5 21.5 96 48 96s48 21.5 48 48c0 10.1-3.1 19.4-8.4 27.1L192 192 298.1 99.1c-17.7-8.3-30-26.3-30-47.1 0-28.7 23.3-52 52-52s52 23.3 52 52z"]
};
var faNonBinary = {
  prefix: 'fass',
  iconName: 'non-binary',
  icon: [384, 512, [], "e807", "M192 544c-97.2 0-176-78.8-176-176 0-86.3 62.1-158 144-173l0-47.2c-36.6 18.3-62.7 31.3-78.3 39.1L53.1 129.7C70.5 121 92.9 109.8 120.5 96 93 82.2 70.5 71 53.1 62.3L81.7 5.1c15.5 7.8 41.6 20.8 78.3 39.2l0-76.2 64 0 0 76.2c36.6-18.3 62.7-31.4 78.3-39.1l28.6 57.2C313.6 71 291.1 82.2 263.6 96l67.3 33.7-28.6 57.2c-15.6-7.8-41.7-20.8-78.3-39.1l0 47.2c81.9 15.1 144 86.8 144 173 0 97.2-78.8 176-176 176zm0-64a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
var faShieldSlash = {
  prefix: 'fass',
  iconName: 'shield-slash',
  icon: [576, 512, [], "e24b", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-110.5-110.5c16.1-22.8 29.1-46.7 39.5-70.7 32.4-74.7 40.2-151 37.3-200.9L526.4 92.5 507.2 85 299.7 4.5 288.1 0 276.5 4.5 128.2 62.1 49.3-16.9zm-.8 135c-2.1 50 6.2 123.6 37.6 195.8 32.7 75.3 91 150 189.4 192.6l12.7 5.5 12.7-5.5c32.4-14 60.4-31.5 84.6-51.3l-337-337z"]
};
var faFloppyDisks = {
  prefix: 'fass',
  iconName: 'floppy-disks',
  icon: [512, 512, [], "e183", "M96 0l297.9 0 7 7 104 104 7 7 0 297.9-416 0 0-416zM48 120l0 344 368 0 0 48-416 0 0-416 48 0 0 24zM360 280a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM384 64l-192 0 0 96 192 0 0-96z"]
};
var faN = {
  prefix: 'fass',
  iconName: 'n',
  icon: [384, 512, [110], "4e", "M0 32l47 0 9.6 11.5 263.4 316.1 0-327.6 64 0 0 448-47 0-9.6-11.5-263.4-316.1 0 327.6-64 0 0-448z"]
};
var faArrowsUpDownLeftRight = {
  prefix: 'fass',
  iconName: 'arrows-up-down-left-right',
  icon: [576, 512, ["arrows"], "f047", "M310.9 9.4L288.3-13.3c-8.2 8.2-37.1 37.1-86.6 86.6L179 96 224.3 141.3c17.3-17.3 28-28 32-32l0 114.7-114.7 0c4-4 14.7-14.7 32-32l-45.3-45.3c-8.2 8.2-37.1 37.1-86.6 86.6l-22.6 22.6 86.6 86.6 22.6 22.6 45.3-45.3-32-32 114.7 0 0 114.7c-4-4-14.7-14.7-32-32L179 416c8.2 8.2 37.1 37.1 86.6 86.6l22.6 22.6 109.3-109.3-45.3-45.3-32 32 0-114.7 114.7 0-32 32 45.3 45.3 109.3-109.3c-8.2-8.2-37.1-37.1-86.6-86.6L448.3 146.7 403 192c17.3 17.3 28 28 32 32l-114.7 0 0-114.7 32 32 45.3-45.3c-8.2-8.2-37.1-37.1-86.6-86.6z"]
};
var faArrows = faArrowsUpDownLeftRight;
var faHouse = {
  prefix: 'fass',
  iconName: 'house',
  icon: [512, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M512 272l-48 0 0 240-416 0 0-240-48 0 0-48 256-240 256 240 0 48zM320 464l0-144-128 0 0 144 128 0z"]
};
var faHome = faHouse;
var faHomeAlt = faHouse;
var faHomeLgAlt = faHouse;
var faSpinner = {
  prefix: 'fass',
  iconName: 'spinner',
  icon: [512, 512, [], "f110", "M208 0l0 96 96 0 0-96-96 0zM0 208l0 96 96 0 0-96-96 0zM208 512l96 0 0-96-96 0 0 96zM512 208l-96 0 0 96 96 0 0-96zM41 403.1l67.9 67.9 67.9-67.9-67.9-67.9-67.9 67.9zm362 67.9l67.9-67.9-67.9-67.9-67.9 67.9 67.9 67.9zM41 108.9l67.9 67.9 67.9-67.9-67.9-67.9-67.9 67.9z"]
};
var faSquareY = {
  prefix: 'fass',
  iconName: 'square-y',
  icon: [448, 512, [], "e287", "M448 32l-448 0 0 448 448 0 0-448zM118 155.2l-7.4-11.2 57.6 0 55.9 84.5 55.9-84.5 57.6 0-7.4 11.2-82 124 0 88.8-48 0 0-88.8-82-124z"]
};
var faSquareMill = {
  prefix: 'fass',
  iconName: 'square-mill',
  icon: [448, 512, [], "e70a", "M448 32l-448 0 0 448 448 0 0-448zM309.1 103.9c-2.3 5.1-10.7 24.1-25.4 57.1 34.2 5.6 60.2 35.3 60.2 71l0 120-48 0 0-120c0-13.3-10.7-24-24-24-3.6 0-7.1 .8-10.2 2.2l-13.8 31.1 0 110.6-48 0 0-2.6c-20.1 45.2-30.7 69.1-31.9 71.7l-29.2-13 6.5-14.6 54.6-122.9 0-38.6 0-.4c-.2-13.1-10.9-23.6-24-23.6-13.3 0-24 10.7-24 24 0 76 0 116 0 120l-48 0c0-10.7 0-37.3 0-80l0 0c0-9.3 0-38.7 0-88l0-24 48 0 0 4.1c7.5-2.7 15.6-4.1 24-4.1 18.4 0 35.3 6.9 48 18.3 6.7-6 14.6-10.8 23.2-13.9 20.7-46.6 31.6-71.1 32.7-73.5l29.2 13z"]
};
var faGavel = {
  prefix: 'fass',
  iconName: 'gavel',
  icon: [640, 512, ["legal"], "f0e3", "M224.5 176l-64-64 160-160 64 64-160 160zm83.7 35.7l-31.4-31.4 112-112 119.4 119.4-112 112-31.4-31.4-232 232-28.3 28.3-56.6-56.6 28.3-28.3 232-232zM400.5 352l160-160 64 64-160 160-64-64z"]
};
var faLegal = faGavel;
var faCircleTugrik = {
  prefix: 'fass',
  iconName: 'circle-tugrik',
  icon: [512, 512, [], "e711", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM144 144l224 0 0 48-88 0 0 39.1c33.3-11.1 52.6-17.5 58.1-19.4l10.1 30.4c-3.8 1.3-26.6 8.9-68.2 22.7l0 30.3c33.3-11.1 52.6-17.5 58.1-19.4l10.1 30.4c-3.8 1.3-26.6 8.9-68.2 22.7l0 71.1-48 0 0-55.1c-33.3 11.1-52.6 17.5-58.1 19.4l-10.1-30.4c3.8-1.3 26.6-8.9 68.2-22.7l0-30.3c-33.3 11.1-52.6 17.5-58.1 19.4l-10.1-30.4c3.8-1.3 26.6-8.9 68.2-22.7l0-55.1-88 0 0-48z"]
};
var faTrashClock = {
  prefix: 'fass',
  iconName: 'trash-clock',
  icon: [576, 512, [], "e2b0", "M176-16l-16 48-128 0 0 64 448 0 0-64-128 0-16-48-160 0zM448 144l-384 0 24 368 188 0c-22.7-31.5-36-70.2-36-112 0-106 86-192 192-192 4 0 7.9 .1 11.8 .4L448 144zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 320l0 64 48 0 0 32-80 0 0-96 32 0z"]
};
var faCirclePhone = {
  prefix: 'fass',
  iconName: 'circle-phone',
  icon: [512, 512, ["phone-circle"], "e11b", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM192 128l48.4 64-40.4 40c16.5 35.2 44.8 63.5 80 80l40-40.4 64 48.4-32 64-8 0c-119.3 0-216-96.7-216-216l0-8 64-32z"]
};
var faPhoneCircle = faCirclePhone;
var faBoltAuto = {
  prefix: 'fass',
  iconName: 'bolt-auto',
  icon: [576, 512, [], "e0b6", "M352 0L0 288 183.1 288 96 512 448 224 264.9 224 352 0zM479.8 288l-31.7 0-6.2 14.6-89.5 209.4 52.2 0 17.1-40 84.5 0 17.1 40 52.2 0-89.5-209.4-6.2-14.6zm5.9 136l-43.5 0 21.8-50.9 21.8 50.9z"]
};
var faUserPilotTieHairLong = {
  prefix: 'fass',
  iconName: 'user-pilot-tie-hair-long',
  icon: [448, 512, [], "e7b4", "M48 16l0 32 32 19.2 0 44.8s5.8 2.8 16 6.7l0 57.3-48 96 352 0-48-96 0-57.3c10.2-3.9 16-6.7 16-6.7l0-44.8 32-19.2 0-32-176-48-176 48zM224.2 224l-.4 0c-44.1-.1-79.8-35.9-79.8-80l0-10.3c23.2 5.7 50.9 10.3 80 10.3s56.8-4.6 80-10.3l0 10.3c0 44.1-35.7 79.9-79.8 80zM272 304l-96 0 0 24 31.4 36.7-31.4 115.3-40-160-56 0-64 192 416 0-64-192-56 0-40 160-.6 0-31-115.1 31.6-36.9 0-24zM168.8 26.5c5.1 2.6 23.5 11.8 55.2 27.6 31.7-15.8 50-25 55.2-27.6l14.3 28.6c-3.9 2-24.7 12.4-62.3 31.2l-7.2 3.6-7.2-3.6c-37.6-18.8-58.4-29.2-62.3-31.2l14.3-28.6zM336 416l32 0 0 32-48 0 0-32 16 0z"]
};
var faArrowTurnLeftDown = {
  prefix: 'fass',
  iconName: 'arrow-turn-left-down',
  icon: [384, 512, [], "e633", "M352 64l32 0 0-64-224 0 0 402.7c-57.4-57.4-89.4-89.4-96-96l-45.3 45.3 22.6 22.6 128 128 22.6 22.6 173.3-173.3-45.3-45.3-96 96 0-338.7 128 0z"]
};
var faTicketSimple = {
  prefix: 'fass',
  iconName: 'ticket-simple',
  icon: [576, 512, ["ticket-alt"], "f3ff", "M0 64l576 0 0 144c-26.5 0-48 21.5-48 48s21.5 48 48 48l0 144-576 0 0-144c26.5 0 48-21.5 48-48S26.5 208 0 208L0 64z"]
};
var faTicketAlt = faTicketSimple;
var faDove = {
  prefix: 'fass',
  iconName: 'dove',
  icon: [576, 512, [128330], "f4ba", "M512 128l0 176c0 79.5-64.5 144-144 144l-112 0-64 64-160-96 160-64C32 304 37.4 117.3 64 64l288 160 0-80c0-44.2 35.8-80 80-80l128 0-48 64zm-80-8a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM313.4 95.9c-5.8 14.4-9.2 30.1-9.4 46.5L170.2 68C185.3 20.8 215.6-15.8 240-32L313.4 95.9z"]
};
var faCircleYen = {
  prefix: 'fass',
  iconName: 'circle-yen',
  icon: [512, 512, [], "e5d0", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM197.3 127.2c2.3 4 21.9 37.5 58.7 100.5 36.8-63 56.4-96.5 58.7-100.5l41.4 24.2c-1.9 3.3-22.3 38.2-61.1 104.6l41 0 0 32-56 0 0 32 56 0 0 32-56 0 0 48-48 0 0-48-56 0 0-32 56 0 0-32-56 0 0-32 41 0c-38.8-66.5-59.2-101.3-61.1-104.6l41.4-24.2z"]
};
var faTarpDroplet = {
  prefix: 'fass',
  iconName: 'tarp-droplet',
  icon: [512, 512, [], "e57c", "M256 160c35.3 0 64-26.9 64-60s-64-108-64-108-64 74.9-64 108 28.7 60 64 60zM368 96c0 61.9-50.1 112-112 112S144 157.9 144 96c0-11.1 1.6-21.9 4.6-32L0 64 0 448 368 448 512 304 512 64 363.4 64c3 10.1 4.6 20.9 4.6 32zm85.5 176L336 389.5 336 272 453.5 272zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBroomWide = {
  prefix: 'fass',
  iconName: 'broom-wide',
  icon: [576, 512, [], "e5d1", "M328 168l200-200 48 48-200 200 40 40-37.8 61.9-152.1-152.1 61.9-37.8 40 40zM191 187.3L356.7 353 240 544 108 412 128 352 68 372 0 304 191 187.3z"]
};
var faPlayPause = {
  prefix: 'fass',
  iconName: 'play-pause',
  icon: [512, 512, [], "e22f", "M256 256L0 464 0 48 256 256zM384 96l0 352-64 0 0-384 64 0 0 32zm128 0l0 352-64 0 0-384 64 0 0 32z"]
};
var faTreeCity = {
  prefix: 'fass',
  iconName: 'tree-city',
  icon: [640, 512, [], "e587", "M288 0l192 0 0 96 48 0 0-96 48 0 0 96 64 0 0 416-352 0 0-512zm64 96l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zm224-96l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zM96 480l0-160-96 0 0-80c0-26.7 13.1-50.3 33.2-64.9-.8-4.9-1.2-10-1.2-15.1 0-53 43-96 96-96s96 43 96 96l0 160-64 0 0 192-64 0 0-32z"]
};
var faCalendarRange = {
  prefix: 'fass',
  iconName: 'calendar-range',
  icon: [448, 512, [], "e0d6", "M160 32l0-32-64 0 0 64-96 0 0 416 448 0 0-416-96 0 0-64-64 0 0 64-128 0 0-32zM128 192l0 64-64 0 0-64 64 0zM384 384l-64 0 0-64 64 0 0 64zm0-192l0 48-192 0 0-48 192 0zM64 320l192 0 0 48-192 0 0-48z"]
};
var faTurnUp = {
  prefix: 'fass',
  iconName: 'turn-up',
  icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M192 0l-192 192 128 0 0 192-128 0 0 128 256 0 0-320 128 0-192-192z"]
};
var faLevelUpAlt = faTurnUp;
var faCreditCardFront = {
  prefix: 'fass',
  iconName: 'credit-card-front',
  icon: [512, 512, [], "f38a", "M0 64l512 0 0 384-512 0 0-384zM64 336l0 48 96 0 0-48-96 0zm144 0l0 48 96 0 0-48-96 0zm144 0l0 48 96 0 0-48-96 0zM192 160l-128 0 0 96 128 0 0-96z"]
};
var faTemperatureQuarter = {
  prefix: 'fass',
  iconName: 'temperature-quarter',
  icon: [320, 512, ["temperature-1", "thermometer-1", "thermometer-quarter"], "f2ca", "M256 0L64 0 64 260.7C34.5 287 16 325.4 16 368 16 447.5 80.5 512 160 512s144-64.5 144-144c0-42.6-18.5-81-48-107.3L256 0zM224 368c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-52.7 48 0 0 52.7c23.5 9.5 40 32.5 40 59.3z"]
};
var faTemperature1 = faTemperatureQuarter;
var faThermometer1 = faTemperatureQuarter;
var faThermometerQuarter = faTemperatureQuarter;
var faChestnut = {
  prefix: 'fass',
  iconName: 'chestnut',
  icon: [448, 512, [127792], "e3f6", "M.5 336C12.4 152.9 224 32 224 32S435.6 152.9 447.5 336L.5 336zM0 384l448 0 0 32-64 64-320 0-64-64 0-32z"]
};
var faCrystalBall = {
  prefix: 'fass',
  iconName: 'crystal-ball',
  icon: [448, 512, [], "e362", "M448 224c0 54.8-19.7 105.1-52.4 144L52.4 368C19.7 329.1 0 278.8 0 224 0 100.3 100.3 0 224 0S448 100.3 448 224zM177.3 126.7L160 80 142.7 126.7 96 144 142.7 161.3 160 208 177.3 161.3 224 144 177.3 126.7zM288 144L262.1 198.1 208 224 262.1 249.9 288 304 313.9 249.9 368 224 313.9 198.1 288 144zM16 480l57.6-64 300.8 0 57.6 64 0 32-416 0 0-32z"]
};
var faFlagSwallowtail = {
  prefix: 'fass',
  iconName: 'flag-swallowtail',
  icon: [448, 512, ["flag-alt"], "f74c", "M64 32l0-32-64 0 0 512 64 0 0-128 384 0-96-160 96-160-384 0 0-32z"]
};
var faFlagAlt = faFlagSwallowtail;
var faSliders = {
  prefix: 'fass',
  iconName: 'sliders',
  icon: [512, 512, ["sliders-h"], "f1de", "M112 24l144 0 0 40 256 0 0 64-256 0 0 40-144 0 0-40-112 0 0-64 112 0 0-40zM32 224l272 0 0-40 144 0 0 40 64 0 0 64-64 0 0 40-144 0 0-40-304 0 0-64 32 0zm0 160l32 0 0-40 144 0 0 40 304 0 0 64-304 0 0 40-144 0 0-40-64 0 0-64 32 0z"]
};
var faSlidersH = faSliders;
var faPersonSledding = {
  prefix: 'fass',
  iconName: 'person-sledding',
  icon: [576, 512, ["sledding"], "f7cb", "M384.4 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM46.1 215.6L67.4 226.7 204.8 298c-12.8-20.3-10.5-49.8 13.8-66l60.1-40.1-118.3 0 0-64 205.3 0c5.7 5.7 13.1 13.1 22.2 22.2l3.2 3.2 22.6 22.6c-9.3 9.3-36 36-80 80l82.7 0 0 151.9 56.2 29.2c27.3-13.7 46.8-23.4 58.5-29.3l21.5 42.9c-9.9 4.9-33 16.5-69.5 34.7l-10.9 5.5-10.9-5.6-416-216-21.3-11.1 22.1-42.6zm306.2 159l0-54.6-105.3 0 105.3 54.6z"]
};
var faSledding = faPersonSledding;
var faMosque = {
  prefix: 'fass',
  iconName: 'mosque',
  icon: [576, 512, [128332], "f678", "M96 145.2c0 43.5 35.3 78.8 78.8 78.8l226.4 0c43.5 0 78.8-35.3 78.8-78.8 0-25.5-12.3-49.4-33.1-64.2L288-32 129.1 81C108.3 95.8 96 119.7 96 145.2zM0 288l0 224 576 0 0-320-64 0 0 80-448 0 0-80-64 0 0 96zM240 464l0-128 96 0 0 128-96 0z"]
};
var faFolderMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'folder-magnifying-glass',
  icon: [512, 512, ["folder-search"], "e18b", "M512 448l-512 0 0-416 224 0 64 48 224 0 0 368zM336 256c0-53-43-96-96-96s-96 43-96 96 43 96 96 96c17.8 0 34.4-4.8 48.7-13.2l55.3 55.3 33.9-33.9c-7.8-7.8-26.2-26.2-55.3-55.3 8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faFolderSearch = faFolderMagnifyingGlass;
var faLinkHorizontal = {
  prefix: 'fass',
  iconName: 'link-horizontal',
  icon: [576, 512, ["chain-horizontal"], "e1cb", "M288 288c53 0 96-43 96-96s-43-96-96-96L160 96c-53 0-96 43-96 96 0 25.2 9.7 48.2 25.6 65.3-6.2 19.8-9.6 40.9-9.6 62.7 0 3.6 .1 7.2 .3 10.8-48-27.6-80.3-79.4-80.3-138.8 0-88.4 71.6-160 160-160l128 0c88.4 0 160 71.6 160 160S376.4 352 288 352l-32 0 0-64 32 0zm224 32c0-25.2-9.7-48.2-25.6-65.3 6.2-19.8 9.6-40.9 9.6-62.7 0-3.6-.1-7.2-.3-10.8 48 27.6 80.3 79.4 80.3 138.8 0 88.4-71.6 160-160 160l-128 0c-88.4 0-160-71.6-160-160s71.6-160 160-160l32 0 0 64-32 0c-53 0-96 43-96 96s43 96 96 96l128 0c53 0 96-43 96-96z"]
};
var faChainHorizontal = faLinkHorizontal;
var faH = {
  prefix: 'fass',
  iconName: 'h',
  icon: [384, 512, [104], "48", "M320 288l0 192 64 0 0-448-64 0 0 192-256 0 0-192-64 0 0 448 64 0 0-192 256 0z"]
};
var faMessageBot = {
  prefix: 'fass',
  iconName: 'message-bot',
  icon: [640, 512, [], "e3b8", "M96 192l0-160 448 0 0 160 96 0 0 48-96 0 0 208-192 0-160 96 0-96-96 0 0-208-96 0 0-48 96 0zm64-64l0 192 320 0 0-192-320 0zm96 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faInfo = {
  prefix: 'fass',
  iconName: 'info',
  icon: [192, 512, [], "f129", "M128 0l0 64-64 0 0-64 64 0zM0 160l128 0 0 288 64 0 0 64-192 0 0-64 64 0 0-224-64 0 0-64z"]
};
var faPersonWalking = {
  prefix: 'fass',
  iconName: 'person-walking',
  icon: [384, 512, [128694, "walking"], "f554", "M192-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM130.7 112l108.6 0 9.6 12 54.4 68 80.6 0 0 64-111.4 0c-4.2-5.2-15-18.8-32.6-40.8l0 115.2 52.8 45.3 9 7.7 1.8 11.7c12.5 81.4 19.5 126.6 20.9 135.6l-63.3 9.7c-1.7-11-8-52.3-19.1-123.9l-80.7-69.1c-21.3-18.2-33.5-44.9-33.5-72.9l0-69.3-32 32 0 82.7-64 0 0-109.3 9.4-9.4 80-80 9.4-9.4zM115.5 415.2L128.1 371c2.4 2.3 4.8 4.6 7.4 6.8l46 39.4c-5.2 18.3-8.2 28.8-9 31.5l-5.9 5.9c-49.6 49.6-78.4 78.4-86.6 86.6L34.7 496c9.2-9.2 36.1-36.1 80.8-80.8z"]
};
var faWalking = faPersonWalking;
var faRadioTuner = {
  prefix: 'fass',
  iconName: 'radio-tuner',
  icon: [512, 512, ["radio-alt"], "f8d8", "M494.3 15.2l23.2-6-12-46.5-23.2 6-464 120-18 4.7 0 386.6 512 0 0-384-330.3 0 312.3-80.8zM384.2 280a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM64.2 160l384 0 0 64-384 0 0-64zm32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faRadioAlt = faRadioTuner;
var faComputerMouseScrollwheel = {
  prefix: 'fass',
  iconName: 'computer-mouse-scrollwheel',
  icon: [384, 512, ["mouse-alt"], "f8cd", "M384 0L0 0 0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160L384 0zM224 128l0 64-64 0 0-96 64 0 0 32z"]
};
var faMouseAlt = faComputerMouseScrollwheel;
var faCarSirenOn = {
  prefix: 'fass',
  iconName: 'car-siren-on',
  icon: [512, 512, [], "e7c2", "M72.8-38.4c11 3.7 34.6 11.5 70.8 23.6L128.4 30.8 57.6 7.2 72.8-38.4zM312 64l121 0c.7 2.9 11.4 45.6 32 128l47 0 0 288-96 0 0-64-320 0 0 64-96 0 0-288 47 0C67.6 109.6 78.3 66.9 79 64l121 0 16-64 80 0 16 64zm71 64l-254 0-16 64 286 0-16-64zM96 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416.4-30.8l22.8-7.6 15.2 45.5c-11 3.7-34.6 11.5-70.8 23.6l-15.2-45.5 48-16z"]
};
var faUpRight = {
  prefix: 'fass',
  iconName: 'up-right',
  icon: [448, 512, [], "e2be", "M416 64L416 416 296 296 112 480 0 368 184 184 64 64 416 64z"]
};
var faPaintbrushSlash = {
  prefix: 'fass',
  iconName: 'paintbrush-slash',
  icon: [576, 512, [], "e74e", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-157.1-157.1 172-258-80-80-258 172-188.9-188.9zM176.1 288c-61.9 0-112 50.1-112 112 0 17.2 3.9 33.5 10.8 48l-74.8 0 0 64 176 0c61.9 0 112-50.1 112-112 0-21.6-6.1-41.8-16.7-58.9L235 304.7c-17.1-10.6-37.3-16.7-58.9-16.7z"]
};
var faCircleArrowUpRight = {
  prefix: 'fass',
  iconName: 'circle-arrow-up-right',
  icon: [512, 512, [], "e0fc", "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM216 208l54.1 0-103 103-17 17 33.9 33.9 17-17 103-103 0 78.1 48 0 0-160-160 0 0 48 24 0z"]
};
var faArrowTurnDown = {
  prefix: 'fass',
  iconName: 'arrow-turn-down',
  icon: [384, 512, ["level-down"], "f149", "M32 64l-32 0 0-64 224 0 0 402.7 96-96 45.3 45.3-173.3 173.3-22.6-22.6-128-128-22.6-22.6 45.3-45.3c6.6 6.6 38.6 38.6 96 96L160 64 32 64z"]
};
var faLevelDown = faArrowTurnDown;
var faRoad = {
  prefix: 'fass',
  iconName: 'road',
  icon: [512, 512, [128739], "f018", "M224 32l-118.6 0-105.4 448 224 0 0-96 64 0 0 96 224 0-105.4-448-118.6 0 0 96-64 0 0-96zm64 192l0 96-64 0 0-128 64 0 0 32z"]
};
var faBuoy = {
  prefix: 'fass',
  iconName: 'buoy',
  icon: [640, 512, [], "e5b5", "M448.4 0l-256 0 0 64 25 0-51.2 256-37.8 0 0 71.4c33.3-13.3 57.3-22.9 72-28.8l26.8 10.7 93.3 37.3 93.2-37.3 26.8-10.7c14.7 5.9 38.8 15.5 72 28.8l0-71.4-37.8 0-51.2-256 25 0 0-64zM358.1 64l9.8 49-47.6 55.5-47.6-55.5 9.8-49 75.5 0zm21.8 108.8l17 84.9-44.9-52.4 27.9-32.6zm-91.1 32.6l-44.9 52.4 17-84.9 27.9 32.6zM253.7 320l66.7-77.8 66.7 77.8-133.4 0zm-44.4 97.7l-8.9-3.6-8.9 3.6-111.8 44.7c-29.3-9.8-50.1-16.7-62.4-20.8L2 487.2c11 3.7 34.6 11.5 70.8 23.6l8.3 2.8 8.2-3.3 111.1-44.4 111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4 111.1 44.4 8.2 3.3 8.3-2.8 70.8-23.6-15.2-45.5c-12.4 4.1-33.2 11.1-62.4 20.8l-111.8-44.7-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4z"]
};
var faSpiral = {
  prefix: 'fass',
  iconName: 'spiral',
  icon: [512, 512, [], "e80a", "M164.8 17.8L181.6 45C110.9 88.8 64 166.9 64 256 64 362 150 448 256 448s192-86 192-192c0-75.1-60.9-136-136-136S176 180.9 176 256c0 44.2 35.8 80 80 80s80-35.8 80-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32-64 0 0-32c0-48.6 39.4-88 88-88s88 39.4 88 88c0 79.5-64.5 144-144 144S112 335.5 112 256c0-110.5 89.5-200 200-200s200 89.5 200 200c0 141.4-114.6 256-256 256S0 397.4 0 256C0 143.9 59.2 45.6 147.9-9.4l16.9 27.2z"]
};
var faPaintbrushPencil = {
  prefix: 'fass',
  iconName: 'paintbrush-pencil',
  icon: [576, 512, [], "e206", "M296.8 120.8L160-16 16 128 133.7 245.7c13.5-3.7 27.7-5.7 42.3-5.7l1.6 0c3.1-3.1 42.8-42.8 119.2-119.2zm33.5 321.5l29.7 29.7 200 56-56-200-48.8-48.8C378.8 355.6 339.1 395.3 336 398.4l0 1.6c0 14.7-2 28.9-5.7 42.3zm34.3-253.7L311.3 242c8.1 7 15.7 14.5 22.6 22.6l53.4-53.4-22.6-22.6zm160.6-47.4L570.5 96 480 5.5c-4.3 4.3-86.2 86.2-245.5 245.5 41.3 16.2 74.3 49.2 90.5 90.5L525.3 141.3zM176 512c61.9 0 112-50.1 112-112S237.9 288 176 288 64 338.1 64 400l0 48-64 0 0 64 176 0z"]
};
var faFileCad = {
  prefix: 'fass',
  iconName: 'file-cad',
  icon: [576, 512, [], "e672", "M272 0l-240 0 0 512 144 0 0-176 240 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM264 380c-24.3 0-44 19.7-44 44l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-16-40 0 0 16c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 16 40 0 0-16c0-24.3-19.7-44-44-44l-16 0zm128 0c-24.3 0-44 19.7-44 44l0 120 40 0 0-44 24 0 0 44 40 0 0-120c0-24.3-19.7-44-44-44l-16 0zm20 80l-24 0 0-36c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 36zm64-80l0 168 52 0c28.7 0 52-23.3 52-52l0-64c0-28.7-23.3-52-52-52l-52 0zm40 40l12 0c6.6 0 12 5.4 12 12l0 64c0 6.6-5.4 12-12 12l-12 0 0-88z"]
};
var faPeoplePantsSimple = {
  prefix: 'fass',
  iconName: 'people-pants-simple',
  icon: [448, 512, [], "e21a", "M96 128A64 64 0 1 0 96 0 64 64 0 1 0 96 128zm96 224l0-192-192 0 0 192 32 0 0 160 128 0 0-160 32 0zM352 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96 224l0-192-192 0 0 192 32 0 0 160 128 0 0-160 32 0z"]
};
var faFaceFrown = {
  prefix: 'fass',
  iconName: 'face-frown',
  icon: [512, 512, [9785, "frown"], "f119", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-160c-38.2 0-72 19.1-92.2 48.5l-39.5-27.3C153.1 331.4 201.3 304 256 304s102.9 27.4 131.8 69.2l-39.5 27.3C328 371.1 294.2 352 256 352zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faFrown = faFaceFrown;
var faWineGlassEmpty = {
  prefix: 'fass',
  iconName: 'wine-glass-empty',
  icon: [320, 512, ["wine-glass-alt"], "f5ce", "M64 0L37.8 0 32.6 25.7 3.2 173C1.1 183.5 0 194.2 0 205l0 3c0 77.4 55 142 128 156.8l0 115.2-96 0 0 64 256 0 0-64-96 0 0-115.2C265 350 320 285.4 320 208l0-3c0-10.7-1.1-21.4-3.2-32L287.4 25.7 282.2 0 64 0zm1.9 185.6L90.2 64 229.8 64 254.1 185.6c1.3 6.4 1.9 12.9 1.9 19.4l0 3c0 53-43 96-96 96s-96-43-96-96l0-3c0-6.5 .6-13 1.9-19.4z"]
};
var faWineGlassAlt = faWineGlassEmpty;
var faClapperboard = {
  prefix: 'fass',
  iconName: 'clapperboard',
  icon: [512, 512, [], "e131", "M361.9 64l92.1 0-96 96 67.9 0 86.1-86.1 0 374.1-512 0 0-384 134.1 0-96 96 67.9 0 95-95 1-1 92.1 0-96 96 67.9 0 95-95 1-1z"]
};
var faOilCanDrip = {
  prefix: 'fass',
  iconName: 'oil-can-drip',
  icon: [640, 512, [], "e205", "M352 128l-64 0 0 32 96 0 64 32 160-32 32 32-208 224-336 0 0-69.3-96-42.7 0-144 224 0 0-32-64 0 0-64 192 0 0 64zM48 208l0 64.8 48 21.3 0-86.1-48 0zM592 448c-26.5 0-48-21.5-48-48 0-32 48-96 48-96s48 64 48 96-21.5 48-48 48z"]
};
var faPhonePlus = {
  prefix: 'fass',
  iconName: 'phone-plus',
  icon: [512, 512, [], "f4d2", "M128 0L0 64 0 80C0 318.6 193.4 512 432 512l16 0 64-128-128-96.8-80 80.8c-70.4-33-127-89.6-160-160L224.8 128 128 0zM392 192l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faForwardStep = {
  prefix: 'fass',
  iconName: 'forward-step',
  icon: [384, 512, ["step-forward"], "f051", "M320 296l0 184 64 0 0-448-64 0 0 184-320-200 0 480 320-200z"]
};
var faStepForward = faForwardStep;
var faFileDashedLine = {
  prefix: 'fass',
  iconName: 'file-dashed-line',
  icon: [576, 512, ["page-break"], "f877", "M336 0l-240 0 0 240 384 0 0-96-144-144zM96 512l384 0 0-128-384 0 0 128zM421.5 176L304 176 304 58.5 421.5 176zM24 288l-24 0 0 48 160 0 0-48-136 0zm208 0l-24 0 0 48 160 0 0-48-136 0zm208 0l-24 0 0 48 160 0 0-48-136 0z"]
};
var faPageBreak = faFileDashedLine;
var faScribble = {
  prefix: 'fass',
  iconName: 'scribble',
  icon: [512, 512, [], "e23f", "M170.4 23.3C187 8.3 208.5 0 230.8 0l1.1 0c48.9 0 88.6 39.7 88.6 88.6 0 23.5-9.3 46-25.9 62.6L103.7 342.1c-4.6 4.6-7.2 10.9-7.2 17.4 0 13.6 11 24.6 24.6 24.6 6.5 0 12.8-2.6 17.4-7.2L361.3 153.9c16.6-16.6 39.1-25.9 62.6-25.9 48.9 0 88.6 39.7 88.6 88.6 0 23.5-9.3 46-25.9 62.6l-88.2 88.2c-8.9 8.9-13.8 20.9-13.8 33.4 0 26.1 21.1 47.2 47.2 47.2l4.4 0c4.8 0 9.5-.8 14.1-2.3 5.1-1.7 19.3-6.4 42.6-14.2L513 492.2c-23.3 7.8-37.5 12.5-42.6 14.2-11.1 3.7-22.6 5.6-34.3 5.6l-4.4 0c-61.4 0-111.2-49.8-111.2-111.2 0-29.5 11.7-57.8 32.6-78.6l88.2-88.2c4.6-4.6 7.2-10.9 7.2-17.4 0-13.6-11-24.6-24.6-24.6-6.5 0-12.8 2.6-17.4 7.2L183.7 422.1c-16.6 16.6-39.1 25.9-62.6 25.9-48.9 0-88.6-39.7-88.6-88.6 0-23.5 9.3-46 25.9-62.6L249.3 105.9c4.6-4.6 7.2-10.9 7.2-17.4 0-13.6-11-24.6-24.6-24.6l-1.1 0c-6.4 0-12.6 2.4-17.3 6.7L54 215.7 11 168.3 170.4 23.3z"]
};
var faGaugeMin = {
  prefix: 'fass',
  iconName: 'gauge-min',
  icon: [512, 512, ["tachometer-alt-slowest"], "f628", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.5 0-27.8 4.8-38.5 12.9l-109.1-65.5-24.7 41.2 109.1 65.5c-.5 3.2-.8 6.6-.8 9.9 0 35.3 28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAltSlowest = faGaugeMin;
var faSquareUpRight = {
  prefix: 'fass',
  iconName: 'square-up-right',
  icon: [448, 512, [8599, "external-link-square-alt"], "f360", "M0 32l448 0 0 448-448 0 0-448zM296 160l-169.9 0c29.6 29.6 52.3 52.3 68 68-53 53-81 81-84 84 24.3 24.3 54.1 54.1 57.9 57.9 3-3 31-31 84-84 15.7 15.7 38.4 38.4 68 68l0-193.9-24 0z"]
};
var faExternalLinkSquareAlt = faSquareUpRight;
var faWifiExclamation = {
  prefix: 'fass',
  iconName: 'wifi-exclamation',
  icon: [576, 512, [], "e2cf", "M264.3 320l-24-288 96 0-24 288-48 0zm146.3 8.8c-13.2-15.6-29.4-28.7-47.6-38.4l5.6-67.6c34.1 13.1 64.2 34.3 87.9 61.2l-45.9 44.8zM213.7 290.4c-18.3 9.6-34.4 22.7-47.6 38.4L120.1 284c23.7-26.9 53.8-48.1 87.9-61.2l5.6 67.6zm323.1-84.7c-42-46.1-96.7-80.5-158.6-97.6l5.4-64.7c77.7 19 146.6 60.7 199.1 117.7l-45.8 44.7zM198.5 108.1c-61.9 17.1-116.6 51.5-158.6 97.6L-6 161.1c52.5-57 121.3-98.7 199.1-117.7l5.4 64.7zM288.3 384a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faBookJournalWhills = {
  prefix: 'fass',
  iconName: 'book-journal-whills',
  icon: [448, 512, ["journal-whills"], "f66a", "M0 0l448 0 0 384-32 0 0 64 32 0 0 64-448 0 0-512zM64 416l0 32 288 0 0-64-256 0c-17.7 0-32 14.3-32 32zM272.8 109c5.2 8.6 8.2 18.7 8.2 29.5 0 15.1-5.9 28.8-15.5 39.1l-4.2 4.5 3.3 5.2c4.6 7.3 7.3 15.9 7.4 25.2l0 .6c-.1 21.5-14.4 39.7-34 45.6L237 234c7.1-4.4 11.8-12.2 11.8-21.1 0-9.6-5.5-18-13.5-22.1l-3.3-81.8-16 0-3.3 81.8c-8 4.1-13.5 12.4-13.5 22.1 0 8.9 4.7 16.7 11.8 21.1l-1 24.8c-19.7-6-34-24.3-34-45.9 0-9.4 2.7-18.2 7.4-25.5l3.3-5.2-4.2-4.5c-9.6-10.2-15.5-23.9-15.5-39.1 0-10.8 3-20.9 8.2-29.5L164.1 98.1c-32.1 20-53.4 55.6-53.4 96.2 0 62.6 50.7 113.3 113.3 113.3s113.3-50.7 113.3-113.3c0-40.6-21.4-76.2-53.4-96.2L272.8 109z"]
};
var faJournalWhills = faBookJournalWhills;
var faOctagonMinus = {
  prefix: 'fass',
  iconName: 'octagon-minus',
  icon: [512, 512, ["minus-octagon"], "f308", "M0 160L0 352 160 512 352 512 512 352 512 160 352 0 160 0 0 160zm168 72l200 0 0 48-224 0 0-48 24 0z"]
};
var faMinusOctagon = faOctagonMinus;
var faChampagneGlasses = {
  prefix: 'fass',
  iconName: 'champagne-glasses',
  icon: [640, 512, [129346, "glass-cheers"], "f79f", "M183.6 127.4l25.3-48.1 61.2 22.3-11.5 53.2-75-27.3zM178.4 0L87.7 172.2C60.2 224.4 76.8 287 122 319.8L91.1 404.7c-27.6-10.1-50.7-18.5-69.2-25.2L0 439.6c165.5 60.2 186.6 67.9 198.6 72.3l21.9-60.1c-18.5-6.7-41.6-15.1-69.2-25.2l30.9-84.9c55.7 3.9 108.6-33.3 121.2-91l16.7-76.9 16.7 76.9c12.5 57.7 65.4 94.9 121.2 91l30.9 84.9c-27.6 10.1-50.7 18.5-69.2 25.2l21.9 60.1C606.9 451.7 628 444 640 439.6l-21.9-60.1c-18.5 6.7-41.6 15.1-69.2 25.2L518 319.8c45.2-32.8 61.8-95.4 34.3-147.6L461.6 0 320 51.5 178.4 0zm278 127.4l-75 27.3-11.5-53.2 61.2-22.3 25.3 48.1z"]
};
var faGlassCheers = faChampagneGlasses;
var faFolderXmark = {
  prefix: 'fass',
  iconName: 'folder-xmark',
  icon: [512, 512, ["folder-times"], "f65f", "M512 80l0 368-512 0 0-416 224 0 64 48 224 0zM340.9 213.1l-33.9-33.9c-8.5 8.5-25.5 25.5-50.9 50.9-25.5-25.5-42.4-42.4-50.9-50.9l-33.9 33.9c8.5 8.5 25.5 25.5 50.9 50.9-25.5 25.5-42.4 42.4-50.9 50.9l33.9 33.9c8.5-8.5 25.5-25.5 50.9-50.9 25.5 25.5 42.4 42.4 50.9 50.9l33.9-33.9c-8.5-8.5-25.5-25.5-50.9-50.9 25.5-25.5 42.4-42.4 50.9-50.9z"]
};
var faFolderTimes = faFolderXmark;
var faTrashList = {
  prefix: 'fass',
  iconName: 'trash-list',
  icon: [640, 512, [], "e2b1", "M336-16l16 48 96 0 0 64-416 0 0-64 96 0 16-48 192 0zM64 144l352 0-24 368-304 0-24-368zm576-16l0 64-160 0 0-64 160 0zM480 256l128 0 0 64-128 0 0-64zm64 128l0 64-64 0 0-64 64 0z"]
};
var faDumpster = {
  prefix: 'fass',
  iconName: 'dumpster',
  icon: [576, 512, [], "f793", "M32 64L0 192 106.7 192 132.3 64 32 64zM264 192l0-128-82.7 0-25.6 128 108.3 0zm48 0l108.3 0-25.6-128-82.7 0 0 128zm157.3 0l106.7 0-32-128-100.3 0 25.6 128zM64 240l-37.8 0 6.2 37.3 32 192 1.8 10.7 64.9 0c-2.2-13.3-4.9-29.3-8-48l329.8 0c-3.1 18.7-5.8 34.7-8 48l64.9 0 1.8-10.7 32-192 6.2-37.3-485.8 0z"]
};
var faCircleEnvelope = {
  prefix: 'fass',
  iconName: 'circle-envelope',
  icon: [512, 512, ["envelope-circle"], "e10c", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM128 201.3l0-41.3 256 0 0 41.3-128 74-128-74zM264 307.6l120-69.3 0 113.8-256 0 0-113.8 120 69.3 8 4.6 8-4.6z"]
};
var faEnvelopeCircle = faCircleEnvelope;
var faMobileNotch = {
  prefix: 'fass',
  iconName: 'mobile-notch',
  icon: [384, 512, ["mobile-iphone"], "e1ee", "M128 64l0 32 128 0 0-32 48 0 0 384-224 0 0-384 48 0zM80 0l-64 0 0 512 352 0 0-512-288 0zm48 352l0 48 128 0 0-48-128 0z"]
};
var faMobileIphone = faMobileNotch;
var faMobileSignal = {
  prefix: 'fass',
  iconName: 'mobile-signal',
  icon: [576, 512, [], "e1ef", "M32 0l352 0 0 295.3c-58 43.4-98.6 108.9-109.2 183.9l-.1 .7c-1.5 10.5-2.3 21.2-2.6 32L32 512 32 0zM168 416l-24 0 0 48 84.6 0c2.8-16.5 6.8-32.5 11.9-48L168 416zM552 288l24 0 0 48-24 0c-101.6 0-184 82.4-184 184l0 24-48 0 0-24c0-128.1 103.9-232 232-232zm-8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-96l0 48-24 0c-48.6 0-88 39.4-88 88l0 24-48 0 0-24c0-75.1 60.9-136 136-136l24 0z"]
};
var faHeartCircleXmark = {
  prefix: 'fass',
  iconName: 'heart-circle-xmark',
  icon: [576, 512, [], "e501", "M133.1 32C175.8 32 216 52.5 241 87.1l15 20.7 15-20.7c25-34.6 65.2-55.1 107.9-55.1 73.5 0 133.1 59.6 133.1 133.1 0 19.2-3 38.1-8.5 56.6-22.1-8.9-46.2-13.8-71.5-13.8-106 0-192 86-192 192 0 33 8.3 64 23 91.2-2.4 1.6-4.7 3.3-7 4.8-102.5-70.7-256-194.1-256-330.9 0-73.5 59.6-133.1 133.1-133.1zM432 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm55.3 111.3L498.6 356 476 333.4c-4 4-18.7 18.6-44 44-25.4-25.4-40-40-44-44L365.4 356c4 4 18.6 18.7 44 44-25.4 25.4-40 40-44 44L388 466.6c4-4 18.7-18.6 44-44 25.4 25.4 40 40 44 44L498.6 444c-4-4-18.6-18.7-44-44l32.7-32.7z"]
};
var faComputer = {
  prefix: 'fass',
  iconName: 'computer',
  icon: [576, 512, [], "e4e5", "M336 32l-336 0 0 352 336 0 0-64-272 0 0-224 272 0 0-64zm0 400l-240 0 0 48 240 0 0-48zM576 32l-192 0 0 448 192 0 0-448zM456 96l72 0 0 48-96 0 0-48 24 0zm0 96l72 0 0 48-96 0 0-48 24 0zm-8 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faWandMagic = {
  prefix: 'fass',
  iconName: 'wand-magic',
  icon: [576, 512, ["magic"], "f0d0", "M346.6 104.4L439.9 197.7 557.5 80 464.3-13.3 346.6 104.4zm-33.9 33.9L19 432 112.3 525.3 405.9 231.6 312.7 138.3z"]
};
var faMagic = faWandMagic;
var faBrain = {
  prefix: 'fass',
  iconName: 'brain',
  icon: [512, 512, [129504], "f5dc", "M120 56c0-30.9 25.1-56 56-56l56 0 0 512-64 0c-29.8 0-54.9-20.4-62-48-.7 0-1.3 0-2 0-44.2 0-80-35.8-80-80 0-18 6-34.6 16-48-19.4-14.6-32-37.8-32-64 0-30.9 17.6-57.8 43.2-71.1-7.1-12-11.2-26-11.2-40.9 0-44.2 35.8-80 80-80l0-24zm272 0l0 24c44.2 0 80 35.8 80 80 0 15-4.1 29-11.2 40.9 25.7 13.3 43.2 40.1 43.2 71.1 0 26.2-12.6 49.4-32 64 10 13.4 16 30 16 48 0 44.2-35.8 80-80 80-.7 0-1.3 0-2 0-7.1 27.6-32.2 48-62 48l-64 0 0-512 56 0c30.9 0 56 25.1 56 56z"]
};
var faPeoplePants = {
  prefix: 'fass',
  iconName: 'people-pants',
  icon: [640, 512, [], "e219", "M192.3 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-80 464l64 0 0-208 32 0 0 208 64 0 0-277.9c15 28 24.6 46 28.8 53.9l38.4 0c4.2-7.9 13.8-25.9 28.8-53.9l0 277.9 64 0 0-208 32 0 0 208 64 0 0-277.9c14 26.1 25.6 47.9 34.9 65.2l56.5-30.2-15.1-28.2-76.9-144-9-16.9-140.5 0-9 16.9-48.7 91.2-48.7-91.2-9-16.9-140.5 0-9 16.9-76.9 144-15.1 28.2 56.5 30.2c9.3-17.4 20.9-39.1 34.9-65.2l0 277.9zm336-464a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faDialpad = {
  prefix: 'fass',
  iconName: 'dialpad',
  icon: [384, 512, [], "e7cc", "M144 0l96 0 0 96-96 0 0-96zm96 144l0 96-96 0 0-96 96 0zM96 288l0 96-96 0 0-96 96 0zm144 0l0 96-96 0 0-96 96 0zm48 0l96 0 0 96-96 0 0-96zM0 144l96 0 0 96-96 0 0-96zm384 0l0 96-96 0 0-96 96 0zM240 432l0 96-96 0 0-96 96 0zM0 0L96 0 96 96 0 96 0 0zM384 0l0 96-96 0 0-96 96 0z"]
};
var faBriefcaseMedical = {
  prefix: 'fass',
  iconName: 'briefcase-medical',
  icon: [512, 512, [], "f469", "M144 0l224 0 0 96 144 0 0 384-512 0 0-384 144 0 0-96zM320 48l-128 0 0 48 128 0 0-48zM224 200l0 56-56 0 0 64 56 0 0 56 64 0 0-56 56 0 0-64-56 0 0-56-64 0z"]
};
var faSmoke = {
  prefix: 'fass',
  iconName: 'smoke',
  icon: [576, 512, [], "f760", "M384.4 75.8c-23.5-26.9-58-43.8-96.4-43.8-22 0-42.6 5.5-60.7 15.3-23.5-28.8-59.2-47.3-99.3-47.3-70.7 0-128 57.3-128 128 0 46.6 24.9 87.3 62.1 109.7 7.8-5.2 16-9.8 24.6-13.8 20.9-73.9 88.8-128 169.4-128 25.6 0 50 5.5 71.9 15.3 16.2-15.2 35.4-27.3 56.5-35.5zM144.7 208.7c5-.4 10.1-.7 15.3-.7 26.3 0 51.3 5.8 73.8 16.2 21.2-10.4 45-16.2 70.2-16.2 52.8 0 99.6 25.6 128.7 65 42.2 4.9 78.9 28 101.9 61.3 25.5-23.4 41.4-57 41.4-94.3 0-70.7-57.3-128-128-128-46.5 0-87.3 24.8-109.7 62-22.3-18.7-51-30-82.3-30-47.6 0-89.2 26-111.3 64.7zM32 384l0 128 480 0 0-96c0-53-43-96-96-96-3.6 0-7.1 .2-10.5 .6-17.9-38.1-56.6-64.6-101.5-64.6-26.2 0-50.3 9-69.3 24-21-15.1-46.8-24-74.7-24-70.7 0-128 57.3-128 128z"]
};
var faHouseMedicalCircleExclamation = {
  prefix: 'fass',
  iconName: 'house-medical-circle-exclamation',
  icon: [640, 512, [], "e512", "M80 512l260 0c-21.2-29.5-34.3-65.3-35.9-104l-48.2 0 0-56-56 0 0-64 56 0 0-56 64 0 0 56 20 0c34.9-48.5 91.7-80 156-80 11.7 0 23.1 1 34.2 3L288-16 32 224 32 272 80 272 80 512zm416 32a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 112-32 0 0-112 32 0z"]
};
var faFaceMonocle = {
  prefix: 'fass',
  iconName: 'face-monocle',
  icon: [512, 512, [], "e380", "M256 512c46.6 0 90.3-12.5 128-34.2L384 312c-20.1 15.1-45 24-72 24-66.3 0-120-53.7-120-120S245.7 96 312 96 432 149.7 432 216c0 2.7-.1 5.4-.3 8l.3 0 0 217.9C481.3 395.2 512 329.2 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256 114.6 512 256 512zM128 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm144 48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 8a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zM184 416l-24 0 0-48 24.2 0c8.5 0 31 0 56.1 6.8 25.3 6.9 55.3 21.4 75.7 51.8L276 453.3c-11.7-17.5-29.7-27.1-48.3-32.2-18.7-5.1-36-5.2-43.7-5.2z"]
};
var faLineColumns = {
  prefix: 'fass',
  iconName: 'line-columns',
  icon: [448, 512, [], "f870", "M192 32l-192 0 0 64 192 0 0-64zm0 128l-192 0 0 64 192 0 0-64zM0 288l0 64 192 0 0-64-192 0zM192 416l-192 0 0 64 192 0 0-64zM256 32l0 64 192 0 0-64-192 0zM448 160l-192 0 0 64 192 0 0-64zM256 288l0 64 192 0 0-64-192 0zM448 416l-192 0 0 64 192 0 0-64z"]
};
var faFaceVomit = {
  prefix: 'fass',
  iconName: 'face-vomit',
  icon: [576, 512, [], "e3a0", "M544 256c0 69.9-28.1 133.3-73.5 179.5l-4.3-1.3c-17.3-5.2-30-19.6-33.3-36.9 9.7-11.4 15.1-24 15.1-37.4 0-48.6-71.6-88-160-88s-160 39.4-160 88c0 13.4 5.4 26.1 15.1 37.4-3.3 17.3-16 31.7-33.3 36.9l-4.3 1.3C60.1 389.3 32 325.9 32 256 32 114.6 146.6 0 288 0S544 114.6 544 256zM246.8 177.7l-95.6-48-16.8 27.1 45.3 34-44.2 27.6 14.7 28.3 95.6-40 10.2-4.3 0-20.2-9.2-4.6zm178-48l-95.6 48-9.2 4.6 0 20.2 10.2 4.3 95.6 40 14.7-28.3-44.2-27.6 45.3-34-16.8-27.1zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm480 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 396.1l0-57.4c23.6-11.1 57.3-18.7 96-18.7s72.4 7.6 96 18.7l0 57.4c0 31 19.8 58.5 49.2 68.3l46.8 15.6 0 32-384 0 0-32 46.8-15.6c29.4-9.8 49.2-37.3 49.2-68.3zM304 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faPersonDolly = {
  prefix: 'fass',
  iconName: 'person-dolly',
  icon: [512, 512, [], "f4d0", "M64-32A56 56 0 1 1 64 80 56 56 0 1 1 64-32zM0 112l96.5 0 9.6 13.4 70.4 98.6 79.5 0 0-64 48 0 0 304 208 0 0 48-194.7 0c-6.6 18.6-24.4 32-45.3 32-26.5 0-48-21.5-48-48 0-20.9 13.4-38.7 32-45.3l0-162.7-112.5 0c-4.3-6-14.8-20.8-31.5-44.1l0 80.1 67.2 50.4 12.8 9.6 0 160-64 0 0-128-89.6-67.2C14.2 330.7 0 302.2 0 272L0 112zM0 379.3c3.1 2.7 6.3 5.4 9.6 7.9L64 428 64 544 0 544 0 379.3zM512 256l0 160-160 0 0-160 160 0z"]
};
var faCodeCommit = {
  prefix: 'fass',
  iconName: 'code-commit',
  icon: [576, 512, [], "f386", "M224 192l0 128 128 0 0-128-128 0zm-80-80l288 0 0 112 144 0 0 64-144 0 0 112-288 0 0-112-144 0 0-64 144 0 0-112z"]
};
var faPersonBreastfeeding = {
  prefix: 'fass',
  iconName: 'person-breastfeeding',
  icon: [448, 512, [], "e53a", "M144.3 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM269.4 443.8l23-32.9-52.8-8.8-47.4-47.4 0-66.7-64 0c0 40 0 66.7 0 80 0 .7 0 1.4 .1 2.1 50.5 25 87.9 43.5 112.2 55.6l-42.6 86c-14.5-7.2-71.5-35.4-171-84.7L.3 413.8c0-49.3 0-49.2 0-61.8l9.6-12.8 96-128 14.4-19.2 226.2 0 14.2 22c57.1 88.8 86.9 135.2 89.4 139.1-6.1 8.7-30.9 44.1-74.5 106.4l-27.5 39.3-78.6-55zm6.8-67.8a44 44 0 1 0 0-88 44 44 0 1 0 0 88z"]
};
var faSquareBaht = {
  prefix: 'fass',
  iconName: 'square-baht',
  icon: [448, 512, [], "e719", "M448 32l-448 0 0 448 448 0 0-448zM208 96l32 0 0 32 4 0c42 0 76 34 76 76 0 16.2-5.1 31.3-13.8 43.7 18.1 13.9 29.8 35.8 29.8 60.3 0 42-34 76-76 76l-20 0 0 32-32 0 0-32-72 0 0-256 72 0 0-32zm-24 80l0 56 24 0 0-56-24 0zm56 0l0 56 4 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-4 0zM184 280l0 56 24 0 0-56-24 0zm56 0l0 56 20 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-20 0z"]
};
var faPersonRays = {
  prefix: 'fass',
  iconName: 'person-rays',
  icon: [576, 512, [], "e54d", "M232.4 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-11.4 88l134.8 0 9.6 13.2C439.7 227.6 477 278.8 477.1 279.1l-51.8 37.6c-9.3-12.8-28.3-39-56.9-78.4l0 305.7-64 0 0-208-32 0 0 208-64 0 0-305.7c-28.6 39.4-47.6 65.6-56.9 78.4l-51.8-37.6 18.8-25.9 92.9-128 9.6-13.2zM56.4-9.9c.8 .8 33.1 33.1 97 97l17 17-33.9 33.9c-.8-.8-33.1-33.1-97-97L22.5 24 56.4-9.9zm447 17l17-17 33.9 33.9-17 17c-63.8 63.8-96.2 96.2-97 97l-33.9-33.9 17-17 80-80zM56.4 521.9L22.5 488c.8-.8 33.1-33.1 97-97l17-17 33.9 33.9c-.8 .8-33.1 33.1-97 97l-17 17zm447-17l-80-80-17-17 33.9-33.9 17 17 80 80 17 17-33.9 33.9-17-17z"]
};
var faWaterArrowDown = {
  prefix: 'fass',
  iconName: 'water-arrow-down',
  icon: [512, 512, ["water-lower"], "f774", "M233.6 230.6l22.6 22.6c5.5-5.5 39.7-39.7 102.6-102.6l22.6-22.6-45.3-45.3c-14.6 14.6-30.6 30.6-48 48l0-130.7-64 0 0 130.7-48-48-45.3 45.3c5.5 5.5 39.7 39.7 102.6 102.6zm-97.4 55.5l-8.9 3.6C44.3 322.9 2.2 339.7 1 340.2l17.8 44.6c2.7-1.1 41.8-16.7 117.4-47l111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4c75.5 30.2 114.6 45.9 117.4 46.9l17.8-44.6c-1.2-.5-43.3-17.3-126.3-50.5l-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4-8.9-3.6zm0 128l-8.9 3.6C44.3 450.9 2.2 467.7 1 468.2l17.8 44.6c2.7-1.1 41.8-16.7 117.4-47l111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4c75.5 30.2 114.6 45.9 117.4 46.9l17.8-44.6c-1.2-.5-43.3-17.3-126.3-50.5l-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4-8.9-3.6z"]
};
var faWaterLower = faWaterArrowDown;
var faSymbols = {
  prefix: 'fass',
  iconName: 'symbols',
  icon: [576, 512, [128291, "icons-alt"], "f86e", "M544.3-7l0 183c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48l0-57-96 19.2 0 117.8c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48l0-122.2 25.7-5.1C472.9 7.2 539-6 544.3-7zM64.3 0l160 0 0 64-192 0 0-64 32 0zm0 112l160 0 0 64-64 0 0 48-64 0 0-48-64 0 0-64 32 0zM534.9 342.6L352.3 525.3 307 480 512.3 274.7 557.5 320 534.9 342.6zM360.3 288a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm104 184a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-352-216c35.3 0 64 28.7 64 64l0 1.9c0 17.2-6.7 33.7-18.7 46.1l18.7 18.7c17.4-17.4 33.4-33.4 48-48L269.5 384c-14.6 14.6-30.6 30.6-48 48 17.4 17.4 33.4 33.4 48 48l-45.3 45.3c-14.6-14.6-30.6-30.6-48-48l-12.1 12.1c-14.5 14.5-34.1 22.6-54.6 22.6-42.7 0-77.3-34.6-77.3-77.3 0-20.5 8.1-40.1 22.6-54.6L67 368c-12-12.3-18.7-28.8-18.7-46.1l0-1.9c0-35.3 28.7-64 64-64zm-11.3 52.7c-6.2 6.2-6.2 16.4 0 22.6l11.3 11.3 11.3-11.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zm14.1 101.7l-2.8-2.8c-.3 .3-5.3 5.3-14.9 14.9-3.2 3.2-5.1 7.6-5.1 12.2 0 9.5 7.7 17.3 17.3 17.3 4.6 0 9-1.8 12.2-5.1 9.6-9.6 14.6-14.6 14.9-14.9l-2.8-2.8-18.7-18.7z"]
};
var faIconsAlt = faSymbols;
var faChartMixedUpCircleCurrency = {
  prefix: 'fass',
  iconName: 'chart-mixed-up-circle-currency',
  icon: [640, 512, [], "e5d8", "M432.5 0l-32 0 0 64 60.8 0-109.4 87.5-108.2-81.1-19.8-14.9-19.4 15.5-160 128-25 20 40 50 25-20 140.6-112.5 108.2 81.1 19.8 14.9 19.4-15.5 140-112 0 71 64 0 0-176-144 0zm-240 224l0 256 64 0 0-256-64 0zm-128 96l0 160 64 0 0-160-64 0zm400 224a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm32-144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 0c0 11.9-3.2 23-8.9 32.5l28.2 28.2-22.6 22.6-28.2-28.2c-9.5 5.6-20.6 8.9-32.5 8.9s-23-3.2-32.5-8.9l-28.2 28.2-22.6-22.6 28.2-28.2c-5.6-9.5-8.9-20.6-8.9-32.5s3.2-23 8.9-32.5l-28.2-28.2 22.6-22.6 28.2 28.2c9.5-5.6 20.6-8.9 32.5-8.9s23 3.2 32.5 8.9l28.2-28.2 22.6 22.6-28.2 28.2c5.6 9.5 8.9 20.6 8.9 32.5z"]
};
var faManatSign = {
  prefix: 'fass',
  iconName: 'manat-sign',
  icon: [384, 512, [], "e1d5", "M216 32l-48 0 0 65.5C73.3 109.3 0 190.1 0 288l0 192 64 0 0-192c0-62.5 44.8-114.5 104-125.8l0 317.8 48 0 0-317.8c59.2 11.2 104 63.3 104 125.8l0 192 64 0 0-192c0-97.9-73.3-178.7-168-190.5L216 32z"]
};
var faBagSeedling = {
  prefix: 'fass',
  iconName: 'bag-seedling',
  icon: [448, 512, [], "e5f2", "M0 0l448 0-32 64 18.6 74.5c8.9 35.5 13.4 72 13.4 108.7l0 17.7c0 36.6-4.5 73.1-13.4 108.7l-18.6 74.5 32 64-448 0 32-64-18.6-74.5C4.5 338 0 301.5 0 264.8l0-17.7C0 210.5 4.5 174 13.4 138.5L32 64 0 0zM128 160l-32 0 0 16c0 59.2 45.9 107.6 104 111.7l0 64.3 48 0 0-64.3c58.1-4.1 104-52.6 104-111.7l0-16-32 0c-40.7 0-76.4 21.8-96 54.3-19.6-32.5-55.3-54.3-96-54.3z"]
};
var faSort = {
  prefix: 'fass',
  iconName: 'sort',
  icon: [448, 512, ["unsorted"], "f0dc", "M224-8L8 224 440 224 224-8zm0 528L440 288 8 288 224 520z"]
};
var faUnsorted = faSort;
var faCircleRadiation = {
  prefix: 'fass',
  iconName: 'circle-radiation',
  icon: [512, 512, [9762, "radiation-alt"], "f7ba", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm64 0l96 0c.6-36.9 22.1-68.8 53.2-84.3L164.4 87.2C104.6 119.8 64 183.1 64 256zm139 81.7l-47.3 82C184.9 437.7 219.2 448 256 448s71.1-10.3 100.3-28.3l-47.3-82c-15.2 10.1-33.4 15.9-53 15.9s-37.8-5.9-53-15.9zM352 256l96 0c0-72.9-40.6-136.2-100.4-168.8l-48.8 84.5c31.1 15.5 52.5 47.3 53.2 84.3zm-96 49.7a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faRadiationAlt = faCircleRadiation;
var faLaptopCode = {
  prefix: 'fass',
  iconName: 'laptop-code',
  icon: [640, 512, [], "f5fc", "M64 32l512 0 0 304-64 0 0-240-384 0 0 240-64 0 0-304zM0 424l0-40 640 0 0 40-56 56-528 0-56-56zM281 209l-31 31c23 23 39 39 48 48L264 321.9c-6.1-6.1-27.8-27.8-65-65l-17-17 65-65 17-17 33.9 33.9-17 17zM393 175c37.2 37.2 58.8 58.8 65 65-6.1 6.1-27.8 27.8-65 65l-17 17-33.9-33.9c9-9 25-25 48-48-23-23-39-39-48-48l33.9-33.9 17 17z"]
};
var faSink = {
  prefix: 'fass',
  iconName: 'sink',
  icon: [512, 512, [], "e06d", "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 64 0 0-32c0-53-43-96-96-96s-96 43-96 96l0 192-64 0 0-96-128 0 0 48 80 0 0 48-112 0 0 64 32 0 0 64c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-64 32 0 0-64-112 0 0-48 88 0 0-48-136 0 0 96-64 0 0-192z"]
};
var faTableCellsRows = {
  prefix: 'fass',
  iconName: 'table-cells-rows',
  icon: [448, 512, [], "e6b0", "M192 288l0-64 192 0 0 64-192 0zm0-192l192 0 0 64-192 0 0-64zm0 320l0-64 192 0 0 64-192 0zM64 32l-64 0 0 448 448 0 0-448-384 0z"]
};
var faArrowUpFromWaterPump = {
  prefix: 'fass',
  iconName: 'arrow-up-from-water-pump',
  icon: [640, 512, [], "e4b6", "M497.3 39l-17-17-17 17-88 88-17 17 33.9 33.9c6.3-6.3 27.6-27.6 64-64l0 142.1-136 0 0-224-224 0 0 224-64 0 0 140.3c15.1 5 30.4 10.1 45.8 15.2 75.1-30.1 115.9-46.4 122.3-48.9 6.7 2.7 46.7 18.7 120 48 73.3-29.3 113.3-45.3 120-48 6.4 2.5 47.1 18.8 122.3 48.9 15.4-5.1 30.6-10.2 45.7-15.2l0-140.3-104 0 0-142.1c36.4 36.4 57.7 57.7 64 64l33.9-33.9-17-17-88-88zm-297 375.1l-8.9 3.6-111.8 44.7c-29.3-9.7-50.1-16.7-62.4-20.8L2 487.2c11 3.7 34.6 11.5 70.8 23.6l8.3 2.8 8.2-3.3 111.1-44.4 111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4 111.1 44.4 8.2 3.3 8.3-2.8c36.2-12.1 59.8-19.9 70.8-23.6l-15.2-45.5c-12.4 4.1-33.2 11.1-62.4 20.8l-111.8-44.7-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4-8.9-3.6z"]
};
var faMicrophoneLinesSlash = {
  prefix: 'fass',
  iconName: 'microphone-lines-slash',
  icon: [576, 512, ["microphone-alt-slash"], "f539", "M32.3-33.8l17 17 142.8 142.8 0-126 192 0 0 88-80 0 0 48 80 0 0 48-80 0 0 48 79.7 0c-1.9 22.8-11.7 43.4-26.8 58.9L391 324.8c25.5-26 41.2-61.6 41.2-100.8l0-64 48 0 0 64c0 52.5-21.1 100.1-55.2 134.7l153.4 153.4-33.9 33.9-17-17-512-512-17-17 33.9-33.9zM339.4 409.1c-8.8 2.4-17.9 4.3-27.3 5.4l0 49.5 72 0 0 48-192 0 0-48 72 0 0-49.5c-94.7-11.8-168-92.6-168-190.5l0-58.2 48 48 0 10.2c0 79.5 64.5 144 144 144 3.3 0 6.6-.1 9.8-.3l41.4 41.4z"]
};
var faMicrophoneAltSlash = faMicrophoneLinesSlash;
var faFaceShakingVertical = {
  prefix: 'fass',
  iconName: 'face-shaking-vertical',
  icon: [512, 512, [], "e79e", "M192-64l0 128 48 0 0-128 48 0 0 66c126.3 15.7 224 123.5 224 254 0 141.4-114.6 256-256 256-22.1 0-43.5-2.8-64-8.1l0 72.1-48 0 0-144-48 0 0 23.9C37.5 408.9 0 336.8 0 256S37.5 103.1 96 56.1l0 71.9 48 0 0-192 48 0zm64 464c-38.2 0-72-19.1-92.2-48.5l-39.5 27.3C153.1 420.6 201.3 448 256 448s102.9-27.4 131.8-69.2l-39.5-27.3C328 380.9 294.2 400 256 400zM168 260l16 0c11 0 20 9 20 20l0 16 40 0 0-16c0-33.1-26.9-60-60-60l-16 0c-33.1 0-60 26.9-60 60l0 16 40 0 0-16c0-11 9-20 20-20zm140 20c0-11 9-20 20-20l16 0c11 0 20 9 20 20l0 16 40 0 0-16c0-33.1-26.9-60-60-60l-16 0c-33.1 0-60 26.9-60 60l0 16 40 0 0-16z"]
};
var faBrowser = {
  prefix: 'fass',
  iconName: 'browser',
  icon: [512, 512, [128468], "f37e", "M0 64l512 0 0 384-512 0 0-384zm64 64l0 64 64 0 0-64-64 0zm120 8l-24 0 0 48 288 0 0-48-264 0z"]
};
var faFaceSleepy = {
  prefix: 'fass',
  iconName: 'face-sleepy',
  icon: [576, 512, [], "e38e", "M532.5 332.1C540 308.1 544 282.5 544 256 544 114.6 429.4 0 288 0S32 114.6 32 256 146.6 512 288 512c40.2 0 78.3-9.3 112.2-25.8-.1-2-.2-4.1-.2-6.2 0-16.7-.4-32.8-4.9-46.8-2-6.3-4.5-10.7-7-13.7-2.4-2.8-5.8-5.7-11.8-8.1l-2.2-.9-22.3 11.8C339.6 399.5 315.6 384 288 384s-51.6 15.5-63.7 38.4l-42.4-22.5c20.1-37.9 60.1-63.9 106.1-63.9 21.9 0 42.4 5.9 60 16.1 3.3-17.3 6.4-33 9.1-47.1-23.9-7.9-41.1-30.4-41.1-57l0-16 40 0 0 16c0 11 9 20 20 20l16 0c11 0 20-9 20-20l0-16 40 0 0 16c0 17.1-7.2 32.6-18.7 43.5 32.5 6.3 68.6 20.9 99.2 40.6zM184 268l16 0c11 0 20-9 20-20l0-16 40 0 0 16c0 33.1-26.9 60-60 60l-16 0c-33.1 0-60-26.9-60-60l0-16 40 0 0 16c0 11 9 20 20 20zm210.1 98.9c26.5 10.6 39.8 30.2 46.7 51.7 7.1 22.1 7.2 45.3 7.2 61.5 0 35.3 28.7 64 64 64s64-28.7 64-64c0-48.1-33.5-84.3-69.3-107.4-35.9-23.2-78.9-36.6-106.7-36.6l-5.9 30.9z"]
};
var faServer = {
  prefix: 'fass',
  iconName: 'server',
  icon: [448, 512, [], "f233", "M448 32l-448 0 0 192 448 0 0-192zM280 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM448 288l-448 0 0 192 448 0 0-192zM280 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faUser = {
  prefix: 'fass',
  iconName: 'user',
  icon: [448, 512, [128100, 62144, 62470, "user-alt", "user-large"], "f007", "M224 248a120 120 0 1 0 0-240 120 120 0 1 0 0 240zM432 512l-64-208-288 0-64 208 416 0z"]
};
var faUserAlt = faUser;
var faUserLarge = faUser;
var faSignalBars = {
  prefix: 'fass',
  iconName: 'signal-bars',
  icon: [448, 512, ["signal-alt", "signal-alt-4", "signal-bars-strong"], "f690", "M448 64l0-32-64 0 0 448 64 0 0-416zM320 128l-64 0 0 352 64 0 0-352zM192 288l0-32-64 0 0 224 64 0 0-192zM64 416l0-32-64 0 0 96 64 0 0-64z"]
};
var faSignalAlt = faSignalBars;
var faSignalAlt4 = faSignalBars;
var faSignalBarsStrong = faSignalBars;
var faStarshipFreighter = {
  prefix: 'fass',
  iconName: 'starship-freighter',
  icon: [576, 512, [], "e03a", "M224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2l228.4 88.8 0 80-160 0 0 64 160 0 0 80-96 37.3 0 74.7-128 0-18.2-18.2C298.5 473.9 261.4 480 224 480zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM80 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm56-120a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM112 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSnowflake = {
  prefix: 'fass',
  iconName: 'snowflake',
  icon: [576, 512, [10052, 10054], "f2dc", "M320.4 0l0-32-64 0 0 94.1-24-24-33.9 33.9c7.3 7.3 26.6 26.6 57.9 57.9l0 70.6-61.2-35.3c-11.5-42.8-18.5-69.2-21.2-79.1L127.7 98.5c4.7 17.7 7.7 28.6 8.8 32.8-40.2-23.2-67.3-38.9-81.5-47L23 139.7c14.1 8.2 41.3 23.8 81.5 47-4.1 1.1-15.1 4-32.8 8.8l12.4 46.4c10-2.7 36.4-9.7 79.1-21.2l61.2 35.3-61.2 35.3c-42.8-11.5-69.2-18.5-79.1-21.2L71.7 316.5c17.7 4.8 28.6 7.7 32.8 8.8-40.2 23.2-67.3 38.9-81.5 47l32 55.4c14.1-8.2 41.3-23.8 81.5-47-1.1 4.1-4 15.1-8.8 32.8L174 425.9c2.7-10 9.7-36.4 21.2-79.1l61.2-35.3 0 70.6c-31.3 31.3-50.6 50.6-57.9 57.9l33.9 33.9c13-13 21-21 24-24l0 94.1 64 0 0-94.1c3 3 11 11 24 24l33.9-33.9-57.9-57.9 0-70.6 61.2 35.3c11.5 42.8 18.5 69.1 21.2 79.1l46.4-12.4c-4.7-17.7-7.7-28.6-8.8-32.8 40.2 23.2 67.3 38.9 81.5 47l32-55.4c-14.1-8.2-41.3-23.8-81.5-47 4.1-1.1 15.1-4 32.8-8.8l-12.4-46.4c-10 2.7-36.4 9.7-79.1 21.2l-61.2-35.3 61.2-35.3c42.8 11.5 69.1 18.5 79.1 21.2l12.4-46.4c-17.7-4.7-28.6-7.7-32.8-8.8 40.2-23.2 67.3-38.9 81.5-47l-32-55.4c-14.1 8.2-41.3 23.8-81.5 47 1.1-4.1 4-15.1 8.8-32.8L402.8 86.1c-2.7 10-9.7 36.4-21.2 79.1l-61.2 35.3 0-70.6C351.7 98.6 371 79.3 378.4 72L344.4 38.1c-13 13-21 21-24 24l0-62.1z"]
};
var faDialMed = {
  prefix: 'fass',
  iconName: 'dial-med',
  icon: [576, 512, [], "e15f", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64-64 0 0-64zm128 31.2C128 207 187 140.6 264 129l0 182.2 48 0 0-182.2c77 11.6 136 78 136 158.2 0 88.4-71.6 160-160 160s-160-71.6-160-160z"]
};
var faSkullCrossbones = {
  prefix: 'fass',
  iconName: 'skull-crossbones',
  icon: [512, 512, [128369, 9760], "f714", "M416.3 144c0-79.5-71.6-144-160-144s-160 64.5-160 144c0 47.1 25.1 88.9 64 115.2l0 60.8 192 0 0-60.8c38.9-26.3 64-68.1 64-115.2zm-224-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM465.6 310.2l-29.5 12.3-179.7 74.9-179.7-74.9-29.5-12.3-24.6 59.1c4.4 1.8 54.7 22.8 150.6 62.8-96 40-146.2 60.9-150.6 62.8l24.6 59.1 29.5-12.3 179.7-74.9 179.7 74.9 29.5 12.3 24.6-59.1c-4.4-1.8-54.7-22.8-150.6-62.8 96-40 146.2-60.9 150.6-62.8l-24.6-59.1z"]
};
var faPesoSign = {
  prefix: 'fass',
  iconName: 'peso-sign',
  icon: [448, 512, [], "e222", "M112 32l-32 0 0 96-48 0 0 48 48 0 0 32-48 0 0 48 48 0 0 224 64 0 0-128 96 0c65.6 0 122-39.5 146.7-96l61.3 0 0-48-48.8 0c.5-5.3 .8-10.6 .8-16s-.3-10.7-.8-16l48.8 0 0-48-61.3 0C362 71.5 305.6 32 240 32L112 32zm199.6 96l-167.6 0 0-32 96 0c28.4 0 54 12.4 71.6 32zM144 176l190.7 0c.9 5.2 1.3 10.5 1.3 16s-.5 10.8-1.3 16l-190.7 0 0-32zm167.6 80c-17.6 19.6-43.1 32-71.6 32l-96 0 0-32 167.6 0z"]
};
var faWineGlass = {
  prefix: 'fass',
  iconName: 'wine-glass',
  icon: [320, 512, [127863], "f4e3", "M37.8 0l244.5 0 5.1 25.7 29.5 147.3c2.1 10.5 3.2 21.2 3.2 32l0 3c0 77.4-55 142-128 156.8l0 115.2 96 0 0 64-256 0 0-64 96 0 0-115.2C55 350 0 285.4 0 208l0-3c0-10.7 1.1-21.4 3.2-32L32.6 25.7 37.8 0zM77.4 128l165.1 0-12.8-64-139.5 0-12.8 64z"]
};
var faTemperatureHalf = {
  prefix: 'fass',
  iconName: 'temperature-half',
  icon: [320, 512, [127777, "temperature-2", "thermometer-2", "thermometer-half"], "f2c9", "M256 0L64 0 64 260.7C34.5 287 16 325.4 16 368 16 447.5 80.5 512 160 512s144-64.5 144-144c0-42.6-18.5-81-48-107.3L256 0zM224 368c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-116.7 48 0 0 116.7c23.5 9.5 40 32.5 40 59.3z"]
};
var faTemperature2 = faTemperatureHalf;
var faThermometer2 = faTemperatureHalf;
var faThermometerHalf = faTemperatureHalf;
var faChartTreeMap = {
  prefix: 'fass',
  iconName: 'chart-tree-map',
  icon: [512, 512, [], "e0ea", "M0 64l192 0 0 160-192 0 0-160zM0 288l192 0 0 160-192 0 0-160zM512 64l0 96-256 0 0-96 256 0zM256 208l256 0 0 96-256 0 0-96zM512 352l0 96-256 0 0-96 256 0z"]
};
var faTicket = {
  prefix: 'fass',
  iconName: 'ticket',
  icon: [576, 512, [127903], "f145", "M576 64L0 64 0 208c26.5 0 48 21.5 48 48S26.5 304 0 304l0 144 576 0 0-144c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-144zM160 176l0 160 256 0 0-160-256 0zm-48-48l352 0 0 256-352 0 0-256z"]
};
var faNfcSymbol = {
  prefix: 'fass',
  iconName: 'nfc-symbol',
  icon: [512, 512, [], "e531", "M163.1 40.2l-17.3-15.5-20.1 11.6C50.3 79.9 0 163.2 0 256S50.3 432.1 125.7 475.7l32-55.4C101.9 388 64 325.7 64 256 64 194.6 93.5 138.8 138.8 104.4l159.9 143.5 23.8 21.4 42.7-47.6-23.8-21.4-178.3-160zM348.9 471.8l17.3 15.5 20.1-11.6C461.6 432.1 512 348.8 512 256S461.6 79.9 386.3 36.3l-32 55.4c55.8 32.3 93.7 94.7 93.7 164.3 0 61.4-29.5 117.2-74.8 151.7l-159.9-143.5-23.8-21.4-42.7 47.6 23.8 21.4 178.3 160z"]
};
var faShieldUser = {
  prefix: 'fass',
  iconName: 'shield-user',
  icon: [512, 512, [], "e809", "M267.6 4.5l207.5 80.5 19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.2-91.1 150-189.4 192.5l-12.7 5.5-12.7-5.5C144.9 463.9 86.6 389.1 53.9 313.9 21.5 239.3 13.7 162.9 16.6 113L17.8 92.5 37 85 244.5 4.5 256 0 267.6 4.5zM176 272l-32 96 224 0-32-96-160 0zm80-152a56 56 0 1 0 0 112 56 56 0 1 0 0-112z"]
};
var faTireRugged = {
  prefix: 'fass',
  iconName: 'tire-rugged',
  icon: [512, 512, [], "f634", "M192 0l128 0 0 41.3c14.9 4.4 29.1 10.4 42.6 17.6l29.2-29.2 90.5 90.5-29.2 29.2c7.3 13.4 13.2 27.7 17.6 42.6l41.3 0 0 128-41.3 0c-4.4 14.9-10.4 29.1-17.6 42.6l29.2 29.2-90.5 90.5-29.2-29.2c-13.4 7.3-27.7 13.2-42.6 17.6l0 41.3-128 0 0-41.3c-14.9-4.4-29.1-10.4-42.6-17.6l-29.2 29.2-90.5-90.5 29.2-29.2c-7.3-13.4-13.2-27.7-17.6-42.6L0 320 0 192 41.3 192c4.4-14.9 10.4-29.1 17.6-42.6l-29.2-29.2 90.5-90.5 29.2 29.2c13.4-7.3 27.7-13.2 42.6-17.6L192 0zM384 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM232 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-64 64a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-88-88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faWheatAwnCircleExclamation = {
  prefix: 'fass',
  iconName: 'wheat-awn-circle-exclamation',
  icon: [640, 512, [], "e598", "M496 576a144 144 0 1 1 0-288 144 144 0 1 1 0 288zM177.4 282.7l6.1 6.7c19.7 23.8 26.3 55 19.2 83.9 31.7-7.7 66.2 1 90.6 25.3l12 12c-.8 7-1.2 14.2-1.2 21.4 0 20 3 39.3 8.7 57.4-36.8 21.8-85 16.9-116.6-14.7L165.7 444.3 81 529c-9.4 9.4-24.5 9.4-33.9 0-9.4-9.4-9.4-24.6 0-33.9l84.7-84.7-30.5-30.5c-37.5-37.5-37.5-98.3 0-135.8l18.8-18.7 57.4 57.4zM480 512l32 0 0-32-32 0 0 32zm0-64l32 0 0-112-32 0 0 112zM281.4 178.7l6.1 6.7c19.7 23.7 26.3 55 19.2 83.9 24.2-5.9 50.2-2.1 71.9 10.8-32.2 24.9-56.2 59.8-67.5 100.1-3.8-2.8-7.5-6-11-9.4l-94.9-94.9c-37.5-37.5-37.5-98.3 0-135.8l18.8-18.7 57.4 57.4zM577.6 32l-17 17-114.5 114.4c7.7 1 15.2 3 22.5 5.9 45.8-45.7 70.9-70.8 75.3-75.2l34 34-17 16.9-52.7 52.7 50.3 50.3-1.9 1.8c-19.1-6.4-39.5-9.8-60.7-9.8-34.2 0-66.2 8.9-94 24.6l-92.7-92.7c-37.5-37.5-37.5-98.3 0-135.8L328 17.4 378.3 67.7 448-1.9 482 32 465 49 406.7 107.2c2.8 7.1 4.7 14.5 5.8 22l114.3-114.2 17-17 33.9 34z"]
};
var faCircleL = {
  prefix: 'fass',
  iconName: 'circle-l',
  icon: [512, 512, [], "e114", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM224 168l0 152 112 0 0 48-160 0 0-224 48 0 0 24z"]
};
var faArrowsTurnRight = {
  prefix: 'fass',
  iconName: 'arrows-turn-right',
  icon: [512, 512, [], "e4c0", "M368.3-29.3c7.1 7.1 38.2 38.2 93.3 93.3l2.7 0 0 2.7c1.8 1.8 11.5 11.5 29.3 29.3-17.8 17.8-27.5 27.5-29.3 29.3l0 2.7-2.7 0c-55.1 55.1-86.2 86.2-93.3 93.3L323 176c14.6-14.6 30.6-30.6 48-48l-274.7 0 0 128-64 0 0-192 338.7 0-48-48 45.3-45.3zm-96 256c7.1 7.1 38.2 38.2 93.3 93.3l2.7 0 0 2.7 29.3 29.3-29.3 29.3 0 2.7-2.7 0-93.3 93.3-45.3-45.3c14.6-14.6 30.6-30.6 48-48l-178.7 0 0 96-64 0 0-160 242.7 0c-17.4-17.4-33.4-33.4-48-48l45.3-45.3z"]
};
var faRouteInterstate = {
  prefix: 'fass',
  iconName: 'route-interstate',
  icon: [512, 512, [], "f61b", "M273.2 12.9l-17-10.6-17 10.6c-29.7 18.6-53.7 28.5-78.3 32.6-24.8 4.1-52.6 2.8-90.5-4.8l-32.8-6.6-5.1 33.1c-16.2 105.3-17.4 193.1 14.5 266 32.6 74.4 96.8 127.1 196.9 168.5l12.9 5.4 12.7-5.9c97.3-44.9 161.1-97.3 194.1-170.4 32.5-71.9 32.3-158 16.1-263.6l-5.1-33.1-32.8 6.6c-37.9 7.6-65.7 8.9-90.5 4.8-24.6-4.1-48.6-14-78.3-32.6zM85.5 192l341.1 0c-.3 44.7-7 81.2-21.1 112.3-22.9 50.7-67.7 92.7-149.9 132.6-83.2-36.6-127.5-78.3-149.9-129.5-14-31.9-20.4-69.6-20.2-115.4z"]
};
var faCandyCane = {
  prefix: 'fass',
  iconName: 'candy-cane',
  icon: [448, 512, [], "f786", "M421.8 39.6C452 85.2 456.5 142.9 435.1 192l-165.4 0 41.4-41.4c.8-.8 1.5-1.6 2.2-2.4L421.8 39.6zM268 103c-.8 .7-1.6 1.4-2.4 2.2-15.9 15.9-40.3 40.4-73.4 73.4L101.7 88 175 14.6C229.9-40.2 314.5-46.7 376.5-5.6L268 103zM125.7 336l80-80 181 0-80 80-181 0zm117 64C165.9 476.8 117 525.7 96.2 546.5L5.7 456c35.9-35.9 54.6-54.6 56-56l181 0z"]
};
var faCircle6 = {
  prefix: 'fass',
  iconName: 'circle-6',
  icon: [512, 512, [], "e0f3", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm56-368l0 48-72 0c-13.3 0-24 10.7-24 24l0 12.1c7.5-2.7 15.6-4.1 24-4.1l32 0c39.8 0 72 32.2 72 72s-32.2 72-72 72l-32 0c-39.8 0-72-32.2-72-72l0-80c0-39.8 32.2-72 72-72l72 0zM240 320l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
var faCitrus = {
  prefix: 'fass',
  iconName: 'citrus',
  icon: [512, 512, [], "e2f4", "M288 112l0 16 96 0c53 0 96-43 96-96l0-32-96 0c-53 0-96 43-96 96l0 16zM244 96c0-23.1 5.6-44.8 15.4-64-1.1 0-2.3 0-3.4 0-132.5 0-240 107.5-240 240S123.5 512 256 512 496 404.5 496 272c0-45.2-12.5-87.5-34.2-123.6-22.2 14.9-49 23.6-77.8 23.6l-140 0 0-76z"]
};
var faWheelchair = {
  prefix: 'fass',
  iconName: 'wheelchair',
  icon: [576, 512, [], "f193", "M280.5 40a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM150.4 197.6c-68 18.5-117.9 80.6-117.9 154.4 0 88.4 71.6 160 160 160 71.6 0 132.3-47.1 152.7-112L290 400c-1 0-2.1 0-3.1 0l-4.1 0c-2.3 0-4.7-.1-7-.2-16.6 28.8-47.7 48.2-83.3 48.2-53 0-96-43-96-96 0-42.7 27.9-79 66.5-91.4l-12.6-63zM224.5 128l-39 0c1.9 9.5 13.4 67 34.5 172.6 6 29.9 32.2 51.4 62.8 51.4l13.1 0c.4 0 .8 0 1.3 0l97.2 0c31.7 84.6 48.7 129.9 51 136.1 40.6-13.5 104.6-34.9 107.6-35.9l-20.2-60.7c-22.2 7.4-38.5 12.8-49.1 16.4l-37.2-99.1-7.8-20.8-115.9 0-26.9-134.3-5.1-25.7-66.2 0z"]
};
var faExpandWide = {
  prefix: 'fass',
  iconName: 'expand-wide',
  icon: [512, 512, [], "f320", "M32 64l-32 0 0 160 64 0 0-96 96 0 0-64-128 0zM64 320l0-32-64 0 0 160 160 0 0-64-96 0 0-64zM384 64l-32 0 0 64 96 0 0 96 64 0 0-160-128 0zM512 320l0-32-64 0 0 96-96 0 0 64 160 0 0-128z"]
};
var faSpellCheck = {
  prefix: 'fass',
  iconName: 'spell-check',
  icon: [640, 512, [], "f891", "M152.5 32c-48.6 0-88 39.4-88 88l0 200 64 0 0-96 64 0 0 96 64 0 0-200c0-48.6-39.4-88-88-88l-16 0zm40 128l-64 0 0-40c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 40zm144-128l-32 0 0 288 104 0c48.6 0 88-39.4 88-88 0-23.6-9.3-45-24.4-60.8 10.3-14.4 16.4-32.1 16.4-51.2 0-48.6-39.4-88-88-88l-64 0zm64 112l-32 0 0-48 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm-32 112l0-48 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0zm233 84l20-25-50-40-20 25-105.7 132.1-61.3-61.3-45.3 45.3 86.6 86.6 25.3 25.3 22.3-27.9 128-160z"]
};
var faTurnDownRight = {
  prefix: 'fass',
  iconName: 'turn-down-right',
  icon: [512, 512, [], "e455", "M512 256l-192-192 0 128-192 0 0-128-128 0 0 256 320 0 0 128 192-192z"]
};
var faVolumeOff = {
  prefix: 'fass',
  iconName: 'volume-off',
  icon: [320, 512, [], "f026", "M96 352l-96 0 0-192 96 0 192-152 0 496-192-152z"]
};
var faSaxophone = {
  prefix: 'fass',
  iconName: 'saxophone',
  icon: [640, 512, [127927], "f8dc", "M246.7 176L171.4 306.1c-2.2 3.8-3.4 8.2-3.4 12.6l0 2.6c0 12.5 10.1 22.6 22.6 22.6 6 0 11.8-2.4 16-6.6L319 225 294.1 200 328 166.1c12.8 12.8 21.1 21.1 25 25L367 177c-3.8-3.8-12.2-12.2-25-25L376 118.1c12.8 12.8 21.1 21.1 25 25L415 129c-3.8-3.8-12.2-12.2-25-25L424 70.1c12.8 12.8 21.1 21.1 25 25l63-63 80 0 48 32 0 32-96 0-255.4 322.6C257.9 457.4 211.2 480 161.8 480 72.4 480 0 407.6 0 318.2l0-3.1c0-12.7 1.5-25.4 4.4-37.8l23.9-101.4-28.2 0 0-48 288 0 0 48-41.3 0zM120 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSensorTriangleExclamation = {
  prefix: 'fass',
  iconName: 'sensor-triangle-exclamation',
  icon: [640, 512, ["sensor-alert"], "e029", "M544 32l-448 0 0 448 125.3 0 210.7-368.7 112 196 0-275.3zM208 120l0 136-48 0 0-160 48 0 0 24zm96 0l0 136-48 0 0-160 48 0 0 24zM240 544.1l384 0-192-336-192 336zm208-208l0 96-32 0 0-112 32 0 0 16zm0 159.7l-32 0 0-32 32 0 0 32z"]
};
var faSensorAlert = faSensorTriangleExclamation;
var faLungs = {
  prefix: 'fass',
  iconName: 'lungs',
  icon: [576, 512, [129729], "f604", "M320 32l0-32-64 0 0 173.9-32 19.2 0-161.1-64 0C57 145.2 0 292.8 0 445.9l0 66.1 128 0 96-64 0-180.3 64-38.4 64 38.4 0 180.3 96 64 128 0 0-54.3c0-141.1-46.7-278.3-132.7-390.2l-27.3-35.5-64 0 0 161.1-32-19.2 0-141.9z"]
};
var faCarWrench = {
  prefix: 'fass',
  iconName: 'car-wrench',
  icon: [512, 512, ["car-mechanic"], "f5e3", "M80.3 128C44.5 128 14.2 104.5 4 72l92.3 0 0-48-92.3 0c10.2-32.5 40.5-56 76.3-56 32.8 0 61 19.7 73.3 48L359 16c12.3-28.3 40.5-48 73.3-48 35.8 0 66.1 23.5 76.3 56l-92.3 0 0 48 92.3 0c-10.2 32.5-40.5 56-76.3 56-32.8 0-61-19.7-73.3-48L153.7 80c-12.3 28.3-40.5 48-73.3 48zm41.8 16l268.4 0 7.8 20.8 46.2 123.2 35.8 0 0 224-80 0 0-64-288 0 0 64-80 0 0-224 35.8 0 54-144zm224 64l-179.6 0-30 80 239.6 0-30-80zM128.3 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCarMechanic = faCarWrench;
var faPopsicle = {
  prefix: 'fass',
  iconName: 'popsicle',
  icon: [320, 512, [], "e43e", "M160 0C71.6 0 0 71.6 0 160l0 224 128 0 0 128 64 0 0-128 128 0 0-224C320 71.6 248.4 0 160 0z"]
};
var faBookmark = {
  prefix: 'fass',
  iconName: 'bookmark',
  icon: [384, 512, [128278, 61591], "f02e", "M0 528L0 0 384 0 384 528 192 416 0 528z"]
};
var faBarcode = {
  prefix: 'fass',
  iconName: 'barcode',
  icon: [448, 512, [], "f02a", "M64 32l-64 0 0 448 64 0 0-448zm80 0l-48 0 0 448 48 0 0-448zm48 0l0 448 64 0 0-448-64 0zm208 0l0 448 48 0 0-448-48 0zm-96 0l0 448 48 0 0-448-48 0z"]
};
var faWheatAwnSlash = {
  prefix: 'fass',
  iconName: 'wheat-awn-slash',
  icon: [576, 512, [], "e338", "M578.2 512.1L544.3 546-1.6 .1 32.3-33.8 578.2 512.1zM145.5 282.7l6.1 6.7c19.7 23.8 26.3 55 19.2 83.9 31.7-7.7 66.2 1 90.6 25.3L318.7 456 300 474.7c-37.5 37.5-98.3 37.5-135.8 0L133.8 444.3 49.1 529c-9.4 9.4-24.5 9.4-33.9 0-9.4-9.4-9.4-24.6 0-33.9l84.7-84.7-30.5-30.5c-37.5-37.5-37.5-98.3 0-135.8l18.8-18.7 57.4 57.4zM545.7 32l-17 17-114.5 114.4c7.7 1 15.3 3 22.5 5.9 45.8-45.7 70.9-70.8 75.3-75.2l34 34-17 16.9-52.7 52.7 50.3 50.3-18.7 18.7c-37.5 37.5-98.3 37.5-135.8 0l-94.9-94.9c-37.5-37.5-37.5-98.3 0-135.8l18.8-18.7 50.3 50.3 69.7-69.7 34 34-17 16.9-58.3 58.3c2.8 7.1 4.7 14.5 5.8 22l114.3-114.2 17-17 33.9 34z"]
};
var faListOl = {
  prefix: 'fass',
  iconName: 'list-ol',
  icon: [576, 512, ["list-1-2", "list-numeric"], "f0cb", "M32.1 48l96 0 0 128 48 0 0 48-144 0 0-48 48 0 0-80-48 0 0-48zM62.5 301.2c11.4-8.6 25.3-13.2 39.6-13.2l4.9 0c33.7 0 61.1 27.4 61.1 61.1 0 19.6-9.4 37.9-25.2 49.4l-24 17.5 57.2 0 0 48-144 0 0-44.2 9.9-7.2 72.7-52.9c3.4-2.5 5.4-6.4 5.4-10.6 0-7.2-5.9-13.1-13.1-13.1l-4.9 0c-3.9 0-7.7 1.3-10.8 3.6l-40 30-28.8-38.4c12.5-9.4 25.9-19.4 40-30zM256.1 64l288 0 0 64-320 0 0-64 32 0zm0 160l288 0 0 64-320 0 0-64 32 0zm0 160l288 0 0 64-320 0 0-64 32 0z"]
};
var faList12 = faListOl;
var faListNumeric = faListOl;
var faTypewriter = {
  prefix: 'fass',
  iconName: 'typewriter',
  icon: [448, 512, [], "f8e7", "M96 0l-32 0 0 144 64 0 0-80 146.7 0 45.3 45.3 0 34.7 64 0 0-61.3-73.4-73.4-9.4-9.4-205.3 0zM0 192l0 96 32 0 0 224 384 0 0-224 32 0 0-96-144 0-32 32-96 0-32-32-144 0zM104 352a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm104-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm56 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm104-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM144 432a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm104-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm56 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"]
};
var faFileCircleXmark = {
  prefix: 'fass',
  iconName: 'file-circle-xmark',
  icon: [576, 512, [], "e5a1", "M272 0l-240 0 0 512 244 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3L416 144 272 0zm85.5 176L240 176 240 58.5 357.5 176zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm55.3-176.7L454.6 400c25.4 25.3 40 40 44 44L476 466.6c-4-4-18.6-18.6-44-44-25.3 25.4-40 40-44 44L365.4 444c4-4 18.6-18.6 44-44-25.4-25.3-40-40-44-44L388 333.4c4 4 18.6 18.6 44 44 25.3-25.4 40-40 44-44l22.6 22.6-11.3 11.3z"]
};
var faInboxOut = {
  prefix: 'fass',
  iconName: 'inbox-out',
  icon: [512, 512, [128228, "inbox-arrow-up"], "f311", "M423.5 96l24 192-79.5 0-32 64-160 0-32-64-79.5 0 24-192 335 0zM32 32l-32 256 0 192 512 0 0-192-32-256-448 0zM273 135l-17-17c-3.5 3.5-30.5 30.5-81 81l-17 17 33.9 33.9c10.3-10.3 23.6-23.6 40-40l0 110.1 48 0 0-110.1c16.4 16.4 29.7 29.7 40 40L353.9 216c-3.5-3.5-30.5-30.5-81-81z"]
};
var faInboxArrowUp = faInboxOut;
var faCube = {
  prefix: 'fass',
  iconName: 'cube',
  icon: [512, 512, [], "f1b2", "M256.3-21l16 9.2 207.8 120 16 9.2 0 277-16 9.2-207.8 120-16 9.2-16-9.2-207.8-120-16-9.2 0-277 16-9.2 207.8-120 16-9.2zM432.2 357.5l0-166.1-143.8 83.1 0 166.1 143.8-83z"]
};
var faTape = {
  prefix: 'fass',
  iconName: 'tape',
  icon: [576, 512, [], "f4db", "M412.8 416c41.5-40.7 67.2-97.3 67.2-160 0-123.7-100.3-224-224-224S32 132.3 32 256 132.3 480 256 480l320 0 0-64-163.2 0zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm48 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faBomb = {
  prefix: 'fass',
  iconName: 'bomb',
  icon: [576, 512, [128163], "f1e2", "M480 152l24-64 64-24-64-24-24-64-24 64-64 24 64 24 24 64zM366.6 97.4L344 74.7c-17 17-28.2 28.2-33.5 33.5-22-7.9-45.8-12.2-70.5-12.2-114.9 0-208 93.1-208 208s93.1 208 208 208 208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5 5.3-5.3 16.5-16.5 33.5-33.5-5.5-5.5-39.7-39.7-102.6-102.6zM240 208c-53 0-96 43-96 96l0 24-48 0 0-24c0-79.5 64.5-144 144-144l24 0 0 48-24 0z"]
};
var faCameraWeb = {
  prefix: 'fass',
  iconName: 'camera-web',
  icon: [448, 512, ["webcam"], "f832", "M64 224a160 160 0 1 1 320 0 160 160 0 1 1 -320 0zM248 446.7C360.4 434.8 448 339.6 448 224 448 100.3 347.7 0 224 0S0 100.3 0 224C0 339.6 87.6 434.8 200 446.7l0 33.3-104 0 0 48 256 0 0-48-104 0 0-33.3zM224 336a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
var faWebcam = faCameraWeb;
var faLacrosseStick = {
  prefix: 'fass',
  iconName: 'lacrosse-stick',
  icon: [576, 512, [], "e3b5", "M400-32c97.2 0 176 78.8 176 176 0 57.8-35.9 109-89.3 129.2l-10.9 3.6-11.5 3.3c-8.6 2.5-16.8 6.2-24.2 11l-7.2 5.2-34.9 27.9c-22.5 18-50.4 27.8-79.2 27.8-23.4 0-45.3-6.4-64.1-17.4L48 541.3 2.8 496 209.4 289.3c-11-18.8-17.4-40.7-17.4-64.1 0-28.8 9.8-56.7 27.8-79.2l27.9-34.9 5.2-7.2c4.9-7.5 8.6-15.6 11-24.2l3.3-11.5 3.6-10.9C291 3.9 342.2-32 400-32zm0 64c-31 0-58.5 19.3-69.3 47.9l-1.9 5.8-3.3 11.5c-4.9 17.2-12.8 33.3-23.2 47.8l-4.6 6.1-27.9 34.9c-8.9 11.1-13.8 25-13.8 39.2 0 34.7 28.1 62.7 62.7 62.8 14.3 0 28.1-4.8 39.2-13.8l34.9-27.9 6.1-4.6c14.4-10.4 30.6-18.3 47.8-23.2l11.5-3.3 5.8-1.9C492.7 202.5 512 175 512 144 512 82.1 461.9 32 400 32z"]
};
var faDisplayChartUp = {
  prefix: 'fass',
  iconName: 'display-chart-up',
  icon: [512, 512, [], "e5e3", "M64 96l0 256 384 0 0-256-384 0zM0 32l512 0 0 384-208 0 16 48 96 0 0 48-320 0 0-48 96 0 16-48-208 0 0-384zM312 144l104 0 0 128-48 0 0-46.1c-56.4 56.4-85.7 85.7-88 88-3.6-3.6-30.3-30.3-80-80-49.7 49.7-76.4 76.4-80 80L86.1 280c.8-.8 33.1-33.1 97-97l17-17c3.6 3.6 30.3 30.3 80 80l54.1-54.1-46.1 0 0-48 24 0z"]
};
var faTrashSlash = {
  prefix: 'fass',
  iconName: 'trash-slash',
  icon: [576, 512, [], "e2b3", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-97.7-97.7 16.5-253.4-270 0-48-48 350 0 0-64-128 0-16-48-160 0-16 48-94 0-48.9-48.9zM97.6 167.3L120.1 512 442.3 512 97.6 167.3z"]
};
var faSdCards = {
  prefix: 'fass',
  iconName: 'sd-cards',
  icon: [448, 512, [], "e240", "M448 448l-352 0 0-368 112-112 240 0 0 480zM48 160l0 336 304 0 0 48-352 0 0-384 48 0zM288 56l0-24-48 0 0 96 48 0 0-72zm96 0l0-24-48 0 0 96 48 0 0-72z"]
};
var faScaleUnbalanced = {
  prefix: 'fass',
  iconName: 'scale-unbalanced',
  icon: [640, 512, ["balance-scale-left"], "f515", "M388.9 39.3l113-37.7 20.2 60.7-125.9 42c-7 22-23.3 39.9-44.2 49l0 294.7 192 0 0 64-256 0 0-358.7c-5.1-2.2-9.9-5-14.4-8.2-107.9 36-163.1 54.4-165.9 55.3L87.5 139.8c4.9-1.6 55.9-18.6 153-51-.3-2.9-.5-5.8-.5-8.8 0-44.2 35.8-80 80-80 29.3 0 55 15.8 68.9 39.3zM112 224l46.5 0 6.7 12.9 88 168 2.7 5.2 0 47.8-7 7-40 40-7 7-147.9 0-7-7-40-40-7-7 0-47.8 2.7-5.2 88-168 6.7-12.9 14.5 0zM51.1 416l153.8 0-75.4-144-3 0-75.4 144zM481.5 96l61 0 6.7 12.9 88 168 2.7 5.2 0 47.8-7 7-40 40-7 7-147.9 0-7-7-40-40-7-7 0-47.8 2.7-5.2 88-168 6.7-12.9zm29 48l-75.4 144 153.8 0-75.4-144-3 0z"]
};
var faBalanceScaleLeft = faScaleUnbalanced;
var faCircleMalaysianRinggit = {
  prefix: 'fass',
  iconName: 'circle-malaysian-ringgit',
  icon: [512, 512, [], "e6f9", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM120 160l54.7 0c37.6 0 68 30.4 68 68 0 24.1-12.5 45.2-31.4 57.3 12.7 22.2 22.5 39.4 29.5 51.6l-41.7 23.8c-5.7-10-18.1-31.6-37-64.7l-18.1 0 0 56-48 0 0-192 24 0zm54.7 88c11 0 20-9 20-20s-9-20-20-20l-30.7 0 0 40 30.7 0zM256 352l0-192 42.1 0c.8 1.2 13.5 19.3 37.9 54.1 24.4-34.9 37.1-52.9 37.9-54.1l42.1 0 0 192-48 0 0-99.9c-7 10-17.7 25.2-32 45.7-14.3-20.5-25-35.7-32-45.7l0 99.9-48 0z"]
};
var faBookCircleArrowRight = {
  prefix: 'fass',
  iconName: 'book-circle-arrow-right',
  icon: [576, 512, [], "e0bc", "M416 0l-384 0 0 512 244 0c-13.7-19-24-40.7-30-64l-150 0 0-32c0-17.7 14.3-32 32-32l112.7 0c8.1-98.6 90.7-176 191.3-176 16.6 0 32.7 2.1 48 6l0-214-64 0zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM440 321.4l11.3 11.3 56 56 11.3 11.3-11.3 11.3-56 56-11.3 11.3-22.6-22.6c4.6-4.6 18-18 40-40l-105.4 0 0-32 105.4 0c-22-22-35.4-35.4-40-40L440 321.4z"]
};
var faSquareCaretLeft = {
  prefix: 'fass',
  iconName: 'square-caret-left',
  icon: [448, 512, ["caret-square-left"], "f191", "M0 32l0 448 448 0 0-448-448 0zM120 256l168-136 0 272-168-136z"]
};
var faCaretSquareLeft = faSquareCaretLeft;
var faRuler = {
  prefix: 'fass',
  iconName: 'ruler',
  icon: [576, 512, [128207], "f545", "M175 550.2l-181-181 50.9-50.9c58.5 58.5 88.6 88.6 90.5 90.5l33.9-33.9c-1.9-1.9-32.1-32.1-90.5-90.5l33.9-33.9c39.6 39.6 62.2 62.2 67.9 67.9l33.9-33.9c-5.7-5.7-28.3-28.3-67.9-67.9l33.9-33.9c58.5 58.5 88.6 88.6 90.5 90.5L305.1 239c-1.9-1.9-32.1-32.1-90.5-90.5l33.9-33.9c39.6 39.6 62.2 62.2 67.9 67.9l33.9-33.9c-5.7-5.7-28.3-28.3-67.9-67.9l33.9-33.9c58.5 58.5 88.6 88.6 90.5 90.5l33.9-33.9c-1.9-1.9-32.1-32.1-90.5-90.5l50.9-50.9 181 181-407.3 407.3z"]
};
var faCardsBlank = {
  prefix: 'fass',
  iconName: 'cards-blank',
  icon: [576, 512, [], "e4df", "M544 512l-320 0 0-6.4 271.3-72.7-98.8-368.9 147.5 0 0 448zM436.6 399L127.5 481.8 11.5 49.1 320.6-33.8 436.6 399z"]
};
var faI = {
  prefix: 'fass',
  iconName: 'i',
  icon: [320, 512, [105], "49", "M32 32l-32 0 0 64 128 0 0 320-128 0 0 64 320 0 0-64-128 0 0-320 128 0 0-64-288 0z"]
};
var faCircleNorwegianKrone = {
  prefix: 'fass',
  iconName: 'circle-norwegian-krone',
  icon: [512, 512, [], "e738", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 128l0 126.1c43-43 67-67 72-72L281.9 216c-7.8 7.8-26.1 26.1-54.7 54.7l53.3 99-42.3 22.8c-3.6-6.7-19.1-35.5-46.5-86.3l-15.8 15.8 0 62.1-48 0 0-256 48 0zm160 78.2c9.6-4.1 20-6.2 30.6-6.2l33.4 0 0 48-33.4 0c-8.1 0-15.9 3.2-21.7 9s-9 13.5-9 21.7l0 105.4-48 0 0-192 48 0 0 14.2z"]
};
var faAirplay = {
  prefix: 'fass',
  iconName: 'airplay',
  icon: [512, 512, [], "e089", "M64 128l384 0 0 224-62.9 0c28.8 28.8 50.1 50.1 64 64l62.9 0 0-352-512 0 0 352 62.9 0c13.9-13.9 35.2-35.2 64-64L64 352 64 128zm2.7 352L445.3 480 256 290.7c-.2 .2-45.1 45.1-134.6 134.6L66.7 480z"]
};
var faVolumeXmark = {
  prefix: 'fass',
  iconName: 'volume-xmark',
  icon: [576, 512, ["volume-mute", "volume-times"], "f6a9", "M0 352l96 0 192 152 0-496-192 152-96 0 0 192zM545.9 192L512 158.1c-6.3 6.3-27.6 27.6-64 64-36.4-36.4-57.7-57.7-64-64L350.1 192c6.3 6.3 27.6 27.6 64 64-36.4 36.4-57.7 57.7-64 64L384 353.9c6.3-6.3 27.6-27.6 64-64 36.4 36.4 57.7 57.7 64 64L545.9 320c-6.3-6.3-27.6-27.6-64-64 36.4-36.4 57.7-57.7 64-64z"]
};
var faVolumeMute = faVolumeXmark;
var faVolumeTimes = faVolumeXmark;
var faArchway = {
  prefix: 'fass',
  iconName: 'archway',
  icon: [512, 512, [], "f557", "M0 32l512 0 0 64-512 0 0-64zM0 416l32 0 0-272 448 0 0 272 32 0 0 64-160 0 0-128c0-53-43-96-96-96s-96 43-96 96l0 128-160 0 0-64z"]
};
var faPersonDigging = {
  prefix: 'fass',
  iconName: 'person-digging',
  icon: [640, 512, ["digging"], "f85e", "M352 40a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm-67.3 88l-152.4 0-32.9 54.9c-17-8.5-32.3-16.2-46.1-23.1L31.8 202.7 53.3 213.5 402 387.8c-33 55-57.8 96.4-74.5 124.2l305 0c-8.2-13.7-49.9-83.2-125.1-208.5L480 257.8c-18.6 30.9-36.3 60.5-53.2 88.7l-92.9-46.4-47.1-164.9-2.1-7.2zM87.1 512l43.6-130.9 61.3 30.7 0 100.2 64 0 0-139.8-17.7-8.8c-87.8-43.9-136.2-68.1-145-72.5l-11.7 35-62 186.1 67.5 0z"]
};
var faDigging = faPersonDigging;
var faGaugeHigh = {
  prefix: 'fass',
  iconName: 'gauge-high',
  icon: [512, 512, [62461, "tachometer-alt", "tachometer-alt-fast"], "f625", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64 0-16.2-6-31.1-16-42.3l69.5-138.9-42.9-21.5-69.5 138.9c-1.7-.1-3.4-.2-5.1-.2-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAlt = faGaugeHigh;
var faTachometerAltFast = faGaugeHigh;
var faSquareHalf = {
  prefix: 'fass',
  iconName: 'square-half',
  icon: [448, 512, [], "e792", "M224 32l-224 0 0 448 224 0 0-448z"]
};
var faGenderless = {
  prefix: 'fass',
  iconName: 'genderless',
  icon: [384, 512, [], "f22d", "M192 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 320a192 192 0 1 0 0-384 192 192 0 1 0 0 384z"]
};
var faClockTen = {
  prefix: 'fass',
  iconName: 'clock-ten',
  icon: [512, 512, [], "e354", "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 91.2c-45.6-30.4-71.8-47.9-78.7-52.4l-26.6 39.9c.6 .4 39.3 26.2 116 77.3l37.3 24.9 0-204.8-48 0 0 24z"]
};
var faWireless = {
  prefix: 'fass',
  iconName: 'wireless',
  icon: [448, 512, [], "e7df", "M32 208c132.5 0 240 107.5 240 240l0 32-64 0 0-32c0-97.2-78.8-176-176-176l-32 0 0-64 32 0zM32 32c229.7 0 416 186.3 416 416l0 32-64 0 0-32C384 253.6 226.4 96 32 96L0 96 0 32 32 32zM82 465.9A48 48 0 1 1 14.1 398 48 48 0 1 1 82 465.9z"]
};
var faSquareAustral = {
  prefix: 'fass',
  iconName: 'square-austral',
  icon: [448, 512, [], "e726", "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM204.5 144l39 0 6.3 14.3 43.3 97.7 58.9 0 0 32-44.7 0 10.6 24 34.1 0 0 32-19.9 0c6.6 14.9 13.1 29.7 19.6 44.2l-43.9 19.4c-5-11.3-14.4-32.6-28.2-63.7l-111.2 0c-13.8 31.1-23.2 52.3-28.2 63.7L96.3 388.2c6.5-14.6 13-29.3 19.6-44.2l-19.9 0 0-32 34.1 0 10.6-24-44.7 0 0-32 58.9 0 43.3-97.7 6.3-14.3zM224 218.5l-16.6 37.5 33.2 0-16.6-37.5zM182.6 312l82.8 0-10.6-24-61.6 0-10.6 24z"]
};
var faCloudSun = {
  prefix: 'fass',
  iconName: 'cloud-sun',
  icon: [640, 512, [9925], "f6c4", "M490.9-26.4c1.1 5.5 8.3 41 21.5 106.4 65.4 13.2 100.9 20.4 106.4 21.5-3.1 4.7-23.1 34.9-60 90.5 36.9 55.6 56.9 85.8 60 90.5-9 1.8-37.5 7.6-85.4 17.3-11.9-8.7-25.1-15.6-39.3-20.4-2.5-12.7-6.8-24.7-12.7-35.7 9.5-14.9 15.1-32.6 15.1-51.7 0-53-43-96-96-96-47.9 0-87.6 35.1-94.8 80.9-26.5-20.3-59.5-32.5-95.4-32.9-10.4-15.6-19.8-29.8-28.2-42.5 5.5-1.1 41-8.3 106.4-21.5 13.2-65.4 20.4-100.9 21.5-106.4 4.7 3.1 34.8 23.1 90.5 60 55.6-36.9 85.8-56.9 90.5-60zM448.4 192c0 3.8-.4 7.5-1.3 11.1-21.7-17-49-27.1-78.7-27.1-4.6 0-9.1 .2-13.5 .7 6.4-19 24.4-32.7 45.5-32.7 26.5 0 48 21.5 48 48zm-320 320l-96 0 0-96c0-41.8 26.7-77.4 64-90.5l0-21.5c0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-416 0z"]
};
var faArrowRight = {
  prefix: 'fass',
  iconName: 'arrow-right',
  icon: [576, 512, [8594], "f061", "M534.9 278.6l22.6-22.6-22.6-22.6-160-160-22.6-22.6-45.3 45.3c1.3 1.3 44 44 128 128l-402.7 0 0 64 402.7 0c-84 84-126.7 126.7-128 128l45.3 45.3 22.6-22.6 160-160z"]
};
var faSquareInfo = {
  prefix: 'fass',
  iconName: 'square-info',
  icon: [448, 512, [8505, "info-square"], "f30f", "M448 32l-448 0 0 448 448 0 0-448zM184 336l24 0 0-64-48 0 0-48 96 0 0 112 32 0 0 48-128 0 0-48 24 0zm72-208l0 64-64 0 0-64 64 0z"]
};
var faInfoSquare = faSquareInfo;
var faHandshake = {
  prefix: 'fass',
  iconName: 'handshake',
  icon: [576, 512, [129309, 62662, "handshake-alt", "handshake-simple"], "f2b5", "M288 64l0 0 128 0 48 32 112-64 0 288-70.4 56C411.3 282.5 346.8 218.5 312 184l0 0-47.4 47.4c-21.5 21.5-52.1 28.2-79.3 20.1-.4-.1-.8-.2-1.1-.3-7-2.2-13.8-5.4-20.1-9.5-.4-.3-.9-.6-1.3-.9-3.9-2.7-7.7-5.8-11.2-9.4L144 224 288 64zM160 64l63.4 0c-90.8 100.9-139.4 154.8-145.6 161.7 25.6 25.6 38.8 38.8 39.6 39.6 50 50 131 50 181 0l13.6-13.6 157.9 156.6-41.3 34.4c-26.9-26.9-44.5-44.5-52.7-52.7L342.1 424c8.7 8.7 25.2 25.2 49.6 49.6l-7.7 6.4-62.1 0c-31.3-31.3-50.6-50.6-57.9-57.9L230.1 456c13 13 21 21 24 24L192 480 0 320 0 32 112 96 160 64z"]
};
var faHandshakeAlt = faHandshake;
var faHandshakeSimple = faHandshake;
var faCloudQuestion = {
  prefix: 'fass',
  iconName: 'cloud-question',
  icon: [576, 512, [], "e492", "M144 480l432 0 0-128c0-47.4-25.7-88.7-64-110.9l0-49.1c0-53-43-96-96-96-17.7 0-34.2 4.8-48.4 13.1-24.1-45.8-72.2-77.1-127.6-77.1-79.5 0-144 64.5-144 144l0 24.2C40.1 220 0 273.3 0 336l0 144 144 0zM288 213.2c-17.7 0-32 14.3-32 32l-42.4 0c0-41.1 33.3-74.4 74.4-74.4s74.4 33.3 74.4 74.4c0 33.5-22.8 59-53.2 69.6l0 18.3-42.4 0 0-53.5 3.3-.5c21.1-3 49.9-7.1 49.9-34 0-17.7-14.3-32-32-32zM264 360l48 0 0 48-48 0 0-48z"]
};
var faPersonSkiing = {
  prefix: 'fass',
  iconName: 'person-skiing',
  icon: [640, 512, [9975, "skiing"], "f7c9", "M448.4 56a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM46.1 279.6l21.3 11.1 197.8 102.7 62.3-87.2-82-92.2c-11-12.4-16.2-27.5-16.2-42.4L340.9 225c40 45 62.8 70.6 68.3 76.9l-14.8 20.8-71.8 100.6 150 77.9c27.3-13.7 46.8-23.4 58.5-29.3l21.5 42.9c-9.9 4.9-33 16.5-69.5 34.7l-10.9 5.5-10.9-5.6-416-216-21.3-11.1 22.1-42.6zM135.3 49.6l18 8.7c6.1-12.1 11.4-22.7 15.9-31.8l28.6 14.3c-4.5 9.1-9.8 19.5-15.7 31.4l84.8 41 .4-.2c82-36.4 126-56 131.9-58.6 4.3 8.6 23 46.1 56.2 112.5 52.3 20.9 85.1 34 98.4 39.4l-23.8 59.4c-11.4-4.6-48-19.2-109.7-43.9l-11.3-4.5c-2.2-4.3-8.7-17.4-19.7-39.4-16.4 9.4-25.9 14.8-28.5 16.3l-7.6-3.7-185.6-89.6c-6.4 12.9-11.9 23.8-16.3 32.6L122.9 119.2 139 86.9c-12.3-5.9-22.9-11.1-32-15.5l13.9-28.8 14.4 7z"]
};
var faSkiing = faPersonSkiing;
var faBridgeWater = {
  prefix: 'fass',
  iconName: 'bridge-water',
  icon: [640, 512, [], "e4ce", "M64.4 64l512 0 0 112c-37.6 9.4-64 43.2-64 82l0 101.4c-33.3-13.3-57.3-22.9-72-28.8l-24 9.6 0-52.2c0-53-43-96-96-96s-96 43-96 96l0 52.2-24-9.6c-14.7 5.9-38.7 15.5-72 28.8l0-101.4c0-38.8-26.4-72.6-64-82l0-112zM209.3 385.7l111.1 44.4 111.1-44.4 8.9-3.6 8.9 3.6 111.8 44.7c29.3-9.7 50.1-16.7 62.4-20.8l15.2 45.5-70.8 23.6-8.3 2.8-8.2-3.3-111.1-44.4-111.1 44.4-8.9 3.6-8.9-3.6-111.1-44.4-111.1 44.4-8.2 3.3-8.3-2.8C36.6 466.7 13 458.8 2 455.2l15.2-45.5c12.4 4.1 33.2 11.1 62.4 20.8l111.8-44.7 8.9-3.6 8.9 3.6z"]
};
var faBuildingNgo = {
  prefix: 'fass',
  iconName: 'building-ngo',
  icon: [576, 512, [], "e4d7", "M448 0l-384 0 0 512 112 0 0-176 272 0 0-336zM160 96l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM160 224l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM520 380c-24.3 0-44 19.7-44 44l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-80c0-24.3-19.7-44-44-44l-16 0zm-4 44c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 80c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80zm-168 0l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-44-48 0 0 40 8 0 0 4c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 8 40 0 0-8c0-24.3-19.7-44-44-44l-16 0c-24.3 0-44 19.7-44 44zM240 380l-20 0 0 168 40 0 0-59.2c15.8 37.2 24.2 56.9 25.2 59.2l38.8 0 0-168-40 0 0 63c-17.1-40.3-26.1-61.3-26.8-63L240 380z"]
};
var faMoped = {
  prefix: 'fass',
  iconName: 'moped',
  icon: [576, 512, [], "e3b9", "M312 32l-24 0 0 48 76 0 26.5 146-82.5 110-84 0 0-144-96 0C57.3 192 0 249.3 0 320l0 64 40.4 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8l116.4 0 7.2-9.6 96-128 6.3-8.4c-.1-.8-3.6-19.8-10.4-57l80.9 27 0-128-93.6 31.2C410 64.9 405.2 38.5 404 32l-92 0zM167.2 384c.5 2.6 .8 5.3 .8 8 0 22.1-17.9 40-40 40s-40-17.9-40-40c0-2.7 .3-5.4 .8-8l78.4 0zM64 112l0 48 160 0 0-48-160 0zM568 392a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zm-88-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faGridRound2 = {
  prefix: 'fass',
  iconName: 'grid-round-2',
  icon: [448, 512, [], "e5db", "M96 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm0 256a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM256 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192z"]
};
var faIgloo = {
  prefix: 'fass',
  iconName: 'igloo',
  icon: [576, 512, [], "f7ae", "M320 33.8l0 126.2-271.5 0c51.7-77.2 139.6-128 239.5-128 10.8 0 21.5 .6 32 1.8zM368 160l0-116.7c66 19 122.2 61 159.5 116.7L368 160zM22.6 208l73.4 0 0 112-96 0c0-39.7 8-77.6 22.6-112zM176 320l-32 0 0-112 288 0 0 112-32 0 0 48 176 0 0 112-576 0 0-112 176 0 0-48zm304 0l0-112 73.4 0C568 242.4 576 280.3 576 320l-96 0zM352 432l0-144-128 0 0 144 128 0z"]
};
var faChessKnightPiece = {
  prefix: 'fass',
  iconName: 'chess-knight-piece',
  icon: [384, 512, ["chess-knight-alt"], "f442", "M208 0c88.4 0 160 71.6 160 160l0 144-64 96 64 64 0 48-352 0 0-48 64-64-16-80 128-96-48 0-12.1 12.1c-12.7 12.7-30 19.9-48 19.9l-4.6 0c-34.9 0-63.2-28.3-63.2-63.2 0-21 8.3-41.1 23.2-55.9L112 64 112 0 208 0zM176 104a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faChessKnightAlt = faChessKnightPiece;
var faHandHoldingMagic = {
  prefix: 'fass',
  iconName: 'hand-holding-magic',
  icon: [576, 512, [], "f6e5", "M176 0l-32 0 0 224 176 0 0-112-64 0 0 48-48 0 0-96 160 0 0 192 64 0 0-256-256 0zM137.4 313.4l-70.6 70.6-66.7 0 0 128 396.4 0 10.2-7c101.2-69.6 154.8-106.4 161-110.7l-45.3-65.9c-11.7 8.1-54.2 37.3-127.5 87.6l-138.8 0 0-48 128 0 0-64-237.3 0-9.4 9.4z"]
};
var faCircleDollarToSlot = {
  prefix: 'fass',
  iconName: 'circle-dollar-to-slot',
  icon: [576, 512, ["donate"], "f4b9", "M96 224a192 192 0 1 1 384 0 192 192 0 1 1 -384 0zM272 112l0 24c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5l-75.5 0 0 40 44 0 0 24 40 0 0-24.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l67.5 0 0-40-28 0 0-24-40 0zM48 344l0 120 480 0 0-144 48 0 0 192-576 0 0-192 48 0 0 24z"]
};
var faDonate = faCircleDollarToSlot;
var faUserTieHairMullet = {
  prefix: 'fass',
  iconName: 'user-tie-hair-mullet',
  icon: [448, 512, [], "e7b9", "M144 144l0-32 64 0 16-48 16 48 64 0 0 32c0 44.2-35.8 80-80 80s-80-35.8-80-80zm208 0l0-32 16 0 0-48-26.8 0C323.2 26.2 284.7 0 240 0L208 0c-44.7 0-83.2 26.2-101.2 64l-26.8 0 0 48 16 0 0 32c0 25.1 7.3 48.6 19.8 68.4L80 272 368 272 332.2 212.4C344.7 192.6 352 169.1 352 144zM272 328l0-24-96 0 0 24 31.4 36.7-31.4 115.3-40-160-56 0-64 192 416 0-64-192-56 0-40 160-.6 0-31-115.1 31.6-36.9z"]
};
var faAwardSimple = {
  prefix: 'fass',
  iconName: 'award-simple',
  icon: [512, 512, [], "e0ab", "M256-40l53.4 32.6 62.6-1.5 30 54.9 54.9 30-1.5 62.6 32.6 53.4-32.6 53.4 1.5 62.6-54.9 30-18 33 0 173-128-64-128 64 0-173-18-33-54.9-30 1.5-62.6-32.6-53.4 32.6-53.4-1.5-62.6 54.9-30 30-54.9 62.6 1.5 53.4-32.6zm0 328a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faConveyorBeltBoxes = {
  prefix: 'fass',
  iconName: 'conveyor-belt-boxes',
  icon: [640, 512, ["conveyor-belt-alt"], "f46f", "M64 0l0 256 256 0 0-256-256 0zM96 320c-53 0-96 43-96 96s43 96 96 96l448 0c53 0 96-43 96-96s-43-96-96-96L96 320zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM576 64l-192 0 0 192 192 0 0-192z"]
};
var faConveyorBeltAlt = faConveyorBeltBoxes;
var faFileSvg = {
  prefix: 'fass',
  iconName: 'file-svg',
  icon: [576, 512, [], "e64b", "M272 0l-240 0 0 512 144 0 0-176 240 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM272 380c-28.7 0-52 23.3-52 52s23.3 52 52 52c6.6 0 12 5.4 12 12s-5.4 12-12 12l-52 0 0 40 52 0c28.7 0 52-23.3 52-52s-23.3-52-52-52c-6.6 0-12-5.4-12-12s5.4-12 12-12l44 0 0-40-44 0zm116 20l0-20-40 0 0 55c0 21.6 3.9 43 11.5 63.2 10.7 28.5 16.9 45.1 18.7 49.8l43.7 0c1.8-4.7 8-21.3 18.7-49.8 7.6-20.2 11.5-41.6 11.5-63.2l0-55-40 0 0 55c0 16.8-3 33.4-8.9 49.2l-3.1 8.2-3.1-8.2C391 468.4 388 451.8 388 435l0-35zm88 24l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-44-48 0 0 40 8 0 0 4c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 8 40 0 0-8c0-24.3-19.7-44-44-44l-16 0c-24.3 0-44 19.7-44 44z"]
};
var faY = {
  prefix: 'fass',
  iconName: 'y',
  icon: [384, 512, [121], "59", "M1.5 32l158.9 264.9 0 183.1 64 0 0-183.1 158.9-264.9-74.6 0-116.3 193.8-116.3-193.8-74.6 0z"]
};
var faFaceSmileWink = {
  prefix: 'fass',
  iconName: 'face-smile-wink',
  icon: [512, 512, [128521, "smile-wink"], "f4da", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-144c38.2 0 72-19.1 92.2-48.5l39.5 27.3C358.9 388.6 310.7 416 256 416s-102.9-27.4-131.8-69.2l39.5-27.3C184 348.9 217.8 368 256 368zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm164 8l0 16-40 0 0-16c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60l0 16-40 0 0-16c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20z"]
};
var faSmileWink = faFaceSmileWink;
var faCircleManat = {
  prefix: 'fass',
  iconName: 'circle-manat',
  icon: [512, 512, [], "e6fb", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM240 104l32 0 0 25.1c58.7 7.8 104 58.1 104 118.9l0 120-48 0 0-120c0-34.3-23.9-62.9-56-70.2l0 190.2-32 0 0-190.2c-32.1 7.3-56 36-56 70.2l0 120-48 0 0-120c0-60.8 45.3-111.1 104-118.9l0-25.1z"]
};
var faDiceFour = {
  prefix: 'fass',
  iconName: 'dice-four',
  icon: [448, 512, [9859], "f524", "M0 32l448 0 0 448-448 0 0-448zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faFileMinus = {
  prefix: 'fass',
  iconName: 'file-minus',
  icon: [384, 512, [], "f318", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM120 304l-24 0 0 48 192 0 0-48-168 0z"]
};
var faArrowLeftToArc = {
  prefix: 'fass',
  iconName: 'arrow-left-to-arc',
  icon: [512, 512, [], "e616", "M64 256C64 150 150 64 256 64l32 0 0-64-32 0C114.6 0 0 114.6 0 256S114.6 512 256 512l32 0 0-64-32 0C150 448 64 362 64 256zM257.4 145.4c-69.6 69.6-106.4 106.4-110.6 110.6 4.2 4.2 41.1 41.1 110.6 110.6l22.6 22.6 45.3-45.3-56-56 242.7 0 0-64-242.7 0c24-24 42.7-42.7 56-56l-45.3-45.3-22.6 22.6z"]
};
var faCarTilt = {
  prefix: 'fass',
  iconName: 'car-tilt',
  icon: [576, 512, [], "f5e5", "M80.8 88.7l21.4-5.7 216.4-58 21.4-5.7 12.9 18 76.5 107.1 34.6-9.3c40 149.4 46.9 175.2 58 216.4l-77.3 20.7-16.6-61.8-278.2 74.5 16.6 61.8-4.8 1.3 414.2 0 0 64-576 0 0-64 84.1 0C70.2 396 44.8 301.3 31.4 251.1l34.6-9.3 12.7-131 2.1-22.1zm232.9 3.8l-173.5 46.5-8.3 85 231.5-62-49.7-69.5zM153.1 334.4a32 32 0 1 0 -16.6-61.8 32 32 0 1 0 16.6 61.8zM423 229A32 32 0 1 0 361.2 245.5 32 32 0 1 0 423 229z"]
};
var faCloudBoltSun = {
  prefix: 'fass',
  iconName: 'cloud-bolt-sun',
  icon: [640, 512, ["thunderstorm-sun"], "f76e", "M284.9-40.8c-4 2.6-29.5 19.6-76.6 50.8-47.1-31.2-72.6-48.2-76.6-50.8-.9 4.7-7 34.7-18.2 90-55.4 11.2-85.4 17.3-90 18.2 2.6 4 19.6 29.5 50.8 76.6-31.2 47.1-48.2 72.6-50.8 76.6 4.8 1 34.5 7 88.9 18 .5-47.2 26.5-88.2 64.9-110 7.3-60.8 57.2-108.5 119.1-112.3-5.6-27.9-9.5-46.9-11.5-57.1zM608.2 320l0-96.1c0-47.6-34.6-87-80-94.6 0-52.8-42.6-97.3-96-97.3-34.9 0-65.4 18.6-82.2 46.4-13-9.1-28.8-14.4-45.8-14.4-44.2 0-80 35.8-80 80l0 17.6c-36.5 7.4-64 39.7-64 78.4l-.1 80.1 92.7 0 161.9-136 78.3 0-32.4 136 147.5 0zM336.7 400l-32.4 136 200-168-104.4 0 32.4-136-200 168 104.4 0z"]
};
var faThunderstormSun = faCloudBoltSun;
var faFaceGrinSquintTears = {
  prefix: 'fass',
  iconName: 'face-grin-squint-tears',
  icon: [576, 512, [129315, "grin-squint-tears"], "f586", "M560 40c0-30.9-25.1-56-56-56S448 9.1 448 40l0 56 56 0c30.9 0 56-25.1 56-56zM400 25.7C304.6-20.7 186.2-4.3 107 75S11.3 272.6 57.7 368l118.3 0 0 118.3c95.4 46.4 213.8 30 293-49.3s95.7-197.6 49.3-293L400 144 400 25.7zM417.8 201c5.8-11.1 21.4-12.4 26.6-1.1 27.5 59.2 16.8 131.8-32 180.6s-121.4 59.5-180.6 32c-11.3-5.3-10-20.8 1.1-26.6 36.4-19.1 72.7-45.6 106-78.9s59.8-69.6 78.9-106zM113.3 252.1l101.6-33.7 9.8-3.2 14.3 14.3-4.2 10.2-39.3 95.9-30.4-9.7 11.7-50.8-56.1 8-7.3-31zm137.2-69.3l33.7-101.6 31 7.3-8 56.1 50.8-11.7 9.7 30.4-95.9 39.3-10.2 4.2-14.3-14.3 3.2-9.8zM72 416c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56l0-56-56 0z"]
};
var faGrinSquintTears = faFaceGrinSquintTears;
var faSnowflakes = {
  prefix: 'fass',
  iconName: 'snowflakes',
  icon: [640, 512, [], "f7cf", "M504-32l0 56 56 0 0 48-56 0 0 56-48 0 0-56-56 0 0-48 56 0 0-56 48 0zM256 64l0 67.7 9.9-9.9 28.3 28.3-38.1 38.1 0 44.3 38.4-22.1 14-52.1 38.6 10.4-3.6 13.5c21.2-12.2 40.7-23.5 58.6-33.9l32 55.4c-17.9 10.4-37.5 21.6-58.6 33.9l13.5 3.6-10.4 38.6-52.1-14-38.4 22.1 38.4 22.1 52.1-14 10.4 38.6-13.5 3.6c21.2 12.2 40.7 23.5 58.6 33.9l-32 55.4c-17.9-10.4-37.5-21.6-58.6-33.9l3.6 13.5-38.6 10.4-14-52.1-38.4-22.1 0 44.3 38.1 38.1-28.3 28.3-9.9-9.9 0 67.7-64 0 0-67.7-9.9 9.9-28.3-28.3 38.1-38.1 0-44.3-38.4 22.1-14 52.1-38.6-10.4 3.6-13.5C83.5 406.1 64 417.4 46 427.7L14 372.3c17.9-10.4 37.5-21.6 58.6-33.9l-13.5-3.6 10.4-38.6 52.1 14 38.4-22.1-38.4-22.1-52.1 14-10.4-38.6 13.5-3.6C51.5 225.4 32 214.1 14 203.7l32-55.4c17.9 10.4 37.5 21.6 58.6 33.9l-3.6-13.5 38.6-10.4 14 52.1 38.3 22.1 0-44.3-38.1-38.1 28.3-28.3 9.9 9.9 0-67.7 64 0zm328 96l0 32 56 0 0 48-56 0 0 56-48 0 0-56-56 0 0-48 56 0 0-56 48 0 0 24z"]
};
var faPretzel = {
  prefix: 'fass',
  iconName: 'pretzel',
  icon: [512, 512, [129384], "e441", "M138.6 32C62.1 32 0 94.1 0 170.6 0 253.3 40.9 326.5 103.7 371 89.9 390.5 75.2 411.5 59.5 433.7l65.4 46c14.4-20.5 31.6-45 51.7-73.5 21.8 6.4 44.9 9.8 68.7 9.8l21.2 0c23.9 0 46.9-3.4 68.7-9.8 20 28.5 37.3 53 51.7 73.4l65.4-46C436.8 411.4 422.1 390.5 408.3 371 471.1 326.5 512 253.3 512 170.6 512 94.1 449.9 32 373.4 32L364 32C321.4 32 283 50 256 78.8 229 50 190.6 32 148 32l-9.4 0zM216 180l0 7.4c0 15.5-4.8 30.7-13.7 43.4l-52.5 74.7c-42.2-30-69.7-79.2-69.7-134.9 0-32.4 26.2-58.6 58.6-58.6l9.4 0c37.6 0 68 30.4 68 68zm40 113.5L285.2 335c-6.1 .7-12.3 1-18.6 1l-21.2 0c-6.3 0-12.5-.3-18.6-1L256 293.5zm53.7-62.6C300.8 218.2 296 203 296 187.4l0-7.4c0-37.6 30.4-68 68-68l9.4 0c32.4 0 58.6 26.2 58.6 58.6 0 55.7-27.5 105-69.7 134.9l-52.5-74.7z"]
};
var faGlass = {
  prefix: 'fass',
  iconName: 'glass',
  icon: [384, 512, [129371], "f804", "M74.2 128l-5-64 245.6 0-5 64-235.6 0zM40 512l304 0 35-448 5-64-384 0 40 512z"]
};
var faTripleChevronsDown = {
  prefix: 'fass',
  iconName: 'triple-chevrons-down',
  icon: [384, 512, [], "e7f7", "M365.5 384l-173.3 173.3-173.2-173.3 45.2-45.3 128 128 128-128 45.3 45.3zm0-192l-173.3 173.3-173.2-173.3 45.2-45.2 128 128 128-128 45.3 45.2zm0-192L192.3 173.2 19 0 64.3-45.2 192.3 82.8 320.3-45.2 365.5 0z"]
};
var faFileAudio = {
  prefix: 'fass',
  iconName: 'file-audio',
  icon: [384, 512, [], "f1c7", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zm0 412.9c62.5-4.1 112-56.2 112-119.7S270.5 236.1 208 232l0 40.1c40.4 4 72 38.1 72 79.6s-31.6 75.6-72 79.6l0 40.1zm0-76.5c20.5-3.8 36-21.7 36-43.3s-15.5-39.5-36-43.3l0 86.5zM104 311.7l-40 0 0 80 40 0 32 40 24 0 0-160-24 0-32 40z"]
};
var faSquareFranc = {
  prefix: 'fass',
  iconName: 'square-franc',
  icon: [448, 512, [], "e72f", "M448 32l-448 0 0 448 448 0 0-448zM160 128l160 0 0 48-112 0 0 40 80 0 0 48-80 0 0 24 48 0 0 32-48 0 0 64-48 0 0-64-32 0 0-32 32 0 0-160z"]
};
var faArrowsDownToLine = {
  prefix: 'fass',
  iconName: 'arrows-down-to-line',
  icon: [512, 512, [], "e4b8", "M150.6 374.6L128 397.3c-8.2-8.2-37.1-37.1-86.6-86.6L18.7 288 64 242.7c17.3 17.3 28 28 32 32L96 0 160 0 160 274.7c4-4 14.7-14.7 32-32L237.3 288c-8.2 8.2-37.1 37.1-86.6 86.6zm256 0L384 397.3 274.7 288 320 242.7c17.3 17.3 28 28 32 32l0-274.7 64 0 0 274.7c4-4 14.7-14.7 32-32l45.3 45.3-86.6 86.6zM32 512l-32 0 0-64 512 0 0 64-480 0z"]
};
var faMobileSlash = {
  prefix: 'fass',
  iconName: 'mobile-slash',
  icon: [576, 512, [], "e815", "M112.1 46l0-46 352 0 0 398 114.1 114.1-33.9 33.9-545.9-545.9 33.9-33.9 79.8 79.8zM442.3 512l-330.2 0 0-330.2 330.2 330.2zM224.1 464l102.3 0-48-48-54.3 0 0 48z"]
};
var faVideoArrowDownLeft = {
  prefix: 'fass',
  iconName: 'video-arrow-down-left',
  icon: [576, 512, [], "e2c8", "M32 64l384 0 0 384-384 0 0-384zM464 341.3l0-170.7 112-74.7 0 320-112-74.7zM264 304l-54.1 0 103-103 17-17-33.9-33.9-17 17-103 103 0-78.1-48 0 0 160 160 0 0-48-24 0z"]
};
var faRightLongToLine = {
  prefix: 'fass',
  iconName: 'right-long-to-line',
  icon: [640, 512, [], "e444", "M320 64l192 192-192 192 0-128-320 0 0-128 320 0 0-128zm320 64l0 288-64 0 0-320 64 0 0 32z"]
};
var faG = {
  prefix: 'fass',
  iconName: 'g',
  icon: [448, 512, [103], "47", "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128l-156.8 0 0-64 224 0 0 32c0 123.7-100.3 224-224 224S0 379.7 0 256 100.3 32 224 32c70.8 0 134 32.9 175 84.1l-50 40C319.6 119.4 274.6 96 224 96z"]
};
var faVihara = {
  prefix: 'fass',
  iconName: 'vihara',
  icon: [576, 512, [], "f6a7", "M288-14l14.4 10.8 153.6 115.2 40 0 0 48-48 0 0 48 58.7 64 37.3 0 0 48-32 0 0 48 24.4 32 39.6 0 0 48-64 0 0 64-64 0 0-64-128 0 0 64-64 0 0-64-128 0 0 64-64 0 0-64-64 0 0-48 46.1 0 17.9-32 0-48-32 0 0-48 37.3 0 58.7-64 0-48-48 0 0-48 40 0 153.6-115.2 14.4-10.8zM128 368l320 0 0-48-320 0 0 48zM384 160l-192 0 0 48 192 0 0-48z"]
};
var faFlagCheckered = {
  prefix: 'fass',
  iconName: 'flag-checkered',
  icon: [448, 512, [127937], "f11e", "M64 0l0 48 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5 43.2 21.6 93.4 23 137.6 4.4 3.2-1.4 6.4-2.8 9.6-4.4l54.4-27.2 0 352-55.5 20.8c-46.2 17.3-97.6 14.6-141.7-7.4-37.9-19-81.4-23.7-122.5-13.4L64 384 64 512 0 512 0 0 64 0zm0 187.1l64-13.9 0 65.5-64 13.9 0 65.5 48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3l0-63.9 38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9 0 66.7-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8l0 71.4c21.8 1.9 43.3 6.7 64 14.4l0-69.8 22.7 6.7c13.5 4 27.3 6.4 41.3 7.4l0-64.2c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12 0-62c-13-3.8-25.8-8.8-38.2-15-8.2-4.1-16.9-7-25.8-8.8l0 72.4c-13-.4-26 .8-38.7 3.6l-25.3 5.5 0-75.2-64 16 0 73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2 0-71.7-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5l0 77.4zm64-149.4l0-70.8c-20.9 6.1-42.4 9.1-64 9.1l0 69.4c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"]
};
var faBriefcaseArrowRight = {
  prefix: 'fass',
  iconName: 'briefcase-arrow-right',
  icon: [512, 512, [], "e2f2", "M144 0l224 0 0 96 144 0 0 384-512 0 0-384 144 0 0-96zM320 48l-128 0 0 48 128 0 0-48zm33 257l17-17c-2.1-2.1-31.8-31.8-89-89l-17-17-33.9 33.9c9 9 25 25 48 48l-126.1 0 0 48 126.1 0c-23 23-39 39-48 48L264 393.9c2.1-2.1 31.8-31.8 89-89z"]
};
var faHeartHalfStroke = {
  prefix: 'fass',
  iconName: 'heart-half-stroke',
  icon: [512, 512, ["heart-half-alt"], "e1ac", "M256 107.8l-17.3-24c-23.6-32.6-61.8-51.9-102-51.9-74.9 0-136.7 60.8-136.7 135.7 0 151.6 255.6 328.1 256 328.3 0 0 256-176.6 256-328.3 0-74.9-61.7-135.7-136.7-135.7-27.9 0-54.8 9.3-76.5 25.8-9.6 7.3-18.2 16.1-25.5 26.1l-17.3 24zm0 109.2l69.2-95.7c11.4-15.8 30.2-25.4 50.2-25.4 40.2 0 72.7 32.7 72.7 71.7 0 20.7-9.1 48-30.1 81-20.4 32.3-48.8 64.8-78.9 94.4-26.2 25.9-54.1 50.1-83.1 72.9l0-199z"]
};
var faHeartHalfAlt = faHeartHalfStroke;
var faCommentCaptions = {
  prefix: 'fass',
  iconName: 'comment-captions',
  icon: [512, 512, [], "e146", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM120 208l-24 0 0 48 176 0 0-48-152 0zm224 0l-24 0 0 48 96 0 0-48-72 0zM120 304l-24 0 0 48 96 0 0-48-72 0zm144 0l-24 0 0 48 176 0 0-48-152 0z"]
};
var faGaugeSimple = {
  prefix: 'fass',
  iconName: 'gauge-simple',
  icon: [512, 512, ["gauge-simple-med", "tachometer-average"], "f629", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm320 96c0-26.9-16.5-49.9-40-59.3l0-196.7-48 0 0 196.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faGaugeSimpleMed = faGaugeSimple;
var faTachometerAverage = faGaugeSimple;
var faShredder = {
  prefix: 'fass',
  iconName: 'shredder',
  icon: [512, 512, [], "f68a", "M368 0l-304 0 0 144 384 0 0-64-80-80zM512 192l-512 0 0 192 64 0 0 128 48 0 0-128 64 0 0 128 48 0 0-128 64 0 0 128 48 0 0-128 64 0 0 128 48 0 0-128 64 0 0-192zM408 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faFonduePot = {
  prefix: 'fass',
  iconName: 'fondue-pot',
  icon: [512, 512, [129749], "e40d", "M392.9 172.4l-13.3-8.9-19 28.5-38.5 0 30.8-46.2-13.3-8.9 91.2-136.9 53.3 35.5-91.2 136.9zM231.5 192l9.2-36.8-15.5-3.9 37.8-151.3 62.1 15.5-37.8 151.3-15.5-3.9-7.3 29.1-33 0zM0 224l64 0 0 96 32 0 0-64 32 0 0 32 32 0 0-64 352 0 0 64-64 0 0 32c0 52.3-25.1 98.8-64 128l0 64-64 0 0-35.2c-10.3 2.1-21 3.2-32 3.2l-128 0c-11 0-21.7-1.1-32-3.2l0 35.2-64 0 0-64C25.1 418.8 0 372.3 0 320l0-96z"]
};
var faRightLeft = {
  prefix: 'fass',
  iconName: 'right-left',
  icon: [512, 512, ["exchange-alt"], "f362", "M512 128l-160-144 0 112-352 0 0 64 352 0 0 112 160-144zM160 528l0-112 352 0 0-64-352 0 0-112-160 144 160 144z"]
};
var faExchangeAlt = faRightLeft;
var faPlanetRinged = {
  prefix: 'fass',
  iconName: 'planet-ringed',
  icon: [576, 512, [129680], "e020", "M63.5 379.1c11.2 20.4 25.5 39.7 42.7 57.1-.5 1-1 2-1.4 3.1 14.2-6.6 30.2-14.9 47.7-25.5-44.4-38.1-72.5-94.7-72.5-157.8 0-114.9 93.1-208 208-208 63.1 0 119.6 28.1 157.8 72.5 10.6-17.6 18.9-33.5 25.5-47.7-1 .5-2 .9-3.1 1.4-17.4-17.2-36.6-31.5-57.1-42.7 33.3-18.3 61.7-29.6 84.4-36.6 13.6-4.2 25.3-6.8 34.7-8.4 19.4-3.3 29.7-2.5 29.7-2.5s.9 10.3-2.5 29.7c-1.6 9.5-4.2 21.1-8.4 34.7-18 59-65.4 155.9-189.1 279.5S139.5 499.1 80.5 517.1c-13.6 4.2-25.3 6.8-34.7 8.4-19.4 3.3-29.7 2.5-29.7 2.5s-.9-10.3 2.5-29.7c1.6-9.5 4.2-21.1 8.4-34.7 6.9-22.7 18.3-51.1 36.6-84.4zM288 464c-3.4 0-6.7-.1-10-.2 35.8-27 74.6-60.5 116-101.8s74.8-80.1 101.8-116c.2 3.3 .2 6.7 .2 10 0 114.9-93.1 208-208 208z"]
};
var faPills = {
  prefix: 'fass',
  iconName: 'pills',
  icon: [512, 512, [], "f484", "M64 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112-96 0 0-112zM176 368c0-48.7 18.1-93.2 48-127l0-129C224 50.1 173.9 0 112 0S0 50.1 0 112L0 400c0 61.9 50.1 112 112 112 37.3 0 70.3-18.2 90.7-46.3-17-28.6-26.7-62-26.7-97.7zm48 0c0 31.1 9.9 59.9 26.6 83.4L451.4 250.6c-23.5-16.8-52.3-26.6-83.4-26.6-79.5 0-144 64.5-144 144zm261.4-83.4L284.6 485.4c23.5 16.8 52.3 26.6 83.4 26.6 79.5 0 144-64.5 144-144 0-31.1-9.9-59.9-26.6-83.4z"]
};
var faExplosion = {
  prefix: 'fass',
  iconName: 'explosion',
  icon: [576, 512, [], "e4e9", "M312-32l-48 0 0 96 48 0 0-96zM144 368l-144-48 82.3 96 115.2 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l115.2 0 82.3-96-144 48 112-368-208 296-24-168-48 0-24 176-144-112 48 176zM24 464l-24 0 0 48 576 0 0-48-552 0z"]
};
var faArrowsDownToPeople = {
  prefix: 'fass',
  iconName: 'arrows-down-to-people',
  icon: [512, 512, [], "e4b9", "M96.4 169.9c-3.5-3.5-30.5-30.5-81-81l-17-17 33.9-33.9 40 40 0-110.1 48 0 0 110.1 40-40 33.9 33.9-81 81-17 17zm320 0c-3.5-3.5-30.5-30.5-81-81l-17-17 33.9-33.9c10.3 10.3 23.6 23.6 40 40l0-110.1 48 0 0 110.1c16.4-16.4 29.7-29.7 40-40L514.4 72c-3.5 3.5-30.5 30.5-81 81l-17 17zM256.4 192a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160c53 0 96 43 96 96l0 64-192 0 0-64c0-53 43-96 96-96zm-224-64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm352 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-304 80c15.3 0 29.6 4.3 41.8 11.8-6.3 16.2-9.8 33.8-9.8 52.2l0 80-112 0 0-64c0-44.2 35.8-80 80-80zm320 144l0-80c0-18.4-3.5-36-9.8-52.2 12.2-7.5 26.5-11.8 41.8-11.8 44.2 0 80 35.8 80 80l0 64-112 0z"]
};
var faUsersViewfinder = {
  prefix: 'fass',
  iconName: 'users-viewfinder',
  icon: [576, 512, [], "e595", "M0 0l0 160 48 0 0-112 112 0 0-48-160 0zM576 0l-160 0 0 48 112 0 0 112 48 0 0-160zM24 512l136 0 0-48-112 0 0-112-48 0 0 160 24 0zm552 0l0-160-48 0 0 112-112 0 0 48 160 0zM352 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-176 0c0-16.8 3.7-32.8 10.4-47.2-3.4-.6-6.8-.8-10.4-.8-35.3 0-64 28.7-64 64s28.7 64 64 64c9.9 0 19.3-2.3 27.7-6.3-17.2-19.7-27.7-45.5-27.7-73.7zm224 80c35.3 0 64-28.7 64-64s-28.7-64-64-64c-3.5 0-7 .3-10.4 .8 6.7 14.3 10.4 30.3 10.4 47.2 0 28.2-10.4 54-27.7 73.7 8.4 4 17.8 6.3 27.7 6.3zM124.7 400l6.3-16.9 35.7-95.1-38.7 0-48 112 44.7 0zm326.5 0l44.7 0-48-112-38.7 0 35.7 95.1 6.3 16.9zM352 272l-128 0-48 128 224 0-48-128z"]
};
var faMusicNote = {
  prefix: 'fass',
  iconName: 'music-note',
  icon: [384, 512, ["music-alt"], "f8cf", "M384-9l0 162c-2.9 .7-45.6 11.4-128 32l0 215c0 53-50.1 96-112 96s-112-43-112-96 50.1-96 112-96c17.2 0 33.5 3.3 48 9.2L192 39 216.2 33C316.3 7.9 372.2-6 384-9z"]
};
var faMusicAlt = faMusicNote;
var faCarOn = {
  prefix: 'fass',
  iconName: 'car-on',
  icon: [512, 512, [], "e4dd", "M280.4-8l0 88-48 0 0-112 48 0 0 24zM122.3 144l268.4 0 7.8 20.8 46.2 123.2 35.8 0 0 224-80 0 0-64-288 0 0 64-80 0 0-224 35.8 0 54-144zm224 64l-179.6 0-30 80 239.6 0-30-80zM128.4 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM56.4-9.9l65 65 17 17-33.9 33.9c-6.1-6.1-27.8-27.8-65-65L22.5 24 56.4-9.9zm383 17l17-17 33.9 33.9c-6.1 6.1-27.8 27.8-65 65l-17 17-33.9-33.9c6.1-6.1 27.8-27.8 65-65z"]
};
var faCircleCamera = {
  prefix: 'fass',
  iconName: 'circle-camera',
  icon: [512, 512, ["camera-circle"], "e103", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM196 160l12-32 96 0 12 32 68 0 0 192-256 0 0-192 68 0zm108 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faCameraCircle = faCircleCamera;
var faSunBright = {
  prefix: 'fass',
  iconName: 'sun-bright',
  icon: [512, 512, ["sun-alt"], "e28f", "M232 488l0 24 48 0 0-104-48 0 0 80zm0-408l0 24 48 0 0-104-48 0 0 80zM92 58L58 92c7.5 7.5 26.4 26.4 56.6 56.6l17 17 33.9-33.9c-7.5-7.5-26.4-26.4-56.6-56.6L92 58zM380.5 346.5l-33.9 33.9 73.5 73.5 33.9-33.9-73.5-73.5zM0 232l0 48 104 0 0-48-104 0zm408 0l0 48 104 0 0-48-104 0zM58 420L92 454c7.5-7.5 26.4-26.4 56.6-56.6l17-17-33.9-33.9c-7.5 7.5-26.4 26.4-56.6 56.6L58 420zM346.5 131.5l33.9 33.9c7.5-7.5 26.4-26.4 56.6-56.6L454 91.9 420 58c-7.5 7.5-26.4 26.4-56.6 56.6l-17 17zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
var faSunAlt = faSunBright;
var faBatteryBolt = {
  prefix: 'fass',
  iconName: 'battery-bolt',
  icon: [640, 512, [], "f376", "M160 280l256-248-64.5 200 128.5 0-256 248 64.5-200-128.5 0zM96 64l218 0-66.1 64-151.9 0 0 256 108.5 0-20.6 64-151.9 0 0-384 64 0zM544 384l0-256-108.5 0 20.6-64 151.9 0 0 128 32 0 0 128-32 0 0 128-282 0 66.1-64 151.9 0z"]
};
var faMushroom = {
  prefix: 'fass',
  iconName: 'mushroom',
  icon: [512, 512, [127812], "e425", "M256 0C397.4 0 512 114.6 512 256l0 64-512 0 0-64C0 114.6 114.6 0 256 0zM182.4 368l147.2 0 22.4 112-192 0 22.4-112zM128 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM256 48c-41.6 0-80.3 12.2-112.8 33.2 12.6 27.6 40.5 46.8 72.8 46.8 42.9 0 77.9-33.8 79.9-76.2-12.9-2.5-26.3-3.8-39.9-3.8z"]
};
var faGlobeWifi = {
  prefix: 'fass',
  iconName: 'globe-wifi',
  icon: [640, 512, [], "e685", "M304 400c0 27.1 5.6 52.8 15.7 76.2-7 10.2-13.8 18.5-20.1 24.8-5.4 5.4-9.3 8.2-11.6 9.7-2.3-1.5-6.2-4.3-11.6-9.7-11.7-11.7-25.3-30.4-38.3-55.4-23-44.3-41.5-103.2-45.3-165.5l153.4 0C319.8 312.9 304 354.6 304 400zM192.8 232c3.9-62.3 22.3-121.2 45.3-165.5 13-25 26.6-43.7 38.3-55.4 5.4-5.4 9.3-8.2 11.6-9.7 2.3 1.5 6.2 4.3 11.6 9.7 11.7 11.7 25.3 30.4 38.3 55.4 23 44.3 41.5 103.2 45.3 165.5l-190.5 0zm-48.1 0L33.1 232c9.8-105.6 83.7-192.5 182.4-221.6-35.2 52.1-66 133.6-70.9 221.6zM33.1 280l111.6 0c4.9 88 35.7 169.5 70.9 221.6-98.7-29.1-172.6-116-182.4-221.6zM496 208c-23 0-45.1 4.1-65.5 11.5-7-83.2-36.5-159.4-70-209.1 92.8 27.3 163.7 105.8 180 202.8-14.3-3.4-29.1-5.2-44.4-5.2zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm256.5-20.4C584.1 343.6 542.8 320 496 320s-88.1 23.6-112.5 59.6l25.6 19.2C427.7 370.6 459.7 352 496 352s68.3 18.6 86.9 46.8l25.6-19.2zM496 384c-26.2 0-49.4 12.6-64 32l25.6 19.2c8.8-11.7 22.7-19.2 38.4-19.2s29.6 7.5 38.4 19.2L560 416c-14.6-19.4-37.8-32-64-32zm0 100a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
var faArrowRotateLeft10 = {
  prefix: 'fass',
  iconName: 'arrow-rotate-left-10',
  icon: [512, 512, [], "e836", "M64 86.7C110.9 33.6 179.5 0 256 0 397.4 0 512 114.6 512 256S397.4 512 256 512C155.9 512 69.2 454.5 27.2 370.9 46.3 361.3 65.3 351.7 84.3 342.2 116 405 181 448 256 448 362 448 448 362 448 256S362 64 256 64c-69.8 0-130.9 37.2-164.6 93.1l-.1 .2-.1 .2-32 51.4-59.2-16.9 0-192 64 0 0 86.7zM208 352l-48 0 0-129.2-18.7 9.4-21.5-42.9c11.7-5.9 31.2-15.6 58.5-29.3l29.7 0 0 192zM312 160c30.9 0 56 25.1 56 56l0 80c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-80c0-30.9 25.1-56 56-56l16 0zm-16 48c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0z"]
};
var faSleigh = {
  prefix: 'fass',
  iconName: 'sleigh',
  icon: [640, 512, [], "f7cc", "M64 32l-32 0 0 64 32 0 0 160c0 41.8 26.7 77.4 64 90.5l0 69.5-96 0 0 48 528 0c44.2 0 80-35.8 80-80l0-32-48 0 0 32c0 17.7-14.3 32-32 32l-80 0 0-64c53 0 96-43 96-96l0-96 32 0 0-64-96 0 0 128-192 0-96-192-160 0zM432 416l-256 0 0-64 256 0 0 64z"]
};
var faArrowDownLeftAndArrowUpRightToCenter = {
  prefix: 'fass',
  iconName: 'arrow-down-left-and-arrow-up-right-to-center',
  icon: [512, 512, [], "e092", "M381.4 176l121.4-121.4-45.3-45.3-121.4 121.4 0-82.7-64 0 0 192 192 0 0-64-82.7 0zM80.1 272l-32 0 0 64 82.7 0-121.4 121.4 45.3 45.3 121.4-121.4 0 82.7 64 0 0-192-160 0z"]
};
var faPersonSwimmingWater = {
  prefix: 'fass',
  iconName: 'person-swimming-water',
  icon: [640, 512, [], "e78b", "M552.4 120a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM294.2 166.4l-84.1 72.1 17 6.8 93.1 37.2c92.7-37.1 144.2-57.7 154.3-61.7l-3.5-3.5-80-80-4.9-4.9-6.5-2.4-128-48-14.5-5.4-13.2 7.9C161.8 121.8 126 143.3 116.5 149l32.9 54.9c11.7-7 43.1-25.9 94.2-56.5l50.7 19zM200.4 286.2l-8.9 3.6-111.8 44.7c-29.3-9.7-50.1-16.7-62.4-20.8L2 359.2c11 3.7 34.6 11.5 70.8 23.6l8.3 2.8 8.2-3.3 111.1-44.4 111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4 111.1 44.4 8.2 3.3 8.3-2.8c36.2-12.1 59.8-19.9 70.8-23.6l-15.2-45.5c-12.4 4.1-33.2 11.1-62.4 20.8l-111.8-44.7-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4-8.9-3.6zm8.9 99.6l-8.9-3.6-8.9 3.6-111.8 44.7c-29.3-9.8-50.1-16.7-62.4-20.8L2 455.2c11 3.7 34.6 11.5 70.8 23.6l8.3 2.8 8.2-3.3 111.1-44.4 111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4 111.1 44.4 8.2 3.3 8.3-2.8c36.2-12.1 59.8-19.9 70.8-23.6l-15.2-45.5c-12.4 4.1-33.2 11.1-62.4 20.8l-111.8-44.7-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4z"]
};
var faDialHigh = {
  prefix: 'fass',
  iconName: 'dial-high',
  icon: [576, 512, [], "e15c", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64-64 0 0-64zM288.4 127.6c80.2 0 146.6 59 158.2 136l-182.2 0 0 48 182.2 0c-11.6 77-78 136-158.2 136-88.4 0-160-71.6-160-160s71.6-160 160-160z"]
};
var faDumbbell = {
  prefix: 'fass',
  iconName: 'dumbbell',
  icon: [640, 512, [], "f44b", "M96 64l96 0 0 160 256 0 0-160 96 0 0 64 64 0 0 96 32 0 0 64-32 0 0 96-64 0 0 64-96 0 0-160-256 0 0 160-96 0 0-64-64 0 0-96-32 0 0-64 32 0 0-96 64 0 0-64z"]
};
var faBabyCarriage = {
  prefix: 'fass',
  iconName: 'baby-carriage',
  icon: [512, 512, ["carriage-baby"], "f77d", "M64 208l0 176 384 0 0-208 64 0 0-48-112 0 0 80-336 0zm.2-48l223.8 0 0-160-56 0C141.9 0 68.4 70.9 64.2 160zM160 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm288 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faCarriageBaby = faBabyCarriage;
var faClouds = {
  prefix: 'fass',
  iconName: 'clouds',
  icon: [576, 512, [], "f744", "M416 160c-14 0-27.4 2.2-40 6.4-27.9-23.9-64.3-38.4-104-38.4-84.4 0-153.6 65.4-159.6 148.4-5.6 3.5-11 7.4-16 11.6L0 288 0 192c0-53 43-96 96-96l1.1 0c7.8-54.3 54.4-96 110.9-96 47.9 0 88.8 30.1 104.8 72.4 12-5.4 25.2-8.4 39.2-8.4 53 0 96 43 96 96 0 1.3 0 2.7-.1 4-10.2-2.6-20.9-4-31.9-4zM184 480l-88 0 0-88c0-40.3 27.1-74.2 64-84.7l0-19.3c0-61.9 50.1-112 112-112 39 0 73.3 19.9 93.3 50.1 13.8-11.3 31.4-18.1 50.7-18.1 44.2 0 80 35.8 80 80 0 .4 0 .9 0 1.3 45.4 7.6 80 47.1 80 94.7l0 96-392 0z"]
};
var faCameraCctv = {
  prefix: 'fass',
  iconName: 'camera-cctv',
  icon: [576, 512, ["cctv"], "f8ac", "M533 143.8l-436-158.7-98.5 270.6 153.8 56 0 8.3 0 104-72 0 0-48-48 0 0 144 48 0 0-48 120 0c0-.2 0-47.8 0-142.8L284.2 359.7 533 143.8zm-53.4 287l65.7-180.4-43.6-15.9-165.9 143.9 143.9 52.4z"]
};
var faCctv = faCameraCctv;
var faBuildings = {
  prefix: 'fass',
  iconName: 'buildings',
  icon: [512, 512, [], "e0cc", "M512 0l-320 0 0 128-192 0 0 384 512 0 0-512zM96 320l64 0 0 64-64 0 0-64zm224 32l-64 0 0-64 64 0 0 64zm64 0l0-64 64 0 0 64-64 0zM160 224l0 64-64 0 0-64 64 0zM256 96l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM256 256l0-64 64 0 0 64-64 0zm192 0l-64 0 0-64 64 0 0 64z"]
};
var faRectangleBarcode = {
  prefix: 'fass',
  iconName: 'rectangle-barcode',
  icon: [512, 512, ["barcode-alt"], "f463", "M512 64l-512 0 0 384 512 0 0-384zM144 160l0 192-48 0 0-192 48 0zm32 0l32 0 0 192-32 0 0-192zm128 0l0 192-48 0 0-192 48 0zm16 0l32 0 0 192-32 0 0-192zm96 0l0 192-32 0 0-192 32 0z"]
};
var faBarcodeAlt = faRectangleBarcode;
var faTruckFire = {
  prefix: 'fass',
  iconName: 'truck-fire',
  icon: [576, 512, [], "e65a", "M0 0l0 48 32 0 0 80-32 0 0 112 304 0 0-192 272 0 0-48-576 0zM0 288l0 160 67.3 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l102.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l67.3 0 0-320-96 0 0-32-64 0 0 32-64 0 0 160-352 0zM256 128l-64 0 0-80 64 0 0 80zM80 48l64 0 0 80-64 0 0-80zM416 288l0-96 96 0 0 96-96 0zM152 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm232 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faArrowDownBigSmall = {
  prefix: 'fass',
  iconName: 'arrow-down-big-small',
  icon: [512, 512, ["sort-size-down"], "f88c", "M288 32l224 0 0 224-224 0 0-224zm0 288l160 0 0 160-160 0 0-160zM150.6 470.6L128 493.3c-5.5-5.5-39.7-39.7-102.6-102.6L2.7 368 48 322.7c14.6 14.6 30.6 30.6 48 48l0-338.7 64 0 0 338.7c17.4-17.4 33.4-33.4 48-48L253.3 368c-5.5 5.5-39.7 39.7-102.6 102.6z"]
};
var faSortSizeDown = faArrowDownBigSmall;
var faHandLove = {
  prefix: 'fass',
  iconName: 'hand-love',
  icon: [512, 512, [], "e1a5", "M192.1 0l0 352 224 0 0-288 64 0 0 272c0 97.2-78.8 176-176 176l-19.2 0c-59.6 0-116.9-22.9-160-64-75.6-72-117.4-111.8-125.4-119.5l55.2-57.9c16.7 15.9 41.2 39.3 73.5 70 0-1.5-.1-3.1-.1-4.6l0-336 64 0zm32 160l64 0 0 160-64 0 0-160zm160 32l0 128-64 0 0-128 64 0z"]
};
var faBagShoppingMinus = {
  prefix: 'fass',
  iconName: 'bag-shopping-minus',
  icon: [448, 512, [], "e650", "M224 16c-35.3 0-64 28.7-64 64l0 48 128 0 0-48c0-35.3-28.7-64-64-64zM0 128l112 0 0-48c0-61.9 50.1-112 112-112S336 18.1 336 80l0 48 112 0 0 352-448 0 0-352zM152 284l-20 0 0 40 184 0 0-40-164 0z"]
};
var faClockElevenThirty = {
  prefix: 'fass',
  iconName: 'clock-eleven-thirty',
  icon: [512, 512, [], "e348", "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM232 392l0-128.7c-47.7-71.6-72.2-108.3-73.3-109.9l39.9-26.6c.4 .6 26.2 39.3 77.3 116l4 6 0 167.3-48 0 0-24z"]
};
var faSlashForward = {
  prefix: 'fass',
  iconName: 'slash-forward',
  icon: [384, 512, [], "2f", "M363.8 20.1l-15.9 27.8-256 448-15.9 27.8-55.6-31.8 15.9-27.8 256-448 15.9-27.8 55.6 31.8z"]
};
var faPineapple = {
  prefix: 'fass',
  iconName: 'pineapple',
  icon: [512, 512, [], "e31f", "M512 96l-40 40 24 24-57.1 22.9 9.1 9.1 0 128-192 192-128 0-128-128 0-128 192-192 128 0 9.1 9.1 22.9-57.1 24 24 40-40 10 30 70-14-14 70 30 10zM176 201.4L153.4 224c4.1 4.1 18.5 18.5 43.3 43.3L208 278.6c4.1-4.1 18.5-18.5 43.3-43.3L262.6 224 240 201.4c-6 6-16.6 16.6-32 32-15.4-15.4-26-26-32-32zm-80 80L73.4 304c4.1 4.1 18.5 18.5 43.3 43.3L128 358.6c4.1-4.1 18.5-18.5 43.3-43.3L182.6 304 160 281.4c-6 6-16.6 16.6-32 32-15.4-15.4-26-26-32-32zm160 0L233.4 304c4.1 4.1 18.5 18.5 43.3 43.3L288 358.6c4.1-4.1 18.5-18.5 43.3-43.3L342.6 304 320 281.4c-6 6-16.6 16.6-32 32-15.3-15.4-26-26-32-32zm-80 80L153.4 384c4.1 4.1 18.5 18.5 43.3 43.3L208 438.6c4.1-4.1 18.5-18.5 43.3-43.3L262.6 384 240 361.4c-6 6-16.6 16.6-32 32-15.4-15.4-26-26-32-32z"]
};
var faFacePersevering = {
  prefix: 'fass',
  iconName: 'face-persevering',
  icon: [512, 512, [], "e385", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-63.7-89.6l-42.4-22.5C170 361.9 210 336 256 336s86 25.9 106.1 63.9l-42.4 22.5C307.6 399.5 283.6 384 256 384s-51.6 15.5-63.7 38.4zm36-310.4c-10.6 10.6-17.7 17.7-21.5 21.5-24.2 24.2-55.3 40.2-89 45.8l-2.5 .4-19.7 3.3-6.6-39.5 19.7-3.3 2.5-.4c25.5-4.2 49-16.4 67.3-34.6L200 83.7 228.3 112zm69.6 14.1L283.7 112 312 83.7c10.6 10.6 17.7 17.7 21.5 21.5 18.3 18.3 41.8 30.4 67.3 34.6l2.5 .4 19.7 3.3-6.6 39.5-19.7-3.3-2.5-.4c-33.7-5.6-64.8-21.6-89-45.8l-7.4-7.4zM135.2 209.7l95.6 48 9.2 4.6 0 20.2-10.2 4.3-95.6 40-14.7-28.3 44.2-27.6-45.3-34 16.8-27.1zm146 48l95.6-48 16.8 27.1-45.3 34 44.2 27.6-14.7 28.3-95.6-40-10.2-4.3 0-20.2 9.2-4.6z"]
};
var faCardDiamond = {
  prefix: 'fass',
  iconName: 'card-diamond',
  icon: [384, 512, [], "e3ea", "M384 0L0 0 0 512 384 512 384 0zM80 256L192 144 304 256 192 368 80 256z"]
};
var faRaccoon = {
  prefix: 'fass',
  iconName: 'raccoon',
  icon: [512, 512, [], "e613", "M288.4 0l-.4 .5 0-.5-73.9 0c-1 2-7.8 15.6-20.4 40.8l-3 5.9 2.1 6.3 15.3 45.8-28.5 35.1-3.6 4.4 0 57.6 11.4 3.4 77.7 23.3 46 30.7 4 2.7 41.7 0 4-2.7 46-30.7 77.7-23.3 11.4-3.4 0-57.6-3.6-4.4-28.5-35.1 15.3-45.8 2.1-6.3-3-5.9C465.7 15.7 458.9 2 457.9 0l-73.9 0 0 .5-.4-.5-95.2 0zm19 32l57.2 0c1.3 0 2.6 .1 3.9 .2l49.2 60.5-31.5-7.3c-20.2-4.7-39.7 4.2-50.2 19.9-10.5-15.7-30.1-24.6-50.2-19.9l-31.5 7.3 49.2-60.5c1.3-.1 2.6-.2 3.9-.2zm45.4 141.5l38.6 21-.2 .1-31.1 20.8c-.3-13-10.9-23.4-24-23.4s-23.7 10.4-24 23.4l-31.1-20.8-.2-.1 38.6-21c6.9-3.8 12.6-9.1 16.8-15.3 4.2 6.3 9.9 11.6 16.8 15.3zM288 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM182.4 231.2C130.1 269 96 330.5 96 400l0 16-32 0 0-16c0-16.4 1.7-32.5 4.8-48L0 352 0 400c0 61.9 50.1 112 112 112l208 0 0-16c0-26.5-21.5-48-48-48l-48 0 0-32 48 0c44.2 0 80 35.8 80 80l0 16 128 0 0-16.4c-.2-26.3-21.6-47.6-48-47.6l-16 0 0-72-19.2 14.4-19.2-25.6c1.1-.8 24.5-18.4 70.4-52.8l0-9.3c0-19.7-7.2-38.5-20.1-53l-7.3 2.2c-33 22-51.1 34-54.1 36.1l-61.1 0c-3.1-2-21.1-14.1-54.1-36.1l-68.9-20.7zM0 128l128 0 0-96-128 0 0 96zm0 32l0 64 128 0 0-64-128 0zM0 320l77.7 0c8.2-23.2 19.8-44.7 34.3-64L0 256 0 320zm480-24l-.2-.6 0 .7 .2-.2zM326 362.5l-16.5 27.4-13.7-8.2-80-48-13.7-8.2 16.5-27.4 13.7 8.2 80 48 13.7 8.2z"]
};
var faFolderBookmark = {
  prefix: 'fass',
  iconName: 'folder-bookmark',
  icon: [512, 512, [], "e186", "M512 448l-512 0 0-416 224 0 64 48 224 0 0 368zM288 144l0 192 80-56 80 56 0-192-160 0z"]
};
var faKeySkeletonLeftRight = {
  prefix: 'fass',
  iconName: 'key-skeleton-left-right',
  icon: [640, 512, [], "e3b4", "M448 128a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm-60 32c14.2 55.2 64.3 96 124 96 70.7 0 128-57.3 128-128S582.7 0 512 0C452.4 0 402.2 40.8 388 96L160 96c0 16 0 48 0 96l0 32 64 0 0-64 32 0 0 64 64 0 0-64 68 0zM192 384a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm60-32c-14.2-55.2-64.3-96-124-96-70.7 0-128 57.3-128 128S57.3 512 128 512c59.6 0 109.8-40.8 124-96l228 0c0-16 0-48 0-96l0-32-64 0c0 21.3 0 42.7 0 64l-32 0 0-64-64 0 0 64-68 0z"]
};
var faCircleI = {
  prefix: 'fass',
  iconName: 'circle-i',
  icon: [512, 512, [], "e111", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM184 144l168 0 0 48-72 0 0 128 72 0 0 48-192 0 0-48 72 0 0-128-72 0 0-48 24 0z"]
};
var faKiwiBird = {
  prefix: 'fass',
  iconName: 'kiwi-bird',
  icon: [576, 512, [], "f535", "M208 415.3c-5.3 .4-10.6 .7-16 .7-16.6 0-32.7-2.1-48-6l0 70-48 0 0-89.7C38.6 357.1 0 295.1 0 224 0 118 86 32 192 32 248.9 32 300 56.7 335.1 96L448 96c70.7 0 128 57.3 128 128l0 256-112-128-128.9 0c-21.3 23.8-48.4 42.2-79.1 53.1l0 74.9-48 0 0-64.7zM448 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCalendarXmark = {
  prefix: 'fass',
  iconName: 'calendar-xmark',
  icon: [448, 512, ["calendar-times"], "f273", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0zM308.9 237.1l-33.9-33.9c-8.5 8.5-25.5 25.5-50.9 50.9-25.5-25.5-42.4-42.4-50.9-50.9l-33.9 33.9c8.5 8.5 25.5 25.5 50.9 50.9-25.5 25.5-42.4 42.4-50.9 50.9l33.9 33.9c8.5-8.5 25.5-25.5 50.9-50.9 25.5 25.5 42.4 42.4 50.9 50.9l33.9-33.9c-8.5-8.5-25.5-25.5-50.9-50.9 25.5-25.5 42.4-42.4 50.9-50.9z"]
};
var faCalendarTimes = faCalendarXmark;
var faCircleDown = {
  prefix: 'fass',
  iconName: 'circle-down',
  icon: [512, 512, [61466, "arrow-alt-circle-down"], "f358", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM128 256l0 8 128 128 128-128 0-8-80 0 0-128-96 0 0 128-80 0z"]
};
var faArrowAltCircleDown = faCircleDown;
var faFileMedical = {
  prefix: 'fass',
  iconName: 'file-medical',
  icon: [384, 512, [], "f477", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM160 264l0 56-56 0 0 64 56 0 0 56 64 0 0-56 56 0 0-64-56 0 0-56-64 0z"]
};
var faXmark = {
  prefix: 'fass',
  iconName: 'xmark',
  icon: [448, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M86.9 73.4L64.3 50.7 19 96 41.6 118.6 179 256 41.6 393.4 19 416 64.3 461.3 86.9 438.6 224.3 301.3 361.6 438.6 384.3 461.3 429.5 416 406.9 393.4 269.5 256 406.9 118.6 429.5 96 384.3 50.7 361.6 73.4 224.3 210.7 86.9 73.4z"]
};
var faClose = faXmark;
var faMultiply = faXmark;
var faRemove = faXmark;
var faTimes = faXmark;
var faShapes = {
  prefix: 'fass',
  iconName: 'shapes',
  icon: [512, 512, ["triangle-circle-square"], "f61f", "M112 224l144-240 144 240-288 0zM16 384a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm272-96l192 0 0 192-192 0 0-192z"]
};
var faTriangleCircleSquare = faShapes;
var faDiceOne = {
  prefix: 'fass',
  iconName: 'dice-one',
  icon: [448, 512, [9856], "f525", "M448 32l-448 0 0 448 448 0 0-448zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faKnifeKitchen = {
  prefix: 'fass',
  iconName: 'knife-kitchen',
  icon: [576, 512, [128298], "f6f5", "M480 0L568 88 448 208 448 272 392.5 315.2 278.6 201.4 480 0zM448 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm40-40a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM0 480L256 224 400 368S272 512 112 512C48 512 0 480 0 480z"]
};
var faArrowsCross = {
  prefix: 'fass',
  iconName: 'arrows-cross',
  icon: [512, 512, [], "e0a2", "M86.9 41.4L64.3 18.7 19 64 41.6 86.6 177.1 222.1 222.3 176.8 86.9 41.4zM371 416l-82.7 0 0 64 192 0 0-192-64 0 0 82.7-80.8-80.8-45.3 45.3 80.8 80.8zM320.3 32l-32 0 0 64 82.7 0-329.4 329.4-22.6 22.6 45.3 45.3 22.6-22.6 329.4-329.4 0 82.7 64 0 0-192-160 0z"]
};
var faCompassSlash = {
  prefix: 'fass',
  iconName: 'compass-slash',
  icon: [576, 512, [], "f5e9", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-1.5-1.5-32.5-32.5-92.9-92.9 36.7-44.3 58.8-101.2 58.8-163.2 0-141.4-114.6-256-256-256-62 0-118.9 22.1-163.2 58.8L49.3-16.9zM242.7 176.6L416.1 128 367.6 301.4 242.7 176.6zM160.1 384L193.9 263.5 63.5 133.2c-20 36.5-31.3 78.3-31.3 122.8 0 141.4 114.6 256 256 256 44.5 0 86.4-11.4 122.8-31.3L280.6 350.3 160.1 384z"]
};
var faLockOpen = {
  prefix: 'fass',
  iconName: 'lock-open',
  icon: [576, 512, [], "f3c1", "M384 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64 64 0 0-64c0-70.7-57.3-128-128-128S320 25.3 320 96l0 64-224 0 0 352 384 0 0-352-96 0 0-64z"]
};
var faPepperHot = {
  prefix: 'fass',
  iconName: 'pepper-hot',
  icon: [576, 512, [127798], "f816", "M545.4 65L513.3 97.1c19.6 26.5 31.2 59.4 31.2 94.9 0 52.3-25.1 98.8-64 128l0-96-128 0 0-128-96 0c29.2-38.9 75.7-64 128-64 35.5 0 68.3 11.6 94.9 31.2 24-23.9 40.3-40.3 49.1-49.1l33.9 33.9-17 17zm-281 79l40 0 0 128 128 0 0 40-157.4 110.2C221.3 459.8 157.2 480 91.6 480l-75.1 0 0-96 55 0c15.7 0 30.3-7.6 39.3-20.5L264.4 144z"]
};
var faDropletSlash = {
  prefix: 'fass',
  iconName: 'droplet-slash',
  icon: [576, 512, ["tint-slash"], "f5c7", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-97.5-97.5c10.5-23.7 16.3-50 16.3-77.6 0-106-192-352-192-352S234.3 36.9 183.7 117.5L49.3-16.9zm84.9 220.7c-22.4 44.1-38 85.8-38 116.1 0 106 86 192 192 192 43.4 0 83.4-14.4 115.5-38.6L134.2 203.9z"]
};
var faTintSlash = faDropletSlash;
var faDroplet = {
  prefix: 'fass',
  iconName: 'droplet',
  icon: [384, 512, [128167, "tint"], "f043", "M192 512C86 512 0 426 0 320S192-32 192-32 384 214 384 320 298 512 192 512zM64 312c0 75.1 60.9 136 136 136l0-48c-48.6 0-88-39.4-88-88l-48 0z"]
};
var faTint = faDroplet;
var faPersonMeditating = {
  prefix: 'fass',
  iconName: 'person-meditating',
  icon: [448, 512, [], "e7e1", "M416 480l-384 0 0-96 192 38.4 192-38.4 0 96zM296.6 187.5l70.4 84.5 81 0 0 64-111 0c-4.1-4.9-15.1-18.1-33-39.6l0 69.2-80 16-80-16 0-69.2c-17.9 21.5-28.9 34.7-33 39.6l-111 0 0-64 81 0 70.4-84.5 9.6-11.5 126 0 9.6 11.5zM224 128a56 56 0 1 1 0-112 56 56 0 1 1 0 112z"]
};
var faFileLines = {
  prefix: 'fass',
  iconName: 'file-lines',
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM120 256l-24 0 0 48 192 0 0-48-168 0zm0 96l-24 0 0 48 192 0 0-48-168 0z"]
};
var faFileAlt = faFileLines;
var faFileText = faFileLines;
var faCommentsDollar = {
  prefix: 'fass',
  iconName: 'comments-dollar',
  icon: [576, 512, [], "f653", "M192 320c106 0 192-78.8 192-176S298-32 192-32 0 46.8 0 144c0 37.9 13.1 73.1 35.4 101.8L0 352 127 309.7c20.3 6.7 42.2 10.3 65 10.3zm3.2 48c16.4 81.9 94.7 144 188.8 144 27 0 52.8-5.1 76.1-14.4L576 544 540.6 437.8c22.3-28.7 35.4-63.9 35.4-101.8 0-82.4-61.7-151.5-145-170.7-11.5 115.8-115.8 201.2-235.8 202.7zM216 32l0 24 28 0 0 40-67.5 0c-6.9 0-12.5 5.6-12.5 12.5 0 6.1 4.4 11.3 10.4 12.3l41.7 7c25.3 4.2 43.9 26.1 43.9 51.8 0 26.1-19 47.7-44 51.8l0 24.7-40 0 0-24-44 0 0-40 75.5 0c6.9 0 12.5-5.6 12.5-12.5 0-6.1-4.4-11.3-10.4-12.3l-41.7-7c-25.3-4.2-43.9-26.1-43.9-51.8 0-28.8 23.2-52.2 52-52.5l0-24 40 0z"]
};
var faPersonGolfing = {
  prefix: 'fass',
  iconName: 'person-golfing',
  icon: [512, 512, [], "e786", "M72.3-32L55-32c-1.9 5.7-9 27.2-21.5 64.4L23 64 105.6 64c2.8-8.4 8.1-24.4 16-48l202.9 0 49.5 98.9c-93 51.7-141.5 78.6-145.5 80.9 4.4 7.6 27.8 48.6 70.3 122.9l-106.4 159.5-17.8 26.6 53.3 35.5 17.8-26.6 103.4-155c-8.9 106.9-13.5 162.4-13.9 166.5l63.8 5.3 2.7-31.9 13.5-161.7c1.2-14.2-.8-28.4-5.8-41.7L369.9 190.4c47.2-26.2 76.8-42.6 88.7-49.3-3.3-6.6-24.1-48.3-62.5-125.1l4.2 0 0-48-328 0zm240 128a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
};
var faTrashCheck = {
  prefix: 'fass',
  iconName: 'trash-check',
  icon: [448, 512, [], "e2af", "M392 512l-336 0-24-368 384 0-24 368zM281.4 233.9L195.8 351.6c-19.3-20-33.7-34.9-43.2-44.7l-34.5 33.3c6.2 6.4 27.2 28.1 63.1 65.3l19.8 20.6 16.8-23.1 102.4-140.8 14.1-19.4-38.8-28.2-14.1 19.4zM320 32l128 0 0 64-448 0 0-64 128 0 16-48 160 0 16 48z"]
};
var faMagnifyingGlassLocation = {
  prefix: 'fass',
  iconName: 'magnifying-glass-location',
  icon: [576, 512, ["search-location"], "f689", "M448.3 208c0 45.9-14.9 88.3-40 122.7L534.9 457.4 557.5 480 512.3 525.3 489.6 502.6 363 376c-34.4 25.2-76.8 40-122.7 40-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208zm-128-32c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 64 80 144 80 144s80-80 80-144zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSearchLocation = faMagnifyingGlassLocation;
var faFloppyDiskCircleArrowRight = {
  prefix: 'fass',
  iconName: 'floppy-disk-circle-arrow-right',
  icon: [576, 512, ["save-circle-arrow-right"], "e180", "M64 32l-32 0 0 448 225.4 0c-9.3-20.3-15.2-42.5-16.9-65.9-27.9-6.9-48.5-32.1-48.5-62.1 0-35.3 28.7-64 64-64 6.3 0 12.4 .9 18.2 2.6 34.7-49.9 92.4-82.6 157.8-82.6 16.6 0 32.7 2.1 48 6l0-67.3-105.4-105.4-9.4-9.4-301.3 0zm64 64l224 0 0 128-224 0 0-128zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM440 321.4l11.3 11.3 56 56 11.3 11.3-11.3 11.3-56 56-11.3 11.3-22.6-22.6c4.6-4.6 18-18 40-40l-105.4 0 0-32 105.4 0c-22-22-35.4-35.4-40-40L440 321.4z"]
};
var faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
var faMagnifyingGlassPlay = {
  prefix: 'fass',
  iconName: 'magnifying-glass-play',
  icon: [576, 512, [], "e660", "M448.3 208c0 45.9-14.9 88.3-40 122.7L534.9 457.4 557.5 480 512.3 525.3 489.6 502.6 363 376c-34.4 25.2-76.8 40-122.7 40-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208zM178.7 304l163.2-96-163.2-96 0 192z"]
};
var faFileInvoice = {
  prefix: 'fass',
  iconName: 'file-invoice',
  icon: [384, 512, [], "f570", "M240 0L0 0 0 512 384 512 384 144 240 0zm85.5 176L208 176 208 58.5 325.5 176zM64 416l0-128 256 0 0 128-256 0zM88 64l72 0 0 48-96 0 0-48 24 0zm0 96l72 0 0 48-96 0 0-48 24 0z"]
};
var faPentagon = {
  prefix: 'fass',
  iconName: 'pentagon',
  icon: [576, 512, [], "e790", "M306.9-9.9l-18.8-13.7-18.8 13.7-243.5 176.9-18.8 13.7 7.2 22.1 93 286.2 7.2 22.1 347.4 0 7.2-22.1 93-286.2 7.2-22.1-18.8-13.7-243.5-176.9z"]
};
var faPhoneOffice = {
  prefix: 'fass',
  iconName: 'phone-office',
  icon: [512, 512, [], "f67d", "M0 32l512 0 0 448-352 0 0-384-160 0 0-64zM248 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM360 296a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM336 416a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM448 296a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM424 416a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM448 96l-224 0 0 96 224 0 0-96zM112 144l0 336-112 0 0-336 112 0z"]
};
var faTreePalm = {
  prefix: 'fass',
  iconName: 'tree-palm',
  icon: [576, 512, [127796], "f82b", "M96 80l37.2 61.9c-4 3.5-8 7.2-12 11.2-79.2 79.2-56.6 169.7-22.6 203.6L248.4 206.9c4 10.8 7.8 26.2 9.7 47.2 4.2 46.5-1.6 116.8-32.7 216.4l-13 41.5 135.8 0 3.5-28c12.4-99-2.3-207.2-31.7-292l131.2 0 28.8-48 28.8 48 67.2 0C576 144 528 64 416 64 372.3 64 338.4 76.2 313.2 93.8 296.5 49.4 248 0 160 0 48 0 0 80 0 128L67.2 128 96 80z"]
};
var faOnion = {
  prefix: 'fass',
  iconName: 'onion',
  icon: [448, 512, [129477], "e427", "M272 0l-96 0 0 15.1c0 2-.3 4.1-.8 6L117.7 229.3c-3.8 13.8-5.7 28.1-5.7 42.4 0 33.2 10.4 65.7 29.7 92.7l6.9 9.7 47.5 55.5 3.9 4.5 0 77.9 48 0 0-77.9 3.9-4.5 47.5-55.5 6.9-9.7c19.3-27 29.7-59.5 29.7-92.7 0-14.3-1.9-28.6-5.7-42.4L272.8 21.1c-.5-2-.8-4-.8-6L272 0zm8 453.1l0 58.9 48 0 0-72.2c68.3-25.9 120-79.1 120-159.8 0-64-44-102-88-140-9.5-8.2-19-16.4-28.1-24.9l29.2 105.7c4.6 16.6 6.9 33.7 6.9 50.9 0 39.9-12.5 78.8-35.7 111.3l-7.3 10.2-.4 .6-.5 .5-44.1 51.5 0 7.2zM88 140l0 0C44 178 0 216 0 280 0 360.7 51.7 414 120 439.8l0 72.2 48 0 0-66.1-44.1-51.5-.5-.5-.4-.6-7.3-10.2c-23.2-32.5-35.7-71.4-35.7-111.3 0-17.2 2.3-34.3 6.9-50.9l29.2-105.7C107 123.6 97.5 131.8 88 140z"]
};
var faValueAbsolute = {
  prefix: 'fass',
  iconName: 'value-absolute',
  icon: [512, 512, [], "f6a6", "M64 64l-64 0 0 384 64 0 0-384zm118.6 73.4L160 114.7 114.7 160c6.6 6.6 38.6 38.6 96 96-57.4 57.4-89.4 89.4-96 96L160 397.3c6.6-6.6 38.6-38.6 96-96l96 96 45.3-45.3-96-96c57.4-57.4 89.4-89.4 96-96L352 114.7c-6.6 6.6-38.6 38.6-96 96l-73.4-73.4zM512 96l0-32-64 0 0 384 64 0 0-352z"]
};
var faRepublican = {
  prefix: 'fass',
  iconName: 'republican',
  icon: [640, 512, [], "f75e", "M0 192C0 103.6 71.6 32 160 32l224 0c88.4 0 160 71.6 160 160l0 64-544 0 0-64zm152-32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM280 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 288l416 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 64 0 0 80c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48-32 0 0 128-128 0 0-96-192 0 0 96-128 0 0-192 128 0z"]
};
var faShop = {
  prefix: 'fass',
  iconName: 'shop',
  icon: [576, 512, ["store-alt"], "f54f", "M16 256l0-64 80-160 384 0 80 160 0 64-48 0 0 224-64 0 0-224-96 0 0 224-288 0 0-224-48 0zm112 0l0 128 160 0 0-128-160 0z"]
};
var faStoreAlt = faShop;
var faFilm = {
  prefix: 'fass',
  iconName: 'film',
  icon: [448, 512, [127902, 62368, "film-alt", "film-simple"], "f008", "M0 32l448 0 0 448-448 0 0-448zM48 352l0 64 64 0 0-64-64 0zm352 0l-64 0 0 64 64 0 0-64zM48 224l0 64 64 0 0-64-64 0zm352 0l-64 0 0 64 64 0 0-64zM48 96l0 64 64 0 0-64-64 0zm352 0l-64 0 0 64 64 0 0-64z"]
};
var faFilmAlt = faFilm;
var faFilmSimple = faFilm;
var faWashingMachine = {
  prefix: 'fass',
  iconName: 'washing-machine',
  icon: [448, 512, ["washer"], "f898", "M0 0L448 0 448 512 0 512 0 0zM368 304a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM96 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM216 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8 304c-53 0-96-43-96-96 0-17.5 4.7-33.8 12.8-48 1.1 0 2.1 0 3.2 0 64 0 96 64 160 64 5 0 10-.2 14.8-.6-7.4 45.7-47 80.6-94.8 80.6z"]
};
var faWasher = faWashingMachine;
var faBuildingCircleXmark = {
  prefix: 'fass',
  iconName: 'building-circle-xmark',
  icon: [576, 512, [], "e4d4", "M416 0l-384 0 0 512 244 0c-10.5-14.6-19-30.7-25.1-48l-74.9 0 0-112 70 0c6-23.3 16.3-45 30-64l-20 0 0-64 64 0 0 20c27.5-19.8 60.3-32.4 96-35.4L416 0zM128 96l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM128 224l64 0 0 64-64 0 0-64zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm55.3-176.7L454.6 400c25.4 25.3 40 40 44 44L476 466.6c-4-4-18.6-18.6-44-44-25.3 25.4-40 40-44 44L365.4 444c4-4 18.6-18.6 44-44-25.4-25.3-40-40-44-44L388 333.4c4 4 18.6 18.6 44 44 25.3-25.4 40-40 44-44l22.6 22.6-11.3 11.3z"]
};
var faComments = {
  prefix: 'fass',
  iconName: 'comments',
  icon: [576, 512, [128490, 61670], "f086", "M384 144c0 97.2-86 176-192 176-22.8 0-44.7-3.6-65-10.3L0 352 35.4 245.8C13.1 217.1 0 181.9 0 144 0 46.8 86-32 192-32S384 46.8 384 144zm0 368c-94.1 0-172.4-62.1-188.8-144 120-1.5 224.3-86.9 235.8-202.7 83.3 19.2 145 88.3 145 170.7 0 37.9-13.1 73.1-35.4 101.8L576 544 460.1 497.6C436.8 506.9 411 512 384 512z"]
};
var faTags = {
  prefix: 'fass',
  iconName: 'tags',
  icon: [640, 512, [], "f02c", "M433.4 39.1l181.6 184 16.6 16.9-16.7 16.9-189.7 192-16.9 17.1-34.1-33.7 16.9-17.1 173.1-175.1-164.9-167.1-16.9-17.1 34.2-33.7 16.9 17.1zM64.3 256l0-224 224 0 208 208-224 224-208-208zm144-112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faFileSpreadsheet = {
  prefix: 'fass',
  iconName: 'file-spreadsheet',
  icon: [384, 512, [], "f65b", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM88 228l-20 0 0 216 248 0 0-216-228 0zm20 176l0-48 64 0 0 48-64 0zm104 0l0-48 64 0 0 48-64 0zm0-88l0-48 64 0 0 48-64 0zm-40-48l0 48-64 0 0-48 64 0z"]
};
var faGun = {
  prefix: 'fass',
  iconName: 'gun',
  icon: [576, 512, [], "e19b", "M528 32l0 32 48 0 0 144-96 0-32 32-47.1 0-34.3 96.1-5.7 15.9-136.9 0-32 128-160 0 60-240-92 0 0-176 480 0 0-32 48 0zM327.1 304l22.9-64-97.9 0-16 64 91.1 0zM480 128l-416 0 0 32 416 0 0-32z"]
};
var faNestingDolls = {
  prefix: 'fass',
  iconName: 'nesting-dolls',
  icon: [640, 512, [], "e3ba", "M307.2 272C295 296 288 323.2 288 352l0 70.8-35.7 89.2-144.3 0c-27.6-30.9-44-77.8-44-120s16.4-89.1 44-120l199.2 0zM464 224c70.7 0 128 57.3 128 128l0 80 32 80-320 0 32-80 0-80c0-70.7 57.3-128 128-128zM432 352l-46.4 0c-1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.5-10.8-1.6-16l-46.4 0-32-32-32 32zM256 0c70.7 0 128 57.3 128 128l0 67.2c-14.9 7.6-28.6 17.4-40.7 28.8l-215.3 0 0-96C128 57.3 185.3 0 256 0zM224 112l-48 0 .4 8.2c4.1 40.3 38.2 71.8 79.6 71.8 44.2 0 80-35.8 80-80l-48 0-32-32-32 32z"]
};
var faDial = {
  prefix: 'fass',
  iconName: 'dial',
  icon: [576, 512, ["dial-med-high"], "e15b", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64-64 0 0-64zm175.1-81.8c56.7-56.7 145.4-62 208-15.7l-111.9 111.9-17 17 33.9 33.9 17-17 111.9-111.9c46.2 62.6 41 151.3-15.7 208-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3z"]
};
var faDialMedHigh = faDial;
var faTruckFlatbed = {
  prefix: 'fass',
  iconName: 'truck-flatbed',
  icon: [576, 512, [], "e2b6", "M416 160l0 96 88.4 0-48-96-40.4 0zm-64 96l0-160 144 0 80 160 0 160-67.3 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-102.6 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64L0 416 0 256 352 256zM192 392a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm232 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faPenNibSlash = {
  prefix: 'fass',
  iconName: 'pen-nib-slash',
  icon: [576, 512, [], "e4a1", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-152.6-152.6 37-111-133-133-111 37-152.4-152.4zM271 340.7c-8.4 7-19.1 11.3-30.9 11.3-4.3 0-8.5-.6-12.4-1.6L81.1 497 96.1 512 355.8 425.5 271 340.7zM118.7 188.4L32.1 448 47.2 463 193.8 316.4c-1.1-4-1.6-8.1-1.6-12.4 0-11.8 4.2-22.6 11.3-30.9l-84.7-84.7zM349.1 67l128 128 99-99-128-128-99 99z"]
};
var faCircleCheck = {
  prefix: 'fass',
  iconName: 'circle-check',
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm84.5-361l-119.4 164.2-69.1-69.1-33.9 33.9 88.9 88.9 19.8 19.9 16.5-22.7 135.9-186.9 14.1-19.4-38.8-28.3-14.1 19.4z"]
};
var faCheckCircle = faCircleCheck;
var faHouseTree = {
  prefix: 'fass',
  iconName: 'house-tree',
  icon: [640, 512, [], "e1b3", "M640 464l-80-112 48 0 0-48-80-112 48 0 0-48-160-144-103.2 92.9 183.2 148 0 110.9-32 0 0 160.2 176 0 0-48zM416 304l32 0 0-40-208-168-208 168 0 40 32 0 0 208 352 0 0-208zM288 272l0 96-96 0 0-96 96 0z"]
};
var faUserPilot = {
  prefix: 'fass',
  iconName: 'user-pilot',
  icon: [448, 512, [], "e2c0", "M48 48l0-32 176-48 176 48 0 32-32 19.2 0 44.8s-5.8 2.8-16 6.7l0 25.3c0 70.7-57.3 128-128 128S96 214.7 96 144l0-25.3c-10.2-3.9-16-6.7-16-6.7L80 67.2 48 48zm176 96c-29.1 0-56.8-4.6-80-10.3l0 10.3c0 44.2 35.8 80 80 80s80-35.8 80-80l0-10.3c-23.2 5.7-50.9 10.3-80 10.3zm0 240l64-64 80 0 64 192-416 0 64-192 80 0 64 64zM168.8 26.5L154.5 55.2c3.9 2 24.7 12.3 62.3 31.2l7.2 3.6 7.2-3.6c37.6-18.8 58.4-29.2 62.3-31.2L279.2 26.5c-5.1 2.6-23.5 11.8-55.2 27.6-31.6-15.8-50-25-55.2-27.6zM304 416l-16 0 0 32 64 0 0-32-48 0z"]
};
var faBracketSquare = {
  prefix: 'fass',
  iconName: 'bracket-square',
  icon: [192, 512, ["bracket", "bracket-left"], "5b", "M0 32l160 0 0 64-96 0 0 320 96 0 0 64-160 0 0-448z"]
};
var faBracket = faBracketSquare;
var faBracketLeft = faBracketSquare;
var faUserPilotHairLong = {
  prefix: 'fass',
  iconName: 'user-pilot-hair-long',
  icon: [448, 512, [], "e7b3", "M48 16l0 32 32 19.2 0 44.8s5.8 2.8 16 6.7l0 57.3-48 96 352 0-48-96 0-57.3c10.2-3.9 16-6.7 16-6.7l0-44.8 32-19.2 0-32-176-48-176 48zm96 117.7c23.2 5.7 50.9 10.3 80 10.3s56.8-4.6 80-10.3l0 10.3c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-10.3zM160 320l-80 0-64 192 416 0-64-192-80 0-64 64-64-64zm8.8-293.5c5.1 2.6 23.5 11.8 55.2 27.6 31.7-15.8 50-25 55.2-27.6l14.3 28.6c-3.9 2-24.7 12.4-62.3 31.2l-7.2 3.6-7.2-3.6c-37.6-18.8-58.4-29.2-62.3-31.2l14.3-28.6zM304 416l48 0 0 32-64 0 0-32 16 0z"]
};
var faIdCardClip = {
  prefix: 'fass',
  iconName: 'id-card-clip',
  icon: [576, 512, ["id-card-alt"], "f47f", "M352-32l0 96-128 0 0-96 128 0zM0 32l176 0 0 80 224 0 0-80 176 0 0 448-576 0 0-448zM400 416l-32-96-160 0-32 96 224 0zM288 280a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faIdCardAlt = faIdCardClip;
var faMoon = {
  prefix: 'fass',
  iconName: 'moon',
  icon: [512, 512, [127769, 9214], "f186", "M359.7 21.9C272.6 43.5 208 122.2 208 216 208 326.4 297.5 416 408 416 426.5 416 444.4 413.5 461.4 408.8 414.8 471.4 340.1 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0c36.9 0 72 7.8 103.7 21.9z"]
};
var faCaretLargeUp = {
  prefix: 'fass',
  iconName: 'caret-large-up',
  icon: [448, 512, [], "e82f", "M8 352L224 120 440 352 8 352z"]
};
var faLamp = {
  prefix: 'fass',
  iconName: 'lamp',
  icon: [448, 512, [], "f4ca", "M96 32L0 288 448 288 352 32 96 32zm0 384c0 38.2 16.8 72.5 43.3 96l169.3 0c26.6-23.5 43.3-57.8 43.3-96 0-30.3-10.5-58.1-28.1-80l-199.9 0C106.5 357.9 96 385.7 96 416z"]
};
var faMobileArrowDown = {
  prefix: 'fass',
  iconName: 'mobile-arrow-down',
  icon: [384, 512, [], "e74b", "M16 0l352 0 0 512-352 0 0-512zM128 416l0 48 128 0 0-48-128 0zm81-119c57.2-57.2 86.8-86.8 89-89L264 174.1c-9 9-25 25-48 48l0-126.1-48 0 0 126.1-48-48-33.9 33.9c2.1 2.1 31.8 31.8 89 89l17 17 17-17z"]
};
var faFilePlus = {
  prefix: 'fass',
  iconName: 'file-plus',
  icon: [384, 512, [], "f319", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM168 432l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faImageUser = {
  prefix: 'fass',
  iconName: 'image-user',
  icon: [448, 512, [], "e1b8", "M0 32l448 0 0 448-448 0 0-448zM336 384l-32-96-160 0-32 96 224 0zM224 248a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faTurnRight = {
  prefix: 'fass',
  iconName: 'turn-right',
  icon: [512, 512, [], "e639", "M512 256l-192 192 0-128-192 0 0 128-128 0 0-256 320 0 0-128 192 192z"]
};
var faHexagonVerticalNft = {
  prefix: 'fass',
  iconName: 'hexagon-vertical-nft',
  icon: [512, 512, [58630, "hexagon-vertical-nft-slanted"], "e505", "M257 531.5l-11.9-6.8-216.1-123.7-12.1-6.9 0-275.1 12.1-6.9 216.1-123.7 11.9-6.8 11.9 6.8 216.1 123.7 12.1 6.9 0 275.1-12.1 6.9-216.1 123.7-11.9 6.8zM112 172l-20 0 0 168 40 0 0-59.2c15.8 37.2 24.2 56.9 25.2 59.2l38.8 0 0-168-40 0 0 63c-17.1-40.3-26.1-61.3-26.8-63L112 172zm108 0l0 168 40 0 0-64 48 0 0-40-48 0 0-24 48 0 0-40-88 0zm116 0l-20 0 0 40 32 0 0 128 40 0 0-128 32 0 0-40-84 0z"]
};
var faHexagonVerticalNftSlanted = faHexagonVerticalNft;
var faSkullCow = {
  prefix: 'fass',
  iconName: 'skull-cow',
  icon: [640, 512, [], "f8de", "M0 95.5C0 166.1 57.2 224 128 224l0-96-23 0c-28.7 0-52.7-21.7-55.6-50.3-1.6-16 5.3-35.5 11.1-51.8 1.2-3.4 2.4-6.7 3.4-9.9L40 0C19 26.2 0 61 0 95.5zM512 224c70.8 0 128-57.9 128-128.5 0-34.5-19-69.3-40-95.5L576 16c1 3.1 2.2 6.4 3.4 9.9l0 0c5.8 16.4 12.7 35.8 11.1 51.8-2.9 28.6-26.9 50.3-55.6 50.3l-23 0 0 96zM480 96l-320 0 0 272 60 0 36 144 128 0 36-144 60 0 0-272zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faOilWell = {
  prefix: 'fass',
  iconName: 'oil-well',
  icon: [576, 512, [], "e532", "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L384 17.1 416.8 139.5 308.5 167.5c-4-11.5-8.6-24.7-13.8-39.5l-45.4 0c-4 11.4-11 31.5-21.1 60.4l-132.2 34.3 0-62.6-48 0 0 288-48 0 0 64 576 0 0-64-169.3 0-64-182.9-62.2 16.1 24.8 70.8-66.6 0 23.1-66-74.6 19.3-49.9 142.6-41.3 0 0-159.2 337.4-87.5 33.5 124.9 46.4-12.4c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32 111.4 0 11.2 32-133.8 0zM272.3 64l-.3-.9-.3 .9 .6 0z"]
};
var faRhombus = {
  prefix: 'fass',
  iconName: 'rhombus',
  icon: [448, 512, [], "e23b", "M249.2 4.1l-25.1-31.6-25.1 31.6-184 232-16.1 20.2 16.4 20 184 224 24.7 30.1 24.7-30.1 184-224 16.4-20-16-20.2-184-232z"]
};
var faSquareLari = {
  prefix: 'fass',
  iconName: 'square-lari',
  icon: [448, 512, [], "e73f", "M448 32l-448 0 0 448 448 0 0-448zM224 136.1c1.3 0 2.7-.1 4-.1 4 0 8.1 .2 12 .6l0-24.6 32 0 0 32c39.3 14.9 69 49.2 77.5 91.2l4.2 20.8-49 0-2.3-11.2C298.6 225.6 287.4 209 272 198l0 42-32 0 0-55.1c-3.9-.6-7.9-.9-12-.9-1.3 0-2.7 0-4 .1l0 55.9-32 0 0-46.9c-23.8 12.8-40 38-40 66.9 0 42 34 76 76 76l108 0 0 48-224 0 0-48 18 0c-16.3-21-26-47.4-26-76 0-56 37.1-103.3 88-118.7l0-29.3 32 0 0 24.1z"]
};
var faCircleUserCircleXmark = {
  prefix: 'fass',
  iconName: 'circle-user-circle-xmark',
  icon: [640, 512, [], "e7a6", "M496 208c-77.5 0-144.3 45.9-174.6 112l-145.4 0-23.9 71.6c34.8 34.8 82.8 56.4 135.9 56.4 7.4 0 14.6-.4 21.7-1.2 5.5 21.9 14.8 42.4 27.1 60.6-15.8 3-32.1 4.6-48.8 4.6-141.4 0-256-114.6-256-256S146.6 0 288 0c126.8 0 232.1 92.2 252.4 213.2-14.3-3.4-29.1-5.2-44.4-5.2zM288 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm208-16a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm55.3 111.3L562.6 356 540 333.4c-4 4-18.7 18.6-44 44-25.4-25.4-40-40-44-44L429.4 356c4 4 18.6 18.7 44 44-25.4 25.4-40 40-44 44L452 466.6c4-4 18.7-18.6 44-44 25.4 25.4 40 40 44 44L562.6 444c-4-4-18.6-18.7-44-44l32.7-32.7z"]
};
var faApartment = {
  prefix: 'fass',
  iconName: 'apartment',
  icon: [576, 512, [], "e468", "M448 0l-320 0 0 96-128 0 0 416 576 0 0-320-128 0 0-192zM240 352l96 0 0 112-96 0 0-112zM64 352l0-64 64 0 0 64-64 0zM384 96l0 64-64 0 0-64 64 0zM192 96l64 0 0 64-64 0 0-64zM384 256l-64 0 0-64 64 0 0 64zm64 96l0-64 64 0 0 64-64 0zM128 256l-64 0 0-64 64 0 0 64zm64 0l0-64 64 0 0 64-64 0z"]
};
var faUserBountyHunter = {
  prefix: 'fass',
  iconName: 'user-bounty-hunter',
  icon: [448, 512, [], "e2bf", "M323 120C309.4 78 270 48 224 48s-85.4 30-99 72L323 120zm5.5 36.4l-80.5 15.1 0 95.9 8.8-1.6c5.1-43.6 33.6-80 72.5-96.4l-.8-13zm-209 0l-.8 13c38.9 16.5 67.4 52.9 72.5 96.4l8.8 1.6 0-95.9-80.5-15.1zM96 70c27.1-42.2 74.5-70 128-70 80.1 0 146.5 62.2 151.7 142.2l8.3 128.2 1.4 21.4-21.2 3.7-136 24c-2.8 .5-5.6 .5-8.3 0l-136-24-21.2-3.7 1.3-20.7 0-271.2 48 0 0 32-16 0 0 38zM48 352l352 0 48 160-160 0 0-48-64-48-64 48 0 48-160 0 48-160z"]
};
var faSeat = {
  prefix: 'fass',
  iconName: 'seat',
  icon: [384, 512, [], "e764", "M64 0l256 0 0 240-256 0 0-240zM0 384l0-96 384 0 0 96-32 0 0 128-64 0 0-128-192 0 0 128-64 0 0-128-32 0z"]
};
var faEyeDropperHalf = {
  prefix: 'fass',
  iconName: 'eye-dropper-half',
  icon: [512, 512, [], "e173", "M240.1 130.8L341.6 29.2c39-39 102.2-39 141.1 0s39 102.2 0 141.1L381.2 271.9c4.1 4.1 14.8 14.8 32.1 32.1l-45.3 45.3-22.6-22.6-160-160-22.6-22.6 45.3-45.3c17.3 17.3 28 28 32.1 32.1zm-76.6 81.8l45.3 45.3-62.2 62.2 91 0 16.7-16.7 16.7 16.7 1.1 0-.6 .6 28 28-131.4 131.4-88 0-5.5 3.7C47.1 501.9 32.9 511.4 32 512L0 480c.6-.9 10-15.1 28.3-42.5l3.7-5.5 0-88 131.4-131.4z"]
};
var faCommentCode = {
  prefix: 'fass',
  iconName: 'comment-code',
  icon: [512, 512, [], "e147", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM217 193l17-17-33.9-33.9c-3.5 3.5-30.5 30.5-81 81l-17 17c3.5 3.5 30.5 30.5 81 81l17 17 33.9-33.9c-6.3-6.3-27.6-27.6-64-64l47-47zM329 159l-17-17-33.9 33.9c6.3 6.3 27.6 27.6 64 64-36.4 36.4-57.7 57.7-64 64L312 337.9c3.5-3.5 30.5-30.5 81-81l17-17c-3.5-3.5-30.5-30.5-81-81z"]
};
var faTachographDigital = {
  prefix: 'fass',
  iconName: 'tachograph-digital',
  icon: [576, 512, ["digital-tachograph"], "f566", "M0 64l576 0 0 384-576 0 0-384zm64 64l0 96 224 0 0-96-224 0zM88 352l-24 0 0 48 184 0 0-48-160 0zm256 0l-24 0 0 48 192 0 0-48-168 0zM496 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM88 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faDigitalTachograph = faTachographDigital;
var faHandBackPointRibbon = {
  prefix: 'fass',
  iconName: 'hand-back-point-ribbon',
  icon: [448, 512, [], "e1a0", "M176 0l0 32c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16L32 128 75.6 80 32 32 96 32 96 0 176 0zM96 224l0-64 80 0 0 16 80 0 0 32 80 0 0 32 80 0 0 144c0 70.7-57.3 128-128 128l-118.1 0c-37.4 0-73.7-13.1-102.4-37.1l-5.4-4.5C32.9 446.1 16 410 16 372l0-68 48-40 0 72 32 0 0-112z"]
};
var faLaptopBinary = {
  prefix: 'fass',
  iconName: 'laptop-binary',
  icon: [640, 512, [], "e5e7", "M64 32l512 0 0 304-64 0 0-240-384 0 0 240-64 0 0-304zM0 424l0-40 640 0 0 40-56 56-528 0-56-56zM176 128l80 0 0 112-96 0 0-112 16 0zm16 80l32 0 0-48-32 0 0 48zm112-80l32 0 0 112-32 0 0-80-16 0 0-32 16 0zm80 0l96 0 0 112-96 0 0-112zm32 32l0 48 32 0 0-48-32 0zM192 272l32 0 0 64-32 0 0-32-16 0 0-32 16 0zm256 16l0 48-32 0 0-32-16 0 0-32 48 0 0 16zm-80 0l0 48-32 0 0-32-32 0 0 32-32 0 0-64 96 0 0 16z"]
};
var faTablet = {
  prefix: 'fass',
  iconName: 'tablet',
  icon: [448, 512, ["tablet-android"], "f3fb", "M448 0L0 0 0 512 448 512 448 0zM184 400l104 0 0 48-128 0 0-48 24 0z"]
};
var faTabletAndroid = faTablet;
var faRubleSign = {
  prefix: 'fass',
  iconName: 'ruble-sign',
  icon: [448, 512, [8381, "rouble", "rub", "ruble"], "f158", "M112 32l-32 0 0 240-64 0 0 48 64 0 0 48-64 0 0 48 64 0 0 64 64 0 0-64 176 0 0-48-176 0 0-48 112 0c79.5 0 144-64.5 144-144S335.5 32 256 32L112 32zM256 256l-112 0 0-160 112 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
var faRouble = faRubleSign;
var faRub = faRubleSign;
var faRuble = faRubleSign;
var faClosedCaptioning = {
  prefix: 'fass',
  iconName: 'closed-captioning',
  icon: [512, 512, [], "f20a", "M0 64l512 0 0 384-512 0 0-384zM152 208l32 0c4.4 0 8 3.6 8 8l0 24 48 0 0-24c0-30.9-25.1-56-56-56l-32 0c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-24-48 0 0 24c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8zm168 8c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 24 48 0 0-24c0-30.9-25.1-56-56-56l-32 0c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-24-48 0 0 24c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-80z"]
};
var faInterrobang = {
  prefix: 'fass',
  iconName: 'interrobang',
  icon: [320, 512, [8253], "e5ba", "M160.1 0c88.3 0 160.1 71.6 160 160-.1 55.1-28.7 108.9-80 138.5l-48 27.7 0 57.7-64 0c0-19.3 0-44.7 0-76.2l0-18.5 0 0 0-161.3 64 0 0 124.4 16-9.2c30.7-17.7 48-49.9 48-83.2 0-53-43-96-96-96-53 0-96 43-96 96l0 32-64 0 0-32C0 71.6 71.7 0 160.1 0zM128 448l64 0 0 64-64 0 0-64z"]
};
var faPen = {
  prefix: 'fass',
  iconName: 'pen',
  icon: [576, 512, [128394], "f304", "M16 528L72 328 295 105 439 249 216 472 16 528zM473 215l-144-144 87-87 144 144-87 87z"]
};
var faPalletBoxes = {
  prefix: 'fass',
  iconName: 'pallet-boxes',
  icon: [576, 512, [57863, "palette-boxes", "pallet-alt"], "f483", "M32 0l0 256 256 0 0-256-256 0zm0 320l-32 0 0 64 64 0 0 64-64 0 0 64 576 0 0-64-64 0 0-64 64 0 0-64-544 0zm96 64l128 0 0 64-128 0 0-64zm192 0l128 0 0 64-128 0 0-64zM544 64l-192 0 0 192 192 0 0-192z"]
};
var faPaletteBoxes = faPalletBoxes;
var faPalletAlt = faPalletBoxes;
var faPlane = {
  prefix: 'fass',
  iconName: 'plane',
  icon: [576, 512, [], "f072", "M520 200c30.9 0 56 25.1 56 56s-25.1 56-56 56l-127.3 0-168.7 184-80 0 61.3-184-99.7 0-57.6 72-48 0 32-128-32-128 48 0 57.6 72 99.7 0-61.3-184 80 0 168.7 184 127.3 0z"]
};
var faBookArrowRight = {
  prefix: 'fass',
  iconName: 'book-arrow-right',
  icon: [448, 512, [], "e0b9", "M0 0l448 0 0 384-32 0 0 64 32 0 0 64-448 0 0-512zM64 416l0 32 288 0 0-64-256 0c-17.7 0-32 14.3-32 32zM321 209l17-17c-2.1-2.1-31.8-31.8-89-89l-17-17-33.9 33.9c9 9 25 25 48 48l-126.1 0 0 48 126.1 0c-23 23-39 39-48 48L232 297.9c2.1-2.1 31.8-31.8 89-89z"]
};
var faImages = {
  prefix: 'fass',
  iconName: 'images',
  icon: [576, 512, [], "f302", "M96 32l448 0 0 384-448 0 0-384zM48 128l0 336 400 0 0 48-448 0 0-384 48 0zm144 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm48 48l-96 144 352 0-128-208-81.9 133.1-46.1-69.1z"]
};
var faMobileScreen = {
  prefix: 'fass',
  iconName: 'mobile-screen',
  icon: [384, 512, ["mobile-android-alt"], "f3cf", "M16 0l352 0 0 512-352 0 0-512zM128 416l0 48 128 0 0-48-128 0zM304 64l-224 0 0 304 224 0 0-304z"]
};
var faMobileAndroidAlt = faMobileScreen;
var faGuaraniSign = {
  prefix: 'fass',
  iconName: 'guarani-sign',
  icon: [384, 512, [], "e19a", "M216 0l-48 0 0 65.5C73.3 77.3 0 158.1 0 256S73.3 434.7 168 446.5l0 65.5 48 0 0-65.5c94.7-11.8 168-92.6 168-190.5l0-32-168 0 0-93.8c25.3 4.8 47.9 17 65.6 34.3l44.8-45.7C297.2 90.2 258.8 70.8 216 65.5L216 0zM168 130.2l0 251.5C108.8 370.5 64 318.5 64 256s44.8-114.5 104-125.8zm48 251.5l0-93.8 100 0c-12.3 47.6-51.2 84.5-100 93.8z"]
};
var faBagShopping = {
  prefix: 'fass',
  iconName: 'bag-shopping',
  icon: [448, 512, ["shopping-bag"], "f290", "M160 80c0-35.3 28.7-64 64-64s64 28.7 64 64l0 48-128 0 0-48zm-48 48l-112 0 0 352 448 0 0-352-112 0 0-48c0-61.9-50.1-112-112-112S112 18.1 112 80l0 48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faShoppingBag = faBagShopping;
var faCircleAustral = {
  prefix: 'fass',
  iconName: 'circle-austral',
  icon: [512, 512, [], "e71b", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM236.5 128l39 0 6.3 14.3 43.3 97.7 58.9 0 0 32-44.7 0 10.6 24 34.1 0 0 32-19.9 0c6.6 14.9 13.1 29.7 19.6 44.2l-43.9 19.4c-5-11.3-14.4-32.6-28.2-63.7l-111.2 0c-13.8 31.1-23.2 52.3-28.2 63.7l-43.9-19.4c6.5-14.6 13-29.3 19.6-44.2l-19.9 0 0-32 34.1 0 10.6-24-44.7 0 0-32 58.9 0 43.3-97.7 6.3-14.3zM256 202.5l-16.6 37.5 33.2 0-16.6-37.5zM214.6 296l82.8 0-10.6-24-61.6 0-10.6 24z"]
};
var faCircleRight = {
  prefix: 'fass',
  iconName: 'circle-right',
  icon: [512, 512, [61838, "arrow-alt-circle-right"], "f35a", "M0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zM256 128l8 0 128 128-128 128-8 0 0-80-128 0 0-96 128 0 0-80z"]
};
var faArrowAltCircleRight = faCircleRight;
var faPersonRunningFast = {
  prefix: 'fass',
  iconName: 'person-running-fast',
  icon: [576, 512, [], "e5ff", "M472 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM256 112l-21.7 0c-1.4 3.4-14.7 36.8-40 100.1l-11.9 29.7 59.4 23.8c5.9-14.8 17.9-44.7 35.8-89.6l41.4 0-22.7 90.6c-8.3 33.2 11 67 43.7 76.8L436 372.2c-38.9 87.5-59.6 134.1-62.2 140l58.5 26 13-29.2c50.9-114.5 77.1-173.5 78.8-177.2-13.5-4.1-56.1-16.8-127.6-38.3l20.7-70.4c14.5 24.8 24 41.1 28.5 48.8l130.4 0 0-64-93.6 0-28.2-48.4C437 130.1 405.4 112 371.2 112L256 112zm4.8 284.9c-70.2 57.9-108.2 89.2-113.9 93.9l40.7 49.4c4.6-3.8 44.8-36.9 120.7-99.5l6.8-5.6c.3-.9 5.6-15.7 15.8-44.3l-4.7-1.4c-20.4-6.1-37.9-17.6-51.2-32.4l-14.3 40zM24 95.8l-24 0 0 48 160 0 0-48-136 0zm8 96l0 48 112 0 0-48-112 0zm-8 96l-24 0 0 48 192 0 0-48-168 0z"]
};
var faCloudSleet = {
  prefix: 'fass',
  iconName: 'cloud-sleet',
  icon: [512, 512, [], "f741", "M96.3 320l-96 0 0-96c0-41.8 26.7-77.4 64-90.5l0-21.5c0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-416 0zM47 368l50.6 0-48 144-50.6 0 48-144zm298.6 0l-48 144-50.6 0 48-144 50.6 0zM200.3 392l0 16 40 0 0 48-40 0 0 40-48 0 0-40-40 0 0-48 40 0 0-40 48 0 0 24zm248-24l0 40 40 0 0 48-40 0 0 40-48 0 0-40-40 0 0-48 40 0 0-40 48 0z"]
};
var faPiano = {
  prefix: 'fass',
  iconName: 'piano',
  icon: [512, 512, [], "f8d4", "M0 192l0 320 512 0 0-224-128-64 0-32C384 86 298 0 192 0S0 86 0 192zM416 352l32 0 0 96-384 0 0-96 32 0 0 64 32 0 0-64 32 0 0 64 32 0 0-64 32 0 0 64 32 0 0-64 64 0 0 64 32 0 0-64 32 0 0 64 32 0 0-64z"]
};
var faPhoneVolume = {
  prefix: 'fass',
  iconName: 'phone-volume',
  icon: [576, 512, ["volume-control-phone"], "f2a0", "M344-32l-24 0 0 48 24 0c101.6 0 184 82.4 184 184l0 24 48 0 0-24C576 71.9 472.1-32 344-32zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 64l0 48 24 0c48.6 0 88 39.4 88 88l0 24 48 0 0-24c0-75.1-60.9-136-136-136l-24 0zM160 0L32 64 32 80c0 238.6 193.4 432 432 432l16 0 64-128-128-96.8-80 80.8c-70.4-33-127-89.6-160-160L256.7 128 160 0z"]
};
var faVolumeControlPhone = faPhoneVolume;
var faCubes = {
  prefix: 'fass',
  iconName: 'cubes',
  icon: [512, 512, [], "f1b3", "M268-10.5l-12-6.9-12 6.9-116.3 67.1-12 6.9 0 134.2-104.3 60.2-12 6.9 0 162 12 6.9 116.3 67.1 12 6.9 12-6.9 104.3-60.2 104.3 60.2 12 6.9 12-6.9 116.3-67.1 12-6.9 0-13.9 0-134.2 0-13.9-12-6.9-104.3-60.2 0-134.2-12-6.9-116.3-67.1zM232 292.6l0 106.5-92.3 53.3 0-106.5 92.3-53.3zm232.5 0l0 106.5-92.3 53.3 0-106.5 92.3-53.3zM348.3 91.2l0 106.5-92.3 53.3 0-106.5 92.3-53.3z"]
};
var faFileMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'file-magnifying-glass',
  icon: [384, 512, ["file-search"], "f865", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM272 320c0-53-43-96-96-96s-96 43-96 96 43 96 96 96c17.8 0 34.4-4.8 48.7-13.2l55.3 55.3 33.9-33.9c-7.8-7.8-26.2-26.2-55.3-55.3 8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faFileSearch = faFileMagnifyingGlass;
var faPhone = {
  prefix: 'fass',
  iconName: 'phone',
  icon: [512, 512, [128222, 128379], "f095", "M0 64L128 0 224.8 128 144 208c33 70.4 89.6 127 160 160l80-80.8 128 96.8-64 128-16 0C193.4 512 0 318.6 0 80L0 64z"]
};
var faHexagonCheck = {
  prefix: 'fass',
  iconName: 'hexagon-check',
  icon: [576, 512, [], "e416", "M433 28.1l123.7 216 6.8 11.9-6.8 11.9-123.7 216.1-6.9 12.1-275.2 0-6.9-12.1-123.7-216.1-6.8-11.9 6.8-11.9 123.7-216 6.9-12.1 275.2 0 6.9 12.1zM373 151l-119.4 164.2-69.1-69.1-33.9 33.9 88.9 88.9 19.8 19.9 16.5-22.7 135.9-186.9 14.1-19.4-38.8-28.3-14.1 19.4z"]
};
var faUserBeardBolt = {
  prefix: 'fass',
  iconName: 'user-beard-bolt',
  icon: [640, 512, [], "e689", "M232 0l48 0c57.4 0 104 46.6 104 104l0 8 32 88 0 40-32 32 0 32-48 48-32 0-32 32-32 0-32-32-32 0-48-48 0-32-32-32 0-40 32-88 0-8C128 46.6 174.6 0 232 0zM336 128c0-11.4-2.4-22.2-6.7-32l-41.3 0-32-32-32 32-41.3 0c-4.3 9.8-6.7 20.6-6.7 32l0 16c0 12.7 3 24.8 8.3 35.5 20.4-20.4 30.8-30.8 31.5-31.5l80.6 0c.6 .6 11.1 11.1 31.5 31.5 5.3-10.7 8.3-22.7 8.3-35.5l0-16zm-40 85.3c1.9-1.1 3.8-2.3 5.5-3.5l-21.8-21.8-47.4 0-21.8 21.8c1.8 1.2 3.6 2.4 5.5 3.5 11.8 6.8 25.4 10.7 40 10.7s28.2-3.9 40-10.7zM48 512l55-165.1c30.2 30.2 47.9 47.9 53.1 53.1l32 0c12.6 12.6 23.3 23.3 32 32l71.8 0 12.1-12.1 0 60.1 79.4 0-7.6 32-327.7 0zm312-96l200-168-32.4 136 104.4 0-200 168 32.4-136-104.4 0z"]
};
var faToriiGate = {
  prefix: 'fass',
  iconName: 'torii-gate',
  icon: [448, 512, [9961], "f6a1", "M0 96l0-80 80 48 288 0 80-48 0 80c0 35.3-28.7 64-64 64l0 64 48 0 0 64-48 0 0 224-64 0 0-224-192 0 0 224-64 0 0-224-48 0 0-64 48 0 0-64C28.7 160 0 131.3 0 96zM128 224l64 0 0-64-64 0 0 64zm128 0l64 0 0-64-64 0 0 64z"]
};
var faDiceD8 = {
  prefix: 'fass',
  iconName: 'dice-d8',
  icon: [576, 512, [], "f6d2", "M576 272L288 544 0 272 288-32 576 272zM268 82.2l0 212.2-162.6-40.7-14.9 15.8 31.3 29.6 146.1 36.5 0 101.5 20 18.9 20-18.9 0-101.5 146.1-36.5 31.4-29.6-14.9-15.8-162.5 40.7 0-212.2-20-21.1-20 21.1z"]
};
var faClockNine = {
  prefix: 'fass',
  iconName: 'clock-nine',
  icon: [512, 512, [], "e34c", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392l0 160-152 0 0-48 104 0 0-136 48 0 0 24z"]
};
var faFileMp3 = {
  prefix: 'fass',
  iconName: 'file-mp3',
  icon: [576, 512, [], "e648", "M272 0l-240 0 0 512 112 0 0-176 272 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM324 400l0-20-20 0c-2.7 0-8.5 0-17.6 0-.5 1-10.8 20.3-30.7 57.9-20.8-37.9-31.5-57.2-31.8-57.9-17.7 0-17.9 0-35.8 0l0 168 40 0 0-77.4c5.8 10.5 15.2 27.6 28.3 51.5 12.7-24 22-41.4 27.7-52.2l0 78.1 40 0 0-148zm44-20l-20 0 0 168 40 0 0-48 12 0c33.1 0 60-26.9 60-60s-26.9-60-60-60l-32 0zm32 80l-12 0 0-40 12 0c11 0 20 9 20 20s-9 20-20 20zm128 88c28.7 0 52-23.3 52-52 0-12.1-4.1-23.2-11-32 6.9-8.8 11-19.9 11-32 0-28.7-23.3-52-52-52l-48 0 0 40 48 0c6.6 0 12 5.4 12 12s-5.4 12-12 12l-32 0 0 40 32 0c6.6 0 12 5.4 12 12s-5.4 12-12 12l-48 0 0 40 48 0z"]
};
var faUserTieHair = {
  prefix: 'fass',
  iconName: 'user-tie-hair',
  icon: [448, 512, [], "e45f", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16 80 0 64-48 0 0c10 13.4 16 30 16 48l0 16zM224 0C153.3 0 96 57.3 96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16C352 57.3 294.7 0 224 0zm48 328l0-24-96 0 0 24 31.4 36.7-31.4 115.3-40-160-56 0-64 192 416 0-64-192-56 0-40 160-.6 0-31-115.1 31.6-36.9z"]
};
var faSquareIndianRupee = {
  prefix: 'fass',
  iconName: 'square-indian-rupee',
  icon: [448, 512, [], "e6f5", "M448 32l-448 0 0 448 448 0 0-448zM152 120l168 0 0 32-60.1 0c9.3 11.3 15.9 25 18.7 40l41.4 0 0 32-41.4 0c-6.1 33-30.5 59.5-62.3 68.6 55.9 44.7 85.7 68.6 89.5 71.6l-30 37.5-18.7-15-112-89.6-9-7.2 0-41.9 56 0c16.4 0 30.5-9.9 36.7-24l-100.7 0 0-32 100.7 0c-6.2-14.1-20.3-24-36.7-24l-64 0 0-48 24 0z"]
};
var faCoffinCross = {
  prefix: 'fass',
  iconName: 'coffin-cross',
  icon: [384, 512, [], "e051", "M104 512L0 144 112 0 272 0 384 144 280 512 104 512zM216 120l0-24-48 0 0 64-72 0 0 48 72 0 0 144 48 0 0-144 72 0 0-48-72 0 0-40z"]
};
var faBacon = {
  prefix: 'fass',
  iconName: 'bacon',
  icon: [640, 512, [129363], "f7e5", "M550.9 58.7l65.6 65.6-162.9 115.2-100.4 197.5-166.3 113.6-64.2-64.2 146.4-112.6 4.4-3.4 2.5-4.9 95.8-191.6 179.2-115.2zM516.2 23.9l-176 113.1-5.5 3.6-2.9 5.9-96.3 192.6-147 113.1-64.5-64.5 162.9-115.2 100.4-197.5 166.3-113.6 62.6 62.6z"]
};
var faImagesUser = {
  prefix: 'fass',
  iconName: 'images-user',
  icon: [576, 512, [], "e1b9", "M544 32l-448 0 0 384 448 0 0-384zM48 152l0-24-48 0 0 384 448 0 0-48-400 0 0-312zM432 352l-224 0 32-96 160 0 32 96zM320 104a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faPersonFallingBurst = {
  prefix: 'fass',
  iconName: 'person-falling-burst',
  icon: [576, 512, [], "e547", "M288 0c0 10.7 0 53.3 0 128l0 18.1c-5.2 3.1-25.8 15.5-61.7 37l60.7 72.8 113 0 9.6 12.8c36.8 49.1 59.2 78.9 67.2 89.6l-51.2 38.4C416 384 396.8 358.4 368 320l-104.8 0 113.6 139.8 20.2 24.8-49.7 40.4-20.2-24.8-199.2-245.1c0 102.1 0 155.8 0 161l-64 0 0-32 0-160 0-18.1 15.5-9.3 144.5-86.7c0-59.6 0-96.2 0-109.9l64 0zM16 88A56 56 0 1 1 128 88 56 56 0 1 1 16 88zM392 72.1l0 24-48 0 0-88 48 0 0 64zm112 160l-24 0 0-48 88 0 0 48-64 0zm-39.8-86.2l-33.9-33.9c23.6-23.6 61.3-61.3 62.2-62.2l33.9 33.9c-23.6 23.6-61.3 61.3-62.2 62.2z"]
};
var faCaduceus = {
  prefix: 'fass',
  iconName: 'caduceus',
  icon: [512, 512, [], "e681", "M280 89.6c14.3-8.3 24-23.8 24-41.6 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.8 9.7 33.3 24 41.6l0 26.4-104-52-128 160 138.7 0c33.5 0 66.2-10.5 93.3-30l0 136.5-20.6-12.3c-12-7.2-19.4-20.2-19.4-34.3l0-27.8-48 0 0 27.8c0 30.9 16.2 59.6 42.7 75.5l22.6 13.6-6.6 4c-26.5 15.9-42.7 44.5-42.7 75.5l0 27.8 48 0 0-27.8c0-14.1 7.4-27.1 19.4-34.3l4.6-2.7 0 96.8 48 0 0-96.8 4.6 2.7c12 7.2 19.4 20.2 19.4 34.3l0 27.8 48 0 0-27.8c0-30.9-16.2-59.6-42.7-75.5l-6.6-4 22.6-13.6c26.5-15.9 42.7-44.5 42.7-75.5l0-27.8-48 0 0 27.8c0 14.1-7.4 27.1-19.4 34.3L280 330.4 280 194c27.2 19.5 59.8 30 93.3 30l138.7 0-128-160-104 52 0-26.4z"]
};
var faQuoteRight = {
  prefix: 'fass',
  iconName: 'quote-right',
  icon: [448, 512, [8221, "quote-right-alt"], "f10e", "M448 296c0 66.3-53.7 120-120 120l-40 0 0-64 40 0c30.9 0 56-25.1 56-56l0-8-128 0 0-192 192 0 0 200zm-256 0c0 66.3-53.7 120-120 120l-40 0 0-64 40 0c30.9 0 56-25.1 56-56l0-8-128 0 0-192 192 0 0 200z"]
};
var faQuoteRightAlt = faQuoteRight;
var faHouseMedicalFlag = {
  prefix: 'fass',
  iconName: 'house-medical-flag',
  icon: [640, 512, [], "e514", "M512 0l-64 0 0 512 64 0 0-320 128 0 0-160-128 0 0-32zM400 192l-160-144-240 216 0 40 50.5 0 0 208 349.5 0 0-320zM275.2 239.2l0 61.6 61.6 0 0 70.4-61.6 0 0 61.6-70.4 0 0-61.6-61.6 0 0-70.4 61.6 0 0-61.6 70.4 0z"]
};
var faPrescription = {
  prefix: 'fass',
  iconName: 'prescription',
  icon: [448, 512, [], "f5b1", "M32 0l-32 0 0 320 64 0 0-96 50.7 0 128 128c-70.7 70.7-108 108-112 112L176 509.3c4-4 41.3-41.3 112-112l112 112 45.3-45.3-112-112 112-112-45.3-45.3c-4 4-41.3 41.3-112 112l-85.8-85.8C251.4 209.1 288 164.8 288 112 288 50.1 237.9 0 176 0L32 0zM176 160l-112 0 0-96 112 0c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
};
var faFaceWeary = {
  prefix: 'fass',
  iconName: 'face-weary',
  icon: [512, 512, [], "e3a1", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM214.1 190.1l-7.4 7.4c-24.2 24.2-55.3 40.2-89 45.8l-2.5 .4-19.7 3.3-6.6-39.5 19.7-3.3 2.5-.4c25.5-4.2 49-16.4 67.3-34.6 3.8-3.8 11-11 21.5-21.5l28.3 28.3-14.1 14.1zM283.7 176L312 147.7c10.6 10.6 17.7 17.7 21.5 21.5 18.3 18.3 41.8 30.4 67.3 34.6l2.5 .4 19.7 3.3-6.6 39.5-19.7-3.3-2.5-.4c-33.7-5.6-64.8-21.6-89-45.8-3.8-3.8-11-11-21.5-21.5zM256 384c-48.9 0-93.5 16.8-127.4 44.3-.4-4.1-.6-8.2-.6-12.3 0-70.7 57.3-128 128-128s128 57.3 128 128c0 4.2-.2 8.3-.6 12.3-33.9-27.6-78.5-44.3-127.4-44.3z"]
};
var faUpLeft = {
  prefix: 'fass',
  iconName: 'up-left',
  icon: [448, 512, [], "e2bd", "M32 64L32 416 152 296 336 480 448 368 264 184 384 64 32 64z"]
};
var faHandBackPointUp = {
  prefix: 'fass',
  iconName: 'hand-back-point-up',
  icon: [448, 512, [], "e1a2", "M176 0l-80 0 0 336-32 0 0-72-48 40 0 68c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1L288 512c70.7 0 128-57.3 128-128l0-144-80 0 0-32-80 0 0-32-80 0 0-176z"]
};
var faRectangleHistoryCirclePlus = {
  prefix: 'fass',
  iconName: 'rectangle-history-circle-plus',
  icon: [576, 512, [], "e4a3", "M257.4 480c-11.2-24.4-17.4-51.4-17.4-80 0-106 86-192 192-192l-432 0 0 272 257.4 0zM464 160l0-48-416 0 0 48 416 0zM416 64l0-48-320 0 0 48 320 0zm16 480a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 64 0 0 32-64 0 0 64-32 0 0-64-64 0 0-32 64 0 0-64 32 0 0 16z"]
};
var faPersonWaterArmsRaised = {
  prefix: 'fass',
  iconName: 'person-water-arms-raised',
  icon: [640, 512, [], "e78c", "M208.4 32l0 160 224 0 0-160 64 0 0 224-96 0 0 58.6-80 32-80-32 0-58.6-96 0 0-224 64 0zm56 56a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM209.3 353.7l111.1 44.4 111.1-44.4 8.9-3.6 8.9 3.6 111.8 44.7c29.3-9.7 50.1-16.7 62.4-20.8l15.2 45.5c-11 3.7-34.6 11.5-70.8 23.6l-8.3 2.8-8.2-3.3-111.1-44.4-111.1 44.4-8.9 3.6-8.9-3.6-111.1-44.4-111.1 44.4-8.2 3.3-8.3-2.8C36.6 434.7 13 426.8 2 423.2l15.2-45.5c12.4 4.1 33.2 11.1 62.4 20.8l111.8-44.7 8.9-3.6 8.9 3.6z"]
};
var faBeerMug = {
  prefix: 'fass',
  iconName: 'beer-mug',
  icon: [576, 512, ["beer-foam"], "e0b3", "M256 128c-35.7 0-65.9-23.4-76.2-55.6-10 27.8-36.6 47.6-67.8 47.6-39.8 0-72-32.2-72-72s32.2-72 72-72C143.2-24 169.8-4.1 179.8 23.6 190.1-8.6 220.3-32 256-32s65.9 23.4 76.2 55.6c10-27.8 36.6-47.6 67.8-47.6 39.8 0 72 32.2 72 72s-32.2 72-72 72c-31.2 0-57.8-19.9-67.8-47.6-10.3 32.3-40.5 55.6-76.2 55.6zM64 512l0-354c14.7 6.4 30.9 10 48 10 24 0 46.4-7.1 65.1-19.2 21.7 17 49.1 27.2 78.9 27.2s57.2-10.2 78.9-27.2c18.8 12.1 41.2 19.2 65.1 19.2 35.5 0 67.5-15.4 89.4-40l86.6 0 0 211.8-128 64 0 108.2-384 0zM448 332.2l64-32 0-108.2-64 0 0 140.2zM192 248l0-24-48 0 0 192 48 0 0-168zm88 0l0-24-48 0 0 192 48 0 0-168zm88 0l0-24-48 0 0 192 48 0 0-168z"]
};
var faBeerFoam = faBeerMug;
var faDiceThree = {
  prefix: 'fass',
  iconName: 'dice-three',
  icon: [448, 512, [9858], "f527", "M448 32l-448 0 0 448 448 0 0-448zM128 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faLasso = {
  prefix: 'fass',
  iconName: 'lasso',
  icon: [576, 512, [], "f8c8", "M288.4 96c59.4 0 110.4 16.7 144.8 40.3 34.6 23.8 47.2 50.2 47.2 71.7s-12.7 47.9-47.2 71.7c-34.4 23.6-85.4 40.3-144.8 40.3-52 0-97.5-12.7-131.1-31.8l-14.2-8.9c-34.2-23.7-46.7-49.9-46.7-71.3 0-21.5 12.7-47.9 47.2-71.7 34.4-23.6 85.3-40.3 144.8-40.3zM253.2 382.4c11.5 1.1 23.2 1.6 35.2 1.6 141.3 0 256.1-78.9 256-176 .1-97.1-114.7-176-256-176-141.3 0-256.1 78.9-256 176 0 48.5 28.6 92.6 75 124.5 5.5 3.8 11.2 7.4 17.1 10.8l49.1 30.7c11.7 7.3 18.8 20.2 18.8 34 0 22.1-17.9 40.1-40.1 40.1l-5.6 0c-7.1 0-14.1-1.7-20.4-4.8-34.9-17.4-60.3-30.2-76.2-38.1L21.5 462.3c15.9 8 41.3 20.7 76.2 38.1 15.2 7.6 32 11.6 49 11.6l5.6 0c57.5 0 104.1-46.6 104.1-104.1 0-8.7-1.1-17.3-3.2-25.6z"]
};
var faFileAiff = {
  prefix: 'fass',
  iconName: 'file-aiff',
  icon: [576, 512, [], "e7fb", "M416 144l0 192-288 0 0 176-96 0 0-512 240 0 144 144zM240 176L357.5 176 240 58.5 240 176zm-8 204c24.3 0 44 19.7 44 44l0 124-40 0 0-48-24 0 0 48-40 0 0-124c0-24.3 19.7-44 44-44l16 0zM340 548l-40 0 0-168 40 0 0 168zM452 420l-48 0 0 24 48 0 0 40-48 0 0 64-40 0 0-168 88 0 0 40zm112 0l-48 0 0 24 48 0 0 40-48 0 0 64-40 0 0-168 88 0 0 40zm-348 0c-2.2 0-4 1.8-4 4l0 36 24 0 0-36c0-2.2-1.8-4-4-4l-16 0z"]
};
var faBuildingLock = {
  prefix: 'fass',
  iconName: 'building-lock',
  icon: [576, 512, [], "e4d6", "M416 0l-384 0 0 512 272 0 0-208 32 0c0-53.7 33.1-99.7 80-118.7L416 0zM176 352l80 0 0 112-80 0 0-112zm80-128l51.2 0c-5.2 10.1-9.4 20.8-12.6 32l-38.6 0 0-32zM128 96l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM128 224l64 0 0 64-64 0 0-64zm304 80c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48-64 0 0-48zm-48 48l-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48z"]
};
var faIdCard = {
  prefix: 'fass',
  iconName: 'id-card',
  icon: [576, 512, [62147, "drivers-license"], "f2c2", "M0 32l576 0 0 64-576 0 0-64zM0 144l576 0 0 336-576 0 0-336zM64 416l224 0-32-64-160 0-32 64zM176 312a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM360 208l-24 0 0 48 160 0 0-48-136 0zm0 96l-24 0 0 48 160 0 0-48-136 0z"]
};
var faDriversLicense = faIdCard;
var faSquareRuble = {
  prefix: 'fass',
  iconName: 'square-ruble',
  icon: [448, 512, [], "e6f8", "M448 32l-448 0 0 448 448 0 0-448zM144 120l104 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-56 0 0 24 72 0 0 32-72 0 0 40-48 0 0-40-40 0 0-32 40 0 0-40-40 0 0-32 40 0 0-128zM248 248c22.1 0 40-17.9 40-40s-17.9-40-40-40l-56 0 0 80 56 0z"]
};
var faClockDesk = {
  prefix: 'fass',
  iconName: 'clock-desk',
  icon: [448, 512, [], "e134", "M384 224a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zM224 0C347.7 0 448 100.3 448 224l0 288-448 0 0-288C0 100.3 100.3 0 224 0zm24 112l0 102.1c31.3 31.3 50.6 50.6 57.9 57.9L272 305.9c-6.1-6.1-27.8-27.8-65-65l-7-7 0-121.9 48 0z"]
};
var faCirclePlay = {
  prefix: 'fass',
  iconName: 'circle-play',
  icon: [512, 512, [61469, "play-circle"], "f144", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM384 256l-208 128 0-256 208 128z"]
};
var faPlayCircle = faCirclePlay;
var faFaceLaughBeam = {
  prefix: 'fass',
  iconName: 'face-laugh-beam',
  icon: [512, 512, [128513, "laugh-beam"], "f59a", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-80c-83 0-151.2-63.1-159.2-144l318.4 0c-8 80.9-76.2 144-159.2 144zM176 164c-15.5 0-28 12.5-28 28l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28zm132 28l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28s-28 12.5-28 28z"]
};
var faLaughBeam = faFaceLaughBeam;
var faLeaf = {
  prefix: 'fass',
  iconName: 'leaf',
  icon: [512, 512, [], "f06c", "M512 24l0 186.9C512 342.1 403.9 448 273.2 448 196.2 448 129.8 398.5 105.7 329.3 70.4 360.1 48 405.4 48 456l0 24-48 0 0-24C0 381.1 38.2 315.1 96.1 276.3 131.3 252.8 173.5 240 216 240l104 0 0-48-104 0c-39.7 0-77.3 8.8-111 24.5 23.3-70 89.2-120.5 167-120.5 58 0 107.5-21.8 143.2-44.3 17.7-11.2 31.7-22.4 41.2-30.8 4.8-4.2 9.4-8.7 13.9-13.2L512 24z"]
};
var faHouseChimneyUser = {
  prefix: 'fass',
  iconName: 'house-chimney-user',
  icon: [512, 512, [], "e065", "M464 272l48 0 0-48-48-45 0-131-96 0 0 41-112-105-256 240 0 48 48 0 0 240 416 0 0-240zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm136 96l32 96-224 0 32-96 160 0z"]
};
var faRotateRight = {
  prefix: 'fass',
  iconName: 'rotate-right',
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M512 192l0-200-79 79c-100.3-96-259.4-94.7-358 4-50.2 50.2-75.2 116.1-75 181.9 0 2 0 3.9 .1 5.9 .9 35.4 9 68.9 22.9 99.3 12.4 27.2 29.7 52.6 52 74.9l0 0c46.3 46.3 110.3 75 181 75 100.1 0 186.8-57.5 228.8-141.1l-57.2-28.8c-31.6 62.8-96.6 105.8-171.6 105.8-84.3 0-156-54.4-181.8-130-6.1-17.9-9.5-36.6-10.1-55.3-.1-2.2-.1-4.5-.1-6.8l0 0c0-49.2 18.7-98.3 56.2-135.8 73.6-73.6 192.2-75 267.5-3.9L312 192 512 192z"]
};
var faRedoAlt = faRotateRight;
var faRotateForward = faRotateRight;
var faBooksMedical = {
  prefix: 'fass',
  iconName: 'books-medical',
  icon: [640, 512, [], "f7e8", "M483.6-7.8l-123.6 33.1 20.7 77.3 123.6-33.1-20.7-77.3zm33.1 123.6l-123.6 33.1 20.8 77.5c24.9-11.8 52.8-18.4 82.2-18.4 16.2 0 31.9 2 46.9 5.8l-26.3-98zM352 96l-112 0 0 416 100 0c-22.7-31.5-36-70.2-36-112 0-48.7 18.1-93.2 48-127l0-177zM64 0l0 80 128 0 0-80-128 0zm0 128l0 256 128 0 0-256-128 0zm0 304l0 80 128 0 0-80-128 0zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm26.7-224l0 53.3 53.3 0 0 53.3-53.3 0 0 53.3-53.3 0 0-53.3-53.3 0 0-53.3 53.3 0 0-53.3 53.3 0z"]
};
var faDress = {
  prefix: 'fass',
  iconName: 'dress',
  icon: [576, 512, [], "e6d1", "M117.7 0l41.1 219.3-123.2 246.4-23.2 46.3 551.6 0-23.2-46.3-123.2-246.4 41.1-219.3-69.6 0-8.3 27.6C368.9 68 330.9 96 288.3 96s-80.6-28-92.7-68.4L187.3 0 117.7 0z"]
};
var faTooth = {
  prefix: 'fass',
  iconName: 'tooth',
  icon: [448, 512, [129463], "f5c9", "M145 5.7L224 32 303 5.7C314.3 1.9 326 0 337.9 0 398.7 0 448 49.3 448 110.1l0 113.9-48 64-32 224-80 0-32-192-64 0-32 192-80 0-32-224-48-64 0-113.9C0 49.3 49.3 0 110.1 0 122 0 133.7 1.9 145 5.7z"]
};
var faHouseChimneyWindow = {
  prefix: 'fass',
  iconName: 'house-chimney-window',
  icon: [512, 512, [], "e00d", "M464 272l48 0 0-48-48-45 0-131-96 0 0 41-112-105-256 240 0 48 48 0 0 240 416 0 0-240zM320 352l-128 0 0-128 128 0 0 128z"]
};
var faSquareEllipsis = {
  prefix: 'fass',
  iconName: 'square-ellipsis',
  icon: [448, 512, [], "e26e", "M448 480l0-448-448 0 0 448 448 0zM160 224l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0z"]
};
var faMotorcycle = {
  prefix: 'fass',
  iconName: 'motorcycle',
  icon: [640, 512, [127949], "f21c", "M280 16l-24 0 0 48 80.6 0 22.5 48.7-95.1 71.3c-33.4-25.1-75-40-120-40l-80 0 0 48 80 0c78.5 0 143.2 59.6 151.2 136l-25.4 0c-11.2-59.2-63.3-104-125.8-104-70.7 0-128 57.3-128 128S73.3 480 144 480c62.5 0 114.5-44.8 125.8-104l74.2 0 0-46.5c0-45.1 25.7-85.4 65.5-107.7l12.1 26.1c-32.4 23.2-53.5 61.2-53.5 104.1 0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-10.7 0-21 1.3-30.9 3.8l-31.3-67.8 78.2 0 0-96-88 0c-2.1 1.6-10.7 8-25.6 19.2-19.4-42.1-29.8-64.5-31-67.2L280 16zM445.8 300.4c22 47.7 34.9 75.5 38.5 83.4l43.6-20.1c-3.6-7.9-16.5-35.7-38.5-83.4 2.2-.2 4.4-.3 6.7-.3 39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72c0-20.2 8.3-38.5 21.8-51.6zM144 424c-39.8 0-72-32.2-72-72s32.2-72 72-72c31.3 0 58 20 67.9 48l-91.9 0 0 48 91.9 0c-9.9 28-36.6 48-67.9 48z"]
};
var faGridRound2Minus = {
  prefix: 'fass',
  iconName: 'grid-round-2-minus',
  icon: [448, 512, [], "e6ab", "M96 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm0 256a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM256 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm24 232l-24 0 0 48 192 0 0-48-168 0z"]
};
var faShieldMinus = {
  prefix: 'fass',
  iconName: 'shield-minus',
  icon: [512, 512, [], "e249", "M256 0l11.6 4.5 207.5 80.5 19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.3-91.1 150-189.4 192.6l-12.7 5.5-12.7-5.5C144.9 463.9 86.6 389.2 53.9 313.9 21.5 239.3 13.7 162.9 16.6 113L17.8 92.5 37 85 244.5 4.5 256 0zM184 216l-24 0 0 48 192 0 0-48-168 0z"]
};
var faBackwardFast = {
  prefix: 'fass',
  iconName: 'backward-fast',
  icon: [512, 512, [9198, "fast-backward"], "f049", "M512 494.5c-15.7-13.8-90.4-79.1-224-196l0 196c-15.7-13.8-90.4-79.1-224-196l0 181.5-64 0 0-448 64 0 0 181.5C197.6 96.6 272.3 31.3 288 17.5l0 196C421.6 96.6 496.3 31.3 512 17.5l0 477z"]
};
var faFastBackward = faBackwardFast;
var faDollyEmpty = {
  prefix: 'fass',
  iconName: 'dolly-empty',
  icon: [640, 512, [], "f473", "M32.5 0l151.1 0 7.3 21.9 99.4 298.1c30.1 .5 56.8 14.9 74 37l202.1-67.4 30.4-10.1 20.2 60.7-30.4 10.1-202.1 67.4c-.9 52.2-43.5 94.3-96 94.3-53 0-96-43-96-96 0-30.8 14.5-58.2 37-75.8L137.4 64 32.5 64 32.5 0zm256 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faAddressBook = {
  prefix: 'fass',
  iconName: 'address-book',
  icon: [512, 512, [62138, "contact-book"], "f2b9", "M448 0l-416 0 0 512 416 0 0-512zM320 288l32 96-224 0 32-96 160 0zM184 192a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM512 80l0-16-32 0 0 96 32 0 0-80zm0 112l-32 0 0 96 32 0 0-96zm0 144l0-16-32 0 0 96 32 0 0-80z"]
};
var faContactBook = faAddressBook;
var faCloudsMoon = {
  prefix: 'fass',
  iconName: 'clouds-moon',
  icon: [576, 512, [], "f745", "M418.4 135c0-58.6 40.4-107.8 94.8-121.3-19.8-8.8-41.7-13.7-64.8-13.7-84 0-152.8 64.7-159.5 147 .4 .7 .8 1.5 1.2 2.2 32.1 10.1 57.9 34.2 70.3 65.2 46.2 15.2 80.8 56 87 105.6l1 0c52.6 0 99.2-25.4 128.4-64.5-10.6 2.9-21.8 4.5-33.4 4.5-69 0-125-56-125-125zm-304 185l.9-.5c11-45.6 52.1-79.5 101.1-79.5 6 0 11.9 .5 17.7 1.5 18.1-16.5 41-28 66.4-32-11.5-10.9-27-17.5-44-17.5-.5 0-1.1 0-1.6 0-7.4-36.5-39.7-64-78.4-64-35 0-64.8 22.5-75.6 53.8-8.7-3.7-18.3-5.8-28.4-5.8-39.8 0-72 32.2-72 72l0 72 114 0zm334 192l0-80c0-33.9-21.1-62.9-50.9-74.5 1.9-6.8 2.9-14 2.9-21.5 0-44.2-35.8-80-80-80-30.8 0-57.5 17.4-70.9 42.8-9.3-6.8-20.7-10.8-33.1-10.8-34.3 0-60.9 32-55.2 65.4-36.9 7.1-64.8 39.6-64.8 78.6l0 80 352 0z"]
};
var faCarBuilding = {
  prefix: 'fass',
  iconName: 'car-building',
  icon: [576, 512, [], "f859", "M0 0l320 0 0 112-92.3-.2-36.6 128.2-47.1 0 0 239.9-144 0 0-480zM64 96l0 64 64 0 0-64-64 0zM96 224l-32 0 0 64 32 0 0-64zm167.9-64.2l24.2 .1 192 .5 24.1 .1c.5 1.9 12.7 44.4 36.6 127.6l35.3 0 0 224-64 0 0-48-256 0 0 48-64 0 0-224 35.3 0c23.9-83.5 36.1-126.2 36.6-128.2zm192 64.5l-143.8-.4-18.3 64 180.3 0-18.3-63.7zM288 415.5a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faFaceAwesome = {
  prefix: 'fass',
  iconName: 'face-awesome',
  icon: [512, 512, ["gave-dandy"], "e409", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm203.5-95.6c-5.6 9.4-15.8 15.6-27.5 15.6-17.7 0-32-14.3-32-32 0-9.1 3.8-17.4 10-23.2-3.3-.5-6.6-.8-10-.8-35.3 0-64 28.7-64 64l0 40 128 0 0-40c0-8.3-1.6-16.3-4.5-23.6zM384 176c-17.7 0-32-14.3-32-32 0-8.5 3.3-16.3 8.8-22-5.4-1.3-11-2-16.8-2-39.8 0-72 32.2-72 72l0 32 144 0 0-32c0-10.4-2.2-20.2-6.1-29.1-5.8 8-15.2 13.1-25.9 13.1zm48 112l-352 0 3.8 18.8c.9 4.5 2 8.9 3.2 13.2 21.1 75.2 89.9 128 169.1 128 55.9 0 106.6-26.3 139-68.3l0 0c16.2-20.9 27.8-45.6 33.2-73L432 288zM240.1 415.1c1.7-44 37.8-79.1 82.2-79.1 19.6 0 37.6 6.8 51.7 18.3-26.2 37.7-69.7 61.7-118 61.7-5.4 0-10.7-.3-15.9-.9z"]
};
var faGaveDandy = faFaceAwesome;
var faBlinds = {
  prefix: 'fass',
  iconName: 'blinds',
  icon: [448, 512, [], "f8fb", "M448 32l-448 0 0 64 32 0-32 96 64 0 0-96 48 0 0 240 48 0 0-240 48 0 0 96 240 0-32-96 32 0 0-64zM32 240l-32 96 64 0 0-96-32 0zm416 96l-32-96-208 0 0 96 240 0zm0 144l-32-96-384 0-32 96 448 0z"]
};
var faSailboat = {
  prefix: 'fass',
  iconName: 'sailboat',
  icon: [512, 512, [], "e445", "M240-16l0 400-240 0 64 128 384 0 64-128-224 0 0-48 192 0-240-352zM192 336l0-240-160 240 160 0z"]
};
var faArrowUpLeftFromCircle = {
  prefix: 'fass',
  iconName: 'arrow-up-left-from-circle',
  icon: [512, 512, [], "e09e", "M32 0L0 0 0 224 64 224 64 109.3 297.4 342.6 320 365.3 365.3 320 342.6 297.4 109.3 64 224 64 224 0 32 0zM288 128c88.4 0 160 71.6 160 160s-71.6 160-160 160-160-71.6-160-160l-64 0c0 123.7 100.3 224 224 224S512 411.7 512 288 411.7 64 288 64l0 64z"]
};
var faRightFromDottedLine = {
  prefix: 'fass',
  iconName: 'right-from-dotted-line',
  icon: [576, 512, [], "e6c4", "M555.3 256l-202.9-192 0 128-192 0 0 128 192 0 0 128 202.9-192zM96.4 64l-64 0 0 64 64 0 0-64zm0 170.7l0-64-64 0 0 64 64 0zm0 42.7l-64 0 0 64 64 0 0-64zm0 170.7l0-64-64 0 0 64 64 0z"]
};
var faBookBookmark = {
  prefix: 'fass',
  iconName: 'book-bookmark',
  icon: [448, 512, [], "e0bb", "M352 0l96 0 0 384-32 0 0 64 32 0 0 64-448 0 0-512 192 0 0 192 80-48 80 48 0-192zM64 416l0 32 288 0 0-64-256 0c-17.7 0-32 14.3-32 32z"]
};
var faSquareBrazilianReal = {
  prefix: 'fass',
  iconName: 'square-brazilian-real',
  icon: [448, 512, [], "e6f1", "M448 32l-448 0 0 448 448 0 0-448zM336 128l0 24 32 0 0 48-57.8 0c-7.8 0-14.2 6.3-14.2 14.2 0 5.8 3.5 11 8.9 13.1l32 12.8c23.6 9.4 39.1 32.3 39.1 57.7 0 26.5-16.6 49.2-40 58.1l0 28.1-32 0 0-24-48 0 0-48 57.8 0c7.8 0 14.2-6.3 14.2-14.2 0-5.8-3.5-11-8.9-13.1l-32-12.8c-23.6-9.4-39.1-32.3-39.1-57.7 0-32.3 24.6-58.8 56-61.9l0-24.3 32 0zM104 144l48 0c39.8 0 72 32.2 72 72 0 26.9-14.7 50.3-36.5 62.6l26.8 80.5-45.5 15.2C166 366 156.4 337.2 140 288l-12 0 0 80-48 0 0-224 24 0zm48 96c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0 48 24 0z"]
};
var faMagnifyingGlassArrowRight = {
  prefix: 'fass',
  iconName: 'magnifying-glass-arrow-right',
  icon: [576, 512, [], "e521", "M448.3 208c0 45.9-14.9 88.3-40 122.7L534.9 457.4 557.5 480 512.3 525.3 489.6 502.6 363 376c-34.4 25.2-76.8 40-122.7 40-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208zm-111 17l17-17c-2.1-2.1-31.8-31.8-89-89l-17-17-33.9 33.9 48 48-126.1 0 0 48 126.1 0c-23 23-39 39-48 48l33.9 33.9c2.1-2.1 31.8-31.8 89-89z"]
};
var faSplit = {
  prefix: 'fass',
  iconName: 'split',
  icon: [576, 512, [], "e254", "M416.1-30.5C449.7-1.2 488.7 33 533.2 71.9L560.7 96c-31 27.1-133.9 117.1-144.6 126.5l0-94.5-50.7 0-128 128 128 128 50.7 0 0-94.5c33.6 29.4 72.6 63.5 117.1 102.4L560.7 416c-31 27.1-133.9 117.1-144.6 126.5l0-94.5-77.3 0-9.4-9.4-150.6-150.6-146.7 0 0-64 146.7 0 150.6-150.6 9.4-9.4 77.3 0 0-94.5z"]
};
var faFacePensive = {
  prefix: 'fass',
  iconName: 'face-pensive',
  icon: [512, 512, [], "e384", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm64-224c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-16 32 0 0 16c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-16 32 0 0 16zM152 312l16 0c13.3 0 24-10.7 24-24l0-16 32 0 0 16c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-16 32 0 0 16c0 13.3 10.7 24 24 24zm64 72l104 0 0 48-128 0 0-48 24 0zM83.9 204.9l15.6-12.5 80-64 15.6-12.5 25 31.2-15.6 12.5-80 64-15.6 12.5-25-31.2zm328.6-12.5l15.6 12.5-25 31.2-15.6-12.5-80-64-15.6-12.5 25-31.2 15.6 12.5 80 64z"]
};
var faBookCircleArrowUp = {
  prefix: 'fass',
  iconName: 'book-circle-arrow-up',
  icon: [576, 512, [], "e0bd", "M32 0l448 0 0 214c-15.3-3.9-31.4-6-48-6-100.6 0-183.2 77.4-191.3 176L128 384c-17.7 0-32 14.3-32 32l0 32 150 0c6 23.3 16.3 45 30 64L32 512 32 0zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM364.7 380.7l56-56 11.3-11.3 11.3 11.3 56 56 11.3 11.3-22.6 22.6c-4.6-4.6-18-18-40-40l0 105.4-32 0 0-105.4c-22 22-35.4 35.4-40 40l-22.6-22.6 11.3-11.3z"]
};
var faShipLarge = {
  prefix: 'fass',
  iconName: 'ship-large',
  icon: [640, 512, [], "e810", "M449.3 417.7l111.8 44.7c29.3-9.8 50.1-16.7 62.5-20.8l15.2 45.5c-9.6 3.2-35.9 12-79.1 26.4l-8.2-3.3-111.1-44.4-120 48-120-48-111.1 44.4-8.2 3.3C37.9 499.2 11.6 490.4 2 487.2l15.2-45.5c12.4 4.1 33.2 11 62.4 20.8l111.8-44.7 8.9-3.6 120 48 120-48 8.9 3.6zM325.4 88.5l224 48 28.7 6.2-11.8 26.9-54 123.4 0 98.4c-33.3-13.3-57.2-22.9-72-28.8-10.7 4.3-42.8 17.1-96 38.4l0-257-48 0 0 257c-53.3-21.3-85.2-34.1-96-38.4-14.7 5.9-38.8 15.5-72 28.8l0-98.4-54-123.4-11.8-26.9 28.8-6.2 224-48 5-1.1 5 1.1zM344.4 0l136 0 0 80.8-146.6-31.4-13.4-2.8-13.4 2.8-146.6 31.4 0-80.8 136 0 0-32 48 0 0 32z"]
};
var faHeartHalf = {
  prefix: 'fass',
  iconName: 'heart-half',
  icon: [512, 512, [], "e1ab", "M256.5 107.8l-15-20.7C216.5 52.5 176.3 32 133.6 32 60.1 32 .5 91.6 .5 165.1 .5 301.9 154 425.3 256.5 496l0-388.2z"]
};
var faCircleLira = {
  prefix: 'fass',
  iconName: 'circle-lira',
  icon: [512, 512, [], "e6f6", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM175.5 200c0-46.5 37.5-88 88.1-88l2.2 0c19.7 0 38.8 6.4 54.5 18.2l14.2 10.6-28.8 38.4-14.2-10.6C284 163 275 160 265.7 160l-2.2 0c-23 0-40.1 18.9-40 40l96.5 0 0 32-87.5 0c2.1 7.9 3.2 16 3.5 24l84 0 0 32-88 0c-3.2 11.3-8.3 22.1-15.1 32l135.1 0 0 48-200 0 0-42.5c1.1-1.4 9-11.6 23.7-30.5 1.7-2.2 3.3-4.6 4.7-7l-20.4 0 0-32 27.9 0c-.4-6.4-1.8-12.9-4.3-19l-1.4-3.5c-.2-.5-.4-1-.6-1.5l-21.6 0 0-32 15.5 0z"]
};
var faMicrophoneLines = {
  prefix: 'fass',
  iconName: 'microphone-lines',
  icon: [384, 512, [127897, "microphone-alt"], "f3c9", "M96 0l192 0 0 88-80 0 0 48 80 0 0 48-80 0 0 48 79.7 0c-4.1 49.3-45.3 88-95.7 88-53 0-96-43-96-96L96 0zM48 160l0 64c0 79.5 64.5 144 144 144s144-64.5 144-144l0-64 48 0 0 64c0 97.9-73.3 178.7-168 190.5l0 49.5 72 0 0 48-192 0 0-48 72 0 0-49.5C73.3 402.7 0 321.9 0 224l0-64 48 0z"]
};
var faMicrophoneAlt = faMicrophoneLines;
var faReplyAll = {
  prefix: 'fass',
  iconName: 'reply-all',
  icon: [640, 512, ["mail-reply-all"], "f122", "M384.3 432l-224-224 224-224 0 144 48 0c97.2 0 176 78.8 176 176 0 128-128 176-128 176s32-32 32-80c0-61.9-50.1-112-112-112l-16 0 0 144zM265.3 31.6L88.9 208 265.3 384.4 231.3 418.3 38 225 21 208 38 191 231.3-2.3 265.3 31.6z"]
};
var faMailReplyAll = faReplyAll;
var faSquareList = {
  prefix: 'fass',
  iconName: 'square-list',
  icon: [448, 512, [], "e489", "M0 32l448 0 0 448-448 0 0-448zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-280l-24 0 0 48 208 0 0-48-184 0zm0 112l-24 0 0 48 208 0 0-48-184 0zm0 112l-24 0 0 48 208 0 0-48-184 0z"]
};
var faUniversalAccess = {
  prefix: 'fass',
  iconName: 'universal-access',
  icon: [512, 512, [], "f29a", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm161.5-86.1l-22.1-9.5-18.9 44.1c16.4 7 27.7 11.9 33.9 14.5 17.3 7.4 35.2 12.9 53.6 16.3l0 56.6c-24.4 73.1-37.2 111.5-38.4 115.1l45.5 15.2c1.9-5.7 13.3-39.8 34.1-102.4l13.4 0c20.8 62.5 32.2 96.6 34.1 102.4l45.5-15.2c-1.2-3.6-14-42-38.4-115.1l0-56.6c18.4-3.5 36.3-8.9 53.6-16.3 6.2-2.7 17.5-7.5 33.9-14.5l-18.9-44.1c-16.4 7-27.7 11.9-33.9 14.5-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faShieldCross = {
  prefix: 'fass',
  iconName: 'shield-cross',
  icon: [512, 512, [9960], "f712", "M267.6 4.5L256 0 244.5 4.5 37 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.3 91 150 189.4 192.6l12.7 5.5 12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9L494.3 92.5 475.1 85 267.6 4.5zM224 81.1l32-12.4 32 12.4 0 78.9 143 0c-1.5 19.5-4.7 41.3-10.1 64l-132.9 0 0 199.8c-10 6.5-20.7 12.6-32 18.1-11.3-5.5-22-11.6-32-18.1l0-199.8-132.8 0c-5.4-22.7-8.6-44.5-10.1-64l142.9 0 0-78.9z"]
};
var faTrainStop = {
  prefix: 'fass',
  iconName: 'train-stop',
  icon: [640, 512, [], "e81f", "M352 416l-56.7 0 47.6 61.3 2.1 2.7-60.8 0-49.8-64-84.9 0-49.8 64-60.8 0 2.1-2.7 47.6-61.3-56.7 0 0-352 320 0 0 352zM512 0c61.9 0 112 50.1 112 112 0 50.7-33.7 93.5-80 107.3l0 260.7-64 0 0-260.7c-46.3-13.8-80-56.6-80-107.3 0-61.9 50.1-112 112-112zM192 304a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM96 256l192 0 0-128-192 0 0 128z"]
};
var faToiletPaper = {
  prefix: 'fass',
  iconName: 'toilet-paper',
  icon: [512, 512, [129531, 63263, "toilet-paper-alt", "toilet-paper-blank"], "f71e", "M327.1 32c-8.8 11.1-16 23.1-21.9 34.8-21.4 42.7-33.2 98.4-33.2 157.2l0 320-272 0 0-320C0 118 43 32 96 32l231.1 0zM416 416c-53 0-96-86-96-192s43-192 96-192 96 86 96 192-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64-32 28.7-32 64 14.3 64 32 64z"]
};
var faToiletPaperAlt = faToiletPaper;
var faToiletPaperBlank = faToiletPaper;
var faSquareCode = {
  prefix: 'fass',
  iconName: 'square-code',
  icon: [448, 512, [], "e267", "M0 32l448 0 0 448-448 0 0-448zM246.1 176c3.6 3.6 30.3 30.3 80 80-49.7 49.7-76.4 76.4-80 80l33.9 33.9 17-17 80-80 17-17-17-17c-63.8-63.8-96.2-96.2-97-97L246.1 176zM185 193l17-17-33.9-33.9c-.8 .8-33.1 33.1-97 97l-17 17c.8 .8 33.1 33.1 97 97l17 17 33.9-33.9c-3.6-3.6-30.3-30.3-80-80l63-63z"]
};
var faVrCardboard = {
  prefix: 'fass',
  iconName: 'vr-cardboard',
  icon: [576, 512, [], "f729", "M576 96l-576 0 0 320 208 0 64-64 32 0 64 64 208 0 0-320zM80 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm352-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faPizzaSlice = {
  prefix: 'fass',
  iconName: 'pizza-slice',
  icon: [512, 512, [], "f818", "M97.9 120.3L0 512 391.7 414.1c.2-4.7 .3-9.4 .3-14.1 0-154.6-125.4-280-280-280-4.7 0-9.4 .1-14.1 .3zM440 402l72-18C512 171.9 340.1 0 128 0L110 72c.7 0 1.3 0 2 0 181.1 0 328 146.9 328 328 0 .7 0 1.3 0 2zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSprayCan = {
  prefix: 'fass',
  iconName: 'spray-can',
  icon: [576, 512, [], "f5bd", "M288 0l0 112-128 0 0-112 128 0zM64 256c0-53 43-96 96-96l128 0c53 0 96 43 96 96l0 256-320 0 0-256zm240 80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM320 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM512 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faNfcTrash = {
  prefix: 'fass',
  iconName: 'nfc-trash',
  icon: [576, 512, [], "e1fd", "M480 32l-448 0 0 448 274.9 0-4.9-64-206 0 0-320 88 0 0 48-40 0 0 224 128 0 0-66.7c-5 1.8-10.4 2.7-16 2.7-26.5 0-48-21.5-48-48 0-17.8 9.7-33.3 24-41.6l0-118.4 184 0 0 80 64 0 0-144zM368 176l0-32-88 0 0 64 67.5 0 16-32 4.5 0zm25.2 48.1c-4 7.9-9.3 18.6-16 32l-57.2 0 0 48 256 0 0-48-57.2 0c-6.7-13.4-12-24.1-16-32l-109.7 0zM360 544.1l176 0 16-208-208 0 16 208z"]
};
var faTemperatureList = {
  prefix: 'fass',
  iconName: 'temperature-list',
  icon: [512, 512, [], "e299", "M64 0l192 0 0 260.7c29.5 26.4 48 64.7 48 107.3 0 79.5-64.5 144-144 144S16 447.5 16 368c0-42.6 18.5-81 48-107.3L64 0zm96 432c35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3l0-116.7-48 0 0 116.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64zM352 32l128 0 0 64-160 0 0-64 32 0zm0 128l128 0 0 64-160 0 0-64 32 0zm0 128l128 0 0 64-128 0 0-64z"]
};
var faShovelSnow = {
  prefix: 'fass',
  iconName: 'shovel-snow',
  icon: [640, 512, [], "f7c3", "M502.6-22.6L480-45.3c-11.5 11.5-33.8 33.8-66.7 66.7-18.7 18.7-29.3 44.1-29.3 70.6 0 15.9 3.7 30.9 10.3 44.3l-113 113-89.4-89.4-192 224 192 192 224-192-89.4-89.4 113-113c13.4 6.6 28.4 10.3 44.3 10.3 26.5 0 51.9-10.5 70.6-29.3 33-33 55.2-55.2 66.7-66.7-2.9-2.9-42.4-42.4-118.6-118.6zM458.5 66.7L480 45.3 530.7 96 509.3 117.5c-6.7 6.7-15.9 10.5-25.4 10.5-19.8 0-35.9-16.1-35.9-35.9 0-9.5 3.8-18.6 10.5-25.4zM225 321l-80 80-17 17-33.9-33.9c.8-.8 33.1-33.1 97-97l17-17 33.9 33.9-17 17zm64 64l-80 80-17 17-33.9-33.9c.8-.8 33.1-33.1 97-97l17-17 33.9 33.9-17 17z"]
};
var faVolumeLow = {
  prefix: 'fass',
  iconName: 'volume-low',
  icon: [448, 512, [128264, "volume-down"], "f027", "M0 352l96 0 192 152 0-496-192 152-96 0 0 192zM350.3 218.7C361.1 227.6 368 241 368 256s-6.9 28.4-17.7 37.3l-9.4 7.6 28.8 38.4 10.9-8.8C402.1 312.9 416 286.1 416 256s-13.9-56.9-35.4-74.5l-10.9-8.8-28.8 38.4 9.4 7.6z"]
};
var faVolumeDown = faVolumeLow;
var faSolarSystem = {
  prefix: 'fass',
  iconName: 'solar-system',
  icon: [512, 512, [], "e02f", "M182.9 61.2c74-27.7 160.6-11.8 220.2 47.7 71.8 71.8 80.1 182.9 25.1 263.8-14.8-2.5-30.6 1.9-42.1 13.4-18.7 18.7-18.7 49.1 0 67.9s49.1 18.7 67.9 0c13.6-13.6 17.3-33.4 11.2-50.3 70.7-99.9 61.3-239.2-28.2-328.7-76-76-187.9-94.2-281.2-54.7 1.3 1.2 2.7 2.5 4 3.7 10.8 10.8 18.5 23.6 23.1 37.1zm-74 341.9c-71.8-71.8-80.1-182.9-25.1-263.8 14.8 2.5 30.6-1.9 42.1-13.4 18.7-18.7 18.7-49.1 0-67.9S76.8 39.3 58 58c-13.6 13.6-17.3 33.4-11.2 50.3-70.7 99.9-61.3 239.2 28.2 328.7 76 76 187.9 94.2 281.2 54.7-1.3-1.2-2.7-2.5-4-3.8-10.8-10.8-18.5-23.6-23.1-37.1-74 27.7-160.6 11.8-220.2-47.7zM256 320l64-64-64-64-64 64 64 64zm0-176c20.5 0 39.7 5.5 56.2 15.1-.2 10.5 3.7 21 11.7 29s18.6 11.9 29 11.7c9.6 16.5 15.1 35.7 15.1 56.2 0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112zm86.1-22.9C317.2 105.2 287.7 96 256 96 167.6 96 96 167.6 96 256s71.6 160 160 160 160-71.6 160-160c0-31.7-9.2-61.2-25.1-86.1 3.4-13.3 0-28-10.4-38.4s-25.1-13.9-38.4-10.4z"]
};
var faCross = {
  prefix: 'fass',
  iconName: 'cross',
  icon: [384, 512, [128327, 10013], "f654", "M256 0l-128 0 0 128-128 0 0 128 128 0 0 256 128 0 0-256 128 0 0-128-128 0 0-128z"]
};
var faPerson = {
  prefix: 'fass',
  iconName: 'person',
  icon: [384, 512, [129485, "male"], "f183", "M136.2 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-11.4 88l134.8 0 9.6 13.2c74.3 102.4 111.5 153.6 111.7 153.9l-51.8 37.6c-9.3-12.8-28.3-39-56.9-78.4l0 305.7-64 0 0-208-32 0 0 208-64 0 0-305.7c-28.6 39.4-47.6 65.6-56.9 78.4l-51.8-37.6 18.8-25.9 92.9-128 9.6-13.2z"]
};
var faMale = faPerson;
var faMp3Player = {
  prefix: 'fass',
  iconName: 'mp3-player',
  icon: [384, 512, [], "f8ce", "M0 0L384 0 384 512 0 512 0 0zM192 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM320 64l-256 0 0 128 256 0 0-128z"]
};
var faCircleBolt = {
  prefix: 'fass',
  iconName: 'circle-bolt',
  icon: [512, 512, [], "e0fe", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM120 272l200-168-32.4 136 104.4 0-200 168 32.4-136-104.4 0z"]
};
var faHourglass = {
  prefix: 'fass',
  iconName: 'hourglass',
  icon: [384, 512, [9203, 62032, "hourglass-empty"], "f254", "M32 0l-32 0 0 64 32 0 0 77.3 9.4 9.4 105.4 105.4-105.4 105.4-9.4 9.4 0 77.3-32 0 0 64 384 0 0-64-32 0 0-77.3-114.7-114.7 105.4-105.4 9.4-9.4 0-77.3 32 0 0-64-352 0zM288 64l0 50.7-96 96-96-96 0-50.7 192 0zM192 301.3l96 96 0 50.7-192 0 0-50.7 96-96z"]
};
var faHourglassEmpty = faHourglass;
var faTrashCanSlash = {
  prefix: 'fass',
  iconName: 'trash-can-slash',
  icon: [576, 512, ["trash-alt-slash"], "e2ad", "M32.3-33.8c6 6 27.9 27.9 65.8 65.8l94 0 16-48 160 0 16 48 128 0 0 64-350 0 48 48 270 0 0 270 81.2 81.2 17 17-33.9 33.9-17-17-512-512-17-17 33.9-33.9zM416.1 350l0-142-48 0 0 94 48 48zm-152-16.1l0 114.2 48 0 0-66.2 130.2 130.2-346.2 0 0-346.2 64 64 0 218.2 48 0 0-170.2 56 56z"]
};
var faTrashAltSlash = faTrashCanSlash;
var faUserBeard = {
  prefix: 'fass',
  iconName: 'user-beard',
  icon: [448, 512, [], "e7a8", "M200 0l48 0c57.4 0 104 46.6 104 104l0 8 32 88 0 40-32 32 0 32-48 48-32 0-32 32-32 0-32-32-32 0-48-48 0-32-32-32 0-40 32-88 0-8C96 46.6 142.6 0 200 0zM304 128c0-11.4-2.4-22.2-6.7-32l-41.3 0-32-32-32 32-41.3 0c-4.3 9.8-6.7 20.6-6.7 32l0 16c0 12.7 3 24.8 8.3 35.5 20.4-20.4 30.8-30.8 31.5-31.5l80.6 0 5.9 5.9 25.6 25.6c5.3-10.7 8.3-22.7 8.3-35.5l0-16zm-40 85.3c1.9-1.1 3.8-2.3 5.5-3.5l-21.8-21.8-47.4 0-21.8 21.8c1.8 1.2 3.6 2.4 5.5 3.5 11.8 6.8 25.4 10.7 40 10.7s28.2-3.9 40-10.7zM16 512L71 346.9c30.2 30.2 47.9 47.9 53.1 53.1l32 0c12.6 12.6 23.3 23.3 32 32l71.8 0c8.7-8.7 19.4-19.4 32-32l32 0c5.2-5.2 22.9-22.9 53.1-53.1L432 512 16 512z"]
};
var faFish = {
  prefix: 'fass',
  iconName: 'fish',
  icon: [576, 512, [128031], "f578", "M336 80c-89.4 0-153.8 54.9-193.2 103.4L32 128 0 160 48 256 0 352 32 384 142.8 328.6C182.2 377.1 246.6 432 336 432 496 432 576 256 576 256S496 80 336 80zm80 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faDrumstickBite = {
  prefix: 'fass',
  iconName: 'drumstick-bite',
  icon: [512, 512, [], "f6d7", "M160 176l0 102.5-58.4 58.3C90.9 326.4 76.2 320 60 320 26.9 320 0 346.9 0 380s26.9 60 60 60l12 0 0 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-16.2-6.4-30.9-16.8-41.7L233.5 352 336 352c34.3 0 66.3-9.8 93.4-26.8-8.6-15.8-13.4-33.9-13.4-53.2 0-56.2 41.4-102.8 95.4-110.8-7.5-90.3-83.2-161.2-175.4-161.2-97.2 0-176 78.8-176 176z"]
};
var faFileJpg = {
  prefix: 'fass',
  iconName: 'file-jpg',
  icon: [576, 512, [], "e646", "M272 0l-240 0 0 512 144 0 0-176 240 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM272 548c28.7 0 52-23.3 52-52l0-116-40 0 0 116c0 6.6-5.4 12-12 12s-12-5.4-12-12l0-16-40 0 0 16c0 28.7 23.3 52 52 52zm96-168l-20 0 0 168 40 0 0-48 12 0c33.1 0 60-26.9 60-60s-26.9-60-60-60l-32 0zm32 80l-12 0 0-40 12 0c11 0 20 9 20 20s-9 20-20 20zm76-36l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-44-48 0 0 40 8 0 0 4c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 8 40 0 0-8c0-24.3-19.7-44-44-44l-16 0c-24.3 0-44 19.7-44 44z"]
};
var faChartSimple = {
  prefix: 'fass',
  iconName: 'chart-simple',
  icon: [512, 512, [], "e473", "M192 32l128 0 0 448-128 0 0-448zM0 224l128 0 0 256-128 0 0-256zM512 96l0 384-128 0 0-384 128 0z"]
};
var faCircleEllipsisVertical = {
  prefix: 'fass',
  iconName: 'circle-ellipsis-vertical',
  icon: [512, 512, [], "e10b", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm32-320l-64 0 0-64 64 0 0 64zm0 192l-64 0 0-64 64 0 0 64zm0-160l0 64-64 0 0-64 64 0z"]
};
var faAtom = {
  prefix: 'fass',
  iconName: 'atom',
  icon: [448, 512, [9883], "f5d2", "M224 328c9.4-4.8 19-10.2 28.8-16 12.1-7.3 23.6-14.8 34.2-22.4 .7-10.8 1-22 1-33.6s-.4-22.7-1-33.6c-10.6-7.6-22.1-15.1-34.2-22.4-9.7-5.8-19.3-11.2-28.8-16-9.4 4.8-19 10.2-28.8 16-12.1 7.3-23.6 14.8-34.2 22.4-.7 10.8-1 22-1 33.6s.4 22.7 1 33.6c10.6 7.6 22.1 15.1 34.2 22.4 9.7 5.8 19.3 11.2 28.8 16zm190-72c33 45.2 44.3 90.9 23.6 128-20.2 36.3-62.5 49.3-115.2 43.2-22 52.1-55.7 84.8-98.4 84.8s-76.4-32.7-98.4-84.8C72.9 433.3 30.6 420.3 10.4 384-10.3 346.9 1 301.2 34 256 1 210.8-10.3 165.1 10.4 128 30.6 91.7 72.9 78.7 125.6 84.8 147.6 32.7 181.2 0 224 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2 20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2 31.8 1.4 38.6-8.7 40.2-11.7 2.3-4.2 7-17.9-11.9-48.1-6.8 6.3-14 12.5-21.6 18.6zM224 398.8c-11.8 5.1-23.4 9.7-34.9 13.5 16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM341.5 147.5c2.8 13.1 5 26.9 6.7 41.2 7.6 6.1 14.8 12.3 21.6 18.6 18.9-30.2 14.2-44 11.9-48.1-1.6-2.9-8.4-13-40.2-11.7zM258.9 99.7C242.1 65.9 227.9 64 224 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5 11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2-31.8-1.4-38.6 8.7-40.2 11.7-2.3 4.2-7 17.9 11.9 48.1 6.8-6.3 14-12.5 21.6-18.6zM78.2 304.8c-18.9 30.2-14.2 44-11.9 48.1 1.6 2.9 8.4 13 40.2 11.7-2.8-13.1-5-26.9-6.7-41.2-7.6-6.1-14.8-12.3-21.6-18.6zM224 296l-40-40 40-40 40 40-40 40z"]
};
var faSquareMalaysianRinggit = {
  prefix: 'fass',
  iconName: 'square-malaysian-ringgit',
  icon: [448, 512, [], "e748", "M448 32l-448 0 0 448 448 0 0-448zM88 160l54.7 0c37.6 0 68 30.4 68 68 0 24.1-12.5 45.2-31.4 57.3 12.7 22.2 22.5 39.4 29.5 51.6l-41.7 23.8c-5.7-10-18.1-31.6-37-64.7l-18.1 0 0 56-48 0 0-192 24 0zm54.7 88c11 0 20-9 20-20s-9-20-20-20l-30.7 0 0 40 30.7 0zM224 352l0-192 42.1 0c.8 1.2 13.5 19.3 37.9 54.1 24.4-34.9 37.1-52.9 37.9-54.1l42.1 0 0 192-48 0 0-99.9c-7 10-17.7 25.2-32 45.7-14.3-20.5-25-35.7-32-45.7l0 99.9-48 0z"]
};
var faPrintMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'print-magnifying-glass',
  icon: [640, 512, ["print-search"], "f81a", "M400.4 0l80 80 0 64-384 0 0-144 304 0zM32.4 192l408 0 0 .1c-90.1 0-163.6 70.9-167.8 159.9l-112.2 0 0 96 136.8 0c17 27.7 41.8 50 71.3 64l-272.2 0 0-128-64 0 0-192zm408 240.1a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 48c-66.3 0-120-53.7-120-120s53.7-120 120-120 120 53.7 120 120c0 24.5-7.3 47.2-19.9 66.2 47.9 47.9 73.8 73.8 77.8 77.8L584.4 538c-4-4-29.9-29.9-77.8-77.8-19 12.6-41.7 19.9-66.2 19.9z"]
};
var faPrintSearch = faPrintMagnifyingGlass;
var faImagePolaroid = {
  prefix: 'fass',
  iconName: 'image-polaroid',
  icon: [448, 512, [], "f8c4", "M448 32l-448 0 0 448 448 0 0-448zM384 96l0 256-320 0 0-256 320 0zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM352 272l-128-112-128 112 0 48 256 0 0-48z"]
};
var faSquareTerminal = {
  prefix: 'fass',
  iconName: 'square-terminal',
  icon: [448, 512, [], "e32a", "M0 32l448 0 0 448-448 0 0-448zM54.1 176l80 80c-49.7 49.7-76.4 76.4-80 80l33.9 33.9 17-17c63.8-63.8 96.2-96.2 97-97-.8-.8-33.1-33.1-97-97l-17-17-33.9 33.9zM216 336l-24 0 0 48 192 0 0-48-168 0z"]
};
var faLightbulbMessage = {
  prefix: 'fass',
  iconName: 'lightbulb-message',
  icon: [576, 512, [], "e687", "M240 240l0 144-144 0 0-25.7C38.6 325.1 0 263.1 0 192 0 86 86 0 192 0S384 86 384 192c0 16.6-2.1 32.7-6 48l-138 0zM96 432l144 0 0 96-144 0 0-96zm88-320l8 0 0-48-8 0C117.7 64 64 117.7 64 184l0 8 48 0 0-8c0-39.8 32.2-72 72-72zM576 288l0 224-96 0-48 64-48-64-96 0 0-224 288 0z"]
};
var faPersonLimbsWide = {
  prefix: 'fass',
  iconName: 'person-limbs-wide',
  icon: [448, 512, [], "e787", "M168 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM144 179l-130-88.6 36-52.9 132.8 90.4 82.4 0 132.8-90.4 36 52.9-130 88.6 0 135.3 62.1 170.7 10.9 30.1-60.1 21.9-10.9-30.1-56.3-154.9-51.2 0-56.3 154.9-10.9 30.1-60.1-21.9 10.9-30.1 62.1-170.7 0-135.3z"]
};
var faHandsHoldingDiamond = {
  prefix: 'fass',
  iconName: 'hands-holding-diamond',
  icon: [640, 512, ["hand-receiving"], "f47c", "M320 256L448 128 320 0 192 128 320 256zM80 64l-80 0 0 301.3 9.4 9.4 128 128 9.4 9.4 141.3 0 0-173.3-9.4-9.4C125.1 175.9 201.5 252.2 160 210.7L114.7 256c48.8 48.8 65.1 65.1 91 91L164.1 374.8 80 290.7 80 64zm480 0l0 226.7-84.1 84.1-41.7-27.8c102.9-102.9 58.7-58.7 91-91L480 210.7c-44.2 44.2-69.7 69.7-118.6 118.6l-9.4 9.4 0 173.3 141.3 0 9.4-9.4 128-128 9.4-9.4 0-301.3-80 0z"]
};
var faHandReceiving = faHandsHoldingDiamond;
var faCircleJ = {
  prefix: 'fass',
  iconName: 'circle-j',
  icon: [512, 512, [], "e112", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm80-344l0 112c0 48.6-39.4 88-88 88s-88-39.4-88-88l0-24 48 0 0 24c0 22.1 17.9 40 40 40s40-17.9 40-40l0-136 48 0 0 24z"]
};
var faPedestal = {
  prefix: 'fass',
  iconName: 'pedestal',
  icon: [448, 512, [], "e20d", "M416 0l-384 0 0 448-32 0 0 64 448 0 0-64-32 0 0-448zM128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM296 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faP = {
  prefix: 'fass',
  iconName: 'p',
  icon: [320, 512, [112], "50", "M64 288l96 0c53 0 96-43 96-96s-43-96-96-96l-96 0 0 192zM0 352L0 32 160 32c88.4 0 160 71.6 160 160S248.4 352 160 352l-96 0 0 128-64 0 0-128z"]
};
var faSquareEquals = {
  prefix: 'fass',
  iconName: 'square-equals',
  icon: [448, 512, [], "e6b6", "M448 32l-448 0 0 448 448 0 0-448zM128 176l192 0 0 48-192 0 0-48zm0 112l192 0 0 48-192 0 0-48z"]
};
var faDagger = {
  prefix: 'fass',
  iconName: 'dagger',
  icon: [384, 512, [], "f6cb", "M224-32l0 128 160 0 0 48c0 26.5-21.5 48-48 48-20.9 0-38.7-13.4-45.3-32L93.3 160c-6.6 18.6-24.4 32-45.3 32-26.5 0-48-21.5-48-48l0-48 160 0 0-128 64 0zM128 208l128 0 0 272-64 64-64-64 0-272z"]
};
var faJetFighterUp = {
  prefix: 'fass',
  iconName: 'jet-fighter-up',
  icon: [512, 512, [], "e518", "M200 64l0 118-152 114 0-72-48 0 0 192 48 0 0-32 152 0 0 54.4-72 57.6 0 48 104 0 0-64 48 0 0 64 104 0 0-48-72-57.6 0-54.4 152 0 0 32 48 0 0-192-48 0 0 72-152-114 0-118-40-96-32 0-40 96z"]
};
var faFieldHockeyStickBall = {
  prefix: 'fass',
  iconName: 'field-hockey-stick-ball',
  icon: [576, 512, [127953, "field-hockey"], "f44c", "M464.1 544a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm-2.9-345.5L297 447.1c-26.7 40.5-72 64.9-120.5 64.9-79.8 0-144.4-64.7-144.4-144.4l0-79.6 112 0 0 79.6c0 17.9 14.5 32.4 32.4 32.4 10.9 0 21.1-5.5 27.1-14.6l162.6-246.3 95 59.4zM565.7 40.1c-17.8 27-43.9 66.4-78.1 118.3L392.6 99c35.5-53.8 62-94 79.6-120.6l93.5 61.7z"]
};
var faFieldHockey = faFieldHockeyStickBall;
var faComputerMouseButtonRight = {
  prefix: 'fass',
  iconName: 'computer-mouse-button-right',
  icon: [384, 512, [], "e7ce", "M168 216L168 0 0 0 0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-112-216 0 0-24zm216-24l0-192-168 0 0 192 168 0z"]
};
var faPlugCircleXmark = {
  prefix: 'fass',
  iconName: 'plug-circle-xmark',
  icon: [640, 512, [], "e560", "M224-32l0 128 128 0 0-128 64 0 0 128 96 0 0 64-32 0 0 48.7c-98.6 8.1-176 90.7-176 191.3 0 27.3 5.7 53.3 16 76.9l0 35.1-64 0 0-98.7C165.2 398.1 96 319.1 96 224l0-64-32 0 0-64 96 0 0-128 64 0zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm55.3 111.3L562.6 356 540 333.4c-4 4-18.7 18.6-44 44-25.4-25.4-40-40-44-44L429.4 356c4 4 18.6 18.7 44 44-25.4 25.4-40 40-44 44L452 466.6c4-4 18.7-18.6 44-44 25.4 25.4 40 40 44 44L562.6 444c-4-4-18.6-18.7-44-44l32.7-32.7z"]
};
var faSheetPlastic = {
  prefix: 'fass',
  iconName: 'sheet-plastic',
  icon: [384, 512, [], "e571", "M0 0L0 512 240 512 384 368 384 0 0 0zM208 453.5L208 336 325.5 336 208 453.5zM153 105c-37.2 37.2-58.8 58.8-65 65L54.1 136c6.1-6.1 27.8-27.8 65-65l17-17 33.9 33.9-17 17zm96 32l-112 112-17 17-33.9-33.9 17-17 112-112 17-17 33.9 33.9-17 17z"]
};
var faV = {
  prefix: 'fass',
  iconName: 'v',
  icon: [384, 512, [118], "56", "M0 32L162.1 459.4 169.9 480 214.1 480 221.9 459.4 384 32 315.6 32 192 357.8 68.4 32 0 32z"]
};
var faList = {
  prefix: 'fass',
  iconName: 'list',
  icon: [512, 512, ["list-squares"], "f03a", "M112 48l-96 0 0 96 96 0 0-96zm80 16l-32 0 0 64 352 0 0-64-320 0zm0 160l-32 0 0 64 352 0 0-64-320 0zm0 160l-32 0 0 64 352 0 0-64-320 0zM16 208l0 96 96 0 0-96-96 0zm96 160l-96 0 0 96 96 0 0-96z"]
};
var faListSquares = faList;
var faOliveBranch = {
  prefix: 'fass',
  iconName: 'olive-branch',
  icon: [640, 512, [], "e317", "M128 0C48 0 0 64 0 64s31.2 36.4 85.2 50.5C34.5 141.4 0 194.6 0 256l0 32 32 0c86.6 0 157.1-68.7 159.9-154.6L373.4 48 640 48 640 0 368 0c-3.5 0-7 .8-10.2 2.3L247.4 54.2C230.3 36.3 188.2 0 128 0zM336 512c79.5 0 144-86 144-192s-64.5-192-144-192-144 86-144 192 64.5 192 144 192zm129.7-40.2c52.9 16.5 105.5 8.4 139.6-27 56.2-58.3 41-168.6-33.9-246.4-42.9-44.5-96.1-68.7-144.2-70.3 13.6 10.4 25.7 22.9 36.2 36.9 30.6 40.8 48.6 95.7 48.6 155 0 57.8-17.1 111.4-46.3 151.8z"]
};
var faGif = {
  prefix: 'fass',
  iconName: 'gif',
  icon: [512, 512, [], "e190", "M512 64l-512 0 0 384 512 0 0-384zM120 216l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-56 48 0 0 56c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-80c0-30.9 25.1-56 56-56l64 0 0 48-64 0c-4.4 0-8 3.6-8 8zm168-56l0 192-48 0 0-192 48 0zm64 0l104 0 0 48-80 0 0 32 64 0 0 48-64 0 0 64-48 0 0-192 24 0z"]
};
var faHoseReel = {
  prefix: 'fass',
  iconName: 'hose-reel',
  icon: [576, 512, [], "e41a", "M288 64C182 64 96 150 96 256s86 192 192 192c40.8 0 78.6-12.7 109.7-34.4l36.6 52.5C392.8 495 342.3 512 288 512 146.6 512 32 397.4 32 256S146.6 0 288 0 544 114.6 544 256l0 96 32 0 0 48-26.3 0-9.1 64 19.4 0 0 48-96 0 0-48 19.4 0-9.1-64-26.3 0 0-48 32 0 0-96c0-106-86-192-192-192zm0 282a90 90 0 1 0 0-180 90 90 0 1 0 0 180zm0-234a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM240 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faCircleS = {
  prefix: 'fass',
  iconName: 'circle-s',
  icon: [512, 512, [], "e121", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM234.5 144l93.5 0 0 48-93.5 0c-10.2 0-18.5 8.3-18.5 18.5 0 9.3 6.9 17.2 16.2 18.3l53.6 6.7c33.3 4.2 58.2 32.4 58.2 66 0 36.7-29.8 66.5-66.5 66.5l-101.5 0 0-48 101.5 0c10.2 0 18.5-8.3 18.5-18.5 0-9.3-6.9-17.2-16.2-18.3l-53.6-6.7c-33.3-4.2-58.2-32.4-58.2-66 0-36.7 29.8-66.5 66.5-66.5z"]
};
var faSquareM = {
  prefix: 'fass',
  iconName: 'square-m',
  icon: [448, 512, [], "e276", "M448 32l-448 0 0 448 448 0 0-448zM112 168l0-24 36.2 0 7.2 9.8 68.6 93.6 68.6-93.6 7.2-9.8 36.2 0 0 224-48 0 0-126.7c-34 46.3-55.3 75.4-64 87.3-8.7-11.8-30-40.9-64-87.3l0 126.7-48 0 0-200z"]
};
var faCircleCaretLeft = {
  prefix: 'fass',
  iconName: 'circle-caret-left',
  icon: [512, 512, ["caret-circle-left"], "f32e", "M512 256a256 256 0 1 0 -512 0 256 256 0 1 0 512 0zm-360 0l168-136 0 272-168-136z"]
};
var faCaretCircleLeft = faCircleCaretLeft;
var faCircleQuarters = {
  prefix: 'fass',
  iconName: 'circle-quarters',
  icon: [512, 512, [], "e3f8", "M120.2 391.8L256 256 391.8 391.8C426.5 357 448 309 448 256s-21.5-101-56.2-135.8L256 256 120.2 120.2C85.5 155 64 203 64 256s21.5 101 56.2 135.8zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"]
};
var faSolarPanel = {
  prefix: 'fass',
  iconName: 'solar-panel',
  icon: [576, 512, [], "f5ba", "M70.7 32l435.3 0 5.6 25.1 64 288 8.7 38.9-263.9 0 0 64 96 0 0 64-256 0 0-64 96 0 0-64-263.9 0 8.7-38.9 64-288 5.6-25.1zM91.8 232l-19.6 88 106.7 0 7.3-88-94.5 0zm10.7-48l87.8 0 7.3-88-75.6 0-19.6 88zm132 48l-7.3 88 122.5 0-7.3-88-107.8 0zm103.8-48l-7.3-88-85.2 0-7.3 88 99.8 0zm52.2 48l7.3 88 106.7 0-19.6-88-94.5 0zm83.8-48l-19.6-88-75.6 0 7.3 88 87.8 0z"]
};
var faLandMineOn = {
  prefix: 'fass',
  iconName: 'land-mine-on',
  icon: [576, 512, [], "e51b", "M312.3 0l0 152-48 0 0-176 48 0 0 24zm-152 256l256 0 0 64 128 0 0 192-512 0 0-192 128 0 0-64zM25.6 94.7c.6 .4 39.3 26.2 116 77.3l20 13.3-26.6 39.9c-.6-.4-39.3-26.2-116-77.3L-1 134.7 25.6 94.7zM531 108l20-13.3 26.6 39.9-20 13.3c-76.7 51.1-115.3 76.9-116 77.3L415 185.3c.6-.4 39.3-26.2 116-77.3z"]
};
var faBallot = {
  prefix: 'fass',
  iconName: 'ballot',
  icon: [384, 512, [], "f732", "M384 0L0 0 0 512 384 512 384 0zM64 96l64 0 0 64-64 0 0-64zm0 128l64 0 0 64-64 0 0-64zm64 128l0 64-64 0 0-64 64 0zm48 8l144 0 0 48-144 0 0-48zm24-256l120 0 0 48-144 0 0-48 24 0zM176 232l144 0 0 48-144 0 0-48z"]
};
var faGiftCard = {
  prefix: 'fass',
  iconName: 'gift-card',
  icon: [512, 512, [], "f663", "M321.5 68.8C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-73.3 0 34.8-59.2zm-131 0l34.8 59.2-73.3 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zm89.6-24.3l-24.1 41-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0c-48.6 0-88 39.4-88 88 0 14.4 3.5 28 9.6 40l-73.6 0 0 352 512 0 0-352-73.6 0c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4zM448 368l0 48-384 0 0-48 384 0zm0-64l-384 0 0-112 138 0c-8.6 11.5-17.8 23.7-27.6 36.8l38.4 28.8c7.2-9.6 21.6-28.8 43.2-57.6 21.6 28.8 36 48 43.2 57.6l38.4-28.8-27.6-36.8 138 0 0 112z"]
};
var faCircleUserCircleQuestion = {
  prefix: 'fass',
  iconName: 'circle-user-circle-question',
  icon: [640, 512, [], "e7a4", "M496 208c-77.5 0-144.3 45.9-174.6 112l-145.4 0-23.9 71.6c34.8 34.8 82.8 56.4 135.9 56.4 7.4 0 14.6-.4 21.7-1.2 5.5 21.9 14.8 42.4 27.1 60.6-15.8 3-32.1 4.6-48.8 4.6-141.4 0-256-114.6-256-256S146.6 0 288 0c126.8 0 232.1 92.2 252.4 213.2-14.3-3.4-29.1-5.2-44.4-5.2zM288 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm64 128a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-56c13.3 0 24 10.7 24 24 0 7.2-4.2 13.7-10.8 16.6-14.8 6.6-24.6 10.9-29.2 13l0 26.4 32 0 0-5.6 10.2-4.5c18.1-8.1 29.8-26 29.8-45.9 0-30.9-25.1-56-56-56s-56 25.1-56 56l32 0c0-13.3 10.7-24 24-24zM480 480l32 0 0-32-32 0 0 32z"]
};
var faHeadphones = {
  prefix: 'fass',
  iconName: 'headphones',
  icon: [448, 512, [127911, 62863, "headphones-alt", "headphones-simple"], "f025", "M64 224c0-88.4 71.6-160 160-160s160 71.6 160 160l0 32-96 0 0 224 64 0c53 0 96-43 96-96l0-160C448 100.3 347.7 0 224 0S0 100.3 0 224L0 384c0 53 43 96 96 96l64 0 0-224-96 0 0-32z"]
};
var faHeadphonesAlt = faHeadphones;
var faHeadphonesSimple = faHeadphones;
var faBus = {
  prefix: 'fass',
  iconName: 'bus',
  icon: [448, 512, [128653], "f207", "M448 0l-448 0 0 448 48 0 0 64 80 0 0-64 192 0 0 64 80 0 0-64 48 0 0-448zM248 144l136 0 0 112-136 0 0-112zm-48 0l0 112-136 0 0-112 136 0zM96 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM152 48l144 0 0 48-144 0 0-48z"]
};
var faFilePowerpoint = {
  prefix: 'fass',
  iconName: 'file-powerpoint',
  icon: [384, 512, [], "f1c4", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM152 256l-24 0 0 192 48 0 0-48 24 0c39.8 0 72-32.2 72-72s-32.2-72-72-72l-48 0zm48 96l-24 0 0-48 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
var faMessages = {
  prefix: 'fass',
  iconName: 'messages',
  icon: [576, 512, ["comments-alt"], "f4b6", "M0-32l384 0 0 336-176 0-112 80 0-80-96 0 0-336zM192 464l0-89.6 31.4-22.4 208.6 0 0-224 144 0 0 336-96 0 0 80-112-80-176 0z"]
};
var faCommentsAlt = faMessages;
var faCircleRuble = {
  prefix: 'fass',
  iconName: 'circle-ruble',
  icon: [512, 512, [], "e6e5", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 120l104 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-56 0 0 24 72 0 0 32-72 0 0 40-48 0 0-40-40 0 0-32 40 0 0-40-40 0 0-32 40 0 0-128zM280 248c22.1 0 40-17.9 40-40s-17.9-40-40-40l-56 0 0 80 56 0z"]
};
var faBarcodeRead = {
  prefix: 'fass',
  iconName: 'barcode-read',
  icon: [512, 512, [], "f464", "M24 0l-24 0 0 160 48 0 0-112 112 0 0-48-136 0zM376 0l-24 0 0 48 112 0 0 112 48 0 0-160-136 0zM48 376l0-24-48 0 0 160 160 0 0-48-112 0 0-88zm464 0l0-24-48 0 0 112-112 0 0 48 160 0 0-136zM96 128l0 256 64 0 0-256-64 0zm176 0l0 256 48 0 0-256-48 0zm144 0l-64 0 0 256 64 0 0-256zm-224 0l0 256 32 0 0-256-32 0z"]
};
var faQuoteLeft = {
  prefix: 'fass',
  iconName: 'quote-left',
  icon: [448, 512, [8220, "quote-left-alt"], "f10d", "M0 216C0 149.7 53.7 96 120 96l40 0 0 64-40 0c-30.9 0-56 25.1-56 56l0 8 128 0 0 192-192 0 0-200zm256 0c0-66.3 53.7-120 120-120l40 0 0 64-40 0c-30.9 0-56 25.1-56 56l0 8 128 0 0 192-192 0 0-200z"]
};
var faQuoteLeftAlt = faQuoteLeft;
var faScreencast = {
  prefix: 'fass',
  iconName: 'screencast',
  icon: [512, 512, [], "e23e", "M448 96l-384 0 0 82.7c-12.6-1.8-25.5-2.7-38.7-2.7l-25.3 0 0-144 512 0 0 448-208 0 0-25.3c0-13.1-.9-26-2.7-38.7l146.7 0 0-320zM24 224c128.1 0 232 103.9 232 232l0 24-48 0 0-24c0-101.6-82.4-184-184-184l-24 0 0-48 24 0zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 320l24 0c75.1 0 136 60.9 136 136l0 24-48 0 0-24c0-48.6-39.4-88-88-88l-24 0 0-48z"]
};
var faSkiBoot = {
  prefix: 'fass',
  iconName: 'ski-boot',
  icon: [512, 512, [], "e3cc", "M368 144l-96 0 0 48 85.3 0-10.7 48-90.7 0 0 48 80 0 144 64 0 96 32 0 0 64-512 0 0-64 24.8-128.8c.8-.1 1.6-.2 2.5-.3 5.8-.9 13.9-2.5 23.6-5.3 19.4-5.7 45.3-16.3 72.4-36.2 53.2-39.1 108.3-111.9 130.6-245.3l74.2 0 8-32 64 0-32 144zM205 32c-21.2 117.5-69.3 176.6-110.3 206.7-21.9 16.1-42.5 24.5-57.4 28.8-1 .3-1.9 .5-2.8 .7L80 32 205 32z"]
};
var faFamilyPants = {
  prefix: 'fass',
  iconName: 'family-pants',
  icon: [448, 512, [], "e302", "M96 128A64 64 0 1 0 96 0 64 64 0 1 0 96 128zM32 512l96 0 0-64-32 0 0-240 37.5 0c-3.5-10-5.5-20.8-5.5-32 0-5.5 .5-10.8 1.3-16L0 160 0 352 32 352 32 512zm384 0l0-160 32 0 0-192-129.3 0c.9 5.2 1.3 10.5 1.3 16 0 11.2-1.9 22-5.5 32l37.5 0 0 240-32 0 0 64 96 0zM352 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM224 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80 176l0-144-160 0 0 144 32 0 0 112 96 0 0-112 32 0z"]
};
var faEyeDropperFull = {
  prefix: 'fass',
  iconName: 'eye-dropper-full',
  icon: [512, 512, [], "e172", "M341.6 29.2L240.1 130.8C236 126.7 225.3 116 208 98.7l-45.3 45.3 22.6 22.6 160 160 22.6 22.6 45.3-45.3c-17.3-17.3-28-28-32.1-32.1L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM32 344l0 88-32 48 32 32 48-32 88 0 131.4-131.4-136-136-131.4 131.4z"]
};
var faChevronDown = {
  prefix: 'fass',
  iconName: 'chevron-down',
  icon: [512, 512, [], "f078", "M256.3 429.3l214.6-214.6 22.6-22.6-45.3-45.3-22.6 22.6-169.4 169.4-169.4-169.4-22.6-22.6-45.3 45.3 22.6 22.6 192 192 22.6 22.6z"]
};
var faEarthAsia = {
  prefix: 'fass',
  iconName: 'earth-asia',
  icon: [512, 512, [127759, "globe-asia"], "f57e", "M50.4 288l77.6 0 32 32 64 0 0-96 48 0 0-80 32-32 0-58.4c-15.4-3.6-31.5-5.6-48-5.6-114.9 0-208 93.1-208 208 0 10.9 .8 21.6 2.4 32zM454 320l-38 0 0-32-64 0-64 64 0 64 64 0 15.6 15.6C408 405.8 439 366.5 454 320zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm128 96l0 32 64 0 0-32-64 0zm160-96l-32 0 0 64 32 0 0-64zm32-128l0 64 32 0 0-64-32 0z"]
};
var faGlobeAsia = faEarthAsia;
var faCentSign = {
  prefix: 'fass',
  iconName: 'cent-sign',
  icon: [384, 512, [], "e3f5", "M240.5 0l0 57.4c55.5 6.6 104.1 36.1 136 78.5l-51.2 38.4c-24.9-33.1-64.3-54.4-108.8-54.4-75.1 0-136 60.9-136 136s60.9 136 136 136c44.5 0 83.9-21.3 108.8-54.4L376.5 376c-31.9 42.5-80.5 71.9-136 78.5l0 57.4-64 0 0-60c-91.3-18.5-160-99.2-160-196S85.2 78.5 176.5 60l0-60 64 0z"]
};
var faComputerMouseButtonLeft = {
  prefix: 'fass',
  iconName: 'computer-mouse-button-left',
  icon: [384, 512, [], "e7cd", "M216 216l0-216 168 0 0 352c0 88.4-71.6 160-160 160l-64 0C71.6 512 0 440.4 0 352l0-112 216 0 0-24zM0 192L0 0 168 0 168 192 0 192z"]
};
var faShieldCat = {
  prefix: 'fass',
  iconName: 'shield-cat',
  icon: [512, 512, [], "e572", "M256 0l11.6 4.5 207.5 80.5 19.2 7.4 1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.3-91.1 150-189.4 192.6l-12.7 5.5-12.7-5.5C144.9 463.9 86.6 389.2 53.9 313.9 21.5 239.3 13.7 162.9 16.6 113L17.8 92.5 37 85 244.5 4.5 256 0zM224 208l-64-64 0 128c0 53 43 96 96 96s96-43 96-96l0-128-64 64-64 0zm-8 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faSchoolCircleCheck = {
  prefix: 'fass',
  iconName: 'school-circle-check',
  icon: [640, 512, [], "e56b", "M128 128l-128 0 0 384 340 0c-10.5-14.6-19-30.7-25.1-48l-90.9 0 0-128 90.9 0c26.4-74.6 97.5-128 181.1-128 28.6 0 55.6 6.2 80 17.4l0-97.4-128 0-160-128-160 128zm0 256l-64 0 0-64 64 0 0 64zM64 256l0-64 64 0 0 64-64 0zM288 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L417.4 400 440 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z"]
};
var faMartiniGlass = {
  prefix: 'fass',
  iconName: 'martini-glass',
  icon: [512, 512, [127864, "glass-martini-alt"], "f57b", "M16 96l-16-16 0-48 512 0 0 48-224 224 0 144 96 0 0 64-256 0 0-64 96 0 0-144-13.3-13.3-194.7-194.7zm138.5 48l203 0 48-48-299 0 48 48z"]
};
var faGlassMartiniAlt = faMartiniGlass;
var faUserUnlock = {
  prefix: 'fass',
  iconName: 'user-unlock',
  icon: [576, 512, [], "e058", "M224 248a120 120 0 1 0 0-240 120 120 0 1 0 0 240zm80 104l0-48-224 0-64 208 288 0 0-160zm192-48l48 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48-32 0 0 192 224 0 0-192-144 0 0-48c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faPlug = {
  prefix: 'fass',
  iconName: 'plug',
  icon: [448, 512, [128268], "f1e6", "M160-32l0 128 128 0 0-128 64 0 0 128 96 0 0 64-32 0 0 64c0 95.1-69.2 174.1-160 189.3l0 98.7-64 0 0-98.7C101.2 398.1 32 319.1 32 224l0-64-32 0 0-64 96 0 0-128 64 0z"]
};
var faSpinnerThird = {
  prefix: 'fass',
  iconName: 'spinner-third',
  icon: [512, 512, [], "f3f4", "M477.7 384C499.5 346.4 512 302.6 512 256 512 114.6 397.4 0 256 0l0 64c106 0 192 86 192 192 0 35-9.4 67.8-25.7 96l55.4 32z"]
};
var faWindWarning = {
  prefix: 'fass',
  iconName: 'wind-warning',
  icon: [640, 512, ["wind-circle-exclamation"], "f776", "M256 32c118.3 0 215.2 91.8 223.4 208l-143.4 0 0 144 96 0 0 10.5C391 446.5 327.4 480 256 480 132.3 480 32 379.7 32 256S132.3 32 256 32zM520 288c48.6 0 88 39.4 88 88s-39.4 88-88 88l-40 0 0-48 40 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-136 0 0-48 136 0zM228 380l56 0 0-56-56 0 0 56zm8.8-92l38.4 0 12.8-160-64 0 12.8 160zM552 48c48.6 0 88 39.4 88 88s-39.4 88-88 88l-25.8 0c-1.9-16.5-5.3-32.5-10.1-48l35.9 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-40 0 0-48 40 0z"]
};
var faWindCircleExclamation = faWindWarning;
var faPanorama = {
  prefix: 'fass',
  iconName: 'panorama',
  icon: [576, 512, [], "e209", "M288 88C144 88 0 48 0 48L0 464s144-40 288-40 288 40 288 40l0-416S432 88 288 88zM499.2 381.4l-1.5-.3C441.6 370.7 365.4 360 288 360S134.4 370.7 78.3 381.1L75.5 381.6 176 256 220.6 311.8 336 144 499.2 381.4zM112 136a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faClockRotateLeft = {
  prefix: 'fass',
  iconName: 'clock-rotate-left',
  icon: [576, 512, ["history"], "f1da", "M288 64c106 0 192 86 192 192S394 448 288 448c-65.2 0-122.9-32.5-157.6-82.3L77.9 402.3C124.1 468.6 201 512 288 512 429.4 512 544 397.4 544 256S429.4 0 288 0C202.3 0 126.5 42.1 80 106.7l0-58.7-64 0 0 176 176 0 0-64-70.3 0C154.9 102.6 217 64 288 64zm24 64l-48 0 0 137.9 7 7c50.5 50.5 77.5 77.5 81 81L385.9 320c-4.6-4.6-29.3-29.3-73.9-73.9L312 128z"]
};
var faHistory = faClockRotateLeft;
var faWifiWeak = {
  prefix: 'fass',
  iconName: 'wifi-weak',
  icon: [128, 512, ["wifi-1"], "f6aa", "M112 432c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48z"]
};
var faWifi1 = faWifiWeak;
var faWaveform = {
  prefix: 'fass',
  iconName: 'waveform',
  icon: [576, 512, [], "f8f1", "M256.5 26.4l4.7-26.4 53.6 0 4.7 26.4 47.4 265.5 33.5-201.1 4.5-26.7 52.1 0 6.1 24.2 41.9 167.8 55 0 0 64-105 0c-3.3-13.1-8.8-35.4-16.7-67l-38.7 232.2-4.5 26.7-53.9 0-4.7-26.4-48.5-271.6-48.5 271.6-4.7 26.4-53.9 0-4.5-26.7-38.7-232.2c-7.9 31.6-13.5 53.9-16.7 67l-105 0 0-64 55 0 41.9-167.8 6.1-24.2 52.1 0 4.5 26.7 33.5 201.1 47.4-265.5z"]
};
var faVideoQuestion = {
  prefix: 'fass',
  iconName: 'video-question',
  icon: [576, 512, [], "e777", "M32 64l384 0 0 384-384 0 0-384zM464 341.3l0-170.7 112-74.7 0 320-112-74.7zM224 181.2c17.7 0 32 14.3 32 32 0 26.9-28.8 31-49.9 34l-3.3 .5 0 53.5 42.4 0 0-18.3c30.4-10.6 53.2-36.1 53.2-69.6 0-41.1-33.3-74.4-74.4-74.4s-74.4 33.3-74.4 74.4l42.4 0c0-17.7 14.3-32 32-32zM200 328l0 48 48 0 0-48-48 0z"]
};
var faTicketAirline = {
  prefix: 'fass',
  iconName: 'ticket-airline',
  icon: [576, 512, ["ticket-perforated-plane", "ticket-plane"], "e29a", "M0 64l576 0 0 144c-26.5 0-48 21.5-48 48s21.5 48 48 48l0 144-576 0 0-384zM416 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM136 224l-24-32-32 0 16 64-16 64 32 0 24-32 40 0-32 80 56 0 56-80 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-56-80-56 0 32 80-40 0z"]
};
var faTicketPerforatedPlane = faTicketAirline;
var faTicketPlane = faTicketAirline;
var faArrowUTurnUpRight = {
  prefix: 'fass',
  iconName: 'arrow-u-turn-up-right',
  icon: [576, 512, [], "e7ee", "M400.2-29.2L355 16 435 96 224.2 96C121.5 96 37.6 176.7 32.5 278.1l-.2 9.9c0 106 86 192 192 192l256 0 0-64-256 0c-70.7 0-128-57.3-128-128l.2-6.6C99.8 213.8 155.8 160 224.2 160l210.7 0-80 80 45.3 45.3 157.2-157.3-157.2-157.2z"]
};
var faLinkSimple = {
  prefix: 'fass',
  iconName: 'link-simple',
  icon: [576, 512, [], "e1cd", "M0 256C0 150 86 64 192 64l64 0 0 64-64 0c-70.7 0-128 57.3-128 128s57.3 128 128 128l64 0 0 64-64 0C86 448 0 362 0 256zm576 0c0 106-86 192-192 192l-64 0 0-64 64 0c70.7 0 128-57.3 128-128S454.7 128 384 128l-64 0 0-64 64 0c106 0 192 86 192 192zM192 224l224 0 0 64-256 0 0-64 32 0z"]
};
var faRectangleWide = {
  prefix: 'fass',
  iconName: 'rectangle-wide',
  icon: [640, 512, [], "f2fc", "M0 64l640 0 0 384-640 0 0-384z"]
};
var faPig = {
  prefix: 'fass',
  iconName: 'pig',
  icon: [640, 512, [128022], "f706", "M453.1 46l74.9-14 0 46c0 19.7-9 37.8-23.6 49.7 6.4 4.9 12.7 10.1 18.6 15.7 17.6-15.9 28.5-38.6 29-63.3l56 0 0 32c0 32.8-24.6 59.8-56.3 63.5l6.8 9C570 200 585 212.5 602.2 221.1l5.8 2.9 32 0 0 144-67.5 0c-22.2 21.2-49.7 36.2-79.8 43.3l-19.6 68.7-89.1 0 0-64-112 0 0 64-89.1 0-27.9-97.6C110.3 358 80 310.5 80 256l0-16-32.6 0c-26.2 0-47.4-21.2-47.4-47.4 0-21.8 14.8-40.7 35.9-46l8.2-2 7.8 31-8.2 2c-6.9 1.7-11.7 7.9-11.7 15 0 8.5 6.9 15.4 15.4 15.4l35.8 0C98 135 162.6 80 240 80l122.4 0c14.6 0 29 1.4 43.1 4 8.4-19.3 25.9-33.8 47.7-37.9zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
var faJarWheat = {
  prefix: 'fass',
  iconName: 'jar-wheat',
  icon: [320, 512, [], "e517", "M32-32l256 0 0 48-256 0 0-48zM0 64l320 0 0 448-320 0 0-448zM192 320c35.3 0 64-28.7 64-64l-48 0c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7l-48 0c0 35.3 28.7 64 64 64l64 0zm0-96c35.3 0 64-28.7 64-64l-48 0c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7l-48 0c0 35.3 28.7 64 64 64l64 0zm0 192c35.3 0 64-28.7 64-64l-48 0c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7l-48 0c0 35.3 28.7 64 64 64l16 0 0 48 32 0 0-48 16 0z"]
};
var faBookmarkSlash = {
  prefix: 'fass',
  iconName: 'bookmark-slash',
  icon: [576, 512, [], "e0c2", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-.6-.6-33.3-33.3-98.1-98.1l0-414-384 0 0 30-46.8-46.8zM96.1 165.8l0 362.2 192-112 34.9-23.3-226.9-226.9z"]
};
var faFileBan = {
  prefix: 'fass',
  iconName: 'file-ban',
  icon: [576, 512, [], "e758", "M272 0l-240 0 0 512 244 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3L416 144 272 0zm85.5 176L240 176 240 58.5 357.5 176zM432 496c-53 0-96-43-96-96 0-17.8 4.8-34.5 13.3-48.8L480.8 482.7c-14.3 8.4-31 13.3-48.8 13.3zM383.2 317.3c14.3-8.4 31-13.3 48.8-13.3 53 0 96 43 96 96 0 17.8-4.8 34.5-13.3 48.8L383.2 317.3zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
};
var faArrowUpRight = {
  prefix: 'fass',
  iconName: 'arrow-up-right',
  icon: [448, 512, [], "e09f", "M384.3 64l32 0 0 288-64 0 0-178.7-265.4 265.4-22.6 22.6-45.3-45.3 22.6-22.6 265.4-265.4-178.7 0 0-64 256 0z"]
};
var faSquareV = {
  prefix: 'fass',
  iconName: 'square-v',
  icon: [448, 512, [], "e284", "M448 32l-448 0 0 448 448 0 0-448zM201.9 353.4l-89.5-209.4 52.2 0 59.4 138.9 59.4-138.9 52.2 0-89.5 209.4-2.8 6.6-38.5 0-2.8-6.6z"]
};
var faCloudArrowDown = {
  prefix: 'fass',
  iconName: 'cloud-arrow-down',
  icon: [576, 512, [62337, "cloud-download", "cloud-download-alt"], "f0ed", "M144 480l432 0 0-128c0-47.4-25.7-88.7-64-110.9l0-49.1c0-53-43-96-96-96-17.7 0-34.2 4.8-48.4 13.1-24.1-45.8-72.2-77.1-127.6-77.1-79.5 0-144 64.5-144 144l0 24.2C40.1 220 0 273.3 0 336l0 144 144 0zm161-95l-17 17c-2.1-2.1-31.8-31.8-89-89l-17-17 33.9-33.9c9 9 25 25 48 48l0-126.1 48 0 0 126.1c23-23 39-39 48-48L393.9 296c-2.1 2.1-31.8 31.8-89 89z"]
};
var faCloudDownload = faCloudArrowDown;
var faCloudDownloadAlt = faCloudArrowDown;
var faKeyboardLeft = {
  prefix: 'fass',
  iconName: 'keyboard-left',
  icon: [640, 512, [], "e1c3", "M192 64l448 0 0 384-448 0 0-384zm48 64l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm32-96l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm-64 96l0 64 160 0 0-64-160 0zM496 128l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zm160-96l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zm-416-8l0 137.9c-65.6-65.6-96.8-96.8-97.9-97.9 17.6-17.6 84.8-84.8 97.9-97.9l0 57.9z"]
};
var faBadgeCheck = {
  prefix: 'fass',
  iconName: 'badge-check',
  icon: [512, 512, [], "f336", "M256 0C292.8 0 324.8 20.7 340.9 51.1 373.8 41 411 48.9 437 75s34 63.3 23.9 96.2C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.2 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.2C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 48.9 101 75 75s63.3-34 96.2-23.9C187.2 20.7 219.2 0 256 0zm57.4 169.9L227.8 287.6c-19.3-20-33.7-34.9-43.2-44.7l-34.5 33.3c6.2 6.4 27.2 28.1 63.1 65.3l19.8 20.6 16.8-23.1 102.4-140.8 14.1-19.4-38.8-28.2-14.1 19.4z"]
};
var faTruckRampBox = {
  prefix: 'fass',
  iconName: 'truck-ramp-box',
  icon: [640, 512, ["truck-loading"], "f4de", "M384.3 32l-32 0 0 328.2-297.2 89.2-30.7 9.2 18.4 61.3 30.7-9.2 315.5-94.6 43.7 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88l0-392-224 0zm176 392c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40c22.1 0 39.9 17.9 40 39.9l0 .1zM237.2 102.7L23 168.2 88.5 382.4 302.7 316.9 237.2 102.7z"]
};
var faTruckLoading = faTruckRampBox;
var faFaceDotted = {
  prefix: 'fass',
  iconName: 'face-dotted',
  icon: [512, 512, [129765], "e47f", "M163 88C131.5 105.5 105.5 131.5 88 163L28.2 139C52.7 91.5 91.5 52.7 139 28.2L163 88zM304.5 70.2C289 66.1 272.7 64 256 64s-33 2.1-48.5 6.2L183.6 10.4C206.6 3.6 230.9 0 256 0s49.4 3.6 72.4 10.4L304.5 70.2zM424 163C406.5 131.5 380.5 105.5 349 88L373 28.2C420.5 52.7 459.3 91.5 483.8 139L424 163zm17.8 141.5c4-15.5 6.2-31.7 6.2-48.5s-2.1-33-6.2-48.5l59.8-23.9c6.8 23 10.4 47.3 10.4 72.4s-3.6 49.4-10.4 72.4l-59.8-23.9zM349 424c31.5-17.5 57.5-43.5 74.9-74.9L483.8 373c-24.4 47.5-63.3 86.4-110.8 110.8L349 424zM207.5 441.8c15.5 4 31.7 6.2 48.5 6.2s33-2.1 48.5-6.2l23.9 59.8c-23 6.8-47.3 10.4-72.4 10.4s-49.4-3.6-72.4-10.4l23.9-59.8zM88 349c17.5 31.5 43.5 57.5 74.9 74.9L139 483.8C91.5 459.3 52.7 420.5 28.2 373L88 349zM70.2 304.5L10.4 328.4C3.6 305.4 0 281.1 0 256s3.6-49.4 10.4-72.4l59.8 23.9C66.1 223 64 239.3 64 256s2.1 33 6.2 48.5zM176 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM184 320l168 0 0 48-192 0 0-48 24 0z"]
};
var faCircle1 = {
  prefix: 'fass',
  iconName: 'circle-1',
  icon: [512, 512, [], "e0ee", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM216 144l64 0 0 176 56 0 0 48-160 0 0-48 56 0 0-128-40 0 0-48 24 0z"]
};
var faOctopus = {
  prefix: 'fass',
  iconName: 'octopus',
  icon: [640, 512, [], "e688", "M207.8 359.6c-2.8 40.4-36.4 72.3-77.4 72.4l-.1 0c-36.7 0-68.3-25.6-76-61.5L47.5 339 .5 349 7.3 380.6c12.4 58 63.6 99.4 122.9 99.4l.1 0c45 0 89-13.3 126.4-38.3l38.6-25.7 49.5 0 38.6 25.7c37.4 25 81.4 38.3 126.4 38.3 59.3 0 110.5-41.4 123-99.4l6.8-31.6-46.9-10.1-6.8 31.6c-7.7 35.8-39.4 61.5-76 61.5-41.1 0-74.8-31.9-77.6-72.4 11.3 7.3 24.5 11.9 38.9 13 38.8 2.8 74.3-21.9 85.3-59.2l10.9-36.9c6.4-21.6 26.2-36.5 48.8-36.5l24 0 0-48-24 0c-43.8 0-82.5 28.9-94.8 71l-10.9 36.9c-4.6 15.7-19.5 26-35.8 24.8-20.5-1.5-35.3-20.3-31.7-40.6l19-109.3c1.5-8.4 2.2-17 2.2-25.6l0-5.2C464 64.5 399.5 0 320 0S176 64.5 176 144l0 5.2c0 8.6 .7 17.1 2.2 25.6l19 109.3c3.5 20.3-11.2 39.1-31.7 40.6-16.3 1.2-31.2-9.2-35.8-24.8L118.8 263c-12.4-42.1-51-71-94.8-71l-24 0 0 48 24 0c22.6 0 42.4 14.9 48.8 36.5l10.9 36.9c11 37.3 46.5 62 85.3 59.2 14.4-1 27.7-5.7 38.9-13zM248 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faAngleDown = {
  prefix: 'fass',
  iconName: 'angle-down',
  icon: [448, 512, [8964], "f107", "M224.3 397.3l182.6-182.6 22.6-22.6-45.3-45.3-22.6 22.6-137.4 137.4-137.4-137.4-22.6-22.6-45.3 45.3 22.6 22.6 160 160 22.6 22.6z"]
};
var faSquareKanban = {
  prefix: 'fass',
  iconName: 'square-kanban',
  icon: [448, 512, [], "e488", "M448 32l-448 0 0 448 448 0 0-448zM304 384l0-256 48 0 0 256-48 0zM248 256l-48 0 0-128 48 0 0 128zM96 320l0-192 48 0 0 192-48 0z"]
};
var faCircleThreeQuartersStroke = {
  prefix: 'fass',
  iconName: 'circle-three-quarters-stroke',
  icon: [512, 512, [], "e5d4", "M256 64l0 192 192 0c0-106-86-192-192-192zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"]
};
var faPlugCircleCheck = {
  prefix: 'fass',
  iconName: 'plug-circle-check',
  icon: [640, 512, [], "e55c", "M224-32l0 128 128 0 0-128 64 0 0 128 96 0 0 64-32 0 0 48.7c-98.6 8.1-176 90.7-176 191.3 0 27.3 5.7 53.3 16 76.9l0 35.1-64 0 0-98.7C165.2 398.1 96 319.1 96 224l0-64-32 0 0-64 96 0 0-128 64 0zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.4-51.5l-25.9-18.8-9.4 12.9-53 72.9C457.7 395 445 382.3 440 377.4L417.4 400c2.8 2.8 19.9 19.9 51.3 51.3l13.2 13.2 11-15.1 64-88 9.4-12.9z"]
};
var faCameraShutter = {
  prefix: 'fass',
  iconName: 'camera-shutter',
  icon: [576, 512, [], "e768", "M57.4-41l39 39 56-56 33.9 33.9c-4.8 4.8-29.1 29.1-73 73l-17 17-73-73-17-17 33.9-33.9 17 17zm103 137l32-64 192 0 32 64 128 0 0 384-512 0 0-384 128 0zm224 192a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faWindowMaximize = {
  prefix: 'fass',
  iconName: 'window-maximize',
  icon: [512, 512, [128470], "f2d0", "M512 64l-512 0 0 384 512 0 0-384zM88 128l360 0 0 48-384 0 0-48 24 0z"]
};
var faTvMusic = {
  prefix: 'fass',
  iconName: 'tv-music',
  icon: [576, 512, [], "f8e6", "M512 96l0 240-448 0 0-240 448 0zM64 32l-64 0 0 368 576 0 0-368-512 0zm64 416l0 64 320 0 0-64-320 0zM376 128l-88 0 0 65.8c-5.1-1.2-10.5-1.8-16-1.8-35.3 0-64 25.1-64 56s28.7 56 64 56 64-25.1 64-56l0-72 40 0 0-48z"]
};
var faHandsHoldingCircle = {
  prefix: 'fass',
  iconName: 'hands-holding-circle',
  icon: [640, 512, [], "e4fb", "M320 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM80 64l-80 0 0 301.3 9.4 9.4 128 128 9.4 9.4 141.3 0 0-173.3-9.4-9.4C125.1 175.9 201.5 252.2 160 210.7L114.7 256c48.8 48.8 65.1 65.1 91 91L164.1 374.8 80 290.7 80 64zm480 0l0 226.7-84.1 84.1-41.7-27.8c102.9-102.9 58.7-58.7 91-91L480 210.7c-44.2 44.2-69.7 69.7-118.6 118.6l-9.4 9.4 0 173.3 141.3 0 9.4-9.4 128-128 9.4-9.4 0-301.3-80 0z"]
};
var faWreath = {
  prefix: 'fass',
  iconName: 'wreath',
  icon: [512, 512, [], "f7e2", "M8.7 322.3c6.3 23.6 22.6 41.9 43.1 51.6-1.9 22.6 5.9 45.8 23.2 63.1 10.6 10.6 23.5 17.6 37 21l0-92.6c39.2 13.1 87.2 29.1 144 48l144-48 0 92.6c13.6-3.4 26.4-10.4 37-21 17.3-17.3 25-40.5 23.2-63.1 20.5-9.7 36.8-28 43.1-51.6s1.4-47.6-11.5-66.3c12.9-18.6 17.8-42.6 11.5-66.3s-22.6-41.9-43.1-51.6c1.8-22.6-5.9-45.8-23.2-63.1s-40.5-25-63.1-23.2c-9.7-20.5-28-36.8-51.6-43.1S274.7 7.3 256 20.2C237.4 7.3 213.4 2.4 189.8 8.7s-41.9 22.6-51.6 43.1C115.5 50 92.3 57.7 75 75s-25 40.5-23.2 63.1c-20.5 9.7-36.8 28-43.1 51.6S7.4 237.3 20.3 256C7.3 274.6 2.4 298.6 8.7 322.3zM282.5 192l37.5 0 0 37.5 26.5 26.5-26.5 26.5 0 37.5-37.5 0-26.5 26.5-26.5-26.5-37.5 0 0-37.5-26.5-26.5 26.5-26.5 0-37.5 37.5 0 26.5-26.5 26.5 26.5zM160 432l0 112 96-32 96 32 0-112-96 32-96-32z"]
};
var faLocationPin = {
  prefix: 'fass',
  iconName: 'location-pin',
  icon: [384, 512, ["map-marker"], "f041", "M192 0C86 0 0 84.4 0 188.6 0 339.4 192 528 192 528S384 339.4 384 188.6C384 84.4 298 0 192 0z"]
};
var faMapMarker = faLocationPin;
var faBowlingBall = {
  prefix: 'fass',
  iconName: 'bowling-ball',
  icon: [512, 512, [], "f436", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCartFlatbed = {
  prefix: 'fass',
  iconName: 'cart-flatbed',
  icon: [576, 512, ["dolly-flatbed"], "f474", "M32 0l-32 0 0 64 64 0 0 384 66.7 0c-1.8 5-2.7 10.4-2.7 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l197.5 0c-1.8 5-2.7 10.4-2.7 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l66.7 0 0-64-448 0 0-384-96 0zM512 64l-336 0 0 272 336 0 0-272z"]
};
var faDollyFlatbed = faCartFlatbed;
var faHouseUser = {
  prefix: 'fass',
  iconName: 'house-user',
  icon: [512, 512, ["home-user"], "e1b0", "M512 272l-48 0 0 240-416 0 0-240-48 0 0-48 256-240 256 240 0 48zM312 256a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm24 96l-160 0-32 96 224 0-32-96z"]
};
var faHomeUser = faHouseUser;
var faBrainCircuit = {
  prefix: 'fass',
  iconName: 'brain-circuit',
  icon: [512, 512, [], "e0c6", "M176 0c-30.9 0-56 25.1-56 56l0 24c-44.2 0-80 35.8-80 80 0 15 4.1 29 11.2 40.9-25.7 13.3-43.2 40.1-43.2 71.1 0 26.2 12.6 49.4 32 64-10 13.4-16 30-16 48 0 44.2 35.8 80 80 80 .7 0 1.3 0 2 0 7.1 27.6 32.2 48 62 48l64 0 0-204-68 0 0 16.4c16.5 7.6 28 24.3 28 43.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-19.4 11.5-36.1 28-43.6l0-56.4 108 0 0-72-44.4 0c-7.6 16.5-24.3 28-43.6 28-26.5 0-48-21.5-48-48s21.5-48 48-48c19.4 0 36.1 11.5 43.6 28l44.4 0 0-156-56 0zM280 196l0 200 68 0 0-16.4c-16.5-7.6-28-24.3-28-43.6 0-26.5 21.5-48 48-48s48 21.5 48 48c0 19.4-11.5 36.1-28 43.6l0 56.4-108 0 0 76 64 0c29.8 0 54.9-20.4 62-48 .7 0 1.3 0 2 0 44.2 0 80-35.8 80-80 0-18-6-34.6-16-48 19.4-14.6 32-37.8 32-64 0-30.9-17.6-57.8-43.2-71.1 7.1-12 11.2-26 11.2-40.9 0-44.2-35.8-80-80-80l0-24c0-30.9-25.1-56-56-56l-56 0 0 156 44.4 0c7.6-16.5 24.3-28 43.6-28 26.5 0 48 21.5 48 48s-21.5 48-48 48c-19.4 0-36.1-11.5-43.6-28L280 196zm88-36a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM352 336a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM128 368a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0-192a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z"]
};
var faSquareaporeDollar = {
  prefix: 'fass',
  iconName: 'squareapore-dollar',
  icon: [448, 512, [], "e733", "M0 32l448 0 0 448-448 0 0-448zM88 215.6c0 30.3 21.4 56.4 51.1 62.3l16.4 3.3c7.3 1.5 12.5 7.8 12.5 15.3 0 8.6-7 15.6-15.6 15.6l-56.4 0 0 48 56.4 0c35.1 0 63.6-28.5 63.6-63.6 0-30.3-21.4-56.4-51.1-62.3l-16.4-3.3c-7.3-1.5-12.5-7.8-12.5-15.3 0-8.6 7-15.6 15.6-15.6l48.4 0 0-48-48.4 0C116.5 152 88 180.5 88 215.6zM312 120l-32 0 0 33.9c-27.6 6.9-48 31.9-48 61.6 0 30.3 21.4 56.4 51.1 62.3l16.4 3.3c7.3 1.5 12.5 7.8 12.5 15.3 0 8.6-7 15.6-15.6 15.6l-56.4 0 0 48 40 0 0 32 32 0 0-33.9c27.6-6.9 48-31.9 48-61.6 0-30.3-21.4-56.4-51.1-62.3l-16.4-3.3c-7.3-1.5-12.5-7.8-12.5-15.3 0-8.6 7-15.6 15.6-15.6l48.4 0 0-48-32 0 0-32z"]
};
var faEnvelopes = {
  prefix: 'fass',
  iconName: 'envelopes',
  icon: [576, 512, [], "e170", "M96 32L96 88.7 336 251 576 88.7 576 32 96 32zM349.4 299.9l-13.4 9.1-13.4-9.1-226.6-153.3 0 237.4 480 0 0-237.4-226.6 153.3zM48 152l0-24-48 0 0 352 480 0 0-48-432 0 0-280z"]
};
var faEscalator = {
  prefix: 'fass',
  iconName: 'escalator',
  icon: [512, 512, [], "e171", "M152 40a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM328.8 224L512 224 512 352 375.2 352 201 497.2 183.2 512 0 512 0 384 136.8 384 311 238.8 328.8 224zm-48.5-22l-152.3 126.9 0-200.9 160 0 0 68.1c-2.6 1.8-5.2 3.8-7.7 5.9z"]
};
var faGhost = {
  prefix: 'fass',
  iconName: 'ghost',
  icon: [384, 512, [128123], "f6e2", "M48 448L0 480 0 192C0 86 86 0 192 0S384 86 384 192l0 288-48-32-72 64-72-64-72 64-72-64zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faShorts = {
  prefix: 'fass',
  iconName: 'shorts',
  icon: [512, 512, [], "e6d9", "M64.1 32l0 80 384 0 0-80-384 0zm-6 128l-49.7 277.2-2.8 15.8 15.8 2.8 184 32 14.8 2.6 3.5-14.6 32.4-136.2 32.4 136.2 3.5 14.6 14.8-2.6 184-32 15.8-2.8-2.8-15.8-49.8-277.2-396 0z"]
};
var faFloppyDiskCircleXmark = {
  prefix: 'fass',
  iconName: 'floppy-disk-circle-xmark',
  icon: [576, 512, ["floppy-disk-times", "save-circle-xmark", "save-times"], "e181", "M64 32l-32 0 0 448 225.4 0c-9.3-20.3-15.2-42.5-16.9-65.9-27.9-6.9-48.5-32.1-48.5-62.1 0-35.3 28.7-64 64-64 6.3 0 12.4 .9 18.2 2.6 34.7-49.9 92.4-82.6 157.8-82.6 16.6 0 32.7 2.1 48 6l0-67.3-105.4-105.4-9.4-9.4-301.3 0zm64 64l224 0 0 128-224 0 0-128zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm55.3-176.7L454.6 400c25.4 25.3 40 40 44 44L476 466.6c-4-4-18.6-18.6-44-44-25.3 25.4-40 40-44 44L365.4 444c4-4 18.6-18.6 44-44-25.4-25.3-40-40-44-44L388 333.4c4 4 18.6 18.6 44 44 25.3-25.4 40-40 44-44l22.6 22.6-11.3 11.3z"]
};
var faFloppyDiskTimes = faFloppyDiskCircleXmark;
var faSaveCircleXmark = faFloppyDiskCircleXmark;
var faSaveTimes = faFloppyDiskCircleXmark;
var faBallYarn = {
  prefix: 'fass',
  iconName: 'ball-yarn',
  icon: [512, 512, [], "e6ce", "M207 136L243.4 .3C150.7 4.8 71 58.6 29.8 136L207 136zM292.5 2.6l-35.8 133.4 66.6 0 31.2-116.4c-19.6-8.2-40.4-14-62-17.1zM117.2 471.2l25.5-95.2-112.9 0c20.6 38.7 50.8 71.5 87.4 95.2zM192.4 376L160.9 493.7c19.7 7.9 40.5 13.4 62.3 16.2L259 376 192.4 376zM482.2 136c-20-37.6-49-69.6-84.2-93.1L373 136 482.2 136zm0 240l-173.5 0-36.4 136 239.7 0 0-48-106.7 0c31.9-23 58.3-53.1 76.9-88zm19.5-48c4.5-15.4 7.6-31.5 9.2-48L1.1 280c1.5 16.5 4.6 32.6 9.2 48l491.5 0zm0-144L10.3 184c-4.5 15.4-7.6 31.5-9.2 48l509.8 0c-1.5-16.5-4.6-32.6-9.2-48z"]
};
var faDisplayCode = {
  prefix: 'fass',
  iconName: 'display-code',
  icon: [512, 512, ["desktop-code"], "e165", "M64 96l0 256 384 0 0-256-384 0zM0 32l512 0 0 384-208 0 16 48 96 0 0 48-320 0 0-48 96 0 16-48-208 0 0-384zM217 193l-31 31c23 23 39 39 48 48L200 305.9c-6.1-6.1-27.8-27.8-65-65l-17-17 65-65 17-17 33.9 33.9-17 17zM329 159c37.2 37.2 58.8 58.8 65 65-6.1 6.1-27.8 27.8-65 65l-17 17-33.9-33.9c9-9 25-25 48-48-23-23-39-39-48-48l33.9-33.9 17 17z"]
};
var faDesktopCode = faDisplayCode;
var faBalloons = {
  prefix: 'fass',
  iconName: 'balloons',
  icon: [576, 512, [], "e2e4", "M320 160C320 71.6 248.4 0 160 0S0 71.6 0 160C0 272 128 368 128 368l-32 80 128 0-32-80s128-96 128-208zM160 96c-35.3 0-64 28.7-64 64l-48 0C48 98.1 98.1 48 160 48l0 48zM384 432l-32 80 128 0-32-80s128-96 128-208c0-88.4-71.6-160-160-160-23.1 0-45.1 4.9-64.9 13.7 6.3 14.7 11 30.3 13.9 46.6 15.3-7.9 32.7-12.3 51.1-12.3l0 48c-19.9 0-37.6 9.1-49.4 23.3-7.3 62.4-42.3 115.8-72.6 152.1 37.7 57.5 90 96.7 90 96.7z"]
};
var faCommentNodes = {
  prefix: 'fass',
  iconName: 'comment-nodes',
  icon: [640, 512, [], "e696", "M287 424c-10.1 17.5-15 36.6-15 55.5-32.5-1.9-63.3-9.4-91.3-21.6L32 512 87.7 389.5c-34.9-41-55.7-93-55.7-149.5 0-132.5 114.6-240 256-240 137 0 248.9 100.9 255.7 227.9-18.1-12.5-40-19.9-63.7-19.9-61.9 0-112 50.1-112 112 0 11.7 1.8 23.1 5.2 33.8l-9.2 16c-31.2 5.7-59.9 24.5-77 54.2zm41.6 24c13.4-23.2 39.1-34.8 64-31.4l34.6-60.5c-7-10.3-11.2-22.7-11.2-36.1 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-4.4 0-8.6-.4-12.8-1.3l-33 57.7c3.8 4.8 6.8 10 9 15.6l73.4 0c2.2-5.6 5.3-10.8 9-15.6l-16.5-28.9c15.7-5 29.6-13.9 40.6-25.6l17.6 30.7c25-3.4 50.6 8.3 64 31.4 17.7 30.6 7.2 69.7-23.4 87.4s-69.7 7.2-87.4-23.4c-1.5-2.6-2.8-5.3-3.9-8l-73.3 0c-1.1 2.7-2.4 5.4-3.9 8-17.7 30.6-56.8 41.1-87.4 23.4s-41.1-56.8-23.4-87.4z"]
};
var faTreeChristmas = {
  prefix: 'fass',
  iconName: 'tree-christmas',
  icon: [512, 512, [127876], "f7db", "M404.1 170.2l29.2 35.6-73.9 0c70.3 82.2 112 131 125 146.2l-105.1 0c80.3 93.7 126 147 137.2 160L-3.9 512c11.1-13 56.8-66.3 137.2-160L28.2 352c13-15.2 54.7-64 125-146.2l-73.8 0c11.3-13.9 47-57.4 106.9-130.6l3.8 1.8 20.4 65.3 91.6 0 20.6-65.8 3.4-1.7 78.1 95.4zM320.2 392a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm-128-128a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM282.9-10.7l53.3 26.7-53.3 26.7-26.7 53.3-26.7-53.3-53.3-25.3 53.3-28 26.7-53.3 26.7 53.3z"]
};
var faPersonArrowDownToLine = {
  prefix: 'fass',
  iconName: 'person-arrow-down-to-line',
  icon: [640, 512, [], "e538", "M528.3 0l0 146.7c17.4-17.4 33.4-33.4 48-48L621.5 144c-5.5 5.5-39.7 39.7-102.6 102.6l-22.6 22.6c-5.5-5.5-39.7-39.7-102.6-102.6L371 144 416.3 98.7c14.6 14.6 30.6 30.6 48 48l0-178.7 64 0 0 32zM32.3 480l112 0 0-241.7c-28.6 39.4-47.6 65.6-56.9 78.4l-51.8-37.6 18.8-25.9 92.9-128 9.6-13.2 134.8 0 9.6 13.2 92.9 128 18.8 25.9-51.8 37.6c-9.3-12.8-28.3-39-56.9-78.4l0 241.7 304 0 0 64-576 0 0-64zm176 0l32 0 0-144-32 0 0 144zm16-512a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faPlugCirclePlus = {
  prefix: 'fass',
  iconName: 'plug-circle-plus',
  icon: [640, 512, [], "e55f", "M224-32l0 128 128 0 0-128 64 0 0 128 96 0 0 64-32 0 0 56.7c-98.6 8.1-176 90.7-176 191.3 0 27.3 5.7 53.3 16 76.9l0 27.1-64 0 0-98.7C165.2 398.1 96 319.1 96 224l0-64-32 0 0-64 96 0 0-128 64 0zM496 264a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 64-64 0 0 32 64 0 0 64 32 0 0-64 64 0 0-32-64 0 0-48z"]
};
var faPersonSwimming = {
  prefix: 'fass',
  iconName: 'person-swimming',
  icon: [640, 512, [127946, "swimmer"], "f5c4", "M496.4 96a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM210.1 270.5l84.1-72.1-50.7-19c-51.1 30.6-82.5 49.5-94.2 56.5L116.5 181c9.5-5.7 45.4-27.2 107.4-64.5l13.2-7.9 14.5 5.4 128 48 6.5 2.4 4.9 4.9 80 80 3.4 3.5c-10.1 4-61.5 24.6-154.3 61.7l-93.1-37.2-17-6.8zm-.8 51.2l111.1 44.4 111.1-44.4 8.9-3.6 8.9 3.6 111.8 44.7c29.3-9.7 50.1-16.7 62.4-20.8l15.2 45.5c-11 3.7-34.6 11.5-70.8 23.6l-8.3 2.8-8.2-3.3-111.1-44.4-111.1 44.4-8.9 3.6-8.9-3.6-111.1-44.4-111.1 44.4-8.2 3.3-8.3-2.8C36.6 402.7 13 394.8 2 391.2l15.2-45.5c12.4 4.1 33.2 11.1 62.4 20.8l111.8-44.7 8.9-3.6 8.9 3.6z"]
};
var faSwimmer = faPersonSwimming;
var faCommentDots = {
  prefix: 'fass',
  iconName: 'comment-dots',
  icon: [512, 512, [128172, 62075, "commenting"], "f4ad", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM128 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCommenting = faCommentDots;
var faChartPie = {
  prefix: 'fass',
  iconName: 'chart-pie',
  icon: [576, 512, ["pie-chart"], "f200", "M544.5 240l-240 0 0-240c132.5 0 240 107.5 240 240zM256.5 32.5l0 240.1 5.5 6.7 153.6 185.4c-40 29.7-89.5 47.3-143.1 47.3-132.5 0-240-107.5-240-240 0-127.2 98.9-231.2 224-239.5zM512 288l64 0c-4.8 72.8-42 136.7-97.4 177.4L331.5 288 512 288z"]
};
var faPieChart = faChartPie;
var faShirtRunning = {
  prefix: 'fass',
  iconName: 'shirt-running',
  icon: [384, 512, [], "e3c8", "M112 0l0 80c0 44.2 35.8 80 80 80s80-35.8 80-80l0-80 64 0 0 128 7.6 20.4-343.6 245.5 0-137.8 48-128 0-128 64 0zM0 472.5l366.9-262.1 17.1 45.6 0 256-384 0 0-39.5z"]
};
var faBusSchool = {
  prefix: 'fass',
  iconName: 'bus-school',
  icon: [448, 512, [], "f5dd", "M416 0l-384 0 0 256-32 0 0 192 48 0 0 64 80 0 0-64 192 0 0 64 80 0 0-64 48 0 0-192-32 0 0-256zM64 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM248 256l0-128 120 0 0 128-120 0zM200 128l0 128-120 0 0-128 120 0zM184 48l104 0 0 48-128 0 0-48 24 0z"]
};
var faPhoneArrowRight = {
  prefix: 'fass',
  iconName: 'phone-arrow-right',
  icon: [576, 512, [], "e5be", "M545.4 113l17-17c-2.1-2.1-31.8-31.8-89-89l-17-17-33.9 33.9c9 9 25 25 48 48l-126.1 0 0 48 126.1 0c-23 23-39 39-48 48l33.9 33.9c2.1-2.1 31.8-31.8 89-89zM160.4 0l-128 64 0 16c0 238.6 193.4 432 432 432l16 0 64-128-128-96.8-80 80.8c-70.4-33-127-89.6-160-160l80.8-80-96.8-128z"]
};
var faListMusic = {
  prefix: 'fass',
  iconName: 'list-music',
  icon: [576, 512, [], "f8c9", "M576 32l0-41C564.2-6 508.3 7.9 408.2 33L384 39 384 313.2c-14.5-5.9-30.8-9.2-48-9.2-61.9 0-112 43-112 96s50.1 96 112 96 112-43 112-96l0-215c82.4-20.6 125.1-31.3 128-32l0-121zM64 64l-32 0 0 64 304 0 0-64-272 0zm0 160l-32 0 0 64 192 0 0-64-160 0zm0 160l-32 0 0 64 144 0 0-64-112 0z"]
};
var faLeafHeart = {
  prefix: 'fass',
  iconName: 'leaf-heart',
  icon: [512, 512, [], "f4cb", "M512 24l0 186.9C512 342.1 403.9 448 273.2 448 191.7 448 121.9 392.4 101.8 316.8 68.7 347.5 48 391.3 48 440l0 40-48 0 0-40C0 364.9 38.3 298.8 96.4 260.1 102.5 168.4 178.8 96 272 96 355.3 96 404.2 73.4 431.6 52.8 455.9 34.6 464.8 17 465.9 14.7L512 24zM357.3 176c-18.5 0-35.9 8.7-46.9 23.5l-6.4 8.5-6.4-8.5c-11.1-14.8-28.5-23.5-46.9-23.5-32.4 0-58.7 26.3-58.7 58.7l0 5.3c0 63.9 111.6 127.8 112 128 0 0 112-64 112-128l0-5.3c0-32.4-26.3-58.7-58.7-58.7z"]
};
var faChartBullet = {
  prefix: 'fass',
  iconName: 'chart-bullet',
  icon: [512, 512, [], "e0e1", "M288 32l0 32 224 0 0 160-224 0 0 32-48 0 0-32-240 0 0-160 240 0 0-32 48 0zM160 128l0 32 80 0 0-32-80 0zm128 0l0 32 160 0 0-32-160 0zm48 224l-80 0 0 32 80 0 0-32zm0-64l0-32 48 0 0 32 128 0 0 160-128 0 0 32-48 0 0-32-336 0 0-160 336 0zm48 64l0 32 64 0 0-32-64 0z"]
};
var faFaceSmileHearts = {
  prefix: 'fass',
  iconName: 'face-smile-hearts',
  icon: [640, 512, [], "e390", "M520.4-20.1c-8-7.6-18.6-11.9-29.6-11.9l-4.4 0C465.2-32 448-14.8 448 6.4 448 57.6 528 96 528 96s80-38.4 80-89.6C608-14.8 590.8-32 569.6-32l-4.4 0c-11 0-21.7 4.3-29.6 11.9l-7.6 7.3-7.6-7.3zM458 107.9C437.8 91.7 403.2 59 400.2 12.8 375 4.5 348 0 320 0 178.6 0 64 114.6 64 256 64 297.6 73.9 336.9 91.6 371.7 99.8 369.3 108.5 368 117.2 368l4.4 0c47.7 0 86.4 38.7 86.4 86.4 0 10.6-1.7 20.5-4.5 29.6 34.9 17.9 74.5 28 116.5 28s81.6-10.1 116.5-28c-2.8-9.2-4.5-19-4.5-29.6 0-47.7 38.7-86.4 86.4-86.4l4.4 0c8.8 0 17.4 1.3 25.6 3.7 17.6-34.7 27.6-74.1 27.6-115.7 0-42-10.1-81.6-28-116.6-6.6 3.4-13.3 6.6-20 9.8-24.7-11.8-48.5-24.2-70-41.4zM320 368c38.2 0 72-19.1 92.2-48.5l39.5 27.3C422.9 388.6 374.7 416 320 416s-102.9-27.4-131.8-69.2l39.5-27.3C248 348.9 281.8 368 320 368zM232 196c-11 0-20 9-20 20l0 16-40 0 0-16c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60l0 16-40 0 0-16c0-11-9-20-20-20l-16 0zm140 20l0 16-40 0 0-16c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60l0 16-40 0 0-16c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20zM72.4 427.9c-8-7.6-18.6-11.9-29.6-11.9l-4.4 0C17.2 416 0 433.2 0 454.4 0 505.6 80 544 80 544s80-38.4 80-89.6c0-21.2-17.2-38.4-38.4-38.4l-4.4 0c-11 0-21.7 4.3-29.6 11.9l-7.6 7.3-7.6-7.3zM522.8 416l-4.4 0c-21.2 0-38.4 17.2-38.4 38.4 0 51.2 80 89.6 80 89.6s80-38.4 80-89.6c0-21.2-17.2-38.4-38.4-38.4l-4.4 0c-11 0-21.7 4.3-29.6 11.9l-7.6 7.3-7.6-7.3c-8-7.6-18.6-11.9-29.6-11.9z"]
};
var faCalendarArrowDown = {
  prefix: 'fass',
  iconName: 'calendar-arrow-down',
  icon: [448, 512, ["calendar-download"], "e0d0", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0zm47 385l17 17c2.1-2.1 31.8-31.8 89-89l17-17-33.9-33.9c-9 9-25 25-48 48l0-126.1-48 0 0 126.1c-23-23-39-39-48-48L118.1 296c2.1 2.1 31.8 31.8 89 89z"]
};
var faCalendarDownload = faCalendarArrowDown;
var faMobileSignalOut = {
  prefix: 'fass',
  iconName: 'mobile-signal-out',
  icon: [576, 512, [], "e1f0", "M344-32C472.1-32 576 71.9 576 200l0 24-48 0 0-24C528 98.4 445.6 16 344 16l-24 0 0-48 24 0zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 64l24 0c75.1 0 136 60.9 136 136l0 24-48 0 0-24c0-48.6-39.4-88-88-88l-24 0 0-48zM32 0l240 0 0 272 112 0 0 240-352 0 0-512zM168 416l-24 0 0 48 128 0 0-48-104 0z"]
};
var faFrog = {
  prefix: 'fass',
  iconName: 'frog',
  icon: [576, 512, [], "f52e", "M368 32c41.7 0 75.9 31.8 79.7 72.5l128.3 39.5 0 80-175.2 99.5 92.5 92.5 82.7 0 0 64-109.3 0-119.8-119.8c11.7-36 3.2-77.1-25.4-105.7-40.6-40.6-106.3-40.6-146.9-.1l-73.6 70.1-11.6 11 22.1 23.2 11.6-11 73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2 27.9-18.5 65.9-15.4 90.5 9.2 24.7 24.7 27.7 62.9 9 90.9-2.6 3.8-5.6 7.5-9 10.9l-37.1 37.1 90.2 0 0 64-352 0 0-64C0 249.6 127 112.9 289.3 97.5 296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faWrenchSimple = {
  prefix: 'fass',
  iconName: 'wrench-simple',
  icon: [384, 512, [], "e2d1", "M128 160l64 64 64-64 0-160c74.6 26.4 128 92.4 128 176 0 71.1-38.6 133.1-96 166.3l0 169.7-192 0 0-169.7C38.6 309.1 0 247.1 0 176 0 92.4 53.4 26.4 128 0l0 160z"]
};
var faWineBottle = {
  prefix: 'fass',
  iconName: 'wine-bottle',
  icon: [320, 512, [], "f72f", "M80-64l160 0 0 64-16 0 0 141.3c56.5 24.7 96 81.1 96 146.7l0 288-320 0 0-288c0-65.6 39.5-122 96-146.7L96 0 80 0 80-64zM256 288l-192 0 0 192 192 0 0-192z"]
};
var faPancakes = {
  prefix: 'fass',
  iconName: 'pancakes',
  icon: [512, 512, [129374], "e42d", "M256 192c86.2 0 160.1-20.1 191.7-48.9 10.2-9.3 16-19.5 16.3-30.2 0-.3 0-.6 0-1 0-44.2-93.1-80-208-80S48 67.8 48 112c0 .3 0 .6 0 1 .2 6.7 2.6 13.3 6.9 19.5 6.9 10.1 18.9 19.4 34.7 27.5 7.3 3.7 15.3 7.2 24.1 10.3 1.5 .5 3 1.1 4.6 1.6 8 2.7 16.7 5.2 25.7 7.5l0 196.6 48 0 0-187.9c12.9 1.6 26.4 2.7 40.3 3.3 7.8 .3 15.7 .5 23.7 .5zm0 48c-5.4 0-10.7-.1-16-.2l0 48c5.3 .1 10.6 .2 16 .2 132.5 0 240-34.1 240-112 0-4.7-.4-9.3-1.2-13.7-4.6 6.2-9.7 11.7-14.9 16.4-16.5 15-37.6 26.2-59.6 34.7-44.4 17.1-102.5 26.6-164.3 26.6zM96.5 215.2c-1.6-.6-3.2-1.2-4.8-1.8-22-8.5-43.2-19.8-59.6-34.7-5.2-4.7-10.3-10.2-14.9-16.4-.8 4.4-1.2 9-1.2 13.7 0 41.8 30.9 70.9 80 89l0-41c0-3 .2-5.9 .5-8.8zM96 315.6c-9.9-3-19.3-6.4-28.3-10.2-18.3-7.7-36.2-17.8-51.6-30.7 .6 17.2 6.5 32.3 16.9 45.2l0 0c13.9 17.3 35.6 30.9 63.1 41l0-45.4zm144 68.2c5.3 .1 10.6 .2 16 .2 101.2 0 187.8-19.9 223.1-64l0 0c10.4-13 16.3-28 16.9-45.2-15.4 12.8-33.3 22.9-51.6 30.7-51.8 21.8-119 30.6-188.3 30.6-5.3 0-10.7-.1-16-.2l0 48zM256 432c-69.3 0-136.5-8.8-188.3-30.6-18.3-7.7-36.2-17.8-51.6-30.7 2.5 75.9 109 109.2 240 109.2s237.4-33.3 240-109.2c-15.4 12.8-33.3 22.9-51.6 30.7-51.8 21.8-119 30.6-188.3 30.6zM216 80l104 0 0 48-128 0 0-48 24 0z"]
};
var faInbox = {
  prefix: 'fass',
  iconName: 'inbox',
  icon: [512, 512, [], "f01c", "M447.5 288l-24-192-335 0-24 192 79.5 0 32 64 160 0 32-64 79.5 0zM0 288l32-256 448 0 32 256 0 192-512 0 0-192z"]
};
var faBoltSlash = {
  prefix: 'fass',
  iconName: 'bolt-slash',
  icon: [576, 512, [], "e0b8", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-155.7-155.7 138.5-115.4-217.6 0 89.6-256-208.3 173.6-158.5-158.5zM241.6 311.3L160.1 544 331.5 401.2 241.6 311.3zM133.7 203.4l-101.6 84.6 186.2 0-84.6-84.6z"]
};
var faStarShooting = {
  prefix: 'fass',
  iconName: 'star-shooting',
  icon: [512, 512, [127776], "e036", "M297 57l17-17-33.9-33.9c-8.8 8.8-25.1 25.1-49 49l-17 17 33.9 33.9c8.8-8.8 25.1-25.1 49-49zM489 249l17-17-33.9-33.9c-8.8 8.8-25.1 25.1-49 49l-17 17 33.9 33.9c8.8-8.8 25.1-25.1 49-49zm17-209l-33.9-33.9-17 17-128 128-17 17 33.9 33.9 17-17 128-128 17-17zM253.3 265.1L193.5 144 133.7 265.1 0 284.6 96.7 378.9 73.9 512 193.5 449.1 313 512 290.2 378.9 386.9 284.6 253.3 265.1z"]
};
var faHorizontalRule = {
  prefix: 'fass',
  iconName: 'horizontal-rule',
  icon: [640, 512, [8213], "f86c", "M0 224l640 0 0 64-640 0 0-64z"]
};
var faCloudBoltMoon = {
  prefix: 'fass',
  iconName: 'cloud-bolt-moon',
  icon: [640, 512, ["thunderstorm-moon"], "f76d", "M496.5 89.5c0-52.8 36.3-97 85.3-109.2-17.8-7.9-37.6-12.3-58.3-12.3-55.9 0-104.4 31.9-128.2 78.4 36.6 19.1 62.9 55.4 68 98.2 38.7 22 64.9 63.6 64.9 111.3 45.4-1.4 85.5-23.9 110.9-58-9.6 2.6-19.6 4.1-30.1 4.1-62.1 0-112.5-50.4-112.5-112.5zM208.6 416l-32.4 136 200-168-104.4 0 32.4-136-200 168 104.4 0zM32.3 239.9l0 96.1 92.6 0 161.9-136 78.3 0-32.4 136 147.6 0-.1-80.1c0-38.7-27.5-71-64-78.4l0-17.6c0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4-16.8-27.8-47.3-46.4-82.2-46.4-53.4 0-96 44.5-96 97.3-45.4 7.6-80 47.1-80 94.6z"]
};
var faThunderstormMoon = faCloudBoltMoon;
var faNfcSlash = {
  prefix: 'fass',
  iconName: 'nfc-slash',
  icon: [576, 512, [], "e1fc", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-5.9-5.9-28-28-66.1-66.1l0-414-414 0-48.9-48.9zM162.2 96l54 0 0 48-6 0-48-48zm102 102l0-102 184 0 0 286-48-48 0-190-88 0 0 102-48-48zm-88 170l122 0-122-122 0 122zm-48 24l0-194-64-64 0 346 346 0-64-64-218 0 0-24z"]
};
var faSquareH = {
  prefix: 'fass',
  iconName: 'square-h',
  icon: [448, 512, ["h-square"], "f0fd", "M448 32l-448 0 0 448 448 0 0-448zM320 168l0 200-48 0 0-88-96 0 0 88-48 0 0-224 48 0 0 88 96 0 0-88 48 0 0 24z"]
};
var faHSquare = faSquareH;
var faHouseMedical = {
  prefix: 'fass',
  iconName: 'house-medical',
  icon: [512, 512, [], "e3b2", "M512 272l-48 0 0 240-416 0 0-240-48 0 0-48 256-240 256 240 0 48zM224 288l-56 0 0 64 56 0 0 56 64 0 0-56 56 0 0-64-56 0 0-56-64 0 0 56z"]
};
var faCircleChevronRight = {
  prefix: 'fass',
  iconName: 'circle-chevron-right',
  icon: [512, 512, ["chevron-circle-right"], "f138", "M0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zm345 17l-104 104-17 17-33.9-33.9 17-17 87-87-87-87-17-17 33.9-33.9 17 17 104 104 17 17-17 17z"]
};
var faChevronCircleRight = faCircleChevronRight;
var faFileCsv = {
  prefix: 'fass',
  iconName: 'file-csv',
  icon: [576, 512, [], "f6dd", "M272 0l-240 0 0 512 144 0 0-176 240 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM264 380c-24.3 0-44 19.7-44 44l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-16-40 0 0 16c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 16 40 0 0-16c0-24.3-19.7-44-44-44l-16 0zm136 0c-28.7 0-52 23.3-52 52s23.3 52 52 52c6.6 0 12 5.4 12 12s-5.4 12-12 12l-52 0 0 40 52 0c28.7 0 52-23.3 52-52s-23.3-52-52-52c-6.6 0-12-5.4-12-12s5.4-12 12-12l44 0 0-40-44 0zm116 0l-40 0 0 55c0 21.6 3.9 43 11.5 63.2 10.7 28.5 16.9 45.1 18.7 49.8l43.7 0c1.8-4.7 8-21.3 18.7-49.8 7.6-20.2 11.5-41.6 11.5-63.2l0-55-40 0 0 55c0 16.8-3 33.4-8.9 49.2l-3.1 8.2-3.1-8.2C519 468.4 516 451.8 516 435l0-55z"]
};
var faHatCowboy = {
  prefix: 'fass',
  iconName: 'hat-cowboy',
  icon: [640, 512, [], "f8c0", "M192 32L130.8 307.5C145.5 324.9 167.4 336 192 336l256 0c24.6 0 46.5-11.1 61.2-28.5l-61.2-275.5-64 0-64 48-64-48-64 0zM64 256l0-32-64 0 0 32C0 362 86 448 192 448l256 0c106 0 192-86 192-192l0-32-64 0 0 32c0 70.7-57.3 128-128 128l-256 0c-70.7 0-128-57.3-128-128z"]
};
var faFaceGrinTongueWink = {
  prefix: 'fass',
  iconName: 'face-grin-tongue-wink',
  icon: [512, 512, [128540, "grin-tongue-wink"], "f58b", "M152.2 490.1C62.5 450.2 0 360.4 0 256 0 114.6 114.6 0 256 0S512 114.6 512 256c0 104.4-62.5 194.2-152.2 234.1 5.3-13 8.2-27.2 8.2-42.1l0-61.7c23.5-23 39.9-53.2 45.7-87-45.3 18.1-99.5 28.7-157.7 28.7S143.6 317.4 98.3 299.3c5.8 33.8 22.2 64 45.7 87l0 61.7c0 14.9 2.9 29.1 8.2 42.1zM152 212l16 0c11 0 20 9 20 20l0 16 40 0 0-16c0-33.1-26.9-60-60-60l-16 0c-33.1 0-60 26.9-60 60l0 16 40 0 0-16c0-11 9-20 20-20zm184 60a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM320 384l0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64 48 0 0 24 32 0 0-24 48 0zm16-200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGrinTongueWink = faFaceGrinTongueWink;
var faShelves = {
  prefix: 'fass',
  iconName: 'shelves',
  icon: [512, 512, ["inventory"], "f480", "M64 0l0 160 384 0 0-160 64 0 0 512-64 0 0-32-384 0 0 32-64 0 0-512 64 0zm0 416l384 0 0-192-384 0 0 192zM240 256l0 128-128 0 0-128 128 0zm32 0l128 0 0 128-128 0 0-128zM400 0l0 128-128 0 0-128 128 0z"]
};
var faInventory = faShelves;
var faHexagonExclamation = {
  prefix: 'fass',
  iconName: 'hexagon-exclamation',
  icon: [576, 512, [], "e417", "M433 28.1l123.7 216 6.8 11.9-6.8 11.9-123.7 216.1-6.9 12.1-275.2 0-6.9-12.1-123.7-216.1-6.8-11.9 6.8-11.9 123.7-216 6.9-12.1 275.2 0 6.9 12.1zM260.5 324l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0z"]
};
var faArrowsRepeat1 = {
  prefix: 'fass',
  iconName: 'arrows-repeat-1',
  icon: [512, 512, ["repeat-1-alt"], "f366", "M493.3 96c-5.5 5.5-39.7 39.7-102.6 102.6L368 221.3 322.7 176c14.6-14.6 30.6-30.6 48-48L64 128 64 288 0 288 0 64 370.7 64c-17.4-17.4-33.4-33.4-48-48L368-29.3c5.5 5.5 39.7 39.7 102.6 102.6L493.3 96zM18.7 416c5.5-5.5 39.7-39.7 102.6-102.6L144 290.7 189.3 336c-14.6 14.6-30.6 30.6-48 48l306.7 0 0-160 64 0 0 224-370.7 0c17.4 17.4 33.4 33.4 48 48L144 541.3 41.4 438.6 18.7 416zM240 192l48 0 0 128-48 0 0-80-24 0 0-48 24 0z"]
};
var faRepeat1Alt = faArrowsRepeat1;
var faL = {
  prefix: 'fass',
  iconName: 'l',
  icon: [320, 512, [108], "4c", "M96 32l0 384 224 0 0 64-288 0 0-448 64 0z"]
};
var faPhoneMissed = {
  prefix: 'fass',
  iconName: 'phone-missed',
  icon: [640, 512, [], "e226", "M184.3 0l125.8 0 0 48-67.9 0 78.1 78.1c63-63 95-95 96-96l33.9 33.9-17 17-96 96-17 17-17-17-95-95 0 67.9-48 0 0-149.8 24 0zM637.1 370.7l-45.2 135.8-158.9-22.1 .5-113.7c-73.1-26.5-153.2-26.5-226.3 0l.5 113.7-158.9 22.1-45.3-135.8 11.3-11.3c168.7-168.7 442.2-168.7 610.9 0l11.3 11.3z"]
};
var faArrowDownShortWide = {
  prefix: 'fass',
  iconName: 'arrow-down-short-wide',
  icon: [576, 512, ["sort-amount-desc", "sort-amount-down-alt"], "f884", "M150.9 470.6l-22.6 22.6c-4.2-4.2-41.1-41.1-110.6-110.6L-5 360 40.3 314.7c13.3 13.3 32 32 56 56l0-338.7 64 0 0 338.7c24-24 42.7-42.7 56-56L261.5 360 150.9 470.6zM320.3 32l64 0 0 64-96 0 0-64 32 0zm0 128l128 0 0 64-160 0 0-64 32 0zm0 128l192 0 0 64-224 0 0-64 32 0zm0 128l256 0 0 64-288 0 0-64 32 0z"]
};
var faSortAmountDesc = faArrowDownShortWide;
var faSortAmountDownAlt = faArrowDownShortWide;
var faHourglassHalf = {
  prefix: 'fass',
  iconName: 'hourglass-half',
  icon: [384, 512, ["hourglass-2"], "f252", "M0 0l384 0 0 64-32 0 0 77.3-9.4 9.4-105.4 105.4 114.7 114.7 0 77.3 32 0 0 64-384 0 0-64 32 0 0-77.3 9.4-9.4 105.4-105.4-105.4-105.4-9.4-9.4 0-77.3-32 0 0-64zM96 64l0 50.7 13.3 13.3 165.5 0 13.3-13.3 0-50.7-192 0zm13.3 320l165.5 0-82.7-82.7-82.7 82.7z"]
};
var faHourglass2 = faHourglassHalf;
var faScalpelLineDashed = {
  prefix: 'fass',
  iconName: 'scalpel-line-dashed',
  icon: [640, 512, ["scalpel-path"], "f61e", "M0 480L111.6 368 304 368 192 480 0 480zM416 320L159.4 320 452.6 25.9c17.2-17.3 40.6-26.9 65-26.7 49.8 .4 89.9 41.5 89.9 91.2 0 24.3-9.6 47.8-26.8 64.9L416 320zM344 432l104 0 0 48-128 0 0-48 24 0zm176 0l88 0 0 48-112 0 0-48 24 0z"]
};
var faScalpelPath = faScalpelLineDashed;
var faCloudSnow = {
  prefix: 'fass',
  iconName: 'cloud-snow',
  icon: [512, 512, [127784], "f742", "M96 320l-96 0 0-96c0-41.8 26.7-77.4 64-90.5L64 112c0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-416 0zm0 72l0 16 40 0 0 48-40 0 0 40-48 0 0-40-40 0 0-48 40 0 0-40 48 0 0 24zm184 32l0 16 40 0 0 48-40 0 0 40-48 0 0-40-40 0 0-48 40 0 0-40 48 0 0 24zm184-56l0 40 40 0 0 48-40 0 0 40-48 0 0-40-40 0 0-48 40 0 0-40 48 0z"]
};
var faSquareDownRight = {
  prefix: 'fass',
  iconName: 'square-down-right',
  icon: [448, 512, [], "e26c", "M0 480l448 0 0-448-448 0 0 448zM296 352l-169.9 0c29.6-29.6 52.3-52.3 68-68l-84-84c24.3-24.3 54.1-54.1 57.9-57.9l84 84c15.7-15.7 38.4-38.4 68-68l0 193.9-24 0z"]
};
var faSpoon = {
  prefix: 'fass',
  iconName: 'spoon',
  icon: [512, 512, [129348, 61873, "utensil-spoon"], "f2e5", "M224 160.2C224 80 320 0 416 0 469 0 512 43 512 96 512 192 432 288 351.8 288l-39.6 0-21.5-21.5-220.1 220.1-22.6 22.6-45.3-45.3 22.6-22.6 220.1-220.1-21.5-21.5 0-39.6z"]
};
var faUtensilSpoon = faSpoon;
var faClockEleven = {
  prefix: 'fass',
  iconName: 'clock-eleven',
  icon: [512, 512, [], "e347", "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 56.7c-14.5-21.7-25.6-38.4-33.3-50l-39.9 26.6c.4 .6 26.2 39.3 77.3 116l44-13.3 0-160-48 0 0 24z"]
};
var faCreditCard = {
  prefix: 'fass',
  iconName: 'credit-card',
  icon: [512, 512, [128179, 62083, "credit-card-alt"], "f09d", "M0 64l0 96 512 0 0-96-512 0zM0 208l0 240 512 0 0-240-512 0zM64 336l96 0 0 48-96 0 0-48zm144 0l112 0 0 48-112 0 0-48z"]
};
var faCreditCardAlt = faCreditCard;
var faFileInvoiceDollar = {
  prefix: 'fass',
  iconName: 'file-invoice-dollar',
  icon: [384, 512, [], "f571", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM64 64l0 32 96 0 0-32-96 0zm0 64l0 32 96 0 0-32-96 0zM176 240l0 24c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5l-75.5 0 0 40 44 0 0 24 40 0 0-24.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l67.5 0 0-40-28 0 0-24-40 0z"]
};
var faViolin = {
  prefix: 'fass',
  iconName: 'violin',
  icon: [640, 512, [127931], "f8ed", "M520.5 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM334.3 52.2l17-17-33.9-33.9-17 17-281.6 281.6-17 17 33.9 33.9 17-17 281.6-281.6zM472.5 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm48-48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM615.1 70.6L637.7 48 592.5 2.7 569.9 25.4 417.5 177.7c-19.1-11.3-41.3-17.7-65-17.7-25.4 0-49.1 7.4-69 20.2 3.2 8.7 5 18.1 5 27.8 0 44.2-35.8 80-80 80-16.7 0-32.3-5.1-45.1-13.9-21.7 25.2-34.9 58-34.9 93.9 0 10.9 1.2 21.5 3.5 31.7 33.2-26.5 59.9-47.9 80.1-64 45.3 45.3 78.7 78.7 92.8 92.8-16.2 20.2-37.5 46.9-64 80.1 10.2 2.3 20.8 3.5 31.7 3.5 35.9 0 68.7-13.1 93.9-34.9-8.8-12.8-13.9-28.4-13.9-45.1 0-44.2 35.8-80 80-80 9.8 0 19.2 1.8 27.8 5 12.8-19.9 20.2-43.6 20.2-69 0-23.7-6.5-46-17.7-65L615.1 70.6zM151.3 445.8l-22.8 18.2 48 48c27.2-34 36.3-45.3 55.4-69.3 4-5 6.8-8.5 8.6-10.7l-32-32c-1 .8-19.2 15.3-42.3 33.8l-14.9 11.9z"]
};
var faSpaghettiMonsterFlying = {
  prefix: 'fass',
  iconName: 'spaghetti-monster-flying',
  icon: [640, 512, ["pastafarianism"], "f67b", "M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3c-10-11.3-16-26.1-16-42.3 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4 7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4 10.7 11.7 16.1 13.4 19.4 13.4 2.5 0 4.3-.6 7.1-3.3 3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7 9.7-9.3 22.9-16.7 40.4-16.7l24 0 0 48-24 0c-2.5 0-4.3 .6-7.1 3.3-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7-9.7 9.3-22.9 16.7-40.4 16.7-18.5 0-32.9-8.5-44.3-18.6-3.1 4-6.6 8.3-10.5 12.7 1.4 4.3 2.8 8.5 4 12.5 .9 3 1.8 5.8 2.6 8.6 3 9.8 5.5 18.2 8.6 25.9 3.9 9.8 7.4 15.4 10.8 18.5 2.6 2.4 5.9 4.3 12.8 4.3 8.7 0 16.9-4.2 33.7-13.2 15-8 35.7-18.8 62.3-18.8l24 0 0 48-24 0c-13.4 0-24.7 5.2-39.7 13.2-1 .6-2.1 1.1-3.2 1.7-13.1 7.1-31.6 17.1-53.1 17.1-18.4 0-33.6-6.1-45.5-17.2-11.1-10.3-17.9-23.7-22.7-36-3.6-9-6.7-19.1-9.5-28.5-16.4 12.3-36.1 23.6-58.9 31.3 3.6 10.8 8.4 23.5 14.4 36.2 7.5 15.9 16.2 30.4 25.8 40.5 9.6 10.2 17.7 13.7 24.5 13.7l24 0 0 48-24 0c-25.2 0-45-13.5-59.5-28.8-14.5-15.4-25.7-34.9-34.2-53-8-17-14.1-33.8-18.3-46.9-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9-8.5 18.1-19.8 37.6-34.2 53-14.4 15.3-34.3 28.8-59.5 28.8l-24 0 0-48 24 0c6.8 0 15-3.5 24.5-13.7 9.5-10.1 18.3-24.6 25.8-40.5 5.9-12.6 10.7-25.4 14.4-36.2-22.8-7.7-42.5-19-58.9-31.3-2.9 9.4-6 19.5-9.5 28.5-4.8 12.2-11.6 25.6-22.7 36-11.9 11.1-27.1 17.2-45.5 17.2-21.4 0-39.9-10-53.1-17.1l0 0c-1.1-.6-2.2-1.2-3.2-1.7-15-8-26.3-13.2-39.7-13.2l-24 0 0-48 24 0c26.6 0 47.3 10.8 62.3 18.8 16.8 9 25 13.2 33.7 13.2 6.8 0 10.2-1.9 12.8-4.3 3.4-3.2 7-8.8 10.8-18.5 3-7.7 5.6-16.1 8.6-25.9 .8-2.7 1.7-5.6 2.6-8.6 1.2-4 2.6-8.2 4-12.5-3.9-4.5-7.4-8.8-10.5-12.7-11.4 10.1-25.9 18.6-44.3 18.6-17.5 0-30.7-7.4-40.4-16.7-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4-2.8-2.7-4.6-3.3-7.1-3.3l-24 0 0-48 24 0c17.5 0 30.7 7.4 40.4 16.7 8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4 2.8 2.7 4.6 3.3 7.1 3.3 3.3 0 8.7-1.7 19.4-13.4 5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24 13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64zm208 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faPastafarianism = faSpaghettiMonsterFlying;
var faMartiniGlassCitrus = {
  prefix: 'fass',
  iconName: 'martini-glass-citrus',
  icon: [640, 512, ["cocktail"], "f561", "M576 80c0-44.2-35.8-80-80-80-18 0-34.6 6-48 16l-81 0c23.6-47.4 72.5-80 129-80 79.5 0 144 64.5 144 144S575.5 224 496 224c-6.5 0-13-.4-19.3-1.3l64-74.7c1.1-1.3 2.2-2.7 3.3-4.1 19.4-14.6 32-37.8 32-64zM78 128l-14-16 0-48 448 0 0 48-14 16-167.5 191.4-10.5 12 0 116.6 96 0 0 64-256 0 0-64 96 0 0-116.6-10.5-12-167.5-191.4zM288 270.8L413 128 163 128 288 270.8z"]
};
var faCocktail = faMartiniGlassCitrus;
var faChartMixedUpCircleDollar = {
  prefix: 'fass',
  iconName: 'chart-mixed-up-circle-dollar',
  icon: [640, 512, [], "e5d9", "M432.5 0l-32 0 0 64 60.8 0-109.4 87.5-108.2-81.1-19.8-14.9-19.4 15.5-160 128-25 20 40 50 25-20 140.6-112.5 108.2 81.1 19.8 14.9 19.4-15.5 140-112 0 71 64 0 0-176-144 0zm-240 224l0 256 64 0 0-256-64 0zm-128 96l0 160 64 0 0-160-64 0zm400 224a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-240l0 24 32 0 0 32-61.8 0c-5.6 0-10.2 4.6-10.2 10.2 0 4.9 3.5 9.1 8.3 10l45 8.2c20 3.6 34.6 21.1 34.6 41.5 0 23.3-18.9 42.2-42.2 42.2l-5.8 0 0 24-32 0 0-24-32 0 0-32 69.8 0c5.6 0 10.2-4.6 10.2-10.2 0-4.9-3.5-9.1-8.3-10l-45-8.2c-20-3.6-34.6-21.1-34.6-41.5 0-22.6 17.7-41 40-42.1l0-24.1 32 0z"]
};
var faSquareRupee = {
  prefix: 'fass',
  iconName: 'square-rupee',
  icon: [448, 512, [], "e715", "M448 32l-448 0 0 448 448 0 0-448zM120 144l48 0c39.8 0 72 32.2 72 72 0 26.9-14.7 50.3-36.5 62.6 14.8 44.3 23.7 71.2 26.8 80.5l-45.5 15.2C182 366 172.4 337.2 156 288l-12 0 0 80-48 0 0-224 24 0zm48 96c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0 48 24 0zm80 .1c0-31 25.1-56.1 56.1-56.1l63.9 0 0 48-63.9 0c-4.5 0-8.1 3.6-8.1 8.1 0 3.6 2.3 6.7 5.8 7.8L336 258.1c23.7 7.1 40 29 40 53.7 0 31-25.1 56.1-56.1 56.1l-63.9 0 0-48 63.9 0c4.5 0 8.1-3.6 8.1-8.1 0-3.6-2.3-6.7-5.8-7.8L288 293.9c-23.7-7.1-40-29-40-53.7z"]
};
var faClockOneThirty = {
  prefix: 'fass',
  iconName: 'clock-one-thirty',
  icon: [512, 512, [], "e34f", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm24-120l0-128.7c47.7-71.6 72.2-108.3 73.3-109.9l-39.9-26.6c-.4 .6-26.2 39.3-77.3 116l-4 6 0 167.3 48 0 0-24z"]
};
var faBullhorn = {
  prefix: 'fass',
  iconName: 'bullhorn',
  icon: [512, 512, [128226, 128363], "f0a1", "M380.4 64.7l37.3-32.7 62.3 0 0 448-62.3 0-37.3-32.7c-43.6-38.1-98.7-60.3-156.4-63l0 127.7-96 0 0-128-128 0 0-256 212.5 0c61.8-.2 121.4-22.7 167.9-63.3zM224 320l0 .2c70.3 2.7 137.8 28.5 192 73.4l0-275.3c-54.2 44.9-121.7 70.7-192 73.4L224 320z"]
};
var faBoxTissue = {
  prefix: 'fass',
  iconName: 'box-tissue',
  icon: [512, 512, [], "e05b", "M64 32l224 0 32 96 128 0-64 192-256 0-64-288zM0 256l64.6 0C77 311.8 85.3 349.1 89.5 368l329.1 0c4.7-14.2 17.2-51.5 37.3-112l56.1 0 0 224-512 0 0-224z"]
};
var faDoNotEnter = {
  prefix: 'fass',
  iconName: 'do-not-enter',
  icon: [512, 512, [], "f5ec", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM416 224l0 64-320 0 0-64 320 0z"]
};
var faAngle = {
  prefix: 'fass',
  iconName: 'angle',
  icon: [512, 512, [], "e08c", "M284.9 78.3l14.3-28.6-57.2-28.6-14.3 28.6-192 384-23.2 46.3 467.8 0 0-64-364.2 0 168.8-337.7zm83.7 209.1l-40.9 25.4c9 17.5 16.3 36 21.7 55.2l49.6 0c-6.8-28.4-17.1-55.4-30.4-80.6zM302.3 272l40.9-25.4c-16.6-23-36.1-43.9-57.7-62.1l-22.2 44.3c14.4 13.1 27.4 27.5 39 43.1z"]
};
var faHouseUnlock = {
  prefix: 'fass',
  iconName: 'house-unlock',
  icon: [640, 512, [], "e6ca", "M368 512l0-208 32 0c0-60 41.2-110.3 96.9-124.2L288-16 32 224 32 272 80 272 80 512 368 512zM224 464l0-144 96 0 0 144-96 0zM528 272c17.7 0 32 14.3 32 32l48 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48-32 0 0 192 224 0 0-192-144 0 0-48c0-17.7 14.3-32 32-32z"]
};
var faMattressPillow = {
  prefix: 'fass',
  iconName: 'mattress-pillow',
  icon: [576, 512, [], "e525", "M256 64l-256 0 0 384 256 0 0-384zm48 384l272 0 0-384-272 0 0 384zM64 128l128 0 0 256-128 0 0-256z"]
};
var faMessageDot = {
  prefix: 'fass',
  iconName: 'message-dot',
  icon: [576, 512, [], "e6df", "M496 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c17 0 33.2-3.3 48-9.3l0 249.3-224 0-160 96 0-96-128 0 0-416 345.3 0c-6 14.8-9.3 31-9.3 48 0 70.7 57.3 128 128 128z"]
};
var faCricketBatBall = {
  prefix: 'fass',
  iconName: 'cricket-bat-ball',
  icon: [640, 512, [127951, "cricket"], "f449", "M621.5 0l-22.6 22.6-160 160 73.4 73.4-32 32-192 0 0-192 32-32 73.4 73.4 160-160 22.6-22.6 45.3 45.3zM240.3 144l0 192 192 0-176 176-32 0c-88.4 0-160-71.6-160-160l0-32 176-176zm256 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faCricket = faCricketBatBall;
var faChevronLeft = {
  prefix: 'fass',
  iconName: 'chevron-left',
  icon: [320, 512, [9001], "f053", "M3 256l22.6 22.6 192 192 22.6 22.6 45.3-45.3-22.6-22.6-169.4-169.4 169.4-169.4 22.6-22.6-45.3-45.3-22.6 22.6-192 192-22.6 22.6z"]
};
var faCloudMoonRain = {
  prefix: 'fass',
  iconName: 'cloud-moon-rain',
  icon: [576, 512, [], "f73c", "M418.4 135c0 69 56 125 125 125 11.6 0 22.8-1.6 33.4-4.5-29.2 39.2-75.8 64.5-128.4 64.5-16.7 0-32.8-2.6-48-7.3l0-40.7c0-48.6-27-90.8-66.9-112.5-5.4-22.2-17.9-41.7-34.9-55.8 22.8-60.6 81.3-103.8 149.8-103.8 23.1 0 45 4.9 64.8 13.7-54.5 13.5-94.8 62.7-94.8 121.3zM.4 352l0-80c0-33.9 21.1-62.9 50.9-74.5-1.9-6.8-2.9-14-2.9-21.5 0-44.2 35.8-80 80-80 30.8 0 57.5 17.4 70.9 42.8 9.3-6.8 20.7-10.8 33.1-10.8 34.3 0 60.9 32 55.2 65.4 36.9 7.1 64.8 39.6 64.8 78.6l0 80-352 0zm44 48l50.6 0-37.3 112-50.6 0 37.3-112zM335 400l-37.3 112-50.6 0 37.3-112 50.6 0zm-120 0l-37.3 112-50.6 0 37.3-112 50.6 0z"]
};
var faArrowDown19 = {
  prefix: 'fass',
  iconName: 'arrow-down-1-9',
  icon: [576, 512, ["sort-numeric-asc", "sort-numeric-down"], "f162", "M182.9 470.6l-22.6 22.6c-2.9-2.9-42.4-42.4-118.6-118.6L19 352 64.3 306.7c12 12 33.3 33.3 64 64l0-338.7 64 0 0 338.7c30.7-30.7 52-52 64-64L301.5 352c-2.9 2.9-42.4 42.4-118.6 118.6zM352.3 32l112 0 0 128 48 0 0 64-160 0 0-64 48 0 0-64-48 0 0-64zm25.6 448l36.6-66c-35.6-8.1-62.3-39.9-62.3-78 0-44.2 35.8-80 80-80s80 35.8 80 80c0 22.2-5.7 44.1-16.5 63.5l-44.7 80.5-73.2 0zm54.4-120a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSortNumericAsc = faArrowDown19;
var faSortNumericDown = faArrowDown19;
var faBinBottlesRecycle = {
  prefix: 'fass',
  iconName: 'bin-bottles-recycle',
  icon: [576, 512, [], "e5f6", "M96 32l0 64c-35.3 0-64 28.7-64 64l0 16 512 0 0-16c0-35.3-28.7-64-64-64l0-64-128 0 0 64c-35.3 0-64 28.7-64 64 0-35.3-28.7-64-64-64l0-64-128 0zM0 224l0 64 36 0 28 224 448 0 28-224 36 0 0-64-576 0zm259.8 32l56.3 0 7.2 9.8 40.5 55.2-40.8 25.5-31.2-42.5-7.7 0-31.2 42.5-40.8-25.5 40.5-55.2 7.2-9.8zm86.9 122.9l40.8-25.5 23.8 32.4 4.6 6.3 0 71.9-108 0 0-48 60 0 0-8.1-21.3-29zM208 416l60 0 0 48-108 0 0-71.9 4.6-6.3 23.8-32.4 40.8 25.5-21.3 29 0 8.1z"]
};
var faBringFront = {
  prefix: 'fass',
  iconName: 'bring-front',
  icon: [576, 512, [], "f857", "M64 32l96 0 0 16 64 0 0-80-224 0 0 224 80 0 0-64-16 0 0-96zM352 480l0 64 224 0 0-224-80 0 0 64 16 0 0 96-96 0 0-16-64 0 0 16zM448 96l-320 0 0 320 320 0 0-320z"]
};
var faSeatAirline = {
  prefix: 'fass',
  iconName: 'seat-airline',
  icon: [384, 512, [], "e244", "M64 0l0 154.8 12.4 37.2 243.6 0 0 64-222.3 0 21.3 64 264.9 0 0 64-311.1 0-7.3-21.9-64-192-1.6-4.9 0-165.2 64 0zM32 448l352 0 0 64-352 0 0-64z"]
};
var faSquareTenge = {
  prefix: 'fass',
  iconName: 'square-tenge',
  icon: [448, 512, [], "e731", "M448 32l-448 0 0 448 448 0 0-448zM336 128l0 32-224 0 0-32 224 0zm0 64l0 48-88 0 0 144-48 0 0-144-88 0 0-48 224 0z"]
};
var faHandSpock = {
  prefix: 'fass',
  iconName: 'hand-spock',
  icon: [512, 512, [128406], "f259", "M219.5 39.7l-8.3-30.9-61.8 16.6 8.3 30.9 53.5 199.7-29.6 0-46.7-153.3-9.3-30.6-61.2 18.6 9.3 30.6 71.7 235.5c-46.5-44.3-76.6-73-90.5-86.2L-.4 328.5c8.1 7.7 49.9 47.5 125.4 119.5 43.1 41.1 100.4 64 160 64l19.5 0c56.7 0 106.7-37.3 122.8-91.7l83.7-283.2 9.1-30.7-61.4-18.1c-.8 2.7-17.3 58.7-49.6 167.8l-24.7 0 39.2-185.4 6.6-31.3-62.6-13.2-6.6 31.3-42 198.6-41.5 0-57.9-216.3z"]
};
var faWandMagicSparkles = {
  prefix: 'fass',
  iconName: 'wand-magic-sparkles',
  icon: [640, 512, ["magic-wand-sparkles"], "e2ca", "M288 112l-24-56-56-24 56-24 24-56 24 56 56 24-56 24-24 56zM16 128l80-32 32-80 32 80 80 32-80 32-32 80-32-80-80-32zM464 368l32-80 32 80 80 32-80 32-32 80-32-80-80-32 80-32zM496-13.3L589.3 80 471.6 197.7 378.3 104.4 496-13.3zM50.7 432L344.4 138.3 437.7 231.6 144 525.3 50.7 432z"]
};
var faMagicWandSparkles = faWandMagicSparkles;
var faPanelEws = {
  prefix: 'fass',
  iconName: 'panel-ews',
  icon: [448, 512, [], "e42e", "M448 32L0 32 0 352 64 352c22.1 0 40-17.9 40-40l0-56-40 0 0-160 128 0 0 160-40 0 0 56c0 48.6-39.4 88-88 88l-64 0 0 80 448 0 0-448zM280 96l104 0 0 48-128 0 0-48 24 0zm0 96l104 0 0 48-128 0 0-48 24 0zm104 96l0 128-128 0 0-128 128 0z"]
};
var faCommentMedical = {
  prefix: 'fass',
  iconName: 'comment-medical',
  icon: [512, 512, [], "f7f5", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM217.6 201.6l-67.2 0 0 76.8 67.2 0 0 67.2 76.8 0 0-67.2 67.2 0 0-76.8-67.2 0 0-67.2-76.8 0 0 67.2z"]
};
var faBellSlash = {
  prefix: 'fass',
  iconName: 'bell-slash',
  icon: [576, 512, [128277, 61943], "f1f6", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-1-1-33-33-96.1-96.1l46 0-80-128 0-96c0-77.4-55-142-128-156.8l0-35.2-64 0 0 35.2C217.6 43 184.1 64.7 161 94.8L49.3-16.9zM128.1 288l-80 128 286.9 0-206.9-206.9 0 78.9zm98 176c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48l-124 0z"]
};
var faHandshakeSlash = {
  prefix: 'fass',
  iconName: 'handshake-slash',
  icon: [576, 512, [57439, "handshake-alt-slash", "handshake-simple-slash"], "e060", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-280.1-280.1 31-31 0 0c34.8 34.5 99.3 98.5 193.6 192l70.4-56 0-288-112 64-48-32-128 0 0 0-74.8 83.1-34-34 44.2-49.1-63.4 0-18 12-92.9-92.9zM.1 69.8l0 250.2 192 160 62.1 0c-3-3-11-11-24-24l33.9-33.9c7.3 7.3 26.6 26.6 57.9 57.9l62.1 0 14.3-11.9-398.3-398.3z"]
};
var faHandshakeAltSlash = faHandshakeSlash;
var faHandshakeSimpleSlash = faHandshakeSlash;
var faPizza = {
  prefix: 'fass',
  iconName: 'pizza',
  icon: [576, 512, [127829], "f817", "M256 464c57.4 0 109.4-23.3 147.1-60.9L437 437c-46.3 46.3-110.3 75-181 75-141.4 0-256-114.6-256-256S114.6 0 256 0c70.7 0 134.7 28.7 181 75l-33.9 33.9C365.4 71.3 313.4 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208zm124.5-83.5c-68.7 68.7-180.2 68.7-248.9 0s-68.7-180.2 0-248.9 180.2-68.7 248.9 0L256 256 380.5 380.5zM192 264a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm24-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm190.6 14.6C509.4 354.3 528 307.3 528 256s-18.6-98.3-49.4-134.6l34-34c39.5 45 63.4 104 63.4 168.6s-23.9 123.6-63.4 168.6l-34-34zM344 256l35.5-35.5c3.6 2.2 7.9 3.5 12.5 3.5 13.3 0 24-10.7 24-24 0-4.6-1.3-8.9-3.5-12.5l43.4-43.4c53.5 64.8 53.5 158.9 0 223.8L344 256zm104 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBottleWater = {
  prefix: 'fass',
  iconName: 'bottle-water',
  icon: [320, 512, [], "e4c5", "M240-32l0 64-160 0 0-64 160 0zM16 144c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64 0 24.1-13.3 45.1-33 56 19.7 10.9 33 31.9 33 56s-13.3 45.1-33 56c19.7 10.9 33 31.9 33 56s-13.3 45.1-33 56c19.7 10.9 33 31.9 33 56l0 64-288 0 0-64c0-24.1 13.3-45.1 33-56-19.7-10.9-33-31.9-33-56s13.3-45.1 33-56c-19.7-10.9-33-31.9-33-56s13.3-45.1 33-56c-19.7-10.9-33-31.9-33-56z"]
};
var faUserPoliceTieHairLong = {
  prefix: 'fass',
  iconName: 'user-police-tie-hair-long',
  icon: [448, 512, [], "e7b6", "M65.7 11.2L215.6-29.7c5.5-1.5 11.3-1.5 16.8 0L382.3 11.2c10.5 2.9 17.7 12.4 17.7 23.2 0 8.5-4.4 16.3-11.7 20.6L368 67.2 368 91.8c0 11.4-6 21.8-16 26.7l0 57.5 48 96-352 0 48-96 0-57.5c-10-5-16-15.4-16-26.7L80 67.2 59.7 55C52.4 50.7 48 42.8 48 34.4 48 23.5 55.3 14 65.7 11.2zM304 144l0-10.3c-23.2 5.7-50.9 10.3-80 10.3s-56.8-4.6-80-10.3l0 10.3c0 44.2 35.8 80 80 80s80-35.8 80-80zM272 328l-31.6 36.9 31 115.1 .6 0 40-160 56 0 64 192-416 0 64-192 56 0 40 160 31.4-115.3-31.4-36.7 0-24 96 0 0 24zM264 64l-40-40-40 40 40 40 40-40z"]
};
var faFolders = {
  prefix: 'fass',
  iconName: 'folders',
  icon: [576, 512, [], "f660", "M576 384l-480 0 0-384 208 0 64 64 208 0 0 320zM48 120l0 312 432 0 0 48-480 0 0-384 48 0 0 24z"]
};
var faSunDust = {
  prefix: 'fass',
  iconName: 'sun-dust',
  icon: [576, 512, [], "f764", "M409.7 14.7l17.5 86.3-56.8 56.8c-22.2-18.6-50.9-29.8-82.2-29.8-70.7 0-128 57.3-128 128 0 31.3 11.2 59.9 29.8 82.2l-56.8 56.8C67.2 381.6 26.7 373.4 12 370.4 19.1 359.8 44.4 321.6 87.9 256 44.4 190.4 19.1 152.2 12 141.6 24.5 139 69.4 130 146.6 114.3 162.2 37.1 171.3-7.7 173.8-20.2 184.5-13.2 222.6 12.1 288.2 55.7 353.9 12.1 392-13.2 402.6-20.2l7.1 35zM288.2 176c18 0 34.6 6 48 16l-112 112c-10-13.4-16-30-16-48 0-44.2 35.8-80 80-80zm192-16a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-80 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-112-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-48-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faDiceD20 = {
  prefix: 'fass',
  iconName: 'dice-d20',
  icon: [512, 512, [], "f6cf", "M512 118.9L512 409.1 256 554.1 0 409.1 0 118.9 256-26.1 512 118.9zM165.5 192l-.4 0-91.6-49.6-.7-.4-16.8 9.6 0 26.8 88.9 48.2-88.9 149.4 180 64.8 0 37.7 20 11.3 20-11.3 0-37.7 180-64.8-88.9-149.4 88.9-48.2 0-26.8-16.8-9.6-.7 .4-91.6 49.6-.4 0-90.5-152-90.5 152zm64.6 204.1l-114.9-41.3 51.2-86 63.7 127.4zm166.8-41.3l-114.9 41.3 63.7-127.4 51.2 86zM319.3 232L256 358.6 192.7 232 319.3 232zm-19.4-40l-87.8 0 43.9-73.8 43.9 73.8z"]
};
var faFolderGear = {
  prefix: 'fass',
  iconName: 'folder-gear',
  icon: [512, 512, ["folder-cog"], "e187", "M512 448l-512 0 0-416 224 0 64 48 224 0 0 368zM284 160l-56 0 0 29.1c-11.1 3.7-21.2 9.7-29.8 17.2l-25.2-14.5-28 48.5 25.2 14.5c-1.1 5.6-1.7 11.3-1.7 17.2s.6 11.6 1.7 17.2l-25.2 14.5 28 48.5 25.2-14.5c8.6 7.6 18.7 13.5 29.8 17.2l0 29.1 56 0 0-29.1c11.1-3.7 21.2-9.7 29.8-17.2l25.2 14.6 28-48.5-25.2-14.5c1.1-5.6 1.7-11.3 1.7-17.2s-.6-11.6-1.7-17.2l25.2-14.5-28-48.5-25.2 14.6c-8.6-7.6-18.7-13.5-29.8-17.2l0-29.1zM224 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faFolderCog = faFolderGear;
var faAlmostEqualTo = {
  prefix: 'fass',
  iconName: 'almost-equal-to',
  icon: [512, 512, [], "e818", "M478.2 333.2c-12.2 48.7-55.9 82.8-106.1 82.8-10.9 0-21.7-1.6-32.2-4.8L154.2 354c-4.3-1.3-8.8-2-13.3-2-20.8 0-38.9 14.2-44 34.3l-7.4 29.7-65.9 0 11.3-45.2c12.2-48.7 55.9-82.8 106.1-82.8 10.9 0 21.7 1.6 32.2 4.8L358.8 350c4.3 1.3 8.8 2 13.3 2 20.8 0 38.9-14.1 44-34.3l7.4-29.7 65.9 0-11.3 45.2zm0-192c-12.2 48.7-55.9 82.8-106.1 82.8-10.9 0-21.7-1.6-32.2-4.8L154.2 162c-4.3-1.3-8.8-2-13.3-2-20.8 0-38.9 14.2-44 34.3l-7.4 29.7-65.9 0 11.3-45.2c12.2-48.7 55.9-82.8 106.1-82.8 10.9 0 21.7 1.6 32.2 4.8L358.8 158c4.3 1.3 8.8 2 13.3 2 20.8 0 38.9-14.1 44-34.3l7.4-29.7 65.9 0-11.3 45.2z"]
};
var faArrowDownZA = {
  prefix: 'fass',
  iconName: 'arrow-down-z-a',
  icon: [512, 512, ["sort-alpha-desc", "sort-alpha-down-alt"], "f881", "M150.9 470.6l-22.6 22.6c-5.5-5.5-39.7-39.7-102.6-102.6L3 368 48.3 322.7c14.6 14.6 30.6 30.6 48 48l0-338.7 64 0 0 338.7c17.4-17.4 33.4-33.4 48-48L253.5 368c-5.5 5.5-39.7 39.7-102.6 102.6zM448.3 32l32 0 0 45.3-9.4 9.4-73.4 73.4 82.7 0 0 64-192 0 0-45.3 9.4-9.4 73.4-73.4-82.7 0 0-64 160 0zm-94 224l60 0 7.9 20.5 78.3 203.5-68.6 0-12.3-32-70.5 0-12.3 32-68.6 0 78.3-203.5 7.9-20.5zm30 100.3l-16.8 43.7 33.6 0-16.8-43.7z"]
};
var faSortAlphaDesc = faArrowDownZA;
var faSortAlphaDownAlt = faArrowDownZA;
var faBrush = {
  prefix: 'fass',
  iconName: 'brush',
  icon: [384, 512, [], "f55d", "M192 64l-32-64-32 0-32 64-32-64-64 0 0 256 384 0 0-256-160 0-32 64zM0 304l0 80 128 0 0 128 128 0 0-128 128 0 0-80-384 0zM192 464c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
};
var faPersonWalkingDashedLineArrowRight = {
  prefix: 'fass',
  iconName: 'person-walking-dashed-line-arrow-right',
  icon: [640, 512, [], "e553", "M216 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM112 112l-13.3 0-9.4 9.4-80 80-9.4 9.4 0 109.3 64 0 0-82.7 32-32 0 69.3c0 28 12.2 54.7 33.5 72.9l80.7 69.1c11 71.6 17.4 112.9 19.1 123.9l63.3-9.7c-1.4-9-8.3-54.2-20.9-135.6l-1.8-11.7-9-7.7-52.8-45.3 0-115.2c17.6 22 28.4 35.6 32.6 40.8l111.4 0 0-64-80.6 0-54.4-68-9.6-12-95.4 0zM96.1 371L83.5 415.2C38.8 459.9 11.9 486.8 2.7 496l45.3 45.3 86.6-86.6 5.9-5.9c.8-2.7 3.8-13.2 9-31.5l-46-39.4c-2.5-2.2-5-4.4-7.4-6.8zM609 273l17-17c-2.1-2.1-31.8-31.8-89-89l-17-17-33.9 33.9c9 9 25 25 48 48l-126.1 0 0 48 126.1 0c-23 23-39 39-48 48L520 361.9c2.1-2.1 31.8-31.8 89-89zM432-16l-48 0 0 80 48 0 0-80zm0 152l0-24-48 0 0 80 48 0 0-56zm0 184l-48 0 0 80 48 0 0-80zm0 152l0-24-48 0 0 80 48 0 0-56z"]
};
var faArrowUpShortWide = {
  prefix: 'fass',
  iconName: 'arrow-up-short-wide',
  icon: [576, 512, ["sort-amount-up-alt"], "f885", "M150.9 41.4L128.3 18.7c-4.2 4.2-41.1 41.1-110.6 110.6L-5 152 40.3 197.3c13.3-13.3 32-32 56-56l0 338.7 64 0 0-338.7c24 24 42.7 42.7 56 56L261.5 152c-4.2-4.2-41.1-41.1-110.6-110.6zM320.3 32l-32 0 0 64 96 0 0-64-64 0zm0 128l-32 0 0 64 160 0 0-64-128 0zm0 128l-32 0 0 64 224 0 0-64-192 0zm0 128l-32 0 0 64 288 0 0-64-256 0z"]
};
var faSortAmountUpAlt = faArrowUpShortWide;
var faGripVertical = {
  prefix: 'fass',
  iconName: 'grip-vertical',
  icon: [320, 512, ["grid-vertical"], "f58e", "M128 0L0 0 0 128 128 128 128 0zm0 192l-128 0 0 128 128 0 0-128zM0 384l0 128 128 0 0-128-128 0zM320 0l-128 0 0 128 128 0 0-128zM192 192l0 128 128 0 0-128-128 0zM320 384l-128 0 0 128 128 0 0-128z"]
};
var faGridVertical = faGripVertical;
var faCarTunnel = {
  prefix: 'fass',
  iconName: 'car-tunnel',
  icon: [512, 512, [], "e4de", "M256 0C114.6 0 0 114.6 0 256l0 256 96 0 0-157.6 2.5-5 55.1-112 6.6-13.4 191.7 0 6.6 13.4 55.1 112 2.5 5 0 157.6 96 0 0-256C512 114.6 397.4 0 256 0zm96 512l0-48-192 0 0 48 192 0zm1.4-176l-31.5-64-131.9 0-31.5 64 194.9 0zM176 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faChartColumn = {
  prefix: 'fass',
  iconName: 'chart-column',
  icon: [512, 512, [], "e0e3", "M64 32l0 384 448 0 0 64-512 0 0-448 64 0zM176 224l0 128-64 0 0-128 64 0zm112-64l0 192-64 0 0-224 64 0 0 32zm112 32l0 160-64 0 0-160 64 0zM512 96l0 256-64 0 0-288 64 0 0 32z"]
};
var faSendBack = {
  prefix: 'fass',
  iconName: 'send-back',
  icon: [576, 512, [], "f87e", "M160 32l0 96-96 0 0-96 96 0zM64-32l-64 0 0 224 224 0 0-224-160 0zM512 384l0 96-96 0 0-96 96 0zm-96-64l-64 0 0 224 224 0 0-224-160 0zM128 240l0 176 176 0 0-144 144 0 0-176-176 0 0 144-144 0z"]
};
var faCommentArrowUpRight = {
  prefix: 'fass',
  iconName: 'comment-arrow-up-right',
  icon: [512, 512, [], "e145", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM216 192l54.1 0-103 103-17 17 33.9 33.9 17-17 103-103 0 78.1 48 0 0-160-160 0 0 48 24 0z"]
};
var faTruckArrowRight = {
  prefix: 'fass',
  iconName: 'truck-arrow-right',
  icon: [576, 512, [], "e58b", "M416 32L0 32 0 448 67.3 448c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l102.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l67.3 0 0-237.3-9.4-9.4-64-64-9.4-9.4-77.3 0 0-96zm96 205.3l0 50.7-96 0 0-96 50.7 0 45.3 45.3zM152 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm232 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM305 225c-57.2 57.2-86.8 86.8-89 89L182.1 280c9-9 25-25 48-48l-126.1 0 0-48 126.1 0c-23-23-39-39-48-48L216 102.1c2.1 2.1 31.8 31.8 89 89l17 17-17 17z"]
};
var faTv = {
  prefix: 'fass',
  iconName: 'tv',
  icon: [576, 512, [63717, "television", "tv-alt"], "f26c", "M64 96l0 240 448 0 0-240-448 0zM0 32l576 0 0 368-576 0 0-368zM160 448l288 0 0 64-320 0 0-64 32 0z"]
};
var faTelevision = faTv;
var faTvAlt = faTv;
var faSection = {
  prefix: 'fass',
  iconName: 'section',
  icon: [256, 512, [], "e447", "M110 0C49.2 0 0 49.2 0 110 0 133.7 7.6 155.8 20.5 174 7.6 192 0 214.1 0 238 0 291.7 38.9 337.6 91.9 346.4l61.7 10.3c22.2 3.7 38.4 22.9 38.4 45.3 0 25.4-20.6 46-46 46l-130 0 0 64 130 0c60.7 0 110-49.2 110-110 0-23.7-7.6-45.9-20.5-64 12.9-18 20.5-40.1 20.5-64 0-53.8-38.9-99.6-91.9-108.5l-61.7-10.3C80.2 151.6 64 132.4 64 110 64 84.6 84.6 64 110 64l130 0 0-64-130 0zm74.7 299.1c-6.5-2.4-13.4-4.3-20.5-5.5l-61.7-10.3c-22.2-3.7-38.4-22.9-38.4-45.3 0-9.2 2.7-17.8 7.4-25 6.5 2.4 13.4 4.3 20.5 5.5l61.7 10.3c22.2 3.7 38.4 22.9 38.4 45.3 0 9.2-2.7 17.8-7.4 25z"]
};
var faParagraphLeft = {
  prefix: 'fass',
  iconName: 'paragraph-left',
  icon: [448, 512, ["paragraph-rtl"], "f878", "M152.3 0C86 0 32.3 53.7 32.3 120S86 240 152.3 240l40 0 0 112 64 0 0-288 48 0 0 288 64 0 0-288 48 0 0-64-264 0zm-1.4 406.6l22.6-22.6-45.3-45.3c-8.2 8.2-37.1 37.1-86.6 86.6L19 448c8.2 8.2 37.1 37.1 86.6 86.6l22.6 22.6 45.3-45.3-32-32 274.7 0 0-64-274.7 0 9.4-9.4z"]
};
var faParagraphRtl = faParagraphLeft;
var faTreeDecorated = {
  prefix: 'fass',
  iconName: 'tree-decorated',
  icon: [512, 512, [], "f7dc", "M273.1 10.2C377.4 137.6 430.7 202.8 433.2 205.8l-73.9 0c70.3 82.2 112 131 125 146.2l-105.1 0c80.3 93.7 126 147 137.2 160L-4 512c11.1-13 56.8-66.3 137.2-160L28.1 352c13-15.2 54.7-64 125-146.2l-73.8 0 29.2-35.6 130.9-160 16.9-20.7 16.9 20.7zM320.2 392a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm-128-128a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm96-128a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faBinBottles = {
  prefix: 'fass',
  iconName: 'bin-bottles',
  icon: [576, 512, [], "e5f5", "M224 32l0 64c35.3 0 64 28.7 64 64 0-35.3 28.7-64 64-64l0-64 128 0 0 64c35.3 0 64 28.7 64 64l0 16-512 0 0-16c0-35.3 28.7-64 64-64l0-64 128 0zM0 288l0-64 576 0 0 64-36 0-28 224-448 0-28-224-36 0z"]
};
var faPeace = {
  prefix: 'fass',
  iconName: 'peace',
  icon: [512, 512, [9774], "f67c", "M224 445.3l0-121.8-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8 224 66.7c-90.8 15.2-160 94.2-160 189.3 0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5l-94.3-77.1 0 121.8c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1 0-95.1-69.2-174.1-160-189.3l0 174.2 134.8 110.3zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"]
};
var faStar = {
  prefix: 'fass',
  iconName: 'star',
  icon: [576, 512, [11088, 61446], "f005", "M288.2-52.8l-92.6 181.4-201.1 32 143.9 144.1-31.7 201.2 181.5-92.3 181.5 92.3-31.7-201.2 143.9-144.1-201.1-32-92.6-181.4z"]
};
var faStoreLock = {
  prefix: 'fass',
  iconName: 'store-lock',
  icon: [640, 512, [], "e4a6", "M80 32l-64 176 80 32 72-32 56 32 64-32 64 32 56-32 24.4 10.9c23.4-26.3 57.6-42.9 95.6-42.9 7.1 0 14.2 .6 21 1.7L496 32 80 32zm48 320l0-73.7c-7.3 3.3-17.7 7.9-31 13.8-13.3-5.3-24.3-9.7-33-13.2l0 201.1 304 0 0-128-240 0zm400-80c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faFlag = {
  prefix: 'fass',
  iconName: 'flag',
  icon: [448, 512, [127988, 61725], "f024", "M64 32l0-32-64 0 0 512 64 0 0-153.6 62.7-18.8c41.9-12.6 87.1-8.7 126.2 10.9 42.7 21.4 92.5 24 137.2 7.2L448 336 448 16 391.4 44.3c-44.9 22.5-97.8 22.5-142.8 0-36.4-18.2-78.3-21.8-117.2-10.1L64 54.4 64 32z"]
};
var faSquareE = {
  prefix: 'fass',
  iconName: 'square-e',
  icon: [448, 512, [], "e26d", "M448 32l-448 0 0 448 448 0 0-448zM168 144l136 0 0 48-112 0 0 40 96 0 0 48-96 0 0 40 112 0 0 48-160 0 0-224 24 0z"]
};
var faTriangleExclamation = {
  prefix: 'fass',
  iconName: 'triangle-exclamation',
  icon: [576, 512, [9888, "exclamation-triangle", "warning"], "f071", "M560 480L16 480 288-16 560 480zM260 356l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0z"]
};
var faExclamationTriangle = faTriangleExclamation;
var faWarning = faTriangleExclamation;
var faFaceSmirking = {
  prefix: 'fass',
  iconName: 'face-smirking',
  icon: [512, 512, [], "e397", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM384 344c0 39.8-32.2 72-72 72l-152 0 0-48 152 0c13.3 0 24-10.7 24-24l0-24 48 0 0 24zM120 192l64 0c22.1 0 40 17.9 40 40s-17.9 40-40 40c-19.4 0-35.5-13.7-39.2-32l-48.8 0 0-48 24 0zm168 0l88 0c22.1 0 40 17.9 40 40s-17.9 40-40 40c-19.4 0-35.5-13.7-39.2-32l-48.8 0 0-48z"]
};
var faCodePullRequestDraft = {
  prefix: 'fass',
  iconName: 'code-pull-request-draft',
  icon: [384, 512, [], "e3fa", "M56 56l0 48 48 0 0-48-48 0zM0 0l160 0 0 160-48 0 0 192 48 0 0 160-160 0 0-160 48 0 0-192-48 0 0-160zM56 408l0 48 48 0 0-48-48 0zm272 0l-48 0 0 48 48 0 0-48zm-48-56l104 0 0 160-160 0 0-160 56 0zM264 192l80 0 0 80-80 0 0-80zM344 40l0 80-80 0 0-80 80 0z"]
};
var faSchoolCircleExclamation = {
  prefix: 'fass',
  iconName: 'school-circle-exclamation',
  icon: [640, 512, [], "e56c", "M128 128l-128 0 0 384 340 0c-10.5-14.6-19-30.7-25.1-48l-90.9 0 0-128 90.9 0c26.4-74.6 97.5-128 181.1-128 28.6 0 55.6 6.2 80 17.4l0-97.4-128 0-160-128-160 128zm0 256l-64 0 0-64 64 0 0 64zM64 256l0-64 64 0 0 64-64 0zM288 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 112-32 0 0-112 32 0z"]
};
var faGraduationCap = {
  prefix: 'fass',
  iconName: 'graduation-cap',
  icon: [576, 512, [127891, "mortar-board"], "f19d", "M288 16l288 128 0 32-288 128-240-106.7 0 282.7-48 0 0-336 288-128zM96 271.2l172.5 76.7 19.5 8.7 19.5-8.7 172.5-76.7 0 112.8c0 53-86 96-192 96S96 437 96 384l0-112.8z"]
};
var faMortarBoard = faGraduationCap;
var faCloudHail = {
  prefix: 'fass',
  iconName: 'cloud-hail',
  icon: [512, 512, [], "f739", "M96 320l-96 0 0-96c0-41.8 26.7-77.4 64-90.5L64 112c0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-416 0zm0 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faArrowRightFromLine = {
  prefix: 'fass',
  iconName: 'arrow-right-from-line',
  icon: [576, 512, [8614, "arrow-from-left"], "f343", "M96.3 96l0-32-64 0 0 384 64 0 0-352zM534.9 278.6l22.6-22.6-22.6-22.6-128-128-22.6-22.6-45.3 45.3c6.6 6.6 38.6 38.6 96 96l-274.7 0 0 64 274.7 0-96 96 45.3 45.3 150.6-150.6z"]
};
var faArrowFromLeft = faArrowRightFromLine;
var faStore = {
  prefix: 'fass',
  iconName: 'store',
  icon: [576, 512, [], "f54e", "M80 32l-64 176 80 32 72-32 56 32 64-32 64 32 56-32 72 32 80-32-64-176-416 0zM64 480l448 0 0-201.1c-8.7 3.5-19.7 7.9-33 13.2-13.3-5.9-23.7-10.5-31-13.8l0 73.7-320 0 0-73.7c-7.3 3.3-17.7 7.9-31 13.8-13.3-5.3-24.3-9.7-33-13.2L64 480z"]
};
var faUserAstronaut = {
  prefix: 'fass',
  iconName: 'user-astronaut',
  icon: [448, 512, [], "f4fb", "M224 336c74.6 0 138.4-46.4 164-112l28 0 0-128-28 0C362.4 30.4 298.6-16 224-16S85.6 30.4 60 96l-28 0 0 128 28 0c25.6 65.6 89.4 112 164 112zM208 80l32 0c53 0 96 43 96 96s-43 96-96 96l-32 0c-53 0-96-43-96-96s43-96 96-96zM67.2 320l-3.2 0-48 192 80 0 0-80 256 0 0 80 80 0-48-192-3.2 0C340.4 359.6 285 384 224 384S107.6 359.6 67.2 320zM176 136L162.7 162.7 136 176 162.7 189.3 176 216 189.3 189.3 216 176 189.3 162.7 176 136zm24 328l-48 0 0 48 48 0 0-48zm96 0l-48 0 0 48 48 0 0-48z"]
};
var faCabin = {
  prefix: 'fass',
  iconName: 'cabin',
  icon: [512, 512, [], "e46d", "M256-16l128 96 0-48 96 0 0 120 32 24 0 48-512 0 0-48 256-192zM464 448l0 64-416 0 0-64 416 0zM48 352l160 0 0 64-160 0 0-64zm160-96l0 64-160 0 0-64 160 0zm96 0l160 0 0 64-160 0 0-64zm160 96l0 64-160 0 0-64 160 0z"]
};
var faBuildingFlag = {
  prefix: 'fass',
  iconName: 'building-flag',
  icon: [640, 512, [], "e4d5", "M384 0L0 0 0 512 384 512 384 0zM240 352l0 112-96 0 0-112 96 0zM96 96l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM96 224l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM496 0l-64 0 0 512 64 0 0-320 144 0 0-160-144 0 0-32z"]
};
var faWifiFair = {
  prefix: 'fass',
  iconName: 'wifi-fair',
  icon: [384, 512, ["wifi-2"], "f6ab", "M192.2 272c49 0 92.9 22.1 122.3 56.8L360.3 284c-41-46.6-101.2-76-168.2-76S65 237.4 24 284l45.9 44.8C99.3 294.1 143.1 272 192.2 272zm0 208c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z"]
};
var faWifi2 = faWifiFair;
var faMugSaucer = {
  prefix: 'fass',
  iconName: 'mug-saucer',
  icon: [576, 512, ["coffee"], "f0f4", "M64 32l384 0c70.7 0 128 57.3 128 128S518.7 288 448 288l0 96-384 0 0-352zM512 160c0-35.3-28.7-64-64-64l0 128c35.3 0 64-28.7 64-64zM64 448l416 0 0 64-448 0 0-64 32 0z"]
};
var faCoffee = faMugSaucer;
var faLemon = {
  prefix: 'fass',
  iconName: 'lemon',
  icon: [448, 512, [127819], "f094", "M448 80l-48-48-72.3 24.1C244 16.3 146.2 46.2 80.2 112.2S-15.7 276 24.1 359.7L0 432 48 480 120.3 455.9c83.7 39.8 181.4 9.9 247.4-56.1s96-163.7 56.1-247.4L448 80zM111 254.7L65 241.3C84.8 173.5 141.5 116.8 209.3 97L222.7 143c-52 15.2-96.5 59.7-111.7 111.7z"]
};
var faCirclePhoneHangup = {
  prefix: 'fass',
  iconName: 'circle-phone-hangup',
  icon: [512, 512, ["phone-circle-down"], "e11d", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM120.2 317.2l-22.6-67.9 5.7-5.7c84.4-84.3 221.1-84.3 305.5 0l5.7 5.7-22.6 67.9-79.5-11 .3-56.8c-36.6-13.2-76.6-13.2-113.1 0l.3 56.8-79.5 11z"]
};
var faPhoneCircleDown = faCirclePhoneHangup;
var faCommentCheck = {
  prefix: 'fass',
  iconName: 'comment-check',
  icon: [512, 512, [], "f4ac", "M256 0C397.4 0 512 107.5 512 240S397.4 480 256 480c-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0zm70.7 153.9l-105.6 145.2-53-53-33.9 33.9 92.7 92.7 16.5-22.7 122.1-167.9 14.1-19.4-38.8-28.2-14.1 19.4z"]
};
var faFilterList = {
  prefix: 'fass',
  iconName: 'filter-list',
  icon: [640, 512, [], "e17c", "M432 64l-144 144 0 256-128-128 0-128-144-144 416 0zm96 0l48 0 0 64-80 0 0-64 32 0zM384 224l192 0 0 64-224 0 0-64 32 0zm0 160l192 0 0 64-224 0 0-64 32 0z"]
};
var faCaravan = {
  prefix: 'fass',
  iconName: 'caravan',
  icon: [640, 512, [], "f8ff", "M32 32l512 0 0 320 96 0 0 64-328.4 0c.2 2.6 .4 5.3 .4 8 0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8L32 416 32 32zM320 352l128 0 0-80-48 0 0-48 48 0 0-96-128 0 0 224zM256 128l-128 0 0 128 128 0 0-128zM224 464a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faLeafOak = {
  prefix: 'fass',
  iconName: 'leaf-oak',
  icon: [448, 512, [], "f6f7", "M288 32l64-16 48 48-48 96 96 0 0 64-96 64 64 32 0 80-160 43.7 0 100.3-64 0 0-100.3-160-43.7 0-80 64-32-96-64 0-64 96 0-48-96 48-48 64 16 32-64 64 0 32 64z"]
};
var faQ = {
  prefix: 'fass',
  iconName: 'q',
  icon: [448, 512, [113], "51", "M64.2 256c0 88.4 71.6 160 160 160 25.3 0 49.2-5.9 70.5-16.3L195.1 256 273 256 345.4 360.5c24.2-28 38.8-64.5 38.8-104.5 0-88.4-71.6-160-160-160s-160 71.6-160 160zM331.5 452.7C299.6 470.1 263.1 480 224.2 480 100.5 480 .2 379.7 .2 256s100.3-224 224-224 224 100.3 224 224c0 61.8-25 117.8-65.5 158.3l66.2 95.5 1.5 2.2-77.9 0-41.1-59.3z"]
};
var faLock = {
  prefix: 'fass',
  iconName: 'lock',
  icon: [384, 512, [128274], "f023", "M128 96l0 64 128 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64zM64 160l0-64C64 25.3 121.3-32 192-32S320 25.3 320 96l0 64 64 0 0 352-384 0 0-352 64 0z"]
};
var faPaintRoller = {
  prefix: 'fass',
  iconName: 'paint-roller',
  icon: [512, 512, [], "f5aa", "M0 0l416 0 0 64 96 0 0 256-256 0 0 32 32 0 0 192-128 0 0-192 32 0 0-96 256 0 0-128-32 0 0 64-416 0 0-192z"]
};
var faVolumeHigh = {
  prefix: 'fass',
  iconName: 'volume-high',
  icon: [640, 512, [128266, "volume-up"], "f028", "M32 352l96 0 192 152 0-496-192 152-96 0 0 192zM382.3 218.7C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3l-11.4 9.3 28.8 38.4 12.8-10.4C434.1 312.9 448 286.1 448 256s-13.9-56.9-35.5-74.5l-12.8-10.4-28.8 38.4 11.4 9.3zm60.5-74.5C475.3 170.7 496 210.9 496 256s-20.7 85.3-53.2 111.8l-14.3 11.6 28.8 38.4 15.7-12.8c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149l-15.7-12.8-28.8 38.4 14.3 11.6zm60.5-74.5C557.5 113.8 592 180.8 592 256s-34.5 142.2-88.7 186.3l-17.2 14 28.7 38.2 .2 .2 18.6-15.1C598.5 426.8 640 346.2 640 256S598.5 85.3 533.6 32.5l-18.6-15.1-.2 .2-28.6 38.2 17.2 14z"]
};
var faVolumeUp = faVolumeHigh;
var faFaceTissue = {
  prefix: 'fass',
  iconName: 'face-tissue',
  icon: [576, 512, [], "e39c", "M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0 32 114.6 32 256c0 16.4 1.5 32.4 4.5 47.9 153.3-30.7 238.1-47.6 254.5-50.9-7.8 39-15.7 78.7-23.8 119l13.8 0c26.9-21.5 42.2-33.7 45.9-36.8 3.5 2.3 20.8 13.9 52 34.7 9.1-3 20.3-6.8 33.7-11.2l12.6 37.9c-11.8 3.9-26.1 8.7-43 14.3l-9.3 3.1c-.8-.5-15.5-10.3-44-29.3l-28.6 22.9-5.5 4.4-35.8 0-19.1 95.5c15.5 2.9 31.5 4.5 47.9 4.5zM262.8 177.7l9.2 4.6 0 20.2-10.2 4.3-95.6 40-14.7-28.3 44.2-27.6-45.3-34 16.8-27.1 95.6 48zm146-48l16.8 27.1-45.3 34 44.2 27.6-14.7 28.3-95.6-40-10.2-4.3 0-20.2 9.2-4.6 95.6-48zM48 416l-16 96 96-16 32 48 32 0 48-240-240 48 0 32 48 32z"]
};
var faFolderPlus = {
  prefix: 'fass',
  iconName: 'folder-plus',
  icon: [512, 512, [], "f65e", "M512 448l-512 0 0-416 224 0 64 48 224 0 0 368zM232 352l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faRefrigerator = {
  prefix: 'fass',
  iconName: 'refrigerator',
  icon: [384, 512, [], "e026", "M384 0l-384 0 0 160 272 0 0-64 48 0 0 64 64 0 0-160zm0 208l-64 0 0 144-48 0 0-144-272 0 0 304 384 0 0-304z"]
};
var faNfc = {
  prefix: 'fass',
  iconName: 'nfc',
  icon: [448, 512, [], "e1f7", "M0 32l448 0 0 448-448 0 0-448zM64 96l0 320 320 0 0-320-184 0 0 118.4c-14.3 8.3-24 23.8-24 41.6 0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.8-9.7-33.3-24-41.6l0-70.4 88 0 0 224-224 0 0-224 40 0 0-48-88 0z"]
};
var faDirectionUpDown = {
  prefix: 'fass',
  iconName: 'direction-up-down',
  icon: [320, 512, [], "e6bf", "M160-43.3L142.5-24.3C62 62.3 14.9 113 1 128l111 0 0 256-111 0c13.9 14.9 61 65.7 141.4 152.3l17.6 18.9 17.6-18.9C258.1 449.7 305.2 398.9 319.1 384l-111 0 0-256 111 0C305.2 113 258 62.3 177.6-24.3L160-43.3z"]
};
var faUserGroupSimple = {
  prefix: 'fass',
  iconName: 'user-group-simple',
  icon: [576, 512, [], "e603", "M48 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM240 288l48 224-288 0 48-224 192 0zm96-160a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM528 512l-192 0-48-224 288 0-48 224z"]
};
var faMercury = {
  prefix: 'fass',
  iconName: 'mercury',
  icon: [384, 512, [9791], "f223", "M39.3-16C49.1 15.3 68.3 42.4 93.5 62.1 46.7 93.7 16 147.3 16 208 16 294.3 78.1 366.1 160 381.1l0 34.9-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-34.9c81.9-15 144-86.8 144-173.1 0-60.7-30.7-114.3-77.5-145.9 25.2-19.7 44.4-46.8 54.2-78.1l-69.5 0C258.6 12.7 227.5 32 192 32s-66.6-19.3-83.2-48L39.3-16zM192 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"]
};
var faMessageQuote = {
  prefix: 'fass',
  iconName: 'message-quote',
  icon: [512, 512, ["comment-alt-quote"], "e1e4", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM224 160l0 120c0 39.8-32.2 72-72 72l-24 0 0-48 24 0c13.3 0 24-10.7 24-24l0-8-64 0 0-112 112 0zM384 272l0 8c0 39.8-32.2 72-72 72l-24 0 0-48 24 0c13.3 0 24-10.7 24-24l0-8-64 0 0-112 112 0 0 112z"]
};
var faCommentAltQuote = faMessageQuote;
var faMailboxFlagUp = {
  prefix: 'fass',
  iconName: 'mailbox-flag-up',
  icon: [576, 512, [], "e5bb", "M480 48l-208 0 0 16-128 0C64.5 64 0 128.5 0 208l0 272 576 0 0-256c0-65.6-39.5-122-96-146.7L480 48zM432 96l0 80-64 0 0 80-48 0 0-160 112 0zM240 432l-192 0 0-224c0-53 43-96 96-96s96 43 96 96l0 224zM104 208l-24 0 0 48 128 0 0-48-104 0z"]
};
var faTruckClock = {
  prefix: 'fass',
  iconName: 'truck-clock',
  icon: [576, 512, ["shipping-timed"], "f48c", "M416 32L0 32 0 448 67.3 448c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l102.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l67.3 0 0-237.3-9.4-9.4-64-64-9.4-9.4-77.3 0 0-96zm96 205.3l0 50.7-96 0 0-96 50.7 0 45.3 45.3zM152 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm232 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM96 208a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm128-65.8l-32 0 0 81.8 69.3 0 0-32-37.3 0 0-49.8z"]
};
var faShippingTimed = faTruckClock;
var faAnchor = {
  prefix: 'fass',
  iconName: 'anchor',
  icon: [576, 512, [9875], "f13d", "M320.4 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-96c-53 0-96 43-96 96 0 41.8 26.7 77.4 64 90.5l0 261.5-112 0 0-140.1c10.5 9.2 21.9 19.2 34.3 30l31.6-36.1c-4.4-3.8-31.7-27.8-82.1-71.8l-15.8-13.8c-2.5 2.2-29.1 25.5-79.8 69.8l-18.1 15.8 31.6 36.1c12.4-10.8 23.8-20.8 34.3-30l0 204.1 416 0 0-204.1c10.5 9.2 21.9 19.2 34.3 30l31.6-36.1c-4.4-3.8-31.7-27.8-82.1-71.8l-15.8-13.8c-2.5 2.2-29.1 25.5-79.8 69.8l-18.1 15.8 31.6 36.1c12.4-10.8 23.8-20.8 34.3-30l0 140.1-112 0 0-261.5c37.3-13.2 64-48.7 64-90.5 0-53-43-96-96-96z"]
};
var faDisplayArrowDown = {
  prefix: 'fass',
  iconName: 'display-arrow-down',
  icon: [512, 512, [], "e164", "M288 24l0 170.7c17.4-17.4 33.4-33.4 48-48L381.3 192c-5.5 5.5-39.7 39.7-102.6 102.6L256 317.3c-5.5-5.5-39.7-39.7-102.6-102.6L130.7 192 176 146.7c14.6 14.6 30.6 30.6 48 48l0-202.7 64 0 0 32zM64 32l112 0 0 64-112 0 0 256 384 0 0-256-112 0 0-64 176 0 0 384-208 0 16 48 96 0 0 48-320 0 0-48 96 0 16-48-208 0 0-384 64 0z"]
};
var faCircleK = {
  prefix: 'fass',
  iconName: 'circle-k',
  icon: [512, 512, [], "e113", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm41.7-368l68.9 0-9.6 9.3-85 82.6 4.6 7.7 66 110 8.6 14.3-56 0-58.6-97.7-28.6 27.8 0 69.9-48 0 0-224 48 0 0 87.2 89.7-87.2z"]
};
var faSoftServe = {
  prefix: 'fass',
  iconName: 'soft-serve',
  icon: [384, 512, [127846, "creemee"], "e400", "M320 96c0 11.8-3.2 22.9-8.8 32.4 32 3.6 56.8 30.7 56.8 63.6l0 64-352 0 0-64c0-32.9 24.8-60 56.8-63.6-5.6-9.5-8.8-20.6-8.8-32.4 0-35.3 28.7-64 64-64l46.1 0c18.7 0 33.9-15.2 33.9-33.9 0-9-3.6-17.6-9.9-24L192-32c70.7 0 128 57.3 128 128zM64 384l0-80 256 0 0 80-34.7 0-13.3 160-160 0-13.3-160-34.7 0z"]
};
var faCreemee = faSoftServe;
var faHeat = {
  prefix: 'fass',
  iconName: 'heat',
  icon: [448, 512, [], "e00c", "M208 32l0 112c0 34.6 11.2 68.3 32 96l19.2 25.6C288.3 304.4 304 351.5 304 400l0 80-64 0 0-80c0-34.6-11.2-68.3-32-96l-19.2-25.6C159.7 239.6 144 192.5 144 144l0-112 64 0zM64 96l0 64c0 34.6 11.2 68.3 32 96l19.2 25.6C144.3 320.4 160 367.5 160 416l0 64-64 0 0-64c0-34.6-11.2-68.3-32-96L44.8 294.4C15.7 255.6 0 208.5 0 160l0-64 64 0zm288 32l0 32c0 34.6 11.2 68.3 32 96l19.2 25.6C432.3 320.4 448 367.5 448 416l0 64-64 0 0-64c0-34.6-11.2-68.3-32-96l-19.2-25.6C303.7 255.6 288 208.5 288 160l0-64 64 0 0 32z"]
};
var faSquareParking = {
  prefix: 'fass',
  iconName: 'square-parking',
  icon: [448, 512, [127359, "parking"], "f540", "M448 32l-448 0 0 448 448 0 0-448zM160 128l80 0c53 0 96 43 96 96s-43 96-96 96l-48 0 0 64-64 0 0-256 32 0zm80 128c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0 64 48 0z"]
};
var faParking = faSquareParking;
var faHanukiah = {
  prefix: 'fass',
  iconName: 'hanukiah',
  icon: [640, 512, [128334], "f6e6", "M316.1 6c1.6-2.4 3-4.5 3.9-6 .9 1.6 2.3 3.6 3.9 6 7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50zM28.1 54c1.6-2.4 3-4.5 3.9-6 .9 1.6 2.3 3.6 3.9 6l0 0c7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24S8 117.3 8 104C8 84.3 20.8 65.1 28.1 54zM112 48c.9 1.6 2.3 3.6 3.9 6l0 0c7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50 1.6-2.4 3-4.5 3.9-6zm60.1 6c1.6-2.4 3-4.5 3.9-6 .9 1.6 2.3 3.6 3.9 6l0 0c7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50zM240 48c.9 1.6 2.3 3.6 3.9 6l0 0c7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50 1.6-2.4 3-4.5 3.9-6zm156.1 6c1.6-2.4 3-4.5 3.9-6 .9 1.6 2.3 3.6 3.9 6 7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50zM528 48c.9 1.6 2.3 3.6 3.9 6 7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50 1.6-2.4 3-4.5 3.9-6zm-67.9 6c1.6-2.4 3-4.5 3.9-6 .9 1.6 2.3 3.6 3.9 6 7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50zM608 48c.9 1.6 2.3 3.6 3.9 6 7.4 11.1 20.1 30.3 20.1 50 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50 1.6-2.4 3-4.5 3.9-6zM352 112l0 208 224 0 0-160 64 0 0 224-288 0 0 64 160 0 0 64-384 0 0-64 160 0 0-64-288 0 0-224 64 0 0 160 224 0 0-208 64 0zM128 160l0 128-32 0 0-128 32 0zm64 0l0 128-32 0 0-128 32 0zm64 0l0 128-32 0 0-128 32 0zm160 0l0 128-32 0 0-128 32 0zm64 0l0 128-32 0 0-128 32 0zm64 0l0 128-32 0 0-128 32 0z"]
};
var faRotateLeft = {
  prefix: 'fass',
  iconName: 'rotate-left',
  icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M0 192L0-8 79 71C128.5 23.7 192.3 0 256 0 395.4 0 512.4 116.1 512 256.1 512 397.4 397.4 512 256 512 155.9 512 69.2 454.5 27.2 370.9l57.2-28.8C116 405 181 448 256 448 362 448 448 362 448 256l0-.1c.4-104.2-87.7-191.9-192-191.9-47.4 0-94.8 17.4-131.7 52.3L200 192 0 192z"]
};
var faRotateBack = faRotateLeft;
var faRotateBackward = faRotateLeft;
var faUndoAlt = faRotateLeft;
var faCakeSlice = {
  prefix: 'fass',
  iconName: 'cake-slice',
  icon: [512, 512, [127856, "shortcake"], "e3e5", "M284.9 32L296 32c44.3 0 97.6 19.2 139.9 55.8 43.2 37.4 76.1 93.9 76.1 168.2l0 224-512 0 0-223.5 12.2-9.6 264-208 8.7-6.9zM448 288l-384 0 0 40 384 0 0-40zM64 416l384 0 0-40-384 0 0 40z"]
};
var faShortcake = faCakeSlice;
var faHeading = {
  prefix: 'fass',
  iconName: 'heading',
  icon: [448, 512, ["header"], "f1dc", "M0 32l160 0 0 64-48 0 0 112 224 0 0-112-48 0 0-64 160 0 0 64-48 0 0 320 48 0 0 64-160 0 0-64 48 0 0-144-224 0 0 144 48 0 0 64-160 0 0-64 48 0 0-320-48 0 0-64z"]
};
var faHeader = faHeading;
var faLambda = {
  prefix: 'fass',
  iconName: 'lambda',
  icon: [448, 512, [], "f66e", "M32 32l-32 0 0 64 140.2 0 16.4 32.9-154.5 351.1 69.9 0 121.8-276.7 129.5 259.1 8.8 17.7 115.8 0 0-64-76.2 0-183.2-366.3-8.8-17.7-147.8 0z"]
};
var faTrainTunnel = {
  prefix: 'fass',
  iconName: 'train-tunnel',
  icon: [512, 512, [], "e454", "M256 0C114.6 0 0 114.6 0 256l0 256 94.1 0 64-64-46.1 0 0-320 288 0 0 320-46.1 0 64 64 94.1 0 0-256C512 114.6 397.4 0 256 0zm94.1 512l-64-64-60.1 0-64 64 188.1 0zM288 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-192l-192 0 0 128 192 0 0-128z"]
};
var faCartMinus = {
  prefix: 'fass',
  iconName: 'cart-minus',
  icon: [640, 512, [], "e0db", "M0-16l116 0c2.1 11.7 5 27.7 8.7 48l451.2 0-48 256-356.7 0 8.7 48 300 0 0 48-340 0-3.6-19.7-60.4-332.3-76 0 0-48zM160 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM264 140l-20 0 0 40 184 0 0-40-164 0z"]
};
var faFaceThinking = {
  prefix: 'fass',
  iconName: 'face-thinking',
  icon: [512, 512, [], "e39b", "M4.5 304l107.5 0 0 64 192 0 0 139.5C422.4 485 512 381 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 16.4 1.5 32.5 4.5 48zM144 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM198 124.1c-18.9-12.6-43.3-13.4-63.1-2.2-8 4.6-18.1 10.4-30.4 17.4L84.7 104.6c12.3-7 22.4-12.8 30.4-17.4 32.9-18.8 73.6-17.4 105.1 3.6 22.9 15.3 38.8 25.9 47.5 31.7l-22.2 33.3c-8.7-5.8-24.6-16.4-47.5-31.7zM160 272l144 0 0 48-144 0 0-48zM64 384l0-32-64 0 0 152c0 39.8 32.2 72 72 72l104 0 0-96 80 0 0-64-192 0 0-32z"]
};
var faFaceEyesXmarks = {
  prefix: 'fass',
  iconName: 'face-eyes-xmarks',
  icon: [512, 512, [], "e374", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-212c44.2 0 80 35.8 80 80l0 4-160 0 0-4c0-44.2 35.8-80 80-80zM120 139.7c7.5 7.5 20.8 20.8 40 40 19.2-19.2 32.5-32.5 40-40L228.3 168c-7.5 7.5-20.8 20.8-40 40 19.2 19.2 32.5 32.5 40 40L200 276.3c-7.5-7.5-20.8-20.8-40-40-19.2 19.2-32.5 32.5-40 40l-28.3-28.3 40-40c-19.2-19.2-32.5-32.5-40-40L120 139.7zm192 0c7.5 7.5 20.8 20.8 40 40 19.2-19.2 32.5-32.5 40-40L420.3 168c-7.5 7.5-20.8 20.8-40 40 19.2 19.2 32.5 32.5 40 40L392 276.3c-7.5-7.5-20.8-20.8-40-40-19.2 19.2-32.5 32.5-40 40L283.7 248c7.5-7.5 20.8-20.8 40-40-19.2-19.2-32.5-32.5-40-40L312 139.7z"]
};
var faMagnifyingGlassMusic = {
  prefix: 'fass',
  iconName: 'magnifying-glass-music',
  icon: [576, 512, [], "e65f", "M448.3 208c0 45.9-14.9 88.3-40 122.7L534.9 457.4 557.5 480 512.3 525.3 489.6 502.6 363 376c-34.4 25.2-76.8 40-122.7 40-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208zM320.3 96l-96 0 0 113.8c-5.1-1.2-10.5-1.8-16-1.8-35.3 0-64 25.1-64 56s28.7 56 64 56 64-25.1 64-56l0-104 48 0 0-64z"]
};
var faCalendarLinesPen = {
  prefix: 'fass',
  iconName: 'calendar-lines-pen',
  icon: [640, 512, [], "e472", "M224 32l0-32-64 0 0 64-96 0 0 416 217.6 0 9.2-55.1 221.3-221.3 0-139.7-96 0 0-64-64 0 0 64-128 0 0-32zM160 224l192 0 0 48-192 0 0-48zM288 368l-128 0 0-48 128 0 0 48zM544 239.9l-52.8 52.8 80 80 52.8-52.8-80-80zm-208 208l-16 96 96-16 132.6-132.6-80-80-132.6 132.6z"]
};
var faCrosshairs = {
  prefix: 'fass',
  iconName: 'crosshairs',
  icon: [576, 512, [], "f05b", "M320-16l0 50.3c98.1 14 175.7 91.6 189.7 189.7l50.3 0 0 64-50.3 0c-14 98.1-91.6 175.7-189.7 189.7l0 50.3-64 0 0-50.3C157.9 463.7 80.3 386.1 66.3 288l-50.3 0 0-64 50.3 0C80.3 125.9 157.9 48.3 256 34.3l0-50.3 64 0zM131.2 288c12.7 62.7 62.1 112.1 124.8 124.8l0-44.8 64 0 0 44.8c62.7-12.7 112.1-62.1 124.8-124.8l-44.8 0 0-64 44.8 0C432.1 161.3 382.7 111.9 320 99.2l0 44.8-64 0 0-44.8C193.3 111.9 143.9 161.3 131.2 224l44.8 0 0 64-44.8 0zM288 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCircleNodes = {
  prefix: 'fass',
  iconName: 'circle-nodes',
  icon: [512, 512, [], "e4e2", "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9 0-44.2-35.8-80-80-80-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128 35.8 128 0 163.8 0 208s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"]
};
var faWindowRestore = {
  prefix: 'fass',
  iconName: 'window-restore',
  icon: [576, 512, [], "f2d2", "M512 96l-352 0 0-64 416 0 0 320-112 0 0-64 48 0 0-192zM0 160l416 0 0 320-416 0 0-320zm64 80l0 48 288 0 0-48-288 0z"]
};
var faR = {
  prefix: 'fass',
  iconName: 'r',
  icon: [320, 512, [114], "52", "M32 32l-32 0 0 448 64 0 0-160 93.2 0 88.8 160 73.2 0-4.2-7.5-89.5-161.2C280.7 291.1 320 238.1 320 176 320 96.5 255.5 32 176 32L32 32zM176 256l-112 0 0-160 112 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
var faFilterCircleXmark = {
  prefix: 'fass',
  iconName: 'filter-circle-xmark',
  icon: [640, 512, [], "e17b", "M224 416l66.7 66.6c-12-25-18.7-53.1-18.7-82.6 0-86.4 57.1-159.5 135.6-183.6L560 64 16 64 224 272 224 416zM464 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm55.3-176.7L486.6 400c25.4 25.3 40 40 44 44L508 466.6c-4-4-18.6-18.6-44-44-25.3 25.4-40 40-44 44L397.4 444c4-4 18.6-18.6 44-44-25.4-25.3-40-40-44-44L420 333.4c4 4 18.6 18.6 44 44 25.3-25.4 40-40 44-44l22.6 22.6-11.3 11.3z"]
};
var faMicrochipAi = {
  prefix: 'fass',
  iconName: 'microchip-ai',
  icon: [512, 512, [], "e1ec", "M176 24l0-24-48 0 0 64-64 0 0 64-64 0 0 48 64 0 0 56-64 0 0 48 64 0 0 56-64 0 0 48 64 0 0 64 64 0 0 64 48 0 0-64 56 0 0 64 48 0 0-64 56 0 0 64 48 0 0-64 64 0 0-64 64 0 0-48-64 0 0-56 64 0 0-48-64 0 0-56 64 0 0-48-64 0 0-64-64 0 0-64-48 0 0 64-56 0 0-64-48 0 0 64-56 0 0-40zM316 176l40 0 0 160-40 0 0-160zm-115.2 0l30.5 0 3.4 8.8 58.6 151.2-42.9 0-7.8-20-53.2 0-7.8 20-42.9 0 58.6-151.2 3.4-8.8zM216 247.4l-11.1 28.6 22.2 0-11.1-28.6z"]
};
var faCircleQuarter = {
  prefix: 'fass',
  iconName: 'circle-quarter',
  icon: [512, 512, [], "e11f", "M0 256C0 114.6 114.6 0 256 0l0 256-256 0z"]
};
var faGopuram = {
  prefix: 'fass',
  iconName: 'gopuram',
  icon: [512, 512, [], "f664", "M144 0l0 32 40 0 0-32 48 0 0 32 48 0 0-32 48 0 0 32 40 0 0-32 48 0 0 160 48 0 0 128 48 0 0 224-96 0 0-224-32 0 0-128-48 0 0 128 32 0 0 224-224 0 0-224 32 0 0-128-48 0 0 128-32 0 0 224-96 0 0-224 48 0 0-128 48 0 0-160 48 0zM288 208l-64 0 0 80 64 0 0-80zM208 352l0 112 96 0 0-112-96 0zM288 96l-64 0 0 64 64 0 0-64z"]
};
var faAnt = {
  prefix: 'fass',
  iconName: 'ant',
  icon: [576, 512, [], "e680", "M544 80l-64.4 0-7.9 17.8c50.2 9.2 88.3 53.1 88.3 106l0 52.2-128 0c-6.2 0-12.3-.8-18.2-2.2 1.4 5.8 2.2 11.9 2.2 18.1 0 5.9-.7 11.7-1.9 17.3l98.7 65.8 2.2 6.5 32 96 6.3 19-38 12.7-6.3-19-29.8-89.5-83.5-55.7c-1.6 1.8-3.3 3.5-5 5.2l43.8 43.8 17.2 85.9 3.9 19.6-39.2 7.8-3.9-19.6-14.8-74.1-43.9-43.9c-5.7 1.3-11.6 2-17.7 2-3.6 0-7.1-.3-10.5-.8l-68 122.5-9.7 17.5-35-19.4 9.7-17.5 65.7-118.2c-9-6.7-16.6-15.3-22.1-25.1l-90.4 162.8-9.7 17.5-35-19.4 9.7-17.5 57.7-103.8c-5.9 1-12 1.6-18.2 1.6l-15.1 0-67.6 121.7-9.7 17.5-35-19.4 9.7-17.5 56.8-102.3-103.3 0 0-72.2C16 196 84 128 167.8 128l8.2 0c51.9 0 95.4 35.3 108.2 83.1 14-11.9 32-19.1 51.8-19.1 6.2 0 12.3 .8 18.1 2.1-1.3-5.8-2.1-11.9-2.1-18.1 0-39.9 29.2-72.9 67.4-78.9 17.8-40 27.5-61.7 29-65.1l95.6 0 0 48zm-80 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faHydra = {
  prefix: 'fass',
  iconName: 'hydra',
  icon: [640, 512, [], "e686", "M483.2 0l-16 0C421.3 0 384 37.2 384 83.2l0 79.7 0 1.3 0 4.5 0 .6c0 .5 0 .9 0 1.4-.8 46.8-40 85.3-87.8 85.3l-14.6 0c-46.7 0-90.3 23.4-116.2 62.2l-10.7 16.1c-7.4 11-19.7 17.7-33 17.7-32.1 0-50.9-36.1-32.5-62.4l33.1-47.2-45.4-44-25.6 19.2C19 241.8 0 279.7 0 320 0 390.7 57.3 448 128 448l32 0 0 64 96 0 10.7-64 74.7 0 10.7 64 96 0 0-68c55.2-14.2 96-64.3 96-124l0-64 96 0 0-47.4c-3.3-2.7-20.7-16.5-52-41.6l-8.8-7-19.2 0c-35.1 0-64.9 22.6-75.7 54l3.7 73.2 .3 5.8-3.5 4.6c-18.4 24.5-29.6 39.5-33.6 44.8l-25.6-19.2c4.6-6.1 14.6-19.5 30.1-40.2l-7.7-154.2 0-.4 0-32.4 96 0 0-47.4c-3.3-2.7-20.7-16.5-52-41.6l-8.8-7zM352 170.3l0-52.6C336.2 85.6 303.2 64 265.8 64l-13 0c-.6 .5-16.9 13.5-48.8 39l-12 9.6 0 47.4 103 0 9.6 38.5 4 24.1c24.6-5.6 42.9-27.3 43.3-52.3z"]
};
var faHeartCircleMinus = {
  prefix: 'fass',
  iconName: 'heart-circle-minus',
  icon: [576, 512, [], "e4ff", "M133.1 32C175.8 32 216 52.5 241 87.1l15 20.7 15-20.7c25-34.6 65.2-55.1 107.9-55.1 73.5 0 133.1 59.6 133.1 133.1 0 19.2-3 38.1-8.5 56.6-22.1-8.9-46.2-13.8-71.5-13.8-106 0-192 86-192 192 0 33 8.3 64 23 91.2-2.4 1.6-4.7 3.3-7 4.8-102.5-70.7-256-194.1-256-330.9 0-73.5 59.6-133.1 133.1-133.1zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16l0-32-160 0 0 32 160 0z"]
};
var faStarOfLife = {
  prefix: 'fass',
  iconName: 'star-of-life',
  icon: [512, 512, [], "f621", "M208.2 0l96 0 0 172.9 149.7-86.4 48 83.1-149.7 86.4 149.7 86.4-48 83.1-149.7-86.4 0 172.9-96 0 0-172.9-149.7 86.4-48-83.1 149.7-86.4-149.7-86.4 48-83.1 149.7 86.4 0-172.9z"]
};
var faBoombox = {
  prefix: 'fass',
  iconName: 'boombox',
  icon: [576, 512, [128254], "f8a5", "M32 0l512 0 0 160 32 0 0 320-576 0 0-320 32 0 0-160zM80 160l80 0 0-32 64 0 0 32 32 0 0-32 64 0 0 32 32 0 0-32 64 0 0 32 80 0 0-112-416 0 0 112zm336 64a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm-256 0a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm-48 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm304-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faBusinessTime = {
  prefix: 'fass',
  iconName: 'business-time',
  icon: [640, 512, ["briefcase-clock"], "f64a", "M208 0l224 0 0 96 144 0 0 129.4c-24.4-11.2-51.4-17.4-80-17.4-48.7 0-93.2 18.1-127 48l-305 0 0-160 144 0 0-96zm96 400c0 28.6 6.2 55.6 17.4 80l-257.4 0 0-176 192 0 0 48 54 0c-3.9 15.3-6 31.4-6 48zM384 48l-128 0 0 48 128 0 0-48zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 96 80 0 0-32-48 0 0-64z"]
};
var faBriefcaseClock = faBusinessTime;
var faFireExtinguisher = {
  prefix: 'fass',
  iconName: 'fire-extinguisher',
  icon: [512, 512, [129519], "f134", "M224 0l-96 0 0 60.4C72.7 72.6 26.7 109.8 2.5 159.5l43.1 21C62 146.9 91.8 121.1 128 110l0 28.8c-37.8 18-64 56.5-64 101.2l0 128 224 0 0-128c0-44.7-26.2-83.2-64-101.2l0-34.8 64 0 0 24 224 32 0-160-224 32 0 24-64 0 0-56zm64 416l-224 0 0 96 224 0 0-96z"]
};
var faArrowDownLong = {
  prefix: 'fass',
  iconName: 'arrow-down-long',
  icon: [384, 512, ["long-arrow-down"], "f175", "M169.6 534.6l22.6 22.6 22.6-22.6 150.6-150.6-45.3-45.3-96 96 0-466.7-64 0 0 466.7c-57.4-57.4-89.4-89.4-96-96l-45.3 45.3 22.6 22.6 128 128z"]
};
var faLongArrowDown = faArrowDownLong;
var faClockThreeThirty = {
  prefix: 'fass',
  iconName: 'clock-three-thirty',
  icon: [512, 512, [], "e357", "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM232 392l0-160 152 0 0 48-104 0 0 136-48 0 0-24z"]
};
var faObjectSubtract = {
  prefix: 'fass',
  iconName: 'object-subtract',
  icon: [512, 512, [], "e49e", "M512 512l-352 0 0-160-160 0 0-352 352 0 0 160 160 0 0 352zM288 288l0-224-224 0 0 224 224 0z"]
};
var faTicketsSimple = {
  prefix: 'fass',
  iconName: 'tickets-simple',
  icon: [640, 512, [], "e659", "M608 32L96 32 96 160c26.5 0 48 21.5 48 48s-21.5 48-48 48l0 128 512 0 0-128c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-128zM48 152l0-24-48 0 0 352 512 0 0-48-464 0 0-280z"]
};
var faUserMinus = {
  prefix: 'fass',
  iconName: 'user-minus',
  icon: [640, 512, [], "f503", "M136 128a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zM400 304l64 208-416 0 64-208 288 0zm72-136l168 0 0 48-192 0 0-48 24 0z"]
};
var faCircleBitcoin = {
  prefix: 'fass',
  iconName: 'circle-bitcoin',
  icon: [512, 512, [], "e737", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm276-80c15.5 0 28 12.5 28 28s-12.5 28-28 28l-60 0 0-56 60 0zm62.2 71.7c8.7-12.4 13.8-27.4 13.8-43.7 0-37.9-27.7-69.3-64-75.1l0-32.9-32 0 0 32-16 0 0-32-32 0 0 32-40 0 0 256 40 0 0 32 32 0 0-32 16 0 0 32 32 0 0-32 4 0c42 0 76-34 76-76 0-24.6-11.7-46.4-29.8-60.3zM216 280l76 0c15.5 0 28 12.5 28 28s-12.5 28-28 28l-76 0 0-56z"]
};
var faMoneyCheck = {
  prefix: 'fass',
  iconName: 'money-check',
  icon: [512, 512, [], "f53c", "M0 64l512 0 0 384-512 0 0-384zM96 288l0 48 192 0 0-48-192 0zM416 176l-320 0 0 48 320 0 0-48z"]
};
var faVideoPlus = {
  prefix: 'fass',
  iconName: 'video-plus',
  icon: [576, 512, [], "f4e1", "M32 64l384 0 0 384-384 0 0-384zM464 341.3l0-170.7 112-74.7 0 320-112-74.7zM200 352l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faHouseLaptop = {
  prefix: 'fass',
  iconName: 'house-laptop',
  icon: [640, 512, ["laptop-house"], "e066", "M445.5 240l50.5 0 0-40-240-216-240 216 0 40 50.5 0 0 208 142.3 0 31.2-31.2 0-128.8-32 0 0-96 96 0 0 48 141.5 0zM512 352l0 128-160 0 0-128 160 0zm-224 0l0 128-48 0 0 32 32 32 320 0 32-32 0-32-48 0 0-192-288 0 0 64z"]
};
var faLaptopHouse = faHouseLaptop;
var faDownload = {
  prefix: 'fass',
  iconName: 'download',
  icon: [448, 512, [], "f019", "M256 32l0-32-64 0 0 242.7c-30.7-30.7-52-52-64-64L82.7 224c2.9 2.9 42.4 42.4 118.6 118.6L224 365.3c2.9-2.9 42.4-42.4 118.6-118.6L365.3 224 320 178.7c-12 12-33.3 33.3-64 64L256 32zM0 320l0 160 448 0 0-160-110.9 0c-37.7 37.7-75.4 75.4-113.1 113.1-37.7-37.7-75.4-75.4-113.1-113.1L0 320zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHandHoldingStar = {
  prefix: 'fass',
  iconName: 'hand-holding-star',
  icon: [576, 512, [], "e801", "M384 368l-128 0 0 48 138.8 0c73.3-50.4 115.7-79.6 127.5-87.6l45.3 65.9c-6.1 4.2-59.8 41.1-161 110.7l-10.2 7-396.4 0 0-128 66.8 0 80-80 237.2 0 0 64zM293.4-14.9L325 47c49.5 7.9 87.9 14 115.2 18.3-19.5 19.5-47 47-82.4 82.5 7.8 49.6 13.9 87.9 18.2 115.2-24.6-12.5-59.2-30.1-103.9-52.9-44.7 22.8-79.3 40.4-103.9 52.9 4.3-27.2 10.3-65.6 18.2-115.2-35.4-35.4-62.9-62.9-82.4-82.5 27.3-4.3 65.7-10.5 115.1-18.3 22.8-44.6 40.5-79.2 53-103.8l21.4 41.9z"]
};
var faInputNumeric = {
  prefix: 'fass',
  iconName: 'input-numeric',
  icon: [576, 512, [], "e1bd", "M512 128l0 256-448 0 0-256 448 0zM64 64l-64 0 0 384 576 0 0-384-512 0zm40 96l0 48 32 0 0 96-40 0 0 48 128 0 0-48-40 0 0-144-80 0zm221.4 51.8c5.9 6.7 5.7 16.7-.3 23.3l-69.1 74.9 0 42 128 0 0-48-57.2 0 33.6-36.4c22.7-24.6 23.2-62.3 1.2-87.4-26.2-30-73-29.7-98.9 .5l-16.9 19.7 36.4 31.2 16.9-19.7c6.9-8.1 19.3-8.1 26.3-.1z"]
};
var faCouch = {
  prefix: 'fass',
  iconName: 'couch',
  icon: [640, 512, [], "f4b8", "M64 64l512 0 0 112-80 0 0 128-352 0 0-128-80 0 0-112zM0 448l0-224 96 0 0 128 448 0 0-128 96 0 0 224-640 0z"]
};
var faGaugeSimpleMax = {
  prefix: 'fass',
  iconName: 'gauge-simple-max',
  icon: [512, 512, ["tachometer-fastest"], "f62b", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm320 96c0-3.4-.3-6.7-.8-9.9l109.1-65.5-24.7-41.2-109.1 65.5c-10.7-8.1-24.1-12.9-38.5-12.9-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64z"]
};
var faTachometerFastest = faGaugeSimpleMax;
var faBoxMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'box-magnifying-glass',
  icon: [640, 512, [], "e828", "M440.4 256.1c66.3 0 120 53.7 120 120 0 24.4-7.4 47.2-19.9 66.1 47.9 47.9 73.8 73.9 77.8 77.9L584.4 554c-4-4-29.9-30-77.8-77.9-19 12.6-41.7 19.9-66.2 19.9-66.3 0-120-53.7-120-120s53.7-120 120-120zm72-128.1l0 96.2c-21.8-10.4-46.2-16.2-72-16.2-92.8 0-168 75.2-168 168 0 39.2 13.5 75.3 36 103.9l-244 0 0-352 80-112 288 0 80 112zm-72 176.1a72 72 0 1 0 0 144 72 72 0 1 0 0-144zM143.1 128l290.7 0-34.3-48-222.1 0-34.3 48z"]
};
var faRoadLock = {
  prefix: 'fass',
  iconName: 'road-lock',
  icon: [576, 512, [], "e567", "M256 32l-118.6 0-105.4 448 224 0 0-96 48 0 0-64-48 0 0-128 64 0 0 112 16 0c0-70.7 57.3-128 128-128 2.9 0 5.7 .1 8.5 .3l-33.9-144.3-118.6 0 0 96-64 0 0-96zM464 272c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faPersonSwimmingPool = {
  prefix: 'fass',
  iconName: 'person-swimming-pool',
  icon: [640, 512, [], "e78a", "M552 120a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM293.9 166.4l-84.1 72.1 17 6.8 93.1 37.2c92.7-37.1 144.2-57.7 154.3-61.7l-3.5-3.5-80-80-4.9-4.9-6.5-2.4-128-48-14.5-5.4-13.2 7.9c-62.1 37.3-97.9 58.7-107.4 64.5L149 203.9c11.7-7 43.1-25.9 94.2-56.5l50.7 19zM200 286.2l-8.9 3.6-111.8 44.7c-29.3-9.7-50.1-16.7-62.4-20.8L1.6 359.2c11 3.7 34.6 11.5 70.8 23.6l8.3 2.8 8.2-3.3 111.1-44.4 111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4 111.1 44.4 8.2 3.3 8.3-2.8c36.2-12.1 59.8-19.9 70.8-23.6l-15.2-45.5c-12.4 4.1-33.2 11.1-62.4 20.8l-111.8-44.7-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4-8.9-3.6zM32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm320-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm112 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCanFood = {
  prefix: 'fass',
  iconName: 'can-food',
  icon: [384, 512, [129387], "e3e6", "M272 304.2c11.4-2.4 22.2-5.3 32-8.6L304 426c-2.8 1.6-6.6 3.6-11.8 5.7-22.4 9.2-57.8 16.3-100.2 16.3s-77.8-7.1-100.2-16.3c-5.2-2.1-9-4.1-11.8-5.7l0-130.4c9.8 3.3 20.6 6.2 32 8.6l0 63.8 160 0 0-63.8zm-48 6.7l0 9.2-64 0 0-64 64 0 0 54.8zM16 72l0 368c0 39.8 78.8 72 176 72s176-32.2 176-72l0-368c0-39.8-78.8-72-176-72S16 32.2 16 72zm288 0c0 13.3-50.1 24-112 24S80 85.3 80 72 130.1 48 192 48 304 58.7 304 72z"]
};
var faCircleX = {
  prefix: 'fass',
  iconName: 'circle-x',
  icon: [512, 512, [], "e12e", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM151.7 144l57.9 0 46.4 69 46.4-69 57.8 0-10.4 15.4-65 96.6 65 96.6 10.4 15.4-57.8 0-46.4-69-46.4 69-57.9 0 10.4-15.4 65-96.6-65-96.6-10.4-15.4z"]
};
var faSquareHalfHorizontal = {
  prefix: 'fass',
  iconName: 'square-half-horizontal',
  icon: [448, 512, [], "e80e", "M448 256l0 224-448 0 0-224 448 0z"]
};
var faUserRobotXmarks = {
  prefix: 'fass',
  iconName: 'user-robot-xmarks',
  icon: [448, 512, [], "e4a7", "M248 24l0-24-48 0 0 64-120 0 0 104-48 0 0 48 48 0 0 88 288 0 0-88 48 0 0-48-48 0 0-104-120 0 0-40zM0 352l0 160 104 0 0-64 48 0 0 64 48 0 0-64 48 0 0 64 48 0 0-64 48 0 0 64 104 0 0-160-448 0zM144 129.4c7.3 7.3 15.3 15.3 24 24 8.7-8.7 16.7-16.7 24-24L214.6 152c-7.3 7.3-15.3 15.3-24 24 8.7 8.7 16.7 16.7 24 24L192 222.6c-7.3-7.3-15.3-15.3-24-24-8.7 8.7-16.7 16.7-24 24L121.4 200c7.3-7.3 15.3-15.3 24-24-8.7-8.7-16.7-16.7-24-24L144 129.4zm123.3 11.3L280 153.4c8.7-8.7 16.7-16.7 24-24L326.6 152c-7.3 7.3-15.3 15.3-24 24 8.7 8.7 16.7 16.7 24 24L304 222.6c-7.3-7.3-15.3-15.3-24-24-8.7 8.7-16.7 16.7-24 24L233.4 200c7.3-7.3 15.3-15.3 24-24-8.7-8.7-16.7-16.7-24-24l22.6-22.6 11.3 11.3z"]
};
var faScissors = {
  prefix: 'fass',
  iconName: 'scissors',
  icon: [576, 512, [9984, 9986, 9988, "cut"], "f0c4", "M224 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L576 32 448 32 288 192 248.5 152.5c4.9-12.6 7.5-26.2 7.5-40.5 0-61.9-50.1-112-112-112S32 50.1 32 112 82.1 224 144 224c14.3 0 27.9-2.7 40.5-7.5L224 256zm97.9 97.9l126.1 126.1 128 0-190.1-190.1-64 64zM96 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCut = faScissors;
var faBug = {
  prefix: 'fass',
  iconName: 'bug',
  icon: [576, 512, [], "f188", "M192 96c0-53 43-96 96-96s96 43 96 96l0 32-192 0 0-32zm364.8 38.4C549.3 140 513.1 167.2 448 216l0 40 128 0 0 64-128 0 0 32c0 2.6-.1 5.3-.2 7.9 65.2 48.9 101.6 76.2 109 81.7l-38.4 51.2c-10.8-8.1-40.4-30.3-88.7-66.5-23.2 44.2-66.5 76.2-117.7 83.9l0-254.2-48 0 0 254.2c-51.2-7.7-94.5-39.7-117.7-83.9-48.3 36.2-77.8 58.4-88.7 66.5L19.2 441.6c7.4-5.6 43.8-32.8 109-81.7-.1-2.6-.2-5.2-.2-7.9l0-32-128 0 0-64 128 0 0-40C62.9 167.2 26.7 140 19.2 134.4L57.6 83.2c5 3.7 46.2 34.7 123.7 92.8l213.3 0c77.5-58.1 118.8-89.1 123.7-92.8l38.4 51.2z"]
};
var faArrowRightFromBracket = {
  prefix: 'fass',
  iconName: 'arrow-right-from-bracket',
  icon: [576, 512, ["sign-out"], "f08b", "M192.3 96l32 0 0-64-192 0 0 448 192 0 0-64-128 0 0-320 96 0zM534.9 278.6l22.6-22.6-22.6-22.6-128-128-22.6-22.6-45.3 45.3c6.6 6.6 38.6 38.6 96 96l-242.7 0 0 64 242.7 0-96 96 45.3 45.3 150.6-150.6z"]
};
var faSignOut = faArrowRightFromBracket;
var faFileZip = {
  prefix: 'fass',
  iconName: 'file-zip',
  icon: [640, 512, [], "e5ee", "M304 0l-240 0 0 512 208 0 0-176 176 0 0-192-144-144zm85.5 176L272 176 272 58.5 389.5 176zM336 380l-20 0 0 40 54.1 0-51.5 90.1-2.6 4.6 0 33.3 104 0 0-40-54.1 0 51.5-90.1 2.6-4.6 0-33.3-84 0zm148 20l0-20-40 0 0 168 40 0 0-148zm24-20l0 168 40 0 0-48 12 0c33.1 0 60-26.9 60-60s-26.9-60-60-60l-52 0zm40 80l0-40 12 0c11 0 20 9 20 20s-9 20-20 20l-12 0z"]
};
var faCupcake = {
  prefix: 'fass',
  iconName: 'cupcake',
  icon: [448, 512, [129473], "e402", "M352 128l0 .8c3.3 .5 6.6 1.4 9.9 2.4l20.5 6.8c39.2 13.1 65.6 49.8 65.6 91.1l0 58.8-448 0 0-58.8c0-41.3 26.4-78 65.6-91.1l20.5-6.8c3.2-1.1 6.5-1.9 9.9-2.4l0-.8c0-35.3 28.7-64 64-64l49.3 0c17 0 30.7-13.7 30.7-30.7 0-6.1-1.8-12-5.2-17L224 0c70.7 0 128 57.3 128 128zM273.8 336l-22 176-55.6 0-22-176 99.6 0zM64 336l61.8 0 22 176-51.8 0-32-176zM300.2 512l22-176 61.8 0-32 176-51.8 0z"]
};
var faHandHoldingHand = {
  prefix: 'fass',
  iconName: 'hand-holding-hand',
  icon: [576, 512, [], "e4f7", "M438.6 214.6l70.6-70.6 66.7 0 0-128-396.4 0-10.2 7C68.2 92.6 14.5 129.5 8.4 133.7l45.3 65.9 127.5-87.6 138.8 0 0 48-128 0 0 64 237.3 0 9.4-9.4zM137.4 297.4l-70.6 70.6-66.7 0 0 128 396.4 0 10.2-7c101.2-69.6 154.8-106.4 161-110.7l-45.3-65.9c-11.7 8.1-54.2 37.3-127.5 87.6l-138.8 0 0-48 128 0 0-64-237.3 0-9.4 9.4z"]
};
var faMicrophoneSignalMeter = {
  prefix: 'fass',
  iconName: 'microphone-signal-meter',
  icon: [512, 512, [], "e760", "M224 0l192 0 0 224c0 53-43 96-96 96s-96-43-96-96L224 0zM176 160l0 64c0 79.5 64.5 144 144 144s144-64.5 144-144l0-64 48 0 0 64c0 97.9-73.3 178.7-168 190.5l0 49.5 72 0 0 48-192 0 0-48 72 0 0-49.5C201.3 402.7 128 321.9 128 224l0-64 48 0zM0 32l64 0 0 64-64 0 0-64zM0 160l64 0 0 64-64 0 0-64zM64 288l0 64-64 0 0-64 64 0zM0 416l64 0 0 64-64 0 0-64z"]
};
var faStroopwafel = {
  prefix: 'fass',
  iconName: 'stroopwafel',
  icon: [512, 512, [], "f551", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM75 188.1L52.4 210.7 97.6 256c-26.4 26.4-41.5 41.5-45.3 45.3L75 323.9c3.8-3.8 18.9-18.9 45.3-45.3l45.3 45.3-56.6 56.6-11.3 11.3 22.6 22.6 11.3-11.3 56.6-56.6 45.3 45.3c-26.4 26.4-41.5 41.5-45.3 45.3l22.6 22.6c3.8-3.8 18.9-18.9 45.3-45.3 26.4 26.4 41.5 41.5 45.3 45.3L323.9 437c-3.8-3.8-18.9-18.9-45.3-45.3l45.3-45.3 67.9 67.9 22.6-22.6-67.9-67.9 45.3-45.3c26.4 26.4 41.5 41.5 45.3 45.3l22.6-22.6c-3.8-3.8-18.9-18.9-45.3-45.3 26.4-26.4 41.5-41.5 45.3-45.3L437 188.1c-3.8 3.8-18.9 18.9-45.3 45.3l-45.3-45.3 56.6-56.6 11.3-11.3-22.6-22.6-11.3 11.3-56.6 56.6-45.3-45.3C305 93.8 320.1 78.8 323.9 75L301.3 52.4c-3.8 3.8-18.9 18.9-45.3 45.3l-45.3-45.3-22.6 22.6 45.3 45.3-45.3 45.3-56.6-56.6-11.3-11.3-22.6 22.6 11.3 11.3 56.6 56.6-45.3 45.3-45.3-45.3zm181 181l-45.3-45.3 45.3-45.3 45.3 45.3-45.3 45.3zm67.9-67.9l-45.3-45.3 45.3-45.3 45.3 45.3-45.3 45.3zM210.7 188.1l45.3-45.3 45.3 45.3-45.3 45.3-45.3-45.3zm-22.6 22.6l45.3 45.3-45.3 45.3-45.3-45.3 45.3-45.3z"]
};
var faChild = {
  prefix: 'fass',
  iconName: 'child',
  icon: [320, 512, [], "f1ae", "M96 64A64 64 0 1 1 224 64 64 64 0 1 1 96 64zm4.9 96l118.1 0 9.6 12.8C285.6 248.5 316 289 320 294.4l-51.2 38.4c-14.4-19.2-24-32-28.8-38.4l0 217.6-64 0 0-128-32 0 0 128-64 0 0-217.6c-4.8 6.4-14.4 19.2-28.8 38.4L0 294.4c4-5.3 34.5-45.9 91.3-121.6L101 160z"]
};
var faIceCream = {
  prefix: 'fass',
  iconName: 'ice-cream',
  icon: [384, 512, [127848], "f810", "M334.9 161.7c.7-5.8 1.1-11.7 1.1-17.7 0-79.5-64.5-144-144-144S48 64.5 48 144c0 6 .4 11.9 1.1 17.7-28.2 6.7-49.1 32-49.1 62.3l0 32 384 0 0-32c0-30.2-20.9-55.5-49.1-62.3zM64 304l128 240 128-240-256 0z"]
};
var faComputerMouse = {
  prefix: 'fass',
  iconName: 'computer-mouse',
  icon: [384, 512, [128433, "mouse"], "f8cc", "M0 192L168 192 168 0 0 0 0 192zm0 48L0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-112-384 0zm384-48l0-192-168 0 0 192 168 0z"]
};
var faMouse = faComputerMouse;
var faCircleA = {
  prefix: 'fass',
  iconName: 'circle-a',
  icon: [512, 512, [], "e0f7", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM240.9 144l30.2 0 6.5 13.6 96 200 5 10.4-53.2 0-15.4-32-108 0-15.4 32-53.2 0 5-10.4 96-200 6.5-13.6zM256 223.5l-31 64.5 62 0-31-64.5z"]
};
var faFaucet = {
  prefix: 'fass',
  iconName: 'faucet',
  icon: [512, 512, [], "e005", "M192 32l64 0 0 32 128 0 0 64-128 0 0 64 32 0 32 32 32 0c88.4 0 160 71.6 160 160l0 32-128 0 0-32c0-17.7-14.3-32-32-32l-36.1 0c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48l-132.1 0 0-128 128 0 32-32 32 0 0-64-128 0 0-64 128 0 0-32z"]
};
var faFaceSmileHorns = {
  prefix: 'fass',
  iconName: 'face-smile-horns',
  icon: [640, 512, [], "e391", "M320 0C264.6 0 213.2 17.6 171.3 47.6 57.1 42.8 0 0 0 0 0 80.1 55.6 160.1 74.1 184.5 67.5 207.2 64 231.2 64 256 64 397.4 178.6 512 320 512S576 397.4 576 256c0-24.8-3.5-48.8-10.1-71.5 18.5-24.4 74.1-104.4 74.1-184.5 0 0-57.1 42.8-171.3 47.6-41.9-30-93.2-47.6-148.7-47.6zM272 272c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-7.3 2.4-14 6.6-19.4-20.9-7-36.9-12.3-47.8-15.9l12.6-37.9 19 6.3 96 32 19 6.3-12.6 37.9c-14.2-4.7-23.7-7.9-28.6-9.6l0 .3zm128 32c-17.7 0-32-14.3-32-32l0-.3c-4.9 1.6-14.5 4.8-28.6 9.6l-12.6-37.9 19-6.3 96-32 19-6.3 12.6 37.9c-11 3.7-26.9 9-47.8 15.9 4.1 5.4 6.6 12.1 6.6 19.4 0 17.7-14.3 32-32 32zM227.8 343.5C248 372.9 281.8 392 320 392s72-19.1 92.2-48.5l39.5 27.3C422.9 412.6 374.7 440 320 440s-102.9-27.4-131.8-69.2l39.5-27.3z"]
};
var faAward = {
  prefix: 'fass',
  iconName: 'award',
  icon: [448, 512, [], "f559", "M275.6-.6L224-32 172.4-.6 112-2 83 51 30 80 31.4 140.4 0 192 31.4 243.6 30 304 83 333 94.8 354.5 32 480 160 544 224 428.8 288 544 416 480 353.2 354.5 365 333 418 304 416.6 243.6 448 192 416.6 140.4 418 80 365 51 336-2 275.6-.6zM224 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faPersonDrowning = {
  prefix: 'fass',
  iconName: 'person-drowning',
  icon: [640, 512, [], "e545", "M264.4 88a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM164.6 55.5c4.1 12.2 16.2 48.5 36.3 108.9l55.7 11.6 122.6 0c110.8-36.9 167.3-55.8 169.4-56.5l20.2 60.7c-1.8 .6-58.9 19.6-171 57l-26.7 89.1-50.7 20.3-93.3-37.3-12.3-4.9 20.2-67.5c-51.4-10.7-79.1-16.5-83.3-17.3L146 202.1c-25-74.9-39-117.1-42.1-126.4l60.7-20.2zm44.7 298.2l111.1 44.4 111.1-44.4 8.9-3.6 8.9 3.6 111.8 44.7c29.3-9.7 50.1-16.7 62.4-20.8l15.2 45.5c-11 3.7-34.6 11.5-70.8 23.6l-8.3 2.8-8.2-3.3-111.1-44.4-111.1 44.4-8.9 3.6-8.9-3.6-111.1-44.4-111.1 44.4-8.2 3.3-8.3-2.8C36.6 434.7 13 426.8 2 423.2l15.2-45.5c12.4 4.1 33.2 11.1 62.4 20.8l111.8-44.7 8.9-3.6 8.9 3.6z"]
};
var faArrowUpToArc = {
  prefix: 'fass',
  iconName: 'arrow-up-to-arc',
  icon: [512, 512, [], "e617", "M256 64c106 0 192 86 192 192l0 32 64 0 0-32C512 114.6 397.4 0 256 0S0 114.6 0 256l0 32 64 0 0-32C64 150 150 64 256 64zM366.6 257.4c-69.6-69.6-106.4-106.4-110.6-110.6-4.2 4.2-41.1 41.1-110.6 110.6L122.7 280 168 325.3c13.3-13.3 32-32 56-56l0 242.7 64 0 0-242.7 56 56 45.3-45.3-22.6-22.6z"]
};
var faSchoolUnlock = {
  prefix: 'fass',
  iconName: 'school-unlock',
  icon: [640, 512, [], "e6cb", "M0 128l128 0 160-128 160 128 128 0 0 57.3c-14.8-6-31-9.3-48-9.3-70.7 0-128 57.3-128 128l-32 0 0 208-368 0 0-384zM320 336l-96 0 0 128 96 0 0-128zM64 384l64 0 0-64-64 0 0 64zm64-128l0-64-64 0 0 64 64 0zm224-64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM496 304l0 48 144 0 0 192-224 0 0-192 32 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faNoteMedical = {
  prefix: 'fass',
  iconName: 'note-medical',
  icon: [448, 512, [], "e200", "M304 480l-304 0 0-448 448 0 0 304-144 144zM192 160l0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0z"]
};
var faTransporter3 = {
  prefix: 'fass',
  iconName: 'transporter-3',
  icon: [640, 512, [], "e045", "M370.6 48c3.5-7.3 5.4-15.4 5.4-24 0-30.9-25.1-56-56-56S264-6.9 264 24c0 8.6 1.9 16.7 5.4 24l101.2 0zM240 544l240 0 0-48-320 0 0 48 80 0zm0-448l-16 0 0 32 192 0 0-32-176 0zm-32 64l-16 0 0 32 256 0 0-32-240 0zm-32 64l-16 0 0 32 320 0 0-32-304 0zm-16 64l-16 0 0 32 352 0 0-32-336 0zm80 64l-16 0 0 32 192 0 0-32-176 0zm0 64l-16 0 0 32 192 0 0-32-176 0zM144 144l-48-16-16-48-16 48-48 16 48 16 16 48 16-48 48-16zM576 32l-16-48-16 48-48 16 48 16 16 48 16-48 48-16-48-16z"]
};
var faPostageStamp = {
  prefix: 'fass',
  iconName: 'postage-stamp',
  icon: [448, 512, [], "e6e3", "M320 32l-64 0c0 17.7-14.3 32-32 32s-32-14.3-32-32l-64 0c0 17.7-14.3 32-32 32S64 49.7 64 32L0 32 0 96c17.7 0 32 14.3 32 32S17.7 160 0 160l0 64c17.7 0 32 14.3 32 32S17.7 288 0 288l0 64c17.7 0 32 14.3 32 32S17.7 416 0 416l0 64 64 0c0-17.7 14.3-32 32-32s32 14.3 32 32l64 0c0-17.7 14.3-32 32-32s32 14.3 32 32l64 0c0-17.7 14.3-32 32-32s32 14.3 32 32l64 0 0-64c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64-64 0c0 17.7-14.3 32-32 32s-32-14.3-32-32zM96 128l256 0 0 256-256 0 0-256zm48 48l0 160 160 0 0-160-160 0z"]
};
var faSnowflakeDroplets = {
  prefix: 'fass',
  iconName: 'snowflake-droplets',
  icon: [640, 512, [], "e5c1", "M344.4 38.1l30.7 30.7-7.1 13.6-6.6 6.6-41 41 0 70.6 17.9-10.3c4.2 22 15.1 41.4 30.2 56.5l-16.1 9.3 61.2 35.3 43.5-11.7c12.5-1 24.5-4.1 35.8-8.9l2.2 8.1-50.2 96.1c-1.1 2.1-2.2 4.3-3.1 6.5l-1.4-.8 .7 2.5c-4.6 11-7.5 22.8-8.3 34.7l-29.9 8c-2.7-10-9.7-36.4-21.2-79.1l-61.2-35.3 0 70.6c31.3 31.3 50.6 50.6 57.9 57.9l-33.9 33.9-24-24 0 94.1-64 0 0-94.1c-3 3-11 11-24 24L198.5 440c7.3-7.3 26.6-26.6 57.9-57.9l0-70.6-61.2 35.3c-11.5 42.8-18.5 69.1-21.2 79.1l-46.4-12.4c4.7-17.7 7.7-28.6 8.8-32.8-40.2 23.2-67.3 38.9-81.5 47L23 372.3c14.1-8.2 41.3-23.8 81.5-47-4.1-1.1-15.1-4-32.8-8.8l12.4-46.4c10 2.7 36.4 9.8 79.1 21.2l61.2-35.3-61.2-35.3c-42.8 11.5-69.2 18.5-79.1 21.2L71.7 195.5c17.7-4.7 28.6-7.7 32.8-8.8-40.2-23.2-67.3-38.9-81.5-47L55 84.3c14.1 8.2 41.3 23.8 81.5 47-1.1-4.1-4-15.1-8.8-32.8L174 86.1c2.7 10 9.7 36.4 21.2 79.1l61.2 35.3 0-70.6C225.1 98.6 205.8 79.3 198.5 72l33.9-33.9c13 13 21 21 24 24l0-94.1 64 0 0 94.1c3-3 11-11 24-24zm161 103.1c4.6 8.9 7 18.7 7 28.7 0 34.3-29.7 62.1-64 62.1s-64-27.8-64-62.1c0-10 2.4-19.9 7-28.7l57-109.2 57 109.2zm39 146.8l57 109.2c4.6 8.9 7 18.7 7 28.7 0 34.3-29.7 62.1-64 62.1s-64-27.8-64-62.1c0-10 2.4-19.9 7-28.7l57-109.2z"]
};
var faCameraRotate = {
  prefix: 'fass',
  iconName: 'camera-rotate',
  icon: [512, 512, [], "e0d8", "M138.7 96l21.3-64 192 0 21.3 64 138.7 0 0 384-512 0 0-384 138.7 0zM160 368l64-80-40 0c0-39.8 32.2-72 72-72 4.4 0 8.7 .4 12.9 1.2l34.9-39.3c-14.6-6.4-30.8-9.9-47.8-9.9-66.3 0-120 53.7-120 120l-40 0 64 80zM352 208l-64 80 40 0c0 39.8-32.2 72-72 72-4.4 0-8.7-.4-12.9-1.2l-34.9 39.3c14.7 6.4 30.8 9.9 47.8 9.9 66.3 0 120-53.7 120-120l40 0-64-80z"]
};
var faLoader = {
  prefix: 'fass',
  iconName: 'loader',
  icon: [512, 512, [], "e1d4", "M288 32l0-32-64 0 0 128 64 0 0-96zm0 384l0-32-64 0 0 128 64 0 0-96zM0 224l0 64 128 0 0-64-128 0zm416 0l-32 0 0 64 128 0 0-64-96 0zM97.6 52.4L52.4 97.6c11.3 11.3 33.9 33.9 67.9 67.9l22.6 22.6 45.3-45.3c-11.3-11.3-33.9-33.9-67.9-67.9L97.6 52.4zM391.8 346.5l-22.6-22.6-45.3 45.3c11.3 11.3 33.9 33.9 67.9 67.9l22.6 22.6 45.3-45.3c-11.3-11.3-33.9-33.9-67.9-67.9zM52.4 414.4l45.3 45.3c11.3-11.3 33.9-33.9 67.9-67.9l22.6-22.6-45.3-45.3c-11.3 11.3-33.9 33.9-67.9 67.9L52.4 414.4zM346.5 120.2l-22.6 22.6 45.3 45.3c11.3-11.3 33.9-33.9 67.9-67.9l22.6-22.6-45.3-45.3c-11.3 11.3-33.9 33.9-67.9 67.9z"]
};
var faFileMidi = {
  prefix: 'fass',
  iconName: 'file-midi',
  icon: [576, 512, [], "e805", "M229.5 390.4l26.1 47.5 25.1-47.3 5.7-10.6 37.6 0 0 168-40 0 0-78.2c-5.7 10.8-15 28.2-27.7 52.2-13.1-23.9-22.6-41.1-28.3-51.5l0 77.4-40 0 0-168 35.8 0 5.7 10.4zM388 548l-40 0 0-168 40 0 0 168zm76-168c28.7 0 52 23.3 52 52l0 64c0 28.7-23.3 52-52 52l-52 0 0-168 52 0zM580 548l-40 0 0-168 40 0 0 168zM416 144l0 192-272 0 0 176-112 0 0-512 240 0 144 144zm36 364l12 0c6.6 0 12-5.4 12-12l0-64c0-6.6-5.4-12-12-12l-12 0 0 88zM240 176L357.5 176 240 58.5 240 176z"]
};
var faUserHoodie = {
  prefix: 'fass',
  iconName: 'user-hoodie',
  icon: [448, 512, [], "e68a", "M341.6 288C372.7 257.5 392 215 392 168 392 75.2 316.8 0 224 0S56 75.2 56 168c0 47 19.3 89.5 50.4 120l-42.4 0-64 224 448 0-64-224-42.4 0zM176 368l0 96-48 0 0-96 48 0zm144 0l0 96-48 0 0-96 48 0zM136 166.7c0-47.9 39.4-86.7 88-86.7s88 38.8 88 86.7C312 236 224 288 224 288s-88-52-88-121.3z"]
};
var faFaceGrinHearts = {
  prefix: 'fass',
  iconName: 'face-grin-hearts',
  icon: [512, 512, [128525, "grin-hearts"], "f584", "M256 512c141.4 0 256-114.6 256-256 0-23.3-3.1-45.9-8.9-67.3 5.5-13.5 8.9-28.4 8.9-44.7 0-53-43-96-96-96l-2.9 0c-2.5 0-5 .1-7.4 .3-42.1-30.4-93.8-48.3-149.7-48.3S148.4 17.9 106.3 48.3c-2.5-.2-4.9-.3-7.4-.3L96 48c-53 0-96 43-96 96 0 16.3 3.5 31.2 8.9 44.7-5.8 21.4-8.9 44-8.9 67.3 0 141.4 114.6 256 256 256zm0-168c58.2 0 112.4-10.6 157.7-28.7-13 75.4-78.6 132.7-157.7 132.7S111.3 390.7 98.3 315.3C143.6 333.4 197.8 344 256 344zM322.9 96c13.5 0 26.5 5.4 36 14.9l9.1 9.1 9.1-9.1c9.5-9.5 22.5-14.9 36-14.9l2.9 0c26.5 0 48 21.5 48 48 0 64-96 112-96 112s-96-48-96-112c0-26.5 21.5-48 48-48l2.9 0zm-188 14.9l9.1 9.1 9.1-9.1c9.5-9.5 22.5-14.9 36-14.9l2.9 0c26.5 0 48 21.5 48 48 0 64-96 112-96 112S48 208 48 144c0-26.5 21.5-48 48-48l2.9 0c13.5 0 26.5 5.4 36 14.9z"]
};
var faGrinHearts = faFaceGrinHearts;
var faFileFragment = {
  prefix: 'fass',
  iconName: 'file-fragment',
  icon: [384, 512, [], "e697", "M240 0l-240 0 0 304 208 0 0 208 176 0 0-368-144-144zm85.5 176L208 176 208 58.5 325.5 176zM160 352l-160 0 0 160 160 0 0-160z"]
};
var faLoveseat = {
  prefix: 'fass',
  iconName: 'loveseat',
  icon: [512, 512, ["couch-small"], "f4cc", "M64 64l384 0 0 112-80 0 0 128-224 0 0-128-80 0 0-112zm0 384l-64 0 0-224 96 0 0 128 320 0 0-128 96 0 0 224-64 0 0 32-64 0 0-32-256 0 0 32-64 0 0-32z"]
};
var faCouchSmall = faLoveseat;
var faPersonMilitaryRifle = {
  prefix: 'fass',
  iconName: 'person-military-rifle',
  icon: [512, 512, [], "e54b", "M160.3 16l0 48 192 0 0-64-192 16zm17.6 80c-1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16L177.9 96zm-1.6 128l-6.1 0 182.1 260.1 0-114.4c41.2 69.8 65.9 111.5 73.9 125.1l68.9-40.7c-3.4-5.7-37.3-63.2-101.9-172.5l52.4-90.8-29.3-16.9 63.5-109.9c-6.9-4-20.8-12-41.6-24l-13.9-8-16 27.7 13.9 8-90.2 156.3-155.6 0zm-34.4 19.7l-104 176-20.3 34.4 68.9 40.7c8-13.6 32.7-55.3 73.9-125.1l0 142.3 172.5 0-189.5-270.7-1.4 2.4zM296.3 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faToggleOn = {
  prefix: 'fass',
  iconName: 'toggle-on',
  icon: [576, 512, [], "f205", "M576 64l-576 0 0 384 576 0 0-384zm-96 96l0 192-192 0 0-192 192 0z"]
};
var faArrowUpToLine = {
  prefix: 'fass',
  iconName: 'arrow-up-to-line',
  icon: [384, 512, ["arrow-to-top"], "f341", "M32 0L0 0 0 64 384 64 384 0 32 0zM214.6 137.4l-22.6-22.6-22.6 22.6-128 128-22.6 22.6 45.3 45.3c6.6-6.6 38.6-38.6 96-96l0 274.7 64 0 0-274.7c57.4 57.4 89.4 89.4 96 96l45.3-45.3-22.6-22.6-128-128z"]
};
var faArrowToTop = faArrowUpToLine;
var faPompebled = {
  prefix: 'fass',
  iconName: 'pompebled',
  icon: [512, 512, [], "e43d", "M295.2 216.3c48.2-58.4 118.9-77.5 165.1-44.3 59 41.8 68.8 131.8 22.6 200.2-85.5 126.3-260.4 185.6-381.8 98.6-121.9-87-129.7-274.1-44.2-400.4 46.2-68.9 131.7-91 190.7-49.3 46.7 32.2 54.5 106.6 17.7 173.5l-10.6 15.3 30 21.6 10.6-15.3z"]
};
var faLungsVirus = {
  prefix: 'fass',
  iconName: 'lungs-virus',
  icon: [576, 512, [], "e067", "M320 32l0 141.9 3.5 2.1-71.1 0 3.5-2.1 0-173.9 64 0 0 32zm-96 0l0 144-8 0 0 34.2-24.2-24.2-101.8 101.8 24.2 24.2-34.2 0 0 144 34.2 0-24.2 24.2 31.8 31.8-121.8 0 0-66.1C0 292.8 57 145.2 160 32l64 0zM576 512l-122.2 0 32-32-24-24 34.2 0 0-144-34.2 0 24.2-24.2-101.8-101.8-24.2 24.2 0-34.2-8 0 0-144 64 0 27.3 35.5C529.3 179.3 576 316.5 576 457.7l0 54.3zm-312 8c0-28.8-34.8-43.2-55.2-22.8l-17 17-33.9-33.9 17-17c20.4-20.4 5.9-55.2-22.9-55.2l-24 0 0-48 24.1 0c28.8 0 43.1-34.8 22.8-55.2l-17-17 33.9-33.9 17 17c20.4 20.4 55.2 6 55.2-22.8l0-24 48 0 0 24c0 28.8 34.8 43.2 55.2 22.9l17-17 33.9 33.9-17 17c-20.3 20.4-5.9 55.1 22.8 55.2l24.1 0 0 48-24 0c-28.8 0-43.2 34.8-22.8 55.2l16.8 16.8-33.9 33.9-16.8-16.8C346.8 476.8 312 491.2 312 520l0 24-48 0 0-24zm56-80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40-88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faTableTennisPaddleBall = {
  prefix: 'fass',
  iconName: 'table-tennis-paddle-ball',
  icon: [512, 512, [127955, "ping-pong-paddle-ball", "table-tennis"], "f45d", "M97 127l67.4-67.4c38.2-38.2 90-59.6 144-59.6 112.5 0 203.7 91.2 203.7 203.6 0 46.4-15.8 91.1-44.5 127-23.6-16.8-52.4-26.7-83.5-26.7-31.1 0-59.9 9.9-83.4 26.6L97 127zM240 448c0 11 1.2 21.7 3.6 32l-19.6 0-56-56-88 88-80-80 88-88-56-56 0-96 31-31 203.6 203.6C249.9 388.1 240 416.9 240 448zm144-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faPingPongPaddleBall = faTableTennisPaddleBall;
var faTableTennis = faTableTennisPaddleBall;
var faBoxesPacking = {
  prefix: 'fass',
  iconName: 'boxes-packing',
  icon: [576, 512, [], "e4c7", "M160 0l128 0 0 80 128 0 0-80 128 0 0 512-144 0 0-176 16 0 0-192-256 0 0-144zM32 336l320 0 0 176-320 0 0-176zM368 192l0 96-352 0 0-96 352 0z"]
};
var faSidebarFlip = {
  prefix: 'fass',
  iconName: 'sidebar-flip',
  icon: [512, 512, [], "e24f", "M0 448l256 0 0-384-256 0 0 384zM512 64l-208 0 0 384 208 0 0-384zM352 128l112 0 0 48-112 0 0-48zm112 88l0 48-112 0 0-48 112 0zM352 304l112 0 0 48-112 0 0-48z"]
};
var faBookFont = {
  prefix: 'fass',
  iconName: 'book-font',
  icon: [448, 512, [], "e0bf", "M0 0l448 0 0 384-32 0 0 64 32 0 0 64-448 0 0-512zM64 416l0 32 288 0 0-64-256 0c-17.7 0-32 14.3-32 32zM202.5 93.3l-88 176-9.4 18.7 53.7 0 16-32 98.3 0 16 32 53.7 0-9.4-18.7-88-176-6.6-13.3-29.7 0-6.6 13.3zM224 157.7l25.2 50.3-50.3 0 25.2-50.3z"]
};
var faHose = {
  prefix: 'fass',
  iconName: 'hose',
  icon: [448, 512, [], "e419", "M288 104l0 24 48 0 0-26.3 64-9.1 0 11.4 48 0 0-80-48 0 0 11.4-64-9.1 0-26.3-48 0 0 32-160 0C57.3 32 0 89.3 0 160S57.3 288 128 288l320 0 0-64-320 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l160 0 0 8zM32 336l-32 0 0 64 448 0 0-64-416 0zm0 112l-32 0 0 64 448 0 0-64-416 0z"]
};
var faTreeLarge = {
  prefix: 'fass',
  iconName: 'tree-large',
  icon: [512, 512, [], "f7dd", "M273.1 10.2C377.3 137.6 430.7 202.8 433.2 205.8l-73.9 0c70.3 82.2 112 131 125 146.2l-105.1 0c80.3 93.7 126 147 137.2 160L-4 512c11.1-13 56.8-66.3 137.2-160L28.1 352c13-15.2 54.7-64 125-146.2l-73.8 0 29.2-35.6 130.9-160 16.9-20.7 16.9 20.7z"]
};
var faHearts = {
  prefix: 'fass',
  iconName: 'hearts',
  icon: [576, 512, [], "e78f", "M175.5 74.8c-21-24.2-52.3-36.9-84.2-34.1-54.9 4.8-95.6 53.2-90.8 108.2 7.1 80.9 85.5 149.2 158.1 197.1-10.4-28.5-15.9-59-13.1-90.7 7.1-81.3 78.8-141.5 160.2-134.4 28 2.5 54.3 12.8 76.2 29.3 1.7-11.5 2.2-23.1 1.2-34.7-4.8-54.9-53.2-95.6-108.2-90.8-31.9 2.8-60.6 20.7-77 48.2l-9.8 16.5-12.6-14.5zm203 142c-16.4-27.5-45.1-45.4-77-48.2-54.9-4.8-103.4 35.8-108.2 90.8-8.9 102.2 97.7 204.4 169.6 263.9 81.2-46.1 204-128.3 212.9-230.5 4.8-54.9-35.8-103.4-90.8-108.2-31.9-2.8-63.2 9.9-84.2 34.1l-12.6 14.5-9.9-16.5z"]
};
var faFaceFrownSlight = {
  prefix: 'fass',
  iconName: 'face-frown-slight',
  icon: [512, 512, [], "e376", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM192.3 390.4l-42.4-22.5C170 329.9 210 304 256 304s86 25.9 106.1 63.9l-42.4 22.5C307.6 367.5 283.6 352 256 352s-51.6 15.5-63.7 38.4zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPersonChalkboard = {
  prefix: 'fass',
  iconName: 'person-chalkboard',
  icon: [640, 512, [], "e53d", "M192 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM112 544l64 0 0-208 32 0 0 208 64 0 0-368 160 0 0-64-48 0 0-48 192 0 0 192-192 0 0-32-64 0 0 96 320 0 0-320-320 0 0 112-195 0-9.6 12.7-108.9 144 51 38.6 54.5-72 0 308.7z"]
};
var faDiceTwo = {
  prefix: 'fass',
  iconName: 'dice-two',
  icon: [448, 512, [9857], "f528", "M0 32l448 0 0 448-448 0 0-448zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faTransformerBolt = {
  prefix: 'fass',
  iconName: 'transformer-bolt',
  icon: [384, 512, [], "e2a4", "M136 24l0 8 40 0 0 32-128 0 0-32 40 0 0-32 48 0 0 24zm160 0l0 8 40 0 0 32-128 0 0-32 40 0 0-32 48 0 0 24zM48 96l128 0 0 32-128 0 0-32zm160 0l128 0 0 32-128 0 0-32zM0 160l384 0 0 64-32 0 0 224 32 0 0 64-384 0 0-64 32 0 0-224-32 0 0-64zm240 48l-144 144 70.5 5-22.5 107 144-144-70.5-5 22.5-107z"]
};
var faArrowRightArrowLeft = {
  prefix: 'fass',
  iconName: 'arrow-right-arrow-left',
  icon: [576, 512, [8644, "exchange"], "f0ec", "M534.9 150.6c-76.2 76.2-115.8 115.8-118.6 118.6L371 224c12-12 33.3-33.3 64-64l-402.7 0 0-64 402.7 0c-30.7-30.7-52-52-64-64l45.3-45.3c2.9 2.9 42.4 42.4 118.6 118.6l22.6 22.6-22.6 22.6zM41.6 406.6L19 384c2.9-2.9 42.4-42.4 118.6-118.6l22.6-22.6 45.3 45.3-64 64 402.7 0 0 64-402.7 0 64 64-45.3 45.3c-2.9-2.9-42.4-42.4-118.6-118.6z"]
};
var faExchange = faArrowRightArrowLeft;
var faFootball = {
  prefix: 'fass',
  iconName: 'football',
  icon: [512, 512, [127944, "football-ball"], "f44e", "M261.1 22.5c-18.3 3.7-35.5 8.6-51.7 14.6-66 24.5-112.2 66.5-142.9 116.5-20.7 33.7-34.1 70.8-42.2 108.3L251.9 489.5c18.3-3.7 35.5-8.6 51.7-14.6 66-24.5 112.2-66.5 142.9-116.5 20.7-33.7 34.1-70.8 42.2-108.3L261.1 22.5zm236 168.1c3.9-51.6-.7-101.4-9-141.7l-4.4-21.5-21.6-3.6c-52-8.7-98.7-11.4-140.7-9L497.1 190.6zM191.7 497.1L15.9 321.4c-3.9 51.6 .7 101.4 9 141.7l4.4 21.5 21.6 3.6c52 8.7 98.7 11.4 140.7 9zm96.8-371.1c3.5 3.5 30.5 30.5 81 81l17 17-33.9 33.9c-3.5-3.5-30.5-30.5-81-81l-17-17 33.9-33.9zm-64 64c3.5 3.5 30.5 30.5 81 81l17 17-33.9 33.9c-3.5-3.5-30.5-30.5-81-81l-17-17 33.9-33.9zm-64 64c3.5 3.5 30.5 30.5 81 81l17 17-33.9 33.9c-3.5-3.5-30.5-30.5-81-81l-17-17 33.9-33.9z"]
};
var faFootballBall = faFootball;
var faTruckMonster = {
  prefix: 'fass',
  iconName: 'truck-monster',
  icon: [576, 512, [], "f63b", "M336 96l48 64-128 0 0-64 80 0zM192 96l0 64-192 0 0 160 18.7 0 10.7 10.7c-3.6 6.7-6.6 13.8-8.8 21.3l-20.6 0 0 64 20.6 0c2.2 7.4 5.2 14.6 8.8 21.3l-14.6 14.6 45.3 45.3 14.6-14.6c6.7 3.6 13.8 6.6 21.3 8.8l0 20.6 64 0 0-20.6c7.4-2.2 14.6-5.2 21.3-8.8l14.6 14.6 45.3-45.3-14.6-14.6c3.6-6.7 6.6-13.8 8.8-21.3l20.6 0 0-64-20.6 0c-2.2-7.4-5.2-14.6-8.8-21.3l10.7-10.7 101.5 0 10.7 10.7c-3.6 6.7-6.6 13.8-8.8 21.3l-20.6 0 0 64 20.6 0c2.2 7.4 5.2 14.6 8.8 21.3l-14.6 14.6 45.3 45.3 14.6-14.6c6.7 3.6 13.8 6.6 21.3 8.8l0 20.6 64 0 0-20.6c7.4-2.2 14.6-5.2 21.3-8.8l14.6 14.6 45.3-45.3-14.6-14.6c3.6-6.7 6.6-13.8 8.8-21.3l20.6 0 0-64-20.6 0c-2.2-7.4-5.2-14.6-8.8-21.3l10.7-10.7 18.7 0 0-160-112 0-96-128-176 0 0 64zM128 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm320 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faTaco = {
  prefix: 'fass',
  iconName: 'taco',
  icon: [512, 512, [127790], "f826", "M325.9 70.1l88.3-2.7 24.7 84.9 73.1 49.7-19.7 54.8C436.6 188 351.4 144 256 144S75.4 188 19.7 256.8L0 202 73.1 152.3 97.8 67.4 186.1 70.1 256 16 325.9 70.1zM0 480l0-32C0 306.6 114.6 192 256 192S512 306.6 512 448l0 32-512 0zm112-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faMaskSnorkel = {
  prefix: 'fass',
  iconName: 'mask-snorkel',
  icon: [576, 512, [], "e3b7", "M576 386.1c0 69.6-55.6 126.4-125.2 128-71.8 1.6-130.8-56.2-130.8-128l0-34.1 64 0 0 34.1c0 35.9 29.5 64.8 65.4 64 34.8-.8 62.6-29.2 62.6-64l0-178.1 64 0 0 178.1zM448 288l-176 0-32-64-32 0-32 64-176 0 0-224 448 0 0 224zM576 160l-64 0 0-128 64 0 0 128z"]
};
var faArrowUpFromLine = {
  prefix: 'fass',
  iconName: 'arrow-up-from-line',
  icon: [384, 512, [8613, "arrow-from-bottom"], "f342", "M214.6 9.4L192-13.3 169.4 9.4 41.4 137.4 18.7 160 64 205.3c6.6-6.6 38.6-38.6 96-96l0 274.7 64 0 0-274.7 96 96 45.3-45.3-22.6-22.6-128-128zM32 448l-32 0 0 64 384 0 0-64-352 0z"]
};
var faArrowFromBottom = faArrowUpFromLine;
var faAsterisk = {
  prefix: 'fass',
  iconName: 'asterisk',
  icon: [512, 512, [10033, 61545], "2a", "M288.2 0l0 200.6 144-83.1 27.7-16 32 55.4-27.7 16-144 83.1 144 83.1 27.7 16-32 55.4-27.7-16-144-83.1 0 200.6-64 0 0-200.6-144 83.1-27.7 16-32-55.4 27.7-16 144-83.1-144-83.1-27.7-16 32-55.4 27.7 16 144 83.1 0-200.6 64 0z"]
};
var faClothesHanger = {
  prefix: 'fass',
  iconName: 'clothes-hanger',
  icon: [576, 512, [], "e136", "M240 112c0-26.5 21.5-48 48-48s48 21.5 48 48c0 19.3-9.6 37.3-25.7 48l-296.1 197.4-14.2 9.5 0 113.1 576 0 0-113.7-15-9.4-222.2-138.9 7.1-4.7C379.7 190.7 400 152.7 400 112 400 50.1 349.9 0 288 0S176 50.1 176 112l64 0zM64 401.1l216.3-144.2 231.7 144.8 0 14.3-448 0 0-14.9z"]
};
var faBarProgressFull = {
  prefix: 'fass',
  iconName: 'bar-progress-full',
  icon: [512, 512, [], "e6a6", "M0 96l512 0 0 320-512 0 0-320z"]
};
var faBatteryFull = {
  prefix: 'fass',
  iconName: 'battery-full',
  icon: [640, 512, [128267, "battery", "battery-5"], "f240", "M544 128l0 256-448 0 0-256 448 0zM96 64l-64 0 0 384 576 0 0-128 32 0 0-128-32 0 0-128-512 0zM496 176l-352 0 0 160 352 0 0-160z"]
};
var faBattery = faBatteryFull;
var faBattery5 = faBatteryFull;
var faChildDress = {
  prefix: 'fass',
  iconName: 'child-dress',
  icon: [320, 512, [], "e59c", "M96 64A64 64 0 1 1 224 64 64 64 0 1 1 96 64zm4.9 96l118.1 0 9.6 12.8C285.6 248.5 316 289 320 294.4l-51.2 38.4c-13.5-17.9-25-33.3-34.6-46l37.7 113.2-40 0 0 112-64 0 0-112-16 0 0 112-64 0 0-112-40 0 37.7-113.2c-9.6 12.8-21.1 28.1-34.6 46L0 294.4c4-5.3 34.5-45.9 91.3-121.6L101 160z"]
};
var faFaceKissBeam = {
  prefix: 'fass',
  iconName: 'face-kiss-beam',
  icon: [512, 512, [128537, "kiss-beam"], "f597", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM232 288l40 0c26.5 0 48 21.5 48 48 0 12.3-4.6 23.5-12.2 32 7.6 8.5 12.2 19.7 12.2 32 0 26.5-21.5 48-48 48l-48 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32 8 0zM176 180c-15.5 0-28 12.5-28 28l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28zm132 28l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28s-28 12.5-28 28z"]
};
var faKissBeam = faFaceKissBeam;
var faTaxiBus = {
  prefix: 'fass',
  iconName: 'taxi-bus',
  icon: [576, 512, [], "e298", "M0 0l384 0 0 80-112 0 0 16-208 0 0 128 112 0 0 16.1-32 0 0 175.9-32 0 0 64-80 0 0-64-32 0 0-416zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288.1 159.9l31.9 .1 0-32 128 0 0 32.3c22.7 .1 41.4 .1 56.1 .1 .5 1.9 12.7 44.4 36.6 127.6l35.3 0 0 224-64 0 0-48-256 0 0 48-64 0 0-224 35.3 0c23.9-83.5 36.1-126.2 36.6-128.2l24.2 .1zM474.1 288l-18.3-63.7-143.8-.4-18.3 64 180.3 0zM320 383.5a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faSquareArrowUpLeft = {
  prefix: 'fass',
  iconName: 'square-arrow-up-left',
  icon: [448, 512, [], "e263", "M448 32l-448 0 0 448 448 0 0-448zM264 208l-54.1 0 103 103 17 17-33.9 33.9-17-17-103-103 0 78.1-48 0 0-160 160 0 0 48-24 0z"]
};
var faTrashCanArrowUp = {
  prefix: 'fass',
  iconName: 'trash-can-arrow-up',
  icon: [448, 512, ["trash-restore-alt"], "f82a", "M304-16l16 48 128 0 0 64-448 0 0-64 128 0 16-48 160 0zM32 144l384 0 0 368-384 0 0-368zm209 79l-17-17c-2.1 2.1-31.8 31.8-89 89l-17 17 33.9 33.9c9-9 25-25 48-48l0 126.1 48 0 0-126.1c23 23 39 39 48 48L329.9 312c-2.1-2.1-31.8-31.8-89-89z"]
};
var faTrashRestoreAlt = faTrashCanArrowUp;
var faFont = {
  prefix: 'fass',
  iconName: 'font',
  icon: [512, 512, [], "f031", "M284.9 66.2l-28.9-60.4-28.9 60.4-167.3 349.8-43.8 0 0 64 152 0 0-64-37.2 0 23-48 204.5 0 23 48-37.2 0 0 64 152 0 0-64-43.8 0-167.3-349.8zM327.7 304L184.3 304 256 154.2 327.7 304z"]
};
var faFaceKissClosedEyes = {
  prefix: 'fass',
  iconName: 'face-kiss-closed-eyes',
  icon: [512, 512, [], "e37d", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM232 288l40 0c26.5 0 48 21.5 48 48 0 12.3-4.6 23.5-12.2 32 7.6 8.5 12.2 19.7 12.2 32 0 26.5-21.5 48-48 48l-48 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32 8 0zm-64-92c-11 0-20 9-20 20l0 16-40 0 0-16c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60l0 16-40 0 0-16c0-11-9-20-20-20l-16 0zm140 20l0 16-40 0 0-16c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60l0 16-40 0 0-16c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20z"]
};
var faBoreHole = {
  prefix: 'fass',
  iconName: 'bore-hole',
  icon: [512, 512, [], "e4c3", "M288 0l-64 0 0 264.6c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4L288 0zM0 384l0 128 512 0 0-384-144 0 0 192c0 61.9-50.1 112-112 112S144 381.9 144 320l0-192-144 0 0 256z"]
};
var faFilmStack = {
  prefix: 'fass',
  iconName: 'film-stack',
  icon: [512, 512, [], "e76b", "M120-32l296 0 0 48-320 0 0-48 24 0zM72 64l392 0 0 48-416 0 0-48 24 0zM0 160l512 0 0 320-512 0 0-320zm48 88l48 0 0-48-48 0 0 48zm48 96l0-48-48 0 0 48 48 0zm0 96l0-48-48 0 0 48 48 0zm368 0l0-48-48 0 0 48 48 0zm-48-96l48 0 0-48-48 0 0 48zm48-96l0-48-48 0 0 48 48 0z"]
};
var faVirusCovid = {
  prefix: 'fass',
  iconName: 'virus-covid',
  icon: [512, 512, [], "e4a8", "M320 48l-40 0 0 33.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92c-6.6-6.6-16-16-28.3-28.3l33.9-33.9c75.4 75.4 80.1 80.1 90.5 90.5l-33.9 33.9c-12.3-12.3-21.7-21.7-28.3-28.3l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3l33.6 0 0-40 48 0 0 128-48 0 0-40-33.6 0c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1c6.6-6.6 16-16 28.3-28.3l33.9 33.9c-75.4 75.4-80.1 80.1-90.5 90.5l-33.9-33.9c12.3-12.3 21.7-21.7 28.3-28.3l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1l0 33.6 40 0 0 48-128 0 0-48 40 0 0-33.6c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420c6.6 6.6 16 16 28.3 28.3l-33.9 33.9c-75.4-75.4-80.1-80.1-90.5-90.5l33.9-33.9c12.3 12.3 21.7 21.7 28.3 28.3l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280l-33.6 0 0 40-48 0 0-128 48 0 0 40 33.6 0c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 63.7 154.2 29.7 120.2c75.4-75.4 80.1-80.1 90.5-90.5l33.9 33.9-28.3 28.3 23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1l0-33.6-40 0 0-48 128 0 0 48zM224 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLeft = {
  prefix: 'fass',
  iconName: 'left',
  icon: [448, 512, ["arrow-alt-left"], "f355", "M0 256l224 208 0-144 224 0 0-128-224 0 0-144-224 208z"]
};
var faArrowAltLeft = faLeft;
var faGaugeCircleBolt = {
  prefix: 'fass',
  iconName: 'gauge-circle-bolt',
  icon: [640, 512, [], "e496", "M288 0c126.8 0 232.1 92.2 252.4 213.2-14.3-3.4-29.1-5.2-44.4-5.2-70.9 0-132.8 38.4-166.1 95.6-5.3-4.6-11.3-8.3-17.9-11l0-196.7-48 0 0 196.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64 5.7 0 11.2-.7 16.5-2.1 2.5 34.5 14 66.4 32.3 93.5-15.8 3-32.1 4.6-48.8 4.6-141.4 0-256-114.6-256-256S146.6 0 288 0zM176 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM432 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM400 416l70.9 0-22.9 80 144-112-70.9 0 22.9-80-144 112z"]
};
var faRectanglesMixed = {
  prefix: 'fass',
  iconName: 'rectangles-mixed',
  icon: [512, 512, [], "e323", "M0 64l288 0 0 192-288 0 0-192zm352 0l160 0 0 352-160 0 0-352zM288 320l0 160-224 0 0-160 224 0z"]
};
var faBracketsRound = {
  prefix: 'fass',
  iconName: 'brackets-round',
  icon: [512, 512, ["parentheses"], "e0c5", "M110.2 37.4C71.9 62.9 0 140.2 0 256S71.9 449 110.2 474.6l35.5-53.3C120.1 404.3 64 345 64 256s56.1-148.3 81.8-165.4L110.2 37.4zm291.5 0L366.2 90.6C391.9 107.7 448 167 448 256s-56.1 148.3-81.8 165.4l35.5 53.3C440.1 449 512 371.8 512 256S440.1 62.9 401.8 37.4z"]
};
var faParentheses = faBracketsRound;
var faOmega = {
  prefix: 'fass',
  iconName: 'omega',
  icon: [448, 512, [], "f67a", "M224 96c-88.4 0-160 71.6-160 160 0 59.2 32.1 110.9 80 138.6l16 9.2 0 76.1-160 0 0-64 67.2 0C25.8 375.4 0 318.7 0 256 0 132.3 100.3 32 224 32S448 132.3 448 256c0 62.7-25.8 119.4-67.2 160l67.2 0 0 64-160 0 0-76.1 16-9.2c47.9-27.7 80-79.4 80-138.6 0-88.4-71.6-160-160-160z"]
};
var faBlindsRaised = {
  prefix: 'fass',
  iconName: 'blinds-raised',
  icon: [448, 512, [], "f8fd", "M448 32l-448 0 0 64 112 0 0 384 48 0 0-384 288 0 0-64zM0 208l64 0 0-64-64 0 0 64zm448 0l0-64-240 0 0 64 240 0z"]
};
var faFilePdf = {
  prefix: 'fass',
  iconName: 'file-pdf',
  icon: [576, 512, [], "f1c1", "M272 0l-240 0 0 512 144 0 0-176 240 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM240 380l-20 0 0 168 40 0 0-48 12 0c33.1 0 60-26.9 60-60s-26.9-60-60-60l-32 0zm32 80l-12 0 0-40 12 0c11 0 20 9 20 20s-9 20-20 20zm96-80l-20 0 0 168 52 0c28.7 0 52-23.3 52-52l0-64c0-28.7-23.3-52-52-52l-32 0zm20 128l0-88 12 0c6.6 0 12 5.4 12 12l0 64c0 6.6-5.4 12-12 12l-12 0zm88-128l0 168 40 0 0-64 48 0 0-40-48 0 0-24 48 0 0-40-88 0z"]
};
var faLanguage = {
  prefix: 'fass',
  iconName: 'language',
  icon: [640, 512, [], "f1ab", "M224.2 0l0 64 160 0 0 64-41.6 0-8.4 23.1c-16.4 45.2-41.1 86.5-72.2 122 14.2 8.8 29 16.6 44.4 23.5l50.4 22.4 62.2-140 8.4-19 41.6 0 8.4 19 144 324 4 9-70 0-28.4-64-157.5 0-28.4 64-70 0 4-9 55.8-125.5-50.4-22.4c-23-10.2-45-22.4-65.8-36.4-21.3 17.2-44.6 32.2-69.5 44.7-24 12-45.1 22.5-63.2 31.6L53.3 337.7c18.1-9 39.2-19.6 63.2-31.6 16.3-8.2 31.8-17.7 46.4-28.3-13.8-12.7-26.8-26.4-38.9-40.9-5.1-6.1-15.3-18.3-30.7-36.8l49.2-41c15.4 18.5 25.6 30.7 30.7 36.8 11.5 13.9 24.1 26.8 37.4 38.7 27.5-30.4 49.2-66.1 63.5-105.4l.5-1.2-242.3 0 0-64 128 0 0-64 64 0zM498.6 384l-50.3-113.2-50.3 113.2 100.6 0z"]
};
var faShieldHalved = {
  prefix: 'fass',
  iconName: 'shield-halved',
  icon: [512, 512, ["shield-alt"], "f3ed", "M267.6 4.5L256 0 244.5 4.5 37 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.3 91 150 189.4 192.6l12.7 5.5 12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9L494.3 92.5 475.1 85 267.6 4.5zM256 68.7l0 0 176 68.3c-.5 40.9-8.8 96.8-32.6 151.5-26.2 60.3-70.6 118-143.5 153.5l0-373.2z"]
};
var faShieldAlt = faShieldHalved;
var faCircleTenge = {
  prefix: 'fass',
  iconName: 'circle-tenge',
  icon: [512, 512, [], "e725", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM368 176l-224 0 0-32 224 0 0 32zm0 80l-88 0 0 144-48 0 0-144-88 0 0-48 224 0 0 48z"]
};
var faFork = {
  prefix: 'fass',
  iconName: 'fork',
  icon: [512, 512, ["utensil-fork"], "f2e3", "M408.3 8l16 16-104 104 16 16 112-96 16 16-96 112 16 16 104-104 16 16-70.5 123.4c-15.8 27.6-45.1 44.6-76.8 44.6-19.4 0-38.1-6.4-53.4-18L70.9 486.6 48.3 509.3 3 464 25.6 441.4 258.2 208.8c-11.6-15.3-18-34-18-53.4 0-31.8 17-61.1 44.6-76.8L408.3 8z"]
};
var faUtensilFork = faFork;
var faUserHair = {
  prefix: 'fass',
  iconName: 'user-hair',
  icon: [448, 512, [], "e45a", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16 80 0 64-48 0 0c10 13.4 16 30 16 48l0 16zM224 0C153.3 0 96 57.3 96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16C352 57.3 294.7 0 224 0zM432 512l-64-192-288 0-64 192 416 0z"]
};
var faCircleF = {
  prefix: 'fass',
  iconName: 'circle-f',
  icon: [512, 512, [], "e10e", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM200 144l136 0 0 48-112 0 0 48 96 0 0 48-96 0 0 80-48 0 0-224 24 0z"]
};
var faCaretUp = {
  prefix: 'fass',
  iconName: 'caret-up',
  icon: [384, 512, [], "f0d8", "M16 320l176-200 176 200-352 0z"]
};
var faPersonSeat = {
  prefix: 'fass',
  iconName: 'person-seat',
  icon: [448, 512, [], "e21e", "M152 72a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm8 104l104 0 0 144 120 0 0 128 48 0 0 64-112 0 0-128-96 0c-35.3 0-64-28.7-64-64l0-144zm-48 16l0 240 160 0 0 64-224 0 0-336 64 0 0 32z"]
};
var faPegasus = {
  prefix: 'fass',
  iconName: 'pegasus',
  icon: [576, 512, [], "f703", "M448 238.1l0-78.1 16 0 32 64 80-32 0-128-32-32 32 0 0-32-128 0C377.3 0 320 57.3 320 128L160 32s-20.2 141.7 68.1 199.7c-8.7-2.7-16.7-6.1-24.2-10.1-22.5-12.1-38.6-29.4-49.9-49.8-7.3-13.2-12.7-27.8-16.5-43-25.9 3.5-48.1 18.6-61.1 40-43.1 5.7-76.3 42.6-76.3 87.2l0 80 48 0 0-80c0-13.4 6.6-25.2 16.7-32.5 1.6 13 6.3 25.4 13.6 36.4l42.4 63.6c-18.7 18.6-34.5 34.5-47.6 47.6 1.5 4.6 17.2 51.6 47 141l101.2 0-38.3-115c20.2-20.2 33.9-33.9 41.1-41.1l0-35.9 83.7 23.9c4.1 1.2 8.2 2.1 12.3 2.8l0 165.3 96 0 0-196.3c19.2-19.2 31.5-45.7 32-75.7l0 0 0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faFilePen = {
  prefix: 'fass',
  iconName: 'file-pen',
  icon: [640, 512, [128221, "file-edit"], "f31c", "M304 0L64 0 64 512 276.2 512 290.7 424.9 448 267.7 448 144 304 0zm85.5 176L272 176 272 58.5 389.5 176zM544 239.9l-52.8 52.8 80 80 52.8-52.8-80-80zm-208 208l-16 96 96-16 132.6-132.6-80-80-132.6 132.6z"]
};
var faFileEdit = faFilePen;
var faPersonBiking = {
  prefix: 'fass',
  iconName: 'person-biking',
  icon: [576, 512, [128692, "biking"], "f84a", "M368 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM304 88l91.2 72 84.8 0 0 64-107.2 0-49.5-39.6-60.3 48.5 57 38 0 177.1-64 0 0-142.9-60.5-38.4c-32.8-20.8-35-67.9-4.3-91.6L304 88zm48 312a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM112 288a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"]
};
var faBiking = faPersonBiking;
var faBookOpenReader = {
  prefix: 'fass',
  iconName: 'book-open-reader',
  icon: [512, 512, ["book-reader"], "f5da", "M256-24a88 88 0 1 1 0 176 88 88 0 1 1 0-176zm0 474.7l.5-.2C311.1 427.7 369.7 416 428.8 416l19.2 0 0-160-19.2 0c-42.2 0-84.1 8.4-123.1 24.6-16.8 7-33.4 13.9-49.7 20.7l0 149.3zM448 192l64 0 0 288-83.2 0c-50.7 0-100.9 10-147.7 29.5L256 520 230.9 509.5C184.1 490 133.9 480 83.2 480L0 480 0 192 83.2 192c50.7 0 100.9 10 147.7 29.5L256 232 281.1 221.5c46.8-19.5 97-29.5 147.7-29.5l19.2 0z"]
};
var faBookReader = faBookOpenReader;
var faCircleStar = {
  prefix: 'fass',
  iconName: 'circle-star',
  icon: [512, 512, ["star-circle"], "e123", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM209.7 192.3l46.3-90.7 46.3 90.7 100.6 16-72 72 15.9 100.6-90.8-46.2-90.8 46.2 15.9-100.6-72-72 100.6-16z"]
};
var faStarCircle = faCircleStar;
var faPhoneXmark = {
  prefix: 'fass',
  iconName: 'phone-xmark',
  icon: [512, 512, [], "e227", "M128 0L0 64 0 80C0 318.6 193.4 512 432 512l16 0 64-128-128-96.8-80 80.8c-70.4-33-127-89.6-160-160L224.8 128 128 0zM492.9 53.1L458.9 19.1c-8.5 8.5-25.5 25.5-50.9 50.9-25.5-25.5-42.4-42.4-50.9-50.9L323.2 53.1c8.5 8.5 25.5 25.5 50.9 50.9-25.5 25.5-42.4 42.4-50.9 50.9l33.9 33.9c8.5-8.5 25.5-25.5 50.9-50.9 25.5 25.5 42.4 42.4 50.9 50.9l33.9-33.9c-8.5-8.5-25.5-25.5-50.9-50.9 25.5-25.5 42.4-42.4 50.9-50.9z"]
};
var faGlassWaterDroplet = {
  prefix: 'fass',
  iconName: 'glass-water-droplet',
  icon: [384, 512, [], "e4f5", "M96 304c20.1 10.1 43.9 10.1 64 0s43.9-10.1 64 0 43.9 10.1 64 0l8.4-4.2 18.4-235.8-245.6 0 18.4 235.8 8.4 4.2zM344 512L40 512 0 0 384 0 379 64 344 512zM192 96l47.9 53.9c10.4 11.7 16.1 26.7 16.1 42.4 0 35.2-28.8 63.8-64 63.8s-64-28.5-64-63.8c0-15.6 5.7-30.7 16.1-42.4L192 96z"]
};
var faScrubber = {
  prefix: 'fass',
  iconName: 'scrubber',
  icon: [512, 512, [], "f2f8", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faGunSlash = {
  prefix: 'fass',
  iconName: 'gun-slash',
  icon: [576, 512, [], "e19c", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-185.2-185.2 25-69.9 47.1 0 32-32 96 0 0-144-48 0 0-32-48 0 0 32-350 0-80.9-80.9zM194.2 128l286 0 0 32-254 0-32-32zm112 112l43.9 0-11.6 32.4-32.4-32.4zM.1 69.8l0 170.2 92 0-60 240 160 0 32-128 58.2 0-282.2-282.2z"]
};
var faArrowUpLongToLine = {
  prefix: 'fass',
  iconName: 'arrow-up-long-to-line',
  icon: [384, 512, [], "e6bd", "M41.6 201.4L19 224 64.3 269.3c6.6-6.6 38.6-38.6 96-96l0 402.7 64 0 0-402.7c57.4 57.4 89.4 89.4 96 96l45.3-45.3-22.6-22.6-128-128-22.6-22.6-22.6 22.6-128 128zM64.3-64l-32 0 0 64 320 0 0-64-288 0z"]
};
var faCameraWebSlash = {
  prefix: 'fass',
  iconName: 'camera-web-slash',
  icon: [576, 512, ["webcam-slash"], "f833", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-113.8-113.8c39.9-40.5 64.6-96 64.6-157.4 0-123.7-100.3-224-224-224-61.3 0-116.9 24.7-157.4 64.6L49.3-16.9zM176 109.8c28.9-28.4 68.4-45.8 112.1-45.8 88.4 0 160 71.6 160 160 0 43.7-17.5 83.2-45.8 112.1l-33.9-33.9c19.7-20.2 31.8-47.8 31.8-78.2 0-61.9-50.1-112-112-112-30.4 0-58 12.1-78.2 31.8L176 109.8zM312.5 382.2c-7.9 1.2-16.1 1.8-24.3 1.8-88.4 0-160-71.6-160-160 0-8.3 .6-16.4 1.8-24.3L77.6 147.3c-8.7 23.9-13.5 49.8-13.5 76.7 0 115.6 87.6 210.8 200 222.7l0 33.3-104 0 0 48 256 0 0-42.2-5.8-5.8-98.2 0 0-33.3c18.3-2 36-6.1 52.7-12.2l-52.4-52.4z"]
};
var faWebcamSlash = faCameraWebSlash;
var faObjectsColumn = {
  prefix: 'fass',
  iconName: 'objects-column',
  icon: [448, 512, [], "e3c1", "M192 32l-192 0 0 256 192 0 0-256zM448 224l-192 0 0 256 192 0 0-256zM0 352l0 128 192 0 0-128-192 0zM448 32l-192 0 0 128 192 0 0-128z"]
};
var faTowerBroadcast = {
  prefix: 'fass',
  iconName: 'tower-broadcast',
  icon: [576, 512, ["broadcast-tower"], "f519", "M108.8 294.4l-41.9 24C34.8 273.8 16 219.1 16 160S34.8 46.2 66.8 1.6l41.9 24C80.7 63 64 109.6 64 160s16.7 97 44.8 134.4zM382.7 73.9l42.4-24.2C449.4 79.8 464 118.2 464 160s-14.6 80.2-38.9 110.4l-42.4-24.2c20.7-22.7 33.3-53 33.3-86.1s-12.6-63.4-33.3-86.1zM512 160c0-50.4-16.7-97-44.8-134.4l41.9-24C541.2 46.2 560 100.9 560 160s-18.8 113.8-50.8 158.4l-41.9-24C495.3 257 512 210.4 512 160zm-352 0c0 33.2 12.6 63.4 33.3 86.1l-42.4 24.2C126.6 240.2 112 201.8 112 160s14.6-80.2 38.9-110.4l42.4 24.2C172.6 96.6 160 126.8 160 160zm192 0c0 23.7-12.9 44.4-32 55.4l0 296.6-64 0 0-296.6c-19.1-11.1-32-31.7-32-55.4 0-35.3 28.7-64 64-64s64 28.7 64 64z"]
};
var faBroadcastTower = faTowerBroadcast;
var faTurkey = {
  prefix: 'fass',
  iconName: 'turkey',
  icon: [576, 512, [], "f725", "M416 48c0 15.1 7 28.7 18 37.5L398.4 121C365 105 327.6 96 288 96 146.6 96 32 210.6 32 352l0 64c0 53 43 96 96 96l320 0c53 0 96-43 96-96l0-64c0-55.9-17.9-107.6-48.3-149.7L464 233.9 464 272c0 88.4-71.6 160-160 160S144 360.4 144 272l48 0c0 61.9 50.1 112 112 112 38 0 71.6-18.9 91.8-47.9 12.7-18.2 20.2-40.3 20.2-64.1l0-55.4 74.5-74.5c8.8 11 22.3 18 37.5 18 26.5 0 48-21.5 48-48s-21.5-48-48-48c-7.4 0-14.4 1.7-20.7 4.7 3-6.3 4.7-13.3 4.7-20.7 0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faSword = {
  prefix: 'fass',
  iconName: 'sword',
  icon: [576, 512, [128481], "f71c", "M464-16l-262.1 262.1 96 96 262.1-262.1 0-96-96 0zM0 448l96 96 32-32 0-48 48-48 112 48 32-32-208-208-32 32 48 112-48 48-48 0-32 32z"]
};
var faHeadSideGoggles = {
  prefix: 'fass',
  iconName: 'head-side-goggles',
  icon: [512, 512, ["head-vr"], "f6ea", "M496 272l-160 0c-53.7 0-99.7-33.1-118.7-80l-215 0C.8 202.4 0 213.1 0 224 0 285 24.4 340.4 64 380.8l0 131.2 256 0 0-64 112 0 0-128 64 0 0-48zM312.5 18.2C285.4 6.5 255.4 0 224 0 147.9 0 80.6 38 40.1 96l177.2 0c16.2-39.9 51.8-69.8 95.2-77.8zM336 64c-44.2 0-80 35.8-80 80s35.8 80 80 80l176 0 0-160-176 0z"]
};
var faHeadVr = faHeadSideGoggles;
var faMinimize = {
  prefix: 'fass',
  iconName: 'minimize',
  icon: [512, 512, ["compress-arrows-alt"], "f78c", "M88 144l-80 80 216 0 0-216-80 80-88-88-56 56 88 88zm416 80l-80-80 88-88-56-56-88 88-80-80 0 216 216 0zM368 424l88 88 56-56-88-88 80-80-216 0 0 216 80-80zM8 288l80 80-88 88 56 56 88-88 80 80 0-216-216 0z"]
};
var faCompressArrowsAlt = faMinimize;
var faArrowRightToCity = {
  prefix: 'fass',
  iconName: 'arrow-right-to-city',
  icon: [640, 512, [], "e4b3", "M288 0l192 0 0 96 48 0 0-96 48 0 0 96 64 0 0 416-352 0 0-512zm64 96l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zm224-96l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zM225 239l17 17c-2.1 2.1-31.8 31.8-89 89l-17 17-33.9-33.9c9-9 25-25 48-48l-126.1 0 0-48 126.1 0c-23-23-39-39-48-48L136 150.1c2.1 2.1 31.8 31.8 89 89z"]
};
var faLaptopMedical = {
  prefix: 'fass',
  iconName: 'laptop-medical',
  icon: [640, 512, [], "f812", "M64 32l512 0 0 304-64 0 0-240-384 0 0 240-64 0 0-304zM0 424l0-40 640 0 0 40-56 56-528 0-56-56zM288 144l64 0 0 56 56 0 0 64-56 0 0 56-64 0 0-56-56 0 0-64 56 0 0-56z"]
};
var faBreadSlice = {
  prefix: 'fass',
  iconName: 'bread-slice',
  icon: [512, 512, [], "f7ec", "M64 256c-35.3 0-64-28.7-64-64 0-216.5 512-216.5 512 0 0 35.3-28.7 64-64 64l0 224-384 0 0-224z"]
};
var faSpiderWeb = {
  prefix: 'fass',
  iconName: 'spider-web',
  icon: [576, 512, [128376], "f719", "M142.5 .1l23.1 4.3 122.8 23 122.8-23 23.1-4.3 8.3 22 46.3 123.6 77 92.4 14.9 17.9-14.9 17.9-77 92.4-46.3 123.6-8.3 22-23.1-4.3-122.8-23-122.8 23-23.1 4.3-8.3-22-46.3-123.6-77-92.4-14.9-17.9 14.9-17.9 77-92.4 46.3-123.6 8.3-22zm25.1 92.7l-28.9 77-1.7 4.4-3 3.6-45.1 54.1 44.7 0 34.8-39.8 21.4-60.6-22.2-38.8zm42.1-23.1l21.5 37.5 57.4 16.6 57.4-16.6 21.5-37.5-73.6 13.8-5.2 1-5.2-1-73.6-13.8zM409.3 92.8l-22.2 38.8 21.4 60.6 34.8 39.8 44.7 0-45.1-54.1-3-3.6-1.7-4.4-28.9-77zM488 280l-44.7 0-34.7 39.6-20.9 61.7 21.6 37.9 28.9-77 1.7-4.4 3-3.6 45.1-54.1zM367.3 442.3l-19.6-34.2-59.7-19.8-56.9 16.5-21.5 37.5 73.6-13.8 5.2-1 5.2 1 73.6 13.8zM167.6 419.2l22.2-38.8-21.4-60.6-34.8-39.8-44.7 0 45.1 54.1 3 3.6 1.7 4.4 28.9 77zM197.3 280c8 9.1 12.4 14.1 13.2 15.1l1.5 4.3 9.1 25.9 25.9-45.3-49.8 0zm68 64.9c12.5-3.6 20.4-5.9 23.6-6.8 3.2 1.1 10.9 3.6 23.1 7.7l-23.6-41.3-23.1 40.5zm90.6-19.2l8.8-26 1.5-4.5 3.1-3.6 10.2-11.6-49.8 0 26.1 45.7zM379.6 232c-8-9.1-12.4-14.1-13.2-15.1l-1.5-4.4-9.1-25.9-25.9 45.3 49.8 0zm-68-64.9c-12.6 3.7-20.3 5.9-23.1 6.7-2.8-.8-10.5-3.1-23.1-6.7l23.1 40.5 23.1-40.5zm-90.4 19.5l-9.1 25.9-1.5 4.4c-.8 1-5.2 6-13.2 15.1l49.8 0-25.9-45.3z"]
};
var faUserNurseHair = {
  prefix: 'fass',
  iconName: 'user-nurse-hair',
  icon: [448, 512, [], "e45d", "M224-32l128 56 0 120c0 70.7-57.3 128-128 128S96 214.7 96 144L96 24 224-32zm0 256c44.2 0 80-35.8 80-80l0-16-37.3 0-42.7 32-78.4 0c7.4 36.5 39.7 64 78.4 64zm-64 96l64 64 64-64 80 0 64 192-416 0 64-192 80 0zM208 8l0 24-24 0 0 32 24 0 0 24 32 0 0-24 24 0 0-32-24 0 0-24-32 0z"]
};
var faGlobe = {
  prefix: 'fass',
  iconName: 'globe',
  icon: [512, 512, [127760], "f0ac", "M351.6 280c-3.9 62.3-22.3 121.2-45.3 165.5-13 25-26.6 43.7-38.3 55.4-5.4 5.4-9.3 8.2-11.6 9.7-2.3-1.5-6.2-4.3-11.6-9.7-11.7-11.7-25.3-30.4-38.3-55.4-23-44.3-41.5-103.2-45.3-165.5l190.5 0zM161.1 232c3.9-62.3 22.3-121.2 45.3-165.5 13-25 26.6-43.7 38.3-55.4 5.4-5.4 9.3-8.2 11.6-9.7 2.3 1.5 6.2 4.3 11.6 9.7 11.7 11.7 25.3 30.4 38.3 55.4 23 44.3 41.5 103.2 45.3 165.5l-190.5 0zm-48.1 0L1.5 232C11.3 126.4 85.2 39.5 183.9 10.4 148.8 62.5 117.9 144 113.1 232zM1.5 280l111.6 0c4.9 88 35.7 169.5 70.9 221.6-98.7-29.1-172.6-116-182.4-221.6zm398.2 0l111.6 0c-9.8 105.6-83.7 192.5-182.4 221.6 35.2-52.1 66-133.6 70.9-221.6zm111.6-48l-111.6 0c-4.9-88-35.7-169.5-70.9-221.6 98.7 29.1 172.6 116 182.4 221.6z"]
};
var faDiceD12 = {
  prefix: 'fass',
  iconName: 'dice-d12',
  icon: [512, 512, [], "f6ce", "M443.4 68.6L512 187.4 512 324.6 443.4 443.4 324.6 512 187.4 512 68.6 443.4 0 324.6 0 187.4 68.6 68.6 187.4 0 324.6 0 443.4 68.6zM113.8 107.1l122.2 50.3 0 85.4-88.6 38-86.6-72.2-4.8-4 0 52.1 69.9 58.3 24.7 111.1 47 27.2-2.1-9.6-28.4-127.8 88.9-38.1 88.8 38.1-28.4 127.8-2.2 9.6 47-27.2 24.7-111.1 70-58.3 0-52.1-4.8 4-86.6 72.2-88.6-38 0-85.4 122.1-50.3-43.8-25.2-98.4 40.5-98.4-40.5-43.8 25.3z"]
};
var faLocationDotSlash = {
  prefix: 'fass',
  iconName: 'location-dot-slash',
  icon: [576, 512, ["map-marker-alt-slash"], "f605", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-138.5-138.5c32.1-53.8 57.3-113.4 57.3-168.1 0-104.1-86-188.6-192-188.6-61 0-115.3 27.9-150.5 71.5L49.3-16.9zM230.4 164.3c10.3-21.5 32.3-36.3 57.7-36.3 35.3 0 64 28.7 64 64 0 25.4-14.8 47.4-36.3 57.7l-85.4-85.4zm137 272.9L97.4 167.1c-.8 7.1-1.2 14.2-1.2 21.5 0 150.9 192 339.4 192 339.4s37.5-36.8 79.3-90.9z"]
};
var faMapMarkerAltSlash = faLocationDotSlash;
var faFolderMinus = {
  prefix: 'fass',
  iconName: 'folder-minus',
  icon: [512, 512, [], "f65d", "M512 448l-512 0 0-416 224 0 64 48 224 0 0 368zM184 240l-24 0 0 48 192 0 0-48-168 0z"]
};
var faMaskFace = {
  prefix: 'fass',
  iconName: 'mask-face',
  icon: [640, 512, [], "e1d7", "M288 64l-9.7 0-8.1 5.4-87.9 58.6-182.3 0 0 251.1 26.7 4.5 178.1 29.7c33 22 72.6 34.7 115.1 34.7s82.2-12.8 115.1-34.7l178.1-29.7 26.7-4.5 0-251.1-182.3 0-87.9-58.6-8.1-5.4-73.7 0zM135.9 336.9l-71.9-12 0-132.9 48 0 0 48c0 35 8.6 67.9 23.9 96.9zm440.1-12l-71.9 12C519.4 307.9 528 275 528 240l0-48 48 0 0 132.9zM192 208l256 0 0 48-256 0 0-48zm56 80l168 0 0 48-192 0 0-48 24 0z"]
};
var faBong = {
  prefix: 'fass',
  iconName: 'bong',
  icon: [576, 512, [], "f55c", "M224.5 273.1c-19.5 11.3-35.7 27.5-46.9 46.9l221.8 0c-11.2-19.4-27.4-35.6-46.9-46.9l-32-18.5 0-190.6-64 0 0 190.6-32 18.5zm228.6 12.2c17.3 28.9 27.3 62.6 27.3 98.8 0 49.2-18.5 94-48.9 128l-286.2 0c-30.4-34-48.9-78.8-48.9-128 0-71.1 38.6-133.1 96-166.3l0-153.7-32 0 0-64 256 0 0 64-32 0 0 153.7c14.2 8.2 27.2 18.2 38.8 29.6L462.5 208c-3-3-11-11-24-24l33.9-33.9c68.3 68.3 70.1 70.1 81.9 81.9l-33.9 33.9c-13-13-21-21-24-24l-43.3 43.3z"]
};
var faCupTogo = {
  prefix: 'fass',
  iconName: 'cup-togo',
  icon: [448, 512, ["coffee-togo"], "f6c5", "M64 0l320 0 32 64 32 0 0 64-448 0 0-64 32 0 32-64zM80 512l-32-336 352 0-32 336-288 0zM327 256l-206 0 14.5 160 176.9 0 14.5-160z"]
};
var faCoffeeTogo = faCupTogo;
var faRoadBridge = {
  prefix: 'fass',
  iconName: 'road-bridge',
  icon: [576, 512, [], "e563", "M32 32l208 0 0 64-24 0 0 64 24 0 0 129.3c-45.4 7.6-80 47.1-80 94.7l0 96-96 0 0-126c0-38.8-26.4-72.6-64-82l0-112 40 0 0-64-40 0 0-64 32 0zM88 96l0 64 80 0 0-64-80 0zM288 32l120 0 0 96 48 0 0-96 120 0 0 448-120 0 0-96-48 0 0 96-120 0 0-448zM456 192l-48 0 0 128 48 0 0-128z"]
};
var faArrowUp91 = {
  prefix: 'fass',
  iconName: 'arrow-up-9-1',
  icon: [576, 512, ["sort-numeric-up-alt"], "f887", "M182.9 41.4L160.3 18.7c-2.9 2.9-42.4 42.4-118.6 118.6L19 160 64.3 205.3c12-12 33.3-33.3 64-64l0 338.7 64 0 0-338.7c30.7 30.7 52 52 64 64L301.5 160c-2.9-2.9-42.4-42.4-118.6-118.6zM377.9 256l73.2 0 44.7-80.5c10.8-19.4 16.5-41.3 16.5-63.5 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 38.1 26.6 70 62.3 78l-36.6 66zM432.3 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-80 200l0 64 48 0 0 64-48 0 0 64 160 0 0-64-48 0 0-128-112 0z"]
};
var faSortNumericUpAlt = faArrowUp91;
var faMountainCity = {
  prefix: 'fass',
  iconName: 'mountain-city',
  icon: [640, 512, [], "e52e", "M256 0l192 0 0 96 48 0 0-96 48 0 0 96 64 0 0 416-104.4 0-14.1-24.2-135.2-231.8 29.8 0 0-64-64 0 0 5.3-54.5-93.5-9.5-16.2 0-87.6zm64 96l0 64 64 0 0-64-64 0zm160 96l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zM28 464L196.2 175.6 224 128 251.8 175.6 420 464 448 512 0 512 28 464zM224 223.3l-65.1 111.6 33.1 33.1 48-48 40.4 0-56.4-96.7z"]
};
var faArrowDown91 = {
  prefix: 'fass',
  iconName: 'arrow-down-9-1',
  icon: [576, 512, ["sort-numeric-desc", "sort-numeric-down-alt"], "f886", "M182.9 470.6l-22.6 22.6c-2.9-2.9-42.4-42.4-118.6-118.6L19 352 64.3 306.7c12 12 33.3 33.3 64 64l0-338.7 64 0 0 338.7c30.7-30.7 52-52 64-64L301.5 352c-2.9 2.9-42.4 42.4-118.6 118.6zM377.9 256l36.6-66c-35.6-8.1-62.3-39.9-62.3-78 0-44.2 35.8-80 80-80s80 35.8 80 80c0 22.2-5.7 44.1-16.5 63.5l-44.7 80.5-73.2 0zm54.4-120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-80 152l112 0 0 128 48 0 0 64-160 0 0-64 48 0 0-64-48 0 0-64z"]
};
var faSortNumericDesc = faArrowDown91;
var faSortNumericDownAlt = faArrowDown91;
var faMoneyBillsSimple = {
  prefix: 'fass',
  iconName: 'money-bills-simple',
  icon: [576, 512, ["money-bills-alt"], "e1f4", "M96 32l480 0 0 352-480 0 0-352zM416 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM48 152l0 280 432 0 0 48-480 0 0-352 48 0 0 24z"]
};
var faMoneyBillsAlt = faMoneyBillsSimple;
var faFaceGrinWide = {
  prefix: 'fass',
  iconName: 'face-grin-wide',
  icon: [512, 512, [128515, "grin-alt"], "f581", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-184c58.2 0 112.4-10.6 157.7-28.7-13 75.4-78.6 132.7-157.7 132.7S111.3 374.7 98.3 299.3C143.6 317.4 197.8 328 256 328zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64 14.3-64 32-64 32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64z"]
};
var faGrinAlt = faFaceGrinWide;
var faCirclePeruvianSoles = {
  prefix: 'fass',
  iconName: 'circle-peruvian-soles',
  icon: [512, 512, [], "e6f3", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm91.6-384l-70.7 247.4-2.5 8.6 49.9 0 70.7-247.4 2.5-8.6-49.9 0zM191.6 152c-35.1 0-63.6 28.5-63.6 63.6 0 30.3 21.4 56.4 51.1 62.3l16.4 3.3c7.3 1.5 12.5 7.8 12.5 15.3 0 8.6-7 15.6-15.6 15.6l-56.4 0 0 48 56.4 0c35.1 0 63.6-28.5 63.6-63.6 0-30.3-21.4-56.4-51.1-62.3l-16.4-3.3c-7.3-1.5-12.5-7.8-12.5-15.2 0-8.6 7-15.6 15.6-15.6l48.4 0 0-48-48.4 0z"]
};
var faArrowsToLine = {
  prefix: 'fass',
  iconName: 'arrows-to-line',
  icon: [384, 512, [], "e0a7", "M192 176l-120-128 88 0 0-80 64 0 0 80 88 0-120 128zm0 160l120 128-88 0 0 80-64 0 0-80-88 0 120-128zM32 224l352 0 0 64-384 0 0-64 32 0z"]
};
var faSquareRenminbi = {
  prefix: 'fass',
  iconName: 'square-renminbi',
  icon: [448, 512, [], "e73d", "M448 32l-448 0 0 448 448 0 0-448zM165.3 127.2c2.3 4 21.9 37.5 58.7 100.5 36.8-63 56.4-96.5 58.7-100.5l41.4 24.2c-1.9 3.3-22.3 38.2-61.1 104.6l41 0 0 32-56 0 0 32 56 0 0 32-56 0 0 48-48 0 0-48-56 0 0-32 56 0 0-32-56 0 0-32 41 0c-38.8-66.5-59.2-101.3-61.1-104.6l41.4-24.2z"]
};
var faTurntable = {
  prefix: 'fass',
  iconName: 'turntable',
  icon: [576, 512, [], "f8e4", "M576 32l-576 0 0 448 576 0 0-448zM224 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm288 16l0 182.1-2.9 5.4c-38.1 69.8-57.9 106.2-59.5 109.1l-42.1-23c2.1-3.8 20.9-38.4 56.6-103.7l0-169.9 48 0zM224 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCrab = {
  prefix: 'fass',
  iconName: 'crab',
  icon: [512, 512, [129408], "e3ff", "M128.5 0C57.8 0 .5 57.3 .5 128l0 79.4 13.9 6.4 85 39.2c-3.7 6-6.9 12.4-9.6 19l-37.5 0c-21.5-10.7-35.8-17.9-42.9-21.5L-5 279.2c6.6 3.3 22 11 46.3 23.2l3.4 1.7 36.8 0c-.7 5.2-1 10.6-1 16l0 9.8-21.1 7-3.6 1.2-2.7 2.7C28.4 365.5 13.9 379.9 9.8 384l22.6 22.6c4.5-4.5 18.1-18.1 40.6-40.6l28-9.3 30.7 30.7-40.4 13.5-3.6 1.2-2.7 2.7C60.4 429.5 45.9 443.9 41.8 448l22.6 22.6c4.5-4.5 18.1-18.1 40.6-40.6l52-17.3 15.7 15.7-36.6 21.9-7.8 4.7 0 57.1 32 0 0-38.9 41.8-25.1 108.5 0 41.8 25.1 0 38.9 32 0 0-57.1-7.8-4.7-36.6-21.9 15.7-15.7 52 17.3c22.6 22.6 36.1 36.1 40.6 40.6l22.6-22.6-43.3-43.3-2.7-2.7-3.6-1.2-40.4-13.5 30.7-30.7 28 9.3c22.6 22.6 36.1 36.1 40.6 40.6l22.6-22.6-43.3-43.3-2.7-2.7-3.6-1.2-21.1-7 0-9.8c0-5.4-.3-10.8-1-16l36.8 0 35.4-17.7 14.3-7.2-14.3-28.6c-7.2 3.6-21.5 10.7-42.9 21.5l-37.5 0c-2.7-6.6-5.9-13-9.6-19l85-39.2 13.9-6.4 0-79.4c0-70.7-57.3-128-128-128l-64 0 64 64-64 0c0 35.3 28.7 64 64 64l80 0 0 48.6-85.3 39.4c-16.9-12.2-37-20.3-58.7-23l0-65-32 0 0 64-64 0 0-64-32 0 0 65c-21.7 2.7-41.7 10.9-58.7 23l-85.3-39.4 0-48.6 80 0c35.3 0 64-28.7 64-64l-64 0 64-64-64 0z"]
};
var faAngel = {
  prefix: 'fass',
  iconName: 'angel',
  icon: [576, 512, [], "f779", "M391.7 85.5C407 75 416 62 416 48 416 12.7 358.7-16 288-16S160 12.7 160 48c0 14 9 27 24.3 37.5 3.8-9.2 8.7-17.8 14.7-25.5-4.5-3.7-7-7.8-7-12 0-17.7 43-32 96-32s96 14.3 96 32c0 4.2-2.5 8.3-7 12 5.9 7.8 10.9 16.3 14.7 25.5zM288 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM16 256l71.6 114.5-23.6 141.5 54.8 0 2.3-10.4 64-288 8.4-37.6 1.2 0-66.7-80-112 0 0 160zM512 512l-23.6-141.5 71.6-114.5 0-160-112 0-66.7 80 1.2 0 8.4 37.6 64 288 2.3 10.4 54.8 0zm-344 0l240 0-64-288-112 0-64 288z"]
};
var faLocationPen = {
  prefix: 'fass',
  iconName: 'location-pen',
  icon: [384, 512, ["map-marker-edit"], "f607", "M0 188.6C0 84.4 86 0 192 0S384 84.4 384 188.6C384 339.4 192 528 192 528S0 339.4 0 188.6zm115.2 29l-12.8 64 64-12.8 115.2-115.2-51.2-51.2-115.2 115.2z"]
};
var faMapMarkerEdit = faLocationPen;
var faTicketsPerforated = {
  prefix: 'fass',
  iconName: 'tickets-perforated',
  icon: [640, 512, [], "e63f", "M608 32l-512 0 0 352 512 0 0-128c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-128zM424 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM48 152l0-24-48 0 0 352 512 0 0-48-464 0 0-280z"]
};
var faSquareRupiah = {
  prefix: 'fass',
  iconName: 'square-rupiah',
  icon: [448, 512, [], "e712", "M448 32l-448 0 0 448 448 0 0-448zM120 144l48 0c39.8 0 72 32.2 72 72 0 26.9-14.7 50.3-36.5 62.6 14.8 44.3 23.7 71.2 26.8 80.5l-45.5 15.2C182 366 172.4 337.2 156 288l-12 0 0 80-48 0 0-224 24 0zm48 96c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0 48 24 0zm88-16l64 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-16 0 0 56-48 0 0-184zm48 80l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0 32z"]
};
var faTrashXmark = {
  prefix: 'fass',
  iconName: 'trash-xmark',
  icon: [448, 512, [], "e2b4", "M304-16l16 48 128 0 0 64-448 0 0-64 128 0 16-48 160 0zM32 144l384 0-24 368-336 0-24-368zM308.9 269.1l-33.9-33.9c-8.5 8.5-25.5 25.5-50.9 50.9-25.5-25.5-42.4-42.4-50.9-50.9l-33.9 33.9c8.5 8.5 25.5 25.5 50.9 50.9-25.5 25.5-42.4 42.4-50.9 50.9l33.9 33.9c8.5-8.5 25.5-25.5 50.9-50.9 25.5 25.5 42.4 42.4 50.9 50.9l33.9-33.9c-8.5-8.5-25.5-25.5-50.9-50.9 25.5-25.5 42.4-42.4 50.9-50.9z"]
};
var faRv = {
  prefix: 'fass',
  iconName: 'rv',
  icon: [576, 512, [], "f7be", "M192 0l160 0 0 32 224 0 0 128-272 0 0 304-67.3 0c-10.4 36.9-44.4 64-84.7 64-48.6 0-88-39.4-88-88l0-1.2-58.6-71.6-5.4-6.6 0-328.6 192 0 0-32zM352 208l142.4 0 9.5 10.7 64 72 8.1 9.1 0 164.2-51.3 0c-10.4 36.9-44.4 64-84.7 64-48.6 0-88-39.4-88-88l0-232zm113.6 64l-49.6 0 0 48 92.3 0-42.7-48zM152 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm328-40a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM224 160l-128 0 0 96 128 0 0-96z"]
};
var faFaceZany = {
  prefix: 'fass',
  iconName: 'face-zany',
  icon: [512, 512, [], "e3a4", "M477.7 128c70.7 122.4 28.7 279-93.7 349.7-5.8 3.4-11.8 6.5-17.7 9.3 2.6-9 4.1-18.5 4.3-28.4l1.7-71c50.2-46.1 66.2-120.2 37.6-183.6L134.2 363.3c3.1 4.3 6.4 8.5 9.9 12.4l0 80.3c0 11.3 1.7 22.2 4.8 32.5-46.5-21.4-87-56.8-114.5-104.5-70.7-122.4-28.7-279 93.7-349.7S407.1 5.6 477.7 128zM160 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm144 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-48-96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 320c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64 48 0 0 24 32 0 0-24 48 0 0 64z"]
};
var faPoop = {
  prefix: 'fass',
  iconName: 'poop',
  icon: [512, 512, [], "f619", "M176 128c44.2 0 80-35.8 80-80 0-17.5-5.6-33.7-15.1-46.8 4.9-.8 10-1.2 15.1-1.2 53 0 96 43 96 96 0 11.2-1.9 22-5.5 32l5.5 0c35.3 0 64 28.7 64 64 0 19.1-8.4 36.3-21.7 48l13.7 0c39.8 0 72 32.2 72 72 0 25.6-13.4 48.2-33.6 60.9 38.1 12.7 65.6 48.7 65.6 91.1l0 48-512 0 0-48c0-42.4 27.5-78.4 65.6-91.1-20.2-12.8-33.6-35.3-33.6-60.9 0-39.8 32.2-72 72-72l13.7 0c-13.3-11.7-21.7-28.9-21.7-48 0-35.3 28.7-64 64-64l16 0z"]
};
var faBarsFilter = {
  prefix: 'fass',
  iconName: 'bars-filter',
  icon: [512, 512, [], "e0ad", "M0 64l512 0 0 64-512 0 0-64zM96 224l320 0 0 64-320 0 0-64zM320 384l0 64-128 0 0-64 128 0z"]
};
var faHouseChimneyHeart = {
  prefix: 'fass',
  iconName: 'house-chimney-heart',
  icon: [512, 512, [], "e1b2", "M464 272l48 0 0-48-48-45 0-131-96 0 0 41-112-105-256 240 0 48 48 0 0 240 416 0 0-240zM249.6 247.5l6.4 8.5 6.4-8.5c11.1-14.8 28.5-23.5 46.9-23.5 32.4 0 58.7 26.3 58.7 58.7l0 5.3c0 64-112 128-112 128S144 352 144 288l0-5.3c0-32.4 26.3-58.7 58.7-58.7 18.5 0 35.9 8.7 46.9 23.5z"]
};
var faBowlScoops = {
  prefix: 'fass',
  iconName: 'bowl-scoops',
  icon: [448, 512, [127813], "e3df", "M224 208c0-29 11-55.5 29.2-75.4 20.2-22.2 49.3-36.3 81.7-36.6l1.1 0c61.9 0 112 50.1 112 112l-224 0zM112 96l1.1 0c32.4 .3 61.5 14.4 81.7 36.6-12 22.5-18.8 48.1-18.8 75.4L0 208C0 146.1 50.1 96 112 96zM316.7 49.2C280.8 53.5 248.5 69.7 224 93.7 199.5 69.7 167.2 53.5 131.3 49.2 151.4 19.5 185.4 0 224 0s72.6 19.5 92.7 49.2zM0 288l0-32 448 0 0 32c0 70.7-57.3 128-128 128l-36.6 0 68.6 96-256 0 68.6-96-36.6 0C57.3 416 0 358.7 0 288z"]
};
var faDharmachakra = {
  prefix: 'fass',
  iconName: 'dharmachakra',
  icon: [512, 512, [9784], "f655", "M236.5 162l-4.9-64.1c-25.9 4-49.8 14.2-70 29l41.9 48.8c9.9-6.5 21.1-11.2 33.1-13.7zM288 0l-2.6 33.9c39.9 5.2 76.4 20.9 106.9 44.3l22.1-25.8 45.3 45.3-25.8 22.1c23.3 30.4 39 67 44.3 106.9l33.9-2.6 0 64-33.9-2.6c-5.2 39.9-20.9 76.4-44.3 106.9l25.8 22.1-45.3 45.3-22.1-25.8c-30.4 23.3-67 39-106.9 44.3l2.6 33.9-64 0 2.6-33.9c-39.9-5.2-76.4-20.9-106.9-44.3l-22.1 25.8-45.3-45.3 25.8-22.1c-23.3-30.4-39.1-67-44.3-106.9L0 288 0 224 33.9 226.6c5.2-39.9 20.9-76.4 44.3-106.9L52.4 97.6 97.6 52.4 119.8 78.2c30.4-23.3 67-39.1 106.9-44.3L224 0 288 0zM275.5 162c12 2.5 23.2 7.2 33.1 13.7l41.9-48.8c-20.2-14.8-44.1-25-70-29L275.5 162zm60.7 41.4c6.5 9.9 11.2 21.1 13.7 33.1l64.1-4.9c-4-25.9-14.2-49.8-29-70l-48.8 41.9zM350 275.5c-2.5 12-7.2 23.2-13.7 33.1l48.8 41.9c14.8-20.2 25-44.1 29-70L350 275.5zm-41.4 60.7c-9.9 6.5-21.1 11.2-33.1 13.7l4.9 64.1c25.9-4 49.8-14.2 70-29l-41.9-48.8zM236.5 350c-12-2.5-23.2-7.2-33.1-13.7l-41.9 48.8c20.2 14.8 44.1 25 70 29l4.9-64.1zm-60.7-41.4c-6.5-9.9-11.2-21.1-13.7-33.1l-64.1 4.9c4 25.9 14.2 49.8 29 70l48.8-41.9zM162 236.5c2.5-12 7.2-23.2 13.7-33.1l-48.8-41.9c-14.8 20.2-25 44.1-29 70l64.1 4.9zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faClockTwelveThirty = {
  prefix: 'fass',
  iconName: 'clock-twelve-thirty',
  icon: [512, 512, [], "e359", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-360l0 264-48 0 0-288 48 0 0 24z"]
};
var faBoxingGlove = {
  prefix: 'fass',
  iconName: 'boxing-glove',
  icon: [448, 512, [129354, "glove-boxing"], "f438", "M384 112l-128 0 0 48-144 0 0-32-48 0 0 80 192.4 0c3.4 37.5 30.2 68.1 65.7 77.2l23.2 6 12-46.5-23.3-6c-17.3-4.4-30-20.1-30-38.8l0-40 144 0 0 128-96 96 0 128-320 0 0-160-32-64 0-288 384 0 0 112zM228.9 367.3L192 391.9c-28-18.6-45.8-30.5-53.6-35.7l-22.2 33.3c10 6.7 23.3 15.5 39.7 26.4-16.4 10.9-29.6 19.8-39.7 26.4l22.2 33.3c7.7-5.1 25.6-17 53.6-35.7 28 18.7 45.8 30.6 53.6 35.7l22.2-33.3c-10-6.7-23.3-15.5-39.7-26.4 16.4-10.9 29.6-19.8 39.7-26.4l-22.2-33.3-16.7 11.1z"]
};
var faGloveBoxing = faBoxingGlove;
var faJeansStraight = {
  prefix: 'fass',
  iconName: 'jeans-straight',
  icon: [448, 512, [], "e6d3", "M446 0L-2 0 1.5 56 442.5 56 446 0zM324.4 96l-76.3 0 0 288-2.1 0 0 128 168 0 20.2-324-10.2 0c-52.5 0-95.6-40.5-99.7-92zm40.2 0c3.9 29.4 29 52 59.5 52l12.7 0 3.3-52-75.4 0zM200.1 96l-76.3 0c-4.1 51.5-47.1 92-99.7 92l-14.3 0 20.3 324 168 0 0-320 2.1 0 0-96zM4 96l3.2 52 16.8 0c30.4 0 55.6-22.6 59.5-52L4 96z"]
};
var faSpeaker = {
  prefix: 'fass',
  iconName: 'speaker',
  icon: [384, 512, [], "f8df", "M0 0L384 0 384 512 0 512 0 0zM304 336a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM192 272a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faDiceD10 = {
  prefix: 'fass',
  iconName: 'dice-d10',
  icon: [576, 512, [], "f6cd", "M560 288L288 544 16 288 288-32 560 288zM270.6 86.2l-98.9 174.9-75.7 6.9-13.9 16.4 24.2 22.8 72.8-6.6 88.8 54.7 0 104 20 18.8 20-18.8 0-104 88.8-54.7 72.7 6.6 24.3-22.8-13.9-16.4-75.7-6.9-98.8-174.9-17.4-30.8-17.4 30.8zm94.5 186.9l-77.1 47.4-77.1-47.4 77.1-136.4 77.1 136.4z"]
};
var faRam = {
  prefix: 'fass',
  iconName: 'ram',
  icon: [640, 512, [128015], "f70a", "M336 64l0 32 48 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32-10.3 10.3c-42.3 18.1-68 29.2-77.2 33.1l18.9 44.1c16-6.8 28.2-12.1 36.6-15.7l0 152.2 192 0 0-152.2c8.4 3.6 20.6 8.8 36.6 15.7l18.9-44.1c-9.2-3.9-34.9-15-77.2-33.1L544 96 544 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 48 0 0-32c0-35.3-28.7-64-64-64s-64 28.7-64 64l-32 0c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-49.5 58.6l30.8-13.2c-8-26.3-32.4-45.4-61.3-45.4-19.2 0-36.5 8.5-48.2 21.9-10.9-8.7-24.8-13.9-39.8-13.9-30.1 0-55.3 20.8-62.2 48.8-3.2-.5-6.5-.8-9.8-.8-35.3 0-64 28.7-64 64 0 5.3 .7 10.5 1.9 15.5-20.2 10.8-33.9 32-33.9 56.5s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64 .5 0 1 0 1.5 0l22.5 120 88 0 0-85.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7l0 85.7 88 0 22.5-120c.5 0 1 0 1.5 0 26.9 0 49.9-16.5 59.3-40l-123.3 0 0-135.6-21.4 9.2-44.1-102.9zM464 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faBatteryQuarter = {
  prefix: 'fass',
  iconName: 'battery-quarter',
  icon: [640, 512, ["battery-2"], "f243", "M544 128l0 256-448 0 0-256 448 0zM96 64l-64 0 0 384 576 0 0-128 32 0 0-128-32 0 0-128-512 0zM256 176l-112 0 0 160 112 0 0-160z"]
};
var faBattery2 = faBatteryQuarter;
var faBasketShoppingSimple = {
  prefix: 'fass',
  iconName: 'basket-shopping-simple',
  icon: [576, 512, ["shopping-basket-alt"], "e0af", "M305.4 7.5l-17.4-18.4-17.4 18.4-144 152-.5 .5-110.1 0 0 64 23.1 0 56.9 256 384 0 56.9-256 23.1 0 0-64-110.1 0-.5-.5-144-152zM383.8 160L192.2 160 288 58.9 383.8 160zM128 264a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm296-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faShoppingBasketAlt = faBasketShoppingSimple;
var faMonitorWaveform = {
  prefix: 'fass',
  iconName: 'monitor-waveform',
  icon: [512, 512, ["monitor-heart-rate"], "f611", "M512 64L0 64 0 240 157.6 240c1.6 2.6 12.4 20.7 32.5 54.2 47.1-94.2 73.8-147.6 80-160 11.9 19.8 33.1 55.1 63.5 105.8l82.4 0 0 48-109.6 0c-1.6-2.6-12.4-20.7-32.5-54.2-47.1 94.2-73.8 147.6-80 160-11.9-19.8-33.1-55.1-63.5-105.8L0 288 0 448 512 448 512 64z"]
};
var faMonitorHeartRate = faMonitorWaveform;
var faCommentWaveform = {
  prefix: 'fass',
  iconName: 'comment-waveform',
  icon: [640, 512, [], "e6dd", "M304 472l0 7.5c-32.5-1.9-63.3-9.4-91.3-21.6L64 512 119.7 389.5C84.8 348.5 64 296.5 64 240 64 107.5 178.6 0 320 0S576 107.5 576 240c0 10.8-.8 21.5-2.3 32l-45.7 0 0-32-144 0 0 48-80 0 0 184zM480 312l0 232-48 0 0-256 48 0 0 24zm80 32l0 168-48 0 0-192 48 0 0 24zM400 360l0 136-48 0 0-160 48 0 0 24zm240 32l0 72-48 0 0-96 48 0 0 24z"]
};
var faAnkh = {
  prefix: 'fass',
  iconName: 'ankh',
  icon: [320, 512, [9765], "f644", "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1-5.9 6.2-11.8 11.8-17.4 16.7-5.6-4.9-11.5-10.5-17.4-16.7-25.9-27.5-46.6-62.6-46.6-104.1zM160 0C89.3 0 32 57.3 32 128 32 180.4 53.5 223.5 78.8 256l-78.8 0 0 64 128 0 0 192 64 0 0-192 128 0 0-64-78.8 0C266.5 223.5 288 180.4 288 128 288 57.3 230.7 0 160 0z"]
};
var faDiamond = {
  prefix: 'fass',
  iconName: 'diamond',
  icon: [576, 512, [9830], "f219", "M16 256L288-16 560 256 288 528 16 256z"]
};
var faSubscript = {
  prefix: 'fass',
  iconName: 'subscript',
  icon: [576, 512, [], "f12c", "M64 64l80.7 0 9.6 13.6 85.8 122.5 85.8-122.5 9.6-13.6 80.7 0 0 64-47.3 0-89.6 128 89.6 128 47.3 0 0 64-80.7 0-9.6-13.6-85.8-122.6-85.8 122.6-9.6 13.6-80.7 0 0-64 47.3 0 89.6-128-89.6-128-47.3 0 0-64zM448 288l96 0 0 160 32 0 0 64-128 0 0-64 32 0 0-96-32 0 0-64z"]
};
var faSquareRight = {
  prefix: 'fass',
  iconName: 'square-right',
  icon: [448, 512, [10145, "arrow-alt-square-right"], "f352", "M448 480l0-448-448 0 0 448 448 0zM224 128l8 0 128 128-128 128-8 0 0-80-128 0 0-96 128 0 0-80z"]
};
var faArrowAltSquareRight = faSquareRight;
var faCircleNaira = {
  prefix: 'fass',
  iconName: 'circle-naira',
  icon: [512, 512, [], "e749", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM184 128l-24 0 0 128-32 0 0 32 32 0 0 96 48 0 0-96 39.5 0 52 84.6 7 11.4 45.4 0 0-96 32 0 0-32-32 0 0-128-48 0 0 128-19.8 0-71.7-116.6-7-11.4-21.4 0zm43.8 128l-19.8 0 0-32.2 19.8 32.2z"]
};
var faComputerClassic = {
  prefix: 'fass',
  iconName: 'computer-classic',
  icon: [448, 512, [], "f8b1", "M0 0L448 0 448 416 0 416 0 0zM32 512l0-48 384 0 0 48-384 0zM384 64l-320 0 0 192 320 0 0-192zM88 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm136-48l0 48 160 0 0-48-160 0z"]
};
var faRupeeSign = {
  prefix: 'fass',
  iconName: 'rupee-sign',
  icon: [448, 512, [8360, "rupee"], "f156", "M0 32l112 0c79.5 0 144 64.5 144 144 0 54.3-30 101.5-74.4 126.1 32.7 108.8 49.4 164.6 50.2 167.4l-61.3 18.4c-.8-2.6-17.6-58.7-50.4-168.1-2.7 .1-5.4 .2-8.1 .2l-48 0 0 160-64 0 0-448zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0 0 160zm285.1-32l66.9 0 0 64-66.9 0c-7.2 0-13.1 5.9-13.1 13.1 0 5.7 3.7 10.7 9.1 12.5l49.4 15.9c31.9 10.3 53.5 39.9 53.5 73.4 0 42.6-34.5 77.1-77.1 77.1l-82.9 0 0-64 82.9 0c7.2 0 13.1-5.9 13.1-13.1 0-5.7-3.7-10.7-9.1-12.5l-49.4-15.9c-31.9-10.3-53.5-39.9-53.5-73.4 0-42.6 34.5-77.1 77.1-77.1z"]
};
var faRupee = faRupeeSign;
var faPersonRifle = {
  prefix: 'fass',
  iconName: 'person-rifle',
  icon: [512, 512, [], "e54e", "M432 0l-64 0 0 32 16 0 0 96-16 0 0 64-32 0 0 208 48 0 0 112 96 0-28-112 60 0 0-48-64 0 0-26.7 64-21.3 0-112-48 0 0 72-16 5.3 0-141.3-16 0 0-128zM160 208l-14 0-9.5 10.3-96 104-8.5 9.2 0 148.5 64 0 0-123.5 32-34.7 0 190.2 160 0 0-304-128 0zM280 88a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z"]
};
var faOctagonExclamation = {
  prefix: 'fass',
  iconName: 'octagon-exclamation',
  icon: [512, 512, [], "e204", "M512 160L512 352 352 512 160 512 0 352 0 160 160 0 352 0 512 160zM228 324l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0z"]
};
var faPipeCollar = {
  prefix: 'fass',
  iconName: 'pipe-collar',
  icon: [512, 512, [], "e437", "M512 256c0 46.2-12.3 89.6-33.7 127.1l17 16.4 .7 96.6-96.6-.7-16.4-17c-37.4 21.4-80.8 33.7-127.1 33.7-46.4 0-90-12.4-127.5-34l-16.6 17.3-95.9 0 0-95.9 17.5-16.8C12.2 345.3 0 302.1 0 256 0 209.8 12.3 166.4 33.7 128.9L16 111.9 16 16 111.9 16 128.9 33.7C166.4 12.3 209.8 0 256 0 302.1 0 345.3 12.2 382.6 33.5l16.8-17.5 95.9 0 0 95.9-17.3 16.6c21.6 37.5 34 81.1 34 127.5zM256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320z"]
};
var faBrightnessLow = {
  prefix: 'fass',
  iconName: 'brightness-low',
  icon: [448, 512, [], "e0ca", "M192 48l0 64 64 0 0-64-64 0zM96 82.7L50.7 128 96 173.3 141.3 128 96 82.7zM16 224l0 64 64 0 0-64-64 0zM141.3 384L96 338.7 50.7 384 96 429.3 141.3 384zM256 464l0-64-64 0 0 64 64 0zm50.7-80L352 429.3 397.3 384 352 338.7 306.7 384zM432 224l-64 0 0 64 64 0 0-64zm-34.7-96L352 82.7 306.7 128 352 173.3 397.3 128zM224 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faPlaneFlying = {
  prefix: 'fass',
  iconName: 'plane-flying',
  icon: [640, 512, [], "e7bb", "M401.3 176l-161.3-176-80 0 58.7 176-103.5 0-51.2-64-48 0 32 176 504 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-150.7 0zM64 448l-32 0 0 64 576 0 0-64-544 0z"]
};
var faFaceSmileRelaxed = {
  prefix: 'fass',
  iconName: 'face-smile-relaxed',
  icon: [512, 512, [], "e392", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-144c38.2 0 72-19.1 92.2-48.5l39.5 27.3C358.9 388.6 310.7 416 256 416s-102.9-27.4-131.8-69.2l39.5-27.3C184 348.9 217.8 368 256 368zM168 196c-11 0-20 9-20 20l0 16-40 0 0-16c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60l0 16-40 0 0-16c0-11-9-20-20-20l-16 0zm140 20l0 16-40 0 0-16c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60l0 16-40 0 0-16c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20z"]
};
var faImageCircleCheck = {
  prefix: 'fass',
  iconName: 'image-circle-check',
  icon: [640, 512, [], "e76d", "M512 32l-448 0 0 448 276 0c-13.7-19-24-40.7-30-64l-198 0 96-144 46.1 69.1 81.9-133.1 18.6 30.2c35.1-38.2 85.5-62.2 141.4-62.2 5.4 0 10.7 .2 16 .7L512 32zM192 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L417.4 368 440 345.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z"]
};
var faMessagesQuestion = {
  prefix: 'fass',
  iconName: 'messages-question',
  icon: [576, 512, [], "e1e7", "M384-32l-384 0 0 336 96 0 0 80 112-80 176 0 0-336zM192 374.4l0 89.6 176 0 112 80 0-80 96 0 0-336-144 0 0 224-208.6 0-31.4 22.4zM192 76c-14.4 0-26.1 11.7-26.1 26.1l-40 0C125.9 65.6 155.5 36 192 36s66.1 29.6 66.1 66.1c0 29.7-17.7 46.9-33.3 55.6-4.5 2.5-8.9 4.4-12.9 5.9l0 16.4-40 0 0-49.4c1.8-.2 3.6-.4 5.4-.6 9.7-1.1 19-2.1 27.9-7.1 7.5-4.2 12.9-10.1 12.9-20.8 0-14.4-11.7-26.1-26.1-26.1zM172 204l40 0 0 40-40 0 0-40z"]
};
var faD = {
  prefix: 'fass',
  iconName: 'd',
  icon: [384, 512, [100], "44", "M0 32l160 0c123.7 0 224 100.3 224 224S283.7 480 160 480L0 480 0 32zM64 96l0 320 96 0c88.4 0 160-71.6 160-160S248.4 96 160 96L64 96z"]
};
var faCircleFranc = {
  prefix: 'fass',
  iconName: 'circle-franc',
  icon: [512, 512, [], "e721", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM192 128l160 0 0 48-112 0 0 40 80 0 0 48-80 0 0 24 48 0 0 32-48 0 0 64-48 0 0-64-32 0 0-32 32 0 0-160z"]
};
var faUpToDottedLine = {
  prefix: 'fass',
  iconName: 'up-to-dotted-line',
  icon: [384, 512, [], "e457", "M0 0L0 64 64 64 64 0 0 0zM192 117.1l-192 202.9 128 0 0 192 128 0 0-192 128 0-192-202.9zM170.7 0l-64 0 0 64 64 0 0-64zm42.7 0l0 64 64 0 0-64-64 0zM384 0l-64 0 0 64 64 0 0-64z"]
};
var faKiwiFruit = {
  prefix: 'fass',
  iconName: 'kiwi-fruit',
  icon: [448, 512, [], "e30c", "M448 176c0 79.5-100.3 144-224 144S0 255.5 0 176 100.3 32 224 32 448 96.5 448 176zM224 64l-16 0 0 56 32 0 0-56-16 0zM64 176l0 16 64 0 0-32-64 0 0 16zm256 0l0 16 64 0 0-32-64 0 0 16zm-96 56l-16 0 0 56 32 0 0-56-16 0zM139.3 92.7L128 81.4 105.4 104c17.5 17.5 22.8 22.8 30.6 30.6L158.6 112c-8.1-8.1-14.5-14.5-19.3-19.3zm192 22.6L342.6 104 320 81.4c-17.5 17.5-22.8 22.8-30.6 30.6L312 134.6c8.1-8.1 14.5-14.5 19.3-19.3zm-184 136L158.6 240 136 217.4c-17.5 17.5-22.8 22.8-30.6 30.6L128 270.6c8.1-8.1 14.5-14.5 19.3-19.3zm176-22.6L312 217.4 289.4 240c17.5 17.5 22.8 22.8 30.6 30.6L342.6 248c-8.1-8.1-14.5-14.5-19.3-19.3zM280 176c0-13.3-25.1-24-56-24s-56 10.7-56 24 25.1 24 56 24 56-10.7 56-24zM224 480C102.4 480 3.4 383.1 .1 262.2 13.3 278.6 29.8 292.9 48.3 304.7 94.7 334.6 156.9 352 224 352s129.3-17.4 175.7-47.3c18.5-11.9 35-26.2 48.2-42.5-3.3 120.8-102.3 217.8-223.9 217.8z"]
};
var faGridRound = {
  prefix: 'fass',
  iconName: 'grid-round',
  icon: [448, 512, [], "e5da", "M112 88A56 56 0 1 1 0 88 56 56 0 1 1 112 88zm0 168a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM0 424a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM280 88a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM168 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM280 424a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM336 88a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM448 256a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM336 424a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z"]
};
var faStarship = {
  prefix: 'fass',
  iconName: 'starship',
  icon: [640, 512, [], "e039", "M0 64l0 64 55 0 78.6 88.5-37.6 7.5 0 64 37.6 7.5-78.6 88.5-55 0 0 64 224 0 0-64-94.1 0 67.3-75.8 25.9 5.2c-4.7-18.4-7.2-37.6-7.2-57.4s2.5-39.1 7.2-57.4l-25.9 5.2-67.3-75.8 94.1 0 0-64-224 0zM448 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 272a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm32-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faClockTwoThirty = {
  prefix: 'fass',
  iconName: 'clock-two-thirty',
  icon: [512, 512, [], "e35b", "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM232 392l0-148.8 10.7-7.1c76.7-51.1 115.3-76.9 116-77.3l26.6 39.9c-2.4 1.6-37.5 25-105.3 70.2l0 147.2-48 0 0-24z"]
};
var faSquareNfi = {
  prefix: 'fass',
  iconName: 'square-nfi',
  icon: [448, 512, [], "e576", "M448 32l-448 0 0 448 448 0 0-448zM72 160l23.6 0c.9 2.1 11.7 26.4 32.4 72.9l0-72.9 48 0 0 192-47.6 0-32.4-72.9 0 72.9-48 0 0-192 24 0zm136 0l128 0 0 48-80 0 0 32 64 0 0 48-64 0 0 64-48 0 0-192zm192 24l0 168-48 0 0-192 48 0 0 24z"]
};
var faDroneFront = {
  prefix: 'fass',
  iconName: 'drone-front',
  icon: [640, 512, ["drone-alt"], "f860", "M24 80l-24 0 0 48 120 0 0 125.3c3.4 2.2 19.1 11.9 47 29.4l-35.4 56.6-3.6 5.8 0 102.9 48 0 0-89.1 31.7-50.8 51.6 32.2 5.8 3.6 109.8 0 5.8-3.6 51.6-32.2 31.7 50.8 0 89.1 48 0 0-102.9-3.6-5.8-35.4-56.6c27.9-17.4 43.6-27.2 47-29.4l0-125.3 120 0 0-48-288 0 0 48 120 0 0 64-304 0 0-64 120 0 0-48-264 0z"]
};
var faDroneAlt = faDroneFront;
var faTeeth = {
  prefix: 'fass',
  iconName: 'teeth',
  icon: [512, 512, [], "f62e", "M0 32l512 0 0 448-512 0 0-448zM144 208l0 48 96 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48zm128 0l0 48 96 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48zM80 176c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm320 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zM48 336c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-64 0 0 32zm144 48c26.5 0 48-21.5 48-48l0-32-96 0 0 32c0 26.5 21.5 48 48 48zm128 0c26.5 0 48-21.5 48-48l0-32-96 0 0 32c0 26.5 21.5 48 48 48zm112-16c17.7 0 32-14.3 32-32l0-32-64 0 0 32c0 17.7 14.3 32 32 32z"]
};
var faMagnifyingGlassDollar = {
  prefix: 'fass',
  iconName: 'magnifying-glass-dollar',
  icon: [576, 512, ["search-dollar"], "f688", "M448.3 208c0 45.9-14.9 88.3-40 122.7L534.9 457.4 557.5 480 512.3 525.3 489.6 502.6 363 376c-34.4 25.2-76.8 40-122.7 40-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208zM264.3 96l-40 0 0 24c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5l-75.5 0 0 40 44 0 0 24 40 0 0-24.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l67.5 0 0-40-28 0 0-24z"]
};
var faSearchDollar = faMagnifyingGlassDollar;
var faDumpsterFire = {
  prefix: 'fass',
  iconName: 'dumpster-fire',
  icon: [640, 512, [], "f794", "M64 64L32 192 138.7 192 164.3 64 64 64zM296 192l0-128-82.7 0-25.6 128 108.3 0zm48 0l25.9 0c19-17.6 37.7-31.5 52.6-40.9l19.2-12-15-75.2-82.7 0 0 128zm230.7-5c2 1.7 4 3.3 5.9 5l27.4 0-32-128-100.3 0 21.9 109.6 14.4 14.4 29.1-29.1 33.7 28.1zM272 383.8c0-57 25.6-106.6 54-143.8l-267.8 0 6.2 37.3 32 192 1.8 10.7 64.9 0c-2.2-13.3-4.9-29.3-8-48l122.5 0c-3.7-15.5-5.6-31.6-5.6-48.2zM448 192c-42.7 26.7-128 102.4-128 192 0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-32 32-64-64zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96z"]
};
var faCircleHryvnia = {
  prefix: 'fass',
  iconName: 'circle-hryvnia',
  icon: [512, 512, [], "e6ef", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm16.8-393.3c42.1-5.3 79.2 27.5 79.2 69.9 0 6.6-.9 13.1-2.7 19.3l18.7 0 0 32-224 0 0-32 149 0c6.8-4 11-11.4 11-19.3 0-13.5-11.8-24-25.3-22.3-59.2 7.4-92.3 11.5-99.6 12.4l-6-47.6c7.2-.9 40.4-5.1 99.6-12.4zM276.6 272l91.4 0 0 32-148.9 0c-6.8 4.1-11.1 11.6-11.1 19.6 0 13.6 11.9 24.3 25.4 22.8 72.6-8.1 111.2-12.4 115.8-12.9l5.3 47.7c-4.6 .5-43.2 4.8-115.8 12.9-42 4.7-78.7-28.2-78.7-70.5 0-6.7 1-13.3 2.8-19.6l-18.8 0 0-32 132.6 0z"]
};
var faEggFried = {
  prefix: 'fass',
  iconName: 'egg-fried',
  icon: [512, 512, [], "f7fc", "M284.3 39.3c30.4 31.6 89.1 65.9 131.5 76.7 27.5 7 52.8 23.2 71 47.8 42.1 56.8 30.2 137-26.6 179.1-17.8 13.2-37.9 21.1-58.4 24-37.2 5.2-84.5 32.7-103.3 65.2-44.2 76.5-142 102.7-218.6 58.6S-22.7 348.5 21.5 272c24.8-42.9 38.7-105.9 43.1-155.2 2.6-29.7 15.6-58.7 38.8-81 51-49 132-47.4 181 3.6zM336 240a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-160 0l-32 0c0-44.2 35.8-80 80-80l0 32c-26.5 0-48 21.5-48 48z"]
};
var faLineHeight = {
  prefix: 'fass',
  iconName: 'line-height',
  icon: [576, 512, [], "f871", "M150.9 41.4L128.3 18.7c-8.2 8.2-37.1 37.1-86.6 86.6L19 128 64.3 173.3c17.3-17.3 28-28 32-32l0 229.5c-4-4-14.7-14.7-32-32L19 384 105.6 470.6 128.3 493.3c8.2-8.2 37.1-37.1 86.6-86.6l22.6-22.6-45.3-45.3c-17.3 17.3-28 28-32 32l0-229.5c4 4 14.7 14.7 32 32L237.5 128c-8.2-8.2-37.1-37.1-86.6-86.6zM544.3 64l-256 0 0 64 256 0 0-64zm0 160l-256 0 0 64 256 0 0-64zm-256 160l0 64 256 0 0-64-256 0z"]
};
var faArrowRightFromDottedLine = {
  prefix: 'fass',
  iconName: 'arrow-right-from-dotted-line',
  icon: [576, 512, [], "e6bb", "M557.5 256l-22.6-22.6-128-128-22.6-22.6-45.3 45.3c6.6 6.6 38.6 38.6 96 96l-274.7 0 0 64 274.7 0-96 96 45.3 45.3 173.3-173.3zM96.3 448l0-64-64 0 0 64 64 0zm0-170.7l-64 0 0 64 64 0 0-64zm0-42.7l0-64-64 0 0 64 64 0zM96.3 64l-64 0 0 64 64 0 0-64z"]
};
var faUpload = {
  prefix: 'fass',
  iconName: 'upload',
  icon: [448, 512, [], "f093", "M256 320l0 32-64 0 0-242.7c-30.7 30.7-52 52-64 64L82.7 128c2.9-2.9 42.4-42.4 118.6-118.6L224-13.3c2.9 2.9 42.4 42.4 118.6 118.6l22.6 22.6-45.3 45.3-64-64 0 210.7zm48 80l0-80 144 0 0 160-448 0 0-160 144 0 0 80 160 0zm64 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faGingerbreadMan = {
  prefix: 'fass',
  iconName: 'gingerbread-man',
  icon: [448, 512, [], "f79d", "M308.7 192c26.6-23.5 43.3-57.8 43.3-96 0-70.7-57.3-128-128-128S96 25.3 96 96c0 38.2 16.8 72.5 43.3 96l-139.3 0 0 128 128 0-96 128 0 96 96 0 96-112 96 112 96 0 0-96-96-128 128 0 0-128-139.3 0zM152 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM272 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM200 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faFilterSlash = {
  prefix: 'fass',
  iconName: 'filter-slash',
  icon: [576, 512, [], "e17d", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-209.2-209.2 0-14 208-208-430 0-80.9-80.9zM224.1 293.8l0 122.2 128 128 0-122.2-128-128z"]
};
var faUserSlash = {
  prefix: 'fass',
  iconName: 'user-slash',
  icon: [576, 512, [62714, "user-alt-slash", "user-large-slash"], "f506", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-249.5-249.5c54.9-11 96.3-59.5 96.3-117.7 0-66.3-53.7-120-120-120-58.2 0-106.7 41.4-117.7 96.3L49.3-16.9zM234.3 304l-90.2 0-64 208 362.2 0-208-208z"]
};
var faUserAltSlash = faUserSlash;
var faUserLargeSlash = faUserSlash;
var faArrowLeft = {
  prefix: 'fass',
  iconName: 'arrow-left',
  icon: [576, 512, [8592], "f060", "M41.6 233.4l-22.6 22.6 22.6 22.6 160 160 22.6 22.6 45.3-45.3c-1.3-1.3-44-44-128-128l402.7 0 0-64-402.7 0c84-84 126.7-126.7 128-128l-45.3-45.3-22.6 22.6-160 160z"]
};
var faVialVirus = {
  prefix: 'fass',
  iconName: 'vial-virus',
  icon: [576, 512, [], "e597", "M64 0l288 0 0 64-32 0 0 122.2-.2-.2-101.8 101.8 24.2 24.2-34.2 0 0 144 34.2 0-24.2 24.2 25.9 25.9c-11.3 3.8-23.4 5.9-35.9 5.9-61.9 0-112-50.1-112-112l0-336-32 0 0-64zm96 64l0 128 96 0 0-128-96 0zM392 520c0-28.8-34.8-43.2-55.2-22.8l-17 17-33.9-33.9 17-17c20.4-20.4 5.9-55.2-22.9-55.2l-24 0 0-48 24.1 0c28.8 0 43.1-34.8 22.8-55.2l-17-17 33.9-33.9 17 17c20.4 20.4 55.2 6 55.2-22.8l0-24 48 0 0 24c0 28.8 34.8 43.2 55.2 22.9l17-17 33.9 33.9-17 17c-20.3 20.4-5.9 55.1 22.8 55.2l24.1 0 0 48-24 0c-28.8 0-43.2 34.8-22.8 55.2l16.8 16.8-33.9 33.9-16.8-16.8C474.8 476.8 440 491.2 440 520l0 24-48 0 0-24zm56-80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40-88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCheckDouble = {
  prefix: 'fass',
  iconName: 'check-double',
  icon: [448, 512, [], "f560", "M282.1 66.8L301 40.9 249.2 3.3 230.4 29.2 124.4 174.9 64.3 114.7 19 160c8.2 8.2 37.1 37.1 86.6 86.6l26.5 26.5 22-30.3 128-176zm128 136l18.8-25.9-51.8-37.6-18.8 25.9-170 233.7c-54.2-54.2-84.9-84.9-92.1-92.1L51 352c2.9 2.9 42.4 42.4 118.6 118.6l26.5 26.5 22-30.3 192-264z"]
};
var faSwords = {
  prefix: 'fass',
  iconName: 'swords',
  icon: [512, 512, [9876], "f71d", "M0 80L0 0 80 0 366.1 286.1 286.1 366.1 0 80zM304 480l-32-32 176-176 32 32-32 96 64 64-48 48-64-64-96 32zM112 320l30.1-30.1 80 80-30.1 30.1 48 48-32 32-96-32-64 64-48-48 64-64-32-96 32-32 48 48zM512 80l-142.1 142.1-80-80 142.1-142.1 80 0 0 80z"]
};
var faTransporter5 = {
  prefix: 'fass',
  iconName: 'transporter-5',
  icon: [640, 512, [], "e2a6", "M272-32l112 0 0 32-128 0 0-32 16 0zM240 96l176 0 0 32-192 0 0-32 16 0zM176 224l304 0 0 32-320 0 0-32 16 0zm64 128l176 0 0 32-192 0 0-32 16 0zM96 160l48 16-48 16-16 48-16-48-48-16 48-16 16-48 16 48zM624 48l-48 16-16 48-16-48-48-16 48-16 16-48 16 48 48 16zM480 496l0 48-320 0 0-48 320 0z"]
};
var faSquareSliders = {
  prefix: 'fass',
  iconName: 'square-sliders',
  icon: [448, 512, ["sliders-h-square"], "f3f0", "M0 32l0 448 448 0 0-448-448 0zM64 200l0-48 64 0 0-56 48 0 0 56 208 0 0 48-208 0 0 56-48 0 0-56-64 0zM88 360l-24 0 0-48 208 0 0-56 48 0 0 56 64 0 0 48-64 0 0 56-48 0 0-56-184 0z"]
};
var faSlidersHSquare = faSquareSliders;
var faCircleSortUp = {
  prefix: 'fass',
  iconName: 'circle-sort-up',
  icon: [512, 512, ["sort-circle-up"], "e032", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm136-32l240 0-120-128-120 128zm87.1 156.9L256 416c12.9-13.8 52.9-56.4 120-128l-65.8 0-54.2 57.8-54.2-57.8-65.8 0 87.1 92.9z"]
};
var faSortCircleUp = faCircleSortUp;
var faPaw = {
  prefix: 'fass',
  iconName: 'paw',
  icon: [512, 512, [], "f1b0", "M256 224c64 0 192 80 192 256L256 432 64 480c0-176 128-256 192-256zM21.8 165.3c24.5-14 59.7 .9 78.5 33.3s14.3 70.1-10.2 84.2-59.7-.9-78.5-33.3-14.3-70.1 10.2-84.2zm389.8 33.3c18.9-32.4 54-47.3 78.5-33.3s29.1 51.7 10.2 84.2-54 47.3-78.5 33.3-29.1-51.7-10.2-84.2zM150.1 34.3c32.3-10.6 70.1 15.6 84.4 58.5s-.3 86.2-32.6 96.8-70.1-15.6-84.4-58.5 .3-86.2 32.6-96.8zM277.5 92.8c14.3-42.9 52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8-52.1 69.1-84.4 58.5-46.9-53.9-32.6-96.8z"]
};
var faHelmetSafety = {
  prefix: 'fass',
  iconName: 'helmet-safety',
  icon: [576, 512, ["hard-hat", "hat-hard"], "f807", "M352 264l0-232-128 0 0 256-48 0 0-209.9C90 109.8 32 191.8 32 288l0 64 512 0 0-64c-1-95.2-58.4-177.7-144-209.8l0 209.8-48 0 0-24zM576 400l-576 0 0 80 576 0 0-80z"]
};
var faHardHat = faHelmetSafety;
var faHatHard = faHelmetSafety;
var faUserCircleMinus = {
  prefix: 'fass',
  iconName: 'user-circle-minus',
  icon: [576, 512, [], "e7aa", "M224 8a120 120 0 1 1 0 240 120 120 0 1 1 0-240zm16 392c0 41.8 13.4 80.5 36 112l-260 0 64-208 185.7 0c-16.3 28.2-25.7 61-25.7 96zm48 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16l0-32-160 0 0 32 160 0z"]
};
var faE = {
  prefix: 'fass',
  iconName: 'e',
  icon: [320, 512, [101], "45", "M32 32l-32 0 0 448 320 0 0-64-256 0 0-128 192 0 0-64-192 0 0-128 256 0 0-64-288 0z"]
};
var faFaceLaughSquint = {
  prefix: 'fass',
  iconName: 'face-laugh-squint',
  icon: [512, 512, ["laugh-squint"], "f59b", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-80c-77.4 0-142-55-156.8-128l313.6 0C398 377 333.4 432 256 432zM127.2 129.7l95.6 48 9.2 4.6 0 20.2-10.2 4.3-95.6 40-14.7-28.3 44.2-27.6-45.3-34 16.8-27.1zm162 48l95.6-48 16.8 27.1-45.3 34 44.2 27.6-14.7 28.3-95.6-40-10.2-4.3 0-20.2 9.2-4.6z"]
};
var faLaughSquint = faFaceLaughSquint;
var faPear = {
  prefix: 'fass',
  iconName: 'pear',
  icon: [512, 512, [], "e20c", "M510.7 35.2c-8.2 8.2-25.8 25.8-52.9 52.8 33.9 49.8 28.8 118.3-15.4 162.5l-58.8 58.8c.2 3.5 .3 7.1 .3 10.7 0 106-86 192-192 192S0 426 0 320 86 128 192 128c3.6 0 7.2 .1 10.7 .3l58.8-58.8C305.7 25.3 374.1 20.2 423.9 54.1 451 27 468.6 9.4 476.8 1.3l33.9 33.9zM272 312c0 48.6-39.4 88-88 88l0 48c75.1 0 136-60.9 136-136l-48 0z"]
};
var faFileTex = {
  prefix: 'fass',
  iconName: 'file-tex',
  icon: [576, 512, [], "e7fd", "M324 420l-32 0 0 128-40 0 0-128-32 0 0-40 104 0 0 40zm128 0l-64 0 0 24 48 0 0 40-48 0 0 24 64 0 0 40-104 0 0-168 104 0 0 40zm64-20c0 6.5 1.9 12.8 5.5 18.2l6.5 9.7 6.5-9.7c3.6-5.4 5.5-11.7 5.5-18.2l0-20 40 0 0 20c0 14.4-4.2 28.4-12.2 40.4L552 464 567.8 487.6c8 12 12.2 26 12.2 40.4l0 20-40 0 0-20c0-6.5-1.9-12.8-5.5-18.2l-6.5-9.7-6.5 9.7c-3.6 5.4-5.5 11.7-5.5 18.2l0 20-40 0 0-20c0-14.4 4.2-28.4 12.2-40.4l15.7-23.6-15.7-23.6c-8-12-12.2-26-12.2-40.4l0-20 40 0 0 20zM416 144l0 192-240 0 0 176-144 0 0-512 240 0 144 144zM240 176L357.5 176 240 58.5 240 176z"]
};
var faDownLeftAndUpRightToCenter = {
  prefix: 'fass',
  iconName: 'down-left-and-up-right-to-center',
  icon: [576, 512, ["compress-alt"], "f422", "M488.4-9.9c8.8 8.8 25.1 25.1 49 49l17 17-17 17-96 96 71 71-208 0 0-208 71 71 96-96 17-17zM272.4 272l0 208-71-71-96 96-17 17c-8.8-8.8-25.1-25.1-49-49l-17-17 17-17 96-96-71-71 208 0z"]
};
var faCompressAlt = faDownLeftAndUpRightToCenter;
var faPuzzlePieceSimple = {
  prefix: 'fass',
  iconName: 'puzzle-piece-simple',
  icon: [640, 512, ["puzzle-piece-alt"], "e231", "M512 224l38.5 0c8.3-19.1 23.8-32 41.5-32 26.5 0 48 28.7 48 64s-21.5 64-48 64c-17.8 0-33.2-12.9-41.5-32l-38.5 0 0 160-160 0 0-38.4c19.1-8.3 32-23.8 32-41.6 0-26.5-28.7-48-64-48s-64 21.5-64 48c0 17.8 12.9 33.3 32 41.6l0 38.4-160 0 0-160-38.5 0c-8.3 19.1-23.8 32-41.5 32-26.5 0-48-28.7-48-64s21.5-64 48-64c17.8 0 33.2 12.9 41.5 32l38.5 0 0-160 160 0 0 38.4c-19.1 8.3-32 23.8-32 41.6 0 26.5 28.7 48 64 48s64-21.5 64-48c0-17.8-12.9-33.3-32-41.6l0-38.4 160 0 0 160z"]
};
var faPuzzlePieceAlt = faPuzzlePieceSimple;
var faGifts = {
  prefix: 'fass',
  iconName: 'gifts',
  icon: [576, 512, [], "f79c", "M224.6-22.6c-5.3 15-10.7 30.2-16.2 45.7 18-13.1 32.9-23.9 44.8-32.6l28.2 38.8c-11.5 8.3-27.4 19.9-47.7 34.7l86.2 0 0 50.1c-47.5 9-84.9 46.4-93.9 93.9l-18.1 0 0 304-208 0 0-448 86.2 0C65.8 49.2 49.9 37.6 38.5 29.3L66.7-9.5c11.6 8.4 27.2 19.8 46.8 34.1-5.7-17-11-32.9-15.9-47.7l45.5-15.2c4.7 14 10.5 31.5 17.5 52.5 7.6-21.4 13.8-39 18.7-52.8l45.2 16zM489.9 208c-7.5 0-14.5 3.8-18.6 10.1L446.9 256 488 256c13.2 0 24-10.8 24-24l0-1.9c0-12.2-9.9-22.1-22.1-22.1zM385.1 256l-24.4-37.9c-4.1-6.3-11.1-10.1-18.6-10.1-12.2 0-22.1 9.9-22.1 22.1l0 1.9c0 13.2 10.7 24 24 24l41.1 0zm-109 0c-2.7-7.5-4.1-15.6-4.1-24l0-1.9c0-38.7 31.4-70.1 70.1-70.1 23.8 0 46 12.1 58.9 32.1l15 23.2 15-23.2c12.9-20 35.1-32.1 58.9-32.1 38.7 0 70.1 31.4 70.1 70.1l0 1.9c0 8.4-1.4 16.5-4.1 24l20.1 0 0 256-136 0 0-208-48 0 0 208-136 0 0-256 20.1 0z"]
};
var faArrowLeftToDottedLine = {
  prefix: 'fass',
  iconName: 'arrow-left-to-dotted-line',
  icon: [512, 512, [], "e6ba", "M0 64l0 64 64 0 0-64-64 0zM114.7 256l22.6 22.6 128 128 22.6 22.6 45.3-45.3c-6.6-6.6-38.6-38.6-96-96l274.7 0 0-64-274.7 0c57.4-57.4 89.4-89.4 96-96l-45.3-45.3-22.6 22.6-128 128-22.6 22.6zM0 234.7l64 0 0-64-64 0 0 64zm0 42.7l0 64 64 0 0-64-64 0zM0 448l64 0 0-64-64 0 0 64z"]
};
var faHospitals = {
  prefix: 'fass',
  iconName: 'hospitals',
  icon: [576, 512, [], "f80e", "M224 0l352 0 0 512-576 0 0-384 224 0 0-128zM448 352l-96 0 0 112 96 0 0-112zM424 72l-48 0 0 48-48 0 0 48 48 0 0 48 48 0 0-48 48 0 0-48-48 0 0-48zM120 200l0 40-40 0 0 48 40 0 0 40 48 0 0-40 40 0 0-48-40 0 0-40-48 0z"]
};
var faBed = {
  prefix: 'fass',
  iconName: 'bed',
  icon: [576, 512, [128716], "f236", "M64 32l0 256 224 0 0-160 192 0c53 0 96 43 96 96l0 256-64 0 0-96-448 0 0 96-64 0 0-448 64 0zm48 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faWindowFlip = {
  prefix: 'fass',
  iconName: 'window-flip',
  icon: [512, 512, ["window-alt"], "f40f", "M0 64l512 0 0 384-512 0 0-384zm384 64l0 64 64 0 0-64-64 0zm-32 0l-64 0 0 64 64 0 0-64zm-160 0l0 64 64 0 0-64-64 0z"]
};
var faWindowAlt = faWindowFlip;
var faMoneyBillTransfer = {
  prefix: 'fass',
  iconName: 'money-bill-transfer',
  icon: [640, 512, [], "e528", "M14.5 88c2.1-2.1 31.8-31.8 89-89l17-17 33.9 33.9c-9 9-25 25-48 48 81.1 0 123.1 0 126.1 0l0 0 344 0 0 242.2-5.1-5.1-50.9-50.9-101.8 101.8 48 48 67.9 0-48-48 33.9-33.9c2.1 2.1 31.8 31.8 89 89l17 17c-2.1 2.1-31.8 31.8-89 89l-17 17-33.9-33.9c9-9 25-25 48-48l-67.9 0 0 0-402.2 0 0-242.2 5.1 5.1 50.9 50.9 101.8-101.8-48-48-67.9 0c23 23 39 39 48 48l-33.9 33.9c-2.1-2.1-31.8-31.8-89-89l-17-17zM416.4 256a96.4 96.4 0 1 0 -192.9 0 96.4 96.4 0 1 0 192.9 0zm32-128c0 35.3 28.7 64 64 64l0-64-64 0zm-256 256c0-35.3-28.7-64-64-64l0 64 64 0z"]
};
var faPersonRunning = {
  prefix: 'fass',
  iconName: 'person-running',
  icon: [512, 512, [127939, "running"], "f70c", "M288-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM106.4 112l136.9 0c34.1 0 65.7 18.1 82.9 47.6l28.2 48.4 93.6 0 0 64-130.4 0c-4.5-7.7-14-24-28.5-48.8l-20.7 70.4c71.5 21.5 114 34.2 127.6 38.3-1.6 3.7-27.9 62.8-78.8 177.2l-13 29.2-58.5-26c2.6-5.9 23.4-52.6 62.2-140l-95.9-28.8c-32.7-9.8-52-43.7-43.7-76.8l22.7-90.6-41.4 0c-18 45-29.9 74.8-35.8 89.6L54.5 241.8c4.6-11.4 19.2-48 43.9-109.7l8-20.1zm40.8 245c13.3 14.9 30.7 26.3 51.2 32.4l4.7 1.4c-10.2 28.6-15.5 43.3-15.8 44.3l-6.8 5.6c-75.9 62.6-116.1 95.7-120.7 99.5L19 490.8c5.7-4.7 43.7-36 113.9-93.9l14.3-40z"]
};
var faRunning = faPersonRunning;
var faCircleChevronDown = {
  prefix: 'fass',
  iconName: 'circle-chevron-down',
  icon: [512, 512, ["chevron-circle-down"], "f13a", "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM239 345l-104-104-17-17 33.9-33.9 17 17 87 87 87-87 17-17 33.9 33.9-17 17-104 104-17 17-17-17z"]
};
var faChevronCircleDown = faCircleChevronDown;
var faManhole = {
  prefix: 'fass',
  iconName: 'manhole',
  icon: [512, 512, [], "e1d6", "M448 256a192 192 0 1 0 -384 0 192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM256 144C272.5 144 286.1 131.5 287.8 115.5 352 130 400 187.4 400 256S352 382 287.8 396.5c-1.8-16-15.3-28.5-31.8-28.5s-30.1 12.5-31.8 28.5C160 382 112 324.6 112 256s48-126 112.2-140.5c1.8 16 15.3 28.5 31.8 28.5zm-16 48l-48 0 0 48 48 0 0-48zm0 80l-48 0 0 48 48 0 0-48zm32-80l0 48 48 0 0-48-48 0zm48 80l-48 0 0 48 48 0 0-48z"]
};
var faUserNurse = {
  prefix: 'fass',
  iconName: 'user-nurse',
  icon: [448, 512, [], "f82f", "M96 24l0 120c0 70.7 57.3 128 128 128s128-57.3 128-128L352 24 224-32 96 24zm48 120l0-16 160 0 0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80zm80 240l-64-64-80 0-64 192 416 0-64-192-80 0-64 64zM208 8l32 0 0 24 24 0 0 32-24 0 0 24-32 0 0-24-24 0 0-32 24 0 0-24z"]
};
var faHeartSlash = {
  prefix: 'fass',
  iconName: 'heart-slash',
  icon: [576, 512, [], "e78e", "M49.3-17l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-122.7-122.7c59-60.6 105.5-131.9 105.5-207.2 0-73.5-59.6-133.1-133.1-133.1-42.7 0-82.8 20.5-107.9 55.1l-15 20.7-15-20.7c-25-34.6-65.2-55.1-107.9-55.1-19.7 0-38.3 4.3-55.1 11.9L49.3-17zM42.9 112.6c-6.9 16.1-10.8 33.9-10.8 52.5 0 136.8 153.5 260.1 256 330.9 24.4-16.9 51.7-36.7 79.2-59L42.9 112.6z"]
};
var faArrowsRepeat = {
  prefix: 'fass',
  iconName: 'arrows-repeat',
  icon: [512, 512, ["repeat-alt"], "f364", "M478.6 118.6L501.3 96c-5.5-5.5-39.7-39.7-102.6-102.6L376-29.3 330.7 16c14.6 14.6 30.6 30.6 48 48l-378.7 0 0 224 64 0 0-160 314.7 0c-17.4 17.4-33.4 33.4-48 48L376 221.3c5.5-5.5 39.7-39.7 102.6-102.6zM33.4 393.4L10.7 416c5.5 5.5 39.7 39.7 102.6 102.6L136 541.3 181.3 496c-14.6-14.6-30.6-30.6-48-48l378.7 0 0-224-64 0 0 160-314.7 0c17.4-17.4 33.4-33.4 48-48L136 290.7 33.4 393.4z"]
};
var faRepeatAlt = faArrowsRepeat;
var faWaffle = {
  prefix: 'fass',
  iconName: 'waffle',
  icon: [512, 512, [129479], "e466", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM176 80l-32 0 0 64-64 0 0 32 64 0 0 64-96 0 0 32 96 0 0 64-64 0 0 32 64 0 0 64 32 0 0-64 64 0 0 96 32 0 0-96 64 0 0 64 32 0 0-64 64 0 0-32-64 0 0-64 96 0 0-32-96 0 0-64 64 0 0-32-64 0 0-64-32 0 0 64-64 0 0-96-32 0 0 96-64 0 0-64zm0 256l0-64 64 0 0 64-64 0zm96 0l0-64 64 0 0 64-64 0zm64-160l0 64-64 0 0-64 64 0zm-96 0l0 64-64 0 0-64 64 0z"]
};
var faArrowLeftFromArc = {
  prefix: 'fass',
  iconName: 'arrow-left-from-arc',
  icon: [576, 512, [], "e615", "M477.5 256c0-106-86-192-192-192l-32 0 0-64 32 0c141.4 0 256 114.6 256 256s-114.6 256-256 256l-32 0 0-64 32 0c106 0 192-86 192-192zM153.6 121.4l22.6-22.6 45.3 45.3c-9.3 9.3-36 36-80 80l240 0 0 64-240 0 80 80-45.3 45.3c-.2-.2-45.1-45.1-134.6-134.6L19 256c.2-.2 45.1-45.1 134.6-134.6z"]
};
var faSquareDivide = {
  prefix: 'fass',
  iconName: 'square-divide',
  icon: [448, 512, [], "e26a", "M448 32l-448 0 0 448 448 0 0-448zM256 128l0 64-64 0 0-64 64 0zM136 232l200 0 0 48-224 0 0-48 24 0zm56 88l64 0 0 64-64 0 0-64z"]
};
var faCircleE = {
  prefix: 'fass',
  iconName: 'circle-e',
  icon: [512, 512, [], "e109", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM200 144l136 0 0 48-112 0 0 40 96 0 0 48-96 0 0 40 112 0 0 48-160 0 0-224 24 0z"]
};
var faFaceKissWinkHeart = {
  prefix: 'fass',
  iconName: 'face-kiss-wink-heart',
  icon: [640, 512, [128536, "kiss-wink-heart"], "f598", "M543.7 268.3c.2-4.1 .3-8.2 .3-12.3 0-141.4-114.6-256-256-256S32 114.6 32 256 146.6 512 288 512c41.4 0 80.5-9.8 115.1-27.3-7.6-17.1-16.1-38.8-21.8-61.7-7.7-30.5-14.1-76.2 8.2-114.7l2.7-4.6c29.5-51 94.7-68.5 145.7-39 2 1.2 4 2.4 5.9 3.7zM240 288l48 0c26.5 0 48 21.5 48 48 0 12.3-4.6 23.5-12.2 32 7.6 8.5 12.2 19.7 12.2 32 0 26.5-21.5 48-48 48l-48 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32zM208 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm152 20c-11 0-20 9-20 20l0 16-40 0 0-16c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60l0 16-40 0 0-16c0-11-9-20-20-20l-16 0zM542.8 350c-2.2-18.3-12.9-34.6-28.9-43.8-28.1-16.2-63.9-6.6-80.1 21.5l-2.7 4.6c-32 55.4 33 166.9 33 166.9s129 .6 161-54.9l2.7-4.6c16.2-28.1 6.6-63.9-21.5-80.1-16-9.2-35.4-10.4-52.4-3.1l-9.8 4.2-1.3-10.6z"]
};
var faKissWinkHeart = faFaceKissWinkHeart;
var faFill = {
  prefix: 'fass',
  iconName: 'fill',
  icon: [576, 512, [], "f575", "M312.3-21.3l22.6 22.6 208 208 22.6 22.6-22.6 22.6-256 256-22.6 22.6-22.6-22.6-208-208-22.6-22.6 22.6-22.6 121.4-121.4C117.6 98.6 93.6 74.6 83 64l45.3-45.3c10.6 10.6 34.6 34.6 72 72 70.7-70.7 108-108 112-112zm-112 202.5l-98.7 98.7 8 8 309.5 0 56-56-162.7-162.7-66.7 66.7c24 24 42.7 42.7 56 56l-45.3 45.3c-13.3-13.3-32-32-56-56z"]
};
var faHorseshoe = {
  prefix: 'fass',
  iconName: 'horseshoe',
  icon: [512, 512, [], "e81a", "M192.2 47.4l-.8 4.4-37.2 198.9c-1.4 7.2-2 14.6-1.9 22l.1 6.2c.7 58.2 48.1 105.1 106.3 105.1 57.1 0 103.2-46.6 102.6-103.7l-.1-8.3c0-3.2-.2-6.5-.5-9.7l-1.4-9.6-37.8-200.9-1.1-5.9 0-14 .2-32 176 0 0 64-42.6 0 31.1 165.1 1.7 10.3c1.5 10.3 2.3 20.7 2.4 31.2l.1 8.3C490.6 407.2 387 512 258.6 512 130.2 512 25.8 408.7 24.3 280.3l-.1-6.2c-.2-15.7 1.2-31.5 4.1-46.9l30.5-163.2-42.4 0 0-64 175.8 0 0 47.4z"]
};
var faUserDoctorHair = {
  prefix: 'fass',
  iconName: 'user-doctor-hair',
  icon: [448, 512, [], "e458", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16 80 0 64-48 0 0c10 13.4 16 30 16 48l0 16zM224 0C153.3 0 96 57.3 96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16C352 57.3 294.7 0 224 0zm60 367.4l0-47.4-120 0 0 68.4c16.5 7.6 28 24.3 28 43.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-19.4 11.5-36.1 28-43.6l0-68.4-44 0-64 192 416 0-64-192-44 0 0 47.4c23.3 8.2 40 30.5 40 56.6l0 52-40 0 0-52c0-11-9-20-20-20s-20 9-20 20l0 52-40 0 0-52c0-26.1 16.7-48.3 40-56.6z"]
};
var faSensorFire = {
  prefix: 'fass',
  iconName: 'sensor-fire',
  icon: [640, 512, [], "e02a", "M96 32l448 0 0 129.4-2.9-2.5-29.1 29.1-57.1-57.1-32.4 20.2c-25.4 15.9-61.7 45-92.1 83.2-30.2 37.9-58.5 89.6-58.5 149.5 0 34.7 8.5 67.4 23.5 96.2L96 480 96 32zM208 96l-48 0 0 160 48 0 0-160zm96 0l-48 0 0 160 5.9 0c2.9-5.2 5.8-10.1 8.8-14.9 9.8-15.9 21-31.7 33.3-47.3L304 96zm144 96l64 64 32-32c76.8 64 96 133.3 96 160 0 88.4-71.6 160-160 160S320 472.4 320 384c0-89.6 85.3-165.3 128-192zm96 240.2c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faMoneyBill1Wave = {
  prefix: 'fass',
  iconName: 'money-bill-1-wave',
  icon: [512, 512, ["money-bill-wave-alt"], "f53b", "M0 60.3L0 451.7c110.8 45.6 182.4 21.7 253.6-2 72.8-24.3 145.1-48.4 258.4 2l0-391.5c-110.8-45.6-182.4-21.7-253.6 2-72.8 24.3-145.1 48.4-258.4-2zM256 368c-53 0-96-50.1-96-112s43-112 96-112 96 50.1 96 112-43 112-96 112zM128 413.5c-19.8 .8-40.6-1.3-64-7.4l0-54c34.5 0 62.6 27.3 64 61.5zm320-49.2c-22.4-4.3-43.4-6.1-63.2-6.1 4.7-30.7 31.2-54.2 63.2-54.2l0 60.3zM448 160c-34.5 0-62.6-27.3-64-61.5 19.8-.8 40.6 1.3 64 7.4l0 54zm-320.8-6.2C122.5 184.5 96 208 64 208l0-60.3c22.4 4.3 43.4 6.1 63.2 6.1zM240 188l-20 0 0 40 16 0 0 48-24 0 0 40 88 0 0-40-24 0 0-88-36 0z"]
};
var faMoneyBillWaveAlt = faMoneyBill1Wave;
var faLandmark = {
  prefix: 'fass',
  iconName: 'landmark',
  icon: [512, 512, [127963], "f66f", "M512 208l-64 0 0 208 64 48 0 48-512 0 0-48 64-48 0-208-64 0 0-48 256-160 256 160 0 48zM112 416l64 0 0-208-64 0 0 208zm112 0l64 0 0-208-64 0 0 208zm112 0l64 0 0-208-64 0 0 208z"]
};
var faCommentMusic = {
  prefix: 'fass',
  iconName: 'comment-music',
  icon: [512, 512, [], "f8b0", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM336 128l-96 0 0 113.8c-5.1-1.2-10.5-1.8-16-1.8-35.3 0-64 25.1-64 56s28.7 56 64 56 64-25.1 64-56l0-104 48 0 0-64z"]
};
var faHammerCrash = {
  prefix: 'fass',
  iconName: 'hammer-crash',
  icon: [640, 512, [], "e414", "M608.2 168l-64 0 0-48 88 0 0 48-24 0zm-152 88l0 88-48 0 0-88 48 0zm0-288l0 64-48 0 0-88 48 0 0 24zM590.6 19.5C567 43.1 529.3 80.8 528.4 81.8L494.4 47.8c23.6-23.6 61.3-61.3 62.2-62.2l33.9 33.9zM545.3 223.2c20.7 20.7 35.8 35.8 45.3 45.3l-33.9 33.9c-23.6-23.6-61.3-61.3-62.2-62.2l33.9-33.9 17 17zM32.1 256l0-128 96-96 240 0 0 224-336 0zm152 48l80 0 0 240-80 0 0-240z"]
};
var faSwordLaser = {
  prefix: 'fass',
  iconName: 'sword-laser',
  icon: [640, 512, [], "e03b", "M328.4 326.5c4.3 4.3 12.8 12.8 25.5 25.5l-33.9 33.9-113-113-17-17 33.9-33.9c12.7 12.7 21.2 21.2 25.5 25.5L600-64 640-24 328.4 326.5zm-47.1 64.1l-30.1 30.1-96-96 30.1-30.1 96 96zm-78.1 78.1l-96-96 25.4-25.4 96 96-25.4 25.4zM84.7 395.3l96 96-84.7 84.7-96-96 84.7-84.7z"]
};
var faMusic = {
  prefix: 'fass',
  iconName: 'music',
  icon: [512, 512, [127925], "f001", "M480-7.9L480 336c0 44.2-43 80-96 80s-96-35.8-96-80 43-80 96-80c11.2 0 22 1.6 32 4.6l0-116.7-224 49.8 0 206.3c0 44.2-43 80-96 80s-96-35.8-96-80 43-80 96-80c11.2 0 22 1.6 32 4.6l0-254.2 25.1-5.6 288-64 38.9-8.7z"]
};
var faFiles = {
  prefix: 'fass',
  iconName: 'files',
  icon: [448, 512, [], "e178", "M96 0l224 0 128 128 0 320-352 0 0-448zM288 58.5L288 160 389.5 160 288 58.5zM48 120l0 376 304 0 0 48-352 0 0-448 48 0 0 24z"]
};
var faNotesSticky = {
  prefix: 'fass',
  iconName: 'notes-sticky',
  icon: [512, 512, [], "e759", "M96 416l272 0 144-144 0-272-416 0 0 416zm240-58.5L336 240 453.5 240 336 357.5zM48 120l0-24-48 0 0 416 352 0 0-48-304 0 0-344z"]
};
var faMessageArrowUpRight = {
  prefix: 'fass',
  iconName: 'message-arrow-up-right',
  icon: [512, 512, [], "e1dd", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM216 192l-24 0 0-48 160 0 0 160-48 0 0-78.1-103 103-17 17-33.9-33.9 17-17 103-103-54.1 0z"]
};
var faBookMedical = {
  prefix: 'fass',
  iconName: 'book-medical',
  icon: [448, 512, [], "f7e6", "M0 0l448 0 0 384-32 0 0 64 32 0 0 64-448 0 0-512zM64 416l0 32 288 0 0-64-256 0c-17.7 0-32 14.3-32 32zM192 104l0 56-56 0 0 64 56 0 0 56 64 0 0-56 56 0 0-64-56 0 0-56-64 0z"]
};
var faMusicNoteSlash = {
  prefix: 'fass',
  iconName: 'music-note-slash',
  icon: [576, 512, ["music-alt-slash"], "f8d0", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-209.2-209.2 0-101c82.4-20.6 125.1-31.3 128-32l0-162C468.3-6 412.4 7.9 312.4 33L288.1 39 288.1 222 49.3-16.9zm185.1 321c-59.2 2.5-106.3 44.5-106.3 95.9 0 53 50.1 96 112 96 54.1 0 99.2-32.8 109.7-76.5L234.4 304.1z"]
};
var faMusicAltSlash = faMusicNoteSlash;
var faShuffle = {
  prefix: 'fass',
  iconName: 'shuffle',
  icon: [512, 512, [128256, "random"], "f074", "M512 128l-128 104 0-72-48 0-42 56-40-53.3c32.1-42.8 48.7-65 50-66.7l80 0 0-72 128 104zM320 416l-16 0-9.6-12.8-182.4-243.2-112 0 0-64 144 0 9.6 12.8 182.4 243.2 48 0 0-72 128 104-128 104 0-72-64 0zM194 349.3c-32.1 42.7-48.7 65-50 66.7l-144 0 0-64 112 0 42-56 40 53.3z"]
};
var faRandom = faShuffle;
var faUnderline = {
  prefix: 'fass',
  iconName: 'underline',
  icon: [384, 512, [], "f0cd", "M0 0l128 0 0 64-32 0 0 160c0 53 43 96 96 96s96-43 96-96l0-160-32 0 0-64 128 0 0 64-32 0 0 160c0 88.4-71.6 160-160 160S32 312.4 32 224L32 64 0 64 0 0zM0 448l384 0 0 64-384 0 0-64z"]
};
var faBuildingUser = {
  prefix: 'fass',
  iconName: 'building-user',
  icon: [640, 512, [], "e4da", "M64 0l384 0 0 185.3c-46.9 19-80 65-80 118.7 0 19.8 4.5 38.5 12.5 55.2L313.6 512 64 512 64 0zM208 352l0 112 74.2 0 21.8-49.8 0-62.2-96 0zM339.2 224l-51.2 0 0 64 32.7 0c2.1-22.9 8.5-44.5 18.5-64zM224 96l-64 0 0 64 64 0 0-64zm64 0l0 64 64 0 0-64-64 0zM224 224l-64 0 0 64 64 0 0-64zm192 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM584 416l56 128-288 0 56-128 176 0z"]
};
var faSushiRoll = {
  prefix: 'fass',
  iconName: 'sushi-roll',
  icon: [448, 512, ["maki-roll", "makizushi"], "e48b", "M448 368l0-224C448 82.1 347.7 32 224 32S0 82.1 0 144L0 368S48 480 224 480 448 368 448 368zM209.4 80.3l8.4 18.3-75.3 26.5-3.9 1.4-3 2.8-50.3 46.6C71.7 166.5 64 155.6 64 144 64 110.6 127.9 83.2 209.4 80.3zm-49.8 81.2l74.9-26.4c6.8 14.9 10.9 23.9 12.3 26.9l7.7 2.9 73.7 27.6c-28 9.6-64.5 15.5-104.3 15.5-37.6 0-72.2-5.2-99.5-13.9l35.2-32.6zm94.1-80.4c74.1 5.6 130.2 31.6 130.2 62.9 0 8-3.7 15.7-10.4 22.8l-97.2-36.4-22.6-49.3z"]
};
var faMakiRoll = faSushiRoll;
var faMakizushi = faSushiRoll;
var faDialOff = {
  prefix: 'fass',
  iconName: 'dial-off',
  icon: [576, 512, [], "e162", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64-64 0 0-64zm448 32c0 80.2-59 146.6-136 158.2l0-182.2-48 0 0 182.2c-77-11.6-136-78-136-158.2 0-88.4 71.6-160 160-160s160 71.6 160 160z"]
};
var faRobot = {
  prefix: 'fass',
  iconName: 'robot',
  icon: [640, 512, [129302], "f544", "M352 0l0-32-64 0 0 96-192 0 0 416 448 0 0-416-192 0 0-64zM160 344l80 0 0 48-80 0 0-48zm120 0l80 0 0 48-80 0 0-48zm120 0l80 0 0 48-80 0 0-48zM224 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm144 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM64 224l0-32-64 0 0 160 64 0 0-128zm576-32l-64 0 0 160 64 0 0-160z"]
};
var faBarProgressEmpty = {
  prefix: 'fass',
  iconName: 'bar-progress-empty',
  icon: [512, 512, [], "e6a5", "M448 160l0 192-384 0 0-192 384 0zM64 96l-64 0 0 320 512 0 0-320-448 0z"]
};
var faTransmission = {
  prefix: 'fass',
  iconName: 'transmission',
  icon: [512, 512, [], "e802", "M448 0c35.3 0 64 28.7 64 64 0 23.7-12.9 44.3-32 55.3l0 168.7-192 0 0 104.6c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64s-64-28.7-64-64c0-23.7 12.9-44.3 32-55.4l0-104.6-128 0 0 104.6c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64S0 483.3 0 448c0-23.7 12.9-44.3 32-55.4l0-273.3C12.9 108.3 0 87.7 0 64 0 28.7 28.7 0 64 0s64 28.7 64 64c0 23.7-12.9 44.3-32 55.3l0 104.7 128 0 0-104.7c-19.1-11.1-32-31.7-32-55.3 0-35.3 28.7-64 64-64s64 28.7 64 64c0 23.7-12.9 44.3-32 55.3l0 104.7 128 0 0-104.7c-19.1-11.1-32-31.7-32-55.3 0-35.3 28.7-64 64-64z"]
};
var faPlus = {
  prefix: 'fass',
  iconName: 'plus',
  icon: [448, 512, [10133, 61543, "add"], "2b", "M256 64l0-32-64 0 0 192-192 0 0 64 192 0 0 192 64 0 0-192 192 0 0-64-192 0 0-160z"]
};
var faAdd = faPlus;
var faObjectsAlignTop = {
  prefix: 'fass',
  iconName: 'objects-align-top',
  icon: [512, 512, [], "e3c0", "M512 0L512 64 0 64 0 0 512 0zM64 128l160 0 0 384-160 0 0-384zm224 0l160 0 0 256-160 0 0-256z"]
};
var faBellRing = {
  prefix: 'fass',
  iconName: 'bell-ring',
  icon: [512, 512, [], "e62c", "M224 0l64 0 0 35.2C361 50 416 114.6 416 192l0 96 80 128-480 0 80-128 0-96c0-77.4 55-142 128-156.8L224 0zm32 512c-29.8 0-54.9-20.4-62-48l124 0c-7.1 27.6-32.2 48-62 48zM48 192L0 192C0 119.1 30.5 53.2 79.4 6.6l33.1 34.8C72.8 79.3 48 132.7 48 192zM399.4 41.4L432.6 6.6C481.5 53.2 512 119.1 512 192l-48 0c0-59.3-24.8-112.7-64.6-150.6z"]
};
var faCopy = {
  prefix: 'fass',
  iconName: 'copy',
  icon: [448, 512, [], "f0c5", "M352 0l-224 0 0 384 320 0 0-288-96-96zM64 128l-64 0 0 384 320 0 0-80-64 0 0 16-192 0 0-256 16 0 0-64-16 0z"]
};
var faChessKing = {
  prefix: 'fass',
  iconName: 'chess-king',
  icon: [448, 512, [9818], "f43f", "M256-32l0 64 64 0 0 64-64 0 0 64 192 0 0 48-96 176 64 80 0 48-384 0 0-48 64-80-96-176 0-48 192 0 0-64-64 0 0-64 64 0 0-64 64 0z"]
};
var faHouseFloodWater = {
  prefix: 'fass',
  iconName: 'house-flood-water',
  icon: [640, 512, [], "e50e", "M496.4 208l32 0 0-40-208-168-208 168 0 40 32 0 0 113c19.9-8 38.6-15.4 56-22.4 6.7 2.7 46.7 18.7 120 48 73.3-29.3 113.3-45.3 120-48 17.4 7 36.1 14.4 56 22.4l0-113zm-128-32l0 96-96 0 0-96 96 0zm-168 174.2l-8.9 3.6-111.8 44.7c-29.3-9.7-50.1-16.7-62.4-20.8L2 423.2c11 3.7 34.6 11.5 70.8 23.6l8.3 2.8 8.2-3.3 111.1-44.4 111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4 111.1 44.4 8.2 3.3 8.3-2.8c36.2-12.1 59.8-19.9 70.8-23.6l-15.2-45.5c-12.4 4.1-33.2 11.1-62.4 20.8l-111.8-44.7-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4-8.9-3.6zm8.9 99.6l-8.9-3.6-8.9 3.6-111.8 44.7c-29.3-9.8-50.1-16.7-62.4-20.8L2 519.2c11 3.7 34.6 11.5 70.8 23.6l8.3 2.8 8.2-3.3 111.1-44.4 111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4 111.1 44.4 8.2 3.3 8.3-2.8c36.2-12.1 59.8-19.9 70.8-23.6l-15.2-45.5c-12.4 4.1-33.2 11.1-62.4 20.8l-111.8-44.7-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4z"]
};
var faMoneyFromBracket = {
  prefix: 'fass',
  iconName: 'money-from-bracket',
  icon: [576, 512, [], "e312", "M0 0l0 192 48 0 0-144 480 0 0 144 48 0 0-192-576 0zM480 512l0-416-384 0 0 416 384 0zM384 256a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM160 384c35.3 0 64 28.7 64 64l-64 0 0-64zm256 0l0 64-64 0c0-35.3 28.7-64 64-64z"]
};
var faBitcoinSign = {
  prefix: 'fass',
  iconName: 'bitcoin-sign',
  icon: [320, 512, [], "e0b4", "M112 0l-48 0 0 64-64 0 0 384 64 0 0 64 48 0 0-64 32 0 0 64 48 0 0-64 16 0c61.9 0 112-50.1 112-112 0-40.1-21.1-75.3-52.7-95.1 13.1-18.3 20.7-40.7 20.7-64.9 0-56.4-41.7-103.1-96-110.9l0-65.1-48 0 0 64-32 0 0-64zM64 128l112 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-112 0 0-96zM176 288l32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-144 0 0-96 112 0z"]
};
var faBox = {
  prefix: 'fass',
  iconName: 'box',
  icon: [448, 512, [128230], "f466", "M369.4 128l-290.7 0 34.3-48 222.1 0 34.3 48zM368 16l-288 0-80 112 0 352 448 0 0-352-80-112z"]
};
var faFaceAnguished = {
  prefix: 'fass',
  iconName: 'face-anguished',
  icon: [512, 512, [], "e369", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-48 92c44.2 0 80 35.8 80 80l0 4-160 0 0-4c0-44.2 35.8-80 80-80zM192 132c-4.2 0-8.4 .3-12.5 .8-20.3 2.7-38.9 11.9-53.8 25.8L111 172.3 83.7 143 98.3 129.4C119 110.1 145.2 97 174.3 93.2 180.1 92.4 186 92 192 92l20 0 0 40-20 0zm140.5 .8c-4.1-.5-8.3-.8-12.5-.8l-20 0 0-40 20 0c6 0 11.9 .4 17.7 1.2 29.1 3.8 55.3 17 75.9 36.2l14.6 13.7-27.3 29.2-14.6-13.7c-14.9-13.9-33.5-23.1-53.8-25.8z"]
};
var faLocationArrowUp = {
  prefix: 'fass',
  iconName: 'location-arrow-up',
  icon: [512, 512, [], "e63a", "M16 496L256-16 496 496 256 384 16 496z"]
};
var faHeadSideHeart = {
  prefix: 'fass',
  iconName: 'head-side-heart',
  icon: [512, 512, [], "e1aa", "M224 0C338.4 0 432.7 85.7 446.3 196.4l49.7 59.6 0 64-64 0 0 128-112 0 0 64-256 0 0-131.2C24.4 340.4 0 285 0 224 0 100.3 100.3 0 224 0zm-6.4 151.5c-11.1-14.8-28.5-23.5-46.9-23.5-32.4 0-58.7 26.3-58.7 58.7l0 5.3c0 64 112 128 112 128s112-64 112-128l0-5.3c0-32.4-26.3-58.7-58.7-58.7-18.5 0-35.9 8.7-46.9 23.5l-6.4 8.5-6.4-8.5z"]
};
var faSquarePlus = {
  prefix: 'fass',
  iconName: 'square-plus',
  icon: [448, 512, [61846, "plus-square"], "f0fe", "M448 32l-448 0 0 448 448 0 0-448zM200 368l0-88-88 0 0-48 88 0 0-88 48 0 0 88 88 0 0 48-88 0 0 88-48 0z"]
};
var faPlusSquare = faSquarePlus;
var faMemo = {
  prefix: 'fass',
  iconName: 'memo',
  icon: [384, 512, [], "e1d8", "M384 0L0 0 0 512 384 512 384 0zM120 128l168 0 0 48-192 0 0-48 24 0zm0 96l168 0 0 48-192 0 0-48 24 0zm0 96l104 0 0 48-128 0 0-48 24 0z"]
};
var faArrowsLeftRight = {
  prefix: 'fass',
  iconName: 'arrows-left-right',
  icon: [640, 512, ["arrows-h"], "f07e", "M598.9 278.6L621.5 256c-2.9-2.9-42.4-42.4-118.6-118.6L480.3 114.7 435 160c12 12 33.3 33.3 64 64l-357.5 0c30.7-30.7 52-52 64-64l-45.3-45.3c-2.9 2.9-42.4 42.4-118.6 118.6L19 256c2.9 2.9 42.4 42.4 118.6 118.6l22.6 22.6 45.3-45.3c-12-12-33.3-33.3-64-64l357.5 0-64 64 45.3 45.3 118.6-118.6z"]
};
var faArrowsH = faArrowsLeftRight;
var faFan = {
  prefix: 'fass',
  iconName: 'fan',
  icon: [512, 512, [], "f863", "M160 144C160 64.5 224.5 0 304 0l16 0 0 168.2c15-5.3 31.2-8.2 48-8.2 79.5 0 144 64.5 144 144l0 16-168.2 0c5.3 15 8.2 31.2 8.2 48 0 79.5-64.5 144-144 144l-16 0 0-168.2c-15 5.3-31.2 8.2-48 8.2-79.5 0-144-64.5-144-144l0-16 168.2 0c-5.3-15-8.2-31.2-8.2-48zm96 144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCrow = {
  prefix: 'fass',
  iconName: 'crow',
  icon: [640, 512, [], "f520", "M456 0c27.3 0 51.7 12.5 67.9 32l68.1 0 48 32 0 32-96 24 0 72c0 88-59.2 162.1-139.8 184.8l55.7 135.2-51.9 0-52.7-128c-1.1 0-2.1 0-3.2 0l-40.9 0 52.7 128-51.9 0-52.7-128-131.3 0-76.8 57.6-38.4-51.2 355.2-266.4 0-36c0-48.6 39.4-88 88-88zm0 64a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faUTurnUpRight = {
  prefix: 'fass',
  iconName: 'u-turn-up-right',
  icon: [512, 512, [], "e7f6", "M0 272C0 157.1 93.2 64 208 64l144 0 0-96 160 160-160 160 0-96-144 0c-44.2 0-80 35.8-80 80s35.8 80 80 80l240 0 0 128-240 0C93.1 480 0 386.9 0 272z"]
};
var faSquare8 = {
  prefix: 'fass',
  iconName: 'square-8',
  icon: [448, 512, [], "e25d", "M448 32l-448 0 0 448 448 0 0-448zM144 212c0-37.6 30.4-68 68-68l24 0c37.6 0 68 30.4 68 68 0 14.7-4.6 28.2-12.5 39.3 12.7 12.3 20.5 29.6 20.5 48.7 0 37.6-30.4 68-68 68l-40 0c-37.6 0-68-30.4-68-68 0-19.1 7.9-36.3 20.5-48.7-7.9-11.1-12.5-24.7-12.5-39.3zm112 0c0-11-9-20-20-20l-24 0c-11 0-20 9-20 20s9 20 20 20l24 0c11 0 20-9 20-20zm-52 68c-11 0-20 9-20 20s9 20 20 20l40 0c11 0 20-9 20-20s-9-20-20-20l-40 0z"]
};
var faFileCircleCheck = {
  prefix: 'fass',
  iconName: 'file-circle-check',
  icon: [576, 512, [], "e5a0", "M272 0l-240 0 0 512 244 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3L416 144 272 0zm85.5 176L240 176 240 58.5 357.5 176zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L353.4 400 376 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z"]
};
var faBracketCurlyRight = {
  prefix: 'fass',
  iconName: 'bracket-curly-right',
  icon: [256, 512, [], "7d", "M160 32l32 0 0 146.7 54.6 54.6 9.4 9.4 0 26.5-64 64 0 146.7-160 0 0-64 96 0 0-109.3 50.7-50.7c-32.9-32.9-49.8-49.8-50.7-50.7l0-109.3-96 0 0-64 128 0z"]
};
var faChartNetwork = {
  prefix: 'fass',
  iconName: 'chart-network',
  icon: [640, 512, [], "f78a", "M288 0l-128 0 0 128 58.6 0 29.1 62.3C221.8 210.4 203 239 195.6 272l-67.6 0 0-32-128 0 0 128 128 0 0-32 67.6 0c14.6 64.1 71.9 112 140.4 112 38.4 0 73.3-15 99.1-39.5l76.9 51.3 0 52.2 128 0 0-128-126.3 0-43.1-28.7c6.1-15.9 9.4-33.2 9.4-51.3 0-20.3-4.2-39.7-11.8-57.2l74.7-54.8 97.2 0 0-128-128 0 0 71.3-81.7 59.9c-25.3-21.9-58.2-35.2-94.3-35.2-10.4 0-20.6 1.1-30.4 3.2L288 125.5 288 0zm48 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faBadgeDollar = {
  prefix: 'fass',
  iconName: 'badge-dollar',
  icon: [512, 512, [], "f645", "M256 0C292.8 0 324.8 20.7 340.9 51.1 373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zm24 144l-40 0 0 24c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5l-75.5 0 0 40 44 0 0 24 40 0 0-24.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l67.5 0 0-40-28 0 0-24z"]
};
var faLinkSlash = {
  prefix: 'fass',
  iconName: 'link-slash',
  icon: [576, 512, ["chain-broken", "chain-slash", "unlink"], "f127", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-114.1-114.1c4.2-3.4 8.2-7 12-10.8l71.1-71.1c29.3-29.3 45.8-69.1 45.8-110.6 0-86.4-70-156.5-156.5-156.5-37.3 0-73.1 13.3-101.3 37.2 20.3 10.1 38.7 23.5 54.5 39.5 14.1-8.3 30.2-12.7 46.8-12.7 51.1 0 92.5 41.4 92.5 92.5 0 24.5-9.7 48-27.1 65.4L414 324.9c-3.9 3.9-8 7.3-12.4 10.4l-47.3-47.3 29.3 0 .6-23.2c0-1.6 0-11.2 0-11.9 0-86.3-69.9-156.9-156.5-156.9-19.1 0-37.9 3.5-55.4 10.1l-123-123zM226.2 160c.5 0 1 0 1.5 0 50.9 0 92.5 41.7 92.5 92.9l0 1.1-93.9-94zM46 212.9c-29.3 29.3-45.8 69.1-45.8 110.6 0 86.4 70 156.5 156.5 156.5 37.2 0 73.1-13.3 101.3-37.2-20.3-10.1-38.8-23.5-54.6-39.5-14 8.2-30.1 12.6-46.7 12.6-51.1 0-92.5-41.4-92.5-92.5 0-24.5 9.7-48 27.1-65.4l48.6-48.6-45.3-45.3-48.6 48.6zm146.2 48.9c1.2 84.6 69.6 152.9 154.1 154.1L192.1 261.8z"]
};
var faChainBroken = faLinkSlash;
var faChainSlash = faLinkSlash;
var faUnlink = faLinkSlash;
var faArrowRotateRight = {
  prefix: 'fass',
  iconName: 'arrow-rotate-right',
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", "M448 32l0-32 64 0 0 192-192 0 0-64 79.1 0C363.9 88.7 312.8 64 256 64 150 64 64 150 64 256s86 192 192 192c75 0 140-43 171.6-105.8l57.2 28.8C442.8 454.5 356.1 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0c76.5 0 145.1 33.6 192 86.7L448 32z"]
};
var faArrowRightRotate = faArrowRotateRight;
var faArrowRotateForward = faArrowRotateRight;
var faRedo = faArrowRotateRight;
var faPersonToPortal = {
  prefix: 'fass',
  iconName: 'person-to-portal',
  icon: [640, 512, ["portal-enter"], "e022", "M344 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM128 112l-21.7 0c-1.4 3.4-14.7 36.8-40 100.1l-11.9 29.7 59.4 23.8c5.9-14.8 17.9-44.7 35.8-89.6l41.4 0-22.7 90.6c-8.3 33.2 11 67 43.7 76.8L308 372.2c-38.9 87.5-59.6 134.1-62.2 140l58.5 26 13-29.2c50.9-114.5 77.1-173.5 78.8-177.2-13.5-4.1-56.1-16.8-127.6-38.3l20.7-70.4c14.5 24.8 24 41.1 28.5 48.8l130.4 0 0-64-93.6 0-28.2-48.4C309 130.1 277.4 112 243.3 112L128 112zm4.8 284.9C62.7 454.8 24.7 486.1 19 490.8l40.7 49.4c4.6-3.8 44.8-36.9 120.7-99.5l6.8-5.6c.3-.9 5.6-15.7 15.8-44.3l-4.7-1.4c-20.4-6.1-37.9-17.6-51.2-32.4l-14.3 40zM512 544c53 0 96-128.9 96-288s-43-288-96-288c-41.8 0-77.4 80.1-90.5 192l74.5 0 0 160-42.2 0-28 62.9C441.5 478.3 474.2 544 512 544z"]
};
var faPortalEnter = faPersonToPortal;
var faSignalBarsSlash = {
  prefix: 'fass',
  iconName: 'signal-bars-slash',
  icon: [576, 512, ["signal-alt-slash"], "f694", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-5.9-5.9-28-28-66.1-66.1l0-414-64 0 0 350-64-64 0-190-64 0 0 126-270.8-270.8zM384.1 453.8l-64-64 0 90.2 64 0 0-26.2zm-128-128l-64-64 0 218.2 64 0 0-154.2zM128.1 416l0-32-64 0 0 96 64 0 0-64z"]
};
var faSignalAltSlash = faSignalBarsSlash;
var faPenClip = {
  prefix: 'fass',
  iconName: 'pen-clip',
  icon: [576, 512, ["pen-alt"], "f305", "M72 328l-56 200 200-56 223-223-3-3-17-17C202.5 12.5 253.5 63.5 230.1 40l-17 17-126.1 126.1-17 17 33.9 33.9 17-17 109.1-109.1 31 31-189.1 189.1zM560 128l-144-144-87 87 144 144 87-87z"]
};
var faPenAlt = faPenClip;
var faRectangleBeta = {
  prefix: 'fass',
  iconName: 'rectangle-beta',
  icon: [640, 512, [], "e808", "M640 448l-640 0 0-384 640 0 0 384zM68 172l0 168 60 0c28.7 0 52-23.3 52-52 0-14.5-6-27.7-15.6-37.1 4.8-7.9 7.6-17 7.6-26.9 0-28.7-23.3-52-52-52l-52 0zm144 0l0 168 104 0 0-40-64 0 0-24 48 0 0-40-48 0 0-24 64 0 0-40-104 0zm128 0l0 40 32 0 0 128 40 0 0-128 32 0 0-40-104 0zm172 0c-24.3 0-44 19.7-44 44l0 124 40 0 0-48 24 0 0 48 40 0 0-124c0-24.3-19.7-44-44-44l-16 0zM124.8 272c8.8 0 16 7.2 16 16s-7.2 16-16 16l-17.6 0 0-32 17.6 0zM528 212c2.2 0 4 1.8 4 4l0 36-24 0 0-36c0-2.2 1.8-4 4-4l16 0zm-411.2-4c8.8 0 16 7.2 16 16s-7.2 16-16 16l-9.6 0 0-32 9.6 0z"]
};
var faDoorClosed = {
  prefix: 'fass',
  iconName: 'door-closed',
  icon: [448, 512, [128682], "f52a", "M32 0l384 0 0 448 32 0 0 64-448 0 0-64 32 0 0-448zM320 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLockA = {
  prefix: 'fass',
  iconName: 'lock-a',
  icon: [384, 512, [], "e422", "M192 32c35.3 0 64 28.7 64 64l0 64-128 0 0-64c0-35.3 28.7-64 64-64zM64 96l0 64-64 0 0 352 384 0 0-352-64 0 0-64c0-70.7-57.3-128-128-128S64 25.3 64 96zM170.1 230.3c1-2.3 2.4-4.4 4-6.3l35.8 0c1.6 1.8 3 3.9 4.1 6.3l96.6 217.7-52.5 0-21.3-48-89.4 0-21.3 48-52.5 0 96.6-217.7zM192 299.2l-23.4 52.8 46.8 0-23.4-52.8z"]
};
var faArrowDownWideShort = {
  prefix: 'fass',
  iconName: 'arrow-down-wide-short',
  icon: [576, 512, ["sort-amount-asc", "sort-amount-down"], "f160", "M150.9 470.6l-22.6 22.6c-4.2-4.2-41.1-41.1-110.6-110.6L-5 360 40.3 314.7c13.3 13.3 32 32 56 56l0-338.7 64 0 0 338.7c24-24 42.7-42.7 56-56L261.5 360c-4.2 4.2-41.1 41.1-110.6 110.6zM320.3 480l-32 0 0-64 96 0 0 64-64 0zm0-128l-32 0 0-64 160 0 0 64-128 0zm0-128l-32 0 0-64 224 0 0 64-192 0zm0-128l-32 0 0-64 288 0 0 64-256 0z"]
};
var faSortAmountAsc = faArrowDownWideShort;
var faSortAmountDown = faArrowDownWideShort;
var faFaceMelting = {
  prefix: 'fass',
  iconName: 'face-melting',
  icon: [640, 512, [129760], "e483", "M573.4 292.7C570.3 314.4 586 336 607.9 336l32.1 0 0 64-72 0c-13.3 0-24 10.7-24 24 0 13.2 10.7 24 24 24l40 0 0 64-608 0 0-64 44.9 0C81.8 448 103.3 397.3 87.8 363.9 72.5 331.1 64 294.5 64 256 64 114.6 178.6 0 320 0S576 114.6 576 256c0 12.5-.9 24.7-2.6 36.7zM291 364.2c-36.9-9.9-64.6-37.1-76.6-70.7l-45.2 16.1c17 47.8 56.5 86.8 109.4 100.9s106.5 .1 145.2-32.7l-31.1-36.6c-27.1 23.1-64.7 32.8-101.7 22.9zM288 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faFaceDisguise = {
  prefix: 'fass',
  iconName: 'face-disguise',
  icon: [512, 512, [], "e370", "M256 512c141.4 0 256-114.6 256-256 0-16.4-1.5-32.5-4.5-48L440 208c0 49.4-37.4 90.1-85.4 95.4l13.4 6.7 0 51.8-23.1 11.6c14.7 18.4 24.6 30.7 29.6 37l-25 20c-4.3-5.4-15.6-19.6-33.9-42.4l-7.3 3.6c7.8 19.5 13.3 33.2 16.5 41.2l-29.7 11.9c-3.4-8.4-8.5-21.3-15.5-38.7l-7.6 3.8 0 38.1-32 0 0-38.1-7.6-3.8c-7 17.4-12.1 30.3-15.5 38.7l-29.7-11.9c3.2-8 8.7-21.7 16.5-41.2l-7.3-3.6c-18.3 22.8-29.6 37-33.9 42.4l-25-20c5.1-6.3 14.9-18.7 29.6-37-10.4-5.2-18.2-9.1-23.1-11.6l0-51.8c6.6-3.3 11.1-5.5 13.4-6.7-48-5.3-85.4-46-85.4-95.4L4.5 208C1.5 223.5 0 239.6 0 256 0 397.4 114.6 512 256 512zm55.1-249.3c2.9 1.8 5.4 3.2 6.8 3.8 7.9 3.5 16.7 5.5 26.1 5.5 35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64c0 4.4 .4 8.7 1.3 12.8l29.6 42.3 .2-.4zM232 208c0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64c9.3 0 18.1-2 26.1-5.5 1.4-.6 3.9-2 6.8-3.8l.2 .4 29.6-42.3c.8-4.1 1.3-8.4 1.3-12.8zM12.7 176l64.7 0c13.2-37.3 48.7-64 90.5-64 39.4 0 73.2 23.7 88 57.6 14.8-33.9 48.6-57.6 88-57.6 41.8 0 77.4 26.7 90.5 64l64.7 0C465.7 73.8 369.4 0 256 0S46.3 73.8 12.7 176zM256 240.5l-50.9 72.7-2.3 3.3-3.6 1.8-23.2 11.6 0 12.2 80 40 80-40 0-12.2-23.2-11.6-3.6-1.8-2.3-3.3-50.9-72.7zM144 216a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSportsball = {
  prefix: 'fass',
  iconName: 'sportsball',
  icon: [512, 512, [], "e44b", "M489.6 56.8L377.7 168.8c32.6 26.1 72.9 42.9 116.9 46.5 7.4-56.9 3.6-113-4.9-158.4zm-33.9-34c-59.6-9.5-112.2-11.1-158.6-5.9 3.4 44.4 20.3 85.1 46.6 117.9l112-112zm-9.3 335.6c18.4-29.9 31-62.5 39.2-95.7-53.8-5.4-102.8-27-142.1-59.8L290.4 256 424.2 389.8c8.2-10 15.6-20.5 22.2-31.4zM309.6 168.9c-33.1-39.8-54.8-89.4-60-143.9-14.1 3.3-27.5 7.4-40.3 12.1-34.1 12.7-63 30-87.1 50.7l134.2 134.2 53.1-53.1zM88.8 122.2c-8.2 10-15.6 20.5-22.2 31.4-18.4 29.9-31 62.5-39.2 95.7 53.8 5.4 102.8 27 142.1 59.8L222.6 256 88.8 122.2zM263.3 487c14.1-3.3 27.5-7.4 40.3-12.1 34.1-12.7 63-30 87.1-50.7l-134.2-134.2-53.1 53.1c33.1 39.8 54.8 89.4 60 143.9zM169.3 377.2l-112 112c59.6 9.5 112.2 11.1 158.6 5.9-3.4-44.4-20.3-85.1-46.6-117.9zm-33.9-33.9c-32.6-26.1-72.9-42.9-116.9-46.5-7.4 56.9-3.6 113 4.9 158.4L135.3 343.2z"]
};
var faSquareMicrophone = {
  prefix: 'fass',
  iconName: 'square-microphone',
  icon: [448, 512, [], "e781", "M448 32l-448 0 0 448 448 0 0-448zM176 112l96 0 0 128c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-128zm-48 96l0 32c0 53 43 96 96 96s96-43 96-96l0-32 48 0 0 32c0 71.4-51.9 130.6-120 142l0 42-48 0 0-42C131.9 370.6 80 311.4 80 240l0-32 48 0z"]
};
var faCaretDown = {
  prefix: 'fass',
  iconName: 'caret-down',
  icon: [384, 512, [], "f0d7", "M16 192l176 200 176-200-352 0z"]
};
var faRadar = {
  prefix: 'fass',
  iconName: 'radar',
  icon: [512, 512, [], "e024", "M497.4 49l17-17-33.9-33.9C473.6 4.9 453.3 25.2 419.7 58.8 375.4 22.1 318.5 0 256.4 0 115.1 0 .4 114.6 .4 256s114.6 256 256 256 256-114.6 256-256l-64 0c0 106-86 192-192 192s-192-86-192-192 86-192 192-192c44.4 0 85.2 15 117.7 40.3l-34.3 34.3c-23.5-16.8-52.3-26.6-83.4-26.6-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144l-64 0c0 44.2-35.8 80-80 80s-80-35.8-80-80 35.8-80 80-80c13.4 0 25.9 3.3 37 9.1-42.2 42.2-65.8 65.8-70.9 70.9l33.9 33.9 17-17 224-224z"]
};
var faImageLandscape = {
  prefix: 'fass',
  iconName: 'image-landscape',
  icon: [576, 512, ["landscape"], "e1b5", "M576 64l-576 0 0 384 576 0 0-384zM96 384L208 256 251.1 305.2 336 192 480 384 96 384zm32-232a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faLandscape = faImageLandscape;
var faRotateReverse = {
  prefix: 'fass',
  iconName: 'rotate-reverse',
  icon: [512, 512, [], "e631", "M0-8L79 71c100.3-96 259.4-94.7 358 4 50 50 75 115.6 75 181l-64 0c0-49.2-18.7-98.3-56.2-135.8-73.6-73.6-192.2-75-267.5-3.9L200 192 0 192 0-8zM387.7 395.7l-75.7-75.7 200 0 0 200-79-79c-100.3 96-259.4 94.7-358-4-50-50-75-115.6-75-181l64 0c0 49.2 18.7 98.3 56.2 135.8 73.6 73.6 192.2 75 267.5 3.9z"]
};
var faTicketPerforated = {
  prefix: 'fass',
  iconName: 'ticket-perforated',
  icon: [576, 512, [], "e63e", "M0 64l576 0 0 144c-26.5 0-48 21.5-48 48s21.5 48 48 48l0 144-576 0 0-384zM416 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSquareC = {
  prefix: 'fass',
  iconName: 'square-c',
  icon: [448, 512, [], "e266", "M448 32l-448 0 0 448 448 0 0-448zM173.1 205.1c-28.1 28.1-28.1 73.7 0 101.8s73.7 28.1 101.8 0l33.9 33.9c-46.9 46.9-122.8 46.9-169.7 0s-46.9-122.8 0-169.7 122.8-46.9 169.7 0l-33.9 33.9c-28.1-28.1-73.7-28.1-101.8 0z"]
};
var faK = {
  prefix: 'fass',
  iconName: 'k',
  icon: [320, 512, [107], "4b", "M236.5 32l83.2 0-10.4 12.5-142.6 171.5 151.1 264.1-73.7 0-121.1-211.5-59.1 71.1 0 140.4-64 0 0-448 64 0 0 207.5c10.6-12.8 68.2-82 172.5-207.5z"]
};
var faArrowUTurnDownLeft = {
  prefix: 'fass',
  iconName: 'arrow-u-turn-down-left',
  icon: [576, 512, [], "e7e7", "M176.2 541.3l45.2-45.3-80-80 210.7 0C455 416 538.9 335.3 544 233.9l.2-9.9c0-106-86-192-192-192l-256 0 0 64 256 0c70.7 0 128 57.3 128 128l-.2 6.6C476.7 298.2 420.7 352 352.2 352l-210.7 0 80-80-45.2-45.2-157.2 157.2 157.2 157.3z"]
};
var faCheckToSlot = {
  prefix: 'fass',
  iconName: 'check-to-slot',
  icon: [576, 512, ["vote-yea"], "f772", "M48 432l480 0 0-144 48 0 0 192-576 0 0-192 48 0 0 144zm432-48l-384 0 0-352 384 0 0 352zM345.4 129.9L259.8 247.6c-19.3-20-33.7-34.9-43.2-44.7l-34.5 33.3c6.2 6.4 27.2 28.1 63.1 65.2l19.8 20.6 16.8-23.1 102.4-140.8 14.1-19.4-38.8-28.2-14.1 19.4z"]
};
var faVoteYea = faCheckToSlot;
var faSquareJ = {
  prefix: 'fass',
  iconName: 'square-j',
  icon: [448, 512, [], "e273", "M448 32l-448 0 0 448 448 0 0-448zM304 168l0 112c0 48.6-39.4 88-88 88s-88-39.4-88-88l0-24 48 0 0 24c0 22.1 17.9 40 40 40s40-17.9 40-40l0-136 48 0 0 24z"]
};
var faFishFins = {
  prefix: 'fass',
  iconName: 'fish-fins',
  icon: [576, 512, [], "e4f2", "M224 64l13.5 53.9c-37.7 17.5-67.9 43.1-90.6 67.6L32 128 0 160 48 256 0 352 32 384 146.9 326.5c22.6 24.4 52.8 50 90.6 67.6l-13.5 53.9 48 32 73.4-64.2C499.1 409.8 576 256 576 256S499.1 102.2 345.4 96.2L272 32 224 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBellSchool = {
  prefix: 'fass',
  iconName: 'bell-school',
  icon: [576, 512, [], "f5d5", "M272 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 288a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm288-64c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.8 9.7 33.3 24 41.6l0 70.4-72 0 0-48c-41 28-90.6 44.3-144 44.3S169 444 128 416l0 96 408 0 0-118.4c14.3-8.3 24-23.8 24-41.6zM272 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLampFloor = {
  prefix: 'fass',
  iconName: 'lamp-floor',
  icon: [384, 512, [], "e015", "M0 224l64-224 256 0 64 224-160 0 0 224 96 0 0 64-256 0 0-64 96 0 0-224-160 0z"]
};
var faCompress = {
  prefix: 'fass',
  iconName: 'compress',
  icon: [448, 512, [], "f066", "M160 64l0-32-64 0 0 96-96 0 0 64 160 0 0-128zM32 320l-32 0 0 64 96 0 0 96 64 0 0-160-128 0zM352 64l0-32-64 0 0 160 160 0 0-64-96 0 0-64zM320 320l-32 0 0 160 64 0 0-96 96 0 0-64-128 0z"]
};
var faTrashPlus = {
  prefix: 'fass',
  iconName: 'trash-plus',
  icon: [448, 512, [], "e2b2", "M304-16l16 48 128 0 0 64-448 0 0-64 128 0 16-48 160 0zM32 144l384 0-24 368-336 0-24-368zM200 416l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faArrowUpAZ = {
  prefix: 'fass',
  iconName: 'arrow-up-a-z',
  icon: [512, 512, ["sort-alpha-up"], "f15e", "M150.9 41.4L128.3 18.7 3 144 48.3 189.3c14.6-14.6 30.6-30.6 48-48l0 338.7 64 0 0-338.7c17.4 17.4 33.4 33.4 48 48L253.5 144c-5.5-5.5-39.7-39.7-102.6-102.6zM354.3 32l-7.9 20.5-78.3 203.5 68.6 0 12.3-32 70.5 0 12.3 32 68.6 0-78.3-203.5-7.9-20.5-60 0zm30 100.3l16.8 43.7-33.6 0 16.8-43.7zm64 155.7l-160 0 0 64 82.7 0-82.7 82.7 0 45.3 192 0 0-64-82.7 0 82.7-82.7 0-45.3-32 0z"]
};
var faSortAlphaUp = faArrowUpAZ;
var faComma = {
  prefix: 'fass',
  iconName: 'comma',
  icon: [192, 512, [], "2c", "M48 288l-32 224 64 0 80-224-112 0z"]
};
var faSemicolon = {
  prefix: 'fass',
  iconName: 'semicolon',
  icon: [192, 512, [], "3b", "M160 64l0 128-128 0 0-128 128 0zM16 512l32-224 112 0-80 224-64 0z"]
};
var faClipboardExclamation = {
  prefix: 'fass',
  iconName: 'clipboard-exclamation',
  icon: [384, 512, [], "e757", "M320 32l64 0 0 480-384 0 0-480 64 0 0-32 256 0 0 32zM164 388l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0zm-48-80l160 0 0-48-160 0 0 48z"]
};
var faRugbyBall = {
  prefix: 'fass',
  iconName: 'rugby-ball',
  icon: [512, 512, [], "e3c6", "M53.8 455.9c-5.4-5.4-9.6-15.1-8.9-32.2 .7-17.2 6.4-39.2 17.7-65 22.6-51.4 65.6-113 124.1-171.5S306.9 85.6 358.3 63c25.8-11.3 47.8-17 65-17.7 17.1-.7 26.8 3.5 32.2 8.9s9.6 15.1 8.9 32.2c-.7 17.2-6.4 39.2-17.7 65-22.6 51.4-65.6 113-124.1 171.5S202.4 424.5 151 447.1c-25.8 11.3-47.8 17-65 17.7-17.1 .7-26.8-3.5-32.2-8.9zm99-302.6c61.7-61.7 128-108.6 186.2-134.2 2.4-1.1 4.8-2.1 7.3-3.1L336 16C159.3 16 16 159.3 16 336l0 9.6c.9-2.1 1.8-4.2 2.7-6.2 25.5-58.1 72.4-124.5 134.2-186.2zM496 157.8c-1.7 4.3-3.5 8.6-5.4 12.9-25.5 58.1-72.4 124.5-134.2 186.2S228.4 465.5 170.3 491c-4 1.7-7.9 3.4-11.9 5l17.6 0c176.7 0 320-143.3 320-320l0-18.2z"]
};
var faGridRound2Plus = {
  prefix: 'fass',
  iconName: 'grid-round-2-plus',
  icon: [448, 512, [], "e5dc", "M96 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm0 256a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM256 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM376 312l0-24-48 0 0 72-72 0 0 48 72 0 0 72 48 0 0-72 72 0 0-48-72 0 0-48z"]
};
var faUserGraduate = {
  prefix: 'fass',
  iconName: 'user-graduate',
  icon: [448, 512, [], "f501", "M448 32l-224-48-224 48 0 32 16 3.4 0 76.6-16 96 64 0-16-96 0-69.7 48 10.3 0 59.4c0 70.7 57.3 128 128 128s128-57.3 128-128l0-59.4 96-20.6 0-32zM224 224c-44.2 0-80-35.8-80-80l160 0c0 44.2-35.8 80-80 80zm-64 96l-80 0-64 192 184 0 0-152-40-40zm88 192l184 0-64-192-80 0-40 40 0 152z"]
};
var faFileCode = {
  prefix: 'fass',
  iconName: 'file-code',
  icon: [384, 512, [], "f1c9", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM154.2 295.6l15.6-18.2-36.4-31.2c-5 5.9-26.2 30.6-63.6 74.2L56.4 336c3.2 3.7 23.6 27.6 61.4 71.6l15.6 18.2 36.4-31.2c-7.2-8.5-24-28-50.2-58.6l34.6-40.4zm112-31.2l-15.6-18.2-36.4 31.2c7.2 8.5 24 28 50.2 58.6-26.2 30.6-43 50.1-50.2 58.6l36.4 31.2c5-5.8 26.2-30.6 63.6-74.2L327.6 336c-3.2-3.7-23.6-27.6-61.4-71.6z"]
};
var faCupStraw = {
  prefix: 'fass',
  iconName: 'cup-straw',
  icon: [384, 512, [129380], "e363", "M208-16l-18.4 0-4.8 17.8-25.1 94.2-151.7 0 0 48 368 0 0-48-166.6 0 17.1-64 61.6 0 0-48-80 0zM36.2 192l27.8 320 256 0 27.8-320-311.7 0z"]
};
var faSoap = {
  prefix: 'fass',
  iconName: 'soap',
  icon: [512, 512, [129532], "e06e", "M208 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 160c0 23.8-7.4 45.9-20.1 64l36.1 0 0 192-384 0 0-192 164.1 0c-12.7-18.1-20.1-40.2-20.1-64l-208 0 0 320 512 0 0-320-80 0zM112 272l0 96 288 0 0-96-288 0z"]
};
var faRecycle = {
  prefix: 'fass',
  iconName: 'recycle',
  icon: [576, 512, [9842, 9850, 9851], "f1b8", "M218.8 0l138.6 0 9.2 16 70.7 122.4 55.4-32-35.1 131.1-131.1-35.1 55.4-32-61.4-106.4-64.7 0-37.4 64.9-55.4-32 46.7-80.9 9.2-16zM453.9 295.1l55.4-32 46.7 80.9 9.2 16-9.2 16-50.8 88-9.2 16-159.8 0 0 64-96-96 96-96 0 64 122.9 0 32.3-56-37.4-64.9zm-252.1-9.6l-55.4-32-61.4 106.4 32.3 56 74.9 0 0 64-111.8 0-9.2-16-50.8-88-9.2-16 9.2-16 70.7-122.4-55.4-32 131.1-35.1 35.1 131.1z"]
};
var faSlidersUp = {
  prefix: 'fass',
  iconName: 'sliders-up',
  icon: [512, 512, ["sliders-v"], "f3f1", "M488 112l0 144-40 0 0 256-64 0 0-256-40 0 0-144 40 0 0-112 64 0 0 112 40 0zM288 32l0 272 40 0 0 144-40 0 0 64-64 0 0-64-40 0 0-144 40 0 0-304 64 0 0 32zM128 32l0 32 40 0 0 144-40 0 0 304-64 0 0-304-40 0 0-144 40 0 0-64 64 0 0 32z"]
};
var faSlidersV = faSlidersUp;
var faCircleUserClock = {
  prefix: 'fass',
  iconName: 'circle-user-clock',
  icon: [640, 512, [], "e7a7", "M496 208c-77.5 0-144.3 45.9-174.6 112l-145.4 0-23.9 71.6c34.8 34.8 82.8 56.4 135.9 56.4 7.4 0 14.6-.4 21.7-1.2 5.5 21.9 14.8 42.4 27.1 60.6-15.8 3-32.1 4.6-48.8 4.6-141.4 0-256-114.6-256-256S146.6 0 288 0c126.8 0 232.1 92.2 252.4 213.2-14.3-3.4-29.1-5.2-44.4-5.2zM288 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm64 128a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 96 80 0 0-32-48 0 0-64z"]
};
var faCarBus = {
  prefix: 'fass',
  iconName: 'car-bus',
  icon: [576, 512, [], "f85a", "M0 0l384 0 0 112.2-64-.2 0-16-256 0 0 128 80 0 0 192-32 0 0 64-80 0 0-64-32 0 0-416zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM263.9 159.8l24.2 .1 192 .5 24.1 .1c.5 1.9 12.7 44.4 36.6 127.6l35.3 0 0 224-64 0 0-48-256 0 0 48-64 0 0-224 35.3 0c23.9-83.5 36.1-126.2 36.6-128.2zm192 64.5l-143.8-.4-18.3 64 180.3 0-18.3-63.7zM288 415.5a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faSignaporeDollarSign = {
  prefix: 'fass',
  iconName: 'signapore-dollar-sign',
  icon: [512, 512, [], "e72e", "M416 0l-48 0 0 64.9c-54.2 7.1-96 53.4-96 109.6 0 53.4 38.2 99.2 90.7 108.7l47.1 8.6c22.1 4 38.2 23.3 38.2 45.7 0 25.7-20.8 46.5-46.5 46.5l-113.5 0 0 64 80 0 0 64 48 0 0-64.9c54.2-7.1 96-53.4 96-109.6 0-53.4-38.2-99.2-90.7-108.7l-47.1-8.6c-22.1-4-38.2-23.3-38.2-45.7 0-25.7 20.8-46.5 46.5-46.5l97.5 0 0-64-64 0 0-64zM110.5 64C49.5 64 0 113.5 0 174.5 0 227.9 38.2 273.7 90.7 283.2l47.1 8.6c22.1 4 38.2 23.3 38.2 45.7 0 25.7-20.8 46.5-46.5 46.5l-113.5 0 0 64 113.5 0c61 0 110.5-49.5 110.5-110.5 0-53.4-38.2-99.2-90.7-108.7l-47.1-8.6C80.1 216.2 64 197 64 174.5 64 148.8 84.8 128 110.5 128l97.5 0 0-64-97.5 0z"]
};
var faPumpkin = {
  prefix: 'fass',
  iconName: 'pumpkin',
  icon: [512, 512, [], "f707", "M208 0L188.5 78.1c1.2 .6 2.4 1.2 3.5 1.8 19.3-10 40.8-15.9 64-15.9s44.7 5.9 64 15.9c1.2-.6 2.3-1.2 3.5-1.8L304 0 208 0zM128 496c23.3 0 45.2-9.4 64-25.7 18.8 16.3 40.7 25.7 64 25.7s45.2-9.4 64-25.7c18.8 16.3 40.7 25.7 64 25.7 70.7 0 128-86 128-192S454.7 112 384 112c-23.3 0-45.2 9.3-64 25.7-18.8-16.3-40.7-25.7-64-25.7s-45.2 9.3-64 25.7C173.2 121.3 151.3 112 128 112 57.3 112 0 198 0 304S57.3 496 128 496z"]
};
var faFaceGrinWink = {
  prefix: 'fass',
  iconName: 'face-grin-wink',
  icon: [512, 512, ["grin-wink"], "f58c", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-184c58.2 0 112.4-10.6 157.7-28.7-13 75.4-78.6 132.7-157.7 132.7S111.3 374.7 98.3 299.3C143.6 317.4 197.8 328 256 328zm72-132c-11 0-20 9-20 20l0 16-40 0 0-16c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60l0 16-40 0 0-16c0-11-9-20-20-20l-16 0zM176 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGrinWink = faFaceGrinWink;
var faFolderArrowDown = {
  prefix: 'fass',
  iconName: 'folder-arrow-down',
  icon: [512, 512, ["folder-download"], "e053", "M512 80l0 368-512 0 0-416 224 0 64 48 224 0zM239 361l17 17c2.1-2.1 31.8-31.8 89-89l17-17-33.9-33.9c-9 9-25 25-48 48l0-126.1-48 0 0 126.1c-23-23-39-39-48-48L150.1 272c2.1 2.1 31.8 31.8 89 89z"]
};
var faFolderDownload = faFolderArrowDown;
var faSignPosts = {
  prefix: 'fass',
  iconName: 'sign-posts',
  icon: [512, 512, [], "e625", "M64 16l0 48-64 0 0 384 64 0 0 64 64 0 0-64 256 0 0 64 64 0 0-64 64 0 0-384-64 0 0-48-64 0 0 48-256 0 0-48-64 0z"]
};
var faSkeletonRibs = {
  prefix: 'fass',
  iconName: 'skeleton-ribs',
  icon: [640, 512, [], "e5cb", "M352 32l0-32-64 0 0 64-82.1 0-9.3 15.5C127.7 194.3 96 316.4 96 448l0 32 101.8 0 5.4-2 84.8-31.8 0 65.8 64 0 0-65.8 84.8 31.8 5.4 2 101.8 0 0-32c0-131.6-31.7-253.7-100.6-368.5l-9.3-15.5-82.1 0 0-32zm-64 96l0 38.3-73.2 16.3c8.2-18.4 17.4-36.6 27.6-54.6l45.6 0zM188 254.1l100-22.2 0 40.3-113.5 34.1c3.8-17.6 8.2-35 13.5-52.1zM163.5 376.3l5.6-1.7 118.8-35.6 0 38.8-101.8 38.2-25.5 0c.6-13.3 1.5-26.6 2.9-39.7zM352 377.8l0-38.8 118.8 35.6 5.6 1.7c1.3 13.1 2.3 26.3 2.9 39.7l-25.5 0-101.8-38.2zm113.5-71.6l-113.5-34.1 0-40.3 100 22.2c5.3 17.2 9.8 34.6 13.5 52.1zM425.2 182.6l-73.2-16.3 0-38.3 45.6 0c10.2 18 19.3 36.2 27.6 54.6zM0 80l0 432 64 0 0-288 16-12c30.2-22.7 48-58.2 48-96l0-36-128 0zm608 0l-96 0 0 36c0 37.8 17.8 73.3 48 96l16 12 0 288 64 0 0-432-32 0z"]
};
var faQrcodeRead = {
  prefix: 'fass',
  iconName: 'qrcode-read',
  icon: [512, 512, [], "e799", "M24 0l-24 0 0 160 48 0 0-112 112 0 0-48-136 0zM376 0l-24 0 0 48 112 0 0 112 48 0 0-160-136 0zM48 376l0-24-48 0 0 160 160 0 0-48-112 0 0-88zm464 0l0-24-48 0 0 112-112 0 0 48 160 0 0-136zM152 152l32 0 0 32-32 0 0-32zM96 96l0 144 144 0 0-144-144 0zm232 56l32 0 0 32-32 0 0-32zM272 96l0 144 144 0 0-144-144 0zM184 328l0 32-32 0 0-32 32 0zm-32-56l-56 0 0 144 144 0 0-144-88 0zm176 0l-56 0 0 56 56 0 0-56zm-56 88l0 56 56 0 0-56-56 0zm144-88l-56 0 0 56 56 0 0-56zm-56 88l0 56 56 0 0-56-56 0z"]
};
var faCircleDollar = {
  prefix: 'fass',
  iconName: 'circle-dollar',
  icon: [512, 512, ["dollar-circle", "usd-circle"], "f2e8", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-368l40 0 0 48-85.6 0c-10.2 0-18.4 8.2-18.4 18.4 0 9.2 6.8 17 16 18.2l54.4 7.2c33 4.4 57.7 32.5 57.7 65.8 0 35.9-28.4 65.1-64 66.3l0 40-48 0 0-40-56 0 0-48 101.6 0c10.2 0 18.4-8.2 18.4-18.4 0-9.2-6.8-17-16-18.2l-54.4-7.2c-33-4.4-57.7-32.5-57.7-65.8 0-35.9 28.4-65.1 64-66.3l0-40 48 0 0 40z"]
};
var faDollarCircle = faCircleDollar;
var faUsdCircle = faCircleDollar;
var faSiren = {
  prefix: 'fass',
  iconName: 'siren',
  icon: [448, 512, [], "e02d", "M48 304l32-272 288 0 32 272-235.4 0 19.3-173.3 .3-2.7-48.3 0-19.6 176-68.3 0zM0 352l448 0 0 128-448 0 0-128z"]
};
var faWaterLadder = {
  prefix: 'fass',
  iconName: 'water-ladder',
  icon: [640, 512, ["ladder-water", "swimming-pool"], "f5c5", "M449.3 385.7l111.8 44.7c29.3-9.8 50.1-16.7 62.4-20.8l15.2 45.5-79.1 26.4-8.2-3.3-111.1-44.4-111.1 44.4-8.9 3.6-120-48-111.1 44.4-8.2 3.3-8.3-2.8-70.8-23.6 15.2-45.5c12.3 4.1 33.2 11 62.4 20.8l111.8-44.7 8.9-3.6 8.9 3.6 111.1 44.4 120-48 8.9 3.6zM512.4 32c53 0 96 43 96 96l0 32-64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 218.6-13.3-5.3-26.7-10.7-24 9.6 0-52.2-192 0 0 52.2-24-9.6-26.8 10.7-13.2 5.3 0-218.6c0-53 43-96 96-96s96 43 96 96l0 32-64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96 192 0 0-96c0-53 43-96 96-96z"]
};
var faLadderWater = faWaterLadder;
var faSwimmingPool = faWaterLadder;
var faTtyAnswer = {
  prefix: 'fass',
  iconName: 'tty-answer',
  icon: [640, 512, ["teletype-answer"], "e2b9", "M128 0L0 64 0 80C0 318.6 193.4 512 432 512l16 0 64-128-128-96.8-80 80.8c-70.4-33-127-89.6-160-160L224.7 128 128 0zM352 32l-64 0 0 64 64 0 0-64zm0 96l-64 0 0 64 64 0 0-64zm224 0l0 64 64 0 0-64-64 0zM448 32l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zm160 0l-64 0 0 64 64 0 0-64zM384 136l0 48 160 0 0-48-160 0z"]
};
var faTeletypeAnswer = faTtyAnswer;
var faSquareThisWayUp = {
  prefix: 'fass',
  iconName: 'square-this-way-up',
  icon: [448, 512, ["box-up"], "f49f", "M448 32l-448 0 0 448 448 0 0-448zM352 400l-256 0 0-48 256 0 0 48zM62.1 192c6.1-6.1 27.8-27.8 65-65l17-17 80 80c4.5-4.5 25.5-25.5 63-63l17-17c6.1 6.1 27.8 27.8 65 65l17 17-33.9 33.9c-13-13-21-21-24-24l0 102.1-48 0 0-102.1c-3 3-11 11-24 24l-32-32-32 32c-13-13-21-21-24-24l0 102.1-48 0 0-102.1c-3 3-11 11-24 24L62.1 192z"]
};
var faBoxUp = faSquareThisWayUp;
var faTowerCell = {
  prefix: 'fass',
  iconName: 'tower-cell',
  icon: [576, 512, [], "e585", "M48 128c0-38.6 9.1-75.1 25.3-107.4L32 0 17.4 29.2C6.1 60 0 93.3 0 128s6.1 68 17.4 98.8L32 256 73.3 235.4C57.1 203.1 48 166.6 48 128zm56 0c0 29.6 7 57.5 19.4 82.3l42.9-21.5c-9.2-18.3-14.3-39-14.3-60.8s5.2-42.5 14.3-60.8L123.4 45.7C111 70.5 104 98.4 104 128zM452.6 45.7L409.7 67.2c9.2 18.3 14.3 39 14.3 60.8s-5.2 42.5-14.3 60.8l42.9 21.5C465 185.5 472 157.6 472 128s-7-57.5-19.4-82.3zM528 128c0 38.6-9.1 75.1-25.3 107.4L544 256 558.6 226.8C569.9 196 576 162.7 576 128s-6.1-68-17.4-98.8L544 0 502.7 20.6C518.9 52.9 528 89.4 528 128zM496 512L336.9 169.3c9.4-11.1 15.1-25.6 15.1-41.3 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 15.7 5.7 30.2 15.1 41.3l-159.1 342.7 70.6 0 29.7-64 215.4 0 29.7 64 70.6 0zM351.2 352l22.3 48-170.9 0 22.3-48 126.3 0zM288 216l40.9 88-81.7 0 40.9-88z"]
};
var faGalleryThumbnails = {
  prefix: 'fass',
  iconName: 'gallery-thumbnails',
  icon: [576, 512, [], "e3aa", "M0 64l576 0 0 224-576 0 0-224zM0 352l96 0 0 96-96 0 0-96zm256 0l0 96-96 0 0-96 96 0zm64 0l96 0 0 96-96 0 0-96zm256 0l0 96-96 0 0-96 96 0z"]
};
var faColonSign = {
  prefix: 'fass',
  iconName: 'colon-sign',
  icon: [384, 512, [], "e140", "M191 2.9l46.6 11.6c-4.1 16.3-7.6 30.2-10.4 41.7 15.4 .8 30.4 3.4 44.7 7.5 6.9-27.4 11.9-47.7 15.2-60.9l46.6 11.6-17.1 68.3c23.4 13.5 43.8 31.7 59.9 53.2l-51.2 38.4c-7.3-9.7-15.8-18.3-25.3-25.7L239.7 390c34.8-6 65.1-25.2 85.6-52.4L376.5 376c-35.2 46.8-90.5 77.8-153.2 79.8-5.3 21.1-9.7 38.8-13.3 53.2l-46.6-11.6c3.9-15.6 7.7-30.9 11.5-45.8-15-3.2-29.4-8-42.9-14.4-9.1 36.6-15.1 60.5-18 71.8L67.4 497.5c2.2-8.7 9.5-37.8 21.8-87.2-44.4-36.7-72.7-92.2-72.7-154.3 0-96.9 68.8-177.6 160.3-196.1 6.1-24.3 10.8-43.3 14.3-57zm-.7 386.6l65.9-263.6c-12.6-3.8-25.9-5.9-39.8-5.9-1.8 0-3.5 0-5.3 .1L147.9 373.4c13 7.6 27.3 13.1 42.5 16.1zM80.5 256c0 30.5 10 58.6 26.9 81.3l51.1-204.3c-46.1 21.8-78 68.7-78 123.1z"]
};
var faLaptopFile = {
  prefix: 'fass',
  iconName: 'laptop-file',
  icon: [576, 512, [], "e51d", "M64 0l416 0 0 112-64 0 0-48-288 0 0 192 112 0 0 96-192 0-48-48 0-48 64 0 0-256zM544 272l0 240-256 0 0-352 144 0 112 112zM416 288l76.1 0-76.1-76.1 0 76.1z"]
};
var faCircleHalfStrokeHorizontal = {
  prefix: 'fass',
  iconName: 'circle-half-stroke-horizontal',
  icon: [512, 512, [], "e80d", "M512 256a256 256 0 1 1 -512 0 256 256 0 1 1 512 0zm-64 0c0-106-86-192-192-192S64 150 64 256l384 0z"]
};
var faBahai = {
  prefix: 'fass',
  iconName: 'bahai',
  icon: [576, 512, ["haykal"], "f666", "M288.2-27.2c19 40.4 38.9 82.7 59.8 127 44.4-20.5 86.9-40.2 127.4-58.9-11.4 43.1-23.4 88.4-35.9 135.7 47.2 12.8 92.4 25.1 135.4 36.8-36.5 25.7-74.7 52.7-114.7 80.9 27.9 40.2 54.6 78.6 80.1 115.2-44.5-3.7-91.1-7.7-139.9-11.8-4.4 48.7-8.7 95.3-12.7 139.8-31.7-31.4-64.9-64.4-99.6-98.9-34.7 34.5-67.9 67.5-99.6 98.9L175.9 397.8c-48.8 4.1-95.4 8-139.9 11.8 25.5-36.6 52.2-75.1 80.1-115.2-40-28.2-78.2-55.2-114.7-80.9 43.1-11.7 88.2-24 135.4-36.8-12.5-47.3-24.5-92.6-35.9-135.7 40.5 18.7 83 38.4 127.4 58.9 20.8-44.3 40.8-86.6 59.8-127zm0 150.3c-10.6 22.4-20.2 42.9-28.9 61.4-18.6-8.6-39.1-18.1-61.6-28.5 6.3 24 12.1 45.8 17.3 65.6-19.8 5.4-41.6 11.3-65.5 17.8 20.3 14.3 38.8 27.3 55.5 39.1-11.7 16.8-24.6 35.4-38.7 55.7 24.7-2.1 47.3-4 67.6-5.7 1.9 20.4 3.9 42.9 6.1 67.6 17.6-17.5 33.6-33.4 48.2-47.8 14.5 14.4 30.6 30.4 48.2 47.8 2.2-24.7 4.3-47.2 6.1-67.6 20.4 1.7 42.9 3.6 67.6 5.7-14.2-20.4-27.1-38.9-38.7-55.7 16.7-11.8 35.2-24.8 55.5-39.1-23.9-6.5-45.8-12.4-65.5-17.8 5.2-19.8 11-41.7 17.3-65.6-22.5 10.4-43 19.9-61.6 28.5-8.7-18.5-18.3-39-28.9-61.4z"]
};
var faHaykal = faBahai;
var faMoneyBill1 = {
  prefix: 'fass',
  iconName: 'money-bill-1',
  icon: [512, 512, ["money-bill-alt"], "f3d1", "M512 64l-512 0 0 384 512 0 0-384zM256 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM64 192l0-64 64 0c0 35.3-28.7 64-64 64zm0 128c35.3 0 64 28.7 64 64l-64 0 0-64zM384 128l64 0 0 64c-35.3 0-64-28.7-64-64zm64 192l0 64-64 0c0-35.3 28.7-64 64-64zM240 188l-20 0 0 40 16 0 0 48-24 0 0 40 88 0 0-40-24 0 0-88-36 0z"]
};
var faMoneyBillAlt = faMoneyBill1;
var faCloudBolt = {
  prefix: 'fass',
  iconName: 'cloud-bolt',
  icon: [512, 512, [127785, "thunderstorm"], "f76c", "M0 320l140.6 0 161.9-136 78.3 0-32.4 136 163.6 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80-24.3 0-46.1 10.9-60.8 28-18.7-35.7-56.1-60-99.2-60-61.9 0-112 50.1-112 112l0 21.5C26.7 146.6 0 182.2 0 224l0 96zm120 80l104.4 0-32.4 136 200-168-104.4 0 32.4-136-200 168z"]
};
var faThunderstorm = faCloudBolt;
var faCircleBookmark = {
  prefix: 'fass',
  iconName: 'circle-bookmark',
  icon: [512, 512, ["bookmark-circle"], "e100", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM160 384l0-256 192 0 0 256-96-64-96 64z"]
};
var faBookmarkCircle = faCircleBookmark;
var faEthernet = {
  prefix: 'fass',
  iconName: 'ethernet',
  icon: [512, 512, [], "f796", "M0 192l0 256 64 0 0-128 48 0 0 128 64 0 0-128 48 0 0 128 64 0 0-128 48 0 0 128 64 0 0-128 48 0 0 128 64 0 0-256-64 0 0-64-64 0 0-64-256 0 0 64-64 0 0 64-64 0z"]
};
var faCirclesOverlap3 = {
  prefix: 'fass',
  iconName: 'circles-overlap-3',
  icon: [576, 512, ["pronoun"], "e6a1", "M176 160c0 5.4 .4 10.8 1.1 16 42.1 .3 80.7 15.3 110.9 40.2 30.2-24.9 68.8-40 110.9-40.2 .7-5.2 1.1-10.6 1.1-16 0-61.9-50.1-112-112-112S176 98.1 176 160zm-61.9 27.2c-1.4-8.9-2.1-17.9-2.1-27.2 0-97.2 78.8-176 176-176S464 62.8 464 160c0 9.2-.7 18.3-2.1 27.2 66.7 25.1 114.1 89.4 114.1 164.8 0 97.2-78.8 176-176 176-42.5 0-81.6-15.1-112-40.2-30.4 25.1-69.5 40.2-112 40.2-97.2 0-176-78.8-176-176 0-75.4 47.4-139.7 114.1-164.8zM349.9 324.8c1.4 8.9 2.1 17.9 2.1 27.2 0 31.5-8.3 61.2-22.8 86.8 19.3 15.8 44 25.2 70.8 25.2 61.9 0 112-50.1 112-112 0-47.5-29.6-88.1-71.3-104.4-20.2 35.2-52.3 62.7-90.8 77.2zm-123.8 0c-38.5-14.5-70.5-42-90.8-77.2-41.7 16.3-71.3 56.9-71.3 104.4 0 61.9 50.1 112 112 112 26.9 0 51.5-9.5 70.8-25.2-14.5-25.6-22.8-55.2-22.8-86.8 0-9.3 .7-18.3 2.1-27.2z"]
};
var faPronoun = faCirclesOverlap3;
var faHryvniaSign = {
  prefix: 'fass',
  iconName: 'hryvnia-sign',
  icon: [384, 512, [8372, "hryvnia"], "f6f2", "M336 149.4C336 77 268.5 23.5 198 40.1 115.9 59.5 70.6 70.2 62.1 72.2l14.7 62.3c8.5-2 53.8-12.7 135.9-32.1 30.3-7.1 59.3 15.8 59.3 46.9 0 17.6-9.6 33.8-25 42.3l-.7 .4-246.3 0 0 48 384 0 0-48-56.4 0c5.5-13.3 8.4-27.8 8.4-42.6zM384 272l-384 0 0 48 57.3 0c-6.1 13.4-9.3 28.1-9.3 43.3 0 64.1 56.9 113.4 120.4 104.2 109.7-15.8 166.2-24 169.6-24.5l-9.1-63.3c-3.4 .5-60 8.7-169.6 24.5-24.9 3.6-47.2-15.7-47.2-40.9 0-15.1 8.2-28.9 21.4-36.2l13-7.1 237.6 0 0-48z"]
};
var faHryvnia = faHryvniaSign;
var faAtomSimple = {
  prefix: 'fass',
  iconName: 'atom-simple',
  icon: [448, 512, ["atom-alt"], "f5d3", "M69.4 411.1c-1.3-1.3-12.4-16.8 3.3-64 3.5-10.4 8-21.4 13.6-32.9 11.6 14.2 24.3 28.3 38 41.9s27.7 26.4 41.9 38c-11.4 5.6-22.4 10.2-32.8 13.6-47.2 15.7-62.7 4.6-64 3.3zM122.2 256c13.5-18.3 29.3-36.8 47.4-54.9s36.6-33.9 54.9-47.4c18.3 13.5 36.8 29.3 54.9 47.4s33.9 36.6 47.4 54.9c-13.5 18.3-29.3 36.8-47.4 54.9s-36.6 33.9-54.9 47.4c-18.3-13.5-36.8-29.3-54.9-47.4s-33.9-36.6-47.4-54.9zm44.1-138.1c-14.2 11.6-28.3 24.3-41.9 38s-26.4 27.7-38 41.9c-5.6-11.4-10.2-22.4-13.6-32.8-15.7-47.2-4.6-62.7-3.3-64s16.8-12.4 64 3.3c10.4 3.5 21.4 8 32.8 13.6zm58.2-41.1C142.4 27.6 63.4 16.5 24.2 55.7S-3.9 173.9 45.3 256C-3.9 338.1-15 417.1 24.2 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1S452.9 338.1 403.7 256C452.9 173.9 464 94.9 424.8 55.7S306.6 27.6 224.5 76.8zm58.2 41.1c11.4-5.6 22.4-10.2 32.9-13.6 47.2-15.7 62.7-4.6 64-3.3s12.4 16.8-3.3 64c-3.5 10.4-8 21.4-13.6 32.8-11.6-14.2-24.3-28.3-38-41.9s-27.7-26.4-41.9-38zm79.9 196.3c5.6 11.4 10.2 22.4 13.6 32.9 15.7 47.2 4.6 62.7 3.3 64s-16.8 12.4-64-3.3c-10.4-3.5-21.4-8-32.9-13.6 14.2-11.6 28.3-24.3 41.9-38s26.4-27.7 38-41.9zM224.5 296l40-40-40-40-40 40 40 40z"]
};
var faAtomAlt = faAtomSimple;
var faFilesMedical = {
  prefix: 'fass',
  iconName: 'files-medical',
  icon: [448, 512, [], "f7fd", "M320 0l-224 0 0 448 352 0 0-320-128-128zm69.5 160L288 160 288 58.5 389.5 160zM48 96l-48 0 0 448 352 0 0-48-304 0 0-400zM240 200l64 0 0 56 56 0 0 64-56 0 0 56-64 0 0-56-56 0 0-64 56 0 0-56z"]
};
var faSalad = {
  prefix: 'fass',
  iconName: 'salad',
  icon: [512, 512, [129367, "bowl-salad"], "f81e", "M272.9 240c-.6-5.3-.9-10.6-.9-16 0-79.5 64.5-144 144-144 2.6 0 5.2 .1 7.7 .2-17.6-19.8-43.2-32.2-71.7-32.2-11.4 0-22.3 2-32.4 5.6-19.7-32.2-55.1-53.6-95.6-53.6s-75.9 21.5-95.6 53.6C118.3 50 107.4 48 96 48 43 48 0 91 0 144s43 96 96 96l51.7 0c-52.5-52.5-79.2-79.2-80-80l28.3-28.3 14.1 14.1 93.9 93.9 0-147.7 40 0 0 148 28.9 0zM512 288L0 288 0 312c0 67 39.2 124.9 96 151.8l0 48.2 320 0 0-48.2c56.8-27 96-84.8 96-151.8l0-24zm0-64c0-53-43-96-96-96s-96 43-96 96c0 5.5 .5 10.8 1.3 16l189.3 0c.9-5.2 1.3-10.5 1.3-16z"]
};
var faBowlSalad = faSalad;
var faPawSimple = {
  prefix: 'fass',
  iconName: 'paw-simple',
  icon: [448, 512, ["paw-alt"], "f701", "M192 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-16 80L107.7 283c-43.5 10.9-75.7 50.2-75.7 97 0 55.2 44.8 100 100 100 24.8 0 47.5-9 65-24l54 0c17.5 15 40.2 24 65 24 55.2 0 100-44.8 100-100 0-46.8-32.2-86.2-75.7-97l-68.3-123-96 0zm128-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm144 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 240a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faPawAlt = faPawSimple;
var faEyeSlash = {
  prefix: 'fass',
  iconName: 'eye-slash',
  icon: [576, 512, [], "f070", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-90.4-90.4c53.7-48.2 89.3-109 105.2-148.7-30-74.7-129.6-224-288-224-55.6 0-103.9 18.4-144.5 45.5L49.3-16.9zM204.7 138.6c23.5-16.7 52.3-26.6 83.4-26.6 79.5 0 144 64.5 144 144 0 31.1-9.8 59.9-26.6 83.4l-34.7-34.7c8.4-14.3 13.3-30.9 13.3-48.7 0-53-43-96-96-96-17.8 0-34.4 4.8-48.7 13.3l-34.7-34.7zM325.4 395.1c-11.9 3.2-24.4 4.9-37.3 4.9-79.5 0-144-64.5-144-144 0-12.9 1.7-25.4 4.9-37.3L71.8 141.5c-35.2 40.4-59.3 83.8-71.7 114.5 30 74.7 129.6 224 288 224 36.8 0 70.5-8.1 100.8-21.4l-63.5-63.5z"]
};
var faPlateUtensils = {
  prefix: 'fass',
  iconName: 'plate-utensils',
  icon: [640, 512, [58713], "e43b", "M56 16L40 16 0 152c0 41.5 31.6 75.6 72 79.6l0 264.4 48 0 0-264.4c40.4-4 72-38.1 72-79.6l-40-136-16 0 0 136-16 0-16-136-16 0-16 136-16 0 0-136zm584 0S512 32 512 160l0 160 80 0 0 176 48 0 0-480zM336 32c-43.8 0-84.7 12.6-119.2 34.3l19.1 64.9c27.4-22 62.2-35.2 100.1-35.2 52.3 0 98.8 25.1 128 64 0-29.7 5.5-55.2 14.5-76.9-38.7-31.9-88.3-51.1-142.5-51.1zm0 384c-86.1 0-156.3-68-159.9-153.2-2.7 1.5-5.4 3-8.1 4.3l0 137c41 46.5 101.1 75.8 168 75.8 82.9 0 155.3-45 194-112l-66 0 0-16c-29.2 38.9-75.7 64-128 64zM448 256a112 112 0 1 0 -224 0 112 112 0 1 0 224 0z"]
};
var faCircleO = {
  prefix: 'fass',
  iconName: 'circle-o',
  icon: [512, 512, [], "e119", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM184 256a72 72 0 1 0 144 0 72 72 0 1 0 -144 0zm72 120a120 120 0 1 1 0-240 120 120 0 1 1 0 240z"]
};
var faJugBottle = {
  prefix: 'fass',
  iconName: 'jug-bottle',
  icon: [512, 512, [], "e5fb", "M224 0l-128 0 0 48-32 0 0 48 192 0 0-48-32 0 0-48zM128 128C57.3 128 0 185.3 0 256l0 256 220.1 0-12.1-12.1 0-51.9 0 0 0-256 0 0 0-25.7c11.8-7.9 31-20.6 57.5-38.3L128 128zM320 64l0 64 128 0 0-64-128 0zm-16 96l-48 32 0 64 24 24-24 24 0 64 24 24-24 24 0 64 32 32 192 0 32-32 0-64-24-24 24-24 0-64-24-24 24-24 0-64-48-32-160 0z"]
};
var faClockTwo = {
  prefix: 'fass',
  iconName: 'clock-two',
  icon: [512, 512, [], "e35a", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392l0 91.2c45.6-30.4 71.8-47.9 78.7-52.4l26.6 39.9c-.6 .4-39.3 26.2-116 77.3l-37.3 24.9 0-204.8 48 0 0 24z"]
};
var faCartFlatbedSuitcase = {
  prefix: 'fass',
  iconName: 'cart-flatbed-suitcase',
  icon: [576, 512, ["luggage-cart"], "f59d", "M0 0l128 0 0 384 448 0 0 64-66.7 0c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16l-197.5 0c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16L64 448 64 64 0 64 0 0zM432 96l80 0 0 240-336 0 0-240 80 0 0-80 176 0 0 80zm-48 0l0-32-80 0 0 32 80 0z"]
};
var faLuggageCart = faCartFlatbedSuitcase;
var faFolderImage = {
  prefix: 'fass',
  iconName: 'folder-image',
  icon: [512, 512, [], "e18a", "M512 80l0 368-512 0 0-416 224 0 64 48 224 0zM192 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 384l0-48-128-112-128 112 0 48 256 0z"]
};
var faRadiation = {
  prefix: 'fass',
  iconName: 'radiation',
  icon: [576, 512, [], "f7b9", "M419.3 17.7C503.2 64 560 153.4 560 256l-176 0c0-37.5-21.5-69.9-52.8-85.7L419.3 17.7zm-262.6 0l88.1 152.5C213.5 186.1 192 218.5 192 256L16 256C16 153.4 72.8 64 156.7 17.7zm-9.4 471.1l88.1-152.5c15.1 9.9 33.2 15.7 52.6 15.7s37.5-5.8 52.6-15.7l88.1 152.5C387.6 513.7 339.5 528 288 528s-99.6-14.3-140.7-39.2zM288 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faFileWord = {
  prefix: 'fass',
  iconName: 'file-word',
  icon: [384, 512, [], "f1c2", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM120.5 428.7l3.9 19.3 37 0c.4-1.1 10.6-31.8 30.7-92.1 20.1 60.3 30.4 91 30.7 92.1l37 0 3.9-19.3 34.5-172.7-49 0-14.9 74.7c-15.3-45.8-23.6-70.7-24.9-74.7l-34.6 0c-1.3 4-9.6 28.9-24.9 74.7l-14.9-74.7-49 0 34.5 172.7z"]
};
var faBedPulse = {
  prefix: 'fass',
  iconName: 'bed-pulse',
  icon: [640, 512, ["procedures"], "f487", "M512-32l21.3 0c.4 .6 13.7 21.9 40 64l66.7 0 0 48-93.3 0c-2.3-3.7-11.8-18.8-28.3-45.3l-48.7 103.5-6.5 13.8-37.4 0-6.9-12.3-33.1-59.7-65.9 0 0-48 94.1 0c2.1 3.8 11.6 20.9 28.4 51.2L490.3-18.2 496.8-32 512-32zM352 128l14.8 0 35.6 64 86.3 0c12.3-26.1 22.3-47.4 30-63.8 49.9 3.4 89.4 45 89.4 95.8l0 256-64 0 0-96-448 0 0 96-64 0 0-448 64 0 0 256 224 0 0-160 32 0zM144 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faProcedures = faBedPulse;
var faBlock = {
  prefix: 'fass',
  iconName: 'block',
  icon: [448, 512, [], "e46a", "M0 32l448 0 0 448-448 0 0-448zm96 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM96 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faShovel = {
  prefix: 'fass',
  iconName: 'shovel',
  icon: [640, 512, [], "f713", "M480.3-45.3c2.9 2.9 42.4 42.4 118.6 118.6L621.5 96c-11.5 11.5-33.8 33.8-66.7 66.7-18.7 18.7-44.1 29.3-70.6 29.3-15.9 0-30.9-3.7-44.3-10.3l-129 129 73.4 73.4-118.8 118.8c-26.4 26.4-62.2 41.2-99.5 41.2-73.8 0-133.7-59.9-133.7-133.7 0-37.3 14.8-73.1 41.2-99.5l118.8-118.8 73.4 73.4 129-129c-6.6-13.3-10.3-28.4-10.3-44.3 0-26.5 10.5-51.9 29.3-70.6 33-33 55.2-55.2 66.7-66.7zm0 90.5L458.8 66.7c-6.7 6.7-10.5 15.9-10.5 25.4 0 19.8 16.1 35.9 35.9 35.9 9.5 0 18.6-3.8 25.4-10.5L531 96 480.3 45.3z"]
};
var faTents = {
  prefix: 'fass',
  iconName: 'tents',
  icon: [576, 512, [], "e582", "M576 352l-131.9 0c-8.1-63.6-12.4-97.8-13-102.6L412.7 237.2 234.4 119.9 210.1 103.9 368 0 546.3 117.3 576 352zM0 512L29.7 277.3 208 160 386.3 277.3 416 512 312 512 208 365.3 208 512 0 512z"]
};
var faDropletPercent = {
  prefix: 'fass',
  iconName: 'droplet-percent',
  icon: [384, 512, ["humidity"], "f750", "M192 512C86 512 0 426 0 320S192-32 192-32 384 214 384 320 298 512 192 512zm89.9-248l-33.9-33.9-17 17-112 112-17 17 33.9 33.9 17-17 112-112 17-17zM136 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm136 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faHumidity = faDropletPercent;
var faMugHot = {
  prefix: 'fass',
  iconName: 'mug-hot',
  icon: [576, 512, [9749], "f7b6", "M176-16l-48 0 0 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C184.5 96.3 192 103.9 192 120l0 24 48 0 0-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C183.5 31.7 176 24.1 176 8l0-24zM384 192l-320 0 0 320 384 0 0-64c70.7 0 128-57.3 128-128S518.7 192 448 192l-64 0zm64 192l0-128c35.3 0 64 28.7 64 64s-28.7 64-64 64zM288 8l0-24-48 0 0 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C296.5 96.3 304 103.9 304 120l0 24 48 0 0-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C295.5 31.7 288 24.1 288 8z"]
};
var faBolt = {
  prefix: 'fass',
  iconName: 'bolt',
  icon: [512, 512, [9889, "zap"], "f0e7", "M0 288L384-32 294.4 224 512 224 128 544 217.6 288 0 288z"]
};
var faZap = faBolt;
var faUserVneckHairLong = {
  prefix: 'fass',
  iconName: 'user-vneck-hair-long',
  icon: [448, 512, [], "e463", "M304 128c0-18-6-34.6-16-48l0 0-64 48-80 0 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zm48 0l0 48 48 96-352 0 48-96 0-48C96 57.3 153.3 0 224 0S352 57.3 352 128zM224 384l64-64 80 0 64 192-416 0 64-192 80 0 64 64z"]
};
var faReflectVertical = {
  prefix: 'fass',
  iconName: 'reflect-vertical',
  icon: [448, 512, [], "e665", "M224 176L400 0 48 0 224 176zM0 232l0 48 448 0 0-48-448 0zM400 512L224 336 48 512 400 512z"]
};
var faMoneyBillSimpleWave = {
  prefix: 'fass',
  iconName: 'money-bill-simple-wave',
  icon: [512, 512, [], "e1f2", "M0 60.3L0 451.7c110.8 45.6 182.4 21.7 253.6-2 72.8-24.3 145.1-48.4 258.4 2l0-391.5c-110.8-45.6-182.4-21.7-253.6 2-72.8 24.3-145.1 48.4-258.4-2zM256 352c-44.2 0-80-43-80-96s35.8-96 80-96 80 43 80 96-35.8 96-80 96z"]
};
var faLightbulbExclamation = {
  prefix: 'fass',
  iconName: 'lightbulb-exclamation',
  icon: [384, 512, [], "f671", "M288 528l-192 0 0-96 192 0 0 96zM192 0c106 0 192 86 192 192 0 71.1-38.6 133.1-96 166.3l0 25.7-192 0 0-25.7C38.6 325.1 0 263.1 0 192 0 86 86 0 192 0zM164 252l0 56 56 0 0-56-56 0zM160 72l12.8 144 38.4 0 12.8-144-64 0z"]
};
var faAperture = {
  prefix: 'fass',
  iconName: 'aperture',
  icon: [512, 512, [], "e2df", "M256 0c9.1 0 18.1 .5 26.9 1.4L163.6 208 82.6 67.7C128.2 25.7 189.1 0 256 0zM0 256c0-56.3 18.2-108.3 49-150.6L168.2 312 6.1 312C2.1 294 0 275.2 0 256zM179.6 500.4C109.1 478.4 51.7 426.7 22 360l238.6 0-81.1 140.4zM256 512c-9.1 0-18.1-.5-26.9-1.4l119.3-206.6 81 140.3C383.8 486.3 322.9 512 256 512zM512 256c0 56.3-18.2 108.3-49 150.6L343.8 200 505.9 200c4 18 6.1 36.8 6.1 56zM332.4 11.6C402.9 33.6 460.3 85.3 490 152l-238.6 0 81.1-140.4z"]
};
var faJar = {
  prefix: 'fass',
  iconName: 'jar',
  icon: [320, 512, [], "e516", "M32-32l256 0 0 48-256 0 0-48zM0 64l320 0 0 448-320 0 0-448zM256 192l-192 0 0 192 192 0 0-192z"]
};
var faArrowDownFromArc = {
  prefix: 'fass',
  iconName: 'arrow-down-from-arc',
  icon: [512, 512, [], "e614", "M256 66.7c-106 0-192 86-192 192l0 32-64 0 0-32C0 117.4 114.6 2.7 256 2.7s256 114.6 256 256l0 32-64 0 0-32c0-106-86-192-192-192zM121.4 390.6L98.7 368 144 322.7c9.3 9.3 36 36 80 80l0-240 64 0 0 240 80-80 45.3 45.3-157.3 157.3c-.2-.2-45.1-45.1-134.6-134.6z"]
};
var faTruckPlane = {
  prefix: 'fass',
  iconName: 'truck-plane',
  icon: [640, 512, [], "e58f", "M144 48l0 113.6-144 158.4 0 80 144-57.6 0 57.6-80 64 0 48 128-32 48 12 0-444c0-26.5-21.5-48-48-48s-48 21.5-48 48zm496 80l-352 0 0 320 32 0 0 64 64 0 0-64 160 0 0 64 64 0 0-64 32 0 0-320zM368 304l0-64 192 0 0 64-192 0zm0 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSignalFair = {
  prefix: 'fass',
  iconName: 'signal-fair',
  icon: [512, 512, ["signal-2"], "f68d", "M176 344l0-24-48 0 0 160 48 0 0-136zM72 408l0-24-48 0 0 96 48 0 0-72z"]
};
var faSignal2 = faSignalFair;
var faHandHoldingHeart = {
  prefix: 'fass',
  iconName: 'hand-holding-heart',
  icon: [576, 512, [], "f4be", "M279.6 23.1c-14.1-19.5-36.7-31-60.7-31-41.4 0-74.9 33.5-74.9 74.9l0 2.4c0 85.3 144 178.7 144 178.7S432 154.8 432 69.4l0-2.4c0-41.4-33.5-74.9-74.9-74.9-24 0-46.6 11.5-60.7 31l-8.4 11.7-8.4-11.7zM137.4 313.5l-70.6 70.6-66.7 0 0 128 396.4 0 10.2-7c101.2-69.6 154.8-106.4 161-110.7l-45.3-65.9c-11.7 8.1-54.2 37.3-127.5 87.6l-138.8 0 0-48 128 0 0-64-237.3 0-9.4 9.4z"]
};
var faArrowRotateLeft = {
  prefix: 'fass',
  iconName: 'arrow-rotate-left',
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M64 32l0-32-64 0 0 192 192 0 0-64-79.1 0c35.2-39.3 86.3-64 143.1-64 106 0 192 86 192 192S362 448 256 448c-75 0-140-43-171.6-105.8L27.2 370.9C69.2 454.5 155.9 512 256 512 397.4 512 512 397.4 512 256S397.4 0 256 0C179.5 0 110.9 33.6 64 86.7L64 32z"]
};
var faArrowLeftRotate = faArrowRotateLeft;
var faArrowRotateBack = faArrowRotateLeft;
var faArrowRotateBackward = faArrowRotateLeft;
var faUndo = faArrowRotateLeft;
var faAnglesUpDown = {
  prefix: 'fass',
  iconName: 'angles-up-down',
  icon: [384, 512, [], "e60d", "M214.9 9.4l-22.6-22.6-22.6 22.6-144 144-22.6 22.6 45.3 45.3 22.6-22.6 121.4-121.4 121.4 121.4 22.6 22.6 45.3-45.3-22.6-22.6-144-144zm0 493.3l166.6-166.6-45.3-45.3-144 144-121.4-121.4-22.6-22.6-45.3 45.3 22.6 22.6 144 144 22.6 22.6 22.6-22.6z"]
};
var faTruckPlow = {
  prefix: 'fass',
  iconName: 'truck-plow',
  icon: [640, 512, [], "f7de", "M267.8 96l57.6 96-133.4 0 0-96 75.8 0zM128 96l0 96-128 0 0 192 32.4 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8l96.7 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88l0-80 48 0 0 80c0 48.6 39.4 88 88 88l24 0 0-48-24 0c-22.1 0-40-17.9-40-40l0-208c0-22.1 17.9-40 40-40l24 0 0-48-24 0c-48.6 0-88 39.4-88 88l0 80-48 0 0-72-80 0-96-160-176 0 0 64zM80 392a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm312-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faUsersMedical = {
  prefix: 'fass',
  iconName: 'users-medical',
  icon: [640, 512, [], "f830", "M320 224a104 104 0 1 0 0-208 104 104 0 1 0 0 208zM96 232a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm14.7 248l2.5-10.8 41.8-181.2-107 0-48 192 110.7 0zM616 160c0-39.8-32.2-72-72-72s-72 32.2-72 72c0 18.5 7 35.3 18.4 48.1 1.9-.1 3.7-.1 5.6-.1 28.2 0 54.9 6.1 79.1 17 24.2-11.6 40.9-36.3 40.9-65zM160 480l161.4 0c-11.2-24.4-17.4-51.4-17.4-80 0-49.2 18.5-94 48.9-128L208 272 160 480zm336 64a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm26.7-224l0 53.3 53.3 0 0 53.3-53.3 0 0 53.3-53.3 0 0-53.3-53.3 0 0-53.3 53.3 0 0-53.3 53.3 0z"]
};
var faWatchApple = {
  prefix: 'fass',
  iconName: 'watch-apple',
  icon: [384, 512, [], "e2cb", "M80-32l224 0 10.7 96 69.3 0 0 384-69.3 0-10.7 96-224 0-10.7-96-69.3 0 0-384 69.3 0 10.7-96zM320 128l-256 0 0 256 256 0 0-256zM192 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm24 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-136a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM88 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCaretLargeLeft = {
  prefix: 'fass',
  iconName: 'caret-large-left',
  icon: [320, 512, [], "e82d", "M256 40L24 256 256 472 256 40z"]
};
var faGridRound4 = {
  prefix: 'fass',
  iconName: 'grid-round-4',
  icon: [448, 512, [], "e5dd", "M38.1 32a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zm124.2 0a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zm85.4 38.1a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zM409.9 32a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zM0 194.2a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zm162.2-38.1a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zm85.4 38.1a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zm162.2-38.1a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zM0 317.8a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zm162.2-38.1a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zm85.4 38.1a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zm162.2-38.1a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zM0 441.9a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zm162.2-38.1a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zm85.4 38.1a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zm162.2-38.1a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2z"]
};
var faBookOpenCover = {
  prefix: 'fass',
  iconName: 'book-open-cover',
  icon: [576, 512, ["book-open-alt"], "e0c0", "M288 140l0 248.1 27.8-9.9c48.4-17.3 99.3-26.1 150.7-26.1l45.5 0 0-256-45.5 0c-36.7 0-73.1 6.3-107.6 18.6-37.5 13.4-61.2 21.8-70.9 25.3zM512 32l64 0 0 384-109.5 0c-44 0-87.7 7.6-129.2 22.4L288 456 238.6 438.4C197.2 423.6 153.5 416 109.5 416L0 416 0 32 109.5 32c44 0 87.7 7.6 129.2 22.4L288 72 337.4 54.4C378.8 39.6 422.5 32 466.5 32L512 32zM0 464l109.5 0c46.8 0 93.2 8 137.2 23.8l41.3 14.7 41.3-14.7c44-15.7 90.5-23.8 137.2-23.8l109.5 0 0 48-109.5 0c-41.3 0-82.2 7.1-121.1 21l-49.4 17.6-8.1 2.9-8.1-2.9-49.4-17.6c-38.9-13.9-79.8-21-121.1-21L0 512 0 464z"]
};
var faBookOpenAlt = faBookOpenCover;
var faCommentDot = {
  prefix: 'fass',
  iconName: 'comment-dot',
  icon: [576, 512, [], "e6dc", "M288 0c34 0 66.5 6.2 96.2 17.5-10.3 18.5-16.2 39.8-16.2 62.5 0 70.7 57.3 128 128 128 15.6 0 30.6-2.8 44.5-7.9 2.3 13 3.5 26.3 3.5 39.9 0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L32 512 87.7 389.5C52.8 348.5 32 296.5 32 240 32 107.5 146.6 0 288 0zM496 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faFlashlight = {
  prefix: 'fass',
  iconName: 'flashlight',
  icon: [640, 512, [128294], "f8b8", "M576 416l64 0 0-320-64 0 0 320zM528 99.9C441.8 113.7 384 160 384 160l-384 0 0 192 384 0s57.8 46.3 144 60.1l0-312.2zM224 224l96 0 0 64-96 0 0-64z"]
};
var faFaceAngry = {
  prefix: 'fass',
  iconName: 'face-angry',
  icon: [512, 512, [128544, "angry"], "f556", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm208-16l0-.3c4.9 1.6 14.5 4.8 28.6 9.6l12.6-37.9-19-6.3-96-32-19-6.3-12.6 37.9c11 3.7 26.9 9 47.8 15.9-4.1 5.4-6.6 12.1-6.6 19.4 0 17.7 14.3 32 32 32s32-14.3 32-32zm128 32c17.7 0 32-14.3 32-32 0-7.3-2.4-14-6.6-19.4 20.9-7 36.8-12.3 47.8-15.9l-12.6-37.9-19 6.3-96 32-19 6.3 12.6 37.9c14.2-4.7 23.7-7.9 28.6-9.6l0 .3c0 17.7 14.3 32 32 32zM192.3 406.4C204.4 383.5 228.4 368 256 368s51.6 15.5 63.7 38.4l42.4-22.5C342 345.9 302 320 256 320s-86 25.9-106.1 63.9l42.4 22.5z"]
};
var faAngry = faFaceAngry;
var faCheeseSwiss = {
  prefix: 'fass',
  iconName: 'cheese-swiss',
  icon: [512, 512, [129472], "f7f0", "M141.8 145.7L0 256 512 256C512 132.3 411.7 32 288 32L217.1 87.2c4.4 7.2 6.9 15.7 6.9 24.8 0 26.5-21.5 48-48 48-13.4 0-25.5-5.5-34.2-14.3zM413.3 304c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32l-322.7 0 0 176 512 0 0-176-98.7 0zM176 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faChartPieSimple = {
  prefix: 'fass',
  iconName: 'chart-pie-simple',
  icon: [512, 512, ["chart-pie-alt"], "f64e", "M272 0l0 240 240 0C512 107.5 404.5 0 272 0zM224 264l0-231.5C98.9 40.8 0 144.8 0 272 0 404.5 107.5 512 240 512 367.2 512 471.2 413.1 479.5 288l-255.5 0 0-24z"]
};
var faChartPieAlt = faChartPieSimple;
var faCircleCent = {
  prefix: 'fass',
  iconName: 'circle-cent',
  icon: [512, 512, [], "e72a", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM232 96l48 0 0 34.2c31.9 6.1 59.6 24 78.4 48.9L320 208c-14.6-19.5-37.9-32-64-32-44.2 0-80 35.8-80 80s35.8 80 80 80c26.2 0 49.4-12.5 64-32l38.4 28.8c-18.7 25-46.5 42.9-78.4 48.9l0 34.2-48 0 0-34.2C172.8 370.5 128 318.5 128 256s44.8-114.5 104-125.8L232 96z"]
};
var faBurst = {
  prefix: 'fass',
  iconName: 'burst',
  icon: [512, 512, [], "e4dc", "M256 0L312.8 118.8 437 75 393.2 199.2 512 256 393.2 312.8 437 437 312.8 393.2 256 512 199.2 393.2 75 437 118.8 312.8 0 256 118.8 199.2 0 0 199.2 118.8 256 0z"]
};
var faZ = {
  prefix: 'fass',
  iconName: 'z',
  icon: [384, 512, [122], "5a", "M384 32l0 43.6-7.4 8.9-276.3 331.5 283.7 0 0 64-384 0 0-43.6 7.4-8.9 276.3-331.5-283.7 0 0-64 384 0z"]
};
var faSquareSwedishKrona = {
  prefix: 'fass',
  iconName: 'square-swedish-krona',
  icon: [448, 512, [], "e71c", "M448 32l-448 0 0 448 448 0 0-448zM144 128l0 126.1c43-43 67-67 72-72L249.9 216c-7.8 7.8-26.1 26.1-54.7 54.7l53.3 99-42.3 22.8c-3.6-6.7-19.1-35.5-46.5-86.3l-15.8 15.8 0 62.1-48 0 0-256 48 0zm160 78.2c9.6-4.1 20-6.2 30.6-6.2l33.4 0 0 48-33.4 0c-8.1 0-15.9 3.2-21.7 9s-9 13.5-9 21.7l0 105.4-48 0 0-192 48 0 0 14.2z"]
};
var faHeadSideHeadphones = {
  prefix: 'fass',
  iconName: 'head-side-headphones',
  icon: [512, 512, [], "f8c2", "M160 106.8l0-97.5C67.5 36.8 0 122.5 0 224 0 285 24.4 340.4 64 380.8l0 131.2 256 0 0-64 112 0 0-128 64 0 0-64-49.7-59.6C434 96.2 355.6 16.5 256 2.3l0 104.5c37.8 18 64 56.5 64 101.2 0 61.9-50.1 112-112 112S96 269.9 96 208c0-44.7 26.2-83.2 64-101.2zM208 256a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faBandage = {
  prefix: 'fass',
  iconName: 'bandage',
  icon: [576, 512, [129657, "band-aid"], "f462", "M464 416l112 0 0-320-112 0 0 320zM416 96l-256 0 0 320 256 0 0-320zM0 96l0 320 112 0 0-320-112 0zM216 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM216 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faBandAid = faBandage;
var faPlaneCircleExclamation = {
  prefix: 'fass',
  iconName: 'plane-circle-exclamation',
  icon: [640, 512, [], "e556", "M232 24c0-30.9 25.1-56 56-56s56 25.1 56 56l0 127.3 78 71.5c-69.3 29-118 97.4-118 177.2 0 49.3 18.6 94.3 49.1 128.3l-65.1-16.3-128 32 0-48 72-57.6 0-99.7-184 61.3 0-80 184-168.7 0-127.3zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 112 32 0 0-112z"]
};
var faBusSide = {
  prefix: 'fass',
  iconName: 'bus-side',
  icon: [640, 512, [], "e81d", "M480 0c88.4 0 160 71.6 160 160l0 288-69.6 0c-13.2 37.3-48.6 64-90.4 64s-77.3-26.7-90.4-64l-139.1 0c-13.2 37.3-48.7 64-90.4 64s-77.2-26.7-90.4-64L0 448 0 0 480 0zM160 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm320 0a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm-32-48l128 0 0-160c0-53-43-96-96-96l-32 0 0 256zM248 224l136 0 0-160-136 0 0 160zM64 224l136 0 0-160-136 0 0 160z"]
};
var faBugs = {
  prefix: 'fass',
  iconName: 'bugs',
  icon: [576, 512, [], "e4d0", "M495.8 172.1c-4.9 10.9-14.9 32.9-30 66 23.3 14.2 40.2 38 44.8 66l41.3 0 0 48-40 0 0 32 40 0 0 48-41.3 0c-7.6 45.4-47.1 80-94.7 80s-87-34.6-94.7-80l-41.3 0 0-48 40 0 0-32-40 0 0-48 41.3 0c4.7-28 21.5-51.8 44.8-66-15-33.1-25-55.1-29.9-66l43.7-19.8c4.5 9.9 15.3 33.9 32.6 71.8 1.2 0 2.3-.1 3.5-.1s2.3 0 3.4 .1l22.7-50 9.9-21.9 43.7 19.8zm-256-160c-4.9 10.9-14.9 32.9-30 66 23.3 14.2 40.2 38 44.8 66l41.3 0 0 48-40 0 0 32 40 0 0 48-41.3 0c-7.6 45.4-47.1 80-94.7 80s-87-34.6-94.7-80l-41.3 0 0-48 40 0 0-32-40 0 0-48 41.3 0c4.7-28 21.5-51.8 44.8-66-15-33.1-25-55.1-29.9-66L123.9-7.8c4.5 9.9 15.3 33.9 32.6 71.8 1.2 0 2.3-.1 3.5-.1 1.2 0 2.3 0 3.4 .1l22.7-50 9.9-21.9 43.7 19.8z"]
};
var faSnowmobileBlank = {
  prefix: 'fass',
  iconName: 'snowmobile-blank',
  icon: [512, 512, [], "e7c4", "M309.5 85.3l-10.7-21.5-42.9 21.5c3.6 7.2 17.9 35.7 42.7 85.5l0 .1-42.6 53.2-224 0 0 112c-19.4 14.6-32 37.8-32 64 0 44.2 35.8 80 80 80l160 0c44.2 0 80-35.8 80-80 0-18-6-34.6-16-48l53.6 0 4.6 10.1 32.3 69.9-43.5 0 0 48 161 0 0-80-48 0 0 32-16.6 0-36.9-80C466.7 350.7 512 304.6 512 248l0-8-166.9-83.4-3.6-7.3-32-64zM80 368l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 432c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faBookUser = {
  prefix: 'fass',
  iconName: 'book-user',
  icon: [448, 512, [], "f7e7", "M0 0l448 0 0 384-32 0 0 64 32 0 0 64-448 0 0-512zM64 416l0 32 288 0 0-64-256 0c-17.7 0-32 14.3-32 32zM224 184a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM325.3 288l-21.3-64-160 0-21.3 64 202.7 0z"]
};
var faChevronsRight = {
  prefix: 'fass',
  iconName: 'chevrons-right',
  icon: [512, 512, ["chevron-double-right"], "f324", "M278.9 278.6L301.5 256 278.9 233.4 86.9 41.4 64.3 18.7 19 64 41.6 86.6 211 256 41.6 425.4 19 448 64.3 493.3 86.9 470.6 278.9 278.6zm192 0l22.6-22.6-22.6-22.6-192-192-22.6-22.6-45.3 45.3 22.6 22.6 169.4 169.4-169.4 169.4-22.6 22.6 45.3 45.3 22.6-22.6 192-192z"]
};
var faChevronDoubleRight = faChevronsRight;
var faBeerMugEmpty = {
  prefix: 'fass',
  iconName: 'beer-mug-empty',
  icon: [576, 512, ["beer"], "f0fc", "M64 32l384 0 0 64 128 0 0 211.8-128 64 0 108.2-384 0 0-448zM448 300.2l64-32 0-108.2-64 0 0 140.2zM176 152l0-24-48 0 0 256 48 0 0-232zm104 0l0-24-48 0 0 256 48 0 0-232zm104 0l0-24-48 0 0 256 48 0 0-232z"]
};
var faBeer = faBeerMugEmpty;
var faPersonCircleCheck = {
  prefix: 'fass',
  iconName: 'person-circle-check',
  icon: [640, 512, [], "e53e", "M168 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-11.4 88l134.8 0 9.6 13.2 85.2 117.3c-17.8 12.4-33.4 27.8-46.1 45.5l-36.1-49.7 0 305.7-64 0 0-208-32 0 0 208-64 0 0-305.7c-28.6 39.4-47.6 65.6-56.9 78.4l-51.8-37.6 18.8-25.9 92.9-128 9.6-13.2zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.4-51.5l-25.9-18.8-9.4 12.9-53 72.9C457.7 395 445 382.3 440 377.4L417.4 400c2.8 2.8 19.9 19.9 51.3 51.3l13.2 13.2 11-15.1 64-88 9.4-12.9z"]
};
var faCartCirclePlus = {
  prefix: 'fass',
  iconName: 'cart-circle-plus',
  icon: [640, 512, [], "e3f3", "M24-16l-24 0 0 48 76 0 60.4 332.3 3.6 19.7 164.7 0c1.4-16.7 4.9-32.8 10.3-48l-134.9 0-8.7-48 168.7 0c34.9-48.5 91.7-80 156-80 15.8 0 31.2 1.9 46 5.5L576 32 124.8 32c-3.7-20.3-6.6-36.3-8.7-48L24-16zM208 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM352 400a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm208 16l-48 0 0 64-32 0 0-64-64 0 0-32 64 0 0-64 32 0 0 64 64 0 0 32-16 0z"]
};
var faStapler = {
  prefix: 'fass',
  iconName: 'stapler',
  icon: [640, 512, [], "e5af", "M640 240l0 240-608 0 0-64 416 0 0-48-384 0 0-148.6-64-11.4 52.1-95.6c27-49.6 79-80.4 135.4-80.4 24 0 47.6 5.6 69 16.3L640 240zm-512-9.1l0 73.1 320 0 0-16-320-57.1z"]
};
var faSquareHalfStrokeHorizontal = {
  prefix: 'fass',
  iconName: 'square-half-stroke-horizontal',
  icon: [448, 512, [], "e80f", "M0 32l448 0 0 448-448 0 0-448zM384 256l0-160-320 0 0 160 320 0z"]
};
var faCandyCorn = {
  prefix: 'fass',
  iconName: 'candy-corn',
  icon: [576, 512, [], "f6bd", "M387 364.9c9.9 11.8 20.5 23.2 31.9 33.8 11.3-10.7 21.9-22 31.9-33.8 3.8-4.5 7.4-9.1 11-13.7 84.4-109.3 115.2-254.1 119.9-320.6-16.3-10.2-71.6-30.7-162.8-30.7S272.4 20.4 256.1 30.7c4.7 66.5 35.5 211.3 119.9 320.6 3.6 4.6 7.2 9.2 11 13.7zm31.9-63.2c-18.6-25.8-34.4-54.1-47.5-83.2 14.6-1.2 30.4-2 47.5-2s32.9 .7 47.5 2c-13.1 29-28.9 57.3-47.5 83.2zM511.6 73.3c-2.8 15.1-6.5 31.8-11.3 49.7-22.8-3.6-50-6-81.4-6s-58.6 2.4-81.4 6c-4.8-17.8-8.5-34.6-11.3-49.7 22.2-5 53.2-9.3 92.7-9.3s70.5 4.3 92.7 9.3zM192.2 146.6c-9.9-11.8-20.5-23.2-31.9-33.8-11.3 10.7-21.9 22-31.9 33.8-3.8 4.5-7.4 9.1-11 13.7-84.4 109.3-115.2 254.1-119.9 320.6 16.3 10.2 71.6 30.7 162.8 30.7s146.6-20.5 162.8-30.7c-4.7-66.5-35.5-211.3-119.9-320.6-3.6-4.6-7.2-9.2-11-13.7zm-31.9 63.2c18.6 25.8 34.4 54.1 47.5 83.2-14.6 1.2-30.4 2-47.5 2s-32.9-.7-47.5-2c13.1-29 28.9-57.3 47.5-83.2zM67.6 438.3c2.8-15.1 6.5-31.8 11.3-49.7 22.8 3.6 50 6 81.4 6s58.6-2.4 81.4-6c4.8 17.8 8.5 34.6 11.3 49.7-22.2 5-53.2 9.3-92.7 9.3s-70.5-4.3-92.7-9.3z"]
};
var faClipboardPrescription = {
  prefix: 'fass',
  iconName: 'clipboard-prescription',
  icon: [384, 512, [], "f5e8", "M320 0l-256 0 0 32-64 0 0 480 384 0 0-480-64 0 0-32zM112 112l0-48 160 0 0 48-160 0zm-8 80l56 0c35.3 0 64 28.7 64 64 0 14.6-4.9 28-13.1 38.8l33.1 31c20-19 35-33.1 45-42.5l33 34.9c-10.3 9.7-24.6 23.2-42.9 40.6 18.2 17.1 32.5 30.5 42.9 40.2l-32.8 35c-10-9.4-25-23.4-45-42.2-20.1 19-35.1 33.2-45.1 42.6l-33-34.9c10.3-9.7 24.6-23.3 43-40.6l-41.9-39.3c-2.3 .3-4.7 .4-7.2 .4l-32 0 0 48-48 0 0-176 24 0zm32 80l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 32 8 0z"]
};
var faCompressWide = {
  prefix: 'fass',
  iconName: 'compress-wide',
  icon: [512, 512, [], "f326", "M160 96l0-32-64 0 0 96-96 0 0 64 160 0 0-128zM32 288l-32 0 0 64 96 0 0 96 64 0 0-160-128 0zM416 96l0-32-64 0 0 160 160 0 0-64-96 0 0-64zM384 288l-32 0 0 160 64 0 0-96 96 0 0-64-128 0z"]
};
var faHouseMedicalCircleCheck = {
  prefix: 'fass',
  iconName: 'house-medical-circle-check',
  icon: [640, 512, [], "e511", "M80 512l260 0c-21.2-29.5-34.3-65.3-35.9-104l-48.2 0 0-56-56 0 0-64 56 0 0-56 64 0 0 56 20 0c34.9-48.5 91.7-80 156-80 11.7 0 23.1 1 34.2 3L288-16 32 224 32 272 80 272 80 512zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L417.4 400 440 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z"]
};
var faCommentPen = {
  prefix: 'fass',
  iconName: 'comment-pen',
  icon: [512, 512, ["comment-edit"], "f4ae", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM160 272l-16 80 80-16 144-144-64-64-144 144z"]
};
var faCommentEdit = faCommentPen;
var faNairaSign = {
  prefix: 'fass',
  iconName: 'naira-sign',
  icon: [448, 512, [], "e1f6", "M96 32l-32 0 0 224-56 0 0 48 56 0 0 176 64 0 0-176 88.7 0 103 161.2 9.4 14.8 54.9 0 0-176 56 0 0-48-56 0 0-224-64 0 0 224-58 0-133.7-209.2-9.4-14.8-22.9 0zM292.6 304l27.4 0 0 42.8-27.4-42.8zM186 256l-58 0 0-90.8 58 90.8z"]
};
var faFilePng = {
  prefix: 'fass',
  iconName: 'file-png',
  icon: [576, 512, [], "e666", "M272 0l-240 0 0 512 144 0 0-176 240 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM240 380l-20 0 0 168 40 0 0-48 12 0c33.1 0 60-26.9 60-60s-26.9-60-60-60l-32 0zm32 80l-12 0 0-40 12 0c11 0 20 9 20 20s-9 20-20 20zm96-80l-20 0 0 168 40 0 0-59.2c15.8 37.2 24.2 56.9 25.2 59.2l38.8 0 0-168-40 0 0 63c-17.1-40.3-26.1-61.3-26.8-63L368 380zm108 44l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-44-48 0 0 40 8 0 0 4c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 8 40 0 0-8c0-24.3-19.7-44-44-44l-16 0c-24.3 0-44 19.7-44 44z"]
};
var faHundredPoints = {
  prefix: 'fass',
  iconName: 'hundred-points',
  icon: [512, 512, [128175, "100"], "e41c", "M242.5 32c47.9 0 85 42 79 89.5l-12.1 96.7c-5 39.8-38.9 69.8-79 69.8-47.9 0-85-42-79-89.5l12.1-96.7c5-39.8 38.9-69.8 79-69.8zM227 109.7l-12.1 96.7c-1.2 9.3 6.1 17.6 15.5 17.6 7.9 0 14.5-5.9 15.5-13.7L258 113.6c1.2-9.3-6.1-17.6-15.5-17.6-7.9 0-14.5 5.9-15.5 13.7zm265.5 242l-464 80-8.2-47.3 464-80 8.2 47.3zm-32.1 88l-240 40-7.9-47.3 240-40 7.9 47.3zM348.6 104.6c3.7-41.1 38.2-72.6 79.5-72.6 46.9 0 83.7 40.3 79.5 87l-7.3 80.4c-3.7 41.1-38.2 72.6-79.5 72.6-46.9 0-83.7-40.3-79.5-87l7.3-80.4zM428.1 96c-8.2 0-15 6.2-15.7 14.4l-7.3 80.4c-.8 9.3 6.4 17.2 15.7 17.2 8.2 0 15-6.2 15.7-14.4l7.3-80.4c.8-9.3-6.4-17.2-15.7-17.2zM64.7 116.5l-3.7 1.6-29.4 13.1-25.2-58.4c15.2-6.7 43.7-19.4 85.4-38l44.3 33.2-34.5 241.5-65.9 9.4 1-6.9 27.9-195.5z"]
};
var fa100 = faHundredPoints;
var faTableTree = {
  prefix: 'fass',
  iconName: 'table-tree',
  icon: [448, 512, [], "e293", "M448 32l-448 0 0 448 448 0 0-448zM384 160l0 256-320 0 0-256 48 0 0 216 128 0 0-48-80 0 0-48 48 0 0-48-48 0 0-72 224 0zM256 224l0 64 96 0 0-64-96 0zm96 96l-64 0 0 64 64 0 0-64z"]
};
var faWifi = {
  prefix: 'fass',
  iconName: 'wifi',
  icon: [576, 512, ["wifi-3", "wifi-strong"], "f1eb", "M288.3 272c49 0 92.9 22.1 122.3 56.8L456.5 284c-41-46.6-101.2-76-168.2-76s-127.1 29.4-168.2 76L166 328.8c29.3-34.7 73.2-56.8 122.3-56.8zm0-176c98.4 0 187 42.3 248.4 109.8l45.8-44.7C509.5 81.7 404.7 32 288.3 32S67.1 81.7-6 161.1l45.8 44.7C101.3 138.3 189.8 96 288.3 96zm0 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faWifi3 = faWifi;
var faWifiStrong = faWifi;
var faPage = {
  prefix: 'fass',
  iconName: 'page',
  icon: [384, 512, [], "e428", "M0 0L240 0 384 144 384 512 0 512 0 0z"]
};
var faSquareChevronLeft = {
  prefix: 'fass',
  iconName: 'square-chevron-left',
  icon: [448, 512, ["chevron-square-left"], "f32a", "M0 32l0 448 448 0 0-448-448 0zM135 239l104-104 17-17 33.9 33.9-17 17-87 87 87 87 17 17-33.9 33.9-17-17-104-104-17-17 17-17z"]
};
var faChevronSquareLeft = faSquareChevronLeft;
var faChartMixed = {
  prefix: 'fass',
  iconName: 'chart-mixed',
  icon: [576, 512, ["analytics"], "f643", "M532.5 89l25-20-40-50-25 20-140.6 112.5-108.2-81.1-19.8-14.9-19.4 15.5-160 128-25 20 40 50 25-20 140.6-112.5 108.2 81.1 19.8 14.9 19.4-15.5 160-128zm-340 135l0 256 64 0 0-256-64 0zm-128 96l0 160 64 0 0-160-64 0zm320-32l-64 0 0 192 64 0 0-192zm64-64l0 256 64 0 0-256-64 0z"]
};
var faAnalytics = faChartMixed;
var faCalendarExclamation = {
  prefix: 'fass',
  iconName: 'calendar-exclamation',
  icon: [448, 512, [], "f334", "M160 64l128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0 0 64zm36 292l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0z"]
};
var faMoneyCheckDollar = {
  prefix: 'fass',
  iconName: 'money-check-dollar',
  icon: [512, 512, ["money-check-alt"], "f53d", "M512 64l-512 0 0 384 512 0 0-384zM448 288l0 48-176 0 0-48 176 0zM272 176l176 0 0 48-176 0 0-48zM168 144l0 24 28 0 0 40-67.5 0c-6.9 0-12.5 5.6-12.5 12.5 0 6.1 4.4 11.3 10.4 12.3l41.7 7c25.3 4.2 43.9 26.1 43.9 51.8 0 26.1-19 47.7-44 51.8l0 24.7-40 0 0-24-44 0 0-40 75.5 0c6.9 0 12.5-5.6 12.5-12.5 0-6.1-4.4-11.3-10.4-12.3l-41.7-7C94.5 268 76 246.1 76 220.5 76 191.7 99.2 168.3 128 168l0-24 40 0z"]
};
var faMoneyCheckAlt = faMoneyCheckDollar;
var faCamcorder = {
  prefix: 'fass',
  iconName: 'camcorder',
  icon: [576, 512, [128249, "video-handheld"], "f8a8", "M64 32l288 0 0 64-224 0 0 64 288 0 0 320-384 0 0-320 32 0 0-128zM576 480l-112-74.7 0-170.7 112-74.7 0 320zM120 224l-24 0 0 48 256 0 0-48-232 0z"]
};
var faVideoHandheld = faCamcorder;
var faHouseChimneyBlank = {
  prefix: 'fass',
  iconName: 'house-chimney-blank',
  icon: [512, 512, [], "e3b0", "M512 272l-48 0 0 240-416 0 0-240-48 0 0-48 256-240 112 105 0-41 96 0 0 131 48 45 0 48z"]
};
var faEyeLowVision = {
  prefix: 'fass',
  iconName: 'eye-low-vision',
  icon: [576, 512, ["low-vision"], "f2a8", "M49.4-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-90.4-90.4c53.7-48.2 89.3-109 105.2-148.7-30-74.7-129.6-224-288-224-55.6 0-103.9 18.4-144.5 45.5L49.4-16.9zM204.9 138.6c23.5-16.7 52.3-26.6 83.4-26.6 79.5 0 144 64.5 144 144 0 31.1-9.8 59.9-26.6 83.4L371 304.7c8.4-14.3 13.3-30.9 13.3-48.7 0-53-43-96-96-96-17.8 0-34.4 4.8-48.7 13.3l-34.7-34.7zM88.3 157.9l-17-17-33.9 33.9 17 17 274.1 274.1 17 17 33.9-33.9-17-17-274.1-274.1zM45.9 251.3l-17-17-33.9 33.9 17 17 170.2 170.2 17 17 33.9-33.9-17-17-170.2-170.2z"]
};
var faLowVision = faEyeLowVision;
var faCircleArrowUp = {
  prefix: 'fass',
  iconName: 'circle-arrow-up',
  icon: [512, 512, ["arrow-circle-up"], "f0aa", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm17-377l80 80 17 17-33.9 33.9c-7.6-7.6-26.3-26.3-56-56l0 174.1-48 0 0-174.1c-29.7 29.7-48.4 48.4-56 56l-33.9-33.9 97-97 17-17 17 17z"]
};
var faArrowCircleUp = faCircleArrowUp;
var faCameraRetro = {
  prefix: 'fass',
  iconName: 'camera-retro',
  icon: [512, 512, [128247], "f083", "M0 480l0-272 136.2 0c13.5-20.2 32-36.8 53.7-48l-190 0 0-98.3 64 0 0-29.7 96 0 0 29.7 32 0 64-29.7 256 0 0 128-190 0c21.7 11.2 40.2 27.8 53.7 48l136.2 0 0 272-512 0zM256 192a96.1 96.1 0 1 0 0 192.1 96.1 96.1 0 1 0 0-192.1z"]
};
var faRightToDottedLine = {
  prefix: 'fass',
  iconName: 'right-to-dotted-line',
  icon: [512, 512, [], "e6c5", "M512 448l-64 0 0-64 64 0 0 64zM394.9 256l-202.9 192 0-128-192 0 0-128 32 0 0 0 160 0 0-128 202.9 192zM512 277.3l0 64-64 0 0-64 64 0zm0-42.7l-64 0 0-64 64 0 0 64zM512 64l0 64-64 0 0-64 64 0z"]
};
var faCapsules = {
  prefix: 'fass',
  iconName: 'capsules',
  icon: [576, 512, [], "f46b", "M96 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112-96 0 0-112zm-64 0l0 288c0 61.9 50.1 112 112 112s112-50.1 112-112l0-105.8 116.3 169.5c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 145.3c-35.5-51.7-105.3-64.3-156-28.1-5.6 4-10.7 8.4-15.3 13.1l0-18.3C256 50.1 205.9 0 144 0S32 50.1 32 112zM296.6 240.2c-16-23.3-10-55.3 11.9-71 21.2-15.1 50.5-10.3 66 12.2l67 97.6-79.9 55.9-65-94.8z"]
};
var faBlockBrickFire = {
  prefix: 'fass',
  iconName: 'block-brick-fire',
  icon: [640, 512, ["firewall"], "e3dc", "M448 32l-256 0 0 80 256 0 0-80zM160 32l-64 0 0 80 64 0 0-80zM96 240l208 0 0-96-208 0 0 96zm0 32l0 96 64 0 0-96-64 0zm0 208l199.5 0c-12.7-24.3-20.7-51.3-22.9-80L96 400 96 480zM544 156.4l0-12.4-76 0 42.3 42.3 29.3-26.1 1.3-1.3 .1 .1 2.9-2.5zM434 144l-98 0 0 83.6c29.2-34.9 62.7-61.5 86.6-76.4L434 144zM304.5 272l-112.5 0 0 96 80.7 0c3-35.7 15.6-68.1 31.9-96zM544 32l-64 0 0 80 64 0 0-80zM448 192c-42.7 26.7-128 102.4-128 192 0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-32 32-64-64zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96z"]
};
var faFirewall = faBlockBrickFire;
var faFilters = {
  prefix: 'fass',
  iconName: 'filters',
  icon: [640, 512, [], "e17e", "M352 328l112 112 0-232 176-176-464 0 176 176 0 120zM0 128l176 176 0 120 112 112 0-232 16-16 0-60.1-99.9-99.9-204.1 0z"]
};
var faBowlingPins = {
  prefix: 'fass',
  iconName: 'bowling-pins',
  icon: [512, 512, [], "f437", "M232 384l-48 128-112 0-48-128 50.3-176 107.4 0 50.3 176zm256 0l-48 128-112 0-48-128 50.3-176 107.4 0 50.3 176zM128 0c35.3 0 64 28.7 64 64l0 5.8c0 6.8-1 13.6-2.9 20.1L168 160 88 160 66.9 89.8C65 83.3 64 76.5 64 69.8L64 64C64 28.7 92.7 0 128 0zM384 0c35.3 0 64 28.7 64 64l0 5.8c0 6.8-1 13.6-2.9 20.1l-21.1 70.2-80 0-21.1-70.2c-2-6.5-2.9-13.3-2.9-20.1l0-5.8c0-35.3 28.7-64 64-64z"]
};
var faCalendarUsers = {
  prefix: 'fass',
  iconName: 'calendar-users',
  icon: [640, 512, [], "e5e2", "M256 32l0-32-64 0 0 64-96 0 0 145.1c5.2-.7 10.6-1.1 16-1.1 61.9 0 112 50.1 112 112 0 17.2-3.9 33.5-10.8 48l13.4 0c4.7 14.2 17.2 51.5 37.3 112l114.7 0c20.2-60.5 32.6-97.8 37.3-112l13.4 0c-6.9-14.5-10.8-30.8-10.8-48 0-61.9 50.1-112 112-112 4.5 0 9 .3 13.4 .8l0-144.8-96 0 0-64-64 0 0 64-128 0 0-32zM112 376a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM224 512l-32-96-160 0-32 96 224 0zM584 320a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm24 96l-160 0-32 96 224 0-32-96z"]
};
var faTableCellsColumns = {
  prefix: 'fass',
  iconName: 'table-cells-columns',
  icon: [448, 512, [], "e6ac", "M192 224l64 0 0 192-64 0 0-192zm192 0l0 192-64 0 0-192 64 0zM64 224l64 0 0 192-64 0 0-192zM64 32l-64 0 0 448 448 0 0-448-384 0z"]
};
var faPeopleSimple = {
  prefix: 'fass',
  iconName: 'people-simple',
  icon: [512, 512, [], "e21b", "M128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96 224l0-192-192 0 0 192 32 0 0 160 128 0 0-160 32 0zM384 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM512 384l-64-224-128 0-64 224 64 0 0 128 128 0 0-128 64 0z"]
};
var faArrowLeftArrowRight = {
  prefix: 'fass',
  iconName: 'arrow-left-arrow-right',
  icon: [576, 512, [], "e6b8", "M534.9 406.6l-118.6 118.6-45.3-45.3 64-64-402.7 0 0-64 402.7 0-64-64 45.3-45.3c2.9 2.9 42.4 42.4 118.6 118.6l22.6 22.6-22.6 22.6zM41.6 150.6L19 128c2.9-2.9 42.4-42.4 118.6-118.6L160.3-13.3 205.5 32c-12 12-33.3 33.3-64 64l402.7 0 0 64-402.7 0c30.7 30.7 52 52 64 64l-45.3 45.3c-2.9-2.9-42.4-42.4-118.6-118.6z"]
};
var faPoo = {
  prefix: 'fass',
  iconName: 'poo',
  icon: [512, 512, [128169], "f2fe", "M256 48c0 44.2-35.8 80-80 80l-16 0c-35.3 0-64 28.7-64 64 0 19.1 8.4 36.3 21.7 48L104 240c-39.8 0-72 32.2-72 72 0 25.6 13.4 48.2 33.6 60.9-38.1 12.7-65.6 48.7-65.6 91.1l0 48 512 0 0-48c0-42.4-27.5-78.4-65.6-91.1 20.2-12.8 33.6-35.3 33.6-60.9 0-39.8-32.2-72-72-72l-13.7 0c13.3-11.7 21.7-28.9 21.7-48 0-35.3-28.7-64-64-64l-5.5 0c3.5-10 5.5-20.8 5.5-32 0-53-43-96-96-96-5.1 0-10.2 .4-15.1 1.2 9.5 13.2 15.1 29.3 15.1 46.8zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 448c-64 0-96-64-96-64l192 0s-32 64-96 64z"]
};
var faSquare5 = {
  prefix: 'fass',
  iconName: 'square-5',
  icon: [448, 512, [], "e25a", "M448 32l-448 0 0 448 448 0 0-448zM264 144l24 0 0 48-96 0 0 32 40 0c39.8 0 72 32.2 72 72s-32.2 72-72 72l-88 0 0-48 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-128 120 0z"]
};
var faVolume = {
  prefix: 'fass',
  iconName: 'volume',
  icon: [512, 512, [128265, "volume-medium"], "f6a8", "M0 352l96 0 192 152 0-496-192 152-96 0 0 192zM350.3 218.7C361.1 227.6 368 241 368 256s-6.9 28.4-17.7 37.3l-9.4 7.6 28.8 38.4 10.9-8.8C402.1 312.9 416 286.1 416 256s-13.9-56.9-35.4-74.5l-10.9-8.8-28.8 38.4 9.4 7.6zm60.5-74.5C443.3 170.7 464 210.9 464 256s-20.7 85.3-53.2 111.8l-12.3 10 28.8 38.4 13.7-11.2c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149l-13.7-11.2-28.8 38.4 12.3 10z"]
};
var faVolumeMedium = faVolume;
var faFlowerDaffodil = {
  prefix: 'fass',
  iconName: 'flower-daffodil',
  icon: [448, 512, [9880], "f800", "M288-8c48.6 0 88 39.4 88 88 0 25.3-10.7 48-27.8 64 17 16 27.8 38.7 27.8 64 0 48.6-39.4 88-88 88-11.3 0-22.1-2.3-32-6.2l0 94.2c29.2-38.9 75.7-64 128-64l64 0 0 32c0 88.4-71.6 160-160 160l-128 0C71.6 512 0 440.4 0 352l0-32 64 0c52.3 0 98.8 25.1 128 64l0-94.2c-9.9 3.9-20.7 6.2-32 6.2-48.6 0-88-39.4-88-88 0-25.2 10.7-48 27.7-64-17-16-27.7-38.8-27.7-64 0-48.6 39.4-88 88-88 25.2 0 48 10.7 64 27.7 16-17 38.8-27.7 64-27.7zM168 144l56 56 56-56-56-56-56 56z"]
};
var faElevator = {
  prefix: 'fass',
  iconName: 'elevator',
  icon: [512, 512, [], "e16d", "M64 48l0 16 160 0 0-16-80-80-80 80zm448 80l-512 0 0 384 512 0 0-384zM160 224a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 448l24-96 112 0 24 96-160 0zm328-96l24 96-160 0 24-96 112 0zM304 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM368 64l80-80 0-16-160 0 0 16 80 80z"]
};
var faWavePulse = {
  prefix: 'fass',
  iconName: 'wave-pulse',
  icon: [576, 512, ["heart-rate"], "f5f8", "M253.7 0L321 0 327 24.2 395.2 296.9C413.4 255.3 424 231 427.1 224l148.9 0 0 64-107.1 0-47.6 108.8-8.4 19.2-53.9 0-6.1-24.2-62.2-248.7-67.4 343.1-5.1 25.8-59.3 0-6.1-24.2-49.9-199.8-103 0 0-64 153 0c.8 3.1 11.4 45.4 31.7 127L248.6 25.8 253.7 0z"]
};
var faHeartRate = faWavePulse;
var faBookHeart = {
  prefix: 'fass',
  iconName: 'book-heart',
  icon: [448, 512, [], "f499", "M0 0l448 0 0 384-32 0 0 64 32 0 0 64-448 0 0-512zM64 416l0 32 288 0 0-64-256 0c-17.7 0-32 14.3-32 32zM217.6 119.5c-11.1-14.8-28.5-23.5-46.9-23.5-32.4 0-58.7 26.3-58.7 58.7l0 5.3c0 64 112 128 112 128s112-64 112-128l0-5.3c0-32.4-26.3-58.7-58.7-58.7-18.5 0-35.9 8.7-46.9 23.5l-6.4 8.5-6.4-8.5z"]
};
var faSquareZ = {
  prefix: 'fass',
  iconName: 'square-z',
  icon: [448, 512, [], "e288", "M448 32l-448 0 0 448 448 0 0-448zM296 144l24 0 0 32.6-5.4 6.6-111.9 136.8 117.4 0 0 48-192 0 0-32.6 5.4-6.6 111.9-136.8-117.4 0 0-48 168 0z"]
};
var faTag = {
  prefix: 'fass',
  iconName: 'tag',
  icon: [512, 512, [127991], "f02b", "M32 32L32 272 272 512 512 272 272 32 32 32zm112 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faWagonCovered = {
  prefix: 'fass',
  iconName: 'wagon-covered',
  icon: [640, 512, [], "f8ee", "M48.1 0l-29.1 0 5.5 28.5 39.6 205.8 0 5.7 144 0 0-240-160 0zm16 288l0 112c0 61.9 50.1 112 112 112 56.4 0 103.1-41.7 110.9-96l66.3 0c7.8 54.3 54.4 96 110.9 96 61.9 0 112-50.1 112-112l0-112-512 0zm192-48l128 0 0-240-128 0 0 0 0 240zm176 0l144 0 0-5.7 39.6-205.8 5.5-28.5-189 0 0 0 0 240zm87.1 127.5c5.6 9.5 8.9 20.6 8.9 32.4l0 .1c0 11.9-3.2 23-8.9 32.5l-32.5-32.5 32.5-32.5zm-55.1 55.1l32.5 32.5c-9.5 5.6-20.6 8.9-32.5 8.9s-23-3.2-32.5-8.9l32.5-32.5zm-55.1 9.9c-5.6-9.5-8.9-20.6-8.9-32.5s3.2-23 8.9-32.5l32.5 32.5-32.5 32.5zm55.1-55.1l-32.5-32.5c9.5-5.6 20.6-8.9 32.5-8.9s23 3.2 32.5 8.9l-32.5 32.5zM120.9 432.5c-5.6-9.5-8.9-20.6-8.9-32.5s3.2-23 8.9-32.5l32.5 32.5-32.5 32.5zm55.1-55.1l-32.5-32.5c9.5-5.6 20.6-8.9 32.5-8.9s23 3.2 32.5 8.9l-32.5 32.5zm-32.5 77.8l32.5-32.5 32.5 32.5c-9.5 5.6-20.6 8.9-32.5 8.9s-23-3.2-32.5-8.9zM198.7 400l32.5-32.5c5.6 9.5 8.9 20.6 8.9 32.5s-3.2 23-8.9 32.5L198.7 400z"]
};
var faFileCircleMinus = {
  prefix: 'fass',
  iconName: 'file-circle-minus',
  icon: [576, 512, [], "e4ed", "M272 0l-240 0 0 512 244 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3L416 144 272 0zm85.5 176L240 176 240 58.5 357.5 176zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 16l-160 0 0-32 160 0 0 32z"]
};
var faMessageCode = {
  prefix: 'fass',
  iconName: 'message-code',
  icon: [512, 512, [], "e1df", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM217 193l-47 47c36.4 36.4 57.7 57.7 64 64L200 337.9c-3.5-3.5-30.5-30.5-81-81l-17-17 81-81 17-17 33.9 33.9-17 17zM329 159c50.5 50.5 77.5 77.5 81 81-3.5 3.5-30.5 30.5-81 81l-17 17-33.9-33.9c6.3-6.3 27.6-27.6 64-64-36.4-36.4-57.7-57.7-64-64l33.9-33.9 17 17z"]
};
var faGearComplex = {
  prefix: 'fass',
  iconName: 'gear-complex',
  icon: [512, 512, [], "e5e9", "M303 0l-96 0-7 55.7c-16.8 4.7-32.7 11.5-47.5 20L107.9 41 40 108.9 75 153.9c-8.3 14.7-14.8 30.4-19.4 47L-1 208 .3 304 55.6 311c4.5 16.6 11.1 32.4 19.4 47.1l-35 45 67.9 67.9 44.6-34.7c14.8 8.5 30.7 15.3 47.5 20l7 55.7 96 0 6.9-55c17.2-4.6 33.6-11.3 48.7-19.9L402.1 471 470 403.1 436.5 360c8.9-15.3 15.8-31.8 20.6-49.3l54-6.7 0-96-54-6.7c-4.7-17.4-11.7-34-20.6-49.3L470 108.9 402.1 41 358.6 74.9c-15.2-8.6-31.5-15.3-48.7-19.9L303 0zM255.7 176a80 80 0 1 1 .6 160 80 80 0 1 1 -.6-160z"]
};
var faCircleC = {
  prefix: 'fass',
  iconName: 'circle-c',
  icon: [512, 512, [], "e101", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM205.1 306.9c28.1 28.1 73.7 28.1 101.8 0l33.9 33.9c-46.9 46.9-122.8 46.9-169.7 0s-46.9-122.8 0-169.7 122.8-46.9 169.7 0l-33.9 33.9c-28.1-28.1-73.7-28.1-101.8 0s-28.1 73.7 0 101.8z"]
};
var faDownLong = {
  prefix: 'fass',
  iconName: 'down-long',
  icon: [384, 512, ["long-arrow-alt-down"], "f309", "M192 544l192-192-128 0 0-384-128 0 0 384-128 0 192 192z"]
};
var faLongArrowAltDown = faDownLong;
var faCompactDisc = {
  prefix: 'fass',
  iconName: 'compact-disc',
  icon: [512, 512, [128191, 128192, 128440], "f51f", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm-56 0c0-83.9 68.1-152 152-152l0-48C145.5 56 56 145.5 56 256l48 0z"]
};
var faSuitcaseRolling = {
  prefix: 'fass',
  iconName: 'suitcase-rolling',
  icon: [384, 512, [], "f5c1", "M120-32l-24 0 0 128-96 0 0 416 64 0 0 32 64 0 0-32 128 0 0 32 64 0 0-32 64 0 0-416-96 0 0-128-168 0zM240 96l-96 0 0-80 96 0 0 80zM120 208l168 0 0 48-192 0 0-48 24 0zm0 128l168 0 0 48-192 0 0-48 24 0z"]
};
var faDanishKroneSign = {
  prefix: 'fass',
  iconName: 'danish-krone-sign',
  icon: [512, 512, [], "e720", "M112 16l0 263.7 122.5-111.3 23.7-21.5 43 47.4c-4.9 4.5-42.4 38.6-112.3 102.1l93.4 133.4 18.4 26.2-52.4 36.7c-.5-.7-36.2-51.7-107-152.9l-29.1 26.5 0 113.8-64 0 0-464 64 0zM396.8 249.6C388.5 260.7 384 274.2 384 288l0 192-64 0 0-320 64 0 0 17.1c19.2-11.1 41.2-17.1 64-17.1l48 0 0 64-48 0c-20.1 0-39.1 9.5-51.2 25.6zM464 408a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faWebhook = {
  prefix: 'fass',
  iconName: 'webhook',
  icon: [576, 512, [], "e5d5", "M192 384c0-9-2.5-17.4-6.8-24.6l72.3-129.3 11.6-20.8-20.7-11.8c-30.4-17.3-46.9-53.3-38-88.9 10.7-42.9 54.1-69 97-58.3 35.6 8.9 59.7 40.3 60.6 75.3l.7 24 48-1.4-.7-24c-1.6-56-40-106.3-97-120.5-68.6-17.1-138.1 24.7-155.2 93.3-12.2 48.8 5.5 98 41.3 128.5L143.4 336c-26.2 .4-47.3 21.7-47.3 48 0 26.5 21.5 48 48 48s48-21.5 48-48zM329.3 152.5c4.3-7.2 6.7-15.5 6.7-24.5 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 26.3 21.2 47.7 47.5 48l72.6 129.1 11.8 20.9 20.9-11.8c30.5-17.2 69.9-12.7 95.8 13.2 31.2 31.2 31.2 81.9 0 113.1-25.9 25.9-65.3 30.4-95.8 13.2l-20.9-11.8-23.6 41.8 20.9 11.8c48.8 27.5 111.7 20.5 153.3-21.1 50-50 50-131 0-181-35.5-35.5-86.7-45.8-131.2-30.9l-62-110.2zM432 432c26.5 0 48-21.5 48-48s-21.5-48-48-48c-17.8 0-33.3 9.7-41.6 24l-166.4 0 0 24c0 34.8-22.9 66.8-58 76.9-42.5 12.2-86.8-12.4-99-54.9-10.1-35.3 5.1-71.8 34.9-90.2l20.4-12.6-25.2-40.9-20.4 12.6c-47.7 29.3-72.1 87.8-55.9 144.3 19.5 68 90.4 107.2 158.3 87.8 48-13.8 81.7-53.2 90.5-99l120.7 0c8.3 14.3 23.8 24 41.6 24z"]
};
var faClockFiveThirty = {
  prefix: 'fass',
  iconName: 'clock-five-thirty',
  icon: [512, 512, [], "e34a", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm24-120l0-56.7c14.5 21.7 25.6 38.4 33.3 50l39.9-26.6-13.3-20-64-96-44 13.3 0 160 48 0 0-24z"]
};
var faPersonWaving = {
  prefix: 'fass',
  iconName: 'person-waving',
  icon: [448, 512, [], "e78d", "M384.1 0l0-32-64 0 0 126.5-183.2 42.3-12.9 3-7 11.2C53.1 253.2 20.8 304.9 20 306.2l54.3 33.9c5.3-8.5 28.6-45.8 69.8-111.7l0 315.6 64 0 0-192 32 0 0 192 64 0 0-380.1c41.9-9.7 68.5-15.8 80-18.5L384.1 0zm-160 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faArrowDownArrowUp = {
  prefix: 'fass',
  iconName: 'arrow-down-arrow-up',
  icon: [576, 512, ["sort-alt"], "f883", "M393.6 9.4l22.6-22.6c2.9 2.9 42.4 42.4 118.6 118.6l22.6 22.6-45.3 45.3-64-64 0 402.7-64 0 0-402.7-64 64-45.3-45.3c2.9-2.9 42.4-42.4 118.6-118.6zm-256 493.3C61.4 426.4 21.9 386.9 19 384l45.3-45.3c12 12 33.3 33.3 64 64l0-402.7 64 0 0 402.7c30.7-30.7 52-52 64-64L301.5 384c-2.9 2.9-42.4 42.4-118.6 118.6l-22.6 22.6-22.6-22.6z"]
};
var faSortAlt = faArrowDownArrowUp;
var faBookQuran = {
  prefix: 'fass',
  iconName: 'book-quran',
  icon: [448, 512, ["quran"], "f687", "M64 0l384 0 0 512-448 0 0-64 32 0 0-64-32 0 0-384 64 0zM352 384l-256 0 0 64 288 0 0-32c0-17.7-14.3-32-32-32zM280 138.7l-14 33.7-36.4 2.9 27.8 23.8-8.5 35.6 31.2-19.1 31.2 19.1-8.5-35.6 27.8-23.8-36.4-2.9-14-33.7zm0-34.7c7.9 0 15.6 1.1 23 3-20.7-19.3-48.5-31-79-31-64.1 0-116 51.9-116 116s51.9 116 116 116c30.5 0 58.3-11.8 79-31-7.3 2-15 3-23 3-48.6 0-88-39.4-88-88s39.4-88 88-88z"]
};
var faQuran = faBookQuran;
var faTelescope = {
  prefix: 'fass',
  iconName: 'telescope',
  icon: [576, 512, [128301], "e03e", "M476 277.7L348 56 445 0 573 221.7 476 277.7zM36.7 284.9l283-181.8 98.6 170.8-71.9 38.6 81.3 199.5-51.8 0-71.9-176.4-71.9 176.4-51.8 0 57.5-141.2-115.7 62.1-16.3-28.2-55.9 32.3-49.9-86.4 55.9-32.3-19.2-33.3z"]
};
var faTemperatureSlash = {
  prefix: 'fass',
  iconName: 'temperature-slash',
  icon: [576, 512, [], "e7cb", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-129.2-129.2c-.6-41.8-19-79.3-48-105.3l0-260.7-192 0 0 126-142.8-142.8zM264.1 198l0-134 48 0 0 182-48-48zm-40 170c0-20.3 9.4-38.3 24.1-50.1l-56.7-56.7c-29.1 26.3-47.4 64.4-47.4 106.8 0 79.5 64.5 144 144 144 42.4 0 80.4-18.3 106.8-47.4l-56.7-56.7c-11.7 14.7-29.8 24.1-50.1 24.1-35.3 0-64-28.7-64-64z"]
};
var faPhoneSlash = {
  prefix: 'fass',
  iconName: 'phone-slash',
  icon: [576, 512, [], "f3dd", "M527-16.9l17-17 33.9 33.9-17 17-512 512-17 17-33.9-33.9 17-17 127.1-127.1c-68.4-76.4-110-177.3-110-288l0-16 128-64 96.8 128-80.8 80c13 27.8 29.8 53.5 49.6 76.4L527-16.9zM464.1 512c-93.3 0-179.7-29.6-250.3-79.9l84.8-84.8c12 7.6 24.5 14.5 37.5 20.6l80-80.8 128 96.8-64 128-16 0z"]
};
var faRoadCircleCheck = {
  prefix: 'fass',
  iconName: 'road-circle-check',
  icon: [640, 512, [], "e564", "M288 32L169.4 32 64 480 321.4 480c-11.2-24.4-17.4-51.4-17.4-80s6.2-55.6 17.4-80l-33.4 0 0-128 64 0 0 81c35.2-39.9 86.7-65 144-65 5.4 0 10.8 .2 16.2 .7l-41.6-176.7-118.6 0 0 96-64 0 0-96zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L417.4 400 440 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z"]
};
var faShopLock = {
  prefix: 'fass',
  iconName: 'shop-lock',
  icon: [640, 512, [], "e4a5", "M16 256l0-64 80-160 384 0 73.2 146.5c-8.2-1.6-16.6-2.5-25.2-2.5-53.7 0-99.7 33.1-118.7 80l-57.3 0 0 224-288 0 0-224-48 0zm112 0l0 128 160 0 0-128-160 0zm400 16c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
var faImagePortrait = {
  prefix: 'fass',
  iconName: 'image-portrait',
  icon: [384, 512, ["portrait"], "f3e0", "M0 0L384 0 384 512 0 512 0 0zM304 384l-32-96-160 0-32 96 224 0zM192 248a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faPortrait = faImagePortrait;
var faBooks = {
  prefix: 'fass',
  iconName: 'books',
  icon: [640, 512, [128218], "f5db", "M483.6-7.8L360 25.3 380.7 102.6 504.3 69.4 483.6-7.8zm33.1 123.6l-123.6 33.1 66.3 247.3 123.6-33.1-66.3-247.3zm-24.3 404l123.6-33.1-20.7-77.3-123.6 33.1 20.7 77.3zM64.1 0l0 80 128 0 0-80-128 0zm0 128l0 256 128 0 0-256-128 0zm0 304l0 80 128 0 0-80-128 0zm176-336l0 416 112 0 0-416-112 0z"]
};
var faGrid2 = {
  prefix: 'fass',
  iconName: 'grid-2',
  icon: [448, 512, [], "e196", "M192 32l-192 0 0 192 192 0 0-192zm0 256l-192 0 0 192 192 0 0-192zM256 32l0 192 192 0 0-192-192 0zM448 288l-192 0 0 192 192 0 0-192z"]
};
var faCartArrowUp = {
  prefix: 'fass',
  iconName: 'cart-arrow-up',
  icon: [640, 512, [], "e3ee", "M0-16l116 0c2.1 11.7 5 27.7 8.7 48l193.3 0c-56.4 56.4-85.7 85.7-88 88l33.9 33.9 48-48 0 126.1 48 0 0-126.1c23 23 39 39 48 48L441.9 120c-2.3-2.3-31.6-31.6-88-88l222.1 0-48 256-356.7 0 8.7 48 300 0 0 48-340 0-3.6-19.7-60.4-332.3-76 0 0-48zM160 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faBridgeLock = {
  prefix: 'fass',
  iconName: 'bridge-lock',
  icon: [576, 512, [], "e4cc", "M0 32l512 0 0 64-40 0 0 32.2c13.8 .6 27.2 2.8 40 6.4l0 50.7c-14.8-6-31-9.3-48-9.3-70.7 0-128 57.3-128 128l-26.9 0c-15.2-10.1-33.5-16-53.1-16-53 0-96 43-96 96l0 96-96 0 0-126c0-38.8-26.4-72.6-64-82l0-112 40 0 0-64-40 0 0-64zM424 132.6l0-36.6-80 0 0 64 18.8 0c18.2-12.8 38.9-22.2 61.2-27.4zM216 96l0 64 80 0 0-64-80 0zm-48 0l-80 0 0 64 80 0 0-64zM464 272c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
var faPaperPlaneTop = {
  prefix: 'fass',
  iconName: 'paper-plane-top',
  icon: [640, 512, ["paper-plane-alt", "send"], "e20a", "M148 226.9L48-16 640 256 48 528 148 285.1 352 256 148 226.9z"]
};
var faPaperPlaneAlt = faPaperPlaneTop;
var faSend = faPaperPlaneTop;
var faClockNineThirty = {
  prefix: 'fass',
  iconName: 'clock-nine-thirty',
  icon: [512, 512, [], "e34d", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm24-120l0-160-152 0 0 48 104 0 0 136 48 0 0-24z"]
};
var faBurgerLettuce = {
  prefix: 'fass',
  iconName: 'burger-lettuce',
  icon: [512, 512, [], "e3e3", "M32 384l0 96 448 0 0-96-448 0zM480 224l0-48S432 32 256 32 32 176 32 176l0 48 448 0zM232 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-88 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM170.7 258.5l-10.7-5.4-10.7 5.4-58.9 29.5-90.3 0 0 48 101.7 0 5.1-2.5 53.3-26.6 85.3 42.6 10.7 5.4 96-48 53.3 26.6 5.1 2.5 101.7 0 0-48-90.3 0-58.9-29.5-10.7-5.4-10.7 5.4-85.3 42.6-85.3-42.6z"]
};
var faHammer = {
  prefix: 'fass',
  iconName: 'hammer',
  icon: [640, 512, [128296], "f6e3", "M224 32L271 3.8c21.6-13 46.3-19.8 71.5-19.8 36.8 0 72.2 14.6 98.2 40.7l87.3 87.3 0 64 19.7 19.7 0 0 28.3-28.3 56.6 56.6c-12.9 12.9-43.7 43.7-92.3 92.3l-28.3 28.3-56.6-56.6 28.3-28.3-19.7-19.7-64 0-96-96 0-64-80-48zM50.8 402.7l222.1-222.1 90.5 90.5C185.8 448.7 96.7 537.8 96 538.5L5.5 448 50.8 402.7z"]
};
var faSquareUpLeft = {
  prefix: 'fass',
  iconName: 'square-up-left',
  icon: [448, 512, [], "e282", "M448 32l-448 0 0 448 448 0 0-448zM152 160l169.9 0c-29.6 29.6-52.3 52.3-68 68 53 53 81 81 84 84-24.3 24.3-54.1 54.1-57.9 57.9-3-3-31-31-84-84-15.7 15.7-38.4 38.4-68 68l0-193.9 24 0z"]
};
var faTransporter7 = {
  prefix: 'fass',
  iconName: 'transporter-7',
  icon: [640, 512, [], "e2a8", "M624 80l-48-16-16-48-16 48-48 16 48 16 16 48 16-48 48-16zM160 496l0 48 320 0 0-48-320 0zM96 288l-16-48-16 48-48 16 48 16 16 48 16-48 48-16-48-16z"]
};
var faArrowUp19 = {
  prefix: 'fass',
  iconName: 'arrow-up-1-9',
  icon: [576, 512, ["sort-numeric-up"], "f163", "M182.9 41.4L160.3 18.7c-2.9 2.9-42.4 42.4-118.6 118.6L19 160 64.3 205.3c12-12 33.3-33.3 64-64l0 338.7 64 0 0-338.7c30.7 30.7 52 52 64 64L301.5 160c-2.9-2.9-42.4-42.4-118.6-118.6zM352.3 32l0 64 48 0 0 64-48 0 0 64 160 0 0-64-48 0 0-128-112 0zm25.6 448l73.2 0 44.7-80.5c10.8-19.4 16.5-41.3 16.5-63.5 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 38.1 26.6 70 62.3 78l-36.6 66zm54.4-168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSortNumericUp = faArrowUp19;
var faTableCellsHeaderUnlock = {
  prefix: 'fass',
  iconName: 'table-cells-header-unlock',
  icon: [640, 512, [], "e6af", "M384 224l0 48-16 0 0 208-304 0 0-448 448 0 0 113c-46.7 5.8-85.6 36.8-102.7 79L384 224zm-64 0l-64 0 0 64 64 0 0-64zm-128 0l-64 0 0 64 64 0 0-64zm64 128l0 64 64 0 0-64-64 0zm-128 0l0 64 64 0 0-64-64 0zM528 240c-17.7 0-32 14.3-32 32l0 48 144 0 0 192-224 0 0-192 32 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32z"]
};
var faChessKnight = {
  prefix: 'fass',
  iconName: 'chess-knight',
  icon: [384, 512, [9822], "f441", "M192-32c106 0 192 86 192 192l0 160-64 64 64 64 0 64-384 0 0-64 64-64 0-64 112-96-48 0-12.1 12.1c-12.7 12.7-30 19.9-48 19.9-37.5 0-67.9-30.4-67.9-67.9l0-8.7c0-22.8 8.2-44.9 23.1-62.3L96 32 96-32 192-32zM160 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faHouseFloodWaterCircleArrowRight = {
  prefix: 'fass',
  iconName: 'house-flood-water-circle-arrow-right',
  icon: [640, 512, [], "e50f", "M288.5 112a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-136-78.6l11.3 11.3 56 56 11.3 11.3-11.3 11.3-56 56-11.3 11.3-22.6-22.6c4.6-4.6 18-18 40-40l-105.4 0 0-32 105.4 0c-22-22-35.4-35.4-40-40l22.6-22.6zm184 78.6c0 71.1-38.6 133.1-96 166.3l0 36.3 80 32c73.3-29.3 113.3-45.3 120-48 6.4 2.5 47.1 18.8 122.3 48.9 18-6 27.9-9.3 29.7-9.9l0-129.6 32 0 0-40-208-168-84.9 68.6c3.2 13.9 4.9 28.5 4.9 43.4zm128 64l0 96-96 0 0-96 96 0zM209.4 353.7l-8.9-3.6-8.9 3.6-111.8 44.7c-29.3-9.8-50.1-16.7-62.4-20.8L2.1 423.2c11 3.7 34.6 11.5 70.8 23.6l8.3 2.8 8.2-3.3 111.1-44.4 111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4 111.1 44.4 8.2 3.3 8.3-2.8 70.8-23.6-15.2-45.5c-12.4 4.1-33.2 11.1-62.4 20.8l-111.8-44.7-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4zm-8.9 92.4l-8.9 3.6-111.8 44.7c-29.3-9.7-50.1-16.7-62.4-20.8L2.1 519.2c11 3.7 34.6 11.5 70.8 23.6l8.3 2.8 8.2-3.3 111.1-44.4 111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4 111.1 44.4 8.2 3.3 8.3-2.8 70.8-23.6-15.2-45.5c-12.4 4.1-33.2 11.1-62.4 20.8l-111.8-44.7-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4-8.9-3.6z"]
};
var faNfcMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'nfc-magnifying-glass',
  icon: [576, 512, [], "e1f9", "M32.4 32l448 0 0 180.1c-18.6-14.7-40.3-25.5-64-31.3l0-84.9-184 0 0 118.4c-14.3 8.3-24 23.8-24 41.6 0 11.3 3.9 21.6 10.4 29.8-6.7 18.2-10.4 37.8-10.4 58.3 0 8.1 .6 16.1 1.7 23.9l-65.7 0 0-224 40 0 0-48-88 0 0 320 128.1 0c12.1 25.5 30.5 47.5 53.1 64l-245.2 0 0-448zm336 112l0 32.3c-32.6 1.5-62.8 12.4-88 29.9l0-62.2 88 0zm8 272.1a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 48c-66.3 0-120-53.7-120-120s53.7-120 120-120 120 53.7 120 120c0 24.5-7.3 47.2-19.9 66.2 47.9 47.9 73.8 73.8 77.8 77.8L520.4 522c-4-4-29.9-29.9-77.8-77.8-19 12.6-41.7 19.9-66.2 19.9z"]
};
var faMelonSlice = {
  prefix: 'fass',
  iconName: 'melon-slice',
  icon: [512, 512, [], "e311", "M391.7 391.4c-96.8 96.8-253.5 96.6-350.4-.3L7.4 425c115.6 115.6 302.6 116 418.3 .3S540.9 122.6 425.3 7L391.4 41c96.9 96.9 97.1 253.6 .3 350.4zM320.3 128c0 106-86 192-192 192-14.4 0-28.4-1.6-41.9-4.6l-38.1 38.1 15.3 15.3c84.4 84.4 221.1 84.4 305.5 0 84.2-84.2 84.4-220.7 .3-305.1L353.8 48 315.7 86.1c3 13.5 4.6 27.5 4.6 41.9z"]
};
var faStairCar = {
  prefix: 'fass',
  iconName: 'stair-car',
  icon: [576, 512, [], "e7c5", "M247.1 0l328.9 0 0 48-64 0 0 48 64 0 0 64-272 0 0 304-67.3 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-67.3 0 0-251 8.3-7.2 232-200 6.8-5.8zM464 48l-176 0 0 48 176 0 0-48zM240 128l0-58.5-192 165.5 0 64 192.1-168.8c-.1-.7-.1-1.4-.1-2.1zm144 80l110.4 0 9.5 10.7 64 72 8.1 9.1 0 164.2-51.3 0c-10.4 36.9-44.4 64-84.7 64-48.6 0-88-39.4-88-88l0-232 32 0zM508.3 320l-42.7-48-49.6 0 0 48 92.3 0zM192 440a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm248 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faPrescriptionBottlePill = {
  prefix: 'fass',
  iconName: 'prescription-bottle-pill',
  icon: [576, 512, [], "e5c0", "M32 0l384 0 0 96-384 0 0-96zM64 144l320 0 0 70c-82.8 21.3-144 96.5-144 186 0 41.8 13.4 80.5 36 112l-212 0 0-64 96 0 0-48-96 0 0-48 96 0 0-48-96 0 0-48 96 0 0-48-96 0 0-64zM576 400c0 79.5-64.5 144-144 144-31.1 0-59.9-9.9-83.4-26.6L549.4 316.6C566.1 340.1 576 368.9 576 400zm-288 0c0-79.5 64.5-144 144-144 31.1 0 59.9 9.9 83.4 26.6L314.6 483.4C297.9 459.9 288 431.1 288 400z"]
};
var faClockEightThirty = {
  prefix: 'fass',
  iconName: 'clock-eight-thirty',
  icon: [512, 512, [], "e346", "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM232 392l0-91.2c-45.6 30.4-71.8 47.9-78.7 52.4l-26.6-39.9c.6-.4 39.3-26.2 116-77.3l37.3-24.9 0 204.8-48 0 0-24z"]
};
var faCloudMinus = {
  prefix: 'fass',
  iconName: 'cloud-minus',
  icon: [576, 512, [], "e35d", "M144 480l432 0 0-128c0-47.4-25.7-88.7-64-110.9l0-49.1c0-53-43-96-96-96-17.7 0-34.2 4.8-48.4 13.1-24.1-45.8-72.2-77.1-127.6-77.1-79.5 0-144 64.5-144 144l0 24.2C40.1 220 0 273.3 0 336l0 144 144 0zm72-216l168 0 0 48-192 0 0-48 24 0z"]
};
var faLaptopMobile = {
  prefix: 'fass',
  iconName: 'laptop-mobile',
  icon: [576, 512, ["phone-laptop"], "f87a", "M64 0l416 0 0 112-64 0 0-48-288 0 0 192 144 0 0 96-224 0-48-48 0-48 64 0 0-256zM320 160l224 0 0 352-224 0 0-352zm88 240l-24 0 0 48 96 0 0-48-72 0z"]
};
var faPhoneLaptop = faLaptopMobile;
var faBagShoppingPlus = {
  prefix: 'fass',
  iconName: 'bag-shopping-plus',
  icon: [448, 512, [], "e651", "M224 16c-35.3 0-64 28.7-64 64l0 48 128 0 0-48c0-35.3-28.7-64-64-64zM0 128l112 0 0-48c0-61.9 50.1-112 112-112S336 18.1 336 80l0 48 112 0 0 352-448 0 0-352zM200 400l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faClapperboardPlay = {
  prefix: 'fass',
  iconName: 'clapperboard-play',
  icon: [576, 512, [], "e132", "M486.1 64l-92.1 0-1 1-95 95-67.9 0 96-96-92.1 0-1 1-95 95-67.9 0 96-96-134.1 0 0 384 225.4 0c-11.2-24.4-17.4-51.4-17.4-80 0-106 86-192 192-192 41.8 0 80.5 13.4 112 36l0-138.1-59.8 59.8c-16.8-3.7-34.3-5.7-52.2-5.7-3.4 0-6.8 .1-10.2 .2L486.1 64zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM416.2 314.3c51.7 31 81.6 49 89.5 53.7-7.9 4.8-37.8 22.7-89.5 53.7l-24.2 14.5 0-136.5 24.2 14.5z"]
};
var faCircleRenminbi = {
  prefix: 'fass',
  iconName: 'circle-renminbi',
  icon: [512, 512, [], "e6e9", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM197.3 127.2c2.3 4 21.9 37.5 58.7 100.5 36.8-63 56.4-96.5 58.7-100.5l41.4 24.2c-1.9 3.3-22.3 38.2-61.1 104.6l41 0 0 32-56 0 0 32 56 0 0 32-56 0 0 48-48 0 0-48-56 0 0-32 56 0 0-32-56 0 0-32 41 0c-38.8-66.5-59.2-101.3-61.1-104.6l41.4-24.2z"]
};
var faLeftFromLine = {
  prefix: 'fass',
  iconName: 'left-from-line',
  icon: [576, 512, ["arrow-alt-from-right"], "f348", "M480.5 448l0-384 64 0 0 384-64 0zM21.5 256L40 238.6c113.3-107 174.7-165 184.5-174.2l0 127.7 160 0 0 0 32 0 0 128-192 0 0 127.7c-9.7-9.2-71.2-67.3-184.5-174.2L21.5 256z"]
};
var faArrowAltFromRight = faLeftFromLine;
var faEngineWarning = {
  prefix: 'fass',
  iconName: 'engine-warning',
  icon: [640, 512, ["engine-exclamation"], "f5f2", "M432 80l-88 0 0 48 136 0 0 80.7c-98.6 8.1-176 90.7-176 191.3 0 16.6 2.1 32.7 6 48l-54 0-42.7-64-85.3 0 0-104-32 0 0 104-48 0 0-256 48 0 0 104 32 0 0-104 168 0 0-48-88 0 0-48 224 0 0 48zm96 130.7l0-50.7 48 0 0 65.4c-15.1-6.9-31.2-11.9-48-14.8zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 112 32 0 0-112z"]
};
var faEngineExclamation = faEngineWarning;
var faPickleball = {
  prefix: 'fass',
  iconName: 'pickleball',
  icon: [576, 512, [], "e435", "M448 544a128 128 0 1 1 0-256 128 128 0 1 1 0 256zM576 208l-50.1 50.1c-23.5-11.6-49.9-18.1-77.9-18.1-64.4 0-120.8 34.6-151.5 86.3l-103.6-103.3-17-16.9-33.9 34 17 16.9 117.9 117.5c-3.2 13.3-4.9 27.2-4.9 41.5 0 10.8 1 21.3 2.8 31.6l-89-32.3-85.4 85-28.3 28.2-56.7-56.5c9.4-9.3 47.3-47.1 113.8-113.3L80 224 336-32 576 208zM448 468a20 20 0 1 0 0 40 20 20 0 1 0 0-40zm-72-72a20 20 0 1 0 0 40 20 20 0 1 0 0-40zm72 0a20 20 0 1 0 0 40 20 20 0 1 0 0-40zm72 0a20 20 0 1 0 0 40 20 20 0 1 0 0-40zm-72-72a20 20 0 1 0 0 40 20 20 0 1 0 0-40z"]
};
var faTrombone = {
  prefix: 'fass',
  iconName: 'trombone',
  icon: [576, 512, [], "e782", "M445.5 16c36.7 0 66.5 29.8 66.5 66.5 0 17.6-7 34.6-19.5 47L480 142.1 385.9 48 398.5 35.5C410.9 23 427.8 16 445.5 16zm.6 160l-46.1 46.1-94-94c.6-.6 1.3-1.3 1.9-1.9 5.8-5.8 20.5-20.5 44.2-44.2L446.1 176zm-80 80L138.9 483.1c-8.2 8.2-19.4 12.9-31 12.9-24.2 0-43.9-19.6-43.9-43.9 0-11.6 4.6-22.8 12.9-31l65.2-65.2-33.9-33.9-65.2 65.2c-17.2 17.2-26.9 40.6-26.9 65 0 50.7 41.1 91.9 91.9 91.9 24.4 0 47.7-9.7 65-26.9L526.5 163.5c21.5-21.5 33.5-50.6 33.5-81 0-63.2-51.3-114.5-114.5-114.5-30.4 0-59.5 12.1-81 33.5-75.9 75.9-85.8 85.8-90.6 90.6-34.7 34.7-79.4 57.5-127.9 65.1-50.4 8-89.2 14.1-116.3 18.4 41.1 41.1 54.2 54.2 153.3 153.3 1.1 1.1 14.9 14.9 41.3 41.3 4.3-27.2 10.4-65.9 18.4-116.3 5-31.5 16.4-61.4 33.2-88.1L366.1 256z"]
};
var faArrowUpRightFromSquare = {
  prefix: 'fass',
  iconName: 'arrow-up-right-from-square',
  icon: [512, 512, ["external-link"], "f08e", "M320 0l-32 0 0 64 114.7 0-201.4 201.4-22.6 22.6 45.3 45.3 22.6-22.6 201.4-201.4 0 114.7 64 0 0-224-192 0zM32 96l-32 0 0 416 416 0 0-192-64 0 0 128-288 0 0-288 128 0 0-64-160 0z"]
};
var faExternalLink = faArrowUpRightFromSquare;
var faPersonCarryEmpty = {
  prefix: 'fass',
  iconName: 'person-carry-empty',
  icon: [320, 512, [], "e785", "M128-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM64 112l96.5 0 9.6 13.4 70.4 98.6 79.5 0 0 64-112.5 0c-4.3-6-14.8-20.8-31.5-44.1l0 80.1 67.2 50.4 12.8 9.6 0 160-64 0 0-128-89.6-67.2C78.2 330.7 64 302.2 64 272l0-160zm0 267.3c3.1 2.7 6.3 5.4 9.6 7.9l54.4 40.8 0 116-64 0 0-164.7z"]
};
var faBorderRight = {
  prefix: 'fass',
  iconName: 'border-right',
  icon: [448, 512, [], "f852", "M64 32l0 64-64 0 0-64 64 0zm128 0l0 64-64 0 0-64 64 0zm128 0l0 64-64 0 0-64 64 0zm128 0l0 448-64 0 0-448 64 0zM320 480l-64 0 0-64 64 0 0 64zm-128 0l-64 0 0-64 64 0 0 64zM64 480l-64 0 0-64 64 0 0 64zm0-320l0 64-64 0 0-64 64 0zm0 192l-64 0 0-64 64 0 0 64z"]
};
var faArrowDownUpAcrossLine = {
  prefix: 'fass',
  iconName: 'arrow-down-up-across-line',
  icon: [576, 512, [], "e4af", "M160.3 525.3c2.9-2.9 42.4-42.4 118.6-118.6l22.6-22.6-45.3-45.3c-12 12-33.3 33.3-64 64l0-114.7 352 0 0-64-96 0 0-114.7c30.7 30.7 52 52 64 64L557.5 128 438.9 9.4 416.3-13.3c-2.9 2.9-42.4 42.4-118.6 118.6L275 128 320.3 173.3c12-12 33.3-33.3 64-64l0 114.7-352 0 0 64 96 0 0 114.7c-30.7-30.7-52-52-64-64L19 384c2.9 2.9 42.4 42.4 118.6 118.6l22.6 22.6zM128.3 32l0 144 64 0 0-176-64 0 0 32zm256 304l0 176 64 0 0-176-64 0z"]
};
var faFaceGrinBeam = {
  prefix: 'fass',
  iconName: 'face-grin-beam',
  icon: [512, 512, [128516, "grin-beam"], "f582", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-184c58.2 0 112.4-10.6 157.7-28.7-13 75.4-78.6 132.7-157.7 132.7S111.3 374.7 98.3 299.3C143.6 317.4 197.8 328 256 328zM176 180c-15.5 0-28 12.5-28 28l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28zm132 28l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28s-28 12.5-28 28z"]
};
var faGrinBeam = faFaceGrinBeam;
var faRectangleAd = {
  prefix: 'fass',
  iconName: 'rectangle-ad',
  icon: [512, 512, ["ad"], "f641", "M512 64l-512 0 0 384 512 0 0-384zM416 184l0 168-48 0 0-5.3c-8.7 3.4-18.1 5.3-28 5.3-42 0-76-34-76-76s34-76 76-76c9.9 0 19.3 1.9 28 5.3l0-45.3 48 0 0 24zm-48 92a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zM160 208c-8.8 0-16 7.2-16 16l0 32 48 0 0-32c0-8.8-7.2-16-16-16l-16 0zm32 96l-48 0 0 48-48 0 0-128c0-35.3 28.7-64 64-64l16 0c35.3 0 64 28.7 64 64l0 128-48 0 0-48z"]
};
var faAd = faRectangleAd;
var faCarSideBolt = {
  prefix: 'fass',
  iconName: 'car-side-bolt',
  icon: [640, 512, [], "e344", "M128 32l-22.7 0-7.5 21.4-48.5 138.6-49.3 0 0 208 64.4 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l144.7 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l80.4 0 0-208-120 0-110.4-147.2-9.6-12.8-272 0zm24 320a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm280 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM320 80l-24.9 112 88.9 0-160 144 24.9-112-88.9 0 160-144z"]
};
var faCircleUpRight = {
  prefix: 'fass',
  iconName: 'circle-up-right',
  icon: [512, 512, [], "e129", "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm72 160l-169.9 0c29.6 29.6 52.3 52.3 68 68-53 53-81 81-84 84 24.3 24.3 54.1 54.1 57.9 57.9 3-3 31-31 84-84 15.7 15.7 38.4 38.4 68 68l0-193.9-24 0z"]
};
var faPersonSkiJumping = {
  prefix: 'fass',
  iconName: 'person-ski-jumping',
  icon: [576, 512, ["ski-jump"], "f7c7", "M384.3 40a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-240 56l221.3 0c10.7 10.7 36.7 36.7 48 48l-22.6 22.6-143.1 143.1-15.4 92.1 263.9-136.5 0-65.4 48 0 0 94.6-13 6.7-464 240-21.3 11-22.1-42.6 21.3-11 116.1-60.1 27.9-167.6c3.3-19.7 12.7-38 26.8-52.1l58.9-58.9-130.7 0 0-64z"]
};
var faSkiJump = faPersonSkiJumping;
var faUserVneck = {
  prefix: 'fass',
  iconName: 'user-vneck',
  icon: [448, 512, [], "e461", "M224 8a120 120 0 1 0 0 240 120 120 0 1 0 0-240zm0 376l-64-64-80 0-64 192 416 0-64-192-80 0-64 64z"]
};
var faClarinet = {
  prefix: 'fass',
  iconName: 'clarinet',
  icon: [640, 512, [], "f8ad", "M640.5-32L640.5 13.3 219.2 434.5 162.5 559.3 1.2 398 126 341.3 463.4 3.8 640.5-32zm-384 360a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBookTanakh = {
  prefix: 'fass',
  iconName: 'book-tanakh',
  icon: [448, 512, ["tanakh"], "f827", "M448 0l-448 0 0 384 32 0 0 64-32 0 0 64 448 0 0-512zM384 416l0 32-288 0 0-64 256 0c17.7 0 32 14.3 32 32zM112 248l39-64-39-64 77.9 0 34.1-56 34.1 56 77.9 0-39 64 39 64-77.9 0-34.1 56-34.1-56-77.9 0z"]
};
var faTanakh = faBookTanakh;
var faFileXmark = {
  prefix: 'fass',
  iconName: 'file-xmark',
  icon: [384, 512, ["file-times"], "f317", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zm68.9 226.6l-33.9-33.9c-8.5 8.5-25.5 25.5-50.9 50.9-25.5-25.5-42.4-42.4-50.9-50.9l-33.9 33.9c8.5 8.5 25.5 25.5 50.9 50.9-25.5 25.5-42.4 42.4-50.9 50.9l33.9 33.9c8.5-8.5 25.5-25.5 50.9-50.9 25.5 25.5 42.4 42.4 50.9 50.9l33.9-33.9c-8.5-8.5-25.5-25.5-50.9-50.9 25.5-25.5 42.4-42.4 50.9-50.9z"]
};
var faFileTimes = faFileXmark;
var faSquareUser = {
  prefix: 'fass',
  iconName: 'square-user',
  icon: [448, 512, [], "e283", "M368 416l-32-96-224 0-32 96 288 0zM0 32l448 0 0 448-448 0 0-448zM224 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
};
var faClockSix = {
  prefix: 'fass',
  iconName: 'clock-six',
  icon: [512, 512, [], "e352", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392l0 264-48 0 0-288 48 0 0 24z"]
};
var faDinosaur = {
  prefix: 'fass',
  iconName: 'dinosaur',
  icon: [640, 512, [], "e5fe", "M448 0l-24 0-16 32-40 16 0 80 112 0c35.3 0 64 28.7 64 64l0 64-53.3 0-66.1-49.6c-40.2-30.1-89-46.4-139.2-46.4-57.7 0-113.4 21.5-156.1 60.3l-118.8 108-10.5 9.5 0 174.2 288 0 0-50.4-178.6-29.8-13.4-2.2 0-77.6 32 0 0 50.4 178.6 29.8 13.4 2.2 0 28.9c5.3 .4 10.6 .7 16 .7 16.6 0 32.7-2.1 48-6l0 54 128 0 0-87.9c76.5-35.9 128-113.5 128-201.5l0-30.6C640 86 554 0 448 0zm0 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faFrenchFries = {
  prefix: 'fass',
  iconName: 'french-fries',
  icon: [384, 512, [127839], "f803", "M176.2-16l0 239.1c-17.4-1.9-33.7-6.6-48-13.3l0-241.9 48 16zm-80 48l0 128-48 0 0-144 48 16zm240 0l0 128-48 0 0-144 48 16zm-80-16l0 192.5-.5 .2c-16 7.4-32.6 12.1-47.5 14.2l0-190.8 48-16zM1 222.2l42.8-20.1c29 40.9 87 69.9 148.4 69.9 26.1 0 56.2-7 83.7-19.7 27.6-12.8 50.8-30.4 64.7-50.1l42.8 20.1-64 240-4.8 17.8-244.9 0-4.8-17.8-64-240z"]
};
var faHotTubPerson = {
  prefix: 'fass',
  iconName: 'hot-tub-person',
  icon: [448, 512, ["hot-tub"], "f593", "M240 40c0 13.6 5.8 26.5 15.8 35.6l26.5 23.8C306.3 121 320 151.7 320 184l0 24-48 0 0-24c0-18.7-7.9-36.4-21.8-48.9l-26.5-23.8C203.5 93.1 192 67.2 192 40l0-24 48 0 0 24zM0 256l0-64 128 0 128 64 192 0 0 256-448 0 0-256zm120 64l-48 0 0 128 48 0 0-128zm128 24l0-24-48 0 0 128 48 0 0-104zm128-24l-48 0 0 128 48 0 0-128zM352 16l0 24c0 13.6 5.8 26.5 15.8 35.6l26.5 23.8C418.3 121 432 151.7 432 184l0 24-48 0 0-24c0-18.7-7.9-36.4-21.8-48.9l-26.5-23.8C315.5 93.1 304 67.2 304 40l0-24 48 0zM64 40a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faHotTub = faHotTubPerson;
var faFileHalfDashed = {
  prefix: 'fass',
  iconName: 'file-half-dashed',
  icon: [384, 512, [], "e698", "M240 0L0 0 0 320 384 320 384 144 240 0zm85.5 176L208 176 208 58.5 325.5 176zM0 352l0 64 64 0 0-64-64 0zM0 480l0 32 64 0 0-64-64 0 0 32zm176 32l0-64-80 0 0 64 80 0zm112 0l0-64-80 0 0 64 80 0zm64 0l32 0 0-64-64 0 0 64 32 0zm32-160l-64 0 0 64 64 0 0-64z"]
};
var faReflectHorizontal = {
  prefix: 'fass',
  iconName: 'reflect-horizontal',
  icon: [512, 512, [], "e664", "M280 32l-48 0 0 448 48 0 0-448zM0 432L176 256 0 80 0 432zM336 256l176 176 0-352-176 176z"]
};
var faDirectionLeftRight = {
  prefix: 'fass',
  iconName: 'direction-left-right',
  icon: [640, 512, [], "e6be", "M21 256l18.9 17.6C126.6 354 177.3 401.2 192.3 415l0-111 256 0 0 111c14.9-13.9 65.7-61 152.3-141.4l18.9-17.6-18.9-17.6C514 158 463.2 110.8 448.3 97l0 111-256 0 0-111c-14.9 13.9-65.7 61-152.3 141.4L21 256z"]
};
var faCartCircleExclamation = {
  prefix: 'fass',
  iconName: 'cart-circle-exclamation',
  icon: [640, 512, [], "e3f2", "M24-16l-24 0 0 48 76 0 60.4 332.3 3.6 19.7 164.7 0c1.4-16.7 4.9-32.8 10.3-48l-134.9 0-8.7-48 168.7 0c34.9-48.5 91.7-80 156-80 15.8 0 31.2 1.9 46 5.5L576 32 124.8 32c-3.7-20.3-6.6-36.3-8.7-48L24-16zM208 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm288 32a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-240l0 112-32 0 0-112 32 0zm0 176l-32 0 0-32 32 0 0 32z"]
};
var faSquareChf = {
  prefix: 'fass',
  iconName: 'square-chf',
  icon: [448, 512, [], "e6e6", "M448 32l-448 0 0 448 448 0 0-448zM104 144c22.1 0 40 17.9 40 40l0 32-32 0 0 80 32 0 0 32c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-144c0-22.1 17.9-40 40-40zm104 24l0 64 16 0 0-88 48 0 0 224-48 0 0-88-16 0 0 88-48 0 0-224 48 0 0 24zm104-24l72 0 0 48-48 0 0 40 40 0 0 48-40 0 0 88-48 0 0-224 24 0z"]
};
var faOutdent = {
  prefix: 'fass',
  iconName: 'outdent',
  icon: [512, 512, ["dedent"], "f03b", "M32 32l448 0 0 64-448 0 0-64zM224 160l256 0 0 64-256 0 0-64zM480 288l0 64-256 0 0-64 256 0zM32 416l448 0 0 64-448 0 0-64zm128-48L16 256 160 144 160 368z"]
};
var faDedent = faOutdent;
var faBrakeWarning = {
  prefix: 'fass',
  iconName: 'brake-warning',
  icon: [640, 512, [], "e0c7", "M320 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM104.1 88.8L91.1 109C63.8 151.4 48 201.8 48 256S63.8 360.6 91.1 403l13 20.2-40.3 26-13-20.2C18.6 379.1 0 319.7 0 256S18.6 132.9 50.8 83l13-20.2 40.3 26zM589.3 83C621.4 132.9 640 192.3 640 256s-18.6 123.1-50.7 173l-13 20.2-40.3-26 13-20.2c27.3-42.4 43.1-92.8 43.1-147s-15.8-104.6-43.1-147l-13-20.2 40.3-26 13 20.2zM292 380l56 0 0-56-56 0 0 56zm8.8-92l38.4 0 12.8-160-64 0 12.8 160z"]
};
var faRectangleTall = {
  prefix: 'fass',
  iconName: 'rectangle-tall',
  icon: [384, 512, [], "e791", "M0-64l384 0 0 640-384 0z"]
};
var faSquareStar = {
  prefix: 'fass',
  iconName: 'square-star',
  icon: [448, 512, [], "e27f", "M448 32l-448 0 0 448 448 0 0-448zM177.7 192.3l46.3-90.7 46.3 90.7 100.6 16-72 72 15.9 100.6-90.8-46.2-90.8 46.2 15.9-100.6-72-72 100.6-16z"]
};
var faHandPeace = {
  prefix: 'fass',
  iconName: 'hand-peace',
  icon: [448, 512, [9996], "f25b", "M224 0l0 240-64 0 0-240 64 0zm96 160l0 128-64 0 0-128 64 0zm32 32l64 0 0 128-64 0 0-128zM69.5 69.8l74.5 170.2-69.9 0C23.5 124.4-1.9 66.4-2 66.1L56.6 40.5 69.5 69.8zM32 363l0-91 192 0 0 80-112 0 0 32 144 0 0-64 64 0 0 32 96 0c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L69.5 453.5C45.5 429.5 32 396.9 32 363z"]
};
var faHeadSideVirus = {
  prefix: 'fass',
  iconName: 'head-side-virus',
  icon: [512, 512, [], "e064", "M224 0C338.4 0 432.7 85.7 446.3 196.4l49.7 59.6 0 64-64 0 0 128-112 0 0 64-256 0 0-131.2C24.4 340.4 0 285 0 224 0 100.3 100.3 0 224 0zm84.9 89.2l-17 17C275.7 122.4 248 110.9 248 88l0-24-48 0 0 24c0 22.9-27.7 34.4-43.9 18.2l-17-17-33.9 33.9 17 17c16.2 16.2 4.7 43.9-18.2 43.9l-24 0 0 48 24 0c22.9 0 34.4 27.7 18.2 43.9l-17 17 33.9 33.9 17-17c16.2-16.2 43.9-4.7 43.9 18.2l0 24 48 0 0-24c0-22.9 27.7-34.4 43.9-18.2l17 17 33.9-33.9-17-17C309.6 259.7 321.1 232 344 232l24 0 0-48-24 0c-22.9 0-34.4-27.7-18.2-43.9l17-17-33.9-33.9zM192 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faUnicycle = {
  prefix: 'fass',
  iconName: 'unicycle',
  icon: [384, 512, [], "e7c7", "M128 0l0 32c0 8.8 7.2 16 16 16l144 0 0 64-64 0 0 50.9c81.9 15 144 86.8 144 173.1 0 97.2-78.8 176-176 176S16 433.2 16 336c0-86.3 62.1-158 144-173.1l0-50.9-16 0c-44.2 0-80-35.8-80-80l0-32 64 0zm32 228.6c-46.3 13.8-80 56.6-80 107.4 0 61.9 50.1 112 112 112s112-50.1 112-112c0-50.7-33.7-93.6-80-107.4l0 139.4-64 0 0-139.4z"]
};
var faSquareDown = {
  prefix: 'fass',
  iconName: 'square-down',
  icon: [448, 512, [11015, "arrow-alt-square-down"], "f350", "M0 480l448 0 0-448-448 0 0 448zM352 256l0 8-128 128-128-128 0-8 80 0 0-128 96 0 0 128 80 0z"]
};
var faArrowAltSquareDown = faSquareDown;
var faCrutches = {
  prefix: 'fass',
  iconName: 'crutches',
  icon: [640, 512, [], "f7f8", "M245.5 56l1.4-1.4 22.6-22.6-45.3-45.3-22.6 22.6-160 160-22.6 22.6 45.3 45.3 22.6-22.6 1.4-1.4 72 72 0-62.4 14.1-14.1-40.8-40.8 66.7-66.7 40.8 40.8 45.3-45.3-40.8-40.8zM473.6 486.6l38.6 38.6 45.3-45.3-102.1-102.1-45.3 45.3 63.4 63.4zM438.9 9.4l-22.6-22.6-45.3 45.3 22.6 22.6 1.4 1.4-177.4 177.4-9.4 9.4 0 112-86.6 86.6C96.1 466.9 97.2 465.8 83 480l45.3 45.3c24.4-24.4 56.2-56.2 125.3-125.3l112 0 9.4-9.4 177.4-177.4 24 24 45.3-45.3-22.6-22.6-160-160zM507 168l-82.7 82.7-66.7-66.7 82.7-82.7 66.7 66.7zM272.3 269.3l40-40 66.7 66.7-40 40-66.7 0 0-66.7z"]
};
var faGramophone = {
  prefix: 'fass',
  iconName: 'gramophone',
  icon: [384, 512, [], "f8bd", "M110.8-36.8l34.4 9.1 4.5 9.4c48.3 101.3 120.9 151.7 166.6 174.9 32.4 16.4 59.7 49.8 59.7 90.6 0 48.2-39 88.8-88 88.8l-104 0-24 0 0-48c2.7 0 45.3 0 128 0l0 0c21.7 0 40-18.3 40-40.8 0-2.3-.2-4.7-.6-7-2.5-14-12.5-22.6-24.4-23.5-50.7-3.5-139.7 2.6-233.4 67l-9.2 6.3-33.8-8.9 6.2-23.3 72-272 6-22.6zM32 384l320 0 0 64 32 0 0 64-384 0 0-64 32 0 0-64z"]
};
var faH3 = {
  prefix: 'fass',
  iconName: 'h3',
  icon: [576, 512, [], "f315", "M96 96l0-32-64 0 0 384 64 0 0-160 96 0 0 160 64 0 0-384-64 0 0 160-96 0 0-128zM384 288l56 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-120 0 0 64 120 0c61.9 0 112-50.1 112-112 0-31.3-12.9-59.7-33.6-80 20.7-20.3 33.6-48.7 33.6-80 0-61.9-50.1-112-112-112l-120 0 0 64 120 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-88 0 0 64 32 0z"]
};
var faCompass = {
  prefix: 'fass',
  iconName: 'compass',
  icon: [512, 512, [129517], "f14e", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm184-72l-56 200 200-56 56-200-200 56zm72 40a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faRollerCoaster = {
  prefix: 'fass',
  iconName: 'roller-coaster',
  icon: [576, 512, [], "e324", "M128 132.2c-37.1 11.7-64 46.4-64 87.3L64 480 0 480 0 219.5C0 133.6 69.6 64 155.5 64 209.2 64 259 91.6 287.4 137.1l93.5 149.6c13 20.7 35.7 33.3 60.2 33.3l6.9 0c35.3 0 64-28.7 64-64 0-.2 0-.4 0-.7-.2-24.7-12.9-46.4-32-59.2l0 42.6c0 18.4-14.9 33.2-33.2 33.2-11.5 0-22.1-5.9-28.2-15.6l-2.6-4.1 0-64.2c-8.9 3.1-17.2 8-24.3 14.4l-3.5 3.2c-4.1-5.2-8-10.7-11.6-16.4L353 151.4c24.4-20.3 55.2-31.4 87-31.4 75.1 0 136.1 60.9 136.1 136 0 .3 0 .5 0 .8l0 223.2-64 0 0-113.1c-18.8 10.9-40.7 17.1-64 17.1l0 96-64 0 0-108.7c-23.3-10.9-43.3-28.3-57.4-50.8l-6.6-10.6 0 170-64 0 0-272.4-22.8-36.6c-10-16-24.4-28.2-41.2-35.4l0 344.4-64 0 0-347.8z"]
};
var faPenNib = {
  prefix: 'fass',
  iconName: 'pen-nib',
  icon: [576, 512, [10001], "f5ad", "M81 497l15 15 288-96 61.5-184.5-133-133-184.5 61.5-96 288 15 15 146.6-146.6c-1.1-4-1.6-8.1-1.6-12.4 0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48c-4.3 0-8.5-.6-12.4-1.6L81 497zM349 67l128 128 99-99-128-128-99 99z"]
};
var faTentArrowsDown = {
  prefix: 'fass',
  iconName: 'tent-arrows-down',
  icon: [576, 512, [], "e581", "M145.4 193c57.2-57.2 86.8-86.8 89-89L200.4 70.1c-9 9-25 25-48 48l0-126.1-48 0 0 126.1c-23-23-39-39-48-48L22.5 104c2.1 2.1 31.8 31.8 89 89l17 17 17-17zm303 17c2.1-2.1 31.8-31.8 89-89l17-17-33.9-33.9c-9 9-25 25-48 48l0-126.1-48 0 0 126.1c-23-23-39-39-48-48L342.5 104c2.1 2.1 31.8 31.8 89 89l17 17zM94.2 277.3l-29.7 234.7 222.9 0 0-160 97.1 160 128 0-29.7-234.7-195.4-117.3-193.1 117.3z"]
};
var faDuck = {
  prefix: 'fass',
  iconName: 'duck',
  icon: [512, 512, [129414], "f6d8", "M431.5 125.9c-5.1-52.7-49.5-93.9-103.5-93.9-57.4 0-104 46.6-104 104 0 36.8 19.1 69.2 48 87.7l0 4.9-208 59.4-32-32-32 0 0 32C0 394 86 480 192 480l120 0c70.7 0 128-57.3 128-128 0-36.6-15.4-69.6-40-93l0-35 16 0c53 0 96-43 96-96l-64 0-16.5-2.1zM320 136a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM242.1 396.4c-32.8 8.2-65.9-.7-89.2-21.4 8.9-10 17.7-19.9 26.6-29.9 13.4 11.9 33.1 17.4 52.9 12.5 24.3-6.1 40.9-25.7 43.8-47.3l39.6 5.3c-5.1 38.2-33.7 70.9-73.7 80.9z"]
};
var faDrawCircle = {
  prefix: 'fass',
  iconName: 'draw-circle',
  icon: [576, 512, [58054, "vector-circle"], "f5ed", "M224-32l128 0 0 40.1C442 31.2 512.8 102 535.9 192l40.1 0 0 128-40.1 0C512.8 410 442 480.8 352 503.9l0 40.1-128 0 0-40.1C134 480.8 63.2 410 40.1 320L0 320 0 192 40.1 192C63.2 102 134 31.2 224 8.1L224-32zM469.1 192C449.8 137.4 406.6 94.2 352 74.9l0 21.1-128 0 0-21.1C169.4 94.2 126.2 137.4 106.9 192l21.1 0 0 128-21.1 0c19.3 54.6 62.5 97.8 117.1 117.1l0-21.1 128 0 0 21.1c54.6-19.3 97.8-62.5 117.1-117.1l-21.1 0 0-128 21.1 0z"]
};
var faVectorCircle = faDrawCircle;
var faForwardFast = {
  prefix: 'fass',
  iconName: 'forward-fast',
  icon: [512, 512, [9197, "fast-forward"], "f050", "M0 494.5c15.7-13.8 90.4-79.1 224-196l0 196c15.7-13.8 90.4-79.1 224-196l0 181.5 64 0 0-448-64 0 0 181.5C314.4 96.6 239.7 31.3 224 17.5l0 196C90.4 96.6 15.7 31.3 0 17.5l0 477z"]
};
var faFastForward = faForwardFast;
var faTrees = {
  prefix: 'fass',
  iconName: 'trees',
  icon: [640, 512, [], "f724", "M320 160l-60.8 0 108.8 128-93.7 0 109.7 128-160 0 0 96-64 0 0-96-160 0 109.7-128-93.7 0 108.8-128-60.8 0 128-160 128 160zm256 0l-60.8 0 108.8 128-93.7 0 109.7 128-160 0 0 96-64 0 0-128-48-64 80 0-97.3-128 65.3 0-65.3-70.4 97.3-121.6 128 160z"]
};
var faCrop = {
  prefix: 'fass',
  iconName: 'crop',
  icon: [512, 512, [], "f125", "M128 0l0 338.7 210.7-210.7-162.7 0 0-64 226.7 0C431.2 35.6 451.6 15.2 464 2.7L509.3 48c-12.4 12.4-32.8 32.8-61.3 61.3l0 274.7 64 0 0 64-64 0 0 64-64 0 0-338.7-210.7 210.7 162.7 0 0 64-272 0 0-320-64 0 0-64 64 0 0-64 64 0z"]
};
var faWhiskeyGlass = {
  prefix: 'fass',
  iconName: 'whiskey-glass',
  icon: [448, 512, [129347, "glass-whiskey"], "f7a0", "M32 32L0 32 0 352c0 70.7 57.3 128 128 128l192 0c70.7 0 128-57.3 128-128l0-320-416 0zM64 256l0-160 320 0 0 160-320 0z"]
};
var faGlassWhiskey = faWhiskeyGlass;
var faDownFromBracket = {
  prefix: 'fass',
  iconName: 'down-from-bracket',
  icon: [448, 512, [], "e66b", "M241.4 504.5L224 523 206.6 504.5C99.6 391.2 41.5 329.7 32.3 320l127.7 0 0-160 128 0 0 160 127.7 0c-9.2 9.7-67.3 71.2-174.2 184.5zM64 160l0 32-64 0 0-192 448 0 0 192-64 0 0-128-320 0 0 96z"]
};
var faGearComplexCode = {
  prefix: 'fass',
  iconName: 'gear-complex-code',
  icon: [512, 512, [], "e5eb", "M303 0l-96 0-7 55.7c-16.8 4.7-32.7 11.5-47.5 20L107.9 41 40 108.9 75 153.9c-8.3 14.7-14.8 30.4-19.4 47L-1 208 .3 304 55.6 311c4.5 16.6 11.1 32.4 19.4 47.1l-35 45 67.9 67.9 44.6-34.7c14.8 8.5 30.7 15.3 47.5 20l7 55.7 96 0 6.9-55c17.2-4.6 33.6-11.3 48.7-19.9L402.1 471 470 403.1 436.5 360c8.9-15.3 15.8-31.8 20.6-49.3l54-6.7 0-96-54-6.7c-4.7-17.4-11.7-34-20.6-49.3L470 108.9 402.1 41 358.6 74.9c-15.2-8.6-31.5-15.3-48.7-19.9L303 0zm-3.2 156.5l-48 208-4.5 19.5-39-9 4.5-19.5 48-208 4.5-19.5 39 9-4.5 19.5zM182.4 238.1L164.6 256c12.5 12.5 23.2 23.2 32 32l-28.3 28.3c-6.5-6.5-21.8-21.8-46.1-46.1l-14.1-14.1 46.1-46.1 14.1-14.1 28.3 28.3-14.1 14.1zm176-28.3c24.3 24.3 39.7 39.7 46.1 46.1-6.5 6.5-21.8 21.8-46.1 46.1L344.3 316.3 316 288c8.8-8.8 19.5-19.5 32-32-12.5-12.5-23.2-23.2-32-32l28.3-28.3 14.1 14.1z"]
};
var faSquareN = {
  prefix: 'fass',
  iconName: 'square-n',
  icon: [448, 512, [], "e277", "M448 32l-448 0 0 448 448 0 0-448zM128 144l35.4 0 7.2 8.8 101.4 124 0-132.8 48 0 0 224-35.4 0-7.2-8.8-101.4-124 0 132.8-48 0 0-224z"]
};
var faSquare3 = {
  prefix: 'fass',
  iconName: 'square-3',
  icon: [448, 512, [], "e258", "M448 32l-448 0 0 448 448 0 0-448zM252 232c11 0 20-9 20-20s-9-20-20-20l-108 0 0-48 108 0c37.6 0 68 30.4 68 68 0 16.8-6.1 32.1-16.2 44 10.1 11.9 16.2 27.2 16.2 44 0 37.6-30.4 68-68 68l-108 0 0-48 108 0c11 0 20-9 20-20s-9-20-20-20l-76 0 0-48 76 0z"]
};
var faUfoBeam = {
  prefix: 'fass',
  iconName: 'ufo-beam',
  icon: [576, 512, [], "e048", "M186.3 104.2c-11.6 18.5-18.3 40.4-18.3 63.8 51.6 51.6 188.4 51.6 240 0 0-23.4-6.7-45.3-18.3-63.8-21.2-33.8-58.8-56.2-101.7-56.2s-80.4 22.4-101.7 56.2zm-58.7 13.4C149.1 49.5 212.8 0 288 0S426.9 49.5 448.3 117.7c77 23 127.7 62 127.7 106.3 0 70.7-128.9 128-288 128S0 294.7 0 224c0-44.3 50.7-83.4 127.7-106.3zM321.9 272L288 238.1 254.1 272 288 305.9 321.9 272zM120 206.1L86.1 240 120 273.9 153.9 240 120 206.1zM489.9 240L456 206.1 422.1 240 456 273.9 489.9 240zM169.4 401.9l-13.7 19.7-72 104-13.7 19.7-39.5-27.3 13.7-19.7 72-104 13.7-19.7 39.5 27.3zm250.9 19.7l-13.7-19.7 39.5-27.3 13.7 19.7 72 104 13.7 19.7-39.5 27.3-13.7-19.7-72-104z"]
};
var faSquare = {
  prefix: 'fass',
  iconName: 'square',
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M0 32l448 0 0 448-448 0z"]
};
var faGarlic = {
  prefix: 'fass',
  iconName: 'garlic',
  icon: [512, 512, [129476], "e40e", "M44.6 204.3l57.4-46c-5 14.6-11.5 26.2-18.7 38.4-.8 1.4-1.6 2.7-2.5 4.1-7.1 11.8-15.2 25.4-21.3 41.7-7.1 18.8-11.6 40.7-11.6 69.4 0 40.4 13.8 73.7 35.8 98.7-48.5-15-83.8-60.2-83.8-113.6 0-36.1 16.4-70.3 44.6-92.8zM393.1 416l-65.8 0c24.9-25.5 40.7-60.7 40.7-104 0-55.4-21.8-85-40.9-111l0 0c-1.2-1.7-2.5-3.3-3.7-5-9.7-13.3-18.2-25.8-24.5-42-6.3-16-10.8-36.7-10.8-66l0-88 64 0 0 112 115.4 92.3C495.6 226.9 512 261 512 297.1 512 362.8 458.8 416 393.1 416zM240 88c0 34.6 5.4 61.3 14.2 83.6 8.7 22.1 20.2 38.7 30.5 52.7 1.1 1.6 2.3 3.1 3.4 4.6 18.4 25 32 43.6 32 83.1 0 64-50.3 104-112 104S96 376 96 312c0-23.3 3.6-39.4 8.4-52.4 4.6-12.1 10.5-22 17.7-34.2l2.5-4.1c8.2-13.9 17.4-30 24.2-51.6 6.9-21.6 11.1-47.6 11.1-81.6l0-88 80 0 0 88zM136 448l48 0 0 64-48 0 0-64zm64 0l48 0 0 64-48 0 0-64zm64 0l48 0 0 64-48 0 0-64zm64 0l48 0 0 64-48 0 0-64z"]
};
var faBackpack = {
  prefix: 'fass',
  iconName: 'backpack',
  icon: [448, 512, [127890], "f5d4", "M128 0l192 0 0 96c70.7 0 128 57.3 128 128l0 288-80 0 0-208-288 0 0 208-80 0 0-288C0 153.3 57.3 96 128 96l0-96zm0 512l0-160 192 0 0 160-192 0zM272 48l-96 0 0 48 96 0 0-48zM152 176l-24 0 0 48 192 0 0-48-168 0z"]
};
var faFileCertificate = {
  prefix: 'fass',
  iconName: 'file-certificate',
  icon: [576, 512, ["file-award"], "f5f3", "M368 0l-240 0 0 144c97.2 0 176 78.8 176 176 0 46.8-18.2 89.3-48 120.8l0 71.2 256 0 0-368-144-144zm85.5 176L336 176 336 58.5 453.5 176zM208 419.9c29.3-23.5 48-59.5 48-99.9 0-70.7-57.3-128-128-128S0 249.3 0 320c0 40.4 18.7 76.5 48 99.9l0 132.1 80-40 80 40 0-132.1zM80 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faFileAward = faFileCertificate;
var faPeople = {
  prefix: 'fass',
  iconName: 'people',
  icon: [640, 512, [], "e216", "M136.3 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm40 520l-64 0 0-277.9c-14 26.1-25.6 47.9-34.9 65.2l-56.5-30.2 15.1-28.2 76.9-144 9-16.9 140.5 0 9 16.9 48.7 91.2 48.7-91.2 9-16.9 140.5 0 9 16.9 76.9 144 15.1 28.2-56.5 30.2c-8.1-15.1-22.1-41.3-42-78.6l47.1 147.3-40 0 0 144-64 0 0-144-32 0 0 144-64 0 0-144-40 0 47.1-147.3c-20.9 39.2-32.9 61.6-36 67.3l-38.4 0c-4.2-7.9-13.8-25.9-28.8-53.9l0 277.9-64 0 0-208-32 0 0 208zm272-576a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faLandmarkMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'landmark-magnifying-glass',
  icon: [640, 512, [], "e622", "M480.4 416l0-132.7c-12.8 3.1-26.2 4.8-40 4.8-2.7 0-5.4-.1-8-.2l0 128.1-64 0 0-144.1c-18-8.5-34.2-20.2-48-34.3l0 178.3-64 0 0-208 40.8 0c-15.7-25.6-24.8-55.7-24.8-87.9 0-40.4 14.2-77.4 38-106.4l-22-13.7-256 160 0 48 64 0 0 208-64 48 0 48 512 0 0-48-64-48zm-336 0l0-208 64 0 0 208-64 0zm296-367.9a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm0 192c24.5 0 47.2-7.3 66.2-19.9 47.9 47.9 73.8 73.8 77.8 77.8l33.9-33.9c-4-4-29.9-30-77.8-77.8 12.6-19 19.9-41.7 19.9-66.2 0-66.3-53.7-120-120-120s-120 53.7-120 120 53.7 120 120 120z"]
};
var faClipboardMedical = {
  prefix: 'fass',
  iconName: 'clipboard-medical',
  icon: [384, 512, [], "e133", "M320 0l-256 0 0 32-64 0 0 480 384 0 0-480-64 0 0-32zM112 112l0-48 160 0 0 48-160 0zm48 120l64 0 0 56 56 0 0 64-56 0 0 56-64 0 0-56-56 0 0-64 56 0 0-56z"]
};
var faFaceGrin = {
  prefix: 'fass',
  iconName: 'face-grin',
  icon: [512, 512, [128512, "grin"], "f580", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-184c58.2 0 112.4-10.6 157.7-28.7-13 75.4-78.6 132.7-157.7 132.7S111.3 374.7 98.3 299.3C143.6 317.4 197.8 328 256 328zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGrin = faFaceGrin;
var faFileContract = {
  prefix: 'fass',
  iconName: 'file-contract',
  icon: [384, 512, [], "f56c", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM160 64l-96 0 0 48 96 0 0-48zM64 208l96 0 0-48-96 0 0 48zm88 112l-11.4 0-7.2 8.8-72 88 37.2 30.4 57-69.7c17.5 43.6 26.8 67.1 28.2 70.5l136.2 0 0-48-103.8 0c-20.6-51.6-31.3-78.2-32-80L152 320z"]
};
var faBorderBottomRight = {
  prefix: 'fass',
  iconName: 'border-bottom-right',
  icon: [448, 512, ["border-style-alt"], "f854", "M448 64l0-32-64 0 0 384-384 0 0 64 448 0 0-416zM64 32l-64 0 0 64 64 0 0-64zM192 96l0-64-64 0 0 64 64 0zm128 0l0-64-64 0 0 64 64 0zM64 224l0-64-64 0 0 64 64 0zm0 64l-64 0 0 64 64 0 0-64z"]
};
var faBorderStyleAlt = faBorderBottomRight;
var faCassetteTape = {
  prefix: 'fass',
  iconName: 'cassette-tape',
  icon: [512, 512, [128429], "f8ab", "M0 64l512 0 0 384-77.4 0-36.2-96.4-5.8-15.6-273.3 0-5.8 15.6-36.2 96.4-77.4 0 0-384zM359.4 384l24 64-254.7 0 24-64 206.7 0zM309.5 192l-106.9 0c3.5 10 5.5 20.8 5.5 32s-1.9 22-5.5 32l106.9 0c-3.5-10-5.5-20.8-5.5-32s1.9-22 5.5-32zm90.5 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM80 224a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faAngleUp = {
  prefix: 'fass',
  iconName: 'angle-up',
  icon: [448, 512, [8963], "f106", "M224.3 114.7l22.6 22.6 182.6 182.6-45.3 45.3-22.6-22.6-137.4-137.4-137.4 137.4-22.6 22.6-45.3-45.3 22.6-22.6 160-160 22.6-22.6z"]
};
var faFolderGrid = {
  prefix: 'fass',
  iconName: 'folder-grid',
  icon: [512, 512, [], "e188", "M512 448l-512 0 0-416 224 0 64 48 224 0 0 368zM160 224l-96 0 0 96 96 0 0-96zm144 0l-96 0 0 96 96 0 0-96zm48 0l0 96 96 0 0-96-96 0z"]
};
var faArrowRightToArc = {
  prefix: 'fass',
  iconName: 'arrow-right-to-arc',
  icon: [512, 512, [], "e4b2", "M448 256c0 106-86 192-192 192l-32 0 0 64 32 0c141.4 0 256-114.6 256-256S397.4 0 256 0l-32 0 0 64 32 0c106 0 192 86 192 192zM254.6 366.6c69.6-69.6 106.4-106.4 110.6-110.6-4.2-4.2-41.1-41.1-110.6-110.6L232 122.7 186.7 168c13.3 13.3 32 32 56 56L0 224 0 288 242.7 288c-24 24-42.7 42.7-56 56l45.3 45.3 22.6-22.6z"]
};
var faFaceSmile = {
  prefix: 'fass',
  iconName: 'face-smile',
  icon: [512, 512, [128578, "smile"], "f118", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-144c38.2 0 72-19.1 92.2-48.5l39.5 27.3C358.9 388.6 310.7 416 256 416s-102.9-27.4-131.8-69.2l39.5-27.3C184 348.9 217.8 368 256 368zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSmile = faFaceSmile;
var faLocationPinSlash = {
  prefix: 'fass',
  iconName: 'location-pin-slash',
  icon: [576, 512, ["map-marker-slash"], "f60c", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-138.5-138.5c32.1-53.8 57.3-113.4 57.3-168.1 0-104.1-86-188.6-192-188.6-61 0-115.3 27.9-150.5 71.5L49.3-16.9zM97.4 167.1c-.8 7.1-1.2 14.2-1.2 21.5 0 150.9 192 339.4 192 339.4s37.5-36.8 79.3-90.9L97.4 167.1z"]
};
var faMapMarkerSlash = faLocationPinSlash;
var faPersonDressBurst = {
  prefix: 'fass',
  iconName: 'person-dress-burst',
  icon: [640, 512, [], "e544", "M232 32.1l0-88-48 0 0 88 48 0zM8 168.1l88 0 0-48-88 0 0 48zm92.5 117.4c20.7-20.7 35.8-35.8 45.3-45.3l-33.9-33.9c-23.6 23.6-61.3 61.3-62.2 62.2l33.9 33.9 17-17zM49.6 19.6c23.6 23.6 61.3 61.3 62.2 62.2l33.9-33.9C122.2 24.4 84.5-13.4 83.5-14.3L49.6 19.6zM352 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-51.1 32l-16.3 0-9.6 13.2-92.9 128-18.8 25.9 51.8 37.6c9.1-12.6 28.5-39.2 57.9-79.8l-49 147.1 48 0 0 160 64 0 0-160 32 0 0 160 64 0 0-160 48 0-49-147.1c29.5 40.6 48.8 67.2 57.9 79.8l51.8-37.6c-.2-.2-37.4-51.6-111.7-153.9l-9.6-13.2-118.5 0z"]
};
var faDivide = {
  prefix: 'fass',
  iconName: 'divide',
  icon: [448, 512, [10135, 247], "f529", "M272 56l0 96-96 0 0-96 96 0zM0 224l448 0 0 64-448 0 0-64zM176 360l96 0 0 96-96 0 0-96z"]
};
var faUserHelmetSafety = {
  prefix: 'fass',
  iconName: 'user-helmet-safety',
  icon: [448, 512, [128119, "user-construction", "user-hard-hat"], "f82c", "M256-32l-64 0 0 96-32 0 0-70.9C123.9 14 99 52 96.2 96l-24.2 0 0 48 24 0c0 70.7 57.3 128 128 128s128-57.3 128-128l24 0 0-48-24.2 0C349 52 324.1 14 288-6.9l0 70.9-32 0 0-96zm48 176c0 44.2-35.8 80-80 80s-80-35.8-80-80l160 0zM432 512l-64-192-288 0-64 192 416 0z"]
};
var faUserConstruction = faUserHelmetSafety;
var faUserHardHat = faUserHelmetSafety;
var faCodeFork = {
  prefix: 'fass',
  iconName: 'code-fork',
  icon: [448, 512, [], "e13b", "M104 56l0 48-48 0 0-48 48 0zM56 0l-56 0 0 160 48 0 0 16c0 61.9 50.1 112 112 112l32 0 0 64-48 0 0 160 160 0 0-160-48 0 0-64 32 0c61.9 0 112-50.1 112-112l0-16 48 0 0-160-160 0 0 160 48 0 0 16c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-16 48 0 0-160-104 0zM392 56l0 48-48 0 0-48 48 0zM200 408l48 0 0 48-48 0 0-48z"]
};
var faBagsShopping = {
  prefix: 'fass',
  iconName: 'bags-shopping',
  icon: [576, 512, [128717], "f847", "M176 64l0 32 96 0 0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48zM128 96l0-32c0-53 43-96 96-96s96 43 96 96l0 32 128 0 0 80-304 0 0 272-144 0 0-352 128 0zM576 224l0 288-384 0 0-288 384 0zM336 312l0-24-48 0 0 64c0 53 43 96 96 96s96-43 96-96l0-64-48 0 0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-40z"]
};
var faBookSparkles = {
  prefix: 'fass',
  iconName: 'book-sparkles',
  icon: [448, 512, ["book-spells"], "f6b8", "M384 0l-384 0 0 512 448 0 0-64-32 0 0-64 32 0 0-384-64 0zM96 384l256 0 0 64-288 0 0-32c0-17.7 14.3-32 32-32zM259.2 195.2L288 136 316.8 195.2 376 224 316.8 252.8 288 312 259.2 252.8 200 224 259.2 195.2zM160 72L181.3 106.7 216 128 181.3 149.3 160 184 138.7 149.3 104 128 138.7 106.7 160 72z"]
};
var faBookSpells = faBookSparkles;
var faSunCloud = {
  prefix: 'fass',
  iconName: 'sun-cloud',
  icon: [640, 512, [127780], "f763", "M205.6-20.2c10.6 7.1 48.8 32.4 114.4 75.9 65.6-43.5 103.8-68.8 114.4-75.9 2.5 12.5 11.6 57.4 27.2 134.6 77.2 15.6 122.1 24.7 134.6 27.2-7.1 10.6-32.4 48.8-75.9 114.4L566 324.8c-20.1-13.2-44.1-20.8-70-20.8-24.5 0-47.4 6.9-66.8 18.8 11.9-19.4 18.8-42.3 18.8-66.8 0-70.7-57.3-128-128-128S192 185.3 192 256c0 67.6 52.4 122.9 118.8 127.7-23.8 21.9-38.8 53.4-38.8 88.3l0 16.2c-25.6 17-47.8 31.7-66.4 44.1-2.5-12.5-11.6-57.4-27.2-134.6-77.2-15.6-122.1-24.7-134.6-27.2 7.1-10.6 32.4-48.8 75.9-114.4-43.5-65.6-68.8-103.8-75.9-114.4 12.5-2.5 57.4-11.6 134.6-27.2 15.6-77.2 24.7-122.1 27.2-134.6zM240 256a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM576 544l-256 0 0-72c0-39.8 32.2-72 72-72 10.1 0 19.7 2.1 28.4 5.8 10.8-31.3 40.6-53.8 75.6-53.8 38.7 0 71 27.5 78.4 64 .5 0 1.1 0 1.6 0 35.3 0 64 28.7 64 64l0 64-64 0z"]
};
var faHouseFlag = {
  prefix: 'fass',
  iconName: 'house-flag',
  icon: [640, 512, [], "e50d", "M512 0l0 32 128 0 0 160-128 0 0 320-64 0 0-512 64 0zM240 48l160 144 0 320-349.5 0 0-208-50.5 0 0-40 240-216zm48 208l-96 0 0 96 96 0 0-96z"]
};
var faBullseyePointer = {
  prefix: 'fass',
  iconName: 'bullseye-pointer',
  icon: [512, 512, [], "f649", "M448 256c0 106-86 192-192 192-4.5 0-8.9-.2-13.3-.5L222 509.8c11.1 1.5 22.5 2.2 34 2.2 141.4 0 256-114.6 256-256S397.4 0 256 0 0 114.6 0 256c0 11.5 .8 22.9 2.2 34l62.2-20.7c-.3-4.4-.5-8.8-.5-13.3 0-106 86-192 192-192s192 86 192 192zm-48 0c0-79.5-64.5-144-144-144-78.7 0-142.6 63.1-144 141.4l68.1-22.7c10.6-31.8 40.6-54.7 75.9-54.7 44.2 0 80 35.8 80 80 0 35.3-22.9 65.3-54.7 75.9L258.6 400C336.9 398.6 400 334.7 400 256zm-144 0L16 336 104.2 373.8 7 471 41 505 138.2 407.8 176 496 256 256z"]
};
var faBuildingColumns = {
  prefix: 'fass',
  iconName: 'building-columns',
  icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M448 208l64 0 0-48-256-160-256 160 0 48 64 0 0 208-64 48 0 48 512 0 0-48-64-48 0-208zM176 416l-64 0 0-208 64 0 0 208zM288 208l0 208-64 0 0-208 64 0zM400 416l-64 0 0-208 64 0 0 208zM256 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBank = faBuildingColumns;
var faInstitution = faBuildingColumns;
var faMuseum = faBuildingColumns;
var faUniversity = faBuildingColumns;
var faCloudShowers = {
  prefix: 'fass',
  iconName: 'cloud-showers',
  icon: [512, 512, [], "f73f", "M96 320l-96 0 0-96c0-41.8 26.7-77.4 64-90.5L64 112c0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-416 0zm16 72l0 88-48 0 0-112 48 0 0 24zm224 0l0 88-48 0 0-112 48 0 0 24zM224 424l0 88-48 0 0-112 48 0 0 24zm224 0l0 88-48 0 0-112 48 0 0 24z"]
};
var faImageCircleXmark = {
  prefix: 'fass',
  iconName: 'image-circle-xmark',
  icon: [640, 512, [], "e76f", "M512 32l-448 0 0 448 276 0c-13.7-19-24-40.7-30-64l-198 0 96-144 46.1 69.1 81.9-133.1 18.6 30.2c35.1-38.2 85.5-62.2 141.4-62.2 5.4 0 10.7 .2 16 .7L512 32zM192 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm55.3-176.7L518.6 368c25.4 25.3 40 40 44 44L540 434.6c-4-4-18.6-18.6-44-44-25.3 25.4-40 40-44 44L429.4 412c4-4 18.6-18.6 44-44-25.4-25.3-40-40-44-44L452 301.4c4 4 18.6 18.6 44 44 25.3-25.4 40-40 44-44l22.6 22.6-11.3 11.3z"]
};
var faRug = {
  prefix: 'fass',
  iconName: 'rug',
  icon: [576, 512, [], "e569", "M24 64l56 0 0 384-80 0 0-48 32 0 0-40-32 0 0-48 32 0 0-32-32 0 0-48 32 0 0-32-32 0 0-48 32 0 0-40-32 0 0-48 24 0zm104 0l320 0 0 384-320 0 0-384zm448 0l0 48-32 0 0 40 32 0 0 48-32 0 0 32 32 0 0 48-32 0 0 32 32 0 0 48-32 0 0 40 32 0 0 48-80 0 0-384 80 0z"]
};
var faTruckBolt = {
  prefix: 'fass',
  iconName: 'truck-bolt',
  icon: [576, 512, [], "e3d0", "M416 32L0 32 0 448 67.3 448c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l102.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l67.3 0 0-237.3-9.4-9.4-64-64-9.4-9.4-77.3 0 0-96zm96 205.3l0 50.7-96 0 0-96 50.7 0 45.3 45.3zM152 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm232 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM256 80l-24.9 112 88.9 0-160 144 24.9-112-88.9 0 160-144z"]
};
var faCodeMerge = {
  prefix: 'fass',
  iconName: 'code-merge',
  icon: [448, 512, [], "f387", "M104 56l0 48-48 0 0-48 48 0zM56 0l-56 0 0 160 48 0 0 192-48 0 0 160 160 0 0-160-48 0 0-80c26.7 20.1 60 32 96 32l80 0 0 48 160 0 0-160-160 0 0 48-80 0c-47.6 0-87.1-34.6-94.7-80L160 160 160 0 56 0zm48 408l0 48-48 0 0-48 48 0zM344 248l48 0 0 48-48 0 0-48z"]
};
var faCactus = {
  prefix: 'fass',
  iconName: 'cactus',
  icon: [512, 512, [127797], "f8a7", "M256 0c53 0 96 43 96 96l0 256 48 0 0-128 96 0 0 224-144 0 0 64-192 0 0-192-144 0 0-224 96 0 0 128 48 0 0-128c0-53 43-96 96-96zm32 360a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM224 136a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faTableCellsHeader = {
  prefix: 'fass',
  iconName: 'table-cells-header',
  icon: [448, 512, [], "e6ad", "M320 288l64 0 0-64-64 0 0 64zm-64-64l-64 0 0 64 64 0 0-64zm-128 0l-64 0 0 64 64 0 0-64zM320 352l0 64 64 0 0-64-64 0zm-64 0l-64 0 0 64 64 0 0-64zm-128 0l-64 0 0 64 64 0 0-64zM0 32l448 0 0 448-448 0 0-448z"]
};
var faHouseTsunami = {
  prefix: 'fass',
  iconName: 'house-tsunami',
  icon: [640, 512, [], "e515", "M0 256C0 96.9 128.9-32 288-32l0 48C155.5 16 48 123.5 48 256S155.5 496 288 496l4.7 0 140.8-39.1 7.8-2.2 7.5 3 111.8 44.7c29.3-9.8 50.1-16.7 62.4-20.8l15.2 45.5c-11 3.7-34.6 11.5-70.8 23.6l-8.3 2.8-8.2-3.3-112.5-45-136.2 37.8-3.2 .9-11.3 0C128.9 544 0 415.1 0 256zM288 64l0 48c-79.5 0-144 64.5-144 144s64.5 144 144 144l4.7 0 140.8-39.1 7.8-2.2 7.5 3 111.8 44.7c29.2-9.7 50.1-16.7 62.4-20.8l15.2 45.5c-11 3.7-34.6 11.5-70.8 23.6l-8.3 2.8-8.2-3.3-112.5-45-136.2 37.8-3.2 .9-11.3 0C182 448 96 362 96 256S182 64 288 64zM448 96l127.4 96 .4 150.3-17.6 5.6c-81.2-30.9-123.9-47.2-128.2-48.8-7.3 2.8-44 16.7-110 41.9l0-149 128-96z"]
};
var faMagnifyingGlassChart = {
  prefix: 'fass',
  iconName: 'magnifying-glass-chart',
  icon: [576, 512, [], "e522", "M448.3 208c0 45.9-14.9 88.3-40 122.7L534.9 457.4 557.5 480 512.3 525.3 489.6 502.6 363 376c-34.4 25.2-76.8 40-122.7 40-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208zm-312 8l0 88 48 0 0-112-48 0 0 24zm80-96l0 184 48 0 0-208-48 0 0 24zm80 64l0 120 48 0 0-144-48 0 0 24z"]
};
var faInputPipe = {
  prefix: 'fass',
  iconName: 'input-pipe',
  icon: [576, 512, [], "e1be", "M64 128l0 256 448 0 0-256-448 0zM0 64l576 0 0 384-576 0 0-384zM160 184l0 168-48 0 0-192 48 0 0 24z"]
};
var faDisplayChartUpCircleDollar = {
  prefix: 'fass',
  iconName: 'display-chart-up-circle-dollar',
  icon: [640, 512, [], "e5e6", "M96 96l384 0 0 112.7c5.3-.4 10.6-.7 16-.7 16.6 0 32.7 2.1 48 6l0-182-512 0 0 384 208 0-16 48-96 0 0 48 212 0c-22.7-31.5-36-70.2-36-112 0-16.6 2.1-32.7 6-48L96 352 96 96zm352 72l0-24-128 0 0 48 46.1 0-54.1 54.1c-49.7-49.7-76.4-76.4-80-80-.8 .8-33.1 33.1-97 97l-17 17 33.9 33.9c3.6-3.6 30.3-30.3 80-80 49.7 49.7 76.4 76.4 80 80 11.2-11.2 22.8-22.8 34.8-34.8 8.4-10.4 17.9-19.9 28.3-28.3l24.9-24.9 0 7.7c14.9-8.6 31-15.3 48-19.6l0-46zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 328l32 0 0 32-61.8 0c-5.6 0-10.2 4.6-10.2 10.2 0 4.9 3.5 9.1 8.3 10l45 8.2c20 3.6 34.6 21.1 34.6 41.5 0 23.3-18.9 42.2-42.2 42.2l-5.8 0 0 24-32 0 0-24-32 0 0-32 69.8 0c5.6 0 10.2-4.6 10.2-10.2 0-4.9-3.5-9.1-8.3-10l-45-8.2c-20-3.6-34.6-21.1-34.6-41.5 0-22.6 17.7-41 40-42.1l0-24.1 32 0 0 24z"]
};
var faUmbrella = {
  prefix: 'fass',
  iconName: 'umbrella',
  icon: [512, 512, [], "f0e9", "M288.5 0l0-32-64 0 0 34C99.2 17.6 2.1 123.7 .5 252.7L0 290.9 27.6 264.5c15.8-15.2 37.3-24.5 60.9-24.5 31.8 0 59.6 16.8 75.1 42.1l12.9 21 14-20.4c14.4-21.1 38.6-34.8 66-34.8s51.6 13.8 66 34.8l14 20.4 12.9-21c15.5-25.3 43.3-42.1 75.1-42.1 23.6 0 45.1 9.3 60.9 24.5l27.6 26.4-.5-38.2C510.8 123.7 413.7 17.6 288.5 2l0-2zm0 328c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 99.9c0 11.1-9 20.1-20.1 20.1-6.7 0-13-3.4-16.7-9l-.5-.8-17.8-26.6-53.3 35.5 17.8 26.6 .5 .8c15.6 23.4 41.9 37.5 70 37.5 46.5 0 84.1-37.7 84.1-84.1l0-99.9z"]
};
var faBoneBreak = {
  prefix: 'fass',
  iconName: 'bone-break',
  icon: [640, 512, [], "f5d8", "M344-8l0-24-48 0 0 128 48 0 0-104zM201 39l-17-17-33.9 33.9c6.1 6.1 27.8 27.8 65 65l17 17 33.9-33.9-65-65zM473 73l17-17-33.9-33.9c-6.1 6.1-27.8 27.8-65 65l-17 17 33.9 33.9c6.1-6.1 27.8-27.8 65-65zM190.7 208c-7.6-45.4-47.1-80-94.7-80-53 0-96 43-96 96 0 33.4 17 62.8 42.9 80-25.9 17.2-42.9 46.6-42.9 80 0 53 43 96 96 96 47.6 0 87.1-34.6 94.7-80l258.7 0c7.6 45.4 47.1 80 94.7 80 53 0 96-43 96-96 0-33.4-17-62.8-42.9-80 25.9-17.2 42.9-46.6 42.9-80 0-53-43-96-96-96-47.6 0-87.1 34.6-94.7 80l-63.9 0-65.5 144-65.5-144-63.9 0z"]
};
var faMessageQuestion = {
  prefix: 'fass',
  iconName: 'message-question',
  icon: [512, 512, [], "e1e3", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM256 165.2c-17.7 0-32 14.3-32 32l-42.4 0c0-41.1 33.3-74.4 74.4-74.4s74.4 33.3 74.4 74.4c0 33.3-19.8 52.7-37.4 62.5-5.5 3.1-11 5.4-15.8 7.1l0 18.3-42.4 0 0-53.5c2.3-.3 4.6-.6 6.9-.9 10.5-1.3 21.1-2.7 30.5-8 9-5.1 15.8-12.4 15.8-25.6 0-17.7-14.3-32-32-32zM232 312l48 0 0 48-48 0 0-48z"]
};
var faCircle5 = {
  prefix: 'fass',
  iconName: 'circle-5',
  icon: [512, 512, [], "e0f2", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm40-368l24 0 0 48-96 0 0 32 40 0c39.8 0 72 32.2 72 72s-32.2 72-72 72l-88 0 0-48 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-128 120 0z"]
};
var faHillRockslide = {
  prefix: 'fass',
  iconName: 'hill-rockslide',
  icon: [576, 512, [], "e508", "M0 512L480 512 0 32 0 512zM160 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 0l36 64 72 0 36-64-36-64-72 0-36 64zM576 372l0-72-64-36-64 36 0 72 64 36 64-36zM416 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faUserSecret = {
  prefix: 'fass',
  iconName: 'user-secret',
  icon: [448, 512, [128373], "f21b", "M96 96l48-112 32 0 48 32 48-32 32 0 48 112 48 0 0 48-48 0 0 32c0 17-3.3 33.2-9.3 48l73.3 0 0 32-32 96 64 160-448 0 64-160-32-96 0-32 73.3 0c-6-14.8-9.3-31-9.3-48l0-32-48 0 0-48 48 0zm54.7 112c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l-57.3 0-16-40-16 40-57.3 0zM120 272l58.3 194.3 28.3-70.7-30.5-35.6 0-24 96 0 0 24-30.5 35.6 28.3 70.6 58.3-194.3-19.3 0c-22.6 19.9-52.2 32-84.7 32s-62.1-12.1-84.7-32L120 272z"]
};
var faPager = {
  prefix: 'fass',
  iconName: 'pager',
  icon: [512, 512, [128223], "f815", "M0 64l512 0 0 384-512 0 0-384zm64 64l0 128 384 0 0-128-384 0zM88 320l-24 0 0 48 96 0 0-48-72 0zm128 0l-24 0 0 48 104 0 0-48-80 0z"]
};
var faBriefcase = {
  prefix: 'fass',
  iconName: 'briefcase',
  icon: [512, 512, [128188], "f0b1", "M144 0l224 0 0 96 144 0 0 160-512 0 0-160 144 0 0-96zM0 304l192 0 0 48 128 0 0-48 192 0 0 176-512 0 0-176zM320 48l-128 0 0 48 128 0 0-48z"]
};
var faTrowelBricks = {
  prefix: 'fass',
  iconName: 'trowel-bricks',
  icon: [576, 512, [], "e58a", "M256.2 41.6l0-56.5C239.8-5.1 175.6 33.4 63.7 100.6L18 128c14.1 8.5 77.4 46.4 189.7 113.8l48.5 29.1 0-110.9 288 0 0-64-288 0 0-54.4zm64 182.4l0 128 224 0 0-128-224 0zm-128 160l-160 0 0 128 160 0 0-128zm352 0l-320 0 0 128 320 0 0-128z"]
};
var faBaseballBat = {
  prefix: 'fass',
  iconName: 'baseball-bat',
  icon: [640, 512, [], "e7e5", "M73 455l103-103 80-160 240-240 128 128-240 240-160 80-103 103 17 17-33.9 33.9-81.9-81.9 33.9-33.9 17 17z"]
};
var faUserPoliceTie = {
  prefix: 'fass',
  iconName: 'user-police-tie',
  icon: [448, 512, [], "e334", "M215.6-29.7L65.7 11.2C55.3 14 48 23.5 48 34.4 48 42.8 52.4 50.7 59.7 55L80 67.2 80 91.8c0 11.4 6 21.8 16 26.7L96 144c0 70.7 57.3 128 128 128s128-57.3 128-128l0-25.5c10-5 16-15.4 16-26.7l0-24.6 20.3-12.2c7.2-4.3 11.7-12.2 11.7-20.6 0-10.8-7.3-20.4-17.7-23.2L232.4-29.7c-5.5-1.5-11.3-1.5-16.8 0zM144 133.7c23.2 5.7 50.9 10.3 80 10.3s56.8-4.6 80-10.3l0 10.3c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-10.3zM272 304l-96 0 0 24 31.4 36.7-31.4 115.3-40-160-56 0-64 192 416 0-64-192-56 0-40 160-.6 0-31-115.1 31.6-36.9 0-24zM264 64l-40 40-40-40 40-40 40 40z"]
};
var faArrowRightToDottedLine = {
  prefix: 'fass',
  iconName: 'arrow-right-to-dotted-line',
  icon: [512, 512, [], "e6bc", "M512 448l0-64-64 0 0 64 64 0zM397.3 256l-22.6-22.6-128-128-22.6-22.6-45.3 45.3c6.6 6.6 38.6 38.6 96 96L0 224 0 288 274.7 288c-57.4 57.4-89.4 89.4-96 96l45.3 45.3 22.6-22.6 128-128 22.6-22.6zM512 277.3l-64 0 0 64 64 0 0-64zm0-42.7l0-64-64 0 0 64 64 0zM512 64l-64 0 0 64 64 0 0-64z"]
};
var faSocks = {
  prefix: 'fass',
  iconName: 'socks',
  icon: [512, 512, [129510], "f696", "M240 0l0 64-112 0 0-64 112 0zm0 112l0 136-70.4 52.8c-36.3 27.2-57.6 69.9-57.6 115.2 0 31.9 10.4 61.4 28 85.3-13.5 7-28.6 10.7-44 10.7-53 0-96-43-96-96 0-30.2 14.2-58.7 38.4-76.8l89.6-67.2 0-160 112 0zm48 0l192 0 0 256-166.4 124.8c-16.6 12.5-36.8 19.2-57.6 19.2-53 0-96-43-96-96 0-30.2 14.2-58.7 38.4-76.8L288 272 288 112zM480 64l-192 0 0-64 192 0 0 64z"]
};
var faGaugeMax = {
  prefix: 'fass',
  iconName: 'gauge-max',
  icon: [512, 512, ["tachometer-alt-fastest"], "f626", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64 0-3.4-.3-6.7-.8-9.9l109.1-65.5-24.7-41.2-109.1 65.5c-10.7-8.1-24.1-12.9-38.5-12.9-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAltFastest = faGaugeMax;
var faCommentArrowUp = {
  prefix: 'fass',
  iconName: 'comment-arrow-up',
  icon: [512, 512, [], "e144", "M512 240c0 132.5-114.6 240-256 240-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240zM273 143l-17-17c-2.1 2.1-31.8 31.8-89 89l-17 17 33.9 33.9c9-9 25-25 48-48l0 126.1 48 0 0-126.1c23 23 39 39 48 48L361.9 232c-2.1-2.1-31.8-31.8-89-89z"]
};
var faGuitarElectric = {
  prefix: 'fass',
  iconName: 'guitar-electric',
  icon: [512, 512, [127928], "f8be", "M352.5 64l0 50.7-107.1 107.1c-21.9-40.6 14.1-76.5 14.1-76.5l-23.8-23.8-40.7 40.7c-9.4 9.4-15.4 21.8-21.2 34-1.6 3.4-3.2 6.7-4.9 10-3.5 6.9-8.7 14.6-16.4 22.3-24.9 24.9-65.2 40-90.3 47.6-14.6 4.4-28.3 11.6-39 22.4-30.3 30.3-30.3 79.3 0 109.6l80.5 81.3c15.6 15.6 36.3 23.2 56.8 22.7 19.2-.5 38.2-8.1 52.8-22.7 10.8-10.8 18-24.5 22.4-39 7.5-25.1 22.7-66.2 47.6-91.2 7.7-7.7 15.4-12.9 22.3-16.4 3.3-1.7 6.6-3.3 10-4.9 12.2-5.8 24.6-11.8 34-21.2l28.8-28.8-23.8-23.8s-26.5 26.5-64.2 3.4L445.1 112.6c16.1 4.8 34.1 .7 46.5-11.7 19.7-19.7 17.9-52.1-3.8-69.5L448.5 0 352.5 64zm-143 207c23.8 23.8 40.2 40.2 49 49l-33.9 33.9c-8.8-8.8-25.1-25.1-49-49l-17-17 33.9-33.9 17 17zm-64 64c23.8 23.8 40.2 40.2 49 49l-33.9 33.9c-8.8-8.8-25.1-25.1-49-49l-17-17 33.9-33.9 17 17z"]
};
var faCoffeeBean = {
  prefix: 'fass',
  iconName: 'coffee-bean',
  icon: [448, 512, [], "e13e", "M9.2 361l100.3-120.4 7.2-8.6 192 0 106.7-128c-5.3-7.5-11.4-14.7-18.1-21.4-78.3-78.3-219.5-64.2-315.2 31.5-72 72-97.8 169.6-72.9 246.9zM32.6 408c5.3 7.5 11.4 14.7 18.1 21.4 78.3 78.3 219.5 64.2 315.2-31.5 72-72 97.8-169.6 72.9-246.9l-100.3 120.4-7.2 8.6-192 0-106.7 128z"]
};
var faArrowDownLongToLine = {
  prefix: 'fass',
  iconName: 'arrow-down-long-to-line',
  icon: [384, 512, [], "e6b7", "M41.6 310.6L19 288 64.3 242.7c6.6 6.6 38.6 38.6 96 96l0-402.7 64 0 0 402.7c57.4-57.4 89.4-89.4 96-96l45.3 45.3-173.3 173.3-22.6-22.6-128-128zM64.3 576l-32 0 0-64 320 0 0 64-288 0z"]
};
var faInputText = {
  prefix: 'fass',
  iconName: 'input-text',
  icon: [576, 512, [], "e1bf", "M512 128l0 256-448 0 0-256 448 0zM64 64l-64 0 0 384 576 0 0-384-512 0zm48 160l0 128 48 0 0-48 32 0 0 48 48 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64zm80 32l-32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32zm96-96l0 192 76 0c33.1 0 60-26.9 60-60 0-16-6.3-30.5-16.5-41.3 5.4-9 8.5-19.5 8.5-30.7 0-33.1-26.9-60-60-60l-68 0zm80 60c0 6.6-5.4 12-12 12l-20 0 0-24 20 0c6.6 0 12 5.4 12 12zm-32 84l0-24 28 0c6.6 0 12 5.4 12 12s-5.4 12-12 12l-28 0z"]
};
var faLightsHoliday = {
  prefix: 'fass',
  iconName: 'lights-holiday',
  icon: [576, 512, [], "f7b2", "M0 96l576 0 0 64-64 0 0 86.7c28.3 12.3 48 40.5 48 73.3 0 64-80 128-80 128s-80-64-80-128c0-32.8 19.7-61 48-73.3l0-86.7-128 0 0 86.7c28.3 12.3 48 40.5 48 73.3 0 64-80 128-80 128s-80-64-80-128c0-32.8 19.7-61 48-73.3l0-86.7-128 0 0 86.7c28.3 12.3 48 40.5 48 73.3 0 64-80 128-80 128S16 384 16 320c0-32.8 19.7-61 48-73.3l0-86.7-64 0 0-64z"]
};
var faT = {
  prefix: 'fass',
  iconName: 't',
  icon: [384, 512, [116], "54", "M32 32l-32 0 0 64 160 0 0 384 64 0 0-384 160 0 0-64-352 0z"]
};
var faMicrochip = {
  prefix: 'fass',
  iconName: 'microchip',
  icon: [512, 512, [], "f2db", "M176 24l0-24-48 0 0 64-64 0 0 64-64 0 0 48 64 0 0 56-64 0 0 48 64 0 0 56-64 0 0 48 64 0 0 64 64 0 0 64 48 0 0-64 56 0 0 64 48 0 0-64 56 0 0 64 48 0 0-64 64 0 0-64 64 0 0-48-64 0 0-56 64 0 0-48-64 0 0-56 64 0 0-48-64 0 0-64-64 0 0-64-48 0 0 64-56 0 0-64-48 0 0 64-56 0 0-40zM336 176l-160 0 0 160 160 0 0-160zM176 128l208 0 0 256-256 0 0-256 48 0z"]
};
var faKeySkeleton = {
  prefix: 'fass',
  iconName: 'key-skeleton',
  icon: [448, 512, [128477], "f6f3", "M304 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 224c79.5 0 144-64.5 144-144S383.5 0 304 0 160 64.5 160 144c0 28.2 8.1 54.5 22.1 76.7L25.4 377.4 2.7 400c8.2 8.2 37.1 37.1 86.6 86.6l22.6 22.6 45.3-45.3-64-64 18.7-18.7c30.7 30.7 52 52 64 64L221.3 400c-12-12-33.3-33.3-64-64l70.1-70.1c22.2 14 48.5 22.1 76.7 22.1z"]
};
var faTruckMedical = {
  prefix: 'fass',
  iconName: 'truck-medical',
  icon: [576, 512, [128657, "ambulance"], "f0f9", "M416 32L0 32 0 448 67.3 448c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l102.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l67.3 0 0-237.3-9.4-9.4-64-64-9.4-9.4-77.3 0 0-96zm96 205.3l0 50.7-96 0 0-96 50.7 0 45.3 45.3zM152 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm232 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM176 120l64 0 0 56 56 0 0 64-56 0 0 56-64 0 0-56-56 0 0-64 56 0 0-56z"]
};
var faAmbulance = faTruckMedical;
var faOm = {
  prefix: 'fass',
  iconName: 'om',
  icon: [512, 512, [128329], "f679", "M368 0l-32 32 32 32 32-32-32-32zm2.7 192l-64 64-61.5 0c6.9-14.5 10.8-30.8 10.8-48 0-61.9-50.1-112-112-112-41.2 0-77.1 22.2-96.5 55.2l55.1 32.5c8.4-14.2 23.8-23.7 41.4-23.7 26.5 0 48 21.5 48 48s-21.5 48-48 48l-56 0 24 64 48 0c35.3 0 64 28.7 64 64s-28.7 64-64 64C48 448 0 352 0 352S0 512 160 512c70.7 0 128-57.3 128-128 0-23.3-6.2-45.2-17.1-64l62.4 0 64-64 18.7 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32-64 0-96-48-96-48l0 64s16 48 96 48c53 0 96-43 96-96l0-96c0-53-43-96-96-96l-45.3 0zM480 64l0 64s-32 32-104 32c-104 0-120-96-120-96s66.5 32 112 32 112-32 112-32z"]
};
var faMosquitoNet = {
  prefix: 'fass',
  iconName: 'mosquito-net',
  icon: [640, 512, [], "e52c", "M504 392l48 0 0-40 48 0 0 40 40 0 0 48-40 0 0 48 40 0 0 48-40 0 0 40-48 0 0-40-48 0 0 40-48 0 0-40-40 0 0-48 40 0 0-48-40 0 0-48 40 0 0-40 48 0 0 40zM480.9 25.7C474 36 461 55.6 441.6 84.7l13.3 53.4 3.8 14.9-11.5 9.9-44.7 38.3 130.4 14.5c42.8 4.8 75.1 40.9 75.1 83.9 0 1.5-.1 2.9-.2 4.4l-199.8 0 0 40-47.8 0-8.2-10.9 0 106.7-64 0 0-106.6-32.3 43 0 47-3.8 6-40 64-12.7 20.5-39.8-26.3c4.6-7.4 21-33.6 49-78.5l0-41 0-8.3 4.9-6.6 39.3-52.2-66.2 59.5c-17 15.3-39 23.7-61.9 23.8l-8.1 0c-46.6 0-84.4-37.8-84.4-84.4 0-43 32.4-79.2 75.1-83.9l130.5-14.5c-35.4-30.3-54.1-46.3-56.2-48.2l3.8-14.9 13.3-53.4c-19.4-29-32.5-48.7-39.3-59l39-27.5c5.8 8.7 20.9 31.4 45.3 68.1l6.1 9.1-2.7 10.7-12.3 49.2 53.3 45.7 0-60.8 16 0 0-72.2 32 0 0 72.2 16 0 0 60.9 53.4-45.8-12.3-49.2-2.7-10.7 6.1-9.1C420.9 29.6 436 6.9 441.8-1.8l39 27.5zM504 488l48 0 0-48-48 0 0 48z"]
};
var faSquareManat = {
  prefix: 'fass',
  iconName: 'square-manat',
  icon: [448, 512, [], "e704", "M448 32l-448 0 0 448 448 0 0-448zM208 104l32 0 0 25.1c58.7 7.8 104 58.1 104 118.9l0 120-48 0 0-120c0-34.3-23.9-62.9-56-70.2l0 190.2-32 0 0-190.2c-32.1 7.3-56 36-56 70.2l0 120-48 0 0-120c0-60.8 45.3-111.1 104-118.9l0-25.1z"]
};
var faPrescriptionBottle = {
  prefix: 'fass',
  iconName: 'prescription-bottle',
  icon: [384, 512, [], "f485", "M0 0L384 0 384 96 0 96 0 0zM32 144l320 0 0 368-320 0 0-64 96 0 0-48-96 0 0-48 96 0 0-48-96 0 0-48 96 0 0-48-96 0 0-64z"]
};
var faUsersGear = {
  prefix: 'fass',
  iconName: 'users-gear',
  icon: [640, 512, ["users-cog"], "f509", "M320 224a104 104 0 1 0 0-208 104 104 0 1 0 0 208zM96 232a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm14.7 248l2.5-10.8 41.8-181.2-107 0-48 192 110.7 0zm49.3 0l184.6 0-2.1-3.7-24-41.6 32.4-18.7-32.4-18.7c14.7-25.4 33.3-57.7 56-97l16.3-28.3-182.8 0-48 208zM616 160a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zM544 288l-64 0 0 33.2c-12.7 4.3-24.2 11-34 19.7l-28.8-16.6-32 55.4 28.8 16.6c-1.3 6.4-1.9 12.9-1.9 19.7s.7 13.3 1.9 19.7l-28.8 16.6 32 55.4 28.8-16.6c9.8 8.7 21.4 15.4 34.1 19.7l0 33.2 64 0 0-33.2c12.7-4.3 24.2-11 34.1-19.7l28.8 16.6 32-55.4-28.8-16.6c1.3-6.4 1.9-12.9 1.9-19.7s-.7-13.3-1.9-19.7l28.8-16.6-32-55.4-28.8 16.6c-9.8-8.7-21.4-15.4-34-19.7l0-33.2zM472 416a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faUsersCog = faUsersGear;
var faRoadCircleExclamation = {
  prefix: 'fass',
  iconName: 'road-circle-exclamation',
  icon: [640, 512, [], "e565", "M288 32L169.4 32 64 480 321.4 480c-11.2-24.4-17.4-51.4-17.4-80s6.2-55.6 17.4-80l-33.4 0 0-128 64 0 0 81c35.2-39.9 86.7-65 144-65 5.4 0 10.8 .2 16.2 .7l-41.6-176.7-118.6 0 0 96-64 0 0-96zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 112-32 0 0-112 32 0z"]
};
var faTrashCanClock = {
  prefix: 'fass',
  iconName: 'trash-can-clock',
  icon: [576, 512, [], "e2aa", "M176-16l160 0 16 48 128 0 0 64-448 0 0-64 128 0 16-48zM64 144l384 0 0 64.7c-5.3-.4-10.6-.7-16-.7-16.6 0-32.7 2.1-48 6l0-6-48 0 0 25.7c-21.7 12.6-40.7 29.3-56 49l0-74.7-48 0 0 240 14 0c6 23.3 16.3 45 30 64l-212 0 0-368zm112 64l-48 0 0 240 48 0 0-240zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 96 80 0 0-32-48 0 0-64z"]
};
var faPause = {
  prefix: 'fass',
  iconName: 'pause',
  icon: [384, 512, [9208], "f04c", "M160 32l-160 0 0 448 160 0 0-448zm224 0l-160 0 0 448 160 0 0-448z"]
};
var faStaffSnake = {
  prefix: 'fass',
  iconName: 'staff-snake',
  icon: [448, 512, ["rod-asclepius", "rod-snake", "staff-aesculapius"], "e579", "M192-32l64 0 0 64 64 0c53 0 96 43 96 96s-43 96-96 96l-16 0 0-64 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0 192 32 0c53 0 96 43 96 96 0 47.6-34.6 87.1-80 94.7l0-67c9.6-5.5 16-15.9 16-27.7 0-17.7-14.3-32-32-32l-32 0 0 192-64 0 0-64-64 0 0-64 64 0 0-64-32 0c-53 0-96-43-96-96 0-47.6 34.6-87.1 80-94.7l0 67c-9.6 5.5-16 15.9-16 27.7 0 17.7 14.3 32 32 32l32 0 0-192-72.6 0c-11.1 19.1-31.7 32-55.4 32L0 128 0 96C0 60.7 28.7 32 64 32l128 0 0-64z"]
};
var faRodAsclepius = faStaffSnake;
var faRodSnake = faStaffSnake;
var faStaffAesculapius = faStaffSnake;
var faPiggyBank = {
  prefix: 'fass',
  iconName: 'piggy-bank',
  icon: [576, 512, [], "f4d3", "M288-32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM48 304c0-70.1 47-131.4 117.1-164.9 25.3 41.3 70.9 68.9 122.9 68.9 55.7 0 104.1-31.7 128-78 15.8-11.3 35.1-18 56-18l40 0-22.1 88.2c9.9 12.4 18.2 25.7 24.4 39.8l45.7 0 0 160-64 0c-16.5 22-38.5 39.6-64 50.7l0 61.3-89.1 0-13.7-48-82.3 0-13.7 48-89.1 0 0-61.3C87.5 426 48 369.6 48 304zm376 16a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faMonument = {
  prefix: 'fass',
  iconName: 'monument',
  icon: [384, 512, [], "f5a6", "M209-33l-17-17-97 97-6.3 6.3-.7 8.9-29.7 385.8-42.4 0 0 64 352 0 0-64-42.4 0-29.7-385.8-.7-8.9-6.3-6.3-80-80zM128 272l128 0 0 48-128 0 0-48z"]
};
var faLightSwitchOff = {
  prefix: 'fass',
  iconName: 'light-switch-off',
  icon: [384, 512, [], "e018", "M0 512L384 512 384 0 0 0 0 512zM144 256l0 112 96 0 0-112-96 0zm0-160l144 0 0 320-192 0 0-320 48 0z"]
};
var faTricycle = {
  prefix: 'fass',
  iconName: 'tricycle',
  icon: [512, 512, [], "e5c3", "M312 32l-24 0 0 48 80 0 0 19.2-196.4 130.9-36.1-54.1 24.5 0 0-48-128 0 0 48 45.8 0 53.8 80.7-1.2 .8c-6-1-12.2-1.5-18.5-1.5-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112c0-35.3-16.3-66.8-41.8-87.3l125-83.3 14.3 42.9C282.4 262.2 256 304 256 352 256 422.7 313.3 480 384 480s128-57.3 128-128-57.3-128-128-128c-5.8 0-11.4 .4-17 1.1l-18.4-55.3 56.7-37.8 10.7-7.1 0-92.8-104 0zm25.1 255.2c18.8 56.5 29.4 88.3 31.7 95.2l45.5-15.2c-2.3-6.9-12.9-38.6-31.7-95.2 .5 0 .9 0 1.4 0 44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80c0-26.7 13-50.3 33.1-64.8zM112 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faBorderCenterV = {
  prefix: 'fass',
  iconName: 'border-center-v',
  icon: [448, 512, [], "f89d", "M56 472l-48 0 0-48 48 0 0 48zm140 4l0-440 56 0 0 440-56 0zM8 88l0-48 48 0 0 48-48 0zm48 96l-48 0 0-48 48 0 0 48zm336 0l0-48 48 0 0 48-48 0zM56 376l-48 0 0-48 48 0 0 48zM8 280l0-48 48 0 0 48-48 0zm144 0l-48 0 0-48 48 0 0 48zm240 96l0-48 48 0 0 48-48 0zm48-96l-48 0 0-48 48 0 0 48zm-144 0l0-48 48 0 0 48-48 0zM152 472l-48 0 0-48 48 0 0 48zM104 88l0-48 48 0 0 48-48 0zM344 472l-48 0 0-48 48 0 0 48zM296 88l0-48 48 0 0 48-48 0zM440 472l-48 0 0-48 48 0 0 48zM392 88l0-48 48 0 0 48-48 0z"]
};
var faOpenCaptioning = {
  prefix: 'fass',
  iconName: 'open-captioning',
  icon: [512, 512, [], "e77f", "M0 64l512 0 0 384-512 0 0-384zM328 208l32 0c4.4 0 8 3.6 8 8l0 24 48 0 0-24c0-30.9-25.1-56-56-56l-32 0c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-24-48 0 0 24c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8zm-184 8c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-80zm8-56c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-80c0-30.9-25.1-56-56-56l-32 0z"]
};
var faCircleY = {
  prefix: 'fass',
  iconName: 'circle-y',
  icon: [512, 512, [], "e12f", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM150 155.2l-7.4-11.2 57.6 0 55.9 84.5 55.9-84.5 57.6 0-7.4 11.2-82 124 0 88.8-48 0 0-88.8-82-124z"]
};
var faFolderMusic = {
  prefix: 'fass',
  iconName: 'folder-music',
  icon: [512, 512, [], "e18d", "M512 448l-512 0 0-416 224 0 64 48 224 0 0 368zM336 160l-96 0 0 113.8c-5.1-1.2-10.5-1.8-16-1.8-35.3 0-64 25.1-64 56s28.7 56 64 56 64-25.1 64-56l0-104 48 0 0-64z"]
};
var faCircleSwedishKrona = {
  prefix: 'fass',
  iconName: 'circle-swedish-krona',
  icon: [512, 512, [], "e743", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 128l0 126.1c43-43 67-67 72-72L281.9 216c-7.8 7.8-26.1 26.1-54.7 54.7l53.3 99-42.3 22.8c-3.6-6.7-19.1-35.5-46.5-86.3l-15.8 15.8 0 62.1-48 0 0-256 48 0zm160 78.2c9.6-4.1 20-6.2 30.6-6.2l33.4 0 0 48-33.4 0c-8.1 0-15.9 3.2-21.7 9s-9 13.5-9 21.7l0 105.4-48 0 0-192 48 0 0 14.2z"]
};
var faAnglesRight = {
  prefix: 'fass',
  iconName: 'angles-right',
  icon: [512, 512, [187, "angle-double-right"], "f101", "M278.9 278.6l22.6-22.6-22.6-22.6-160-160-22.6-22.6-45.3 45.3 22.6 22.6 137.4 137.4-137.4 137.4-22.6 22.6 45.3 45.3 22.6-22.6 160-160zm192 0l22.6-22.6-22.6-22.6-160-160-22.6-22.6-45.3 45.3 22.6 22.6 137.4 137.4-137.4 137.4-22.6 22.6 45.3 45.3 22.6-22.6 160-160z"]
};
var faAngleDoubleRight = faAnglesRight;
var faCircleT = {
  prefix: 'fass',
  iconName: 'circle-t',
  icon: [512, 512, [], "e124", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM168 144l200 0 0 48-88 0 0 176-48 0 0-176-88 0 0-48 24 0z"]
};
var faUserCrown = {
  prefix: 'fass',
  iconName: 'user-crown',
  icon: [448, 512, [], "f6a4", "M96 52.5L96 144c0 70.7 57.3 128 128 128s128-57.3 128-128L352 0c-36 16-60 26.7-72 32l-56-48-56 48c-12-5.3-36-16-72-32l0 52.5zM224 224c-44.2 0-80-35.8-80-80l160 0c0 44.2-35.8 80-80 80zM432 512l-64-192-288 0-64 192 416 0z"]
};
var faDesktop = {
  prefix: 'fass',
  iconName: 'desktop',
  icon: [512, 512, [128421, 61704, "desktop-alt"], "f390", "M512 32l-512 0 0 384 208 0-16 48-96 0 0 48 320 0 0-48-96 0-16-48 208 0 0-384zM448 96l0 224-384 0 0-224 384 0z"]
};
var faDesktopAlt = faDesktop;
var faArrowUTurnLeftDown = {
  prefix: 'fass',
  iconName: 'arrow-u-turn-left-down',
  icon: [576, 512, [], "e7e9", "M3 368l45.2-45.2 80 80 0-210.8C128.3 89.3 208.9 5.4 310.4 .2l9.9-.2c106 0 192 86 192 192l0 256-64 0 0-256c0-70.7-57.3-128-128-128l-6.6 .2C246 67.6 192.3 123.5 192.2 192l0 210.8 80-80 45.3 45.2-157.3 157.3-157.2-157.3z"]
};
var faDonut = {
  prefix: 'fass',
  iconName: 'donut',
  icon: [512, 512, [127849, "doughnut"], "e406", "M512 208c0 37-21.9 75.8-68.1 107.5-46 31.5-112.3 52.5-187.9 52.5S114.2 347 68.1 315.5C21.9 283.8 0 245 0 208s21.9-75.8 68.1-107.5C114.2 69 180.5 48 256 48s141.8 21 187.9 52.5C490.1 132.2 512 171 512 208zM1.6 321.9C55.9 378.6 149.6 416 256 416s200.1-37.4 254.4-94.1C496.2 401.8 387.7 464 256 464S15.8 401.8 1.6 321.9zM294.6 96L272 73.4c-16.2 16.2-36.1 36.1-38.6 38.6L256 134.6c16.2-16.2 36.1-36.1 38.6-38.6zm-112 16L160 89.4c-4.1 4.1-18.5 18.5-43.3 43.3L105.4 144 128 166.6c4.1-4.1 18.5-18.5 43.3-43.3L182.6 112zM384 121.4L361.4 144c4.1 4.1 18.5 18.5 43.3 43.3L416 198.6 438.6 176c-4.1-4.1-18.5-18.5-43.3-43.3L384 121.4zM48 192l0 32 64 0 0-32-64 0zm336 25.4L361.4 240c16.2 16.2 36.1 36.1 38.6 38.6L422.6 256c-16.2-16.2-36.1-36.1-38.6-38.6zm-240 16L121.4 256c4.1 4.1 18.5 18.5 43.3 43.3L176 310.6 198.6 288c-4.1-4.1-18.5-18.5-43.3-43.3L144 233.4zM342.6 272L320 249.4c-4.1 4.1-18.5 18.5-43.3 43.3L265.4 304 288 326.6c4.1-4.1 18.5-18.5 43.3-43.3L342.6 272zM256 224c35.3 0 64-14.3 64-32s-28.7-32-64-32-64 14.3-64 32 28.7 32 64 32z"]
};
var faDoughnut = faDonut;
var faPlaneCircleXmark = {
  prefix: 'fass',
  iconName: 'plane-circle-xmark',
  icon: [640, 512, [], "e557", "M232 24c0-30.9 25.1-56 56-56s56 25.1 56 56l0 127.3 78 71.5c-69.3 29-118 97.4-118 177.2 0 49.3 18.6 94.3 49.1 128.3l-65.1-16.3-128 32 0-48 72-57.6 0-99.7-184 61.3 0-80 184-168.7 0-127.3zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm55.3 111.3L562.6 356 540 333.4c-4 4-18.7 18.6-44 44-25.4-25.4-40-40-44-44L429.4 356c4 4 18.6 18.7 44 44-25.4 25.4-40 40-44 44L452 466.6c4-4 18.7-18.6 44-44 25.4 25.4 40 40 44 44L562.6 444c-4-4-18.6-18.7-44-44l32.7-32.7z"]
};
var faProjector = {
  prefix: 'fass',
  iconName: 'projector',
  icon: [576, 512, [], "f8d6", "M376-8l0 88-48 0 0-112 48 0 0 24zM217 7c30.5 30.5 49.5 49.5 57 57L240 97.9c-7.5-7.5-26.5-26.5-57-57L166.1 24 200-9.9 217 7zM521 41c-30.5 30.5-49.5 49.5-57 57L430.1 64c7.5-7.5 26.5-26.5 57-57l17-17 33.9 33.9-17 17zM480 192l96 0 0 288-64 0 0 32-96 0 0-32-256 0 0 32-96 0 0-32-64 0 0-288 224 0c29.2-38.9 75.7-64 128-64s98.8 25.1 128 64zm-32 96a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM160 256l-96 0 0 48 96 0 0-48zM64 336l0 48 112 0 0-48-112 0z"]
};
var faUpFromLine = {
  prefix: 'fass',
  iconName: 'up-from-line',
  icon: [384, 512, ["arrow-alt-from-bottom"], "f346", "M0 192l192-202.9 192 202.9-128 0 0 192-128 0 0-192-128 0zM32 448l352 0 0 64-384 0 0-64 32 0z"]
};
var faArrowAltFromBottom = faUpFromLine;
var faWaterTemperature = {
  prefix: 'fass',
  iconName: 'water-temperature',
  icon: [640, 512, ["water-temp"], "e82a", "M449.3 417.7l111.8 44.7c29.3-9.8 50.1-16.7 62.5-20.8l15.2 45.5c-9.6 3.2-35.9 12-79.1 26.4l-8.2-3.3-111.1-44.4-120 48-120-48-111.1 44.4-8.2 3.3C37.9 499.2 11.6 490.4 2 487.2l15.2-45.5c12.4 4.1 33.2 11 62.4 20.8l111.8-44.7 8.9-3.6 120 48 120-48 8.9 3.6zM193.2 289c-.6 4.9-.9 9.9-.9 15 0 12.2 1.7 23.9 4.9 35.1l-108 43.2-8.2 3.3C37.9 371.2 11.6 362.4 2 359.2l15.2-45.5c12.4 4.1 33.2 11 62.4 20.8l111.8-44.7 1.8-.7zm256 .7l111.8 44.7c29.3-9.8 50.1-16.7 62.5-20.8l15.2 45.5c-9.6 3.2-35.9 12-79.1 26.4l-8.2-3.3-108-43.2c3.2-11.1 4.9-22.9 4.9-35.1 0-5.1-.3-10.1-.9-15l1.8 .7zM416.3 64l-64 0 0 32 64 0 0 64-64 0 0 70.7c28.2 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.8-61 48-73.3l0-230.7 128 0 0 64z"]
};
var faWaterTemp = faWaterTemperature;
var faRetweet = {
  prefix: 'fass',
  iconName: 'retweet',
  icon: [640, 512, [], "f079", "M240 160l-80 0 0 256 192 0 0 64-256 0 0-320-80 0 0-24 112-112 112 112 0 24zM544 352l80 0 0 24-112 112-112-112 0-24 80 0 0-256-192 0 0-64 256 0 0 320z"]
};
var faUserGear = {
  prefix: 'fass',
  iconName: 'user-gear',
  icon: [640, 512, ["user-cog"], "f4fe", "M128 128a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM287.3 304c-3.9 7-14.4 25.7-31.5 56.3l37.7 23.5-37.7 23.4c12.6 22.6 32.1 57.5 58.5 104.8l-266.3 0 64-208 175.3 0zm144.9-80.1l96 0 0 41.4c11.1 4.5 21.4 10.5 30.7 17.8l35.9-20.7 45.3 81.5-33.4 20.9c.9 6.3 1.4 12.7 1.4 19.2 0 6.5-.5 12.9-1.4 19.1l33.4 20.8-45.3 81.7-35.9-20.7c-9.3 7.3-19.6 13.3-30.7 17.8l0 41.4-96 0 0-41.2c-11.2-4.5-21.5-10.5-30.9-17.8l-35.7 20.6-45.6-81.7 33.4-20.7c-.9-6.3-1.4-12.7-1.4-19.2 0-6.5 .5-13 1.4-19.3l-33.4-20.8 45.6-81.5 35.7 20.6c9.3-7.3 19.7-13.3 30.9-17.8l0-41.2zm99.9 160.2a52 52 0 1 0 -104 0 52 52 0 1 0 104 0z"]
};
var faUserCog = faUserGear;
var faUserHairBuns = {
  prefix: 'fass',
  iconName: 'user-hair-buns',
  icon: [448, 512, [], "e3d3", "M304 128l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l46.4 0 32-42.7 32 42.7 46.4 0c1 5.2 1.6 10.5 1.6 16zM48 192l57.3 0c19 46.9 65 80 118.7 80s99.7-33.1 118.7-80l57.3 0 0-128-65.1 0C312.7 25.7 271.4 0 224 0S135.3 25.7 113.1 64L48 64 48 192zM432 512l-64-192-288 0-64 192 416 0z"]
};
var faBorderAll = {
  prefix: 'fass',
  iconName: 'border-all',
  icon: [448, 512, [], "f84c", "M384 96l0 128-128 0 0-128 128 0zm0 192l0 128-128 0 0-128 128 0zM192 224l-128 0 0-128 128 0 0 128zM64 288l128 0 0 128-128 0 0-128zM64 32l-64 0 0 448 448 0 0-448-384 0z"]
};
var faCoin = {
  prefix: 'fass',
  iconName: 'coin',
  icon: [512, 512, [129689], "f85c", "M0 304l0-96C0 128.5 114.6 64 256 64s256 64.5 256 144l0 96c0 29.1-19.4 55.9-52 77.3l0-86.3c-11.7 8.7-25.1 16.6-40 23.6l0 83.7c-23.5 9.8-50.5 17.5-80 22.7l0-80.9c-12.9 2.5-26.3 4.5-40 5.8l0 80.2c-14.3 1.2-29 1.9-44 1.9s-29.7-.6-44-1.9l0-80.2c-13.7-1.3-27.1-3.3-40-5.8l0 80.9c-29.5-5.1-56.5-12.9-80-22.7l0-83.7c-14.9-7-28.3-14.9-40-23.6l0 86.3C19.4 359.9 0 333.1 0 304zm64-96c0 53 86 96 192 96s192-43 192-96-86-96-192-96-192 43-192 96zm48 0c0-35.3 64.5-64 144-64s144 28.7 144 64-64.5 64-144 64-144-28.7-144-64z"]
};
var faLockKeyholeOpen = {
  prefix: 'fass',
  iconName: 'lock-keyhole-open',
  icon: [576, 512, ["lock-open-alt"], "f3c2", "M448 32c-35.3 0-64 28.7-64 64l0 64 96 0 0 352-384 0 0-352 224 0 0-64c0-70.7 57.3-128 128-128S576 25.3 576 96l0 64-64 0 0-64c0-35.3-28.7-64-64-64zM328 360l24 0 0-48-128 0 0 48 104 0z"]
};
var faLockOpenAlt = faLockKeyholeOpen;
var faCoins = {
  prefix: 'fass',
  iconName: 'coins',
  icon: [512, 512, [], "f51e", "M128 96l0-16c0-44.2 86-80 192-80S512 35.8 512 80l0 16c0 30.6-41.3 57.2-102 70.7-2.4-2.8-4.9-5.5-7.4-8-15.5-15.3-35.5-26.9-56.4-35.5-41.9-17.5-96.5-27.1-154.2-27.1-21.9 0-43.3 1.4-63.8 4.1-.2-1.3-.2-2.7-.2-4.1zM432 353l0-46.2c15.1-3.9 29.3-8.5 42.2-13.9 13.2-5.5 26.1-12.2 37.8-20.3l0 15.4c0 26.8-31.5 50.5-80 65zm0-96l0-33c0-4.5-.4-8.8-1-13 15.5-3.9 30-8.6 43.2-14.2s26.1-12.2 37.8-20.3l0 15.4c0 26.8-31.5 50.5-80 65zM0 240l0-16c0-44.2 86-80 192-80s192 35.8 192 80l0 16c0 44.2-86 80-192 80S0 284.2 0 240zm384 96c0 44.2-86 80-192 80S0 380.2 0 336l0-15.4c11.6 8.1 24.5 14.7 37.8 20.3 41.9 17.5 96.5 27.1 154.2 27.1s112.3-9.7 154.2-27.1c13.2-5.5 26.1-12.2 37.8-20.3l0 15.4zm0 80.6l0 15.4c0 44.2-86 80-192 80S0 476.2 0 432l0-15.4c11.6 8.1 24.5 14.7 37.8 20.3 41.9 17.5 96.5 27.1 154.2 27.1s112.3-9.7 154.2-27.1c13.2-5.5 26.1-12.2 37.8-20.3z"]
};
var faClockFourThirty = {
  prefix: 'fass',
  iconName: 'clock-four-thirty',
  icon: [512, 512, [], "e34b", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm24-120l0-91.2c45.6 30.4 71.8 47.9 78.7 52.4l26.6-39.9-20-13.3c-73.8-49.2-118.2-78.8-133.3-88.9l0 204.8 48 0 0-24z"]
};
var fa00 = {
  prefix: 'fass',
  iconName: '00',
  icon: [512, 512, [], "e467", "M112 32C50.1 32 0 82.1 0 144L0 368c0 61.9 50.1 112 112 112s112-50.1 112-112l0-224c0-61.9-50.1-112-112-112zM64 144c0-26.5 21.5-48 48-48s48 21.5 48 48l0 224c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-224zM400 32c-61.9 0-112 50.1-112 112l0 224c0 61.9 50.1 112 112 112s112-50.1 112-112l0-224c0-61.9-50.1-112-112-112zM352 144c0-26.5 21.5-48 48-48s48 21.5 48 48l0 224c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-224z"]
};
var faAmpGuitar = {
  prefix: 'fass',
  iconName: 'amp-guitar',
  icon: [512, 512, [], "f8a1", "M120 0l-24 0 0 96-96 0 0 384 512 0 0-384-96 0 0-96-296 0zM368 96l-224 0 0-48 224 0 0 48zM72 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM400 304l-288 0 0 64 288 0 0-64zM112 256l336 0 0 160-384 0 0-160 48 0z"]
};
var faFolderArrowLeft = {
  prefix: 'fass',
  iconName: 'folder-arrow-left',
  icon: [512, 512, [], "e7d2", "M224 32l64 48 224 0 0 368-512 0 0-416 224 0zM142.1 264l105.9 105.9 33.9-33.9-48-48 126.1 0 0-48-126.1 0 48-48-33.9-33.9-105.9 105.9z"]
};
var faMarsStroke = {
  prefix: 'fass',
  iconName: 'mars-stroke',
  icon: [576, 512, [9894], "f229", "M416-32l-32 0 0 64 82.7 0-58.7 58.7-40-40-45.3 45.3c16 16 29.3 29.3 40 40l-23 23c-28.4-19.5-62.7-31-99.8-31-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176c0-37-11.4-71.4-31-99.8l23-23c10.7 10.7 24 24 40 40L493.3 176c-16-16-29.3-29.3-40-40l58.7-58.7 0 82.7 64 0 0-192-160 0zM128 304a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z"]
};
var faCircleDashed = {
  prefix: 'fass',
  iconName: 'circle-dashed',
  icon: [512, 512, [], "e105", "M1.5 232l64.4 0c4.4-35.1 18.2-67.2 38.8-93.7L59.2 92.7C27.3 131.3 6.4 179.3 1.5 232zM138.7 104.3c26.6-20.6 58.7-34.5 93.7-38.8l0-64.4C179.7 6 131.7 26.9 93.1 58.8l45.5 45.5zM280.4 446.5l0 64.4c52.7-4.9 100.7-25.8 139.3-57.7l-45.5-45.5c-26.6 20.6-58.7 34.5-93.7 38.8zm127.7-72.8l45.5 45.5c31.9-38.5 52.8-86.6 57.7-139.3l-64.4 0c-4.4 35.1-18.2 67.2-38.8 93.7zM93.1 453.2c38.5 31.9 86.6 52.8 139.3 57.7l0-64.4c-35.1-4.4-67.2-18.2-93.7-38.8L93.1 453.2zM59.2 419.3l45.5-45.5C84.1 347.2 70.2 315.1 65.9 280L1.5 280c4.9 52.7 25.8 100.7 57.7 139.3zM419.6 58.8C381.1 26.9 333.1 6 280.4 1.1l0 64.4c35.1 4.4 67.2 18.2 93.7 38.8l45.5-45.5zm-11.6 79.5c20.6 26.6 34.5 58.7 38.8 93.7l64.4 0c-4.9-52.7-25.8-100.7-57.7-139.3l-45.5 45.5z"]
};
var faHandshakeAngle = {
  prefix: 'fass',
  iconName: 'handshake-angle',
  icon: [576, 512, ["hands-helping"], "f4c4", "M288 32l0 0 128 0 48 32 112-64 0 288-70.4 56-193.6-192 0 0-40 40c-22.1 22.1-52.8 30.4-81.3 24.9-1.3-.2-2.5-.5-3.8-.8-11.5-2.7-22.5-7.7-32.5-15-1.1-.8-2.2-1.7-3.3-2.6-2.5-2-4.9-4.2-7.2-6.5L288 32zM144 32l79.4 0C132.6 132.9 84.1 186.8 77.9 193.7l32.2 32.2c54.1 54.1 141.8 54.1 195.9 0l6.2-6.2 150.7 149.4-37.9 37.9c-23.8-23.8-40.2-40.2-49-49L342.1 392c8.8 8.8 25.1 25.1 49 49l-7 7-62.1 0c-31.3-31.3-50.6-50.6-57.9-57.9L230.1 424c13 13 21 21 24 24L192 448 144 408 0 544 0 192c11.2-12.7 22.2-25.5 33.3-38.2l0 0 0 0C69.3 112.3 105.2 70.8 144 32z"]
};
var faHandsHelping = faHandshakeAngle;
var faGaugeSimpleLow = {
  prefix: 'fass',
  iconName: 'gauge-simple-low',
  icon: [512, 512, ["tachometer-slow"], "f62c", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm320 96c0-35.3-28.7-64-64-64-1.7 0-3.4 .1-5.1 .2l-69.5-138.9-42.9 21.5 69.5 138.9c-10 11.3-16 26.1-16 42.3 0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faTachometerSlow = faGaugeSimpleLow;
var faArrowDown = {
  prefix: 'fass',
  iconName: 'arrow-down',
  icon: [448, 512, [8595], "f063", "M201.6 502.6l22.6 22.6 22.6-22.6 160-160 22.6-22.6-45.3-45.3c-1.3 1.3-44 44-128 128l0-402.7-64 0 0 402.7c-84-84-126.7-126.7-128-128l-45.3 45.3 22.6 22.6 160 160z"]
};
var faLocationDot = {
  prefix: 'fass',
  iconName: 'location-dot',
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M0 188.6C0 84.4 86 0 192 0S384 84.4 384 188.6C384 339.4 192 528 192 528S0 339.4 0 188.6zM192 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faMapMarkerAlt = faLocationDot;
var faGasPumpRight = {
  prefix: 'fass',
  iconName: 'gas-pump-right',
  icon: [640, 512, [], "e779", "M0 0l288 0 0 256 80 0 0 112 32 0 0-176-48 0 0-91.5c-18.8-20.7-32.7-36-41.9-46.1l35.5-32.3c.1 .1 32.2 35.4 96.1 105.8l6.2 6.9 0 281.3-128 0 0-112-32 0 0 208-288 0 0-512zM64 64l0 128 160 0 0-128-160 0zM640 288l-128 96 0-192 128 96z"]
};
var faDeerRudolph = {
  prefix: 'fass',
  iconName: 'deer-rudolph',
  icon: [576, 512, [], "f78f", "M288 16l0-16-32 0 0 40c0 30.9 25.1 56 56 56l40 0-64 16 0 32 56 0-9.6 32-196.3 0c-54.3 0-99.5 41.8-103.7 96-1.6 21.1-3 39.2-4.2 54.1l47.9 3.7 1.8-23.3c2.4 3.3 5.2 6.5 8.1 9.5L104.1 332c-18.2 18.2-34 34-47.4 47.4 2.3 6.4 17.9 50.6 46.8 132.6l101.8 0-37.9-107.4c19.8-19.8 33.4-33.4 40.7-40.7l0-23.3 64 27.4 48 0 0 144 96 0 0-208 26.7-80 101.3 0 0-56c9.7-7.3 16-18.9 16-32 0-22.1-17.9-40-40-40-11 0-21 4.5-28.3 11.7L475.4 91.4c-.6-.6-1.1-1.1-1.7-1.6 18-9.3 30.3-28.1 30.3-49.8l0-40-32 0 0 40c0 13.3-10.7 24-24 24l-69.4 0c3.5-7.3 5.4-15.4 5.4-24l0-40-32 0 0 40c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-24zM416 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faUfo = {
  prefix: 'fass',
  iconName: 'ufo',
  icon: [576, 512, [128760], "e047", "M186.3 168.2c-11.6 18.5-18.3 40.4-18.3 63.8 51.6 51.6 188.4 51.6 240 0 0-23.4-6.7-45.3-18.3-63.8-21.2-33.8-58.8-56.2-101.7-56.2s-80.4 22.4-101.7 56.2zm-58.7 13.4C149.1 113.5 212.8 64 288 64s138.9 49.5 160.3 117.7c77 23 127.7 62 127.7 106.3 0 70.7-128.9 128-288 128S0 358.7 0 288c0-44.3 50.7-83.4 127.7-106.3zM321.9 336L288 302.1 254.1 336 288 369.9 321.9 336zM120 270.1L86.1 304 120 337.9 153.9 304 120 270.1zM489.9 304L456 270.1 422.1 304 456 337.9 489.9 304z"]
};
var faPlugCircleExclamation = {
  prefix: 'fass',
  iconName: 'plug-circle-exclamation',
  icon: [640, 512, [], "e55d", "M224-32l0 128 128 0 0-128 64 0 0 128 96 0 0 64-32 0 0 48.7c-98.6 8.1-176 90.7-176 191.3 0 27.3 5.7 53.3 16 76.9l0 35.1-64 0 0-98.7C165.2 398.1 96 319.1 96 224l0-64-32 0 0-64 96 0 0-128 64 0zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 112 32 0 0-112z"]
};
var faCookieBite = {
  prefix: 'fass',
  iconName: 'cookie-bite',
  icon: [512, 512, [], "f564", "M256.8 22.1L213.9 16 81.7 86.7 16 222.1 42 370.4 149.8 475 298.1 496 430.3 425.3 496 289.9 489.9 255.2c-61.5-6.7-109.9-57.1-113.7-119.5-62.4-3.7-112.7-52.2-119.5-113.7zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSquareChevronRight = {
  prefix: 'fass',
  iconName: 'square-chevron-right',
  icon: [448, 512, ["chevron-square-right"], "f32b", "M448 480l0-448-448 0 0 448 448 0zM313 273l-104 104-17 17-33.9-33.9 17-17 87-87-87-87-17-17 33.9-33.9 17 17 104 104 17 17-17 17z"]
};
var faChevronSquareRight = faSquareChevronRight;
var faHandPointRibbon = {
  prefix: 'fass',
  iconName: 'hand-point-ribbon',
  icon: [448, 512, [], "e1a6", "M64 0l64 0 0 32 32 0 0 96-160 0 43.6-48-43.6-48 64 0 0-32zm96 128l0 112 64 0 0-112-64 0zM64 160l64 0 0 80-64 0 0-80zm192 0l64 0 0 128-64 0 0-128zm96 32l64 0 0 128-64 0 0-128zM32 363l0-91 192 0 0 80-112 0 0 32 144 0 0-64 64 0 0 32 96 0c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L69.5 453.5C45.5 429.5 32 396.9 32 363z"]
};
var faGrid2Plus = {
  prefix: 'fass',
  iconName: 'grid-2-plus',
  icon: [448, 512, [], "e197", "M192 32l-192 0 0 192 192 0 0-192zm0 256l-192 0 0 192 192 0 0-192zM256 32l0 192 192 0 0-192-192 0zM376 288l-48 0 0 72-72 0 0 48 72 0 0 72 48 0 0-72 72 0 0-48-72 0 0-72z"]
};
var faScrewdriverWrench = {
  prefix: 'fass',
  iconName: 'screwdriver-wrench',
  icon: [576, 512, ["tools"], "f7d9", "M224.5 80l0 66.8 109.3 109.2 82.7 0 160 160-128 128-160-160 0-82.7-109.2-109.3-66.8 0-96-144 64-64 144 96zm16 241.1l0 82.7 .9 .9-128.9 129-101.8-101.8 170.3-170.4 59.5 59.5zM384.5 0c27.7 0 53.8 7.1 76.5 19.5l-76.5 76.5 0 64 64 0 76.5-76.5c12.4 22.7 19.5 48.8 19.5 76.5 0 43.2-17.2 82.3-45 111.1l-63.1-63.1-82.7 0-81.1-81.1 0-81.1C301.3 17.5 340.9 0 384.5 0z"]
};
var faTools = faScrewdriverWrench;
var faKeynote = {
  prefix: 'fass',
  iconName: 'keynote',
  icon: [448, 512, [], "f66c", "M288 0l-112 0 0 24-112 0 0 104-64 176 0 48 200 0 0 112-72 0 0 48 192 0 0-48-72 0 0-112 200 0 0-48-64-176-272 0 0-56 64 0 0 24 112 0c26.5 0 48-21.5 48-48S314.5 0 288 0z"]
};
var faTicketsAirline = {
  prefix: 'fass',
  iconName: 'tickets-airline',
  icon: [640, 512, ["tickets-perforated-plane", "tickets-plane"], "e29b", "M608 32l-512 0 0 352 512 0 0-128c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-128zM48 128l-48 0 0 352 512 0 0-48-464 0 0-304zm274.7 48l-26.7-80 56 0 46.7 80 49.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-49.3 0-46.7 80-56 0 26.7-80-42.7 0-24 32-32 0 16-64-16-64 32 0 24 32 42.7 0z"]
};
var faTicketsPerforatedPlane = faTicketsAirline;
var faTicketsPlane = faTicketsAirline;
var faCalendarLines = {
  prefix: 'fass',
  iconName: 'calendar-lines',
  icon: [448, 512, ["calendar-note"], "e0d5", "M160 32l0-32-64 0 0 64-96 0 0 416 448 0 0-416-96 0 0-64-64 0 0 64-128 0 0-32zM96 224l256 0 0 48-256 0 0-48zm160 96l0 48-160 0 0-48 160 0z"]
};
var faCalendarNote = faCalendarLines;
var faIndent = {
  prefix: 'fass',
  iconName: 'indent',
  icon: [448, 512, [], "f03c", "M0 32l0 64 448 0 0-64-448 0zM192 160l0 64 256 0 0-64-256 0zM448 288l-256 0 0 64 256 0 0-64zM0 416l0 64 448 0 0-64-448 0zm0-48L144 256 0 144 0 368z"]
};
var faGolfClub = {
  prefix: 'fass',
  iconName: 'golf-club',
  icon: [640, 512, [], "f451", "M619.6-13.2l-15 28.2-256 480-9.1 16.9-275.2 0 0-56 64 0 0-40-64 0 0-32 64 0 0-40-64 0 0-65 39.8 10 248.7 62.2 195.3-366.2 15.1-28.2 56.5 30.1z"]
};
var faBars = {
  prefix: 'fass',
  iconName: 'bars',
  icon: [448, 512, ["navicon"], "f0c9", "M0 64l448 0 0 64-448 0 0-64zM0 224l448 0 0 64-448 0 0-64zM448 384l0 64-448 0 0-64 448 0z"]
};
var faNavicon = faBars;
var faHandsPraying = {
  prefix: 'fass',
  iconName: 'hands-praying',
  icon: [640, 512, ["praying-hands"], "f684", "M288 448L0 528 0 360 80 336 80 179.2 87 169C156.6 67.8 193.5 14.1 197.7 8l65.9 45.3C255.6 65 226.4 107.5 176 180.8l0 138.8 48 0 0-128 64 0 0 256.4zm64 0l0-256.4 64 0 0 128 48 0 0-138.8C413.6 107.5 384.4 65 376.4 53.3L442.3 8c4.2 6.1 41.1 59.8 110.7 161l7 10.2 0 156.8 80 24 0 168-288-80z"]
};
var faPrayingHands = faHandsPraying;
var faTemperatureSnow = {
  prefix: 'fass',
  iconName: 'temperature-snow',
  icon: [576, 512, ["temperature-frigid"], "f768", "M304.3 0l192 0 0 260.7c29.5 26.4 48 64.7 48 107.3 0 79.5-64.5 144-144 144s-144-64.5-144-144c0-42.6 18.5-81 48-107.3L304.3 0zm96 432c35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3l0-52.7-48 0 0 52.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64zM256.3 73.4l0 13.3-4.7 4.7-35.3 35.3 0 55.8 40-23.1 0 55.4-16 9.2 16 9.2 0 7.8c-9.1 10.3-17.2 21.7-23.9 33.8l-16.1-9.3 0 47.5c-5.2 17.4-8 35.9-8 55 0 16.6 2.1 32.6 6 48l-46 0 0-49.4c-8.7 8.7-16.7 16.7-24 24L121.6 368c3.5-3.5 19.1-19.1 46.6-46.6l0-55.8-48.3 27.9c-10.1 37.6-15.8 58.9-17.1 63.7L72 348.9c2.7-10 5.6-20.9 8.8-32.8-14.8 8.6-29.1 16.8-42.8 24.7L14 299.2c13.7-7.9 27.9-16.1 42.8-24.7-11.9-3.2-22.8-6.1-32.8-8.8l8.3-30.9c4.8 1.3 26.1 7 63.7 17.1l48.3-27.9-48.3-27.9c-37.6 10.1-58.9 15.8-63.7 17.1L24 182.2c10-2.7 20.9-5.6 32.8-8.8-14.8-8.6-29.1-16.8-42.8-24.7l24-41.6c13.7 7.9 27.9 16.1 42.8 24.7L72 99.1 102.9 90.8c1.3 4.8 7 26.1 17.1 63.7l48.3 27.9 0-55.8-46.6-46.6 22.6-22.6c7.3 7.3 15.3 15.3 24 24l0-49.4 48 0 0 49.4c8.7-8.7 16.7-16.7 24-24l16 16z"]
};
var faTemperatureFrigid = faTemperatureSnow;
var faViruses = {
  prefix: 'fass',
  iconName: 'viruses',
  icon: [640, 512, [], "e076", "M224 0l-64 0 0 32c0 30.5-36.7 45.8-58.4 24.4L78.9 33.6 33.6 78.9 56.2 101.5C77.8 123.1 62.5 160 32 160l-32 0 0 64 32 0c30.4 0 45.7 36.6 24.6 58.2l-23 23 45.3 45.3 22.6-22.6c21.6-21.6 58.5-6.3 58.5 24.2l0 32 64 0 0-32c0-30.5 36.9-45.8 58.5-24.2l22.6 22.6 45.3-45.3-22.8-22.8C306.2 260.7 321.5 224 352 224l32 0 0-64-32 0c-30.4 0-45.7-36.5-24.6-58.2l23-23-45.3-45.3c-7.5 7.5-15.1 15.1-22.6 22.6-21.6 21.6-58.5 6.3-58.5-24.2l0-32zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm372.9 41.2l-17 17C547.7 314.4 520 302.9 520 280l0-24-48 0 0 24c0 22.9-27.7 34.4-43.9 18.2l-17-17-33.9 33.9 17 17c16.2 16.2 4.7 43.9-18.2 43.9l-24 0 0 48 24 0c22.9 0 34.4 27.7 18.2 43.9l-17 17 33.9 33.9 17-17c16.2-16.2 43.9-4.7 43.9 18.2l0 24 48 0 0-24c0-22.9 27.7-34.4 43.9-18.2l17 17 33.9-33.9-17-17C581.6 451.7 593.1 424 616 424l24 0 0-48-24 0c-22.9 0-34.4-27.7-18.2-43.9l17-17-33.9-33.9zM456 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faDryer = {
  prefix: 'fass',
  iconName: 'dryer',
  icon: [448, 512, [], "f861", "M0 0L448 0 448 512 0 512 0 0zM368 304a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM96 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM216 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM320 304c0 53-43 96-96 96-44.7 0-82.3-30.6-93-72l69 0 0-48-69 0c10.7-41.4 48.2-72 93-72 53 0 96 43 96 96z"]
};
var faSchoolFlag = {
  prefix: 'fass',
  iconName: 'school-flag',
  icon: [576, 512, [], "e56e", "M256-32l160 0 0 96-96 0 0 19.2 128 76.8 128 0 0 352-576 0 0-352 128 0 128-76.8 0-115.2zm80 368l-96 0 0 128 96 0 0-128zM64 416l64 0 0-64-64 0 0 64zm64-128l0-64-64 0 0 64 64 0zM448 416l64 0 0-64-64 0 0 64zm64-128l0-64-64 0 0 64 64 0zM288 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faCircleGf = {
  prefix: 'fass',
  iconName: 'circle-gf',
  icon: [512, 512, [], "e67f", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM184 128c39.8 0 72 32.2 72 72l0 24-48 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8-24 0 0-48 72 0 0 56c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-112c0-39.8 32.2-72 72-72zm104 0l112 0 0 48-64 0 0 64 48 0 0 48-48 0 0 96-48 0 0-256z"]
};
var faTrademark = {
  prefix: 'fass',
  iconName: 'trademark',
  icon: [640, 512, [8482], "f25c", "M32 96l224 0 0 64-96 0 0 256-64 0 0-256-96 0 0-64 32 0zm256 32l0-32 49.1 0 9.5 14.2 101.4 152.1 101.4-152.1 9.5-14.2 49.1 0 0 320-64 0 0-182.3c-53.4 80.1-85.4 128.1-96 144-10.6-15.9-42.6-63.9-96-144l0 182.3-64 0 0-288z"]
};
var faStretcher = {
  prefix: 'fass',
  iconName: 'stretcher',
  icon: [640, 512, [], "f825", "M608.2 272l0 48-140 0-7.7 4.6-93.7 56.2 64.5 38.7c5.3-2 10.9-3.1 16.9-3.1 26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48c0-2.5 .2-4.9 .6-7.2l-80.6-48.4-80.6 48.4c.4 2.4 .6 4.8 .6 7.2 0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48c5.9 0 11.6 1.1 16.8 3.1l64.5-38.7-93.7-56.2-7.7-4.6-140 0 0-48 576 0zm-288 80.8l54.7-32.8-109.3 0 54.7 32.8zM119.2 9.4l153.9 102.6 335.1 0 0 112-369 0-14.1-9.4-214.6-143.1 62.1-93.2 46.6 31.1z"]
};
var faUTurnRightDown = {
  prefix: 'fass',
  iconName: 'u-turn-right-down',
  icon: [576, 512, [], "e7f3", "M272 0C386.9 0 480 93.1 480 208l0 144 96 0-160 160-160-160 96 0 0-144c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 240-128 0 0-240C64 93.1 157.1 0 272 0z"]
};
var faFireBurner = {
  prefix: 'fass',
  iconName: 'fire-burner',
  icon: [512, 512, [], "e4f1", "M224 0c-42.7 26.7-128 102.4-128 192 0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160L288 64 224 0zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96zM92.8 320l-92.8 0 0 160 512 0 0-160-93 0c-37.9 48.3-96.4 80-163 80-67.1 0-125.5-31.7-163.2-80zM408 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faIntegral = {
  prefix: 'fass',
  iconName: 'integral',
  icon: [320, 512, [], "f667", "M128 0l192 0 0 128-64 0 0-64-64 0 0 448-192 0 0-128 64 0 0 64 64 0 0-448z"]
};
var faGripDotsVertical = {
  prefix: 'fass',
  iconName: 'grip-dots-vertical',
  icon: [320, 512, [], "e411", "M128 64A64 64 0 1 0 0 64 64 64 0 1 0 128 64zm0 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM0 448c0 35.3 28.7 64 64 64s64-28.7 64-64-28.7-64-64-64-64 28.7-64 64zM320 64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM192 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM320 448c0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64 64-28.7 64-64z"]
};
var faFaceLying = {
  prefix: 'fass',
  iconName: 'face-lying',
  icon: [576, 512, [], "e37e", "M352 224l0 32 184 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-120 0 0 32 102.3 0c-41.5 85.3-129 144-230.3 144-141.4 0-256-114.6-256-256S146.6 0 288 0C418.5 0 526.3 97.7 542 224l-190 0zM240 408c0-4.4 3.6-8 8-8l72 0 0-48-72 0c-30.9 0-56 25.1-56 56l0 24 48 0 0-24zm0-232a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faPersonBasketball = {
  prefix: 'fass',
  iconName: 'person-basketball',
  icon: [512, 512, [], "e784", "M184 40a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM77.9 128l170.8 0 9.6 13.6 48.6 69.5c51 10.2 83.9 16.8 98.8 19.8l-12.6 62.8c-12.8-2.6-49.9-10-111.4-22.3l-12.6-2.5c-2.5-3.6-12.2-17.5-29.2-41.7l-17.5 59.4 78.9 36.4 13.9 6.4 3.7 14.9c25.4 101.5 38.6 154.5 39.8 159l-62.1 15.5c-1.8-7-13.8-55.1-36-144.2l-89.1-41.1c14.3 43 23.2 69.8 26.8 80.3L177 427.1c-88.8 55.5-135.2 84.5-139.1 87L3.9 459.8c7.5-4.7 46.8-29.2 117.8-73.6l-16.9-50.6c-7-20.9-6.5-43.5 1.2-64.1l29.8-79.5-21.7 0C84.6 241.2 66.3 271.8 59 283.9L4.1 251c5.7-9.5 27.2-45.4 64.5-107.4L77.9 128zM448 320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faFolderUser = {
  prefix: 'fass',
  iconName: 'folder-user',
  icon: [512, 512, [], "e18e", "M512 448l-512 0 0-416 224 0 64 48 224 0 0 368zM256 280a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM357.3 384l-21.3-64-160 0-21.3 64 202.7 0z"]
};
var faSkiBootSki = {
  prefix: 'fass',
  iconName: 'ski-boot-ski',
  icon: [640, 512, [], "e3cd", "M640 424c0 48.6-39.4 88-88 88l-552 0 0-48 552 0c22.1 0 40-17.9 40-40l0-32 48 0 0 32zM412 96l-92 0 0 48 82 0-10 48-88 0 0 48 78 0 130 52.3 0 128-416-4.3 39.4-189.1c4.1-.7 9.6-1.8 16-3.6 14.1-4.1 32.9-11.9 52.6-26.3 37-27.2 75-76.7 92.2-165l65.2 0 6.7-32 64 0-20 96zM255.3 32c-16.1 74.6-48 112.9-75 132.7-13.3 9.8-26 15.4-35.8 18.7L176 32 255.3 32z"]
};
var faFaceSmileBeam = {
  prefix: 'fass',
  iconName: 'face-smile-beam',
  icon: [512, 512, [128522, "smile-beam"], "f5b8", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-144c38.2 0 72-19.1 92.2-48.5l39.5 27.3C358.9 388.6 310.7 416 256 416s-102.9-27.4-131.8-69.2l39.5-27.3C184 348.9 217.8 368 256 368zM176 180c-15.5 0-28 12.5-28 28l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28zm132 28l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28s-28 12.5-28 28z"]
};
var faSmileBeam = faFaceSmileBeam;
var faBatteryExclamation = {
  prefix: 'fass',
  iconName: 'battery-exclamation',
  icon: [640, 512, [], "e0b0", "M240.1 66.2l2.9 61.8-147 0 0 256 144 0 0 64-208 0 0-384 208 0 .1 2.2zM352 448l-64 0 0-64 64 0 0 64zM608 192l32 0 0 128-32 0 0 128-208 0 0-64 144 0 0-256-147 0 2.9-61.8 .1-2.2 208 0 0 128zM339.2 336l-38.4 0-12.8-272 64 0-12.8 272z"]
};
var faSquarePolishZloty = {
  prefix: 'fass',
  iconName: 'square-polish-zloty',
  icon: [448, 512, [], "e736", "M448 32l-448 0 0 448 448 0 0-448zM319.4 152l0 77.4c6.4-2.6 14.9-5.9 25.5-10.2l11.9 29.7c-8.6 3.5-21.1 8.4-37.4 14.9l0 120.1-48 0 0-100.9c-5.4 2.2-13.5 5.4-24.3 9.7l-11.9-29.7c8.8-3.5 20.9-8.4 36.2-14.5l0-120.6 48 0 0 24zM104 192l131.1 0c-3.4 8.7-22.1 56.7-56 144l60.9 0 0 48-131.1 0c3.4-8.7 22.1-56.7 56-144l-60.9 0 0-48z"]
};
var faWreathLaurel = {
  prefix: 'fass',
  iconName: 'wreath-laurel',
  icon: [640, 512, [], "e5d2", "M144 112C144 50.1 194.1 0 256 0l32 0 0 32c0 60.2-47.5 109.3-107 111.9-23.9 32.2-37 71.5-37 112.1 0 97.2 78.8 176 176 176l77.7 0 5.1 2.5 64 32-21.5 42.9-58.9-29.5-132.7 0-58.9 29.5-21.5-42.9 33.9-17c-5.1-3-10.1-6.1-14.9-9.5-59.6 28.2-131.9 6.3-165.4-51.8l-16-27.7 13.9-8C38.5 344.6 53.2 339.5 68 337.1 27.5 315.6 0 273 0 224l0-32 16 0c15.9 0 31.1 2.9 45.2 8.2-24.3-38.8-26.8-89.5-2.3-131.9l16-27.7 13.9 8C115 63.7 133.8 86.8 144 113l0-1zm352 0l0 1c10.2-26.2 29-49.2 55.3-64.4l13.9-8 16 27.7c24.5 42.4 21.9 93.1-2.3 131.9 14.1-5.3 29.3-8.2 45.2-8.2l16 0 0 32c0 49-27.5 91.6-68 113.1 14.8 2.4 29.5 7.5 43.3 15.5l13.9 8-16 27.7c-17.5 30.3-45.5 50.8-76.8 59.4-32.1-16.1-64.2-32.1-96-48l-11.1-5.6c40.7-32.2 66.8-82.1 66.8-138.1 0-40.6-13.1-79.9-37-112.1-59.5-2.6-107-51.7-107-111.9l0-32 32 0c61.9 0 112 50.1 112 112z"]
};
var faStars = {
  prefix: 'fass',
  iconName: 'stars',
  icon: [512, 512, [], "f762", "M356 60l-20-60-20 60-60 20 60 20 20 60 20-60 60-20-60-20zM464 208l-16-48-16 48-48 16 48 16 16 48 16-48 48-16-48-16zM253.3 265.1L193.5 144 133.7 265.1 0 284.6 96.7 378.9 73.9 512 193.5 449.1 313 512 290.2 378.9 386.9 284.6 253.3 265.1z"]
};
var faTentArrowLeftRight = {
  prefix: 'fass',
  iconName: 'tent-arrow-left-right',
  icon: [576, 512, [], "e57f", "M31.5 113l-17-17c2.1-2.1 31.8-31.8 89-89l17-17 33.9 33.9c-9 9-25 25-48 48l126.1 0 0 0 238.1 0c-23-23-39-39-48-48L456.4-9.9c2.1 2.1 31.8 31.8 89 89l17 17c-2.1 2.1-31.8 31.8-89 89l-17 17-33.9-33.9c9-9 25-25 48-48l-310.1 0 0 0-54.1 0 48 48-33.9 33.9c-2.1-2.1-31.8-31.8-89-89zm33 399l29.7-234.7 193.1-117.3 195.4 117.3 29.7 234.7-128 0-97.1-160 0 160-222.9 0z"]
};
var faRoute = {
  prefix: 'fass',
  iconName: 'route',
  icon: [512, 512, [], "f4d7", "M416 256s96-96 96-160c0-53-43-96-96-96s-96 43-96 96c0 29.4 20.2 65.5 42.1 96l-138.1 0 0 192 224 0 0 64-259.4 0c-6.2 9.6-12.6 18.8-19 27.2-10.7 14.2-21.3 26.9-30 36.8l372.4 0 0-192-224 0 0-64 128 0zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM149.9 448c21.9-30.5 42.1-66.6 42.1-96 0-53-43-96-96-96S0 299 0 352c0 64 96 160 96 160s3.5-3.5 9.2-9.6c.4-.4 .7-.8 1.1-1.2 3.3-3.5 7.1-7.8 11.4-12.8 .2-.2 .4-.4 .6-.6 9.4-10.8 20.7-24.6 31.6-39.8zM96 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faAnglesUp = {
  prefix: 'fass',
  iconName: 'angles-up',
  icon: [448, 512, ["angle-double-up"], "f102", "M246.9 41.4l-22.6-22.6-22.6 22.6-160 160-22.6 22.6 45.3 45.3 22.6-22.6 137.4-137.4 137.4 137.4 22.6 22.6 45.3-45.3-22.6-22.6-160-160zm0 192l-22.6-22.6-22.6 22.6-160 160-22.6 22.6 45.3 45.3 22.6-22.6 137.4-137.4 137.4 137.4 22.6 22.6 45.3-45.3-182.6-182.6z"]
};
var faAngleDoubleUp = faAnglesUp;
var faBucket = {
  prefix: 'fass',
  iconName: 'bucket',
  icon: [448, 512, [], "e4cf", "M448 256l-37.1 0-26.9 256-320 0-26.9-256-37.1 0 0-48 448 0 0 48zM351.8 4.9l20 155.1-48.4 0-16.5-128-165.7 0-16.5 128-48.4 0 20-155.1 2.7-20.9 250.2 0 2.7 20.9z"]
};
var faLessThanEqual = {
  prefix: 'fass',
  iconName: 'less-than-equal',
  icon: [448, 512, [], "f537", "M21.9 161.6l426.1-142 0 67.5-314.8 104.9 314.8 104.9 0 67.5-426.1-142-21.9-7.3 0-46.1 21.9-7.3zM32 416l416 0 0 64-448 0 0-64 32 0z"]
};
var faFlagPennant = {
  prefix: 'fass',
  iconName: 'flag-pennant',
  icon: [448, 512, [128681, "pennant"], "f456", "M64 32L64 0 0 0 0 512 64 512 64 352 448 192 64 32z"]
};
var faPennant = faFlagPennant;
var faFolderClosed = {
  prefix: 'fass',
  iconName: 'folder-closed',
  icon: [512, 512, [], "e185", "M512 448l-512 0 0-240 512 0 0 240zm0-288l-512 0 0-128 224 0 64 48 224 0 0 80z"]
};
var faChessKingPiece = {
  prefix: 'fass',
  iconName: 'chess-king-piece',
  icon: [320, 512, ["chess-king-alt"], "f440", "M136 56l-40 0 0-48 40 0 0-40 48 0 0 40 40 0 0 48-40 0 0 40 104 0 0 32-36 72 20 0 0 48-29.6 0 13.6 136 64 80 0 48-320 0 0-48 64-80 13.6-136-29.6 0 0-48 20 0-36-72 0-32 104 0 0-40z"]
};
var faChessKingAlt = faChessKingPiece;
var faSquareKip = {
  prefix: 'fass',
  iconName: 'square-kip',
  icon: [448, 512, [], "e70d", "M448 32l-448 0 0 448 448 0 0-448zM321.8 163.5c-2.9 2.3-34.4 27.9-94.6 76.7l92.7 0 0 32-92.5 0c60 48.4 91.5 73.8 94.4 76.2l-30.1 37.4c-2.1-1.7-35.3-28.5-99.6-80.4l0 78.6-48 0 0-111.8-31.8 0 0-32 31.8 0 0-112.2 48 0 0 78.9c64.3-52.1 97.5-79 99.5-80.7l30.2 37.3z"]
};
var faBinRecycle = {
  prefix: 'fass',
  iconName: 'bin-recycle',
  icon: [576, 512, [], "e5f7", "M0 64l576 0 0 64-34.9 0-29.1 320-448 0-29.1-320-34.9 0 0-64zm259.3 80l-7.1 10.4-45.8 67 40.7 25.5 37.5-54.9 6.7 0 37.5 54.9 40.7-25.5-45.8-67-7.1-10.4-57.3 0zm92.1 135.9l32.5 47.5 0 8.6-76 0 0 48 124 0 0-71.4-4.2-6.1-35.6-52-40.7 25.5zM192 336l0-8.6 32.5-47.5-40.7-25.5-35.6 52-4.2 6.1 0 71.4 124 0 0-48-76 0z"]
};
var faAeropress = {
  prefix: 'fass',
  iconName: 'aeropress',
  icon: [384, 512, [], "e82b", "M320 400l64 0 0 48-64 0 0 64-256 0 0-64-64 0 0-48 64 0 0-272 256 0 0 272zm-72-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-80a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-80a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM336 32l-48 0 0 48-192 0 0-48-48 0 0-48 288 0 0 48z"]
};
var faSendBackward = {
  prefix: 'fass',
  iconName: 'send-backward',
  icon: [512, 512, [], "f87f", "M352 0l-352 0 0 352 112 0 0-240 240 0 0-112zM224 224l224 0 0 224-224 0 0-224zm-64-64l0 352 352 0 0-352-352 0z"]
};
var faTruckRampCouch = {
  prefix: 'fass',
  iconName: 'truck-ramp-couch',
  icon: [576, 512, ["truck-couch"], "f4dd", "M352.3 32l-32 0 0 328.2-297.2 89.2-30.7 9.2 18.4 61.3 30.7-9.2 315.5-94.6 43.7 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88l0-392-224 0zm176 392c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40c22.1 0 39.9 17.9 40 39.9l0 .1zM60.9 158.2c-30.7 9.4-49.2 39.7-44.6 70.5 8-6.7 17.4-12 28.1-15.2 37-11.3 75.9 5.5 93.7 38.3l134.4-41.1 0-117.1-211.5 64.7zm92.7 139l-45.9 14-9.4-30.6c-5.2-16.9-23.1-26.4-40-21.2s-26.4 23.1-21.2 40l28.1 91.8 207.2-63.3 0-66.9-118.8 36.3z"]
};
var faTruckCouch = faTruckRampCouch;
var faPersonThroughWindow = {
  prefix: 'fass',
  iconName: 'person-through-window',
  icon: [640, 512, [], "e5a9", "M288 64l0 77.9-144.5 86.7-15.5 9.3 0 146.1-64 0 0-320 224 0zm64 0l224 0 0 320-67.7 0-3.7-4.5-80-96-9.6-11.5-93.6 0-35.3-54.4c39.4-23.6 61.3-36.8 65.9-39.5L352 64zm73 320l-26.6 0 42.7 64 198.9 0 0-448-640 0 0 448 308.2 0c17.8 26.6 32 48 42.6 63.9l53.3-35.5c-2.1-3.2-33.4-50-93.6-140.4l74.6 0 40 48zm-159.5 0l-73.5 0 0-109.9 .2-.1 73.3 110zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faAvocado = {
  prefix: 'fass',
  iconName: 'avocado',
  icon: [512, 512, [], "e0aa", "M470.3 245.8c56.2-56.2 56.2-147.4 0-203.6s-147.4-56.2-203.6 0L212.8 96c-54.7-1.1-109.7 19.2-151.4 60.9-81.2 81.2-81.2 212.9 0 294.2s212.9 81.2 294.2 0c41.7-41.7 62-96.7 60.9-151.4l53.9-53.9zM283.7 347.2c-41.7 41.7-102.1 49.1-134.8 16.4s-25.3-93 16.4-134.8 102.1-49.1 134.8-16.4 25.3 93-16.4 134.8z"]
};
var faSealExclamation = {
  prefix: 'fass',
  iconName: 'seal-exclamation',
  icon: [512, 512, [], "e242", "M320 64l128 0 0 128 64 64-64 64 0 128-128 0-64 64-64-64-128 0 0-128-64-64 64-64 0-128 128 0 64-64 64 64zM228 324l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0z"]
};
var faWindTurbine = {
  prefix: 'fass',
  iconName: 'wind-turbine',
  icon: [512, 512, [], "f89b", "M341.1 393L317.3 170.8 415.6-30 235 101.7 12 116.9 216.4 207.5 341.1 393zM224.2 305.2l0 158.7-96 0 0 48 256 0 0-48-96 0 0-63.5-64-95.2zm32-169.2a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSchoolLock = {
  prefix: 'fass',
  iconName: 'school-lock',
  icon: [640, 512, [], "e56f", "M0 128l128 0 160-128 160 128 128 0 0 57.3c-14.8-6-31-9.3-48-9.3-70.7 0-128 57.3-128 128l-32 0 0 208-368 0 0-384zM320 336l-96 0 0 128 96 0 0-128zM64 384l64 0 0-64-64 0 0 64zm64-128l0-64-64 0 0 64 64 0zm224-64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM496 304l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z"]
};
var faChartScatter3d = {
  prefix: 'fass',
  iconName: 'chart-scatter-3d',
  icon: [512, 512, [], "e0e8", "M64 32l-64 0 0 64 64 0 0-64zM288 64l0-32-64 0 0 241-180.5 150.4-24.6 20.5 41 49.2 24.6-20.5 171.5-142.9 171.5 142.9 24.6 20.5 41-49.2-24.6-20.5-180.5-150.4 0-209zM0 224l0 64 64 0 0-64-64 0zm160-96l-64 0 0 64 64 0 0-64zM352 32l0 64 64 0 0-64-64 0zm160 96l-64 0 0 64 64 0 0-64zM352 224l0 64 64 0 0-64-64 0zM288 416l-64 0 0 64 64 0 0-64z"]
};
var faBusStop = {
  prefix: 'fass',
  iconName: 'bus-stop',
  icon: [640, 512, [], "e81e", "M352 416l-32 0 0 64-64 0 0-64-128 0 0 64-64 0 0-64-32 0 0-352 320 0 0 352zM512 0c61.9 0 112 50.1 112 112 0 50.7-33.7 93.5-80 107.3l0 260.7-64 0 0-260.7c-46.3-13.8-80-56.6-80-107.3 0-61.9 50.1-112 112-112zM120 304a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm144 0a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM96 256l192 0 0-128-192 0 0 128z"]
};
var faAlbumCollectionCirclePlus = {
  prefix: 'fass',
  iconName: 'album-collection-circle-plus',
  icon: [576, 512, [], "e48e", "M128 0l0 48 256 0 0-48-256 0zM64 192L8.7 192c1.2 8.3 14.5 101.3 39.8 278.8L54.4 512 276 512c-10.5-14.6-19-30.8-25.1-48.1-86-1.9-154.9-51.3-154.9-111.9 0-61.9 71.6-112 160-112 20.8 0 40.7 2.8 58.9 7.8 32.4-25 73-39.8 117.1-39.8 23.7 0 46.4 4.3 67.3 12.1l4-28.1-439.3 0zM241.2 378c2.2-19 7.1-37.1 14.4-54-21.9 .1-39.6 12.6-39.6 28 0 11.8 10.5 21.9 25.2 26zM104 96l-24 0 0 48 352 0 0-48-328 0zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 64 0 0 32-64 0 0 64-32 0 0-64-64 0 0-32 64 0 0-64 32 0 0 16z"]
};
var faPersonBurst = {
  prefix: 'fass',
  iconName: 'person-burst',
  icon: [640, 512, [], "e53b", "M228 32.1l0-88-48 0 0 88 48 0zM4 168.1l88 0 0-48-88 0 0 48zM96.5 285.5c20.7-20.7 35.8-35.8 45.3-45.3l-33.9-33.9c-23.6 23.6-61.3 61.3-62.2 62.2l33.9 33.9 17-17zM45.6 19.6c23.6 23.6 61.3 61.3 62.2 62.2l33.9-33.9C118.2 24.4 80.5-13.4 79.5-14.3L45.6 19.6zM352.4 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-51.1 32l-16.3 0-9.6 13.2-92.9 128-18.8 25.9 51.8 37.6c9.3-12.8 28.3-39 56.9-78.4l0 305.7 64 0 0-208 32 0 0 208 64 0 0-305.7c28.6 39.4 47.6 65.6 56.9 78.4l51.8-37.6c-.2-.2-37.4-51.6-111.7-153.9l-9.6-13.2-118.5 0z"]
};
var faBalloon = {
  prefix: 'fass',
  iconName: 'balloon',
  icon: [384, 512, [], "e2e3", "M0 192C0 86 86 0 192 0S384 86 384 192c0 128-160 240-160 240l32 80-128 0 32-80S0 320 0 192zm104 0c0-48.6 39.4-88 88-88l0-48C116.9 56 56 116.9 56 192l48 0z"]
};
var faLeftLong = {
  prefix: 'fass',
  iconName: 'left-long',
  icon: [576, 512, ["long-arrow-alt-left"], "f30a", "M0 256l192 192 0-128 384 0 0-128-384 0 0-128-192 192z"]
};
var faLongArrowAltLeft = faLeftLong;
var faLocationCrosshairs = {
  prefix: 'fass',
  iconName: 'location-crosshairs',
  icon: [576, 512, ["location"], "f601", "M320-16l0 50.3c98.1 14 175.7 91.6 189.7 189.7l50.3 0 0 64-50.3 0c-14 98.1-91.6 175.7-189.7 189.7l0 50.3-64 0 0-50.3C157.9 463.7 80.3 386.1 66.3 288l-50.3 0 0-64 50.3 0C80.3 125.9 157.9 48.3 256 34.3l0-50.3 64 0zM448 256a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faLocation = faLocationCrosshairs;
var faPersonDotsFromLine = {
  prefix: 'fass',
  iconName: 'person-dots-from-line',
  icon: [512, 512, ["diagnoses"], "f470", "M184 72a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM159.5 192l192.9 0 9.6 13.4 80 112 6 8.3 0 90.3-64 0 0-69.7-32-44.8 0 114.5-192 0 0-114.5-32 44.8 0 69.7-64 0 0-90.3 6-8.3 80-112 9.6-13.4zM232 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM24 464l488 0 0 48-512 0 0-48 24 0zM64 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm424 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faDiagnoses = faPersonDotsFromLine;
var faGaugeSimpleHigh = {
  prefix: 'fass',
  iconName: 'gauge-simple-high',
  icon: [512, 512, [61668, "tachometer", "tachometer-fast"], "f62a", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm320 96c0-16.2-6-31.1-16-42.3l69.5-138.9-42.9-21.5-69.5 138.9c-1.7-.1-3.4-.2-5.1-.2-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64z"]
};
var faTachometer = faGaugeSimpleHigh;
var faTachometerFast = faGaugeSimpleHigh;
var faAnglesLeft = {
  prefix: 'fass',
  iconName: 'angles-left',
  icon: [512, 512, [171, "angle-double-left"], "f100", "M41.6 278.6l-22.6-22.6 22.6-22.6 160-160 22.6-22.6 45.3 45.3-22.6 22.6-137.4 137.4 137.4 137.4 22.6 22.6-45.3 45.3-22.6-22.6-160-160zm192 0l-22.6-22.6 22.6-22.6 160-160 22.6-22.6 45.3 45.3-22.6 22.6-137.4 137.4 137.4 137.4 22.6 22.6-45.3 45.3-22.6-22.6-160-160z"]
};
var faAngleDoubleLeft = faAnglesLeft;
var faUpDown = {
  prefix: 'fass',
  iconName: 'up-down',
  icon: [576, 512, [8597, 11021, "arrows-alt-v"], "f338", "M160 0l-144 160 112 0 0 352 64 0 0-352 112 0-144-160zM560 352l-112 0 0-352-64 0 0 352-112 0 144 160 144-160z"]
};
var faArrowsAltV = faUpDown;
var faBoxArrowDownMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'box-arrow-down-magnifying-glass',
  icon: [640, 512, [], "e796", "M288.7 16c-9.3 19.5-14.9 41.2-16 64l-95.3 0-34.3 48 121.3 0 0 190.1-40-40-33.9 33.9 97.9 97.9 97.9-97.9-33.9-33.9-40 40 0-121.2c30.8 36.2 76.7 59.2 128 59.2 19.8 0 38.8-3.4 56.5-9.7l15.5 15.5 0 218.1-448 0 0-352 80-112 144.2 0zM440.4-31.9c66.3 0 120 53.7 120 120 0 24.4-7.4 47.2-19.9 66.1 47.9 47.9 73.8 73.9 77.8 77.9L584.4 266c-4-4-29.9-30-77.8-77.9-19 12.6-41.7 19.9-66.2 19.9-66.3 0-120-53.7-120-120s53.7-120 120-120zm0 48a72 72 0 1 0 0 144 72 72 0 1 0 0-144z"]
};
var faBatteryEmpty = {
  prefix: 'fass',
  iconName: 'battery-empty',
  icon: [640, 512, ["battery-0"], "f244", "M96 160l0 256 448 0 0-256-448 0zM32 96l576 0 0 128 32 0 0 128-32 0 0 128-576 0 0-384z"]
};
var faBattery0 = faBatteryEmpty;
var faChartSine = {
  prefix: 'fass',
  iconName: 'chart-sine',
  icon: [512, 512, [], "e69d", "M64 64l0-32-64 0 0 448 512 0 0-64-448 0 0-352zm42.3 184.4l62.7 13c.9-4.2 1.7-8.4 2.5-12.7 2-10.4 4.1-20.9 6.9-31.1 2.1-7.7 5.5-17.7 10.3-27.3 10.5-21 22.3-30.3 35.4-30.3 12.1 0 19.3 4.5 26.6 15.6 8.8 13.4 15.1 32.6 22.9 57.9 .2 .7 .4 1.4 .7 2.2 6.9 22.4 15.5 50.1 29.9 72 16.4 24.9 41.8 44.4 80 44.4 50.9 0 79.1-38.6 92.6-65.7 7.2-14.4 11.9-28.5 14.7-38.7 3.2-11.5 5.5-23.2 7.8-34.9 .8-4.3 1.7-8.6 2.6-12.9l-62.7-13c-.9 4.2-1.7 8.4-2.5 12.7-2 10.4-4.1 20.9-6.9 31.1-2.1 7.7-5.5 17.7-10.3 27.3-10.5 21-22.3 30.3-35.4 30.3-12.1 0-19.3-4.5-26.6-15.6-9.1-13.8-15.4-33.6-23.5-60-6.9-22.4-15.5-50.1-29.9-72-16.4-24.9-41.8-44.4-80-44.4-50.9 0-79.1 38.6-92.6 65.7-7.2 14.4-11.9 28.5-14.7 38.7-3.2 11.5-5.5 23.3-7.8 35-.8 4.3-1.7 8.6-2.6 12.9z"]
};
var faArrowsRetweet = {
  prefix: 'fass',
  iconName: 'arrows-retweet',
  icon: [640, 512, ["retweet-alt"], "f361", "M150.9 41.4L128.3 18.7c-8.2 8.2-37.1 37.1-86.6 86.6L19 128 64.3 173.3c17.3-17.3 28-28 32-32l0 338.7 256 0 0-64-192 0 0-274.7c4 4 14.7 14.7 32 32L237.5 128c-8.2-8.2-37.1-37.1-86.6-86.6zM489.6 470.6l22.6 22.6 109.3-109.3-45.3-45.3-32 32 0-338.7-256 0 0 64 192 0 0 274.7-32-32-45.3 45.3 86.6 86.6z"]
};
var faRetweetAlt = faArrowsRetweet;
var faKeyboard = {
  prefix: 'fass',
  iconName: 'keyboard',
  icon: [576, 512, [9000], "f11c", "M576 64l-576 0 0 384 576 0 0-384zM128 128l0 64-64 0 0-64 64 0zM64 224l64 0 0 64-64 0 0-64zm160-96l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm256 96l0 64-256 0 0-64 256 0zM256 128l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zm32-96l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zm32-96l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0z"]
};
var faCodePullRequestClosed = {
  prefix: 'fass',
  iconName: 'code-pull-request-closed',
  icon: [384, 512, [], "e3f9", "M264.3-5.3c16 16 29.3 29.3 40 40 10.7-10.7 24-24 40-40L389.5 40c-16 16-29.3 29.3-40 40 10.7 10.7 24 24 40 40l-45.3 45.3-40-40-40 40-45.3-45.3c16-16 29.3-29.3 40-40-10.7-10.7-24-24-40-40L264.3-5.3zM56.3 56l0 48 48 0 0-48-48 0zM.3 0l160 0 0 160-48 0 0 192 48 0 0 160-160 0 0-160 48 0 0-192-48 0 0-160zm336 224l0 128 48 0 0 160-160 0 0-160 48 0 0-128 64 0zm-56 232l48 0 0-48-48 0 0 48zm-176-48l-48 0 0 48 48 0 0-48z"]
};
var faRight = {
  prefix: 'fass',
  iconName: 'right',
  icon: [448, 512, [11157, "arrow-alt-right"], "f356", "M448 256l-224-208 0 144-224 0 0 128 224 0 0 144 224-208z"]
};
var faArrowAltRight = faRight;
var faPenClipSlash = {
  prefix: 'fass',
  iconName: 'pen-clip-slash',
  icon: [576, 512, ["pen-alt-slash"], "e20f", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-184.1-184.1 62-62-3-3-17-17c-216.5-216.5-165.5-165.5-189-189-6.6 6.6-27.3 27.3-62 62L49.3-16.9zM202.1 136l28.1-28.1 31 31-28.1 28.1-31-31zm107.1 243l-144-144-93.1 93.1-56 200 200-56 93.1-93.1zM473.1 215l87-87-144-144-87 87 144 144z"]
};
var faPenAltSlash = faPenClipSlash;
var faSensorOn = {
  prefix: 'fass',
  iconName: 'sensor-on',
  icon: [640, 512, [], "e02b", "M0 32l448 0 0 448-448 0 0-448zM112 96l-48 0 0 160 48 0 0-160zm96 0l-48 0 0 160 48 0 0-160zm389.3 12c-36.7 24.4-59.3 39.6-68 45.3l-26.6-39.9c8.6-5.8 31.3-20.9 68-45.3l20-13.3 26.6 39.9-20 13.3zM536 232l104 0 0 48-128 0 0-48 24 0zm13.3 140c36.7 24.4 59.3 39.6 68 45.3l-26.6 39.9-68-45.3-20-13.3 26.6-39.9 20 13.3z"]
};
var faChevronsUp = {
  prefix: 'fass',
  iconName: 'chevrons-up',
  icon: [512, 512, ["chevron-double-up"], "f325", "M278.9 41.4l-22.6-22.6-22.6 22.6-192 192-22.6 22.6 45.3 45.3 22.6-22.6 169.4-169.4 169.4 169.4 22.6 22.6 45.3-45.3-22.6-22.6-192-192zm0 192l-22.6-22.6-22.6 22.6-192 192-22.6 22.6 45.3 45.3 22.6-22.6 169.4-169.4 169.4 169.4 22.6 22.6 45.3-45.3-214.6-214.6z"]
};
var faChevronDoubleUp = faChevronsUp;
var faCookie = {
  prefix: 'fass',
  iconName: 'cookie',
  icon: [512, 512, [127850], "f563", "M362.2 37L213.9 16 81.7 86.7 16 222.1 42 370.4 149.8 475 298.1 496 430.3 425.3 496 289.9 470 141.6 362.2 37zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faStopwatch = {
  prefix: 'fass',
  iconName: 'stopwatch',
  icon: [512, 512, [9201], "f2f2", "M336.3 0l-160 0 0 48 56 0 0 25.3c-108 11.9-192 103.5-192 214.7 0 119.3 96.7 216 216 216s216-96.7 216-216c0-39.8-10.8-77.1-29.6-109.2 19.7-19.7 36.7-36.7 50.8-50.8L448.3 82.7c-15 15-30.3 30.3-46 46-32.9-30.2-75.2-50.3-122-55.5l0-25.3 56 0 0-48zm-56 184l0 128-48 0 0-152 48 0 0 24z"]
};
var faEject = {
  prefix: 'fass',
  iconName: 'eject',
  icon: [448, 512, [9167], "f052", "M0 320l0-64 224-240 224 240 0 64-448 0zM448 480l-448 0 0-96 448 0 0 96z"]
};
var faCardSpade = {
  prefix: 'fass',
  iconName: 'card-spade',
  icon: [384, 512, [], "e3ec", "M384 512L0 512 0 0 384 0 384 512zM136 352l0 48 112 0 0-48-112 0zM88.4 224.4c-21.9 21.9-21.9 57.3 0 79.2 21.9 21.9 57.3 21.9 79.2 0l24.4-24.4 24.4 24.4c21.9 21.9 57.3 21.9 79.2 0s21.9-57.3 0-79.2L192 120.8 88.4 224.4z"]
};
var faSatelliteDish = {
  prefix: 'fass',
  iconName: 'satellite-dish',
  icon: [512, 512, [128225], "f7c0", "M232 0C386.6 0 512 125.4 512 280l0 24-48 0 0-24C464 151.9 360.1 48 232 48l-24 0 0-48 24 0zM208 96l24 0c101.6 0 184 82.4 184 184l0 24-48 0 0-24c0-75.1-60.9-136-136-136l-24 0 0-48zM0 256c0-54.3 16.9-104.7 45.8-146.2L201.4 265.4c22.9-22.9 41.1-41.1 54.6-54.6L301.3 256c-13.5 13.5-31.7 31.7-54.6 54.6L402.2 466.2C360.7 495.1 310.3 512 256 512 114.6 512 0 397.4 0 256z"]
};
var faTableCellsUnlock = {
  prefix: 'fass',
  iconName: 'table-cells-unlock',
  icon: [640, 512, [], "e692", "M448 96l0 64-64 0 0-64 64 0zM384 224l25.3 0c17.1-42.2 56-73.2 102.7-79l0-113-448 0 0 448 304 0 0-208 16 0 0-48zm-64 64l-64 0 0-64 64 0 0 64zm-64 64l64 0 0 64-64 0 0-64zm-64-64l-64 0 0-64 64 0 0 64zm-64 64l64 0 0 64-64 0 0-64zm0-192l0-64 64 0 0 64-64 0zm128 0l0-64 64 0 0 64-64 0zm272 80c17.7 0 32 14.3 32 32l48 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48-32 0 0 192 224 0 0-192-144 0 0-48c0-17.7 14.3-32 32-32z"]
};
var faClipboardClock = {
  prefix: 'fass',
  iconName: 'clipboard-clock',
  icon: [576, 512, [], "e756", "M96 0l256 0 0 32 64 0 0 176.7c-98.6 8.1-176 90.7-176 191.3 0 41.8 13.4 80.5 36 112l-244 0 0-480 64 0 0-32zm48 64l0 48 160 0 0-48-160 0zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 96 80 0 0-32-48 0 0-64z"]
};
var faHandBackPointDown = {
  prefix: 'fass',
  iconName: 'hand-back-point-down',
  icon: [448, 512, [], "e19e", "M176 512l-80 0 0-336-32 0 0 72-48-40 0-68c0-38 16.9-74 46.1-98.3l5.4-4.5C96.3 13.1 132.5 0 169.9 0L288 0c70.7 0 128 57.3 128 128l0 144-80 0 0 32-80 0 0 32-80 0 0 176z"]
};
var faClockSixThirty = {
  prefix: 'fass',
  iconName: 'clock-six-thirty',
  icon: [512, 512, [], "e353", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm24-120l0-160-48 0 0 184 48 0 0-24z"]
};
var faFaceRollingEyes = {
  prefix: 'fass',
  iconName: 'face-rolling-eyes',
  icon: [512, 512, [128580, "meh-rolling-eyes"], "f5a5", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM192 352l152 0 0 48-176 0 0-48 24 0zm32-128c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4-3.7 5.2-5.8 11.6-5.8 18.4 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4 22.3 10 37.8 32.4 37.8 58.4zm128 64c-35.3 0-64-28.7-64-64 0-26 15.5-48.4 37.8-58.4-3.7 5.2-5.8 11.6-5.8 18.4 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4 22.3 10 37.8 32.4 37.8 58.4 0 35.3-28.7 64-64 64z"]
};
var faMehRollingEyes = faFaceRollingEyes;
var faListCheck = {
  prefix: 'fass',
  iconName: 'list-check',
  icon: [576, 512, ["tasks"], "f0ae", "M185.9 50.1c-2.1 3-25.4 36.3-69.8 99.7L99.7 173.2C89.5 163 69.4 142.9 39.5 113l-17-17 33.9-33.9c10.8 10.8 23.1 23.1 36.7 36.7 30.7-43.9 48.5-69.3 53.4-76.2l39.3 27.5zm0 160c-2.1 3-25.4 36.3-69.8 99.7L99.7 333.2C89.5 323 69.4 302.9 39.5 273l-17-17 33.9-33.9c10.8 10.8 23.1 23.1 36.7 36.7 30.7-43.9 48.5-69.3 53.4-76.2l39.3 27.5zM256.4 64l288 0 0 64-288 0 0-64zm0 160l288 0 0 64-288 0 0-64zm-64 160l352 0 0 64-352 0 0-64zm-96-8a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faTasks = faListCheck;
var faHouseBlank = {
  prefix: 'fass',
  iconName: 'house-blank',
  icon: [512, 512, ["home-blank"], "e487", "M464 272l48 0 0-48-256-240-256 240 0 48 48 0 0 240 416 0 0-240z"]
};
var faHomeBlank = faHouseBlank;
var faSackXmark = {
  prefix: 'fass',
  iconName: 'sack-xmark',
  icon: [512, 512, [], "e56a", "M320 96l-128 0-64-96 256 0-64 96zM167.2 144l177.6 0C405.1 183.2 512 261.6 512 416l0 96-512 0 0-96C0 261.6 106.9 183.2 167.2 144zM340.9 301.1l-33.9-33.9c-8.5 8.5-25.5 25.5-50.9 50.9-25.5-25.5-42.4-42.4-50.9-50.9l-33.9 33.9c8.5 8.5 25.5 25.5 50.9 50.9-25.5 25.5-42.4 42.4-50.9 50.9l33.9 33.9c8.5-8.5 25.5-25.5 50.9-50.9 25.5 25.5 42.4 42.4 50.9 50.9l33.9-33.9c-8.5-8.5-25.5-25.5-50.9-50.9 25.5-25.5 42.4-42.4 50.9-50.9z"]
};
var faUserHatTie = {
  prefix: 'fass',
  iconName: 'user-hat-tie',
  icon: [448, 512, [], "e7ae", "M96 80l48-112 32 0 48 32 48-32 32 0 48 112 48 0 0 48-48 0 0 14.8c0 70.7-57.3 128-128 128S96 213.5 96 142.8l0-14.8-48 0 0-48 48 0zm48 62.8c0 44.2 35.8 80 80 80s80-35.8 80-80l0-14.8-160 0 0 14.8zM272 328l-31.6 36.9 31 115.1 .6 0 40-160 56 0 64 192-416 0 64-192 56 0 40 160 31.4-115.3-31.4-36.7 0-24 96 0 0 24z"]
};
var faHashtag = {
  prefix: 'fass',
  iconName: 'hashtag',
  icon: [512, 512, [62098], "23", "M154.8 128l27.4-128 65.5 0-27.4 128 126.5 0 27.4-128 65.5 0-27.4 128 99.9 0-13.7 64-99.9 0-27.4 128 99.9 0-13.7 64-99.9 0-27.4 128-65.5 0 27.4-128-126.5 0-27.4 128-65.5 0 27.4-128-99.9 0 13.7-64 99.9 0 27.4-128-99.9 0 13.7-64 99.9 0zm51.7 64l-27.4 128 126.5 0 27.4-128-126.5 0z"]
};
var faFileHeart = {
  prefix: 'fass',
  iconName: 'file-heart',
  icon: [384, 512, [], "e176", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zm-22.4 221c-11.1-14.8-28.5-23.5-46.9-23.5-32.4 0-58.7 26.3-58.7 58.7l0 5.3c0 64 112 128 112 128s112-64 112-128l0-5.3c0-32.4-26.3-58.7-58.7-58.7-18.5 0-35.9 8.7-46.9 23.5l-6.4 8.5-6.4-8.5z"]
};
var faSquareQ = {
  prefix: 'fass',
  iconName: 'square-q',
  icon: [448, 512, [], "e27b", "M448 32l-448 0 0 448 448 0 0-448zM152 256c0 39.8 32.2 72 72 72 11.1 0 21.6-2.5 31-7-18.7-18.7-33-33-42.8-42.8l33.9-33.9c9.8 9.8 24.1 24.1 42.8 42.8 4.5-9.4 7-19.9 7-31 0-39.8-32.2-72-72-72s-72 32.2-72 72zm192 0c0 24.5-7.3 47.2-19.9 66.2 7.9 7.9 17.8 17.8 29.8 29.8L320 385.9c-12-12-21.9-21.9-29.8-29.8-19 12.6-41.7 19.9-66.2 19.9-66.3 0-120-53.7-120-120s53.7-120 120-120 120 53.7 120 120z"]
};
var faCastle = {
  prefix: 'fass',
  iconName: 'castle',
  icon: [512, 512, [], "e0de", "M176 32l-64 0 0 192-48 0 0-64-64 0 0 352 512 0 0-352-64 0 0 64-48 0 0-192-64 0 0 64-48 0 0-64-64 0 0 64-48 0 0-64zm16 288l128 0 0 144-128 0 0-144z"]
};
var faTrafficLightSlow = {
  prefix: 'fass',
  iconName: 'traffic-light-slow',
  icon: [320, 512, [], "f639", "M320-32l-320 0 0 576 320 0 0-576zM160 360c30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56 25.1-56 56-56zm56-104a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 152a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm24-56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM160 440c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24z"]
};
var faMessageCaptions = {
  prefix: 'fass',
  iconName: 'message-captions',
  icon: [512, 512, ["comment-alt-captions"], "e1de", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM120 208l152 0 0 48-176 0 0-48 24 0zm224 0l72 0 0 48-96 0 0-48 24 0zM120 304l72 0 0 48-96 0 0-48 24 0zm144 0l152 0 0 48-176 0 0-48 24 0z"]
};
var faCommentAltCaptions = faMessageCaptions;
var faBird = {
  prefix: 'fass',
  iconName: 'bird',
  icon: [512, 512, [], "e469", "M0 160l0 32C0 294.3 68.5 380.5 162.1 407.4l55.4 104.6 54.3 0-.6-1.2-50.2-94.8c1 0 2 0 3 0 12.6 0 25-1 37.1-3.1l52.4 99.1 54.3 0-.6-1.2-58.9-111.2C390.3 366.3 448 285.9 448 192l0-21.3 64-42.7-64.6-43.1C441.9 37.1 401.3 0 352 0 299 0 256 43 256 96l0 64-256 0zM352 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTrain = {
  prefix: 'fass',
  iconName: 'train',
  icon: [448, 512, [128646], "f238", "M416 0l-384 0 0 448 52.5 0c-41.3 51.7-62.7 78.3-64 80l61.5 0 64-80 156.1 0 64 80 61.5 0c-1.3-1.7-22.7-28.3-64-80l52.5 0 0-448zM352 96l0 160-256 0 0-160 256 0zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faFileWav = {
  prefix: 'fass',
  iconName: 'file-wav',
  icon: [576, 512, [], "e7fe", "M196 435c0 16.8 3 33.4 8.9 49.2l3.1 8.2 7.7-20.4c2.9-7.7 4.3-15.8 4.3-24l0-20 40 0 0 20c0 8.2 1.5 16.3 4.3 24l7.7 20.4 3.1-8.2 2.1-5.9c4.5-13.9 6.8-28.5 6.8-43.2l0-55 40 0 0 55c0 18.9-3 37.6-8.8 55.6l-2.7 7.6-13.8 36.8-4.8 13-43.8 0c-3.2-8.5-6.5-17.5-10.1-27.1-3.6 9.6-7 18.6-10.1 27.1l-43.7 0-4.8-13-13.8-36.8C159.9 478 156 456.6 156 435l0-55 40 0 0 55zm320 0c0 16.8 3 33.4 8.9 49.2l3.1 8.2 3.1-8.2 2.1-5.9c4.5-13.9 6.8-28.5 6.8-43.2l0-55 40 0 0 55c0 18.9-3 37.6-8.8 55.6l-2.7 7.6-13.8 36.8-4.8 13-43.8 0-4.8-13-13.8-36.8C479.9 478 476 456.6 476 435l0-55 40 0 0 55zM408 380c24.3 0 44 19.7 44 44l0 120-40 0 0-44-24 0 0 44-40 0 0-120c0-24.3 19.7-44 44-44l16 0zm8-236l0 192-304 0 0 176-80 0 0-512 240 0 144 144zM392 420c-2.2 0-4 1.8-4 4l0 36 24 0 0-36c0-2.2-1.8-4-4-4l-16 0zM240 176L357.5 176 240 58.5 240 176z"]
};
var faMessageMiddle = {
  prefix: 'fass',
  iconName: 'message-middle',
  icon: [512, 512, ["comment-middle-alt"], "e1e1", "M176 448l80 96 80-96 176 0 0-416-512 0 0 416 176 0z"]
};
var faCommentMiddleAlt = faMessageMiddle;
var faGamepad = {
  prefix: 'fass',
  iconName: 'gamepad',
  icon: [640, 512, [], "f11b", "M640 448l-640 0 0-384 640 0 0 384zM168 232l-56 0 0 48 56 0 0 56 48 0 0-56 56 0 0-48-56 0 0-56-48 0 0 56zm264 40a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64-96a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faBroccoli = {
  prefix: 'fass',
  iconName: 'broccoli',
  icon: [512, 512, [129382], "e3e2", "M0 352l512 0 0-96c0-45.5-31.6-83.6-74.1-93.5 6.4-10 10.1-21.8 10.1-34.5 0-35.3-28.7-64-64-64-12.7 0-24.6 3.7-34.5 10.1-9.9-42.5-48-74.1-93.5-74.1s-83.6 31.6-93.5 74.1c-10-6.4-21.8-10.1-34.5-10.1-35.3 0-64 28.7-64 64 0 12.7 3.7 24.6 10.1 34.5-42.5 9.9-74.1 48-74.1 93.5l0 96zM200 512l112 0c15.3-45.8 36-84.2 53.5-112l-93.5 0-16 32-16-32-93.5 0c17.5 27.8 38.2 66.2 53.5 112z"]
};
var faCoffeeBeans = {
  prefix: 'fass',
  iconName: 'coffee-beans',
  icon: [576, 512, [], "e13f", "M518.7 27c43.6 43.6 63.6 100.3 58.1 150.3l-116.4-69.8-5.5-3.3-6.4-.1-88.4-1.6-90.3-66.5C275.6 24.3 283.1 13.7 292.5 4.4 348.7-51.9 450-41.8 518.7 27zm22.6 226.3c-56.2 56.2-157.5 46.1-226.3-22.6-42.1-42.1-62.2-96.3-58.6-145l81.4 59.9 6.2 4.5 7.6 .1 89.6 1.6 121.2 72.7c-5.5 10.4-12.6 20-21.1 28.6zM80.1 320l0 8.7 5.6 6.7 74.4 89.3 0 118.2c-5.3 .7-10.6 1.1-16 1.1-79.5 0-144-78.8-144-176 0-69.1 32.6-128.9 80-157.7l0 109.7zm48-8.7l0-118.2c5.3-.7 10.6-1.1 16-1.1 79.5 0 144 78.8 144 176 0 69.1-32.6 128.9-80 157.7l0-118.4-5.6-6.7-74.4-89.3z"]
};
var faSquareChevronUp = {
  prefix: 'fass',
  iconName: 'square-chevron-up',
  icon: [448, 512, ["chevron-square-up"], "f32c", "M448 32l-448 0 0 448 448 0 0-448zM241 167l104 104 17 17-33.9 33.9-17-17-87-87-87 87-17 17-33.9-33.9 17-17 104-104 17-17 17 17z"]
};
var faChevronSquareUp = faSquareChevronUp;
var faFileExport = {
  prefix: 'fass',
  iconName: 'file-export',
  icon: [640, 512, ["arrow-right-from-file"], "f56e", "M304.4 0l-240 0 0 512 384 0 0-160 78.1 0c-23 23-39 39-48 48l33.9 33.9c2.1-2.1 31.8-31.8 89-89l17-17c-2.1-2.1-31.8-31.8-89-89l-17-17-33.9 33.9c9 9 25 25 48 48l-78.1 0 0-160-144-144zm85.5 176l-117.5 0 0-117.5 117.5 117.5zM256.4 304l128 0 0 48-128 0 0-48z"]
};
var faArrowRightFromFile = faFileExport;
var faCupStrawSwoosh = {
  prefix: 'fass',
  iconName: 'cup-straw-swoosh',
  icon: [384, 512, [], "e364", "M189.6-16l98.4 0 0 48-61.6 0-17.1 64 166.6 0 0 48-368 0 0-48 151.7 0 25.1-94.2 4.8-17.8zM50.1 352l-13.9-160 311.7 0c-6.5 74.7-13.7 157.4-27.8 320L64 512c-7.4-85.3-12.1-138.7-13.9-160zM160 400l12.8 0 7.1-10.7 56.9-85.3 53.1 0 4.2-48-82.9 0-7.1 10.7-56.9 85.3-48.9 0 4.2 48 57.6 0z"]
};
var faMandolin = {
  prefix: 'fass',
  iconName: 'mandolin',
  icon: [512, 512, [], "f6f9", "M448 0l-80 48-25.4 76.1-65.7 65.7C189.6 188.3 0 200.5 0 336 0 433.2 78.8 512 176 512 311.5 512 323.7 322.4 322.2 235.1l65.7-65.7 76.1-25.4 48-80-64-64zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faMerge = {
  prefix: 'fass',
  iconName: 'merge',
  icon: [576, 512, [], "e526", "M192.1 64l15.4 0 9.6 12 118.4 148 80.6 0 0-94.5c33.6 29.4 72.6 63.5 117.1 102.4L560.7 256c-31 27.1-133.9 117.1-144.6 126.5l0-94.5-80.6 0-118.4 148-9.6 12-175.4 0 0-64 144.6 0 102.4-128-102.4-128-144.6 0 0-64 160 0z"]
};
var faBookArrowUp = {
  prefix: 'fass',
  iconName: 'book-arrow-up',
  icon: [448, 512, [], "e0ba", "M0 0l448 0 0 384-32 0 0 64 32 0 0 64-448 0 0-512zM64 416l0 32 288 0 0-64-256 0c-17.7 0-32 14.3-32 32zM241 95l-17-17-89 89-17 17 33.9 33.9c9-9 25-25 48-48l0 126.1 48 0 0-126.1c23 23 39 39 48 48L329.9 184c-2.1-2.1-31.8-31.8-89-89z"]
};
var faCircleBrazilianReal = {
  prefix: 'fass',
  iconName: 'circle-brazilian-real',
  icon: [512, 512, [], "e6eb", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM368 128l0 24 32 0 0 48-57.8 0c-7.8 0-14.2 6.3-14.2 14.2 0 5.8 3.5 11 8.9 13.1l32 12.8c23.6 9.4 39.1 32.3 39.1 57.7 0 26.5-16.6 49.2-40 58.1l0 28.1-32 0 0-24-48 0 0-48 57.8 0c7.8 0 14.2-6.3 14.2-14.2 0-5.8-3.5-11-8.9-13.1l-32-12.8c-23.6-9.4-39.1-32.3-39.1-57.7 0-32.3 24.6-58.8 56-61.9l0-24.3 32 0zM136 144l48 0c39.8 0 72 32.2 72 72 0 26.9-14.7 50.3-36.5 62.6l26.8 80.5-45.5 15.2C198 366 188.4 337.2 172 288l-12 0 0 80-48 0 0-224 24 0zm48 96c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0 48 24 0z"]
};
var faMeter = {
  prefix: 'fass',
  iconName: 'meter',
  icon: [512, 512, [], "e1e8", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM376 152l0 72-48 0 0-96 48 0 0 24zm-96-24l0 96-48 0 0-96 48 0zm-96 24l0 72-48 0 0-96 48 0 0 24z"]
};
var faSquareSmall = {
  prefix: 'fass',
  iconName: 'square-small',
  icon: [320, 512, [], "e27e", "M0 96l320 0 0 320-320 0 0-320z"]
};
var faCircleZ = {
  prefix: 'fass',
  iconName: 'circle-z',
  icon: [512, 512, [], "e130", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm72-368l24 0 0 32.6-5.4 6.6-111.9 136.8 117.4 0 0 48-192 0 0-32.6 5.4-6.6 111.9-136.8-117.4 0 0-48 168 0z"]
};
var faMistletoe = {
  prefix: 'fass',
  iconName: 'mistletoe',
  icon: [576, 512, [], "f7b4", "M312 24l0-24-48 0 0 118.1-98 98-74.7 14.4c-53 10.2-91.3 56.6-91.3 110.5 0 41.4 33.6 75 75 75 50.5 0 94.3-33.5 108.1-81.2 7.2 10.4 19.3 17.2 32.9 17.2 22.1 0 40-17.9 40-40s-17.9-40-40-40c-7.9 0-15.3 2.3-21.5 6.3l5.4-28.2 64.1-64.1 0 72.4c14.7 13.2 24 32.3 24 53.7 0 39.8-32.2 72-72 72-7.2 0-14.2-1.1-20.8-3-2.1 8.4-3.2 17.1-3.2 25.9l0 9.1c0 53 43 96 96 96s96-43 96-96l0-9.1c0-25.1-9-49.4-25.3-68.4l-46.7-54.5 0-98.1 64.1 64.1 14.4 74.7c10.2 53 56.6 91.3 110.5 91.3 41.4 0 75-33.6 75-75 0-54-38.3-100.3-91.3-110.5l-74.7-14.4-98-98 0-94.1zm64 88a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faUpFromDottedLine = {
  prefix: 'fass',
  iconName: 'up-from-dotted-line',
  icon: [384, 512, [], "e456", "M192-10.9l-192 202.9 128 0 0 192 128 0 0-192 128 0-192-202.9zM0 448l0 64 64 0 0-64-64 0zm170.7 0l-64 0 0 64 64 0 0-64zm42.7 0l0 64 64 0 0-64-64 0zM384 448l-64 0 0 64 64 0 0-64z"]
};
var faFaceHeadBandage = {
  prefix: 'fass',
  iconName: 'face-head-bandage',
  icon: [576, 512, [], "e37a", "M288.1 0c-74.4 0-141.4 31.8-188.2 82.4-16.7 3.3-33.2 7.2-49.7 11.2-62.1 90.7-66 213.5-10.8 307.7l20.2-29.9c42.2 83.4 128.7 140.5 228.5 140.5 141.4 0 256-114.6 256-256 0-8.2-.4-16.4-1.1-24.4l32.8 9.9C570.9 142.8 513.6 51.4 427 3.6 407.3 6.1 387.7 8.8 368.3 12.8 343.1 4.5 316.1 0 288.1 0zm12.6 64.1c38.3-13 78.3-22.3 119.5-27.4 20.8 12.6 39.7 28 56.1 45.8-56.9-11.3-115.6-17.6-175.6-18.4zM39.1 196.4c6.4-26.8 17-51.9 31-74.7 142.6-34.3 293.4-34.3 436 0 14.1 22.8 24.6 47.9 31 74.7-161.4-48.5-336.6-48.5-498.1 0zm137 43.9c13.6-10.9 27.7-21.1 42.4-30.6 12.6 4.3 21.6 16.2 21.6 30.3 0 17.7-14.3 32-32 32-17.6 0-31.8-14.2-32-31.7zM50.5 226.4c41-12.2 83.3-21.3 126.6-27.1-51.6 37.5-96.5 83.8-132.2 136.7-9.4-28.7-13.7-59-12.6-89.2 5.9-7 12-13.8 18.2-20.5zM385.2 408.3c-25.6-23.3-52.8-40.3-89.1-40.3-17.7 0-33.8 4.8-50.5 10.1l-9.6-30.5c19.8-6.2 39.1-11.6 60.1-11.6 44.3 0 79 19.9 110.6 48.6l-21.5 23.7zM368.1 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSlashBack = {
  prefix: 'fass',
  iconName: 'slash-back',
  icon: [384, 512, [], "5c", "M20.5 20.1l15.9 27.8 256 448 15.9 27.8 55.6-31.8-15.9-27.8-256-448-15.9-27.8-55.6 31.8z"]
};
var faSimCards = {
  prefix: 'fass',
  iconName: 'sim-cards',
  icon: [448, 512, [], "e251", "M96-32l0 480 352 0 0-368-112-112-240 0zM48 160l-48 0 0 384 352 0 0-48-304 0 0-336zm112 64l112 0 0 56-112 0 0-56zm0 160l0-56 64 0 0 56-64 0zm224 0l-112 0 0-56 112 0 0 56zm0-160l0 56-64 0 0-56 64 0z"]
};
var faArrowLeftFromBracket = {
  prefix: 'fass',
  iconName: 'arrow-left-from-bracket',
  icon: [512, 512, [], "e668", "M22.6 233.4l-22.6 22.6 22.6 22.6 128 128 22.6 22.6 45.3-45.3c-6.6-6.6-38.6-38.6-96-96l229.5 0 0-64-229.5 0c57.4-57.4 89.4-89.4 96-96l-45.3-45.3-22.6 22.6-128 128zM352 416l-32 0 0 64 192 0 0-448-192 0 0 64 128 0 0 320-96 0z"]
};
var faUsbDrive = {
  prefix: 'fass',
  iconName: 'usb-drive',
  icon: [576, 512, [], "f8e9", "M368 96l-368 0 0 320 368 0 0-320zm208 32l-160 0 0 256 160 0 0-256zM496 232a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm24 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"]
};
var faHeadSideBrain = {
  prefix: 'fass',
  iconName: 'head-side-brain',
  icon: [512, 512, [], "f808", "M224 0C338.4 0 432.7 85.7 446.3 196.4l49.7 59.6 0 64-64 0 0 128-112 0 0 64-256 0 0-131.2C24.4 340.4 0 285 0 224 0 100.3 100.3 0 224 0zm16 64c-12.3 0-23.5 4.6-32 12.2-8.5-7.6-19.7-12.2-32-12.2-26.5 0-48 21.5-48 48-26.5 0-48 21.5-48 48s21.5 48 48 48c.7 0 1.3 0 2 0 7.1 27.6 32.2 48 62 48 35.3 0 64-28.7 64-64l48 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-18.7 0c-6.6-18.6-24.4-32-45.3-32z"]
};
var faGlassHalf = {
  prefix: 'fass',
  iconName: 'glass-half',
  icon: [384, 512, ["glass-half-empty", "glass-half-full"], "e192", "M81.7 224l-12.5-160 245.6 0-12.5 160-220.6 0zM40 512l304 0 35-448 5-64-384 0 40 512z"]
};
var faGlassHalfEmpty = faGlassHalf;
var faGlassHalfFull = faGlassHalf;
var faFaceGrimace = {
  prefix: 'fass',
  iconName: 'face-grimace',
  icon: [512, 512, [128556, "grimace"], "f57f", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 144c0 25.2-19.4 45.8-44 47.8l0-95.7c24.6 2 44 22.7 44 47.8zM276 304l40 0 0 96-40 0 0-96zm-80 96l0-96 40 0 0 96-40 0zm-40-95.8l0 95.7c-24.6-2-44-22.7-44-47.8s19.4-45.8 44-47.8z"]
};
var faGrimace = faFaceGrimace;
var faPanties = {
  prefix: 'fass',
  iconName: 'panties',
  icon: [576, 512, [], "e6d4", "M28.4 113.5L0 108.2 0 206.5c.4 .2 25.4 13.3 75 39.1 72 37.6 125.4 103 147.7 181.1 7.7 26.9 12.8 44.7 15.2 53.2l100.2 0c2.4-8.5 7.5-26.3 15.2-53.2 22.3-78.1 75.7-143.6 147.7-181.1 49.6-25.9 74.6-38.9 75-39.1l0-98.4-28.4 5.4C472.1 127.8 383.3 136 288 136s-184.1-8.2-259.6-22.5z"]
};
var faTrainSubway = {
  prefix: 'fass',
  iconName: 'train-subway',
  icon: [448, 512, ["subway"], "f239", "M416 0l-384 0 0 448 52.5 0c-41.3 51.7-62.7 78.3-64 80l61.5 0 64-80 156.1 0 64 80 61.5 0c-1.3-1.7-22.7-28.3-64-80l52.5 0 0-448zM200 96l0 160-104 0 0-160 104 0zm48 0l104 0 0 160-104 0 0-160zM128 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSubway = faTrainSubway;
var faFaceGlasses = {
  prefix: 'fass',
  iconName: 'face-glasses',
  icon: [512, 512, [], "e377", "M256 512c141.4 0 256-114.6 256-256 0-28-4.5-55-12.8-80.2-1 .1-2.1 .2-3.2 .2l0 144-200 0-6.4-4.8-32-24-1.6-1.2-1.6 1.2-32 24-6.4 4.8-200 0 0-144c-1.1 0-2.1-.1-3.2-.2-8.3 25.2-12.8 52.2-12.8 80.2 0 141.4 114.6 256 256 256zM56.1 96l159.9 0 6.4 4.8 32 24 1.6 1.2c18-18 28-28 30-30l169.8 0C408.9 37.5 336.8 0 256 0S103.1 37.5 56.1 96zM256 400c38.2 0 72-19.1 92.2-48.5l39.5 27.3C358.9 420.6 310.7 448 256 448s-102.9-27.4-131.8-69.2l39.5-27.3C184 380.9 217.8 400 256 400zM128 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-56-22.1l0 106.1 16 12 136 0 0-128-142.1 0-9.9 9.9zM64 272l136 0 16-12 0-104-16-12-136 0 0 128z"]
};
var faCloudDrizzle = {
  prefix: 'fass',
  iconName: 'cloud-drizzle',
  icon: [512, 512, [], "f738", "M96 320l-96 0 0-96c0-41.8 26.7-77.4 64-90.5L64 112c0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-416 0zm-8 48l0 96-48 0 0-96 48 0zm192 0l0 96-48 0 0-96 48 0zm192 0l0 96-48 0 0-96 48 0zM184 416l0 96-48 0 0-96 48 0zm192 0l0 96-48 0 0-96 48 0z"]
};
var faCircleDot = {
  prefix: 'fass',
  iconName: 'circle-dot',
  icon: [512, 512, [128280, "dot-circle"], "f192", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faDotCircle = faCircleDot;
var faObjectGroup = {
  prefix: 'fass',
  iconName: 'object-group',
  icon: [576, 512, [], "f247", "M0 128l0-128 128 0 0 32 320 0 0-32 128 0 0 128-32 0 0 256 32 0 0 128-128 0 0-32-320 0 0 32-128 0 0-128 32 0 0-256-32 0zM96 416l384 0 0-320-384 0 0 320zm48-272l160 0 0 128-160 0 0-128zM256 320l96 0 0-96 80 0 0 144-176 0 0-48z"]
};
var faUserPolice = {
  prefix: 'fass',
  iconName: 'user-police',
  icon: [448, 512, [], "e333", "M48 48l0-32 176-48 176 48 0 32-32 19.2 0 44.8s-5.8 2.8-16 6.7l0 25.3c0 70.7-57.3 128-128 128S96 214.7 96 144l0-25.3c-10.2-3.9-16-6.7-16-6.7L80 67.2 48 48zm176 96c-29.1 0-56.8-4.6-80-10.3l0 10.3c0 44.2 35.8 80 80 80s80-35.8 80-80l0-10.3c-23.2 5.7-50.9 10.3-80 10.3zm0 240l64-64 80 0 64 192-416 0 64-192 80 0 64 64zm0-360l-40 40 40 40 40-40-40-40zm80 440a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faShip = {
  prefix: 'fass',
  iconName: 'ship',
  icon: [640, 512, [128674], "f21a", "M416.4 0l-192 0 0 64-96 0 0 188.8-48 19.2 40.8 122.3c39.3-15.7 65.7-26.3 79.2-31.7 10.7 4.3 42.8 17.1 96 38.4l0-215.4-104 41.6 0-99.2 256 0 0 99.2-104-41.6 0 215.4c53.3-21.3 85.3-34.1 96-38.4 13.5 5.4 40 16 79.2 31.7l40.8-122.3-48-19.2 0-188.8-96 0 0-64zM209.3 417.7l-8.9-3.6-8.9 3.6-111.8 44.7c-29.3-9.8-50.1-16.7-62.4-20.8L2 487.2c11 3.7 34.6 11.5 70.8 23.6l8.3 2.8 8.2-3.3 111.1-44.4 111.1 44.4 8.9 3.6 8.9-3.6 111.1-44.4 111.1 44.4 8.2 3.3 8.3-2.8c36.2-12.1 59.8-19.9 70.8-23.6l-15.2-45.5c-12.4 4.1-33.2 11.1-62.4 20.8l-111.8-44.7-8.9-3.6-8.9 3.6-111.1 44.4-111.1-44.4z"]
};
var faC = {
  prefix: 'fass',
  iconName: 'c',
  icon: [384, 512, [99], "43", "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3 155.8 62.5 218.3 0l45.3 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8 221.3-87.5 308.8 0l-45.3 45.3z"]
};
var faSquarePhone = {
  prefix: 'fass',
  iconName: 'square-phone',
  icon: [448, 512, ["phone-square"], "f098", "M448 32l-448 0 0 448 448 0 0-448zM160 128l48.4 64-40.4 40c16.5 35.2 44.8 63.5 80 80l40-40.4 64 48.4-32 64-8 0C192.7 384 96 287.3 96 168l0-8 64-32z"]
};
var faPhoneSquare = faSquarePhone;
var faBoxTaped = {
  prefix: 'fass',
  iconName: 'box-taped',
  icon: [448, 512, ["box-alt"], "f49a", "M256 16l112 0 57.1 80-146.3 0-22.9-80zM160 144l0 80 128 0 0-80 160 0 0 336-448 0 0-336 160 0zm9.1-48L22.9 96 80 16 192 16 169.1 96z"]
};
var faBoxAlt = faBoxTaped;
var faRulerCombined = {
  prefix: 'fass',
  iconName: 'ruler-combined',
  icon: [448, 512, [], "f546", "M0 288l0 192 448 0 0-192-96 0 0 96-48 0 0-96-64 0 0 96-48 0 0-96-96 0 0-48 96 0 0-64-96 0 0-48 96 0 0-96-192 0 0 256z"]
};
var faBracketSquareRight = {
  prefix: 'fass',
  iconName: 'bracket-square-right',
  icon: [192, 512, [], "5d", "M192 32l-160 0 0 64 96 0 0 320-96 0 0 64 160 0 0-448z"]
};
var faLeafMaple = {
  prefix: 'fass',
  iconName: 'leaf-maple',
  icon: [576, 512, [127809], "f6f6", "M352 64l64 0-30.6 152.6 80.4-72.6 29.2 50.5 70.9 19-19 71 29.1 50.4-159.6 51.5 13.4 77.6-109.8-37.2 0 117.2-64 0 0-117.3-112 37.3 15.5-77.6-159.5-51.5 29.1-50.4-19-71 70.9-19 29.1-50.5 80.4 72.7-30.6-152.7 64 0 64-80 64 80z"]
};
var faArrowsRotate = {
  prefix: 'fass',
  iconName: 'arrows-rotate',
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M64.3 256c0-49.2 18.7-98.3 56.2-135.8S207.1 64 256.3 64c53 0 103.8 21 141.3 58.5l5.5 5.5-82.7 0 0 64 192 0 0-192-64 0 0 82.7-5.5-5.5C393.3 27.8 326.2 0 256.3 0 190.8 0 125.2 25 75.2 75S.3 190.5 .3 256l64 0zm.6 173.9l4.9 4.9c49.5 49.5 116.6 77.3 186.5 77.3 65.5 0 131-25 181-75s75-115.6 75-181l-64 0c0 49.2-18.7 98.3-56.2 135.8S305.4 448 256.3 448c-53 0-103.8-21-141.3-58.5l-5.5-5.5 82.7 0 0-64-192.3 0c0 5.7 .5 58.8 1.3 159.2l.3 32 64-.5-.7-80.8z"]
};
var faRefresh = faArrowsRotate;
var faSync = faArrowsRotate;
var faBenchTree = {
  prefix: 'fass',
  iconName: 'bench-tree',
  icon: [640, 512, [], "e2e7", "M384 416l-32 0 0 96-64 0 0-96-192 0 0 96-64 0 0-96-32 0 0-64 384 0 0 64zM512 0c53 0 96 43 96 96 0 5.1-.4 10.2-1.2 15.1 20.1 14.5 33.2 38.2 33.2 64.9l0 80-96 0 0 256-64 0 0-256-96 0 0-80c0-26.7 13.1-50.3 33.2-64.9-.8-4.9-1.2-10-1.2-15.1 0-53 43-96 96-96zM352 304l-320 0 0-112 320 0 0 112z"]
};
var faSquareRoot = {
  prefix: 'fass',
  iconName: 'square-root',
  icon: [576, 512, [8730], "f697", "M320 32l-24 0-6.7 23-91.2 312.5-74.5-127.7-9.3-15.9-114.4 0 0 64 77.6 0 102.7 176.1 9.3 15.9 42.4 0 6.7-23 105.3-361 232 0 0-64-256 0z"]
};
var faArrowDownTriangleSquare = {
  prefix: 'fass',
  iconName: 'arrow-down-triangle-square',
  icon: [512, 512, ["sort-shapes-down"], "f888", "M150.9 470.6l-22.6 22.6c-5.5-5.5-39.7-39.7-102.6-102.6L3 368 48.3 322.7c14.6 14.6 30.6 30.6 48 48l0-338.7 64 0 0 338.7c17.4-17.4 33.4-33.4 48-48L253.5 368 150.9 470.6zM384.3 32l112 192-224 0 112-192zm96 256l0 192-192 0 0-192 192 0z"]
};
var faSortShapesDown = faArrowDownTriangleSquare;
var faPersonDress = {
  prefix: 'fass',
  iconName: 'person-dress',
  icon: [384, 512, ["female"], "f182", "M136.2 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-11.4 88l134.8 0 9.6 13.2c74.3 102.4 111.5 153.6 111.7 153.9l-51.8 37.6c-9.1-12.6-28.5-39.2-57.9-79.8l49 147.1-48 0 0 160-64 0 0-160-32 0 0 160-64 0 0-160-48 0 49-147.1c-29.5 40.6-48.8 67.2-57.9 79.8l-51.8-37.6 18.8-25.9 92.9-128 9.6-13.2z"]
};
var faFemale = faPersonDress;
var faQuotes = {
  prefix: 'fass',
  iconName: 'quotes',
  icon: [576, 512, [], "e234", "M88 0C39.4 0 0 39.4 0 88l0 152 144 0 0-144-80 0 0-8c0-13.3 10.7-24 24-24l40 0 0-64-40 0zM264 0c-48.6 0-88 39.4-88 88l0 152 144 0 0-144-80 0 0-8c0-13.3 10.7-24 24-24l40 0 0-64-40 0zM488 512c48.6 0 88-39.4 88-88l0-152-144 0 0 144 80 0 0 8c0 13.3-10.7 24-24 24l-40 0 0 64 40 0zm-176 0c48.6 0 88-39.4 88-88l0-152-144 0 0 144 80 0 0 8c0 13.3-10.7 24-24 24l-40 0 0 64 40 0z"]
};
var faBookOpen = {
  prefix: 'fass',
  iconName: 'book-open',
  icon: [512, 512, [128214, 128366], "f518", "M256 141.3c16.3-6.8 32.9-13.7 49.7-20.7 39-16.2 80.8-24.6 123.1-24.6l19.2 0 0 320-19.2 0c-59.1 0-117.7 11.7-172.3 34.5l-.5 .2 0-309.3zM512 32l-83.2 0c-50.7 0-100.9 10-147.7 29.5L256 72 230.9 61.5C184.1 42 133.9 32 83.2 32L0 32 0 480 83.2 480c50.7 0 100.9 10 147.7 29.5L256 520 281.1 509.5c46.8-19.5 97-29.5 147.7-29.5l83.2 0 0-448z"]
};
var faFolderTree = {
  prefix: 'fass',
  iconName: 'folder-tree',
  icon: [576, 512, [], "f802", "M48 24l0-24-48 0 0 448 240 0 0-48-192 0 0-240 192 0 0-48-192 0 0-88zm528 8l-144 0-32-32-112 0 0 224 288 0 0-192zm0 288l-144 0-32-32-112 0 0 224 288 0 0-192z"]
};
var faObjectUnion = {
  prefix: 'fass',
  iconName: 'object-union',
  icon: [512, 512, [], "e49f", "M352 0l-352 0 0 352 160 0 0 160 352 0 0-352-160 0 0-160z"]
};
var faFileBinary = {
  prefix: 'fass',
  iconName: 'file-binary',
  icon: [384, 512, [], "e175", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM88 256l-24 0 0 160 128 0 0-160-104 0zm24 112l0-64 32 0 0 64-32 0zM248 256l-24 0 0 48 24 0 0 64-24 0 0 48 96 0 0-48-24 0 0-112-48 0z"]
};
var faBoxArchive = {
  prefix: 'fass',
  iconName: 'box-archive',
  icon: [512, 512, ["archive"], "f187", "M0 32l512 0 0 96-512 0 0-96zM32 176l448 0 0 304-448 0 0-304zm152 64l-24 0 0 48 192 0 0-48-168 0z"]
};
var faArchive = faBoxArchive;
var faChopsticks = {
  prefix: 'fass',
  iconName: 'chopsticks',
  icon: [640, 512, [], "e3f7", "M420.5 60.9L24.6 510.4 0 491 343.1 0 420.5 60.9zM576 61L640 135.6 149.4 512 129 488.2 576 61z"]
};
var faWaveformLines = {
  prefix: 'fass',
  iconName: 'waveform-lines',
  icon: [576, 512, ["waveform-path"], "f8f2", "M268 4l0 504-56 0 0-504 56 0zM460 68l0 376-56 0 0-376 56 0zM172 100l0 312-56 0 0-312 56 0zm192 32l0 248-56 0 0-248 56 0zM76 196l0 120-56 0 0-120 56 0zm480 0l0 120-56 0 0-120 56 0z"]
};
var faWaveformPath = faWaveformLines;
var faDown = {
  prefix: 'fass',
  iconName: 'down',
  icon: [448, 512, ["arrow-alt-down"], "f354", "M224 480l208-224-144 0 0-224-128 0 0 224-144 0 208 224z"]
};
var faArrowAltDown = faDown;
var faMessageArrowUp = {
  prefix: 'fass',
  iconName: 'message-arrow-up',
  icon: [512, 512, ["comment-alt-arrow-up"], "e1dc", "M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM273 143c57.2 57.2 86.8 86.8 89 89L328 265.9c-9-9-25-25-48-48l0 126.1-48 0 0-126.1c-23 23-39 39-48 48L150.1 232 256 126.1 273 143z"]
};
var faCommentAltArrowUp = faMessageArrowUp;
var faCircleDownLeft = {
  prefix: 'fass',
  iconName: 'circle-down-left',
  icon: [512, 512, [], "e107", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM184 352l169.9 0c-29.6-29.6-52.3-52.3-68-68 53-53 81-81 84-84-24.3-24.3-54.1-54.1-57.9-57.9-3 3-31 31-84 84-15.7-15.7-38.4-38.4-68-68l0 193.9 24 0z"]
};
var faObjectsAlignRight = {
  prefix: 'fass',
  iconName: 'objects-align-right',
  icon: [512, 512, [], "e3bf", "M512 512l-64 0 0-512 64 0 0 512zM384 64l0 160-384 0 0-160 384 0zm0 224l0 160-256 0 0-160 256 0z"]
};
var faHourglassClock = {
  prefix: 'fass',
  iconName: 'hourglass-clock',
  icon: [576, 512, [], "e41b", "M64 0l-32 0 0 64 32 0 0 77.3 9.4 9.4 105.4 105.4-105.4 105.4-9.4 9.4 0 77.3-32 0 0 64 244 0c-13.7-19-24-40.7-30-64l-118 0 0-50.7 96-96 29 29c8.1-20.8 19.7-39.8 34.1-56.4l-17.9-17.9 105.4-105.4 9.4-9.4 0-77.3 32 0 0-64-352 0zM320 64l0 50.7-96 96-96-96 0-50.7 192 0zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 320l0 64 48 0 0 32-80 0 0-96 32 0z"]
};
var faShutters = {
  prefix: 'fass',
  iconName: 'shutters',
  icon: [448, 512, [], "e449", "M448 32l-448 0 0 64 32 0-32 96 448 0-32-96 32 0 0-64zM0 336l448 0-32-96-384 0-32 96zM448 480l-32-96-384 0-32 96 448 0z"]
};
var faTentArrowDownToLine = {
  prefix: 'fass',
  iconName: 'tent-arrow-down-to-line',
  icon: [640, 512, [], "e57e", "M145.4 193l89-89-33.9-33.9-48 48 0-126.1-48 0 0 126.1c-23-23-39-39-48-48L22.5 104c2.1 2.1 31.8 31.8 89 89l17 17 17-17zm44.7 52.4l-25.7 202.7-132.1 0 0 64 576 0 0-64-29.7-202.7-195.4-117.3-193.1 117.3zM477.6 448l-94.3 0 0-160 94.3 160z"]
};
var faQrcode = {
  prefix: 'fass',
  iconName: 'qrcode',
  icon: [448, 512, [], "f029", "M64 96l0 64 64 0 0-64-64 0zM0 32l192 0 0 192-192 0 0-192zM64 352l0 64 64 0 0-64-64 0zM0 288l192 0 0 192-192 0 0-192zM384 96l-64 0 0 64 64 0 0-64zM320 32l128 0 0 192-192 0 0-192 64 0zm0 256l0 64 64 0 0-64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64 64 0 0-64-64 0 0-64 64 0z"]
};
var faCircleUserCircleMoon = {
  prefix: 'fass',
  iconName: 'circle-user-circle-moon',
  icon: [640, 512, [], "e7a2", "M496 208c-77.5 0-144.3 45.9-174.6 112l-145.4 0-23.9 71.6c34.8 34.8 82.8 56.4 135.9 56.4 7.4 0 14.6-.4 21.7-1.2 5.5 21.9 14.8 42.4 27.1 60.6-15.8 3-32.1 4.6-48.8 4.6-141.4 0-256-114.6-256-256S146.6 0 288 0c126.8 0 232.1 92.2 252.4 213.2-14.3-3.4-29.1-5.2-44.4-5.2zM288 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm64 128a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm227.2 47.9c-1.1 0-2.1 .1-3.2 .1-53 0-96-43-96-96 0-17.5 4.7-33.8 12.8-47.9-51.5 1.7-92.8 44-92.8 95.9 0 53 43 96 96 96 35.6 0 66.6-19.3 83.2-48.1z"]
};
var faDragon = {
  prefix: 'fass',
  iconName: 'dragon',
  icon: [640, 512, [128009], "f6d5", "M448 160l32 0 32 32 96 0 0-64-96-128-224 0 0 32 48 24-48 24 0 32 64 16 0 165.3 96 96 0 21.5-417.4 37.3-30.6 0 0 64 640 0 0-170.6-22.6-14.1-169.4-105.9 0-61.4zm64-87.7l0-.6c0 .1 0 .2 0 .3s0 .2 0 .3zm-1.3 7.4c-3.2 9.5-12.2 16.3-22.7 16.3-13.3 0-24-10.7-24-24 0-1.3 .1-2.6 .3-3.9l46.4 11.6zM160 96l-160 160 176-16-80 80 224 0 0-128-160-96z"]
};
var faHourglassEnd = {
  prefix: 'fass',
  iconName: 'hourglass-end',
  icon: [384, 512, [8987, "hourglass-3"], "f253", "M0 0l384 0 0 64-32 0 0 77.3-9.4 9.4-105.4 105.4 114.7 114.7 0 77.3 32 0 0 64-384 0 0-64 32 0 0-77.3 9.4-9.4 105.4-105.4-105.4-105.4-9.4-9.4 0-77.3-32 0 0-64zM96 64l0 50.7 96 96 96-96 0-50.7-192 0z"]
};
var faHourglass3 = faHourglassEnd;
var faGrip = {
  prefix: 'fass',
  iconName: 'grip',
  icon: [512, 512, [58119, "grid-horizontal", "grip-horizontal"], "f58d", "M128 96l0 128-128 0 0-128 128 0zM320 224l-128 0 0-128 128 0 0 128zm192 0l-128 0 0-128 128 0 0 128zm0 192l-128 0 0-128 128 0 0 128zM320 288l0 128-128 0 0-128 128 0zM128 416l-128 0 0-128 128 0 0 128z"]
};
var faGridHorizontal = faGrip;
var faGripHorizontal = faGrip;
var faBorderTopLeft = {
  prefix: 'fass',
  iconName: 'border-top-left',
  icon: [448, 512, ["border-style"], "f853", "M0 448l0 32 64 0 0-384 384 0 0-64-448 0 0 416zm192-32l-64 0 0 64 64 0 0-64zm128 0l-64 0 0 64 64 0 0-64zm64 64l64 0 0-64-64 0 0 64zm0-192l0 64 64 0 0-64-64 0zm0-64l64 0 0-64-64 0 0 64z"]
};
var faBorderStyle = faBorderTopLeft;
var faSignPost = {
  prefix: 'fass',
  iconName: 'sign-post',
  icon: [512, 512, [], "e624", "M224 0l64 0 0 64 144 0 80 96-80 96-144 0 0 256-64 0 0-256-192 0 0-192 192 0 0-64z"]
};
var faListUl = {
  prefix: 'fass',
  iconName: 'list-ul',
  icon: [512, 512, ["list-dots"], "f0ca", "M48 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64l-32 0 0 64 352 0 0-64-320 0zm0 160l-32 0 0 64 352 0 0-64-320 0zm0 160l-32 0 0 64 352 0 0-64-320 0zM48 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM96 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faListDots = faListUl;
var faBookSection = {
  prefix: 'fass',
  iconName: 'book-section',
  icon: [448, 512, ["book-law"], "e0c1", "M0 0l448 0 0 384-32 0 0 64 32 0 0 64-448 0 0-512zM64 416l0 32 288 0 0-64-256 0c-17.7 0-32 14.3-32 32zM192 76c-28.7 0-52 23.3-52 52 0 12.1 4.1 23.2 11 32-6.9 8.8-11 19.9-11 32 0 28.7 23.3 52 52 52l64 0c6.6 0 12 5.4 12 12s-5.4 12-12 12l-108 0 0 40 108 0c28.7 0 52-23.3 52-52 0-12.1-4.1-23.2-11-32 6.9-8.8 11-19.9 11-32 0-28.7-23.3-52-52-52l-64 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l108 0 0-40-108 0zm32 128l-32 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l64 0c6.6 0 12 5.4 12 12s-5.4 12-12 12l-32 0z"]
};
var faBookLaw = faBookSection;
var faPeopleRobbery = {
  prefix: 'fass',
  iconName: 'people-robbery',
  icon: [576, 512, [], "e536", "M80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM40 128l-32 0 0 192 0 0 0 192 64 0 0-160 16 0 0 160 64 0 0-259.3c9.2 14.6 16.7 26.3 22.4 35.3l97.6 0 0-64-62.4 0-51.5-81.1-9.4-14.9-108.7 0zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM273.1 168.2l6.3 23.8 48.6 0 0 320 64 0 0-160 16 0 0 160 64 0 0-320 48.6 0 6.3-23.8c25.3-94.9 38.7-145.2 40.2-150.9L505.3 .8C502.7 10.6 491.4 53 471.4 128l-63.4 0 0 0-16 0 0 0-63.4 0C308.6 52.9 297.3 10.6 294.7 .8L232.8 17.3c1.5 5.8 15 56.1 40.2 150.9z"]
};
var faShirtTankTop = {
  prefix: 'fass',
  iconName: 'shirt-tank-top',
  icon: [384, 512, [], "e3c9", "M112 32l0-32-64 0 0 128-48 128 0 256 384 0 0-256-48-128 0-128-64 0 0 80c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48z"]
};
var faSteeringWheel = {
  prefix: 'fass',
  iconName: 'steering-wheel',
  icon: [512, 512, [], "f622", "M176 320l36.9 123.2C140.5 426.6 83.6 368.9 68.2 296L176 320zM256 64c71.1 0 133.1 38.6 166.3 96L89.7 160c33.2-57.4 95.2-96 166.3-96zm80 256l107.8-24c-15.5 72.9-72.3 130.5-144.8 147.1L336 320zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faMagnifyingGlassWaveform = {
  prefix: 'fass',
  iconName: 'magnifying-glass-waveform',
  icon: [576, 512, [], "e661", "M448.3 208c0 45.9-14.9 88.3-40 122.7L534.9 457.4 557.5 480 512.3 525.3 489.6 502.6 363 376c-34.4 25.2-76.8 40-122.7 40-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208zm-184-88l0-24-48 0 0 224 48 0 0-200zm-88 32l0-24-48 0 0 160 48 0 0-136zm176 32l0-24-48 0 0 96 48 0 0-72z"]
};
var faAlarmPlus = {
  prefix: 'fass',
  iconName: 'alarm-plus',
  icon: [512, 512, [], "f844", "M492.3 153.2c-32.2-56.4-84-100.1-146.1-121.9 17.4-19.2 42.6-31.3 70.6-31.3 52.6 0 95.2 42.6 95.2 95.2 0 21.8-7.3 41.9-19.7 58zm-472.6 0C7.3 137.2 0 117.1 0 95.2 0 42.6 42.6 0 95.2 0 123.2 0 148.4 12.1 165.8 31.3 103.7 53.1 51.9 96.9 19.7 153.2zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6C96.3 493 77 512.3 64 525.3L18.7 480C31.7 467 51 447.7 76.6 422.2 48.6 384.8 32 338.3 32 288 32 164.3 132.3 64 256 64S480 164.3 480 288c0 50.3-16.6 96.8-44.6 134.2l57.8 57.8-45.3 45.3-57.8-57.8zM232 384l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faWineGlassCrack = {
  prefix: 'fass',
  iconName: 'wine-glass-crack',
  icon: [320, 512, ["fragile"], "f4bb", "M64 0L37.8 0 32.6 25.7 3.2 173C1.1 183.5 0 194.2 0 205l0 3c0 77.4 55 142 128 156.8l0 115.2-96 0 0 64 256 0 0-64-96 0 0-115.2C265 350 320 285.4 320 208l0-3c0-10.7-1.1-21.4-3.2-32l-29.5-147.3-5.1-25.7-74.2 0 32 64-80 56 32 104-112-120 88-56-32-48-72 0z"]
};
var faFragile = faWineGlassCrack;
var faTransporter = {
  prefix: 'fass',
  iconName: 'transporter',
  icon: [640, 512, [], "e042", "M264 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-11.4 88l134.8 0 9.6 13.2c74.3 102.4 111.5 153.6 111.7 153.9l-51.8 37.6c-9.3-12.8-28.3-39-56.9-78.4l0 209.7-64 0 0-112-32 0 0 112-64 0 0-209.7c-28.6 39.4-47.6 65.6-56.9 78.4l-51.8-37.6 18.8-25.9 92.9-128 9.6-13.2zM336 496l144 0 0 48-320 0 0-48 176 0zM144 112l-48 16-16 48-16-48-48-16 48-16 16-48 16 48 48 16zM576 32l48 16-48 16-16 48-16-48-48-16 48-16 16-48 16 48z"]
};
var faMobileButton = {
  prefix: 'fass',
  iconName: 'mobile-button',
  icon: [384, 512, [], "f10b", "M368 0l-352 0 0 512 352 0 0-512zM192 464c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faArrowDownAZ = {
  prefix: 'fass',
  iconName: 'arrow-down-a-z',
  icon: [512, 512, ["sort-alpha-asc", "sort-alpha-down"], "f15d", "M150.9 470.6l-22.6 22.6c-5.5-5.5-39.7-39.7-102.6-102.6l-22.6-22.6 45.3-45.3 48 48 0-338.7 64 0 0 338.7c17.4-17.4 33.4-33.4 48-48L253.5 368c-5.5 5.5-39.7 39.7-102.6 102.6zM354.3 32l60 0 7.9 20.5 78.3 203.5-68.6 0-12.3-32-70.5 0-12.3 32-68.6 0 78.3-203.5 7.9-20.5zm30 100.3l-16.8 43.7 33.6 0-16.8-43.7zm64 155.7l32 0 0 45.3-82.7 82.7 82.7 0 0 64-192 0 0-45.3 82.7-82.7-82.7 0 0-64 160 0z"]
};
var faSortAlphaAsc = faArrowDownAZ;
var faSortAlphaDown = faArrowDownAZ;
var faGlassCitrus = {
  prefix: 'fass',
  iconName: 'glass-citrus',
  icon: [576, 512, [], "f869", "M512 80c0-44.2-35.8-80-80-80-18 0-34.6 6-48 16l-81 0c23.6-47.4 72.5-80 129-80 79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4l0-67.1c28.3-12.3 48-40.5 48-73.3zM64 64l352 0 0 448-352 0 0-448zm64 64l0 128 224 0 0-128-224 0z"]
};
var faPool8Ball = {
  prefix: 'fass',
  iconName: 'pool-8-ball',
  icon: [512, 512, [], "e3c5", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-464a136 136 0 1 1 0 272 136 136 0 1 1 0-272zm0 72a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm43.8 50.9c7.7-9.6 12.2-21.7 12.2-34.9 0-30.9-25.1-56-56-56s-56 25.1-56 56c0 13.2 4.6 25.4 12.2 34.9-10.1 10.7-16.2 25.2-16.2 41.1 0 33.1 26.9 60 60 60s60-26.9 60-60c0-15.9-6.2-30.3-16.2-41.1zM256 232a20 20 0 1 1 0-40 20 20 0 1 1 0 40z"]
};
var faArrowDownSquareTriangle = {
  prefix: 'fass',
  iconName: 'arrow-down-square-triangle',
  icon: [512, 512, ["sort-shapes-down-alt"], "f889", "M150.9 470.6l-22.6 22.6c-5.5-5.5-39.7-39.7-102.6-102.6L3 368 48.3 322.7c14.6 14.6 30.6 30.6 48 48l0-338.7 64 0 0 338.7c17.4-17.4 33.4-33.4 48-48L253.5 368c-5.5 5.5-39.7 39.7-102.6 102.6zM288.3 32l192 0 0 192-192 0 0-192zm96 256l112 192-224 0 112-192z"]
};
var faSortShapesDownAlt = faArrowDownSquareTriangle;
var faRepeat1 = {
  prefix: 'fass',
  iconName: 'repeat-1',
  icon: [512, 512, [128258], "f365", "M352 128l0 80 24 0 112-112-112-112-24 0 0 80-352 0 0 224 64 0 0-160 288 0zM160 528l0-80 352 0 0-224-64 0 0 160-288 0 0-80-24 0-112 112 112 112 24 0zm64-288l16 0 0 80 48 0 0-128-72 0 0 48 8 0z"]
};
var faTransporter2 = {
  prefix: 'fass',
  iconName: 'transporter-2',
  icon: [640, 512, [], "e044", "M264 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-11.4 88l134.8 0 9.6 13.2 83.3 114.8-320.6 0 83.3-114.8 9.6-13.2zM336 496l144 0 0 48-320 0 0-48 176 0zM160 288l336 0 0 32-352 0 0-32 16 0zm80 64l176 0 0 32-192 0 0-32 16 0zm0 64l176 0 0 32-192 0 0-32 16 0zM144 48l-48 16-16 48-16-48-48-16 48-16 16-48 16 48 48 16zM576 352l48 16-48 16-16 48-16-48-48-16 48-16 16-48 16 48z"]
};
var faStarChristmas = {
  prefix: 'fass',
  iconName: 'star-christmas',
  icon: [512, 512, [], "f7d4", "M0 256l192 64 64 192 64-192 192-64-192-64-64-192-64 192-192 64zM54.1 88c6.1 6.1 27.8 27.8 65 65l17 17 33.9-33.9c-6.1-6.1-27.8-27.8-65-65L88 54.1 54.1 88zm403.9 0L424 54.1c-6.1 6.1-27.8 27.8-65 65l-17 17 33.9 33.9c6.1-6.1 27.8-27.8 65-65l17-17zM441 407c-37.2-37.2-58.8-58.8-65-65L342.1 376c6.1 6.1 27.8 27.8 65 65l17 17 33.9-33.9-17-17zM54.1 424L88 457.9c6.1-6.1 27.8-27.8 65-65l17-17-33.9-33.9c-6.1 6.1-27.8 27.8-65 65l-17 17z"]
};
var faMobileRotateReverse = {
  prefix: 'fass',
  iconName: 'mobile-rotate-reverse',
  icon: [640, 512, [], "e814", "M37.5 320L256 538.5 602.5 192 384-26.5 37.5 320zM464 416l55.5 0c-4 36-34.5 64-71.5 64-18.3 0-35-6.9-47.8-18.2l-34.1 34c21.4 20 50.2 32.2 81.8 32.2 63.6 0 115.6-49.5 119.7-112l56.3 0-80-80-80 80zM266 392L232 425.9 150.1 344 184 310.1 266 392zM192-16C128.4-16 76.4 33.5 72.3 96l-56.3 0 80 80 80-80-55.5 0c4-36 34.5-64 71.5-64 18.3 0 35 6.9 47.8 18.2l34.1-34C252.4-3.7 223.6-16 192-16z"]
};
var faClawMarks = {
  prefix: 'fass',
  iconName: 'claw-marks',
  icon: [576, 512, [], "f6c2", "M166.7 313.4l9.4 9.3 0 45.3 45.3 0 108.8 108.8-45.2 45.3-90-90-82.8 0 0-82.8-90.1-90.1 45.2-45.3 99.4 99.4zm32-192l9.4 9.3 0 45.3 45.3 0 137.4 137.4 9.4 9.3 0 45.3 45.3 0 108.8 108.8-45.2 45.3-90-90-82.8 0 0-82.8-109.2-109.2-82.8 0 0-82.7-122.1-122.1 45.2-45.2 131.4 131.4zm128-96l9.4 9.3 0 45.3 45.3 0 73.4 73.4 9.4 9.3 0 45.3 45.3 0 44.8 44.8-45.2 45.3-26-26-82.8 0 0-82.8-45.2-45.3-82.8 0 0-82.7-26.1-26.1 45.3-45.2 35.4 35.4z"]
};
var faLightbulbOn = {
  prefix: 'fass',
  iconName: 'lightbulb-on',
  icon: [640, 512, [], "f672", "M512 192c0 71.1-38.6 133.1-96 166.3l0 25.7-192 0 0-25.7C166.6 325.1 128 263.1 128 192 128 86 214 0 320 0S512 86 512 192zM224 528l0-96 192 0 0 96-192 0zm16-344c0-39.8 32.2-72 72-72l8 0 0-48-8 0c-66.3 0-120 53.7-120 120l0 8 48 0 0-8zM58.7 26.5l53.5 26.7-21.5 42.9C60.3 81 19.5 60.6 15.8 58.7L37.3 15.8 58.7 26.5zm544 42.9C579.6 81 561.8 89.9 549.3 96.2L527.8 53.3C558.2 38 599 17.7 602.7 15.8l21.5 42.9-21.5 10.7zM24 168l56 0 0 48-80 0 0-48 24 0zm560 0l56 0 0 48-80 0 0-48 24 0zM90.7 341.5C67.6 353 49.8 361.9 37.3 368.2L15.8 325.3C46.2 310 87 289.7 90.7 287.8l21.5 42.9-21.5 10.7zm458.5-53.7l74.9 37.5-21.5 42.9-74.9-37.5 21.5-42.9z"]
};
var faMoneyBill = {
  prefix: 'fass',
  iconName: 'money-bill',
  icon: [512, 512, [], "f0d6", "M512 64l-512 0 0 384 512 0 0-384zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm192 32c-35.3 0-64-28.7-64-64l64 0 0 64zM64 320c35.3 0 64 28.7 64 64l-64 0 0-64zm64-192c0 35.3-28.7 64-64 64l0-64 64 0zM384 384c0-35.3 28.7-64 64-64l0 64-64 0z"]
};
var faMessagesDollar = {
  prefix: 'fass',
  iconName: 'messages-dollar',
  icon: [576, 512, ["comments-alt-dollar"], "f652", "M384-32l-384 0 0 336 96 0 0 80 112-80 176 0 0-336zM192 374.4l0 89.6 176 0 112 80 0-80 96 0 0-336-144 0 0 224-208.6 0-31.4 22.4zM216 24l0 24 28 0 0 40-67.5 0c-6.9 0-12.5 5.6-12.5 12.5 0 6.1 4.4 11.3 10.4 12.3l41.7 7c25.3 4.2 43.9 26.1 43.9 51.8 0 26.1-19 47.7-44 51.8l0 24.7-40 0 0-24-44 0 0-40 75.5 0c6.9 0 12.5-5.6 12.5-12.5 0-6.1-4.4-11.3-10.4-12.3l-41.7-7c-25.3-4.2-43.9-26.1-43.9-51.8 0-28.8 23.2-52.2 52-52.5l0-24 40 0z"]
};
var faCommentsAltDollar = faMessagesDollar;
var faUserChefHairLong = {
  prefix: 'fass',
  iconName: 'user-chef-hair-long',
  icon: [448, 512, [], "e7a9", "M64 32c0 20.9 13.4 38.7 32 45.3l0 98.7-48 96 352 0-48-96 0-98.7c18.6-6.6 32-24.4 32-45.3 0-26.5-21.5-48-48-48-14.3 0-27.2 6.3-36 16.3-8.8-10-21.7-16.3-36-16.3-16.7 0-31.4 8.5-40 21.5-8.6-12.9-23.3-21.5-40-21.5-14.3 0-27.2 6.3-36 16.3-8.8-10-21.7-16.3-36-16.3-26.5 0-48 21.5-48 48zM304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16 160 0 0 16zM275.8 320l-147.8 73.9 0 118.1 304 0-64-192-92.2 0zm-71.6 0l-124.2 0-64 192 80 0 0-137.9 8.8-4.4 99.4-49.7zM280 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCroissant = {
  prefix: 'fass',
  iconName: 'croissant',
  icon: [512, 512, [129360], "f7f6", "M243.2 .3c4.2-.2 8.5-.3 12.8-.3 62.1 0 118.9 22.1 163.3 58.8L314.6 163.4 243.2 .3zM194 7.6L307.4 266.6 267.3 306.8 12 178.3C38.8 94.2 107.7 29 194 7.6zM1.6 226.8l166 83.6-108.9 108.9C22.1 374.9 0 318.1 0 256 0 246.1 .6 236.4 1.6 226.8zM92.7 453.2l120.1-120.1 11.2 5.6 0 171.3c-49.5-6.2-94.7-26.5-131.3-56.8zM341.2 224l-5.9-13.4 117.9-117.9c30.3 36.6 50.6 81.7 56.8 131.3l-168.8 0z"]
};
var faFileUser = {
  prefix: 'fass',
  iconName: 'file-user',
  icon: [384, 512, [], "f65c", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM192 344a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM293.3 448l-21.3-64-160 0-21.3 64 202.7 0z"]
};
var faArrowTurnRight = {
  prefix: 'fass',
  iconName: 'arrow-turn-right',
  icon: [576, 512, [], "e635", "M96.3 416l0 32-64 0 0-224 402.7 0c-57.4-57.4-89.4-89.4-96-96l45.3-45.3 22.6 22.6 128 128 22.6 22.6-173.3 173.3-45.3-45.3 96-96-338.7 0 0 128z"]
};
var faBorderTop = {
  prefix: 'fass',
  iconName: 'border-top',
  icon: [448, 512, [], "f855", "M448 32l-448 0 0 64 448 0 0-64zM64 160l-64 0 0 64 64 0 0-64zM384 416l0 64 64 0 0-64-64 0zm64-128l-64 0 0 64 64 0 0-64zM384 160l0 64 64 0 0-64-64 0zM64 288l-64 0 0 64 64 0 0-64zM0 416l0 64 64 0 0-64-64 0zm192 0l-64 0 0 64 64 0 0-64zm64 0l0 64 64 0 0-64-64 0z"]
};
var faCircleMinus = {
  prefix: 'fass',
  iconName: 'circle-minus',
  icon: [512, 512, ["minus-circle"], "f056", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM168 232l200 0 0 48-224 0 0-48 24 0z"]
};
var faMinusCircle = faCircleMinus;
var faArrowPointer = {
  prefix: 'fass',
  iconName: 'arrow-pointer',
  icon: [512, 512, ["mouse-pointer"], "f245", "M96.3-24l38.4 28.8 307.2 230.3 57.6 43.2-216.3 0 93.7 187.3 14.3 28.6-57.2 28.6-14.3-28.6-93.7-187.3C161.1 393.6 117.8 451.2 96.3 480l0-504z"]
};
var faMousePointer = faArrowPointer;
var faSquareShareNodes = {
  prefix: 'fass',
  iconName: 'square-share-nodes',
  icon: [448, 512, ["share-alt-square"], "f1e1", "M448 32l-448 0 0 448 448 0 0-448zM368 160c0 35.3-28.7 64-64 64-15.4 0-29.5-5.4-40.6-14.5l-85.3 46.5 85.3 46.5c11-9.1 25.2-14.5 40.6-14.5 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L158.5 300c-11.7 12.3-28.2 20-46.5 20-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3 0-35.3 28.7-64 64-64s64 28.7 64 64z"]
};
var faShareAltSquare = faSquareShareNodes;
var faBorderOuter = {
  prefix: 'fass',
  iconName: 'border-outer',
  icon: [448, 512, [], "f851", "M64 96l0 320 320 0 0-320-320 0zM0 32l448 0 0 448-448 0 0-448zm248 96l0 48-48 0 0-48 48 0zM96 232l48 0 0 48-48 0 0-48zm152 0l0 48-48 0 0-48 48 0zm56 0l48 0 0 48-48 0 0-48zM248 336l0 48-48 0 0-48 48 0z"]
};
var faArrowDownRight = {
  prefix: 'fass',
  iconName: 'arrow-down-right',
  icon: [448, 512, [], "e093", "M384.3 448l32 0 0-288-64 0 0 178.7-265.4-265.4-22.6-22.6-45.3 45.3 22.6 22.6 265.4 265.4-178.7 0 0 64 256 0z"]
};
var faTableCellsLarge = {
  prefix: 'fass',
  iconName: 'table-cells-large',
  icon: [448, 512, ["th-large"], "f009", "M384 96l-128 0 0 128 128 0 0-128zm64 128l0 256-448 0 0-448 448 0 0 192zM64 288l0 128 128 0 0-128-128 0zm128-64l0-128-128 0 0 128 128 0zm64 64l0 128 128 0 0-128-128 0z"]
};
var faThLarge = faTableCellsLarge;
var faCircleUserCircleMinus = {
  prefix: 'fass',
  iconName: 'circle-user-circle-minus',
  icon: [640, 512, [], "e7a1", "M496 208c-77.5 0-144.3 45.9-174.6 112l-145.4 0-23.9 71.6c34.8 34.8 82.8 56.4 135.9 56.4 7.4 0 14.6-.4 21.7-1.2 5.5 21.9 14.8 42.4 27.1 60.6-15.8 3-32.1 4.6-48.8 4.6-141.4 0-256-114.6-256-256S146.6 0 288 0c126.8 0 232.1 92.2 252.4 213.2-14.3-3.4-29.1-5.2-44.4-5.2zM288 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm64 128a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16l0-32-160 0 0 32 160 0z"]
};
var faCloudPlus = {
  prefix: 'fass',
  iconName: 'cloud-plus',
  icon: [576, 512, [], "e35e", "M144 480l432 0 0-128c0-47.4-25.7-88.7-64-110.9l0-49.1c0-53-43-96-96-96-17.7 0-34.2 4.8-48.4 13.1-24.1-45.8-72.2-77.1-127.6-77.1-79.5 0-144 64.5-144 144l0 24.2C40.1 220 0 273.3 0 336l0 144 144 0zm120-96l0-72-72 0 0-48 72 0 0-72 48 0 0 72 72 0 0 48-72 0 0 72-48 0z"]
};
var faCat = {
  prefix: 'fass',
  iconName: 'cat',
  icon: [576, 512, [128008], "f6be", "M64 96c53 0 96 43 96 96l0 85.8c29.7-44.7 77.8-76.3 133.4-84 25.6 60 85.2 102.1 154.6 102.1 10.9 0 21.6-1.1 32-3.1l0 219.1-64 0 0-172.8-136 108.8 88 0 0 64-272 0 0-320c0-17.7-14.3-32-32-32l-32 0 0-64 32 0zm496 32c0 61.9-50.1 112-112 112S336 189.9 336 128l0-146.7 80 66.7 64 0 80-66.7 0 146.7zM400 108a20 20 0 1 0 0 40 20 20 0 1 0 0-40zm96 0a20 20 0 1 0 0 40 20 20 0 1 0 0-40z"]
};
var faCalendarWeek = {
  prefix: 'fass',
  iconName: 'calendar-week',
  icon: [448, 512, [], "f784", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 64 0zM384 256l-320 0 0 128 320 0 0-128z"]
};
var faSpine = {
  prefix: 'fass',
  iconName: 'spine',
  icon: [448, 512, [], "e761", "M32 0l384 0 0 32 32 0 0 64-32 0 0 32-384 0 0-32-32 0 0-64 32 0 0-32zm0 176l384 0 0 48 32 0 0 64-32 0 0 48-384 0 0-48-32 0 0-64 32 0 0-48zM416 384l0 32 32 0 0 64-32 0 0 32-384 0 0-32-32 0 0-64 32 0 0-32 384 0z"]
};
var faScannerImage = {
  prefix: 'fass',
  iconName: 'scanner-image',
  icon: [576, 512, [], "f8f3", "M78.5 46.7l-28.5-14.5-29.1 57 28.5 14.5 361.4 184.3-410.8 0 0 192 576 0 0-179.6-17.5-8.9-480-244.8zM64 352l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0z"]
};
var faTRex = {
  prefix: 'fass',
  iconName: 't-rex',
  icon: [640, 512, [], "e629", "M112 288l-32 0-32-96-16 0-6.3 9.4C9 226.6 0 256.1 0 286.4 0 358 58 416 129.6 416l54.4 0 72 96 128 0 0-16c0-26.5-21.5-48-48-48l-18.6-49.6 41.9-37.7 8.7-8.7 0-32c0-35.3-28.7-64-64-64l-32 0 0-32 32 0c34.8 0 65.3 18.5 82.1 46.3l45.9 30.6 0 43.2 48 0 0-68.8c-1.5-1-19.9-13.2-55.1-36.7l39.1-30.4 112 0 21.3-32-48.6 0-2.3-2.3-29.7-29.7-36.7 0 0-16 43.3 0 2.3 2.3 29.7 29.7 84.7 0 0-48c0-44.2-35.8-80-80-80l-16 0-16-32-88 0 0 0c-33.5 .1-63.2 21.6-73.8 53.4l-14.2 42.6-32 32-41 0c-70.7 0-132.9 46.3-153.3 114L112 288zM480 56a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faPipe = {
  prefix: 'fass',
  iconName: 'pipe',
  icon: [64, 512, [], "7c", "M64 0L64 512 0 512 0 0 64 0z"]
};
var faArrowUpToBracket = {
  prefix: 'fass',
  iconName: 'arrow-up-to-bracket',
  icon: [448, 512, [], "e66a", "M246.6 169.4l-22.6-22.6-22.6 22.6-128 128-22.6 22.6 45.3 45.3c6.6-6.6 38.6-38.6 96-96l0 242.7 64 0 0-242.7 96 96 45.3-45.3-22.6-22.6-128-128zM64 160l0-96 320 0 0 128 64 0 0-192-448 0 0 192 64 0 0-32z"]
};
var faSigma = {
  prefix: 'fass',
  iconName: 'sigma',
  icon: [384, 512, [8721], "f68b", "M0 480l384 0 0-128-64 0 0 64-210.7 0 137.4-137.4 22.6-22.6-22.6-22.6-137.4-137.4 210.7 0 0 64 64 0 0-128-384 0 0 45.3 9.4 9.4 169.4 169.4-169.4 169.4-9.4 9.4 0 45.3z"]
};
var faKeyboardDown = {
  prefix: 'fass',
  iconName: 'keyboard-down',
  icon: [576, 512, [], "e1c2", "M16 0l544 0 0 384-544 0 0-384zM64 64l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm32 96l0 64 256 0 0-64-256 0zM224 64l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zM320 64l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zM416 64l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zM512 64l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zM248 432l137.9 0c-65.6 65.6-96.8 96.8-97.9 97.9-17.6-17.6-84.8-84.8-97.9-97.9l57.9 0z"]
};
var faArrowDownToArc = {
  prefix: 'fass',
  iconName: 'arrow-down-to-arc',
  icon: [512, 512, [], "e4ae", "M256 448c106 0 192-86 192-192l0-32 64 0 0 32c0 141.4-114.6 256-256 256S0 397.4 0 256l0-32 64 0 0 32c0 106 86 192 192 192zM366.6 254.6c-69.6 69.6-106.4 106.4-110.6 110.6-4.2-4.2-41.1-41.1-110.6-110.6L122.7 232 168 186.7c13.3 13.3 32 32 56 56l0-242.7 64 0 0 242.7c24-24 42.7-42.7 56-56l45.3 45.3-22.6 22.6z"]
};
var faCodeCompare = {
  prefix: 'fass',
  iconName: 'code-compare',
  icon: [512, 512, [], "e13a", "M192-17.9l0 65.9-32 0c-53 0-96 43-96 96l0 208-48 0 0 160 160 0 0-160-48 0 0-208c0-17.7 14.3-32 32-32l32 0 0 65.9c27.5-27.5 54.5-54.5 81-81l17-17C272.3 62.4 205.1-4.8 192-17.9zM440 56l0 48-48 0 0-48 48 0zM496 0l-160 0 0 160 48 0 0 208c0 17.7-14.3 32-32 32l-32 0 0-65.9c-65.6 65.6-96.8 96.8-97.9 97.9 17.6 17.6 84.8 84.8 97.9 97.9l0-65.9 32 0c53 0 96-43 96-96l0-208 48 0 0-160zM120 408l0 48-48 0 0-48 48 0z"]
};
var faAlarmMinus = {
  prefix: 'fass',
  iconName: 'alarm-minus',
  icon: [512, 512, [], "e803", "M256 64c123.7 0 224 100.3 224 224 0 50.3-16.6 96.8-44.6 134.2l57.8 57.8-45.3 45.3-57.8-57.8C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.2-44.6L64 525.3 18.8 480 76.6 422.2C48.6 384.8 32 338.3 32 288 32 164.3 132.3 64 256 64zM160 264l0 48 192 0 0-48-192 0zM95.2 0C123.2 0 148.4 12.1 165.8 31.3 103.7 53.1 51.9 96.9 19.7 153.2 7.3 137.2 0 117.1 0 95.2 0 42.6 42.6 0 95.2 0zM416.7 0c52.6 0 95.3 42.6 95.3 95.2 0 21.8-7.3 41.9-19.7 58-32.2-56.4-84-100.1-146.2-121.9 17.4-19.2 42.6-31.3 70.6-31.3z"]
};
var faWand = {
  prefix: 'fass',
  iconName: 'wand',
  icon: [512, 512, [], "f72a", "M80 512l-80-80 128-115.2 0-60.8 67.6 0 284.4-256 32 32-96 106.7 0 53.3-48 0-288 320z"]
};
var faMeterBolt = {
  prefix: 'fass',
  iconName: 'meter-bolt',
  icon: [640, 512, [], "e1e9", "M320 512c19.7 0 38.9-2.2 57.3-6.4l6.1-25.6-79.4 0 0-100.5 242.2-203.5 17 0C529.7 73.8 433.4 0 320 0 178.6 0 64 114.6 64 256S178.6 512 320 512zM440 152l0 72-48 0 0-96 48 0 0 24zm-96-24l0 96-48 0 0-96 48 0zm-96 24l0 72-48 0 0-96 48 0 0 24zM360 416l104.4 0-32.4 136 200-168-104.4 0 32.4-136-200 168z"]
};
var faArrowsRotateReverse = {
  prefix: 'fass',
  iconName: 'arrows-rotate-reverse',
  icon: [512, 512, [], "e630", "M448.3 256c0-49.2-18.7-98.3-56.2-135.8S305.4 64 256.3 64c-53 0-103.8 21-141.3 58.5l-5.5 5.5 82.7 0 0 64-192 0 0-192 64 0 0 82.7 5.5-5.5C119.2 27.8 186.3 0 256.3 0 321.7 0 387.3 25 437.3 75s75 115.6 75 181l-64 0zm-.6 173.9l-4.9 4.9c-49.5 49.5-116.6 77.3-186.5 77.3-65.5 0-131-25-181-75S.3 321.5 .3 256l64 0c0 49.2 18.7 98.3 56.2 135.8S207.1 448 256.3 448c53 0 103.8-21 141.3-58.5l5.5-5.5-82.7 0 0-64 192.3 0c0 5.7-.5 58.8-1.3 159.2l-.3 32-64-.5c.2-18.5 .4-45.5 .7-80.8z"]
};
var faScannerKeyboard = {
  prefix: 'fass',
  iconName: 'scanner-keyboard',
  icon: [512, 512, [], "f489", "M144-32l0 80-48 0 0-80 48 0zM416 288l-48 0 0-320 48 0 0 320zM320-32l0 80-32 0 0-80 32 0zm-64 0l0 80-64 0 0-80 64 0zm192 0l64 0 0 320-64 0 0-320zM0 96l320 0 0 416-320 0 0-416zM72 320l0 48 64 0 0-48-64 0zM256 160l-192 0 0 96 192 0 0-96zM72 400l0 48 64 0 0-48-64 0zm176-80l-64 0 0 48 64 0 0-48zm-64 80l0 48 64 0 0-48-64 0z"]
};
var faChessBishopPiece = {
  prefix: 'fass',
  iconName: 'chess-bishop-piece',
  icon: [320, 512, ["chess-bishop-alt"], "f43b", "M96 288L80.8 275c-25.9-22.2-40.8-54.6-40.8-88.7 0-27.3 9.6-53.8 27.1-74.8l52.9-63.5-32 0 0-48 144 0 0 48-32 0 31.8 38.2-81.8 81.8 33.9 33.9 78-78c11.7 18.6 18 40.2 18 62.3 0 34.1-14.9 66.5-40.8 88.7l-15.2 13 16 96 64 80 0 48-288 0 0-48 64-80 16-96z"]
};
var faChessBishopAlt = faChessBishopPiece;
var faFilePlusMinus = {
  prefix: 'fass',
  iconName: 'file-plus-minus',
  icon: [384, 512, [], "e177", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM216 240l0-24-48 0 0 48-48 0 0 48 48 0 0 48 48 0 0-48 48 0 0-48-48 0 0-24zM144 400l-24 0 0 48 144 0 0-48-120 0z"]
};
var faUnion = {
  prefix: 'fass',
  iconName: 'union',
  icon: [384, 512, [8899], "f6a2", "M64 32l0 256c0 70.7 57.3 128 128 128s128-57.3 128-128l0-256 64 0 0 256c0 106-86 192-192 192S0 394 0 288L0 32 64 32z"]
};
var faArrowUpBigSmall = {
  prefix: 'fass',
  iconName: 'arrow-up-big-small',
  icon: [512, 512, ["sort-size-up"], "f88e", "M150.6 41.4L128 18.7 25.4 121.4 2.7 144 48 189.3c14.6-14.6 30.6-30.6 48-48l0 338.7 64 0 0-338.7 48 48 45.3-45.3c-5.5-5.5-39.7-39.7-102.6-102.6zM288 32l0 224 224 0 0-224-224 0zm0 288l0 160 160 0 0-160-160 0z"]
};
var faSortSizeUp = faArrowUpBigSmall;
var faRoadCircleXmark = {
  prefix: 'fass',
  iconName: 'road-circle-xmark',
  icon: [640, 512, [], "e566", "M288 32L169.4 32 64 480 321.4 480c-11.2-24.4-17.4-51.4-17.4-80s6.2-55.6 17.4-80l-33.4 0 0-128 64 0 0 81c35.2-39.9 86.7-65 144-65 5.4 0 10.8 .2 16.2 .7l-41.6-176.7-118.6 0 0 96-64 0 0-96zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm55.3-176.7L518.6 400c25.4 25.3 40 40 44 44L540 466.6c-4-4-18.6-18.6-44-44-25.3 25.4-40 40-44 44L429.4 444c4-4 18.6-18.6 44-44-25.4-25.3-40-40-44-44L452 333.4c4 4 18.6 18.6 44 44 25.3-25.4 40-40 44-44l22.6 22.6-11.3 11.3z"]
};
var faCowbellCirclePlus = {
  prefix: 'fass',
  iconName: 'cowbell-circle-plus',
  icon: [576, 512, ["cowbell-more"], "f8b4", "M160-16l192 0 0 80 48 0 36 144c-1.3 0-2.7 0-4 0-106 0-192 86-192 192 0 5.4 .2 10.7 .7 16l-216.7 0 88-352 48 0 0-80zM284.4 522.8c-8.8 3.4-18.4 5.2-28.4 5.2-38.7 0-71-27.5-78.4-64l73.3 0c7.7 21.6 19.1 41.5 33.5 58.8zM304 32l-96 0 0 32 96 0 0-32zM432 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 64-64 0 0 32 64 0 0 64 32 0 0-64 64 0 0-32-64 0 0-48z"]
};
var faCowbellMore = faCowbellCirclePlus;
var faThoughtBubble = {
  prefix: 'fass',
  iconName: 'thought-bubble',
  icon: [512, 512, [], "e32e", "M256 0c-53.7 0-99.7 33.1-118.7 80L128 80C57.3 80 0 137.3 0 208S57.3 336 128 336l36.1 0c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48l36.1 0c70.7 0 128-57.3 128-128S454.7 80 384 80l-9.3 0c-19-46.9-65-80-118.7-80zM16 464l0 64 64 0 0-64-64 0zm184-56l-80 0 0 80 80 0 0-80z"]
};
var faPallet = {
  prefix: 'fass',
  iconName: 'pallet',
  icon: [576, 512, [], "f482", "M32 320l-32 0 0 64 64 0 0 64-64 0 0 64 576 0 0-64-64 0 0-64 64 0 0-64-544 0zm96 64l128 0 0 64-128 0 0-64zm192 0l128 0 0 64-128 0 0-64z"]
};
var faCircleBookOpen = {
  prefix: 'fass',
  iconName: 'circle-book-open',
  icon: [512, 512, ["book-circle"], "e0ff", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM141 144c32.9 0 65.4 7.5 95 22l0 208c-29.6-14.5-62.1-22-95-22l-29 0 0-208 29 0zM371 352c-32.9 0-65.4 7.5-95 22l0-208c29.6-14.5 62.1-22 95-22l29 0 0 208-29 0z"]
};
var faBookCircle = faCircleBookOpen;
var faVialVertical = {
  prefix: 'fass',
  iconName: 'vial-vertical',
  icon: [320, 512, [], "e762", "M16 0l288 0 0 64-32 0 0 336c0 61.9-50.1 112-112 112S48 461.9 48 400l0-336-32 0 0-64zm96 64l0 128 96 0 0-128-96 0z"]
};
var faPodiumStar = {
  prefix: 'fass',
  iconName: 'podium-star',
  icon: [448, 512, [], "f758", "M288 0l-112 0 0 24-96 0 0 120-64 0 0 48 36.2 0 27.8 320 288 0 27.8-320 36.2 0 0-48-304 0 0-72 48 0 0 24 112 0c26.5 0 48-21.5 48-48S314.5 0 288 0zM252.2 311.2l63.1 9.2-45.7 44.5 10.8 62.8-56.4-29.7-56.4 29.7 10.8-62.8-45.7-44.5 63.1-9.2 28.2-57.2 28.2 57.2z"]
};
var faBarProgressQuarter = {
  prefix: 'fass',
  iconName: 'bar-progress-quarter',
  icon: [512, 512, [], "e6a8", "M160 160l0 192 288 0 0-192-288 0zM0 96l512 0 0 320-512 0 0-320z"]
};
var faCakeCandles = {
  prefix: 'fass',
  iconName: 'cake-candles',
  icon: [448, 512, [127874, "birthday-cake", "cake"], "f1fd", "M96-16L63.9 28.9C58.8 36.1 56 44.8 56 53.6L56 56c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.4c0-8.8-2.8-17.5-7.9-24.6L96-16zm128 0L191.9 28.9c-5.1 7.2-7.9 15.8-7.9 24.6l0 2.4c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.4c0-8.8-2.8-17.5-7.9-24.6L224-16zm95.9 44.9c-5.1 7.2-7.9 15.8-7.9 24.6l0 2.4c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.4c0-8.8-2.8-17.5-7.9-24.6L352-16 319.9 28.9zM128 160l0-32-64 0 0 80-64 0 0 105.1 3.3 1.8 108.3 57.8 100.5-57.4 11.9-6.8 11.9 6.8 100.5 57.4 108.3-57.8 3.3-1.8 0-105.1-64 0 0-80-64 0 0 80-64 0 0-80-64 0 0 80-64 0 0-48zM448 367.5l-100.7 53.7-11.7 6.2-11.5-6.6-100.1-57.2-100.1 57.2-11.5 6.6-11.7-6.2-100.7-53.7 0 144.5 448 0 0-144.5z"]
};
var faBirthdayCake = faCakeCandles;
var faCake = faCakeCandles;
var faFaceExhaling = {
  prefix: 'fass',
  iconName: 'face-exhaling',
  icon: [640, 512, [], "e480", "M544 257.3l0-1.3C544 114.6 429.4 0 288 0S32 114.6 32 256 146.6 512 288 512c54.2 0 104.4-16.8 145.8-45.5l-.1-.6C402 458 374.7 451.2 352 445.5l0-90.9c22.7-5.7 50-12.5 81.7-20.4 8.4-44.5 47.4-78.1 94.3-78.1 5.5 0 10.8 .5 16 1.3zM248 400a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM356 232c0 11 9 20 20 20l16 0c11 0 20-9 20-20l0-16 40 0 0 16c0 33.1-26.9 60-60 60l-16 0c-33.1 0-60-26.9-60-60l0-16 40 0 0 16zM184 252l16 0c11 0 20-9 20-20l0-16 40 0 0 16c0 33.1-26.9 60-60 60l-16 0c-33.1 0-60-26.9-60-60l0-16 40 0 0 16c0 11 9 20 20 20zm389.3 84.1c-6.6-18.7-24.4-32.1-45.3-32.1-26.5 0-48 21.5-48 48 0 6.7 1.4 13.2 3.9 19l-83.9 21 0 16 83.9 21c-2.5 5.8-3.9 12.2-3.9 19 0 26.5 21.5 48 48 48 20.9 0 38.7-13.4 45.3-32.1 .9 0 1.8 .1 2.7 .1 35.3 0 64-28.7 64-64s-28.7-64-64-64c-.9 0-1.8 0-2.7 .1z"]
};
var faBugSlash = {
  prefix: 'fass',
  iconName: 'bug-slash',
  icon: [576, 512, [], "e490", "M32.3-33.8l17 17 192.9 192.9 152.6 0c77.5-58.1 118.8-89.1 123.7-92.8l38.4 51.2c-7.5 5.6-43.7 32.8-108.8 81.6l0 40 128 0 0 64-128 0 0 32c0 9.4-.8 18.6-2.4 27.6l115.5 115.5 17 17-33.9 33.9-17-17-512-512-17-17 33.9-33.9zM398.3 468c-23.2 22.1-53 37.2-86.2 42.2l0-128.4 86.2 86.2zM264.1 333.8l0 176.4c-51.2-7.7-94.5-39.7-117.7-83.9-48.3 36.2-77.8 58.4-88.7 66.5L19.3 441.6c7.4-5.6 43.8-32.8 109-81.7-.1-2.6-.2-5.2-.2-7.9l0-32-128 0 0-64 128 0 0-58.2 136 136zM384.1 128L273.3 128 201 55.7c15.2-32.9 48.5-55.7 87.2-55.7 53 0 96 43 96 96l0 32z"]
};
var faTrashCanPlus = {
  prefix: 'fass',
  iconName: 'trash-can-plus',
  icon: [448, 512, [], "e2ac", "M304-16l16 48 128 0 0 64-448 0 0-64 128 0 16-48 160 0zM32 144l384 0 0 368-384 0 0-368zM200 416l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faTarp = {
  prefix: 'fass',
  iconName: 'tarp',
  icon: [512, 512, [], "e57b", "M512 64l0 240-144 144-368 0 0-384 512 0zM453.5 272L336 272 336 389.5 453.5 272zM96 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBorderCenterH = {
  prefix: 'fass',
  iconName: 'border-center-h',
  icon: [448, 512, [], "f89c", "M152 40l0 48-48 0 0-48 48 0zM4 228l440 0 0 56-440 0 0-56zM440 424l0 48-48 0 0-48 48 0zM56 424l0 48-48 0 0-48 48 0zm48 0l48 0 0 48-48 0 0-48zm192 0l48 0 0 48-48 0 0-48zm-48 0l0 48-48 0 0-48 48 0zm-48-96l48 0 0 48-48 0 0-48zM344 40l0 48-48 0 0-48 48 0zM200 40l48 0 0 48-48 0 0-48zm48 96l0 48-48 0 0-48 48 0zM440 328l0 48-48 0 0-48 48 0zM56 328l0 48-48 0 0-48 48 0zM392 136l48 0 0 48-48 0 0-48zM56 136l0 48-48 0 0-48 48 0zM392 40l48 0 0 48-48 0 0-48zM56 40l0 48-48 0 0-48 48 0z"]
};
var faTally = {
  prefix: 'fass',
  iconName: 'tally',
  icon: [576, 512, ["tally-5"], "f69c", "M128.3 32l0 231 64-16 0-215 64 0 0 199 64-16 0-183 64 0 0 167 64-16 0-151 64 0 0 135c15-3.8 33.5-8.4 55.3-13.8l15.5 62.1c-19.2 4.8-42.8 10.7-70.8 17.7l0 247-64 0 0-231-64 16 0 215-64 0 0-199-64 16 0 183-64 0 0-167-64 16 0 151-64 0 0-135c-15 3.8-33.5 8.4-55.3 13.8L-6.5 296.7C12.7 291.9 36.4 286 64.3 279l0-247 64 0z"]
};
var faTally5 = faTally;
var faDiagramPredecessor = {
  prefix: 'fass',
  iconName: 'diagram-predecessor',
  icon: [512, 512, [], "e477", "M305.5 128l70.6 0 0-48-120 0 0 144-224 0 0-192 392 0 0 96 70.6 0c-13.4 13.4-41.2 41.2-83.3 83.3l-11.3 11.3-11.3-11.3c-42.1-42.1-69.9-69.9-83.3-83.3zM416.1 352l-320 0 0 64 320 0 0-64zm64 64l0 64-448 0 0-192 448 0 0 128z"]
};
var faFaceFlushed = {
  prefix: 'fass',
  iconName: 'face-flushed',
  icon: [512, 512, [128563, "flushed"], "f579", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM168 368l0 48 176 0 0-48-176 0zm-8-72a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faFlushed = faFaceFlushed;
var faDiagramNext = {
  prefix: 'fass',
  iconName: 'diagram-next',
  icon: [448, 512, [], "e476", "M448 224l0-192-448 0 0 192 192 0 0 64-62.6 0c13.4 13.4 41.2 41.2 83.3 83.3l11.3 11.3 11.3-11.3c42.1-42.1 69.9-69.9 83.3-83.3l-62.6 0 0-64 192 0zM0 288l0 192 448 0 0-192-61.5 0c-48.3 48.3-77.5 77.5-117.3 117.3-3.8 3.8-18.9 18.9-45.3 45.3-51-51-50.8-50.8-101.3-101.3-17.1-17.1-37.5-37.5-61.3-61.3L0 288z"]
};
var faCircleSortDown = {
  prefix: 'fass',
  iconName: 'circle-sort-down',
  icon: [512, 512, ["sort-circle-down"], "e031", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm136 32l120 128 120-128-240 0zm87.1-156.9l-87.1 92.9 65.8 0 54.2-57.8 54.2 57.8 65.8 0C308.9 152.4 268.9 109.8 256 96l-32.9 35.1z"]
};
var faSortCircleDown = faCircleSortDown;
var faAnchorCircleXmark = {
  prefix: 'fass',
  iconName: 'anchor-circle-xmark',
  icon: [640, 512, [], "e4ac", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-53 0-96 43-96 96 0 41.8 26.7 77.4 64 90.5l0 261.5-112 0 0-140.1c10.5 9.2 21.9 19.2 34.3 30l31.6-36.1c-4.4-3.8-31.7-27.8-82.1-71.8L112 216.1c-2.5 2.2-29.1 25.5-79.8 69.8l-18.1 15.8 31.6 36.1c12.4-10.8 23.8-20.8 34.3-30l0 204.1 260 0c-22.7-31.5-36-70.2-36-112 0-27.3 5.7-53.3 16-76.9l0-136.6c37.3-13.2 64-48.7 64-90.5 0-53-43-96-96-96zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm55.3-176.7l-32.7 32.7 44 44-22.6 22.6c-4-4-18.6-18.6-44-44l-44 44-22.6-22.6c4-4 18.6-18.6 44-44-25.3-25.3-40-40-44-44l22.6-22.6 44 44c25.3-25.4 40-40 44-44l22.6 22.6-11.3 11.3z"]
};
var faCircleP = {
  prefix: 'fass',
  iconName: 'circle-p',
  icon: [512, 512, [], "e11a", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM200 144l68 0c46.4 0 84 37.6 84 84s-37.6 84-84 84l-44 0 0 56-48 0 0-224 24 0zm68 120c19.9 0 36-16.1 36-36s-16.1-36-36-36l-44 0 0 72 44 0z"]
};
var faPersonCircleXmark = {
  prefix: 'fass',
  iconName: 'person-circle-xmark',
  icon: [640, 512, [], "e543", "M168 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-11.4 88l134.8 0 9.6 13.2 85.2 117.3c-17.8 12.4-33.4 27.8-46.1 45.5l-36.1-49.7 0 305.7-64 0 0-208-32 0 0 208-64 0 0-305.7c-28.6 39.4-47.6 65.6-56.9 78.4l-51.8-37.6 18.8-25.9 92.9-128 9.6-13.2zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm55.3 111.3L562.6 356 540 333.4c-4 4-18.7 18.6-44 44-25.4-25.4-40-40-44-44L429.4 356c4 4 18.6 18.7 44 44-25.4 25.4-40 40-44 44L452 466.6c4-4 18.7-18.6 44-44 25.4 25.4 40 40 44 44L562.6 444c-4-4-18.6-18.7-44-44l32.7-32.7z"]
};
var faBurrito = {
  prefix: 'fass',
  iconName: 'burrito',
  icon: [512, 512, [127791], "f7ed", "M245.7 58.3L10.3 293.7c28.2 21.5 63.5 34.3 101.7 34.3 75.6 0 139.5-49.9 160.6-118.6 4.8-15.6 7.4-32.2 7.4-49.4 0-38.2-12.8-73.5-34.3-101.7zm26.9-42.7c34.4 38.3 55.4 88.9 55.4 144.4 0 8.6-.5 17.1-1.5 25.5 8.4-1 16.9-1.5 25.5-1.5 55.5 0 106.2 21 144.5 55.4 9.8-13.3 15.5-29.7 15.5-47.4 0-11.4-2.4-22.2-6.7-32 4.3-9.8 6.7-20.6 6.7-32 0-34.6-22-64.1-52.8-75.2-11.1-30.8-40.6-52.8-75.2-52.8-11.4 0-22.2 2.4-32 6.7-9.8-4.3-20.6-6.7-32-6.7-17.7 0-34.1 5.8-47.4 15.6zM453.7 266.3c-28.2-21.5-63.5-34.3-101.7-34.3-13 0-25.7 1.5-37.9 4.3-30.8 81.6-109.7 139.7-202.1 139.7-41 0-79.3-11.4-112-31.3l0 55.3 112 112 96 0 245.7-245.7z"]
};
var faSignalBarsGood = {
  prefix: 'fass',
  iconName: 'signal-bars-good',
  icon: [448, 512, ["signal-alt-3"], "f693", "M320 160l0-32-64 0 0 352 64 0 0-320zM192 256l-64 0 0 224 64 0 0-224zM64 384l-64 0 0 96 64 0 0-96z"]
};
var faSignalAlt3 = faSignalBarsGood;
var faSpa = {
  prefix: 'fass',
  iconName: 'spa',
  icon: [576, 512, [], "f5bb", "M170.4 227.9c34 18.7 64 43.9 88.2 74.2 11.1 13.9 21 28.9 29.4 44.8 8.5-15.9 18.3-30.8 29.4-44.8 24.2-30.3 54.1-55.5 88.2-74.2 41.8-22.9 89.8-35.9 140.4-35.9l30 0c0 159.1-128.9 288-288 288S0 351.1 0 192l30 0c50.6 0 98.6 13 140.4 35.9zM288 32s66.3 49.7 103.4 149.1C351.9 201.3 316.8 229 288 262.4 259.2 229 224.1 201.3 184.6 181.1 221.7 81.7 288 32 288 32z"]
};
var faChessClockFlip = {
  prefix: 'fass',
  iconName: 'chess-clock-flip',
  icon: [576, 512, ["chess-clock-alt"], "f43e", "M336 16l160 0 0 48-56 0 0 32 136 0 0 352-576 0 0-352 64 0 0-32 160 0 0 32 168 0 0-32-56 0 0-48zM528 272a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-88-80l0 96-48 0 0-96 48 0zM80.8 351.2A112 112 0 1 0 239.2 192.8 112 112 0 1 0 80.8 351.2zM216.6 249.4c-25.5 25.5-42.4 42.4-50.9 50.9l-33.9-33.9c8.5-8.5 25.5-25.5 50.9-50.9l17-17 33.9 33.9-17 17z"]
};
var faChessClockAlt = faChessClockFlip;
var faBarsProgress = {
  prefix: 'fass',
  iconName: 'bars-progress',
  icon: [448, 512, ["tasks-alt"], "f828", "M384 96l0 64-96 0 0-64 96 0zM0 32l0 192 448 0 0-192-448 0zM384 352l0 64-224 0 0-64 224 0zM0 288l0 192 448 0 0-192-448 0z"]
};
var faTasksAlt = faBarsProgress;
var faOverline = {
  prefix: 'fass',
  iconName: 'overline',
  icon: [384, 512, [], "f876", "M32 64l352 0 0-64-384 0 0 64 32 0zm160 64a192 192 0 1 0 0 384 192 192 0 1 0 0-384zM320 320a128 128 0 1 1 -256 0 128 128 0 1 1 256 0z"]
};
var faCircleMicrophone = {
  prefix: 'fass',
  iconName: 'circle-microphone',
  icon: [512, 512, ["microphone-circle"], "e116", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM208 240l0-128 96 0 0 128c0 26.5-21.5 48-48 48s-48-21.5-48-48zm-48-32l0 32c0 53 43 96 96 96s96-43 96-96l0-32 48 0 0 32c0 71.4-51.9 130.6-120 142l0 42-48 0 0-42c-68.1-11.4-120-70.7-120-142l0-32 48 0z"]
};
var faMicrophoneCircle = faCircleMicrophone;
var faHeartCircleCheck = {
  prefix: 'fass',
  iconName: 'heart-circle-check',
  icon: [576, 512, [], "e4fd", "M133.1 32C175.8 32 216 52.5 241 87.1l15 20.7 15-20.7c25-34.6 65.2-55.1 107.9-55.1 73.5 0 133.1 59.6 133.1 133.1 0 19.2-3 38.1-8.5 56.6-22.1-8.9-46.2-13.8-71.5-13.8-106 0-192 86-192 192 0 33 8.3 64 23 91.2-2.4 1.6-4.7 3.3-7 4.8-102.5-70.7-256-194.1-256-330.9 0-73.5 59.6-133.1 133.1-133.1zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.4-51.5l-25.9-18.8-9.4 12.9-53 72.9C393.7 395 381 382.3 376 377.4L353.4 400c2.8 2.8 19.9 19.9 51.3 51.3l13.2 13.2 11-15.1 64-88 9.4-12.9z"]
};
var faMarsStrokeRight = {
  prefix: 'fass',
  iconName: 'mars-stroke-right',
  icon: [640, 512, [9897, "mars-stroke-h"], "f22b", "M320.5 256a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM208.5 80c86.3 0 158.1 62.1 173.1 144l18.9 0 0-64 64 0 0 64 61.4 0c-15.3-19.2-29.5-36.8-42.4-53l50-40c6 7.5 34 42.5 84 105l16 20c-2.7 3.3-29.3 36.7-80 100l-20 25-50-40c12.9-16.2 27.1-33.8 42.4-53l-61.4 0 0 64-64 0 0-64-18.9 0c-15 81.9-86.8 144-173.1 144-97.2 0-176-78.8-176-176s78.8-176 176-176z"]
};
var faMarsStrokeH = faMarsStrokeRight;
var faFaceExpressionless = {
  prefix: 'fass',
  iconName: 'face-expressionless',
  icon: [512, 512, [], "e373", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM152 320l232 0 0 48-256 0 0-48 24 0zM128 176l96 0 0 48-96 0 0-48zm184 0l72 0 0 48-96 0 0-48 24 0z"]
};
var faTransporterEmpty = {
  prefix: 'fass',
  iconName: 'transporter-empty',
  icon: [320, 512, [], "e046", "M0 496l320 0 0 48-320 0 0-48z"]
};
var faWatchFitness = {
  prefix: 'fass',
  iconName: 'watch-fitness',
  icon: [384, 512, [], "f63e", "M80-32l224 0 10.7 96 69.3 0 0 384-69.3 0-10.7 96-224 0-10.7-96-69.3 0 0-384 69.3 0 10.7-96zM320 128l-256 0 0 256 256 0 0-256zM186.9 206l5.1 6.8 5.1-6.8c8.9-11.8 22.8-18.8 37.5-18.8 25.9 0 46.9 21 46.9 46.9l0 4.3c0 51.2-89.6 102.4-89.6 102.4s-89.6-51.2-89.6-102.4l0-4.3c0-25.9 21-46.9 46.9-46.9 14.8 0 28.7 7 37.5 18.8z"]
};
var faMoonCloud = {
  prefix: 'fass',
  iconName: 'moon-cloud',
  icon: [640, 512, [], "f754", "M520.1 21.9c-87.1 21.6-151.7 100.3-151.7 194.1 0 110.5 89.5 200 200 200 18.5 0 36.4-2.5 53.4-7.2-46.7 62.6-121.3 103.2-205.4 103.2-10.8 0-21.5-.7-32-2l0-94c0-50.1-32.9-92.5-78.3-106.8-21.3-41.1-64.2-69.2-113.7-69.2-11 0-21.6 1.4-31.7 4 6.3-135.8 118.4-244 255.7-244 36.9 0 72 7.8 103.7 21.9zM272.4 480l-240 0 0-72c0-39.8 32.2-72 72-72 4.8 0 9.5 .5 14.1 1.4 12-29 40.6-49.4 73.9-49.4 38.7 0 71 27.5 78.4 64 .5 0 1.1 0 1.6 0 35.3 0 64 28.7 64 64l0 64-64 0z"]
};
var faUTurnDownRight = {
  prefix: 'fass',
  iconName: 'u-turn-down-right',
  icon: [512, 512, [], "e7f0", "M0 240C0 354.9 93.2 448 208 448l144 0 0 96 160-160-160-160 0 96-144 0c-44.2 0-80-35.8-80-80s35.8-80 80-80l240 0 0-128-240 0C93.1 32 0 125.1 0 240z"]
};
var faFaceShaking = {
  prefix: 'fass',
  iconName: 'face-shaking',
  icon: [576, 512, [], "e79c", "M52.6 120L11 96C55.2 19.5 126.2-31.9 205.3-53.1L217.7-6.7C150.5 11.3 90.1 54.9 52.6 120zM523.7 392l41.6 24C521.1 492.5 450 543.9 371 565.1l-12.4-46.4c67.3-18 127.6-61.7 165.2-126.7zM93.9 144A224.1 224.1 0 1 1 482.1 368 224.1 224.1 0 1 1 93.9 144zm176.7 46.4a32 32 0 1 0 -55.4-32 32 32 0 1 0 55.4 32zm94.8 91.7a32 32 0 1 0 32-55.4 32 32 0 1 0 -32 55.4zm-69.9 89a64 64 0 1 0 -110.8-64 64 64 0 1 0 110.8 64z"]
};
var faSunrise = {
  prefix: 'fass',
  iconName: 'sunrise',
  icon: [576, 512, [127749], "f766", "M305.2-9l-17-17c-3.5 3.5-30.5 30.5-81 81l-17 17 33.9 33.9 40-40 0 126.1 48 0 0-126.1c16.4 16.4 29.7 29.7 40 40L386.2 72c-3.5-3.5-30.5-30.5-81-81zM203.5 207.5l-29.7-19.7c-2.5 12.5-11.6 57.4-27.2 134.6-77.2 15.6-122.1 24.7-134.6 27.2 12.4 18.6 27.1 40.8 44.1 66.4l113.5 0c19-46.9 65-80 118.7-80s99.7 33.1 118.7 80l113.5 0c17-25.6 31.7-47.8 44.1-66.4-12.5-2.5-57.4-11.6-134.6-27.2-15.6-77.2-24.7-122.1-27.2-134.6-10.6 7.1-48.8 32.4-114.4 75.9l-84.7-56.2zM32.2 464l0 48 512 0 0-48-512 0z"]
};
var faBuildingMemo = {
  prefix: 'fass',
  iconName: 'building-memo',
  icon: [640, 512, [], "e61e", "M416 0l-384 0 0 512 272 0 0-224-48 0 0-64 48 0 0-64-48 0 0-64 48 0 0-16 112 0 0-80zM272 352l0 112-96 0 0-112 96 0zM128 96l64 0 0 64-64 0 0-64zm0 128l64 0 0 64-64 0 0-64zm224-96l0 416 288 0 0-416-288 0zm72 88l144 0 0 48-144 0 0-48zm24 96l120 0 0 48-144 0 0-48 24 0zm-24 96l112 0 0 48-112 0 0-48z"]
};
var faCartFlatbedEmpty = {
  prefix: 'fass',
  iconName: 'cart-flatbed-empty',
  icon: [576, 512, ["dolly-flatbed-empty"], "f476", "M0 0l128 0 0 384 448 0 0 64-66.7 0c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16l-197.5 0c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16L64 448 64 64 0 64 0 0z"]
};
var faDollyFlatbedEmpty = faCartFlatbedEmpty;
var faSquareDanishKrone = {
  prefix: 'fass',
  iconName: 'square-danish-krone',
  icon: [448, 512, [], "e747", "M0 32l448 0 0 448-448 0 0-448zM144 152l0-24-48 0 0 256 48 0 0-62.1 15.8-15.8c27.4 50.8 42.9 79.6 46.5 86.3l42.3-22.8-53.3-99c28.6-28.7 46.9-46.9 54.7-54.7L216 182.1c-5 5-29 29-72 72L144 152zm160 40l-48 0 0 192 48 0 0-105.4c0-8.1 3.2-15.9 9-21.7s13.5-9 21.7-9l33.4 0 0-48-33.4 0c-10.6 0-21 2.2-30.6 6.2l0-14.2zm40 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFaceDisappointed = {
  prefix: 'fass',
  iconName: 'face-disappointed',
  icon: [512, 512, [], "e36f", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM214.1 270.1l-7.4 7.4c-24.2 24.2-55.3 40.2-89 45.8l-2.5 .4-19.7 3.3-6.6-39.5 19.7-3.3 2.5-.4c25.5-4.2 49-16.4 67.3-34.6 3.8-3.8 11-11 21.5-21.5l28.3 28.3-14.1 14.1zM283.7 256L312 227.7c10.6 10.6 17.7 17.7 21.5 21.5 18.3 18.3 41.8 30.4 67.3 34.6l2.5 .4 19.7 3.3-6.6 39.5-19.7-3.3-2.5-.4c-33.7-5.6-64.8-21.6-89-45.8-3.8-3.8-11-11-21.5-21.5zM192.3 422.4l-42.4-22.5C170 361.9 210 336 256 336s86 25.9 106.1 63.9l-42.4 22.5C307.6 399.5 283.6 384 256 384s-51.6 15.5-63.7 38.4z"]
};
var faBowlChopsticks = {
  prefix: 'fass',
  iconName: 'bowl-chopsticks',
  icon: [512, 512, [], "e2e9", "M0 96L0 128 512 48 512 0 0 96zm0 48l0 32 512 0 0-48-512 16zm512 80L0 224 3.6 285.2C8.5 368.1 58 438.2 128 472.9l0 39.1 256 0 0-39.1c70-34.6 119.5-104.8 124.4-187.7L512 224z"]
};
var faCarSiren = {
  prefix: 'fass',
  iconName: 'car-siren',
  icon: [512, 512, [], "e7c1", "M312 64l121 0c.7 2.9 11.4 45.6 32 128l47 0 0 288-96 0 0-64-320 0 0 64-96 0 0-288 47 0C67.6 109.6 78.3 66.9 79 64l121 0 16-64 80 0 16 64zm71 64l-254 0-16 64 286 0-16-64zM96 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTowerObservation = {
  prefix: 'fass',
  iconName: 'tower-observation',
  icon: [448, 512, [], "e586", "M32 96l192-96 192 96 0 48-32 0 0 112-45 0 32 192 77 0 0 64-448 0 0-64 77 0 32-192-45 0 0-112-32 0 0-48zM310.7 448l-86.7-61.9-86.7 61.9 173.4 0zM154.1 277.2l69.9 49.9 69.9-49.9-3.5-21.2-132.7 0-3.5 21.2zm-8.8 52.7l-10.1 60.6 47.5-33.9-37.4-26.7zm119.9 26.7l47.5 33.9-10.1-60.6-37.4 26.7zM320 128l-192 0 0 48 192 0 0-48z"]
};
var faBinaryLock = {
  prefix: 'fass',
  iconName: 'binary-lock',
  icon: [576, 512, [], "e33d", "M288 0l0 64 48 0 0 96-48 0 0 64 76.1 0c20.3-25.3 50.1-42.8 83.9-47l0-17-48 0 0-160-112 0zm16 288l-48 0 0 224 48 0 0-224zM64 288l0 64 48 0 0 96-48 0 0 64 160 0 0-64-48 0 0-160-112 0zM96 0l-32 0 0 224 192 0 0-224-160 0zm32 160l0-96 64 0 0 96-64 0zM464 272c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faSterlingSign = {
  prefix: 'fass',
  iconName: 'sterling-sign',
  icon: [320, 512, [163, "gbp", "pound-sign"], "f154", "M58.8 288l-58.8 0 0-48 45.4 0C4.8 147.3 72.6 42 175.1 42l8.2 0c33.6 0 66.2 11.3 92.5 32.2 9.2 7.3 22.9 18.2 41.2 32.6L277.2 157c-18.2-14.4-32-25.3-41.2-32.6-15-11.9-33.6-18.4-52.8-18.4l-8.2 0c-57.3 0-94.7 59.9-69.7 111.4 3.6 7.4 6.6 14.9 9.1 22.6l173.5 0 0 48-165.2 0c1 35.3-8.7 70.6-28.9 100.9l-18.1 27.1 244.2 0 0 64-320 0 0-65.7 5.4-8.1 35.2-52.8c13.1-19.6 19.2-42.6 18.2-65.4z"]
};
var faGbp = faSterlingSign;
var faPoundSign = faSterlingSign;
var faAlicorn = {
  prefix: 'fass',
  iconName: 'alicorn',
  icon: [640, 512, [], "f6b0", "M448 160l0 80 0 0c-.5 30-12.8 56.4-32 75.7l0 196.3-96 0 0-165.3c-4.1-.7-8.2-1.6-12.3-2.8L224 320 224 355.9c-7.2 7.2-20.9 20.9-41.1 41.1l38.3 115-101.2 0c-29.8-89.3-45.4-136.3-47-141 13.1-13.1 28.9-28.9 47.6-47.6L78.2 259.9c-7.3-11-11.9-23.4-13.6-36.4-10.1 7.3-16.7 19.1-16.7 32.5l0 80-48 0 0-80c0-44.6 33.2-81.5 76.3-87.2 13-21.4 35.2-36.5 61.1-40 3.8 15.3 9.2 29.8 16.5 43 11.3 20.4 27.4 37.7 49.9 49.8 7.5 4 15.5 7.4 24.2 10.1-88.3-58-68.1-199.7-68.1-199.7l160 96C320 57.3 377.3 0 448 0l112 0 0 32-32 0 16 16 96 0 0 16-80 26.7 0 101.3-80 32-32-64zm64-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faSquareHryvnia = {
  prefix: 'fass',
  iconName: 'square-hryvnia',
  icon: [448, 512, [], "e710", "M448 32l-448 0 0 448 448 0 0-448zM240.8 118.7c42.1-5.3 79.2 27.5 79.2 69.9 0 6.6-.9 13.1-2.7 19.3l18.7 0 0 32-224 0 0-32 149 0c6.8-4 11-11.4 11-19.3 0-13.5-11.8-24-25.3-22.3-59.2 7.4-92.3 11.5-99.6 12.4l-6-47.6c7.2-.9 40.4-5.1 99.6-12.4zM244.6 272l91.4 0 0 32-148.9 0c-6.8 4.1-11.1 11.6-11.1 19.6 0 13.6 11.9 24.3 25.4 22.8 72.6-8.1 111.2-12.4 115.8-12.9l5.3 47.7c-4.6 .5-43.2 4.8-115.8 12.9-42 4.7-78.7-28.2-78.7-70.5 0-6.7 1-13.3 2.8-19.6l-18.8 0 0-32 132.6 0z"]
};
var faArrowRightLongToLine = {
  prefix: 'fass',
  iconName: 'arrow-right-long-to-line',
  icon: [640, 512, [], "e3d5", "M374.6 105.4L352 82.7 306.7 128c6.6 6.6 38.6 38.6 96 96L0 224 0 288 402.7 288c-57.4 57.4-89.4 89.4-96 96l45.3 45.3 173.3-173.3-22.6-22.6-128-128zM640 128l0-32-64 0 0 320 64 0 0-288z"]
};
var faComputerSpeaker = {
  prefix: 'fass',
  iconName: 'computer-speaker',
  icon: [576, 512, [], "f8b2", "M240 32l-240 0 0 352 240 0 0-64-176 0 0-224 176 0 0-64zm0 400l-144 0 0 48 144 0 0-48zM576 32l-288 0 0 448 288 0 0-448zM464 336a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm48-208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faFaucetDrip = {
  prefix: 'fass',
  iconName: 'faucet-drip',
  icon: [512, 512, [128688], "e006", "M256 32l-64 0 0 32-128 0 0 64 128 0 0 64-32 0-32 32-128 0 0 128 132.1 0c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48l36.1 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-88.4-71.6-160-160-160l-32 0-32-32-32 0 0-64 128 0 0-64-128 0 0-32zM448 448l-27.8 48.7c-2.7 4.8-4.2 10.2-4.2 15.7 0 17.5 14.2 31.6 31.6 31.6l.8 0c17.5 0 31.6-14.2 31.6-31.6 0-5.5-1.4-10.9-4.2-15.7L448 448z"]
};
var faMailboxOpenEmpty = {
  prefix: 'fass',
  iconName: 'mailbox-open-empty',
  icon: [640, 512, [], "e821", "M480 64c88.4 0 160 71.6 160 160l0 256-640 0 0-48 96 0 0-224c0-79.5 64.5-144 144-144l240 0zM240 112c-53 0-96 43-96 96l0 224 192 0 0-224c0-53-43-96-96-96zM416 256l80 0 0 64 80 0 0-112-160 0 0 48z"]
};
var faFaceRaisedEyebrow = {
  prefix: 'fass',
  iconName: 'face-raised-eyebrow',
  icon: [512, 512, [], "e388", "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm208-16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 336l0 48 192 0 0-48-192 0zM360.9 110.1l-8.9-4.5-72.9 36.5-17.9 8.9 17.9 35.8c5.7-2.9 30.1-15 72.9-36.5 16.2 8.1 29.9 14.9 40.9 20.5l17.9-35.8c-9.6-4.8-26.2-13.1-49.9-24.9zM128 132l-20 0 0 40 104 0 0-40-84 0z"]
};
var faClonePlus = {
  prefix: 'fass',
  iconName: 'clone-plus',
  icon: [512, 512, [], "e74c", "M64 448l224 0 0-48 64 0 0 112-352 0 0-352 112 0 0 64-48 0 0 224zm96-96l0-352 352 0 0 352-352 0zm152-80l48 0 0-72 72 0 0-48-72 0 0-72-48 0 0 72-72 0 0 48 72 0 0 72z"]
};
var faFaceSmilingHands = {
  prefix: 'fass',
  iconName: 'face-smiling-hands',
  icon: [640, 512, [], "e396", "M360.6 508.8C350 488.9 344 466.3 344 442.2l0-28c-7.8 1.2-15.8 1.8-24 1.8s-16.2-.6-24-1.8l0 28c0 24.1-6 46.8-16.6 66.6 13.2 2.1 26.8 3.2 40.6 3.2s27.4-1.1 40.6-3.2zM64 256c0 7.6 .3 15.1 1 22.5 10.9-10.9 26.6-26.6 47-47 20.2 20.2 36.4 36.4 48.6 48.6l135.4 0 0 85.4c7.7 1.7 15.8 2.6 24 2.6s16.3-.9 24-2.6l0-85.4 135.4 0c12.2-12.2 28.4-28.4 48.6-48.6 20.4 20.4 36.1 36.1 47 47 .6-7.4 1-14.9 1-22.5 0-141.4-114.6-256-256-256S64 114.6 64 256zm148-48l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28s-28 12.5-28 28zm188-28c-15.5 0-28 12.5-28 28l0 28-40 0 0-28c0-37.6 30.4-68 68-68s68 30.4 68 68l0 28-40 0 0-28c0-15.5-12.5-28-28-28zM256 442.2l0-122.2-48 0 0 64-96-96-32 32 64 64-16 16-80-80-32 32 80 80-16 16-48-48-32 32 82.2 82.2c19.1 19.1 45 29.8 72 29.8 56.2 0 101.8-45.6 101.8-101.8zm128 0c0 56.2 45.6 101.8 101.8 101.8 27 0 52.9-10.7 72-29.8l82.2-82.2-32-32-48 48-16-16 80-80-32-32-80 80-16-16 64-64-32-32-96 96 0-64-48 0 0 122.2z"]
};
var faFileLock = {
  prefix: 'fass',
  iconName: 'file-lock',
  icon: [576, 512, [], "e3a6", "M272 0l-240 0 0 512 272 0 0-208 32 0c0-53.7 33.1-99.7 80-118.7L416 144 272 0zm85.5 176L240 176 240 58.5 357.5 176zM464 272c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faCircleInfo = {
  prefix: 'fass',
  iconName: 'circle-info',
  icon: [512, 512, ["info-circle"], "f05a", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM216 336l24 0 0-64-48 0 0-48 96 0 0 112 32 0 0 48-128 0 0-48 24 0zm72-144l-64 0 0-64 64 0 0 64z"]
};
var faInfoCircle = faCircleInfo;
var faBellExclamation = {
  prefix: 'fass',
  iconName: 'bell-exclamation',
  icon: [512, 512, [], "f848", "M318 464c-7.1 27.6-32.1 48-62 48s-54.9-20.4-62-48l124 0zM288 35.2C361 50 416 114.6 416 192l0 96 80 128-480 0 80-128 0-96c0-77.4 55-142 128-156.8l0-35.2 64 0 0 35.2zM228 292l0 56 56 0 0-56-56 0zm-4-180l12.8 144 38.4 0 12.8-144-64 0z"]
};
var faFeather = {
  prefix: 'fass',
  iconName: 'feather',
  icon: [512, 512, [129718], "f52d", "M352 0c41 0 80.3 16.3 109.2 45.2l5.5 5.5c29 29 45.3 68.3 45.3 109.2 0 26.3-6.7 51.9-19.2 74.6l-124.8 37.4 0 16 80 0-52.6 52.6-91.4 27.4 0 16 48 0-64 64-192 0-64 64-32-32 272-272-32-32-176 176 0-128 178.7-178.8C271.7 16.3 311 0 352 0z"]
};
var faBowlRice = {
  prefix: 'fass',
  iconName: 'bowl-rice',
  icon: [512, 512, [], "e2eb", "M200 16l40 0 0 48-64 0 0-48 24 0zM176 88l64 0 0 48-64 0 0-48zM56 160l40 0 0 48-64 0 0-48 24 0zm192 0l40 0 0 48-64 0 0-48 24 0zm-96 0l40 0 0 48-64 0 0-48 24 0zM80 88l64 0 0 48-64 0 0-48zm264 72l40 0 0 48-64 0 0-48 24 0zM272 88l64 0 0 48-64 0 0-48zm168 72l40 0 0 48-64 0 0-48 24 0zM368 88l64 0 0 48-64 0 0-48zM272 16l64 0 0 48-64 0 0-48zM0 240l512 0 0 24c0 67-39.2 124.9-96 151.8l0 48.2-320 0 0-48.2C39.2 388.9 0 331 0 264l0-24z"]
};
var faDialMedLow = {
  prefix: 'fass',
  iconName: 'dial-med-low',
  icon: [576, 512, [], "e160", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64-64 0 0-64zM174.6 400.5c-56.7-56.7-62-145.4-15.7-208l111.9 111.9 17 17 33.9-33.9-17-17-111.9-111.9c62.6-46.2 151.3-41 208 15.7 62.5 62.5 62.5 163.8 0 226.3s-163.8 62.5-226.3 0z"]
};
var faStarHalfStroke = {
  prefix: 'fass',
  iconName: 'star-half-stroke',
  icon: [576, 512, ["star-half-alt"], "f5c0", "M324.1 17.6l56.6 111c89.6 14.2 156.6 24.9 201.1 32-31.9 31.9-79.8 79.9-143.9 144.1 14.1 89.6 24.7 156.6 31.7 201.2-40.2-20.4-100.7-51.2-181.5-92.3-80.8 41.1-141.3 71.9-181.5 92.3 7-44.5 17.6-111.6 31.7-201.2-64.1-64.2-112-112.2-143.9-144.1 44.5-7.1 111.6-17.7 201.1-32 41.2-80.8 72.1-141.2 92.6-181.4l35.9 70.4zm46.6 174.2l-32.2-5.1c-6.4-12.6-23.2-45.4-50.4-98.7l0 253.7c12.6 6.4 45.5 23.1 98.7 50.2-9.3-59-15.1-95.5-17.3-109.4 10-10 36.1-36.1 78.3-78.4l-77.3-12.3z"]
};
var faStarHalfAlt = faStarHalfStroke;
var faPlanetMoon = {
  prefix: 'fass',
  iconName: 'planet-moon',
  icon: [576, 512, [], "e01f", "M512 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM0 288a224 224 0 1 1 448 0 224 224 0 1 1 -448 0zM256 114.9c-10.4-1.9-21.1-2.9-32-2.9-86.3 0-158 62.1-173.1 144l77.1 0 64 64 0 64 32 0 0 72 40 0 56-104 0-64-112 0-32-32 80-96 0-45.1z"]
};
var faTemperatureArrowDown = {
  prefix: 'fass',
  iconName: 'temperature-arrow-down',
  icon: [576, 512, ["temperature-down"], "e03f", "M96.3 0l192 0 0 260.7c29.5 26.4 48 64.7 48 107.3 0 79.5-64.5 144-144 144s-144-64.5-144-144c0-42.6 18.5-81 48-107.3L96.3 0zm96 432c35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3l0-52.7-48 0 0 52.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64zM470.9 310.6l-22.6 22.6c-8.2-8.2-37.1-37.1-86.6-86.6l-22.6-22.6 45.3-45.3 32 32 0-210.7 64 0 0 210.7 32-32 45.3 45.3c-8.2 8.2-37.1 37.1-86.6 86.6z"]
};
var faTemperatureDown = faTemperatureArrowDown;
var faMaskVentilator = {
  prefix: 'fass',
  iconName: 'mask-ventilator',
  icon: [640, 512, [], "e524", "M154.2 192c-16.1 39.3-26.2 77.9-26.2 108.8 0 13.3 1.5 26.2 4.4 38.7L64 325.8 64 192 154.2 192zm31.3-64L0 128 0 378.2 25.7 383.4 169.2 412.1c18.7 22.1 42.9 40 70.8 51.8l0-87.8c-10.1-14.2-16-31.3-16-49.7 0-39 32-102.4 64-134.4l64 0c32 32 64 95.4 64 134.4 0 18.4-5.9 35.4-16 49.6l0 87.7c27.6-11.8 51.7-29.6 70.4-51.6l143.8-28.8 25.7-5.1 0-250.2-185.4 0C433.5 90.9 408.8 56.8 384 32L256 32c-24.8 24.8-49.5 58.9-70.6 96zm300.4 64l90.2 0 0 133.8-68.5 13.7c2.9-12.4 4.5-25.4 4.5-38.7 0-30.9-10.1-69.5-26.2-108.8zM288 288l0 224 64 0 0-224-64 0z"]
};
var faCannon = {
  prefix: 'fass',
  iconName: 'cannon',
  icon: [640, 512, [], "e642", "M256.4 464.8c-56.1 28-121.7 16.1-164.4-25.1L42.9 464.2 0 378.3 49.1 353.8C41.7 294.9 71.5 235.2 127.6 207.2 192 176 559 51.3 559 51.3l81 161.9s-51.5 35.2-117.2 79.5c-25.3-41.2-70.8-68.7-122.8-68.7-79.5 0-144 64.5-144 144 0 30.6 9.5 58.9 25.8 82.3-10.5 6.4-19.2 11.3-25.4 14.5zM288 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm144 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faChartScatter = {
  prefix: 'fass',
  iconName: 'chart-scatter',
  icon: [512, 512, [], "f7ee", "M64 64l0-32-64 0 0 448 512 0 0-64-448 0 0-352zm160 64l-64 0 0 64 64 0 0-64zM192 288l-64 0 0 64 64 0 0-64zm128-64l-64 0 0 64 64 0 0-64zm32 128l64 0 0-64-64 0 0 64zM448 96l-64 0 0 64 64 0 0-64z"]
};
var faFileVideo = {
  prefix: 'fass',
  iconName: 'file-video',
  icon: [384, 512, [], "f1c8", "M0 0L240 0 384 144 384 512 0 512 0 0zM208 58.5L208 176 325.5 176 208 58.5zM80 272l0 160 160 0 0-56 64 40 0-128-64 40 0-56-160 0z"]
};
var faSquareO = {
  prefix: 'fass',
  iconName: 'square-o',
  icon: [448, 512, [], "e278", "M448 32l-448 0 0 448 448 0 0-448zM152 256a72 72 0 1 0 144 0 72 72 0 1 0 -144 0zm72 120a120 120 0 1 1 0-240 120 120 0 1 1 0 240z"]
};
var faArrowTrendDown = {
  prefix: 'fass',
  iconName: 'arrow-trend-down',
  icon: [640, 512, [], "e097", "M416.3 416l-32 0 0-64 114.7 0-146.7-146.7c-84 84-126.7 126.7-128 128l-22.6-22.6-160-160-22.6-22.6 45.3-45.3 22.6 22.6 137.4 137.4 105.4-105.4 22.6-22.6 22.6 22.6 169.4 169.4 0-114.7 64 0 0 224-192 0z"]
};
var faCitrusSlice = {
  prefix: 'fass',
  iconName: 'citrus-slice',
  icon: [512, 512, [], "e2f5", "M391.7 391.4c-96.8 96.8-253.5 96.6-350.4-.3L7.4 425c115.6 115.6 302.6 116 418.3 .3S540.9 122.6 425.3 7L391.4 41c96.9 96.9 97.1 253.6 .3 350.4zM176.3 428.3l0-174.3c-7.1-1.8-13.7-4.9-19.7-8.8L48.3 353.5 63.6 368.7c32 32 71.4 51.8 112.7 59.5zm69.1-272c4 5.9 7 12.6 8.8 19.7l174.3 0c-7.7-41.2-27.4-80.5-59.2-112.4L353.8 48 245.5 156.3zm8.8 51.7c-1.5 5.9-3.8 11.4-6.8 16.5L380 357c36.8-42.6 54.2-96.1 52.2-149l-177.9 0zm-29.5 39.1c-5.1 3-10.6 5.3-16.5 6.8l0 177.9c52.9 2 106.4-15.5 149-52.2L224.8 247.1z"]
};
var faDisplayChartUpCircleCurrency = {
  prefix: 'fass',
  iconName: 'display-chart-up-circle-currency',
  icon: [640, 512, [], "e5e5", "M96 96l384 0 0 112.7c5.3-.4 10.6-.7 16-.7 16.6 0 32.7 2.1 48 6l0-182-512 0 0 384 208 0-16 48-96 0 0 48 212 0c-22.7-31.5-36-70.2-36-112 0-16.6 2.1-32.7 6-48L96 352 96 96zm352 72l0-24-128 0 0 48 46.1 0-54.1 54.1c-49.7-49.7-76.4-76.4-80-80-.8 .8-33.1 33.1-97 97l-17 17 33.9 33.9c3.6-3.6 30.3-30.3 80-80 49.7 49.7 76.4 76.4 80 80 11.2-11.2 22.8-22.8 34.8-34.8 8.4-10.4 17.9-19.9 28.3-28.3l24.9-24.9 0 7.7c14.9-8.6 31-15.3 48-19.6l0-46zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm55.1 .5l28.2 28.2-22.6 22.6-28.2-28.2c-9.5 5.6-20.6 8.9-32.5 8.9s-23-3.2-32.5-8.9l-28.2 28.2-22.6-22.6 28.2-28.2c-5.6-9.5-8.9-20.6-8.9-32.5s3.2-23 8.9-32.5l-28.2-28.2 22.6-22.6 28.2 28.2c9.5-5.6 20.6-8.9 32.5-8.9s23 3.2 32.5 8.9l28.2-28.2 22.6 22.6-28.2 28.2c5.6 9.5 8.9 20.6 8.9 32.5s-3.2 23-8.9 32.5z"]
};
var faCommentMiddleTop = {
  prefix: 'fass',
  iconName: 'comment-middle-top',
  icon: [512, 512, [], "e14a", "M191.5 71.2L256-32 320.5 71.2C430.6 96.2 512 183.8 512 288 512 411.7 397.4 512 256 512S0 411.7 0 288C0 183.8 81.4 96.2 191.5 71.2z"]
};
var faCaretLargeDown = {
  prefix: 'fass',
  iconName: 'caret-large-down',
  icon: [448, 512, [], "e82c", "M440 160L224 392 8 160 440 160z"]
};
var faDownToDottedLine = {
  prefix: 'fass',
  iconName: 'down-to-dotted-line',
  icon: [384, 512, [], "e408", "M0 512l0-64 64 0 0 64-64 0zM192 394.9l-192-202.9 128 0 0-192 128 0 0 192 128 0-192 202.9zM170.7 512l-64 0 0-64 64 0 0 64zm42.7 0l0-64 64 0 0 64-64 0zM384 512l-64 0 0-64 64 0 0 64z"]
};
var faPhoneArrowDownLeft = {
  prefix: 'fass',
  iconName: 'phone-arrow-down-left',
  icon: [512, 512, ["phone-arrow-down", "phone-incoming"], "e223", "M128 0L0 64 0 80C0 318.6 193.4 512 432 512l16 0 64-128-128-96.8-80 80.8c-70.4-33-127-89.6-160-160L224.8 128 128 0zM489 57l17-17-33.9-33.9-17 17-87 87 0-78.1-48 0 0 160 160 0 0-48-78.1 0 87-87z"]
};
var faPhoneArrowDown = faPhoneArrowDownLeft;
var faPhoneIncoming = faPhoneArrowDownLeft;
var faBuoyMooring = {
  prefix: 'fass',
  iconName: 'buoy-mooring',
  icon: [640, 512, [], "e5b6", "M288.4 0l64 0 0 48 58.2 0 5.1 25.7 60.7 303.3c-3.3-1.3-15.3-6.1-36-14.4l-26.7 10.7-93.3 37.3-93.2-37.3-26.8-10.7-26.8 10.7-9.3 3.7 60.7-303.3 5.1-25.7 58.2 0 0-48zM253.8 256l133.1 0-28.8-144-75.5 0-28.8 144zM209.3 417.7l111.1 44.4 111.1-44.4 8.9-3.6 8.9 3.6 111.8 44.7c29.3-9.7 50.1-16.7 62.4-20.8l15.2 45.5-70.8 23.6-8.3 2.8-8.2-3.3-111.1-44.4-111.1 44.4-8.9 3.6-8.9-3.6-111.1-44.4-111.1 44.4-8.2 3.3-8.3-2.8C36.6 498.7 13 490.8 2 487.2l15.2-45.5c12.4 4.1 33.2 11.1 62.4 20.8l111.8-44.7 8.9-3.6 8.9 3.6z"]
};
var faTentCircus = {
  prefix: 'fass',
  iconName: 'tent-circus',
  icon: [512, 512, [], "e6cd", "M256-5.2l13.6 9.4 232 160 10.4 7.2 0 100.4c-5.4 2.3-23.7 10.2-55.1 23.6l47.1 208.6-103.6 0-.8-4.4-39.2-211.6-35.5 14.2-8.9 3.6-1.2-.5 36.8 198.6-191.2 0 36.8-198.6-1.2 .5c-1.5-.6-16.3-6.5-44.4-17.8l-39.2 211.5-.8 4.4-103.6 0 47.1-208.6C23.7 282 5.4 274.1 0 271.8l0-100.4 10.4-7.2 232-160 13.6-9.4zM232 160l24 0 0-106.8-154.9 106.8 130.9 0zM48 208l0 32.2 32 13.7 32-13.7 0-32.2-64 0zm416 0l-64 0 0 32.2 32 13.7 32-13.7 0-32.2zm-304 0l0 31.8 36 14.4 36-14.4 0-31.8-72 0zm120 31.8l36 14.4 36-14.4 0-31.8-72 0 0 31.8z"]
};
var faOilCan = {
  prefix: 'fass',
  iconName: 'oil-can',
  icon: [640, 512, [], "f613", "M288 128l64 0 0-64-192 0 0 64 64 0 0 32-224 0 0 144 96 42.7 0 69.3 336 0 208-224-32-32-160 32-64-32-96 0 0-32zM96 208l0 86.1-48-21.3 0-64.8 48 0z"]
};
var faMemoCircleInfo = {
  prefix: 'fass',
  iconName: 'memo-circle-info',
  icon: [576, 512, [], "e49a", "M416 0l-384 0 0 512 244 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3L416 0zM128 128l192 0 0 48-192 0 0-48zm0 96l112 0 0 48-112 0 0-48zm0 96l80 0 0 48-80 0 0-48zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm15.3-224l0 32-32 0 0-32 32 0zm1.2 64l0 64 15.5 0 0 32-15.5 0-.5 0c-24 0-40 0-48 0l0-32 16 0 .5 0 0-32-.5 0-16 0 0-32c23.9 0 40.8 0 48.5 0z"]
};
var faCartCircleArrowUp = {
  prefix: 'fass',
  iconName: 'cart-circle-arrow-up',
  icon: [640, 512, [], "e3f0", "M24-16l-24 0 0 48 76 0 60.4 332.3 3.6 19.7 164.7 0c1.4-16.7 4.9-32.8 10.3-48l-134.9 0-8.7-48 168.7 0c34.9-48.5 91.7-80 156-80 15.8 0 31.2 1.9 46 5.5L576 32 124.8 32c-3.7-20.3-6.6-36.3-8.7-48L24-16zM208 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM496 256a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM417.4 392l11.3-11.3 56-56 11.3-11.3 11.3 11.3 56 56 11.3 11.3-22.6 22.6c-4.6-4.6-18-18-40-40l0 105.4-32 0 0-105.4c-22 22-35.4 35.4-40 40L417.4 392z"]
};
var faCircleParking = {
  prefix: 'fass',
  iconName: 'circle-parking',
  icon: [512, 512, ["parking-circle"], "f615", "M448 256a192 192 0 1 0 -384 0 192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM200 128l80 0c53 0 96 43 96 96s-43 96-96 96l-48 0 0 64-64 0 0-256 32 0zm112 96c0-17.7-14.3-32-32-32l-48 0 0 64 48 0c17.7 0 32-14.3 32-32z"]
};
var faParkingCircle = faCircleParking;
var faCassetteBetamax = {
  prefix: 'fass',
  iconName: 'cassette-betamax',
  icon: [512, 512, ["betamax"], "f8a4", "M512 64l-512 0 0 64 512 0 0-64zm0 112l-512 0 0 272 512 0 0-272zM144 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm304 0l0 160-160 0 0-160 160 0z"]
};
var faBetamax = faCassetteBetamax;
var faTankRecovery = {
  prefix: 'fass',
  iconName: 'tank-recovery',
  icon: [448, 512, [], "e825", "M416 464l-64 0 0 48-256 0 0-48-64 0 0-112 384 0 0 112zM352 112l64 0 0 144 32 0 0 48-448 0 0-48 32 0 0-144 64 0 0-128 256 0 0 128zM160 32l0 48 40 0 0 32 48 0 0-32 40 0 0-48-128 0z"]
};
var faPeopleCarryBox = {
  prefix: 'fass',
  iconName: 'people-carry-box',
  icon: [576, 512, ["people-carry"], "f4ce", "M64-32A56 56 0 1 1 64 80 56 56 0 1 1 64-32zM0 112l96.5 0 9.6 13.4 70.4 98.6 15.5 0 0-128 192 0 0 128 15.5 0 70.4-98.6 9.6-13.4 96.5 0 0 160c0 30.2-14.2 58.7-38.4 76.8l-89.6 67.2 0 128-64 0 0-160 12.8-9.6 67.2-50.4 0-80.1c-16.7 23.4-27.2 38.1-31.5 44.1l-288.9 0c-4.3-6-14.8-20.8-31.5-44.1l0 80.1 67.2 50.4 12.8 9.6 0 160-64 0 0-128-89.6-67.2C14.2 330.7 0 302.2 0 272L0 112zM0 379.3c3.1 2.7 6.3 5.4 9.6 7.9L64 428 64 544 0 544 0 379.3zM512-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm64 411.3l0 164.7-64 0 0-116 54.4-40.8c3.3-2.5 6.5-5.1 9.6-7.9z"]
};
var faPeopleCarry = faPeopleCarryBox;
var faClockEight = {
  prefix: 'fass',
  iconName: 'clock-eight',
  icon: [512, 512, [], "e345", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392l0 148.8-10.7 7.1-96 64-20 13.3-26.6-39.9c2.4-1.6 37.5-25 105.3-70.2l0-147.2 48 0 0 24z"]
};
var faChair = {
  prefix: 'fass',
  iconName: 'chair',
  icon: [448, 512, [129681], "f6c0", "M152 48l0 208-40 0 0-208 40 0zm48 0l48 0 0 208-48 0 0-208zm96 0l40 0 0 208-40 0 0-208zM64 48l0 208-64 0 0 128 32 0 0 128 64 0 0-128 256 0 0 128 64 0 0-128 32 0 0-128-64 0 0-256-320 0 0 48z"]
};
var faWind = {
  prefix: 'fass',
  iconName: 'wind',
  icon: [512, 512, [], "f72e", "M288 0l0 64 72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-360 0 0 64 360 0c48.6 0 88-39.4 88-88S408.6 0 360 0L288 0zm64 416l64 0c53 0 96-43 96-96s-43-96-96-96l-416 0 0 64 416 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0 0 64zM128 512l40 0c48.6 0 88-39.4 88-88s-39.4-88-88-88l-168 0 0 64 168 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0 0 64 32 0z"]
};
var faLayerGroup = {
  prefix: 'fass',
  iconName: 'layer-group',
  icon: [576, 512, [], "f5fd", "M288 256L16 128 288 0 560 128 288 256zM95.6 218.5L288 309 480.4 218.5 560 256 288 384 16 256 95.6 218.5zM16 384L95.6 346.5 288 437 480.4 346.5 560 384 288 512 16 384z"]
};
var faLollipop = {
  prefix: 'fass',
  iconName: 'lollipop',
  icon: [512, 512, [127853, "lollypop"], "e424", "M210.8 334.8C265.3 314.2 304 261.6 304 200l0-8c0-61.9-50.1-112-112-112S80 130.1 80 192c0 39.8 32.2 72 72 72s72-32.2 72-72l0-16-48 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-35.3 28.7-64 64-64s64 28.7 64 64l0 8c0 53-43 96-96 96l-8 0c-57.4 0-104-46.6-104-104 0-79.5 64.5-144 144-144s144 64.5 144 144c0 73.2-54.6 133.6-125.2 142.8zM0 192c0 106 86 192 192 192 41.5 0 79.9-13.1 111.2-35.5l162.1 162.1 45.3-45.3-162.1-162.1C370.9 271.9 384 233.5 384 192 384 86 298 0 192 0S0 86 0 192z"]
};
var faLollypop = faLollipop;
var faNotes = {
  prefix: 'fass',
  iconName: 'notes',
  icon: [512, 512, [], "e202", "M368 416l-272 0 0-416 416 0 0 272-144 144zm85.5-176L336 240 336 357.5 453.5 240zM168 72l0 48 48 0 0-48-48 0zm48 112l-48 0 0 48 48 0 0-48zM168 296l0 48 48 0 0-48-48 0zM48 120l0 344 304 0 0 48-352 0 0-416 48 0 0 24z"]
};
var faHexagonXmark = {
  prefix: 'fass',
  iconName: 'hexagon-xmark',
  icon: [576, 512, ["times-hexagon", "xmark-hexagon"], "f2ee", "M13.5 256.1l6.8-11.9 123.7-216.1 6.9-12.1 275.1 0 6.9 12.1 123.7 216.1 6.8 11.9-6.8 11.9-123.7 216.1-6.9 12.1-275.1 0-6.9-12.1-123.7-216.1-6.8-11.9zm191.1 49.9l-17 17 33.9 33.9c5.8-5.8 28.1-28.1 66.9-66.9 38.8 38.8 61.1 61.1 66.9 66.9l33.9-33.9c-5.8-5.8-28.1-28.1-66.9-66.9 38.8-38.8 61.1-61.1 66.9-66.9l-33.9-33.9c-5.8 5.8-28.1 28.1-66.9 66.9-38.8-38.8-61.1-61.1-66.9-66.9l-33.9 33.9c5.8 5.8 28.1 28.1 66.9 66.9l-49.9 49.9z"]
};
var faTimesHexagon = faHexagonXmark;
var faXmarkHexagon = faHexagonXmark;
var faShishKebab = {
  prefix: 'fass',
  iconName: 'shish-kebab',
  icon: [512, 512, [], "f821", "M439.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l22.6 22.6C405 152.8 382.7 175 349.8 208l-45.3-45.3 25.4-25.4c-17-35.7-10.8-79.7 18.8-109.3 37.5-37.5 98.3-37.5 135.8 0 31.4 31.4 36.5 79.2 15.3 115.9l-55.4-32c7.1-12.2 5.3-28.2-5.1-38.6zM104.5 453.3l-57.4 57.4-45.3-45.3 57.4-57.4 45.3 45.3zm24-245.3l88-88 176 176-88 88-176-176zM16.5 320l88-88 176 176-88 88-176-176z"]
};
var faHeadSideMask = {
  prefix: 'fass',
  iconName: 'head-side-mask',
  icon: [512, 512, [], "e063", "M445.9 193.4C431 84.2 337.3 0 224 0 139 0 65 47.4 27.1 117.2l256.2 170.8 164.7 0 0 32-4.4 16-123.6 0 0 32 114.7 0-8.9 32-105.8 0 0 32 96.9 0-8.9 32-152 0 0-136.5-247.5-165C3 182.1 0 202.7 0 224 0 285 24.4 340.4 64 380.8l0 131.2 144 0 0 0 240 0 48-192 0-64-50.1-62.6zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faHands = {
  prefix: 'fass',
  iconName: 'hands',
  icon: [512, 512, ["sign-language", "signing"], "f2a7", "M512 128c0 14.6 0 49.4-.1 104.6-.1 52.2-23.9 101-63.9 133-.8-80.9-42.8-155.8-111.5-198.8-33.1-20.7-60.1-37.6-80.8-50.5-30.5-52.8-47.5-82.3-51-88.3l41.6-24 12 20.8 84 145.5 20.8-12-63.2-109.5-12-20.8 41.6-24 12 20.8 63.2 109.5 0 0 43.3 75c0-35.8 .1-62.9 .1-81.3l64 .1zM227.9 116.2l-28.8 46.1c-22-38-35.5-61.6-40.7-70.6l41.6-24c7.3 12.7 16.7 28.9 28 48.5zm-43.2 69.1L168 212 144.7 212c-15.2-26.4-26.1-45.2-32.7-56.6l41.6-24c6.8 11.8 17.2 29.8 31.1 53.9zm61.1-37.4c12.6 7.9 41.7 26.1 87.3 54.6 51.6 32.2 82.9 88.7 82.9 149.5l0 8C416 444 348 512 264 512l-200 0 0-48 128 0 0-24-160 0 0-48 160 0 0-24-192 0 0-48 192 0 0-24-160 0 0-48 160 0 0 0 93.2 0c-34-21.2-58.4-36.5-73.3-45.8l33.9-54.3z"]
};
var faSignLanguage = faHands;
var faSigning = faHands;
var faTablets = {
  prefix: 'fass',
  iconName: 'tablets',
  icon: [512, 512, [], "f490", "M512 144c0-31.1-9.9-59.9-26.6-83.4L284.6 261.4c23.5 16.8 52.3 26.6 83.4 26.6 79.5 0 144-64.5 144-144zm-288 0c0 31.1 9.9 59.9 26.6 83.4L451.4 26.6C427.9 9.9 399.1 0 368 0 288.5 0 224 64.5 224 144zm-80 80C72.6 224 13.4 275.9 2 344l284 0c-1.6-9.4-4.1-18.5-7.3-27.1-37.4-18.1-68-48-87-84.8-14.9-5.2-30.9-8.1-47.6-8.1zM2 392c11.4 68.1 70.7 120 142 120s130.6-51.9 142-120L2 392z"]
};
var faWeightHanging = {
  prefix: 'fass',
  iconName: 'weight-hanging',
  icon: [512, 512, [], "f5cd", "M256 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm90.5 0c3.5-10 5.5-20.8 5.5-32 0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32l-77.5 0-88 384 512 0-88-384-77.5 0z"]
};
var faPinball = {
  prefix: 'fass',
  iconName: 'pinball',
  icon: [448, 512, [], "e229", "M352 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM34.3 361.6c9.2 7.7 19.9 13.8 32 17.7l307.8 99.1 29.6-55.7-246-208.3c-40.6-34.1-101.2-28.8-135.2 11.8S-6.3 327.5 34.3 361.6zM64 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faDice = {
  prefix: 'fass',
  iconName: 'dice',
  icon: [576, 512, [127922], "f522", "M344.6 400.3L432.7 71.7 104.1-16.3 16 312.3 344.6 400.3zM196.6 208a32 32 0 1 1 55.4-32 32 32 0 1 1 -55.4 32zm-85.3 12.3a32 32 0 1 1 32 55.4 32 32 0 1 1 -32-55.4zm185 96.4a32 32 0 1 1 -32-55.4 32 32 0 1 1 32 55.4zm9-208.4a32 32 0 1 1 32 55.4 32 32 0 1 1 -32-55.4zm-121 14.4a32 32 0 1 1 -32-55.4 32 32 0 1 1 32 55.4zm40 295.1l0 94.2 320 0 0-320-94.2 0-71.6 267.1-154.2-41.3z"]
};
var faShopSlash = {
  prefix: 'fass',
  iconName: 'shop-slash',
  icon: [576, 512, ["store-alt-slash"], "e070", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-5.9-5.9-28-28-66.1-66.1l0-190 48 0 0-64-80-160-382 0-48.9-48.9zM322.2 256l126 0 0 126-126-126zm-194 0l58.2 0-134.8-134.8-35.4 70.8 0 64 48 0 0 224 288 0 0-58.2-64-64 0 26.2-160 0 0-128z"]
};
var faStoreAltSlash = faShopSlash;
var faSortDown = {
  prefix: 'fass',
  iconName: 'sort-down',
  icon: [448, 512, ["sort-desc"], "f0dd", "M8 288L224 520 440 288 8 288z"]
};
var faSortDesc = faSortDown;
var faCommentExclamation = {
  prefix: 'fass',
  iconName: 'comment-exclamation',
  icon: [512, 512, [], "f4af", "M256 0C397.4 0 512 107.5 512 240S397.4 480 256 480c-38.3 0-74.7-7.9-107.3-22.1L0 512 55.7 389.5C20.8 348.5 0 296.5 0 240 0 107.5 114.6 0 256 0zM228 308l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0z"]
};
var faTableLayout = {
  prefix: 'fass',
  iconName: 'table-layout',
  icon: [448, 512, [], "e290", "M448 32l-448 0 0 448 448 0 0-448zM384 96l0 64-320 0 0-64 320 0zM64 224l64 0 0 192-64 0 0-192zm320 0l0 192-192 0 0-192 192 0z"]
};
var faPesetaSign = {
  prefix: 'fass',
  iconName: 'peseta-sign',
  icon: [448, 512, [], "e221", "M112 32l-32 0 0 136-48 0 0 48 48 0 0 264 64 0 0-128 96 0c80.2 0 146.6-59 158.2-136l49.8 0 0-48-49.8 0C386.6 91 320.2 32 240 32L112 32zM333 168l-189 0 0-72 96 0c44.7 0 82.3 30.6 93 72zM144 216l189 0c-10.7 41.4-48.2 72-93 72l-96 0 0-72z"]
};
var faTabletScreenButton = {
  prefix: 'fass',
  iconName: 'tablet-screen-button',
  icon: [448, 512, ["tablet-alt"], "f3fa", "M0 0L448 0 448 512 0 512 0 0zM256 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64l-320 0 0 288 320 0 0-288z"]
};
var faTabletAlt = faTabletScreenButton;
var faUserViewfinder = {
  prefix: 'fass',
  iconName: 'user-viewfinder',
  icon: [512, 512, [], "e775", "M24 0l-24 0 0 160 48 0 0-112 112 0 0-48-136 0zM376 0l-24 0 0 48 112 0 0 112 48 0 0-160-136 0zM48 376l0-24-48 0 0 160 160 0 0-48-112 0 0-88zm464 0l0-24-48 0 0 112-112 0 0 48 160 0 0-136zM328 168a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm24 120l-192 0-37.3 112 266.7 0-37.3-112z"]
};
var faHandHoldingDollar = {
  prefix: 'fass',
  iconName: 'hand-holding-dollar',
  icon: [576, 512, ["hand-holding-usd"], "f4c0", "M312-16l-48 0 0 36-1.8 0c-36.6 0-66.2 29.7-66.2 66.2 0 33.4 24.9 61.6 58 65.7l61 7.6c5.1 .6 9 5 9 10.2 0 5.7-4.6 10.2-10.2 10.2l-101.8 0 0 56 52 0 0 36 48 0 0-36 1.8 0c36.6 0 66.2-29.7 66.2-66.2 0-33.4-24.9-61.6-58-65.7l-61-7.6c-5.1-.6-9-5-9-10.2 0-5.7 4.6-10.2 10.2-10.2l93.8 0 0-56-44 0 0-36zM137.4 313.4l-70.6 70.6-66.7 0 0 128 396.4 0 10.2-7c101.2-69.6 154.8-106.4 161-110.7l-45.3-65.9c-11.7 8.1-54.2 37.3-127.5 87.6l-138.8 0 0-48 128 0 0-64-237.3 0-9.4 9.4z"]
};
var faHandHoldingUsd = faHandHoldingDollar;
var faHorseSaddle = {
  prefix: 'fass',
  iconName: 'horse-saddle',
  icon: [576, 512, [], "f8c3", "M448 160l0 80 0 0c-.5 30-12.8 56.4-32 75.7l0 196.3-96 0 0-165.3c-4.1-.7-8.2-1.6-12.3-2.8l-51.7-14.8 0-73.1 64 0 0-128C320 57.3 377.3 0 448 0l128 0 0 32-32 0 32 32 0 128-80 32-32-64-16 0zM224 256l0 99.9c-7.2 7.2-20.9 20.9-41.1 41.1l38.3 115-101.2 0c-29.8-89.3-45.4-136.3-47-141 13.1-13.1 28.9-28.9 47.6-47.6L78.2 259.9c-7.3-11-11.9-23.4-13.6-36.4-10.1 7.3-16.7 19.1-16.7 32.5l0 80-48 0 0-80c0-44.6 33.2-81.5 76.3-87.2 11.4-18.7 29.9-32.7 51.7-38.2l0 125.4 96 0zm-64-32l0-96 128 0 0 96-128 0zM512 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faShield = {
  prefix: 'fass',
  iconName: 'shield',
  icon: [512, 512, [128737, "shield-blank"], "f132", "M267.6 4.5L256 0 244.5 4.5 37 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9 32.7 75.3 91 150 189.4 192.6l12.7 5.5 12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6 32.4-74.7 40.2-151 37.3-200.9L494.3 92.5 475.1 85 267.6 4.5z"]
};
var faShieldBlank = faShield;
var faPeach = {
  prefix: 'fass',
  iconName: 'peach',
  icon: [512, 512, [], "e20b", "M344 80c-31.5 0-61.4 7.3-88 20.4-26.6-13-56.5-20.4-88-20.4-10 0-19.9 .7-29.6 2.2-16.4-17.2-26.4-40.5-26.4-66.2l0-16 48 0c53 0 96 43 96 96 0-53 43-96 96-96l48 0 0 16c0 25.6-10.1 48.9-26.4 66.2-9.6-1.4-19.5-2.2-29.6-2.2zM168 112c31.9 0 61.7 8.9 87.1 24.3l.9 .5c48 29.6 80 82.6 80 143.1l32 0c0-64.8-30.8-122.4-78.6-158.9 17.1-5.9 35.5-9.1 54.6-9.1 92.8 0 168 75.2 168 168 0 152-256 232-256 232S0 432 0 280c0-92.8 75.2-168 168-168z"]
};
var faFaceLaugh = {
  prefix: 'fass',
  iconName: 'face-laugh',
  icon: [512, 512, ["laugh"], "f599", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-80c-83 0-151.2-63.1-159.2-144l318.4 0c-8 80.9-76.2 144-159.2 144zM144 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faLaugh = faFaceLaugh;
var faBellSchoolSlash = {
  prefix: 'fass',
  iconName: 'bell-school-slash',
  icon: [576, 512, [], "f5d6", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-9.9-9.9-24-24-42.1-42.1l0-76.4c14.3-8.3 24-23.8 24-41.6 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.8 9.7 33.3 24 41.6l0 28.4-67.9-67.9c37-37.6 59.9-89.1 59.9-146.1 0-114.9-93.1-208-208-208-56.9 0-108.5 22.9-146.1 59.9L49.3-16.9zM216.6 150.4c14.4-13.9 34-22.4 55.5-22.4 44.2 0 80 35.8 80 80 0 21.6-8.5 41.2-22.4 55.5l-34-34c5.2-5.7 8.4-13.3 8.4-21.6 0-17.7-14.3-32-32-32-8.3 0-15.9 3.2-21.6 8.4l-34-34zM370.9 440.6c-30.4 12.7-63.7 19.7-98.7 19.7-53.4 0-103-16.3-144-44.3l0 96 314.2 0-71.4-71.4zm-34.6-34.6l-262-262c-6.5 20.2-10.1 41.7-10.1 64.1 0 114.9 93.1 208 208 208 22.4 0 43.9-3.5 64.1-10.1z"]
};
var faAlignSlash = {
  prefix: 'fass',
  iconName: 'align-slash',
  icon: [576, 512, [], "f846", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-143.1-143.1 94 0 0-64-158 0-64-64 222 0 0-64-286 0-64-64 350 0 0-64-414 0-48.9-48.9zM410.3 480l-64-64-282.2 0 0 64 346.2 0zm-192-192l-154.2 0 0 64 218.2 0-64-64zM90.3 160l-26.2 0 0 64 90.2 0-64-64z"]
};
var faCloudExclamation = {
  prefix: 'fass',
  iconName: 'cloud-exclamation',
  icon: [576, 512, [], "e491", "M240 32c55.4 0 103.5 31.3 127.6 77.1 14.2-8.3 30.8-13.1 48.4-13.1 53 0 96 43 96 96l0 49.1c38.3 22.1 64 63.5 64 110.9l0 128-576 0 0-144c0-62.7 40.1-116 96-135.8L96 176C96 96.5 160.5 32 240 32zm20 324l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0z"]
};
var faHandsHolding = {
  prefix: 'fass',
  iconName: 'hands-holding',
  icon: [640, 512, [], "f4c2", "M80 104l0 186.7 84.1 84.1 41.7-27.8c-102.9-102.9-58.7-58.7-91-91L160 210.7c44.2 44.2 69.7 69.7 118.6 118.6l9.4 9.4 0 173.3-141.3 0-9.4-9.4-128-128-9.4-9.4 0-301.3 80 0 0 40zm480 0l0-40 80 0 0 301.3-9.4 9.4-128 128-9.4 9.4-141.3 0 0-173.3 73.4-73.4c36.1-36.2 34.5-34.5 54.6-54.6L525.3 256c-48.8 48.8-65.1 65.1-91 91l41.7 27.8 84.1-84.1 0-186.7z"]
};
var faCartShopping = {
  prefix: 'fass',
  iconName: 'cart-shopping',
  icon: [640, 512, [128722, "shopping-cart"], "f07a", "M24-16l-24 0 0 48 76 0 60.4 332.3 3.6 19.7 340 0 0-48-300 0-8.7-48 356.7 0 48-256-451.2 0c-3.7-20.3-6.6-36.3-8.7-48L24-16zM208 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm224 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faShoppingCart = faCartShopping;
var faTrianglePersonDigging = {
  prefix: 'fass',
  iconName: 'triangle-person-digging',
  icon: [576, 512, ["construction"], "f85d", "M16 480L288-16 560 480 16 480zM214.1 256l-.4 .8c-2.2 4.4-5.8 11.6-10.8 21.7l13.3 7.5 77.5 43.3 61.6 37-27.3 49.8 136 0-68-124-25.3 46.2-56.7-34-23.6-47.3-.4-.8-75.8 0zM288 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-98.8 83.4l-7.9 15.8-43.7 87.7-2.6 5.1 35.7 0 31.3-62.8 37.9 23.7 0 39.1 32 0 0-56.9-7.5-4.7c-47.8-29.9-72.9-45.6-75.3-47.1z"]
};
var faConstruction = faTrianglePersonDigging;
var faSquareColon = {
  prefix: 'fass',
  iconName: 'square-colon',
  icon: [448, 512, [], "e73a", "M448 32l-448 0 0 448 448 0 0-448zM247.2 117.1l-4.1 12.4c9.7 1.4 19 4 27.8 7.4 7.5-22.4 12.5-37.4 15-45.1l30.4 10.1c-2.2 6.7-7.9 23.6-16.9 50.6 10.3 7.5 19.4 16.5 27 26.6L288 208c-1.6-2.1-3.3-4.2-5.1-6.1L238.6 334.7c20.1-3.7 37.5-14.9 49.4-30.7l38.4 28.8c-23.3 31-60.5 51.2-102.4 51.2-.6 0-1.2 0-1.8 0-5 15-9 27.1-12.1 36.3l-30.4-10.1c3.4-10.1 6.8-20.3 10.2-30.7-9.4-2.6-18.3-6.2-26.7-10.7-9.3 27.8-15 44.9-17.2 51.5l-30.4-10.1c1.7-5 8.5-25.4 20.4-61.1-24.7-23.3-40.1-56.4-40.1-93.1 0-65.8 49.7-120 113.5-127.2l12.3-37 30.4 10.1-5.1 15.2zm8.5 65.4c-8.7-3.7-18.2-6-28.1-6.4L178.9 322c7.9 5.4 16.8 9.4 26.4 11.7l50.4-151.3zm-64.1 .4c-28 12.5-47.5 40.5-47.5 73.1 0 14.2 3.7 27.5 10.1 39l37.4-112.1z"]
};
var faSubtitlesSlash = {
  prefix: 'fass',
  iconName: 'subtitles-slash',
  icon: [576, 512, [], "e610", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-6.3-6.3-27.7-27.7-64.1-64.1l30 0 0-384-414 0-80.9-80.9zM402.2 336l78 0 0 48-30 0-48-48zM378.3 448l-64-64-218.2 0 0-48 170.2 0-48-48-122.2 0 0-48 74.2 0-138.2-138.2 0 346.2 346.2 0zM480.1 240l0 48-112 0 0-48 112 0z"]
};
var faSquareD = {
  prefix: 'fass',
  iconName: 'square-d',
  icon: [448, 512, [], "e268", "M448 32l-448 0 0 448 448 0 0-448zM152 144l72 0c61.9 0 112 50.1 112 112S285.9 368 224 368l-96 0 0-224 24 0zm24 176l48 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-48 0 0 128z"]
};
var faFolderMedical = {
  prefix: 'fass',
  iconName: 'folder-medical',
  icon: [512, 512, [], "e18c", "M512 448l-512 0 0-416 224 0 64 48 224 0 0 368zM224 184l0 56-56 0 0 64 56 0 0 56 64 0 0-56 56 0 0-64-56 0 0-56-64 0z"]
};
var faChartScatterBubble = {
  prefix: 'fass',
  iconName: 'chart-scatter-bubble',
  icon: [512, 512, [], "e0e9", "M64 32l0 384 448 0 0 64-512 0 0-448 64 0zm64 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM192 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM384 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faHatWitch = {
  prefix: 'fass',
  iconName: 'hat-witch',
  icon: [512, 512, [], "f6e7", "M80 400l112-272 192-128 32 0 96 96 0 96-47.5-47.5c-10.6-10.6-24.9-16.5-39.9-16.5l-5.2 0c-21.1 0-39.9 13.5-46.6 33.6-3.1 9.4-3.4 19.5-.6 29L432 400 80 400zM0 512l0-64 512 0 0 64-512 0z"]
};
var faBin = {
  prefix: 'fass',
  iconName: 'bin',
  icon: [576, 512, [], "e763", "M576 64l-576 0 0 64 34.9 0 29.1 320 448 0 29.1-320 34.9 0 0-64z"]
};
var faGarageCar = {
  prefix: 'fass',
  iconName: 'garage-car',
  icon: [576, 512, [], "e00a", "M0 512l0-416 288-96 288 96 0 416-64 0 0-320-448 0 0 320-64 0zM207.1 240l175.7 0 6.9 12.1 55.1 96 3.2 5.5 0 158.4-64 0 0-48-192 0 0 48-64 0 0-158.4 3.2-5.5 55.1-96 6.9-12.1 13.9 0zm175.4 96l-27.6-48-134 0-27.6 48 189.1 0zM208 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCalendarClock = {
  prefix: 'fass',
  iconName: 'calendar-clock',
  icon: [576, 512, ["calendar-time"], "e0d2", "M192 0l0 64 128 0 0-64 64 0 0 64 96 0 0 112-448 0 0-112 96 0 0-64 64 0zM32 224l323.1 0c-67.8 29.6-115.1 97.3-115.1 176 0 28.6 6.2 55.6 17.4 80L32 480 32 224zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 96 80 0 0-32-48 0 0-64z"]
};
var faCalendarTime = faCalendarClock;
var faOctagon = {
  prefix: 'fass',
  iconName: 'octagon',
  icon: [512, 512, [128721], "f306", "M0 352L0 160 160 0 352 0 512 160 512 352 352 512 160 512 0 352z"]
};
var faHandPointer = {
  prefix: 'fass',
  iconName: 'hand-pointer',
  icon: [448, 512, [], "f25a", "M128 0l80 0 0 176 80 0 0 32 80 0 0 32 80 0 0 144c0 70.7-57.3 128-128 128l-85.3 0c-5 0-9.9-.3-14.7-1-55.3-5.6-106.2-34-140-79-42.6-56.8-69.2-92.3-79.9-106.6l64-48 63.9 85.2 0-362.7zM240 304l0-16-32 0 0 128 32 0 0-112zm64-16l-32 0 0 128 32 0 0-128zm64 16l0-16-32 0 0 128 32 0 0-112z"]
};
var faRabbit = {
  prefix: 'fass',
  iconName: 'rabbit',
  icon: [512, 512, [128007], "f708", "M311.9 128l24 0c1-23.7-2.8-47.2-11-69.2 7.6-17.8 18.6-34.2 32.7-48.3L368 0 392 8 395 19.9c10.4 41.6 3.3 85.1-18.6 120.8l71.7 58.4 0 88.9-96 0 0 10.3 78 210.6 1.2 3.1-68.2 0-45.2-121.9-52.1 57.9 54.4 0 0 64-224 0 0-40.8C85.8 481.6 71.7 488 56 488 25.1 488 0 462.9 0 432s25.1-56 56-56c17.4 0 33 8 43.3 20.5 14.7-78.7 77.5-140.5 156.7-153.8l0-88.8c-29.7-37.6-42.4-86.4-34-134.4l2-11.5 32-8 10.4 10.3C298 41.7 314.1 84.6 311.9 128zM368 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faCircleaporeDollar = {
  prefix: 'fass',
  iconName: 'circleapore-dollar',
  icon: [512, 512, [], "e71e", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm88-392l0 32 32 0 0 48-48.4 0c-8.6 0-15.6 7-15.6 15.6 0 7.4 5.2 13.8 12.5 15.3l16.4 3.3c29.7 5.9 51.1 32 51.1 62.3 0 29.7-20.4 54.7-48 61.6l0 33.9-32 0 0-32-40 0 0-48 56.4 0c8.6 0 15.6-7 15.6-15.6 0-7.4-5.2-13.8-12.5-15.3l-16.4-3.3c-29.7-5.9-51.1-32-51.1-62.3 0-29.7 20.4-54.7 48-61.6l0-33.9 32 0zM120 215.6c0-35.1 28.5-63.6 63.6-63.6l48.4 0 0 48-48.4 0c-8.6 0-15.6 7-15.6 15.6 0 7.4 5.2 13.8 12.5 15.3l16.4 3.3c29.7 5.9 51.1 32 51.1 62.3 0 35.1-28.5 63.6-63.6 63.6l-56.4 0 0-48 56.4 0c8.6 0 15.6-7 15.6-15.6 0-7.4-5.2-13.8-12.5-15.3l-16.4-3.3c-29.7-5.9-51.1-32-51.1-62.3z"]
};
var faSushi = {
  prefix: 'fass',
  iconName: 'sushi',
  icon: [576, 512, [127843, "nigiri"], "e48a", "M479.7 320l-69.9-23.2 99.3-168.1c23.3 26.2 39.5 59 45.6 95.7L576 352c-41.4-13.7-73.5-24.4-96.3-32l0 0zM397.7 66.7c29.9 5.1 57.5 17.1 81.2 34.4l-108 182.7-84.9-28.2 111.7-189zM352.9 64L229.7 272.4 102 316.7 251.3 64 352.9 64zM21.3 224.4C36.4 133.8 113.5 66.9 204.8 64.1L43.6 336.9 0 352 21.3 224.4zM96 448c-32.8 0-59.8-24.7-63.6-56.4L282.2 305 543.5 391.8c-3.8 31.7-30.8 56.2-63.5 56.2-19.1 0-36.3-8.4-48-21.7-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7C132.3 439.6 115.1 448 96 448z"]
};
var faNigiri = faSushi;
var faScannerGun = {
  prefix: 'fass',
  iconName: 'scanner-gun',
  icon: [576, 512, ["scanner"], "f488", "M112 32C50.1 32 0 82.1 0 144S50.1 256 112 256l0 224 144 0 32-224 48 0 32-224-256 0zm304 0l0 48 160 0 0-48-160 0zm0 160l0 48 160 0 0-48-160 0zM576 432l-160 0 0 48 160 0 0-48zM416 128l0 32 160 0 0-32-160 0zM576 288l-160 0 0 32 160 0 0-32zM416 352l0 32 160 0 0-32-160 0z"]
};
var faScanner = faScannerGun;
var faPencilMechanical = {
  prefix: 'fass',
  iconName: 'pencil-mechanical',
  icon: [576, 512, [], "e5ca", "M513.9 110.1l46.1-46.1-80-80-46.1 46.1 80 80zM297 31l-17-17-17 17-128 128-17 17 33.9 33.9 17-17 111-111 35 35-219 219-32 112-32 32 32 32 32-32 0 0 112-32 254.1-254.1 33.9-33.9C446.8 110.8 394.2 58.2 384 48L350.1 81.9 349 83 297 31zM121.1 422.9l17.3-60.5 43.2 43.2-60.5 17.3z"]
};
var faHandHoldingSeedling = {
  prefix: 'fass',
  iconName: 'hand-holding-seedling',
  icon: [576, 512, [], "f4bf", "M96 0c0 88.4 71.6 160 160 160l0 96 64 0 0-96c88.4 0 160-71.6 160-160L416 0c-52.3 0-98.8 25.1-128 64-29.2-38.9-75.7-64-128-64L96 0zm41.4 313.4l-70.6 70.6-66.7 0 0 128 396.4 0 10.2-7c101.2-69.6 154.8-106.4 161-110.7l-45.3-65.9c-11.7 8.1-54.2 37.3-127.5 87.6l-138.8 0 0-48 128 0 0-64-237.3 0-9.4 9.4z"]
};
var faLocationQuestion = {
  prefix: 'fass',
  iconName: 'location-question',
  icon: [384, 512, ["map-marker-question"], "f60b", "M0 188.6C0 84.4 86 0 192 0S384 84.4 384 188.6C384 339.4 192 528 192 528S0 339.4 0 188.6zm192-39.4c17.7 0 32 14.3 32 32 0 13.2-6.8 20.5-15.8 25.6-9.4 5.3-20 6.6-30.5 8-2.3 .3-4.6 .6-6.9 .9l0 53.5 42.4 0 0-18.3c4.8-1.7 10.3-4 15.8-7.1 17.6-9.9 37.4-29.2 37.4-62.5 0-41.1-33.3-74.4-74.4-74.4s-74.4 33.3-74.4 74.4l42.4 0c0-17.7 14.3-32 32-32zM168 296l0 48 48 0 0-48-48 0z"]
};
var faMapMarkerQuestion = faLocationQuestion;
var faUp = {
  prefix: 'fass',
  iconName: 'up',
  icon: [448, 512, ["arrow-alt-up"], "f357", "M224 32l-208 224 144 0 0 224 128 0 0-224 144 0-208-224z"]
};
var faArrowAltUp = faUp;
var faArrowUpArrowDown = {
  prefix: 'fass',
  iconName: 'arrow-up-arrow-down',
  icon: [576, 512, ["sort-up-down"], "e099", "M182.9 9.4L160.3-13.3c-2.9 2.9-42.4 42.4-118.6 118.6L19 128 64.3 173.3c12-12 33.3-33.3 64-64l0 402.7 64 0 0-402.7c30.7 30.7 52 52 64 64L301.5 128c-2.9-2.9-42.4-42.4-118.6-118.6zm256 493.3l118.6-118.6-45.3-45.3-64 64 0-402.7-64 0 0 402.7-64-64-45.3 45.3c2.9 2.9 42.4 42.4 118.6 118.6l22.6 22.6 22.6-22.6z"]
};
var faSortUpDown = faArrowUpArrowDown;
var faScarecrow = {
  prefix: 'fass',
  iconName: 'scarecrow',
  icon: [512, 512, [], "f70d", "M368.2 80c0 17.2-3.9 33.5-10.8 48l120.7 0c-12.6 18.8-20.6 30.9-24.2 36.3 13.7 10.3 26.1 19.5 37 27.7-10.9 8.2-23.2 17.4-37 27.7 3.6 5.4 11.6 17.5 24.2 36.3l-122.4 0 28.2 140.9 3.8 19.1-99.5 0 0 128-64 0 0-128-99.5 0 3.8-19.1 28.2-140.9-122.4 0c12.6-18.8 20.6-30.9 24.2-36.3-13.7-10.3-26.1-19.5-37-27.7 10.9-8.2 23.2-17.4 37-27.7-3.6-5.4-11.6-17.5-24.2-36.3l120.7 0c-6.9-14.5-10.8-30.8-10.8-48 0-61.9 50.1-112 112-112s112 50.1 112 112zm-128-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faLocationCrosshairsSlash = {
  prefix: 'fass',
  iconName: 'location-crosshairs-slash',
  icon: [576, 512, ["location-slash"], "f603", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-115.6-115.6c24.6-30.6 41.4-67.8 47.2-108.5l50.3 0 0-64-50.3 0c-14-98.1-91.6-175.7-189.7-189.7l0-50.3-64 0 0 50.3c-40.7 5.8-77.9 22.6-108.5 47.2L49.3-16.9zm144 144c26.5-19.6 59.3-31.1 94.8-31.1 88.4 0 160 71.6 160 160 0 35.5-11.6 68.3-31.1 94.8l-46.1-46.1c8.4-14.3 13.3-30.9 13.3-48.7 0-53-43-96-96-96-17.8 0-34.4 4.8-48.7 13.3l-46.1-46.1zM338.3 408c-15.8 5.2-32.6 8-50.2 8-88.4 0-160-71.6-160-160 0-17.5 2.8-34.4 8-50.2l-49-49C76.9 177.6 69.8 200.2 66.4 224l-50.3 0 0 64 50.3 0c14 98.1 91.6 175.7 189.7 189.7l0 50.3 64 0 0-50.3c23.8-3.4 46.4-10.5 67.1-20.8l-49-49zm-146-146c3 48.2 41.6 86.8 89.8 89.8L192.3 262z"]
};
var faLocationSlash = faLocationCrosshairsSlash;
var faRegistered = {
  prefix: 'fass',
  iconName: 'registered',
  icon: [512, 512, [174], "f25d", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 144l104 0c39.8 0 72 32.2 72 72 0 29.5-17.7 54.8-43.1 66l40.2 74.7 6.1 11.4-54.5 0-43.1-80-33.7 0 0 80-48 0 0-224zM318 400l1.2 0-.9 .5-.3-.5zM224 240l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0 48z"]
};
var faRectanglePro = {
  prefix: 'fass',
  iconName: 'rectangle-pro',
  icon: [576, 512, ["pro"], "e235", "M576 64l-576 0 0 384 576 0 0-384zM88 160l40 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-16 0 0 64-48 0 0-192 24 0zm40 80c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0 32 16 0zm120-80l36 0c37.6 0 68 30.4 68 68 0 17.4-6.5 33.2-17.2 45.3 10.8 12.6 17.2 28.9 17.2 46.7l0 32-48 0 0-32c0-13.3-10.7-24-24-24l-8 0 0 56-48 0 0-192 24 0zm32 88l4 0c11 0 20-9 20-20s-9-20-20-20l-12 0 0 40 8 0zm152-32l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8zm8-56l16 0c30.9 0 56 25.1 56 56l0 80c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-80c0-30.9 25.1-56 56-56z"]
};
var faPro = faRectanglePro;
var faBreadSliceButter = {
  prefix: 'fass',
  iconName: 'bread-slice-butter',
  icon: [512, 512, [], "e3e1", "M0 192c0 35.3 28.7 64 64 64l0 224 384 0 0-224c35.3 0 64-28.7 64-64 0-216.5-512-216.5-512 0zM256 376l-88-88 88-88 88 88-88 88z"]
};
var faLightCeiling = {
  prefix: 'fass',
  iconName: 'light-ceiling',
  icon: [512, 512, [], "e016", "M512 416c0-130.5-97.7-238.3-224-254l0-162-64 0 0 162C97.7 177.7 0 285.5 0 416l137.3 0c19 46.9 65 80 118.7 80s99.7-33.1 118.7-80L512 416zm-192 0c-14.6 19.4-37.8 32-64 32s-49.4-12.6-64-32l128 0z"]
};
var faUserHairMullet = {
  prefix: 'fass',
  iconName: 'user-hair-mullet',
  icon: [448, 512, ["business-front", "party-back", "trian-balbot"], "e45c", "M144 144l0-32 64 0 16-48 16 48 64 0 0 32c0 44.2-35.8 80-80 80s-80-35.8-80-80zm208 0l0-32 16 0 0-48-26.8 0C323.2 26.2 284.7 0 240 0L208 0c-44.7 0-83.2 26.2-101.2 64l-26.8 0 0 48 16 0 0 32c0 25.1 7.3 48.6 19.8 68.4L80 272 368 272 332.2 212.4C344.7 192.6 352 169.1 352 144zm80 368l-64-192-288 0-64 192 416 0z"]
};
var faBusinessFront = faUserHairMullet;
var faPartyBack = faUserHairMullet;
var faTrianBalbot = faUserHairMullet;
var faSquareParkingSlash = {
  prefix: 'fass',
  iconName: 'square-parking-slash',
  icon: [576, 512, ["parking-slash"], "f617", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-5.9-5.9-28-28-66.1-66.1l0-414-414 0-48.9-48.9zM194.2 128l110 0c53 0 96 43 96 96 0 30.1-13.8 56.9-35.5 74.5l-46-46c10.4-5.3 17.5-16.1 17.5-28.5 0-17.7-14.3-32-32-32l-46 0-64-64zm62 197.8l0 58.2-64 0 0-122.2-128-128 0 346.2 346.2 0-154.2-154.2z"]
};
var faParkingSlash = faSquareParkingSlash;
var faLinkSimpleSlash = {
  prefix: 'fass',
  iconName: 'link-simple-slash',
  icon: [576, 512, [], "e1ce", "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-1.5-1.5-32.5-32.5-92.9-92.9 54.5-33.9 90.8-94.3 90.8-163.2 0-106-86-192-192-192l-64 0 0 64 64 0c70.7 0 128 57.3 128 128 0 51.4-30.3 95.7-73.9 116l-84-84 62 0 0-64-126 0-96-96 62 0 0-64-64 0c-18.8 0-37 2.7-54.2 7.8L49.3-16.9zM98.8 168.4L53.5 123.2c-33 34.5-53.4 81.3-53.4 132.8 0 106 86 192 192 192l64 0 0-64-64 0c-70.7 0-128-57.3-128-128 0-33.9 13.2-64.7 34.6-87.6z"]
};
var faHouseSignal = {
  prefix: 'fass',
  iconName: 'house-signal',
  icon: [576, 512, [], "e012", "M493.5 240l50.5 0 0-40-240-216-240 216 0 42.7C176.1 258.2 266.8 340.4 295 448l198.6 0 0-208zM24 288l-24 0 0 48 24 0c101.6 0 184 82.4 184 184l0 24 48 0 0-24c0-128.1-103.9-232-232-232zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 192l96 0 0 96-96 0 0-96zM0 384l0 48 24 0c48.6 0 88 39.4 88 88l0 24 48 0 0-24c0-75.1-60.9-136-136-136L0 384z"]
};
var faLockKeyhole = {
  prefix: 'fass',
  iconName: 'lock-keyhole',
  icon: [384, 512, ["lock-alt"], "f30d", "M192 32c35.3 0 64 28.7 64 64l0 64-128 0 0-64c0-35.3 28.7-64 64-64zM64 96l0 64-64 0 0 352 384 0 0-352-64 0 0-64c0-70.7-57.3-128-128-128S64 25.3 64 96zM216 296l0 104-48 0 0-128 48 0 0 24z"]
};
var faLockAlt = faLockKeyhole;
var faTally2 = {
  prefix: 'fass',
  iconName: 'tally-2',
  icon: [448, 512, [], "e295", "M64 64l0-32-64 0 0 448 64 0 0-416zm128 0l0-32-64 0 0 448 64 0 0-416z"]
};
var faBangladeshiTakaSign = {
  prefix: 'fass',
  iconName: 'bangladeshi-taka-sign',
  icon: [384, 512, [], "e2e6", "M0 96l32 0c17.7 0 32 14.3 32 32l0 32-64 0 0 48 64 0 0 176c0 53 43 96 96 96l32 0c106 0 192-86 192-192l0-32c0-53-43-96-96-96l-32 0 0 64 32 0c17.7 0 32 14.3 32 32l0 32c0 70.7-57.3 128-128 128l-32 0c-17.7 0-32-14.3-32-32l0-176 64 0 0-48-64 0 0-32c0-53-43-96-96-96L0 32 0 96z"]
};
var icons = {
  fa0: fa0,
  fa1: fa1,
  fa2: fa2,
  fa3: fa3,
  fa4: fa4,
  fa5: fa5,
  fa6: fa6,
  fa7: fa7,
  fa8: fa8,
  fa9: fa9,
  faChessPawnPiece: faChessPawnPiece,
  faChessPawnAlt: faChessPawnAlt,
  faDollarSign: faDollarSign,
  faDollar: faDollar,
  faUsd: faUsd,
  faLayerPlus: faLayerPlus,
  faLayerGroupPlus: faLayerGroupPlus,
  faGrid4: faGrid4,
  faDog: faDog,
  faTruckMoving: faTruckMoving,
  faRotate: faRotate,
  faSyncAlt: faSyncAlt,
  faArrowUTurnUpLeft: faArrowUTurnUpLeft,
  faKeyboardBrightness: faKeyboardBrightness,
  faTentDoublePeak: faTentDoublePeak,
  faSquareMinus: faSquareMinus,
  faMinusSquare: faMinusSquare,
  faWaterArrowUp: faWaterArrowUp,
  faWaterRise: faWaterRise,
  faXmarkToSlot: faXmarkToSlot,
  faTimesToSlot: faTimesToSlot,
  faVoteNay: faVoteNay,
  faSensorCloud: faSensorCloud,
  faSensorSmoke: faSensorSmoke,
  faLychee: faLychee,
  faAlignJustify: faAlignJustify,
  faSunglasses: faSunglasses,
  faCloudCheck: faCloudCheck,
  faMessageMinus: faMessageMinus,
  faCommentAltMinus: faCommentAltMinus,
  faFaceClouds: faFaceClouds,
  faLeftLongToLine: faLeftLongToLine,
  faPlaneLandingGear: faPlaneLandingGear,
  faCalendarCheck: faCalendarCheck,
  faSquareRing: faSquareRing,
  faFaceKiss: faFaceKiss,
  faKiss: faKiss,
  faCircleVideo: faCircleVideo,
  faVideoCircle: faVideoCircle,
  faCartShoppingFast: faCartShoppingFast,
  faDesktopArrowDown: faDesktopArrowDown,
  faBanjo: faBanjo,
  faCloudHailMixed: faCloudHailMixed,
  faSquareHalfStroke: faSquareHalfStroke,
  faKitchenSet: faKitchenSet,
  faDna: faDna,
  faCircleBangladeshiTaka: faCircleBangladeshiTaka,
  faBoxCircleCheck: faBoxCircleCheck,
  faTrillium: faTrillium,
  faDeleteRight: faDeleteRight,
  faCircleColon: faCircleColon,
  faChildReaching: faChildReaching,
  faFaceConfounded: faFaceConfounded,
  faSidebar: faSidebar,
  faPaste: faPaste,
  faFileClipboard: faFileClipboard,
  faInhaler: faInhaler,
  faMeteor: faMeteor,
  faHoneyPot: faHoneyPot,
  faLaptopSlash: faLaptopSlash,
  faGears: faGears,
  faCogs: faCogs,
  faWaveSine: faWaveSine,
  faArrowTurnLeftUp: faArrowTurnLeftUp,
  faGarage: faGarage,
  faFlatbreadStuffed: faFlatbreadStuffed,
  faUTurnDownLeft: faUTurnDownLeft,
  faFaceShakingHorizontal: faFaceShakingHorizontal,
  faEyes: faEyes,
  faDash: faDash,
  faMinusLarge: faMinusLarge,
  faPhotoFilmMusic: faPhotoFilmMusic,
  faLocationArrowSlash: faLocationArrowSlash,
  faCircleM: faCircleM,
  faArrowUpToDottedLine: faArrowUpToDottedLine,
  faFileCirclePlus: faFileCirclePlus,
  faMustache: faMustache,
  faWindowFrame: faWindowFrame,
  faHouseNight: faHouseNight,
  faReel: faReel,
  faIcicles: faIcicles,
  faBinarySlash: faBinarySlash,
  faSquareSlidersVertical: faSquareSlidersVertical,
  faSlidersVSquare: faSlidersVSquare,
  faArrowTrendUp: faArrowTrendUp,
  faTimelineArrow: faTimelineArrow,
  faFort: faFort,
  faCircleV: faCircleV,
  faHexagonNodesBolt: faHexagonNodesBolt,
  faLightEmergencyOn: faLightEmergencyOn,
  faQuestion: faQuestion,
  faSquareLira: faSquareLira,
  faSquareDashedCirclePlus: faSquareDashedCirclePlus,
  faChairOffice: faChairOffice,
  faUserMagnifyingGlass: faUserMagnifyingGlass,
  faContainerStorage: faContainerStorage,
  faArrowLeftToBracket: faArrowLeftToBracket,
  faSparkle: faSparkle,
  faCampfire: faCampfire,
  faHandsBound: faHandsBound,
  faPanelFire: faPanelFire,
  faClockSevenThirty: faClockSevenThirty,
  faTugrikSign: faTugrikSign,
  faAudioDescriptionSlash: faAudioDescriptionSlash,
  faFaceThermometer: faFaceThermometer,
  faLightbulbCflOn: faLightbulbCflOn,
  faClockThree: faClockThree,
  faPersonWalkingLuggage: faPersonWalkingLuggage,
  faFileArrowDown: faFileArrowDown,
  faFileDownload: faFileDownload,
  faPersonBooth: faPersonBooth,
  faLocust: faLocust,
  faWindow: faWindow,
  faRightLong: faRightLong,
  faLongArrowAltRight: faLongArrowAltRight,
  faTruckDroplet: faTruckDroplet,
  faHandHoldingMedical: faHandHoldingMedical,
  faHandPointLeft: faHandPointLeft,
  faCalculator: faCalculator,
  faOilTemperature: faOilTemperature,
  faOilTemp: faOilTemp,
  faMinus: faMinus,
  faSubtract: faSubtract,
  faMessageArrowDown: faMessageArrowDown,
  faCommentAltArrowDown: faCommentAltArrowDown,
  faShoe: faShoe,
  faGameBoardSimple: faGameBoardSimple,
  faGameBoardAlt: faGameBoardAlt,
  faArrowTurnLeft: faArrowTurnLeft,
  faCircle4: faCircle4,
  faHammerWar: faHammerWar,
  faLightEmergency: faLightEmergency,
  faArrowUpZA: faArrowUpZA,
  faSortAlphaUpAlt: faSortAlphaUpAlt,
  faMicrophoneSlash: faMicrophoneSlash,
  faSquarePen: faSquarePen,
  faPenSquare: faPenSquare,
  faPencilSquare: faPencilSquare,
  faBellPlus: faBellPlus,
  faHandFist: faHandFist,
  faFistRaised: faFistRaised,
  faPants: faPants,
  faCommentSms: faCommentSms,
  faSms: faSms,
  faHeadSideGear: faHeadSideGear,
  faTransporter1: faTransporter1,
  faScannerTouchscreen: faScannerTouchscreen,
  faFlaskRoundPotion: faFlaskRoundPotion,
  faFlaskPotion: faFlaskPotion,
  faCarBolt: faCarBolt,
  faTableRows: faTableRows,
  faRows: faRows,
  faCloudSlash: faCloudSlash,
  faFaceHandYawn: faFaceHandYawn,
  faTickets: faTickets,
  faSimCard: faSimCard,
  faShieldQuartered: faShieldQuartered,
  faSquareEllipsisVertical: faSquareEllipsisVertical,
  faOven: faOven,
  faScaleBalanced: faScaleBalanced,
  faBalanceScale: faBalanceScale,
  faCar: faCar,
  faAutomobile: faAutomobile,
  faCircleBaht: faCircleBaht,
  faBadgerHoney: faBadgerHoney,
  faCropSimple: faCropSimple,
  faCropAlt: faCropAlt,
  faTimer: faTimer,
  faSquareDollar: faSquareDollar,
  faDollarSquare: faDollarSquare,
  faUsdSquare: faUsdSquare,
  faMedal: faMedal,
  faScroll: faScroll,
  faCalendars: faCalendars,
  faAppleCore: faAppleCore,
  faFileExcel: faFileExcel,
  faDiamondHalf: faDiamondHalf,
  faBaguette: faBaguette,
  faEarTriangleExclamation: faEarTriangleExclamation,
  faH5: faH5,
  faPersonSkiLift: faPersonSkiLift,
  faSkiLift: faSkiLift,
  faSquareCedi: faSquareCedi,
  faFilter: faFilter,
  faCalculatorSimple: faCalculatorSimple,
  faCalculatorAlt: faCalculatorAlt,
  faCoinBlank: faCoinBlank,
  faIntersection: faIntersection,
  faDrum: faDrum,
  faMapPin: faMapPin,
  faCircleHouse: faCircleHouse,
  faTablePivot: faTablePivot,
  faBridgeSuspension: faBridgeSuspension,
  faScaleUnbalancedFlip: faScaleUnbalancedFlip,
  faBalanceScaleRight: faBalanceScaleRight,
  faLightSwitch: faLightSwitch,
  faArrowsToCircle: faArrowsToCircle,
  faAmpersand: faAmpersand,
  faChessClock: faChessClock,
  faEnvelope: faEnvelope,
  faBaby: faBaby,
  faNfcLock: faNfcLock,
  faSquareCaretDown: faSquareCaretDown,
  faCaretSquareDown: faCaretSquareDown,
  faHyphen: faHyphen,
  faPlaneProp: faPlaneProp,
  faTent: faTent,
  faChimney: faChimney,
  faA: faA,
  faCircleSmall: faCircleSmall,
  faParachuteBox: faParachuteBox,
  faCartFlatbedBoxes: faCartFlatbedBoxes,
  faDollyFlatbedAlt: faDollyFlatbedAlt,
  faCartArrowDown: faCartArrowDown,
  faCircle7: faCircle7,
  faLockHashtag: faLockHashtag,
  faCircleSterling: faCircleSterling,
  faBridgeCircleExclamation: faBridgeCircleExclamation,
  faCloudArrowUp: faCloudArrowUp,
  faCloudUpload: faCloudUpload,
  faCloudUploadAlt: faCloudUploadAlt,
  faAt: faAt,
  faIndianRupeeSign: faIndianRupeeSign,
  faIndianRupee: faIndianRupee,
  faInr: faInr,
  faTruck: faTruck,
  faGameConsoleHandheldCrank: faGameConsoleHandheldCrank,
  faChalkboardUser: faChalkboardUser,
  faChalkboardTeacher: faChalkboardTeacher,
  faUserCheck: faUserCheck,
  faChartPieSimpleCircleCurrency: faChartPieSimpleCircleCurrency,
  faFaceFearful: faFaceFearful,
  faUserNinja: faUserNinja,
  faFrame: faFrame,
  faPlantWilt: faPlantWilt,
  faWeightScale: faWeightScale,
  faWeight: faWeight,
  faFarm: faFarm,
  faBarnSilo: faBarnSilo,
  faCaretRight: faCaretRight,
  faHexagonDivide: faHexagonDivide,
  faFlorinSign: faFlorinSign,
  faLightbulbExclamationOn: faLightbulbExclamationOn,
  faBell: faBell,
  faHandBackPointLeft: faHandBackPointLeft,
  faLariSign: faLariSign,
  faRectanglePlus: faRectanglePlus,
  faCucumber: faCucumber,
  faSeal: faSeal,
  faCircleCaretDown: faCircleCaretDown,
  faCaretCircleDown: faCaretCircleDown,
  faMillSign: faMillSign,
  faMugTeaSaucer: faMugTeaSaucer,
  faCartCircleCheck: faCartCircleCheck,
  faAlbum: faAlbum,
  faLeftToLine: faLeftToLine,
  faArrowAltToLeft: faArrowAltToLeft,
  faPersonSnowboarding: faPersonSnowboarding,
  faSnowboarding: faSnowboarding,
  faTty: faTty,
  faTeletype: faTeletype,
  faSliderCircle: faSliderCircle,
  faUsersRectangle: faUsersRectangle,
  faMobile: faMobile,
  faMobileAndroid: faMobileAndroid,
  faMobilePhone: faMobilePhone,
  faArrowsTurnToDots: faArrowsTurnToDots,
  faExclamation: faExclamation,
  faLocationXmark: faLocationXmark,
  faMapMarkerTimes: faMapMarkerTimes,
  faMapMarkerXmark: faMapMarkerXmark,
  faChurch: faChurch,
  faToggleOff: faToggleOff,
  faFaceNauseated: faFaceNauseated,
  faDeer: faDeer,
  faBoxOpenFull: faBoxOpenFull,
  faBoxFull: faBoxFull,
  faCherries: faCherries,
  faVacuumRobot: faVacuumRobot,
  faCircleEurozone: faCircleEurozone,
  faShoePrints: faShoePrints,
  faSquirrel: faSquirrel,
  faCircleCedi: faCircleCedi,
  faFileCircleExclamation: faFileCircleExclamation,
  faWallet: faWallet,
  faSquareTugrik: faSquareTugrik,
  faMessage: faMessage,
  faCommentAlt: faCommentAlt,
  faTrophy: faTrophy,
  faFaceDizzy: faFaceDizzy,
  faDizzy: faDizzy,
  faBacteria: faBacteria,
  faToggleLargeOn: faToggleLargeOn,
  faEarDeaf: faEarDeaf,
  faDeaf: faDeaf,
  faDeafness: faDeafness,
  faHardOfHearing: faHardOfHearing,
  faPeopleArrows: faPeopleArrows,
  faPeopleArrowsLeftRight: faPeopleArrowsLeftRight,
  faTreasureChest: faTreasureChest,
  faCaretLargeRight: faCaretLargeRight,
  faHandsClapping: faHandsClapping,
  faCircleAmpersand: faCircleAmpersand,
  faVirusCovidSlash: faVirusCovidSlash,
  faChartSimpleHorizontal: faChartSimpleHorizontal,
  faDownFromDottedLine: faDownFromDottedLine,
  faCalendarDays: faCalendarDays,
  faCalendarAlt: faCalendarAlt,
  faLighthouse: faLighthouse,
  faDiamondTurnRight: faDiamondTurnRight,
  faDirections: faDirections,
  faDrone: faDrone,
  faText: faText,
  faSquareGuarani: faSquareGuarani,
  faToiletPaperUnderSlash: faToiletPaperUnderSlash,
  faToiletPaperReverseSlash: faToiletPaperReverseSlash,
  faHandPointUp: faHandPointUp,
  faPenSlash: faPenSlash,
  faCommentPlus: faCommentPlus,
  faBezierCurve: faBezierCurve,
  faClipboardListCheck: faClipboardListCheck,
  faLampDesk: faLampDesk,
  faPersonHalfDress: faPersonHalfDress,
  faPeanut: faPeanut,
  faMessagePlus: faMessagePlus,
  faCommentAltPlus: faCommentAltPlus,
  faBracketCurly: faBracketCurly,
  faBracketCurlyLeft: faBracketCurlyLeft,
  faSquarePollHorizontal: faSquarePollHorizontal,
  faPollH: faPollH,
  faNfcSignal: faNfcSignal,
  faBoxIsometric: faBoxIsometric,
  faSchoolCircleXmark: faSchoolCircleXmark,
  faPersonSeatWindow: faPersonSeatWindow,
  faGrapes: faGrapes,
  faHandLizard: faHandLizard,
  faCameraSlash: faCameraSlash,
  faChalkboard: faChalkboard,
  faBlackboard: faBlackboard,
  faMemoPad: faMemoPad,
  faBluetooth: faBluetooth,
  faObjectsAlignCenterHorizontal: faObjectsAlignCenterHorizontal,
  faDistributeSpacingVertical: faDistributeSpacingVertical,
  faUpRightFromSquare: faUpRightFromSquare,
  faExternalLinkAlt: faExternalLinkAlt,
  faSquareTurkishLira: faSquareTurkishLira,
  faRotateExclamation: faRotateExclamation,
  faRightFromLine: faRightFromLine,
  faArrowAltFromLeft: faArrowAltFromLeft,
  faCircleQ: faCircleQ,
  faMoonOverSun: faMoonOverSun,
  faEclipseAlt: faEclipseAlt,
  fa360Degrees: fa360Degrees,
  faBracketRoundRight: faBracketRoundRight,
  faSquareFull: faSquareFull,
  faStarSharp: faStarSharp,
  faListRadio: faListRadio,
  faHeadSideMedical: faHeadSideMedical,
  faTombstone: faTombstone,
  faSquareALock: faSquareALock,
  faClover: faClover,
  faSignalBarsFair: faSignalBarsFair,
  faSignalAlt2: faSignalAlt2,
  faFolderHeart: faFolderHeart,
  faCloudWord: faCloudWord,
  faScreenUsers: faScreenUsers,
  faUsersClass: faUsersClass,
  faTeethOpen: faTeethOpen,
  faCircleU: faCircleU,
  faCalendarHeart: faCalendarHeart,
  faNarwhal: faNarwhal,
  faBarsStaggered: faBarsStaggered,
  faReorder: faReorder,
  faStream: faStream,
  faWarehouse: faWarehouse,
  faSwatchbook: faSwatchbook,
  faCircleThreeQuarters: faCircleThreeQuarters,
  faCircleChf: faCircleChf,
  faCampground: faCampground,
  faPersonWalkingArrowRight: faPersonWalkingArrowRight,
  faSpiderBlackWidow: faSpiderBlackWidow,
  faGlasses: faGlasses,
  faCirclePause: faCirclePause,
  faPauseCircle: faPauseCircle,
  faMemory: faMemory,
  faGift: faGift,
  faSprinklerCeiling: faSprinklerCeiling,
  faSquarePhoneHangup: faSquarePhoneHangup,
  faPhoneSquareDown: faPhoneSquareDown,
  faMoneyBillWheat: faMoneyBillWheat,
  faCircleFlorin: faCircleFlorin,
  faDungeon: faDungeon,
  faComet: faComet,
  faFaceHoldingBackTears: faFaceHoldingBackTears,
  faCardHeart: faCardHeart,
  faCarMirrors: faCarMirrors,
  faSuitcaseMedical: faSuitcaseMedical,
  faMedkit: faMedkit,
  faBlockQuote: faBlockQuote,
  faHandsHoldingHeart: faHandsHoldingHeart,
  faHandsHeart: faHandsHeart,
  faArrowUpSmallBig: faArrowUpSmallBig,
  faSortSizeUpAlt: faSortSizeUpAlt,
  faSlidersSimple: faSlidersSimple,
  faPersonCane: faPersonCane,
  faMessageMusic: faMessageMusic,
  faCommentAltMusic: faCommentAltMusic,
  faGaugeLow: faGaugeLow,
  faTachometerAltSlow: faTachometerAltSlow,
  faHexagonEquals: faHexagonEquals,
  faCapsule: faCapsule,
  faUserSith: faUserSith,
  faGauge: faGauge,
  faDashboard: faDashboard,
  faGaugeMed: faGaugeMed,
  faTachometerAltAverage: faTachometerAltAverage,
  faEnvelopeOpenText: faEnvelopeOpenText,
  faToolbox: faToolbox,
  faWheatSlash: faWheatSlash,
  faPowerOff: faPowerOff,
  faSignal: faSignal,
  faSignal5: faSignal5,
  faSignalPerfect: faSignalPerfect,
  faArrowsSpin: faArrowsSpin,
  faJoint: faJoint,
  faDownFromLine: faDownFromLine,
  faArrowAltFromTop: faArrowAltFromTop,
  faTabletRugged: faTabletRugged,
  faBraille: faBraille,
  faBasketShopping: faBasketShopping,
  faShoppingBasket: faShoppingBasket,
  faPartyBell: faPartyBell,
  faBra: faBra,
  faCarWash: faCarWash,
  faFaceSunglasses: faFaceSunglasses,
  faBridge: faBridge,
  faArrowsFromLine: faArrowsFromLine,
  faUpLongToLine: faUpLongToLine,
  faUpToLine: faUpToLine,
  faArrowAltToTop: faArrowAltToTop,
  faPlaneArrival: faPlaneArrival,
  faPotFood: faPotFood,
  faCashRegister: faCashRegister,
  faRing: faRing,
  faMessageXmark: faMessageXmark,
  faCommentAltTimes: faCommentAltTimes,
  faMessageTimes: faMessageTimes,
  faShareNodes: faShareNodes,
  faShareAlt: faShareAlt,
  faOctagonDivide: faOctagonDivide,
  faFolderArrowUp: faFolderArrowUp,
  faFolderUpload: faFolderUpload,
  faArrowsMinimize: faArrowsMinimize,
  faCompressArrows: faCompressArrows,
  faPersonCircleExclamation: faPersonCircleExclamation,
  faBinoculars: faBinoculars,
  faGridRound5: faGridRound5,
  faKipSign: faKipSign,
  faHardDrive: faHardDrive,
  faHdd: faHdd,
  faRankingStar: faRankingStar,
  faUserTie: faUserTie,
  faSquareBitcoin: faSquareBitcoin,
  faEllipsis: faEllipsis,
  faEllipsisH: faEllipsisH,
  faArrowTurnDownLeft: faArrowTurnDownLeft,
  faOctagonCheck: faOctagonCheck,
  faStore24: faStore24,
  faStoreSlash: faStoreSlash,
  faPercent: faPercent,
  faPercentage: faPercentage,
  faCircleN: faCircleN,
  faFileZipper: faFileZipper,
  faFileArchive: faFileArchive,
  faTrashCanXmark: faTrashCanXmark,
  faDisplay: faDisplay,
  faEllipsisStroke: faEllipsisStroke,
  faEllipsisHAlt: faEllipsisHAlt,
  faAirConditioner: faAirConditioner,
  faFileXls: faFileXls,
  faPinata: faPinata,
  faChartFft: faChartFft,
  faCircleUserCircleExclamation: faCircleUserCircleExclamation,
  faPhoneIntercom: faPhoneIntercom,
  faTurnLeftUp: faTurnLeftUp,
  faScarf: faScarf,
  faMessagePen: faMessagePen,
  faCommentAltEdit: faCommentAltEdit,
  faMessageEdit: faMessageEdit,
  faIcons: faIcons,
  faHeartMusicCameraBolt: faHeartMusicCameraBolt,
  faFileXml: faFileXml,
  faRulerVertical: faRulerVertical,
  faMapLocationDot: faMapLocationDot,
  faMapMarkedAlt: faMapMarkedAlt,
  faWatermelonSlice: faWatermelonSlice,
  faJackOLantern: faJackOLantern,
  faCandy: faCandy,
  faHeartCrack: faHeartCrack,
  faHeartBroken: faHeartBroken,
  faCow: faCow,
  faRss: faRss,
  faFeed: faFeed,
  faMagnifyingGlass: faMagnifyingGlass,
  faSearch: faSearch,
  faObjectsAlignLeft: faObjectsAlignLeft,
  faCloudMoon: faCloudMoon,
  faAbacus: faAbacus,
  faBoxesStacked: faBoxesStacked,
  faBoxes: faBoxes,
  faBoxesAlt: faBoxesAlt,
  faCodeBranch: faCodeBranch,
  faBan: faBan,
  faCancel: faCancel,
  faPersonCarryBox: faPersonCarryBox,
  faPersonCarry: faPersonCarry,
  faCircleLitecoin: faCircleLitecoin,
  faJugDetergent: faJugDetergent,
  faFloppyDiskPen: faFloppyDiskPen,
  faLips: faLips,
  faOutlet: faOutlet,
  faReply: faReply,
  faMailReply: faMailReply,
  faSunPlantWilt: faSunPlantWilt,
  faFaceMask: faFaceMask,
  faFalafel: faFalafel,
  faTombstoneBlank: faTombstoneBlank,
  faTombstoneAlt: faTombstoneAlt,
  faCircleCaretUp: faCircleCaretUp,
  faCaretCircleUp: faCaretCircleUp,
  faLampStreet: faLampStreet,
  faCircleB: faCircleB,
  faButterfly: faButterfly,
  faBacterium: faBacterium,
  faSquare7: faSquare7,
  faMagnifyingGlassArrowsRotate: faMagnifyingGlassArrowsRotate,
  faSquareI: faSquareI,
  faStandardDefinition: faStandardDefinition,
  faRectangleSd: faRectangleSd,
  faAlien8bit: faAlien8bit,
  faAlienMonster: faAlienMonster,
  faVacuum: faVacuum,
  faBowlChopsticksNoodles: faBowlChopsticksNoodles,
  faRecordVinyl: faRecordVinyl,
  faFloppyDisk: faFloppyDisk,
  faSave: faSave,
  faDownLeft: faDownLeft,
  faToiletsPortable: faToiletsPortable,
  faO: faO,
  faPalette: faPalette,
  faPaintbrushFineSlash: faPaintbrushFineSlash,
  faBlueberries: faBlueberries,
  faFishBones: faFishBones,
  faUnlock: faUnlock,
  faFanTable: faFanTable,
  faEarListen: faEarListen,
  faAssistiveListeningSystems: faAssistiveListeningSystems,
  faCodePullRequest: faCodePullRequest,
  faThumbtackAngle: faThumbtackAngle,
  faKey: faKey,
  faSnake: faSnake,
  faCircleWaveformLines: faCircleWaveformLines,
  faWaveformCircle: faWaveformCircle,
  faEmptySet: faEmptySet,
  faCircleWon: faCircleWon,
  faHockeyStick: faHockeyStick,
  faMonkey: faMonkey,
  faForklift: faForklift,
  faSkull: faSkull,
  faSneaker: faSneaker,
  faGamepadModern: faGamepadModern,
  faGamepadAlt: faGamepadAlt,
  faSquareK: faSquareK,
  faCommentText: faCommentText,
  faMarsStrokeUp: faMarsStrokeUp,
  faMarsStrokeV: faMarsStrokeV,
  faCowbell: faCowbell,
  faFireFlameSimple: faFireFlameSimple,
  faBurn: faBurn,
  faTree: faTree,
  faGaugeSimpleMin: faGaugeSimpleMin,
  faTachometerSlowest: faTachometerSlowest,
  faCommentsQuestionCheck: faCommentsQuestionCheck,
  faSmog: faSmog,
  faS: faS,
  faPhoneArrowUpRight: faPhoneArrowUpRight,
  faPhoneArrowUp: faPhoneArrowUp,
  faPhoneOutgoing: faPhoneOutgoing,
  faTeddyBear: faTeddyBear,
  faSlotMachine: faSlotMachine,
  faFaceSleeping: faFaceSleeping,
  faJedi: faJedi,
  faPoliceBox: faPoliceBox,
  faDogLeashed: faDogLeashed,
  faPersonHiking: faPersonHiking,
  faHiking: faHiking,
  faArrowsUpToLine: faArrowsUpToLine,
  faPenLine: faPenLine,
  faBadgePercent: faBadgePercent,
  faMarsDouble: faMarsDouble,
  faThermometer: faThermometer,
  faPaintbrush: faPaintbrush,
  faPaintBrush: faPaintBrush,
  faSignalStream: faSignalStream,
  faSquareP: faSquareP,
  faBee: faBee,
  faMusicSlash: faMusicSlash,
  faPersonSimple: faPersonSimple,
  faAlbumCollectionCircleUser: faAlbumCollectionCircleUser,
  faWhale: faWhale,
  faArrowUpTriangleSquare: faArrowUpTriangleSquare,
  faSortShapesUp: faSortShapesUp,
  faNeuter: faNeuter,
  faSquarePhoneFlip: faSquarePhoneFlip,
  faPhoneSquareAlt: faPhoneSquareAlt,
  faCircleG: faCircleG,
  faCircleDownRight: faCircleDownRight,
  faPeopleDress: faPeopleDress,
  faCircleHalf: faCircleHalf,
  faFaceGrinTongueSquint: faFaceGrinTongueSquint,
  faGrinTongueSquint: faGrinTongueSquint,
  faPickaxe: faPickaxe,
  faCommentDollar: faCommentDollar,
  faListTimeline: faListTimeline,
  faSwordsLaser: faSwordsLaser,
  faPhoneWaveform: faPhoneWaveform,
  faHippo: faHippo,
  faSwordLaserAlt: faSwordLaserAlt,
  faFlower: faFlower,
  faBowlFood: faBowlFood,
  faGlobePointer: faGlobePointer,
  faEggplant: faEggplant,
  faFolderArrowRight: faFolderArrowRight,
  faBatterySlash: faBatterySlash,
  faFilmSlash: faFilmSlash,
  faSquareVirus: faSquareVirus,
  faTricycleAdult: faTricycleAdult,
  faCirclePhoneFlip: faCirclePhoneFlip,
  faPhoneCircleAlt: faPhoneCircleAlt,
  faCloudSunRain: faCloudSunRain,
  faH4: faH4,
  faCircleCaretRight: faCircleCaretRight,
  faCaretCircleRight: faCaretCircleRight,
  faKeyboardBrightnessLow: faKeyboardBrightnessLow,
  faArrowRightLong: faArrowRightLong,
  faLongArrowRight: faLongArrowRight,
  faFontCase: faFontCase,
  faBuildingUn: faBuildingUn,
  faToiletPaperXmark: faToiletPaperXmark,
  faTemperatureLow: faTemperatureLow,
  faH2: faH2,
  faFaceSmileHalo: faFaceSmileHalo,
  faRocketVertical: faRocketVertical,
  faDoorOpen: faDoorOpen,
  faAlignLeft: faAlignLeft,
  faPencilSlash: faPencilSlash,
  faCamera: faCamera,
  faCameraAlt: faCameraAlt,
  faHatWinter: faHatWinter,
  faHousePersonReturn: faHousePersonReturn,
  faHousePersonArrive: faHousePersonArrive,
  faHouseReturn: faHouseReturn,
  faKnife: faKnife,
  faUtensilKnife: faUtensilKnife,
  faMessageExclamation: faMessageExclamation,
  faCommentAltExclamation: faCommentAltExclamation,
  faRightToLine: faRightToLine,
  faArrowAltToRight: faArrowAltToRight,
  faMailbox: faMailbox,
  faMessageHeart: faMessageHeart,
  faMessageMiddleTop: faMessageMiddleTop,
  faCommentMiddleTopAlt: faCommentMiddleTopAlt,
  faUsersRays: faUsersRays,
  faCirclesOverlap: faCirclesOverlap,
  faRainbow: faRainbow,
  faBoxArrowDownArrowUp: faBoxArrowDownArrowUp,
  faLeftFromDottedLine: faLeftFromDottedLine,
  faSitemap: faSitemap,
  faCaravanSimple: faCaravanSimple,
  faCaravanAlt: faCaravanAlt,
  faFaceGrinStars: faFaceGrinStars,
  faGrinStars: faGrinStars,
  faMessageSms: faMessageSms,
  faCommentsQuestion: faCommentsQuestion,
  faSortUp: faSortUp,
  faSortAsc: faSortAsc,
  faBillboard: faBillboard,
  faEye: faEye,
  faArrowDownSmallBig: faArrowDownSmallBig,
  faSortSizeDownAlt: faSortSizeDownAlt,
  faAxe: faAxe,
  faCaretLeft: faCaretLeft,
  faAppleWhole: faAppleWhole,
  faAppleAlt: faAppleAlt,
  faScrollTorah: faScrollTorah,
  faTorah: faTorah,
  faHouseLock: faHouseLock,
  faSquareLitecoin: faSquareLitecoin,
  faArrowsLeftRightToLine: faArrowsLeftRightToLine,
  faTrash: faTrash,
  faFaceSadTear: faFaceSadTear,
  faSadTear: faSadTear,
  faTireFlat: faTireFlat,
  faMelon: faMelon,
  faFax: faFax,
  faArrowLeftLongToLine: faArrowLeftLongToLine,
  faUserMusic: faUserMusic,
  faPersonCirclePlus: faPersonCirclePlus,
  faHamsa: faHamsa,
  faHouseBuilding: faHouseBuilding,
  faPersonCircleQuestion: faPersonCircleQuestion,
  faCrateEmpty: faCrateEmpty,
  faSunHaze: faSunHaze,
  faCircle3: faCircle3,
  faClipboardCheck: faClipboardCheck,
  faShareFromSquare: faShareFromSquare,
  faShareSquare: faShareSquare,
  faForkKnife: faForkKnife,
  faUtensilsAlt: faUtensilsAlt,
  faReceipt: faReceipt,
  faEquals: faEquals,
  faDiagramLeanCanvas: faDiagramLeanCanvas,
  faBoxArrowUp: faBoxArrowUp,
  faChevronUp: faChevronUp,
  faVirusSlash: faVirusSlash,
  faGlobeStand: faGlobeStand,
  faRingDiamond: faRingDiamond,
  faPhoneRotary: faPhoneRotary,
  faSlash: faSlash,
  faArrowDownToDottedLine: faArrowDownToDottedLine,
  faSaxophoneFire: faSaxophoneFire,
  faSaxHot: faSaxHot,
  faWindowFrameOpen: faWindowFrameOpen,
  faCircleD: faCircleD,
  faExpand: faExpand,
  faScooter: faScooter,
  faFileMp4: faFileMp4,
  faNoteSticky: faNoteSticky,
  faStickyNote: faStickyNote,
  faDolphin: faDolphin,
  faBorderBottom: faBorderBottom,
  faUserMessage: faUserMessage,
  faSignalWeak: faSignalWeak,
  faSignal1: faSignal1,
  faTableColumns: faTableColumns,
  faColumns: faColumns,
  faPersonShelter: faPersonShelter,
  faCameraSecurity: faCameraSecurity,
  faCameraHome: faCameraHome,
  faCircleNotch: faCircleNotch,
  faWater: faWater,
  faDeleteLeft: faDeleteLeft,
  faBackspace: faBackspace,
  faCircleRupee: faCircleRupee,
  faArrowDownToSquare: faArrowDownToSquare,
  faSquareB: faSquareB,
  faBroomBall: faBroomBall,
  faQuidditch: faQuidditch,
  faQuidditchBroomBall: faQuidditchBroomBall,
  faH6: faH6,
  faJ: faJ,
  faShuttleSpace: faShuttleSpace,
  faSpaceShuttle: faSpaceShuttle,
  faYinYang: faYinYang,
  faSignalGood: faSignalGood,
  faSignal3: faSignal3,
  faImageStack: faImageStack,
  faStop: faStop,
  faTrowel: faTrowel,
  faCircle2: faCircle2,
  faDrumstick: faDrumstick,
  faSquareX: faSquareX,
  faPeapod: faPeapod,
  faMessageText: faMessageText,
  faCommentAltText: faCommentAltText,
  faHandBackFist: faHandBackFist,
  faHandRock: faHandRock,
  faSnowmanHead: faSnowmanHead,
  faFrostyHead: faFrostyHead,
  faBlanket: faBlanket,
  faCommentXmark: faCommentXmark,
  faCommentTimes: faCommentTimes,
  faPersonDollyEmpty: faPersonDollyEmpty,
  faSignalSlash: faSignalSlash,
  faHexagonPlus: faHexagonPlus,
  faPlusHexagon: faPlusHexagon,
  faTemperatureHigh: faTemperatureHigh,
  faGreaterThan: faGreaterThan,
  faToothbrush: faToothbrush,
  faFlute: faFlute,
  faLobster: faLobster,
  faCalendarCircleExclamation: faCalendarCircleExclamation,
  faMobileRotate: faMobileRotate,
  faCrutch: faCrutch,
  faCommand: faCommand,
  faTvRetro: faTvRetro,
  faPawClaws: faPawClaws,
  faSeptagon: faSeptagon,
  faHeptagon: faHeptagon,
  faFaceSmileUpsideDown: faFaceSmileUpsideDown,
  faGlassEmpty: faGlassEmpty,
  faEar: faEar,
  faStreetView: faStreetView,
  faBriefs: faBriefs,
  faSpeakers: faSpeakers,
  faWaveSquare: faWaveSquare,
  faAngleLeft: faAngleLeft,
  faTurtle: faTurtle,
  faArrowRightToLine: faArrowRightToLine,
  faArrowToRight: faArrowToRight,
  faPantsStraight: faPantsStraight,
  faScrewdriver: faScrewdriver,
  faTrafficLightStop: faTrafficLightStop,
  faSquareEuro: faSquareEuro,
  faTractor: faTractor,
  faBridgeCircleXmark: faBridgeCircleXmark,
  faVials: faVials,
  faStarfighterTwinIonEngineAdvanced: faStarfighterTwinIonEngineAdvanced,
  faStarfighterAltAdvanced: faStarfighterAltAdvanced,
  faStethoscope: faStethoscope,
  faPodcast: faPodcast,
  faArrowUpRightDots: faArrowUpRightDots,
  faChessQueen: faChessQueen,
  faAnchorCircleExclamation: faAnchorCircleExclamation,
  faEllipsisVertical: faEllipsisVertical,
  faEllipsisV: faEllipsisV,
  faAcorn: faAcorn,
  faBanParking: faBanParking,
  faParkingCircleSlash: faParkingCircleSlash,
  faSquareDong: faSquareDong,
  faListDropdown: faListDropdown,
  faCameraCircleEllipsis: faCameraCircleEllipsis,
  faFamilyDress: faFamilyDress,
  faPodium: faPodium,
  faRobotAstromech: faRobotAstromech,
  faHeartCircleExclamation: faHeartCircleExclamation,
  faBuildingCircleExclamation: faBuildingCircleExclamation,
  faPersonArrowUpFromLine: faPersonArrowUpFromLine,
  faCircleArrowDownLeft: faCircleArrowDownLeft,
  faNotEqual: faNotEqual,
  faBinaryCircleCheck: faBinaryCircleCheck,
  faTrainTram: faTrainTram,
  faPlaneDeparture: faPlaneDeparture,
  faMicrophoneStand: faMicrophoneStand,
  faShop24: faShop24,
  faBrightness: faBrightness,
  faRightToBracket: faRightToBracket,
  faSignInAlt: faSignInAlt,
  faSdCard: faSdCard,
  faDot: faDot,
  faHouseCircleExclamation: faHouseCircleExclamation,
  faShekelSign: faShekelSign,
  faIls: faIls,
  faShekel: faShekel,
  faSheqel: faSheqel,
  faSheqelSign: faSheqelSign,
  faSquareU: faSquareU,
  faTruckContainerEmpty: faTruckContainerEmpty,
  faUserPilotTie: faUserPilotTie,
  faRadio: faRadio,
  faHandDots: faHandDots,
  faAllergies: faAllergies,
  faPencilLine: faPencilLine,
  faHandShaka: faHandShaka,
  faFlaskGear: faFlaskGear,
  faBookSkull: faBookSkull,
  faBookDead: faBookDead,
  faUnlockKeyhole: faUnlockKeyhole,
  faUnlockAlt: faUnlockAlt,
  faTruckRamp: faTruckRamp,
  faEnvelopeDot: faEnvelopeDot,
  faEnvelopeBadge: faEnvelopeBadge,
  faHouseHeart: faHouseHeart,
  faHomeHeart: faHomeHeart,
  faFileArrowUp: faFileArrowUp,
  faFileUpload: faFileUpload,
  faGameConsoleHandheld: faGameConsoleHandheld,
  faFaceGrinTears: faFaceGrinTears,
  faGrinTears: faGrinTears,
  faPenToSquare: faPenToSquare,
  faEdit: faEdit,
  faEarthEurope: faEarthEurope,
  faGlobeEurope: faGlobeEurope,
  faTablePicnic: faTablePicnic,
  faFaceGrinBeamSweat: faFaceGrinBeamSweat,
  faGrinBeamSweat: faGrinBeamSweat,
  faCircleHalfStroke: faCircleHalfStroke,
  faAdjust: faAdjust,
  faRulerTriangle: faRulerTriangle,
  faOctagonPlus: faOctagonPlus,
  faPlusOctagon: faPlusOctagon,
  faUserCowboy: faUserCowboy,
  faBookmarkPlus: faBookmarkPlus,
  faPersonMilitaryToPerson: faPersonMilitaryToPerson,
  faImageMusic: faImageMusic,
  faPersonPinball: faPersonPinball,
  faMouseField: faMouseField,
  faTableCellsColumnLock: faTableCellsColumnLock,
  faTruckFieldUn: faTruckFieldUn,
  faClock: faClock,
  faClockFour: faClockFour,
  faLayerMinus: faLayerMinus,
  faLayerGroupMinus: faLayerGroupMinus,
  faCircleEuro: faCircleEuro,
  faBook: faBook,
  faFaceLaughWink: faFaceLaughWink,
  faLaughWink: faLaughWink,
  faTransducer: faTransducer,
  faUserDoctorHairLong: faUserDoctorHairLong,
  faCloudMeatball: faCloudMeatball,
  faCloudXmark: faCloudXmark,
  faChartArea: faChartArea,
  faAreaChart: faAreaChart,
  faUtilityPoleDouble: faUtilityPoleDouble,
  faRupiahSign: faRupiahSign,
  faDiagramNested: faDiagramNested,
  faSquareQuarters: faSquareQuarters,
  faPrintSlash: faPrintSlash,
  faShieldKeyhole: faShieldKeyhole,
  faSquareLeft: faSquareLeft,
  faArrowAltSquareLeft: faArrowAltSquareLeft,
  faTextWidth: faTextWidth,
  faCircleCurrency: faCircleCurrency,
  faSignatureLock: faSignatureLock,
  faSatellite: faSatellite,
  faBallPile: faBallPile,
  faSeats: faSeats,
  faFileEps: faFileEps,
  faMagnifyingGlassMinus: faMagnifyingGlassMinus,
  faSearchMinus: faSearchMinus,
  faVentDamper: faVentDamper,
  faPeopleGroup: faPeopleGroup,
  faSquareQuote: faSquareQuote,
  faSquareBinary: faSquareBinary,
  faMasksTheater: faMasksTheater,
  faTheaterMasks: faTheaterMasks,
  faHouseTurret: faHouseTurret,
  faCartPlus: faCartPlus,
  faHandsAslInterpreting: faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting: faAmericanSignLanguageInterpreting,
  faAslInterpreting: faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting: faHandsAmericanSignLanguageInterpreting,
  faFaceAnxiousSweat: faFaceAnxiousSweat,
  faMessageSmile: faMessageSmile,
  faCommentAltSmile: faCommentAltSmile,
  faLocationExclamation: faLocationExclamation,
  faMapMarkerExclamation: faMapMarkerExclamation,
  faSquareNaira: faSquareNaira,
  faTableCellsRowUnlock: faTableCellsRowUnlock,
  faDiamonds4: faDiamonds4,
  faRocket: faRocket,
  faFileCircleInfo: faFileCircleInfo,
  faCloudFog: faCloudFog,
  faFog: faFog,
  faOption: faOption,
  faUtilityPole: faUtilityPole,
  faShrimp: faShrimp,
  faAlien: faAlien,
  faSkeleton: faSkeleton,
  faTirePressureWarning: faTirePressureWarning,
  faNose: faNose,
  faSignPostsWrench: faSignPostsWrench,
  faTengeSign: faTengeSign,
  faTenge: faTenge,
  faFaceScream: faFaceScream,
  faHouseChimneyMedical: faHouseChimneyMedical,
  faClinicMedical: faClinicMedical,
  faSquareArrowLeft: faSquareArrowLeft,
  faArrowSquareLeft: faArrowSquareLeft,
  faCircleLocationArrow: faCircleLocationArrow,
  faLocationCircle: faLocationCircle,
  faUsersSlash: faUsersSlash,
  faTrafficCone: faTrafficCone,
  faStarSharpHalfStroke: faStarSharpHalfStroke,
  faStarSharpHalfAlt: faStarSharpHalfAlt,
  faH1: faH1,
  faTamale: faTamale,
  faRouteHighway: faRouteHighway,
  faPaperPlane: faPaperPlane,
  faObjectIntersect: faObjectIntersect,
  faBookAtlas: faBookAtlas,
  faAtlas: faAtlas,
  faTable: faTable,
  faCircleSort: faCircleSort,
  faSortCircle: faSortCircle,
  faHeart: faHeart,
  faScythe: faScythe,
  faCircleChevronUp: faCircleChevronUp,
  faChevronCircleUp: faChevronCircleUp,
  faApostrophe: faApostrophe,
  faBatteryHalf: faBatteryHalf,
  faBattery3: faBattery3,
  faFontAwesome: faFontAwesome,
  faFontAwesomeFlag: faFontAwesomeFlag,
  faFontAwesomeLogoFull: faFontAwesomeLogoFull,
  faHandcuffs: faHandcuffs,
  faSquareBangladeshiTaka: faSquareBangladeshiTaka,
  faHatCowboySide: faHatCowboySide,
  faSausage: faSausage,
  faChevronsDown: faChevronsDown,
  faChevronDoubleDown: faChevronDoubleDown,
  faIndustry: faIndustry,
  faPeopleDressSimple: faPeopleDressSimple,
  faLinesLeaning: faLinesLeaning,
  faPassport: faPassport,
  faInfinity: faInfinity,
  faHandHeart: faHandHeart,
  faClone: faClone,
  faForward: faForward,
  faSquareR: faSquareR,
  faPeriod: faPeriod,
  faM: faM,
  faMoneyCheckPen: faMoneyCheckPen,
  faMoneyCheckEdit: faMoneyCheckEdit,
  faRoadSpikes: faRoadSpikes,
  faFishCooked: faFishCooked,
  faPersonSeatReclined: faPersonSeatReclined,
  faMountain: faMountain,
  faCircleW: faCircleW,
  faChess: faChess,
  faTemperatureThreeQuarters: faTemperatureThreeQuarters,
  faTemperature3: faTemperature3,
  faThermometer3: faThermometer3,
  faThermometerThreeQuarters: faThermometerThreeQuarters,
  faB: faB,
  faShieldVirus: faShieldVirus,
  faTriangle: faTriangle,
  faLitecoinSign: faLitecoinSign,
  faDiceD6: faDiceD6,
  faGripLinesVertical: faGripLinesVertical,
  faToggleLargeOff: faToggleLargeOff,
  faGolfBallTee: faGolfBallTee,
  faGolfBall: faGolfBall,
  faHexagon: faHexagon,
  faKite: faKite,
  faShareAll: faShareAll,
  faChemex: faChemex,
  faFolderOpen: faFolderOpen,
  faTick: faTick,
  faFaceDrooling: faFaceDrooling,
  faBullseyeArrow: faBullseyeArrow,
  faKaaba: faKaaba,
  faHandBackPointRight: faHandBackPointRight,
  faStarfighterTwinIonEngine: faStarfighterTwinIonEngine,
  faStarfighterAlt: faStarfighterAlt,
  faHandHolding: faHandHolding,
  faBadgeSheriff: faBadgeSheriff,
  faRainbowHalf: faRainbowHalf,
  faCommentLines: faCommentLines,
  faSingleQuoteRight: faSingleQuoteRight,
  faBottleDroplet: faBottleDroplet,
  faFaceExplode: faFaceExplode,
  faExplodingHead: faExplodingHead,
  faWindowMinimize: faWindowMinimize,
  faStadium: faStadium,
  faMegaphone: faMegaphone,
  faBurgerGlass: faBurgerGlass,
  faPenPaintbrush: faPenPaintbrush,
  faPencilPaintbrush: faPencilPaintbrush,
  faLightbulbSlash: faLightbulbSlash,
  faCircleAustralianDollar: faCircleAustralianDollar,
  faShuttleSpaceVertical: faShuttleSpaceVertical,
  faPersonToDoor: faPersonToDoor,
  faFaceViewfinder: faFaceViewfinder,
  faRectangleVideoOnDemand: faRectangleVideoOnDemand,
  faTennisBall: faTennisBall,
  faChevronRight: faChevronRight,
  faEgg: faEgg,
  faConveyorBeltArm: faConveyorBeltArm,
  faLandmarkDome: faLandmarkDome,
  faLandmarkAlt: faLandmarkAlt,
  faGrate: faGrate,
  faWorm: faWorm,
  faSack: faSack,
  faUserInjured: faUserInjured,
  faMidi: faMidi,
  faMoonStar: faMoonStar,
  faStrikethrough: faStrikethrough,
  faCalendarCircleMinus: faCalendarCircleMinus,
  faBlog: faBlog,
  faStopwatch20: faStopwatch20,
  faSquareFlorin: faSquareFlorin,
  faBinary: faBinary,
  faShieldCheck: faShieldCheck,
  faSquareCruzeiro: faSquareCruzeiro,
  faTruckPickup: faTruckPickup,
  faSeedling: faSeedling,
  faSprout: faSprout,
  faCircleDivide: faCircleDivide,
  faCircleKip: faCircleKip,
  faTransgender: faTransgender,
  faTransgenderAlt: faTransgenderAlt,
  faArrowDownToBracket: faArrowDownToBracket,
  faUnicorn: faUnicorn,
  faLeftFromBracket: faLeftFromBracket,
  faRampLoading: faRampLoading,
  faHandHoldingBox: faHandHoldingBox,
  faStarHalf: faStarHalf,
  faArrowDownToLine: faArrowDownToLine,
  faArrowToBottom: faArrowToBottom,
  faPhotoFilm: faPhotoFilm,
  faPhotoVideo: faPhotoVideo,
  faPi: faPi,
  faPictureInPicture: faPictureInPicture,
  faTableCellsLock: faTableCellsLock,
  faPumpMedical: faPumpMedical,
  faFire: faFire,
  faFaceSmilePlus: faFaceSmilePlus,
  faSmilePlus: faSmilePlus,
  faMagnifyingGlassPlus: faMagnifyingGlassPlus,
  faSearchPlus: faSearchPlus,
  faSwap: faSwap,
  faCommentHeart: faCommentHeart,
  faFaceSmileTear: faFaceSmileTear,
  faWheat: faWheat,
  faBarcodeScan: faBarcodeScan,
  faEarCircleCheckmark: faEarCircleCheckmark,
  faGalaxy: faGalaxy,
  faFlask: faFlask,
  faCarKey: faCarKey,
  faFireplace: faFireplace,
  faFlowerTulip: faFlowerTulip,
  faInboxes: faInboxes,
  faRectangleVertical: faRectangleVertical,
  faRectanglePortrait: faRectanglePortrait,
  faAlignRight: faAlignRight,
  faTransporter6: faTransporter6,
  faCableCar: faCableCar,
  faTram: faTram,
  faKitMedical: faKitMedical,
  faFirstAid: faFirstAid,
  faGripLines: faGripLines,
  faBurger: faBurger,
  faHamburger: faHamburger,
  faRaindrops: faRaindrops,
  faSnowman: faSnowman,
  faHotel: faHotel,
  faPrint: faPrint,
  faDialMin: faDialMin,
  faCirclePolishZloty: faCirclePolishZloty,
  faFamily: faFamily,
  faStarfighter: faStarfighter,
  faCartCircleArrowDown: faCartCircleArrowDown,
  faMessageMedical: faMessageMedical,
  faCommentAltMedical: faCommentAltMedical,
  faCircleArrowDownRight: faCircleArrowDownRight,
  faVolleyball: faVolleyball,
  faVolleyballBall: faVolleyballBall,
  faArrowTurnDownRight: faArrowTurnDownRight,
  faTrafficLight: faTrafficLight,
  faPlaneCircleCheck: faPlaneCircleCheck,
  faSquarePeso: faSquarePeso,
  faHouseWater: faHouseWater,
  faHouseFlood: faHouseFlood,
  faUsers: faUsers,
  faCertificate: faCertificate,
  faAlarmClock: faAlarmClock,
  faHelicopterSymbol: faHelicopterSymbol,
  faHouseChimneyCrack: faHouseChimneyCrack,
  faHouseDamage: faHouseDamage,
  faDryerHeat: faDryerHeat,
  faDryerAlt: faDryerAlt,
  faBringForward: faBringForward,
  faDialLow: faDialLow,
  faCircleWifiCircleWifi: faCircleWifiCircleWifi,
  faCircleWifiGroup: faCircleWifiGroup,
  faDisplayMedical: faDisplayMedical,
  faDesktopMedical: faDesktopMedical,
  faPersonMilitaryPointing: faPersonMilitaryPointing,
  faDatabase: faDatabase,
  faNewspaper: faNewspaper,
  faCloudRain: faCloudRain,
  faSignalStrong: faSignalStrong,
  faSignal4: faSignal4,
  faMaximize: faMaximize,
  faExpandArrowsAlt: faExpandArrowsAlt,
  faLocationArrow: faLocationArrow,
  faCity: faCity,
  faRectangleCode: faRectangleCode,
  faToiletPaperCheck: faToiletPaperCheck,
  faSealQuestion: faSealQuestion,
  faXRay: faXRay,
  faUmbrellaBeach: faUmbrellaBeach,
  faArrowRightToBracket: faArrowRightToBracket,
  faSignIn: faSignIn,
  faHeadset: faHeadset,
  faThumbtackAngleSlash: faThumbtackAngleSlash,
  faCameraPolaroid: faCameraPolaroid,
  faFaceSaluting: faFaceSaluting,
  faHandHorns: faHandHorns,
  faFileExclamation: faFileExclamation,
  faHeadSideCircuit: faHeadSideCircuit,
  faPipeCircleCheck: faPipeCircleCheck,
  faSplotch: faSplotch,
  faSquareShekel: faSquareShekel,
  faUpLong: faUpLong,
  faLongArrowAltUp: faLongArrowAltUp,
  faFaceUnamused: faFaceUnamused,
  faCircleIndianRupee: faCircleIndianRupee,
  faSpinnerScale: faSpinnerScale,
  faHexagonNodes: faHexagonNodes,
  faHospital: faHospital,
  faHospitalAlt: faHospitalAlt,
  faHospitalWide: faHospitalWide,
  faFaceRelieved: faFaceRelieved,
  faSquarePeruvianSoles: faSquarePeruvianSoles,
  faCommentSmile: faCommentSmile,
  faFolderCheck: faFolderCheck,
  faCurrencySign: faCurrencySign,
  faChartUser: faChartUser,
  faUserChart: faUserChart,
  faPersonHarassing: faPersonHarassing,
  faFlatbread: faFlatbread,
  faCircleMicrophoneLines: faCircleMicrophoneLines,
  faMicrophoneCircleAlt: faMicrophoneCircleAlt,
  faMoneyBillTrendUp: faMoneyBillTrendUp,
  faPenRuler: faPenRuler,
  faPencilRuler: faPencilRuler,
  faBracketsSquare: faBracketsSquare,
  faBrackets: faBrackets,
  faPersonDressSimple: faPersonDressSimple,
  faTrainSubwayTunnel: faTrainSubwayTunnel,
  faSubwayTunnel: faSubwayTunnel,
  faRepeat: faRepeat,
  faBottleBaby: faBottleBaby,
  faBone: faBone,
  faRightLeftLarge: faRightLeftLarge,
  faStrawberry: faStrawberry,
  faSquareBolt: faSquareBolt,
  faFireFlameCurved: faFireFlameCurved,
  faFireAlt: faFireAlt,
  faSignatureSlash: faSignatureSlash,
  faBusSimple: faBusSimple,
  faBusAlt: faBusAlt,
  faSquarePeseta: faSquarePeseta,
  faTankWater: faTankWater,
  faUserShakespeare: faUserShakespeare,
  faVenusMars: faVenusMars,
  faKazoo: faKazoo,
  faDiagramSubtask: faDiagramSubtask,
  faArrowsFromDottedLine: faArrowsFromDottedLine,
  faGripDots: faGripDots,
  faBlender: faBlender,
  faU: faU,
  faBoxHeart: faBoxHeart,
  faLightbulbCfl: faLightbulbCfl,
  faShare: faShare,
  faMailForward: faMailForward,
  faCassetteVhs: faCassetteVhs,
  faVhs: faVhs,
  faPhoneFlip: faPhoneFlip,
  faPhoneAlt: faPhoneAlt,
  faFaceSwear: faFaceSwear,
  faToiletPortable: faToiletPortable,
  faCircleRupiah: faCircleRupiah,
  faMobileVibrateSlash: faMobileVibrateSlash,
  faTableCellsColumnUnlock: faTableCellsColumnUnlock,
  faPersonPregnant: faPersonPregnant,
  faLessThan: faLessThan,
  faImageCircleArrowDown: faImageCircleArrowDown,
  faSquareFragile: faSquareFragile,
  faBoxFragile: faBoxFragile,
  faSquareWineGlassCrack: faSquareWineGlassCrack,
  faInboxFull: faInboxFull,
  faFilmCanister: faFilmCanister,
  faFilmCannister: faFilmCannister,
  faHammerBrush: faHammerBrush,
  faSuperscript: faSuperscript,
  faUniformMartialArts: faUniformMartialArts,
  faCircleUserCircleUser: faCircleUserCircleUser,
  faCircleStop: faCircleStop,
  faStopCircle: faStopCircle,
  faArrowsUpDown: faArrowsUpDown,
  faArrowsV: faArrowsV,
  faMeterDroplet: faMeterDroplet,
  faOrnament: faOrnament,
  faDisplaySlash: faDisplaySlash,
  faDesktopSlash: faDesktopSlash,
  faPageCaretUp: faPageCaretUp,
  faFileCaretUp: faFileCaretUp,
  faPooStorm: faPooStorm,
  faPooBolt: faPooBolt,
  faVideoSlash: faVideoSlash,
  faSquareXmark: faSquareXmark,
  faTimesSquare: faTimesSquare,
  faXmarkSquare: faXmarkSquare,
  faMessageDots: faMessageDots,
  faCommentAltDots: faCommentAltDots,
  faMessaging: faMessaging,
  faDropletDegree: faDropletDegree,
  faDewpoint: faDewpoint,
  faTowerControl: faTowerControl,
  faCircleDong: faCircleDong,
  faBurgerCheese: faBurgerCheese,
  faCheeseburger: faCheeseburger,
  faHandHoldingDroplet: faHandHoldingDroplet,
  faHandHoldingWater: faHandHoldingWater,
  faWonSign: faWonSign,
  faKrw: faKrw,
  faWon: faWon,
  faObjectUngroup: faObjectUngroup,
  faChartWaterfall: faChartWaterfall,
  faComment: faComment,
  faSpaceStationMoon: faSpaceStationMoon,
  faUpFromBracket: faUpFromBracket,
  faCalendarCirclePlus: faCalendarCirclePlus,
  faTabletScreen: faTabletScreen,
  faTabletAndroidAlt: faTabletAndroidAlt,
  faSaltShaker: faSaltShaker,
  faFileCheck: faFileCheck,
  faHillAvalanche: faHillAvalanche,
  faArrowsToEye: faArrowsToEye,
  faSnowplow: faSnowplow,
  faShieldExclamation: faShieldExclamation,
  faSquareW: faSquareW,
  faChartGantt: faChartGantt,
  faCreditCardBlank: faCreditCardBlank,
  faHandsHoldingDollar: faHandsHoldingDollar,
  faHandsUsd: faHandsUsd,
  faBuildingMagnifyingGlass: faBuildingMagnifyingGlass,
  faSquareA: faSquareA,
  faVideo: faVideo,
  faVideoCamera: faVideoCamera,
  faFacePouting: faFacePouting,
  faChessPawn: faChessPawn,
  faUserHeadset: faUserHeadset,
  faSynagogue: faSynagogue,
  faMug: faMug,
  faShirtJersey: faShirtJersey,
  faBuildingCircleCheck: faBuildingCircleCheck,
  faCalendarPlus: faCalendarPlus,
  faWheelchairMove: faWheelchairMove,
  faWheelchairAlt: faWheelchairAlt,
  faUserKey: faUserKey,
  faUserShield: faUserShield,
  faTally4: faTally4,
  faBreadLoaf: faBreadLoaf,
  faCircle0: faCircle0,
  faBold: faBold,
  faHeartPulse: faHeartPulse,
  faHeartbeat: faHeartbeat,
  faSquareRootVariable: faSquareRootVariable,
  faSquareRootAlt: faSquareRootAlt,
  faMessageCheck: faMessageCheck,
  faCommentAltCheck: faCommentAltCheck,
  faHandsBubbles: faHandsBubbles,
  faHandsWash: faHandsWash,
  faGuitars: faGuitars,
  faMarker: faMarker,
  faUserHairLong: faUserHairLong,
  faTrafficLightGo: faTrafficLightGo,
  faHousePersonLeave: faHousePersonLeave,
  faHouseLeave: faHouseLeave,
  faHousePersonDepart: faHousePersonDepart,
  faDownUp: faDownUp,
  faClipboard: faClipboard,
  faPlaceOfWorship: faPlaceOfWorship,
  faCannabis: faCannabis,
  faFaceZipper: faFaceZipper,
  faPeopleRoof: faPeopleRoof,
  faPump: faPump,
  faSquareAmpersand: faSquareAmpersand,
  faDisease: faDisease,
  faBookBible: faBookBible,
  faBible: faBible,
  faChessBoard: faChessBoard,
  faSprinkler: faSprinkler,
  faGunSquirt: faGunSquirt,
  faMugMarshmallows: faMugMarshmallows,
  faCircleHeart: faCircleHeart,
  faHeartCircle: faHeartCircle,
  faUserHatTieMagnifyingGlass: faUserHatTieMagnifyingGlass,
  faDiagramSankey: faDiagramSankey,
  faSunset: faSunset,
  faCircleEquals: faCircleEquals,
  faMars: faMars,
  faUserVneckHairMullet: faUserVneckHairMullet,
  faLaptop: faLaptop,
  faUserXmark: faUserXmark,
  faUserTimes: faUserTimes,
  faFlagUsa: faFlagUsa,
  faHandMiddleFinger: faHandMiddleFinger,
  faAlt: faAlt,
  faMortarPestle: faMortarPestle,
  faBanana: faBanana,
  faUmbrellaSimple: faUmbrellaSimple,
  faUmbrellaAlt: faUmbrellaAlt,
  faJoystick: faJoystick,
  faHeadSideCough: faHeadSideCough,
  faPlaneLock: faPlaneLock,
  faBatteryThreeQuarters: faBatteryThreeQuarters,
  faBattery4: faBattery4,
  faFrancSign: faFrancSign,
  faTripleChevronsRight: faTripleChevronsRight,
  faFilterCircleDollar: faFilterCircleDollar,
  faFunnelDollar: faFunnelDollar,
  faCheese: faCheese,
  faCircleH: faCircleH,
  faHospitalSymbol: faHospitalSymbol,
  faBoxBallot: faBoxBallot,
  faLocationCheck: faLocationCheck,
  faMapMarkerCheck: faMapMarkerCheck,
  faTilde: faTilde,
  faCommentMiddle: faCommentMiddle,
  faArrowLeftFromDottedLine: faArrowLeftFromDottedLine,
  faUTurnLeftDown: faUTurnLeftDown,
  faUTurn: faUTurn,
  faArrowDownFromBracket: faArrowDownFromBracket,
  faSchool: faSchool,
  faEarMuffs: faEarMuffs,
  faClockSeven: faClockSeven,
  faDiceFive: faDiceFive,
  faTornado: faTornado,
  faArrowLeftToLine: faArrowLeftToLine,
  faArrowToLeft: faArrowToLeft,
  faJetFighter: faJetFighter,
  faFighterJet: faFighterJet,
  faPersonBikingMountain: faPersonBikingMountain,
  faBikingMountain: faBikingMountain,
  faThumbsDown: faThumbsDown,
  faFunction: faFunction,
  faBroom: faBroom,
  faDiscDrive: faDiscDrive,
  faGrill: faGrill,
  faFileImport: faFileImport,
  faArrowRightToFile: faArrowRightToFile,
  faJug: faJug,
  faUtensils: faUtensils,
  faCutlery: faCutlery,
  faIdBadge: faIdBadge,
  faSpider: faSpider,
  faUserQuestion: faUserQuestion,
  faPersonFairy: faPersonFairy,
  faMobileRetro: faMobileRetro,
  faSignsPost: faSignsPost,
  faMapSigns: faMapSigns,
  faGroupArrowsRotate: faGroupArrowsRotate,
  faDiagramVenn: faDiagramVenn,
  faArrowsSplitUpAndLeft: faArrowsSplitUpAndLeft,
  faImagePolaroidUser: faImagePolaroidUser,
  faArrowUpLeft: faArrowUpLeft,
  faSquareAustralianDollar: faSquareAustralianDollar,
  faCarGarage: faCarGarage,
  faPersonFromPortal: faPersonFromPortal,
  faPortalExit: faPortalExit,
  faFillDrip: faFillDrip,
  faShieldHeart: faShieldHeart,
  faTrashCanUndo: faTrashCanUndo,
  faTrashCanArrowTurnLeft: faTrashCanArrowTurnLeft,
  faTrashUndoAlt: faTrashUndoAlt,
  faChampagneGlass: faChampagneGlass,
  faGlassChampagne: faGlassChampagne,
  faPersonSkiingNordic: faPersonSkiingNordic,
  faSkiingNordic: faSkiingNordic,
  faDiagramCells: faDiagramCells,
  faSquare6: faSquare6,
  faSquare2: faSquare2,
  faArrowsToDottedLine: faArrowsToDottedLine,
  faHatBeach: faHatBeach,
  faRouter: faRouter,
  faSensor: faSensor,
  faSquareCheck: faSquareCheck,
  faCheckSquare: faCheckSquare,
  faPaintbrushFine: faPaintbrushFine,
  faPaintBrushAlt: faPaintBrushAlt,
  faPaintBrushFine: faPaintBrushFine,
  faPaintbrushAlt: faPaintbrushAlt,
  faBath: faBath,
  faBathtub: faBathtub,
  faChessBishop: faChessBishop,
  faFence: faFence,
  faMicrowave: faMicrowave,
  faAlarmExclamation: faAlarmExclamation,
  faTomato: faTomato,
  faPrescriptionBottleMedical: faPrescriptionBottleMedical,
  faPrescriptionBottleAlt: faPrescriptionBottleAlt,
  faWatchCalculator: faWatchCalculator,
  faDrawPolygon: faDrawPolygon,
  faVectorPolygon: faVectorPolygon,
  faCircleGuarani: faCircleGuarani,
  faSlider: faSlider,
  faICursor: faICursor,
  faCloudRainbow: faCloudRainbow,
  faHeartCirclePlus: faHeartCirclePlus,
  faShieldDog: faShieldDog,
  faFileSlash: faFileSlash,
  faChessRookPiece: faChessRookPiece,
  faChessRookAlt: faChessRookAlt,
  faGreaterThanEqual: faGreaterThanEqual,
  faEnvelopeOpen: faEnvelopeOpen,
  faMound: faMound,
  faRingsWedding: faRingsWedding,
  faGrillFire: faGrillFire,
  faDistributeSpacingHorizontal: faDistributeSpacingHorizontal,
  faBowlSoftServe: faBowlSoftServe,
  faVoicemail: faVoicemail,
  faVest: faVest,
  faAudioDescription: faAudioDescription,
  faW: faW,
  faCartCircleXmark: faCartCircleXmark,
  faCloudsSun: faCloudsSun,
  faEyeDropper: faEyeDropper,
  faEyeDropperEmpty: faEyeDropperEmpty,
  faEyedropper: faEyedropper,
  faCircleXmark: faCircleXmark,
  faTimesCircle: faTimesCircle,
  faXmarkCircle: faXmarkCircle,
  faTrailer: faTrailer,
  faTurkishLiraSign: faTurkishLiraSign,
  faTry: faTry,
  faTurkishLira: faTurkishLira,
  faGaugeCircleMinus: faGaugeCircleMinus,
  faDrawSquare: faDrawSquare,
  faVectorSquare: faVectorSquare,
  faMountains: faMountains,
  faTruckTow: faTruckTow,
  faLocationMinus: faLocationMinus,
  faMapMarkerMinus: faMapMarkerMinus,
  faShieldXmark: faShieldXmark,
  faShieldTimes: faShieldTimes,
  faFaceShush: faFaceShush,
  faSquareEurozone: faSquareEurozone,
  faHeadSideSpeak: faHeadSideSpeak,
  faHouseDay: faHouseDay,
  faVolcano: faVolcano,
  faWandSparkles: faWandSparkles,
  faFireFlame: faFireFlame,
  faFlame: faFlame,
  faBowlingBallPin: faBowlingBallPin,
  faMicrophone: faMicrophone,
  faCrown: faCrown,
  faTentArrowTurnLeft: faTentArrowTurnLeft,
  faTruckFast: faTruckFast,
  faShippingFast: faShippingFast,
  faUserPen: faUserPen,
  faUserEdit: faUserEdit,
  faSquareNorwegianKrone: faSquareNorwegianKrone,
  faPersonSnowmobiling: faPersonSnowmobiling,
  faSnowmobile: faSnowmobile,
  faBurgerSoda: faBurgerSoda,
  faRabbitRunning: faRabbitRunning,
  faRabbitFast: faRabbitFast,
  faDialMax: faDialMax,
  faFaceHushed: faFaceHushed,
  faStocking: faStocking,
  faCircleDanishKrone: faCircleDanishKrone,
  faUserClock: faUserClock,
  faFaceDowncastSweat: faFaceDowncastSweat,
  faShieldPlus: faShieldPlus,
  faAccentGrave: faAccentGrave,
  faHeadphonesSlash: faHeadphonesSlash,
  faHoodCloak: faHoodCloak,
  faFileOdf: faFileOdf,
  faSquareArrowUp: faSquareArrowUp,
  faArrowSquareUp: faArrowSquareUp,
  faClockTenThirty: faClockTenThirty,
  faSquare4: faSquare4,
  faShower: faShower,
  faSquareSterling: faSquareSterling,
  faFishingRod: faFishingRod,
  faSquareCaretUp: faSquareCaretUp,
  faCaretSquareUp: faCaretSquareUp,
  faCircleArrowUpLeft: faCircleArrowUpLeft,
  faBoxDollar: faBoxDollar,
  faBoxUsd: faBoxUsd,
  faTheta: faTheta,
  faFaceSmileTongue: faFaceSmileTongue,
  faFileVector: faFileVector,
  faVideoArrowUpRight: faVideoArrowUpRight,
  faMapLocation: faMapLocation,
  faMapMarked: faMapMarked,
  faTableCellsHeaderLock: faTableCellsHeaderLock,
  faFaceIcicles: faFaceIcicles,
  faPenFancy: faPenFancy,
  faUserChef: faUserChef,
  faDropletPlus: faDropletPlus,
  faEuroSign: faEuroSign,
  faEur: faEur,
  faEuro: faEuro,
  faHouseCircleXmark: faHouseCircleXmark,
  faLiraSign: faLiraSign,
  faCirclePeso: faCirclePeso,
  faYenSign: faYenSign,
  faCny: faCny,
  faJpy: faJpy,
  faRmb: faRmb,
  faYen: faYen,
  faBoxOpen: faBoxOpen,
  faGolfFlagHole: faGolfFlagHole,
  faTruckField: faTruckField,
  faUTurnLeftUp: faUTurnLeftUp,
  faCircleMill: faCircleMill,
  faWhistle: faWhistle,
  faKerning: faKerning,
  faLocationPinLock: faLocationPinLock,
  faWavesSine: faWavesSine,
  faPersonPraying: faPersonPraying,
  faPray: faPray,
  faLocationPlus: faLocationPlus,
  faMapMarkerPlus: faMapMarkerPlus,
  faDiamondHalfStroke: faDiamondHalfStroke,
  faClipboardList: faClipboardList,
  faObjectsAlignCenterVertical: faObjectsAlignCenterVertical,
  faCandyBar: faCandyBar,
  faChocolateBar: faChocolateBar,
  faBoothCurtain: faBoothCurtain,
  faSackDollar: faSackDollar,
  faMountainSun: faMountainSun,
  faHockeyMask: faHockeyMask,
  faLocationSmile: faLocationSmile,
  faMapMarkerSmile: faMapMarkerSmile,
  faTally3: faTally3,
  faArrowDownFromLine: faArrowDownFromLine,
  faArrowFromTop: faArrowFromTop,
  faChartPyramid: faChartPyramid,
  faGoalNet: faGoalNet,
  faLinkHorizontalSlash: faLinkHorizontalSlash,
  faChainHorizontalSlash: faChainHorizontalSlash,
  faCarpool: faCarpool,
  faCarPeople: faCarPeople,
  faArrowUpWideShort: faArrowUpWideShort,
  faSortAmountUp: faSortAmountUp,
  faArrowUpFromDottedLine: faArrowUpFromDottedLine,
  faUTurnRightUp: faUTurnRightUp,
  faHexagonImage: faHexagonImage,
  faUsersLine: faUsersLine,
  faArrowUpRightAndArrowDownLeftFromCenter: faArrowUpRightAndArrowDownLeftFromCenter,
  faCameraViewfinder: faCameraViewfinder,
  faScreenshot: faScreenshot,
  faStarOfDavid: faStarOfDavid,
  faNotesMedical: faNotesMedical,
  faAustralSign: faAustralSign,
  faFileChartPie: faFileChartPie,
  faFaceSadSweat: faFaceSadSweat,
  faClipboardUser: faClipboardUser,
  faCommentArrowDown: faCommentArrowDown,
  faFileImage: faFileImage,
  faFileMov: faFileMov,
  faPie: faPie,
  faUserPoliceHairLong: faUserPoliceHairLong,
  faBagel: faBagel,
  faCartXmark: faCartXmark,
  faSquareCaretRight: faSquareCaretRight,
  faCaretSquareRight: faCaretSquareRight,
  faUtensilsSlash: faUtensilsSlash,
  faVial: faVial,
  faHelicopter: faHelicopter,
  faMitten: faMitten,
  faFileMusic: faFileMusic,
  faGasPump: faGasPump,
  faHelmetBattle: faHelmetBattle,
  faMeat: faMeat,
  faTrumpet: faTrumpet,
  faBrowsers: faBrowsers,
  faArrowDownLeft: faArrowDownLeft,
  faSquare1: faSquare1,
  faUserNurseHairLong: faUserNurseHairLong,
  faTemperatureSun: faTemperatureSun,
  faTemperatureHot: faTemperatureHot,
  faGasPumpSlash: faGasPumpSlash,
  faEnvelopeCircleCheck: faEnvelopeCircleCheck,
  faFileGif: faFileGif,
  faPersonSkating: faPersonSkating,
  faSkating: faSkating,
  faFaceAngryHorns: faFaceAngryHorns,
  faSun: faSun,
  faDiploma: faDiploma,
  faScrollRibbon: faScrollRibbon,
  faBaseball: faBaseball,
  faBaseballBall: faBaseballBall,
  faImage: faImage,
  faBoot: faBoot,
  faCarBump: faCarBump,
  faMoneyBillSimple: faMoneyBillSimple,
  faSquareArrowDown: faSquareArrowDown,
  faArrowSquareDown: faArrowSquareDown,
  faNotdef: faNotdef,
  faCommentQuestion: faCommentQuestion,
  faUserRobot: faUserRobot,
  faBasketball: faBasketball,
  faBasketballBall: faBasketballBall,
  faPencil: faPencil,
  faPencilAlt: faPencilAlt,
  faPersonWalkingArrowLoopLeft: faPersonWalkingArrowLoopLeft,
  faBootHeeled: faBootHeeled,
  faDiceSix: faDiceSix,
  faCircleEllipsis: faCircleEllipsis,
  faSwedishKronaSign: faSwedishKronaSign,
  faArrowUpSquareTriangle: faArrowUpSquareTriangle,
  faSortShapesUpAlt: faSortShapesUpAlt,
  faAnglesDown: faAnglesDown,
  faAngleDoubleDown: faAngleDoubleDown,
  faVan: faVan,
  faBatteryLow: faBatteryLow,
  faBattery1: faBattery1,
  faLacrosseStickBall: faLacrosseStickBall,
  faSeatAirlineWindow: faSeatAirlineWindow,
  faAlarmSnooze: faAlarmSnooze,
  faSyringe: faSyringe,
  faShowerDown: faShowerDown,
  faShowerAlt: faShowerAlt,
  faWheatAwn: faWheatAwn,
  faWheatAlt: faWheatAlt,
  faPlaneUp: faPlaneUp,
  faCircleUserCircleCheck: faCircleUserCircleCheck,
  faBat: faBat,
  faAlignCenter: faAlignCenter,
  faHockeyPuck: faHockeyPuck,
  faCircleArrowLeft: faCircleArrowLeft,
  faArrowCircleLeft: faArrowCircleLeft,
  faChartRadar: faChartRadar,
  faArrowProgress: faArrowProgress,
  faWarehouseFull: faWarehouseFull,
  faWarehouseAlt: faWarehouseAlt,
  faPenSwirl: faPenSwirl,
  faTruckLadder: faTruckLadder,
  faCommentImage: faCommentImage,
  faPlugCircleBolt: faPlugCircleBolt,
  faJeans: faJeans,
  faGrid5: faGrid5,
  faPipeSection: faPipeSection,
  faRestroom: faRestroom,
  faReflectBoth: faReflectBoth,
  faGearCode: faGearCode,
  faCurlingStone: faCurlingStone,
  faCurling: faCurling,
  faAnchorLock: faAnchorLock,
  faTimeline: faTimeline,
  faBriefcaseBlank: faBriefcaseBlank,
  faCoinFront: faCoinFront,
  faCalendarStar: faCalendarStar,
  faPenCircle: faPenCircle,
  faLightbulb: faLightbulb,
  faPageCaretDown: faPageCaretDown,
  faFileCaretDown: faFileCaretDown,
  faBookBlank: faBookBlank,
  faBookAlt: faBookAlt,
  faTrashUndo: faTrashUndo,
  faTrashArrowTurnLeft: faTrashArrowTurnLeft,
  faSubtitles: faSubtitles,
  faWaveTriangle: faWaveTriangle,
  faFootWing: faFootWing,
  faGaugeCirclePlus: faGaugeCirclePlus,
  faFilmMusic: faFilmMusic,
  faHeadSide: faHeadSide,
  faOctagonEquals: faOctagonEquals,
  faChevronsLeft: faChevronsLeft,
  faChevronDoubleLeft: faChevronDoubleLeft,
  faCircleArrowRight: faCircleArrowRight,
  faArrowCircleRight: faArrowCircleRight,
  faGameBoard: faGameBoard,
  faFileChartColumn: faFileChartColumn,
  faFileChartLine: faFileChartLine,
  faCustard: faCustard,
  faBlockQuestion: faBlockQuestion,
  faMarsAndVenus: faMarsAndVenus,
  faNetworkWired: faNetworkWired,
  faFaceConfused: faFaceConfused,
  faBuildingShield: faBuildingShield,
  faBedEmpty: faBedEmpty,
  faGrillHot: faGrillHot,
  faEarWaveform: faEarWaveform,
  faCode: faCode,
  faFeatherPointed: faFeatherPointed,
  faFeatherAlt: faFeatherAlt,
  faBoxIsometricTape: faBoxIsometricTape,
  faFileCircleQuestion: faFileCircleQuestion,
  faFaceNoseSteam: faFaceNoseSteam,
  faSignature: faSignature,
  faEarthAmericas: faEarthAmericas,
  faEarth: faEarth,
  faEarthAmerica: faEarthAmerica,
  faGlobeAmericas: faGlobeAmericas,
  faCarrot: faCarrot,
  faSparkles: faSparkles,
  faSquareL: faSquareL,
  faCauldron: faCauldron,
  faTemperatureFull: faTemperatureFull,
  faTemperature4: faTemperature4,
  faThermometer4: faThermometer4,
  faThermometerFull: faThermometerFull,
  faTableCellsRowLock: faTableCellsRowLock,
  faCircleUserCirclePlus: faCircleUserCirclePlus,
  faBoltLightning: faBoltLightning,
  faCloudShowersWater: faCloudShowersWater,
  faArrowUpLong: faArrowUpLong,
  faLongArrowUp: faLongArrowUp,
  faFluxCapacitor: faFluxCapacitor,
  faAddressCard: faAddressCard,
  faContactCard: faContactCard,
  faVcard: faVcard,
  faStaff: faStaff,
  faBasketShoppingMinus: faBasketShoppingMinus,
  faAngleRight: faAngleRight,
  faToiletPaperUnder: faToiletPaperUnder,
  faToiletPaperBlankUnder: faToiletPaperBlankUnder,
  faToiletPaperReverse: faToiletPaperReverse,
  faToiletPaperReverseAlt: faToiletPaperReverseAlt,
  faStomach: faStomach,
  faFaceCowboyHat: faFaceCowboyHat,
  faFaceMeh: faFaceMeh,
  faMeh: faMeh,
  faArrowUpFromGroundWater: faArrowUpFromGroundWater,
  faFacePleading: faFacePleading,
  faEnvelopeCircleUser: faEnvelopeCircleUser,
  faBarn: faBarn,
  faMap: faMap,
  faUserPlus: faUserPlus,
  faTurnDownLeft: faTurnDownLeft,
  faPlaneEngines: faPlaneEngines,
  faPlaneAlt: faPlaneAlt,
  faVenus: faVenus,
  faUserDoctorMessage: faUserDoctorMessage,
  faUserMdChat: faUserMdChat,
  faBarsSort: faBarsSort,
  faHighDefinition: faHighDefinition,
  faRectangleHd: faRectangleHd,
  faCirclePeseta: faCirclePeseta,
  faDitto: faDitto,
  faSquareArrowDownRight: faSquareArrowDownRight,
  faPipeValve: faPipeValve,
  faSquareS: faSquareS,
  faDiagramSuccessor: faDiagramSuccessor,
  faHeadSideCoughSlash: faHeadSideCoughSlash,
  faArrowsMaximize: faArrowsMaximize,
  faExpandArrows: faExpandArrows,
  faPlusLarge: faPlusLarge,
  faMugTea: faMugTea,
  faDiagramProject: faDiagramProject,
  faProjectDiagram: faProjectDiagram,
  faTerminal: faTerminal,
  faEclipse: faEclipse,
  faHouseFire: faHouseFire,
  faMask: faMask,
  faHurricane: faHurricane,
  faEarthAfrica: faEarthAfrica,
  faGlobeAfrica: faGlobeAfrica,
  faThumbtack: faThumbtack,
  faThumbTack: faThumbTack,
  faSquareUp: faSquareUp,
  faArrowAltSquareUp: faArrowAltSquareUp,
  faFaceTongueMoney: faFaceTongueMoney,
  faHandPointDown: faHandPointDown,
  faFaceMehBlank: faFaceMehBlank,
  faMehBlank: faMehBlank,
  faBowlHot: faBowlHot,
  faSoup: faSoup,
  faPartyHorn: faPartyHorn,
  faBells: faBells,
  faTemperatureEmpty: faTemperatureEmpty,
  faTemperature0: faTemperature0,
  faThermometer0: faThermometer0,
  faThermometerEmpty: faThermometerEmpty,
  faPopcorn: faPopcorn,
  faBorderLeft: faBorderLeft,
  faBorderNone: faBorderNone,
  faHighlighter: faHighlighter,
  faPalletBox: faPalletBox,
  faStarExclamation: faStarExclamation,
  faSickle: faSickle,
  faMoneyBillWave: faMoneyBillWave,
  faPlaneTail: faPlaneTail,
  faToiletPaperSlash: faToiletPaperSlash,
  faSirenOn: faSirenOn,
  faFileShield: faFileShield,
  faWhiskeyGlassIce: faWhiskeyGlassIce,
  faGlassWhiskeyRocks: faGlassWhiskeyRocks,
  faSquid: faSquid,
  faTextHeight: faTextHeight,
  faMoneyCheckDollarPen: faMoneyCheckDollarPen,
  faMoneyCheckEditAlt: faMoneyCheckEditAlt,
  faHandWave: faHandWave,
  faChartCandlestick: faChartCandlestick,
  faTransporter4: faTransporter4,
  faPanFood: faPanFood,
  faEurozoneSign: faEurozoneSign,
  faFaceGrinTongue: faFaceGrinTongue,
  faGrinTongue: faGrinTongue,
  faPotato: faPotato,
  faFileSignature: faFileSignature,
  faSquareDashed: faSquareDashed,
  faSteak: faSteak,
  faAxeBattle: faAxeBattle,
  faCircleQuarterStroke: faCircleQuarterStroke,
  faPhoneHangup: faPhoneHangup,
  faSquareHeart: faSquareHeart,
  faHeartSquare: faHeartSquare,
  faConveyorBelt: faConveyorBelt,
  faBoxCheck: faBoxCheck,
  faBlanketFire: faBlanketFire,
  faSquare9: faSquare9,
  faBuildingWheat: faBuildingWheat,
  faPlugCircleMinus: faPlugCircleMinus,
  faBookSpine: faBookSpine,
  faHockeySticks: faHockeySticks,
  faDownLongToLine: faDownLongToLine,
  faColon: faColon,
  faFutbol: faFutbol,
  faFutbolBall: faFutbolBall,
  faSoccerBall: faSoccerBall,
  faFaceHandOverMouth: faFaceHandOverMouth,
  faCirclePlus: faCirclePlus,
  faPlusCircle: faPlusCircle,
  faCoffeePot: faCoffeePot,
  faSquareQuestion: faSquareQuestion,
  faQuestionSquare: faQuestionSquare,
  faListTree: faListTree,
  faBrazilianRealSign: faBrazilianRealSign,
  faBookOpenLines: faBookOpenLines,
  faEllipsisStrokeVertical: faEllipsisStrokeVertical,
  faEllipsisVAlt: faEllipsisVAlt,
  faStarAndCrescent: faStarAndCrescent,
  faTextSize: faTextSize,
  faFaceSurprise: faFaceSurprise,
  faSurprise: faSurprise,
  faHospitalUser: faHospitalUser,
  faArrowDownUpLock: faArrowDownUpLock,
  faFolder: faFolder,
  faFolderBlank: faFolderBlank,
  faHollyBerry: faHollyBerry,
  faMessageImage: faMessageImage,
  faCommentAltImage: faCommentAltImage,
  faCommentQuote: faCommentQuote,
  faVenusDouble: faVenusDouble,
  faElephant: faElephant,
  faClipboardQuestion: faClipboardQuestion,
  faHotdog: faHotdog,
  faArrowUpFromBracket: faArrowUpFromBracket,
  faReplyClock: faReplyClock,
  faReplyTime: faReplyTime,
  faChartLineUp: faChartLineUp,
  faMicroscope: faMicroscope,
  faCatSpace: faCatSpace,
  faCircleExclamationCheck: faCircleExclamationCheck,
  faCards: faCards,
  faCloud: faCloud,
  faAlbumCirclePlus: faAlbumCirclePlus,
  faBaseballBatBall: faBaseballBatBall,
  faCarRear: faCarRear,
  faCarAlt: faCarAlt,
  faWindsock: faWindsock,
  faFaceWorried: faFaceWorried,
  faMicrophoneCircleXmark: faMicrophoneCircleXmark,
  faMessageLines: faMessageLines,
  faCommentAltLines: faCommentAltLines,
  faThumbtackSlash: faThumbtackSlash,
  faThumbTackSlash: faThumbTackSlash,
  faBoxArrowDown: faBoxArrowDown,
  faPlusMinus: faPlusMinus,
  faHouseCircleCheck: faHouseCircleCheck,
  faFaceWoozy: faFaceWoozy,
  faCrateApple: faCrateApple,
  faAppleCrate: faAppleCrate,
  faCalendarDay: faCalendarDay,
  faCircle: faCircle,
  faNotebook: faNotebook,
  faOctagonXmark: faOctagonXmark,
  faTimesOctagon: faTimesOctagon,
  faXmarkOctagon: faXmarkOctagon,
  faRacquet: faRacquet,
  faMobileVibrate: faMobileVibrate,
  faFaceGrinSquint: faFaceGrinSquint,
  faGrinSquint: faGrinSquint,
  faTreeDeciduous: faTreeDeciduous,
  faTreeAlt: faTreeAlt,
  faUsersBetweenLines: faUsersBetweenLines,
  faMango: faMango,
  faCrosshairsSimple: faCrosshairsSimple,
  faPipeSmoking: faPipeSmoking,
  faCoconut: faCoconut,
  faFaceDiagonalMouth: faFaceDiagonalMouth,
  faStarSharpHalf: faStarSharpHalf,
  faMessageWaveform: faMessageWaveform,
  faMusicMagnifyingGlass: faMusicMagnifyingGlass,
  faHouseMedicalCircleXmark: faHouseMedicalCircleXmark,
  faClub: faClub,
  faFireSmoke: faFireSmoke,
  faTableList: faTableList,
  faThList: faThList,
  faFlaskVial: faFlaskVial,
  faLuchadorMask: faLuchadorMask,
  faLuchador: faLuchador,
  faMaskLuchador: faMaskLuchador,
  faCircleExclamation: faCircleExclamation,
  faExclamationCircle: faExclamationCircle,
  faBlockBrick: faBlockBrick,
  faWallBrick: faWallBrick,
  faArrowUTurnRightUp: faArrowUTurnRightUp,
  faTaxi: faTaxi,
  faCab: faCab,
  faTextSlash: faTextSlash,
  faRemoveFormat: faRemoveFormat,
  faPeoplePulling: faPeoplePulling,
  faBackward: faBackward,
  faSpade: faSpade,
  faDreidel: faDreidel,
  faCarBurst: faCarBurst,
  faCarCrash: faCarCrash,
  faCommentMinus: faCommentMinus,
  faSquareF: faSquareF,
  faChessQueenPiece: faChessQueenPiece,
  faChessQueenAlt: faChessQueenAlt,
  faTurnLeftDown: faTurnLeftDown,
  faLink: faLink,
  faChain: faChain,
  faChartLineDown: faChartLineDown,
  faBackwardStep: faBackwardStep,
  faStepBackward: faStepBackward,
  faClockOne: faClockOne,
  faDiceD4: faDiceD4,
  faX: faX,
  faCircleUser: faCircleUser,
  faUserCircle: faUserCircle,
  faRectangleList: faRectangleList,
  faListAlt: faListAlt,
  faCircleWifi: faCircleWifi,
  faHand: faHand,
  faHandPaper: faHandPaper,
  faLassoSparkles: faLassoSparkles,
  faArrowUpFromSquare: faArrowUpFromSquare,
  faCircleR: faCircleR,
  faPolishZlotySign: faPolishZlotySign,
  faPhoneConnection: faPhoneConnection,
  faSnooze: faSnooze,
  faZzz: faZzz,
  faUserDoctorHairMullet: faUserDoctorHairMullet,
  faPanFrying: faPanFrying,
  faVanShuttle: faVanShuttle,
  faShuttleVan: faShuttleVan,
  faStairs: faStairs,
  faShuttlecock: faShuttlecock,
  faCoinVertical: faCoinVertical,
  faCircleTurkishLira: faCircleTurkishLira,
  faSheep: faSheep,
  faHorseHead: faHorseHead,
  faCircleCalendar: faCircleCalendar,
  faCalendarCircle: faCalendarCircle,
  faVault: faVault,
  faClosedCaptioningSlash: faClosedCaptioningSlash,
  faDrumSteelpan: faDrumSteelpan,
  faThumbsUp: faThumbsUp,
  faEngine: faEngine,
  faUserAlien: faUserAlien,
  faRectangleHistory: faRectangleHistory,
  faRectangleMinus: faRectangleMinus,
  faStamp: faStamp,
  faTripleChevronsUp: faTripleChevronsUp,
  faMenorah: faMenorah,
  faTurnLeft: faTurnLeft,
  faSquareWon: faSquareWon,
  faMalaysianRinggitSign: faMalaysianRinggitSign,
  faPresentationScreen: faPresentationScreen,
  faPresentation: faPresentation,
  faCameraMovie: faCameraMovie,
  faSquareCurrency: faSquareCurrency,
  faHatChef: faHatChef,
  faChildren: faChildren,
  faSnowBlowing: faSnowBlowing,
  faAlbumCollection: faAlbumCollection,
  faChartLine: faChartLine,
  faLineChart: faLineChart,
  faCircleUpLeft: faCircleUpLeft,
  faEnvelopeRibbon: faEnvelopeRibbon,
  faEnvelopeCertificate: faEnvelopeCertificate,
  faTire: faTire,
  faAustralianDollarSign: faAustralianDollarSign,
  faSquareEnvelope: faSquareEnvelope,
  faEnvelopeSquare: faEnvelopeSquare,
  faObjectExclude: faObjectExclude,
  faUserGroupCrown: faUserGroupCrown,
  faUsersCrown: faUsersCrown,
  faBanSmoking: faBanSmoking,
  faSmokingBan: faSmokingBan,
  faUserVisor: faUserVisor,
  faBarProgressHalf: faBarProgressHalf,
  faTruckFront: faTruckFront,
  faBlindsOpen: faBlindsOpen,
  faBuilding: faBuilding,
  faBullseye: faBullseye,
  faAlbumCircleUser: faAlbumCircleUser,
  faArrowLeftLong: faArrowLeftLong,
  faLongArrowLeft: faLongArrowLeft,
  faSwapArrows: faSwapArrows,
  faChessRook: faChessRook,
  faBlenderPhone: faBlenderPhone,
  faArrowTurnUp: faArrowTurnUp,
  faLevelUp: faLevelUp,
  faShelvesEmpty: faShelvesEmpty,
  faNote: faNote,
  faPenField: faPenField,
  faCorn: faCorn,
  faPianoKeyboard: faPianoKeyboard,
  faFaceTongueSweat: faFaceTongueSweat,
  faBicycle: faBicycle,
  faMoneySimpleFromBracket: faMoneySimpleFromBracket,
  faUserTieHairLong: faUserTieHairLong,
  faBadge: faBadge,
  faTruckUtensils: faTruckUtensils,
  faFileBracketsCurly: faFileBracketsCurly,
  faCircleArrowDown: faCircleArrowDown,
  faArrowCircleDown: faArrowCircleDown,
  faPeruvianSolesSign: faPeruvianSolesSign,
  faTripleChevronsLeft: faTripleChevronsLeft,
  faGear: faGear,
  faCog: faCog,
  faFilms: faFilms,
  faWalker: faWalker,
  faSquareArrowRight: faSquareArrowRight,
  faArrowSquareRight: faArrowSquareRight,
  faFaceParty: faFaceParty,
  faMarsAndVenusBurst: faMarsAndVenusBurst,
  faColumns3: faColumns3,
  faOtter: faOtter,
  faArrowUTurnRightDown: faArrowUTurnRightDown,
  faCircle9: faCircle9,
  faSneakerRunning: faSneakerRunning,
  faCircleChevronLeft: faCircleChevronLeft,
  faChevronCircleLeft: faChevronCircleLeft,
  faCircleQuestion: faCircleQuestion,
  faQuestionCircle: faQuestionCircle,
  faArrowRotateRight10: faArrowRotateRight10,
  faWalkieTalkie: faWalkieTalkie,
  faUserGroup: faUserGroup,
  faUserFriends: faUserFriends,
  faBedFront: faBedFront,
  faBedAlt: faBedAlt,
  faHouseChimney: faHouseChimney,
  faHomeLg: faHomeLg,
  faRightFromBracket: faRightFromBracket,
  faSignOutAlt: faSignOutAlt,
  faPeanuts: faPeanuts,
  faTriangleInstrument: faTriangleInstrument,
  faTriangleMusic: faTriangleMusic,
  faBowlSpoon: faBowlSpoon,
  faFile: faFile,
  faPlaneSlash: faPlaneSlash,
  faIndustryWindows: faIndustryWindows,
  faIndustryAlt: faIndustryAlt,
  faCloudShowersHeavy: faCloudShowersHeavy,
  faBedBunk: faBedBunk,
  faPersonFalling: faPersonFalling,
  faSquareChevronDown: faSquareChevronDown,
  faChevronSquareDown: faChevronSquareDown,
  faButter: faButter,
  faTurnDown: faTurnDown,
  faLevelDownAlt: faLevelDownAlt,
  faVolumeSlash: faVolumeSlash,
  faUpRightAndDownLeftFromCenter: faUpRightAndDownLeftFromCenter,
  faExpandAlt: faExpandAlt,
  faUserTag: faUserTag,
  faSquare0: faSquare0,
  faInboxIn: faInboxIn,
  faInboxArrowDown: faInboxArrowDown,
  faKettlebell: faKettlebell,
  faGlobeSnow: faGlobeSnow,
  faHandSparkles: faHandSparkles,
  faFilePpt: faFilePpt,
  faArrowsToDot: faArrowsToDot,
  faFaceSadCry: faFaceSadCry,
  faSadCry: faSadCry,
  faImageSlash: faImageSlash,
  faTrophyStar: faTrophyStar,
  faTrophyAlt: faTrophyAlt,
  faDongSign: faDongSign,
  faSquareCent: faSquareCent,
  faPeopleLine: faPeopleLine,
  faSquareRss: faSquareRss,
  faRssSquare: faRssSquare,
  faIslandTropical: faIslandTropical,
  faIslandTreePalm: faIslandTreePalm,
  faClockTwelve: faClockTwelve,
  faCalendarMinus: faCalendarMinus,
  faChartDiagram: faChartDiagram,
  faBallotCheck: faBallotCheck,
  faChfSign: faChfSign,
  faCalendarImage: faCalendarImage,
  faDownRight: faDownRight,
  faCalendarCircleUser: faCalendarCircleUser,
  faCircleShareNodes: faCircleShareNodes,
  faFaceTired: faFaceTired,
  faTired: faTired,
  faDiagramPrevious: faDiagramPrevious,
  faFaceAstonished: faFaceAstonished,
  faIceSkate: faIceSkate,
  faArrowUTurnLeftUp: faArrowUTurnLeftUp,
  faLaptopArrowDown: faLaptopArrowDown,
  faUserCirclePlus: faUserCirclePlus,
  faRaygun: faRaygun,
  faHandPointRight: faHandPointRight,
  faConveyorBeltEmpty: faConveyorBeltEmpty,
  faArrowRightFromArc: faArrowRightFromArc,
  faSignalStreamSlash: faSignalStreamSlash,
  faCourtSport: faCourtSport,
  faTrainTrack: faTrainTrack,
  faUserMicrophone: faUserMicrophone,
  faCars: faCars,
  faNfcPen: faNfcPen,
  faArrowUp: faArrowUp,
  faXmarkLarge: faXmarkLarge,
  faCubesStacked: faCubesStacked,
  faChildCombatant: faChildCombatant,
  faChildRifle: faChildRifle,
  faSquareG: faSquareG,
  faVestPatches: faVestPatches,
  faImageCirclePlus: faImageCirclePlus,
  faMartiniGlassEmpty: faMartiniGlassEmpty,
  faGlassMartini: faGlassMartini,
  faCircleLari: faCircleLari,
  faKidneys: faKidneys,
  faBracketsCurly: faBracketsCurly,
  faPersonSoccer: faPersonSoccer,
  faDiamondExclamation: faDiamondExclamation,
  faMagnet: faMagnet,
  faRoadBarrier: faRoadBarrier,
  faCompassDrafting: faCompassDrafting,
  faDraftingCompass: faDraftingCompass,
  faRectangle: faRectangle,
  faRectangleLandscape: faRectangleLandscape,
  faHandHoldingSkull: faHandHoldingSkull,
  faSquarePersonConfined: faSquarePersonConfined,
  faGrid: faGrid,
  faGrid3: faGrid3,
  faCabinetFiling: faCabinetFiling,
  faPlateWheat: faPlateWheat,
  faRectangleVerticalHistory: faRectangleVerticalHistory,
  faSignHanging: faSignHanging,
  faSign: faSign,
  faCircle8: faCircle8,
  faCarBattery: faCarBattery,
  faBatteryCar: faBatteryCar,
  faShirt: faShirt,
  faTShirt: faTShirt,
  faTshirt: faTshirt,
  faParagraph: faParagraph,
  faEnvelopesBulk: faEnvelopesBulk,
  faMailBulk: faMailBulk,
  faFileDoc: faFileDoc,
  faGuitar: faGuitar,
  faFlyingDisc: faFlyingDisc,
  faSuitcase: faSuitcase,
  faCircleUp: faCircleUp,
  faArrowAltCircleUp: faArrowAltCircleUp,
  faF: faF,
  faXmarksLines: faXmarksLines,
  faHashtagLock: faHashtagLock,
  faGarageOpen: faGarageOpen,
  faGasPumpLeft: faGasPumpLeft,
  faPumpImpeller: faPumpImpeller,
  faBasketShoppingPlus: faBasketShoppingPlus,
  faHandFingersCrossed: faHandFingersCrossed,
  faBrainArrowCurvedRight: faBrainArrowCurvedRight,
  faMindShare: faMindShare,
  faPersonSign: faPersonSign,
  faCircleTrash: faCircleTrash,
  faTrashCircle: faTrashCircle,
  faEarthOceania: faEarthOceania,
  faGlobeOceania: faGlobeOceania,
  faUTurnUpLeft: faUTurnUpLeft,
  faCommentSlash: faCommentSlash,
  faPlay: faPlay,
  faUserDashed: faUserDashed,
  faHouseWindow: faHouseWindow,
  faVialCircleCheck: faVialCircleCheck,
  faBridgeCircleCheck: faBridgeCircleCheck,
  faCediSign: faCediSign,
  faHatSanta: faHatSanta,
  faPuzzlePiece: faPuzzlePiece,
  faHelmetUn: faHelmetUn,
  faGlassWater: faGlassWater,
  faPenFancySlash: faPenFancySlash,
  faHeartCircleBolt: faHeartCircleBolt,
  faFireHydrant: faFireHydrant,
  faMemoCircleCheck: faMemoCircleCheck,
  faPumpSoap: faPumpSoap,
  faHandScissors: faHandScissors,
  faSandwich: faSandwich,
  faDolly: faDolly,
  faDollyBox: faDollyBox,
  faPaperclip: faPaperclip,
  faMeterFire: faMeterFire,
  faDemocrat: faDemocrat,
  faSquareArrowUpRight: faSquareArrowUpRight,
  faExternalLinkSquare: faExternalLinkSquare,
  faSquareExclamation: faSquareExclamation,
  faExclamationSquare: faExclamationSquare,
  faWave: faWave,
  faFerry: faFerry,
  faMosquito: faMosquito,
  faHexagonMinus: faHexagonMinus,
  faMinusHexagon: faMinusHexagon,
  faBuildingCircleArrowRight: faBuildingCircleArrowRight,
  faFaceHandPeeking: faFaceHandPeeking,
  faArrowLeftFromLine: faArrowLeftFromLine,
  faArrowFromRight: faArrowFromRight,
  faLeftRight: faLeftRight,
  faArrowsAltH: faArrowsAltH,
  faSignalBarsWeak: faSignalBarsWeak,
  faSignalAlt1: faSignalAlt1,
  faAirplayAudio: faAirplayAudio,
  faLightbulbGear: faLightbulbGear,
  faGrid2Minus: faGrid2Minus,
  faRectangleTerminal: faRectangleTerminal,
  faSquareDownLeft: faSquareDownLeft,
  faMailboxOpenLetter: faMailboxOpenLetter,
  faPepper: faPepper,
  faMoonStars: faMoonStars,
  faClockFive: faClockFive,
  faCorner: faCorner,
  faVirus: faVirus,
  faNorwegianKroneSign: faNorwegianKroneSign,
  faGem: faGem,
  faToilet: faToilet,
  faBurgerFries: faBurgerFries,
  faPaperclipVertical: faPaperclipVertical,
  faShirtLongSleeve: faShirtLongSleeve,
  faTrashCanCheck: faTrashCanCheck,
  faSingleQuoteLeft: faSingleQuoteLeft,
  faArrowUTurnDownRight: faArrowUTurnDownRight,
  faMoneyBills: faMoneyBills,
  faCarCircleBolt: faCarCircleBolt,
  faTabletButton: faTabletButton,
  faRectangleHighDynamicRange: faRectangleHighDynamicRange,
  faRectangleHdr: faRectangleHdr,
  faSquareYen: faSquareYen,
  faSquareArrowDownLeft: faSquareArrowDownLeft,
  faBulldozer: faBulldozer,
  faCalendarPen: faCalendarPen,
  faCalendarEdit: faCalendarEdit,
  faBellOn: faBellOn,
  faExcavator: faExcavator,
  faRectangleXmark: faRectangleXmark,
  faRectangleTimes: faRectangleTimes,
  faTimesRectangle: faTimesRectangle,
  faWindowClose: faWindowClose,
  faWrench: faWrench,
  faMessageSlash: faMessageSlash,
  faCommentAltSlash: faCommentAltSlash,
  faMace: faMace,
  faWatch: faWatch,
  faTally1: faTally1,
  faTrashCan: faTrashCan,
  faTrashAlt: faTrashAlt,
  faPuzzle: faPuzzle,
  faTableCells: faTableCells,
  faTh: faTh,
  faTrashCanList: faTrashCanList,
  faRibbon: faRibbon,
  faLandmarkFlag: faLandmarkFlag,
  faBadminton: faBadminton,
  faUpToBracket: faUpToBracket,
  faChartLineUpDown: faChartLineUpDown,
  faUpDownLeftRight: faUpDownLeftRight,
  faArrowsAlt: faArrowsAlt,
  faGarageEmpty: faGarageEmpty,
  faCarSide: faCarSide,
  faTrashArrowUp: faTrashArrowUp,
  faTrashRestore: faTrashRestore,
  faLifeRing: faLifeRing,
  faBarProgressThreeQuarters: faBarProgressThreeQuarters,
  faCopyright: faCopyright,
  faLeafyGreen: faLeafyGreen,
  faHighlighterLine: faHighlighterLine,
  faRectangleHistoryCircleUser: faRectangleHistoryCircleUser,
  faFerrisWheel: faFerrisWheel,
  faArrowUpFromArc: faArrowUpFromArc,
  faGridDividers: faGridDividers,
  faLightbulbDollar: faLightbulbDollar,
  faCoffin: faCoffin,
  faFilePrescription: faFilePrescription,
  faEraser: faEraser,
  faFlaskRoundPoison: faFlaskRoundPoison,
  faFlaskPoison: faFlaskPoison,
  faCameraClock: faCameraClock,
  faCircleHalfHorizontal: faCircleHalfHorizontal,
  faSquareT: faSquareT,
  faCircleShekel: faCircleShekel,
  faSpaceStationMoonConstruction: faSpaceStationMoonConstruction,
  faSpaceStationMoonAlt: faSpaceStationMoonAlt,
  faCircleMoon: faCircleMoon,
  faBasketballHoop: faBasketballHoop,
  faCodeSimple: faCodeSimple,
  faLeftToDottedLine: faLeftToDottedLine,
  faHockeyStickPuck: faHockeyStickPuck,
  faHourglassStart: faHourglassStart,
  faHourglass1: faHourglass1,
  faCircleLeft: faCircleLeft,
  faArrowAltCircleLeft: faArrowAltCircleLeft,
  faRestroomSimple: faRestroomSimple,
  faCruzeiroSign: faCruzeiroSign,
  faSmoking: faSmoking,
  faChartPieSimpleCircleDollar: faChartPieSimpleCircleDollar,
  faUserVneckHair: faUserVneckHair,
  faSquarePollVertical: faSquarePollVertical,
  faPoll: faPoll,
  faPersonCircleMinus: faPersonCircleMinus,
  faEnvelopeOpenDollar: faEnvelopeOpenDollar,
  faBiohazard: faBiohazard,
  faObjectsAlignBottom: faObjectsAlignBottom,
  faScrollOld: faScrollOld,
  faBellConcierge: faBellConcierge,
  faConciergeBell: faConciergeBell,
  faRulerHorizontal: faRulerHorizontal,
  faHorse: faHorse,
  faAngle90: faAngle90,
  faDownToBracket: faDownToBracket,
  faBookCopy: faBookCopy,
  faCalendar: faCalendar,
  faHandsHoldingChild: faHandsHoldingChild,
  faPollPeople: faPollPeople,
  faBracketRound: faBracketRound,
  faParenthesis: faParenthesis,
  faTruckContainer: faTruckContainer,
  faEyeEvil: faEyeEvil,
  faPlayFlip: faPlayFlip,
  faBorderInner: faBorderInner,
  faItalic: faItalic,
  faMicrophoneCirclePlus: faMicrophoneCirclePlus,
  faDownToLine: faDownToLine,
  faArrowAltToBottom: faArrowAltToBottom,
  faCircleCruzeiro: faCircleCruzeiro,
  faCloudBinary: faCloudBinary,
  faCardClub: faCardClub,
  faLightSwitchOn: faLightSwitchOn,
  faTruckSuv: faTruckSuv,
  faKhanda: faKhanda,
  faFaceFrownOpen: faFaceFrownOpen,
  faFrownOpen: faFrownOpen,
  faCheck: faCheck,
  faBowArrow: faBowArrow,
  faBanBug: faBanBug,
  faDebug: faDebug,
  faArrowDownFromDottedLine: faArrowDownFromDottedLine,
  faFingerprint: faFingerprint,
  faBowlScoop: faBowlScoop,
  faBowlShavedIce: faBowlShavedIce,
  faChargingStation: faChargingStation,
  faPlaneUpSlash: faPlaneUpSlash,
  faUserLock: faUserLock,
  faMobileScreenButton: faMobileScreenButton,
  faMobileAlt: faMobileAlt,
  faOlive: faOlive,
  faAnchorCircleCheck: faAnchorCircleCheck,
  faRectangle4k: faRectangle4k,
  faScalpel: faScalpel,
  faPersonWalkingWithCane: faPersonWalkingWithCane,
  faBlind: faBlind,
  faCandleHolder: faCandleHolder,
  faFileWaveform: faFileWaveform,
  faFileMedicalAlt: faFileMedicalAlt,
  faRenminbiSign: faRenminbiSign,
  faFaceSpiralEyes: faFaceSpiralEyes,
  faCalendarArrowUp: faCalendarArrowUp,
  faCalendarUpload: faCalendarUpload,
  faPersonArmsRaised: faPersonArmsRaised,
  faPersonDressFairy: faPersonDressFairy,
  faBarProgress: faBarProgress,
  faChartKanban: faChartKanban,
  faCloudMusic: faCloudMusic,
  faWatchSmart: faWatchSmart,
  faLeftToBracket: faLeftToBracket,
  faGrateDroplet: faGrateDroplet,
  faHouseCrack: faHouseCrack,
  faWifiSlash: faWifiSlash,
  faHatWizard: faHatWizard,
  faFootballHelmet: faFootballHelmet,
  faUserDoctor: faUserDoctor,
  faUserMd: faUserMd,
  faGlassesRound: faGlassesRound,
  faGlassesAlt: faGlassesAlt,
  faRocketLaunch: faRocketLaunch,
  faHandHoldingCircleDollar: faHandHoldingCircleDollar,
  faChartBar: faChartBar,
  faBarChart: faBarChart,
  faMessageDollar: faMessageDollar,
  faCommentAltDollar: faCommentAltDollar,
  faVideoDownToLine: faVideoDownToLine,
  faSprayCanSparkles: faSprayCanSparkles,
  faAirFreshener: faAirFreshener,
  faBahtSign: faBahtSign,
  faFaceBeamHandOverMouth: faFaceBeamHandOverMouth,
  faTemperatureArrowUp: faTemperatureArrowUp,
  faTemperatureUp: faTemperatureUp,
  faWebAwesome: faWebAwesome,
  faNonBinary: faNonBinary,
  faShieldSlash: faShieldSlash,
  faFloppyDisks: faFloppyDisks,
  faN: faN,
  faArrowsUpDownLeftRight: faArrowsUpDownLeftRight,
  faArrows: faArrows,
  faHouse: faHouse,
  faHome: faHome,
  faHomeAlt: faHomeAlt,
  faHomeLgAlt: faHomeLgAlt,
  faSpinner: faSpinner,
  faSquareY: faSquareY,
  faSquareMill: faSquareMill,
  faGavel: faGavel,
  faLegal: faLegal,
  faCircleTugrik: faCircleTugrik,
  faTrashClock: faTrashClock,
  faCirclePhone: faCirclePhone,
  faPhoneCircle: faPhoneCircle,
  faBoltAuto: faBoltAuto,
  faUserPilotTieHairLong: faUserPilotTieHairLong,
  faArrowTurnLeftDown: faArrowTurnLeftDown,
  faTicketSimple: faTicketSimple,
  faTicketAlt: faTicketAlt,
  faDove: faDove,
  faCircleYen: faCircleYen,
  faTarpDroplet: faTarpDroplet,
  faBroomWide: faBroomWide,
  faPlayPause: faPlayPause,
  faTreeCity: faTreeCity,
  faCalendarRange: faCalendarRange,
  faTurnUp: faTurnUp,
  faLevelUpAlt: faLevelUpAlt,
  faCreditCardFront: faCreditCardFront,
  faTemperatureQuarter: faTemperatureQuarter,
  faTemperature1: faTemperature1,
  faThermometer1: faThermometer1,
  faThermometerQuarter: faThermometerQuarter,
  faChestnut: faChestnut,
  faCrystalBall: faCrystalBall,
  faFlagSwallowtail: faFlagSwallowtail,
  faFlagAlt: faFlagAlt,
  faSliders: faSliders,
  faSlidersH: faSlidersH,
  faPersonSledding: faPersonSledding,
  faSledding: faSledding,
  faMosque: faMosque,
  faFolderMagnifyingGlass: faFolderMagnifyingGlass,
  faFolderSearch: faFolderSearch,
  faLinkHorizontal: faLinkHorizontal,
  faChainHorizontal: faChainHorizontal,
  faH: faH,
  faMessageBot: faMessageBot,
  faInfo: faInfo,
  faPersonWalking: faPersonWalking,
  faWalking: faWalking,
  faRadioTuner: faRadioTuner,
  faRadioAlt: faRadioAlt,
  faComputerMouseScrollwheel: faComputerMouseScrollwheel,
  faMouseAlt: faMouseAlt,
  faCarSirenOn: faCarSirenOn,
  faUpRight: faUpRight,
  faPaintbrushSlash: faPaintbrushSlash,
  faCircleArrowUpRight: faCircleArrowUpRight,
  faArrowTurnDown: faArrowTurnDown,
  faLevelDown: faLevelDown,
  faRoad: faRoad,
  faBuoy: faBuoy,
  faSpiral: faSpiral,
  faPaintbrushPencil: faPaintbrushPencil,
  faFileCad: faFileCad,
  faPeoplePantsSimple: faPeoplePantsSimple,
  faFaceFrown: faFaceFrown,
  faFrown: faFrown,
  faWineGlassEmpty: faWineGlassEmpty,
  faWineGlassAlt: faWineGlassAlt,
  faClapperboard: faClapperboard,
  faOilCanDrip: faOilCanDrip,
  faPhonePlus: faPhonePlus,
  faForwardStep: faForwardStep,
  faStepForward: faStepForward,
  faFileDashedLine: faFileDashedLine,
  faPageBreak: faPageBreak,
  faScribble: faScribble,
  faGaugeMin: faGaugeMin,
  faTachometerAltSlowest: faTachometerAltSlowest,
  faSquareUpRight: faSquareUpRight,
  faExternalLinkSquareAlt: faExternalLinkSquareAlt,
  faWifiExclamation: faWifiExclamation,
  faBookJournalWhills: faBookJournalWhills,
  faJournalWhills: faJournalWhills,
  faOctagonMinus: faOctagonMinus,
  faMinusOctagon: faMinusOctagon,
  faChampagneGlasses: faChampagneGlasses,
  faGlassCheers: faGlassCheers,
  faFolderXmark: faFolderXmark,
  faFolderTimes: faFolderTimes,
  faTrashList: faTrashList,
  faDumpster: faDumpster,
  faCircleEnvelope: faCircleEnvelope,
  faEnvelopeCircle: faEnvelopeCircle,
  faMobileNotch: faMobileNotch,
  faMobileIphone: faMobileIphone,
  faMobileSignal: faMobileSignal,
  faHeartCircleXmark: faHeartCircleXmark,
  faComputer: faComputer,
  faWandMagic: faWandMagic,
  faMagic: faMagic,
  faBrain: faBrain,
  faPeoplePants: faPeoplePants,
  faDialpad: faDialpad,
  faBriefcaseMedical: faBriefcaseMedical,
  faSmoke: faSmoke,
  faHouseMedicalCircleExclamation: faHouseMedicalCircleExclamation,
  faFaceMonocle: faFaceMonocle,
  faLineColumns: faLineColumns,
  faFaceVomit: faFaceVomit,
  faPersonDolly: faPersonDolly,
  faCodeCommit: faCodeCommit,
  faPersonBreastfeeding: faPersonBreastfeeding,
  faSquareBaht: faSquareBaht,
  faPersonRays: faPersonRays,
  faWaterArrowDown: faWaterArrowDown,
  faWaterLower: faWaterLower,
  faSymbols: faSymbols,
  faIconsAlt: faIconsAlt,
  faChartMixedUpCircleCurrency: faChartMixedUpCircleCurrency,
  faManatSign: faManatSign,
  faBagSeedling: faBagSeedling,
  faSort: faSort,
  faUnsorted: faUnsorted,
  faCircleRadiation: faCircleRadiation,
  faRadiationAlt: faRadiationAlt,
  faLaptopCode: faLaptopCode,
  faSink: faSink,
  faTableCellsRows: faTableCellsRows,
  faArrowUpFromWaterPump: faArrowUpFromWaterPump,
  faMicrophoneLinesSlash: faMicrophoneLinesSlash,
  faMicrophoneAltSlash: faMicrophoneAltSlash,
  faFaceShakingVertical: faFaceShakingVertical,
  faBrowser: faBrowser,
  faFaceSleepy: faFaceSleepy,
  faServer: faServer,
  faUser: faUser,
  faUserAlt: faUserAlt,
  faUserLarge: faUserLarge,
  faSignalBars: faSignalBars,
  faSignalAlt: faSignalAlt,
  faSignalAlt4: faSignalAlt4,
  faSignalBarsStrong: faSignalBarsStrong,
  faStarshipFreighter: faStarshipFreighter,
  faSnowflake: faSnowflake,
  faDialMed: faDialMed,
  faSkullCrossbones: faSkullCrossbones,
  faPesoSign: faPesoSign,
  faWineGlass: faWineGlass,
  faTemperatureHalf: faTemperatureHalf,
  faTemperature2: faTemperature2,
  faThermometer2: faThermometer2,
  faThermometerHalf: faThermometerHalf,
  faChartTreeMap: faChartTreeMap,
  faTicket: faTicket,
  faNfcSymbol: faNfcSymbol,
  faShieldUser: faShieldUser,
  faTireRugged: faTireRugged,
  faWheatAwnCircleExclamation: faWheatAwnCircleExclamation,
  faCircleL: faCircleL,
  faArrowsTurnRight: faArrowsTurnRight,
  faRouteInterstate: faRouteInterstate,
  faCandyCane: faCandyCane,
  faCircle6: faCircle6,
  faCitrus: faCitrus,
  faWheelchair: faWheelchair,
  faExpandWide: faExpandWide,
  faSpellCheck: faSpellCheck,
  faTurnDownRight: faTurnDownRight,
  faVolumeOff: faVolumeOff,
  faSaxophone: faSaxophone,
  faSensorTriangleExclamation: faSensorTriangleExclamation,
  faSensorAlert: faSensorAlert,
  faLungs: faLungs,
  faCarWrench: faCarWrench,
  faCarMechanic: faCarMechanic,
  faPopsicle: faPopsicle,
  faBookmark: faBookmark,
  faBarcode: faBarcode,
  faWheatAwnSlash: faWheatAwnSlash,
  faListOl: faListOl,
  faList12: faList12,
  faListNumeric: faListNumeric,
  faTypewriter: faTypewriter,
  faFileCircleXmark: faFileCircleXmark,
  faInboxOut: faInboxOut,
  faInboxArrowUp: faInboxArrowUp,
  faCube: faCube,
  faTape: faTape,
  faBomb: faBomb,
  faCameraWeb: faCameraWeb,
  faWebcam: faWebcam,
  faLacrosseStick: faLacrosseStick,
  faDisplayChartUp: faDisplayChartUp,
  faTrashSlash: faTrashSlash,
  faSdCards: faSdCards,
  faScaleUnbalanced: faScaleUnbalanced,
  faBalanceScaleLeft: faBalanceScaleLeft,
  faCircleMalaysianRinggit: faCircleMalaysianRinggit,
  faBookCircleArrowRight: faBookCircleArrowRight,
  faSquareCaretLeft: faSquareCaretLeft,
  faCaretSquareLeft: faCaretSquareLeft,
  faRuler: faRuler,
  faCardsBlank: faCardsBlank,
  faI: faI,
  faCircleNorwegianKrone: faCircleNorwegianKrone,
  faAirplay: faAirplay,
  faVolumeXmark: faVolumeXmark,
  faVolumeMute: faVolumeMute,
  faVolumeTimes: faVolumeTimes,
  faArchway: faArchway,
  faPersonDigging: faPersonDigging,
  faDigging: faDigging,
  faGaugeHigh: faGaugeHigh,
  faTachometerAlt: faTachometerAlt,
  faTachometerAltFast: faTachometerAltFast,
  faSquareHalf: faSquareHalf,
  faGenderless: faGenderless,
  faClockTen: faClockTen,
  faWireless: faWireless,
  faSquareAustral: faSquareAustral,
  faCloudSun: faCloudSun,
  faArrowRight: faArrowRight,
  faSquareInfo: faSquareInfo,
  faInfoSquare: faInfoSquare,
  faHandshake: faHandshake,
  faHandshakeAlt: faHandshakeAlt,
  faHandshakeSimple: faHandshakeSimple,
  faCloudQuestion: faCloudQuestion,
  faPersonSkiing: faPersonSkiing,
  faSkiing: faSkiing,
  faBridgeWater: faBridgeWater,
  faBuildingNgo: faBuildingNgo,
  faMoped: faMoped,
  faGridRound2: faGridRound2,
  faIgloo: faIgloo,
  faChessKnightPiece: faChessKnightPiece,
  faChessKnightAlt: faChessKnightAlt,
  faHandHoldingMagic: faHandHoldingMagic,
  faCircleDollarToSlot: faCircleDollarToSlot,
  faDonate: faDonate,
  faUserTieHairMullet: faUserTieHairMullet,
  faAwardSimple: faAwardSimple,
  faConveyorBeltBoxes: faConveyorBeltBoxes,
  faConveyorBeltAlt: faConveyorBeltAlt,
  faFileSvg: faFileSvg,
  faY: faY,
  faFaceSmileWink: faFaceSmileWink,
  faSmileWink: faSmileWink,
  faCircleManat: faCircleManat,
  faDiceFour: faDiceFour,
  faFileMinus: faFileMinus,
  faArrowLeftToArc: faArrowLeftToArc,
  faCarTilt: faCarTilt,
  faCloudBoltSun: faCloudBoltSun,
  faThunderstormSun: faThunderstormSun,
  faFaceGrinSquintTears: faFaceGrinSquintTears,
  faGrinSquintTears: faGrinSquintTears,
  faSnowflakes: faSnowflakes,
  faPretzel: faPretzel,
  faGlass: faGlass,
  faTripleChevronsDown: faTripleChevronsDown,
  faFileAudio: faFileAudio,
  faSquareFranc: faSquareFranc,
  faArrowsDownToLine: faArrowsDownToLine,
  faMobileSlash: faMobileSlash,
  faVideoArrowDownLeft: faVideoArrowDownLeft,
  faRightLongToLine: faRightLongToLine,
  faG: faG,
  faVihara: faVihara,
  faFlagCheckered: faFlagCheckered,
  faBriefcaseArrowRight: faBriefcaseArrowRight,
  faHeartHalfStroke: faHeartHalfStroke,
  faHeartHalfAlt: faHeartHalfAlt,
  faCommentCaptions: faCommentCaptions,
  faGaugeSimple: faGaugeSimple,
  faGaugeSimpleMed: faGaugeSimpleMed,
  faTachometerAverage: faTachometerAverage,
  faShredder: faShredder,
  faFonduePot: faFonduePot,
  faRightLeft: faRightLeft,
  faExchangeAlt: faExchangeAlt,
  faPlanetRinged: faPlanetRinged,
  faPills: faPills,
  faExplosion: faExplosion,
  faArrowsDownToPeople: faArrowsDownToPeople,
  faUsersViewfinder: faUsersViewfinder,
  faMusicNote: faMusicNote,
  faMusicAlt: faMusicAlt,
  faCarOn: faCarOn,
  faCircleCamera: faCircleCamera,
  faCameraCircle: faCameraCircle,
  faSunBright: faSunBright,
  faSunAlt: faSunAlt,
  faBatteryBolt: faBatteryBolt,
  faMushroom: faMushroom,
  faGlobeWifi: faGlobeWifi,
  faArrowRotateLeft10: faArrowRotateLeft10,
  faSleigh: faSleigh,
  faArrowDownLeftAndArrowUpRightToCenter: faArrowDownLeftAndArrowUpRightToCenter,
  faPersonSwimmingWater: faPersonSwimmingWater,
  faDialHigh: faDialHigh,
  faDumbbell: faDumbbell,
  faBabyCarriage: faBabyCarriage,
  faCarriageBaby: faCarriageBaby,
  faClouds: faClouds,
  faCameraCctv: faCameraCctv,
  faCctv: faCctv,
  faBuildings: faBuildings,
  faRectangleBarcode: faRectangleBarcode,
  faBarcodeAlt: faBarcodeAlt,
  faTruckFire: faTruckFire,
  faArrowDownBigSmall: faArrowDownBigSmall,
  faSortSizeDown: faSortSizeDown,
  faHandLove: faHandLove,
  faBagShoppingMinus: faBagShoppingMinus,
  faClockElevenThirty: faClockElevenThirty,
  faSlashForward: faSlashForward,
  faPineapple: faPineapple,
  faFacePersevering: faFacePersevering,
  faCardDiamond: faCardDiamond,
  faRaccoon: faRaccoon,
  faFolderBookmark: faFolderBookmark,
  faKeySkeletonLeftRight: faKeySkeletonLeftRight,
  faCircleI: faCircleI,
  faKiwiBird: faKiwiBird,
  faCalendarXmark: faCalendarXmark,
  faCalendarTimes: faCalendarTimes,
  faCircleDown: faCircleDown,
  faArrowAltCircleDown: faArrowAltCircleDown,
  faFileMedical: faFileMedical,
  faXmark: faXmark,
  faClose: faClose,
  faMultiply: faMultiply,
  faRemove: faRemove,
  faTimes: faTimes,
  faShapes: faShapes,
  faTriangleCircleSquare: faTriangleCircleSquare,
  faDiceOne: faDiceOne,
  faKnifeKitchen: faKnifeKitchen,
  faArrowsCross: faArrowsCross,
  faCompassSlash: faCompassSlash,
  faLockOpen: faLockOpen,
  faPepperHot: faPepperHot,
  faDropletSlash: faDropletSlash,
  faTintSlash: faTintSlash,
  faDroplet: faDroplet,
  faTint: faTint,
  faPersonMeditating: faPersonMeditating,
  faFileLines: faFileLines,
  faFileAlt: faFileAlt,
  faFileText: faFileText,
  faCommentsDollar: faCommentsDollar,
  faPersonGolfing: faPersonGolfing,
  faTrashCheck: faTrashCheck,
  faMagnifyingGlassLocation: faMagnifyingGlassLocation,
  faSearchLocation: faSearchLocation,
  faFloppyDiskCircleArrowRight: faFloppyDiskCircleArrowRight,
  faSaveCircleArrowRight: faSaveCircleArrowRight,
  faMagnifyingGlassPlay: faMagnifyingGlassPlay,
  faFileInvoice: faFileInvoice,
  faPentagon: faPentagon,
  faPhoneOffice: faPhoneOffice,
  faTreePalm: faTreePalm,
  faOnion: faOnion,
  faValueAbsolute: faValueAbsolute,
  faRepublican: faRepublican,
  faShop: faShop,
  faStoreAlt: faStoreAlt,
  faFilm: faFilm,
  faFilmAlt: faFilmAlt,
  faFilmSimple: faFilmSimple,
  faWashingMachine: faWashingMachine,
  faWasher: faWasher,
  faBuildingCircleXmark: faBuildingCircleXmark,
  faComments: faComments,
  faTags: faTags,
  faFileSpreadsheet: faFileSpreadsheet,
  faGun: faGun,
  faNestingDolls: faNestingDolls,
  faDial: faDial,
  faDialMedHigh: faDialMedHigh,
  faTruckFlatbed: faTruckFlatbed,
  faPenNibSlash: faPenNibSlash,
  faCircleCheck: faCircleCheck,
  faCheckCircle: faCheckCircle,
  faHouseTree: faHouseTree,
  faUserPilot: faUserPilot,
  faBracketSquare: faBracketSquare,
  faBracket: faBracket,
  faBracketLeft: faBracketLeft,
  faUserPilotHairLong: faUserPilotHairLong,
  faIdCardClip: faIdCardClip,
  faIdCardAlt: faIdCardAlt,
  faMoon: faMoon,
  faCaretLargeUp: faCaretLargeUp,
  faLamp: faLamp,
  faMobileArrowDown: faMobileArrowDown,
  faFilePlus: faFilePlus,
  faImageUser: faImageUser,
  faTurnRight: faTurnRight,
  faHexagonVerticalNft: faHexagonVerticalNft,
  faHexagonVerticalNftSlanted: faHexagonVerticalNftSlanted,
  faSkullCow: faSkullCow,
  faOilWell: faOilWell,
  faRhombus: faRhombus,
  faSquareLari: faSquareLari,
  faCircleUserCircleXmark: faCircleUserCircleXmark,
  faApartment: faApartment,
  faUserBountyHunter: faUserBountyHunter,
  faSeat: faSeat,
  faEyeDropperHalf: faEyeDropperHalf,
  faCommentCode: faCommentCode,
  faTachographDigital: faTachographDigital,
  faDigitalTachograph: faDigitalTachograph,
  faHandBackPointRibbon: faHandBackPointRibbon,
  faLaptopBinary: faLaptopBinary,
  faTablet: faTablet,
  faTabletAndroid: faTabletAndroid,
  faRubleSign: faRubleSign,
  faRouble: faRouble,
  faRub: faRub,
  faRuble: faRuble,
  faClosedCaptioning: faClosedCaptioning,
  faInterrobang: faInterrobang,
  faPen: faPen,
  faPalletBoxes: faPalletBoxes,
  faPaletteBoxes: faPaletteBoxes,
  faPalletAlt: faPalletAlt,
  faPlane: faPlane,
  faBookArrowRight: faBookArrowRight,
  faImages: faImages,
  faMobileScreen: faMobileScreen,
  faMobileAndroidAlt: faMobileAndroidAlt,
  faGuaraniSign: faGuaraniSign,
  faBagShopping: faBagShopping,
  faShoppingBag: faShoppingBag,
  faCircleAustral: faCircleAustral,
  faCircleRight: faCircleRight,
  faArrowAltCircleRight: faArrowAltCircleRight,
  faPersonRunningFast: faPersonRunningFast,
  faCloudSleet: faCloudSleet,
  faPiano: faPiano,
  faPhoneVolume: faPhoneVolume,
  faVolumeControlPhone: faVolumeControlPhone,
  faCubes: faCubes,
  faFileMagnifyingGlass: faFileMagnifyingGlass,
  faFileSearch: faFileSearch,
  faPhone: faPhone,
  faHexagonCheck: faHexagonCheck,
  faUserBeardBolt: faUserBeardBolt,
  faToriiGate: faToriiGate,
  faDiceD8: faDiceD8,
  faClockNine: faClockNine,
  faFileMp3: faFileMp3,
  faUserTieHair: faUserTieHair,
  faSquareIndianRupee: faSquareIndianRupee,
  faCoffinCross: faCoffinCross,
  faBacon: faBacon,
  faImagesUser: faImagesUser,
  faPersonFallingBurst: faPersonFallingBurst,
  faCaduceus: faCaduceus,
  faQuoteRight: faQuoteRight,
  faQuoteRightAlt: faQuoteRightAlt,
  faHouseMedicalFlag: faHouseMedicalFlag,
  faPrescription: faPrescription,
  faFaceWeary: faFaceWeary,
  faUpLeft: faUpLeft,
  faHandBackPointUp: faHandBackPointUp,
  faRectangleHistoryCirclePlus: faRectangleHistoryCirclePlus,
  faPersonWaterArmsRaised: faPersonWaterArmsRaised,
  faBeerMug: faBeerMug,
  faBeerFoam: faBeerFoam,
  faDiceThree: faDiceThree,
  faLasso: faLasso,
  faFileAiff: faFileAiff,
  faBuildingLock: faBuildingLock,
  faIdCard: faIdCard,
  faDriversLicense: faDriversLicense,
  faSquareRuble: faSquareRuble,
  faClockDesk: faClockDesk,
  faCirclePlay: faCirclePlay,
  faPlayCircle: faPlayCircle,
  faFaceLaughBeam: faFaceLaughBeam,
  faLaughBeam: faLaughBeam,
  faLeaf: faLeaf,
  faHouseChimneyUser: faHouseChimneyUser,
  faRotateRight: faRotateRight,
  faRedoAlt: faRedoAlt,
  faRotateForward: faRotateForward,
  faBooksMedical: faBooksMedical,
  faDress: faDress,
  faTooth: faTooth,
  faHouseChimneyWindow: faHouseChimneyWindow,
  faSquareEllipsis: faSquareEllipsis,
  faMotorcycle: faMotorcycle,
  faGridRound2Minus: faGridRound2Minus,
  faShieldMinus: faShieldMinus,
  faBackwardFast: faBackwardFast,
  faFastBackward: faFastBackward,
  faDollyEmpty: faDollyEmpty,
  faAddressBook: faAddressBook,
  faContactBook: faContactBook,
  faCloudsMoon: faCloudsMoon,
  faCarBuilding: faCarBuilding,
  faFaceAwesome: faFaceAwesome,
  faGaveDandy: faGaveDandy,
  faBlinds: faBlinds,
  faSailboat: faSailboat,
  faArrowUpLeftFromCircle: faArrowUpLeftFromCircle,
  faRightFromDottedLine: faRightFromDottedLine,
  faBookBookmark: faBookBookmark,
  faSquareBrazilianReal: faSquareBrazilianReal,
  faMagnifyingGlassArrowRight: faMagnifyingGlassArrowRight,
  faSplit: faSplit,
  faFacePensive: faFacePensive,
  faBookCircleArrowUp: faBookCircleArrowUp,
  faShipLarge: faShipLarge,
  faHeartHalf: faHeartHalf,
  faCircleLira: faCircleLira,
  faMicrophoneLines: faMicrophoneLines,
  faMicrophoneAlt: faMicrophoneAlt,
  faReplyAll: faReplyAll,
  faMailReplyAll: faMailReplyAll,
  faSquareList: faSquareList,
  faUniversalAccess: faUniversalAccess,
  faShieldCross: faShieldCross,
  faTrainStop: faTrainStop,
  faToiletPaper: faToiletPaper,
  faToiletPaperAlt: faToiletPaperAlt,
  faToiletPaperBlank: faToiletPaperBlank,
  faSquareCode: faSquareCode,
  faVrCardboard: faVrCardboard,
  faPizzaSlice: faPizzaSlice,
  faSprayCan: faSprayCan,
  faNfcTrash: faNfcTrash,
  faTemperatureList: faTemperatureList,
  faShovelSnow: faShovelSnow,
  faVolumeLow: faVolumeLow,
  faVolumeDown: faVolumeDown,
  faSolarSystem: faSolarSystem,
  faCross: faCross,
  faPerson: faPerson,
  faMale: faMale,
  faMp3Player: faMp3Player,
  faCircleBolt: faCircleBolt,
  faHourglass: faHourglass,
  faHourglassEmpty: faHourglassEmpty,
  faTrashCanSlash: faTrashCanSlash,
  faTrashAltSlash: faTrashAltSlash,
  faUserBeard: faUserBeard,
  faFish: faFish,
  faDrumstickBite: faDrumstickBite,
  faFileJpg: faFileJpg,
  faChartSimple: faChartSimple,
  faCircleEllipsisVertical: faCircleEllipsisVertical,
  faAtom: faAtom,
  faSquareMalaysianRinggit: faSquareMalaysianRinggit,
  faPrintMagnifyingGlass: faPrintMagnifyingGlass,
  faPrintSearch: faPrintSearch,
  faImagePolaroid: faImagePolaroid,
  faSquareTerminal: faSquareTerminal,
  faLightbulbMessage: faLightbulbMessage,
  faPersonLimbsWide: faPersonLimbsWide,
  faHandsHoldingDiamond: faHandsHoldingDiamond,
  faHandReceiving: faHandReceiving,
  faCircleJ: faCircleJ,
  faPedestal: faPedestal,
  faP: faP,
  faSquareEquals: faSquareEquals,
  faDagger: faDagger,
  faJetFighterUp: faJetFighterUp,
  faFieldHockeyStickBall: faFieldHockeyStickBall,
  faFieldHockey: faFieldHockey,
  faComputerMouseButtonRight: faComputerMouseButtonRight,
  faPlugCircleXmark: faPlugCircleXmark,
  faSheetPlastic: faSheetPlastic,
  faV: faV,
  faList: faList,
  faListSquares: faListSquares,
  faOliveBranch: faOliveBranch,
  faGif: faGif,
  faHoseReel: faHoseReel,
  faCircleS: faCircleS,
  faSquareM: faSquareM,
  faCircleCaretLeft: faCircleCaretLeft,
  faCaretCircleLeft: faCaretCircleLeft,
  faCircleQuarters: faCircleQuarters,
  faSolarPanel: faSolarPanel,
  faLandMineOn: faLandMineOn,
  faBallot: faBallot,
  faGiftCard: faGiftCard,
  faCircleUserCircleQuestion: faCircleUserCircleQuestion,
  faHeadphones: faHeadphones,
  faHeadphonesAlt: faHeadphonesAlt,
  faHeadphonesSimple: faHeadphonesSimple,
  faBus: faBus,
  faFilePowerpoint: faFilePowerpoint,
  faMessages: faMessages,
  faCommentsAlt: faCommentsAlt,
  faCircleRuble: faCircleRuble,
  faBarcodeRead: faBarcodeRead,
  faQuoteLeft: faQuoteLeft,
  faQuoteLeftAlt: faQuoteLeftAlt,
  faScreencast: faScreencast,
  faSkiBoot: faSkiBoot,
  faFamilyPants: faFamilyPants,
  faEyeDropperFull: faEyeDropperFull,
  faChevronDown: faChevronDown,
  faEarthAsia: faEarthAsia,
  faGlobeAsia: faGlobeAsia,
  faCentSign: faCentSign,
  faComputerMouseButtonLeft: faComputerMouseButtonLeft,
  faShieldCat: faShieldCat,
  faSchoolCircleCheck: faSchoolCircleCheck,
  faMartiniGlass: faMartiniGlass,
  faGlassMartiniAlt: faGlassMartiniAlt,
  faUserUnlock: faUserUnlock,
  faPlug: faPlug,
  faSpinnerThird: faSpinnerThird,
  faWindWarning: faWindWarning,
  faWindCircleExclamation: faWindCircleExclamation,
  faPanorama: faPanorama,
  faClockRotateLeft: faClockRotateLeft,
  faHistory: faHistory,
  faWifiWeak: faWifiWeak,
  faWifi1: faWifi1,
  faWaveform: faWaveform,
  faVideoQuestion: faVideoQuestion,
  faTicketAirline: faTicketAirline,
  faTicketPerforatedPlane: faTicketPerforatedPlane,
  faTicketPlane: faTicketPlane,
  faArrowUTurnUpRight: faArrowUTurnUpRight,
  faLinkSimple: faLinkSimple,
  faRectangleWide: faRectangleWide,
  faPig: faPig,
  faJarWheat: faJarWheat,
  faBookmarkSlash: faBookmarkSlash,
  faFileBan: faFileBan,
  faArrowUpRight: faArrowUpRight,
  faSquareV: faSquareV,
  faCloudArrowDown: faCloudArrowDown,
  faCloudDownload: faCloudDownload,
  faCloudDownloadAlt: faCloudDownloadAlt,
  faKeyboardLeft: faKeyboardLeft,
  faBadgeCheck: faBadgeCheck,
  faTruckRampBox: faTruckRampBox,
  faTruckLoading: faTruckLoading,
  faFaceDotted: faFaceDotted,
  faCircle1: faCircle1,
  faOctopus: faOctopus,
  faAngleDown: faAngleDown,
  faSquareKanban: faSquareKanban,
  faCircleThreeQuartersStroke: faCircleThreeQuartersStroke,
  faPlugCircleCheck: faPlugCircleCheck,
  faCameraShutter: faCameraShutter,
  faWindowMaximize: faWindowMaximize,
  faTvMusic: faTvMusic,
  faHandsHoldingCircle: faHandsHoldingCircle,
  faWreath: faWreath,
  faLocationPin: faLocationPin,
  faMapMarker: faMapMarker,
  faBowlingBall: faBowlingBall,
  faCartFlatbed: faCartFlatbed,
  faDollyFlatbed: faDollyFlatbed,
  faHouseUser: faHouseUser,
  faHomeUser: faHomeUser,
  faBrainCircuit: faBrainCircuit,
  faSquareaporeDollar: faSquareaporeDollar,
  faEnvelopes: faEnvelopes,
  faEscalator: faEscalator,
  faGhost: faGhost,
  faShorts: faShorts,
  faFloppyDiskCircleXmark: faFloppyDiskCircleXmark,
  faFloppyDiskTimes: faFloppyDiskTimes,
  faSaveCircleXmark: faSaveCircleXmark,
  faSaveTimes: faSaveTimes,
  faBallYarn: faBallYarn,
  faDisplayCode: faDisplayCode,
  faDesktopCode: faDesktopCode,
  faBalloons: faBalloons,
  faCommentNodes: faCommentNodes,
  faTreeChristmas: faTreeChristmas,
  faPersonArrowDownToLine: faPersonArrowDownToLine,
  faPlugCirclePlus: faPlugCirclePlus,
  faPersonSwimming: faPersonSwimming,
  faSwimmer: faSwimmer,
  faCommentDots: faCommentDots,
  faCommenting: faCommenting,
  faChartPie: faChartPie,
  faPieChart: faPieChart,
  faShirtRunning: faShirtRunning,
  faBusSchool: faBusSchool,
  faPhoneArrowRight: faPhoneArrowRight,
  faListMusic: faListMusic,
  faLeafHeart: faLeafHeart,
  faChartBullet: faChartBullet,
  faFaceSmileHearts: faFaceSmileHearts,
  faCalendarArrowDown: faCalendarArrowDown,
  faCalendarDownload: faCalendarDownload,
  faMobileSignalOut: faMobileSignalOut,
  faFrog: faFrog,
  faWrenchSimple: faWrenchSimple,
  faWineBottle: faWineBottle,
  faPancakes: faPancakes,
  faInbox: faInbox,
  faBoltSlash: faBoltSlash,
  faStarShooting: faStarShooting,
  faHorizontalRule: faHorizontalRule,
  faCloudBoltMoon: faCloudBoltMoon,
  faThunderstormMoon: faThunderstormMoon,
  faNfcSlash: faNfcSlash,
  faSquareH: faSquareH,
  faHSquare: faHSquare,
  faHouseMedical: faHouseMedical,
  faCircleChevronRight: faCircleChevronRight,
  faChevronCircleRight: faChevronCircleRight,
  faFileCsv: faFileCsv,
  faHatCowboy: faHatCowboy,
  faFaceGrinTongueWink: faFaceGrinTongueWink,
  faGrinTongueWink: faGrinTongueWink,
  faShelves: faShelves,
  faInventory: faInventory,
  faHexagonExclamation: faHexagonExclamation,
  faArrowsRepeat1: faArrowsRepeat1,
  faRepeat1Alt: faRepeat1Alt,
  faL: faL,
  faPhoneMissed: faPhoneMissed,
  faArrowDownShortWide: faArrowDownShortWide,
  faSortAmountDesc: faSortAmountDesc,
  faSortAmountDownAlt: faSortAmountDownAlt,
  faHourglassHalf: faHourglassHalf,
  faHourglass2: faHourglass2,
  faScalpelLineDashed: faScalpelLineDashed,
  faScalpelPath: faScalpelPath,
  faCloudSnow: faCloudSnow,
  faSquareDownRight: faSquareDownRight,
  faSpoon: faSpoon,
  faUtensilSpoon: faUtensilSpoon,
  faClockEleven: faClockEleven,
  faCreditCard: faCreditCard,
  faCreditCardAlt: faCreditCardAlt,
  faFileInvoiceDollar: faFileInvoiceDollar,
  faViolin: faViolin,
  faSpaghettiMonsterFlying: faSpaghettiMonsterFlying,
  faPastafarianism: faPastafarianism,
  faMartiniGlassCitrus: faMartiniGlassCitrus,
  faCocktail: faCocktail,
  faChartMixedUpCircleDollar: faChartMixedUpCircleDollar,
  faSquareRupee: faSquareRupee,
  faClockOneThirty: faClockOneThirty,
  faBullhorn: faBullhorn,
  faBoxTissue: faBoxTissue,
  faDoNotEnter: faDoNotEnter,
  faAngle: faAngle,
  faHouseUnlock: faHouseUnlock,
  faMattressPillow: faMattressPillow,
  faMessageDot: faMessageDot,
  faCricketBatBall: faCricketBatBall,
  faCricket: faCricket,
  faChevronLeft: faChevronLeft,
  faCloudMoonRain: faCloudMoonRain,
  faArrowDown19: faArrowDown19,
  faSortNumericAsc: faSortNumericAsc,
  faSortNumericDown: faSortNumericDown,
  faBinBottlesRecycle: faBinBottlesRecycle,
  faBringFront: faBringFront,
  faSeatAirline: faSeatAirline,
  faSquareTenge: faSquareTenge,
  faHandSpock: faHandSpock,
  faWandMagicSparkles: faWandMagicSparkles,
  faMagicWandSparkles: faMagicWandSparkles,
  faPanelEws: faPanelEws,
  faCommentMedical: faCommentMedical,
  faBellSlash: faBellSlash,
  faHandshakeSlash: faHandshakeSlash,
  faHandshakeAltSlash: faHandshakeAltSlash,
  faHandshakeSimpleSlash: faHandshakeSimpleSlash,
  faPizza: faPizza,
  faBottleWater: faBottleWater,
  faUserPoliceTieHairLong: faUserPoliceTieHairLong,
  faFolders: faFolders,
  faSunDust: faSunDust,
  faDiceD20: faDiceD20,
  faFolderGear: faFolderGear,
  faFolderCog: faFolderCog,
  faAlmostEqualTo: faAlmostEqualTo,
  faArrowDownZA: faArrowDownZA,
  faSortAlphaDesc: faSortAlphaDesc,
  faSortAlphaDownAlt: faSortAlphaDownAlt,
  faBrush: faBrush,
  faPersonWalkingDashedLineArrowRight: faPersonWalkingDashedLineArrowRight,
  faArrowUpShortWide: faArrowUpShortWide,
  faSortAmountUpAlt: faSortAmountUpAlt,
  faGripVertical: faGripVertical,
  faGridVertical: faGridVertical,
  faCarTunnel: faCarTunnel,
  faChartColumn: faChartColumn,
  faSendBack: faSendBack,
  faCommentArrowUpRight: faCommentArrowUpRight,
  faTruckArrowRight: faTruckArrowRight,
  faTv: faTv,
  faTelevision: faTelevision,
  faTvAlt: faTvAlt,
  faSection: faSection,
  faParagraphLeft: faParagraphLeft,
  faParagraphRtl: faParagraphRtl,
  faTreeDecorated: faTreeDecorated,
  faBinBottles: faBinBottles,
  faPeace: faPeace,
  faStar: faStar,
  faStoreLock: faStoreLock,
  faFlag: faFlag,
  faSquareE: faSquareE,
  faTriangleExclamation: faTriangleExclamation,
  faExclamationTriangle: faExclamationTriangle,
  faWarning: faWarning,
  faFaceSmirking: faFaceSmirking,
  faCodePullRequestDraft: faCodePullRequestDraft,
  faSchoolCircleExclamation: faSchoolCircleExclamation,
  faGraduationCap: faGraduationCap,
  faMortarBoard: faMortarBoard,
  faCloudHail: faCloudHail,
  faArrowRightFromLine: faArrowRightFromLine,
  faArrowFromLeft: faArrowFromLeft,
  faStore: faStore,
  faUserAstronaut: faUserAstronaut,
  faCabin: faCabin,
  faBuildingFlag: faBuildingFlag,
  faWifiFair: faWifiFair,
  faWifi2: faWifi2,
  faMugSaucer: faMugSaucer,
  faCoffee: faCoffee,
  faLemon: faLemon,
  faCirclePhoneHangup: faCirclePhoneHangup,
  faPhoneCircleDown: faPhoneCircleDown,
  faCommentCheck: faCommentCheck,
  faFilterList: faFilterList,
  faCaravan: faCaravan,
  faLeafOak: faLeafOak,
  faQ: faQ,
  faLock: faLock,
  faPaintRoller: faPaintRoller,
  faVolumeHigh: faVolumeHigh,
  faVolumeUp: faVolumeUp,
  faFaceTissue: faFaceTissue,
  faFolderPlus: faFolderPlus,
  faRefrigerator: faRefrigerator,
  faNfc: faNfc,
  faDirectionUpDown: faDirectionUpDown,
  faUserGroupSimple: faUserGroupSimple,
  faMercury: faMercury,
  faMessageQuote: faMessageQuote,
  faCommentAltQuote: faCommentAltQuote,
  faMailboxFlagUp: faMailboxFlagUp,
  faTruckClock: faTruckClock,
  faShippingTimed: faShippingTimed,
  faAnchor: faAnchor,
  faDisplayArrowDown: faDisplayArrowDown,
  faCircleK: faCircleK,
  faSoftServe: faSoftServe,
  faCreemee: faCreemee,
  faHeat: faHeat,
  faSquareParking: faSquareParking,
  faParking: faParking,
  faHanukiah: faHanukiah,
  faRotateLeft: faRotateLeft,
  faRotateBack: faRotateBack,
  faRotateBackward: faRotateBackward,
  faUndoAlt: faUndoAlt,
  faCakeSlice: faCakeSlice,
  faShortcake: faShortcake,
  faHeading: faHeading,
  faHeader: faHeader,
  faLambda: faLambda,
  faTrainTunnel: faTrainTunnel,
  faCartMinus: faCartMinus,
  faFaceThinking: faFaceThinking,
  faFaceEyesXmarks: faFaceEyesXmarks,
  faMagnifyingGlassMusic: faMagnifyingGlassMusic,
  faCalendarLinesPen: faCalendarLinesPen,
  faCrosshairs: faCrosshairs,
  faCircleNodes: faCircleNodes,
  faWindowRestore: faWindowRestore,
  faR: faR,
  faFilterCircleXmark: faFilterCircleXmark,
  faMicrochipAi: faMicrochipAi,
  faCircleQuarter: faCircleQuarter,
  faGopuram: faGopuram,
  faAnt: faAnt,
  faHydra: faHydra,
  faHeartCircleMinus: faHeartCircleMinus,
  faStarOfLife: faStarOfLife,
  faBoombox: faBoombox,
  faBusinessTime: faBusinessTime,
  faBriefcaseClock: faBriefcaseClock,
  faFireExtinguisher: faFireExtinguisher,
  faArrowDownLong: faArrowDownLong,
  faLongArrowDown: faLongArrowDown,
  faClockThreeThirty: faClockThreeThirty,
  faObjectSubtract: faObjectSubtract,
  faTicketsSimple: faTicketsSimple,
  faUserMinus: faUserMinus,
  faCircleBitcoin: faCircleBitcoin,
  faMoneyCheck: faMoneyCheck,
  faVideoPlus: faVideoPlus,
  faHouseLaptop: faHouseLaptop,
  faLaptopHouse: faLaptopHouse,
  faDownload: faDownload,
  faHandHoldingStar: faHandHoldingStar,
  faInputNumeric: faInputNumeric,
  faCouch: faCouch,
  faGaugeSimpleMax: faGaugeSimpleMax,
  faTachometerFastest: faTachometerFastest,
  faBoxMagnifyingGlass: faBoxMagnifyingGlass,
  faRoadLock: faRoadLock,
  faPersonSwimmingPool: faPersonSwimmingPool,
  faCanFood: faCanFood,
  faCircleX: faCircleX,
  faSquareHalfHorizontal: faSquareHalfHorizontal,
  faUserRobotXmarks: faUserRobotXmarks,
  faScissors: faScissors,
  faCut: faCut,
  faBug: faBug,
  faArrowRightFromBracket: faArrowRightFromBracket,
  faSignOut: faSignOut,
  faFileZip: faFileZip,
  faCupcake: faCupcake,
  faHandHoldingHand: faHandHoldingHand,
  faMicrophoneSignalMeter: faMicrophoneSignalMeter,
  faStroopwafel: faStroopwafel,
  faChild: faChild,
  faIceCream: faIceCream,
  faComputerMouse: faComputerMouse,
  faMouse: faMouse,
  faCircleA: faCircleA,
  faFaucet: faFaucet,
  faFaceSmileHorns: faFaceSmileHorns,
  faAward: faAward,
  faPersonDrowning: faPersonDrowning,
  faArrowUpToArc: faArrowUpToArc,
  faSchoolUnlock: faSchoolUnlock,
  faNoteMedical: faNoteMedical,
  faTransporter3: faTransporter3,
  faPostageStamp: faPostageStamp,
  faSnowflakeDroplets: faSnowflakeDroplets,
  faCameraRotate: faCameraRotate,
  faLoader: faLoader,
  faFileMidi: faFileMidi,
  faUserHoodie: faUserHoodie,
  faFaceGrinHearts: faFaceGrinHearts,
  faGrinHearts: faGrinHearts,
  faFileFragment: faFileFragment,
  faLoveseat: faLoveseat,
  faCouchSmall: faCouchSmall,
  faPersonMilitaryRifle: faPersonMilitaryRifle,
  faToggleOn: faToggleOn,
  faArrowUpToLine: faArrowUpToLine,
  faArrowToTop: faArrowToTop,
  faPompebled: faPompebled,
  faLungsVirus: faLungsVirus,
  faTableTennisPaddleBall: faTableTennisPaddleBall,
  faPingPongPaddleBall: faPingPongPaddleBall,
  faTableTennis: faTableTennis,
  faBoxesPacking: faBoxesPacking,
  faSidebarFlip: faSidebarFlip,
  faBookFont: faBookFont,
  faHose: faHose,
  faTreeLarge: faTreeLarge,
  faHearts: faHearts,
  faFaceFrownSlight: faFaceFrownSlight,
  faPersonChalkboard: faPersonChalkboard,
  faDiceTwo: faDiceTwo,
  faTransformerBolt: faTransformerBolt,
  faArrowRightArrowLeft: faArrowRightArrowLeft,
  faExchange: faExchange,
  faFootball: faFootball,
  faFootballBall: faFootballBall,
  faTruckMonster: faTruckMonster,
  faTaco: faTaco,
  faMaskSnorkel: faMaskSnorkel,
  faArrowUpFromLine: faArrowUpFromLine,
  faArrowFromBottom: faArrowFromBottom,
  faAsterisk: faAsterisk,
  faClothesHanger: faClothesHanger,
  faBarProgressFull: faBarProgressFull,
  faBatteryFull: faBatteryFull,
  faBattery: faBattery,
  faBattery5: faBattery5,
  faChildDress: faChildDress,
  faFaceKissBeam: faFaceKissBeam,
  faKissBeam: faKissBeam,
  faTaxiBus: faTaxiBus,
  faSquareArrowUpLeft: faSquareArrowUpLeft,
  faTrashCanArrowUp: faTrashCanArrowUp,
  faTrashRestoreAlt: faTrashRestoreAlt,
  faFont: faFont,
  faFaceKissClosedEyes: faFaceKissClosedEyes,
  faBoreHole: faBoreHole,
  faFilmStack: faFilmStack,
  faVirusCovid: faVirusCovid,
  faLeft: faLeft,
  faArrowAltLeft: faArrowAltLeft,
  faGaugeCircleBolt: faGaugeCircleBolt,
  faRectanglesMixed: faRectanglesMixed,
  faBracketsRound: faBracketsRound,
  faParentheses: faParentheses,
  faOmega: faOmega,
  faBlindsRaised: faBlindsRaised,
  faFilePdf: faFilePdf,
  faLanguage: faLanguage,
  faShieldHalved: faShieldHalved,
  faShieldAlt: faShieldAlt,
  faCircleTenge: faCircleTenge,
  faFork: faFork,
  faUtensilFork: faUtensilFork,
  faUserHair: faUserHair,
  faCircleF: faCircleF,
  faCaretUp: faCaretUp,
  faPersonSeat: faPersonSeat,
  faPegasus: faPegasus,
  faFilePen: faFilePen,
  faFileEdit: faFileEdit,
  faPersonBiking: faPersonBiking,
  faBiking: faBiking,
  faBookOpenReader: faBookOpenReader,
  faBookReader: faBookReader,
  faCircleStar: faCircleStar,
  faStarCircle: faStarCircle,
  faPhoneXmark: faPhoneXmark,
  faGlassWaterDroplet: faGlassWaterDroplet,
  faScrubber: faScrubber,
  faGunSlash: faGunSlash,
  faArrowUpLongToLine: faArrowUpLongToLine,
  faCameraWebSlash: faCameraWebSlash,
  faWebcamSlash: faWebcamSlash,
  faObjectsColumn: faObjectsColumn,
  faTowerBroadcast: faTowerBroadcast,
  faBroadcastTower: faBroadcastTower,
  faTurkey: faTurkey,
  faSword: faSword,
  faHeadSideGoggles: faHeadSideGoggles,
  faHeadVr: faHeadVr,
  faMinimize: faMinimize,
  faCompressArrowsAlt: faCompressArrowsAlt,
  faArrowRightToCity: faArrowRightToCity,
  faLaptopMedical: faLaptopMedical,
  faBreadSlice: faBreadSlice,
  faSpiderWeb: faSpiderWeb,
  faUserNurseHair: faUserNurseHair,
  faGlobe: faGlobe,
  faDiceD12: faDiceD12,
  faLocationDotSlash: faLocationDotSlash,
  faMapMarkerAltSlash: faMapMarkerAltSlash,
  faFolderMinus: faFolderMinus,
  faMaskFace: faMaskFace,
  faBong: faBong,
  faCupTogo: faCupTogo,
  faCoffeeTogo: faCoffeeTogo,
  faRoadBridge: faRoadBridge,
  faArrowUp91: faArrowUp91,
  faSortNumericUpAlt: faSortNumericUpAlt,
  faMountainCity: faMountainCity,
  faArrowDown91: faArrowDown91,
  faSortNumericDesc: faSortNumericDesc,
  faSortNumericDownAlt: faSortNumericDownAlt,
  faMoneyBillsSimple: faMoneyBillsSimple,
  faMoneyBillsAlt: faMoneyBillsAlt,
  faFaceGrinWide: faFaceGrinWide,
  faGrinAlt: faGrinAlt,
  faCirclePeruvianSoles: faCirclePeruvianSoles,
  faArrowsToLine: faArrowsToLine,
  faSquareRenminbi: faSquareRenminbi,
  faTurntable: faTurntable,
  faCrab: faCrab,
  faAngel: faAngel,
  faLocationPen: faLocationPen,
  faMapMarkerEdit: faMapMarkerEdit,
  faTicketsPerforated: faTicketsPerforated,
  faSquareRupiah: faSquareRupiah,
  faTrashXmark: faTrashXmark,
  faRv: faRv,
  faFaceZany: faFaceZany,
  faPoop: faPoop,
  faBarsFilter: faBarsFilter,
  faHouseChimneyHeart: faHouseChimneyHeart,
  faBowlScoops: faBowlScoops,
  faDharmachakra: faDharmachakra,
  faClockTwelveThirty: faClockTwelveThirty,
  faBoxingGlove: faBoxingGlove,
  faGloveBoxing: faGloveBoxing,
  faJeansStraight: faJeansStraight,
  faSpeaker: faSpeaker,
  faDiceD10: faDiceD10,
  faRam: faRam,
  faBatteryQuarter: faBatteryQuarter,
  faBattery2: faBattery2,
  faBasketShoppingSimple: faBasketShoppingSimple,
  faShoppingBasketAlt: faShoppingBasketAlt,
  faMonitorWaveform: faMonitorWaveform,
  faMonitorHeartRate: faMonitorHeartRate,
  faCommentWaveform: faCommentWaveform,
  faAnkh: faAnkh,
  faDiamond: faDiamond,
  faSubscript: faSubscript,
  faSquareRight: faSquareRight,
  faArrowAltSquareRight: faArrowAltSquareRight,
  faCircleNaira: faCircleNaira,
  faComputerClassic: faComputerClassic,
  faRupeeSign: faRupeeSign,
  faRupee: faRupee,
  faPersonRifle: faPersonRifle,
  faOctagonExclamation: faOctagonExclamation,
  faPipeCollar: faPipeCollar,
  faBrightnessLow: faBrightnessLow,
  faPlaneFlying: faPlaneFlying,
  faFaceSmileRelaxed: faFaceSmileRelaxed,
  faImageCircleCheck: faImageCircleCheck,
  faMessagesQuestion: faMessagesQuestion,
  faD: faD,
  faCircleFranc: faCircleFranc,
  faUpToDottedLine: faUpToDottedLine,
  faKiwiFruit: faKiwiFruit,
  faGridRound: faGridRound,
  faStarship: faStarship,
  faClockTwoThirty: faClockTwoThirty,
  faSquareNfi: faSquareNfi,
  faDroneFront: faDroneFront,
  faDroneAlt: faDroneAlt,
  faTeeth: faTeeth,
  faMagnifyingGlassDollar: faMagnifyingGlassDollar,
  faSearchDollar: faSearchDollar,
  faDumpsterFire: faDumpsterFire,
  faCircleHryvnia: faCircleHryvnia,
  faEggFried: faEggFried,
  faLineHeight: faLineHeight,
  faArrowRightFromDottedLine: faArrowRightFromDottedLine,
  faUpload: faUpload,
  faGingerbreadMan: faGingerbreadMan,
  faFilterSlash: faFilterSlash,
  faUserSlash: faUserSlash,
  faUserAltSlash: faUserAltSlash,
  faUserLargeSlash: faUserLargeSlash,
  faArrowLeft: faArrowLeft,
  faVialVirus: faVialVirus,
  faCheckDouble: faCheckDouble,
  faSwords: faSwords,
  faTransporter5: faTransporter5,
  faSquareSliders: faSquareSliders,
  faSlidersHSquare: faSlidersHSquare,
  faCircleSortUp: faCircleSortUp,
  faSortCircleUp: faSortCircleUp,
  faPaw: faPaw,
  faHelmetSafety: faHelmetSafety,
  faHardHat: faHardHat,
  faHatHard: faHatHard,
  faUserCircleMinus: faUserCircleMinus,
  faE: faE,
  faFaceLaughSquint: faFaceLaughSquint,
  faLaughSquint: faLaughSquint,
  faPear: faPear,
  faFileTex: faFileTex,
  faDownLeftAndUpRightToCenter: faDownLeftAndUpRightToCenter,
  faCompressAlt: faCompressAlt,
  faPuzzlePieceSimple: faPuzzlePieceSimple,
  faPuzzlePieceAlt: faPuzzlePieceAlt,
  faGifts: faGifts,
  faArrowLeftToDottedLine: faArrowLeftToDottedLine,
  faHospitals: faHospitals,
  faBed: faBed,
  faWindowFlip: faWindowFlip,
  faWindowAlt: faWindowAlt,
  faMoneyBillTransfer: faMoneyBillTransfer,
  faPersonRunning: faPersonRunning,
  faRunning: faRunning,
  faCircleChevronDown: faCircleChevronDown,
  faChevronCircleDown: faChevronCircleDown,
  faManhole: faManhole,
  faUserNurse: faUserNurse,
  faHeartSlash: faHeartSlash,
  faArrowsRepeat: faArrowsRepeat,
  faRepeatAlt: faRepeatAlt,
  faWaffle: faWaffle,
  faArrowLeftFromArc: faArrowLeftFromArc,
  faSquareDivide: faSquareDivide,
  faCircleE: faCircleE,
  faFaceKissWinkHeart: faFaceKissWinkHeart,
  faKissWinkHeart: faKissWinkHeart,
  faFill: faFill,
  faHorseshoe: faHorseshoe,
  faUserDoctorHair: faUserDoctorHair,
  faSensorFire: faSensorFire,
  faMoneyBill1Wave: faMoneyBill1Wave,
  faMoneyBillWaveAlt: faMoneyBillWaveAlt,
  faLandmark: faLandmark,
  faCommentMusic: faCommentMusic,
  faHammerCrash: faHammerCrash,
  faSwordLaser: faSwordLaser,
  faMusic: faMusic,
  faFiles: faFiles,
  faNotesSticky: faNotesSticky,
  faMessageArrowUpRight: faMessageArrowUpRight,
  faBookMedical: faBookMedical,
  faMusicNoteSlash: faMusicNoteSlash,
  faMusicAltSlash: faMusicAltSlash,
  faShuffle: faShuffle,
  faRandom: faRandom,
  faUnderline: faUnderline,
  faBuildingUser: faBuildingUser,
  faSushiRoll: faSushiRoll,
  faMakiRoll: faMakiRoll,
  faMakizushi: faMakizushi,
  faDialOff: faDialOff,
  faRobot: faRobot,
  faBarProgressEmpty: faBarProgressEmpty,
  faTransmission: faTransmission,
  faPlus: faPlus,
  faAdd: faAdd,
  faObjectsAlignTop: faObjectsAlignTop,
  faBellRing: faBellRing,
  faCopy: faCopy,
  faChessKing: faChessKing,
  faHouseFloodWater: faHouseFloodWater,
  faMoneyFromBracket: faMoneyFromBracket,
  faBitcoinSign: faBitcoinSign,
  faBox: faBox,
  faFaceAnguished: faFaceAnguished,
  faLocationArrowUp: faLocationArrowUp,
  faHeadSideHeart: faHeadSideHeart,
  faSquarePlus: faSquarePlus,
  faPlusSquare: faPlusSquare,
  faMemo: faMemo,
  faArrowsLeftRight: faArrowsLeftRight,
  faArrowsH: faArrowsH,
  faFan: faFan,
  faCrow: faCrow,
  faUTurnUpRight: faUTurnUpRight,
  faSquare8: faSquare8,
  faFileCircleCheck: faFileCircleCheck,
  faBracketCurlyRight: faBracketCurlyRight,
  faChartNetwork: faChartNetwork,
  faBadgeDollar: faBadgeDollar,
  faLinkSlash: faLinkSlash,
  faChainBroken: faChainBroken,
  faChainSlash: faChainSlash,
  faUnlink: faUnlink,
  faArrowRotateRight: faArrowRotateRight,
  faArrowRightRotate: faArrowRightRotate,
  faArrowRotateForward: faArrowRotateForward,
  faRedo: faRedo,
  faPersonToPortal: faPersonToPortal,
  faPortalEnter: faPortalEnter,
  faSignalBarsSlash: faSignalBarsSlash,
  faSignalAltSlash: faSignalAltSlash,
  faPenClip: faPenClip,
  faPenAlt: faPenAlt,
  faRectangleBeta: faRectangleBeta,
  faDoorClosed: faDoorClosed,
  faLockA: faLockA,
  faArrowDownWideShort: faArrowDownWideShort,
  faSortAmountAsc: faSortAmountAsc,
  faSortAmountDown: faSortAmountDown,
  faFaceMelting: faFaceMelting,
  faFaceDisguise: faFaceDisguise,
  faSportsball: faSportsball,
  faSquareMicrophone: faSquareMicrophone,
  faCaretDown: faCaretDown,
  faRadar: faRadar,
  faImageLandscape: faImageLandscape,
  faLandscape: faLandscape,
  faRotateReverse: faRotateReverse,
  faTicketPerforated: faTicketPerforated,
  faSquareC: faSquareC,
  faK: faK,
  faArrowUTurnDownLeft: faArrowUTurnDownLeft,
  faCheckToSlot: faCheckToSlot,
  faVoteYea: faVoteYea,
  faSquareJ: faSquareJ,
  faFishFins: faFishFins,
  faBellSchool: faBellSchool,
  faLampFloor: faLampFloor,
  faCompress: faCompress,
  faTrashPlus: faTrashPlus,
  faArrowUpAZ: faArrowUpAZ,
  faSortAlphaUp: faSortAlphaUp,
  faComma: faComma,
  faSemicolon: faSemicolon,
  faClipboardExclamation: faClipboardExclamation,
  faRugbyBall: faRugbyBall,
  faGridRound2Plus: faGridRound2Plus,
  faUserGraduate: faUserGraduate,
  faFileCode: faFileCode,
  faCupStraw: faCupStraw,
  faSoap: faSoap,
  faRecycle: faRecycle,
  faSlidersUp: faSlidersUp,
  faSlidersV: faSlidersV,
  faCircleUserClock: faCircleUserClock,
  faCarBus: faCarBus,
  faSignaporeDollarSign: faSignaporeDollarSign,
  faPumpkin: faPumpkin,
  faFaceGrinWink: faFaceGrinWink,
  faGrinWink: faGrinWink,
  faFolderArrowDown: faFolderArrowDown,
  faFolderDownload: faFolderDownload,
  faSignPosts: faSignPosts,
  faSkeletonRibs: faSkeletonRibs,
  faQrcodeRead: faQrcodeRead,
  faCircleDollar: faCircleDollar,
  faDollarCircle: faDollarCircle,
  faUsdCircle: faUsdCircle,
  faSiren: faSiren,
  faWaterLadder: faWaterLadder,
  faLadderWater: faLadderWater,
  faSwimmingPool: faSwimmingPool,
  faTtyAnswer: faTtyAnswer,
  faTeletypeAnswer: faTeletypeAnswer,
  faSquareThisWayUp: faSquareThisWayUp,
  faBoxUp: faBoxUp,
  faTowerCell: faTowerCell,
  faGalleryThumbnails: faGalleryThumbnails,
  faColonSign: faColonSign,
  faLaptopFile: faLaptopFile,
  faCircleHalfStrokeHorizontal: faCircleHalfStrokeHorizontal,
  faBahai: faBahai,
  faHaykal: faHaykal,
  faMoneyBill1: faMoneyBill1,
  faMoneyBillAlt: faMoneyBillAlt,
  faCloudBolt: faCloudBolt,
  faThunderstorm: faThunderstorm,
  faCircleBookmark: faCircleBookmark,
  faBookmarkCircle: faBookmarkCircle,
  faEthernet: faEthernet,
  faCirclesOverlap3: faCirclesOverlap3,
  faPronoun: faPronoun,
  faHryvniaSign: faHryvniaSign,
  faHryvnia: faHryvnia,
  faAtomSimple: faAtomSimple,
  faAtomAlt: faAtomAlt,
  faFilesMedical: faFilesMedical,
  faSalad: faSalad,
  faBowlSalad: faBowlSalad,
  faPawSimple: faPawSimple,
  faPawAlt: faPawAlt,
  faEyeSlash: faEyeSlash,
  faPlateUtensils: faPlateUtensils,
  faCircleO: faCircleO,
  faJugBottle: faJugBottle,
  faClockTwo: faClockTwo,
  faCartFlatbedSuitcase: faCartFlatbedSuitcase,
  faLuggageCart: faLuggageCart,
  faFolderImage: faFolderImage,
  faRadiation: faRadiation,
  faFileWord: faFileWord,
  faBedPulse: faBedPulse,
  faProcedures: faProcedures,
  faBlock: faBlock,
  faShovel: faShovel,
  faTents: faTents,
  faDropletPercent: faDropletPercent,
  faHumidity: faHumidity,
  faMugHot: faMugHot,
  faBolt: faBolt,
  faZap: faZap,
  faUserVneckHairLong: faUserVneckHairLong,
  faReflectVertical: faReflectVertical,
  faMoneyBillSimpleWave: faMoneyBillSimpleWave,
  faLightbulbExclamation: faLightbulbExclamation,
  faAperture: faAperture,
  faJar: faJar,
  faArrowDownFromArc: faArrowDownFromArc,
  faTruckPlane: faTruckPlane,
  faSignalFair: faSignalFair,
  faSignal2: faSignal2,
  faHandHoldingHeart: faHandHoldingHeart,
  faArrowRotateLeft: faArrowRotateLeft,
  faArrowLeftRotate: faArrowLeftRotate,
  faArrowRotateBack: faArrowRotateBack,
  faArrowRotateBackward: faArrowRotateBackward,
  faUndo: faUndo,
  faAnglesUpDown: faAnglesUpDown,
  faTruckPlow: faTruckPlow,
  faUsersMedical: faUsersMedical,
  faWatchApple: faWatchApple,
  faCaretLargeLeft: faCaretLargeLeft,
  faGridRound4: faGridRound4,
  faBookOpenCover: faBookOpenCover,
  faBookOpenAlt: faBookOpenAlt,
  faCommentDot: faCommentDot,
  faFlashlight: faFlashlight,
  faFaceAngry: faFaceAngry,
  faAngry: faAngry,
  faCheeseSwiss: faCheeseSwiss,
  faChartPieSimple: faChartPieSimple,
  faChartPieAlt: faChartPieAlt,
  faCircleCent: faCircleCent,
  faBurst: faBurst,
  faZ: faZ,
  faSquareSwedishKrona: faSquareSwedishKrona,
  faHeadSideHeadphones: faHeadSideHeadphones,
  faBandage: faBandage,
  faBandAid: faBandAid,
  faPlaneCircleExclamation: faPlaneCircleExclamation,
  faBusSide: faBusSide,
  faBugs: faBugs,
  faSnowmobileBlank: faSnowmobileBlank,
  faBookUser: faBookUser,
  faChevronsRight: faChevronsRight,
  faChevronDoubleRight: faChevronDoubleRight,
  faBeerMugEmpty: faBeerMugEmpty,
  faBeer: faBeer,
  faPersonCircleCheck: faPersonCircleCheck,
  faCartCirclePlus: faCartCirclePlus,
  faStapler: faStapler,
  faSquareHalfStrokeHorizontal: faSquareHalfStrokeHorizontal,
  faCandyCorn: faCandyCorn,
  faClipboardPrescription: faClipboardPrescription,
  faCompressWide: faCompressWide,
  faHouseMedicalCircleCheck: faHouseMedicalCircleCheck,
  faCommentPen: faCommentPen,
  faCommentEdit: faCommentEdit,
  faNairaSign: faNairaSign,
  faFilePng: faFilePng,
  faHundredPoints: faHundredPoints,
  fa100: fa100,
  faTableTree: faTableTree,
  faWifi: faWifi,
  faWifi3: faWifi3,
  faWifiStrong: faWifiStrong,
  faPage: faPage,
  faSquareChevronLeft: faSquareChevronLeft,
  faChevronSquareLeft: faChevronSquareLeft,
  faChartMixed: faChartMixed,
  faAnalytics: faAnalytics,
  faCalendarExclamation: faCalendarExclamation,
  faMoneyCheckDollar: faMoneyCheckDollar,
  faMoneyCheckAlt: faMoneyCheckAlt,
  faCamcorder: faCamcorder,
  faVideoHandheld: faVideoHandheld,
  faHouseChimneyBlank: faHouseChimneyBlank,
  faEyeLowVision: faEyeLowVision,
  faLowVision: faLowVision,
  faCircleArrowUp: faCircleArrowUp,
  faArrowCircleUp: faArrowCircleUp,
  faCameraRetro: faCameraRetro,
  faRightToDottedLine: faRightToDottedLine,
  faCapsules: faCapsules,
  faBlockBrickFire: faBlockBrickFire,
  faFirewall: faFirewall,
  faFilters: faFilters,
  faBowlingPins: faBowlingPins,
  faCalendarUsers: faCalendarUsers,
  faTableCellsColumns: faTableCellsColumns,
  faPeopleSimple: faPeopleSimple,
  faArrowLeftArrowRight: faArrowLeftArrowRight,
  faPoo: faPoo,
  faSquare5: faSquare5,
  faVolume: faVolume,
  faVolumeMedium: faVolumeMedium,
  faFlowerDaffodil: faFlowerDaffodil,
  faElevator: faElevator,
  faWavePulse: faWavePulse,
  faHeartRate: faHeartRate,
  faBookHeart: faBookHeart,
  faSquareZ: faSquareZ,
  faTag: faTag,
  faWagonCovered: faWagonCovered,
  faFileCircleMinus: faFileCircleMinus,
  faMessageCode: faMessageCode,
  faGearComplex: faGearComplex,
  faCircleC: faCircleC,
  faDownLong: faDownLong,
  faLongArrowAltDown: faLongArrowAltDown,
  faCompactDisc: faCompactDisc,
  faSuitcaseRolling: faSuitcaseRolling,
  faDanishKroneSign: faDanishKroneSign,
  faWebhook: faWebhook,
  faClockFiveThirty: faClockFiveThirty,
  faPersonWaving: faPersonWaving,
  faArrowDownArrowUp: faArrowDownArrowUp,
  faSortAlt: faSortAlt,
  faBookQuran: faBookQuran,
  faQuran: faQuran,
  faTelescope: faTelescope,
  faTemperatureSlash: faTemperatureSlash,
  faPhoneSlash: faPhoneSlash,
  faRoadCircleCheck: faRoadCircleCheck,
  faShopLock: faShopLock,
  faImagePortrait: faImagePortrait,
  faPortrait: faPortrait,
  faBooks: faBooks,
  faGrid2: faGrid2,
  faCartArrowUp: faCartArrowUp,
  faBridgeLock: faBridgeLock,
  faPaperPlaneTop: faPaperPlaneTop,
  faPaperPlaneAlt: faPaperPlaneAlt,
  faSend: faSend,
  faClockNineThirty: faClockNineThirty,
  faBurgerLettuce: faBurgerLettuce,
  faHammer: faHammer,
  faSquareUpLeft: faSquareUpLeft,
  faTransporter7: faTransporter7,
  faArrowUp19: faArrowUp19,
  faSortNumericUp: faSortNumericUp,
  faTableCellsHeaderUnlock: faTableCellsHeaderUnlock,
  faChessKnight: faChessKnight,
  faHouseFloodWaterCircleArrowRight: faHouseFloodWaterCircleArrowRight,
  faNfcMagnifyingGlass: faNfcMagnifyingGlass,
  faMelonSlice: faMelonSlice,
  faStairCar: faStairCar,
  faPrescriptionBottlePill: faPrescriptionBottlePill,
  faClockEightThirty: faClockEightThirty,
  faCloudMinus: faCloudMinus,
  faLaptopMobile: faLaptopMobile,
  faPhoneLaptop: faPhoneLaptop,
  faBagShoppingPlus: faBagShoppingPlus,
  faClapperboardPlay: faClapperboardPlay,
  faCircleRenminbi: faCircleRenminbi,
  faLeftFromLine: faLeftFromLine,
  faArrowAltFromRight: faArrowAltFromRight,
  faEngineWarning: faEngineWarning,
  faEngineExclamation: faEngineExclamation,
  faPickleball: faPickleball,
  faTrombone: faTrombone,
  faArrowUpRightFromSquare: faArrowUpRightFromSquare,
  faExternalLink: faExternalLink,
  faPersonCarryEmpty: faPersonCarryEmpty,
  faBorderRight: faBorderRight,
  faArrowDownUpAcrossLine: faArrowDownUpAcrossLine,
  faFaceGrinBeam: faFaceGrinBeam,
  faGrinBeam: faGrinBeam,
  faRectangleAd: faRectangleAd,
  faAd: faAd,
  faCarSideBolt: faCarSideBolt,
  faCircleUpRight: faCircleUpRight,
  faPersonSkiJumping: faPersonSkiJumping,
  faSkiJump: faSkiJump,
  faUserVneck: faUserVneck,
  faClarinet: faClarinet,
  faBookTanakh: faBookTanakh,
  faTanakh: faTanakh,
  faFileXmark: faFileXmark,
  faFileTimes: faFileTimes,
  faSquareUser: faSquareUser,
  faClockSix: faClockSix,
  faDinosaur: faDinosaur,
  faFrenchFries: faFrenchFries,
  faHotTubPerson: faHotTubPerson,
  faHotTub: faHotTub,
  faFileHalfDashed: faFileHalfDashed,
  faReflectHorizontal: faReflectHorizontal,
  faDirectionLeftRight: faDirectionLeftRight,
  faCartCircleExclamation: faCartCircleExclamation,
  faSquareChf: faSquareChf,
  faOutdent: faOutdent,
  faDedent: faDedent,
  faBrakeWarning: faBrakeWarning,
  faRectangleTall: faRectangleTall,
  faSquareStar: faSquareStar,
  faHandPeace: faHandPeace,
  faHeadSideVirus: faHeadSideVirus,
  faUnicycle: faUnicycle,
  faSquareDown: faSquareDown,
  faArrowAltSquareDown: faArrowAltSquareDown,
  faCrutches: faCrutches,
  faGramophone: faGramophone,
  faH3: faH3,
  faCompass: faCompass,
  faRollerCoaster: faRollerCoaster,
  faPenNib: faPenNib,
  faTentArrowsDown: faTentArrowsDown,
  faDuck: faDuck,
  faDrawCircle: faDrawCircle,
  faVectorCircle: faVectorCircle,
  faForwardFast: faForwardFast,
  faFastForward: faFastForward,
  faTrees: faTrees,
  faCrop: faCrop,
  faWhiskeyGlass: faWhiskeyGlass,
  faGlassWhiskey: faGlassWhiskey,
  faDownFromBracket: faDownFromBracket,
  faGearComplexCode: faGearComplexCode,
  faSquareN: faSquareN,
  faSquare3: faSquare3,
  faUfoBeam: faUfoBeam,
  faSquare: faSquare,
  faGarlic: faGarlic,
  faBackpack: faBackpack,
  faFileCertificate: faFileCertificate,
  faFileAward: faFileAward,
  faPeople: faPeople,
  faLandmarkMagnifyingGlass: faLandmarkMagnifyingGlass,
  faClipboardMedical: faClipboardMedical,
  faFaceGrin: faFaceGrin,
  faGrin: faGrin,
  faFileContract: faFileContract,
  faBorderBottomRight: faBorderBottomRight,
  faBorderStyleAlt: faBorderStyleAlt,
  faCassetteTape: faCassetteTape,
  faAngleUp: faAngleUp,
  faFolderGrid: faFolderGrid,
  faArrowRightToArc: faArrowRightToArc,
  faFaceSmile: faFaceSmile,
  faSmile: faSmile,
  faLocationPinSlash: faLocationPinSlash,
  faMapMarkerSlash: faMapMarkerSlash,
  faPersonDressBurst: faPersonDressBurst,
  faDivide: faDivide,
  faUserHelmetSafety: faUserHelmetSafety,
  faUserConstruction: faUserConstruction,
  faUserHardHat: faUserHardHat,
  faCodeFork: faCodeFork,
  faBagsShopping: faBagsShopping,
  faBookSparkles: faBookSparkles,
  faBookSpells: faBookSpells,
  faSunCloud: faSunCloud,
  faHouseFlag: faHouseFlag,
  faBullseyePointer: faBullseyePointer,
  faBuildingColumns: faBuildingColumns,
  faBank: faBank,
  faInstitution: faInstitution,
  faMuseum: faMuseum,
  faUniversity: faUniversity,
  faCloudShowers: faCloudShowers,
  faImageCircleXmark: faImageCircleXmark,
  faRug: faRug,
  faTruckBolt: faTruckBolt,
  faCodeMerge: faCodeMerge,
  faCactus: faCactus,
  faTableCellsHeader: faTableCellsHeader,
  faHouseTsunami: faHouseTsunami,
  faMagnifyingGlassChart: faMagnifyingGlassChart,
  faInputPipe: faInputPipe,
  faDisplayChartUpCircleDollar: faDisplayChartUpCircleDollar,
  faUmbrella: faUmbrella,
  faBoneBreak: faBoneBreak,
  faMessageQuestion: faMessageQuestion,
  faCircle5: faCircle5,
  faHillRockslide: faHillRockslide,
  faUserSecret: faUserSecret,
  faPager: faPager,
  faBriefcase: faBriefcase,
  faTrowelBricks: faTrowelBricks,
  faBaseballBat: faBaseballBat,
  faUserPoliceTie: faUserPoliceTie,
  faArrowRightToDottedLine: faArrowRightToDottedLine,
  faSocks: faSocks,
  faGaugeMax: faGaugeMax,
  faTachometerAltFastest: faTachometerAltFastest,
  faCommentArrowUp: faCommentArrowUp,
  faGuitarElectric: faGuitarElectric,
  faCoffeeBean: faCoffeeBean,
  faArrowDownLongToLine: faArrowDownLongToLine,
  faInputText: faInputText,
  faLightsHoliday: faLightsHoliday,
  faT: faT,
  faMicrochip: faMicrochip,
  faKeySkeleton: faKeySkeleton,
  faTruckMedical: faTruckMedical,
  faAmbulance: faAmbulance,
  faOm: faOm,
  faMosquitoNet: faMosquitoNet,
  faSquareManat: faSquareManat,
  faPrescriptionBottle: faPrescriptionBottle,
  faUsersGear: faUsersGear,
  faUsersCog: faUsersCog,
  faRoadCircleExclamation: faRoadCircleExclamation,
  faTrashCanClock: faTrashCanClock,
  faPause: faPause,
  faStaffSnake: faStaffSnake,
  faRodAsclepius: faRodAsclepius,
  faRodSnake: faRodSnake,
  faStaffAesculapius: faStaffAesculapius,
  faPiggyBank: faPiggyBank,
  faMonument: faMonument,
  faLightSwitchOff: faLightSwitchOff,
  faTricycle: faTricycle,
  faBorderCenterV: faBorderCenterV,
  faOpenCaptioning: faOpenCaptioning,
  faCircleY: faCircleY,
  faFolderMusic: faFolderMusic,
  faCircleSwedishKrona: faCircleSwedishKrona,
  faAnglesRight: faAnglesRight,
  faAngleDoubleRight: faAngleDoubleRight,
  faCircleT: faCircleT,
  faUserCrown: faUserCrown,
  faDesktop: faDesktop,
  faDesktopAlt: faDesktopAlt,
  faArrowUTurnLeftDown: faArrowUTurnLeftDown,
  faDonut: faDonut,
  faDoughnut: faDoughnut,
  faPlaneCircleXmark: faPlaneCircleXmark,
  faProjector: faProjector,
  faUpFromLine: faUpFromLine,
  faArrowAltFromBottom: faArrowAltFromBottom,
  faWaterTemperature: faWaterTemperature,
  faWaterTemp: faWaterTemp,
  faRetweet: faRetweet,
  faUserGear: faUserGear,
  faUserCog: faUserCog,
  faUserHairBuns: faUserHairBuns,
  faBorderAll: faBorderAll,
  faCoin: faCoin,
  faLockKeyholeOpen: faLockKeyholeOpen,
  faLockOpenAlt: faLockOpenAlt,
  faCoins: faCoins,
  faClockFourThirty: faClockFourThirty,
  fa00: fa00,
  faAmpGuitar: faAmpGuitar,
  faFolderArrowLeft: faFolderArrowLeft,
  faMarsStroke: faMarsStroke,
  faCircleDashed: faCircleDashed,
  faHandshakeAngle: faHandshakeAngle,
  faHandsHelping: faHandsHelping,
  faGaugeSimpleLow: faGaugeSimpleLow,
  faTachometerSlow: faTachometerSlow,
  faArrowDown: faArrowDown,
  faLocationDot: faLocationDot,
  faMapMarkerAlt: faMapMarkerAlt,
  faGasPumpRight: faGasPumpRight,
  faDeerRudolph: faDeerRudolph,
  faUfo: faUfo,
  faPlugCircleExclamation: faPlugCircleExclamation,
  faCookieBite: faCookieBite,
  faSquareChevronRight: faSquareChevronRight,
  faChevronSquareRight: faChevronSquareRight,
  faHandPointRibbon: faHandPointRibbon,
  faGrid2Plus: faGrid2Plus,
  faScrewdriverWrench: faScrewdriverWrench,
  faTools: faTools,
  faKeynote: faKeynote,
  faTicketsAirline: faTicketsAirline,
  faTicketsPerforatedPlane: faTicketsPerforatedPlane,
  faTicketsPlane: faTicketsPlane,
  faCalendarLines: faCalendarLines,
  faCalendarNote: faCalendarNote,
  faIndent: faIndent,
  faGolfClub: faGolfClub,
  faBars: faBars,
  faNavicon: faNavicon,
  faHandsPraying: faHandsPraying,
  faPrayingHands: faPrayingHands,
  faTemperatureSnow: faTemperatureSnow,
  faTemperatureFrigid: faTemperatureFrigid,
  faViruses: faViruses,
  faDryer: faDryer,
  faSchoolFlag: faSchoolFlag,
  faCircleGf: faCircleGf,
  faTrademark: faTrademark,
  faStretcher: faStretcher,
  faUTurnRightDown: faUTurnRightDown,
  faFireBurner: faFireBurner,
  faIntegral: faIntegral,
  faGripDotsVertical: faGripDotsVertical,
  faFaceLying: faFaceLying,
  faPersonBasketball: faPersonBasketball,
  faFolderUser: faFolderUser,
  faSkiBootSki: faSkiBootSki,
  faFaceSmileBeam: faFaceSmileBeam,
  faSmileBeam: faSmileBeam,
  faBatteryExclamation: faBatteryExclamation,
  faSquarePolishZloty: faSquarePolishZloty,
  faWreathLaurel: faWreathLaurel,
  faStars: faStars,
  faTentArrowLeftRight: faTentArrowLeftRight,
  faRoute: faRoute,
  faAnglesUp: faAnglesUp,
  faAngleDoubleUp: faAngleDoubleUp,
  faBucket: faBucket,
  faLessThanEqual: faLessThanEqual,
  faFlagPennant: faFlagPennant,
  faPennant: faPennant,
  faFolderClosed: faFolderClosed,
  faChessKingPiece: faChessKingPiece,
  faChessKingAlt: faChessKingAlt,
  faSquareKip: faSquareKip,
  faBinRecycle: faBinRecycle,
  faAeropress: faAeropress,
  faSendBackward: faSendBackward,
  faTruckRampCouch: faTruckRampCouch,
  faTruckCouch: faTruckCouch,
  faPersonThroughWindow: faPersonThroughWindow,
  faAvocado: faAvocado,
  faSealExclamation: faSealExclamation,
  faWindTurbine: faWindTurbine,
  faSchoolLock: faSchoolLock,
  faChartScatter3d: faChartScatter3d,
  faBusStop: faBusStop,
  faAlbumCollectionCirclePlus: faAlbumCollectionCirclePlus,
  faPersonBurst: faPersonBurst,
  faBalloon: faBalloon,
  faLeftLong: faLeftLong,
  faLongArrowAltLeft: faLongArrowAltLeft,
  faLocationCrosshairs: faLocationCrosshairs,
  faLocation: faLocation,
  faPersonDotsFromLine: faPersonDotsFromLine,
  faDiagnoses: faDiagnoses,
  faGaugeSimpleHigh: faGaugeSimpleHigh,
  faTachometer: faTachometer,
  faTachometerFast: faTachometerFast,
  faAnglesLeft: faAnglesLeft,
  faAngleDoubleLeft: faAngleDoubleLeft,
  faUpDown: faUpDown,
  faArrowsAltV: faArrowsAltV,
  faBoxArrowDownMagnifyingGlass: faBoxArrowDownMagnifyingGlass,
  faBatteryEmpty: faBatteryEmpty,
  faBattery0: faBattery0,
  faChartSine: faChartSine,
  faArrowsRetweet: faArrowsRetweet,
  faRetweetAlt: faRetweetAlt,
  faKeyboard: faKeyboard,
  faCodePullRequestClosed: faCodePullRequestClosed,
  faRight: faRight,
  faArrowAltRight: faArrowAltRight,
  faPenClipSlash: faPenClipSlash,
  faPenAltSlash: faPenAltSlash,
  faSensorOn: faSensorOn,
  faChevronsUp: faChevronsUp,
  faChevronDoubleUp: faChevronDoubleUp,
  faCookie: faCookie,
  faStopwatch: faStopwatch,
  faEject: faEject,
  faCardSpade: faCardSpade,
  faSatelliteDish: faSatelliteDish,
  faTableCellsUnlock: faTableCellsUnlock,
  faClipboardClock: faClipboardClock,
  faHandBackPointDown: faHandBackPointDown,
  faClockSixThirty: faClockSixThirty,
  faFaceRollingEyes: faFaceRollingEyes,
  faMehRollingEyes: faMehRollingEyes,
  faListCheck: faListCheck,
  faTasks: faTasks,
  faHouseBlank: faHouseBlank,
  faHomeBlank: faHomeBlank,
  faSackXmark: faSackXmark,
  faUserHatTie: faUserHatTie,
  faHashtag: faHashtag,
  faFileHeart: faFileHeart,
  faSquareQ: faSquareQ,
  faCastle: faCastle,
  faTrafficLightSlow: faTrafficLightSlow,
  faMessageCaptions: faMessageCaptions,
  faCommentAltCaptions: faCommentAltCaptions,
  faBird: faBird,
  faTrain: faTrain,
  faFileWav: faFileWav,
  faMessageMiddle: faMessageMiddle,
  faCommentMiddleAlt: faCommentMiddleAlt,
  faGamepad: faGamepad,
  faBroccoli: faBroccoli,
  faCoffeeBeans: faCoffeeBeans,
  faSquareChevronUp: faSquareChevronUp,
  faChevronSquareUp: faChevronSquareUp,
  faFileExport: faFileExport,
  faArrowRightFromFile: faArrowRightFromFile,
  faCupStrawSwoosh: faCupStrawSwoosh,
  faMandolin: faMandolin,
  faMerge: faMerge,
  faBookArrowUp: faBookArrowUp,
  faCircleBrazilianReal: faCircleBrazilianReal,
  faMeter: faMeter,
  faSquareSmall: faSquareSmall,
  faCircleZ: faCircleZ,
  faMistletoe: faMistletoe,
  faUpFromDottedLine: faUpFromDottedLine,
  faFaceHeadBandage: faFaceHeadBandage,
  faSlashBack: faSlashBack,
  faSimCards: faSimCards,
  faArrowLeftFromBracket: faArrowLeftFromBracket,
  faUsbDrive: faUsbDrive,
  faHeadSideBrain: faHeadSideBrain,
  faGlassHalf: faGlassHalf,
  faGlassHalfEmpty: faGlassHalfEmpty,
  faGlassHalfFull: faGlassHalfFull,
  faFaceGrimace: faFaceGrimace,
  faGrimace: faGrimace,
  faPanties: faPanties,
  faTrainSubway: faTrainSubway,
  faSubway: faSubway,
  faFaceGlasses: faFaceGlasses,
  faCloudDrizzle: faCloudDrizzle,
  faCircleDot: faCircleDot,
  faDotCircle: faDotCircle,
  faObjectGroup: faObjectGroup,
  faUserPolice: faUserPolice,
  faShip: faShip,
  faC: faC,
  faSquarePhone: faSquarePhone,
  faPhoneSquare: faPhoneSquare,
  faBoxTaped: faBoxTaped,
  faBoxAlt: faBoxAlt,
  faRulerCombined: faRulerCombined,
  faBracketSquareRight: faBracketSquareRight,
  faLeafMaple: faLeafMaple,
  faArrowsRotate: faArrowsRotate,
  faRefresh: faRefresh,
  faSync: faSync,
  faBenchTree: faBenchTree,
  faSquareRoot: faSquareRoot,
  faArrowDownTriangleSquare: faArrowDownTriangleSquare,
  faSortShapesDown: faSortShapesDown,
  faPersonDress: faPersonDress,
  faFemale: faFemale,
  faQuotes: faQuotes,
  faBookOpen: faBookOpen,
  faFolderTree: faFolderTree,
  faObjectUnion: faObjectUnion,
  faFileBinary: faFileBinary,
  faBoxArchive: faBoxArchive,
  faArchive: faArchive,
  faChopsticks: faChopsticks,
  faWaveformLines: faWaveformLines,
  faWaveformPath: faWaveformPath,
  faDown: faDown,
  faArrowAltDown: faArrowAltDown,
  faMessageArrowUp: faMessageArrowUp,
  faCommentAltArrowUp: faCommentAltArrowUp,
  faCircleDownLeft: faCircleDownLeft,
  faObjectsAlignRight: faObjectsAlignRight,
  faHourglassClock: faHourglassClock,
  faShutters: faShutters,
  faTentArrowDownToLine: faTentArrowDownToLine,
  faQrcode: faQrcode,
  faCircleUserCircleMoon: faCircleUserCircleMoon,
  faDragon: faDragon,
  faHourglassEnd: faHourglassEnd,
  faHourglass3: faHourglass3,
  faGrip: faGrip,
  faGridHorizontal: faGridHorizontal,
  faGripHorizontal: faGripHorizontal,
  faBorderTopLeft: faBorderTopLeft,
  faBorderStyle: faBorderStyle,
  faSignPost: faSignPost,
  faListUl: faListUl,
  faListDots: faListDots,
  faBookSection: faBookSection,
  faBookLaw: faBookLaw,
  faPeopleRobbery: faPeopleRobbery,
  faShirtTankTop: faShirtTankTop,
  faSteeringWheel: faSteeringWheel,
  faMagnifyingGlassWaveform: faMagnifyingGlassWaveform,
  faAlarmPlus: faAlarmPlus,
  faWineGlassCrack: faWineGlassCrack,
  faFragile: faFragile,
  faTransporter: faTransporter,
  faMobileButton: faMobileButton,
  faArrowDownAZ: faArrowDownAZ,
  faSortAlphaAsc: faSortAlphaAsc,
  faSortAlphaDown: faSortAlphaDown,
  faGlassCitrus: faGlassCitrus,
  faPool8Ball: faPool8Ball,
  faArrowDownSquareTriangle: faArrowDownSquareTriangle,
  faSortShapesDownAlt: faSortShapesDownAlt,
  faRepeat1: faRepeat1,
  faTransporter2: faTransporter2,
  faStarChristmas: faStarChristmas,
  faMobileRotateReverse: faMobileRotateReverse,
  faClawMarks: faClawMarks,
  faLightbulbOn: faLightbulbOn,
  faMoneyBill: faMoneyBill,
  faMessagesDollar: faMessagesDollar,
  faCommentsAltDollar: faCommentsAltDollar,
  faUserChefHairLong: faUserChefHairLong,
  faCroissant: faCroissant,
  faFileUser: faFileUser,
  faArrowTurnRight: faArrowTurnRight,
  faBorderTop: faBorderTop,
  faCircleMinus: faCircleMinus,
  faMinusCircle: faMinusCircle,
  faArrowPointer: faArrowPointer,
  faMousePointer: faMousePointer,
  faSquareShareNodes: faSquareShareNodes,
  faShareAltSquare: faShareAltSquare,
  faBorderOuter: faBorderOuter,
  faArrowDownRight: faArrowDownRight,
  faTableCellsLarge: faTableCellsLarge,
  faThLarge: faThLarge,
  faCircleUserCircleMinus: faCircleUserCircleMinus,
  faCloudPlus: faCloudPlus,
  faCat: faCat,
  faCalendarWeek: faCalendarWeek,
  faSpine: faSpine,
  faScannerImage: faScannerImage,
  faTRex: faTRex,
  faPipe: faPipe,
  faArrowUpToBracket: faArrowUpToBracket,
  faSigma: faSigma,
  faKeyboardDown: faKeyboardDown,
  faArrowDownToArc: faArrowDownToArc,
  faCodeCompare: faCodeCompare,
  faAlarmMinus: faAlarmMinus,
  faWand: faWand,
  faMeterBolt: faMeterBolt,
  faArrowsRotateReverse: faArrowsRotateReverse,
  faScannerKeyboard: faScannerKeyboard,
  faChessBishopPiece: faChessBishopPiece,
  faChessBishopAlt: faChessBishopAlt,
  faFilePlusMinus: faFilePlusMinus,
  faUnion: faUnion,
  faArrowUpBigSmall: faArrowUpBigSmall,
  faSortSizeUp: faSortSizeUp,
  faRoadCircleXmark: faRoadCircleXmark,
  faCowbellCirclePlus: faCowbellCirclePlus,
  faCowbellMore: faCowbellMore,
  faThoughtBubble: faThoughtBubble,
  faPallet: faPallet,
  faCircleBookOpen: faCircleBookOpen,
  faBookCircle: faBookCircle,
  faVialVertical: faVialVertical,
  faPodiumStar: faPodiumStar,
  faBarProgressQuarter: faBarProgressQuarter,
  faCakeCandles: faCakeCandles,
  faBirthdayCake: faBirthdayCake,
  faCake: faCake,
  faFaceExhaling: faFaceExhaling,
  faBugSlash: faBugSlash,
  faTrashCanPlus: faTrashCanPlus,
  faTarp: faTarp,
  faBorderCenterH: faBorderCenterH,
  faTally: faTally,
  faTally5: faTally5,
  faDiagramPredecessor: faDiagramPredecessor,
  faFaceFlushed: faFaceFlushed,
  faFlushed: faFlushed,
  faDiagramNext: faDiagramNext,
  faCircleSortDown: faCircleSortDown,
  faSortCircleDown: faSortCircleDown,
  faAnchorCircleXmark: faAnchorCircleXmark,
  faCircleP: faCircleP,
  faPersonCircleXmark: faPersonCircleXmark,
  faBurrito: faBurrito,
  faSignalBarsGood: faSignalBarsGood,
  faSignalAlt3: faSignalAlt3,
  faSpa: faSpa,
  faChessClockFlip: faChessClockFlip,
  faChessClockAlt: faChessClockAlt,
  faBarsProgress: faBarsProgress,
  faTasksAlt: faTasksAlt,
  faOverline: faOverline,
  faCircleMicrophone: faCircleMicrophone,
  faMicrophoneCircle: faMicrophoneCircle,
  faHeartCircleCheck: faHeartCircleCheck,
  faMarsStrokeRight: faMarsStrokeRight,
  faMarsStrokeH: faMarsStrokeH,
  faFaceExpressionless: faFaceExpressionless,
  faTransporterEmpty: faTransporterEmpty,
  faWatchFitness: faWatchFitness,
  faMoonCloud: faMoonCloud,
  faUTurnDownRight: faUTurnDownRight,
  faFaceShaking: faFaceShaking,
  faSunrise: faSunrise,
  faBuildingMemo: faBuildingMemo,
  faCartFlatbedEmpty: faCartFlatbedEmpty,
  faDollyFlatbedEmpty: faDollyFlatbedEmpty,
  faSquareDanishKrone: faSquareDanishKrone,
  faFaceDisappointed: faFaceDisappointed,
  faBowlChopsticks: faBowlChopsticks,
  faCarSiren: faCarSiren,
  faTowerObservation: faTowerObservation,
  faBinaryLock: faBinaryLock,
  faSterlingSign: faSterlingSign,
  faGbp: faGbp,
  faPoundSign: faPoundSign,
  faAlicorn: faAlicorn,
  faSquareHryvnia: faSquareHryvnia,
  faArrowRightLongToLine: faArrowRightLongToLine,
  faComputerSpeaker: faComputerSpeaker,
  faFaucetDrip: faFaucetDrip,
  faMailboxOpenEmpty: faMailboxOpenEmpty,
  faFaceRaisedEyebrow: faFaceRaisedEyebrow,
  faClonePlus: faClonePlus,
  faFaceSmilingHands: faFaceSmilingHands,
  faFileLock: faFileLock,
  faCircleInfo: faCircleInfo,
  faInfoCircle: faInfoCircle,
  faBellExclamation: faBellExclamation,
  faFeather: faFeather,
  faBowlRice: faBowlRice,
  faDialMedLow: faDialMedLow,
  faStarHalfStroke: faStarHalfStroke,
  faStarHalfAlt: faStarHalfAlt,
  faPlanetMoon: faPlanetMoon,
  faTemperatureArrowDown: faTemperatureArrowDown,
  faTemperatureDown: faTemperatureDown,
  faMaskVentilator: faMaskVentilator,
  faCannon: faCannon,
  faChartScatter: faChartScatter,
  faFileVideo: faFileVideo,
  faSquareO: faSquareO,
  faArrowTrendDown: faArrowTrendDown,
  faCitrusSlice: faCitrusSlice,
  faDisplayChartUpCircleCurrency: faDisplayChartUpCircleCurrency,
  faCommentMiddleTop: faCommentMiddleTop,
  faCaretLargeDown: faCaretLargeDown,
  faDownToDottedLine: faDownToDottedLine,
  faPhoneArrowDownLeft: faPhoneArrowDownLeft,
  faPhoneArrowDown: faPhoneArrowDown,
  faPhoneIncoming: faPhoneIncoming,
  faBuoyMooring: faBuoyMooring,
  faTentCircus: faTentCircus,
  faOilCan: faOilCan,
  faMemoCircleInfo: faMemoCircleInfo,
  faCartCircleArrowUp: faCartCircleArrowUp,
  faCircleParking: faCircleParking,
  faParkingCircle: faParkingCircle,
  faCassetteBetamax: faCassetteBetamax,
  faBetamax: faBetamax,
  faTankRecovery: faTankRecovery,
  faPeopleCarryBox: faPeopleCarryBox,
  faPeopleCarry: faPeopleCarry,
  faClockEight: faClockEight,
  faChair: faChair,
  faWind: faWind,
  faLayerGroup: faLayerGroup,
  faLollipop: faLollipop,
  faLollypop: faLollypop,
  faNotes: faNotes,
  faHexagonXmark: faHexagonXmark,
  faTimesHexagon: faTimesHexagon,
  faXmarkHexagon: faXmarkHexagon,
  faShishKebab: faShishKebab,
  faHeadSideMask: faHeadSideMask,
  faHands: faHands,
  faSignLanguage: faSignLanguage,
  faSigning: faSigning,
  faTablets: faTablets,
  faWeightHanging: faWeightHanging,
  faPinball: faPinball,
  faDice: faDice,
  faShopSlash: faShopSlash,
  faStoreAltSlash: faStoreAltSlash,
  faSortDown: faSortDown,
  faSortDesc: faSortDesc,
  faCommentExclamation: faCommentExclamation,
  faTableLayout: faTableLayout,
  faPesetaSign: faPesetaSign,
  faTabletScreenButton: faTabletScreenButton,
  faTabletAlt: faTabletAlt,
  faUserViewfinder: faUserViewfinder,
  faHandHoldingDollar: faHandHoldingDollar,
  faHandHoldingUsd: faHandHoldingUsd,
  faHorseSaddle: faHorseSaddle,
  faShield: faShield,
  faShieldBlank: faShieldBlank,
  faPeach: faPeach,
  faFaceLaugh: faFaceLaugh,
  faLaugh: faLaugh,
  faBellSchoolSlash: faBellSchoolSlash,
  faAlignSlash: faAlignSlash,
  faCloudExclamation: faCloudExclamation,
  faHandsHolding: faHandsHolding,
  faCartShopping: faCartShopping,
  faShoppingCart: faShoppingCart,
  faTrianglePersonDigging: faTrianglePersonDigging,
  faConstruction: faConstruction,
  faSquareColon: faSquareColon,
  faSubtitlesSlash: faSubtitlesSlash,
  faSquareD: faSquareD,
  faFolderMedical: faFolderMedical,
  faChartScatterBubble: faChartScatterBubble,
  faHatWitch: faHatWitch,
  faBin: faBin,
  faGarageCar: faGarageCar,
  faCalendarClock: faCalendarClock,
  faCalendarTime: faCalendarTime,
  faOctagon: faOctagon,
  faHandPointer: faHandPointer,
  faRabbit: faRabbit,
  faCircleaporeDollar: faCircleaporeDollar,
  faSushi: faSushi,
  faNigiri: faNigiri,
  faScannerGun: faScannerGun,
  faScanner: faScanner,
  faPencilMechanical: faPencilMechanical,
  faHandHoldingSeedling: faHandHoldingSeedling,
  faLocationQuestion: faLocationQuestion,
  faMapMarkerQuestion: faMapMarkerQuestion,
  faUp: faUp,
  faArrowAltUp: faArrowAltUp,
  faArrowUpArrowDown: faArrowUpArrowDown,
  faSortUpDown: faSortUpDown,
  faScarecrow: faScarecrow,
  faLocationCrosshairsSlash: faLocationCrosshairsSlash,
  faLocationSlash: faLocationSlash,
  faRegistered: faRegistered,
  faRectanglePro: faRectanglePro,
  faPro: faPro,
  faBreadSliceButter: faBreadSliceButter,
  faLightCeiling: faLightCeiling,
  faUserHairMullet: faUserHairMullet,
  faBusinessFront: faBusinessFront,
  faPartyBack: faPartyBack,
  faTrianBalbot: faTrianBalbot,
  faSquareParkingSlash: faSquareParkingSlash,
  faParkingSlash: faParkingSlash,
  faLinkSimpleSlash: faLinkSimpleSlash,
  faHouseSignal: faHouseSignal,
  faLockKeyhole: faLockKeyhole,
  faLockAlt: faLockAlt,
  faTally2: faTally2,
  faBangladeshiTakaSign: faBangladeshiTakaSign
};

export { icons as fass, prefix, fa0, fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9, faChessPawnPiece, faChessPawnAlt, faDollarSign, faDollar, faUsd, faLayerPlus, faLayerGroupPlus, faGrid4, faDog, faTruckMoving, faRotate, faSyncAlt, faArrowUTurnUpLeft, faKeyboardBrightness, faTentDoublePeak, faSquareMinus, faMinusSquare, faWaterArrowUp, faWaterRise, faXmarkToSlot, faTimesToSlot, faVoteNay, faSensorCloud, faSensorSmoke, faLychee, faAlignJustify, faSunglasses, faCloudCheck, faMessageMinus, faCommentAltMinus, faFaceClouds, faLeftLongToLine, faPlaneLandingGear, faCalendarCheck, faSquareRing, faFaceKiss, faKiss, faCircleVideo, faVideoCircle, faCartShoppingFast, faDesktopArrowDown, faBanjo, faCloudHailMixed, faSquareHalfStroke, faKitchenSet, faDna, faCircleBangladeshiTaka, faBoxCircleCheck, faTrillium, faDeleteRight, faCircleColon, faChildReaching, faFaceConfounded, faSidebar, faPaste, faFileClipboard, faInhaler, faMeteor, faHoneyPot, faLaptopSlash, faGears, faCogs, faWaveSine, faArrowTurnLeftUp, faGarage, faFlatbreadStuffed, faUTurnDownLeft, faFaceShakingHorizontal, faEyes, faDash, faMinusLarge, faPhotoFilmMusic, faLocationArrowSlash, faCircleM, faArrowUpToDottedLine, faFileCirclePlus, faMustache, faWindowFrame, faHouseNight, faReel, faIcicles, faBinarySlash, faSquareSlidersVertical, faSlidersVSquare, faArrowTrendUp, faTimelineArrow, faFort, faCircleV, faHexagonNodesBolt, faLightEmergencyOn, faQuestion, faSquareLira, faSquareDashedCirclePlus, faChairOffice, faUserMagnifyingGlass, faContainerStorage, faArrowLeftToBracket, faSparkle, faCampfire, faHandsBound, faPanelFire, faClockSevenThirty, faTugrikSign, faAudioDescriptionSlash, faFaceThermometer, faLightbulbCflOn, faClockThree, faPersonWalkingLuggage, faFileArrowDown, faFileDownload, faPersonBooth, faLocust, faWindow, faRightLong, faLongArrowAltRight, faTruckDroplet, faHandHoldingMedical, faHandPointLeft, faCalculator, faOilTemperature, faOilTemp, faMinus, faSubtract, faMessageArrowDown, faCommentAltArrowDown, faShoe, faGameBoardSimple, faGameBoardAlt, faArrowTurnLeft, faCircle4, faHammerWar, faLightEmergency, faArrowUpZA, faSortAlphaUpAlt, faMicrophoneSlash, faSquarePen, faPenSquare, faPencilSquare, faBellPlus, faHandFist, faFistRaised, faPants, faCommentSms, faSms, faHeadSideGear, faTransporter1, faScannerTouchscreen, faFlaskRoundPotion, faFlaskPotion, faCarBolt, faTableRows, faRows, faCloudSlash, faFaceHandYawn, faTickets, faSimCard, faShieldQuartered, faSquareEllipsisVertical, faOven, faScaleBalanced, faBalanceScale, faCar, faAutomobile, faCircleBaht, faBadgerHoney, faCropSimple, faCropAlt, faTimer, faSquareDollar, faDollarSquare, faUsdSquare, faMedal, faScroll, faCalendars, faAppleCore, faFileExcel, faDiamondHalf, faBaguette, faEarTriangleExclamation, faH5, faPersonSkiLift, faSkiLift, faSquareCedi, faFilter, faCalculatorSimple, faCalculatorAlt, faCoinBlank, faIntersection, faDrum, faMapPin, faCircleHouse, faTablePivot, faBridgeSuspension, faScaleUnbalancedFlip, faBalanceScaleRight, faLightSwitch, faArrowsToCircle, faAmpersand, faChessClock, faEnvelope, faBaby, faNfcLock, faSquareCaretDown, faCaretSquareDown, faHyphen, faPlaneProp, faTent, faChimney, faA, faCircleSmall, faParachuteBox, faCartFlatbedBoxes, faDollyFlatbedAlt, faCartArrowDown, faCircle7, faLockHashtag, faCircleSterling, faBridgeCircleExclamation, faCloudArrowUp, faCloudUpload, faCloudUploadAlt, faAt, faIndianRupeeSign, faIndianRupee, faInr, faTruck, faGameConsoleHandheldCrank, faChalkboardUser, faChalkboardTeacher, faUserCheck, faChartPieSimpleCircleCurrency, faFaceFearful, faUserNinja, faFrame, faPlantWilt, faWeightScale, faWeight, faFarm, faBarnSilo, faCaretRight, faHexagonDivide, faFlorinSign, faLightbulbExclamationOn, faBell, faHandBackPointLeft, faLariSign, faRectanglePlus, faCucumber, faSeal, faCircleCaretDown, faCaretCircleDown, faMillSign, faMugTeaSaucer, faCartCircleCheck, faAlbum, faLeftToLine, faArrowAltToLeft, faPersonSnowboarding, faSnowboarding, faTty, faTeletype, faSliderCircle, faUsersRectangle, faMobile, faMobileAndroid, faMobilePhone, faArrowsTurnToDots, faExclamation, faLocationXmark, faMapMarkerTimes, faMapMarkerXmark, faChurch, faToggleOff, faFaceNauseated, faDeer, faBoxOpenFull, faBoxFull, faCherries, faVacuumRobot, faCircleEurozone, faShoePrints, faSquirrel, faCircleCedi, faFileCircleExclamation, faWallet, faSquareTugrik, faMessage, faCommentAlt, faTrophy, faFaceDizzy, faDizzy, faBacteria, faToggleLargeOn, faEarDeaf, faDeaf, faDeafness, faHardOfHearing, faPeopleArrows, faPeopleArrowsLeftRight, faTreasureChest, faCaretLargeRight, faHandsClapping, faCircleAmpersand, faVirusCovidSlash, faChartSimpleHorizontal, faDownFromDottedLine, faCalendarDays, faCalendarAlt, faLighthouse, faDiamondTurnRight, faDirections, faDrone, faText, faSquareGuarani, faToiletPaperUnderSlash, faToiletPaperReverseSlash, faHandPointUp, faPenSlash, faCommentPlus, faBezierCurve, faClipboardListCheck, faLampDesk, faPersonHalfDress, faPeanut, faMessagePlus, faCommentAltPlus, faBracketCurly, faBracketCurlyLeft, faSquarePollHorizontal, faPollH, faNfcSignal, faBoxIsometric, faSchoolCircleXmark, faPersonSeatWindow, faGrapes, faHandLizard, faCameraSlash, faChalkboard, faBlackboard, faMemoPad, faBluetooth, faObjectsAlignCenterHorizontal, faDistributeSpacingVertical, faUpRightFromSquare, faExternalLinkAlt, faSquareTurkishLira, faRotateExclamation, faRightFromLine, faArrowAltFromLeft, faCircleQ, faMoonOverSun, faEclipseAlt, fa360Degrees, faBracketRoundRight, faSquareFull, faStarSharp, faListRadio, faHeadSideMedical, faTombstone, faSquareALock, faClover, faSignalBarsFair, faSignalAlt2, faFolderHeart, faCloudWord, faScreenUsers, faUsersClass, faTeethOpen, faCircleU, faCalendarHeart, faNarwhal, faBarsStaggered, faReorder, faStream, faWarehouse, faSwatchbook, faCircleThreeQuarters, faCircleChf, faCampground, faPersonWalkingArrowRight, faSpiderBlackWidow, faGlasses, faCirclePause, faPauseCircle, faMemory, faGift, faSprinklerCeiling, faSquarePhoneHangup, faPhoneSquareDown, faMoneyBillWheat, faCircleFlorin, faDungeon, faComet, faFaceHoldingBackTears, faCardHeart, faCarMirrors, faSuitcaseMedical, faMedkit, faBlockQuote, faHandsHoldingHeart, faHandsHeart, faArrowUpSmallBig, faSortSizeUpAlt, faSlidersSimple, faPersonCane, faMessageMusic, faCommentAltMusic, faGaugeLow, faTachometerAltSlow, faHexagonEquals, faCapsule, faUserSith, faGauge, faDashboard, faGaugeMed, faTachometerAltAverage, faEnvelopeOpenText, faToolbox, faWheatSlash, faPowerOff, faSignal, faSignal5, faSignalPerfect, faArrowsSpin, faJoint, faDownFromLine, faArrowAltFromTop, faTabletRugged, faBraille, faBasketShopping, faShoppingBasket, faPartyBell, faBra, faCarWash, faFaceSunglasses, faBridge, faArrowsFromLine, faUpLongToLine, faUpToLine, faArrowAltToTop, faPlaneArrival, faPotFood, faCashRegister, faRing, faMessageXmark, faCommentAltTimes, faMessageTimes, faShareNodes, faShareAlt, faOctagonDivide, faFolderArrowUp, faFolderUpload, faArrowsMinimize, faCompressArrows, faPersonCircleExclamation, faBinoculars, faGridRound5, faKipSign, faHardDrive, faHdd, faRankingStar, faUserTie, faSquareBitcoin, faEllipsis, faEllipsisH, faArrowTurnDownLeft, faOctagonCheck, faStore24, faStoreSlash, faPercent, faPercentage, faCircleN, faFileZipper, faFileArchive, faTrashCanXmark, faDisplay, faEllipsisStroke, faEllipsisHAlt, faAirConditioner, faFileXls, faPinata, faChartFft, faCircleUserCircleExclamation, faPhoneIntercom, faTurnLeftUp, faScarf, faMessagePen, faCommentAltEdit, faMessageEdit, faIcons, faHeartMusicCameraBolt, faFileXml, faRulerVertical, faMapLocationDot, faMapMarkedAlt, faWatermelonSlice, faJackOLantern, faCandy, faHeartCrack, faHeartBroken, faCow, faRss, faFeed, faMagnifyingGlass, faSearch, faObjectsAlignLeft, faCloudMoon, faAbacus, faBoxesStacked, faBoxes, faBoxesAlt, faCodeBranch, faBan, faCancel, faPersonCarryBox, faPersonCarry, faCircleLitecoin, faJugDetergent, faFloppyDiskPen, faLips, faOutlet, faReply, faMailReply, faSunPlantWilt, faFaceMask, faFalafel, faTombstoneBlank, faTombstoneAlt, faCircleCaretUp, faCaretCircleUp, faLampStreet, faCircleB, faButterfly, faBacterium, faSquare7, faMagnifyingGlassArrowsRotate, faSquareI, faStandardDefinition, faRectangleSd, faAlien8bit, faAlienMonster, faVacuum, faBowlChopsticksNoodles, faRecordVinyl, faFloppyDisk, faSave, faDownLeft, faToiletsPortable, faO, faPalette, faPaintbrushFineSlash, faBlueberries, faFishBones, faUnlock, faFanTable, faEarListen, faAssistiveListeningSystems, faCodePullRequest, faThumbtackAngle, faKey, faSnake, faCircleWaveformLines, faWaveformCircle, faEmptySet, faCircleWon, faHockeyStick, faMonkey, faForklift, faSkull, faSneaker, faGamepadModern, faGamepadAlt, faSquareK, faCommentText, faMarsStrokeUp, faMarsStrokeV, faCowbell, faFireFlameSimple, faBurn, faTree, faGaugeSimpleMin, faTachometerSlowest, faCommentsQuestionCheck, faSmog, faS, faPhoneArrowUpRight, faPhoneArrowUp, faPhoneOutgoing, faTeddyBear, faSlotMachine, faFaceSleeping, faJedi, faPoliceBox, faDogLeashed, faPersonHiking, faHiking, faArrowsUpToLine, faPenLine, faBadgePercent, faMarsDouble, faThermometer, faPaintbrush, faPaintBrush, faSignalStream, faSquareP, faBee, faMusicSlash, faPersonSimple, faAlbumCollectionCircleUser, faWhale, faArrowUpTriangleSquare, faSortShapesUp, faNeuter, faSquarePhoneFlip, faPhoneSquareAlt, faCircleG, faCircleDownRight, faPeopleDress, faCircleHalf, faFaceGrinTongueSquint, faGrinTongueSquint, faPickaxe, faCommentDollar, faListTimeline, faSwordsLaser, faPhoneWaveform, faHippo, faSwordLaserAlt, faFlower, faBowlFood, faGlobePointer, faEggplant, faFolderArrowRight, faBatterySlash, faFilmSlash, faSquareVirus, faTricycleAdult, faCirclePhoneFlip, faPhoneCircleAlt, faCloudSunRain, faH4, faCircleCaretRight, faCaretCircleRight, faKeyboardBrightnessLow, faArrowRightLong, faLongArrowRight, faFontCase, faBuildingUn, faToiletPaperXmark, faTemperatureLow, faH2, faFaceSmileHalo, faRocketVertical, faDoorOpen, faAlignLeft, faPencilSlash, faCamera, faCameraAlt, faHatWinter, faHousePersonReturn, faHousePersonArrive, faHouseReturn, faKnife, faUtensilKnife, faMessageExclamation, faCommentAltExclamation, faRightToLine, faArrowAltToRight, faMailbox, faMessageHeart, faMessageMiddleTop, faCommentMiddleTopAlt, faUsersRays, faCirclesOverlap, faRainbow, faBoxArrowDownArrowUp, faLeftFromDottedLine, faSitemap, faCaravanSimple, faCaravanAlt, faFaceGrinStars, faGrinStars, faMessageSms, faCommentsQuestion, faSortUp, faSortAsc, faBillboard, faEye, faArrowDownSmallBig, faSortSizeDownAlt, faAxe, faCaretLeft, faAppleWhole, faAppleAlt, faScrollTorah, faTorah, faHouseLock, faSquareLitecoin, faArrowsLeftRightToLine, faTrash, faFaceSadTear, faSadTear, faTireFlat, faMelon, faFax, faArrowLeftLongToLine, faUserMusic, faPersonCirclePlus, faHamsa, faHouseBuilding, faPersonCircleQuestion, faCrateEmpty, faSunHaze, faCircle3, faClipboardCheck, faShareFromSquare, faShareSquare, faForkKnife, faUtensilsAlt, faReceipt, faEquals, faDiagramLeanCanvas, faBoxArrowUp, faChevronUp, faVirusSlash, faGlobeStand, faRingDiamond, faPhoneRotary, faSlash, faArrowDownToDottedLine, faSaxophoneFire, faSaxHot, faWindowFrameOpen, faCircleD, faExpand, faScooter, faFileMp4, faNoteSticky, faStickyNote, faDolphin, faBorderBottom, faUserMessage, faSignalWeak, faSignal1, faTableColumns, faColumns, faPersonShelter, faCameraSecurity, faCameraHome, faCircleNotch, faWater, faDeleteLeft, faBackspace, faCircleRupee, faArrowDownToSquare, faSquareB, faBroomBall, faQuidditch, faQuidditchBroomBall, faH6, faJ, faShuttleSpace, faSpaceShuttle, faYinYang, faSignalGood, faSignal3, faImageStack, faStop, faTrowel, faCircle2, faDrumstick, faSquareX, faPeapod, faMessageText, faCommentAltText, faHandBackFist, faHandRock, faSnowmanHead, faFrostyHead, faBlanket, faCommentXmark, faCommentTimes, faPersonDollyEmpty, faSignalSlash, faHexagonPlus, faPlusHexagon, faTemperatureHigh, faGreaterThan, faToothbrush, faFlute, faLobster, faCalendarCircleExclamation, faMobileRotate, faCrutch, faCommand, faTvRetro, faPawClaws, faSeptagon, faHeptagon, faFaceSmileUpsideDown, faGlassEmpty, faEar, faStreetView, faBriefs, faSpeakers, faWaveSquare, faAngleLeft, faTurtle, faArrowRightToLine, faArrowToRight, faPantsStraight, faScrewdriver, faTrafficLightStop, faSquareEuro, faTractor, faBridgeCircleXmark, faVials, faStarfighterTwinIonEngineAdvanced, faStarfighterAltAdvanced, faStethoscope, faPodcast, faArrowUpRightDots, faChessQueen, faAnchorCircleExclamation, faEllipsisVertical, faEllipsisV, faAcorn, faBanParking, faParkingCircleSlash, faSquareDong, faListDropdown, faCameraCircleEllipsis, faFamilyDress, faPodium, faRobotAstromech, faHeartCircleExclamation, faBuildingCircleExclamation, faPersonArrowUpFromLine, faCircleArrowDownLeft, faNotEqual, faBinaryCircleCheck, faTrainTram, faPlaneDeparture, faMicrophoneStand, faShop24, faBrightness, faRightToBracket, faSignInAlt, faSdCard, faDot, faHouseCircleExclamation, faShekelSign, faIls, faShekel, faSheqel, faSheqelSign, faSquareU, faTruckContainerEmpty, faUserPilotTie, faRadio, faHandDots, faAllergies, faPencilLine, faHandShaka, faFlaskGear, faBookSkull, faBookDead, faUnlockKeyhole, faUnlockAlt, faTruckRamp, faEnvelopeDot, faEnvelopeBadge, faHouseHeart, faHomeHeart, faFileArrowUp, faFileUpload, faGameConsoleHandheld, faFaceGrinTears, faGrinTears, faPenToSquare, faEdit, faEarthEurope, faGlobeEurope, faTablePicnic, faFaceGrinBeamSweat, faGrinBeamSweat, faCircleHalfStroke, faAdjust, faRulerTriangle, faOctagonPlus, faPlusOctagon, faUserCowboy, faBookmarkPlus, faPersonMilitaryToPerson, faImageMusic, faPersonPinball, faMouseField, faTableCellsColumnLock, faTruckFieldUn, faClock, faClockFour, faLayerMinus, faLayerGroupMinus, faCircleEuro, faBook, faFaceLaughWink, faLaughWink, faTransducer, faUserDoctorHairLong, faCloudMeatball, faCloudXmark, faChartArea, faAreaChart, faUtilityPoleDouble, faRupiahSign, faDiagramNested, faSquareQuarters, faPrintSlash, faShieldKeyhole, faSquareLeft, faArrowAltSquareLeft, faTextWidth, faCircleCurrency, faSignatureLock, faSatellite, faBallPile, faSeats, faFileEps, faMagnifyingGlassMinus, faSearchMinus, faVentDamper, faPeopleGroup, faSquareQuote, faSquareBinary, faMasksTheater, faTheaterMasks, faHouseTurret, faCartPlus, faHandsAslInterpreting, faAmericanSignLanguageInterpreting, faAslInterpreting, faHandsAmericanSignLanguageInterpreting, faFaceAnxiousSweat, faMessageSmile, faCommentAltSmile, faLocationExclamation, faMapMarkerExclamation, faSquareNaira, faTableCellsRowUnlock, faDiamonds4, faRocket, faFileCircleInfo, faCloudFog, faFog, faOption, faUtilityPole, faShrimp, faAlien, faSkeleton, faTirePressureWarning, faNose, faSignPostsWrench, faTengeSign, faTenge, faFaceScream, faHouseChimneyMedical, faClinicMedical, faSquareArrowLeft, faArrowSquareLeft, faCircleLocationArrow, faLocationCircle, faUsersSlash, faTrafficCone, faStarSharpHalfStroke, faStarSharpHalfAlt, faH1, faTamale, faRouteHighway, faPaperPlane, faObjectIntersect, faBookAtlas, faAtlas, faTable, faCircleSort, faSortCircle, faHeart, faScythe, faCircleChevronUp, faChevronCircleUp, faApostrophe, faBatteryHalf, faBattery3, faFontAwesome, faFontAwesomeFlag, faFontAwesomeLogoFull, faHandcuffs, faSquareBangladeshiTaka, faHatCowboySide, faSausage, faChevronsDown, faChevronDoubleDown, faIndustry, faPeopleDressSimple, faLinesLeaning, faPassport, faInfinity, faHandHeart, faClone, faForward, faSquareR, faPeriod, faM, faMoneyCheckPen, faMoneyCheckEdit, faRoadSpikes, faFishCooked, faPersonSeatReclined, faMountain, faCircleW, faChess, faTemperatureThreeQuarters, faTemperature3, faThermometer3, faThermometerThreeQuarters, faB, faShieldVirus, faTriangle, faLitecoinSign, faDiceD6, faGripLinesVertical, faToggleLargeOff, faGolfBallTee, faGolfBall, faHexagon, faKite, faShareAll, faChemex, faFolderOpen, faTick, faFaceDrooling, faBullseyeArrow, faKaaba, faHandBackPointRight, faStarfighterTwinIonEngine, faStarfighterAlt, faHandHolding, faBadgeSheriff, faRainbowHalf, faCommentLines, faSingleQuoteRight, faBottleDroplet, faFaceExplode, faExplodingHead, faWindowMinimize, faStadium, faMegaphone, faBurgerGlass, faPenPaintbrush, faPencilPaintbrush, faLightbulbSlash, faCircleAustralianDollar, faShuttleSpaceVertical, faPersonToDoor, faFaceViewfinder, faRectangleVideoOnDemand, faTennisBall, faChevronRight, faEgg, faConveyorBeltArm, faLandmarkDome, faLandmarkAlt, faGrate, faWorm, faSack, faUserInjured, faMidi, faMoonStar, faStrikethrough, faCalendarCircleMinus, faBlog, faStopwatch20, faSquareFlorin, faBinary, faShieldCheck, faSquareCruzeiro, faTruckPickup, faSeedling, faSprout, faCircleDivide, faCircleKip, faTransgender, faTransgenderAlt, faArrowDownToBracket, faUnicorn, faLeftFromBracket, faRampLoading, faHandHoldingBox, faStarHalf, faArrowDownToLine, faArrowToBottom, faPhotoFilm, faPhotoVideo, faPi, faPictureInPicture, faTableCellsLock, faPumpMedical, faFire, faFaceSmilePlus, faSmilePlus, faMagnifyingGlassPlus, faSearchPlus, faSwap, faCommentHeart, faFaceSmileTear, faWheat, faBarcodeScan, faEarCircleCheckmark, faGalaxy, faFlask, faCarKey, faFireplace, faFlowerTulip, faInboxes, faRectangleVertical, faRectanglePortrait, faAlignRight, faTransporter6, faCableCar, faTram, faKitMedical, faFirstAid, faGripLines, faBurger, faHamburger, faRaindrops, faSnowman, faHotel, faPrint, faDialMin, faCirclePolishZloty, faFamily, faStarfighter, faCartCircleArrowDown, faMessageMedical, faCommentAltMedical, faCircleArrowDownRight, faVolleyball, faVolleyballBall, faArrowTurnDownRight, faTrafficLight, faPlaneCircleCheck, faSquarePeso, faHouseWater, faHouseFlood, faUsers, faCertificate, faAlarmClock, faHelicopterSymbol, faHouseChimneyCrack, faHouseDamage, faDryerHeat, faDryerAlt, faBringForward, faDialLow, faCircleWifiCircleWifi, faCircleWifiGroup, faDisplayMedical, faDesktopMedical, faPersonMilitaryPointing, faDatabase, faNewspaper, faCloudRain, faSignalStrong, faSignal4, faMaximize, faExpandArrowsAlt, faLocationArrow, faCity, faRectangleCode, faToiletPaperCheck, faSealQuestion, faXRay, faUmbrellaBeach, faArrowRightToBracket, faSignIn, faHeadset, faThumbtackAngleSlash, faCameraPolaroid, faFaceSaluting, faHandHorns, faFileExclamation, faHeadSideCircuit, faPipeCircleCheck, faSplotch, faSquareShekel, faUpLong, faLongArrowAltUp, faFaceUnamused, faCircleIndianRupee, faSpinnerScale, faHexagonNodes, faHospital, faHospitalAlt, faHospitalWide, faFaceRelieved, faSquarePeruvianSoles, faCommentSmile, faFolderCheck, faCurrencySign, faChartUser, faUserChart, faPersonHarassing, faFlatbread, faCircleMicrophoneLines, faMicrophoneCircleAlt, faMoneyBillTrendUp, faPenRuler, faPencilRuler, faBracketsSquare, faBrackets, faPersonDressSimple, faTrainSubwayTunnel, faSubwayTunnel, faRepeat, faBottleBaby, faBone, faRightLeftLarge, faStrawberry, faSquareBolt, faFireFlameCurved, faFireAlt, faSignatureSlash, faBusSimple, faBusAlt, faSquarePeseta, faTankWater, faUserShakespeare, faVenusMars, faKazoo, faDiagramSubtask, faArrowsFromDottedLine, faGripDots, faBlender, faU, faBoxHeart, faLightbulbCfl, faShare, faMailForward, faCassetteVhs, faVhs, faPhoneFlip, faPhoneAlt, faFaceSwear, faToiletPortable, faCircleRupiah, faMobileVibrateSlash, faTableCellsColumnUnlock, faPersonPregnant, faLessThan, faImageCircleArrowDown, faSquareFragile, faBoxFragile, faSquareWineGlassCrack, faInboxFull, faFilmCanister, faFilmCannister, faHammerBrush, faSuperscript, faUniformMartialArts, faCircleUserCircleUser, faCircleStop, faStopCircle, faArrowsUpDown, faArrowsV, faMeterDroplet, faOrnament, faDisplaySlash, faDesktopSlash, faPageCaretUp, faFileCaretUp, faPooStorm, faPooBolt, faVideoSlash, faSquareXmark, faTimesSquare, faXmarkSquare, faMessageDots, faCommentAltDots, faMessaging, faDropletDegree, faDewpoint, faTowerControl, faCircleDong, faBurgerCheese, faCheeseburger, faHandHoldingDroplet, faHandHoldingWater, faWonSign, faKrw, faWon, faObjectUngroup, faChartWaterfall, faComment, faSpaceStationMoon, faUpFromBracket, faCalendarCirclePlus, faTabletScreen, faTabletAndroidAlt, faSaltShaker, faFileCheck, faHillAvalanche, faArrowsToEye, faSnowplow, faShieldExclamation, faSquareW, faChartGantt, faCreditCardBlank, faHandsHoldingDollar, faHandsUsd, faBuildingMagnifyingGlass, faSquareA, faVideo, faVideoCamera, faFacePouting, faChessPawn, faUserHeadset, faSynagogue, faMug, faShirtJersey, faBuildingCircleCheck, faCalendarPlus, faWheelchairMove, faWheelchairAlt, faUserKey, faUserShield, faTally4, faBreadLoaf, faCircle0, faBold, faHeartPulse, faHeartbeat, faSquareRootVariable, faSquareRootAlt, faMessageCheck, faCommentAltCheck, faHandsBubbles, faHandsWash, faGuitars, faMarker, faUserHairLong, faTrafficLightGo, faHousePersonLeave, faHouseLeave, faHousePersonDepart, faDownUp, faClipboard, faPlaceOfWorship, faCannabis, faFaceZipper, faPeopleRoof, faPump, faSquareAmpersand, faDisease, faBookBible, faBible, faChessBoard, faSprinkler, faGunSquirt, faMugMarshmallows, faCircleHeart, faHeartCircle, faUserHatTieMagnifyingGlass, faDiagramSankey, faSunset, faCircleEquals, faMars, faUserVneckHairMullet, faLaptop, faUserXmark, faUserTimes, faFlagUsa, faHandMiddleFinger, faAlt, faMortarPestle, faBanana, faUmbrellaSimple, faUmbrellaAlt, faJoystick, faHeadSideCough, faPlaneLock, faBatteryThreeQuarters, faBattery4, faFrancSign, faTripleChevronsRight, faFilterCircleDollar, faFunnelDollar, faCheese, faCircleH, faHospitalSymbol, faBoxBallot, faLocationCheck, faMapMarkerCheck, faTilde, faCommentMiddle, faArrowLeftFromDottedLine, faUTurnLeftDown, faUTurn, faArrowDownFromBracket, faSchool, faEarMuffs, faClockSeven, faDiceFive, faTornado, faArrowLeftToLine, faArrowToLeft, faJetFighter, faFighterJet, faPersonBikingMountain, faBikingMountain, faThumbsDown, faFunction, faBroom, faDiscDrive, faGrill, faFileImport, faArrowRightToFile, faJug, faUtensils, faCutlery, faIdBadge, faSpider, faUserQuestion, faPersonFairy, faMobileRetro, faSignsPost, faMapSigns, faGroupArrowsRotate, faDiagramVenn, faArrowsSplitUpAndLeft, faImagePolaroidUser, faArrowUpLeft, faSquareAustralianDollar, faCarGarage, faPersonFromPortal, faPortalExit, faFillDrip, faShieldHeart, faTrashCanUndo, faTrashCanArrowTurnLeft, faTrashUndoAlt, faChampagneGlass, faGlassChampagne, faPersonSkiingNordic, faSkiingNordic, faDiagramCells, faSquare6, faSquare2, faArrowsToDottedLine, faHatBeach, faRouter, faSensor, faSquareCheck, faCheckSquare, faPaintbrushFine, faPaintBrushAlt, faPaintBrushFine, faPaintbrushAlt, faBath, faBathtub, faChessBishop, faFence, faMicrowave, faAlarmExclamation, faTomato, faPrescriptionBottleMedical, faPrescriptionBottleAlt, faWatchCalculator, faDrawPolygon, faVectorPolygon, faCircleGuarani, faSlider, faICursor, faCloudRainbow, faHeartCirclePlus, faShieldDog, faFileSlash, faChessRookPiece, faChessRookAlt, faGreaterThanEqual, faEnvelopeOpen, faMound, faRingsWedding, faGrillFire, faDistributeSpacingHorizontal, faBowlSoftServe, faVoicemail, faVest, faAudioDescription, faW, faCartCircleXmark, faCloudsSun, faEyeDropper, faEyeDropperEmpty, faEyedropper, faCircleXmark, faTimesCircle, faXmarkCircle, faTrailer, faTurkishLiraSign, faTry, faTurkishLira, faGaugeCircleMinus, faDrawSquare, faVectorSquare, faMountains, faTruckTow, faLocationMinus, faMapMarkerMinus, faShieldXmark, faShieldTimes, faFaceShush, faSquareEurozone, faHeadSideSpeak, faHouseDay, faVolcano, faWandSparkles, faFireFlame, faFlame, faBowlingBallPin, faMicrophone, faCrown, faTentArrowTurnLeft, faTruckFast, faShippingFast, faUserPen, faUserEdit, faSquareNorwegianKrone, faPersonSnowmobiling, faSnowmobile, faBurgerSoda, faRabbitRunning, faRabbitFast, faDialMax, faFaceHushed, faStocking, faCircleDanishKrone, faUserClock, faFaceDowncastSweat, faShieldPlus, faAccentGrave, faHeadphonesSlash, faHoodCloak, faFileOdf, faSquareArrowUp, faArrowSquareUp, faClockTenThirty, faSquare4, faShower, faSquareSterling, faFishingRod, faSquareCaretUp, faCaretSquareUp, faCircleArrowUpLeft, faBoxDollar, faBoxUsd, faTheta, faFaceSmileTongue, faFileVector, faVideoArrowUpRight, faMapLocation, faMapMarked, faTableCellsHeaderLock, faFaceIcicles, faPenFancy, faUserChef, faDropletPlus, faEuroSign, faEur, faEuro, faHouseCircleXmark, faLiraSign, faCirclePeso, faYenSign, faCny, faJpy, faRmb, faYen, faBoxOpen, faGolfFlagHole, faTruckField, faUTurnLeftUp, faCircleMill, faWhistle, faKerning, faLocationPinLock, faWavesSine, faPersonPraying, faPray, faLocationPlus, faMapMarkerPlus, faDiamondHalfStroke, faClipboardList, faObjectsAlignCenterVertical, faCandyBar, faChocolateBar, faBoothCurtain, faSackDollar, faMountainSun, faHockeyMask, faLocationSmile, faMapMarkerSmile, faTally3, faArrowDownFromLine, faArrowFromTop, faChartPyramid, faGoalNet, faLinkHorizontalSlash, faChainHorizontalSlash, faCarpool, faCarPeople, faArrowUpWideShort, faSortAmountUp, faArrowUpFromDottedLine, faUTurnRightUp, faHexagonImage, faUsersLine, faArrowUpRightAndArrowDownLeftFromCenter, faCameraViewfinder, faScreenshot, faStarOfDavid, faNotesMedical, faAustralSign, faFileChartPie, faFaceSadSweat, faClipboardUser, faCommentArrowDown, faFileImage, faFileMov, faPie, faUserPoliceHairLong, faBagel, faCartXmark, faSquareCaretRight, faCaretSquareRight, faUtensilsSlash, faVial, faHelicopter, faMitten, faFileMusic, faGasPump, faHelmetBattle, faMeat, faTrumpet, faBrowsers, faArrowDownLeft, faSquare1, faUserNurseHairLong, faTemperatureSun, faTemperatureHot, faGasPumpSlash, faEnvelopeCircleCheck, faFileGif, faPersonSkating, faSkating, faFaceAngryHorns, faSun, faDiploma, faScrollRibbon, faBaseball, faBaseballBall, faImage, faBoot, faCarBump, faMoneyBillSimple, faSquareArrowDown, faArrowSquareDown, faNotdef, faCommentQuestion, faUserRobot, faBasketball, faBasketballBall, faPencil, faPencilAlt, faPersonWalkingArrowLoopLeft, faBootHeeled, faDiceSix, faCircleEllipsis, faSwedishKronaSign, faArrowUpSquareTriangle, faSortShapesUpAlt, faAnglesDown, faAngleDoubleDown, faVan, faBatteryLow, faBattery1, faLacrosseStickBall, faSeatAirlineWindow, faAlarmSnooze, faSyringe, faShowerDown, faShowerAlt, faWheatAwn, faWheatAlt, faPlaneUp, faCircleUserCircleCheck, faBat, faAlignCenter, faHockeyPuck, faCircleArrowLeft, faArrowCircleLeft, faChartRadar, faArrowProgress, faWarehouseFull, faWarehouseAlt, faPenSwirl, faTruckLadder, faCommentImage, faPlugCircleBolt, faJeans, faGrid5, faPipeSection, faRestroom, faReflectBoth, faGearCode, faCurlingStone, faCurling, faAnchorLock, faTimeline, faBriefcaseBlank, faCoinFront, faCalendarStar, faPenCircle, faLightbulb, faPageCaretDown, faFileCaretDown, faBookBlank, faBookAlt, faTrashUndo, faTrashArrowTurnLeft, faSubtitles, faWaveTriangle, faFootWing, faGaugeCirclePlus, faFilmMusic, faHeadSide, faOctagonEquals, faChevronsLeft, faChevronDoubleLeft, faCircleArrowRight, faArrowCircleRight, faGameBoard, faFileChartColumn, faFileChartLine, faCustard, faBlockQuestion, faMarsAndVenus, faNetworkWired, faFaceConfused, faBuildingShield, faBedEmpty, faGrillHot, faEarWaveform, faCode, faFeatherPointed, faFeatherAlt, faBoxIsometricTape, faFileCircleQuestion, faFaceNoseSteam, faSignature, faEarthAmericas, faEarth, faEarthAmerica, faGlobeAmericas, faCarrot, faSparkles, faSquareL, faCauldron, faTemperatureFull, faTemperature4, faThermometer4, faThermometerFull, faTableCellsRowLock, faCircleUserCirclePlus, faBoltLightning, faCloudShowersWater, faArrowUpLong, faLongArrowUp, faFluxCapacitor, faAddressCard, faContactCard, faVcard, faStaff, faBasketShoppingMinus, faAngleRight, faToiletPaperUnder, faToiletPaperBlankUnder, faToiletPaperReverse, faToiletPaperReverseAlt, faStomach, faFaceCowboyHat, faFaceMeh, faMeh, faArrowUpFromGroundWater, faFacePleading, faEnvelopeCircleUser, faBarn, faMap, faUserPlus, faTurnDownLeft, faPlaneEngines, faPlaneAlt, faVenus, faUserDoctorMessage, faUserMdChat, faBarsSort, faHighDefinition, faRectangleHd, faCirclePeseta, faDitto, faSquareArrowDownRight, faPipeValve, faSquareS, faDiagramSuccessor, faHeadSideCoughSlash, faArrowsMaximize, faExpandArrows, faPlusLarge, faMugTea, faDiagramProject, faProjectDiagram, faTerminal, faEclipse, faHouseFire, faMask, faHurricane, faEarthAfrica, faGlobeAfrica, faThumbtack, faThumbTack, faSquareUp, faArrowAltSquareUp, faFaceTongueMoney, faHandPointDown, faFaceMehBlank, faMehBlank, faBowlHot, faSoup, faPartyHorn, faBells, faTemperatureEmpty, faTemperature0, faThermometer0, faThermometerEmpty, faPopcorn, faBorderLeft, faBorderNone, faHighlighter, faPalletBox, faStarExclamation, faSickle, faMoneyBillWave, faPlaneTail, faToiletPaperSlash, faSirenOn, faFileShield, faWhiskeyGlassIce, faGlassWhiskeyRocks, faSquid, faTextHeight, faMoneyCheckDollarPen, faMoneyCheckEditAlt, faHandWave, faChartCandlestick, faTransporter4, faPanFood, faEurozoneSign, faFaceGrinTongue, faGrinTongue, faPotato, faFileSignature, faSquareDashed, faSteak, faAxeBattle, faCircleQuarterStroke, faPhoneHangup, faSquareHeart, faHeartSquare, faConveyorBelt, faBoxCheck, faBlanketFire, faSquare9, faBuildingWheat, faPlugCircleMinus, faBookSpine, faHockeySticks, faDownLongToLine, faColon, faFutbol, faFutbolBall, faSoccerBall, faFaceHandOverMouth, faCirclePlus, faPlusCircle, faCoffeePot, faSquareQuestion, faQuestionSquare, faListTree, faBrazilianRealSign, faBookOpenLines, faEllipsisStrokeVertical, faEllipsisVAlt, faStarAndCrescent, faTextSize, faFaceSurprise, faSurprise, faHospitalUser, faArrowDownUpLock, faFolder, faFolderBlank, faHollyBerry, faMessageImage, faCommentAltImage, faCommentQuote, faVenusDouble, faElephant, faClipboardQuestion, faHotdog, faArrowUpFromBracket, faReplyClock, faReplyTime, faChartLineUp, faMicroscope, faCatSpace, faCircleExclamationCheck, faCards, faCloud, faAlbumCirclePlus, faBaseballBatBall, faCarRear, faCarAlt, faWindsock, faFaceWorried, faMicrophoneCircleXmark, faMessageLines, faCommentAltLines, faThumbtackSlash, faThumbTackSlash, faBoxArrowDown, faPlusMinus, faHouseCircleCheck, faFaceWoozy, faCrateApple, faAppleCrate, faCalendarDay, faCircle, faNotebook, faOctagonXmark, faTimesOctagon, faXmarkOctagon, faRacquet, faMobileVibrate, faFaceGrinSquint, faGrinSquint, faTreeDeciduous, faTreeAlt, faUsersBetweenLines, faMango, faCrosshairsSimple, faPipeSmoking, faCoconut, faFaceDiagonalMouth, faStarSharpHalf, faMessageWaveform, faMusicMagnifyingGlass, faHouseMedicalCircleXmark, faClub, faFireSmoke, faTableList, faThList, faFlaskVial, faLuchadorMask, faLuchador, faMaskLuchador, faCircleExclamation, faExclamationCircle, faBlockBrick, faWallBrick, faArrowUTurnRightUp, faTaxi, faCab, faTextSlash, faRemoveFormat, faPeoplePulling, faBackward, faSpade, faDreidel, faCarBurst, faCarCrash, faCommentMinus, faSquareF, faChessQueenPiece, faChessQueenAlt, faTurnLeftDown, faLink, faChain, faChartLineDown, faBackwardStep, faStepBackward, faClockOne, faDiceD4, faX, faCircleUser, faUserCircle, faRectangleList, faListAlt, faCircleWifi, faHand, faHandPaper, faLassoSparkles, faArrowUpFromSquare, faCircleR, faPolishZlotySign, faPhoneConnection, faSnooze, faZzz, faUserDoctorHairMullet, faPanFrying, faVanShuttle, faShuttleVan, faStairs, faShuttlecock, faCoinVertical, faCircleTurkishLira, faSheep, faHorseHead, faCircleCalendar, faCalendarCircle, faVault, faClosedCaptioningSlash, faDrumSteelpan, faThumbsUp, faEngine, faUserAlien, faRectangleHistory, faRectangleMinus, faStamp, faTripleChevronsUp, faMenorah, faTurnLeft, faSquareWon, faMalaysianRinggitSign, faPresentationScreen, faPresentation, faCameraMovie, faSquareCurrency, faHatChef, faChildren, faSnowBlowing, faAlbumCollection, faChartLine, faLineChart, faCircleUpLeft, faEnvelopeRibbon, faEnvelopeCertificate, faTire, faAustralianDollarSign, faSquareEnvelope, faEnvelopeSquare, faObjectExclude, faUserGroupCrown, faUsersCrown, faBanSmoking, faSmokingBan, faUserVisor, faBarProgressHalf, faTruckFront, faBlindsOpen, faBuilding, faBullseye, faAlbumCircleUser, faArrowLeftLong, faLongArrowLeft, faSwapArrows, faChessRook, faBlenderPhone, faArrowTurnUp, faLevelUp, faShelvesEmpty, faNote, faPenField, faCorn, faPianoKeyboard, faFaceTongueSweat, faBicycle, faMoneySimpleFromBracket, faUserTieHairLong, faBadge, faTruckUtensils, faFileBracketsCurly, faCircleArrowDown, faArrowCircleDown, faPeruvianSolesSign, faTripleChevronsLeft, faGear, faCog, faFilms, faWalker, faSquareArrowRight, faArrowSquareRight, faFaceParty, faMarsAndVenusBurst, faColumns3, faOtter, faArrowUTurnRightDown, faCircle9, faSneakerRunning, faCircleChevronLeft, faChevronCircleLeft, faCircleQuestion, faQuestionCircle, faArrowRotateRight10, faWalkieTalkie, faUserGroup, faUserFriends, faBedFront, faBedAlt, faHouseChimney, faHomeLg, faRightFromBracket, faSignOutAlt, faPeanuts, faTriangleInstrument, faTriangleMusic, faBowlSpoon, faFile, faPlaneSlash, faIndustryWindows, faIndustryAlt, faCloudShowersHeavy, faBedBunk, faPersonFalling, faSquareChevronDown, faChevronSquareDown, faButter, faTurnDown, faLevelDownAlt, faVolumeSlash, faUpRightAndDownLeftFromCenter, faExpandAlt, faUserTag, faSquare0, faInboxIn, faInboxArrowDown, faKettlebell, faGlobeSnow, faHandSparkles, faFilePpt, faArrowsToDot, faFaceSadCry, faSadCry, faImageSlash, faTrophyStar, faTrophyAlt, faDongSign, faSquareCent, faPeopleLine, faSquareRss, faRssSquare, faIslandTropical, faIslandTreePalm, faClockTwelve, faCalendarMinus, faChartDiagram, faBallotCheck, faChfSign, faCalendarImage, faDownRight, faCalendarCircleUser, faCircleShareNodes, faFaceTired, faTired, faDiagramPrevious, faFaceAstonished, faIceSkate, faArrowUTurnLeftUp, faLaptopArrowDown, faUserCirclePlus, faRaygun, faHandPointRight, faConveyorBeltEmpty, faArrowRightFromArc, faSignalStreamSlash, faCourtSport, faTrainTrack, faUserMicrophone, faCars, faNfcPen, faArrowUp, faXmarkLarge, faCubesStacked, faChildCombatant, faChildRifle, faSquareG, faVestPatches, faImageCirclePlus, faMartiniGlassEmpty, faGlassMartini, faCircleLari, faKidneys, faBracketsCurly, faPersonSoccer, faDiamondExclamation, faMagnet, faRoadBarrier, faCompassDrafting, faDraftingCompass, faRectangle, faRectangleLandscape, faHandHoldingSkull, faSquarePersonConfined, faGrid, faGrid3, faCabinetFiling, faPlateWheat, faRectangleVerticalHistory, faSignHanging, faSign, faCircle8, faCarBattery, faBatteryCar, faShirt, faTShirt, faTshirt, faParagraph, faEnvelopesBulk, faMailBulk, faFileDoc, faGuitar, faFlyingDisc, faSuitcase, faCircleUp, faArrowAltCircleUp, faF, faXmarksLines, faHashtagLock, faGarageOpen, faGasPumpLeft, faPumpImpeller, faBasketShoppingPlus, faHandFingersCrossed, faBrainArrowCurvedRight, faMindShare, faPersonSign, faCircleTrash, faTrashCircle, faEarthOceania, faGlobeOceania, faUTurnUpLeft, faCommentSlash, faPlay, faUserDashed, faHouseWindow, faVialCircleCheck, faBridgeCircleCheck, faCediSign, faHatSanta, faPuzzlePiece, faHelmetUn, faGlassWater, faPenFancySlash, faHeartCircleBolt, faFireHydrant, faMemoCircleCheck, faPumpSoap, faHandScissors, faSandwich, faDolly, faDollyBox, faPaperclip, faMeterFire, faDemocrat, faSquareArrowUpRight, faExternalLinkSquare, faSquareExclamation, faExclamationSquare, faWave, faFerry, faMosquito, faHexagonMinus, faMinusHexagon, faBuildingCircleArrowRight, faFaceHandPeeking, faArrowLeftFromLine, faArrowFromRight, faLeftRight, faArrowsAltH, faSignalBarsWeak, faSignalAlt1, faAirplayAudio, faLightbulbGear, faGrid2Minus, faRectangleTerminal, faSquareDownLeft, faMailboxOpenLetter, faPepper, faMoonStars, faClockFive, faCorner, faVirus, faNorwegianKroneSign, faGem, faToilet, faBurgerFries, faPaperclipVertical, faShirtLongSleeve, faTrashCanCheck, faSingleQuoteLeft, faArrowUTurnDownRight, faMoneyBills, faCarCircleBolt, faTabletButton, faRectangleHighDynamicRange, faRectangleHdr, faSquareYen, faSquareArrowDownLeft, faBulldozer, faCalendarPen, faCalendarEdit, faBellOn, faExcavator, faRectangleXmark, faRectangleTimes, faTimesRectangle, faWindowClose, faWrench, faMessageSlash, faCommentAltSlash, faMace, faWatch, faTally1, faTrashCan, faTrashAlt, faPuzzle, faTableCells, faTh, faTrashCanList, faRibbon, faLandmarkFlag, faBadminton, faUpToBracket, faChartLineUpDown, faUpDownLeftRight, faArrowsAlt, faGarageEmpty, faCarSide, faTrashArrowUp, faTrashRestore, faLifeRing, faBarProgressThreeQuarters, faCopyright, faLeafyGreen, faHighlighterLine, faRectangleHistoryCircleUser, faFerrisWheel, faArrowUpFromArc, faGridDividers, faLightbulbDollar, faCoffin, faFilePrescription, faEraser, faFlaskRoundPoison, faFlaskPoison, faCameraClock, faCircleHalfHorizontal, faSquareT, faCircleShekel, faSpaceStationMoonConstruction, faSpaceStationMoonAlt, faCircleMoon, faBasketballHoop, faCodeSimple, faLeftToDottedLine, faHockeyStickPuck, faHourglassStart, faHourglass1, faCircleLeft, faArrowAltCircleLeft, faRestroomSimple, faCruzeiroSign, faSmoking, faChartPieSimpleCircleDollar, faUserVneckHair, faSquarePollVertical, faPoll, faPersonCircleMinus, faEnvelopeOpenDollar, faBiohazard, faObjectsAlignBottom, faScrollOld, faBellConcierge, faConciergeBell, faRulerHorizontal, faHorse, faAngle90, faDownToBracket, faBookCopy, faCalendar, faHandsHoldingChild, faPollPeople, faBracketRound, faParenthesis, faTruckContainer, faEyeEvil, faPlayFlip, faBorderInner, faItalic, faMicrophoneCirclePlus, faDownToLine, faArrowAltToBottom, faCircleCruzeiro, faCloudBinary, faCardClub, faLightSwitchOn, faTruckSuv, faKhanda, faFaceFrownOpen, faFrownOpen, faCheck, faBowArrow, faBanBug, faDebug, faArrowDownFromDottedLine, faFingerprint, faBowlScoop, faBowlShavedIce, faChargingStation, faPlaneUpSlash, faUserLock, faMobileScreenButton, faMobileAlt, faOlive, faAnchorCircleCheck, faRectangle4k, faScalpel, faPersonWalkingWithCane, faBlind, faCandleHolder, faFileWaveform, faFileMedicalAlt, faRenminbiSign, faFaceSpiralEyes, faCalendarArrowUp, faCalendarUpload, faPersonArmsRaised, faPersonDressFairy, faBarProgress, faChartKanban, faCloudMusic, faWatchSmart, faLeftToBracket, faGrateDroplet, faHouseCrack, faWifiSlash, faHatWizard, faFootballHelmet, faUserDoctor, faUserMd, faGlassesRound, faGlassesAlt, faRocketLaunch, faHandHoldingCircleDollar, faChartBar, faBarChart, faMessageDollar, faCommentAltDollar, faVideoDownToLine, faSprayCanSparkles, faAirFreshener, faBahtSign, faFaceBeamHandOverMouth, faTemperatureArrowUp, faTemperatureUp, faWebAwesome, faNonBinary, faShieldSlash, faFloppyDisks, faN, faArrowsUpDownLeftRight, faArrows, faHouse, faHome, faHomeAlt, faHomeLgAlt, faSpinner, faSquareY, faSquareMill, faGavel, faLegal, faCircleTugrik, faTrashClock, faCirclePhone, faPhoneCircle, faBoltAuto, faUserPilotTieHairLong, faArrowTurnLeftDown, faTicketSimple, faTicketAlt, faDove, faCircleYen, faTarpDroplet, faBroomWide, faPlayPause, faTreeCity, faCalendarRange, faTurnUp, faLevelUpAlt, faCreditCardFront, faTemperatureQuarter, faTemperature1, faThermometer1, faThermometerQuarter, faChestnut, faCrystalBall, faFlagSwallowtail, faFlagAlt, faSliders, faSlidersH, faPersonSledding, faSledding, faMosque, faFolderMagnifyingGlass, faFolderSearch, faLinkHorizontal, faChainHorizontal, faH, faMessageBot, faInfo, faPersonWalking, faWalking, faRadioTuner, faRadioAlt, faComputerMouseScrollwheel, faMouseAlt, faCarSirenOn, faUpRight, faPaintbrushSlash, faCircleArrowUpRight, faArrowTurnDown, faLevelDown, faRoad, faBuoy, faSpiral, faPaintbrushPencil, faFileCad, faPeoplePantsSimple, faFaceFrown, faFrown, faWineGlassEmpty, faWineGlassAlt, faClapperboard, faOilCanDrip, faPhonePlus, faForwardStep, faStepForward, faFileDashedLine, faPageBreak, faScribble, faGaugeMin, faTachometerAltSlowest, faSquareUpRight, faExternalLinkSquareAlt, faWifiExclamation, faBookJournalWhills, faJournalWhills, faOctagonMinus, faMinusOctagon, faChampagneGlasses, faGlassCheers, faFolderXmark, faFolderTimes, faTrashList, faDumpster, faCircleEnvelope, faEnvelopeCircle, faMobileNotch, faMobileIphone, faMobileSignal, faHeartCircleXmark, faComputer, faWandMagic, faMagic, faBrain, faPeoplePants, faDialpad, faBriefcaseMedical, faSmoke, faHouseMedicalCircleExclamation, faFaceMonocle, faLineColumns, faFaceVomit, faPersonDolly, faCodeCommit, faPersonBreastfeeding, faSquareBaht, faPersonRays, faWaterArrowDown, faWaterLower, faSymbols, faIconsAlt, faChartMixedUpCircleCurrency, faManatSign, faBagSeedling, faSort, faUnsorted, faCircleRadiation, faRadiationAlt, faLaptopCode, faSink, faTableCellsRows, faArrowUpFromWaterPump, faMicrophoneLinesSlash, faMicrophoneAltSlash, faFaceShakingVertical, faBrowser, faFaceSleepy, faServer, faUser, faUserAlt, faUserLarge, faSignalBars, faSignalAlt, faSignalAlt4, faSignalBarsStrong, faStarshipFreighter, faSnowflake, faDialMed, faSkullCrossbones, faPesoSign, faWineGlass, faTemperatureHalf, faTemperature2, faThermometer2, faThermometerHalf, faChartTreeMap, faTicket, faNfcSymbol, faShieldUser, faTireRugged, faWheatAwnCircleExclamation, faCircleL, faArrowsTurnRight, faRouteInterstate, faCandyCane, faCircle6, faCitrus, faWheelchair, faExpandWide, faSpellCheck, faTurnDownRight, faVolumeOff, faSaxophone, faSensorTriangleExclamation, faSensorAlert, faLungs, faCarWrench, faCarMechanic, faPopsicle, faBookmark, faBarcode, faWheatAwnSlash, faListOl, faList12, faListNumeric, faTypewriter, faFileCircleXmark, faInboxOut, faInboxArrowUp, faCube, faTape, faBomb, faCameraWeb, faWebcam, faLacrosseStick, faDisplayChartUp, faTrashSlash, faSdCards, faScaleUnbalanced, faBalanceScaleLeft, faCircleMalaysianRinggit, faBookCircleArrowRight, faSquareCaretLeft, faCaretSquareLeft, faRuler, faCardsBlank, faI, faCircleNorwegianKrone, faAirplay, faVolumeXmark, faVolumeMute, faVolumeTimes, faArchway, faPersonDigging, faDigging, faGaugeHigh, faTachometerAlt, faTachometerAltFast, faSquareHalf, faGenderless, faClockTen, faWireless, faSquareAustral, faCloudSun, faArrowRight, faSquareInfo, faInfoSquare, faHandshake, faHandshakeAlt, faHandshakeSimple, faCloudQuestion, faPersonSkiing, faSkiing, faBridgeWater, faBuildingNgo, faMoped, faGridRound2, faIgloo, faChessKnightPiece, faChessKnightAlt, faHandHoldingMagic, faCircleDollarToSlot, faDonate, faUserTieHairMullet, faAwardSimple, faConveyorBeltBoxes, faConveyorBeltAlt, faFileSvg, faY, faFaceSmileWink, faSmileWink, faCircleManat, faDiceFour, faFileMinus, faArrowLeftToArc, faCarTilt, faCloudBoltSun, faThunderstormSun, faFaceGrinSquintTears, faGrinSquintTears, faSnowflakes, faPretzel, faGlass, faTripleChevronsDown, faFileAudio, faSquareFranc, faArrowsDownToLine, faMobileSlash, faVideoArrowDownLeft, faRightLongToLine, faG, faVihara, faFlagCheckered, faBriefcaseArrowRight, faHeartHalfStroke, faHeartHalfAlt, faCommentCaptions, faGaugeSimple, faGaugeSimpleMed, faTachometerAverage, faShredder, faFonduePot, faRightLeft, faExchangeAlt, faPlanetRinged, faPills, faExplosion, faArrowsDownToPeople, faUsersViewfinder, faMusicNote, faMusicAlt, faCarOn, faCircleCamera, faCameraCircle, faSunBright, faSunAlt, faBatteryBolt, faMushroom, faGlobeWifi, faArrowRotateLeft10, faSleigh, faArrowDownLeftAndArrowUpRightToCenter, faPersonSwimmingWater, faDialHigh, faDumbbell, faBabyCarriage, faCarriageBaby, faClouds, faCameraCctv, faCctv, faBuildings, faRectangleBarcode, faBarcodeAlt, faTruckFire, faArrowDownBigSmall, faSortSizeDown, faHandLove, faBagShoppingMinus, faClockElevenThirty, faSlashForward, faPineapple, faFacePersevering, faCardDiamond, faRaccoon, faFolderBookmark, faKeySkeletonLeftRight, faCircleI, faKiwiBird, faCalendarXmark, faCalendarTimes, faCircleDown, faArrowAltCircleDown, faFileMedical, faXmark, faClose, faMultiply, faRemove, faTimes, faShapes, faTriangleCircleSquare, faDiceOne, faKnifeKitchen, faArrowsCross, faCompassSlash, faLockOpen, faPepperHot, faDropletSlash, faTintSlash, faDroplet, faTint, faPersonMeditating, faFileLines, faFileAlt, faFileText, faCommentsDollar, faPersonGolfing, faTrashCheck, faMagnifyingGlassLocation, faSearchLocation, faFloppyDiskCircleArrowRight, faSaveCircleArrowRight, faMagnifyingGlassPlay, faFileInvoice, faPentagon, faPhoneOffice, faTreePalm, faOnion, faValueAbsolute, faRepublican, faShop, faStoreAlt, faFilm, faFilmAlt, faFilmSimple, faWashingMachine, faWasher, faBuildingCircleXmark, faComments, faTags, faFileSpreadsheet, faGun, faNestingDolls, faDial, faDialMedHigh, faTruckFlatbed, faPenNibSlash, faCircleCheck, faCheckCircle, faHouseTree, faUserPilot, faBracketSquare, faBracket, faBracketLeft, faUserPilotHairLong, faIdCardClip, faIdCardAlt, faMoon, faCaretLargeUp, faLamp, faMobileArrowDown, faFilePlus, faImageUser, faTurnRight, faHexagonVerticalNft, faHexagonVerticalNftSlanted, faSkullCow, faOilWell, faRhombus, faSquareLari, faCircleUserCircleXmark, faApartment, faUserBountyHunter, faSeat, faEyeDropperHalf, faCommentCode, faTachographDigital, faDigitalTachograph, faHandBackPointRibbon, faLaptopBinary, faTablet, faTabletAndroid, faRubleSign, faRouble, faRub, faRuble, faClosedCaptioning, faInterrobang, faPen, faPalletBoxes, faPaletteBoxes, faPalletAlt, faPlane, faBookArrowRight, faImages, faMobileScreen, faMobileAndroidAlt, faGuaraniSign, faBagShopping, faShoppingBag, faCircleAustral, faCircleRight, faArrowAltCircleRight, faPersonRunningFast, faCloudSleet, faPiano, faPhoneVolume, faVolumeControlPhone, faCubes, faFileMagnifyingGlass, faFileSearch, faPhone, faHexagonCheck, faUserBeardBolt, faToriiGate, faDiceD8, faClockNine, faFileMp3, faUserTieHair, faSquareIndianRupee, faCoffinCross, faBacon, faImagesUser, faPersonFallingBurst, faCaduceus, faQuoteRight, faQuoteRightAlt, faHouseMedicalFlag, faPrescription, faFaceWeary, faUpLeft, faHandBackPointUp, faRectangleHistoryCirclePlus, faPersonWaterArmsRaised, faBeerMug, faBeerFoam, faDiceThree, faLasso, faFileAiff, faBuildingLock, faIdCard, faDriversLicense, faSquareRuble, faClockDesk, faCirclePlay, faPlayCircle, faFaceLaughBeam, faLaughBeam, faLeaf, faHouseChimneyUser, faRotateRight, faRedoAlt, faRotateForward, faBooksMedical, faDress, faTooth, faHouseChimneyWindow, faSquareEllipsis, faMotorcycle, faGridRound2Minus, faShieldMinus, faBackwardFast, faFastBackward, faDollyEmpty, faAddressBook, faContactBook, faCloudsMoon, faCarBuilding, faFaceAwesome, faGaveDandy, faBlinds, faSailboat, faArrowUpLeftFromCircle, faRightFromDottedLine, faBookBookmark, faSquareBrazilianReal, faMagnifyingGlassArrowRight, faSplit, faFacePensive, faBookCircleArrowUp, faShipLarge, faHeartHalf, faCircleLira, faMicrophoneLines, faMicrophoneAlt, faReplyAll, faMailReplyAll, faSquareList, faUniversalAccess, faShieldCross, faTrainStop, faToiletPaper, faToiletPaperAlt, faToiletPaperBlank, faSquareCode, faVrCardboard, faPizzaSlice, faSprayCan, faNfcTrash, faTemperatureList, faShovelSnow, faVolumeLow, faVolumeDown, faSolarSystem, faCross, faPerson, faMale, faMp3Player, faCircleBolt, faHourglass, faHourglassEmpty, faTrashCanSlash, faTrashAltSlash, faUserBeard, faFish, faDrumstickBite, faFileJpg, faChartSimple, faCircleEllipsisVertical, faAtom, faSquareMalaysianRinggit, faPrintMagnifyingGlass, faPrintSearch, faImagePolaroid, faSquareTerminal, faLightbulbMessage, faPersonLimbsWide, faHandsHoldingDiamond, faHandReceiving, faCircleJ, faPedestal, faP, faSquareEquals, faDagger, faJetFighterUp, faFieldHockeyStickBall, faFieldHockey, faComputerMouseButtonRight, faPlugCircleXmark, faSheetPlastic, faV, faList, faListSquares, faOliveBranch, faGif, faHoseReel, faCircleS, faSquareM, faCircleCaretLeft, faCaretCircleLeft, faCircleQuarters, faSolarPanel, faLandMineOn, faBallot, faGiftCard, faCircleUserCircleQuestion, faHeadphones, faHeadphonesAlt, faHeadphonesSimple, faBus, faFilePowerpoint, faMessages, faCommentsAlt, faCircleRuble, faBarcodeRead, faQuoteLeft, faQuoteLeftAlt, faScreencast, faSkiBoot, faFamilyPants, faEyeDropperFull, faChevronDown, faEarthAsia, faGlobeAsia, faCentSign, faComputerMouseButtonLeft, faShieldCat, faSchoolCircleCheck, faMartiniGlass, faGlassMartiniAlt, faUserUnlock, faPlug, faSpinnerThird, faWindWarning, faWindCircleExclamation, faPanorama, faClockRotateLeft, faHistory, faWifiWeak, faWifi1, faWaveform, faVideoQuestion, faTicketAirline, faTicketPerforatedPlane, faTicketPlane, faArrowUTurnUpRight, faLinkSimple, faRectangleWide, faPig, faJarWheat, faBookmarkSlash, faFileBan, faArrowUpRight, faSquareV, faCloudArrowDown, faCloudDownload, faCloudDownloadAlt, faKeyboardLeft, faBadgeCheck, faTruckRampBox, faTruckLoading, faFaceDotted, faCircle1, faOctopus, faAngleDown, faSquareKanban, faCircleThreeQuartersStroke, faPlugCircleCheck, faCameraShutter, faWindowMaximize, faTvMusic, faHandsHoldingCircle, faWreath, faLocationPin, faMapMarker, faBowlingBall, faCartFlatbed, faDollyFlatbed, faHouseUser, faHomeUser, faBrainCircuit, faSquareaporeDollar, faEnvelopes, faEscalator, faGhost, faShorts, faFloppyDiskCircleXmark, faFloppyDiskTimes, faSaveCircleXmark, faSaveTimes, faBallYarn, faDisplayCode, faDesktopCode, faBalloons, faCommentNodes, faTreeChristmas, faPersonArrowDownToLine, faPlugCirclePlus, faPersonSwimming, faSwimmer, faCommentDots, faCommenting, faChartPie, faPieChart, faShirtRunning, faBusSchool, faPhoneArrowRight, faListMusic, faLeafHeart, faChartBullet, faFaceSmileHearts, faCalendarArrowDown, faCalendarDownload, faMobileSignalOut, faFrog, faWrenchSimple, faWineBottle, faPancakes, faInbox, faBoltSlash, faStarShooting, faHorizontalRule, faCloudBoltMoon, faThunderstormMoon, faNfcSlash, faSquareH, faHSquare, faHouseMedical, faCircleChevronRight, faChevronCircleRight, faFileCsv, faHatCowboy, faFaceGrinTongueWink, faGrinTongueWink, faShelves, faInventory, faHexagonExclamation, faArrowsRepeat1, faRepeat1Alt, faL, faPhoneMissed, faArrowDownShortWide, faSortAmountDesc, faSortAmountDownAlt, faHourglassHalf, faHourglass2, faScalpelLineDashed, faScalpelPath, faCloudSnow, faSquareDownRight, faSpoon, faUtensilSpoon, faClockEleven, faCreditCard, faCreditCardAlt, faFileInvoiceDollar, faViolin, faSpaghettiMonsterFlying, faPastafarianism, faMartiniGlassCitrus, faCocktail, faChartMixedUpCircleDollar, faSquareRupee, faClockOneThirty, faBullhorn, faBoxTissue, faDoNotEnter, faAngle, faHouseUnlock, faMattressPillow, faMessageDot, faCricketBatBall, faCricket, faChevronLeft, faCloudMoonRain, faArrowDown19, faSortNumericAsc, faSortNumericDown, faBinBottlesRecycle, faBringFront, faSeatAirline, faSquareTenge, faHandSpock, faWandMagicSparkles, faMagicWandSparkles, faPanelEws, faCommentMedical, faBellSlash, faHandshakeSlash, faHandshakeAltSlash, faHandshakeSimpleSlash, faPizza, faBottleWater, faUserPoliceTieHairLong, faFolders, faSunDust, faDiceD20, faFolderGear, faFolderCog, faAlmostEqualTo, faArrowDownZA, faSortAlphaDesc, faSortAlphaDownAlt, faBrush, faPersonWalkingDashedLineArrowRight, faArrowUpShortWide, faSortAmountUpAlt, faGripVertical, faGridVertical, faCarTunnel, faChartColumn, faSendBack, faCommentArrowUpRight, faTruckArrowRight, faTv, faTelevision, faTvAlt, faSection, faParagraphLeft, faParagraphRtl, faTreeDecorated, faBinBottles, faPeace, faStar, faStoreLock, faFlag, faSquareE, faTriangleExclamation, faExclamationTriangle, faWarning, faFaceSmirking, faCodePullRequestDraft, faSchoolCircleExclamation, faGraduationCap, faMortarBoard, faCloudHail, faArrowRightFromLine, faArrowFromLeft, faStore, faUserAstronaut, faCabin, faBuildingFlag, faWifiFair, faWifi2, faMugSaucer, faCoffee, faLemon, faCirclePhoneHangup, faPhoneCircleDown, faCommentCheck, faFilterList, faCaravan, faLeafOak, faQ, faLock, faPaintRoller, faVolumeHigh, faVolumeUp, faFaceTissue, faFolderPlus, faRefrigerator, faNfc, faDirectionUpDown, faUserGroupSimple, faMercury, faMessageQuote, faCommentAltQuote, faMailboxFlagUp, faTruckClock, faShippingTimed, faAnchor, faDisplayArrowDown, faCircleK, faSoftServe, faCreemee, faHeat, faSquareParking, faParking, faHanukiah, faRotateLeft, faRotateBack, faRotateBackward, faUndoAlt, faCakeSlice, faShortcake, faHeading, faHeader, faLambda, faTrainTunnel, faCartMinus, faFaceThinking, faFaceEyesXmarks, faMagnifyingGlassMusic, faCalendarLinesPen, faCrosshairs, faCircleNodes, faWindowRestore, faR, faFilterCircleXmark, faMicrochipAi, faCircleQuarter, faGopuram, faAnt, faHydra, faHeartCircleMinus, faStarOfLife, faBoombox, faBusinessTime, faBriefcaseClock, faFireExtinguisher, faArrowDownLong, faLongArrowDown, faClockThreeThirty, faObjectSubtract, faTicketsSimple, faUserMinus, faCircleBitcoin, faMoneyCheck, faVideoPlus, faHouseLaptop, faLaptopHouse, faDownload, faHandHoldingStar, faInputNumeric, faCouch, faGaugeSimpleMax, faTachometerFastest, faBoxMagnifyingGlass, faRoadLock, faPersonSwimmingPool, faCanFood, faCircleX, faSquareHalfHorizontal, faUserRobotXmarks, faScissors, faCut, faBug, faArrowRightFromBracket, faSignOut, faFileZip, faCupcake, faHandHoldingHand, faMicrophoneSignalMeter, faStroopwafel, faChild, faIceCream, faComputerMouse, faMouse, faCircleA, faFaucet, faFaceSmileHorns, faAward, faPersonDrowning, faArrowUpToArc, faSchoolUnlock, faNoteMedical, faTransporter3, faPostageStamp, faSnowflakeDroplets, faCameraRotate, faLoader, faFileMidi, faUserHoodie, faFaceGrinHearts, faGrinHearts, faFileFragment, faLoveseat, faCouchSmall, faPersonMilitaryRifle, faToggleOn, faArrowUpToLine, faArrowToTop, faPompebled, faLungsVirus, faTableTennisPaddleBall, faPingPongPaddleBall, faTableTennis, faBoxesPacking, faSidebarFlip, faBookFont, faHose, faTreeLarge, faHearts, faFaceFrownSlight, faPersonChalkboard, faDiceTwo, faTransformerBolt, faArrowRightArrowLeft, faExchange, faFootball, faFootballBall, faTruckMonster, faTaco, faMaskSnorkel, faArrowUpFromLine, faArrowFromBottom, faAsterisk, faClothesHanger, faBarProgressFull, faBatteryFull, faBattery, faBattery5, faChildDress, faFaceKissBeam, faKissBeam, faTaxiBus, faSquareArrowUpLeft, faTrashCanArrowUp, faTrashRestoreAlt, faFont, faFaceKissClosedEyes, faBoreHole, faFilmStack, faVirusCovid, faLeft, faArrowAltLeft, faGaugeCircleBolt, faRectanglesMixed, faBracketsRound, faParentheses, faOmega, faBlindsRaised, faFilePdf, faLanguage, faShieldHalved, faShieldAlt, faCircleTenge, faFork, faUtensilFork, faUserHair, faCircleF, faCaretUp, faPersonSeat, faPegasus, faFilePen, faFileEdit, faPersonBiking, faBiking, faBookOpenReader, faBookReader, faCircleStar, faStarCircle, faPhoneXmark, faGlassWaterDroplet, faScrubber, faGunSlash, faArrowUpLongToLine, faCameraWebSlash, faWebcamSlash, faObjectsColumn, faTowerBroadcast, faBroadcastTower, faTurkey, faSword, faHeadSideGoggles, faHeadVr, faMinimize, faCompressArrowsAlt, faArrowRightToCity, faLaptopMedical, faBreadSlice, faSpiderWeb, faUserNurseHair, faGlobe, faDiceD12, faLocationDotSlash, faMapMarkerAltSlash, faFolderMinus, faMaskFace, faBong, faCupTogo, faCoffeeTogo, faRoadBridge, faArrowUp91, faSortNumericUpAlt, faMountainCity, faArrowDown91, faSortNumericDesc, faSortNumericDownAlt, faMoneyBillsSimple, faMoneyBillsAlt, faFaceGrinWide, faGrinAlt, faCirclePeruvianSoles, faArrowsToLine, faSquareRenminbi, faTurntable, faCrab, faAngel, faLocationPen, faMapMarkerEdit, faTicketsPerforated, faSquareRupiah, faTrashXmark, faRv, faFaceZany, faPoop, faBarsFilter, faHouseChimneyHeart, faBowlScoops, faDharmachakra, faClockTwelveThirty, faBoxingGlove, faGloveBoxing, faJeansStraight, faSpeaker, faDiceD10, faRam, faBatteryQuarter, faBattery2, faBasketShoppingSimple, faShoppingBasketAlt, faMonitorWaveform, faMonitorHeartRate, faCommentWaveform, faAnkh, faDiamond, faSubscript, faSquareRight, faArrowAltSquareRight, faCircleNaira, faComputerClassic, faRupeeSign, faRupee, faPersonRifle, faOctagonExclamation, faPipeCollar, faBrightnessLow, faPlaneFlying, faFaceSmileRelaxed, faImageCircleCheck, faMessagesQuestion, faD, faCircleFranc, faUpToDottedLine, faKiwiFruit, faGridRound, faStarship, faClockTwoThirty, faSquareNfi, faDroneFront, faDroneAlt, faTeeth, faMagnifyingGlassDollar, faSearchDollar, faDumpsterFire, faCircleHryvnia, faEggFried, faLineHeight, faArrowRightFromDottedLine, faUpload, faGingerbreadMan, faFilterSlash, faUserSlash, faUserAltSlash, faUserLargeSlash, faArrowLeft, faVialVirus, faCheckDouble, faSwords, faTransporter5, faSquareSliders, faSlidersHSquare, faCircleSortUp, faSortCircleUp, faPaw, faHelmetSafety, faHardHat, faHatHard, faUserCircleMinus, faE, faFaceLaughSquint, faLaughSquint, faPear, faFileTex, faDownLeftAndUpRightToCenter, faCompressAlt, faPuzzlePieceSimple, faPuzzlePieceAlt, faGifts, faArrowLeftToDottedLine, faHospitals, faBed, faWindowFlip, faWindowAlt, faMoneyBillTransfer, faPersonRunning, faRunning, faCircleChevronDown, faChevronCircleDown, faManhole, faUserNurse, faHeartSlash, faArrowsRepeat, faRepeatAlt, faWaffle, faArrowLeftFromArc, faSquareDivide, faCircleE, faFaceKissWinkHeart, faKissWinkHeart, faFill, faHorseshoe, faUserDoctorHair, faSensorFire, faMoneyBill1Wave, faMoneyBillWaveAlt, faLandmark, faCommentMusic, faHammerCrash, faSwordLaser, faMusic, faFiles, faNotesSticky, faMessageArrowUpRight, faBookMedical, faMusicNoteSlash, faMusicAltSlash, faShuffle, faRandom, faUnderline, faBuildingUser, faSushiRoll, faMakiRoll, faMakizushi, faDialOff, faRobot, faBarProgressEmpty, faTransmission, faPlus, faAdd, faObjectsAlignTop, faBellRing, faCopy, faChessKing, faHouseFloodWater, faMoneyFromBracket, faBitcoinSign, faBox, faFaceAnguished, faLocationArrowUp, faHeadSideHeart, faSquarePlus, faPlusSquare, faMemo, faArrowsLeftRight, faArrowsH, faFan, faCrow, faUTurnUpRight, faSquare8, faFileCircleCheck, faBracketCurlyRight, faChartNetwork, faBadgeDollar, faLinkSlash, faChainBroken, faChainSlash, faUnlink, faArrowRotateRight, faArrowRightRotate, faArrowRotateForward, faRedo, faPersonToPortal, faPortalEnter, faSignalBarsSlash, faSignalAltSlash, faPenClip, faPenAlt, faRectangleBeta, faDoorClosed, faLockA, faArrowDownWideShort, faSortAmountAsc, faSortAmountDown, faFaceMelting, faFaceDisguise, faSportsball, faSquareMicrophone, faCaretDown, faRadar, faImageLandscape, faLandscape, faRotateReverse, faTicketPerforated, faSquareC, faK, faArrowUTurnDownLeft, faCheckToSlot, faVoteYea, faSquareJ, faFishFins, faBellSchool, faLampFloor, faCompress, faTrashPlus, faArrowUpAZ, faSortAlphaUp, faComma, faSemicolon, faClipboardExclamation, faRugbyBall, faGridRound2Plus, faUserGraduate, faFileCode, faCupStraw, faSoap, faRecycle, faSlidersUp, faSlidersV, faCircleUserClock, faCarBus, faSignaporeDollarSign, faPumpkin, faFaceGrinWink, faGrinWink, faFolderArrowDown, faFolderDownload, faSignPosts, faSkeletonRibs, faQrcodeRead, faCircleDollar, faDollarCircle, faUsdCircle, faSiren, faWaterLadder, faLadderWater, faSwimmingPool, faTtyAnswer, faTeletypeAnswer, faSquareThisWayUp, faBoxUp, faTowerCell, faGalleryThumbnails, faColonSign, faLaptopFile, faCircleHalfStrokeHorizontal, faBahai, faHaykal, faMoneyBill1, faMoneyBillAlt, faCloudBolt, faThunderstorm, faCircleBookmark, faBookmarkCircle, faEthernet, faCirclesOverlap3, faPronoun, faHryvniaSign, faHryvnia, faAtomSimple, faAtomAlt, faFilesMedical, faSalad, faBowlSalad, faPawSimple, faPawAlt, faEyeSlash, faPlateUtensils, faCircleO, faJugBottle, faClockTwo, faCartFlatbedSuitcase, faLuggageCart, faFolderImage, faRadiation, faFileWord, faBedPulse, faProcedures, faBlock, faShovel, faTents, faDropletPercent, faHumidity, faMugHot, faBolt, faZap, faUserVneckHairLong, faReflectVertical, faMoneyBillSimpleWave, faLightbulbExclamation, faAperture, faJar, faArrowDownFromArc, faTruckPlane, faSignalFair, faSignal2, faHandHoldingHeart, faArrowRotateLeft, faArrowLeftRotate, faArrowRotateBack, faArrowRotateBackward, faUndo, faAnglesUpDown, faTruckPlow, faUsersMedical, faWatchApple, faCaretLargeLeft, faGridRound4, faBookOpenCover, faBookOpenAlt, faCommentDot, faFlashlight, faFaceAngry, faAngry, faCheeseSwiss, faChartPieSimple, faChartPieAlt, faCircleCent, faBurst, faZ, faSquareSwedishKrona, faHeadSideHeadphones, faBandage, faBandAid, faPlaneCircleExclamation, faBusSide, faBugs, faSnowmobileBlank, faBookUser, faChevronsRight, faChevronDoubleRight, faBeerMugEmpty, faBeer, faPersonCircleCheck, faCartCirclePlus, faStapler, faSquareHalfStrokeHorizontal, faCandyCorn, faClipboardPrescription, faCompressWide, faHouseMedicalCircleCheck, faCommentPen, faCommentEdit, faNairaSign, faFilePng, faHundredPoints, fa100, faTableTree, faWifi, faWifi3, faWifiStrong, faPage, faSquareChevronLeft, faChevronSquareLeft, faChartMixed, faAnalytics, faCalendarExclamation, faMoneyCheckDollar, faMoneyCheckAlt, faCamcorder, faVideoHandheld, faHouseChimneyBlank, faEyeLowVision, faLowVision, faCircleArrowUp, faArrowCircleUp, faCameraRetro, faRightToDottedLine, faCapsules, faBlockBrickFire, faFirewall, faFilters, faBowlingPins, faCalendarUsers, faTableCellsColumns, faPeopleSimple, faArrowLeftArrowRight, faPoo, faSquare5, faVolume, faVolumeMedium, faFlowerDaffodil, faElevator, faWavePulse, faHeartRate, faBookHeart, faSquareZ, faTag, faWagonCovered, faFileCircleMinus, faMessageCode, faGearComplex, faCircleC, faDownLong, faLongArrowAltDown, faCompactDisc, faSuitcaseRolling, faDanishKroneSign, faWebhook, faClockFiveThirty, faPersonWaving, faArrowDownArrowUp, faSortAlt, faBookQuran, faQuran, faTelescope, faTemperatureSlash, faPhoneSlash, faRoadCircleCheck, faShopLock, faImagePortrait, faPortrait, faBooks, faGrid2, faCartArrowUp, faBridgeLock, faPaperPlaneTop, faPaperPlaneAlt, faSend, faClockNineThirty, faBurgerLettuce, faHammer, faSquareUpLeft, faTransporter7, faArrowUp19, faSortNumericUp, faTableCellsHeaderUnlock, faChessKnight, faHouseFloodWaterCircleArrowRight, faNfcMagnifyingGlass, faMelonSlice, faStairCar, faPrescriptionBottlePill, faClockEightThirty, faCloudMinus, faLaptopMobile, faPhoneLaptop, faBagShoppingPlus, faClapperboardPlay, faCircleRenminbi, faLeftFromLine, faArrowAltFromRight, faEngineWarning, faEngineExclamation, faPickleball, faTrombone, faArrowUpRightFromSquare, faExternalLink, faPersonCarryEmpty, faBorderRight, faArrowDownUpAcrossLine, faFaceGrinBeam, faGrinBeam, faRectangleAd, faAd, faCarSideBolt, faCircleUpRight, faPersonSkiJumping, faSkiJump, faUserVneck, faClarinet, faBookTanakh, faTanakh, faFileXmark, faFileTimes, faSquareUser, faClockSix, faDinosaur, faFrenchFries, faHotTubPerson, faHotTub, faFileHalfDashed, faReflectHorizontal, faDirectionLeftRight, faCartCircleExclamation, faSquareChf, faOutdent, faDedent, faBrakeWarning, faRectangleTall, faSquareStar, faHandPeace, faHeadSideVirus, faUnicycle, faSquareDown, faArrowAltSquareDown, faCrutches, faGramophone, faH3, faCompass, faRollerCoaster, faPenNib, faTentArrowsDown, faDuck, faDrawCircle, faVectorCircle, faForwardFast, faFastForward, faTrees, faCrop, faWhiskeyGlass, faGlassWhiskey, faDownFromBracket, faGearComplexCode, faSquareN, faSquare3, faUfoBeam, faSquare, faGarlic, faBackpack, faFileCertificate, faFileAward, faPeople, faLandmarkMagnifyingGlass, faClipboardMedical, faFaceGrin, faGrin, faFileContract, faBorderBottomRight, faBorderStyleAlt, faCassetteTape, faAngleUp, faFolderGrid, faArrowRightToArc, faFaceSmile, faSmile, faLocationPinSlash, faMapMarkerSlash, faPersonDressBurst, faDivide, faUserHelmetSafety, faUserConstruction, faUserHardHat, faCodeFork, faBagsShopping, faBookSparkles, faBookSpells, faSunCloud, faHouseFlag, faBullseyePointer, faBuildingColumns, faBank, faInstitution, faMuseum, faUniversity, faCloudShowers, faImageCircleXmark, faRug, faTruckBolt, faCodeMerge, faCactus, faTableCellsHeader, faHouseTsunami, faMagnifyingGlassChart, faInputPipe, faDisplayChartUpCircleDollar, faUmbrella, faBoneBreak, faMessageQuestion, faCircle5, faHillRockslide, faUserSecret, faPager, faBriefcase, faTrowelBricks, faBaseballBat, faUserPoliceTie, faArrowRightToDottedLine, faSocks, faGaugeMax, faTachometerAltFastest, faCommentArrowUp, faGuitarElectric, faCoffeeBean, faArrowDownLongToLine, faInputText, faLightsHoliday, faT, faMicrochip, faKeySkeleton, faTruckMedical, faAmbulance, faOm, faMosquitoNet, faSquareManat, faPrescriptionBottle, faUsersGear, faUsersCog, faRoadCircleExclamation, faTrashCanClock, faPause, faStaffSnake, faRodAsclepius, faRodSnake, faStaffAesculapius, faPiggyBank, faMonument, faLightSwitchOff, faTricycle, faBorderCenterV, faOpenCaptioning, faCircleY, faFolderMusic, faCircleSwedishKrona, faAnglesRight, faAngleDoubleRight, faCircleT, faUserCrown, faDesktop, faDesktopAlt, faArrowUTurnLeftDown, faDonut, faDoughnut, faPlaneCircleXmark, faProjector, faUpFromLine, faArrowAltFromBottom, faWaterTemperature, faWaterTemp, faRetweet, faUserGear, faUserCog, faUserHairBuns, faBorderAll, faCoin, faLockKeyholeOpen, faLockOpenAlt, faCoins, faClockFourThirty, fa00, faAmpGuitar, faFolderArrowLeft, faMarsStroke, faCircleDashed, faHandshakeAngle, faHandsHelping, faGaugeSimpleLow, faTachometerSlow, faArrowDown, faLocationDot, faMapMarkerAlt, faGasPumpRight, faDeerRudolph, faUfo, faPlugCircleExclamation, faCookieBite, faSquareChevronRight, faChevronSquareRight, faHandPointRibbon, faGrid2Plus, faScrewdriverWrench, faTools, faKeynote, faTicketsAirline, faTicketsPerforatedPlane, faTicketsPlane, faCalendarLines, faCalendarNote, faIndent, faGolfClub, faBars, faNavicon, faHandsPraying, faPrayingHands, faTemperatureSnow, faTemperatureFrigid, faViruses, faDryer, faSchoolFlag, faCircleGf, faTrademark, faStretcher, faUTurnRightDown, faFireBurner, faIntegral, faGripDotsVertical, faFaceLying, faPersonBasketball, faFolderUser, faSkiBootSki, faFaceSmileBeam, faSmileBeam, faBatteryExclamation, faSquarePolishZloty, faWreathLaurel, faStars, faTentArrowLeftRight, faRoute, faAnglesUp, faAngleDoubleUp, faBucket, faLessThanEqual, faFlagPennant, faPennant, faFolderClosed, faChessKingPiece, faChessKingAlt, faSquareKip, faBinRecycle, faAeropress, faSendBackward, faTruckRampCouch, faTruckCouch, faPersonThroughWindow, faAvocado, faSealExclamation, faWindTurbine, faSchoolLock, faChartScatter3d, faBusStop, faAlbumCollectionCirclePlus, faPersonBurst, faBalloon, faLeftLong, faLongArrowAltLeft, faLocationCrosshairs, faLocation, faPersonDotsFromLine, faDiagnoses, faGaugeSimpleHigh, faTachometer, faTachometerFast, faAnglesLeft, faAngleDoubleLeft, faUpDown, faArrowsAltV, faBoxArrowDownMagnifyingGlass, faBatteryEmpty, faBattery0, faChartSine, faArrowsRetweet, faRetweetAlt, faKeyboard, faCodePullRequestClosed, faRight, faArrowAltRight, faPenClipSlash, faPenAltSlash, faSensorOn, faChevronsUp, faChevronDoubleUp, faCookie, faStopwatch, faEject, faCardSpade, faSatelliteDish, faTableCellsUnlock, faClipboardClock, faHandBackPointDown, faClockSixThirty, faFaceRollingEyes, faMehRollingEyes, faListCheck, faTasks, faHouseBlank, faHomeBlank, faSackXmark, faUserHatTie, faHashtag, faFileHeart, faSquareQ, faCastle, faTrafficLightSlow, faMessageCaptions, faCommentAltCaptions, faBird, faTrain, faFileWav, faMessageMiddle, faCommentMiddleAlt, faGamepad, faBroccoli, faCoffeeBeans, faSquareChevronUp, faChevronSquareUp, faFileExport, faArrowRightFromFile, faCupStrawSwoosh, faMandolin, faMerge, faBookArrowUp, faCircleBrazilianReal, faMeter, faSquareSmall, faCircleZ, faMistletoe, faUpFromDottedLine, faFaceHeadBandage, faSlashBack, faSimCards, faArrowLeftFromBracket, faUsbDrive, faHeadSideBrain, faGlassHalf, faGlassHalfEmpty, faGlassHalfFull, faFaceGrimace, faGrimace, faPanties, faTrainSubway, faSubway, faFaceGlasses, faCloudDrizzle, faCircleDot, faDotCircle, faObjectGroup, faUserPolice, faShip, faC, faSquarePhone, faPhoneSquare, faBoxTaped, faBoxAlt, faRulerCombined, faBracketSquareRight, faLeafMaple, faArrowsRotate, faRefresh, faSync, faBenchTree, faSquareRoot, faArrowDownTriangleSquare, faSortShapesDown, faPersonDress, faFemale, faQuotes, faBookOpen, faFolderTree, faObjectUnion, faFileBinary, faBoxArchive, faArchive, faChopsticks, faWaveformLines, faWaveformPath, faDown, faArrowAltDown, faMessageArrowUp, faCommentAltArrowUp, faCircleDownLeft, faObjectsAlignRight, faHourglassClock, faShutters, faTentArrowDownToLine, faQrcode, faCircleUserCircleMoon, faDragon, faHourglassEnd, faHourglass3, faGrip, faGridHorizontal, faGripHorizontal, faBorderTopLeft, faBorderStyle, faSignPost, faListUl, faListDots, faBookSection, faBookLaw, faPeopleRobbery, faShirtTankTop, faSteeringWheel, faMagnifyingGlassWaveform, faAlarmPlus, faWineGlassCrack, faFragile, faTransporter, faMobileButton, faArrowDownAZ, faSortAlphaAsc, faSortAlphaDown, faGlassCitrus, faPool8Ball, faArrowDownSquareTriangle, faSortShapesDownAlt, faRepeat1, faTransporter2, faStarChristmas, faMobileRotateReverse, faClawMarks, faLightbulbOn, faMoneyBill, faMessagesDollar, faCommentsAltDollar, faUserChefHairLong, faCroissant, faFileUser, faArrowTurnRight, faBorderTop, faCircleMinus, faMinusCircle, faArrowPointer, faMousePointer, faSquareShareNodes, faShareAltSquare, faBorderOuter, faArrowDownRight, faTableCellsLarge, faThLarge, faCircleUserCircleMinus, faCloudPlus, faCat, faCalendarWeek, faSpine, faScannerImage, faTRex, faPipe, faArrowUpToBracket, faSigma, faKeyboardDown, faArrowDownToArc, faCodeCompare, faAlarmMinus, faWand, faMeterBolt, faArrowsRotateReverse, faScannerKeyboard, faChessBishopPiece, faChessBishopAlt, faFilePlusMinus, faUnion, faArrowUpBigSmall, faSortSizeUp, faRoadCircleXmark, faCowbellCirclePlus, faCowbellMore, faThoughtBubble, faPallet, faCircleBookOpen, faBookCircle, faVialVertical, faPodiumStar, faBarProgressQuarter, faCakeCandles, faBirthdayCake, faCake, faFaceExhaling, faBugSlash, faTrashCanPlus, faTarp, faBorderCenterH, faTally, faTally5, faDiagramPredecessor, faFaceFlushed, faFlushed, faDiagramNext, faCircleSortDown, faSortCircleDown, faAnchorCircleXmark, faCircleP, faPersonCircleXmark, faBurrito, faSignalBarsGood, faSignalAlt3, faSpa, faChessClockFlip, faChessClockAlt, faBarsProgress, faTasksAlt, faOverline, faCircleMicrophone, faMicrophoneCircle, faHeartCircleCheck, faMarsStrokeRight, faMarsStrokeH, faFaceExpressionless, faTransporterEmpty, faWatchFitness, faMoonCloud, faUTurnDownRight, faFaceShaking, faSunrise, faBuildingMemo, faCartFlatbedEmpty, faDollyFlatbedEmpty, faSquareDanishKrone, faFaceDisappointed, faBowlChopsticks, faCarSiren, faTowerObservation, faBinaryLock, faSterlingSign, faGbp, faPoundSign, faAlicorn, faSquareHryvnia, faArrowRightLongToLine, faComputerSpeaker, faFaucetDrip, faMailboxOpenEmpty, faFaceRaisedEyebrow, faClonePlus, faFaceSmilingHands, faFileLock, faCircleInfo, faInfoCircle, faBellExclamation, faFeather, faBowlRice, faDialMedLow, faStarHalfStroke, faStarHalfAlt, faPlanetMoon, faTemperatureArrowDown, faTemperatureDown, faMaskVentilator, faCannon, faChartScatter, faFileVideo, faSquareO, faArrowTrendDown, faCitrusSlice, faDisplayChartUpCircleCurrency, faCommentMiddleTop, faCaretLargeDown, faDownToDottedLine, faPhoneArrowDownLeft, faPhoneArrowDown, faPhoneIncoming, faBuoyMooring, faTentCircus, faOilCan, faMemoCircleInfo, faCartCircleArrowUp, faCircleParking, faParkingCircle, faCassetteBetamax, faBetamax, faTankRecovery, faPeopleCarryBox, faPeopleCarry, faClockEight, faChair, faWind, faLayerGroup, faLollipop, faLollypop, faNotes, faHexagonXmark, faTimesHexagon, faXmarkHexagon, faShishKebab, faHeadSideMask, faHands, faSignLanguage, faSigning, faTablets, faWeightHanging, faPinball, faDice, faShopSlash, faStoreAltSlash, faSortDown, faSortDesc, faCommentExclamation, faTableLayout, faPesetaSign, faTabletScreenButton, faTabletAlt, faUserViewfinder, faHandHoldingDollar, faHandHoldingUsd, faHorseSaddle, faShield, faShieldBlank, faPeach, faFaceLaugh, faLaugh, faBellSchoolSlash, faAlignSlash, faCloudExclamation, faHandsHolding, faCartShopping, faShoppingCart, faTrianglePersonDigging, faConstruction, faSquareColon, faSubtitlesSlash, faSquareD, faFolderMedical, faChartScatterBubble, faHatWitch, faBin, faGarageCar, faCalendarClock, faCalendarTime, faOctagon, faHandPointer, faRabbit, faCircleaporeDollar, faSushi, faNigiri, faScannerGun, faScanner, faPencilMechanical, faHandHoldingSeedling, faLocationQuestion, faMapMarkerQuestion, faUp, faArrowAltUp, faArrowUpArrowDown, faSortUpDown, faScarecrow, faLocationCrosshairsSlash, faLocationSlash, faRegistered, faRectanglePro, faPro, faBreadSliceButter, faLightCeiling, faUserHairMullet, faBusinessFront, faPartyBack, faTrianBalbot, faSquareParkingSlash, faParkingSlash, faLinkSimpleSlash, faHouseSignal, faLockKeyhole, faLockAlt, faTally2, faBangladeshiTakaSign };
